var rM = Object.defineProperty;
var sM = (e, t, n) => t in e ? rM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Bt = (e, t, n) => sM(e, typeof t != "symbol" ? t + "" : t, n);
import { ref as S, shallowRef as Ea, watch as Xe, computed as E, getCurrentInstance as Go, inject as bi, onMounted as qt, onBeforeUnmount as Ct, shallowReactive as lM, toRaw as uM, defineComponent as rt, openBlock as f, createElementBlock as h, normalizeStyle as Xt, normalizeClass as Ne, Fragment as Ce, createTextVNode as Vt, toDisplayString as y, createCommentVNode as D, renderList as nt, createVNode as Je, createElementVNode as d, createBlock as We, unref as u, nextTick as Jt, Teleport as wi, Transition as zr, withCtx as mt, withModifiers as vt, withKeys as za, renderSlot as Ln, resolveDynamicComponent as Ki, withDirectives as cn, vModelText as xn, provide as jo, useSlots as cM, mergeProps as dv, h as dM, resolveComponent as fM, vModelCheckbox as wc, getCurrentScope as q0, onScopeDispose as yy, createStaticVNode as W0, onUpdated as pM, reactive as Y0, defineAsyncComponent as G0, watchEffect as hM, createSlots as mM, isRef as vM, vShow as yM } from "vue";
import { ChevronDown as gM, Check as fv, Sparkles as bM, Plus as kM, History as wM, X as _M, Trash2 as xM, Undo2 as SM, Ban as $M, CircleAlert as Dw, LoaderCircle as Lw, Square as TM, Send as AM } from "lucide-vue-next";
import { Popover as EM, PopoverButton as CM, PopoverPanel as zM, Menu as MM, MenuButton as OM, MenuItems as PM, MenuItem as DM } from "@headlessui/vue";
function pv(e) {
  return !!e && e.enabled && e.state === "ok";
}
const Gs = {
  "toolbar.new_folder": "New folder",
  "toolbar.upload": "Upload",
  "toolbar.search": "Search",
  "toolbar.search.placeholder": "Search by name or tag:…",
  "toolbar.view.list": "List",
  "toolbar.view.grid": "Grid",
  "toolbar.refresh": "Refresh",
  "toolbar.go_up": "Up one level",
  "ctx.open": "Open",
  "ctx.preview": "Preview",
  "ctx.download": "Download",
  "ctx.archive_create": "Create archive…",
  "ctx.archive_extract": "Extract archive…",
  "ctx.rename": "Rename",
  "ctx.delete": "Delete",
  "ctx.delete_perm": "Delete permanently",
  "ctx.restore": "Restore",
  "ctx.share": "Share",
  "ctx.move": "Move",
  "ctx.copy": "Copy",
  "ctx.cut": "Cut",
  "ctx.show_hidden": "Show hidden files",
  "ctx.hide_hidden": "Hide hidden files",
  "ctx.keep_local": "Keep on this computer",
  "ctx.keep_online": "Keep online only",
  "ctx.keep_reveal": "Open local folder",
  "ctx.keep_inherited": "Kept on this computer with its parent",
  "keep.started": "Will be kept on this computer - sync started",
  "keep.failed": "Could not keep on this computer",
  "keep.badge_kept": "On this computer",
  "keep.badge_syncing": "Syncing…",
  "keep.badge_cloud": "Online only",
  "keep.badge_partial": "Contains items kept on this computer",
  "keep.strip_transfer": "Syncing {name} - {done}/{total} ({pct}%)",
  "keep.strip_inventory": "Syncing {name} - scanning the server…",
  "keep.strip_settling": "Syncing {name} - settling…",
  "ctx.paste": "Paste",
  "ctx.info": "Info",
  "ctx.duplicate": "Duplicate",
  "ctx.new_file": "New file",
  "modal.delete.title": "Delete?",
  "modal.delete.message": "{count} items will be moved to trash.",
  "modal.delete.message_one": "{count} item will be moved to trash.",
  "modal.delete.confirm": "Move to Trash",
  "modal.delete.working": "Moving to Trash…",
  "modal.delete.cancel": "Cancel",
  "modal.delete.permanent_title": "Delete permanently?",
  "modal.delete.permanent_message": "{count} items will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_message_one": "{count} item will be deleted for good. This cannot be undone.",
  "modal.delete.permanent_confirm": "Delete permanently",
  "modal.delete.permanent_working": "Deleting…",
  "modal.rename.title": "Rename",
  "modal.rename.save": "Save",
  "modal.rename.saving": "Renaming…",
  "modal.rename.cancel": "Cancel",
  "modal.rename.empty": "Type a name.",
  "modal.newfolder.title": "New folder",
  "modal.newfolder.placeholder": "Folder name",
  "modal.newfolder.create": "Create",
  "modal.newfolder.creating": "Creating…",
  "modal.newfolder.cancel": "Cancel",
  "modal.share.title": "Share link",
  "archive.create_title": "Create archive",
  "archive.extract_title": "Extract archive",
  "archive.create_count": "{count} selected items",
  "archive.create_count_one": "{count} selected item",
  "archive.filename": "Archive name",
  "archive.format": "Format",
  "archive.password_optional": "Password (optional)",
  "archive.password_confirm": "Confirm password",
  "archive.password_mismatch": "Passwords do not match.",
  "archive.encrypt_names": "Encrypt file names",
  "archive.compression": "Compression",
  "archive.solid": "Create solid archive",
  "archive.dictionary_size": "Dictionary size",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Larger dictionaries can improve compression but use more memory while creating and extracting.",
  "archive.destination_folder": "Extract to folder",
  "archive.create": "Create",
  "archive.creating": "Creating…",
  "archive.extract": "Extract",
  "archive.extract_here": "Extract here",
  "archive.extract_to_folder": "Extract to folder",
  "archive.extracting": "Extracting…",
  "archive.cancel": "Cancel",
  "archive.invalid_name": "Enter a file name without slashes.",
  "archive.invalid_extension": "Archive name must use one of the available format extensions.",
  "archive.invalid_folder": "Enter a folder name without slashes.",
  "archive.password_required": "This archive requires a password.",
  "archive.password_title": "Archive password",
  "archive.continue": "Continue",
  "archive.opening": "Opening…",
  "archive.bad_password": "The archive password is incorrect.",
  "archive.target_exists": "An item with that name already exists. Choose another name or remove it first.",
  "archive.password_charset": "A ZIP password can use only ASCII characters: unaccented letters, digits and ordinary punctuation. Choose 7z to use any characters.",
  "archive.error_unsupported": "This archive cannot be extracted: this server cannot read its format, or it holds something filex does not extract (a link, a special file, or a file whose size it does not state).",
  "archive.error_limit": "This archive is larger than the server allows to extract.",
  "archive.error_unavailable": "This server cannot open this kind of archive right now.",
  "archive.created": "Archive created",
  "archive.queued": "Archive creation is running in the background",
  "archive.extracted": "Extracted {count} files",
  "archive.extracted_one": "Extracted {count} file",
  "archive.extraction_queued": "Archive extraction is running in the background",
  "archive.preparing_extract": "Reading {name}… the whole archive is read before it can be extracted.",
  "archive.already_preparing": "Still reading {name} - it is extracted once that is done",
  "archive.extraction_completed": "Extraction completed",
  "archive.extraction_cancelled": "Extraction cancelled after {count} files",
  "archive.extraction_cancelled_one": "Extraction cancelled after {count} file",
  "modal.share.pin": "PIN protected",
  "modal.share.expires": "Expires at",
  "modal.share.max_downloads": "Download limit",
  "modal.share.create": "Share",
  "modal.share.cancel": "Cancel",
  "modal.share.close": "Close",
  "modal.share.limit_applied": "(server limit applied)",
  "modal.share.copy": "Copy",
  "modal.share.url_copied": "Link copied",
  "modal.share.pin_copied": "PIN copied",
  "modal.share.cli_copied": "CLI command copied",
  "upload.progress": "Uploading",
  "upload.done": "Done",
  "upload.error": "Error",
  "upload.failed": "Could not upload “{name}”",
  "upload.aborted": "Aborted",
  "upload.cancel": "Cancel",
  "upload.resuming": "Resuming “{name}” from {percent}%",
  "upload.saving": "Saving to the storage…",
  "empty.folder": "This folder is empty",
  "empty.search": "No results",
  loading: "Loading…",
  "notFound.title": "Folder not found",
  "notFound.desc": "This folder does not exist, was moved, or you do not have access to it.",
  "notFound.goRoot": "Go to root folder",
  "col.name": "Name",
  "col.size": "Size",
  "col.modified": "Modified",
  "col.type": "Type",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Root",
  "breadcrumb.copy_path": "Copy path",
  "breadcrumb.go_to_path": "Go to path",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Copying",
  "ops.move": "Moving",
  "ops.delete": "Deleting",
  "ops.queued": "queued",
  "ops.done": "done",
  "ops.error": "error",
  "node.trash": "Trash",
  /* gorunum:v1 - the singular kind, printed under a folder's name on a card
   * and beside it in the list. The plural section heading is a different
   * string on purpose. */
  "node.folder": "Folder",
  // --- Rich viewer chrome ---
  "viewer.open_in_new_tab": "Open in new tab",
  "viewer.loading": "Loading…",
  "viewer.failed_to_load": "Failed to load file",
  /* ⚠ Said to a PERSON: it used to tell them to "install the peer dependency". */
  "viewer.peer_not_installed": "This kind of file cannot be shown here. Download it to open it on your device.",
  "viewer.remote_image.label": "Remote image",
  "viewer.remote_image.title": "Load a remote image?",
  "viewer.remote_image.body": "This image is on another server. Loading it tells that server that this file was opened, and your IP address.",
  "viewer.remote_image.setting_hint": "To load them without asking, turn on “Load remote images in previews” in User settings → Preferences.",
  "viewer.remote_image.load": "Load image",
  "viewer.remote_image.load_all": "Load all remote images in this file",
  "viewer.remote_image.book_held": "Pictures from other servers in this book are not loaded.",
  "viewer.remote_image.book_load": "Load remote images…",
  "viewer.format_unsupported_3d": "The preview shows 3D models in .glb, .gltf and .usdz only. Download the file to open it in a 3D program.",
  "viewer.zoom_in": "Zoom in",
  "viewer.zoom_out": "Zoom out",
  "viewer.fit_width": "Fit width",
  "viewer.next_page": "Next page",
  "viewer.prev_page": "Previous page",
  "viewer.page_n_of_m": "Page {n} of {m}",
  "viewer.tags": "Tags",
  "viewer.layers": "Layers",
  "viewer.toc": "Contents",
  "viewer.font_smaller": "Smaller text",
  "viewer.font_larger": "Larger text",
  "viewer.search": "Search",
  "viewer.download": "Download",
  "viewer.saving": "Saving…",
  "viewer.save": "Save (Ctrl+S)",
  "viewer.saved": "Saved",
  "viewer.save_error": "Error",
  "viewer.editor_loading": "Loading editor…",
  "viewer.no_preview": "No preview for this file type yet.",
  "viewer.edit": "Edit",
  "viewer.close": "Close",
  "presence.expand": "Show names",
  "presence.collapse": "Collapse",
  "viewer.save_annotations": "Save annotations",
  "viewer.annotations_on": "Annotations: on",
  "viewer.annotations_off": "Annotations: off",
  "viewer.read_only": "Read only",
  "viewer.csv_first_row_header": "First row as header",
  "viewer.csv_filter": "Filter rows…",
  "viewer.epub_prev": "Previous",
  "viewer.epub_next": "Next",
  /* ⚠ The old sentence named an ENVIRONMENT VARIABLE to every reader
     ("operator must wire FILEX_DRAWIO_URL"). A person who only wanted to look
     at a diagram is told what they can do; `_admin` - someone who can fix it -
     is told where. */
  "viewer.drawio.disabled": "Diagrams cannot be opened here: this server has no draw.io. Download the file to open it elsewhere.",
  "viewer.drawio.disabled_admin": "draw.io is not set up on this server. Set it up in the admin panel under External services.",
  "viewer.drawio.load_failed": "This diagram could not be read. Download it to open it elsewhere.",
  "viewer.drawio.save_failed": "The diagram could not be saved. Your changes are still in the editor - try again.",
  "viewer.archive.entries": "{n} files",
  "viewer.archive.entries_one": "{n} file",
  "viewer.archive.empty": "Archive is empty.",
  "viewer.archive.error": "Could not read archive contents.",
  "viewer.archive.unsupported": "This kind of archive cannot be listed here. Download it to see what is inside.",
  "viewer.archive.too_large": "This archive is too large to list here. Download it to see what is inside.",
  "viewer.archive.open": "Open archive",
  "viewer.archive.root": "Archive",
  "viewer.archive.location": "Archive location",
  "viewer.archive.reading": "Still reading… the whole archive is read before its contents can be listed, which takes a while for a large one.",
  "viewer.name": "Name",
  "viewer.size": "Size",
  // --- cila:a - sorting / date groups / density ---
  "col.sort": "Sort",
  "group.today": "Today",
  "group.yesterday": "Yesterday",
  "group.this_week": "This week",
  "group.this_month": "This month",
  "group.no_date": "No date",
  "toolbar.density.compact": "Compact view",
  "toolbar.density.comfortable": "Comfortable view",
  // --- cila:c - command palette + shortcuts help + breadcrumb ---
  "palette.placeholder": "Search files, folders or commands…",
  "palette.files": "Files",
  "palette.commands": "Commands",
  "palette.goto": "Go to path",
  "palette.empty": "No results",
  "palette.hint": "↑↓ navigate · Enter select · Esc close",
  "cmd.view_toggle": "Toggle view (list ⇄ grid)",
  "cmd.trash": "Open trash",
  "shortcuts.title": "Keyboard shortcuts",
  "shortcuts.group.nav": "Navigation",
  "shortcuts.group.selection": "Selection",
  "shortcuts.group.file": "File operations",
  "shortcuts.palette": "Command palette",
  "shortcuts.search": "Focus search",
  "shortcuts.go_up": "Go up one level",
  "shortcuts.open": "Open selected item",
  "shortcuts.close": "Close / cancel",
  "shortcuts.toggle_hidden": "Show/hide hidden files",
  "shortcuts.help": "This help dialog",
  "shortcuts.select_all": "Select all",
  "shortcuts.star": "Star / unstar",
  "shortcuts.rename": "Rename",
  "shortcuts.delete": "Delete",
  "shortcuts.cut": "Cut",
  "shortcuts.copy": "Copy",
  "shortcuts.paste": "Paste",
  "breadcrumb.more": "Folders in between",
  // --- State screens + undo snackbar + connection badge (cila:b) ---
  "empty.hint": "Drag and drop files here",
  "empty.upload": "Upload files",
  "empty.search.title": "No files match your search",
  "empty.search.hint": "Try a different search term",
  "empty.trash.title": "Trash is empty",
  "error.title": "Could not load this folder",
  "error.retry": "Try again",
  "toast.undo": "Undo",
  "toast.undone": "Undone",
  "toast.undoing": "Undoing…",
  "toast.undo_queued": "The undo is queued - the operations panel shows when it is done",
  "toast.undo_failed": "Could not undo",
  "toast.renamed": "Renamed",
  "toast.rename_queued": "Renaming to “{name}”…",
  "toast.moved": "Moved",
  "toast.trashed": "Moved to trash",
  /* i18n:hardcoded - toast copy that used to be Turkish string literals in
     FileExplorer.vue, unreachable by any locale. */
  "toast.failed": "Operation failed",
  /* ── errorWords (lib/errorWords): how a failure is SAID. ⚠ No status code,
     no JSON, no environment variable ever reaches these; an administrator
     sees the raw words on a second line, nobody else does. ── */
  "err.status.400": "Bad request",
  "err.status.401": "Sign-in required",
  "err.status.403": "You are not allowed to do this",
  "err.status.404": "Not found",
  "err.status.409": "Already exists / conflict",
  "err.status.413": "File too large",
  "err.status.415": "Unsupported file type",
  "err.status.422": "Invalid data",
  "err.status.429": "Too many requests",
  "err.status.500": "Server error",
  "err.status.501": "Not supported",
  "err.status.502": "A connected service reported an error",
  "err.status.503": "Service unavailable",
  "err.status.504": "A connected service took too long to answer",
  "err.status.other": "The server refused this request.",
  "err.upload_stalled": "The upload stopped making progress. Try again - it continues where it stopped.",
  "err.network": "The server could not be reached. Check your connection and try again.",
  /* 0.54 (audit A1/A2): a refusal the server names is said in the SERVER's
     words (`message`, backend internal/apierr `server.error.*`); the copies
     that stood here (err.read_only, err.quota, err.e2e_*, err.name_taken,
     opc.err.*…) are gone with the tables of lib/errorWords that used them. */
  "err.save_failed": "Your changes could not be saved.",
  "err.load_failed": "This file could not be loaded.",
  "err.viewer_failed": "The viewer for this file could not be started. Download the file to open it.",
  "err.detail": "Details",
  "toast.copied": "Copied",
  "toast.deleted": "Deleted",
  "toast.cut": "Cut",
  "toast.cut_ready": "Cut - ready to paste",
  "toast.copy_ready": "Copied - ready to paste",
  "toast.same_folder_cut": "Cannot cut into the same folder",
  "toast.restored": "{n} items restored",
  "toast.restored_one": "{n} item restored",
  "toast.delete_queued": "Delete queued",
  "toast.trash_retention": "Items in the trash are removed automatically once the retention window ends. Permanent deletion is done from the admin panel.",
  /* The Trash row a permanent delete is on its way for (the admin Trash
     page's words: one sentence, both catalogues - lesson #447). */
  "trash.purging": "Deleting permanently…",
  "trash.row_busy": "Something is already being done to this item",
  "dropzone.hint": "Drop files here",
  "modal.newfolder.invalid": "Invalid character",
  "names.reserved": "“{name}” is reserved for filex’s own use. Choose another name.",
  /* ⚠ A missing or broken document server is said in words, never as the
     HTTP layer (it used to read `Config fetch 503: {"error":"onlyoffice not
     configured"}`). `_admin` is what someone who can fix it reads - where to
     fix it; everybody else reads how to get the file anyway. */
  "viewer.office_unconfigured": "Office documents cannot be opened here: this server has no ONLYOFFICE document server. Download the file to open it on your computer.",
  "viewer.office_unconfigured_admin": "ONLYOFFICE is not set up on this server, so office documents cannot be opened here. Set it up in the admin panel under External services.",
  "viewer.office_unreachable": "The document server is not answering right now. Try again later, or download the file.",
  "viewer.office_unreachable_admin": "The ONLYOFFICE document server is not answering. Check it in the admin panel under External services.",
  /* Task #92: the editor runs in a frame on another origin (the document
     server's own, or the interface origin), and that page never answered -
     the address does not reach this filex. */
  "viewer.office_frame_unreachable_admin": "The ONLYOFFICE editor frame did not load from {origin}. Check that the reverse proxy there sends the frame to filex ({env}).",
  "viewer.office_failed": "This document could not be opened in ONLYOFFICE. Download it to open it on your computer.",
  "viewer.csv_office_note": "Saved as CSV: only the values of the active sheet are kept. Formatting, formulas and other sheets are not saved.",
  "viewer.office_forbidden": "You do not have permission to open this document in ONLYOFFICE.",
  /* After ONLYOFFICE's "Download failed": which of its two failures it was,
     as filex saw it (lib/officeDiagnosis, issue #80). */
  "viewer.office_download_served": "The document server downloaded this file from filex, but your browser could not load the converted copy from the document server. Check the X-Forwarded-Proto and X-Forwarded-Host headers on the reverse proxy in front of the document server.",
  "viewer.office_download_not_requested": "The document server never asked filex for this file. If the file was opened before, the document server may be using its own copy of it.",
  "viewer.office_download_refused": "filex refused the document server’s request for this file: {reason}.",
  "viewer.office_fetch_reason.bad_link": "the address was malformed",
  "viewer.office_fetch_reason.signature_expired": "the address had expired",
  "viewer.office_fetch_reason.signature_bad": "its signature did not match (the JWT secret changed, or the address was altered)",
  "viewer.office_fetch_reason.not_found": "the file no longer exists",
  "viewer.office_fetch_reason.storage_unavailable": "the storage could not be opened",
  "viewer.office_fetch_reason.body_unavailable": "the file’s contents could not be found",
  "viewer.office_fetch_reason.object_missing": "the file is missing from the storage",
  "viewer.office_fetch_reason.read_failed": "reading the file from the storage failed",
  /* The explorer's Open on a document the document server would open, when
     there is none - shown to an administrator only (everyone else is not
     offered the entry at all; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE is not set up - set it up in the admin panel under External services.",
  "ctx.needs_drawio": "draw.io is not set up - set it up in the admin panel under External services.",
  "viewer.pdf_inline_failed": "Your browser could not display this PDF inline.",
  "viewer.too_large": "File is too large (>1 MB).",
  "viewer.csv_rows": "{n} rows",
  "viewer.csv_rows_one": "{n} row",
  "presence.others": "{n} people",
  "presence.others_one": "{n} person",
  "conn.offline": "No live connection - changes may be delayed",
  "conn.tooltip": "Live connection to the server is unavailable; the list refreshes periodically. This notice disappears once the connection is back.",
  /* === bul:s3 === */
  "palette.everywhere": "Everywhere",
  "palette.searching": "Searching…",
  "palette.everywhere_failed": "The search could not be done. Try again.",
  "palette.saved": "Saved searches",
  "palette.save": "Save search",
  "palette.saved.delete": "Delete saved search",
  /* #168 - the admin panel's search (components/PanelSearch.vue). */
  "panelsearch.label": "Search the admin panel",
  "panelsearch.trigger": "Search",
  "panelsearch.placeholder": "Search pages, settings, people, apps…",
  "panelsearch.close": "Close search",
  "panelsearch.clear": "Clear the search",
  "panelsearch.results": "Search results",
  "panelsearch.group.page": "Pages",
  "panelsearch.group.setting": "Settings",
  "panelsearch.group.app": "Apps",
  "panelsearch.group.user": "Users",
  "panelsearch.group.group": "Groups",
  "panelsearch.group.key": "API keys",
  "panelsearch.group.storage": "Storages",
  "panelsearch.group.share": "Shares",
  "panelsearch.group.file": "Files",
  "panelsearch.group.recent": "Recent searches",
  "panelsearch.files_all": "Search files: {q}",
  "panelsearch.recent_remove": "Remove from recent searches",
  "panelsearch.recent_clear": "Clear recent searches",
  "panelsearch.empty": "Nothing matches “{q}”.",
  "panelsearch.searching": "Searching…",
  "panelsearch.failed": "Some results could not be loaded. The rest are shown.",
  "panelsearch.prefixes": "Narrow to one kind:",
  "panelsearch.count_one": "{n} result",
  "panelsearch.count": "{n} results",
  "search.in_content": "In content",
  "search.truncated": "More results than shown - narrow your search",
  "nav.more_shown": "Showing {shown} of {total}",
  "nav.load_more": "Load more",
  /* Catalog coverage (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). One
     sentence per reason; the banner sits over a listing and over search
     results, and says what is left out and why. */
  "coverage.first_scan": "This storage’s first sync has not finished. Until it does, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_filling": "filex is still cataloging this storage ({pct}% of the folders found so far). Until it finishes, search, folder sizes and usage leave part of it out.",
  "coverage.lazy_on_open": "Only the folders people open on this storage are cataloged. Search, folder sizes and usage cover those folders only.",
  "coverage.search_some": "Not everything on these storages is cataloged yet: {names}. This search may miss files there.",
  "coverage.catalog_all": "Catalog everything",
  "coverage.catalog_started": "Sync started - the whole storage is being cataloged.",
  "coverage.catalog_running": "Cataloging…",
  "coverage.cataloging": "Cataloging {storage}… this runs in the background, and this page says when it is done.",
  "coverage.catalog_done": "{storage} is cataloged in full",
  "coverage.catalog_failed": "Cataloging {storage} failed. The admin panel shows why, under the storage’s sync runs.",
  "coverage.catalog_stopped": "Cataloging {storage} was stopped before it finished",
  "coverage.catalog_joined": "A scan of {storage} was already running - this page says when it is done.",
  "coverage.catalog_gone": "{storage} was removed while it was being cataloged",
  "coverage.catalog_unfollowed": "Cataloging {storage} goes on in the background; the admin panel shows how it ends, under the storage’s sync runs",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Part of this folder is not cataloged yet, so its size is at least this.",
  "size.unknown_hint": "This folder is not cataloged yet, so its size is not known.",
  /* === bag:b4 === */
  "toolbar.more": "More actions",
  "toolbar.search.close": "Close search",
  "sheet.menu": "Actions",
  "sheet.close": "Close",
  /* === koru:k1 === */
  "toolbar.inspector": "Details",
  "ctx.details": "Details",
  /* yildiz:s1 - starring is an action, so it has a verb in the menu. */
  "ctx.star": "Star",
  "ctx.unstar": "Unstar",
  "star.failed": "Could not change the star",
  "shortcuts.inspector": "Toggle details panel",
  "inspector.title": "Details",
  "inspector.copy_name": "Copy name",
  "inspector.items": "{n} items",
  "inspector.items_one": "{n} item",
  "inspector.type": "Type",
  "inspector.select_hint": "Select an item to see its details.",
  /* pane:p1 - the panel HOLDS the last selected thing (owner's ruling,
     2026-09-13), so it can be describing an item in the half of a split
     window nobody is looking at. This line says which one and where. */
  "inspector.held": "Last selected - in {where}",
  "inspector.close": "Close",
  "inspector.section.general": "General",
  "inspector.section.tags": "Tags",
  /* etiket:t1 - TagPicker's own chrome. It printed these three in English
     regardless of the catalogue until 2026-09-13; `tags.open` is the chip's new
     "show me everything with this tag". */
  "tags.open": "Open tag: {tag}",
  "tags.add": "+ Add tag",
  "tags.name": "Tag name",
  "tags.remove": "Remove tag",
  /* etiket:k2 (v0.43.0) - the two KINDS of tag. Every place a tag is drawn
     says which kind it is, in words as well as the icon, because until this
     release a tag was silently shared with every account on the server. */
  "tags.kind.label": "Who sees this tag",
  "tags.kind.personal": "Personal",
  "tags.kind.team": "Team",
  "tags.kind.personal_help": "Only you see it",
  "tags.kind.team_help": "Everyone on your team who can see this file",
  "tags.kind.team_locked": "Adding or removing a team tag needs edit permission on this file.",
  "tags.chip.personal": "Personal tag “{tag}” - only you see it",
  "tags.chip.team": "Team tag “{tag}” - everyone on your team who can see this file sees it",
  "tags.add_submit": "Add",
  "inspector.section.versions": "Versions",
  "inspector.section.permissions": "Permissions",
  "inspector.section.shares": "Shares",
  "inspector.path": "Path",
  "inspector.size": "Size",
  "inspector.modified": "Modified",
  "inspector.mime": "MIME type",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Node ID",
  "inspector.copy": "Copy",
  "inspector.copied": "Copied",
  "inspector.error": "Could not load",
  "inspector.items_summary": "{n} items, {size} total",
  "inspector.items_summary_one": "{n} item, {size} total",
  "inspector.folder_items": "{n} items",
  "inspector.folder_items_one": "{n} item",
  "inspector.versions.empty": "No version history",
  "inspector.versions.v": "Version {n}",
  "inspector.versions.restore": "Restore",
  "inspector.versions.restore_confirm": "Restore this version?",
  "inspector.versions.snapshot_current": "Snapshot the current state first",
  "inspector.versions.confirm": "Confirm",
  "inspector.versions.restoring": "Restoring…",
  "inspector.versions.cancel": "Cancel",
  "inspector.versions.take_snapshot": "Snapshot current state",
  "inspector.versions.snapshotting": "Taking a snapshot…",
  "inspector.versions.restored": "Version restored",
  "inspector.versions.snapshotted": "Snapshot taken",
  "inspector.versions.unsupported": "The server does not support this operation",
  "inspector.perm.none": "No access",
  "inspector.perm.viewer": "Viewer",
  "inspector.perm.editor": "Editor",
  "inspector.perm.owner": "Owner",
  "inspector.perm.manage": "Manage permissions",
  "inspector.shares.empty": "No share links",
  "inspector.shares.copy": "Copy link",
  /* wiring:c1 - theme gallery */
  "theme.menu": "Theme",
  "theme.title": "Theme gallery",
  "theme.hint": "A theme only changes the color palette - day or night is the choice above.",
  "theme.mode.label": "Appearance",
  "theme.mode.light": "Day",
  "theme.mode.dark": "Night",
  "theme.mode.auto": "Automatic",
  "theme.reset": "Reset to default",
  "theme.close": "Close",
  "theme.selected": "Selected",
  "theme.name.default": "Default",
  "theme.name.night": "Night blue",
  "theme.name.forest": "Forest",
  "theme.name.amber": "Amber",
  "theme.name.lilac": "Lilac",
  "theme.name.contrast": "High contrast",
  "theme.name.gray": "Soft gray",
  "theme.name.terminal": "Terminal green",
  /* === zaman:z3 - the time-zone picker (embed dialog + web settings) === */
  "tz.menu": "Time zone",
  "tz.title": "Time zone",
  "tz.label": "Show dates in",
  "tz.search": 'Search a city, country or offset - try "Istanbul" or "GMT+3"',
  "tz.default.device": "Use this device's zone ({zone})",
  "tz.default.account": "Use the account's zone ({zone})",
  "tz.default.host": "Use this site's default ({zone})",
  "tz.no_match": "No zone matches “{query}”. Try a city, a country, or an offset like GMT+3.",
  "tz.more": "{n} more - keep typing to narrow the list.",
  "tz.hint": "Saved in this browser only. Every date is stored as one moment in time and shown on the clock you pick here.",
  "tz.now": "Right now in {zone}: {time}",
  /* === wiring:c2 - customizable shortcuts + quick look === */
  "shortcuts.quicklook": "Quick look",
  "shortcuts.customize": "Customize",
  "shortcuts.settings.menu": "Shortcuts",
  "shortcuts.settings.title": "Shortcut settings",
  "shortcuts.settings.hint": 'To remap a shortcut, press "Change" and then the new key combination. Changes are stored in this browser only.',
  "shortcuts.settings.change": "Change",
  "shortcuts.settings.capture": "Press keys… (Esc cancels)",
  "shortcuts.settings.reset": "Reset to default",
  "shortcuts.settings.reset_all": "Reset all",
  "shortcuts.settings.unbound": "Not set",
  "shortcuts.settings.fixed": "Fixed",
  "shortcuts.settings.customized": "Customized",
  "shortcuts.settings.conflict": 'is already used by "{name}".',
  "shortcuts.settings.conflict_fixed": 'is reserved by the fixed shortcut "{name}" - it cannot be used.',
  "shortcuts.settings.conflict_take": "Unassign old and use here",
  "shortcuts.settings.conflict_cancel": "Cancel",
  "quicklook.hint_close": "close",
  "quicklook.hint_nav": "previous/next",
  "quicklook.hint_open": "open",
  /* === /wiring:c2 === */
  /* === wiring:c3 - operations center === */
  "opc.title": "Operations",
  "opc.aria_badge": "{n} operations - toggle operations center",
  "opc.aria_badge_one": "{n} operation - toggle operations center",
  "opc.close": "Close",
  "opc.active": "In progress",
  "opc.history": "History",
  "opc.clear": "Clear",
  "opc.empty": "No operations",
  "opc.cancel": "Cancel",
  "opc.retry": "Retry",
  "opc.dismiss": "Dismiss",
  "opc.queued": "Queued",
  "opc.cancelling": "Cancel requested…",
  "opc.percent": "{n}%",
  "opc.items": "{done} of {total} items",
  "opc.trash_items": "{n} items from the trash",
  "opc.trash_items_one": "{n} item from the trash",
  "opc.status.running": "In progress",
  "opc.status.done": "Done",
  "opc.status.error": "Failed",
  "opc.status.aborted": "Cancelled",
  "opc.kind.upload": "Upload",
  "opc.kind.copy": "Copy",
  "opc.kind.move": "Move",
  "opc.kind.delete": "Delete",
  "opc.kind.rename": "Rename",
  "opc.kind.restore": "Restore",
  "opc.kind.purge": "Delete permanently",
  "opc.kind.convert": "Convert",
  "opc.kind.archive": "Archive",
  "opc.kind.plugin": "App",
  "opc.kind.trash": "Empty trash",
  "opc.kind.thumbs": "Thumbnail repair",
  /* A folder's contents on hover (FolderPeek, useFolderPeek). */
  "peek.items": "{n} items",
  "peek.items_one": "{n} item",
  "peek.more": "+{n} more",
  "peek.empty": "Empty",
  "peek.loading": "Looking inside…",
  "opc.open": "Open",
  /* App plugins - rows a WebAssembly plugin adds to the file menu, and the
     jobs they queue (docs/APP-PLUGINS-API.md). "App" is what the feature is
     called on every surface; "plugin" is the wire word. */
  "plugin.queued": "{label} queued",
  "plugin.done": "{label} finished",
  "plugin.failed": "{label} failed",
  "plugin.cancel_failed": "Could not cancel the job",
  "plugin.not_applicable": "This action does not apply to the selection",
  "plugin.needs_engine": "{name} is not installed on this server - install it and restart filex.",
  "plugin.needs_other": "{name} is not available on this server.",
  "plugin.needs_office": "Office documents need an office engine, and none runs on this server - install the Office editor app (Apps) or connect {name} under External services.",
  "plugin.confirm.title": "Confirm",
  "plugin.confirm.cancel": "Cancel",
  "plugin.confirm.run": "Run",
  "plugin.view.close": "Close",
  "appframe.confirm_title": "Confirm",
  "appframe.consent_clipboard": "{app} wants to copy text to your clipboard.",
  "appframe.consent_download": "{app} wants to save “{name}” to your computer.",
  "appframe.consent_print": "{app} wants to print “{name}”.",
  "appframe.consent_job": "{app} wants to start “{action}”.",
  "appframe.consent_allow": "Allow",
  "appframe.consent_deny": "Don’t allow",
  "appframe.unsaved_title": "Unsaved changes",
  "appframe.unsaved_text": "{app} has changes that are not saved. Close it anyway?",
  "appframe.state_no_account": "The app’s settings for an encrypted file are kept sealed for the account you are signed in as, and this page could not tell which account that is, so nothing was kept. Sign in again, or open the file where you are signed in.",
  "appframe.discard": "Close without saving",
  "appframe.keep_open": "Keep editing",
  "appframe.save_close": "Save and close",
  "appframe.updated": "{app} was updated to {version}.",
  "appframe.updated_reload": "An administrator approved a new version of {app}. Reload it to use the new version - save your work first.",
  "appframe.reload": "Reload",
  "appframe.dismiss": "Dismiss",
  "appframe.not_connected": "{app} did not start. Close it and open it again; if it keeps happening, tell your administrator.",
  "appframe.save_as_title": "{app}: save “{name}” to",
  "plugin.view.busy": "Working…",
  "plugin.view.unsupported": "This screen uses a component this version cannot draw ({type})",
  "plugin.view.error": "The app answered with an error",
  "plugin.output_missing": "The output is no longer where it was",
  /* M2 - surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Loading…",
  "plugin.view.preview_failed": "The preview could not be loaded",
  "plugin.steps.label": "Steps",
  "plugin.list.empty": "Nothing here yet",
  "plugin.list.actions": "Actions",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Actions",
  "plugin.people.placeholder": "Name or email",
  "plugin.people.placeholder_email": "Email address",
  "plugin.people.add": "Add",
  "plugin.people.remove": "Remove {name}",
  "plugin.people.invalid_email": "Enter a valid email address",
  "plugin.people.external_off": "Only people with an account can be added",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Choose…",
  "plugin.file.clear": "Clear",
  "plugin.file.none": "Nothing chosen",
  /* M3 - the sign track: signature-pad + pdf-fields nodes, and the outside
     participant's public page (views/PublicSurface.vue via usePublicPage). */
  "plugin.sig.mode_draw": "Draw",
  "plugin.sig.mode_type": "Type",
  "plugin.sig.mode_upload": "Upload",
  "plugin.sig.draw_hint": "Sign here with your finger or mouse",
  "plugin.sig.type_placeholder": "Type your name",
  "plugin.sig.upload_pick": "Choose a picture…",
  "plugin.sig.upload_hint": "PNG or JPEG, at most {kb} KB",
  "plugin.sig.upload_too_big": "The picture is larger than {kb} KB",
  "plugin.sig.upload_bad_type": "Only PNG or JPEG pictures can be used",
  "plugin.sig.upload_unreadable": "The picture could not be read",
  "plugin.sig.clear": "Clear signature",
  "plugin.sig.signed": "Signature captured",
  "plugin.pdf.load_failed": "The document could not be loaded",
  "plugin.pdf.palette": "Field types",
  "plugin.pdf.pending": "Boxes waiting for a place",
  "plugin.pdf.place_box_hint": "Tap the page where “{name}” goes, or drag to size it",
  "plugin.pdf.all_placed": "Every box has a place",
  "plugin.pdf.place_idle": "Choose one of the boxes above, then tap the page where it goes.",
  "plugin.pdf.place_idle_done": "Tap a box on the page to take it off or copy it; drag it to move it.",
  "plugin.pdf.no_boxes": "No boxes yet. Add one below: give it a name, say whose it is, and place it on the document in the next step.",
  "plugin.pdf.add_box": "Add a box",
  "plugin.pdf.unplace": "Take off the page",
  "plugin.pdf.place_hint": "Tap the page where the {type} field goes, or drag to size it",
  "plugin.pdf.type_signature": "Signature",
  "plugin.pdf.type_initials": "Initials",
  "plugin.pdf.type_date": "Date",
  "plugin.pdf.type_text": "Text",
  "plugin.pdf.type_checkbox": "Checkbox",
  "plugin.pdf.tap_signature": "Tap to sign",
  "plugin.pdf.tap_initials": "Tap to initial",
  "plugin.pdf.tap_date": "Tap for today",
  "plugin.pdf.tap_text": "Text",
  "plugin.pdf.tap_checkbox": "Tap to tick",
  "plugin.pdf.label": "Name",
  "plugin.pdf.assignee": "Signer",
  "plugin.pdf.unassigned": "Anyone",
  "plugin.pdf.filled_by": "Filled by",
  "plugin.pdf.style": "How it is signed",
  "plugin.pdf.style_drawn": "Drawn",
  "plugin.pdf.style_typed": "Typed",
  "plugin.pdf.lines": "Printed under it",
  "plugin.pdf.lines_preview": "Under the signature:",
  "plugin.pdf.lines_none": "Nothing is printed under this signature.",
  "plugin.pdf.required": "Required",
  "plugin.pdf.copy_to_page": "Copy to page",
  "plugin.pdf.copy": "Copy",
  "plugin.pdf.delete": "Delete field",
  "plugin.pdf.zoom_in": "Zoom in",
  "plugin.pdf.zoom_out": "Zoom out",
  "plugin.pdf.zoom_fit": "Fit to width",
  "plugin.pdf.zoom_fit_page": "Fit the page to the screen",
  "plugin.pdf.pad_for": "Your {type}",
  "plugin.pdf.pad_done": "Done",
  "plugin.page.loading": "Loading…",
  "plugin.page.pin_title": "This page is protected",
  "plugin.page.pin_hint": "Enter the PIN you were given to continue",
  "plugin.page.pin_submit": "Continue",
  "plugin.page.pin_wrong": "That PIN is not right",
  "plugin.page.pin_locked": "Too many wrong PINs - wait a few minutes and try again",
  "plugin.page.unavailable_title": "This link is not available",
  "plugin.page.unavailable_text": "It may have expired, been used up or been withdrawn. Ask the person who sent it for a new one.",
  "plugin.page.accepted_title": "Received, thank you",
  "plugin.page.accepted_text": "Your answer has been recorded. You can close this page.",
  "plugin.page.done_title": "All done",
  "plugin.page.done_text": "There is nothing more to do here. You can close this page.",
  "plugin.page.error_title": "Something went wrong",
  "plugin.page.retry": "Try again",
  "plugin.page.files": "Documents",
  "plugin.page.open_file": "Open {name} in a new tab",
  "plugin.page.footer": "Served by filex",
  /* The public pages' own sentences (share, file request) are the SERVER's
     `server.public.*` (composables/usePublicText) - not keys of this file. */
  /* === App plugins v2 - a `page` view, an app's lock on a file, the output
     mode a job wrote in, and the faces + rules a signature field carries. === */
  "plugin.page_view.back": "Back to the files",
  "plugin.page_view.queued_title": "The job is queued",
  "plugin.page_view.queued_text": "filex is working on it. This page says when it is done, and its progress is in the operations tray too.",
  "plugin.page_view.finished_title": "The job is done",
  "plugin.page_view.finished_text": "There is nothing more to do here. You can go back to the files or close this tab.",
  "plugin.page_view.failed_title": "The job did not finish",
  "plugin.page_view.opening_title": "Opening the result",
  "plugin.page_view.open_ops": "Open the operations tray",
  "plugin.page_view.done_title": "All done",
  "plugin.page_view.done_text": "There is nothing more to do here. You can close this tab.",
  "plugin.page_view.error_title": "This screen could not be opened",
  "plugin.page_view.retry": "Try again",
  "plugin.page_view.blocked": "The new tab was blocked - allow pop-ups for this site, or the screen will open in a dialog",
  "plugin.output.sibling": "new file",
  "plugin.output.version": "new version",
  "plugin.output.sibling_title": "The result lands as a new file beside the original",
  "plugin.output.version_title": "The result replaces the file as a new version of it",
  "plugin.sign.font_label": "Handwriting",
  "plugin.pdf.font": "Font",
  "plugin.pdf.rule_number": "Numbers only",
  "plugin.pdf.rule_email": "Email address",
  "plugin.pdf.rule_length": "Between {min} and {max} characters",
  "plugin.pdf.rule_min": "At least {min} characters",
  "plugin.pdf.rule_max": "At most {max} characters",
  "plugin.pdf.err_number": "Enter a number",
  "plugin.pdf.err_email": "Enter a valid email address",
  "plugin.pdf.err_min": "Too short - at least {min} characters",
  "plugin.pdf.err_max": "Too long - at most {max} characters",
  "applock.badge": "Locked",
  "applock.some_app": "an app",
  "applock.held": "{app} locked this file",
  "applock.held_reason": "{app} locked this file: {reason}",
  "applock.until": "- until {date}",
  "applock.inspector": "Held by an app",
  /* issue #34 - a symlink the server will NOT follow (lib/symlink). The badge
     is the short word on the row; `why` is the sentence behind it, shown on
     hover, in the details panel and in the toast when somebody tries to open
     one. ⚠ Broken and outside-of-root are DIFFERENT states and must read
     differently: only one has an administrator remedy, and offering that
     remedy for a target that has been deleted sends the person to a settings
     screen that cannot help them. */
  "symlink.badge.outside_root": "Outside storage",
  "symlink.badge.broken": "Broken link",
  "symlink.badge.unresolved": "Remote link",
  "symlink.badge.unknown": "Link",
  "symlink.why.outside_root": `A link whose target lies outside this storage, which is why it cannot be opened. An administrator can allow it with "Follow symlinks that leave this folder" in the storage's settings.`,
  "symlink.why.broken": "A link whose target no longer exists, so there is nothing to open. It has to be repaired or removed on the server - no setting can bring the target back.",
  "symlink.why.unresolved": "A link on a remote server. filex cannot tell whether its target is inside this storage, so it does not follow it and cannot open it.",
  "symlink.why.unknown": "A link filex will not follow, so it cannot be opened. Its target is either outside this storage, missing, or on a remote server filex cannot resolve.",
  "symlink.inspector": "A link that cannot be opened",
  /* Issue #104 - an entry the storage could not answer for (lib/unavailable).
     The sentence says what it means and what happens next; the storage's own
     answer follows it ({reason}), usually in English. */
  "unavailable.why.file": "The storage could not say whether this file still exists. It cannot be opened or changed until the storage answers for it again; the next scan checks.",
  "unavailable.why.dir": "The storage could not say whether this folder still exists. Neither the folder nor anything inside it can be opened or changed until the storage answers for it again; the next scan checks.",
  "unavailable.withReason": "{why} The storage answered: {reason}",
  "unavailable.inspector": "Unavailable",
  /* 0.50 - why a file has no thumbnail, on the file itself (lib/thumbNote):
     the marker's name and the sentence a resting pointer or a tap shows. */
  "thumbNote.corrupt": "Damaged",
  "thumbNote.corrupt_why": "No thumbnail: the file could not be read. It may be damaged or incomplete.",
  "thumbNote.encrypted": "Encrypted",
  "thumbNote.encrypted_why": "No thumbnail: the file is encrypted or protected by a password.",
  "thumbNote.too_large": "Too large",
  "thumbNote.too_large_why": "No thumbnail: the file is larger than the thumbnail size limit.",
  "thumbNote.full": "{label}. {why}",
  "plugin.pdf.rule": "Accepts",
  "plugin.pdf.rule_kind_any": "Any text",
  "plugin.pdf.rule_kind_number": "Numbers only",
  "plugin.pdf.rule_kind_email": "Email address",
  "plugin.pdf.rule_min_label": "Min length",
  "plugin.pdf.rule_max_label": "Max length",
  "plugin.pdf.format": "Date layout",
  "plugin.pdf.date_order": "Date order",
  "plugin.pdf.date_separator": "Separator",
  "plugin.pdf.date_example": "Example",
  "opc.kind.archive-create": "Creating archive",
  "opc.kind.archive-extract": "Extracting archive",
  /* === wiring:c4 - onboarding tour + accessibility + error card === */
  "tour.aria": "Onboarding tour",
  "tour.restart": "Restart the tour",
  "tour.skip": "Skip tour",
  "tour.back": "Back",
  "tour.next": "Next",
  "tour.done": "Done",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Storages & views",
  "tour.step.nav.desc": "Home, Shared with me, Recent, Starred and Trash are always in this panel, with your storages and connections underneath. The button in the top-left corner collapses it to a rail and brings it back.",
  "tour.step.nav.desc_closed": "This button opens the navigation panel: Home, Shared with me, Recent, Starred and Trash, with your storages and connections underneath.",
  "tour.step.new.title": "Add something",
  "tour.step.new.desc": "Everything new starts here - upload from this device, create a folder, or ask somebody else for a file. Dropping files onto the window uploads them as well.",
  "tour.step.new.desc_fab": "This button uploads files from this device. Dropping files onto the window works as well.",
  "tour.step.search.title": "Search",
  "tour.step.search.desc": 'This field searches the whole storage by name - separators and one typo are forgiven, so "invoice 2026" finds invoice_2026.pdf. Add tag:invoice to filter by tag. The sliders button opens advanced search, and {palette} opens the command palette, which runs commands too.',
  "tour.step.crumb.title": "Where you are",
  "tour.step.crumb.desc": "This trail is the address of the folder on screen. Click any step to go back up, and the chevron beside the last one lists the folders inside it.",
  "tour.step.filters.title": "Narrow the list",
  "tour.step.filters.desc": "Type, Owner, Modified and Size filter the folder you are in, the box beside them matches names as you type, and the control at the end of the row sorts.",
  "tour.step.view.title": "Switch views",
  "tour.step.view.desc": "Change how this folder is drawn; your choice is remembered.",
  "tour.step.details.title": "Details & sharing",
  "tour.step.details.desc": 'Select a file and open this panel for its details, its activity and its share links. For the full menu, right-click the file or use the button at the end of its row - "Share" there creates a link with an optional PIN and expiry.',
  "tour.step.help.title": "Shortcuts",
  "tour.step.help.desc": 'Press {help} for the shortcut cheat-sheet and {palette} for the command palette. Theme and "Restart the tour" are in the "More actions" menu at the top right; your account and sign-out are behind the avatar beside it.',
  "error.hint": "This may be a temporary network or server problem. Please try again.",
  "error.details": "Technical details",
  "col.star": "Star",
  "toolbar.view_label": "View",
  "list.aria": "File list",
  "grid.aria": "File grid",
  /* === wiring:d1 - tabs + split pane === */
  "tabs.strip": "Tabs",
  "tabs.new": "New tab",
  "tabs.close": "Close tab",
  "tabs.split": "Split view",
  "tabs.split_off": "Close split",
  "ctx.open_new_tab": "Open in new tab",
  "ctx.open_with": "Open with {app}",
  "ctx.open_with_builtin": "Open with the built-in viewer",
  "ctx.open_with_choose": "Choose an app…",
  "openWith.title": "Open with",
  "openWith.lead": "Which app should open {name}?",
  "openWith.builtin": "filex viewer (built-in)",
  "openWith.onlyoffice": "ONLYOFFICE (spreadsheet editor)",
  "openWith.now": "Opens it now",
  "openWith.always": "Always use this app for {ext} files",
  "openWith.hint": "Kept on your account. You can change it in Settings, Default apps.",
  "openWith.open": "Open",
  "shortcuts.group.tabs": "Tabs",
  "shortcuts.tab_new": "New tab",
  "shortcuts.tab_close": "Close tab",
  "shortcuts.tab_next": "Next tab",
  "shortcuts.tab_prev": "Previous tab",
  /* tus:t1 - the menu verbs */
  "shortcuts.new_folder": "New folder",
  "shortcuts.upload": "Upload files",
  "shortcuts.refresh": "Refresh the listing",
  "shortcuts.download": "Download",
  "shortcuts.preview": "Preview",
  "shortcuts.share": "Share",
  "shortcuts.tags": "Tags",
  "shortcuts.open_tab": "Open in a new tab",
  "shortcuts.copy_path": "Copy path",
  "shortcuts.copy_id": "Copy id",
  "shortcuts.restore": "Restore from trash",
  "shortcuts.settings.reserved": "is taken by the browser before the page sees it, so it would do nothing here. Pick another key.",
  "shortcuts.settings.reserved_badge": "Desktop app only",
  "shortcuts.settings.reserved_title": "The browser handles this combination itself. It fires in the desktop app and in an installed PWA, not in a browser tab.",
  "cmd.tab_new": "Open a new tab",
  "cmd.split_toggle": "Toggle split view",
  "split.pane": "Secondary pane",
  "split.close": "Close the side pane",
  "split.error": "Could not load the listing",
  "split.retry": "Retry",
  "split.copy_queued": "Copy queued",
  "split.move_queued": "Move queued",
  "toast.move_kept_both": "Move queued. A name was already taken there, so that item will be kept beside the existing one with “-copy” added. This move cannot be undone.",
  "split.cross_copy": "Different storages - copy queued instead",
  "dragout.downloading": "Downloading into the folder you dropped on…",
  "dragout.downloading_n": "Downloading into the folder you dropped on - {n} files so far…",
  "dragout.downloading_n_one": "Downloading into the folder you dropped on - {n} file so far…",
  "dragout.stop": "Stop",
  "dragout.stopping": "Stopping…",
  "dragout.stopped": "Stopped - what had arrived stays in the folder",
  "dragout.not_found": "Could not find where it was dropped - a drop onto an application (rather than a folder) cannot be filled in",
  "dragout.done": "Download finished",
  "dragout.ready": "Files are ready - drag them to your desktop",
  "dragout.preparing": "Getting them ready to drag…",
  "split.cross_move": "Different storages - move queued (bytes travel, then the original is removed)",
  /* === /wiring:d1 === */
  /* wiring:d2 - gallery view */
  "toolbar.view.gallery": "Gallery",
  "gallery.aria": "File gallery",
  /* /wiring:d2 */
  /* wiring:d3 - inspector node comments */
  "inspector.section.comments": "Comments",
  "inspector.comments.empty": "No comments yet.",
  "inspector.comments.placeholder": "Write a comment…",
  "inspector.comments.send": "Send",
  "inspector.comments.delete": "Delete comment",
  /* wiring:e2 - end-to-end encrypted folders */
  "e2e.create.title": "Create encrypted folder",
  "e2e.create.option": "Create encrypted folder…",
  "e2e.create.pw_label": "Folder password",
  "e2e.create.pw_placeholder": "At least 8 characters",
  "e2e.create.pw2_label": "Repeat the password",
  "e2e.create.warn_title": "NO WAY BACK",
  "e2e.create.warn_body": "Files in this folder can only be opened with this password or the recovery key shown once when the folder is created. The password is NEVER stored on the server, and filex keeps no copy of the recovery key either. Lose both and the contents are gone for good.",
  "e2e.create.ack": "I understand: if I lose both the password and the recovery key, my data cannot be recovered.",
  "e2e.create.ack_required": "Please confirm the warning to continue.",
  "e2e.create.pw_short": "Password must be at least 8 characters.",
  "e2e.create.pw_mismatch": "Passwords do not match.",
  "e2e.create.bad_name": "Invalid folder name.",
  "e2e.create.create": "Create encrypted folder",
  "e2e.create.busy": "Creating…",
  "e2e.create.done": "Encrypted folder created",
  "e2e.create.failed": "Could not create the encrypted folder",
  "e2e.create.nested": "You cannot create an encrypted folder inside another one.",
  /* wiring:e2 policy - asking an administrator to allow one encryption
     (E2eRequestModal), where the tenant's policy wants an approval first. */
  "e2e.request.ctx": "Request encryption…",
  "e2e.request.option": "Request an encrypted folder…",
  "e2e.request.title": "Request encryption for “{name}”",
  "e2e.request.lead": "Making an encrypted folder here needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and this folder: it can be used once, to make one new encrypted folder directly inside it.",
  "e2e.request.lead_folder": "Encrypting this folder needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and this folder: it can be used once, to encrypt this folder where it is, and not a folder inside it.",
  "e2e.request.lead_file": "Encrypting this file needs an administrator’s approval. Say why you need it; you will be told the answer. An approval is for you and the folder this file is in: it can be used once, for one new encrypted file there.",
  "e2e.request.reason": "Reason",
  "e2e.request.reason_placeholder": "What it holds, and why it must be encrypted",
  "e2e.request.reason_required": "Write a reason for the administrator.",
  "e2e.request.send": "Send request",
  "e2e.request.sending": "Sending…",
  "e2e.request.sent": "Request sent. You will be notified when an administrator answers.",
  "e2e.request.already": "You already asked for this; it is waiting for an administrator.",
  "e2e.request.failed": "The request could not be sent.",
  "e2e.locked.title": "This folder is end-to-end encrypted",
  "e2e.locked.hint": "Enter the folder password to see its contents. The password stays in this tab’s memory only.",
  "e2e.locked.pw_placeholder": "Folder password",
  "e2e.locked.unlock": "Unlock",
  "e2e.locked.busy": "Verifying…",
  "e2e.unlock.wrong": "Wrong password.",
  "e2e.unlock.damaged": "The password is right, but the folder key in the key file (.filex-e2e.json) does not open: the file is damaged. Try the recovery key.",
  "e2e.unlock.marker_missing": "Could not read the key file (.filex-e2e.json).",
  /* ikon:emoji - the listing marker's accessible name. The row used to print
     a 🔒 and nothing else; the padlock that replaced it is aria-hidden inside
     the tile, so the span that carries it says this instead. */
  "e2e.badge": "Encrypted folder",
  "e2e.strip.label": "Encrypted folder - unlocked",
  "e2e.strip.lock": "Lock",
  /* wiring:e2 password - changing a folder's password */
  "e2e.password.strip_action": "Change password…",
  "e2e.password.title": "Change the folder password",
  "e2e.password.reset_title": "Set a new password for this folder",
  "e2e.password.reset_lead": "You opened this folder with its recovery key, so its password was lost or may be known to someone. Set a new one now. Closing this dialog locks the folder again.",
  "e2e.password.current": "Current password",
  "e2e.password.recovery": "Recovery key",
  "e2e.password.use_recovery": "I do not remember it - use the recovery key",
  "e2e.password.use_current": "Use the current password instead",
  "e2e.password.new": "New password",
  "e2e.password.current_required": "Enter the current password, or use the recovery key.",
  "e2e.password.bad_recovery": "That is not a recovery key (32 characters, in groups of four).",
  "e2e.password.same": "The new password is the same as the current one.",
  "e2e.password.cheap_note": "Only the folder’s key file changes. No file is re-encrypted, and the recovery key and any escrow key keep working.",
  "e2e.password.old_copies": "Someone who knows the old password and has an old copy of the key file (a version, a backup) can still open the folder with it. If that is a risk, tick “Also replace the folder key”.",
  "e2e.password.rotate_label": "Also replace the folder key (re-wraps every file’s key; use this if the old password may be known)",
  "e2e.password.rekey_title": "This folder is from before v0.31: its key comes from its password",
  "e2e.password.rekey_body": "A new password therefore needs a new folder key, and the key of every file in the folder is re-wrapped under it. The contents are not re-encrypted. It can take a while, and if it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rotate_title": "The folder key is replaced too",
  "e2e.password.rotate_body": "Every file’s key is re-wrapped under a new folder key. The contents are not re-encrypted. If it is interrupted it continues where it stopped; the files open throughout.",
  "e2e.password.rekey_rk_new": "You get a new recovery key, shown once; the old one stops working.",
  "e2e.password.rekey_rk_kept": "The recovery key you used keeps working.",
  "e2e.password.rekey_escrow": "The operator’s escrow key keeps working: its slot is sealed to the new folder key.",
  "e2e.password.rekey_ack": "I understand: this re-wraps the key of every file in the folder.",
  "e2e.password.submit": "Change password",
  "e2e.password.busy": "Changing…",
  "e2e.password.lock_instead": "Lock the folder instead",
  "e2e.password.wrong_current": "Wrong password.",
  "e2e.password.wrong_recovery": "Wrong recovery key.",
  "e2e.password.escrow_blocked": "This folder has an escrow slot for a key this installation does not have, and replacing the folder key would lose it. Nothing was changed.",
  "e2e.password.failed": "Could not change the password. Nothing was changed.",
  "e2e.password.done": "Password changed. The old password no longer opens this folder.",
  "e2e.password.resume_title": "File keys are still being re-wrapped",
  "e2e.password.resume_body": "The password was changed and a new folder key issued. Some files still have their key under the previous one; they open either way. Continue to finish.",
  "e2e.password.progress": "{n} files re-wrapped so far · {failed} failed",
  "e2e.password.progress_one": "{n} file re-wrapped so far · {failed} failed",
  "e2e.password.rekey_partial": "{n} files could not be re-wrapped. They still open with the previous key; continue to try again.",
  "e2e.password.rekey_partial_one": "{n} file could not be re-wrapped. It still opens with the previous key; continue to try again.",
  "e2e.password.rekey_done": "New folder key in place ({n} files re-wrapped). The old password opens nothing here any more.",
  "e2e.password.rekey_done_one": "New folder key in place ({n} file re-wrapped). The old password opens nothing here any more.",
  "e2e.recovery.lead_replaced": "The folder has a new key, so it has a new recovery key too - the old one no longer opens it. Shown once; filex keeps no copy.",
  /* wiring:e2 names - encrypted file and folder names */
  "e2e.unlock.unsupported": "This folder needs a newer filex: it uses {features}, which this version does not understand. Nothing was changed.",
  "e2e.settings.open": "Encryption settings…",
  "e2e.settings.title": "Encryption settings",
  "e2e.settings.level": "Encryption level",
  "e2e.settings.password": "Password",
  "e2e.settings.escrow": "Escrow key",
  "e2e.settings.close": "Close",
  "e2e.level.content": "Contents only",
  "e2e.level.names": "Contents and names",
  "e2e.level.content_hint": "File contents are encrypted. File and folder names stay readable to the server, so WebDAV, the command line and desktop sync keep working with them, and every filex since 0.31 opens the folder.",
  "e2e.level.names_hint": "Contents and file and folder names are encrypted: the server sees only scrambled names. WebDAV, the command line and desktop sync see them scrambled too, and filex 0.47 and older will not open the folder.",
  "e2e.level.pending": "the change of level has not finished",
  "e2e.level.change": "Change level…",
  "e2e.level.raise_title": "Move this folder to “Contents and names”?",
  "e2e.level.raise_body": "filex gives every file and folder in here an encrypted name, in this browser. The contents are not touched, and if it is interrupted it continues where it stopped. filex does not offer the way back to readable names.",
  "e2e.level.raise_ack": "I understand what changes",
  "e2e.level.raise_go": "Encrypt the names",
  /* wiring:e2 vault - level 3, the vault (docs/E2E-VAULT-FORMAT.md) */
  "e2e.level.vault": "Vault",
  "e2e.level.vault_hint": "Contents, names and the whole tree are encrypted: the server keeps only packs of one size, and does not see how many files there are, their names, their sizes or their dates.",
  "e2e.level.vault_cost": "What it costs: one person writes at a time, and only filex opens it (the web app, the desktop app, filex decrypt and filex vault mount). WebDAV, folder sync, share links and previews on the server do not reach inside.",
  "e2e.vault.pack_label": "Pack size",
  "e2e.vault.pack_4": "4 MiB",
  "e2e.vault.pack_4_help": "The default. The smallest change uploads 4 MiB.",
  "e2e.vault.pack_16": "16 MiB",
  "e2e.vault.pack_16_help": "Fewer, larger files on the server. Every change uploads at least 16 MiB.",
  "e2e.vault.pack_hint": "Chosen now and never again. Every pack on the server is this size, and what it does not use is filled with random bytes.",
  "e2e.vault.read_only": "Read-only. An upload, a new folder or any other change takes the write lock, when nobody else holds it.",
  "e2e.vault.writing": "You are writing to this vault. If you do nothing for {left}, it goes back to read-only.",
  "e2e.vault.lock_countdown": "If nothing is done in it for {left}, the vault locks and asks for the password again.",
  "e2e.vault.held_by": "{name} has been writing since {since}. The vault is read-only for you.",
  "e2e.vault.someone": "Someone",
  "e2e.vault.take_over": "Take over",
  "e2e.vault.lost_idle": "You did nothing for {n} minutes, so this vault went back to read-only. Nothing was lost.",
  "e2e.vault.lost_idle_one": "You did nothing for {n} minute, so this vault went back to read-only. Nothing was lost.",
  "e2e.vault.lost_taken": "Someone else took over writing. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_taken_by": "{name} took over writing. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_broken_by": "{name} ended your write lock. What you saved stays; the vault is read-only for you.",
  "e2e.vault.lost_connection": "The connection was lost, so this vault went back to read-only.",
  "e2e.vault.lost_expired": "The write lock ran out, so this vault went back to read-only.",
  "e2e.vault.unsaved": "Not saved: {names}. Do it again when the vault is free.",
  "e2e.vault.saving": "Saving…",
  "e2e.vault.saving_progress": "Saving: {done} of {total}",
  "e2e.vault.dismiss": "OK",
  "e2e.vault.continue": "Continue from this state",
  "e2e.vault.ro_damaged": "The newest state of this vault is damaged. You are looking at the one from {when}, read-only.",
  "e2e.vault.ro_damaged_short": "The newest state of this vault is damaged. You are looking at an older one, read-only.",
  "e2e.vault.ro_rollback": "The server offers an older state of this vault than this tab has already seen. It stays read-only here.",
  "e2e.vault.ro_newer": "A newer filex wrote this vault. This version reads it and does not change it.",
  "e2e.vault.unreadable": "No state of this vault can be read: nothing can be shown, and nothing is written.",
  "e2e.vault.limit_warn": "This vault holds {held} of at most {max} files and folders.",
  "e2e.vault.cross": "Nothing moves between a vault and the folders outside it on the server: download it from one, then upload it into the other.",
  "e2e.vault.dl_too_big": "This browser cannot save a file this large from memory. Use a browser that saves straight to disk (Chrome, Edge), or filex decrypt.",
  "e2e.vault.damaged_file": "This file is damaged in the vault and could not be read.",
  "e2e.vault.level_fixed": "A vault stays a vault: its level does not change and its key is not replaced. To start again with a new key, make a new vault and move the files into it.",
  "e2e.vault.locked_idle_toast": "Nothing was done in “{name}” for 15 minutes, so the vault locked itself. Enter the password to open it again.",
  "e2e.vault.open_failed": "The vault could not be opened.",
  "e2e.vault.err.parent_missing": "The folder it was going into is not there any more.",
  "e2e.vault.err.parent_not_folder": "“{name}” is a file, not a folder.",
  "e2e.vault.err.name_taken": "“{name}” is already taken there.",
  "e2e.vault.err.bad_name": "“{name}” cannot be a name in a vault: 1 to 255 bytes, without slashes or control characters, and not . or ..",
  "e2e.vault.err.too_deep": "Folders in a vault go at most 256 deep.",
  "e2e.vault.err.not_found": "“{name}” is not in the vault any more.",
  "e2e.vault.err.is_folder": "“{name}” is a folder.",
  "e2e.vault.err.into_itself": "A folder cannot go into itself.",
  "e2e.vault.err.too_many_entries": "This vault is full: it holds at most 250 000 files and folders. Nothing was changed.",
  "e2e.vault.err.index_too_large": "This vault's index has reached its limit. Nothing was changed.",
  "e2e.vault.err.newer_format": "A newer filex wrote this vault. This version reads it and does not change it.",
  "e2e.vault.err.size_mismatch": "A file changed while it was being uploaded. Upload it again.",
  "e2e.vault.err.changed": "“{name}” changed in the vault since it was opened, so it was not saved over. Open it again to see the newer version.",
  "e2e.vault.err.failed": "The change could not be saved.",
  "userSettings.vault.idle": "Vault: back to read-only after",
  "userSettings.vault.idle_help": "How long a vault you write to stays yours while you do nothing in it. Then others may write; your vault goes back to read-only, and 15 minutes later it locks.",
  "userSettings.vault.minutes": "{n} minutes",
  "userSettings.vault.minutes_one": "{n} minute",
  "userSettings.vault.saved": "Saved",
  "userSettings.vault.failed": "Could not save the vault setting.",
  "e2e.names.move_unreadable": "Not moved: the name of one of the items cannot be read.",
  "e2e.names.move_taken": "Not moved: “{name}” is already taken in that folder. Rename one of the two first.",
  "e2e.convert.ctx": "Encrypt with E2EE…",
  "e2e.convert.title": "Encrypt “{name}”",
  "e2e.convert.lead": "Every file in this folder is encrypted where it is, in this browser, with the password below. Nothing moves; at level 1 the names stay as they are. If it is interrupted, opening the folder again continues it.",
  "e2e.convert.past_title": "What the server already has",
  "e2e.convert.past_body": "Encrypting protects these files from now on. Until now the server has had them in the clear, and some copies remain: filex drops its thumbnails and the text it extracted for search, and can delete older versions and trash entries from this folder.",
  "e2e.convert.drop_versions": "Delete the older versions of these files (they are plaintext)",
  "e2e.convert.drop_trash": "Delete the trash entries that came from this folder",
  "e2e.convert.past_outside": "Backups, replicas and copies anyone already made are outside filex and stay as they are.",
  "e2e.convert.submit": "Encrypt folder",
  "e2e.convert.nested": "This folder holds an encrypted folder. Encrypted folders cannot be nested, so nothing was changed.",
  "e2e.convert.failed": "The folder could not be encrypted. Files already encrypted stay so; open the folder to continue.",
  "e2e.convert.stopped": "Stopped after {n} files. Continue from the strip above the folder.",
  "e2e.convert.stopped_one": "Stopped after {n} file. Continue from the strip above the folder.",
  "e2e.convert.partial": "{n} files could not be encrypted (changed meanwhile, too large, or not writable). They are still plaintext; try again to continue.",
  "e2e.convert.partial_one": "{n} file could not be encrypted (changed meanwhile, too large, or not writable). It is still plaintext; try again to continue.",
  "e2e.convert.too_large_here": "{n} files are too large for this browser to send in one piece, and this server takes no upload in pieces, so they could not be encrypted where they are. They are still plaintext, and the folder stays unfinished until they are encrypted.",
  "e2e.convert.too_large_here_one": "{n} file is too large for this browser to send in one piece, and this server takes no upload in pieces, so it could not be encrypted where it is. It is still plaintext, and the folder stays unfinished until it is encrypted.",
  "e2e.convert.large_progress": "Encrypting “{name}”: {percent}%",
  "e2e.convert.busy": "Encrypting the folder…",
  "e2e.convert.resume_title": "Finish encrypting this folder",
  "e2e.convert.resume_body": "Encrypting this folder started and did not finish. Files it has not reached yet are still plaintext on the server. Continuing picks up where it stopped.",
  "e2e.convert.progress": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.progress_one": "{n} of {total} files encrypted · {failed} not done",
  "e2e.convert.done": "Folder encrypted ({n} files). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.done_one": "Folder encrypted ({n} file). Old versions deleted: {versions}; trash entries deleted: {trash}.",
  "e2e.convert.cleanup_failed": "The folder is encrypted, but its old versions and trash entries could not be deleted - only the folder’s owner or an administrator can.",
  "e2e.names.locked_item": "🔒 Encrypted item",
  "e2e.names.unreadable_item": "🔒 Unreadable name",
  "e2e.names.key_failed": "The key file says the names in this folder are encrypted, but their key does not open with this one. Nothing was changed.",
  "e2e.names.write_failed": "Could not write the name file of a long name, so nothing was uploaded.",
  "e2e.names.bad_name": "“{name}” cannot be used in an encrypted folder: a name must be 1-255 bytes, with no slash, backslash or control character.",
  "e2e.names.offer_cost": "What changes: WebDAV, the command line and desktop sync will see scrambled names, and filex 0.47 and older will refuse to open this folder. The server still sees how many items there are and how big they are.",
  "e2e.names.resume_title": "Finish encrypting the names",
  "e2e.names.resume_body": "Encrypting the names in this folder started and did not finish. Items it has not reached yet still have readable names. Continuing picks up where it stopped.",
  "e2e.names.resume": "Continue",
  "e2e.names.stop": "Stop",
  "e2e.names.busy": "Encrypting names…",
  "e2e.names.progress": "{n} names encrypted so far · {failed} could not be renamed",
  "e2e.names.progress_one": "{n} name encrypted so far · {failed} could not be renamed",
  "e2e.names.done": "Names encrypted ({n} items renamed). The server no longer sees them.",
  "e2e.names.done_one": "Names encrypted ({n} item renamed). The server no longer sees them.",
  "e2e.names.stopped": "Stopped after {n} names. The rest keep their readable names until you continue.",
  "e2e.names.stopped_one": "Stopped after {n} name. The rest keep their readable names until you continue.",
  "e2e.names.partial": "{n} items could not be renamed (no permission, or a name a disk cannot hold). Their names stay readable; try again to continue.",
  "e2e.names.partial_one": "{n} item could not be renamed (no permission, or a name a disk cannot hold). Its name stays readable; try again to continue.",
  "e2e.names.failed": "Could not encrypt the names. Nothing already renamed is lost; try again to continue.",
  "e2e.names.strip_fix": "Fix {n} names (readable, or moved in from outside filex)",
  "e2e.names.strip_fix_one": "Fix {n} name (readable, or moved in from outside filex)",
  "e2e.create.names_root_hint": "The folder’s own name stays readable either way - it sits in a folder that is not encrypted. Pick a name that gives nothing away.",
  "e2e.locked_toast": "Folder locked",
  "e2e.app_closed_unsaved": "The changes to “{name}” that were not saved are gone: the app closed when the folder locked.",
  "e2e.upload.locked": "Unlock the folder first",
  "e2e.decrypting": "Decrypting…",
  "e2e.decrypt_failed": "Could not decrypt the file (password changed or file corrupted).",
  /* wiring:e2 recovery - recovery keys + operator escrow */
  "e2e.create.escrow_title": "This server holds a second key",
  "e2e.create.escrow_body": "Key escrow is enabled on this installation, so its operator can open this folder without your password. Using that key notifies you. Escrow is fixed when the server is installed and cannot be turned off for a folder.",
  "e2e.locked.use_recovery": "Lost the password? Use a recovery key",
  "e2e.recovery.title": "Save your recovery key",
  "e2e.recovery.title_upgraded": "Your recovery key",
  "e2e.recovery.lead": "This key opens the folder without its password. It is shown once - filex does not store it and cannot show it again.",
  "e2e.recovery.lead_upgraded": "This folder now has a recovery key. It opens the folder without its password, is shown once, and is not stored by filex.",
  "e2e.recovery.copy": "Copy",
  "e2e.recovery.copied": "Copied",
  "e2e.recovery.download": "Download as a file",
  "e2e.recovery.warn_title": "TREAT THIS LIKE A PASSWORD",
  "e2e.recovery.warn_body": "Anyone holding this key can read the folder. Keep it somewhere separate from the password - a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.escrow_title": "This server also holds a key",
  "e2e.recovery.escrow_body": "Key escrow is enabled here, so the operator of this installation can open this folder without your password. You are notified when that key is used.",
  "e2e.recovery.escrow_kid": "Escrow key",
  "e2e.recovery.ack": "I have saved this key somewhere safe.",
  "e2e.recovery.done": "Done",
  "e2e.recover.title": "Unlock without the password",
  "e2e.recover.none": "This folder was created before recovery keys existed, so it has none. Its password is the only way in. Unlock it with the password once and filex will offer to add a recovery key.",
  "e2e.recover.tab_recovery": "Recovery key",
  "e2e.recover.tab_escrow": "Escrow key",
  "e2e.recover.recovery_hint": "The key shown once when this folder was created.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "The owner will be told",
  "e2e.recover.escrow_warn_body": "Opening a folder with the escrow key notifies its owner. Use it only when you are entitled to.",
  "e2e.recover.escrow_kid": "Escrow key",
  "e2e.recover.escrow_predates": "This installation has an escrow key, but this folder does not. It was created before escrow was turned on here, so its master key was never wrapped to the escrow identity. The escrow key will not open it. Nothing the operator can do changes that - adding a slot needs this folder’s password, which the server has never had. The folder’s owner can grant it: unlock with the password, then choose to give the operator a key. Until they do, use the password or the recovery key.",
  "e2e.recover.escrow_other_key": "This folder carries an escrow key from a DIFFERENT installation. It was created elsewhere and restored here, so this installation’s escrow key does not open it. Only the private key belonging to the escrow key it was sealed to can.",
  "e2e.recover.escrow_placeholder": "Paste the escrow private key (PKCS#8, base64 or PEM)",
  "e2e.recover.bad_format": "That does not look like a recovery key. It is 32 characters in eight groups of four.",
  "e2e.recover.escrow_required": "Paste the escrow private key.",
  "e2e.recover.wrong_recovery": "That recovery key does not open this folder.",
  "e2e.recover.wrong_escrow": "That escrow key does not open this folder. A folder created before escrow was turned on has no escrow slot until its owner grants one - until then, use the password or the recovery key.",
  "e2e.recover.bad_escrow_key": "That is not a readable private key (expected PKCS#8, base64 or PEM).",
  "e2e.recover.notify_failed": "Could not notify the folder owner, so the folder was not unlocked. Escrow use is always announced.",
  "e2e.recover.recovery_done": "Unlocked with the recovery key",
  "e2e.recover.escrow_done": "Unlocked with the escrow key - the owner has been notified",
  "e2e.recover.unlock": "Unlock",
  "e2e.recover.busy": "Unlocking…",
  "e2e.escrowoffer.title": "Give the operator a key to this folder?",
  "e2e.escrowoffer.body": "This folder was created before key escrow was turned on here, so the operator of this installation cannot open it. Right now - while your password is in memory - filex can seal this folder to the escrow key. Your files are not re-encrypted or moved; only the key file changes.",
  "e2e.escrowoffer.consequence": "What this means: the operator gains a second, permanent way into this folder, without your password. You are notified when that key is used, but that notification is an announcement rather than a control.",
  "e2e.escrowoffer.learn_more": "What escrow can and cannot do",
  "e2e.escrowoffer.password_label": "Folder password",
  "e2e.escrowoffer.password_required": "Enter the folder password.",
  "e2e.escrowoffer.wrong_password": "That is not this folder’s password.",
  "e2e.escrowoffer.accept": "Give the operator a key",
  "e2e.escrowoffer.decline": "No, keep it to myself",
  "e2e.escrowoffer.cancel": "Cancel",
  "e2e.escrowoffer.busy": "Sealing…",
  "e2e.escrowoffer.done": "The operator can now open this folder with the escrow key",
  "e2e.escrowoffer.declined_toast": "Kept to yourself. filex will not ask again for this folder.",
  "e2e.escrowoffer.decline_failed": "Could not record your answer, so filex will ask again next time. Nothing about the folder changed.",
  "e2e.escrowoffer.failed": "Could not give the operator a key to this folder",
  "e2e.escrowoffer.strip_action": "Escrow key…",
  "e2e.upgrade.title": "This folder has no recovery key",
  "e2e.upgrade.body": "It was created before recovery keys existed, so its password is the only way in. Right now - and only right now, while the password is in memory - filex can add one. Your files are not re-encrypted or moved.",
  "e2e.upgrade.escrow_note": "Note: this installation has key escrow enabled, so adding a recovery key also lets its operator open this folder without your password.",
  "e2e.upgrade.accept": "Create a recovery key",
  "e2e.upgrade.decline": "Not now",
  "e2e.upgrade.busy": "Creating…",
  "e2e.upgrade.failed": "Could not add a recovery key to this folder",
  "e2e.download.failed": "Could not download the encrypted file.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Connections",
  "conn.subtitle": "How to reach {host} from your own computer: mount it, or point a client at it.",
  "conn.close": "Close",
  "conn.list.disabled": "Disabled",
  "conn.form.required": "Required",
  "conn.form.advanced": "Advanced settings",
  /* A two-button decision's own words, when the declaration did not name them. */
  "conn.form.yes": "Yes",
  "conn.form.no": "No",
  "conn.form.noFields": "This server did not describe any settings for this driver.",
  "conn.form.reveal": "Show",
  "conn.form.hide": "Hide",
  "conn.guide.protocol": "Protocol",
  "conn.guide.storage": "Storage",
  "conn.guide.allStorages": "All storages",
  "conn.guide.copy": "Copy",
  "conn.guide.copied": "Copied",
  "conn.guide.goodToKnow": "Good to know",
  "conn.guide.userPlaceholder": "your-email@example.com",
  "conn.guide.secretPlaceholder": "your-password-or-api-key",
  "conn.guide.fact.url": "Address",
  "conn.guide.fact.urlRootHint": "Every storage you can see appears as a folder under this address.",
  "conn.guide.fact.urlStorageHint": "Mounts “{storage}” directly. Drop the last segment to see every storage.",
  "conn.guide.fact.user": "Username",
  "conn.guide.fact.password": "Password",
  "conn.guide.webdav.summary": "WebDAV mounts filex as a drive: Windows Explorer, macOS Finder, Linux, rclone and Cyberduck all speak it, and every change is mirrored back into filex.",
  "conn.guide.webdav.userHint": "Your username or your email - not your display name.",
  "conn.guide.webdav.passwordHint": "Your account password, or an API key (API keys, in the navigation panel). An account with two-factor authentication MUST use an API key: Basic auth has no second-factor slot.",
  "conn.guide.webdav.win.s1": "Open File Explorer, right-click This PC and choose “Map network drive…”.",
  "conn.guide.webdav.win.s2": "Pick a drive letter and enter {url} as the folder.",
  "conn.guide.webdav.win.s3": "Tick “Connect using different credentials” and sign in with the username and password above.",
  "conn.guide.webdav.win.cmdCaption": "Command Prompt (same thing, without the wizard)",
  "conn.guide.webdav.win.limits": "Windows has three built-in limits that look exactly like filex bugs: transfers stop at ~47.7 MB, folders with about a thousand files refuse to open (“Disk is not formatted”), and the WebClient service must be restarted after changing either.",
  "conn.guide.webdav.win.regCaption": "Run as administrator, then reconnect the drive",
  "conn.guide.webdav.win.https": "HTTPS is mandatory. Windows sends Basic credentials over TLS only, and over plain http:// it silently refuses with no useful message. Do not set BasicAuthLevel to 2 - use TLS.",
  "conn.guide.webdav.win.persist": "The mapped drive does not survive a sign-out: since Windows 7 Basic credentials cannot be stored in Credential Manager, and /persistent:yes does not change that. Re-run the command from a logon script if you need it back automatically.",
  "conn.guide.webdav.win.service": "If nothing mounts at all, make sure the WebClient service is running: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "In Finder choose Go → Connect to Server… (⌘K).",
  "conn.guide.webdav.mac.s2": "Enter {url} and connect.",
  "conn.guide.webdav.mac.s3": "Authenticate with the username and password above.",
  "conn.guide.webdav.mac.note": "The drive appears under Locations; each storage is a top-level folder.",
  "conn.guide.webdav.linux.mountCaption": "davfs2, or the desktop file manager (GNOME Files, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "or paste this address into GNOME Files / Dolphin",
  "conn.guide.webdav.linux.locks": "davfs2 needs locking turned off. filex keeps WebDAV locks in process memory, so they do not survive a restart and are not shared between replicas - davfs2 assumes otherwise and hangs.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone stores an obscured password - run this first and paste the output below",
  "conn.guide.webdav.rclone.passPlaceholder": "<output of rclone obscure>",
  "conn.guide.webdav.rclone.useCaption": "Using it",
  "conn.guide.webdav.duck.s1": "New Bookmark → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Server {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Path {path}.",
  "conn.guide.webdav.duck.s4": "Username {user}, password as above.",
  "conn.guide.webdav.note.delete": "A WebDAV delete is permanent. The web UI moves files to the filex trash; a client delete removes the object from the backing storage directly.",
  "conn.guide.webdav.note.locks": "Locks live in server memory: they do not survive a restart and are not shared between replicas. They exist to satisfy Windows and Office, not to arbitrate concurrent edits.",
  "conn.guide.webdav.note.permissions": "You see exactly what you see in the web UI. The root lists only the storages you may open, and a path outside your grants answers 404 rather than 403, so the tree never leaks what exists.",
  "conn.guide.webdav.note.http": "This server is reachable over plain http://. Windows will refuse to send your credentials at all, and every other client sends your password in the clear. Put filex behind TLS before mounting it.",
  // ── S3 endpoint: keys and the guide ──────────────────────────────
  "conn.s3keys.title": "S3 access keys",
  "conn.s3keys.lead": "An access key lets any S3 client - rclone, restic, the AWS CLI, mc, s3fs, Cyberduck - connect to filex. It carries your own permissions and nothing more.",
  "conn.s3keys.disabled": "The S3 endpoint is switched off on this server (FILEX_S3). A key minted here will not connect until an operator turns it back on.",
  "conn.s3keys.cannotMint": "You are not signed in with an account that can mint access keys. The instructions below still apply - ask for a key and paste it in.",
  "conn.s3keys.label": "What is it for? (laptop backup, CI, …)",
  "conn.s3keys.defaultLabel": "access key",
  "conn.s3keys.everyBucket": "Every bucket I can see",
  "conn.s3keys.prefix": "Folder inside the bucket (optional)",
  "conn.s3keys.mint": "Create key",
  "conn.s3keys.inheritNote": "A key can only ever narrow what you already have: your grants and your role. Confining it to one bucket or folder is the difference between a laptop backup and a credential that can read everything.",
  "conn.s3keys.once": "Copy the secret now - this is the only time it is shown.",
  "conn.s3keys.accessKeyID": "Access key ID",
  "conn.s3keys.secret": "Secret key",
  "conn.s3keys.dismiss": "I have copied it",
  "conn.s3keys.col.label": "Label",
  "conn.s3keys.col.key": "Access key ID",
  "conn.s3keys.col.scope": "Limited to",
  "conn.s3keys.col.lastUsed": "Last used",
  "conn.s3keys.scopeAll": "everything you can see",
  "conn.s3keys.noLabel": "(no label)",
  "conn.s3keys.neverUsed": "never",
  "conn.s3keys.enable": "Enable",
  "conn.s3keys.disable": "Disable",
  "conn.s3keys.revoke": "Revoke",
  "conn.s3keys.confirm": "Sure?",
  "conn.s3keys.empty": "No access keys yet.",
  "conn.guide.s3.summary": "The S3 endpoint makes filex the destination for anything that speaks S3 - backups, sync tools, SDKs - using the storages you already have.",
  "conn.guide.s3.keyPlaceholder": "create a key above",
  "conn.guide.s3.secretPlaceholder": "shown once, when you create the key",
  "conn.guide.s3.fact.endpoint": "Endpoint",
  "conn.guide.s3.fact.endpointHint": "Point the client here, not at the web address of filex.",
  "conn.guide.s3.fact.bucket": "Bucket",
  "conn.guide.s3.fact.bucketHint": "A bucket is a filex storage. Buckets are created by an administrator, not by the client.",
  "conn.guide.s3.fact.key": "Access key ID",
  "conn.guide.s3.fact.keyHint": "The public half. It travels in every request.",
  "conn.guide.s3.fact.secret": "Secret key",
  "conn.guide.s3.fact.secretHint": "Shown once, when the key is created. filex cannot show it again - create a new key if it is lost.",
  "conn.guide.s3.fact.region": "Region",
  "conn.guide.s3.fact.regionHint": "filex has no regions; any value works and is echoed back. Clients still insist on one.",
  "conn.guide.s3.fact.addressing": "Addressing",
  "conn.guide.s3.fact.pathStyle": "path-style (required)",
  "conn.guide.s3.fact.pathStyleHint": "There is no dedicated S3 host on this install, so bucket.host does not resolve.",
  "conn.guide.s3.fact.virtualHosted": "virtual-hosted or path-style",
  "conn.guide.s3.fact.virtualHostedHint": "This install has its own S3 host, so both styles work.",
  "conn.guide.s3.rclone.useCaption": "Use it",
  "conn.guide.s3.rclone.mtime": "filex carries the file modification time (x-amz-meta-mtime), so rclone sync settles after the first run instead of re-uploading everything.",
  "conn.guide.s3.aws.configureCaption": "Configure once",
  "conn.guide.s3.aws.useCaption": "Use it",
  "conn.guide.s3.aws.pathStyle": "Add path addressing to your AWS config, or every command fails at DNS.",
  "conn.guide.s3.restic.envCaption": "Environment",
  "conn.guide.s3.restic.useCaption": "Back up, verify, prune",
  "conn.guide.s3.restic.verified": "Verified against this endpoint: restic check --read-data reads every pack byte for byte and reports no errors.",
  "conn.guide.s3.mc.aliasCaption": "Add the alias",
  "conn.guide.s3.mc.useCaption": "Use it",
  "conn.guide.s3.s3fs.credsCaption": "Credentials file",
  "conn.guide.s3.s3fs.mountCaption": "Mount it",
  "conn.guide.s3.s3fs.note": "Editing a file over s3fs rewrites the whole object, and a delete goes to the filex trash. Good for a shared folder, not for a database.",
  "conn.guide.s3.duck.s1": "New bookmark → Amazon S3.",
  "conn.guide.s3.duck.s2": "Server: {host}.",
  "conn.guide.s3.duck.s3": "Access key ID: {key}, secret as above.",
  "conn.guide.s3.duck.s4": "Open the bookmark; the buckets are your filex storages.",
  "conn.guide.s3.duck.pathStyle": 'In Preferences → S3, turn OFF "Use virtual host style" - this install has no wildcard S3 host.',
  "conn.guide.s3.sdk.note": "Any SigV4 client works the same way: endpoint, key, secret, and path addressing when this install has no S3 host of its own.",
  "conn.guide.s3.note.buckets": "A bucket is a filex storage. A client can create folders and objects inside one, but not the bucket itself - that needs a driver and a path, which an S3 request cannot express.",
  "conn.guide.s3.note.permissions": 'The key sees exactly what you see. A bucket you may not open answers "no such bucket" rather than "forbidden", so the endpoint never reveals what exists.',
  "conn.guide.s3.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.s3.note.mtime": "Uploads carry their modification time, and the checksums clients send (Content-MD5, x-amz-checksum-*) are verified - a corrupted upload is refused rather than stored.",
  "conn.guide.s3.note.pathStyle": "This install has no dedicated S3 host, so clients must be told to use path-style addressing. Without it a current SDK fails at DNS with an error that names neither filex nor the cause.",
  "conn.guide.s3.note.http": "This endpoint is plain http://. Signatures still protect the request, but the objects travel in the clear. Put filex behind TLS before pointing a backup at it.",
  // ── SFTP endpoint: keys and the guide ────────────────────────────
  "conn.sshkeys.title": "SSH keys",
  "conn.sshkeys.lead": "Register a public key and every SSH client - sftp, scp, WinSCP, FileZilla, rclone, sshfs - can connect without sending your password.",
  "conn.sshkeys.disabled": "The SFTP endpoint is switched off on this server (FILEX_SFTP). A key registered here will not connect until an operator turns it back on.",
  "conn.sshkeys.cannotAdd": "You are not signed in with an account that can register keys.",
  "conn.sshkeys.paste": "Paste the contents of ~/.ssh/id_ed25519.pub",
  "conn.sshkeys.name": "Name (optional - the key comment is used otherwise)",
  "conn.sshkeys.add": "Add key",
  "conn.sshkeys.noCopyId": "ssh-copy-id cannot work here: it appends to ~/.ssh/authorized_keys over a shell, and filex has none. This box is the way in.",
  "conn.sshkeys.col.name": "Name",
  "conn.sshkeys.col.fingerprint": "Fingerprint",
  "conn.sshkeys.col.added": "Added",
  "conn.sshkeys.col.lastUsed": "Last used",
  "conn.sshkeys.noName": "(no name)",
  "conn.sshkeys.neverUsed": "never",
  "conn.sshkeys.enable": "Enable",
  "conn.sshkeys.disable": "Disable",
  "conn.sshkeys.remove": "Remove",
  "conn.sshkeys.confirm": "Sure?",
  "conn.sshkeys.empty": "No keys yet. Without one, clients sign in with your account password.",
  "conn.guide.sftp.summary": "SFTP makes filex reachable by anything that already speaks SSH - a backup job, a scanner, WinSCP, rclone, or a mounted folder.",
  "conn.guide.sftp.fact.host": "Host",
  "conn.guide.sftp.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Not 22 and not 443: SFTP is raw TCP and cannot go through the web proxy.",
  "conn.guide.sftp.fact.userHint": "Your username. An @ in it would have to be quoted in most client config files, which is what the username avoids.",
  "conn.guide.sftp.fact.auth": "Sign in with",
  "conn.guide.sftp.fact.authKey": "your registered SSH key (or your password)",
  "conn.guide.sftp.fact.authPassword": "your account password - or register a key above",
  "conn.guide.sftp.fact.authHint": "An API key works as a password too, and is revocable on its own. An account with two-factor sign-in must use an SSH key or an API key.",
  "conn.guide.sftp.fact.path": "Path",
  "conn.guide.sftp.fact.pathHint": "The first folder is a storage; the root lists the ones you may open.",
  "conn.guide.sftp.openssh.connectCaption": "Connect, put, get",
  "conn.guide.sftp.openssh.noShell": "There is no shell here - only the SFTP subsystem. `ssh host command` is refused on purpose, and scp works because OpenSSH 9 speaks SFTP for it.",
  "conn.guide.sftp.key.tab": "Set up a key",
  "conn.guide.sftp.key.s1": "Generate a key pair on the machine that will connect (skip if you already have one).",
  "conn.guide.sftp.key.s2": "Copy the PUBLIC half - the .pub file, never the other one.",
  "conn.guide.sftp.key.s3": "Paste it into the box above and connect; no password is sent from then on.",
  "conn.guide.sftp.key.genCaption": "On your own machine",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id will NOT work against filex: it needs a shell to append to ~/.ssh/authorized_keys, and there is none. Paste the key above instead.",
  "conn.guide.sftp.winscp.s1": "New site → File protocol: SFTP.",
  "conn.guide.sftp.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "User name: {user}. For a key: Advanced → SSH → Authentication → private key file.",
  "conn.guide.sftp.winscp.s4": "WinSCP needs a .ppk private key - use its own tool (Tools → PuTTYgen) to convert an OpenSSH key once.",
  "conn.guide.sftp.filezilla.s1": "File → Site Manager → New site, Protocol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "User: {user}. Logon type: Normal for a password, or Key file for a key.",
  "conn.guide.sftp.rclone.useCaption": "Use it",
  "conn.guide.sftp.sshfs.mountCaption": "Mount and unmount",
  "conn.guide.sftp.sshfs.note": "A mounted folder rewrites the whole file on every save. Good for documents, not for a database or a video you are editing in place.",
  "conn.guide.sftp.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.sftp.note.permissions": "The permission bits your client draws come from your access level here, so a file shown as read-only really is one for you.",
  "conn.guide.sftp.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.sftp.note.totp": "If your account has two-factor sign-in, the password will not work here - SSH has no way to ask for the code. Register an SSH key, or use an API key as the password.",
  "conn.guide.sftp.note.disabled": "The SFTP endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS is here for the equipment that only ever learned FTP - scan-to-folder printers, EDI counterparties, older lab and industrial software. Always over TLS.",
  "conn.guide.ftps.fact.host": "Host",
  "conn.guide.ftps.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "The control channel. Data moves on a separate port from the passive range below.",
  "conn.guide.ftps.fact.mode": "Encryption",
  "conn.guide.ftps.fact.modeValue": "FTPS - explicit TLS (AUTH TLS), required",
  "conn.guide.ftps.fact.modeHint": 'Plain FTP is refused before the password is read. Choose "Require explicit FTP over TLS", never "plain FTP" and never "implicit".',
  "conn.guide.ftps.fact.userHint": "Your username, or your email. An API key works as the password too and can be revoked on its own.",
  "conn.guide.ftps.fact.passwordHint": "Your account password, or an API key. An account with two-factor sign-in must use an API key - FTP has no way to ask for the code.",
  "conn.guide.ftps.fact.pasv": "Passive ports",
  "conn.guide.ftps.fact.pasvHint": "Data connections land here. If your firewall blocks this range the transfer HANGS with no error on either side - that is the classic FTP failure.",
  "conn.guide.ftps.filezilla.s1": "File → Site Manager → New site, Protocol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Host: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Encryption: "Require explicit FTP over TLS". Logon type: Normal, user: {user}.',
  "conn.guide.ftps.filezilla.s4": "Transfer settings → Passive. Active mode is refused by this server.",
  "conn.guide.ftps.winscp.s1": "New site → File protocol: FTP, Encryption: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Host name: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "User name: {user}, password as above.",
  "conn.guide.ftps.curl.caption": "Upload and download",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd is not optional: it makes curl REQUIRE TLS instead of falling back to plaintext. This server refuses plaintext anyway, but the habit protects you against the servers that do not.",
  "conn.guide.ftps.lftp.caption": "Connect",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data encrypts the FILE as well as the sign-in. Without it lftp signs in over TLS and then sends your file in the clear - which is the FTPS misconfiguration people actually ship.",
  "conn.guide.ftps.rclone.useCaption": "Use it",
  "conn.guide.ftps.printer.tab": "Scanner / printer",
  "conn.guide.ftps.printer.s1": "In the device's scan-to-FTP settings: server {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "User: {user}, password as above. Create an API key for the device rather than using your own password - it can be revoked without changing anything else.",
  "conn.guide.ftps.printer.s3": "Path: {path} - or a folder inside it that you created first. The device cannot create a storage.",
  "conn.guide.ftps.printer.s4": 'Turn ON "SSL/TLS" or "FTPS explicit", and PASSIVE mode.',
  "conn.guide.ftps.printer.noTLS": "Plenty of scan-to-FTP firmware cannot do TLS at all. This server will not talk to such a device, and that is deliberate - the alternative is your documents and your password crossing the office network in the clear.",
  "conn.guide.ftps.note.tls": "TLS is mandatory and there is no switch to turn it off. Plain FTP sends your password in the clear and your file after it.",
  "conn.guide.ftps.note.passive": "Passive mode only. Active mode has the server dial back to the client, which does not survive NAT and is blocked by most firewalls.",
  "conn.guide.ftps.note.storages": "The root is not a home directory: it lists the storages you may open, and the first path segment names one.",
  "conn.guide.ftps.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.ftps.note.prefer": "If the client can speak SFTP, prefer it: one connection, one port, no passive-mode surprises.",
  "conn.guide.ftps.note.selfSigned": "This server is using a self-signed certificate. It encrypts the channel but proves nothing about who is on the other end - most clients will ask you to accept it once. Supply a real certificate for anything that matters.",
  "conn.guide.ftps.note.disabled": "The FTPS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS exports",
  "conn.nfs.lead": "An export lets a machine on your network mount filex as a drive - a media player, a build server, a backup box.",
  "conn.nfs.pathIsSecret": "⚠ The export path IS the password. NFS cannot ask a client who it is without Kerberos, so filex puts 32 random bytes in the path instead: whoever knows it can mount as you. Treat the mount line like a credential - /etc/fstab is world-readable on most systems.",
  "conn.nfs.disabled": "The NFS endpoint is switched off on this server (FILEX_NFS). An export created here will not mount until an operator turns it back on.",
  "conn.nfs.cannotMint": "You are not signed in with an account that can create exports.",
  "conn.nfs.label": "What is it for? (media player, backup box, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Every storage I can see",
  "conn.nfs.prefix": "Folder inside the storage (optional)",
  "conn.nfs.allowCidrs": "Allowed addresses, e.g. 192.168.1.0/24 (optional)",
  "conn.nfs.readOnly": "Read-only",
  "conn.nfs.readOnlyHint": "Read-only is the safer default for a machine: it refuses every write through this mount whatever your own permissions are. An address list narrows it further - outside it, the mount is refused.",
  "conn.nfs.mint": "Create export",
  "conn.nfs.once": "Copy this now - the path is shown only once and cannot be recovered.",
  "conn.nfs.dismiss": "I have copied it",
  "conn.nfs.col.label": "Label",
  "conn.nfs.col.scope": "Limited to",
  "conn.nfs.col.mode": "Mode",
  "conn.nfs.col.lastUsed": "Last mounted",
  "conn.nfs.scopeAll": "everything you can see",
  "conn.nfs.modeRead": "read-only",
  "conn.nfs.modeWrite": "read/write",
  "conn.nfs.noLabel": "(no label)",
  "conn.nfs.neverUsed": "never",
  "conn.nfs.enable": "Enable",
  "conn.nfs.disable": "Disable",
  "conn.nfs.revoke": "Revoke",
  "conn.nfs.confirm": "Sure?",
  "conn.nfs.empty": "No exports yet.",
  "conn.guide.nfs.summary": "NFS mounts filex as a drive on a machine in your own network - the NAS protocol, for the devices that expect one.",
  "conn.guide.nfs.pathPlaceholder": "create an export above",
  "conn.guide.nfs.fact.host": "Host",
  "conn.guide.nfs.fact.hostHint": "The same machine as the web app, on a port of its own.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Both port= and mountport= must be set to this; filex serves the mount and NFS services on one port.",
  "conn.guide.nfs.fact.export": "Export path",
  "conn.guide.nfs.fact.exportHint": "This is the credential. It is shown once, when you create the export, and is stored hashed - filex cannot show it again.",
  "conn.guide.nfs.fact.options": "Mount options",
  "conn.guide.nfs.fact.optionsHint": "nolock because filex does not run the NFS lock manager; nfsvers=3 because that is what this server speaks.",
  "conn.guide.nfs.linux.mountCaption": "Mount it",
  "conn.guide.nfs.linux.fstabSecret": "An /etc/fstab line containing this path is a password in a world-readable file. Use a credentials-protected automount, or keep the mount in a root-only unit, if that matters where you are.",
  "conn.guide.nfs.mac.mountCaption": "Mount it",
  "conn.guide.nfs.mac.resvport": "macOS needs resvport: its client insists on a privileged source port and refuses the mount without it.",
  "conn.guide.nfs.win.s1": 'Turn on "Services for NFS" → "Client for NFS" in Windows Features (Pro and Enterprise only; Home does not have it).',
  "conn.guide.nfs.win.s2": "Open a Command Prompt as administrator.",
  "conn.guide.nfs.win.s3": "Map the export to a drive letter with the command below.",
  "conn.guide.nfs.win.cmdCaption": "Map it to Z:",
  "conn.guide.nfs.win.port": "Windows has no way to say which port the mount service is on, so it can only reach an NFS server on the standard port 2049. If this server is on another port, use SFTP or the filex desktop app instead.",
  "conn.guide.nfs.nas.tab": "NAS / media player",
  "conn.guide.nfs.nas.s1": "In the device's NFS settings: server {host}, port {port} (set both the NFS and the mount port if it asks for them separately).",
  "conn.guide.nfs.nas.s2": "Remote path: the export path above, exactly as shown.",
  "conn.guide.nfs.nas.s3": "NFS version 3, no locking. Create the export read-only unless the device genuinely needs to write.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 is not encrypted. Anyone who can read the traffic sees your files, and anyone who learns the path can mount them. Use it on a home or office network, or over a VPN - never across the internet.",
  "conn.guide.nfs.note.pathIsSecret": "The export path is the whole credential. Revoke it from the list above if it leaks; there is nothing else to change.",
  "conn.guide.nfs.note.noPortmapper": "There is no portmapper on port 111, so a client that is not told the port cannot find the server. That is why every command here carries port= and mountport=.",
  "conn.guide.nfs.note.uid": "The user and group ids your client sends are ignored: the mount already knows whose it is. The permissions you see come from your access in filex.",
  "conn.guide.nfs.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.nfs.note.revoke": "Revoking takes effect on the next request, not instantly: NFS has no session to end, so a client with the mount open sees its next operation fail.",
  "conn.guide.nfs.note.disabled": "The NFS endpoint is switched off on this server. These instructions will work once an operator enables it.",
  "conn.tokens.title": "API keys",
  "conn.tokens.lead": "FTPS, WebDAV and filex mount all sign in with an API key instead of your account password. Create one here - it can be revoked on its own, and an account with two-factor sign-in cannot use its password on these at all.",
  "conn.tokens.mint": "Create API key",
  "conn.tokens.once": "Copy it now - this is the only time it is shown. Only a hash is stored, so it cannot be shown again.",
  "conn.tokens.dismiss": "I have copied it",
  "conn.tokens.cannotMint": "This session cannot create API keys. Sign in with your own account to create one.",
  "conn.tokens.empty": "No API keys yet.",
  "conn.tokens.neverUsed": "never",
  "conn.tokens.revoke": "Revoke",
  "conn.tokens.confirm": "Sure?",
  "conn.tokens.col.label": "Name",
  "conn.tokens.col.scopes": "Permissions",
  "conn.tokens.col.comments": "Comments",
  "conn.tokens.col.used": "Last used",
  "conn.tokens.revokeHint": "Revoking stops a connection that is already open, not just the next sign-in: an SFTP or FTPS session is cut and a mount stops working within about half a minute.",
  "conn.guide.mount.summary": "filex mount attaches a remote filex server to a folder on this machine, over the same HTTPS the browser uses. It is the only one of these that works from anywhere - no LAN, no extra server, no third-party client.",
  "conn.guide.mount.fact.url": "Server URL",
  "conn.guide.mount.fact.urlHint": "The same address you use in the browser. Nothing else has to be reachable.",
  "conn.guide.mount.fact.token": "API key",
  "conn.guide.mount.fact.tokenPlaceholder": "create one under API keys",
  "conn.guide.mount.fact.tokenHint": "An API key, not your password - it can be revoked on its own, and an account with 2FA cannot use its password here at all.",
  "conn.guide.mount.fact.remote": "What to mount",
  "conn.guide.mount.fact.remoteHint": "Leave --remote off to see every storage as a folder, or name one storage - or a folder inside it - to mount just that.",
  "conn.guide.mount.linux.mountCaption": "Mount it",
  "conn.guide.mount.linux.umountCaption": "Unmount it",
  "conn.guide.mount.linux.umountWarn": "Unmount with fusermount, not by killing the process. A mount whose process died without detaching leaves a folder where every ls hangs until somebody runs fusermount by hand.",
  "conn.guide.mount.linux.systemdCaption": "Mount it at sign-in (systemd user unit)",
  "conn.guide.mount.win.winfsp": "Windows needs WinFsp installed once - it is free and open source: https://winfsp.dev. Nothing else, and no administrator rights after that.",
  "conn.guide.mount.win.mountCaption": "Mount it as a drive",
  "conn.guide.mount.win.freeLetter": "Pick a drive letter that is FREE. The letter is created by the mount, not attached to something that already exists, and pointing it at one that is in use fails with a message that does not say so.",
  "conn.guide.mount.win.stop": "Stop it with Ctrl-C in that window. The drive disappears and nothing is left behind on this machine.",
  "conn.guide.mount.mac.unsupported": "filex mount does not work on macOS. It needs macFUSE, whose license does not allow a program like filex to install it for you, and whose Go binding needs a C compiler filex deliberately does not require. The command refuses here rather than appearing to work and doing nothing.",
  "conn.guide.mount.mac.alternatives": "On macOS, use the filex desktop app with folder sync (keeps the files on disk), or SFTP with a client that mounts drives.",
  "conn.guide.mount.note.notASync": "This is not a sync. Nothing is copied to this machine except a small read cache, so a mount opens one file out of a hundred thousand without downloading the rest. If you want the files when you are offline, use folder sync instead.",
  "conn.guide.mount.note.reachable": "It reaches the server through whatever proxy or tunnel the browser goes through, because underneath it is the same API. Your permissions and your storages come with it.",
  "conn.guide.mount.note.wholeFileWrites": "A file you write through the mount is uploaded when the program closes it, not while it is being written. Editing a very large file in place is slower here than a local disk; copying it in and out is not.",
  "conn.guide.mount.note.trash": "A delete goes to the filex trash, the same as everywhere else, and is recoverable until the retention policy sweeps it.",
  "conn.guide.mount.note.revoke": "Revoke the API key to stop a mount. It stops serving within half a minute, even if the mount is still attached.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Local filesystem",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "The share name alone, without the server: `media`, not `\\\\nas\\media`.",
  "storages.fieldHelp.smbDomain": "Only for a Windows domain account. Leave empty for a NAS.",
  "storages.fieldHelp.smbRoot": "Sub-folder inside the share. Leave empty for the whole share.",
  "storages.fields.share": "Share",
  "storages.fields.domain": "Domain / workgroup",
  "storages.fieldHelp.disablePresign": "On by default: uploads and the downloads behind public share links stream through filex, so the bucket endpoint never has to be reachable from a browser (a LAN-only MinIO just works). Turn it off only when the endpoint is reachable from your users' browsers (AWS, a public MinIO) and you want them to talk to the bucket directly - faster for very large files, and the store must accept SDK-signed URLs (Ceph RGW / some Hetzner setups answer SignatureDoesNotMatch).",
  "storages.fieldHelp.endpoint": "Leave empty for AWS S3. Any S3-compatible store needs its endpoint.",
  "storages.fieldHelp.hostKey": "A single public key in authorized_keys / known_hosts line form.",
  "storages.fieldHelp.insecureSkipHostKey": "Accepts any host key. Only for throwaway hosts.",
  "storages.fieldHelp.keyPath": "Path to a key file on the server, read when the storage starts. Used when the PEM field is empty.",
  "storages.fieldHelp.knownHosts": "OpenSSH known_hosts path for strict host-key checking. Default is trust-on-first-use in ~/.filex/known_hosts.",
  "storages.fieldHelp.passive": "Off switches to active mode, which needs the server to dial back into this host.",
  "storages.fieldHelp.path": "Directory on the server. It is created if missing; filex never mounts /.",
  "storages.fieldHelp.pathStyle": "On for every non-AWS store. It is turned on automatically when an endpoint is set and this was never touched.",
  "storages.fieldHelp.prefix": "Sub-folder inside the bucket. Required: filex never takes ownership of the bucket root.",
  "storages.fieldHelp.region": 'Defaults to "auto" when left empty.',
  "storages.fieldHelp.root": "Sub-folder on the backend. Required: filex never mounts the account root.",
  "storages.fieldHelp.sftpAuth": "Either a password or a private key is required.",
  "storages.fieldHelp.tls": "Plain FTP sends credentials in the clear - turn this on whenever the server supports it.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Base path",
  "storages.fields.bucket": "Bucket",
  "storages.fields.disablePresign": "Stream transfers through filex",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Host",
  "storages.fields.hostKey": "Pinned host key",
  "storages.fields.insecureSkipHostKey": "Skip host-key verification (insecure)",
  "storages.fields.keyPath": "Private key file",
  "storages.fields.knownHosts": "known_hosts file",
  "storages.fields.name": "Display name",
  "storages.fields.namePlaceholder": "Personal photos",
  "storages.fields.passive": "Passive mode (PASV)",
  "storages.fields.password": "Password",
  "storages.fields.path": "Filesystem path",
  "storages.fields.pathStyle": "Use path-style URLs (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Prefix",
  "storages.fields.privateKey": "Private key (PEM)",
  "storages.fields.rbac": "Per-item access control (RBAC)",
  "storages.fields.rbacHint": "When on, non-admins see only the files and folders granted to them (listed under Folder access). When off, everyone opens the storage according to their role.",
  "storages.fields.readOnly": "Read-only mount",
  "storages.fields.region": "Region",
  "storages.fields.root": "Base path",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (explicit AUTH TLS)",
  "storages.fields.url": "Base URL",
  "storages.fields.user": "User",
  "storages.fields.s3AttemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.s3MaxAttempts": "Attempts per request",
  "storages.fields.s3TotalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.s3AttemptTimeout": "How long one attempt may wait for a sign of life from the store: connecting, the TLS handshake, the answer after the request is sent, and each next piece of the answer. A transfer that keeps moving is never cut, however long it takes; an upload the store stops taking is cut after 60 seconds, or after this if it is longer. Copies and renames wait up to 10 minutes for the answer, because the store answers them only when the copy is done.",
  "storages.fieldHelp.s3MaxAttempts": "How many times a request is tried in all when the failure can pass: a network error, a timeout, a 5xx answer, throttling. 1 turns retrying off. A refusal (403, a missing bucket, a host name that does not resolve) is never retried.",
  "storages.fieldHelp.s3TotalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so an upload or a listing on a store that is down reports the outage within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  "storages.fields.attemptTimeout": "Attempt timeout (seconds)",
  "storages.fields.maxAttempts": "Attempts per request",
  "storages.fields.totalTimeout": "Give up after (seconds)",
  "storages.fieldHelp.attemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer.",
  "storages.fieldHelp.webdavAttemptTimeout": "How long one attempt may wait for a sign of life from the server: connecting, logging in, the answer to each request, and each next piece of a transfer. A transfer that keeps moving is never cut, however long it takes; an upload the server stops taking is cut after 60 seconds, or after this if it is longer. Copies, moves and deletes wait up to 10 minutes for the answer, because the server answers them only when the work is done.",
  "storages.fieldHelp.maxAttempts": "How many times a request is tried in all when the failure can pass: the connection is refused or drops, no answer comes in time, the server answers that it is unavailable (5xx). 1 turns retrying off. A refusal (a wrong password, a missing folder, a certificate that does not verify) is never retried, and neither is an upload that has started sending.",
  "storages.fieldHelp.totalTimeout": "No new attempt starts unless it could finish within this many seconds of the first, so a server that is down is reported within this time. A transfer that is under way is not cut. A request that timed out is tried again only when this is at least twice the attempt timeout.",
  /* === gezinti:g1 - navigation panel (SideNav) === */
  "sidenav.title": "Navigation",
  "sidenav.views": "Views",
  "sidenav.storages": "Storages",
  "sidenav.home": "Home",
  "sidenav.myfiles": "My files",
  "sidenav.recent": "Recent",
  "sidenav.starred": "Starred",
  "sidenav.shared": "Shared with me",
  // The mirror of the row above, and it sits right under it: what came in,
  // and what went out. ⚠ "My shares", not "Shared by me" - the page lists
  // LINKS the person minted, not files they granted somebody access to.
  "sidenav.myshares": "My shares",
  "sidenav.trash": "Trash",
  "sidenav.collapse": "Collapse navigation",
  "sidenav.expand": "Expand navigation",
  "sidenav.close": "Close navigation",
  // ⚠ `open`/`close` are the DRAWER's pair, `expand`/`collapse` the docked
  // panel's, and they are not interchangeable - see the note on
  // `navToggleLabel` in Toolbar.vue. Below 560px the panel is a drawer over
  // the listing: it is not narrowed to a rail, it is not on screen at all, so
  // "expand" would promise a width change to something that has no width.
  "sidenav.open": "Open navigation",
  "sidenav.storage.shared": "Shared",
  "sidenav.storage.readOnly": "Read-only",
  // #57 - a storage row's order menu (right click, a long press, Shift+F10).
  // "Sort by name" writes an order the person can keep adjusting; it is not a
  // mode. "Use default order" lets the person's own order go: the panel then
  // follows the administrator's order (or, with none, the server's). The two
  // `.done`/`.none` lines are the reason a greyed row gives.
  "sidenav.storage.moveUp": "Move up",
  "sidenav.storage.moveDown": "Move down",
  "sidenav.storage.sortName": "Sort by name",
  "sidenav.storage.sortName.done": "Already sorted by name",
  "sidenav.storage.defaultOrder": "Use default order",
  "sidenav.storage.defaultOrder.none": "Already in the default order",
  // ⚠ `toolbar.nav` is GONE, and nothing replaced it. It was the one label on
  // the panel's collapse control, first as the noun "Navigation" - which names
  // the panel and never says the button does anything to it, so the owner
  // could not find how to collapse the panel (2026-09-13: "yan menüyü kısıp
  // açabilir olalım ya bence") - and then as the static stopgap "Show or hide
  // navigation". The four `sidenav.*` verbs above are the real fix: the label
  // is bound to `navOpen`, so it says *collapse* when it will collapse and
  // *expand* when it will expand.
  "node.home": "Home",
  "node.recent": "Recent",
  "node.starred": "Starred",
  "node.shared": "Shared with me",
  "empty.recent.title": "Nothing opened yet",
  "empty.recent.hint": "Files you open show up here",
  "empty.starred.title": "Nothing starred yet",
  "empty.starred.hint": "Star a file to find it here",
  "empty.shared.title": "Nothing has been shared with you",
  "empty.shared.hint": "Folders and files other people share appear here",
  /* etiket:t1 */
  "sidenav.tags": "Tags",
  "sidenav.tags.empty": "No tags yet - add one from a file’s right-click menu.",
  "sidenav.tags.more": "Show {count} more",
  "sidenav.tags.less": "Show fewer",
  "sidenav.tags.personal": "Personal",
  "sidenav.tags.team": "Team",
  "empty.tag.title": "Nothing is tagged “{tag}”",
  "empty.tag.hint": "Right-click a file and choose Tags to put it here",
  "sidenav.connections": "Connections",
  "sidenav.apps": "Apps",
  // #162 - the store screen: the catalog of the stores an administrator turned
  // on, where a person asks for an app.
  "sidenav.appstore": "App store",
  "sidenav.connect": "Connections",
  "sidenav.apikeys": "API keys",
  "overlay.close": "Close",
  "conn.tokens.scopes": "Permissions",
  "conn.tokens.root": "Limit to one folder (optional)",
  "conn.tokens.rootPlaceholder": "storage://folder",
  "conn.tokens.expiry": "Expires in (days)",
  "conn.tokens.expiryNever": "never",
  "conn.tokens.defaultName": "API key {date}",
  "conn.tokens.namePlaceholder": "Name - e.g. backup script",
  "conn.tokens.capNote": "Your own access is the ceiling - a permission you do not have is refused, not granted.",
  "conn.tokens.scopesRequired": "Choose at least one permission - an API key is never issued with none.",
  "conn.tokens.comments": "Comments",
  "conn.tokens.commentsRead": "Read",
  "conn.tokens.commentsRw": "Read and write",
  "conn.tokens.commentsHint": "Adding and deleting comments is a permission of its own - “write” does not include it. Every API key reads them.",
  "conn.tokens.commentsToRw": "Comments: allow writing",
  "conn.tokens.commentsToRead": "Comments: read only",
  /* === /gezinti:g1 === */
  /* === surucu:d1 - the shell (GitHub #14); every profile, no longer a
     `uiProfile: 'drive'` opt-in === */
  "drive.new": "New",
  "drive.new.upload": "Upload files",
  "drive.new.folder": "New folder",
  "drive.new.request": "Request files",
  "drive.new.document": "New document",
  /* === belge:n1 - "New document": the picker under + New =================
     Type names are NOT listed here. A tile reads its words from
     lib/fileIcons `typeLabelFor`, the same table the listing's Type column
     uses, so ".docx" is called the same thing in both places and a new type
     needs no string at all. Only this dialog's own chrome lives below. */
  "newdoc.title": "New document",
  "newdoc.type.label": "Document type",
  "newdoc.group.document": "Documents",
  "newdoc.group.text": "Text and code",
  "newdoc.group.diagram": "Diagrams",
  "newdoc.group.app": "Apps",
  /* ⚠ One name per service, the name its own project uses: draw.io (not
     "drawio", not "diagrams.net") and ONLYOFFICE - the QA sweep of
     2026-09-21 found draw.io called three things on three screens. */
  "newdoc.empty.title": "No document types are available",
  "newdoc.empty.body": "This server did not offer any type this app can create.",
  "newdoc.empty.blocked": "Every type this server can create needs an editor service that is not configured here.",
  "newdoc.name": "Name",
  "newdoc.name.placeholder": "File name, e.g. notes.txt or LICENSE",
  "newdoc.untitled": "Untitled",
  "newdoc.err.slash": "A name cannot contain a slash.",
  "newdoc.err.exists": "{name} is already here. Choose another name.",
  "newdoc.err.bare_ext": "Give the file a name, not only an extension.",
  "newdoc.err.ext_needs_type": "A .{ext} file has to be created as its own type - an empty one would not open. Choose that type, or another extension.",
  "newdoc.hint.ext_added": "This type keeps its extension, so the file will be created as {name}.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Drafts",
  "sidenav.drafts.count": "{n} drafts",
  "sidenav.drafts.count_one": "{n} draft",
  "node.drafts": "Drafts",
  "empty.drafts.title": "No drafts",
  "empty.drafts.hint": "A new document waits here until you save it where it belongs.",
  "drafts.lead": "New documents that have not been saved yet. Only you can see them.",
  "drafts.count_of": "{n} of {limit} drafts",
  "drafts.col.target": "Save to",
  "drafts.col.storage": "Storage",
  "drafts.action.save": "Save to disk",
  "drafts.open_hint": "Open {name}",
  "drafts.no_match": "No draft matches the filter.",
  "draft.badge": "Draft",
  "draft.bar.target": "will be saved to {folder}",
  "draft.save": "Save",
  "draft.saved_to": "{name} was saved to {folder}.",
  "draft.discarded": "{name} was moved to the trash.",
  "draft.kept": "Kept in Drafts",
  "draft.editing": "Editing…",
  "draft.close.title": "Close this draft?",
  "draft.close.body": "{name} is a draft for {folder} and has not been saved there yet.",
  "draft.close.hint": "A kept draft waits in Drafts. Discard moves it to the trash.",
  "draft.close.save": "Save to disk",
  "draft.close.keep": "Keep in Drafts",
  "draft.close.discard": "Discard",
  "outside.title": "This file changed outside filex",
  "outside.body": "{name} was changed somewhere else while it was open here, and this editor has changes of its own. Which version should stay?",
  "outside.theirs": "Keep the outside version",
  "outside.theirs_hint": "the changes made here are dropped and the outside version is loaded.",
  "outside.mine": "Write mine",
  "outside.mine_hint": "your version replaces the outside one when it is saved.",
  "outside.both": "Keep both",
  "outside.both_hint": "the outside version stays where it is, and yours is saved beside it as a separate copy (name.filex-conflict-time).",
  "outside.hint": "Until you choose, nothing is written over either version.",
  "outside.pending": "This file changed outside filex. Nothing is written over either version until you choose which one stays.",
  "outside.choose": "Choose…",
  "outside.note.reloaded": "The file was updated outside filex; the new version is loaded.",
  "outside.note.theirs": "The outside version is loaded; the changes made here were dropped.",
  "outside.note.mine": "Your version will replace the outside one when it is saved.",
  "outside.note.both": "The outside version stays; yours will be saved beside it as a separate copy.",
  "draft.taken.title": "A file with this name is already there",
  "draft.taken.body": "{folder} already has a file called {name}. Save the draft as {suggested} instead?",
  "draft.taken.confirm": "Save as {name}",
  "upload.taken.body": "{folder} already has something called {name}, and a vault keeps no earlier version. Upload it as {suggested} instead?",
  "upload.taken.confirm": "Upload as {name}",
  "newdoc.hint.draft": "It opens as a draft: nothing is created in the folder until you save it.",
  "newdoc.err.draft_limit": "You already keep as many drafts as this server allows ({limit}). Save or delete some in Drafts first.",
  "newdoc.err.draft_limit_any": "You already keep as many drafts as this server allows. Save or delete some in Drafts first.",
  "newdoc.open_drafts": "Open Drafts",
  "newdoc.location": "Location",
  "newdoc.location.none": "Choose a folder",
  "newdoc.location.change": "Change",
  "newdoc.location.noaccess": "You cannot save into this folder.",
  "newdoc.create": "Create",
  "newdoc.creating": "Creating…",
  "newdoc.cancel": "Cancel",
  // ⚠ The top search field searches the WHOLE storage (and every storage at
  // the root) - never only the open folder. The scope named here is therefore
  // the storage, not the folder; "Filter in this folder…" (FilterBar) is the
  // folder-scoped one. It used to say "Search in Photos" for a folder called
  // Photos, which was a lie (2026-09-19).
  "drive.search.placeholder": "Search in {scope}",
  "drive.search.placeholder_all": "Search all storages",
  "drive.search.hint_title": "Search everywhere and run commands ({combo})",
  "drive.storage.used": "{used} of {total} used",
  "drive.storage.used_unlimited": "{used} used",
  "drive.storage.used_partial": "at least {used} used",
  "drive.storage.label": "Storage",
  /* === gorunum:v3-shell - the Home view (the overview, inside the shell) ==
   * The section headings are `sidenav.storages` / `sidenav.recent` /
   * `sidenav.starred` and the two empty states are `empty.recent.*` /
   * `empty.starred.*`, on purpose: the block headed "Recent" on Home and the
   * panel row labelled "Recent" beside it are the same thing, and a second
   * string for it is how the two drift apart one translation at a time. Only
   * what exists nowhere else is below. */
  "home.title": "Home",
  "home.storages.empty": "No storages yet",
  "home.storages.hint": "A storage is a place filex reads and writes - an administrator adds them.",
  "drive.section.folders": "Folders",
  "drive.section.files": "Files",
  "filter.aria": "Filters",
  "filter.type": "Type",
  "filter.type.any": "Any type",
  "filter.type.folder": "Folders",
  "filter.type.document": "Documents",
  "filter.type.spreadsheet": "Spreadsheets",
  "filter.type.presentation": "Presentations",
  "filter.type.pdf": "PDFs",
  "filter.type.image": "Images",
  "filter.type.video": "Videos",
  "filter.type.audio": "Audio",
  "filter.type.archive": "Archives",
  "filter.type.code": "Code",
  "filter.modified": "Modified",
  "filter.modified.any": "Any time",
  "filter.modified.today": "Today",
  "filter.modified.7d": "Last 7 days",
  "filter.modified.30d": "Last 30 days",
  "filter.modified.year": "This year",
  "filter.size": "Size",
  "filter.size.any": "Any size",
  "filter.size.lt1": "Under 1 MB",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "Over 100 MB",
  /* surucu:d1-actions - the ⋮ menu at the end of the filter row. Only its own
     NAME is new: every row inside it reuses the string that verb already has
     (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`, `shortcuts.select_all`,
     `selection.clear`), because a menu that renames a command is a menu the
     reader has to learn twice. */
  "filter.actions": "Listing actions",
  "filter.clear": "Clear filters",
  "filter.empty.title": "Nothing here matches those filters",
  "filter.empty.hint": "Clear a filter, or search everywhere with the field above.",
  "filter.count": "{shown} of {total}",
  "inspector.tab.details": "Details",
  "inspector.tab.activity": "Activity",
  "inspector.people": "People with access",
  "inspector.people.you": "You",
  "inspector.people.inherited": "from a parent folder",
  "inspector.people.empty": "Only you, and anyone with a link below.",
  "inspector.people.manage": "Manage access",
  "inspector.link": "Shared link",
  "inspector.link.none": "Not shared",
  "inspector.link.create": "Create link",
  "inspector.link.copy": "Copy link",
  "inspector.activity.empty": "No activity recorded for this item yet.",
  "inspector.activity.hint": "Versions are written when a file changes; comments are written by people.",
  "inspector.activity.version": "Version {n} saved",
  "inspector.activity.comment": "Comment by {who}",
  "inspector.activity.select": "Select a file or folder to see its activity.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome - the filter row's name box === */
  "filter.find": "Filter in this folder…",
  /* surucu:d1-scope - the same box where the rows are not a folder's contents.
     It has to say what it narrows: at the drive list "this folder" names
     nothing, and on Home it would name three blocks at once. */
  "filter.find.storages": "Filter storages…",
  "filter.find.home": "Filter Home…",
  /* === gorunum:v1-viewer - the full-bleed overlay's own chrome === */
  "viewer.share": "Share",
  "viewer.nav_prev": "Previous file",
  "viewer.nav_next": "Next file",
  /* The counter in the top bar's meta line: "246.3 KB • Sep 9, 2026 • 1 of 9". */
  "viewer.counter": "{i} of {n}",
  "viewer.zoom_reset": "Reset zoom",
  "viewer.fullscreen": "Full screen",
  "viewer.exit_fullscreen": "Exit full screen",
  "viewer.md_placeholder": "# Markdown here…",
  /* === gorunum:v1-selbar - the selection bar that replaces the filter row === */
  "selection.count": "{n} selected",
  "selection.clear": "Clear selection",
  /* === gorunum:v1-preview - the kind, said in words ======================
     The Type column used to print the extension in caps. These are what it
     prints instead; the table that picks one is in `lib/fileIcons.ts`
     (`typeLabelKey`), so this list and that one are the only two places a
     kind is named. Anything unmapped still falls back to the uppercased
     extension - these names improve on that fallback, they do not replace
     it. `Folder` is NOT here: it is `node.folder`, which the grid card's
     caption already prints. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue component",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C source",
  "ftype.cpp": "C++ source",
  "ftype.csharp": "C# source",
  "ftype.stylesheet": "Stylesheet",
  "ftype.html": "HTML document",
  "ftype.json": "JSON data",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Shell script",
  "ftype.powershell": "PowerShell script",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Plain text",
  "ftype.log": "Log file",
  "ftype.config": "Configuration",
  "ftype.sheet": "Spreadsheet",
  "ftype.figma": "Figma design",
  "ftype.drawio": "draw.io diagram",
  "ftype.design": "Design file",
  "ftype.image": "Image",
  "ftype.video": "Video",
  "ftype.audio": "Audio",
  "ftype.pdf": "PDF document",
  "ftype.document": "Document",
  "ftype.slides": "Presentation",
  "ftype.archive": "Archive",
  "ftype.code": "Code",
  /* === gorunum:v1-advsearch - the Advanced search dialog ==================
   * Two `filter.*` keys are added here rather than beside their siblings
   * because they are new members of shared unions the dialog introduced
   * (`modified: 'around'`, `size: 'range'`); the filter row never selects
   * them, but `chipLabel` would print the raw key if one ever reached it. */
  "filter.modified.around": "Around a date",
  "filter.size.range": "Custom range",
  "advsearch.open": "Advanced search",
  "advsearch.title": "Advanced search",
  "advsearch.subtitle": "Find files by name, content, path, or tags.",
  "advsearch.close": "Close",
  "advsearch.content.heading": "Content search",
  "advsearch.viewall": "View all results",
  "advsearch.where.any_short": "Anywhere",
  "advsearch.where.here_short": "Only here",
  "advsearch.where.skip_short": "Skip this",
  "advsearch.server.legend": "What the server searches",
  "advsearch.client.legend": "Narrow the results that come back",
  "advsearch.query.label": "Words",
  "advsearch.query.placeholder": "Part of a name, or words inside a file",
  "advsearch.scope.label": "Look in",
  "advsearch.scope.name": "Names and paths",
  "advsearch.scope.content": "File contents",
  "advsearch.scope.all": "Both",
  "advsearch.scope.hint": "Contents are searched from the index, which covers text-like files up to 200 KB.",
  "advsearch.people.name_only": "Owner is read off the rows that come back, and only a name search returns rows that carry one.",
  "advsearch.scope.name_only": "Only names and paths here: a content hit reaches the explorer without the storage it came from, so content search is offered on single-storage deployments only.",
  "advsearch.tags.label": "Tags",
  "advsearch.tags.placeholder": "invoice, quarterly report",
  "advsearch.tags.exclude": "Without tags",
  "advsearch.tags.exclude_placeholder": "archive",
  "advsearch.tags.hint": "Separate with commas. Tags narrow: several tags means files carrying all of them, and a tag nobody has applied returns nothing. A name matches your personal tag and your team’s tag of that name alike.",
  "advsearch.where.label": "Folder",
  "advsearch.where.any": "Anywhere in this storage",
  "advsearch.where.here": "Only in {folder}",
  "advsearch.where.skip": "Everywhere except {folder}",
  "advsearch.around.label": "Within",
  "advsearch.around.date": "Date and time",
  "advsearch.around.h1": "1 hour",
  "advsearch.around.d1": "1 day",
  "advsearch.around.w1": "1 week",
  "advsearch.size.range_label": "Between",
  "advsearch.size.from": "From",
  "advsearch.size.to": "To",
  "advsearch.count.idle": "Type something, or pick a tag.",
  "advsearch.count.counting": "Counting…",
  "advsearch.count.result": "{n} matching items",
  "advsearch.count.capped": "{n} matching items in the first page of hits",
  "advsearch.count.result_one": "{n} matching item",
  "advsearch.count.capped_one": "{n} matching item in the first page of hits",
  "advsearch.count.error": "The count could not be run.",
  "advsearch.count.cost": "The count runs this search. Type, owner, date, size and folder narrow the results it finds.",
  "advsearch.wire": "Type this in the search box next time:",
  "advsearch.reset": "Reset",
  "advsearch.cancel": "Cancel",
  "advsearch.submit": "Search",
  /* === gorunum:v2-topbar - the page bar is gone; the explorer's own header
     and breadcrumb row carry what it used to. === */
  "breadcrumb.subfolders": "Subfolders",
  "breadcrumb.subfolders.empty": "No subfolders here",
  "header.admin": "Admin panel",
  "header.settings": "Settings",
  "header.signout": "Sign out",
  "ai.assistant": "AI assistant",
  "assistant.new": "New conversation",
  "assistant.history": "Conversations",
  "assistant.history_empty": "No conversations yet.",
  "assistant.close": "Close the assistant",
  "assistant.delete": "Delete this conversation",
  "assistant.intro": "Ask the assistant to find, read, summarise, tidy up or move your files. It works with your permissions only. Changes that can be undone happen at once, with an Undo; anything that cannot be undone waits for your approval. Encrypted folders and the vault are never sent to it.",
  "assistant.placeholder": "Ask about your files...",
  "assistant.send": "Send",
  "assistant.stop": "Stop",
  "assistant.working": "Working...",
  "assistant.with_selection": "With the {count} selected items",
  "assistant.with_selection_one": "With the {count} selected item",
  "assistant.approve": "Approve",
  "assistant.decline": "Decline",
  "assistant.undo": "Undo",
  /* gorunum:v2-share - the Share / Permissions dialog's own chrome. The
     controls inside it keep the strings they already had; these are the new
     shell: the title, the one switch, the sentence that says who can open the
     item right now, and the three named sections it all folds into. */
  "access.title": 'Share "{name}"',
  "access.title_storage": 'Access to "{name}"',
  "access.close": "Close",
  "access.done": "Done",
  "access.copy": "Copy",
  "access.copied": "Copied",
  "access.link.switch": "Link sharing",
  "access.who.private": "Only people with access can open it.",
  "access.who.link": "Anyone with the link can open it.",
  "access.who.pin": "Anyone with the link and the PIN can open it.",
  "access.who.existing": "Link sharing is on - {n} links already exist.",
  "access.who.existing_one": "Link sharing is on - {n} link already exists.",
  "access.section.link": "Link options",
  "access.section.people": "People with access",
  "access.section.drop": "Request files",
  "access.sum.pin_on": "PIN on",
  "access.sum.pin_off": "No PIN",
  "access.sum.people": "{n} people",
  "access.sum.people_one": "{n} person",
  "access.sum.people_none": "No one yet",
  "access.sum.groups": "{n} groups",
  "access.sum.groups_one": "{n} group",
  "access.sum.drop": "{n} upload links",
  "access.sum.drop_one": "{n} upload link",
  "access.sum.drop_none": "No upload link",
  /* Ownership - the Owner column and the People chip. "System" is the honest
     word for a row nobody put here through filex (the scanner found it, or it
     was written straight into the bucket); it is a real answer, not a blank. */
  "col.owner": "Owner",
  "owner.you": "You",
  "owner.system": "System",
  "owner.unknown": "Unknown",
  "owner.external": "Uploaded through an upload link",
  "owner.last_actor": "Last changed by {who}",
  "filter.people": "Owner",
  "filter.people.any": "Anyone",
  "filter.people.me": "You",
  "filter.people.system": "System",
  "filter.people.someone": "Someone else",
  /* surucu:d1-sort - the listing sort control at the trailing edge of the
     filter row. The four key names are `col.*`: the menu offers exactly the
     words the list view's own column headers carry, so the two controls that
     drive one sort cannot name it differently. */
  "sort.by": "Sort by",
  "sort.asc": "Ascending",
  "sort.desc": "Descending",
  /* The order a SEARCH RESULT is in. It is not a fifth sort key - it is what
     the control prints instead of a key while the rows on screen were ranked
     by the server, so the button stops claiming a sort it is not performing.
     `_why` is the reason the control is closed, and the owner asked for the
     reason to be written rather than for the control to go quietly inert. */
  "sort.relevance": "Relevance",
  "sort.relevance_why": "Search results are listed by how well they match. Your sort comes back when you leave the search.",
  /* === tablo:t1 - the table's own configuration ==========================
     Since v0.43 everything about how a folder looks - view, sort AND columns -
     belongs to the folder it was changed in; a folder nobody changed opens
     with the person's default (their settings), else the instance's.
     `folder_hint` is that rule in one sentence, written where the person who
     is about to be surprised by it can read it. */
  "col.location": "Location",
  "col.deleted": "Deleted",
  "col.deleted_from": "Deleted from",
  "col.deleted_by": "Deleted by",
  "col.remaining": "Time left",
  "cols.menu": "Column options",
  "cols.title": "Columns",
  "cols.resize": "Resize {col}",
  "cols.sort_by": "Sort by {col}",
  "cols.move_left": "Move {col} left",
  "cols.move_right": "Move {col} right",
  "cols.reset": "Reset columns",
  "cols.folder_title": "Folder view",
  "cols.folder_hint": "A change you make here stays in this folder. Folders you have never changed open with your default view (Settings → Default folder view).",
  "cols.forget_folder": "Forget this folder's view",
  "cols.apply_all": "Make this my default for all folders ({count} remembered)",
  /* === tablo:t3 - THE ONE TABLE (components/DataTable.vue) ================
     Every table in the product speaks these, so a column menu or a pager is
     never the one English thing on a Turkish page. */
  "table.empty": "Nothing here yet",
  "table.prev": "Previous page",
  "table.next": "Next page",
  "table.sort_paged": "This list is split into pages. Sorting would only re-order the page on screen, so it is off here - narrow the list with the search or filters instead.",
  /* === tablo:t1 - the trash banner ======================================
     ⚠ `retention` is only used when the deployment has TOLD us the number
     (GET /api/admin/protection). Everywhere else `retention_unknown` says the
     same thing without naming a period we cannot verify: a banner that states
     the wrong retention is worse than no banner, because people act on it. */
  "trash.retention": "Items in the trash are permanently deleted after {days} days.",
  "trash.retention_one": "Items in the trash are permanently deleted after {days} day.",
  "trash.retention_unknown": "Items in the trash are permanently deleted after a retention period set by your administrator.",
  "trash.empty_action": "Empty trash",
  "trash.empty_confirm_title": "Empty the trash?",
  /* 0.54 (finding D1): the confirmation waits for the server's count of
     what "Empty trash" deletes, and the Trash view is paged. Every
     sentence about the trash itself is the server's (server.trash.*). */
  "trash.empty_counting": "Counting what is in the trash…",
  "trash.show_more": "Show more",
  "trash.shown_of": "{shown} of {total} shown",
  "trash.days_remaining": "{n} days",
  "trash.days_remaining_one": "{n} day",
  "trash.days_remaining_due": "Due for deletion",
  "trash.deleted_by_nobody": "Not recorded: quarantined by the virus scan, or deleted before filex kept this",
  "empty.trash.hint": "Files you delete land here first, so you can put them back.",
  /* tasi:m1 - the destination picker (modals/DestinationPickerModal.vue) and
     the two selection verbs built on it. */
  "destpicker.title.move": "Move to",
  "destpicker.title.copy": "Copy to",
  "destpicker.title.choose": "Choose a folder",
  "destpicker.confirm.move": "Move here",
  "destpicker.confirm.copy": "Copy here",
  "destpicker.confirm.choose": "Choose this folder",
  "destpicker.title.choose_file": "Choose a file",
  "destpicker.confirm.choose_file": "Choose this file",
  "destpicker.title.save": "Save to",
  "destpicker.confirm.save": "Save here",
  "destpicker.pick_a_file": "Select a file from the list.",
  "destpicker.empty_files": "This folder is empty",
  "destpicker.cancel": "Cancel",
  "destpicker.up": "Up one level",
  "destpicker.crumbs": "Location",
  "destpicker.drives": "Storages",
  "destpicker.loading": "Loading…",
  "destpicker.empty": "No subfolders here",
  "destpicker.unreadable": "This folder cannot be opened.",
  "destpicker.readonly": "Read-only",
  "destpicker.readonly_here": "You cannot write into this folder.",
  "destpicker.pick_a_drive": "Open a storage to choose a folder inside it.",
  "destpicker.target": "Destination: {name}",
  "destpicker.tag.blocked": "Not allowed",
  "destpicker.blocked.self": "A folder cannot be moved into itself.",
  "destpicker.blocked.descendant": "A folder cannot be moved into one of its own subfolders.",
  "destpicker.tag.vault": "Vault",
  "destpicker.blocked.vault_in": "Nothing goes into a vault from here: upload into it from inside the vault.",
  "destpicker.blocked.vault_out": "What is in a vault moves only inside that vault. Download it to take it out.",
  "ctx.move_to": "Move to…",
  "ctx.copy_to": "Copy to…",
  "ctx.access.one_only": "Sharing works on one item at a time.",
  "ctx.storage_access": "Access…",
  "toast.archive.preparing": "Preparing the archive…",
  "toast.archive.started": "Downloading {name} ({count} files)",
  "toast.archive.started_one": "Downloading {name} ({count} file)",
  "toast.archive.empty": "Nothing to download - the selection contains no readable file.",
  "toast.moved_to": "Move to {name} queued",
  "toast.copied_to": "Copy to {name} queued",
  "toast.already_there": "The selected items are already in {name} - nothing was sent",
  /* ── dil:paket - strings that used to be inline `en ? … : …` pairs in
     FileExplorer / RecentlyOpened, where no language pack could reach them
     (and where a pack's language fell through to TURKISH). */
  "ctx.tags_menu": "Tags…",
  "toast.node_id_copied": "Node id {id} copied",
  "toast.read_only_here": "Read-only here",
  "recents.title": "Recently opened",
  "recents.refresh": "Refresh",
  "recents.empty": "Nothing here yet.",
  "recents.loading": "Loading…",
  "recents.close": "Close",
  "tags.title": "Tags",
  "tags.close": "Close",
  "share.ttl.never": "This link does not expire.",
  "share.ttl.until": "This link is valid until {when}.",
  "share.ttl.ceiling": "Links can be valid for at most {days} days (server setting).",
  "share.ttl.ceiling_one": "Links can be valid for at most {days} day (server setting).",
  /* ── dil:paket - the share / access dialog (modals/PermissionsModal.vue). These were ~90 inline (tr, en) pairs: no language pack could reach them, and under any third language the dialog spoke TURKISH. access.ui.emails_comma_separated / access.ui.send / access.ui.mail_not_set_up are the mail-row lines another branch rewrote in the same release, converted at the v0.43.0 merge. */
  "access.ui.level_viewer": "Viewer",
  "access.ui.level_viewer_desc": "view + download",
  "access.ui.level_editor": "Editor",
  "access.ui.level_editor_desc": "read + write + delete",
  "access.ui.level_owner": "Owner",
  "access.ui.level_owner_desc": "edit + manage access",
  "access.ui.never": "Never",
  "access.ui.days": "{days} days",
  "access.ui.days_one": "{days} day",
  "access.ui.unlimited": "Unlimited",
  "access.ui.downloads": "{count} downloads",
  "access.ui.downloads_one": "{count} download",
  "access.ui.inherited_from": "Inherited from",
  "access.ui.whole_storage": "Whole storage",
  "access.ui.storage_root_hint": "Everyone added here reaches every file and folder in this storage, in the web interface, the desktop app and over every protocol. Folder grants inside it stay as they are; where two apply, the higher level counts.",
  "access.ui.access_granted": "Access granted.",
  "access.ui.enter_a_valid_email": "Enter a valid email.",
  "access.ui.recipient_lang": "Recipient's language",
  "access.ui.recipient_lang_server": "The server's language",
  "access.ui.user_created_invite_emailed": "User created, invite emailed.",
  "access.ui.user_created_share_the_temp_password": "User created. Share the temp password.",
  "access.ui.server_limit_applied": "(server limit applied)",
  "access.ui.protect_with_a_pin": "Protect with a PIN",
  "access.ui.expiry": "Expiry",
  "access.ui.download_limit": "Download limit",
  "access.ui.create_link": "Create link",
  "access.ui.replace_link": "Replace the link with these settings",
  "access.ui.replace_link_hint": "The address changes: the current link stops working.",
  "access.ui.create_then_send": "Create a link, then it will be sent to {email}.",
  "access.ui.command_line": "Command line",
  "access.ui.share": "Share",
  "access.ui.existing_links": "Existing links",
  "access.ui.rbac_off_here": "Per-item access control is off on this storage - everyone opens it according to their role, so people added here would change nothing. Turn it on in the admin panel under Storages (this storage → Per-item access control).",
  "access.ui.other_links": "Other links",
  "access.ui.revoke": "Revoke",
  "access.ui.loading": "Loading…",
  "access.ui.name_or_email": "Name or email",
  "access.ui.add": "Add",
  "access.ui.no_account_for_this_email_what_next": "No account for this email - what next?",
  "access.ui.user": "User",
  "access.ui.viewer": "Viewer",
  "access.ui.create_user_grant": "Create user + grant",
  "access.ui.just_send_a_share_link": "Just send a share link →",
  "access.ui.temp_password": "Temp password:",
  "access.ui.people_with_access": "Who has access",
  "access.ui.group": "Group",
  "access.ui.group_title": "The group “{name}” - everyone in it",
  "access.ui.group_owner_confirm": "Owner lets everyone in “{name}” manage who has access here - including sharing it with other people and groups. Give the group Owner?",
  "access.ui.group_owner_give": "Give owner access",
  "access.ui.not_shared_with_anyone_yet": "Not shared with anyone yet.",
  "access.ui.remove": "Remove",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "A public link that lets anyone UPLOAD files into this folder. Uploaders never see the folder's existing files.",
  "access.ui.hide_upload_limits": "Hide upload limits",
  "access.ui.upload_limits": "Upload limits",
  "access.ui.max_files": "Max files",
  "access.ui.mb_file": "MB / file",
  "access.ui.allowed_types": "Allowed types",
  "access.ui.all_e_g_pdf_jpg": "all (e.g. pdf, jpg)",
  "access.ui.ask_uploader_name": "Ask uploader name",
  "access.ui.emails_comma_separated": "email(s) - comma separated",
  "access.ui.send": "Send",
  "access.ui.mail_not_set_up": "Email is not set up - set it up in the admin panel under Settings (Email / SMTP).",
  /* ── wiring:e2 fxe - single encrypted files (.fxe), streamed downloads ── */
  "e2e.fxe.type": "Encrypted file",
  "e2e.fxe.ctx_encrypt": "Encrypt with E2EE…",
  "e2e.fxe.ctx_download_raw": "Download encrypted file",
  "e2e.fxe.ctx_password": "Change password…",
  "e2e.fxe.ctx_remove": "Remove encryption…",
  "e2e.fxe.encrypt_title": "Encrypt this file",
  "e2e.fxe.encrypt_lead": "“{name}” is encrypted in this browser with a password of its own. The server keeps only ciphertext. The password or the recovery key opens it - here, or offline with filex decrypt.",
  "e2e.fxe.pw_label": "File password",
  "e2e.fxe.hide_label": "Hide the file name too",
  "e2e.fxe.hide_on_hint": "Stored as “{stored}”: the server sees neither the name nor the type. The real name is sealed inside the file and shown once you open it here.",
  "e2e.fxe.hide_off_hint": "Stored as “{stored}”: the name stays readable to the server; the content does not.",
  "e2e.fxe.seen_title": "What the server has already seen",
  "e2e.fxe.seen_lead": "Until now this file was stored in the clear, and encrypting it cannot take that back:",
  "e2e.fxe.seen_trash": "The original goes to the trash and stays there until the trash retention period ends or an administrator empties it. You cannot delete it for good yourself.",
  "e2e.fxe.seen_versions": "Its earlier versions stay in its version history; only an administrator can delete them.",
  "e2e.fxe.seen_thumb": "A thumbnail made from it stays on the server until the original is deleted for good. Its search-index entry is removed when it goes to the trash.",
  "e2e.fxe.seen_backups": "Backups, copies and downloads made before now still hold it.",
  "e2e.fxe.warn_body": "This file opens only with this password or the recovery key shown once after it is encrypted. filex keeps neither. Lose both and the contents are gone for good.",
  "e2e.fxe.escrow_body": "Key escrow is enabled on this installation: its operator holds a key that opens this file without your password.",
  "e2e.fxe.encrypt_submit": "Encrypt",
  "e2e.fxe.encrypt_busy": "Encrypting and uploading… {percent}%",
  "e2e.fxe.size_unknown": "The size of this file is not known yet. Refresh the folder and try again.",
  "e2e.fxe.bad_name": "This name cannot be sealed into an encrypted file (it is over 255 bytes, or holds a slash or a control character). Rename the file first.",
  "e2e.fxe.name_too_long": "The name is too long to add “.fxe” to it. Tick “Hide the file name too”, or rename the file first.",
  "e2e.fxe.encrypted": "“{name}” is encrypted. The original is in the trash.",
  "e2e.fxe.original_kept": "The encrypted copy is saved, but “{name}” could not be moved to the trash. Delete the original yourself.",
  "e2e.fxe.upload_too_big": "This server has no chunked upload, and the file is too large to send in one piece from this browser.",
  "e2e.fxe.unlock_title_open": "Open an encrypted file",
  "e2e.fxe.unlock_title_download": "Download decrypted",
  "e2e.fxe.unlock_title_remove": "Remove encryption",
  "e2e.fxe.unlock_lead": "“{name}” is encrypted. Its password is checked here, in this browser, and is never sent to the server.",
  "e2e.fxe.known_note": "Already opened in this tab - no password needed.",
  "e2e.fxe.use_password": "Use the password instead",
  "e2e.fxe.remove_warn_title": "The plaintext goes back to the server",
  "e2e.fxe.remove_warn_body": "The file is decrypted here and uploaded as a plain file under its original name: the server, its administrators, thumbnails, search and backups can read it again. The encrypted file goes to the trash.",
  "e2e.fxe.unlock_open": "Open",
  "e2e.fxe.unlock_download": "Download",
  "e2e.fxe.unlock_remove": "Remove encryption",
  "e2e.fxe.unlock_busy": "Working…",
  "e2e.fxe.save_again": "Unlocked. Your browser wants one more click before it asks where to save the file.",
  "e2e.fxe.save_button": "Save…",
  "e2e.fxe.progress": "{percent}% done",
  "e2e.fxe.wrong_password": "Wrong password.",
  "e2e.fxe.wrong_recovery": "That recovery key does not open this file.",
  "e2e.fxe.damaged": "This file is damaged or was tampered with (or it changed since it was opened). Nothing was saved.",
  "e2e.fxe.not_readable": "This is not a filex encrypted file, or its header is damaged.",
  "e2e.fxe.unsupported": "This file needs a newer filex (it requires: {features}).",
  "e2e.fxe.downloaded": "“{name}” saved.",
  "e2e.fxe.removed": "Encryption removed: “{name}” is a plain file again. The encrypted file is in the trash.",
  "e2e.fxe.password_title": "Change the file password",
  "e2e.fxe.password_cost": "Only the file’s header changes: the content is sent back byte for byte, and the recovery key keeps working.",
  "e2e.fxe.password_old_copies": "An earlier version of this file - its version history, a backup, a copy someone downloaded - still opens with the OLD password.",
  "e2e.fxe.password_done": "Password changed. The old password no longer opens this file.",
  "e2e.recovery.warn_body_file": "Anyone holding this key can read the file. Keep it somewhere separate from the password - a key stored next to the password protects you from forgetting, not from anyone else.",
  "e2e.recovery.lead_file": "This key opens the file without its password. It is shown once - filex does not store it and cannot show it again.",
  "e2e.dl.ctx_encrypted_copy": "Download encrypted copy",
  "e2e.dl.too_big": "This browser can save at most {limit} of decrypted data at once, and this is {size}. Use Chrome or Edge (they save straight to disk), the filex desktop app, or download the encrypted file and run filex decrypt.",
  "e2e.dl.click_again": "Click Download again to choose where to save it.",
  "e2e.dl.zip_started": "Decrypting into “{name}”…",
  "e2e.dl.zip_done": "“{name}” saved - decrypted, with the real names.",
  "e2e.dl.zip_done_plain": "“{name}” saved. {n} files in it were never encrypted and are in it as they were.",
  "e2e.dl.zip_done_plain_one": "“{name}” saved. {n} file in it was never encrypted and is in it as it was.",
  "e2e.dl.zip_damaged": "A file in the folder is damaged or was tampered with. The download stopped and nothing was saved.",
  "e2e.upload.streaming_unsupported": "This file is over 200 MB, and this server has no chunked upload to send it encrypted piece by piece.",
  /* wiring:e2 fxe escrow - the escrow key opens a single file, and its owner is told */
  "e2e.fxe.use_escrow": "Use the escrow key",
  "e2e.fxe.escrow_warn_title": "The file’s owner will be told",
  "e2e.fxe.escrow_warn_body": "Opening a file with the escrow key notifies its owner, before the file is opened. Use it only when you are entitled to.",
  "e2e.fxe.escrow_predates": "This installation has an escrow key, but this file was encrypted without it (before escrow was turned on here), so the escrow key does not open it. Use the password or the recovery key.",
  "e2e.fxe.escrow_other_key": "This file is sealed to the escrow key of a DIFFERENT installation, so this installation’s escrow key does not open it.",
  "e2e.fxe.wrong_escrow": "That escrow key does not open this file.",
  "e2e.fxe.escrow_notify_failed": "Could not notify the file’s owner, so the file was not opened. Escrow use is always announced.",
  "e2e.fxe.escrow_done": "Opened with the escrow key - the owner has been notified",
  /* wiring:e2 fxe purge - an administrator deletes the original for good */
  "e2e.fxe.seen_trash_admin": "The original goes to the trash and stays there until the trash retention period ends - unless you delete it for good below.",
  "e2e.fxe.seen_versions_admin": "Its earlier versions stay in its version history - unless you delete them for good below.",
  "e2e.fxe.purge_label": "Delete the original for good (administrator)",
  "e2e.fxe.purge_hint": "Its earlier versions and its trash entry are deleted as soon as the encrypted copy is saved, so no plaintext of it stays on this server. There is no undo. Backups and copies made before now are not reached.",
  "e2e.fxe.purge_others": "This file belongs to {owner}, not to you. Delete their original and its versions for good.",
  "e2e.fxe.purge_others_unknown": "This file has no recorded owner - it is not yours. Delete the original and its versions for good.",
  "e2e.fxe.purge_others_required": "Confirm that you are deleting someone else’s file for good.",
  "e2e.fxe.purge_no_id": "This file is not in the catalog yet, so it cannot be deleted for good. Refresh the folder and try again.",
  "e2e.fxe.purged": "“{name}” is encrypted. The original, its versions and its trash entry are deleted for good.",
  "e2e.fxe.purge_failed": "The encrypted copy of “{name}” is saved, but the original could not be deleted for good ({reason}). Delete it from the trash and its version history.",
  /* wiring:e2 fxe big - a decrypted download too large for this browser's memory */
  "e2e.big.title": "Too large to decrypt in this browser",
  "e2e.big.lead": "“{name}” is {size} once decrypted. This browser decrypts a download in its memory and can hold at most {limit} of it, so nothing was downloaded.",
  "e2e.big.lead_grew": "“{name}” grew past {limit} while it was being decrypted. This browser decrypts a download in its memory and cannot hold more, so nothing was saved.",
  "e2e.big.instead": "Decrypt it on your own computer instead:",
  "e2e.big.step_file": "Download the encrypted file, as it is (the button below).",
  "e2e.big.step_folder": "Download the encrypted folder as a zip (the button below) - it carries the folder’s key file.",
  "e2e.big.step_run": "In the folder you saved it to, run filex decrypt and give it the password:",
  "e2e.big.copy": "Copy",
  "e2e.big.copied": "Copied",
  "e2e.big.other_ways": "Chrome, Edge and the filex desktop app decrypt straight to disk, whatever the size.",
  "e2e.big.close": "Close",
  "e2e.big.download_file": "Download encrypted file",
  "e2e.big.download_folder": "Download encrypted folder (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket - accessible names that were English literals */
  "breadcrumb.aria": "Breadcrumb",
  "e2e.recovery_key_aria": "Recovery key",
  "modal.close": "Close",
  "modal.busy_close.keep": "Keep going",
  "modal.busy_close.confirm": "Stop and close",
  /* ── the bell and the account menu (2026-09-27: moved here from the admin
     app so the desktop app's explorer draws the same ones). ⚠ SHARED keys:
     the admin app's catalogue has every one of them under the same name, with
     the same English and Turkish (web/tests/i18n/langPackCatalogue.test.ts),
     so a language pack translates each once for both screens. */
  "notifications.bell": "Notifications",
  "notifications.unreadCount": "{n} unread",
  "notifications.title": "Notifications",
  "notifications.markAllRead": "Mark all read",
  "notifications.markRead": "Mark read",
  "notifications.empty": "No notifications yet",
  "notifications.viewAll": "View all",
  "notifications.manageAdmin": "Manage notifications",
  "notifications.openTarget": "Open what this is about",
  "notifications.unreadOnly": "Unread only",
  "notifications.pageOf": "Page {page} of {pages} · {total} in total",
  "notifications.severity.info": "Info",
  "notifications.severity.warning": "Warning",
  "notifications.severity.error": "Error",
  "notifications.severity.critical": "Critical",
  "common.prev": "Previous",
  "common.next": "Next",
  "explore.account": "Account",
  /* ── the user settings dialog (2026-09-27: moved here from the admin app
     so the desktop app opens the same dialog inside its window). ⚠ SHARED
     keys: the admin app's catalogue has each under the same name with the same
     English and Turkish (web/tests/i18n/langPackCatalogue.test.ts). An
     account field's refusal is the server's sentence (POST
     /api/auth/account/check, lib/accountRules), not a key here. */
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.currentPassword": "Current password",
  "common.email": "Email",
  "common.loading": "Loading…",
  "common.newPassword": "New password",
  "common.remove": "Remove",
  "common.save": "Save",
  "common.saving": "Saving…",
  "errors.generic": "Something went wrong",
  "errors.validationFailed": "Please check the highlighted fields",
  "install.desktopAllDownloads": "All downloads and release notes",
  "install.desktopSubtitle": "Sync folders to this computer and keep them up to date in the background. Available for {platform}.",
  "install.install": "Install",
  "install.menuInstructions": "Open your browser's menu and choose “Install app” or “Add to Home screen”.",
  "install.iosInstructions": "Tap Share (on iOS 26: ⋯, then Share), then “Add to Home Screen” and Add.",
  "nav.themeAuto": "Auto",
  "nav.themeDark": "Dark",
  "nav.themeLight": "Light",
  "notifications.prefs.browser": "Browser notifications",
  "notifications.prefs.browserHint": "Raise a notification outside the tab when something new arrives. Clicking it opens the file, folder or share it is about.",
  "notifications.prefs.desktopHandled": "The desktop app shows these itself",
  "notifications.prefs.enableBrowser": "Allow notifications",
  "notifications.prefs.inApp": "In-app bell",
  "notifications.prefs.inAppHint": "Turning this off empties your bell. Nothing stops being recorded - an admin still sees every event.",
  "notifications.prefs.iosHomeScreen": "On an iPhone or iPad, notifications work in {name} added to the Home Screen (iOS 16.4 or later), not in a browser tab.",
  "notifications.prefs.movedToSettings": "Your own notification settings - the bell, browser pop-ups, which events - are in your user settings.",
  "notifications.prefs.openSettings": "Open my notification settings",
  "notifications.prefs.permDefault": "Permission not asked yet",
  "notifications.prefs.permDenied": "Blocked by this browser",
  "notifications.prefs.permDeniedHint": "Re-allow notifications for this site in your browser settings.",
  "notifications.prefs.permGranted": "Allowed by this browser",
  "notifications.prefs.permUnsupported": "This browser cannot show notifications",
  "notifications.prefs.push": "Push notifications on this device",
  "notifications.prefs.pushAdded": "Added {date}",
  "notifications.prefs.pushDevices": "Devices that receive push notifications",
  "notifications.prefs.pushDisabled": "Turned off on the server (FILEX_PUSH_ENABLED).",
  "notifications.prefs.pushFailed": "Push notifications could not be turned on for this device.",
  "notifications.prefs.pushHint": "What your bell tells you reaches this phone or browser even while {name} is closed - the same notifications, at the same moment.",
  "notifications.prefs.pushKeyUnreadable": "The server's push key no longer opens (FILEX_SECRET_KEY changed). Rotate it under Admin → Notifications.",
  "notifications.prefs.pushNoSecretKey": "Push notifications need FILEX_SECRET_KEY on the server: the key they are signed with is stored encrypted with it.",
  "notifications.prefs.pushOn": "On for this device",
  "notifications.prefs.pushRemove": "Remove",
  "notifications.prefs.pushRemoveLabel": "Remove {device}",
  "notifications.prefs.pushTest": "Send a test",
  "notifications.prefs.pushTestNone": "No device took the test.",
  "notifications.prefs.pushTestSent": "Test sent to {count} devices",
  "notifications.prefs.pushTestSent_one": "Test sent to {count} device",
  "notifications.prefs.pushThisDevice": "This device",
  "notifications.prefs.pushUnavailable": "Not available on this server",
  "notifications.prefs.pushUnnamed": "A device",
  "notifications.prefs.pushUnsupported": "This browser cannot receive push notifications",
  "notifications.prefs.saved": "Preference saved",
  "notifications.prefs.title": "Your notifications",
  "profile.avatar.change": "Change photo",
  "profile.avatar.failed": "That image could not be processed - try another one.",
  "profile.avatar.help": "Shown next to your name, and in the file explorer's collaboration bar - on every client signed in as you. Resized to 160px automatically.",
  "profile.avatar.label": "Profile picture",
  "profile.avatar.notImage": "Please choose an image file.",
  "profile.locale": "Language",
  "profile.passwordChanged": "Password changed",
  "profile.saved": "Profile saved",
  "profile.totp.code": "Verification code",
  "profile.totp.disable": "Disable 2FA",
  "profile.totp.disabled": "Disabled",
  "profile.totp.enable": "Enable 2FA",
  "profile.totp.enabled": "Enabled",
  "profile.totp.recoveryHint": "Save these now - each one signs you in once if you lose your authenticator. They are shown only this time.",
  "profile.totp.recoveryTitle": "Recovery codes",
  "profile.totp.scanHint": "Scan this QR code with your authenticator app, then enter the 6-digit code.",
  "profile.totp.title": "Two-factor authentication",
  "profile.username.label": "Username",
  "quota.title": "Storage quota",
  "quota.tooltip": "{used} of {limit} used ({percent})",
  "quota.unlimitedTooltip": "{used} used · unlimited",
  "userSettings.adminBadge": "Admin",
  "userSettings.demoReadOnly": "This is a shared demo account, so its profile, password and second factor cannot be changed.",
  "userSettings.footNote.ai": "There is nothing on this tab to save.",
  "userSettings.footNote.notifications": "Saved as you change them.",
  "userSettings.footNote.preferences": "Saved as you change them.",
  "userSettings.footNote.profile": "Changes on this tab are saved when you press Save.",
  "userSettings.footNote.security": "Each action here applies on its own.",
  "userSettings.heading": "User settings",
  "userSettings.headingSub": "Manage your profile, preferences, and security.",
  "userSettings.notifications.adminAlerts": "Administrator alerts",
  "userSettings.notifications.adminAlertsHint": "Updates, replicas, sign-in providers, tenant domains and the other alerts for administrators",
  "userSettings.notifications.device": "Desktop notifications",
  "userSettings.notifications.deviceHint": "Your computer's own notifications when something new arrives, also while filex runs in the background.",
  "userSettings.notifications.digestHint": "Kinds marked urgent reach you at once. The rest are held for {minutes} min and arrive as one summary, folder by folder.",
  "userSettings.notifications.digestOffHint": "Every kind reaches you at once. Turn Urgent off for a kind to get it in one summary instead, folder by folder.",
  "userSettings.notifications.events.archive_created": "An archive finishes being created",
  "userSettings.notifications.events.archive_extracted": "An archive finishes extracting",
  "userSettings.notifications.events.comment_added": "Someone comments on a file",
  "userSettings.notifications.events.drop_received": "A file arrives through a request link",
  "userSettings.notifications.events.e2e_escrow_used": "An encrypted folder is opened with the escrow key",
  "userSettings.notifications.events.e2e_password_changed": "The password of your encrypted folder is changed",
  "userSettings.notifications.events.e2e_request_created": "Someone asks to encrypt a folder or a file",
  "userSettings.notifications.events.e2e_request_decided": "Your encryption request is answered",
  "userSettings.notifications.events.file_deleted": "A file is deleted for good",
  "userSettings.notifications.events.file_infected": "A virus is found in a file",
  "userSettings.notifications.events.file_moved": "A file is moved or renamed",
  "userSettings.notifications.events.file_trashed": "A file goes to the trash",
  "userSettings.notifications.events.file_updated": "A file is changed",
  "userSettings.notifications.events.file_upload_failed": "An upload does not finish",
  "userSettings.notifications.events.file_uploaded": "A new file arrives",
  "userSettings.notifications.events.notification_digest": "A summary of the notifications I did not mark urgent",
  "userSettings.notifications.events.plugin_notice": "An installed app sends you a message",
  "userSettings.notifications.events.share_created": "Someone creates a share link",
  "userSettings.notifications.eventsHint": "Turning one off keeps it out of your bell. Nothing stops being recorded - an administrator still sees every event.",
  "userSettings.notifications.eventsTitle": "What to tell me about",
  "userSettings.notifications.urgent": "Urgent",
  "userSettings.notifications.urgentFor": "Tell me at once: {event}",
  "userSettings.open": "User settings",
  "userSettings.prefs.appearance": "Appearance",
  "userSettings.prefs.compact": "Use compact file list",
  "userSettings.prefs.compactHint": "Tighter rows in the file explorer.",
  "userSettings.prefs.remoteImages": "Load remote images in previews",
  "userSettings.prefs.remoteImagesHint": "Pictures from other servers in a file's preview load without asking. Off, each one waits for a click, because loading it tells that server the file was opened. Thumbnails never load them.",
  "userSettings.prefs.desktopApp": "Desktop app",
  "userSettings.prefs.desktopAppHint": "The reminder in the corner of the app can be closed for good - these downloads stay here.",
  "userSettings.prefs.folderView": "Default folder view",
  "userSettings.prefs.folderViewHint": "How a folder you have never changed opens. A folder you have changed keeps its own view - changing this does not touch it.",
  "userSettings.prefs.fvColumns": "Your default columns are customized (set with “Make this my default for all folders”).",
  "userSettings.prefs.fvColumnsReset": "Reset them",
  "userSettings.prefs.fvDir": "Direction",
  "userSettings.prefs.fvDir_asc": "Ascending",
  "userSettings.prefs.fvDir_desc": "Descending",
  "userSettings.prefs.fvForget": "Forget them all",
  "userSettings.prefs.fvInherit": "Server default ({value})",
  "userSettings.prefs.fvMode": "View",
  "userSettings.prefs.fvSort": "Sort by",
  "userSettings.prefs.fvSort_modified": "Modified",
  "userSettings.prefs.fvSort_name": "Name",
  "userSettings.prefs.fvSort_size": "Size",
  "userSettings.prefs.fvSort_type": "Type",
  "userSettings.prefs.fvView_gallery": "Gallery",
  "userSettings.prefs.fvView_grid": "Grid",
  "userSettings.prefs.fvView_list": "List",
  "userSettings.prefs.installApp": "Install as a web app",
  "userSettings.prefs.installAppLead": "Put {name} on this device's home screen: it opens in a window of its own, like an app.",
  "userSettings.prefs.languageHint": "Applies here right away, and is saved on your account for the next browser you sign in from.",
  "userSettings.prefs.mode": "Light or dark",
  "userSettings.prefs.modeHint": "Which variant is painted. Auto follows your operating system.",
  "userSettings.prefs.openTrigger": "Open files with",
  "userSettings.prefs.openTriggerDouble": "Double-click",
  "userSettings.prefs.openTriggerHint": "How a mouse opens a file. On a touchscreen a tap always opens, and the checkbox always selects.",
  "userSettings.prefs.openTriggerSingle": "Single-click",
  "userSettings.prefs.palette": "Color palette",
  "userSettings.prefs.paletteHint": "Which colors that variant is made of. Every palette has a light and a dark version, so this and the setting above work together.",
  "userSettings.prefs.shortcuts": "Keyboard shortcuts",
  "userSettings.prefs.shortcutsEdit": "Edit…",
  "userSettings.prefs.shortcutsHint": "The keys the file manager answers to.",
  "userSettings.prefs.startPage": "Start page",
  "userSettings.prefs.startPageHint": "Where filex opens when you sign in or go to the front door. Following a link straight to a page still takes you there.",
  "userSettings.prefs.startPage_admin": "Admin panel",
  "userSettings.prefs.startPage_files": "Files",
  "userSettings.prefs.startPage_home": "Home",
  "userSettings.prefs.timezone": "Time zone",
  "userSettings.prefs.timezoneHint": "Dates are stored as a moment in time and shown on the clock you pick here, so everyone sees the same instant on their own clock. Saved to your account, so it follows you to another browser.",
  "userSettings.prefs.timezoneNow": "Right now in {zone}: {time}",
  "userSettings.saveChanges": "Save changes",
  "userSettings.scope.account": "Account",
  "userSettings.scope.accountHint": "Saved on your account: the same wherever you sign in.",
  "userSettings.scope.device": "This device",
  "userSettings.scope.deviceHint": "Saved on this device only: another computer, phone or browser keeps its own.",
  "userSettings.scope.deviceNotifyHint": "How this device tells you about something new, saved on this device only.",
  "userSettings.scope.myAccount": "My account",
  "userSettings.scope.myAccountHint": "What reaches your bell, saved on your account.",
  "userSettings.security.passwordTitle": "Change password",
  "userSettings.security.totpDisabled": "Two-factor authentication is off",
  "userSettings.security.totpEnabled": "Two-factor authentication is on",
  "userSettings.subtitle.ai": "Nothing for you to set here yet.",
  "userSettings.subtitle.notifications": "What reaches your bell, and what reaches your desktop.",
  "userSettings.subtitle.preferences": "How this app looks and reads on your devices.",
  "userSettings.subtitle.profile": "Your name, email and picture - what other people see.",
  "userSettings.subtitle.security": "Your password and second factor.",
  "userSettings.tabs.ai": "AI assistant",
  "userSettings.ai.state.on": "The assistant is on.",
  "userSettings.ai.state.off": "The assistant is turned off on this server.",
  "userSettings.ai.state.not_configured": "The administrator has not set the assistant up yet.",
  "userSettings.ai.state.not_permitted": "The assistant is on, but your role does not include it.",
  "userSettings.ai.provider": "Who reads what you write",
  "userSettings.ai.providerHint": "Your messages, and the files the assistant reads for you, are sent to this provider. Every file it reads is in the audit log.",
  "userSettings.ai.confirmAll": "Ask me before every change",
  "userSettings.ai.confirmAllHint": "Off: changes that can be undone (move, rename, edit, delete to the trash) happen at once, with an Undo. On: they wait for your approval too. Anything that cannot be undone always waits.",
  "userSettings.ai.history": "Conversation history",
  "userSettings.ai.retention": "Conversations are kept on the server for {count} days after they were last used.",
  "userSettings.ai.retention_one": "Conversations are kept on the server for {count} day after they were last used.",
  "userSettings.ai.clear": "Delete my conversations",
  "userSettings.ai.clearConfirm": "Delete them all for good?",
  "userSettings.ai.cleared": "Your conversations were deleted.",
  "userSettings.ai.saveFailed": "That could not be saved.",
  "userSettings.tabs.notifications": "Notifications",
  "userSettings.tabs.preferences": "Preferences",
  "userSettings.tabs.profile": "Profile",
  "userSettings.tabs.security": "Security",
  "userSettings.apps.title": "Default apps",
  "userSettings.apps.lead": `Choose one in a file's menu: Open with, Choose an app…, then tick "Always use this app". Only the apps your administrator left on for a kind are offered.`,
  "userSettings.apps.empty": "You have not chosen an app for any kind of file yet: every file opens with what your administrator put first.",
  "userSettings.apps.reset": "Reset",
  "userSettings.apps.resetAll": "Reset all",
  "userSettings.apps.unavailable": "No longer available: it opens with {app} until you choose again.",
  "userSettings.apps.change": "The app that opens {ext} files",
  "userSettings.title": "User settings",
  "users.fields.displayName": "Display name",
  "profile.username.helpText": "Your username. You can sign in with it or with your email - and connection clients (SFTP, FTP) need it, because an @ in the name they sign in with has to be escaped in their config files.",
  "userSettings.prefs.fvKeptCount": "{count} folders keep a view of their own.",
  "userSettings.prefs.fvKeptCount_one": "{count} folder keeps a view of its own."
}, X0 = {
  "toolbar.new_folder": "Yeni klasör",
  "toolbar.upload": "Yükle",
  "toolbar.search": "Ara",
  "toolbar.search.placeholder": "Ada ya da tag: ile ara…",
  "toolbar.view.list": "Liste",
  "toolbar.view.grid": "Izgara",
  "toolbar.refresh": "Yenile",
  "toolbar.go_up": "Üst klasör",
  "ctx.open": "Aç",
  "ctx.preview": "Önizle",
  "ctx.download": "İndir",
  "ctx.archive_create": "Arşiv oluştur…",
  "ctx.archive_extract": "Arşivi çıkar…",
  "ctx.rename": "Yeniden adlandır",
  "ctx.delete": "Sil",
  "ctx.delete_perm": "Kalıcı olarak sil",
  "ctx.restore": "Geri getir",
  "ctx.share": "Paylaş",
  "ctx.move": "Taşı",
  "ctx.copy": "Kopyala",
  "ctx.cut": "Kes",
  "ctx.show_hidden": "Gizli dosyaları göster",
  "ctx.hide_hidden": "Gizli dosyaları gizle",
  "ctx.keep_local": "Bilgisayarda tut",
  "ctx.keep_online": "Yalnızca çevrimiçi tut",
  "ctx.keep_reveal": "Yerel klasörü aç",
  "ctx.keep_inherited": "Üst klasörle bilgisayarda tutuluyor",
  "keep.started": "Bilgisayarda tutulacak - eşitleme başladı",
  "keep.failed": "Bilgisayarda tutulamadı",
  "keep.badge_kept": "Bilgisayarda",
  "keep.badge_syncing": "Eşitleniyor…",
  "keep.badge_cloud": "Yalnızca çevrimiçi",
  "keep.badge_partial": "İçinde bilgisayarda tutulanlar var",
  "keep.strip_transfer": "{name} eşitleniyor - {done}/{total} (%{pct})",
  "keep.strip_inventory": "{name} eşitleniyor - sunucu taranıyor…",
  "keep.strip_settling": "{name} eşitleniyor - son durum kaydediliyor…",
  "ctx.paste": "Yapıştır",
  "ctx.info": "Bilgi",
  "ctx.duplicate": "Kopyasını oluştur",
  "ctx.new_file": "Yeni dosya",
  "modal.delete.title": "Silinsin mi?",
  "modal.delete.message": "{count} öğe çöpe atılacak.",
  "modal.delete.message_one": "{count} öğe çöpe atılacak.",
  "modal.delete.confirm": "Çöpe at",
  "modal.delete.working": "Çöpe taşınıyor…",
  "modal.delete.cancel": "Vazgeç",
  "modal.delete.permanent_title": "Kalıcı olarak silinsin mi?",
  "modal.delete.permanent_message": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_message_one": "{count} öğe kalıcı olarak silinecek. Bu geri alınamaz.",
  "modal.delete.permanent_confirm": "Kalıcı olarak sil",
  "modal.delete.permanent_working": "Siliniyor…",
  "modal.rename.title": "Yeniden adlandır",
  "modal.rename.save": "Kaydet",
  "modal.rename.saving": "Yeniden adlandırılıyor…",
  "modal.rename.cancel": "Vazgeç",
  "modal.rename.empty": "Bir ad yazın.",
  "modal.newfolder.title": "Yeni klasör",
  "modal.newfolder.placeholder": "Klasör adı",
  "modal.newfolder.create": "Oluştur",
  "modal.newfolder.creating": "Oluşturuluyor…",
  "modal.newfolder.cancel": "Vazgeç",
  "modal.share.title": "Paylaşım bağlantısı",
  "archive.create_title": "Arşiv oluştur",
  "archive.extract_title": "Arşivi çıkar",
  "archive.create_count": "{count} öğe seçildi",
  "archive.create_count_one": "{count} öğe seçildi",
  "archive.filename": "Arşiv adı",
  "archive.format": "Biçim",
  "archive.password_optional": "Parola (isteğe bağlı)",
  "archive.password_confirm": "Parolayı doğrula",
  "archive.password_mismatch": "Parolalar birbiriyle eşleşmiyor.",
  "archive.encrypt_names": "Dosya adlarını şifrele",
  "archive.compression": "Sıkıştırma",
  "archive.solid": "Katı arşiv oluştur",
  "archive.dictionary_size": "Sözlük boyutu",
  "archive.dictionary_size_value": "{n} MiB",
  "archive.dictionary_hint": "Daha büyük sözlükler sıkıştırmayı iyileştirebilir ancak oluşturma ve çıkarma sırasında daha fazla bellek kullanır.",
  "archive.destination_folder": "Çıkarılacak klasör",
  "archive.create": "Oluştur",
  "archive.creating": "Oluşturuluyor…",
  "archive.extract": "Çıkar",
  "archive.extract_here": "Buraya çıkar",
  "archive.extract_to_folder": "Klasöre çıkar",
  "archive.extracting": "Çıkarılıyor…",
  "archive.cancel": "Vazgeç",
  "archive.invalid_name": "Eğik çizgi içermeyen bir dosya adı girin.",
  "archive.invalid_extension": "Arşiv adı kullanılabilir biçim uzantılarından biriyle bitmelidir.",
  "archive.invalid_folder": "Eğik çizgi içermeyen bir klasör adı girin.",
  "archive.password_required": "Bu arşiv için parola gerekiyor.",
  "archive.password_title": "Arşiv parolası",
  "archive.continue": "Devam et",
  "archive.opening": "Açılıyor…",
  "archive.bad_password": "Arşiv parolası yanlış.",
  "archive.target_exists": "Bu ada sahip bir öğe zaten var. Başka bir ad seçin veya önce mevcut öğeyi kaldırın.",
  "archive.password_charset": "ZIP parolasında yalnızca ASCII karakterler kullanılabilir; ç, ğ, ı, İ, ö, ş, ü gibi harfler kullanılamaz. Her karakteri kullanmak için 7z biçimini seçin.",
  "archive.error_unsupported": "Bu arşiv çıkarılamıyor: bu sunucu biçimini okuyamıyor ya da içinde filex’in çıkarmadığı bir şey var (bağlantı, özel dosya ya da boyutunu belirtmeyen bir dosya).",
  "archive.error_limit": "Bu arşiv, sunucunun çıkarmaya izin verdiği boyutu aşıyor.",
  "archive.error_unavailable": "Bu sunucu şu anda bu tür bir arşivi açamıyor.",
  "archive.created": "Arşiv oluşturuldu",
  "archive.queued": "Arşiv oluşturma arka planda çalışıyor",
  "archive.extracted": "{count} dosya çıkarıldı",
  "archive.extracted_one": "{count} dosya çıkarıldı",
  "archive.extraction_queued": "Arşiv çıkarma arka planda çalışıyor",
  "archive.preparing_extract": "{name} okunuyor… çıkarılmadan önce arşivin tamamı okunur.",
  "archive.already_preparing": "{name} hâlâ okunuyor - okuma bitince bir kez çıkarılacak",
  "archive.extraction_completed": "Çıkarma tamamlandı",
  "archive.extraction_cancelled": "Çıkarma {count} dosyadan sonra iptal edildi",
  "archive.extraction_cancelled_one": "Çıkarma {count} dosyadan sonra iptal edildi",
  "modal.share.pin": "PIN koruması",
  "modal.share.expires": "Son kullanma",
  "modal.share.max_downloads": "İndirme limiti",
  "modal.share.create": "Paylaş",
  "modal.share.cancel": "Vazgeç",
  "modal.share.close": "Kapat",
  "modal.share.limit_applied": "(sunucu sınırı uygulandı)",
  "modal.share.copy": "Kopyala",
  "modal.share.url_copied": "Bağlantı kopyalandı",
  "modal.share.pin_copied": "PIN kopyalandı",
  "modal.share.cli_copied": "CLI komutu kopyalandı",
  "upload.progress": "Yükleniyor",
  "upload.done": "Tamamlandı",
  "upload.error": "Hata",
  "upload.failed": "“{name}” yüklenemedi",
  "upload.aborted": "İptal edildi",
  "upload.cancel": "İptal",
  "upload.resuming": "“{name}” %{percent} noktasından devam ediyor",
  "upload.saving": "Depoya kaydediliyor…",
  "empty.folder": "Bu klasör boş",
  "empty.search": "Sonuç bulunamadı",
  loading: "Yükleniyor…",
  "notFound.title": "Klasör bulunamadı",
  "notFound.desc": "Bu klasör mevcut değil, taşınmış ya da erişim yetkiniz yok.",
  "notFound.goRoot": "Kök klasöre dön",
  "col.name": "Ad",
  "col.size": "Boyut",
  "col.modified": "Değiştirilme",
  "col.type": "Tür",
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB",
  "breadcrumb.root": "Kök",
  "breadcrumb.copy_path": "Yolu kopyala",
  "breadcrumb.go_to_path": "Yola git",
  "breadcrumb.path_placeholder": "fileman/foo/bar",
  "ops.copy": "Kopyalanıyor",
  "ops.move": "Taşınıyor",
  "ops.delete": "Siliniyor",
  "ops.queued": "sırada",
  "ops.done": "tamamlandı",
  "ops.error": "hata",
  "node.trash": "Çöp kutusu",
  "node.folder": "Klasör",
  // --- Zengin önizleyici chrome ---
  "viewer.open_in_new_tab": "Yeni sekmede aç",
  "viewer.loading": "Yükleniyor…",
  "viewer.failed_to_load": "Dosya yüklenemedi",
  "viewer.peer_not_installed": "Bu tür bir dosya burada gösterilemiyor. Cihazınızda açmak için indirin.",
  "viewer.remote_image.label": "Uzak görsel",
  "viewer.remote_image.title": "Uzak görsel yüklensin mi?",
  "viewer.remote_image.body": "Bu görsel başka bir sunucuda. Yüklerseniz o sunucu bu dosyanın açıldığını ve IP adresinizi öğrenir.",
  "viewer.remote_image.setting_hint": "Sormadan yüklenmeleri için Kullanıcı ayarları → Tercihler bölümünde “Önizlemelerde uzak görselleri yükle” seçeneğini açın.",
  "viewer.remote_image.load": "Görseli yükle",
  "viewer.remote_image.load_all": "Bu dosyadaki tüm uzak görselleri yükle",
  "viewer.remote_image.book_held": "Bu kitapta başka sunuculardaki görseller yüklenmedi.",
  "viewer.remote_image.book_load": "Uzak görselleri yükle…",
  "viewer.format_unsupported_3d": "Önizleme yalnızca .glb, .gltf ve .usdz biçimindeki 3B modelleri gösterir. Dosyayı indirip bir 3B programında açın.",
  "viewer.zoom_in": "Yakınlaştır",
  "viewer.zoom_out": "Uzaklaştır",
  "viewer.fit_width": "Sayfa genişliğine sığdır",
  "viewer.next_page": "Sonraki sayfa",
  "viewer.prev_page": "Önceki sayfa",
  "viewer.page_n_of_m": "Sayfa {n} / {m}",
  "viewer.tags": "Etiketler",
  "viewer.layers": "Katmanlar",
  "viewer.toc": "İçindekiler",
  "viewer.font_smaller": "Yazıyı küçült",
  "viewer.font_larger": "Yazıyı büyüt",
  "viewer.search": "Ara",
  "viewer.download": "İndir",
  "viewer.saving": "Kaydediliyor…",
  "viewer.save": "Kaydet (Ctrl+S)",
  "viewer.saved": "Kaydedildi",
  "viewer.save_error": "Hata",
  "viewer.editor_loading": "Editör yükleniyor…",
  "viewer.no_preview": "Bu dosya tipi için önizleme henüz yok.",
  "viewer.edit": "Düzenle",
  "viewer.close": "Kapat",
  "presence.expand": "Adları göster",
  "presence.collapse": "Küçült",
  "viewer.save_annotations": "Açıklamaları kaydet",
  "viewer.annotations_on": "Açıklamalar: açık",
  "viewer.annotations_off": "Açıklamalar: kapalı",
  "viewer.read_only": "Salt okunur",
  "viewer.csv_first_row_header": "İlk satır başlık olsun",
  "viewer.csv_filter": "Satır filtrele…",
  "viewer.epub_prev": "Önceki",
  "viewer.epub_next": "Sonraki",
  /* ⚠ Eski cümle her okuyucuya bir ORTAM DEĞİŞKENİ söylüyordu ("yönetici
     FILEX_DRAWIO_URL'yi ayarlamalı"). Yalnızca bir diyagrama bakmak isteyen
     kişiye ne yapabileceği; `_admin` - düzeltebilecek kişiye - nereden
     düzelteceği söylenir. */
  "viewer.drawio.disabled": "Diyagramlar burada açılamıyor: bu sunucuda draw.io yok. Başka bir yerde açmak için dosyayı indirin.",
  "viewer.drawio.disabled_admin": "Bu sunucuda draw.io kurulu değil. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.drawio.load_failed": "Bu diyagram okunamadı. Başka bir yerde açmak için indirin.",
  "viewer.drawio.save_failed": "Diyagram kaydedilemedi. Değişiklikleriniz hâlâ düzenleyicide - yeniden deneyin.",
  "viewer.archive.entries": "{n} dosya",
  "viewer.archive.entries_one": "{n} dosya",
  "viewer.archive.empty": "Arşiv boş.",
  "viewer.archive.error": "Arşiv okunamadı.",
  "viewer.archive.unsupported": "Bu tür bir arşiv burada listelenemiyor. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.too_large": "Bu arşiv burada listelenemeyecek kadar büyük. İçinde ne olduğunu görmek için indirin.",
  "viewer.archive.open": "Arşivi aç",
  "viewer.archive.root": "Arşiv",
  "viewer.archive.location": "Arşiv konumu",
  "viewer.archive.reading": "Hâlâ okunuyor… İçeriği listelenmeden önce arşivin tamamı okunur; büyük bir arşivde bu biraz sürer.",
  "viewer.name": "Ad",
  "viewer.size": "Boyut",
  // --- cila:a - sıralama / tarih grupları / yoğunluk ---
  "col.sort": "Sırala",
  "group.today": "Bugün",
  "group.yesterday": "Dün",
  "group.this_week": "Bu hafta",
  "group.this_month": "Bu ay",
  "group.no_date": "Tarihsiz",
  "toolbar.density.compact": "Sıkışık görünüm",
  "toolbar.density.comfortable": "Rahat görünüm",
  // --- cila:c - komut paleti + kısayol yardımı + breadcrumb ---
  "palette.placeholder": "Dosya, klasör veya komut ara…",
  "palette.files": "Dosyalar",
  "palette.commands": "Komutlar",
  "palette.goto": "Yola git",
  "palette.empty": "Sonuç bulunamadı",
  "palette.hint": "↑↓ gezin · Enter seç · Esc kapat",
  "cmd.view_toggle": "Görünümü değiştir (liste ⇄ ızgara)",
  "cmd.trash": "Çöp kutusunu aç",
  "shortcuts.title": "Klavye kısayolları",
  "shortcuts.group.nav": "Gezinme",
  "shortcuts.group.selection": "Seçim",
  "shortcuts.group.file": "Dosya işlemleri",
  "shortcuts.palette": "Komut paleti",
  "shortcuts.search": "Aramaya odaklan",
  "shortcuts.go_up": "Üst klasöre çık",
  "shortcuts.open": "Seçili öğeyi aç",
  "shortcuts.close": "Kapat / vazgeç",
  "shortcuts.toggle_hidden": "Gizli dosyaları göster/gizle",
  "shortcuts.help": "Bu yardım penceresi",
  "shortcuts.select_all": "Tümünü seç",
  "shortcuts.star": "Yıldızla / yıldızı kaldır",
  "shortcuts.rename": "Yeniden adlandır",
  "shortcuts.delete": "Sil",
  "shortcuts.cut": "Kes",
  "shortcuts.copy": "Kopyala",
  "shortcuts.paste": "Yapıştır",
  "breadcrumb.more": "Aradaki klasörler",
  // --- State screens + undo snackbar + connection badge (cila:b) ---
  "empty.hint": "Dosyaları buraya sürükleyip bırakın",
  "empty.upload": "Dosya yükle",
  "empty.search.title": "Aramanızla eşleşen dosya yok",
  "empty.search.hint": "Farklı bir arama terimi deneyin",
  "empty.trash.title": "Çöp kutusu boş",
  "error.title": "Liste yüklenemedi",
  "error.retry": "Yeniden dene",
  "toast.undo": "Geri al",
  "toast.undone": "Geri alındı",
  "toast.undoing": "Geri alınıyor…",
  "toast.undo_queued": "Geri alma kuyruğa alındı - bittiğini işlemler paneli gösterecek",
  "toast.undo_failed": "Geri alınamadı",
  "toast.renamed": "Yeniden adlandırıldı",
  "toast.rename_queued": "“{name}” olarak yeniden adlandırılıyor…",
  "toast.moved": "Taşındı",
  "toast.trashed": "Çöpe taşındı",
  /* i18n:hardcoded - FileExplorer.vue'da düz string olarak duran, hiçbir dilin
     değiştiremediği bildirim metinleri. */
  "toast.failed": "İşlem başarısız",
  "err.status.400": "Geçersiz istek",
  "err.status.401": "Oturum açmanız gerekiyor",
  "err.status.403": "Bu işlem için yetkiniz yok",
  "err.status.404": "Bulunamadı",
  "err.status.409": "Zaten var / çakışma",
  "err.status.413": "Dosya çok büyük",
  "err.status.415": "Bu dosya türü desteklenmiyor",
  "err.status.422": "Geçersiz veri",
  "err.status.429": "Çok fazla istek, biraz bekleyin",
  "err.status.500": "Sunucu hatası",
  "err.status.501": "Bu işlem desteklenmiyor",
  "err.status.502": "Bağlı bir servis hata verdi",
  "err.status.503": "Servis şu an kullanılamıyor",
  "err.status.504": "Bağlı bir servis zamanında yanıt vermedi",
  "err.status.other": "Sunucu bu isteği kabul etmedi.",
  "err.upload_stalled": "Yükleme ilerlemeyi bıraktı. Yeniden deneyin - kaldığı yerden devam eder.",
  "err.network": "Sunucuya ulaşılamadı. Bağlantınızı kontrol edip yeniden deneyin.",
  /* 0.54: sunucunun adını verdiği ret, sunucunun cümlesiyle söylenir (`message`, server.error.*). */
  "err.save_failed": "Değişiklikleriniz kaydedilemedi.",
  "err.load_failed": "Bu dosya yüklenemedi.",
  "err.viewer_failed": "Bu dosyanın görüntüleyicisi başlatılamadı. Açmak için dosyayı indirin.",
  "err.detail": "Ayrıntı",
  "toast.copied": "Kopyalandı",
  "toast.deleted": "Silindi",
  "toast.cut": "Kesildi",
  "toast.cut_ready": "Kes → Yapıştır hazır",
  "toast.copy_ready": "Kopyala → Yapıştır hazır",
  "toast.same_folder_cut": "Aynı klasöre kesilemez",
  "toast.restored": "{n} öğe geri getirildi",
  "toast.restored_one": "{n} öğe geri getirildi",
  "toast.delete_queued": "Silme kuyruğa alındı",
  "toast.trash_retention": "Çöpteki öğeler saklama süresi sonunda otomatik silinir. Kalıcı silme yönetici panelinden yapılır.",
  /* Kalıcı silinmesi yolda olan çöp satırı (yönetici Çöp sayfasının sözleri:
     iki katalogda tek cümle - ders #447). */
  "trash.purging": "Kalıcı olarak siliniyor…",
  "trash.row_busy": "Bu öğe üzerinde zaten bir iş sürüyor",
  "dropzone.hint": "Dosyaları buraya bırak",
  "modal.newfolder.invalid": "Geçersiz karakter",
  "names.reserved": "“{name}” adı filex’in kendi kullanımına ayrılmış. Başka bir ad seçin.",
  /* ⚠ Eksik ya da bozuk belge sunucusu kelimelerle söylenir, asla HTTP
     katmanıyla değil (eskiden `Config fetch 503: {"error":"onlyoffice not
     configured"}` yazıyordu). `_admin`, düzeltebilecek kişinin okuduğu -
     nereden düzelteceği; diğer herkes dosyayı yine de nasıl alacağını okur. */
  "viewer.office_unconfigured": "Ofis belgeleri burada açılamıyor: bu sunucuda ONLYOFFICE belge sunucusu yok. Dosyayı bilgisayarınızda açmak için indirin.",
  "viewer.office_unconfigured_admin": "Bu sunucuda ONLYOFFICE kurulu değil, bu yüzden ofis belgeleri burada açılamıyor. Yönetim panelinde Dış servisler altından kurabilirsiniz.",
  "viewer.office_unreachable": "Belge sunucusu şu anda yanıt vermiyor. Daha sonra yeniden deneyin ya da dosyayı indirin.",
  "viewer.office_unreachable_admin": "ONLYOFFICE belge sunucusu yanıt vermiyor. Yönetim panelinde Dış servisler altından kontrol edin.",
  /* Görev #92: düzenleyici başka bir kökendeki (belge sunucusunun kendi
     kökeni ya da arayüz kökeni) bir çerçevede çalışır ve o sayfa hiç yanıt
     vermedi - adres bu filex'e ulaşmıyor. */
  "viewer.office_frame_unreachable_admin": "ONLYOFFICE düzenleyici çerçevesi {origin} adresinden yüklenmedi. Oradaki vekil sunucunun çerçeveyi filex'e yönlendirdiğini kontrol edin ({env}).",
  "viewer.office_failed": "Bu belge ONLYOFFICE ile açılamadı. Bilgisayarınızda açmak için indirin.",
  "viewer.csv_office_note": "CSV olarak kaydedilir: yalnızca etkin sayfanın değerleri kalır. Biçimlendirme, formüller ve diğer sayfalar kaydedilmez.",
  "viewer.office_forbidden": "Bu belgeyi ONLYOFFICE ile açma izniniz yok.",
  /* ONLYOFFICE'in "Download failed" (İndirme başarısız) hatasından sonra:
     iki durumdan hangisi olduğu, filex'in gördüğüyle (lib/officeDiagnosis,
     #80). */
  "viewer.office_download_served": "Belge sunucusu bu dosyayı filex’ten indirdi, ancak tarayıcınız dönüştürülmüş kopyayı belge sunucusundan yükleyemedi. Belge sunucusunun önündeki vekil sunucunun X-Forwarded-Proto ve X-Forwarded-Host başlıklarına bakın.",
  "viewer.office_download_not_requested": "Belge sunucusu bu dosyayı filex’ten hiç istemedi. Dosya daha önce açıldıysa belge sunucusu kendi kopyasını kullanıyor olabilir.",
  "viewer.office_download_refused": "filex, belge sunucusunun bu dosya için yaptığı isteği şu nedenle reddetti: {reason}.",
  "viewer.office_fetch_reason.bad_link": "adres bozuktu",
  "viewer.office_fetch_reason.signature_expired": "adresin süresi dolmuştu",
  "viewer.office_fetch_reason.signature_bad": "imzası eşleşmedi (JWT sırrı değişti ya da adres değiştirildi)",
  "viewer.office_fetch_reason.not_found": "dosya artık yok",
  "viewer.office_fetch_reason.storage_unavailable": "depo açılamadı",
  "viewer.office_fetch_reason.body_unavailable": "dosyanın içeriği bulunamadı",
  "viewer.office_fetch_reason.object_missing": "dosya depoda yok",
  "viewer.office_fetch_reason.read_failed": "dosya depodan okunamadı",
  /* Gezginin "Aç" girdisi, belge sunucusu yokken - yalnızca yöneticiye
     gösterilir (diğer herkese girdi hiç sunulmaz; lib/serviceGate). */
  "ctx.needs_onlyoffice": "ONLYOFFICE kurulu değil - yönetim panelinde Dış servisler altından kurun.",
  "ctx.needs_drawio": "draw.io kurulu değil - yönetim panelinde Dış servisler altından kurun.",
  "viewer.pdf_inline_failed": "Tarayıcı PDF'i inline açamadı.",
  "viewer.too_large": "Dosya çok büyük (>1 MB).",
  "viewer.csv_rows": "{n} satır",
  "viewer.csv_rows_one": "{n} satır",
  "presence.others": "{n} kişi",
  "presence.others_one": "{n} kişi",
  "conn.offline": "Canlı bağlantı yok - değişiklikler gecikebilir",
  "conn.tooltip": "Sunucuyla canlı bağlantı kurulamadı; liste belirli aralıklarla otomatik yenilenir. Bağlantı geri gelince bu uyarı kaybolur.",
  /* === bul:s3 === */
  "palette.everywhere": "Her yerde",
  "palette.searching": "Aranıyor…",
  "palette.everywhere_failed": "Arama yapılamadı. Yeniden deneyin.",
  "palette.saved": "Kayıtlı aramalar",
  "palette.save": "Aramayı kaydet",
  "palette.saved.delete": "Kayıtlı aramayı sil",
  /* #168 - yönetim panelinin araması (components/PanelSearch.vue). */
  "panelsearch.label": "Yönetim panelinde ara",
  "panelsearch.trigger": "Ara",
  "panelsearch.placeholder": "Sayfa, ayar, kişi, uygulama ara…",
  "panelsearch.close": "Aramayı kapat",
  "panelsearch.clear": "Aramayı temizle",
  "panelsearch.results": "Arama sonuçları",
  "panelsearch.group.page": "Sayfalar",
  "panelsearch.group.setting": "Ayarlar",
  "panelsearch.group.app": "Uygulamalar",
  "panelsearch.group.user": "Kullanıcılar",
  "panelsearch.group.group": "Gruplar",
  "panelsearch.group.key": "API anahtarları",
  "panelsearch.group.storage": "Depolar",
  "panelsearch.group.share": "Paylaşımlar",
  "panelsearch.group.file": "Dosyalar",
  "panelsearch.group.recent": "Son aramalar",
  "panelsearch.files_all": "Dosyalarda ara: {q}",
  "panelsearch.recent_remove": "Son aramalardan kaldır",
  "panelsearch.recent_clear": "Son aramaları temizle",
  "panelsearch.empty": "“{q}” ile eşleşen bir şey yok.",
  "panelsearch.searching": "Aranıyor…",
  "panelsearch.failed": "Sonuçların bir kısmı yüklenemedi. Gelenler gösteriliyor.",
  "panelsearch.prefixes": "Tek bir türe daraltın:",
  "panelsearch.count_one": "{n} sonuç",
  "panelsearch.count": "{n} sonuç",
  "search.in_content": "İçerikte",
  "search.truncated": "Gösterilenden daha fazla sonuç var - aramanızı daraltın",
  "nav.more_shown": "{total} öğeden {shown} tanesi gösteriliyor",
  "nav.load_more": "Daha fazla yükle",
  /* Katalog kapsamı (docs/LAZY-CATALOGUE.md, lib/catalogCoverage). */
  "coverage.first_scan": "Bu deponun ilk senkronu henüz bitmedi. Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_filling": "filex bu depoyu hâlâ kataloglıyor (şimdiye kadar bulunan klasörlerin %{pct} kadarı tamam). Bitene kadar arama, klasör boyutları ve kullanım deponun bir kısmını kapsamaz.",
  "coverage.lazy_on_open": "Bu depoda yalnız açılan klasörler kataloglanır. Arama, klasör boyutları ve kullanım yalnız bu klasörleri kapsar.",
  "coverage.search_some": "Şu depoların tamamı henüz kataloglanmadı: {names}. Bu arama oradaki bazı dosyaları bulamayabilir.",
  "coverage.catalog_all": "Tümünü katalogla",
  "coverage.catalog_started": "Senkron başladı - deponun tamamı kataloglanıyor.",
  "coverage.catalog_running": "Kataloglanıyor…",
  "coverage.cataloging": "{storage} kataloglanıyor… arka planda sürüyor, bittiğinde bu sayfa söyleyecek.",
  "coverage.catalog_done": "{storage} baştan sona kataloglandı",
  "coverage.catalog_failed": "{storage} kataloglanamadı. Nedenini yönetim panelinde, deponun senkron geçmişinde görebilirsiniz.",
  "coverage.catalog_stopped": "{storage} kataloglaması bitmeden durduruldu",
  "coverage.catalog_joined": "{storage} zaten taranıyordu - bittiğinde bu sayfa haber verecek.",
  "coverage.catalog_gone": "{storage} kataloglanırken kaldırıldı",
  "coverage.catalog_unfollowed": "{storage} arka planda kataloglanmaya devam ediyor; nasıl bittiğini yönetim panelinde deponun senkron geçmişi gösterir",
  "size.at_least": "≥ {size}",
  "size.partial_hint": "Bu klasörün bir kısmı henüz kataloglanmadı; boyutu en az bu kadar.",
  "size.unknown_hint": "Bu klasör henüz kataloglanmadı; boyutu bilinmiyor.",
  /* === bag:b4 === */
  "toolbar.more": "Diğer işlemler",
  "toolbar.search.close": "Aramayı kapat",
  "sheet.menu": "İşlemler",
  "sheet.close": "Kapat",
  /* === koru:k1 === */
  "toolbar.inspector": "Ayrıntılar",
  "ctx.details": "Ayrıntılar",
  /* yildiz:s1 - yıldızlamak bir eylem, menüde de öyle görünür. */
  "ctx.star": "Yıldızla",
  "ctx.unstar": "Yıldızı kaldır",
  "star.failed": "Yıldız değiştirilemedi",
  "shortcuts.inspector": "Ayrıntılar panelini aç/kapat",
  "inspector.title": "Ayrıntılar",
  "inspector.copy_name": "Adı kopyala",
  "inspector.items": "{n} öğe",
  "inspector.items_one": "{n} öğe",
  "inspector.type": "Tür",
  "inspector.select_hint": "Ayrıntılarını görmek için bir öğe seçin.",
  /* pane:p1 - panel SON seçilen şeyi tutar (bakımcının kararı, 2026-09-13);
     dolayısıyla bölünmüş pencerenin bakılmayan yarısındaki bir öğeyi
     anlatıyor olabilir. Bu satır hangisi olduğunu ve nerede durduğunu söyler. */
  "inspector.held": "Son seçilen - {where} içinde",
  "inspector.close": "Kapat",
  "inspector.section.general": "Genel",
  "inspector.section.tags": "Etiketler",
  /* etiket:t1 - TagPicker'ın kendi çerçevesi. 2026-09-13'e kadar bu üçü
     katalogdan bağımsız olarak İngilizce basılıyordu; `tags.open` ise çipin
     yeni "bu etiketi taşıyan her şeyi göster" kapısı. */
  "tags.open": "Etiketi aç: {tag}",
  "tags.add": "+ Etiket ekle",
  "tags.name": "Etiket adı",
  "tags.remove": "Etiketi kaldır",
  /* etiket:k2 (v0.43.0) - etiketin iki TÜRÜ. Etiket nerede çiziliyorsa türünü
     simgeyle birlikte sözcükle de söyler: bu sürüme kadar her etiket sessizce
     sunucudaki herkesle paylaşılıyordu. */
  "tags.kind.label": "Bu etiketi kim görür",
  "tags.kind.personal": "Kişisel",
  "tags.kind.team": "Ekip",
  "tags.kind.personal_help": "Yalnızca siz görürsünüz",
  "tags.kind.team_help": "Bu dosyayı görebilen ekibindeki herkes görür",
  "tags.kind.team_locked": "Ekip etiketi eklemek ya da kaldırmak için bu dosyada düzenleme yetkiniz olmalı.",
  "tags.chip.personal": "Kişisel etiket “{tag}” - yalnızca siz görürsünüz",
  "tags.chip.team": "Ekip etiketi “{tag}” - bu dosyayı görebilen ekibindeki herkes görür",
  "tags.add_submit": "Ekle",
  "inspector.section.versions": "Sürümler",
  "inspector.section.permissions": "İzinler",
  "inspector.section.shares": "Paylaşımlar",
  "inspector.path": "Yol",
  "inspector.size": "Boyut",
  "inspector.modified": "Değiştirilme",
  "inspector.mime": "MIME türü",
  "inspector.etag": "ETag",
  "inspector.nodeId": "Düğüm kimliği",
  "inspector.copy": "Kopyala",
  "inspector.copied": "Kopyalandı",
  "inspector.error": "Yüklenemedi",
  "inspector.items_summary": "{n} öğe, toplam {size}",
  "inspector.items_summary_one": "{n} öğe, toplam {size}",
  "inspector.folder_items": "{n} öğe",
  "inspector.folder_items_one": "{n} öğe",
  "inspector.versions.empty": "Sürüm geçmişi yok",
  "inspector.versions.v": "Sürüm {n}",
  "inspector.versions.restore": "Geri yükle",
  "inspector.versions.restore_confirm": "Bu sürüm geri yüklensin mi?",
  "inspector.versions.snapshot_current": "Önce şimdiki halin sürümünü al",
  "inspector.versions.confirm": "Onayla",
  "inspector.versions.restoring": "Geri yükleniyor…",
  "inspector.versions.cancel": "Vazgeç",
  "inspector.versions.take_snapshot": "Şimdiki halin sürümünü al",
  "inspector.versions.snapshotting": "Sürüm alınıyor…",
  "inspector.versions.restored": "Sürüm geri yüklendi",
  "inspector.versions.snapshotted": "Sürüm alındı",
  "inspector.versions.unsupported": "Sunucu bu işlemi desteklemiyor",
  "inspector.perm.none": "Erişim yok",
  "inspector.perm.viewer": "Görüntüleyen",
  "inspector.perm.editor": "Düzenleyen",
  "inspector.perm.owner": "Sahip",
  "inspector.perm.manage": "İzinleri yönet",
  "inspector.shares.empty": "Paylaşım bağlantısı yok",
  "inspector.shares.copy": "Bağlantıyı kopyala",
  /* wiring:c1 - tema galerisi */
  "theme.menu": "Tema",
  "theme.title": "Tema galerisi",
  "theme.hint": "Tema yalnız renk paletini değiştirir; gündüz mü gece mi olduğu yukarıdaki seçim.",
  "theme.mode.label": "Görünüm",
  "theme.mode.light": "Gündüz",
  "theme.mode.dark": "Gece",
  "theme.mode.auto": "Otomatik",
  "theme.reset": "Varsayılana dön",
  "theme.close": "Kapat",
  "theme.selected": "Seçili",
  "theme.name.default": "Varsayılan",
  "theme.name.night": "Gece mavisi",
  "theme.name.forest": "Orman",
  "theme.name.amber": "Kehribar",
  "theme.name.lilac": "Leylak",
  "theme.name.contrast": "Yüksek kontrast",
  "theme.name.gray": "Yumuşak gri",
  "theme.name.terminal": "Terminal yeşili",
  /* === zaman:z3 - saat dilimi seçici (gömme penceresi + web ayarları) === */
  "tz.menu": "Saat dilimi",
  "tz.title": "Saat dilimi",
  "tz.label": "Tarihleri şu saatle göster",
  "tz.search": "Şehir, ülke ya da saat farkı arayın - “İstanbul” veya “GMT+3” deneyin",
  "tz.default.device": "Bu cihazın saat dilimini kullan ({zone})",
  "tz.default.account": "Hesabınızın saat dilimini kullan ({zone})",
  "tz.default.host": "Bu sitenin varsayılanını kullan ({zone})",
  "tz.no_match": "“{query}” ile eşleşen saat dilimi yok. Bir şehir, bir ülke ya da GMT+3 gibi bir fark deneyin.",
  "tz.more": "{n} kayıt daha var - listeyi daraltmak için yazmayı sürdürün.",
  "tz.hint": "Yalnızca bu tarayıcıda saklanır. Her tarih tek bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir.",
  "tz.now": "{zone} bölgesinde şu an: {time}",
  /* === wiring:c2 - özelleştirilebilir kısayollar + hızlı bakış === */
  "shortcuts.quicklook": "Hızlı bakış",
  "shortcuts.customize": "Özelleştir",
  "shortcuts.settings.menu": "Kısayollar",
  "shortcuts.settings.title": "Kısayol ayarları",
  "shortcuts.settings.hint": 'Bir kısayolu değiştirmek için "Değiştir"e basıp yeni tuş kombinasyonuna basın. Değişiklikler yalnızca bu tarayıcıda saklanır.',
  "shortcuts.settings.change": "Değiştir",
  "shortcuts.settings.capture": "Tuşlara basın… (Esc iptal)",
  "shortcuts.settings.reset": "Varsayılana dön",
  "shortcuts.settings.reset_all": "Tümünü sıfırla",
  "shortcuts.settings.unbound": "Atanmadı",
  "shortcuts.settings.fixed": "Sabit",
  "shortcuts.settings.customized": "Özelleştirildi",
  "shortcuts.settings.conflict": 'kombinasyonu "{name}" kısayolunda kullanılıyor.',
  "shortcuts.settings.conflict_fixed": 'kombinasyonu "{name}" sabit kısayoluna ayrılmış - kullanılamaz.',
  "shortcuts.settings.conflict_take": "Eskisini boşa çıkar ve ata",
  "shortcuts.settings.conflict_cancel": "Vazgeç",
  "quicklook.hint_close": "kapat",
  "quicklook.hint_nav": "önceki/sonraki",
  "quicklook.hint_open": "aç",
  /* === /wiring:c2 === */
  /* === wiring:c3 - işlem merkezi === */
  "opc.title": "İşlemler",
  "opc.aria_badge": "{n} işlem - işlem merkezini aç/kapat",
  "opc.aria_badge_one": "{n} işlem - işlem merkezini aç/kapat",
  "opc.close": "Kapat",
  "opc.active": "Sürüyor",
  "opc.history": "Geçmiş",
  "opc.clear": "Temizle",
  "opc.empty": "İşlem yok",
  "opc.cancel": "İptal",
  "opc.retry": "Yeniden dene",
  "opc.dismiss": "Kapat",
  "opc.queued": "Sırada",
  "opc.cancelling": "İptal isteniyor…",
  "opc.percent": "%{n}",
  "opc.items": "{total} öğeden {done}",
  "opc.trash_items": "Çöpten {n} öğe",
  "opc.trash_items_one": "Çöpten {n} öğe",
  "opc.status.running": "Sürüyor",
  "opc.status.done": "Bitti",
  "opc.status.error": "Hata",
  "opc.status.aborted": "İptal edildi",
  "opc.kind.upload": "Yükleme",
  "opc.kind.copy": "Kopyalama",
  "opc.kind.move": "Taşıma",
  "opc.kind.delete": "Silme",
  "opc.kind.rename": "Yeniden adlandırma",
  "opc.kind.restore": "Geri getirme",
  "opc.kind.purge": "Kalıcı silme",
  "opc.kind.convert": "Dönüştürme",
  "opc.kind.archive": "Arşiv",
  "opc.kind.plugin": "Uygulama",
  "opc.kind.trash": "Çöp kutusunu boşaltma",
  "opc.kind.thumbs": "Küçük resim onarımı",
  /* A folder's contents on hover (FolderPeek, useFolderPeek). */
  "peek.items": "{n} öğe",
  "peek.items_one": "{n} öğe",
  "peek.more": "+{n} tane daha",
  "peek.empty": "Boş",
  "peek.loading": "İçine bakılıyor…",
  "opc.open": "Aç",
  /* Uygulama eklentileri - dosya menüsüne eklenen satırlar ve kuyruğa
     aldıkları işler (docs/APP-PLUGINS-API.md). */
  "plugin.queued": "{label} kuyruğa alındı",
  "plugin.done": "{label} tamamlandı",
  "plugin.failed": "{label} başarısız",
  "plugin.cancel_failed": "İş iptal edilemedi",
  "plugin.not_applicable": "Bu işlem seçime uygulanamaz",
  "plugin.needs_engine": "{name} bu sunucuda kurulu değil - sunucuya kurup filex'i yeniden başlatın.",
  "plugin.needs_other": "{name} bu sunucuda kullanılamıyor.",
  "plugin.needs_office": "Ofis belgeleri için bir ofis motoru gerekiyor ve bu sunucuda çalışan yok - Ofis düzenleyici uygulamasını kurun (Uygulamalar) ya da Dış servisler sayfasından {name} bağlayın.",
  "plugin.confirm.title": "Onayla",
  "plugin.confirm.cancel": "Vazgeç",
  "plugin.confirm.run": "Çalıştır",
  "plugin.view.close": "Kapat",
  "appframe.confirm_title": "Onay",
  "appframe.consent_clipboard": "{app} panonuza metin kopyalamak istiyor.",
  "appframe.consent_download": "{app}, “{name}” dosyasını bilgisayarınıza kaydetmek istiyor.",
  "appframe.consent_print": "{app}, “{name}” belgesini yazdırmak istiyor.",
  "appframe.consent_job": "{app} “{action}” işini başlatmak istiyor.",
  "appframe.consent_allow": "İzin ver",
  "appframe.consent_deny": "İzin verme",
  "appframe.unsaved_title": "Kaydedilmemiş değişiklikler",
  "appframe.state_no_account": "Uygulamanın şifreli bir dosya için ayarları, oturum açtığınız hesaba göre mühürlenerek saklanır; bu sayfa hangi hesap olduğunu öğrenemedi, bu yüzden hiçbir şey saklanmadı. Yeniden oturum açın ya da dosyayı oturum açtığınız yerde açın.",
  "appframe.unsaved_text": "{app} içinde kaydedilmemiş değişiklikler var. Yine de kapatılsın mı?",
  "appframe.discard": "Kaydetmeden kapat",
  "appframe.keep_open": "Düzenlemeye devam et",
  "appframe.save_close": "Kaydet ve kapat",
  "appframe.updated": "{app}, {version} sürümüne güncellendi.",
  "appframe.updated_reload": "Bir yönetici {app} uygulamasının yeni sürümünü onayladı. Yeni sürümü kullanmak için yeniden yükleyin - önce çalışmanızı kaydedin.",
  "appframe.reload": "Yeniden yükle",
  "appframe.dismiss": "Kapat",
  "appframe.not_connected": "{app} başlamadı. Kapatıp yeniden açın; tekrar ederse yöneticinize haber verin.",
  "appframe.save_as_title": "{app}: “{name}” nereye kaydedilsin?",
  "plugin.view.busy": "Çalışıyor…",
  "plugin.view.unsupported": "Bu ekran, bu sürümün çizemediği bir bileşen kullanıyor ({type})",
  "plugin.view.error": "Uygulama hata döndürdü",
  "plugin.output_missing": "Çıktı artık eski yerinde değil",
  /* M2 - surface components (components/plugin/nodes/*) */
  "plugin.view.loading": "Yükleniyor…",
  "plugin.view.preview_failed": "Önizleme yüklenemedi",
  "plugin.steps.label": "Adımlar",
  "plugin.list.empty": "Henüz bir şey yok",
  "plugin.list.actions": "İşlemler",
  /* The label on a table row's ONE action control (core RowActions.vue).
     The explorer's handle is the ⋮ glyph; a panel row's says what it is.
     Owner, 2026-09-20: "adminde 'Aksiyon' diye yazmalı". */
  "row.actions": "Aksiyon",
  "plugin.people.placeholder": "Ad veya e-posta",
  "plugin.people.placeholder_email": "E-posta adresi",
  "plugin.people.add": "Ekle",
  "plugin.people.remove": "{name} kişisini kaldır",
  "plugin.people.invalid_email": "Geçerli bir e-posta adresi girin",
  "plugin.people.external_off": "Yalnızca hesabı olan kişiler eklenebilir",
  "plugin.pin.label": "PIN",
  "plugin.file.choose": "Seç…",
  "plugin.file.clear": "Temizle",
  "plugin.file.none": "Seçim yok",
  /* M3 - imza yolu: signature-pad + pdf-fields düğümleri ve dış katılımcının
     herkese açık sayfası (views/PublicSurface.vue, usePublicPage). */
  "plugin.sig.mode_draw": "Çiz",
  "plugin.sig.mode_type": "Yaz",
  "plugin.sig.mode_upload": "Yükle",
  "plugin.sig.draw_hint": "Parmağınızla ya da fareyle buraya imzalayın",
  "plugin.sig.type_placeholder": "Adınızı yazın",
  "plugin.sig.upload_pick": "Görsel seç…",
  "plugin.sig.upload_hint": "PNG ya da JPEG, en çok {kb} KB",
  "plugin.sig.upload_too_big": "Görsel {kb} KB sınırından büyük",
  "plugin.sig.upload_bad_type": "Yalnızca PNG ya da JPEG görsel kullanılabilir",
  "plugin.sig.upload_unreadable": "Görsel okunamadı",
  "plugin.sig.clear": "İmzayı temizle",
  "plugin.sig.signed": "İmza alındı",
  "plugin.pdf.load_failed": "Belge yüklenemedi",
  "plugin.pdf.palette": "Alan türleri",
  "plugin.pdf.pending": "Yeri bekleyen kutular",
  "plugin.pdf.place_box_hint": "“{name}” kutusunun gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.all_placed": "Her kutunun bir yeri var",
  "plugin.pdf.place_idle": "Yukarıdaki kutulardan birini seçin, sonra sayfada gideceği yere dokunun.",
  "plugin.pdf.place_idle_done": "Kaldırmak ya da kopyalamak için sayfadaki bir kutuya dokunun; taşımak için sürükleyin.",
  "plugin.pdf.no_boxes": "Henüz kutu yok. Aşağıdan ekleyin: adını verin, kimin olduğunu söyleyin; yerini bir sonraki adımda belgede seçeceksiniz.",
  "plugin.pdf.add_box": "Kutu ekle",
  "plugin.pdf.unplace": "Sayfadan kaldır",
  "plugin.pdf.place_hint": "{type} alanının gideceği yere dokunun ya da boyutlandırmak için sürükleyin",
  "plugin.pdf.type_signature": "İmza",
  "plugin.pdf.type_initials": "Paraf",
  "plugin.pdf.type_date": "Tarih",
  "plugin.pdf.type_text": "Metin",
  "plugin.pdf.type_checkbox": "Onay kutusu",
  "plugin.pdf.tap_signature": "İmzalamak için dokunun",
  "plugin.pdf.tap_initials": "Paraflamak için dokunun",
  "plugin.pdf.tap_date": "Bugünün tarihi için dokunun",
  "plugin.pdf.tap_text": "Metin",
  "plugin.pdf.tap_checkbox": "İşaretlemek için dokunun",
  "plugin.pdf.label": "Ad",
  "plugin.pdf.assignee": "İmzacı",
  "plugin.pdf.unassigned": "Herkes",
  "plugin.pdf.filled_by": "Dolduran",
  "plugin.pdf.style": "Nasıl imzalanır",
  "plugin.pdf.style_drawn": "Çizerek",
  "plugin.pdf.style_typed": "Yazarak",
  "plugin.pdf.lines": "Altına yazılanlar",
  "plugin.pdf.lines_preview": "İmzanın altında:",
  "plugin.pdf.lines_none": "Bu imzanın altına bir şey yazılmaz.",
  "plugin.pdf.required": "Zorunlu",
  "plugin.pdf.copy_to_page": "Sayfaya kopyala",
  "plugin.pdf.copy": "Kopyala",
  "plugin.pdf.delete": "Alanı sil",
  "plugin.pdf.zoom_in": "Yakınlaştır",
  "plugin.pdf.zoom_out": "Uzaklaştır",
  "plugin.pdf.zoom_fit": "Genişliğe sığdır",
  "plugin.pdf.zoom_fit_page": "Sayfayı ekrana sığdır",
  "plugin.pdf.pad_for": "{type} alanınız",
  "plugin.pdf.pad_done": "Tamam",
  "plugin.page.loading": "Yükleniyor…",
  "plugin.page.pin_title": "Bu sayfa korumalı",
  "plugin.page.pin_hint": "Devam etmek için size verilen PIN'i girin",
  "plugin.page.pin_submit": "Devam et",
  "plugin.page.pin_wrong": "Bu PIN doğru değil",
  "plugin.page.pin_locked": "Çok fazla yanlış PIN girildi - birkaç dakika bekleyip yeniden deneyin",
  "plugin.page.unavailable_title": "Bu bağlantı kullanılamıyor",
  "plugin.page.unavailable_text": "Süresi dolmuş, hakkı tükenmiş ya da geri çekilmiş olabilir. Gönderen kişiden yeni bir bağlantı isteyin.",
  "plugin.page.accepted_title": "Alındı, teşekkürler",
  "plugin.page.accepted_text": "Yanıtınız kaydedildi. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.done_title": "Tamamlandı",
  "plugin.page.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sayfayı kapatabilirsiniz.",
  "plugin.page.error_title": "Bir sorun oluştu",
  "plugin.page.retry": "Yeniden dene",
  "plugin.page.files": "Belgeler",
  "plugin.page.open_file": "{name} dosyasını yeni sekmede aç",
  "plugin.page.footer": "filex ile sunuldu",
  /* Herkese açık sayfaların (paylaşım, dosya isteği) kendi cümleleri
     sunucunundur: `server.public.*` (composables/usePublicText). */
  /* === Uygulama eklentileri v2 - `page` görünümü, uygulamanın dosya kilidi,
     işin yazdığı çıktı kipi, imza alanının yazı tipleri ve kuralları. === */
  "plugin.page_view.back": "Dosyalara dön",
  "plugin.page_view.queued_title": "İş kuyruğa alındı",
  "plugin.page_view.queued_text": "filex işi yürütüyor. Bittiğinde bu sayfa söyler; ilerleyişi işlemler tepsisinde de görünür.",
  "plugin.page_view.finished_title": "İş bitti",
  "plugin.page_view.finished_text": "Burada yapılacak başka bir şey kalmadı. Dosyalara dönebilir ya da bu sekmeyi kapatabilirsiniz.",
  "plugin.page_view.failed_title": "İş tamamlanamadı",
  "plugin.page_view.opening_title": "Sonuç açılıyor",
  "plugin.page_view.open_ops": "İşlemler tepsisini aç",
  "plugin.page_view.done_title": "Tamamlandı",
  "plugin.page_view.done_text": "Burada yapılacak başka bir şey kalmadı. Bu sekmeyi kapatabilirsiniz.",
  "plugin.page_view.error_title": "Bu ekran açılamadı",
  "plugin.page_view.retry": "Yeniden dene",
  "plugin.page_view.blocked": "Yeni sekme engellendi - bu site için açılır pencerelere izin verin, yoksa ekran pencere içinde açılır",
  "plugin.output.sibling": "yeni dosya",
  "plugin.output.version": "yeni sürüm",
  "plugin.output.sibling_title": "Sonuç, aslının yanına yeni bir dosya olarak iner",
  "plugin.output.version_title": "Sonuç, dosyanın yerine yeni bir sürümü olarak geçer",
  "plugin.sign.font_label": "El yazısı",
  "plugin.pdf.font": "Yazı tipi",
  "plugin.pdf.rule_number": "Yalnızca sayı",
  "plugin.pdf.rule_email": "E-posta adresi",
  "plugin.pdf.rule_length": "{min} ile {max} karakter arasında",
  "plugin.pdf.rule_min": "En az {min} karakter",
  "plugin.pdf.rule_max": "En çok {max} karakter",
  "plugin.pdf.err_number": "Bir sayı girin",
  "plugin.pdf.err_email": "Geçerli bir e-posta adresi girin",
  "plugin.pdf.err_min": "Çok kısa - en az {min} karakter",
  "plugin.pdf.err_max": "Çok uzun - en çok {max} karakter",
  "applock.badge": "Kilitli",
  "applock.some_app": "bir uygulama",
  "applock.held": "{app} bu dosyayı kilitledi",
  "applock.held_reason": "{app} bu dosyayı kilitledi: {reason}",
  "applock.until": "- {date} tarihine kadar",
  "applock.inspector": "Uygulama kilidi",
  /* issue #34 - sunucunun İZLEMEDİĞİ sembolik bağ (lib/symlink). Rozet satırdaki
     kısa söz; `why` ise arkasındaki cümle - üzerine gelince, ayrıntılar panelinde
     ve biri açmaya kalkıştığında çıkan bildirimde. ⚠ Kırık bağ ile depo dışına
     çıkan bağ AYRI durumlardır ve ayrı okunmalıdır: yalnızca birinin yönetici
     çaresi vardır; silinmiş bir hedef için o çareyi önermek insanı işe yaramayacak
     bir ayar ekranına yollar. */
  "symlink.badge.outside_root": "Depo dışında",
  "symlink.badge.broken": "Kırık bağ",
  "symlink.badge.unresolved": "Uzak bağ",
  "symlink.badge.unknown": "Bağlantı",
  "symlink.why.outside_root": 'Hedefi bu deponun dışında kalan bir bağ; bu yüzden açılamıyor. Bir yönetici, deponun ayarlarındaki "Bu klasörün dışına çıkan sembolik bağları izle" seçeneğiyle buna izin verebilir.',
  "symlink.why.broken": "Hedefi artık var olmayan bir bağ; açılacak bir şey yok. Sunucuda onarılması ya da kaldırılması gerekir - hiçbir ayar silinmiş hedefi geri getirmez.",
  "symlink.why.unresolved": "Uzak sunucudaki bir bağ. filex hedefinin bu deponun içinde olup olmadığını bilemediği için bağı izlemez ve açamaz.",
  "symlink.why.unknown": "filex'in izlemediği bir bağ, bu yüzden açılamıyor. Hedefi ya bu deponun dışında, ya kayıp, ya da filex'in çözümleyemediği uzak bir sunucuda.",
  "symlink.inspector": "Açılamayan bir bağ",
  "unavailable.why.file": "Depo bu dosyanın hâlâ var olup olmadığını söyleyemedi. Depo yeniden yanıt verene kadar dosya açılamaz ve değiştirilemez; bir sonraki tarama yeniden denetler.",
  "unavailable.why.dir": "Depo bu klasörün hâlâ var olup olmadığını söyleyemedi. Depo yeniden yanıt verene kadar ne klasör ne de içindekiler açılabilir ya da değiştirilebilir; bir sonraki tarama yeniden denetler.",
  "unavailable.withReason": "{why} Deponun yanıtı: {reason}",
  "unavailable.inspector": "Kullanılamıyor",
  /* 0.50 - why a file has no thumbnail, on the file itself (lib/thumbNote). */
  "thumbNote.corrupt": "Bozuk",
  "thumbNote.corrupt_why": "Küçük resim yok: dosya okunamadı. Bozuk ya da eksik olabilir.",
  "thumbNote.encrypted": "Şifreli",
  "thumbNote.encrypted_why": "Küçük resim yok: dosya şifreli ya da parolayla korunuyor.",
  "thumbNote.too_large": "Çok büyük",
  "thumbNote.too_large_why": "Küçük resim yok: dosya, küçük resim boyut sınırından büyük.",
  "thumbNote.full": "{label}. {why}",
  "plugin.pdf.rule": "Kabul ettiği",
  "plugin.pdf.rule_kind_any": "Serbest metin",
  "plugin.pdf.rule_kind_number": "Yalnızca sayı",
  "plugin.pdf.rule_kind_email": "E-posta adresi",
  "plugin.pdf.rule_min_label": "En az uzunluk",
  "plugin.pdf.rule_max_label": "En çok uzunluk",
  "plugin.pdf.format": "Tarih biçimi",
  "plugin.pdf.date_order": "Tarih sırası",
  "plugin.pdf.date_separator": "Ayraç",
  "plugin.pdf.date_example": "Örnek",
  "opc.kind.archive-create": "Arşiv oluşturuluyor",
  "opc.kind.archive-extract": "Arşiv çıkarılıyor",
  /* === wiring:c4 - onboarding turu + erişilebilirlik + hata kartı === */
  "tour.aria": "Tanıtım turu",
  "tour.restart": "Turu tekrar başlat",
  "tour.skip": "Turu atla",
  "tour.back": "Geri",
  "tour.next": "İleri",
  "tour.done": "Bitti",
  "tour.progress": "{n} / {m}",
  "tour.step.nav.title": "Depolar ve görünümler",
  "tour.step.nav.desc": "Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu hep bu panelde durur; altında da depolarınız ve bağlantılarınız. Sol üst köşedeki düğme paneli ince bir şeride indirir ve geri açar.",
  "tour.step.nav.desc_closed": "Bu düğme gezinti panelini açar: Ana sayfa, Benimle paylaşılanlar, Son kullanılanlar, Yıldızlılar ve Çöp kutusu; altında da depolarınız ve bağlantılarınız.",
  "tour.step.new.title": "Yeni bir şey ekle",
  "tour.step.new.desc": "Yeni olan her şey buradan başlar: bu cihazdan dosya yükleyebilir, klasör oluşturabilir ya da birinden dosya isteyebilirsiniz. Dosyaları pencereye sürükleyip bırakmak da yükler.",
  "tour.step.new.desc_fab": "Bu düğme bu cihazdan dosya yükler. Dosyaları pencereye sürükleyip bırakmak da çalışır.",
  "tour.step.search.title": "Arama",
  "tour.step.search.desc": 'Bu alan deponun tamamında ada göre arar; ayraçları ve bir harflik yazım hatasını affeder, yani "fatura 2026" yazdığınızda fatura_2026.pdf gelir. tag:fatura yazarak etikete göre filtreleyebilirsiniz. Yanındaki sürgü düğmesi gelişmiş aramayı, {palette} ise komut paletini açar; palet komut da çalıştırır.',
  "tour.step.crumb.title": "Bulunduğunuz yer",
  "tour.step.crumb.desc": "Bu iz, ekrandaki klasörün adresidir. Adımlardan birine tıklayarak üste çıkabilir, sonuncusunun yanındaki oktan içindeki klasörleri görebilirsiniz.",
  "tour.step.filters.title": "Listeyi daralt",
  "tour.step.filters.desc": "Tür, Sahibi, Değiştirilme ve Boyut bulunduğunuz klasörü filtreler; yanındaki kutu siz yazdıkça adlara göre eşleşir, satırın sonundaki denetim ise sıralar.",
  "tour.step.view.title": "Görünümü değiştir",
  "tour.step.view.desc": "Bu klasörün nasıl çizildiğini değiştirir; seçiminiz hatırlanır.",
  "tour.step.details.title": "Ayrıntılar ve paylaşım",
  "tour.step.details.desc": 'Bir dosyayı seçip bu paneli açtığınızda ayrıntılarını, hareketlerini ve paylaşım bağlantılarını görürsünüz. Tam menü için dosyaya sağ tıklayın ya da satırının sonundaki düğmeyi kullanın: oradaki "Paylaş" ile PIN ve son kullanma süresi verilebilen bir bağlantı oluşturulur.',
  "tour.step.help.title": "Kısayollar",
  "tour.step.help.desc": '{help} tuşu kısayol kartını, {palette} komut paletini açar. Tema ve "Turu tekrar başlat" sağ üstteki "Diğer işlemler" menüsünde; hesabınız ve oturumu kapatma ise yanındaki avatarın arkasında.',
  "error.hint": "Bağlantı ya da sunucu kaynaklı geçici bir sorun olabilir. Yeniden deneyin.",
  "error.details": "Teknik ayrıntılar",
  "col.star": "Yıldız",
  "toolbar.view_label": "Görünüm",
  "list.aria": "Dosya listesi",
  "grid.aria": "Dosya ızgarası",
  /* === wiring:d1 - sekmeler + split panel === */
  "tabs.strip": "Sekmeler",
  "tabs.new": "Yeni sekme",
  "tabs.close": "Sekmeyi kapat",
  "tabs.split": "Görünümü böl",
  "tabs.split_off": "Bölmeyi kapat",
  "ctx.open_new_tab": "Yeni sekmede aç",
  "ctx.open_with": "{app} ile aç",
  "ctx.open_with_builtin": "Yerleşik görüntüleyiciyle aç",
  "ctx.open_with_choose": "Uygulama seç…",
  "openWith.title": "Birlikte aç",
  "openWith.lead": "{name} hangi uygulamayla açılsın?",
  "openWith.builtin": "filex görüntüleyicisi (yerleşik)",
  "openWith.onlyoffice": "ONLYOFFICE (tablo düzenleyici)",
  "openWith.now": "Şu an bununla açılıyor",
  "openWith.always": "{ext} dosyalarını her zaman bu uygulamayla aç",
  "openWith.hint": "Hesabınızda saklanır. Ayarlar, Varsayılan uygulamalar bölümünden değiştirebilirsiniz.",
  "openWith.open": "Aç",
  "shortcuts.group.tabs": "Sekmeler",
  "shortcuts.tab_new": "Yeni sekme",
  "shortcuts.tab_close": "Sekmeyi kapat",
  "shortcuts.tab_next": "Sonraki sekme",
  "shortcuts.tab_prev": "Önceki sekme",
  /* tus:t1 - menü fiilleri */
  "shortcuts.new_folder": "Yeni klasör",
  "shortcuts.upload": "Dosya yükle",
  "shortcuts.refresh": "Listeyi yenile",
  "shortcuts.download": "İndir",
  "shortcuts.preview": "Önizle",
  "shortcuts.share": "Paylaş",
  "shortcuts.tags": "Etiketler",
  "shortcuts.open_tab": "Yeni sekmede aç",
  "shortcuts.copy_path": "Yolu kopyala",
  "shortcuts.copy_id": "Kimliği kopyala",
  "shortcuts.restore": "Çöp kutusundan geri al",
  "shortcuts.settings.reserved": "tarayıcı tarafından sayfaya ulaşmadan yakalanıyor, burada hiçbir şey yapmaz. Başka bir tuş seçin.",
  "shortcuts.settings.reserved_badge": "Yalnız masaüstü uygulamasında",
  "shortcuts.settings.reserved_title": "Bu kombinasyonu tarayıcının kendisi işliyor. Masaüstü uygulamasında ve kurulu PWA’da çalışır, tarayıcı sekmesinde çalışmaz.",
  "cmd.tab_new": "Yeni sekme aç",
  "cmd.split_toggle": "Görünümü böl / birleştir",
  "split.pane": "İkincil panel",
  "split.close": "Yan paneli kapat",
  "split.error": "Liste yüklenemedi",
  "split.retry": "Yeniden dene",
  "split.copy_queued": "Kopyalama kuyruğa alındı",
  "split.move_queued": "Taşıma kuyruğa alındı",
  "toast.move_kept_both": "Taşıma kuyruğa alındı. Hedefte aynı adla bir öğe vardı, taşınan öğe onun yanına “-copy” ekiyle konacak. Bu taşıma geri alınamaz.",
  "split.cross_copy": "Depolar farklı - kopyalama kuyruğa alındı",
  "dragout.downloading": "Bırakılan klasöre indiriliyor…",
  "dragout.downloading_n": "Bırakılan klasöre indiriliyor - şimdiye dek {n} dosya…",
  "dragout.downloading_n_one": "Bırakılan klasöre indiriliyor - şimdiye dek {n} dosya…",
  "dragout.stop": "Durdur",
  "dragout.stopping": "Durduruluyor…",
  "dragout.stopped": "Durduruldu - gelenler klasörde kalıyor",
  "dragout.not_found": "Bırakılan yer bulunamadı - dosya bir klasöre değil bir uygulamaya bırakıldıysa indirme yapılamaz",
  "dragout.done": "İndirme tamamlandı",
  "dragout.ready": "Dosyalar hazır - masaüstüne sürükleyebilirsiniz",
  "dragout.preparing": "Sürükleme için hazırlanıyor…",
  "split.cross_move": "Depolar farklı - taşıma kuyruğa alındı (baytlar aktarılıp kaynak silinir)",
  /* === /wiring:d1 === */
  /* wiring:d2 - galeri görünümü */
  "toolbar.view.gallery": "Galeri",
  "gallery.aria": "Dosya galerisi",
  /* /wiring:d2 */
  /* wiring:d3 - Yorumlar (inspector node comments) */
  "inspector.section.comments": "Yorumlar",
  "inspector.comments.empty": "Henüz yorum yok.",
  "inspector.comments.placeholder": "Yorum yaz…",
  "inspector.comments.send": "Gönder",
  "inspector.comments.delete": "Yorumu sil",
  /* wiring:e2 - uçtan uca şifreli klasörler */
  "e2e.create.title": "Şifreli klasör oluştur",
  "e2e.create.option": "Şifreli klasör oluştur…",
  "e2e.create.pw_label": "Klasör parolası",
  "e2e.create.pw_placeholder": "En az 8 karakter",
  "e2e.create.pw2_label": "Parolayı tekrar girin",
  "e2e.create.warn_title": "GERİ DÖNÜŞÜ YOK",
  "e2e.create.warn_body": "Bu klasördeki dosyalar yalnız bu parolayla ya da klasör oluşturulurken bir kez gösterilen kurtarma anahtarıyla açılır. Parola sunucuda TUTULMAZ; kurtarma anahtarının da filex'te kopyası kalmaz. İkisini de kaybederseniz içerik sonsuza dek gider.",
  "e2e.create.ack": "Anladım: parolayı da kurtarma anahtarını da kaybedersem verilerim kurtarılamaz.",
  "e2e.create.ack_required": "Devam etmek için uyarıyı onaylayın.",
  "e2e.create.pw_short": "Parola en az 8 karakter olmalı.",
  "e2e.create.pw_mismatch": "Parolalar birbirini tutmuyor.",
  "e2e.create.bad_name": "Geçersiz klasör adı.",
  "e2e.create.create": "Şifreli klasörü oluştur",
  "e2e.create.busy": "Oluşturuluyor…",
  "e2e.create.done": "Şifreli klasör oluşturuldu",
  "e2e.create.failed": "Şifreli klasör oluşturulamadı",
  "e2e.create.nested": "Şifreli klasörün içine ikinci bir şifreli klasör açılamaz.",
  /* wiring:e2 policy - bir yöneticiden şifreleme izni istemek. */
  "e2e.request.ctx": "Şifreleme iste…",
  "e2e.request.option": "Şifreli klasör iste…",
  "e2e.request.title": "“{name}” için şifreleme iste",
  "e2e.request.lead": "Burada şifreli klasör oluşturmak için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu klasör içindir: hemen içinde yeni bir şifreli klasör oluşturmak için bir kez kullanılabilir.",
  "e2e.request.lead_folder": "Bu klasörü şifrelemek için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu klasör içindir: bu klasörü olduğu yerde şifrelemek için bir kez kullanılabilir, içindeki bir klasör için kullanılamaz.",
  "e2e.request.lead_file": "Bu dosyayı şifrelemek için yönetici onayı gerekiyor. Neden gerektiğini yazın; yanıt size bildirilir. Onay sizin ve bu dosyanın bulunduğu klasör içindir: orada yeni bir şifreli dosya için bir kez kullanılabilir.",
  "e2e.request.reason": "Gerekçe",
  "e2e.request.reason_placeholder": "İçinde ne var, neden şifrelenmesi gerekiyor",
  "e2e.request.reason_required": "Yönetici için bir gerekçe yazın.",
  "e2e.request.send": "İsteği gönder",
  "e2e.request.sending": "Gönderiliyor…",
  "e2e.request.sent": "İstek gönderildi. Bir yönetici yanıtladığında size bildirilecek.",
  "e2e.request.already": "Bunu zaten istediniz; bir yöneticinin yanıtını bekliyor.",
  "e2e.request.failed": "İstek gönderilemedi.",
  "e2e.locked.title": "Bu klasör uçtan uca şifreli",
  "e2e.locked.hint": "İçeriği görmek için klasör parolasını girin. Parola yalnız bu sekmede, bellekte tutulur.",
  "e2e.locked.pw_placeholder": "Klasör parolası",
  "e2e.locked.unlock": "Kilidi aç",
  "e2e.locked.busy": "Doğrulanıyor…",
  "e2e.unlock.wrong": "Parola yanlış.",
  "e2e.unlock.damaged": "Parola doğru ama anahtar dosyasındaki (.filex-e2e.json) klasör anahtarı açılmıyor: dosya bozulmuş. Kurtarma anahtarını deneyin.",
  "e2e.unlock.marker_missing": "Anahtar dosyası (.filex-e2e.json) okunamadı.",
  /* ikon:emoji - listedeki işaretin erişilebilir adı. Satır eskiden yalnız
     bir 🔒 basıyordu; onun yerini alan asma kilit kutunun içinde
     aria-hidden, dolayısıyla adı taşıyan yer bu. */
  "e2e.badge": "Şifreli klasör",
  "e2e.strip.label": "Şifreli klasör - kilit açık",
  "e2e.strip.lock": "Kilitle",
  /* wiring:e2 password - klasör parolasını değiştirme */
  "e2e.password.strip_action": "Parolayı değiştir…",
  "e2e.password.title": "Klasör parolasını değiştir",
  "e2e.password.reset_title": "Bu klasör için yeni bir parola belirleyin",
  "e2e.password.reset_lead": "Bu klasörü kurtarma anahtarıyla açtınız; parolası kaybolmuş ya da başkası tarafından biliniyor olabilir. Şimdi yeni bir parola belirleyin. Bu pencereyi kapatmak klasörü yeniden kilitler.",
  "e2e.password.current": "Mevcut parola",
  "e2e.password.recovery": "Kurtarma anahtarı",
  "e2e.password.use_recovery": "Hatırlamıyorum - kurtarma anahtarını kullan",
  "e2e.password.use_current": "Bunun yerine mevcut parolayı kullan",
  "e2e.password.new": "Yeni parola",
  "e2e.password.current_required": "Mevcut parolayı girin ya da kurtarma anahtarını kullanın.",
  "e2e.password.bad_recovery": "Bu bir kurtarma anahtarı değil (dörderli gruplar hâlinde 32 karakter).",
  "e2e.password.same": "Yeni parola mevcut parolayla aynı.",
  "e2e.password.cheap_note": "Yalnız klasörün anahtar dosyası değişir. Hiçbir dosya yeniden şifrelenmez; kurtarma anahtarı ve varsa emanet anahtarı çalışmaya devam eder.",
  "e2e.password.old_copies": "Eski parolayı bilen ve anahtar dosyasının eski bir kopyasına (bir sürüm, bir yedek) sahip olan biri klasörü onunla hâlâ açabilir. Bu bir risk ise “Klasör anahtarını da değiştir”i işaretleyin.",
  "e2e.password.rotate_label": "Klasör anahtarını da değiştir (her dosyanın anahtarı yeniden sarılır; eski parola başkasınca biliniyor olabilirse kullanın)",
  "e2e.password.rekey_title": "Bu klasör v0.31 öncesinden: anahtarı parolasından türetiliyor",
  "e2e.password.rekey_body": "Bu yüzden yeni bir parola yeni bir klasör anahtarı gerektirir ve klasördeki her dosyanın anahtarı onunla yeniden sarılır. İçerik yeniden şifrelenmez. Biraz sürebilir; yarıda kalırsa kaldığı yerden devam eder, dosyalar bu sırada da açılır.",
  "e2e.password.rotate_title": "Klasör anahtarı da değişir",
  "e2e.password.rotate_body": "Her dosyanın anahtarı yeni bir klasör anahtarıyla yeniden sarılır. İçerik yeniden şifrelenmez. Yarıda kalırsa kaldığı yerden devam eder; dosyalar bu sırada da açılır.",
  "e2e.password.rekey_rk_new": "Yeni bir kurtarma anahtarı alırsınız, bir kez gösterilir; eskisi artık çalışmaz.",
  "e2e.password.rekey_rk_kept": "Kullandığınız kurtarma anahtarı çalışmaya devam eder.",
  "e2e.password.rekey_escrow": "İşletmecinin emanet anahtarı çalışmaya devam eder: yuvası yeni klasör anahtarına mühürlenir.",
  "e2e.password.rekey_ack": "Anlıyorum: bu, klasördeki her dosyanın anahtarını yeniden sarar.",
  "e2e.password.submit": "Parolayı değiştir",
  "e2e.password.busy": "Değiştiriliyor…",
  "e2e.password.lock_instead": "Bunun yerine klasörü kilitle",
  "e2e.password.wrong_current": "Parola yanlış.",
  "e2e.password.wrong_recovery": "Kurtarma anahtarı yanlış.",
  "e2e.password.escrow_blocked": "Bu klasörün, bu kurulumda bulunmayan bir anahtar için emanet yuvası var; klasör anahtarını değiştirmek onu kaybettirir. Hiçbir şey değiştirilmedi.",
  "e2e.password.failed": "Parola değiştirilemedi. Hiçbir şey değiştirilmedi.",
  "e2e.password.done": "Parola değişti. Eski parola bu klasörü artık açmıyor.",
  "e2e.password.resume_title": "Dosya anahtarları hâlâ yeniden sarılıyor",
  "e2e.password.resume_body": "Parola değişti ve yeni bir klasör anahtarı verildi. Bazı dosyaların anahtarı hâlâ öncekinin altında; her iki durumda da açılırlar. Bitirmek için devam edin.",
  "e2e.password.progress": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.progress_one": "Şu ana kadar {n} dosya yeniden sarıldı · {failed} başarısız",
  "e2e.password.rekey_partial": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyorlar; yeniden denemek için devam edin.",
  "e2e.password.rekey_partial_one": "{n} dosya yeniden sarılamadı. Önceki anahtarla hâlâ açılıyor; yeniden denemek için devam edin.",
  "e2e.password.rekey_done": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.password.rekey_done_one": "Yeni klasör anahtarı yerinde ({n} dosya yeniden sarıldı). Eski parola burada artık hiçbir şey açmıyor.",
  "e2e.recovery.lead_replaced": "Klasörün yeni bir anahtarı var, bu yüzden yeni bir kurtarma anahtarı da var - eskisi artık açmıyor. Bir kez gösterilir; filex kopyasını tutmaz.",
  /* wiring:e2 names - şifreli dosya ve klasör adları */
  "e2e.unlock.unsupported": "Bu klasör daha yeni bir filex istiyor: bu sürümün tanımadığı bir özellik kullanıyor ({features}). Hiçbir şey değiştirilmedi.",
  "e2e.settings.open": "Şifreleme ayarları…",
  "e2e.settings.title": "Şifreleme ayarları",
  "e2e.settings.level": "Şifreleme seviyesi",
  "e2e.settings.password": "Parola",
  "e2e.settings.escrow": "Emanet anahtarı",
  "e2e.settings.close": "Kapat",
  "e2e.level.content": "Yalnız içerik",
  "e2e.level.names": "İçerik ve adlar",
  "e2e.level.content_hint": "Dosya içerikleri şifrelenir. Dosya ve klasör adları sunucuya açık kalır; böylece WebDAV, komut satırı ve masaüstü senkronu adlarla çalışmayı sürdürür ve 0.31'den beri her filex klasörü açar.",
  "e2e.level.names_hint": "İçerik de dosya ve klasör adları da şifrelenir: sunucu yalnız karıştırılmış adlar görür. WebDAV, komut satırı ve masaüstü senkronu da adları karıştırılmış görür; filex 0.47 ve öncesi klasörü açmaz.",
  "e2e.level.pending": "seviye değişikliği bitmedi",
  "e2e.level.change": "Seviyeyi değiştir…",
  "e2e.level.raise_title": "Bu klasör “İçerik ve adlar” seviyesine geçsin mi?",
  "e2e.level.raise_body": "filex buradaki her dosya ve klasöre bu tarayıcıda şifreli bir ad verir. İçeriğe dokunulmaz; yarıda kalırsa kaldığı yerden devam eder. filex açık adlara geri dönüş yolu sunmaz.",
  "e2e.level.raise_ack": "Neyin değiştiğini anladım",
  "e2e.level.raise_go": "Adları şifrele",
  /* wiring:e2 vault - 3. seviye, kasa (docs/E2E-VAULT-FORMAT.md) */
  "e2e.level.vault": "Kasa",
  "e2e.level.vault_hint": "İçerik, adlar ve bütün ağaç şifrelenir: sunucu yalnız aynı boyda paketler tutar; kaç dosya olduğunu, adlarını, boyutlarını ve tarihlerini görmez.",
  "e2e.level.vault_cost": "Bedeli: aynı anda yalnız bir kişi yazar ve kasayı yalnız filex açar (web, masaüstü, filex decrypt ve filex vault mount). WebDAV, klasör eşitleme, paylaşım bağlantıları ve sunucudaki önizlemeler içine ulaşmaz.",
  "e2e.vault.pack_label": "Paket boyutu",
  "e2e.vault.pack_4": "4 MiB",
  "e2e.vault.pack_4_help": "Varsayılan. En küçük değişiklik 4 MiB yükler.",
  "e2e.vault.pack_16": "16 MiB",
  "e2e.vault.pack_16_help": "Sunucuda daha az ve daha büyük dosya. Her değişiklik en az 16 MiB yükler.",
  "e2e.vault.pack_hint": "Yalnız şimdi seçilir, sonra değişmez. Sunucudaki her paket bu boydadır; kullanılmayan yeri rastgele baytlarla doldurulur.",
  "e2e.vault.read_only": "Salt okunur. Bir yükleme, yeni bir klasör ya da başka bir değişiklik, kimse tutmuyorsa yazma kilidini alır.",
  "e2e.vault.writing": "Bu kasaya şu an siz yazıyorsunuz. {left} boyunca hiçbir şey yapmazsanız salt okunura döner.",
  "e2e.vault.lock_countdown": "{left} boyunca içinde hiçbir şey yapılmazsa kasa kilitlenir ve parolayı yeniden sorar.",
  "e2e.vault.held_by": "{name} {since} tarihinden beri yazıyor. Kasa sizin için salt okunur.",
  "e2e.vault.someone": "Biri",
  "e2e.vault.take_over": "Devral",
  "e2e.vault.lost_idle": "{n} dakika boyunca hiçbir şey yapmadığınız için kasa salt okunura döndü. Hiçbir şey kaybolmadı.",
  "e2e.vault.lost_idle_one": "{n} dakika boyunca hiçbir şey yapmadığınız için kasa salt okunura döndü. Hiçbir şey kaybolmadı.",
  "e2e.vault.lost_taken": "Yazmayı başka biri devraldı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_taken_by": "{name} yazmayı devraldı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_broken_by": "{name} yazma kilidinizi kaldırdı. Kaydettikleriniz yerinde duruyor; kasa sizin için salt okunur.",
  "e2e.vault.lost_connection": "Bağlantı koptuğu için kasa salt okunura döndü.",
  "e2e.vault.lost_expired": "Yazma kilidinin süresi dolduğu için kasa salt okunura döndü.",
  "e2e.vault.unsaved": "Kaydedilmedi: {names}. Kasa boşalınca yeniden yapın.",
  "e2e.vault.saving": "Kaydediliyor…",
  "e2e.vault.saving_progress": "Kaydediliyor: {total} içinden {done}",
  "e2e.vault.dismiss": "Tamam",
  "e2e.vault.continue": "Bu durumdan devam et",
  "e2e.vault.ro_damaged": "Bu kasanın en yeni durumu bozuk. {when} tarihli durumu görüyorsunuz, salt okunur.",
  "e2e.vault.ro_damaged_short": "Bu kasanın en yeni durumu bozuk. Daha eski bir durumu görüyorsunuz, salt okunur.",
  "e2e.vault.ro_rollback": "Sunucu bu kasanın, bu sekmenin daha önce gördüğünden eski bir durumunu sunuyor. Kasa burada salt okunur kalır.",
  "e2e.vault.ro_newer": "Bu kasayı daha yeni bir filex yazmış. Bu sürüm onu okur ama değiştirmez.",
  "e2e.vault.unreadable": "Bu kasanın hiçbir durumu okunamıyor: hiçbir şey gösterilemez ve hiçbir şey yazılmaz.",
  "e2e.vault.limit_warn": "Bu kasa en fazla {max} dosya ve klasör tutabilir; şu an {held} tane tutuyor.",
  "e2e.vault.cross": "Sunucuda kasa ile dışındaki klasörler arasında hiçbir şey taşınmaz: birinden indirin, sonra ötekine yükleyin.",
  "e2e.vault.dl_too_big": "Bu tarayıcı bu kadar büyük bir dosyayı bellekten kaydedemez. Doğrudan diske kaydeden bir tarayıcı (Chrome, Edge) ya da filex decrypt kullanın.",
  "e2e.vault.damaged_file": "Bu dosya kasada bozuk ve okunamadı.",
  "e2e.vault.level_fixed": "Kasa kasa olarak kalır: seviyesi değişmez, anahtarı yenilenmez. Yeni bir anahtarla baştan başlamak için yeni bir kasa oluşturup dosyaları içine taşıyın.",
  "e2e.vault.locked_idle_toast": "“{name}” içinde 15 dakika hiçbir şey yapılmadığı için kasa kendini kilitledi. Yeniden açmak için parolayı girin.",
  "e2e.vault.open_failed": "Kasa açılamadı.",
  "e2e.vault.err.parent_missing": "İçine gideceği klasör artık yok.",
  "e2e.vault.err.parent_not_folder": "“{name}” bir klasör değil, bir dosya.",
  "e2e.vault.err.name_taken": "Orada “{name}” adı zaten var.",
  "e2e.vault.err.bad_name": "“{name}” kasada ad olamaz: 1 ile 255 bayt arası olmalı, eğik çizgi ya da denetim karakteri içermemeli, . ya da .. olmamalı.",
  "e2e.vault.err.too_deep": "Kasada klasörler en fazla 256 düzey iç içe olabilir.",
  "e2e.vault.err.not_found": "“{name}” artık kasada yok.",
  "e2e.vault.err.is_folder": "“{name}” bir klasör.",
  "e2e.vault.err.into_itself": "Bir klasör kendi içine taşınamaz.",
  "e2e.vault.err.too_many_entries": "Bu kasa dolu: en fazla 250 000 dosya ve klasör tutar. Hiçbir şey değiştirilmedi.",
  "e2e.vault.err.index_too_large": "Bu kasanın dizini sınırına ulaştı. Hiçbir şey değiştirilmedi.",
  "e2e.vault.err.newer_format": "Bu kasayı daha yeni bir filex yazmış. Bu sürüm onu okur ama değiştirmez.",
  "e2e.vault.err.size_mismatch": "Bir dosya yüklenirken değişti. Yeniden yükleyin.",
  "e2e.vault.err.changed": "“{name}” açıldığından beri kasada değişti, bu yüzden üzerine kaydedilmedi. Yeni sürümü görmek için yeniden açın.",
  "e2e.vault.err.failed": "Değişiklik kaydedilemedi.",
  "userSettings.vault.idle": "Kasa: salt okunura dönme süresi",
  "userSettings.vault.idle_help": "Yazdığınız bir kasada hiçbir şey yapmadığınızda kasanın ne kadar süre sizde kalacağı. Sonra başkaları yazabilir; kasanız salt okunura döner ve 15 dakika sonra kilitlenir.",
  "userSettings.vault.minutes": "{n} dakika",
  "userSettings.vault.minutes_one": "{n} dakika",
  "userSettings.vault.saved": "Kaydedildi",
  "userSettings.vault.failed": "Kasa ayarı kaydedilemedi.",
  "e2e.names.move_unreadable": "Taşınmadı: öğelerden birinin adı okunamıyor.",
  "e2e.names.move_taken": "Taşınmadı: o klasörde “{name}” adı zaten var. Önce ikisinden birinin adını değiştirin.",
  "e2e.convert.ctx": "E2EE ile şifrele…",
  "e2e.convert.title": "“{name}” klasörünü şifrele",
  "e2e.convert.lead": "Bu klasördeki her dosya bulunduğu yerde, bu tarayıcıda, aşağıdaki parolayla şifrelenir. Hiçbir şey yer değiştirmez; 1. seviyede adlar olduğu gibi kalır. Yarıda kalırsa klasörü yeniden açınca devam eder.",
  "e2e.convert.past_title": "Sunucuda zaten olanlar",
  "e2e.convert.past_body": "Şifreleme bu dosyaları bundan sonrası için korur. Şimdiye kadar sunucu onları açık hâlde tuttu ve bazı kopyalar kalır: filex küçük resimlerini ve arama için çıkardığı metni siler; bu klasörün eski sürümlerini ve çöp kutusundaki kayıtlarını da silebilir.",
  "e2e.convert.drop_versions": "Bu dosyaların eski sürümlerini sil (şifresizdirler)",
  "e2e.convert.drop_trash": "Bu klasörden çöp kutusuna gidenleri sil",
  "e2e.convert.past_outside": "Yedekler, kopya sunucular ve birinin önceden aldığı kopyalar filex'in dışındadır ve olduğu gibi kalır.",
  "e2e.convert.submit": "Klasörü şifrele",
  "e2e.convert.nested": "Bu klasörün içinde şifreli bir klasör var. Şifreli klasörler iç içe olamaz; hiçbir şey değiştirilmedi.",
  "e2e.convert.failed": "Klasör şifrelenemedi. Şifrelenmiş dosyalar öyle kalır; devam etmek için klasörü açın.",
  "e2e.convert.stopped": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.stopped_one": "{n} dosyadan sonra durduruldu. Klasörün üstündeki şeritten devam edebilirsiniz.",
  "e2e.convert.partial": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresizler; devam etmek için yeniden deneyin.",
  "e2e.convert.partial_one": "{n} dosya şifrelenemedi (bu arada değişti, çok büyük ya da yazılamıyor). Hâlâ şifresiz; devam etmek için yeniden deneyin.",
  "e2e.convert.too_large_here": "{n} dosya bu tarayıcının tek parçada gönderebileceğinden büyük ve bu sunucu parça parça yükleme almıyor; bu yüzden yerlerinde şifrelenemediler. Hâlâ şifresizler ve onlar şifrelenene kadar klasörün şifrelenmesi tamamlanmış sayılmaz.",
  "e2e.convert.too_large_here_one": "{n} dosya bu tarayıcının tek parçada gönderebileceğinden büyük ve bu sunucu parça parça yükleme almıyor; bu yüzden yerinde şifrelenemedi. Hâlâ şifresiz ve o şifrelenene kadar klasörün şifrelenmesi tamamlanmış sayılmaz.",
  "e2e.convert.large_progress": "“{name}” şifreleniyor: %{percent}",
  "e2e.convert.busy": "Klasör şifreleniyor…",
  "e2e.convert.resume_title": "Bu klasörü şifrelemeyi bitirin",
  "e2e.convert.resume_body": "Bu klasörü şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan dosyalar sunucuda hâlâ şifresiz. Devam ederseniz kaldığı yerden sürer.",
  "e2e.convert.progress": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.progress_one": "{total} dosyanın {n} tanesi şifrelendi · {failed} dosya kaldı",
  "e2e.convert.done": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.done_one": "Klasör şifrelendi ({n} dosya). Silinen eski sürüm: {versions}; silinen çöp kaydı: {trash}.",
  "e2e.convert.cleanup_failed": "Klasör şifrelendi ama eski sürümleri ve çöp kayıtları silinemedi - bunu yalnız klasörün sahibi ya da bir yönetici yapabilir.",
  "e2e.names.locked_item": "🔒 Şifreli öğe",
  "e2e.names.unreadable_item": "🔒 Adı okunamıyor",
  "e2e.names.key_failed": "Anahtar dosyası bu klasördeki adların şifreli olduğunu söylüyor ama ad anahtarı bu anahtarla açılmıyor. Hiçbir şey değiştirilmedi.",
  "e2e.names.write_failed": "Uzun bir adın ad dosyası yazılamadı, bu yüzden hiçbir şey yüklenmedi.",
  "e2e.names.bad_name": "“{name}” şifreli klasörde kullanılamaz: ad 1-255 bayt olmalı; bölü, ters bölü ya da kontrol karakteri içeremez.",
  "e2e.names.offer_cost": "Ne değişir: WebDAV, komut satırı ve masaüstü senkronu adları karıştırılmış görür; filex 0.47 ve öncesi bu klasörü açmayı reddeder. Sunucu kaç öğe olduğunu ve boyutlarını hâlâ görür.",
  "e2e.names.resume_title": "Adları şifrelemeyi bitirin",
  "e2e.names.resume_body": "Bu klasördeki adları şifreleme işi başladı ama bitmedi. Henüz ulaşılmayan öğelerin adları hâlâ açık. Devam ederseniz kaldığı yerden sürer.",
  "e2e.names.resume": "Devam et",
  "e2e.names.stop": "Durdur",
  "e2e.names.busy": "Adlar şifreleniyor…",
  "e2e.names.progress": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.progress_one": "Şu ana kadar {n} ad şifrelendi · {failed} öğe yeniden adlandırılamadı",
  "e2e.names.done": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.done_one": "Adlar şifrelendi ({n} öğe yeniden adlandırıldı). Sunucu artık adları göremiyor.",
  "e2e.names.stopped": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.stopped_one": "{n} addan sonra durduruldu. Kalanlar siz devam edene kadar açık adlarını korur.",
  "e2e.names.partial": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adları açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.partial_one": "{n} öğe yeniden adlandırılamadı (izin yok ya da ad bir diskte tutulamıyor). Adı açık kalıyor; devam etmek için yeniden deneyin.",
  "e2e.names.failed": "Adlar şifrelenemedi. Zaten yeniden adlandırılanlar kaybolmaz; devam etmek için yeniden deneyin.",
  "e2e.names.strip_fix": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.names.strip_fix_one": "{n} adı düzelt (açık kalmış ya da filex dışından taşınmış)",
  "e2e.create.names_root_hint": "Klasörün kendi adı her durumda açık kalır - şifresiz bir klasörün içinde durur. Hiçbir şey ele vermeyen bir ad seçin.",
  "e2e.locked_toast": "Klasör kilitlendi",
  "e2e.app_closed_unsaved": "“{name}” dosyasında kaydedilmemiş değişiklikler kayboldu: klasör kilitlenince uygulama kapandı.",
  "e2e.upload.locked": "Önce klasörün kilidini açın",
  "e2e.decrypting": "Çözülüyor…",
  "e2e.decrypt_failed": "Dosya çözülemedi (parola değişmiş ya da dosya bozulmuş olabilir).",
  /* wiring:e2 recovery - kurtarma anahtarı + yönetici escrow'u */
  "e2e.create.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.create.escrow_body": "Bu kurulumda anahtar emaneti (escrow) açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir. Escrow sunucu kurulurken sabitlenir; bir klasör için kapatılamaz.",
  "e2e.locked.use_recovery": "Parolayı mı kaybettiniz? Kurtarma anahtarı kullanın",
  "e2e.recovery.title": "Kurtarma anahtarınızı saklayın",
  "e2e.recovery.title_upgraded": "Kurtarma anahtarınız",
  "e2e.recovery.lead": "Bu anahtar klasörü parolasız açar. Yalnız bir kez gösterilir - filex bu anahtarı saklamaz ve bir daha gösteremez.",
  "e2e.recovery.lead_upgraded": "Bu klasörün artık bir kurtarma anahtarı var. Klasörü parolasız açar, yalnız bir kez gösterilir ve filex'te kopyası kalmaz.",
  "e2e.recovery.copy": "Kopyala",
  "e2e.recovery.copied": "Kopyalandı",
  "e2e.recovery.download": "Dosya olarak indir",
  "e2e.recovery.warn_title": "BUNU PAROLA GİBİ SAKLAYIN",
  "e2e.recovery.warn_body": "Bu anahtarı eline geçiren herkes klasörü okuyabilir. Parolanızdan ayrı bir yerde tutun - parolanın yanında duran bir anahtar sizi unutmaya karşı korur, başkasına karşı değil.",
  "e2e.recovery.escrow_title": "Bu sunucunun da bir anahtarı var",
  "e2e.recovery.escrow_body": "Bu kurulumda anahtar emaneti açık: sunucunun işletmecisi bu klasörü parolanız olmadan açabilir. O anahtar kullanıldığında size bildirim gelir.",
  "e2e.recovery.escrow_kid": "Emanet anahtarı",
  "e2e.recovery.ack": "Bu anahtarı güvenli bir yere kaydettim.",
  "e2e.recovery.done": "Tamam",
  "e2e.recover.title": "Parolasız kilit açma",
  "e2e.recover.none": "Bu klasör kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden anahtarı yok. Tek giriş yolu parolası. Bir kez parolayla açın, filex kurtarma anahtarı eklemeyi önerecek.",
  "e2e.recover.tab_recovery": "Kurtarma anahtarı",
  "e2e.recover.tab_escrow": "Emanet anahtarı",
  "e2e.recover.recovery_hint": "Klasör oluşturulurken bir kez gösterilen anahtar.",
  "e2e.recover.recovery_placeholder": "XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX-XXXX",
  "e2e.recover.escrow_warn_title": "Klasörün sahibine haber gidecek",
  "e2e.recover.escrow_warn_body": "Emanet anahtarıyla açılan klasörün sahibine bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.recover.escrow_kid": "Emanet anahtarı",
  "e2e.recover.escrow_predates": "Bu kurulumun emanet anahtarı var ama bu klasörün yok. Klasör, emanet burada açılmadan önce oluşturulmuş; ana anahtarı emanet kimliğine hiç sarmalanmadı. Emanet anahtarı bu klasörü açmaz. İşletmecinin yapabileceği hiçbir şey bunu değiştirmez - sarmalama için klasörün parolası gerekir ve sunucu onu hiçbir zaman görmedi. Klasörün sahibi verebilir: parolayla kilidi açıp işletmeciye anahtar vermeyi seçebilir. O yapılana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.escrow_other_key": "Bu klasör BAŞKA bir kurulumun emanet anahtarını taşıyor. Başka yerde oluşturulup buraya geri yüklenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz. Yalnızca sarmalandığı emanet anahtarının özel yarısı açabilir.",
  "e2e.recover.escrow_placeholder": "Emanet özel anahtarını yapıştırın (PKCS#8, base64 ya da PEM)",
  "e2e.recover.bad_format": "Bu bir kurtarma anahtarına benzemiyor. Dörtlü sekiz grup, toplam 32 karakter olmalı.",
  "e2e.recover.escrow_required": "Emanet özel anahtarını yapıştırın.",
  "e2e.recover.wrong_recovery": "Bu kurtarma anahtarı bu klasörü açmıyor.",
  "e2e.recover.wrong_escrow": "Bu emanet anahtarı bu klasörü açmıyor. Emanet açılmadan önce oluşturulmuş bir klasörün, sahibi izin verene kadar emanet anahtarı yoktur - o zamana kadar parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.recover.bad_escrow_key": "Bu okunabilir bir özel anahtar değil (PKCS#8, base64 ya da PEM bekleniyor).",
  "e2e.recover.notify_failed": "Klasör sahibine bildirim gönderilemedi, bu yüzden kilit açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.recover.recovery_done": "Kurtarma anahtarıyla açıldı",
  "e2e.recover.escrow_done": "Emanet anahtarıyla açıldı - klasör sahibine bildirildi",
  "e2e.recover.unlock": "Kilidi aç",
  "e2e.recover.busy": "Açılıyor…",
  "e2e.escrowoffer.title": "İşletmeciye bu klasörün anahtarı verilsin mi?",
  "e2e.escrowoffer.body": "Bu klasör, burada anahtar emaneti açılmadan önce oluşturulmuş; bu yüzden kurulumun işletmecisi onu açamıyor. Şu anda - parolanız bellekteyken - filex bu klasörü emanet anahtarına sarmalayabilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz; yalnızca anahtar dosyası değişir.",
  "e2e.escrowoffer.consequence": "Bunun anlamı: işletmeci, parolanız olmadan bu klasöre giren ikinci ve kalıcı bir yol kazanır. O anahtar kullanıldığında size bildirim gelir, ama bu bildirim bir denetim değil yalnızca bir duyurudur.",
  "e2e.escrowoffer.learn_more": "Emanet anahtarı neyi yapar, neyi yapamaz",
  "e2e.escrowoffer.password_label": "Klasör parolası",
  "e2e.escrowoffer.password_required": "Klasör parolasını girin.",
  "e2e.escrowoffer.wrong_password": "Bu, bu klasörün parolası değil.",
  "e2e.escrowoffer.accept": "İşletmeciye anahtar ver",
  "e2e.escrowoffer.decline": "Hayır, bende kalsın",
  "e2e.escrowoffer.cancel": "Vazgeç",
  "e2e.escrowoffer.busy": "Sarmalanıyor…",
  "e2e.escrowoffer.done": "İşletmeci artık bu klasörü emanet anahtarıyla açabilir",
  "e2e.escrowoffer.declined_toast": "Sizde kaldı. filex bu klasör için bir daha sormayacak.",
  "e2e.escrowoffer.decline_failed": "Cevabınız kaydedilemedi, bu yüzden filex bir dahakine yine soracak. Klasörde hiçbir şey değişmedi.",
  "e2e.escrowoffer.failed": "İşletmeciye bu klasörün anahtarı verilemedi",
  "e2e.escrowoffer.strip_action": "Emanet anahtarı…",
  "e2e.upgrade.title": "Bu klasörün kurtarma anahtarı yok",
  "e2e.upgrade.body": "Kurtarma anahtarları eklenmeden önce oluşturulmuş, bu yüzden tek giriş yolu parolası. Şu anda - ve yalnız şu anda, parola bellekteyken - filex bir tane ekleyebilir. Dosyalarınız yeniden şifrelenmez, hiçbir yere taşınmaz.",
  "e2e.upgrade.escrow_note": "Not: bu kurulumda anahtar emaneti açık; kurtarma anahtarı eklemek aynı zamanda işletmecinin bu klasörü parolanız olmadan açabilmesi demektir.",
  "e2e.upgrade.accept": "Kurtarma anahtarı oluştur",
  "e2e.upgrade.decline": "Şimdi değil",
  "e2e.upgrade.busy": "Oluşturuluyor…",
  "e2e.upgrade.failed": "Bu klasöre kurtarma anahtarı eklenemedi",
  "e2e.download.failed": "Şifreli dosya indirilemedi.",
  /* /wiring:e2 */
  /* ── connections: storage config + "how to connect" ──────────────
     `storages.*` keys are the ones the BACKEND's driver descriptors
     name (each driver package declares one next to its Init). They are
     kept identical to web/src/locales/*.json on purpose: the same
     descriptor is rendered on both surfaces, so a field that reads
     "Base path" in the admin panel and something else in the desktop
     app would be the same drift this whole mechanism exists to stop. */
  "conn.title": "Bağlantılar",
  "conn.subtitle": "{host} sunucusuna kendi bilgisayarınızdan nasıl erişilir: bağlayın ya da bir istemciyi buraya yönlendirin.",
  "conn.close": "Kapat",
  "conn.list.disabled": "Kapalı",
  "conn.form.required": "Zorunlu",
  "conn.form.advanced": "Gelişmiş ayarlar",
  "conn.form.yes": "Evet",
  "conn.form.no": "Hayır",
  "conn.form.noFields": "Bu sunucu bu sürücü için hiçbir ayar tanımlamadı.",
  "conn.form.reveal": "Göster",
  "conn.form.hide": "Gizle",
  "conn.guide.protocol": "Protokol",
  "conn.guide.storage": "Depo",
  "conn.guide.allStorages": "Tüm depolar",
  "conn.guide.copy": "Kopyala",
  "conn.guide.copied": "Kopyalandı",
  "conn.guide.goodToKnow": "Bilmekte fayda var",
  "conn.guide.userPlaceholder": "eposta@ornek.com",
  "conn.guide.secretPlaceholder": "parolanız-ya-da-api-anahtarınız",
  "conn.guide.fact.url": "Adres",
  "conn.guide.fact.urlRootHint": "Görebildiğiniz her depo bu adresin altında bir klasör olarak görünür.",
  "conn.guide.fact.urlStorageHint": "Doğrudan “{storage}” deposunu bağlar. Son parçayı silerseniz tüm depoları görürsünüz.",
  "conn.guide.fact.user": "Kullanıcı adı",
  "conn.guide.fact.password": "Parola",
  "conn.guide.webdav.summary": "WebDAV, filex’i bir sürücü gibi bağlar: Windows Gezgini, macOS Finder, Linux, rclone ve Cyberduck bu protokolü konuşur ve yapılan her değişiklik filex’e yansır.",
  "conn.guide.webdav.userHint": "Kullanıcı adınız ya da e-postanız - görünen adınız değil.",
  "conn.guide.webdav.passwordHint": "Hesap parolanız ya da bir API anahtarı (gezinti panelindeki API anahtarları bölümü). İki adımlı doğrulaması açık bir hesap ZORUNLU olarak API anahtarı kullanır: Basic kimlik doğrulamasında ikinci adım için yer yoktur.",
  "conn.guide.webdav.win.s1": "Dosya Gezgini’ni açın, Bu bilgisayar’a sağ tıklayın ve “Ağ sürücüsü bağla…” deyin.",
  "conn.guide.webdav.win.s2": "Bir sürücü harfi seçin ve klasör olarak {url} adresini girin.",
  "conn.guide.webdav.win.s3": "“Farklı kimlik bilgileri kullanarak bağlan” kutusunu işaretleyin ve yukarıdaki kullanıcı adı/parola ile girin.",
  "conn.guide.webdav.win.cmdCaption": "Komut İstemi (sihirbaz olmadan aynı iş)",
  "conn.guide.webdav.win.limits": "Windows’un tam olarak filex hatası gibi görünen üç yerleşik sınırı vardır: aktarımlar ~47,7 MB’ta durur, yaklaşık bin dosyalı klasörler açılmaz (“Disk biçimlendirilmemiş”) ve her iki ayarı değiştirdikten sonra WebClient hizmeti yeniden başlatılmalıdır.",
  "conn.guide.webdav.win.regCaption": "Yönetici olarak çalıştırın, sonra sürücüyü yeniden bağlayın",
  "conn.guide.webdav.win.https": "HTTPS zorunludur. Windows Basic kimlik bilgilerini yalnızca TLS üzerinden gönderir; düz http:// üzerinde hiçbir açıklama vermeden reddeder. BasicAuthLevel değerini 2 yapmayın - TLS kullanın.",
  "conn.guide.webdav.win.persist": "Bağlanan sürücü oturum kapatmayı atlatamaz: Windows 7’den beri Basic kimlik bilgileri Kimlik Bilgisi Yöneticisi’nde saklanamaz ve /persistent:yes bunu değiştirmez. Kendiliğinden geri gelsin istiyorsanız komutu bir oturum açma betiğinden yeniden çalıştırın.",
  "conn.guide.webdav.win.service": "Hiç bağlanamıyorsa WebClient hizmetinin çalıştığından emin olun: sc config WebClient start= auto && net start WebClient.",
  "conn.guide.webdav.mac.s1": "Finder’da Git → Sunucuya Bağlan… (⌘K) yolunu izleyin.",
  "conn.guide.webdav.mac.s2": "{url} adresini girip bağlanın.",
  "conn.guide.webdav.mac.s3": "Yukarıdaki kullanıcı adı ve parolayla kimliğinizi doğrulayın.",
  "conn.guide.webdav.mac.note": "Sürücü Konumlar altında görünür; her depo en üst düzeyde bir klasördür.",
  "conn.guide.webdav.linux.mountCaption": "davfs2 ya da masaüstü dosya yöneticisi (GNOME Dosyalar, Dolphin)",
  "conn.guide.webdav.linux.gvfsComment": "ya da bu adresi GNOME Dosyalar / Dolphin icine yapistirin",
  "conn.guide.webdav.linux.locks": "davfs2 için kilitler kapatılmalıdır. filex WebDAV kilitlerini süreç belleğinde tutar; yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar - davfs2 tersini varsayar ve takılır.",
  "conn.guide.webdav.rclone.obscureCaption": "rclone parolayı gizlenmiş biçimde saklar - önce bunu çalıştırıp çıktısını aşağıya yapıştırın",
  "conn.guide.webdav.rclone.passPlaceholder": "<rclone obscure çıktısı>",
  "conn.guide.webdav.rclone.useCaption": "Kullanımı",
  "conn.guide.webdav.duck.s1": "Yeni Yer İmi → WebDAV (HTTPS).",
  "conn.guide.webdav.duck.s2": "Sunucu {host}, port 443.",
  "conn.guide.webdav.duck.s3": "Yol {path}.",
  "conn.guide.webdav.duck.s4": "Kullanıcı adı {user}, parola yukarıdaki gibi.",
  "conn.guide.webdav.note.delete": "WebDAV üzerinden silme kalıcıdır. Web arayüzü dosyaları filex çöp kutusuna taşır; istemciden silme ise nesneyi doğrudan arka uçtan kaldırır.",
  "conn.guide.webdav.note.locks": "Kilitler sunucu belleğinde durur: yeniden başlatmayı atlatamazlar ve kopyalar arasında paylaşılmazlar. Windows ile Office’i memnun etmek için varlar, eşzamanlı düzenlemeyi hakemlemek için değil.",
  "conn.guide.webdav.note.permissions": "Web arayüzünde ne görüyorsanız burada da onu görürsünüz. Kök yalnızca açabildiğiniz depoları listeler; yetkiniz dışındaki bir yol 403 değil 404 döner, böylece ağaç neyin var olduğunu sızdırmaz.",
  "conn.guide.webdav.note.http": "Bu sunucuya düz http:// ile erişiliyor. Windows kimlik bilgilerinizi hiç göndermez, diğer tüm istemciler ise parolanızı açık metin olarak yollar. Bağlamadan önce filex’i TLS arkasına alın.",
  // ── S3 ucu: anahtarlar ve rehber ─────────────────────────────────
  "conn.s3keys.title": "S3 erişim anahtarları",
  "conn.s3keys.lead": "Bir erişim anahtarı, S3 konuşan her istemcinin - rclone, restic, AWS CLI, mc, s3fs, Cyberduck - filex’e bağlanmasını sağlar. Anahtar sizin yetkinizi taşır, bir fazlasını değil.",
  "conn.s3keys.disabled": "Bu sunucuda S3 ucu kapalı (FILEX_S3). Burada üretilen anahtar, yönetici ucu tekrar açana kadar bağlanmaz.",
  "conn.s3keys.cannotMint": "Erişim anahtarı üretebilecek bir hesapla oturum açmış değilsiniz. Aşağıdaki talimatlar yine geçerli - bir anahtar isteyip yapıştırmanız yeter.",
  "conn.s3keys.label": "Ne için? (dizüstü yedeği, CI, …)",
  "conn.s3keys.defaultLabel": "erişim anahtarı",
  "conn.s3keys.everyBucket": "Görebildiğim tüm kovalar",
  "conn.s3keys.prefix": "Kova içindeki klasör (isteğe bağlı)",
  "conn.s3keys.mint": "Anahtar oluştur",
  "conn.s3keys.inheritNote": "Bir anahtar sahip olduğunuz yetkiyi yalnızca DARALTABİLİR: yetkileriniz ve rolünüz. Anahtarı tek bir kovaya ya da klasöre kısıtlamak, bir dizüstü yedeği ile her şeyi okuyabilen bir kimlik arasındaki farktır.",
  "conn.s3keys.once": "Gizli anahtarı şimdi kopyalayın - bir daha gösterilmeyecek.",
  "conn.s3keys.accessKeyID": "Erişim anahtarı kimliği",
  "conn.s3keys.secret": "Gizli anahtar",
  "conn.s3keys.dismiss": "Kopyaladım",
  "conn.s3keys.col.label": "Etiket",
  "conn.s3keys.col.key": "Erişim anahtarı kimliği",
  "conn.s3keys.col.scope": "Kapsam",
  "conn.s3keys.col.lastUsed": "Son kullanım",
  "conn.s3keys.scopeAll": "görebildiğiniz her şey",
  "conn.s3keys.noLabel": "(etiketsiz)",
  "conn.s3keys.neverUsed": "hiç",
  "conn.s3keys.enable": "Aç",
  "conn.s3keys.disable": "Kapat",
  "conn.s3keys.revoke": "İptal et",
  "conn.s3keys.confirm": "Emin misiniz?",
  "conn.s3keys.empty": "Henüz erişim anahtarı yok.",
  "conn.guide.s3.summary": "S3 ucu, S3 konuşan her şeyin - yedekleme, eşitleme araçları, SDK’lar - hedefi olarak filex’i kullanmanızı sağlar; hem de zaten sahip olduğunuz depolarla.",
  "conn.guide.s3.keyPlaceholder": "yukarıdan bir anahtar oluşturun",
  "conn.guide.s3.secretPlaceholder": "anahtarı oluştururken bir kez gösterilir",
  "conn.guide.s3.fact.endpoint": "Uç adresi",
  "conn.guide.s3.fact.endpointHint": "İstemciyi buraya yöneltin, filex’in web adresine değil.",
  "conn.guide.s3.fact.bucket": "Kova",
  "conn.guide.s3.fact.bucketHint": "Kova = filex deposu. Kovaları istemci değil yönetici oluşturur.",
  "conn.guide.s3.fact.key": "Erişim anahtarı kimliği",
  "conn.guide.s3.fact.keyHint": "Genel yarısı; her istekte gider.",
  "conn.guide.s3.fact.secret": "Gizli anahtar",
  "conn.guide.s3.fact.secretHint": "Yalnızca anahtar oluşturulurken bir kez gösterilir. filex bir daha gösteremez - kaybolduysa yeni anahtar üretin.",
  "conn.guide.s3.fact.region": "Bölge",
  "conn.guide.s3.fact.regionHint": "filex’te bölge yok; hangi değeri verirseniz aynen geri döner. Yine de istemciler bir değer ister.",
  "conn.guide.s3.fact.addressing": "Adresleme",
  "conn.guide.s3.fact.pathStyle": "yol tabanlı (zorunlu)",
  "conn.guide.s3.fact.pathStyleHint": "Bu kurulumda S3’e ayrılmış bir alan adı yok, yani kova.host çözülmez.",
  "conn.guide.s3.fact.virtualHosted": "sanal-host ya da yol tabanlı",
  "conn.guide.s3.fact.virtualHostedHint": "Bu kurulumun kendi S3 alan adı var, iki adresleme de çalışır.",
  "conn.guide.s3.rclone.useCaption": "Kullanımı",
  "conn.guide.s3.rclone.mtime": "filex dosyanın değişiklik zamanını taşır (x-amz-meta-mtime); böylece rclone sync ilk turdan sonra oturur, her seferinde her şeyi yeniden yüklemez.",
  "conn.guide.s3.aws.configureCaption": "Bir kez ayarlayın",
  "conn.guide.s3.aws.useCaption": "Kullanımı",
  "conn.guide.s3.aws.pathStyle": "AWS yapılandırmanıza yol tabanlı adreslemeyi ekleyin; yoksa her komut DNS aşamasında düşer.",
  "conn.guide.s3.restic.envCaption": "Ortam değişkenleri",
  "conn.guide.s3.restic.useCaption": "Yedekle, doğrula, buda",
  "conn.guide.s3.restic.verified": "Bu uca karşı ölçüldü: restic check --read-data her pack’i bayt bayt okuyor ve hata bulmuyor.",
  "conn.guide.s3.mc.aliasCaption": "Takma adı ekleyin",
  "conn.guide.s3.mc.useCaption": "Kullanımı",
  "conn.guide.s3.s3fs.credsCaption": "Kimlik dosyası",
  "conn.guide.s3.s3fs.mountCaption": "Bağlayın",
  "conn.guide.s3.s3fs.note": "s3fs üzerinden bir dosyayı düzenlemek nesnenin tamamını yeniden yazar; silme ise filex çöp kutusuna gider. Paylaşılan bir klasör için iyi, veritabanı için değil.",
  "conn.guide.s3.duck.s1": "Yeni yer imi → Amazon S3.",
  "conn.guide.s3.duck.s2": "Sunucu: {host}.",
  "conn.guide.s3.duck.s3": "Erişim anahtarı kimliği: {key}, gizli anahtar yukarıdaki.",
  "conn.guide.s3.duck.s4": "Yer imini açın; kovalar sizin filex depolarınızdır.",
  "conn.guide.s3.duck.pathStyle": 'Tercihler → S3 altında "Use virtual host style" seçeneğini KAPATIN - bu kurulumda joker S3 alan adı yok.',
  "conn.guide.s3.sdk.note": "SigV4 konuşan her istemci aynı şekilde çalışır: uç adresi, anahtar, gizli anahtar ve bu kurulumun kendi S3 alan adı yoksa yol tabanlı adresleme.",
  "conn.guide.s3.note.buckets": "Kova = filex deposu. İstemci kovanın İÇİNDE klasör ve nesne oluşturabilir, ama kovanın kendisini oluşturamaz: kova bir sürücü ve bir yol ister, bunu bir S3 isteği ifade edemez.",
  "conn.guide.s3.note.permissions": 'Anahtar tam olarak sizin gördüğünüzü görür. Açamayacağınız bir kova "yasak" değil "böyle bir kova yok" der; böylece uç, neyin var olduğunu sızdırmaz.',
  "conn.guide.s3.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.s3.note.mtime": "Yüklemeler değişiklik zamanını taşır; istemcinin gönderdiği sağlama toplamları (Content-MD5, x-amz-checksum-*) doğrulanır - bozulmuş bir yükleme saklanmaz, reddedilir.",
  "conn.guide.s3.note.pathStyle": "Bu kurulumda S3’e ayrılmış alan adı yok; istemcilere yol tabanlı adresleme söylenmeli. Söylenmezse güncel bir SDK, ne filex’i ne de sebebi anan bir DNS hatasıyla düşer.",
  "conn.guide.s3.note.http": "Bu uç düz http://. İmzalar isteği yine korur ama nesneler açık metin gider. Bir yedeği buraya yöneltmeden önce filex’i TLS arkasına alın.",
  // ── SFTP ucu: anahtarlar ve rehber ───────────────────────────────
  "conn.sshkeys.title": "SSH anahtarları",
  "conn.sshkeys.lead": "Bir açık anahtar kaydedin; SSH konuşan her istemci - sftp, scp, WinSCP, FileZilla, rclone, sshfs - parolanızı göndermeden bağlansın.",
  "conn.sshkeys.disabled": "Bu sunucuda SFTP ucu kapalı (FILEX_SFTP). Burada kaydedilen anahtar, yönetici ucu açana kadar bağlanmaz.",
  "conn.sshkeys.cannotAdd": "Anahtar kaydedebilecek bir hesapla oturum açmış değilsiniz.",
  "conn.sshkeys.paste": "~/.ssh/id_ed25519.pub dosyasının içeriğini yapıştırın",
  "conn.sshkeys.name": "Ad (isteğe bağlı - boşsa anahtarın kendi yorumu kullanılır)",
  "conn.sshkeys.add": "Anahtar ekle",
  "conn.sshkeys.noCopyId": "ssh-copy-id burada çalışamaz: kabuk üzerinden ~/.ssh/authorized_keys dosyasına ekler, filex’in kabuğu yoktur. Anahtar eklemenin yolu bu kutudur.",
  "conn.sshkeys.col.name": "Ad",
  "conn.sshkeys.col.fingerprint": "Parmak izi",
  "conn.sshkeys.col.added": "Eklendi",
  "conn.sshkeys.col.lastUsed": "Son kullanım",
  "conn.sshkeys.noName": "(adsız)",
  "conn.sshkeys.neverUsed": "hiç",
  "conn.sshkeys.enable": "Aç",
  "conn.sshkeys.disable": "Kapat",
  "conn.sshkeys.remove": "Sil",
  "conn.sshkeys.confirm": "Emin misiniz?",
  "conn.sshkeys.empty": "Henüz anahtar yok. Anahtarsız istemciler hesap parolanızla oturum açar.",
  "conn.guide.sftp.summary": "SFTP, filex’i SSH konuşan her şeyin erişebileceği hâle getirir: bir yedekleme işi, bir tarayıcı, WinSCP, rclone ya da bağlanmış bir klasör.",
  "conn.guide.sftp.fact.host": "Sunucu",
  "conn.guide.sftp.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.sftp.fact.port": "Port",
  "conn.guide.sftp.fact.portHint": "Ne 22 ne 443: SFTP ham TCP’dir, web vekilinin içinden geçemez.",
  "conn.guide.sftp.fact.userHint": "Kullanıcı adınız. İçinde @ işareti olsaydı çoğu istemcinin ayar dosyasında tırnaklanması gerekirdi; kullanıcı adı tam da bunu ortadan kaldırır.",
  "conn.guide.sftp.fact.auth": "Oturum açma yöntemi",
  "conn.guide.sftp.fact.authKey": "kayıtlı SSH anahtarınız (ya da parolanız)",
  "conn.guide.sftp.fact.authPassword": "hesap parolanız - ya da yukarıdan bir anahtar kaydedin",
  "conn.guide.sftp.fact.authHint": "API anahtarı da parola yerine geçer ve tek başına iptal edilebilir. İki adımlı doğrulaması açık bir hesap SSH anahtarı ya da API anahtarı kullanmalıdır.",
  "conn.guide.sftp.fact.path": "Yol",
  "conn.guide.sftp.fact.pathHint": "İlk klasör bir depodur; kök, açabildiğiniz depoları listeler.",
  "conn.guide.sftp.openssh.connectCaption": "Bağlan, gönder, al",
  "conn.guide.sftp.openssh.noShell": "Burada kabuk yok, yalnız SFTP alt sistemi var. `ssh sunucu komut` bilerek reddedilir; scp çalışır çünkü OpenSSH 9 onun için de SFTP konuşur.",
  "conn.guide.sftp.key.tab": "Anahtar kurulumu",
  "conn.guide.sftp.key.s1": "Bağlanacak makinede bir anahtar çifti üretin (zaten varsa atlayın).",
  "conn.guide.sftp.key.s2": "AÇIK yarısını kopyalayın - .pub dosyası, asla diğeri değil.",
  "conn.guide.sftp.key.s3": "Yukarıdaki kutuya yapıştırıp bağlanın; o andan sonra parola gönderilmez.",
  "conn.guide.sftp.key.genCaption": "Kendi makinenizde",
  "conn.guide.sftp.key.noCopyId": "ssh-copy-id filex’e karşı ÇALIŞMAZ: ~/.ssh/authorized_keys dosyasına eklemek için kabuğa ihtiyacı var, filex’te kabuk yok. Anahtarı yukarıdan yapıştırın.",
  "conn.guide.sftp.winscp.s1": "Yeni site → Dosya protokolü: SFTP.",
  "conn.guide.sftp.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.sftp.winscp.s3": "Kullanıcı adı: {user}. Anahtar için: Gelişmiş → SSH → Kimlik Doğrulama → özel anahtar dosyası.",
  "conn.guide.sftp.winscp.s4": "WinSCP .ppk biçiminde özel anahtar ister - OpenSSH anahtarını kendi aracıyla (Araçlar → PuTTYgen) bir kez dönüştürün.",
  "conn.guide.sftp.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: SFTP.",
  "conn.guide.sftp.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.sftp.filezilla.s3": "Kullanıcı: {user}. Giriş türü: parola için Normal, anahtar için Anahtar dosyası.",
  "conn.guide.sftp.rclone.useCaption": "Kullanımı",
  "conn.guide.sftp.sshfs.mountCaption": "Bağla ve çöz",
  "conn.guide.sftp.sshfs.note": "Bağlanmış bir klasörde her kayıt dosyanın tamamını yeniden yazar. Belgeler için iyi; veritabanı ya da yerinde düzenlediğiniz bir video için değil.",
  "conn.guide.sftp.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.sftp.note.permissions": "İstemcinizin çizdiği izin bitleri buradaki erişim seviyenizden gelir; yani salt-okunur görünen bir dosya sizin için gerçekten öyledir.",
  "conn.guide.sftp.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.sftp.note.totp": "Hesabınızda iki adımlı doğrulama açıksa parola burada çalışmaz - SSH’ın kodu soracak bir kanalı yok. Bir SSH anahtarı kaydedin ya da parola yerine API anahtarı kullanın.",
  "conn.guide.sftp.note.disabled": "Bu sunucuda SFTP ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── FTPS ─────────────────────────────────────────────────────────
  "conn.guide.ftps.summary": "FTPS, yalnızca FTP öğrenmiş ekipman için var: tarayıp-klasöre-atan yazıcılar, EDI muhatapları, eski laboratuvar ve endüstri yazılımları. Her zaman TLS üzerinden.",
  "conn.guide.ftps.fact.host": "Sunucu",
  "conn.guide.ftps.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.ftps.fact.port": "Port",
  "conn.guide.ftps.fact.portHint": "Kontrol kanalı. Veri, aşağıdaki pasif aralıktan ayrı bir porttan akar.",
  "conn.guide.ftps.fact.mode": "Şifreleme",
  "conn.guide.ftps.fact.modeValue": "FTPS - açık (explicit) TLS, zorunlu",
  "conn.guide.ftps.fact.modeHint": 'Düz FTP, parola okunmadan reddedilir. "Require explicit FTP over TLS" seçin; "plain FTP" ya da "implicit" asla.',
  "conn.guide.ftps.fact.userHint": "Kullanıcı adınız ya da e-postanız. Parola yerine bir API anahtarı da kullanılabilir ve tek başına iptal edilebilir.",
  "conn.guide.ftps.fact.passwordHint": "Hesap parolanız ya da bir API anahtarı. İki adımlı doğrulaması açık bir hesap API anahtarı kullanmalıdır - FTP'nin kodu soracak bir yolu yok.",
  "conn.guide.ftps.fact.pasv": "Pasif portlar",
  "conn.guide.ftps.fact.pasvHint": "Veri bağlantıları buraya düşer. Güvenlik duvarınız bu aralığı kapatıyorsa aktarım iki tarafta da hata vermeden ASILI KALIR - FTP'nin klasik arızası budur.",
  "conn.guide.ftps.filezilla.s1": "Dosya → Site Yöneticisi → Yeni site, Protokol: FTP.",
  "conn.guide.ftps.filezilla.s2": "Sunucu: {host}, port: {port}.",
  "conn.guide.ftps.filezilla.s3": 'Şifreleme: "Require explicit FTP over TLS". Giriş türü: Normal, kullanıcı: {user}.',
  "conn.guide.ftps.filezilla.s4": "Aktarım ayarları → Pasif. Bu sunucu aktif modu reddeder.",
  "conn.guide.ftps.winscp.s1": "Yeni site → Dosya protokolü: FTP, Şifreleme: TLS/SSL Explicit encryption.",
  "conn.guide.ftps.winscp.s2": "Sunucu adı: {host}, port: {port}.",
  "conn.guide.ftps.winscp.s3": "Kullanıcı adı: {user}, parola yukarıdaki.",
  "conn.guide.ftps.curl.caption": "Gönder ve al",
  "conn.guide.ftps.curl.sslReqd": "--ssl-reqd isteğe bağlı değil: curl'ün düz metne geri düşmek yerine TLS'i ZORUNLU kılmasını sağlar. Bu sunucu zaten düz metni reddediyor, ama alışkanlık sizi reddetmeyen sunuculara karşı korur.",
  "conn.guide.ftps.lftp.caption": "Bağlan",
  "conn.guide.ftps.lftp.protectData": "ssl-protect-data yalnız oturum açmayı değil DOSYAYI da şifreler. Olmazsa lftp TLS ile oturum açar ve dosyayı açık metin gönderir - sahada en sık yapılan FTPS yanlışı budur.",
  "conn.guide.ftps.rclone.useCaption": "Kullanımı",
  "conn.guide.ftps.printer.tab": "Tarayıcı / yazıcı",
  "conn.guide.ftps.printer.s1": "Cihazın tara-ve-FTP'ye-gönder ayarlarında: sunucu {host}, port {port}.",
  "conn.guide.ftps.printer.s2": "Kullanıcı: {user}, parola yukarıdaki. Cihaz için kendi parolanız yerine bir API anahtarı oluşturun - başka hiçbir şeyi değiştirmeden iptal edilebilir.",
  "conn.guide.ftps.printer.s3": "Yol: {path} - ya da önceden oluşturduğunuz bir alt klasör. Cihaz depo oluşturamaz.",
  "conn.guide.ftps.printer.s4": '"SSL/TLS" ya da "FTPS explicit" seçeneğini AÇIN ve PASİF modu seçin.',
  "conn.guide.ftps.printer.noTLS": "Tara-ve-gönder yazılımlarının önemli bir kısmı TLS konuşamıyor. Bu sunucu öyle bir cihazla konuşmayacak ve bu bilinçli: alternatifi, belgelerinizin ve parolanızın ofis ağında açık metin dolaşması.",
  "conn.guide.ftps.note.tls": "TLS zorunludur ve kapatan bir düğme yoktur. Düz FTP parolanızı açık metin gönderir, ardından dosyanızı da.",
  "conn.guide.ftps.note.passive": "Yalnızca pasif mod. Aktif modda sunucu istemciyi geri arar; bu NAT arkasında çalışmaz ve çoğu güvenlik duvarı tarafından engellenir.",
  "conn.guide.ftps.note.storages": "Kök bir ev dizini değildir: açabildiğiniz depoları listeler ve yolun ilk parçası bir depoyu adlandırır.",
  "conn.guide.ftps.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.ftps.note.prefer": "İstemci SFTP konuşabiliyorsa onu tercih edin: tek bağlantı, tek port, pasif mod sürprizi yok.",
  "conn.guide.ftps.note.selfSigned": "Bu sunucu kendinden imzalı bir sertifika kullanıyor. Kanalı şifreler ama karşı tarafın kim olduğunu kanıtlamaz; çoğu istemci bir kez onay ister. Önemli bir iş için gerçek sertifika koyun.",
  "conn.guide.ftps.note.disabled": "Bu sunucuda FTPS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  // ── NFS ──────────────────────────────────────────────────────────
  "conn.nfs.title": "NFS export'ları",
  "conn.nfs.lead": "Bir export, ağınızdaki bir makinenin filex'i sürücü olarak bağlamasını sağlar - medya oynatıcı, derleme sunucusu, yedek kutusu.",
  "conn.nfs.pathIsSecret": "⚠ Export yolu PAROLANIN TA KENDİSİDİR. NFS, Kerberos olmadan istemciye kim olduğunu soramaz; bu yüzden filex yola 32 rastgele bayt koyar: yolu bilen sizin adınıza bağlanır. Bağlama satırını bir kimlik bilgisi gibi saklayın - /etc/fstab çoğu sistemde herkes tarafından okunabilir.",
  "conn.nfs.disabled": "Bu sunucuda NFS ucu kapalı (FILEX_NFS). Burada oluşturulan export, yönetici ucu açana kadar bağlanmaz.",
  "conn.nfs.cannotMint": "Export oluşturabilecek bir hesapla oturum açmış değilsiniz.",
  "conn.nfs.label": "Ne için? (medya oynatıcı, yedek kutusu, …)",
  "conn.nfs.defaultLabel": "nfs export",
  "conn.nfs.everyStorage": "Görebildiğim tüm depolar",
  "conn.nfs.prefix": "Depo içindeki klasör (isteğe bağlı)",
  "conn.nfs.allowCidrs": "İzinli adresler, örn. 192.168.1.0/24 (isteğe bağlı)",
  "conn.nfs.readOnly": "Salt okunur",
  "conn.nfs.readOnlyHint": "Bir makine için güvenli varsayılan salt okunurdur: sizin yetkiniz ne olursa olsun bu bağlantı üzerinden her yazmayı reddeder. Adres listesi daha da daraltır - listenin dışından gelen bağlanamaz.",
  "conn.nfs.mint": "Export oluştur",
  "conn.nfs.once": "Şimdi kopyalayın - yol yalnızca bir kez gösterilir ve geri alınamaz.",
  "conn.nfs.dismiss": "Kopyaladım",
  "conn.nfs.col.label": "Etiket",
  "conn.nfs.col.scope": "Kapsam",
  "conn.nfs.col.mode": "Mod",
  "conn.nfs.col.lastUsed": "Son bağlanma",
  "conn.nfs.scopeAll": "görebildiğiniz her şey",
  "conn.nfs.modeRead": "salt okunur",
  "conn.nfs.modeWrite": "okuma/yazma",
  "conn.nfs.noLabel": "(etiketsiz)",
  "conn.nfs.neverUsed": "hiç",
  "conn.nfs.enable": "Aç",
  "conn.nfs.disable": "Kapat",
  "conn.nfs.revoke": "İptal et",
  "conn.nfs.confirm": "Emin misiniz?",
  "conn.nfs.empty": "Henüz export yok.",
  "conn.guide.nfs.summary": "NFS, filex'i kendi ağınızdaki bir makinede sürücü olarak bağlar - NAS protokolü, onu bekleyen cihazlar için.",
  "conn.guide.nfs.pathPlaceholder": "yukarıdan bir export oluşturun",
  "conn.guide.nfs.fact.host": "Sunucu",
  "conn.guide.nfs.fact.hostHint": "Web uygulamasıyla aynı makine, kendine ait bir portta.",
  "conn.guide.nfs.fact.port": "Port",
  "conn.guide.nfs.fact.portHint": "Hem port= hem mountport= buna ayarlanmalı; filex mount ve NFS servislerini tek portta veriyor.",
  "conn.guide.nfs.fact.export": "Export yolu",
  "conn.guide.nfs.fact.exportHint": "Kimlik bilgisi budur. Export oluşturulurken bir kez gösterilir ve hash'li saklanır - filex bir daha gösteremez.",
  "conn.guide.nfs.fact.options": "Bağlama seçenekleri",
  "conn.guide.nfs.fact.optionsHint": "nolock, çünkü filex NFS kilit yöneticisini çalıştırmıyor; nfsvers=3, çünkü bu sunucunun konuştuğu sürüm bu.",
  "conn.guide.nfs.linux.mountCaption": "Bağla",
  "conn.guide.nfs.linux.fstabSecret": "Bu yolu içeren bir /etc/fstab satırı, herkesin okuyabildiği bir dosyadaki paroladır. Ortamınızda önemliyse kimlik korumalı automount kullanın ya da bağlamayı yalnız root'un okuyabildiği bir unit dosyasında tutun.",
  "conn.guide.nfs.mac.mountCaption": "Bağla",
  "conn.guide.nfs.mac.resvport": "macOS resvport ister: istemcisi ayrıcalıklı bir kaynak portta ısrar eder ve olmadan bağlantıyı reddeder.",
  "conn.guide.nfs.win.s1": `Windows Özellikleri'nden "Services for NFS" → "Client for NFS" bileşenini açın (yalnız Pro ve Enterprise; Home'da yok).`,
  "conn.guide.nfs.win.s2": "Komut İstemi'ni yönetici olarak açın.",
  "conn.guide.nfs.win.s3": "Aşağıdaki komutla export'u bir sürücü harfine bağlayın.",
  "conn.guide.nfs.win.cmdCaption": "Z: sürücüsüne bağla",
  "conn.guide.nfs.win.port": "Windows'un mount servisinin portunu söyleme imkânı yok; yalnızca standart 2049 portundaki bir NFS sunucusuna erişebilir. Bu sunucu başka bir porttaysa SFTP'yi ya da filex masaüstü uygulamasını kullanın.",
  "conn.guide.nfs.nas.tab": "NAS / medya oynatıcı",
  "conn.guide.nfs.nas.s1": "Cihazın NFS ayarlarında: sunucu {host}, port {port} (ayrı ayrı soruyorsa hem NFS hem mount portunu ayarlayın).",
  "conn.guide.nfs.nas.s2": "Uzak yol: yukarıdaki export yolu, birebir.",
  "conn.guide.nfs.nas.s3": "NFS sürüm 3, kilitleme kapalı. Cihazın gerçekten yazması gerekmiyorsa export'u salt okunur oluşturun.",
  "conn.guide.nfs.note.unencrypted": "NFSv3 şifreli değildir. Trafiği okuyabilen dosyalarınızı görür, yolu öğrenen bağlanabilir. Ev/ofis ağında ya da VPN üzerinden kullanın - internet üzerinden asla.",
  "conn.guide.nfs.note.pathIsSecret": "Export yolu kimlik bilgisinin tamamıdır. Sızarsa yukarıdaki listeden iptal edin; değiştirilecek başka bir şey yok.",
  "conn.guide.nfs.note.noPortmapper": "111 portunda portmapper yok; portu söylenmeyen istemci sunucuyu bulamaz. Buradaki her komutun port= ve mountport= taşımasının sebebi bu.",
  "conn.guide.nfs.note.uid": "İstemcinizin gönderdiği kullanıcı ve grup kimlikleri yok sayılır: bağlantı zaten kime ait olduğunu biliyor. Gördüğünüz izinler filex'teki erişiminizden gelir.",
  "conn.guide.nfs.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.nfs.note.revoke": "İptal anında değil, bir sonraki istekte etkili olur: NFS'te sonlandırılacak bir oturum yok, bağlantısı açık olan istemci sıradaki işleminde hata alır.",
  "conn.guide.nfs.note.disabled": "Bu sunucuda NFS ucu kapalı. Yönetici açtığında bu talimatlar çalışacaktır.",
  "conn.tokens.title": "API anahtarları",
  "conn.tokens.lead": "FTPS, WebDAV ve filex mount hesap parolanız yerine bir API anahtarıyla oturum açar. Buradan oluşturun - tek başına iptal edilebilir, ayrıca iki adımlı doğrulaması açık bir hesap bunlarda parolasını zaten kullanamaz.",
  "conn.tokens.mint": "API anahtarı oluştur",
  "conn.tokens.once": "Şimdi kopyalayın - yalnızca bir kez gösterilir. Sunucuda yalnız özeti saklandığı için bir daha gösterilemez.",
  "conn.tokens.dismiss": "Kopyaladım",
  "conn.tokens.cannotMint": "Bu oturum API anahtarı oluşturamıyor. Kendi hesabınızla oturum açıp oluşturun.",
  "conn.tokens.empty": "Henüz API anahtarı yok.",
  "conn.tokens.neverUsed": "hiç",
  "conn.tokens.revoke": "İptal et",
  "conn.tokens.confirm": "Emin misiniz?",
  "conn.tokens.col.label": "Ad",
  "conn.tokens.col.scopes": "İzinler",
  "conn.tokens.col.comments": "Yorumlar",
  "conn.tokens.col.used": "Son kullanım",
  "conn.tokens.revokeHint": "İptal, yalnız bir sonraki oturum açmayı değil AÇIK bağlantıyı da durdurur: SFTP ya da FTPS oturumu kesilir, bağlı bir sürücü yarım dakika içinde çalışmayı bırakır.",
  "conn.guide.mount.summary": "filex mount, uzaktaki bir filex sunucusunu bu makinede bir klasöre bağlar - tarayıcının kullandığı aynı HTTPS üzerinden. Buradakilerin her yerden çalışan tek yöntemi: yerel ağ da gerekmez, ek sunucu da, üçüncü parti bir istemci de.",
  "conn.guide.mount.fact.url": "Sunucu adresi",
  "conn.guide.mount.fact.urlHint": "Tarayıcıda kullandığınız adresin aynısı. Başka hiçbir şeye erişilebilir olması gerekmez.",
  "conn.guide.mount.fact.token": "API anahtarı",
  "conn.guide.mount.fact.tokenPlaceholder": "API anahtarları bölümünden oluşturun",
  "conn.guide.mount.fact.tokenHint": "Parolanız değil, bir API anahtarı - tek başına iptal edilebilir, ayrıca 2FA açık bir hesap burada parolasını zaten kullanamaz.",
  "conn.guide.mount.fact.remote": "Neyi bağlayacağınız",
  "conn.guide.mount.fact.remoteHint": "--remote vermezseniz her depo bir klasör olarak görünür; tek bir depoyu - ya da onun içindeki bir klasörü - adlandırırsanız yalnızca o bağlanır.",
  "conn.guide.mount.linux.mountCaption": "Bağlayın",
  "conn.guide.mount.linux.umountCaption": "Ayırın",
  "conn.guide.mount.linux.umountWarn": "Süreci öldürerek değil, fusermount ile ayırın. Ayrılmadan ölen bir bağlantı, birileri elle fusermount çalıştırana kadar her ls komutunun asılı kaldığı bir klasör bırakır.",
  "conn.guide.mount.linux.systemdCaption": "Oturum açılınca otomatik bağlansın (systemd kullanıcı birimi)",
  "conn.guide.mount.win.winfsp": "Windows'ta bir kez WinFsp kurulması gerekiyor - ücretsiz ve açık kaynak: https://winfsp.dev. Başka bir şey gerekmiyor, sonrasında yönetici hakkı da istemiyor.",
  "conn.guide.mount.win.mountCaption": "Sürücü olarak bağlayın",
  "conn.guide.mount.win.freeLetter": "BOŞ bir sürücü harfi seçin. Harf bağlama sırasında oluşturulur, var olan bir şeye eklenmez; kullanımdaki bir harfi verirseniz bunu söylemeyen bir hatayla başarısız olur.",
  "conn.guide.mount.win.stop": "O pencerede Ctrl-C ile durdurun. Sürücü kaybolur ve bu makinede hiçbir şey kalmaz.",
  "conn.guide.mount.mac.unsupported": "filex mount macOS'ta çalışmıyor. macFUSE gerekiyor; lisansı filex gibi bir programın onu sizin yerinize kurmasına izin vermiyor ve Go bağlaması filex'in bilinçli olarak kullanmadığı bir C derleyicisi istiyor. Komut burada çalışıyormuş gibi görünüp hiçbir şey yapmak yerine açıkça reddediyor.",
  "conn.guide.mount.mac.alternatives": "macOS'ta filex masaüstü uygulamasını klasör eşitlemesiyle kullanın (dosyalar diskte durur) ya da sürücü bağlayabilen bir istemciyle SFTP.",
  "conn.guide.mount.note.notASync": "Bu bir eşitleme değildir. Küçük bir okuma önbelleği dışında bu makineye hiçbir şey kopyalanmaz; yüz bin dosyanın içinden birini gerisini indirmeden açar. Dosyaları çevrimdışıyken istiyorsanız klasör eşitlemesini kullanın.",
  "conn.guide.mount.note.reachable": "Sunucuya, tarayıcının geçtiği hangi vekil ya da tünel varsa oradan ulaşır - çünkü altında aynı API vardır. İzinleriniz ve depolarınız da birlikte gelir.",
  "conn.guide.mount.note.wholeFileWrites": "Bağlantı üzerinden yazdığınız dosya, yazılırken değil, program onu kapattığında yüklenir. Çok büyük bir dosyayı yerinde düzenlemek burada yerel diskten yavaştır; içeri ve dışarı kopyalamak değildir.",
  "conn.guide.mount.note.trash": "Silme her yerdeki gibi filex çöp kutusuna gider ve saklama politikası süpürene kadar geri alınabilir.",
  "conn.guide.mount.note.revoke": "Bir bağlantıyı durdurmak için API anahtarını iptal edin. Bağlantı hâlâ takılı olsa bile yarım dakika içinde hizmet vermeyi bırakır.",
  "storages.driver.ftp": "FTP / FTPS",
  "storages.driver.local": "Yerel dosya sistemi",
  "storages.driver.s3": "S3 / Hetzner / MinIO",
  "storages.driver.sftp": "SFTP",
  "storages.driver.smb": "SMB / CIFS (NAS)",
  "storages.driver.webdav": "WebDAV",
  "storages.fieldHelp.smbShare": "Sunucu adı olmadan yalnızca paylaşım adı: `\\\\nas\\media` değil, `media`.",
  "storages.fieldHelp.smbDomain": "Yalnızca Windows etki alanı hesabı için. NAS kullanıyorsanız boş bırakın.",
  "storages.fieldHelp.smbRoot": "Paylaşımın içindeki alt klasör. Paylaşımın tamamı için boş bırakın.",
  "storages.fields.share": "Paylaşım",
  "storages.fields.domain": "Etki alanı / çalışma grubu",
  "storages.fieldHelp.disablePresign": "Varsayılan olarak açık: yüklemeler ve herkese açık paylaşım bağlantılarındaki indirmeler filex üzerinden akar; kova endpoint'inin tarayıcıdan erişilebilir olması gerekmez (yalnız yerel ağdaki MinIO doğrudan çalışır). Yalnızca endpoint kullanıcıların tarayıcısından erişilebiliyorsa (AWS, herkese açık MinIO) ve tarayıcının kovayla doğrudan konuşmasını istiyorsanız kapatın - çok büyük dosyalarda daha hızlıdır, ama depo SDK'nın imzaladığı URL'leri kabul etmelidir (Ceph RGW / bazı Hetzner kurulumları SignatureDoesNotMatch döner).",
  "storages.fieldHelp.endpoint": "AWS S3 için boş bırakın. S3 uyumlu diğer tüm depolar kendi endpoint'ini ister.",
  "storages.fieldHelp.hostKey": "authorized_keys / known_hosts satır biçiminde tek bir açık anahtar.",
  "storages.fieldHelp.insecureSkipHostKey": "Her sunucu anahtarını kabul eder. Yalnızca geçici sunucular için.",
  "storages.fieldHelp.keyPath": "Sunucudaki anahtar dosyasının yolu; depo başlarken okunur. PEM alanı boşken kullanılır.",
  "storages.fieldHelp.knownHosts": "Katı sunucu anahtarı denetimi için OpenSSH known_hosts yolu. Varsayılan, ~/.filex/known_hosts içinde ilk bağlantıda güven.",
  "storages.fieldHelp.passive": "Kapatmak aktif moda geçirir; bu, sunucunun bu makineye geri bağlanmasını gerektirir.",
  "storages.fieldHelp.path": "Sunucudaki dizin. Yoksa oluşturulur; filex asla / dizinini mount etmez.",
  "storages.fieldHelp.pathStyle": "AWS dışındaki tüm depolarda açık olmalı. Endpoint girildiyse ve bu alana hiç dokunulmadıysa kendiliğinden açılır.",
  "storages.fieldHelp.prefix": "Kova içindeki alt klasör. Zorunlu: filex kova kökünün sahipliğini asla almaz.",
  "storages.fieldHelp.region": 'Boş bırakılırsa "auto" kullanılır.',
  "storages.fieldHelp.root": "Arka uçtaki alt klasör. Zorunlu: filex hesabın kökünü asla mount etmez.",
  "storages.fieldHelp.sftpAuth": "Parola ya da özel anahtardan biri zorunludur.",
  "storages.fieldHelp.tls": "Düz FTP kimlik bilgilerini açık metin gönderir - sunucu destekliyorsa açın.",
  "storages.fields.accessKey": "Access key",
  "storages.fields.basePath": "Temel yol",
  "storages.fields.bucket": "Kova",
  "storages.fields.disablePresign": "Aktarımları filex üzerinden geçir",
  "storages.fields.endpoint": "Endpoint",
  "storages.fields.host": "Sunucu",
  "storages.fields.hostKey": "Sabitlenmiş sunucu anahtarı",
  "storages.fields.insecureSkipHostKey": "Sunucu anahtarı doğrulamasını atla (güvensiz)",
  "storages.fields.keyPath": "Özel anahtar dosyası",
  "storages.fields.knownHosts": "known_hosts dosyası",
  "storages.fields.name": "Görünen ad",
  "storages.fields.namePlaceholder": "Kişisel fotoğraflar",
  "storages.fields.passive": "Pasif mod (PASV)",
  "storages.fields.password": "Parola",
  "storages.fields.path": "Dizin yolu",
  "storages.fields.pathStyle": "Path-style URL kullan (Hetzner, MinIO)",
  "storages.fields.port": "Port",
  "storages.fields.prefix": "Önek (prefix)",
  "storages.fields.privateKey": "Özel anahtar (PEM)",
  "storages.fields.rbac": "Öğe bazlı erişim denetimi (RBAC)",
  "storages.fields.rbacHint": "Açıkken yönetici olmayanlar yalnızca kendilerine yetki verilen dosya ve klasörleri görür (Klasör erişimi sayfasında listelenir). Kapalıyken herkes depoyu rolüne göre açar.",
  "storages.fields.readOnly": "Salt okunur mount",
  "storages.fields.region": "Bölge",
  "storages.fields.root": "Temel yol",
  "storages.fields.secretKey": "Secret key",
  "storages.fields.tls": "FTPS (açık AUTH TLS)",
  "storages.fields.url": "Temel URL",
  "storages.fields.user": "Kullanıcı",
  "storages.fields.s3AttemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.s3MaxAttempts": "İstek başına deneme sayısı",
  "storages.fields.s3TotalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.s3AttemptTimeout": "Tek bir denemenin depodan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, TLS el sıkışması, istek gönderildikten sonraki cevap ve cevabın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; deponun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama ve yeniden adlandırma cevap için 10 dakikaya kadar bekler, çünkü depo bunları ancak kopya bittiğinde cevaplar.",
  "storages.fieldHelp.s3MaxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: ağ hatası, zaman aşımı, 5xx cevabı, hız sınırlaması. 1 yeniden denemeyi kapatır. Bir ret (403, bulunmayan bir kova, çözümlenmeyen bir sunucu adı) hiçbir zaman yeniden denenmez.",
  "storages.fieldHelp.s3TotalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir depoya yükleme ya da listeleme, kesintiyi bu süre içinde bildirir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  "storages.fields.attemptTimeout": "Deneme zaman aşımı (saniye)",
  "storages.fields.maxAttempts": "İstek başına deneme sayısı",
  "storages.fields.totalTimeout": "Vazgeçme süresi (saniye)",
  "storages.fieldHelp.attemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir.",
  "storages.fieldHelp.webdavAttemptTimeout": "Tek bir denemenin sunucudan bir yaşam belirtisi için bekleyebileceği süre: bağlanma, oturum açma, her isteğin cevabı ve bir aktarımın her yeni parçası. İlerleyen bir aktarım, süresi ne olursa olsun hiçbir zaman kesilmez; sunucunun almayı bıraktığı bir yükleme 60 saniye sonra, bu değer daha uzunsa bu kadar sonra kesilir. Kopyalama, taşıma ve silme cevap için 10 dakikaya kadar bekler, çünkü sunucu bunları ancak iş bittiğinde cevaplar.",
  "storages.fieldHelp.maxAttempts": "Hata geçebilecek türdeyse bir isteğin toplamda kaç kez deneneceği: bağlantı reddedilir ya da kopar, cevap zamanında gelmez, sunucu şu an hizmet veremediğini söyler (5xx). 1 yeniden denemeyi kapatır. Bir ret (yanlış parola, bulunmayan bir klasör, doğrulanamayan bir sertifika) hiçbir zaman yeniden denenmez; gönderilmeye başlamış bir yükleme de yeniden denenmez.",
  "storages.fieldHelp.totalTimeout": "İlk denemeden itibaren bu kadar saniye içinde bitemeyecek yeni bir deneme başlatılmaz; böylece çalışmayan bir sunucu bu süre içinde bildirilir. Sürmekte olan bir aktarım kesilmez. Zaman aşımına uğrayan bir istek ancak bu değer deneme zaman aşımının en az iki katıysa yeniden denenir.",
  /* === gezinti:g1 - gezinti paneli (SideNav) === */
  "sidenav.title": "Gezinti",
  "sidenav.views": "Görünümler",
  "sidenav.storages": "Depolar",
  "sidenav.home": "Ana sayfa",
  "sidenav.myfiles": "Dosyalarım",
  "sidenav.recent": "Son kullanılanlar",
  "sidenav.starred": "Yıldızlılar",
  "sidenav.shared": "Benimle paylaşılanlar",
  // Üstteki satırın aynası ve tam altında durur: gelen ile giden.
  "sidenav.myshares": "Paylaştıklarım",
  "sidenav.trash": "Çöp kutusu",
  "sidenav.collapse": "Gezintiyi daralt",
  "sidenav.expand": "Gezintiyi genişlet",
  "sidenav.close": "Gezintiyi kapat",
  // ⚠ aç/kapat çifti ÇEKMECENİN, daralt/genişlet çifti yerleşik PANELİN -
  // ikisi birbirinin yerine kullanılamaz; bkz. en.ts'teki not ve Toolbar.vue
  // içindeki `navToggleLabel`. 560px altında panel listenin üzerine gelen bir
  // çekmecedir: raya inmez, hiç ekranda değildir; "genişlet" olmayan bir
  // genişliği büyütmeyi vaat ederdi.
  "sidenav.open": "Gezintiyi aç",
  "sidenav.storage.shared": "Paylaşılan",
  "sidenav.storage.readOnly": "Salt okunur",
  // #57 - depo satırının sıralama menüsü (sağ tık, uzun basış, Shift+F10).
  // "Ada göre sırala" bir mod değildir; kişinin elle düzeltmeye devam
  // edebileceği bir sıra yazar. "Varsayılan sırayı kullan" kişinin kendi
  // sırasını bırakır: panel yöneticinin sırasına (yoksa sunucununkine) döner.
  "sidenav.storage.moveUp": "Yukarı taşı",
  "sidenav.storage.moveDown": "Aşağı taşı",
  "sidenav.storage.sortName": "Ada göre sırala",
  "sidenav.storage.sortName.done": "Zaten ada göre sıralı",
  "sidenav.storage.defaultOrder": "Varsayılan sırayı kullan",
  "sidenav.storage.defaultOrder.none": "Zaten varsayılan sırada",
  // ⚠ `toolbar.nav` KALDIRILDI, yerine bir şey konmadı - bkz. en.ts'teki not.
  // Paneli daraltan tek denetimin etiketiydi; önce "Gezinti" (panelin adı,
  // düğmenin ne yaptığını söylemiyor), sonra "Gezintiyi göster/gizle" (sabit
  // geçici çözüm). Gerçek düzeltme yukarıdaki dört `sidenav.*` fiili:
  // etiket `navOpen`'a bağlı, daraltacaksa "daralt", genişletecekse
  // "genişlet" yazıyor.
  "node.home": "Ana sayfa",
  "node.recent": "Son kullanılanlar",
  "node.starred": "Yıldızlılar",
  "node.shared": "Benimle paylaşılanlar",
  "empty.recent.title": "Henüz hiçbir şey açılmadı",
  "empty.recent.hint": "Açtığınız dosyalar burada görünür",
  "empty.starred.title": "Henüz yıldızlı dosya yok",
  "empty.starred.hint": "Bir dosyayı yıldızlayın; burada bulursunuz",
  "empty.shared.title": "Sizinle henüz bir şey paylaşılmadı",
  "empty.shared.hint": "Başkalarının paylaştığı klasör ve dosyalar burada görünür",
  /* etiket:t1 */
  "sidenav.tags": "Etiketler",
  "sidenav.tags.empty": "Henüz etiket yok - bir dosyaya sağ tıklayıp Etiketler’den ekleyebilirsiniz.",
  "sidenav.tags.more": "{count} tane daha göster",
  "sidenav.tags.less": "Daha az göster",
  "sidenav.tags.personal": "Kişisel",
  "sidenav.tags.team": "Ekip",
  "empty.tag.title": "“{tag}” etiketli hiçbir şey yok",
  "empty.tag.hint": "Bir dosyaya sağ tıklayıp Etiketler’i seçin; dosya burada görünür",
  "sidenav.connections": "Bağlantılar",
  "sidenav.apps": "Uygulamalar",
  // #162 - mağaza ekranı: yöneticinin açtığı mağazaların kataloğu.
  "sidenav.appstore": "Uygulama mağazası",
  "sidenav.connect": "Bağlantılar",
  "sidenav.apikeys": "API anahtarları",
  "overlay.close": "Kapat",
  "conn.tokens.scopes": "İzinler",
  "conn.tokens.root": "Tek bir klasörle sınırla (isteğe bağlı)",
  "conn.tokens.rootPlaceholder": "depo://klasör",
  "conn.tokens.expiry": "Geçerlilik (gün)",
  "conn.tokens.expiryNever": "süresiz",
  "conn.tokens.defaultName": "API anahtarı {date}",
  "conn.tokens.namePlaceholder": "Ad - ör. yedekleme betiği",
  "conn.tokens.capNote": "Tavan kendi erişiminizdir - sahip olmadığınız bir izin reddedilir, verilmez.",
  "conn.tokens.scopesRequired": "En az bir izin seçin - hiçbir izni olmayan bir API anahtarı verilmez.",
  "conn.tokens.comments": "Yorumlar",
  "conn.tokens.commentsRead": "Okuma",
  "conn.tokens.commentsRw": "Okuma ve yazma",
  "conn.tokens.commentsHint": "Yorum eklemek ve silmek ayrı bir izindir - “write” bunu kapsamaz. Her API anahtarı yorumları okur.",
  "conn.tokens.commentsToRw": "Yorumlar: yazmaya izin ver",
  "conn.tokens.commentsToRead": "Yorumlar: yalnız okuma",
  /* === /gezinti:g1 === */
  /* === surucu:d1 - kabuk (GitHub #14); artık `uiProfile: 'drive'` ile
     gelen bir seçenek değil, her profilde çizilir === */
  "drive.new": "Yeni",
  "drive.new.upload": "Dosya yükle",
  "drive.new.folder": "Yeni klasör",
  "drive.new.request": "Dosya iste",
  "drive.new.document": "Yeni belge",
  /* === belge:n1 - "Yeni belge": + Yeni altındaki seçici ==================
     Tür adları BURADA durmuyor. Her kutucuk sözcüklerini lib/fileIcons
     `typeLabelFor`den okur - listedeki Tür sütununun okuduğu tablonun
     aynısı - böylece ".docx" iki yerde de aynı adla anılır ve yeni bir tür
     için hiç dizge gerekmez. Aşağıda yalnız bu pencerenin kendi metni var. */
  "newdoc.title": "Yeni belge",
  "newdoc.type.label": "Belge türü",
  "newdoc.group.document": "Belgeler",
  "newdoc.group.text": "Metin ve kod",
  "newdoc.group.diagram": "Çizimler",
  "newdoc.group.app": "Uygulamalar",
  /* ⚠ Her servisin tek adı, kendi projesinin kullandığı ad: draw.io
     ("drawio" ya da "diagrams.net" değil) ve ONLYOFFICE. */
  "newdoc.empty.title": "Kullanılabilir belge türü yok",
  "newdoc.empty.body": "Bu sunucu, bu uygulamanın oluşturabileceği bir tür sunmadı.",
  "newdoc.empty.blocked": "Bu sunucunun oluşturabildiği her tür, burada tanımlı olmayan bir düzenleyici servisine bağlı.",
  "newdoc.name": "Ad",
  "newdoc.name.placeholder": "Dosya adı, ör. notlar.txt ya da LICENSE",
  "newdoc.untitled": "Adsız",
  "newdoc.err.slash": "Ad eğik çizgi içeremez.",
  "newdoc.err.exists": "{name} burada zaten var. Başka bir ad seçin.",
  "newdoc.err.bare_ext": "Dosyaya yalnız bir uzantı değil, bir ad verin.",
  "newdoc.err.ext_needs_type": ".{ext} dosyası kendi türüyle oluşturulmalı - boş bir dosya açılmaz. O türü ya da başka bir uzantıyı seçin.",
  "newdoc.hint.ext_added": "Bu tür uzantısını korur; dosya {name} adıyla oluşturulacak.",
  // Drafts (issue #71): a new document is a draft until its first save.
  "sidenav.drafts": "Taslaklar",
  "sidenav.drafts.count": "{n} taslak",
  "sidenav.drafts.count_one": "{n} taslak",
  "node.drafts": "Taslaklar",
  "empty.drafts.title": "Taslak yok",
  "empty.drafts.hint": "Yeni bir belge, ait olduğu yere kaydedilene kadar burada bekler.",
  "drafts.lead": "Henüz kaydedilmemiş yeni belgeler. Bunları yalnızca siz görebilirsiniz.",
  "drafts.count_of": "{n} / {limit} taslak",
  "drafts.col.target": "Kaydedileceği yer",
  "drafts.col.storage": "Depo",
  "drafts.action.save": "Diske kaydet",
  "drafts.open_hint": "{name} dosyasını aç",
  "drafts.no_match": "Filtreye uyan taslak yok.",
  "draft.badge": "Taslak",
  "draft.bar.target": "{folder} konumuna kaydedilecek",
  "draft.save": "Kaydet",
  "draft.saved_to": "{name}, {folder} konumuna kaydedildi.",
  "draft.discarded": "{name} çöp kutusuna taşındı.",
  "draft.kept": "Taslaklarda tutuluyor",
  "draft.editing": "Düzenleniyor…",
  "draft.close.title": "Bu taslak kapatılsın mı?",
  "draft.close.body": "{name}, {folder} için bir taslak ve henüz oraya kaydedilmedi.",
  "draft.close.hint": "Tutulan taslak Taslaklar’da bekler. Çöpe at, taslağı çöp kutusuna taşır.",
  "draft.close.save": "Diske kaydet",
  "draft.close.keep": "Taslaklarda tut",
  "draft.close.discard": "Çöpe at",
  "outside.title": "Bu dosya dışarıda değişti",
  "outside.body": "{name} burada açıkken başka bir yerde değiştirildi ve bu düzenleyicide de değişiklikler var. Hangi sürüm kalsın?",
  "outside.theirs": "Dışarıdakini koru",
  "outside.theirs_hint": "burada yapılan değişiklikler atılır, dışarıdaki sürüm yüklenir.",
  "outside.mine": "Benimkini yaz",
  "outside.mine_hint": "kaydedildiğinde sizin sürümünüz dışarıdakinin üstüne yazılır.",
  "outside.both": "İkisini de tut",
  "outside.both_hint": "dışarıdaki sürüm yerinde kalır, sizinki yanına ayrı bir kopya olarak kaydedilir (ad.filex-conflict-zaman).",
  "outside.hint": "Siz seçene kadar hiçbir sürümün üstüne yazılmaz.",
  "outside.pending": "Bu dosya dışarıda değişti. Hangi sürümün kalacağını seçene kadar hiçbir sürümün üstüne yazılmaz.",
  "outside.choose": "Seç…",
  "outside.note.reloaded": "Dosya dışarıda güncellendi, yeni sürüm yüklendi.",
  "outside.note.theirs": "Dışarıdaki sürüm yüklendi; burada yapılan değişiklikler atıldı.",
  "outside.note.mine": "Sizin sürümünüz kaydedildiğinde dışarıdakinin üstüne yazılacak.",
  "outside.note.both": "Dışarıdaki sürüm yerinde kalıyor; sizinki kaydedildiğinde yanına ayrı bir kopya olarak yazılacak.",
  "draft.taken.title": "Bu adda bir dosya zaten var",
  "draft.taken.body": "{folder} konumunda {name} adında bir dosya zaten var. Taslak {suggested} olarak kaydedilsin mi?",
  "draft.taken.confirm": "{name} olarak kaydet",
  "upload.taken.body": "{folder} konumunda {name} adında bir öğe zaten var ve kasa eski sürümleri saklamaz. {suggested} olarak yüklensin mi?",
  "upload.taken.confirm": "{name} olarak yükle",
  "newdoc.hint.draft": "Taslak olarak açılır: siz kaydedene kadar klasörde hiçbir şey oluşturulmaz.",
  "newdoc.err.draft_limit": "Bu sunucunun izin verdiği kadar taslağınız var ({limit}). Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.err.draft_limit_any": "Bu sunucunun izin verdiği sayıda taslağınız var. Önce Taslaklar’da bazılarını kaydedin ya da silin.",
  "newdoc.open_drafts": "Taslakları aç",
  "newdoc.location": "Konum",
  "newdoc.location.none": "Bir klasör seçin",
  "newdoc.location.change": "Değiştir",
  "newdoc.location.noaccess": "Bu klasöre kaydedemezsiniz.",
  "newdoc.create": "Oluştur",
  "newdoc.creating": "Oluşturuluyor…",
  "newdoc.cancel": "Vazgeç",
  "drive.search.placeholder": "{scope} deposunda ara",
  "drive.search.placeholder_all": "Tüm depolarda ara",
  "drive.search.hint_title": "Her yerde ara ve komut çalıştır ({combo})",
  "drive.storage.used": "{total} alanın {used} kadarı dolu",
  "drive.storage.used_unlimited": "{used} kullanılıyor",
  "drive.storage.used_partial": "en az {used} kullanılıyor",
  "drive.storage.label": "Depolama",
  /* === gorunum:v3-shell - Ana sayfa görünümü (kabuğun içindeki genel bakış)
   * Bölüm başlıkları `sidenav.storages` / `sidenav.recent` / `sidenav.starred`,
   * boş durumlar da `empty.recent.*` / `empty.starred.*` - bilerek: Ana
   * sayfadaki "Son kullanılanlar" başlığı ile yanındaki panel satırı aynı
   * şeydir, ikisine ayrı metin yazmak onları çeviri çeviri birbirinden
   * ayırmanın yoludur. Aşağıda yalnızca başka hiçbir yerde olmayanlar var. */
  "home.title": "Ana sayfa",
  "home.storages.empty": "Henüz depo yok",
  "home.storages.hint": "Depo, filex’in okuyup yazdığı yerdir - depoları yönetici ekler.",
  "drive.section.folders": "Klasörler",
  "drive.section.files": "Dosyalar",
  "filter.aria": "Filtreler",
  "filter.type": "Tür",
  "filter.type.any": "Her tür",
  "filter.type.folder": "Klasörler",
  "filter.type.document": "Belgeler",
  "filter.type.spreadsheet": "Hesap tabloları",
  "filter.type.presentation": "Sunumlar",
  "filter.type.pdf": "PDF’ler",
  "filter.type.image": "Görseller",
  "filter.type.video": "Videolar",
  "filter.type.audio": "Ses dosyaları",
  "filter.type.archive": "Arşivler",
  "filter.type.code": "Kod",
  "filter.modified": "Değiştirilme",
  "filter.modified.any": "Her zaman",
  "filter.modified.today": "Bugün",
  "filter.modified.7d": "Son 7 gün",
  "filter.modified.30d": "Son 30 gün",
  "filter.modified.year": "Bu yıl",
  "filter.size": "Boyut",
  "filter.size.any": "Her boyut",
  "filter.size.lt1": "1 MB altı",
  "filter.size.1to10": "1 - 10 MB",
  "filter.size.10to100": "10 - 100 MB",
  "filter.size.gt100": "100 MB üstü",
  /* surucu:d1-actions - filtre satırının sonundaki ⋮ menüsü. Yalnızca menünün
     KENDİ adı yeni: içindeki her satır o eylemin zaten sahip olduğu metni
     kullanır (`toolbar.new_folder`, `toolbar.upload`, `ctx.paste`,
     `shortcuts.select_all`, `selection.clear`) - bir komutu yeniden adlandıran
     menü, okuyucuya aynı şeyi iki kez öğretir. */
  "filter.actions": "Liste işlemleri",
  "filter.clear": "Filtreleri temizle",
  "filter.empty.title": "Bu filtrelere uyan bir şey yok",
  "filter.empty.hint": "Bir filtreyi kaldırın ya da yukarıdaki alandan her yerde arayın.",
  "filter.count": "{total} öğeden {shown} tanesi",
  "inspector.tab.details": "Ayrıntılar",
  "inspector.tab.activity": "Etkinlik",
  "inspector.people": "Erişimi olan kişiler",
  "inspector.people.you": "Siz",
  "inspector.people.inherited": "üst klasörden",
  "inspector.people.empty": "Yalnızca siz ve aşağıdaki bağlantıya sahip olanlar.",
  "inspector.people.manage": "Erişimi yönet",
  "inspector.link": "Paylaşım bağlantısı",
  "inspector.link.none": "Paylaşılmadı",
  "inspector.link.create": "Bağlantı oluştur",
  "inspector.link.copy": "Bağlantıyı kopyala",
  "inspector.activity.empty": "Bu öğe için henüz etkinlik kaydı yok.",
  "inspector.activity.hint": "Sürümler dosya değiştikçe, yorumlar ise insanlar yazdıkça birikir.",
  "inspector.activity.version": "{n}. sürüm kaydedildi",
  "inspector.activity.comment": "{who} yorum yaptı",
  "inspector.activity.select": "Etkinliğini görmek için bir dosya ya da klasör seçin.",
  /* === /surucu:d1 === */
  /* === gorunum:v1-chrome - filtre satırındaki ad kutusu === */
  "filter.find": "Bu klasörde filtrele…",
  /* surucu:d1-scope - satırların bir klasörün içeriği olmadığı yerlerde aynı
     kutu. Neyi daralttığını söylemek zorunda: depo listesinde "bu klasör" hiçbir
     şeyi adlandırmaz, Ana sayfada ise üç bloğu birden adlandırırdı. */
  "filter.find.storages": "Depolarda filtrele…",
  "filter.find.home": "Ana sayfada filtrele…",
  /* === gorunum:v1-viewer - tam ekran görüntüleyicinin kendi çerçevesi === */
  "viewer.share": "Paylaş",
  "viewer.nav_prev": "Önceki dosya",
  "viewer.nav_next": "Sonraki dosya",
  /* Üst çubuğun künye satırındaki sayaç: "246,3 KB • 9 Eyl 2026 • 1 / 9". */
  "viewer.counter": "{i} / {n}",
  "viewer.zoom_reset": "Yakınlaştırmayı sıfırla",
  "viewer.fullscreen": "Tam ekran",
  "viewer.exit_fullscreen": "Tam ekrandan çık",
  "viewer.md_placeholder": "# Markdown buraya…",
  /* === gorunum:v1-selbar - filtre satırının yerini alan seçim çubuğu === */
  "selection.count": "{n} seçildi",
  "selection.clear": "Seçimi temizle",
  /* === gorunum:v1-preview - türün adı, kelimeyle =======================
     Tür sütunu eskiden uzantıyı büyük harfle yazıyordu; artık bunları
     yazıyor. Hangisinin seçileceğine `lib/fileIcons.ts` karar verir
     (`typeLabelKey`) - bir türü adlandıran yalnız iki yer var: o tablo ve bu
     liste. Eşleşmeyen her şey yine büyük harfli uzantıya düşer. `Klasör`
     burada DEĞİL: o `node.folder`, grid kartının alt yazısı zaten onu basar. */
  "ftype.typescript": "TypeScript",
  "ftype.javascript": "JavaScript",
  "ftype.vue": "Vue bileşeni",
  "ftype.python": "Python",
  "ftype.go": "Go",
  "ftype.rust": "Rust",
  "ftype.php": "PHP",
  "ftype.ruby": "Ruby",
  "ftype.java": "Java",
  "ftype.kotlin": "Kotlin",
  "ftype.swift": "Swift",
  "ftype.c": "C kaynağı",
  "ftype.cpp": "C++ kaynağı",
  "ftype.csharp": "C# kaynağı",
  "ftype.stylesheet": "Stil dosyası",
  "ftype.html": "HTML belgesi",
  "ftype.json": "JSON verisi",
  "ftype.yaml": "YAML",
  "ftype.xml": "XML",
  "ftype.toml": "TOML",
  "ftype.sql": "SQL",
  "ftype.shell": "Kabuk betiği",
  "ftype.powershell": "PowerShell betiği",
  "ftype.markdown": "Markdown",
  "ftype.plaintext": "Düz metin",
  "ftype.log": "Günlük dosyası",
  "ftype.config": "Ayar dosyası",
  "ftype.sheet": "Hesap tablosu",
  "ftype.drawio": "draw.io diyagramı",
  "ftype.figma": "Figma tasarımı",
  "ftype.design": "Tasarım dosyası",
  "ftype.image": "Görsel",
  "ftype.video": "Video",
  "ftype.audio": "Ses",
  "ftype.pdf": "PDF belgesi",
  "ftype.document": "Belge",
  "ftype.slides": "Sunum",
  "ftype.archive": "Arşiv",
  "ftype.code": "Kod",
  /* === gorunum:v1-advsearch - Gelişmiş arama penceresi ===================
   * İki `filter.*` anahtarı kardeşlerinin yanında değil burada: paylaşılan
   * birleşimlere pencerenin eklediği yeni üyeler (`modified: 'around'`,
   * `size: 'range'`). Filtre satırı bunları hiç seçmez ama biri oraya
   * ulaşırsa `chipLabel` ham anahtarı yazardı. */
  "filter.modified.around": "Bir tarihin çevresinde",
  "filter.size.range": "Özel aralık",
  "advsearch.open": "Gelişmiş arama",
  "advsearch.title": "Gelişmiş arama",
  "advsearch.subtitle": "Dosyaları ada, içeriğe, yola ya da etikete göre bulun.",
  "advsearch.close": "Kapat",
  "advsearch.content.heading": "İçerik araması",
  "advsearch.viewall": "Tüm sonuçları gör",
  "advsearch.where.any_short": "Her yerde",
  "advsearch.where.here_short": "Yalnız burada",
  "advsearch.where.skip_short": "Burayı atla",
  "advsearch.server.legend": "Sunucunun aradığı",
  "advsearch.client.legend": "Gelen sonuçları daralt",
  "advsearch.query.label": "Kelimeler",
  "advsearch.query.placeholder": "Adın bir parçası ya da dosyanın içindeki kelimeler",
  "advsearch.scope.label": "Nerede arasın",
  "advsearch.scope.name": "Ad ve yol",
  "advsearch.scope.content": "Dosya içeriği",
  "advsearch.scope.all": "İkisi de",
  "advsearch.scope.hint": "İçerik, dizinden aranır; dizin metin türü dosyaların ilk 200 KB’ını kapsar.",
  "advsearch.people.name_only": "Sahip, gelen satırlardan okunur; sahip bilgisi taşıyan satırları da yalnız ad araması döndürür.",
  "advsearch.scope.name_only": "Burada yalnız ad ve yol: içerik sonucu gezgine hangi depodan geldiği bilgisi olmadan ulaşır, bu yüzden içerik araması yalnız tek depolu kurulumlarda sunulur.",
  "advsearch.tags.label": "Etiketler",
  "advsearch.tags.placeholder": "fatura, üç aylık rapor",
  "advsearch.tags.exclude": "Şu etiketler hariç",
  "advsearch.tags.exclude_placeholder": "arşiv",
  "advsearch.tags.hint": "Virgülle ayırın. Etiket daraltır: birden çok etiket hepsini birden taşıyan dosyalar demektir, hiç kullanılmamış bir etiket ise hiçbir şey döndürmez. Bir ad, o adı taşıyan kişisel etiketinizi de ekibinizin etiketini de bulur.",
  "advsearch.where.label": "Klasör",
  "advsearch.where.any": "Bu deponun her yerinde",
  "advsearch.where.here": "Yalnız {folder} içinde",
  "advsearch.where.skip": "{folder} dışındaki her yerde",
  "advsearch.around.label": "Şu kadar içinde",
  "advsearch.around.date": "Tarih ve saat",
  "advsearch.around.h1": "1 saat",
  "advsearch.around.d1": "1 gün",
  "advsearch.around.w1": "1 hafta",
  "advsearch.size.range_label": "Şunun arasında",
  "advsearch.size.from": "En az",
  "advsearch.size.to": "En çok",
  "advsearch.count.idle": "Bir şeyler yazın ya da etiket seçin.",
  "advsearch.count.counting": "Sayılıyor…",
  "advsearch.count.result": "{n} eşleşen öğe",
  "advsearch.count.capped": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.result_one": "{n} eşleşen öğe",
  "advsearch.count.capped_one": "Sonuçların ilk sayfasında {n} eşleşen öğe",
  "advsearch.count.error": "Sayım çalıştırılamadı.",
  "advsearch.count.cost": "Sayım bu aramayı çalıştırır. Tür, sahip, tarih, boyut ve klasör bulduğu sonuçları daraltır.",
  "advsearch.wire": "Bir dahaki sefere arama kutusuna şunu yazabilirsiniz:",
  "advsearch.reset": "Sıfırla",
  "advsearch.cancel": "Vazgeç",
  "advsearch.submit": "Ara",
  /* === gorunum:v2-topbar - sayfanın üst barı kalktı; onun taşıdıklarını
     artık gezginin kendi başlığı ve kırıntı satırı taşıyor. === */
  "breadcrumb.subfolders": "Alt klasörler",
  "breadcrumb.subfolders.empty": "Burada alt klasör yok",
  "header.admin": "Yönetim paneli",
  "header.settings": "Ayarlar",
  "header.signout": "Oturumu kapat",
  "ai.assistant": "AI asistanı",
  "assistant.new": "Yeni konuşma",
  "assistant.history": "Konuşmalar",
  "assistant.history_empty": "Henüz konuşma yok.",
  "assistant.close": "Asistanı kapat",
  "assistant.delete": "Bu konuşmayı sil",
  "assistant.intro": "Asistandan dosyalarınızı bulmasını, okumasını, özetlemesini, düzenlemesini ya da taşımasını isteyin. Yalnız sizin izinlerinizle çalışır. Geri alınabilen değişiklikler hemen yapılır ve Geri al bağlantısı bırakır; geri alınamayan her şey onayınızı bekler. Şifreli klasörler ve kasa ona hiçbir zaman gönderilmez.",
  "assistant.placeholder": "Dosyalarınız hakkında sorun...",
  "assistant.send": "Gönder",
  "assistant.stop": "Durdur",
  "assistant.working": "Çalışıyor...",
  "assistant.with_selection": "Seçili {count} öğeyle birlikte",
  "assistant.with_selection_one": "Seçili {count} öğeyle birlikte",
  "assistant.approve": "Onayla",
  "assistant.decline": "Reddet",
  "assistant.undo": "Geri al",
  /* gorunum:v2-share - Paylaş / İzinler penceresinin kendi çerçevesi. İçindeki
     denetimler eski metinlerini koruyor; buradakiler yeni kabuk: başlık, tek
     anahtar, "şu anda kim açabilir" cümlesi ve her şeyin katlandığı üç adlı
     bölüm. */
  "access.title": '"{name}" paylaşımı',
  "access.title_storage": '"{name}" erişimi',
  "access.close": "Kapat",
  "access.done": "Bitti",
  "access.copy": "Kopyala",
  "access.copied": "Kopyalandı",
  "access.link.switch": "Bağlantı paylaşımı",
  "access.who.private": "Yalnızca erişimi olan kişiler açabilir.",
  "access.who.link": "Bağlantıyı bilen herkes açabilir.",
  "access.who.pin": "Bağlantıyı ve PIN'i bilen herkes açabilir.",
  "access.who.existing": "Bağlantı paylaşımı açık - {n} bağlantı var.",
  "access.who.existing_one": "Bağlantı paylaşımı açık - {n} bağlantı var.",
  "access.section.link": "Bağlantı seçenekleri",
  "access.section.people": "Erişimi olanlar",
  "access.section.drop": "Dosya iste",
  "access.sum.pin_on": "PIN var",
  "access.sum.pin_off": "PIN yok",
  "access.sum.people": "{n} kişi",
  "access.sum.people_one": "{n} kişi",
  "access.sum.people_none": "Henüz kimse yok",
  "access.sum.groups": "{n} grup",
  "access.sum.groups_one": "{n} grup",
  "access.sum.drop": "{n} yükleme bağlantısı",
  "access.sum.drop_one": "{n} yükleme bağlantısı",
  "access.sum.drop_none": "Yükleme bağlantısı yok",
  /* Sahiplik - Sahibi sütunu ve Kişiler çipi. "Sistem", filex üzerinden kimsenin
     koymadığı satırın dürüst karşılığıdır (tarayıcı buldu ya da doğrudan kovaya
     yazıldı); boşluk değil, gerçek bir cevaptır. */
  "col.owner": "Sahibi",
  "owner.you": "Siz",
  "owner.system": "Sistem",
  "owner.unknown": "Bilinmiyor",
  "owner.external": "Yükleme bağlantısıyla geldi",
  "owner.last_actor": "Son değiştiren: {who}",
  "filter.people": "Sahibi",
  "filter.people.any": "Herkes",
  "filter.people.me": "Siz",
  "filter.people.system": "Sistem",
  "filter.people.someone": "Başka biri",
  /* surucu:d1-sort - filtre satırının sağ ucundaki sıralama denetimi. Dört
     ölçütün adı `col.*`: menü, liste görünümünün sütun başlıklarındaki
     sözcüklerin aynısını sunar - tek bir sıralamayı süren iki denetim onu
     farklı adlarla anamaz. */
  "sort.by": "Sıralama ölçütü",
  "sort.asc": "Artan",
  "sort.desc": "Azalan",
  /* Bir ARAMA SONUCUNUN sırası. Beşinci bir sıralama ölçütü değildir -
     ekrandaki satırları sunucu sıraladığında denetim, ölçüt adı yerine bunu
     yazar; böylece yapmadığı bir sıralamayı üstlenmez. `_why` denetimin neden
     kapalı olduğudur: bakımcı, denetimin sessizce işlevsizleşmesini değil
     nedeninin yazılmasını istedi. */
  "sort.relevance": "Alaka",
  "sort.relevance_why": "Arama sonuçları eşleşme yakınlığına göre listelenir. Seçtiğiniz sıralama, aramadan çıkınca geri gelir.",
  /* === tablo:t1 - tablonun kendi yapılandırması ==========================
     v0.43'ten beri bir klasörün görünüşüne dair her şey - görünüm, sıralama VE
     sütunlar - değiştirildiği klasöre aittir; kimsenin değiştirmediği klasör
     kişinin varsayılanıyla (ayarlarından), o yoksa kurulumunkiyle açılır.
     `folder_hint` bu kuralı tek cümlede, tam da ona şaşıracak kişinin
     okuyabileceği yerde söyler. */
  "col.location": "Konum",
  "col.deleted": "Silinme",
  "col.deleted_from": "Silindiği yer",
  "col.deleted_by": "Silen",
  "col.remaining": "Kalan süre",
  "cols.menu": "Sütun seçenekleri",
  "cols.title": "Sütunlar",
  "cols.resize": "{col} sütununu yeniden boyutlandır",
  "cols.sort_by": "{col} sütununa göre sırala",
  "cols.move_left": "{col} sütununu sola taşı",
  "cols.move_right": "{col} sütununu sağa taşı",
  "cols.reset": "Sütunları sıfırla",
  "cols.folder_title": "Klasör görünümü",
  "cols.folder_hint": "Burada yaptığınız değişiklik bu klasörde kalır. Hiç değiştirmediğiniz klasörler varsayılan görünümünüzle açılır (Ayarlar → Varsayılan klasör görünümü).",
  "cols.forget_folder": "Bu klasörün görünümünü unut",
  "cols.apply_all": "Bunu tüm klasörler için varsayılanım yap ({count} klasör hatırlanıyor)",
  /* === tablo:t3 - TEK TABLO (components/DataTable.vue) ====================
     Üründeki her tablo bunları konuşur; Türkçe bir sayfada sütun menüsü ya da
     sayfalayıcı İngilizce kalmasın. */
  "table.empty": "Henüz burada bir şey yok",
  "table.prev": "Önceki sayfa",
  "table.next": "Sonraki sayfa",
  "table.sort_paged": "Bu liste sayfalara bölünmüş. Sıralama yalnızca ekrandaki sayfayı yeniden dizerdi, bu yüzden burada kapalı - listeyi arama ya da filtrelerle daraltın.",
  /* === tablo:t1 - çöp kutusu bilgi şeridi ================================
     ⚠ `retention` yalnızca kurulum bize sayıyı SÖYLEDİĞİNDE kullanılır
     (GET /api/admin/protection). Diğer her durumda `retention_unknown` aynı
     şeyi, doğrulayamadığımız bir süreyi taahhüt etmeden söyler: yanlış saklama
     süresi yazan bir şerit, hiç şerit olmamasından kötüdür - insanlar ona
     bakıp karar verir. */
  "trash.retention": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_one": "Çöp kutusundaki öğeler {days} gün sonra kalıcı olarak silinir.",
  "trash.retention_unknown": "Çöp kutusundaki öğeler, yöneticinizin belirlediği saklama süresi dolunca kalıcı olarak silinir.",
  "trash.empty_action": "Çöp kutusunu boşalt",
  "trash.empty_confirm_title": "Çöp kutusu boşaltılsın mı?",
  "trash.empty_counting": "Çöp kutusundakiler sayılıyor…",
  "trash.show_more": "Daha fazla göster",
  "trash.shown_of": "{total} öğenin {shown} tanesi gösteriliyor",
  "trash.days_remaining": "{n} gün",
  "trash.days_remaining_one": "{n} gün",
  "trash.days_remaining_due": "Silinmek üzere",
  "trash.deleted_by_nobody": "Kayıt yok: virüs taraması karantinaya almış ya da filex bunu tutmaya başlamadan önce silinmiş",
  "empty.trash.hint": "Sildiğiniz dosyalar önce buraya düşer, böylece geri alabilirsiniz.",
  /* tasi:m1 - hedef klasör seçici (modals/DestinationPickerModal.vue) ve
     üzerine kurulan iki seçim eylemi. */
  "destpicker.title.move": "Şuraya taşı",
  "destpicker.title.copy": "Şuraya kopyala",
  "destpicker.title.choose": "Klasör seç",
  "destpicker.confirm.move": "Buraya taşı",
  "destpicker.confirm.copy": "Buraya kopyala",
  "destpicker.confirm.choose": "Bu klasörü seç",
  "destpicker.title.choose_file": "Dosya seç",
  "destpicker.confirm.choose_file": "Bu dosyayı seç",
  "destpicker.title.save": "Şuraya kaydet",
  "destpicker.confirm.save": "Buraya kaydet",
  "destpicker.pick_a_file": "Listeden bir dosya seçin.",
  "destpicker.empty_files": "Bu klasör boş",
  "destpicker.cancel": "Vazgeç",
  "destpicker.up": "Bir üst klasör",
  "destpicker.crumbs": "Konum",
  "destpicker.drives": "Depolar",
  "destpicker.loading": "Yükleniyor…",
  "destpicker.empty": "Burada alt klasör yok",
  "destpicker.unreadable": "Bu klasör açılamıyor.",
  "destpicker.readonly": "Salt okunur",
  "destpicker.readonly_here": "Bu klasöre yazamazsınız.",
  "destpicker.pick_a_drive": "Bir klasör seçmek için önce bir depo açın.",
  "destpicker.target": "Hedef: {name}",
  "destpicker.tag.blocked": "Uygun değil",
  "destpicker.blocked.self": "Bir klasör kendi içine taşınamaz.",
  "destpicker.blocked.descendant": "Bir klasör kendi alt klasörlerinden birine taşınamaz.",
  "destpicker.tag.vault": "Kasa",
  "destpicker.blocked.vault_in": "Buradan kasaya bir şey konmaz: kasanın içinden yükleyin.",
  "destpicker.blocked.vault_out": "Kasadakiler yalnız o kasanın içinde taşınır. Dışarı almak için indirin.",
  "ctx.move_to": "Şuraya taşı…",
  "ctx.copy_to": "Şuraya kopyala…",
  "ctx.access.one_only": "Paylaşım aynı anda tek öğe için çalışır.",
  "ctx.storage_access": "Erişim…",
  "toast.archive.preparing": "Arşiv hazırlanıyor…",
  "toast.archive.started": "{name} indiriliyor ({count} dosya)",
  "toast.archive.started_one": "{name} indiriliyor ({count} dosya)",
  "toast.archive.empty": "İndirilecek bir şey yok - seçimde okunabilir dosya bulunmuyor.",
  "toast.moved_to": "{name} klasörüne taşıma kuyruğa alındı",
  "toast.copied_to": "{name} klasörüne kopyalama kuyruğa alındı",
  "toast.already_there": "Seçilen öğeler zaten {name} içinde - hiçbir şey gönderilmedi",
  /* ── dil:paket - bkz. en.ts */
  "ctx.tags_menu": "Etiketler…",
  "toast.node_id_copied": "Node id {id} kopyalandı",
  "toast.read_only_here": "Burada yazma yetkiniz yok",
  "recents.title": "Son açılanlar",
  "recents.refresh": "Yenile",
  "recents.empty": "Henüz bir şey yok.",
  "recents.loading": "Yükleniyor…",
  "recents.close": "Kapat",
  "tags.title": "Etiketler",
  "tags.close": "Kapat",
  "share.ttl.never": "Bu bağlantının süresi yoktur.",
  "share.ttl.until": "Bu bağlantı {when} tarihine kadar geçerli.",
  "share.ttl.ceiling": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  "share.ttl.ceiling_one": "Bağlantılar en fazla {days} gün geçerli olabilir (sunucu ayarı).",
  /* ── dil:paket - paylaşım / erişim penceresi (bkz. en.ts) */
  "access.ui.level_viewer": "Görüntüleyen",
  "access.ui.level_viewer_desc": "görüntüle + indir",
  "access.ui.level_editor": "Düzenleyen",
  "access.ui.level_editor_desc": "oku + yaz + sil",
  "access.ui.level_owner": "Sahip",
  "access.ui.level_owner_desc": "düzenle + izin yönet",
  "access.ui.never": "Süresiz",
  "access.ui.days": "{days} gün",
  "access.ui.days_one": "{days} gün",
  "access.ui.unlimited": "Sınırsız",
  "access.ui.downloads": "{count} indirme",
  "access.ui.downloads_one": "{count} indirme",
  "access.ui.inherited_from": "Üst klasörden gelir",
  "access.ui.whole_storage": "Tüm depo",
  "access.ui.storage_root_hint": "Buraya eklenen herkes bu depodaki her dosya ve klasöre erişir: web arayüzünde, masaüstü uygulamasında ve her protokolde. İçindeki klasör yetkileri olduğu gibi kalır; ikisi birden geçerliyse yüksek olan sayılır.",
  "access.ui.access_granted": "Yetki verildi.",
  "access.ui.enter_a_valid_email": "Geçerli bir e-posta girin.",
  "access.ui.recipient_lang": "Alıcının dili",
  "access.ui.recipient_lang_server": "Sunucunun dili",
  "access.ui.user_created_invite_emailed": "Kullanıcı açıldı, davet e-postası gönderildi.",
  "access.ui.user_created_share_the_temp_password": "Kullanıcı açıldı. Geçici parolayı iletin.",
  "access.ui.server_limit_applied": "(sunucu sınırı uygulandı)",
  "access.ui.protect_with_a_pin": "PIN ile koru",
  "access.ui.expiry": "Süre",
  "access.ui.download_limit": "İndirme limiti",
  "access.ui.create_link": "Bağlantı oluştur",
  "access.ui.replace_link": "Bağlantıyı bu ayarlarla yenile",
  "access.ui.replace_link_hint": "Adres değişir: şu anki bağlantı çalışmayı bırakır.",
  "access.ui.create_then_send": "Bir bağlantı oluşturun, ardından {email} adresine gönderin.",
  "access.ui.command_line": "Komut satırı",
  "access.ui.share": "Paylaş",
  "access.ui.existing_links": "Mevcut bağlantılar",
  "access.ui.rbac_off_here": "Bu depoda öğe bazlı erişim denetimi kapalı - herkes depoyu rolüne göre açar, burada eklenen kişiler bir şey değiştirmez. Yönetim panelinde Depolar altından (bu depo → Öğe bazlı erişim denetimi) açın.",
  "access.ui.other_links": "Diğer bağlantılar",
  "access.ui.revoke": "İptal",
  "access.ui.loading": "Yükleniyor…",
  "access.ui.name_or_email": "Ad ya da e-posta",
  "access.ui.add": "Ekle",
  "access.ui.no_account_for_this_email_what_next": "Bu e-postada hesap yok. Ne yapmak istersiniz?",
  "access.ui.user": "Kullanıcı",
  "access.ui.viewer": "Görüntüleyen",
  "access.ui.create_user_grant": "Kullanıcı oluştur + yetki ver",
  "access.ui.just_send_a_share_link": "Yalnızca paylaşım bağlantısı gönder →",
  "access.ui.temp_password": "Geçici parola:",
  "access.ui.people_with_access": "Erişimi olanlar",
  "access.ui.group": "Grup",
  "access.ui.group_title": "“{name}” grubu - içindeki herkes",
  "access.ui.group_owner_confirm": "Sahip düzeyi, “{name}” grubundaki herkesin buraya kimin erişebileceğini yönetmesine izin verir - başka kişi ve gruplarla paylaşmak dâhil. Gruba Sahip verilsin mi?",
  "access.ui.group_owner_give": "Sahip yap",
  "access.ui.not_shared_with_anyone_yet": "Henüz kimseyle paylaşılmadı.",
  "access.ui.remove": "Kaldır",
  "access.ui.a_public_link_that_lets_anyone_upload_fi": "Bu klasöre herkesin dosya YÜKLEYEBİLECEĞİ herkese açık bir bağlantı. Yükleyenler klasördeki mevcut dosyaları göremez.",
  "access.ui.hide_upload_limits": "Yükleme sınırlarını gizle",
  "access.ui.upload_limits": "Yükleme sınırları",
  "access.ui.max_files": "En fazla dosya",
  "access.ui.mb_file": "Dosya başı MB",
  "access.ui.allowed_types": "İzinli türler",
  "access.ui.all_e_g_pdf_jpg": "hepsi (örn. pdf, jpg)",
  "access.ui.ask_uploader_name": "Yükleyenin adını sor",
  "access.ui.emails_comma_separated": "e-posta(lar) - virgülle ayırın",
  "access.ui.send": "Gönder",
  "access.ui.mail_not_set_up": "E-posta kurulu değil - yönetim panelinde Ayarlar altından (E-posta / SMTP) kurun.",
  /* ── wiring:e2 fxe - tek şifreli dosyalar (.fxe), akışlı indirmeler ── */
  "e2e.fxe.type": "Şifreli dosya",
  "e2e.fxe.ctx_encrypt": "E2EE ile şifrele…",
  "e2e.fxe.ctx_download_raw": "Şifreli dosyayı indir",
  "e2e.fxe.ctx_password": "Parolayı değiştir…",
  "e2e.fxe.ctx_remove": "Şifrelemeyi kaldır…",
  "e2e.fxe.encrypt_title": "Bu dosyayı şifrele",
  "e2e.fxe.encrypt_lead": "“{name}” bu tarayıcıda, kendine ait bir parolayla şifrelenir. Sunucu yalnızca şifreli veriyi saklar. Dosyayı parola ya da kurtarma anahtarı açar - burada ya da çevrimdışı olarak filex decrypt ile.",
  "e2e.fxe.pw_label": "Dosya parolası",
  "e2e.fxe.hide_label": "Dosya adını da gizle",
  "e2e.fxe.hide_on_hint": "“{stored}” olarak saklanır: sunucu ne adı ne de türü görür. Gerçek ad dosyanın içinde mühürlüdür; dosyayı burada açınca görünür.",
  "e2e.fxe.hide_off_hint": "“{stored}” olarak saklanır: ad sunucu tarafından okunabilir kalır, içerik kalmaz.",
  "e2e.fxe.seen_title": "Sunucunun zaten gördükleri",
  "e2e.fxe.seen_lead": "Bu dosya şimdiye kadar şifresiz saklandı ve şifrelemek bunu geri almaz:",
  "e2e.fxe.seen_trash": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana ya da bir yönetici boşaltana kadar orada kalır. Kalıcı olarak kendiniz silemezsiniz.",
  "e2e.fxe.seen_versions": "Önceki sürümleri sürüm geçmişinde kalır; onları yalnızca bir yönetici silebilir.",
  "e2e.fxe.seen_thumb": "Ondan üretilmiş bir küçük resim, asıl dosya kalıcı olarak silinene kadar sunucuda kalır. Arama dizinindeki kaydı, dosya çöp kutusuna gidince kaldırılır.",
  "e2e.fxe.seen_backups": "Bundan önce alınmış yedekler, kopyalar ve indirmeler onu hâlâ içerir.",
  "e2e.fxe.warn_body": "Bu dosya yalnızca bu parolayla ya da şifrelemeden sonra bir kez gösterilen kurtarma anahtarıyla açılır. filex ikisini de saklamaz. İkisini de kaybederseniz içerik kalıcı olarak kaybolur.",
  "e2e.fxe.escrow_body": "Bu kurulumda anahtar emaneti açık: işletmecisi, bu dosyayı parolanız olmadan açan bir anahtara sahip.",
  "e2e.fxe.encrypt_submit": "Şifrele",
  "e2e.fxe.encrypt_busy": "Şifreleniyor ve yükleniyor… %{percent}",
  "e2e.fxe.size_unknown": "Bu dosyanın boyutu henüz bilinmiyor. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.bad_name": "Bu ad şifreli bir dosyanın içine mühürlenemez (255 baytı aşıyor ya da eğik çizgi veya denetim karakteri içeriyor). Önce dosyayı yeniden adlandırın.",
  "e2e.fxe.name_too_long": "Ad, sonuna “.fxe” eklenemeyecek kadar uzun. “Dosya adını da gizle” kutusunu işaretleyin ya da önce dosyayı yeniden adlandırın.",
  "e2e.fxe.encrypted": "“{name}” şifrelendi. Asıl dosya çöp kutusunda.",
  "e2e.fxe.original_kept": "Şifreli kopya kaydedildi, ancak “{name}” çöp kutusuna taşınamadı. Asıl dosyayı kendiniz silin.",
  "e2e.fxe.upload_too_big": "Bu sunucuda parçalı yükleme yok ve dosya bu tarayıcıdan tek parça gönderilemeyecek kadar büyük.",
  "e2e.fxe.unlock_title_open": "Şifreli dosyayı aç",
  "e2e.fxe.unlock_title_download": "Çözerek indir",
  "e2e.fxe.unlock_title_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_lead": "“{name}” şifreli. Parolası burada, bu tarayıcıda denetlenir ve asla sunucuya gönderilmez.",
  "e2e.fxe.known_note": "Bu sekmede zaten açıldı - parola gerekmiyor.",
  "e2e.fxe.use_password": "Onun yerine parolayı kullan",
  "e2e.fxe.remove_warn_title": "Şifresiz içerik sunucuya geri döner",
  "e2e.fxe.remove_warn_body": "Dosya burada çözülür ve özgün adıyla şifresiz bir dosya olarak yüklenir: sunucu, yöneticileri, küçük resimler, arama ve yedekler onu yeniden okuyabilir. Şifreli dosya çöp kutusuna gider.",
  "e2e.fxe.unlock_open": "Aç",
  "e2e.fxe.unlock_download": "İndir",
  "e2e.fxe.unlock_remove": "Şifrelemeyi kaldır",
  "e2e.fxe.unlock_busy": "İşleniyor…",
  "e2e.fxe.save_again": "Kilit açıldı. Tarayıcınız, dosyanın nereye kaydedileceğini sormadan önce bir tıklama daha istiyor.",
  "e2e.fxe.save_button": "Kaydet…",
  "e2e.fxe.progress": "%{percent} tamamlandı",
  "e2e.fxe.wrong_password": "Parola yanlış.",
  "e2e.fxe.wrong_recovery": "Bu kurtarma anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.damaged": "Bu dosya bozuk ya da kurcalanmış (veya açıldığından beri değişmiş). Hiçbir şey kaydedilmedi.",
  "e2e.fxe.not_readable": "Bu bir filex şifreli dosyası değil ya da başlığı bozuk.",
  "e2e.fxe.unsupported": "Bu dosya daha yeni bir filex gerektiriyor (gereken: {features}).",
  "e2e.fxe.downloaded": "“{name}” kaydedildi.",
  "e2e.fxe.removed": "Şifreleme kaldırıldı: “{name}” yeniden şifresiz bir dosya. Şifreli dosya çöp kutusunda.",
  "e2e.fxe.password_title": "Dosya parolasını değiştir",
  "e2e.fxe.password_cost": "Yalnızca dosyanın başlığı değişir: içerik bayt bayt aynen geri gönderilir ve kurtarma anahtarı çalışmaya devam eder.",
  "e2e.fxe.password_old_copies": "Bu dosyanın önceki bir sürümü - sürüm geçmişi, bir yedek, birinin indirdiği bir kopya - ESKİ parolayla açılmaya devam eder.",
  "e2e.fxe.password_done": "Parola değişti. Eski parola bu dosyayı artık açmıyor.",
  "e2e.recovery.warn_body_file": "Bu anahtara sahip olan herkes dosyayı okuyabilir. Onu paroladan ayrı bir yerde saklayın - parolanın yanında duran bir anahtar sizi unutmaktan korur, başkalarından değil.",
  "e2e.recovery.lead_file": "Bu anahtar dosyayı parolası olmadan açar. Yalnızca bir kez gösterilir - filex onu saklamaz ve bir daha gösteremez.",
  "e2e.dl.ctx_encrypted_copy": "Şifreli kopyayı indir",
  "e2e.dl.too_big": "Bu tarayıcı tek seferde en çok {limit} çözülmüş veri kaydedebilir, bu ise {size}. Chrome ya da Edge (doğrudan diske kaydeder), filex masaüstü uygulamasını kullanın ya da şifreli dosyayı indirip filex decrypt çalıştırın.",
  "e2e.dl.click_again": "Nereye kaydedileceğini seçmek için İndir’e bir kez daha tıklayın.",
  "e2e.dl.zip_started": "“{name}” içine çözülerek yazılıyor…",
  "e2e.dl.zip_done": "“{name}” kaydedildi - çözülmüş, gerçek adlarla.",
  "e2e.dl.zip_done_plain": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_done_plain_one": "“{name}” kaydedildi. İçindeki {n} dosya hiç şifrelenmemişti ve olduğu gibi eklendi.",
  "e2e.dl.zip_damaged": "Klasördeki bir dosya bozuk ya da kurcalanmış. İndirme durduruldu ve hiçbir şey kaydedilmedi.",
  "e2e.upload.streaming_unsupported": "Bu dosya 200 MB’tan büyük ve bu sunucuda onu parça parça şifreli göndermek için parçalı yükleme yok.",
  /* wiring:e2 fxe escrow - emanet anahtarı tek bir dosyayı açar, sahibine haber gider */
  "e2e.fxe.use_escrow": "Emanet anahtarını kullan",
  "e2e.fxe.escrow_warn_title": "Dosyanın sahibine haber gidecek",
  "e2e.fxe.escrow_warn_body": "Emanet anahtarıyla açılan dosyanın sahibine, dosya açılmadan önce bildirim gönderilir. Yalnız yetkiniz olduğunda kullanın.",
  "e2e.fxe.escrow_predates": "Bu kurulumun emanet anahtarı var, ama bu dosya onsuz şifrelenmiş (emanet burada açılmadan önce), bu yüzden emanet anahtarı onu açmaz. Parolayı ya da kurtarma anahtarını kullanın.",
  "e2e.fxe.escrow_other_key": "Bu dosya BAŞKA bir kurulumun emanet anahtarına mühürlenmiş, bu yüzden bu kurulumun emanet anahtarı onu açmaz.",
  "e2e.fxe.wrong_escrow": "Bu emanet anahtarı bu dosyayı açmıyor.",
  "e2e.fxe.escrow_notify_failed": "Dosyanın sahibine bildirim gönderilemedi, bu yüzden dosya açılmadı. Emanet anahtarının kullanımı her zaman duyurulur.",
  "e2e.fxe.escrow_done": "Emanet anahtarıyla açıldı - dosya sahibine bildirildi",
  /* wiring:e2 fxe purge - yönetici aslını kalıcı olarak siler */
  "e2e.fxe.seen_trash_admin": "Asıl dosya çöp kutusuna gider ve çöp kutusunun saklama süresi dolana kadar orada kalır - aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.seen_versions_admin": "Önceki sürümleri sürüm geçmişinde kalır - aşağıda kalıcı olarak silmediğiniz sürece.",
  "e2e.fxe.purge_label": "Aslını kalıcı olarak sil (yönetici)",
  "e2e.fxe.purge_hint": "Şifreli kopya kaydedilir kaydedilmez önceki sürümleri ve çöp kutusundaki kaydı silinir; açık hâlinden bu sunucuda hiçbir şey kalmaz. Geri alınamaz. Daha önce alınmış yedeklere ve kopyalara ulaşılmaz.",
  "e2e.fxe.purge_others": "Bu dosya sizin değil, {owner} adlı kullanıcının. Onun aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_unknown": "Bu dosyanın kayıtlı bir sahibi yok - sizin değil. Aslını ve sürümlerini kalıcı olarak sil.",
  "e2e.fxe.purge_others_required": "Başkasının dosyasını kalıcı olarak sildiğinizi onaylayın.",
  "e2e.fxe.purge_no_id": "Bu dosya henüz katalogda değil, bu yüzden kalıcı olarak silinemez. Klasörü yenileyip tekrar deneyin.",
  "e2e.fxe.purged": "“{name}” şifrelendi. Aslı, sürümleri ve çöp kutusundaki kaydı kalıcı olarak silindi.",
  "e2e.fxe.purge_failed": "“{name}” dosyasının şifreli kopyası kaydedildi, ama aslı kalıcı olarak silinemedi ({reason}). Çöp kutusundan ve sürüm geçmişinden silin.",
  /* wiring:e2 fxe big - bu tarayıcının belleğine sığmayan çözülmüş indirme */
  "e2e.big.title": "Bu tarayıcıda çözülemeyecek kadar büyük",
  "e2e.big.lead": "“{name}” çözüldüğünde {size}. Bu tarayıcı indirmeyi belleğinde çözer ve en çok {limit} tutabilir, bu yüzden hiçbir şey indirilmedi.",
  "e2e.big.lead_grew": "“{name}” çözülürken {limit} sınırını aştı. Bu tarayıcı indirmeyi belleğinde çözer ve daha fazlasını tutamaz, bu yüzden hiçbir şey kaydedilmedi.",
  "e2e.big.instead": "Bunun yerine kendi bilgisayarınızda çözün:",
  "e2e.big.step_file": "Şifreli dosyayı olduğu gibi indirin (aşağıdaki düğme).",
  "e2e.big.step_folder": "Şifreli klasörü zip olarak indirin (aşağıdaki düğme) - klasörün anahtar dosyası da içindedir.",
  "e2e.big.step_run": "Kaydettiğiniz klasörde filex decrypt komutunu çalıştırıp parolayı girin:",
  "e2e.big.copy": "Kopyala",
  "e2e.big.copied": "Kopyalandı",
  "e2e.big.other_ways": "Chrome, Edge ve filex masaüstü uygulaması, boyutu ne olursa olsun doğrudan diske çözer.",
  "e2e.big.close": "Kapat",
  "e2e.big.download_file": "Şifreli dosyayı indir",
  "e2e.big.download_folder": "Şifreli klasörü indir (zip)",
  /* /wiring:e2 fxe */
  /* ── dil:paket - İngilizce sabit yazılmış erişilebilir adlar */
  "breadcrumb.aria": "Konum yolu",
  "e2e.recovery_key_aria": "Kurtarma anahtarı",
  "modal.close": "Kapat",
  "modal.busy_close.keep": "Devam etsin",
  "modal.busy_close.confirm": "Durdur ve kapat",
  /* ── zil ve hesap menüsü (2026-09-27: masaüstü uygulamasının gezgini de
     aynılarını çizsin diye yönetim uygulamasından buraya taşındı). ⚠ ORTAK
     anahtarlar: yönetim uygulamasının kataloğunda her biri aynı adla, aynı
     İngilizce ve Türkçeyle durur (web/tests/i18n/langPackCatalogue.test.ts),
     bir dil paketi her birini iki ekran için bir kez çevirir. */
  "notifications.bell": "Bildirim zili",
  "notifications.unreadCount": "{n} okunmamış",
  "notifications.title": "Bildirimler",
  "notifications.markAllRead": "Tümünü okundu işaretle",
  "notifications.markRead": "Okundu işaretle",
  "notifications.empty": "Henüz bildirim yok",
  "notifications.viewAll": "Tüm bildirimleri gör",
  "notifications.manageAdmin": "Bildirim yönetimi",
  "notifications.openTarget": "Bildirimin konusunu aç",
  "notifications.unreadOnly": "Sadece okunmamış",
  "notifications.pageOf": "Sayfa {page} / {pages} · toplam {total}",
  "notifications.severity.info": "Bilgi",
  "notifications.severity.warning": "Uyarı",
  "notifications.severity.error": "Hata",
  "notifications.severity.critical": "Kritik",
  "common.prev": "Önceki",
  "common.next": "İleri",
  "explore.account": "Hesap",
  /* ── kullanıcı ayarları penceresi (2026-09-27: masaüstü uygulaması aynı
     pencereyi kendi içinde açsın diye yönetim uygulamasından buraya taşındı).
     ⚠ ORTAK anahtarlar; ardından gelenler bu tablonun kendisinin (yönetim
     kataloğu onları yalnız vue-i18n'in anladığı sözdizimiyle yazar). */
  "common.cancel": "İptal",
  "common.close": "Kapat",
  "common.confirm": "Onayla",
  "common.currentPassword": "Mevcut parola",
  "common.email": "E-posta",
  "common.loading": "Yükleniyor…",
  "common.newPassword": "Yeni parola",
  "common.remove": "Kaldır",
  "common.save": "Kaydet",
  "common.saving": "Kaydediliyor…",
  "errors.generic": "Bir şeyler ters gitti",
  "errors.validationFailed": "Lütfen işaretli alanları kontrol edin",
  "install.desktopAllDownloads": "Tüm indirmeler ve sürüm notları",
  "install.desktopSubtitle": "Klasörleri bu bilgisayara eşitleyin, arka planda güncel kalsınlar. {platform} için mevcut.",
  "install.install": "Kur",
  "install.menuInstructions": "Tarayıcınızın menüsünü açıp “Uygulamayı yükle” ya da “Ana ekrana ekle”yi seçin.",
  "install.iosInstructions": "Paylaş'a dokunun (iOS 26'da önce ⋯, sonra Paylaş), ardından “Ana Ekrana Ekle” ve Ekle'ye dokunun.",
  "nav.themeAuto": "Otomatik",
  "nav.themeDark": "Karanlık",
  "nav.themeLight": "Aydınlık",
  "notifications.prefs.browser": "Tarayıcı bildirimleri",
  "notifications.prefs.browserHint": "Yeni bir şey geldiğinde sekmenin dışında bildirim göster. Bildirime tıklayınca konusu olan dosya, klasör ya da paylaşım açılır.",
  "notifications.prefs.desktopHandled": "Masaüstü uygulaması bunları kendisi gösteriyor",
  "notifications.prefs.enableBrowser": "Bildirimlere izin ver",
  "notifications.prefs.inApp": "Uygulama içi zil",
  "notifications.prefs.inAppHint": "Kapatırsanız ziliniz boşalır. Hiçbir kayıt silinmez - yönetici tüm olayları görmeye devam eder.",
  "notifications.prefs.iosHomeScreen": "iPhone ve iPad'de bildirimler tarayıcı sekmesinde değil, ana ekrana eklenmiş {name} uygulamasında çalışır (iOS 16.4 ve sonrası).",
  "notifications.prefs.movedToSettings": "Kendi bildirim ayarlarınız - zil, tarayıcı bildirimleri, hangi olaylar - kullanıcı ayarlarınızda.",
  "notifications.prefs.openSettings": "Bildirim ayarlarımı aç",
  "notifications.prefs.permDefault": "İzin henüz istenmedi",
  "notifications.prefs.permDenied": "Bu tarayıcıda engellendi",
  "notifications.prefs.permDeniedHint": "Tarayıcı ayarlarından bu siteye bildirim iznini yeniden verin.",
  "notifications.prefs.permGranted": "Bu tarayıcıda izin verildi",
  "notifications.prefs.permUnsupported": "Bu tarayıcı bildirim gösteremiyor",
  "notifications.prefs.push": "Bu cihazda anlık bildirim",
  "notifications.prefs.pushAdded": "Eklendi: {date}",
  "notifications.prefs.pushDevices": "Anlık bildirim alan cihazlar",
  "notifications.prefs.pushDisabled": "Sunucuda kapatılmış (FILEX_PUSH_ENABLED).",
  "notifications.prefs.pushFailed": "Bu cihazda anlık bildirimler açılamadı.",
  "notifications.prefs.pushHint": "Zilinizin size söyledikleri, {name} kapalıyken de bu telefona ya da tarayıcıya ulaşır: aynı bildirimler, aynı anda.",
  "notifications.prefs.pushKeyUnreadable": "Sunucunun anlık bildirim anahtarı artık açılamıyor (FILEX_SECRET_KEY değişmiş). Yönetim → Bildirimler sayfasında anahtarı yenileyin.",
  "notifications.prefs.pushNoSecretKey": "Anlık bildirimler için sunucuda FILEX_SECRET_KEY tanımlı olmalı: bildirimleri imzalayan anahtar onunla şifrelenerek saklanır.",
  "notifications.prefs.pushOn": "Bu cihazda açık",
  "notifications.prefs.pushRemove": "Kaldır",
  "notifications.prefs.pushRemoveLabel": "Kaldır: {device}",
  "notifications.prefs.pushTest": "Deneme gönder",
  "notifications.prefs.pushTestNone": "Deneme hiçbir cihaza ulaşmadı.",
  "notifications.prefs.pushTestSent": "Deneme {count} cihaza gönderildi",
  "notifications.prefs.pushTestSent_one": "Deneme {count} cihaza gönderildi",
  "notifications.prefs.pushThisDevice": "Bu cihaz",
  "notifications.prefs.pushUnavailable": "Bu sunucuda kullanılamıyor",
  "notifications.prefs.pushUnnamed": "Bir cihaz",
  "notifications.prefs.pushUnsupported": "Bu tarayıcı anlık bildirim alamıyor",
  "notifications.prefs.saved": "Tercih kaydedildi",
  "notifications.prefs.title": "Bildirimleriniz",
  "profile.avatar.change": "Fotoğrafı değiştir",
  "profile.avatar.failed": "Bu görsel işlenemedi - başka bir tane deneyin.",
  "profile.avatar.help": "Adınızın yanında ve dosya yöneticisinin işbirliği çubuğunda görünür - hesabınızla açılan her istemcide. Otomatik olarak 160 piksele küçültülür.",
  "profile.avatar.label": "Profil fotoğrafı",
  "profile.avatar.notImage": "Lütfen bir görsel dosyası seçin.",
  "profile.locale": "Dil",
  "profile.passwordChanged": "Parola değiştirildi",
  "profile.saved": "Profil kaydedildi",
  "profile.totp.code": "Doğrulama kodu",
  "profile.totp.disable": "2FA'yı kapat",
  "profile.totp.disabled": "Pasif",
  "profile.totp.enable": "2FA'yı aç",
  "profile.totp.enabled": "Aktif",
  "profile.totp.recoveryHint": "Bunları şimdi kaydedin - doğrulayıcınızı kaybederseniz her biri bir kez oturum açmanızı sağlar. Yalnızca bu sefer gösterilir.",
  "profile.totp.recoveryTitle": "Kurtarma kodları",
  "profile.totp.scanHint": "Bu QR kodu doğrulayıcı uygulamanızla tarayın, sonra 6 haneli kodu girin.",
  "profile.totp.title": "İki adımlı doğrulama",
  "profile.username.label": "Kullanıcı adı",
  "quota.title": "Depolama kotası",
  "quota.tooltip": "{used} / {limit} kullanıldı ({percent})",
  "quota.unlimitedTooltip": "{used} kullanıldı · sınırsız",
  "userSettings.adminBadge": "Yönetici",
  "userSettings.demoReadOnly": "Bu ortak bir demo hesabı; profili, parolası ve ikinci faktörü değiştirilemez.",
  "userSettings.footNote.ai": "Bu sekmede kaydedilecek bir şey yok.",
  "userSettings.footNote.notifications": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.preferences": "Değiştirdiğiniz anda kaydedilir.",
  "userSettings.footNote.profile": "Bu sekmedeki değişiklikler Kaydet'e bastığınızda kaydedilir.",
  "userSettings.footNote.security": "Buradaki her işlem kendi başına uygulanır.",
  "userSettings.heading": "Kullanıcı ayarları",
  "userSettings.headingSub": "Profilinizi, tercihlerinizi ve güvenliğinizi yönetin.",
  "userSettings.notifications.adminAlerts": "Yönetici uyarıları",
  "userSettings.notifications.adminAlertsHint": "Güncellemeler, kopyalar, oturum açma sağlayıcıları, kiracı alan adları ve yöneticilere yönelik diğer uyarılar",
  "userSettings.notifications.device": "Masaüstü bildirimleri",
  "userSettings.notifications.deviceHint": "Yeni bir şey geldiğinde, filex arka planda çalışırken de bilgisayarınızın kendi bildirimleri.",
  "userSettings.notifications.digestHint": "Acil olarak işaretlenen türler size hemen ulaşır. Diğerleri {minutes} dakika bekletilir ve klasör klasör tek bir özet olarak gelir.",
  "userSettings.notifications.digestOffHint": "Her tür size hemen ulaşır. Bir türün Acil anahtarını kapatırsanız o tür, klasör klasör tek bir özet olarak gelir.",
  "userSettings.notifications.events.archive_created": "Bir arşiv oluşturulduğunda",
  "userSettings.notifications.events.archive_extracted": "Bir arşiv çıkarıldığında",
  "userSettings.notifications.events.comment_added": "Biri bir dosyaya yorum yaptığında",
  "userSettings.notifications.events.drop_received": "İstek bağlantısıyla bir dosya geldiğinde",
  "userSettings.notifications.events.e2e_escrow_used": "Şifreli bir klasör emanet anahtarıyla açıldığında",
  "userSettings.notifications.events.e2e_password_changed": "Şifreli klasörünüzün parolası değiştiğinde",
  "userSettings.notifications.events.e2e_request_created": "Biri bir klasörü ya da dosyayı şifrelemek istediğinde",
  "userSettings.notifications.events.e2e_request_decided": "Şifreleme isteğiniz yanıtlandığında",
  "userSettings.notifications.events.file_deleted": "Bir dosya kalıcı olarak silindiğinde",
  "userSettings.notifications.events.file_infected": "Bir dosyada virüs bulunduğunda",
  "userSettings.notifications.events.file_moved": "Bir dosya taşındığında ya da adı değiştiğinde",
  "userSettings.notifications.events.file_trashed": "Bir dosya çöp kutusuna taşındığında",
  "userSettings.notifications.events.file_updated": "Bir dosya değiştiğinde",
  "userSettings.notifications.events.file_upload_failed": "Bir yükleme tamamlanmadığında",
  "userSettings.notifications.events.file_uploaded": "Yeni bir dosya geldiğinde",
  "userSettings.notifications.events.notification_digest": "Acil olarak işaretlemediğim bildirimlerin özeti",
  "userSettings.notifications.events.plugin_notice": "Kurulu bir uygulama size mesaj gönderdiğinde",
  "userSettings.notifications.events.share_created": "Biri paylaşım bağlantısı oluşturduğunda",
  "userSettings.notifications.eventsHint": "Birini kapatmak onu zilinizin dışında tutar. Hiçbir şey kaydedilmekten çıkmaz - yönetici her olayı görmeye devam eder.",
  "userSettings.notifications.eventsTitle": "Nelerden haberdar olayım",
  "userSettings.notifications.urgent": "Acil",
  "userSettings.notifications.urgentFor": "Hemen bildir: {event}",
  "userSettings.open": "Kullanıcı ayarları",
  "userSettings.prefs.appearance": "Görünüm",
  "userSettings.prefs.compact": "Sıkışık dosya listesi kullan",
  "userSettings.prefs.compactHint": "Dosya gezgininde daha dar satırlar.",
  "userSettings.prefs.remoteImages": "Önizlemelerde uzak görselleri yükle",
  "userSettings.prefs.remoteImagesHint": "Bir dosyanın önizlemesinde başka sunuculardaki görseller sormadan yüklenir. Kapalıyken her biri bir tıklama bekler, çünkü yüklemek o sunucuya dosyanın açıldığını bildirir. Küçük resimler bunları hiçbir zaman yüklemez.",
  "userSettings.prefs.desktopApp": "Masaüstü uygulaması",
  "userSettings.prefs.desktopAppHint": "Uygulamanın köşesindeki hatırlatmayı kapattığınızda bir daha çıkmaz - indirmeler burada kalır.",
  "userSettings.prefs.folderView": "Varsayılan klasör görünümü",
  "userSettings.prefs.folderViewHint": "Hiç değiştirmediğiniz bir klasörün nasıl açılacağı. Değiştirdiğiniz klasörler kendi görünümünü korur - bu ayar onlara dokunmaz.",
  "userSettings.prefs.fvColumns": "Varsayılan sütunlarınız özelleştirilmiş (“Bunu tüm klasörler için varsayılanım yap” ile ayarlandı).",
  "userSettings.prefs.fvColumnsReset": "Sıfırla",
  "userSettings.prefs.fvDir": "Yön",
  "userSettings.prefs.fvDir_asc": "Artan",
  "userSettings.prefs.fvDir_desc": "Azalan",
  "userSettings.prefs.fvForget": "Hepsini unut",
  "userSettings.prefs.fvInherit": "Sunucu varsayılanı ({value})",
  "userSettings.prefs.fvMode": "Görünüm",
  "userSettings.prefs.fvSort": "Sıralama",
  "userSettings.prefs.fvSort_modified": "Değiştirilme",
  "userSettings.prefs.fvSort_name": "Ad",
  "userSettings.prefs.fvSort_size": "Boyut",
  "userSettings.prefs.fvSort_type": "Tür",
  "userSettings.prefs.fvView_gallery": "Galeri",
  "userSettings.prefs.fvView_grid": "Izgara",
  "userSettings.prefs.fvView_list": "Liste",
  "userSettings.prefs.installApp": "Web uygulaması olarak kur",
  "userSettings.prefs.installAppLead": "Bu cihazın ana ekranına ekleyin: {name} bir uygulama gibi kendi penceresinde açılır.",
  "userSettings.prefs.languageHint": "Burada hemen uygulanır; bir sonraki tarayıcıda da açılsın diye hesabınıza kaydedilir.",
  "userSettings.prefs.mode": "Aydınlık ya da karanlık",
  "userSettings.prefs.modeHint": "Hangi sürümün çizileceği. Otomatik, işletim sisteminizi izler.",
  "userSettings.prefs.openTrigger": "Dosyaları açma",
  "userSettings.prefs.openTriggerDouble": "Çift tık",
  "userSettings.prefs.openTriggerHint": "Farenin dosyayı nasıl açtığı. Dokunmatik ekranda tek dokunuş her zaman açar, kutucuk her zaman seçer.",
  "userSettings.prefs.openTriggerSingle": "Tek tık",
  "userSettings.prefs.palette": "Renk paleti",
  "userSettings.prefs.paletteHint": "O sürümün hangi renklerden oluştuğu. Her paletin aydınlık ve karanlık bir sürümü vardır; bu ayarla üstteki ayar birlikte çalışır.",
  "userSettings.prefs.shortcuts": "Klavye kısayolları",
  "userSettings.prefs.shortcutsEdit": "Düzenle…",
  "userSettings.prefs.shortcutsHint": "Dosya yöneticisinin yanıt verdiği tuşlar.",
  "userSettings.prefs.startPage": "Açılış sayfası",
  "userSettings.prefs.startPageHint": "Oturum açtığınızda ya da ana adrese geldiğinizde filex burayı açar. Doğrudan bir sayfanın bağlantısına tıkladığınızda yine o sayfaya gidersiniz.",
  "userSettings.prefs.startPage_admin": "Yönetim paneli",
  "userSettings.prefs.startPage_files": "Dosyalar",
  "userSettings.prefs.startPage_home": "Ana sayfa",
  "userSettings.prefs.timezone": "Saat dilimi",
  "userSettings.prefs.timezoneHint": "Tarihler bir an olarak saklanır ve burada seçtiğiniz saatle gösterilir; böylece herkes aynı anı kendi saatiyle görür. Hesabınıza kaydedilir, başka bir tarayıcıda da geçerli olur.",
  "userSettings.prefs.timezoneNow": "{zone} bölgesinde şu an: {time}",
  "userSettings.saveChanges": "Değişiklikleri kaydet",
  "userSettings.scope.account": "Hesap",
  "userSettings.scope.accountHint": "Hesabınızda saklanır: nerede oturum açarsanız açın aynıdır.",
  "userSettings.scope.device": "Bu cihaz",
  "userSettings.scope.deviceHint": "Yalnızca bu cihazda saklanır: başka bir bilgisayar, telefon ya da tarayıcı kendi ayarını tutar.",
  "userSettings.scope.deviceNotifyHint": "Bu cihazın size yeni bir şeyi nasıl haber vereceği; yalnızca bu cihazda saklanır.",
  "userSettings.scope.myAccount": "Hesabım",
  "userSettings.scope.myAccountHint": "Zilinize nelerin düşeceği; hesabınızda saklanır.",
  "userSettings.security.passwordTitle": "Parolayı değiştir",
  "userSettings.security.totpDisabled": "İki adımlı doğrulama kapalı",
  "userSettings.security.totpEnabled": "İki adımlı doğrulama açık",
  "userSettings.subtitle.ai": "Burada henüz ayarlayabileceğiniz bir şey yok.",
  "userSettings.subtitle.notifications": "Zilinize ve masaüstünüze neyin ulaşacağı.",
  "userSettings.subtitle.preferences": "Uygulamanın cihazlarınızda nasıl göründüğü ve okunduğu.",
  "userSettings.subtitle.profile": "Adınız, e-postanız ve fotoğrafınız - başkalarının gördüğü bilgiler.",
  "userSettings.subtitle.security": "Parolanız ve ikinci faktörünüz.",
  "userSettings.tabs.ai": "AI asistanı",
  "userSettings.ai.state.on": "Asistan açık.",
  "userSettings.ai.state.off": "Asistan bu sunucuda kapalı.",
  "userSettings.ai.state.not_configured": "Yönetici asistanı henüz kurmadı.",
  "userSettings.ai.state.not_permitted": "Asistan açık ama rolünüz onu kapsamıyor.",
  "userSettings.ai.provider": "Yazdıklarınızı kim okuyor",
  "userSettings.ai.providerHint": "Mesajlarınız ve asistanın sizin için okuduğu dosyalar bu sağlayıcıya gönderilir. Okuduğu her dosya denetim kaydında yer alır.",
  "userSettings.ai.confirmAll": "Her değişiklikten önce bana sor",
  "userSettings.ai.confirmAllHint": "Kapalıyken geri alınabilen değişiklikler (taşıma, yeniden adlandırma, düzenleme, çöp kutusuna silme) hemen yapılır ve Geri al bırakır. Açıkken bunlar da onayınızı bekler. Geri alınamayan her şey her zaman bekler.",
  "userSettings.ai.history": "Konuşma geçmişi",
  "userSettings.ai.retention": "Konuşmalar son kullanımlarından sonra {count} gün sunucuda saklanır.",
  "userSettings.ai.retention_one": "Konuşmalar son kullanımlarından sonra {count} gün sunucuda saklanır.",
  "userSettings.ai.clear": "Konuşmalarımı sil",
  "userSettings.ai.clearConfirm": "Hepsi kalıcı olarak silinsin mi?",
  "userSettings.ai.cleared": "Konuşmalarınız silindi.",
  "userSettings.ai.saveFailed": "Bu kaydedilemedi.",
  "userSettings.tabs.notifications": "Bildirimler",
  "userSettings.tabs.preferences": "Tercihler",
  "userSettings.tabs.profile": "Profil",
  "userSettings.tabs.security": "Güvenlik",
  "userSettings.apps.title": "Varsayılan uygulamalar",
  "userSettings.apps.lead": 'Bir dosyanın menüsünden seçin: Birlikte aç, Uygulama seç…, sonra "Her zaman bu uygulamayla aç" kutusunu işaretleyin. Yalnız yöneticinizin o tür için açık bıraktığı uygulamalar sunulur.',
  "userSettings.apps.empty": "Henüz hiçbir dosya türü için uygulama seçmediniz: her dosya, yöneticinizin ilk sıraya koyduğu uygulamayla açılır.",
  "userSettings.apps.reset": "Sıfırla",
  "userSettings.apps.resetAll": "Tümünü sıfırla",
  "userSettings.apps.unavailable": "Artık kullanılamıyor: siz yeniden seçene kadar {app} ile açılıyor.",
  "userSettings.apps.change": "{ext} dosyalarını açan uygulama",
  "userSettings.title": "Kullanıcı ayarları",
  "users.fields.displayName": "Görünen ad",
  "profile.username.helpText": "Kullanıcı adınız. Oturum açarken bunu da e-postanızı da kullanabilirsiniz - bağlantı istemcileri (SFTP, FTP) için ise bu ad gerekir, çünkü oturum açtıkları addaki @ işareti onların ayar dosyalarında kaçış gerektirir.",
  "userSettings.prefs.fvKeptCount": "{count} klasör kendi görünümünü koruyor.",
  "userSettings.prefs.fvKeptCount_one": "{count} klasör kendi görünümünü koruyor."
}, LM = "filex-base", RM = /^(\/[A-Za-z0-9_~.-]+)+$/;
function NM(e) {
  var a, i;
  const t = e ?? (typeof document < "u" ? document : null);
  if (!t) return "";
  let n = "";
  try {
    n = ((i = (a = t.querySelector(`meta[name="${LM}"]`)) == null ? void 0 : a.getAttribute("content")) == null ? void 0 : i.trim()) ?? "";
  } catch {
    return "";
  }
  return !n || !RM.test(n) || n.split("/").some((r) => r === "." || r === "..") ? "" : n;
}
function Zu() {
  return NM();
}
function efe(e) {
  return Zu() + e;
}
function gy(e, t) {
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(t)) return t;
  const n = String(e ?? "").replace(/\/+$/, "");
  return !n || !t.startsWith("/") ? t : n + t;
}
function El(e) {
  return String(e ?? Zu()).replace(/\/+$/, "");
}
const oi = S(0), vp = S(!1), J0 = ["en", "tr"], Rw = {
  en: "English",
  tr: "Türkçe",
  de: "Deutsch",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  nl: "Nederlands",
  pt: "Português",
  pl: "Polski",
  ru: "Русский",
  uk: "Українська",
  ar: "العربية",
  fa: "فارسی",
  az: "Azərbaycanca",
  ja: "日本語",
  ko: "한국어",
  zh: "中文"
};
function Z0(e) {
  if (Rw[e]) return Rw[e];
  try {
    const t = new Intl.DisplayNames([e], { type: "language" }).of(e);
    if (t && t.toLowerCase() !== e)
      return t.charAt(0).toLocaleUpperCase(e) + t.slice(1);
  } catch {
  }
  return e.toUpperCase();
}
const Uu = { en: Gs, tr: X0 }, _a = /* @__PURE__ */ new Map(), Hu = /* @__PURE__ */ new Map(), yp = /^[a-z]{2,3}(-[a-z0-9]{2,8})*$/;
function IM(e) {
  return yp.test(String(e ?? "").trim().toLowerCase().replace(/_/g, "-"));
}
function Wi(e) {
  const t = String(e ?? "").trim().toLowerCase().replace(/_/g, "-");
  if (!yp.test(t)) return "";
  if (_a.has(t)) return t;
  const n = t.split("-")[0];
  if (Cl(n) || _a.has(n)) return n;
  for (const a of _a.keys()) if (a.startsWith(`${n}-`)) return a;
  return t;
}
function Cl(e) {
  return J0.includes(e);
}
function Q0(e) {
  const t = {};
  for (const [n, a] of Object.entries(e ?? {}))
    typeof a != "string" || !a.trim() || !n || n.split(".").some((i) => i === "__proto__" || i === "constructor" || i === "prototype") || (t[n] = a);
  return t;
}
function BM(e) {
  const t = String((e == null ? void 0 : e.code) ?? "").trim().toLowerCase().replace(/_/g, "-"), n = yp.test(t) ? t : "";
  n && (_a.set(n, {
    code: n,
    label: String(e.label ?? "").trim() || Z0(n),
    source: e.source === "plugin" ? "plugin" : e.source || "builtin",
    plugin: e.plugin,
    rtl: e.rtl === !0,
    strings: e.strings ? Q0(e.strings) : null
  }), oi.value += 1);
}
function FM(e) {
  _a.clear(), Hu.clear();
  for (const t of e ?? []) BM(t);
  oi.value += 1;
}
function tfe(e) {
  let t = !1;
  for (const [n, a] of _a)
    a.source === "plugin" && a.plugin === e && (_a.delete(n), t = !0);
  t && (oi.value += 1);
}
function nfe() {
  _a.clear(), Hu.clear(), Ar = {}, vp.value = !1, oi.value += 1;
}
function Mr() {
  oi.value;
  const e = J0.map((t) => ({
    code: t,
    label: Z0(t),
    source: "builtin"
  }));
  for (const [t, n] of _a)
    Cl(t) || e.push({ code: t, label: n.label, source: n.source, plugin: n.plugin, rtl: n.rtl });
  return e;
}
function Df(e) {
  oi.value;
  const t = Wi(e);
  return !!t && (Cl(t) || _a.has(t));
}
function UM(e) {
  return Df(e) ? !0 : !vp.value && IM(e);
}
function HM(e) {
  const t = Wi(e), n = Cl(t) ? Uu[t] : void 0, a = _a.get(t);
  return a && a.strings === null && t2(t), !(a != null && a.strings) || !Object.keys(a.strings).length ? n ?? Uu.en : { ...Uu.en, ...n ?? {}, ...a.strings };
}
function e2(e) {
  const t = Wi(e), n = Cl(t) ? Uu[t] : void 0, a = _a.get(t);
  a && a.strings === null && t2(t);
  const i = a != null && a.strings && Object.keys(a.strings).length ? a.strings : null;
  return n ? { lang: t, strings: i ? { ...n, ...i } : n } : i ? { lang: t, strings: i } : { lang: "en", strings: Uu.en };
}
function afe(e) {
  var t;
  return { ...((t = _a.get(Wi(e))) == null ? void 0 : t.strings) ?? {} };
}
let Ar = {};
function t2(e) {
  const t = Wi(e), n = _a.get(t);
  if (!n) return Promise.resolve(!1);
  if (n.strings !== null) return Promise.resolve(Object.keys(n.strings).length > 0);
  const a = Hu.get(t);
  if (a) return a;
  const i = Ar.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!i) return Promise.resolve(!1);
  const r = El(Ar.base), l = (async () => {
    let c = {};
    try {
      const m = Ar.headers ? await Ar.headers() : {}, v = await i(`${r}/api/public/ui-locales/${encodeURIComponent(t)}`, {
        method: "GET",
        headers: { Accept: "application/json", ...m },
        credentials: "same-origin"
      });
      if (v.ok) {
        const x = await v.json();
        c = Q0(x == null ? void 0 : x.strings);
      }
    } catch {
    }
    const p = _a.get(t);
    return p === n && (p.strings = c, oi.value += 1), Hu.delete(t), Object.keys(c).length > 0;
  })();
  return Hu.set(t, l), l;
}
function n2(e, t) {
  if (t && (Ar = t), !e) return Mr();
  const n = Array.isArray(e.ui_locales) ? e.ui_locales : [], a = new Set(n.map((r) => String((r == null ? void 0 : r.code) ?? "").toLowerCase())), i = (e.locales ?? []).map((r) => String(r ?? "").trim().toLowerCase()).filter((r) => yp.test(r) && !Cl(r) && !a.has(r)).map((r) => ({ code: r, source: "plugin" }));
  return FM([...n, ...i]), vp.value = !0, Mr();
}
async function ife(e = {}) {
  Ar = e;
  const t = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!t) return Mr();
  const n = El(e.base);
  try {
    const a = e.headers ? await e.headers() : {}, i = await t(`${n}/api/public/branding`, {
      method: "GET",
      headers: { Accept: "application/json", ...a },
      credentials: "same-origin"
    });
    if (i.ok)
      return n2(await i.json()), Mr();
  } catch {
  }
  return vp.value = !0, oi.value += 1, Mr();
}
const Nw = "en";
function Ca(e) {
  return e && UM(e) ? Wi(e) : a2();
}
function a2() {
  try {
    const e = typeof navigator > "u" ? void 0 : navigator;
    if (!e) return Nw;
    const t = e.languages && e.languages.length ? e.languages : [e.language];
    for (const n of t)
      if (n && Df(n))
        return Wi(n);
  } catch {
  }
  return Nw;
}
const KM = [".filex-trash", ".versions", ".thumbs", ".filex-open", ".filex-drafts"], VM = ".filex-drafts", i2 = ".keepdir", o2 = new Set(KM);
function r2(e) {
  let t = String(e ?? "").trim().replace(/\\/g, "/");
  const n = t.indexOf("://");
  return n >= 0 && (t = t.slice(n + 3)), t.split("/").filter((a) => a && a !== ".");
}
function gp(e) {
  const t = String(e ?? "").trim();
  return o2.has(t) || t === i2;
}
function Lf(e) {
  const t = r2(e);
  return t.some((n) => o2.has(n)) ? !0 : t.length > 0 && t[t.length - 1] === i2;
}
function hv(e) {
  const t = String(e ?? "");
  if (!Lf(t)) return t;
  const n = t.indexOf("://");
  return n >= 0 ? t.slice(0, n + 3) : "";
}
function Iw(e) {
  const t = r2(e);
  return t.length !== 4 || t[0] !== VM || !/^[1-9][0-9]*$/.test(t[1]) || !/^[0-9a-f]{8,32}$/.test(t[2]) || gp(t[3]) ? "" : t[2];
}
const Cu = (e) => Array.isArray(e) ? e.filter((t) => typeof t == "string").map((t) => t.toLowerCase()) : [], _c = Ea(null), s2 = Ea({});
function jM(e) {
  if (!e) return;
  const t = e.edit_kinds;
  t && typeof t == "object" && (_c.value = {
    office: new Set(Cu(t.office)),
    text: new Set(Cu(t.text)),
    names: new Set(Cu(t.text_names)),
    prefixes: Cu(t.text_mime_prefixes),
    mimes: new Set(Cu(t.text_mimes))
  });
  const n = e.limits;
  n && typeof n == "object" && (s2.value = { ...n });
}
function ofe() {
  return _c.value !== null;
}
function mv(e) {
  var t;
  return ((t = _c.value) == null ? void 0 : t.office.has(String(e ?? "").toLowerCase())) ?? !1;
}
function l2(e) {
  const t = _c.value;
  if (!t) return !1;
  const n = String(e ?? "").split(";")[0].trim().toLowerCase();
  return n ? t.mimes.has(n) || t.prefixes.some((a) => n.startsWith(a)) : !1;
}
function qM(e) {
  const t = e.replace(/[\\/]+$/, "").split(/[\\/]/);
  return (t[t.length - 1] ?? "").toLowerCase();
}
function WM(e) {
  const t = e.lastIndexOf(".");
  return t >= 0 ? e.slice(t + 1) : "";
}
function rfe(e) {
  const t = _c.value;
  if (!t || !e) return !1;
  const n = qM(String(e.basename ?? "")), a = String(e.extension ?? WM(n)).toLowerCase();
  return a && t.text.has(a) || n && t.names.has(n) ? !0 : l2(e.mime_type);
}
function xc(e) {
  const t = s2.value[e];
  return typeof t == "number" && t > 0 ? t : void 0;
}
function sfe(e) {
  return Array.from(e).length;
}
function by(e, t) {
  if (!t) return e;
  const n = Array.from(e);
  return n.length > t ? n.slice(0, t).join("") : e;
}
const YM = E(() => {
  oi.value;
  const e = /* @__PURE__ */ new Set();
  for (const t of Mr())
    t.rtl === !0 && e.add(t.code);
  return e;
});
function hl(e) {
  const t = Wi(e ?? "");
  return t && YM.value.has(t) ? "rtl" : "ltr";
}
function lfe(e = typeof document < "u" ? document.documentElement : null) {
  if (!e) return () => {
  };
  const t = () => {
    const i = hl(e.getAttribute("lang"));
    e.getAttribute("dir") !== i && e.setAttribute("dir", i);
  };
  t();
  const n = typeof MutationObserver < "u" ? new MutationObserver(t) : null;
  n == null || n.observe(e, { attributes: !0, attributeFilter: ["lang"] });
  const a = Xe(oi, t);
  return () => {
    n == null || n.disconnect(), a();
  };
}
function ei(e) {
  var n;
  const t = (n = e == null ? void 0 : e.closest) == null ? void 0 : n.call(e, '[dir="rtl"], [dir="ltr"]');
  return (t == null ? void 0 : t.getAttribute("dir")) === "rtl" ? "rtl" : "ltr";
}
function vv(e) {
  return e === "rtl" ? -1 : 1;
}
function Rf(e, t) {
  const n = e === "ArrowRight" ? 1 : e === "ArrowLeft" ? -1 : 0;
  return n === 0 ? 0 : n * vv(t);
}
function Rr(e, t) {
  return t === "rtl" ? e.right : e.left;
}
function Bw(e, t) {
  return t === "rtl" ? e.left : e.right;
}
function yv(e) {
  const t = Math.abs(e.scrollLeft);
  return { start: t > 0, end: e.scrollWidth - e.clientWidth - t > 1 };
}
function Fw(e, t, n, a, i = 8) {
  const r = a === "rtl" ? n - e : e;
  let l = r;
  if (r + t > n - i) {
    const c = r - t;
    l = c >= i ? c : Math.max(i, n - t - i);
  }
  return a === "rtl" ? n - l - t : l;
}
function Sc(e, t, n, a, i = 8) {
  const r = a === "rtl" ? n - e : e, l = r + t > n - i ? Math.max(i, n - i - t) : r;
  return a === "rtl" ? n - l - t : l;
}
const Nf = "⁦", Uw = "⁧", If = "⁨", Qu = "⁩", GM = new RegExp("[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?\\s*\\/\\s*[\\u2066-\\u2069]?\\d[\\d.,]*(?:\\s?[A-Za-z%]{1,3})?[\\u2066-\\u2069]?|[A-Za-z][\\w+.-]*:[^\\s,\\u060C)\\u2066-\\u2069]+|\\/(?:[A-Za-z0-9_.~%+-]+\\/)+[A-Za-z0-9_.~%+-]*|(?<![A-Za-z0-9_.~%+:\\/-])\\/(?=[A-Za-z0-9_.~%+-]*[A-Za-z0-9])[A-Za-z0-9_.~%+-]*[A-Za-z0-9_~%+-](?!\\.?[A-Za-z0-9_~%+:-])", "g");
function XM(e) {
  if (!(e[0] === Nf || e[0] === If || e[0] === Uw) || e[e.length - 1] !== Qu) return !1;
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    const a = e[n];
    if (a === Nf || a === If || a === Uw ? t += 1 : a === Qu && (t -= 1), t === 0 && n < e.length - 1) return !1;
  }
  return t === 0;
}
function u2(e) {
  return e.replace(GM, (t, n, a) => {
    if (XM(t)) return t;
    const i = a[n - 1], r = a[n + t.length];
    return (i === Nf || i === If) && r === Qu ? t : Nf + t + Qu;
  });
}
function Yi(e, t) {
  return hl(e) === "rtl" ? u2(t) : t;
}
function JM(e) {
  return If + e + Qu;
}
function c2(e) {
  if (e === "code") return "ltr";
  if (e === "text") return "auto";
}
function Bf(e, t) {
  return typeof (e == null ? void 0 : e.foreign) == "function" ? e.foreign(t) : t;
}
function $c(e) {
  const t = (n, a = {}) => {
    const i = HM(e)[n] ?? n, r = Object.entries(a).reduce((l, [c, p]) => l.replaceAll(`{${c}}`, String(p)), i);
    return Yi(e, r);
  };
  return t.foreign = (n) => Yi(e, n), t;
}
const d2 = {
  400: "err.status.400",
  401: "err.status.401",
  403: "err.status.403",
  404: "err.status.404",
  409: "err.status.409",
  413: "err.status.413",
  415: "err.status.415",
  422: "err.status.422",
  429: "err.status.429",
  500: "err.status.500",
  501: "err.status.501",
  /* ⚠ 502 and 504 are what an APP answers with (handlers/app_plugins.go
     callFail: any plugin error, and a plugin that ran out of time). */
  502: "err.status.502",
  503: "err.status.503",
  504: "err.status.504"
};
function ufe(e, t) {
  return f2(e, $c(t));
}
function f2(e, t) {
  return t(d2[e] ?? (e >= 500 ? "err.status.500" : "err.status.other"));
}
function cfe(e) {
  return e >= 400 && e < 500 && e in d2;
}
function ky(e) {
  const t = e.message;
  return typeof t == "string" ? t.trim() : "";
}
function dfe(e, t) {
  if (!e || typeof e != "object" || Array.isArray(e)) return "";
  const n = ky(e);
  return n ? Yi(t, n) : "";
}
function wy(e) {
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" && !Array.isArray(t) ? t : {};
  } catch {
    return {};
  }
}
function ZM(e) {
  const t = wy(e).error;
  return typeof t == "string" ? t : "";
}
function ffe(e, t, n) {
  return _y(e, t, $c(n));
}
function _y(e, t, n, a = {}) {
  const i = a.server || ky(wy(t));
  return i ? Bf(n, i) : f2(e, n);
}
function pa(e, t, n) {
  const a = wy(t), i = ky(a), r = new Error(_y(e, t, $c(n), { server: i }));
  r.status = e, r.code = ZM(t), r.detail = t.slice(0, 300), r.said = !0, i && (r.server = i);
  const l = a.admin_hint;
  return typeof l == "string" && l && (r.hint = l), typeof a.reason == "string" && a.reason && (r.reason = a.reason), r;
}
function Za(e, t) {
  const n = (r) => Yi(t, r), a = e;
  if (!a || a.said !== !0) return n(a instanceof Error ? a.message : e ? String(e) : "");
  if (a.server) return n(a.server);
  const i = a.code ?? "";
  return i && !xy(i) && !/^[a-z0-9_]+$/.test(i) ? n(i) : n(a.message ?? "");
}
function gv(e, t) {
  const n = new Error($c(e)("err.network"));
  return n.detail = t instanceof Error ? t.message : t ? String(t) : "", n.said = !0, n;
}
function xy(e) {
  const t = e.trim();
  return t ? /^[[{]/.test(t) || // a JSON body
  /\b[1-5]\d\d\b\s+[A-Z][a-z]+/.test(t) || // "500 Internal Server Error"
  /\b[A-Z][A-Z0-9]+_[A-Z0-9_]+\b/.test(t) || // FILEX_SECRET_KEY
  /\b(panic|goroutine|stack trace|Traceback|at [\w$.]+ \()/i.test(t) || /^[\w.-]+: [\w.-]+(: |$)/.test(t) || // "protocolauth: no secret key…"
  /(^|\s)\/(?:[\w.-]+\/){2,}/.test(t) || // /var/lib/filex/…
  /\b[a-z][\w.-]*: [^:()]{1,60}: [a-z][\w.-]*: /i.test(t) || // a Go error chain "a: b: c: d"
  /\b(ECONNREFUSED|ETIMEDOUT|EOF|nil pointer|dial tcp|x509|context deadline exceeded)\b/i.test(t) : !1;
}
function QM(e) {
  const t = /^(.*\S)\s*\(([^()]*)\)\s*$/.exec(e);
  return t && xy(t[2]) ? [t[1], t[2]] : [e, ""];
}
function p2(e, t, n = {}) {
  const a = e, i = (a == null ? void 0 : a.said) === !0, r = i ? (a == null ? void 0 : a.detail) ?? "" : a instanceof Error ? a.message : e ? String(e) : "", l = i ? n.t && typeof (a == null ? void 0 : a.status) == "number" ? _y(a.status, a.detail ?? "", n.t, { server: a.server }) : (a == null ? void 0 : a.message) || t : t;
  !i && r && typeof console < "u" && console.warn("[filex]", r);
  const c = Bf(n.t, l), p = Bf(n.t, r);
  return n.callerAdmin && r && r !== l ? { text: c, detail: p } : { text: c };
}
function Ff(e, t, n = {}) {
  const i = e.op_type === "plugin" || e.op_type === "plugin-action" ? t("plugin.failed", { label: e.label || e.action || t("opc.kind.plugin") }) : t("toast.failed");
  return eO(
    { error: e.error_message, error_code: e.error_code, error_engine: e.error_engine, error_text: e.error_text },
    i,
    t,
    n
  );
}
function eO(e, t, n, a = {}) {
  const i = (e.error ?? "").trim(), r = a.callerAdmin === !0, l = (m) => Bf(n, m), c = (m) => r && i && i !== m ? { text: l(m), detail: l(i) } : { text: l(m) }, p = (e.error_text ?? "").trim();
  if (p) return c(p);
  switch (e.error_code) {
    case "cancelled":
      return { text: n("opc.status.aborted") };
    case "app": {
      const [m, v] = QM(i);
      return m && !xy(m) ? v && r ? { text: l(m), detail: l(i) } : { text: l(m) } : c(t);
    }
  }
  return c(t);
}
const tO = "DRAFT_LIMIT", nO = "TARGET_TAKEN", aO = "FOLDER_GONE";
function Sy(e, t) {
  const n = e == null ? void 0 : e.detail;
  if (n)
    try {
      const a = JSON.parse(n);
      return a && typeof a == "object" ? a[t] : void 0;
    } catch {
      return;
    }
}
function pfe(e) {
  return Sy(e, "code") === tO;
}
function hfe(e) {
  return Sy(e, "code") === aO;
}
function mfe(e) {
  const t = Sy(e, "limit");
  return typeof t == "number" && t > 0 ? t : null;
}
function iO(e, t) {
  const n = e.replace(/\/+$/, ""), a = (l) => `${n}/${encodeURIComponent(l)}`;
  async function i(l, c = {}) {
    const p = await t.request(l, {
      ...c,
      headers: { "Content-Type": "application/json", ...c.headers ?? {} }
    }), m = await p.text().catch(() => "");
    let v = null;
    if (m)
      try {
        v = JSON.parse(m);
      } catch {
        v = null;
      }
    return { status: p.status, body: v, text: m };
  }
  function r(l, c) {
    throw pa(l, c, t.locale);
  }
  return {
    /**
     * New document, as a draft (the New document dialog's request): the same
     * body as `action=newfile`, answered with the same fields — `path` is the
     * draft's — plus the draft itself. A refusal throws; DRAFT_LIMIT is the
     * one the dialog says in its own words (isDraftLimit).
     */
    async create(l, c, p, m = {}) {
      var x;
      const v = await i(n, {
        method: "POST",
        body: JSON.stringify(m.exactName ? { path: l, name: c, type: p, exact_name: !0 } : { path: l, name: c, type: p })
      });
      return (v.status !== 201 || !((x = v.body) != null && x.draft)) && r(v.status, v.text), v.body;
    },
    /** Every draft of the caller's, across every storage they can see. */
    async list() {
      const l = await i(n);
      return (l.status !== 200 || !l.body) && r(l.status, l.text), { drafts: l.body.drafts ?? [], count: l.body.count ?? 0, limit: l.body.limit ?? 0 };
    },
    /** How many — the navigation panel's badge. */
    async count() {
      const l = await i(`${n}/count`);
      return (l.status !== 200 || !l.body) && r(l.status, l.text), { count: l.body.count ?? 0, limit: l.body.limit ?? 0 };
    },
    /** One draft — what an editor on a draft's path asks. */
    async get(l) {
      const c = await i(a(l));
      return (c.status !== 200 || !c.body) && r(c.status, c.text), c.body;
    },
    /**
     * Save the draft where it is meant to go — under `as` when given (only
     * ever the `suggested` name a taken answer offered).
     */
    async save(l, c) {
      var m, v;
      const p = await i(`${a(l)}/save`, { method: "POST", body: JSON.stringify(c ? { as: c } : {}) });
      if (p.status === 200 && ((m = p.body) != null && m.path))
        return { saved: !0, path: p.body.path, name: p.body.name ?? "", targetDir: p.body.target_dir ?? "" };
      if (p.status === 409 && ((v = p.body) == null ? void 0 : v.code) === nO && p.body.suggested)
        return {
          saved: !1,
          taken: !0,
          name: p.body.name ?? "",
          suggested: p.body.suggested,
          targetDir: p.body.target_dir ?? ""
        };
      r(p.status, p.text);
    },
    /** Discard it: the draft goes to the trash (restorable until it ages out). */
    async discard(l) {
      const c = await i(a(l), { method: "DELETE" });
      c.status !== 200 && r(c.status, c.text);
    }
  };
}
function h2(e) {
  const t = e.indexOf("://"), n = t >= 0 ? e.slice(0, t) : "", a = (t >= 0 ? e.slice(t + 3) : e).replace(/^\/+|\/+$/g, "");
  return [n, ...a.split("/").filter(Boolean)].filter(Boolean).join(" / ");
}
const oO = "X-Filex-Text-Dialect", m2 = [",", ";", "	", "|"], v2 = /^[a-z0-9_-]{1,40}$/i;
function rO(e) {
  if (!e) return;
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return;
  }
  const n = t;
  if (!(!n || typeof n != "object" || typeof n.delimiter != "string" || !m2.includes(n.delimiter) || typeof n.bom != "boolean" || typeof n.crlf != "boolean" || typeof n.encoding != "string" || !v2.test(n.encoding)))
    return { delimiter: n.delimiter, bom: n.bom, crlf: n.crlf, encoding: n.encoding.toLowerCase() };
}
function sO(e, t) {
  try {
    return new TextDecoder(t).decode(e);
  } catch {
    return new TextDecoder().decode(e);
  }
}
function y2(e) {
  if (e == null) return;
  if (typeof e != "object" || Array.isArray(e)) return null;
  const t = e, n = {};
  if (t.delimiter !== void 0) {
    if (typeof t.delimiter != "string" || !m2.includes(t.delimiter)) return null;
    n.csv_delimiter = t.delimiter;
  }
  if (t.encoding !== void 0) {
    if (typeof t.encoding != "string" || !v2.test(t.encoding)) return null;
    n.csv_encoding = t.encoding;
  }
  if (t.bom !== void 0) {
    if (typeof t.bom != "boolean") return null;
    n.csv_bom = t.bom ? "1" : "0";
  }
  if (t.eol !== void 0) {
    if (t.eol !== "crlf" && t.eol !== "lf") return null;
    n.csv_eol = t.eol;
  }
  return n;
}
const lO = ["zero", "one", "two", "few", "many", "other"], Hw = ["one", "other"], Kw = /* @__PURE__ */ new Map();
function g2(e) {
  const t = String(e ?? ""), n = Kw.get(t);
  if (n !== void 0) return n;
  let a = null;
  if (typeof Intl < "u" && typeof Intl.PluralRules == "function")
    try {
      a = new Intl.PluralRules(t || "en");
    } catch {
      try {
        a = new Intl.PluralRules("en");
      } catch {
        a = null;
      }
    }
  return Kw.set(t, a), a;
}
const Vw = /* @__PURE__ */ new Map(), uO = 999;
function cO(e) {
  const t = String(e ?? ""), n = Vw.get(t);
  if (n) return n;
  let a = Hw;
  const i = g2(t);
  if (i)
    try {
      const r = /* @__PURE__ */ new Set(["other"]);
      for (let l = 0; l <= uO; l++) r.add(i.select(l));
      a = lO.filter((l) => r.has(l));
    } catch {
      a = Hw;
    }
  return Vw.set(t, a), a;
}
function $y(e, t) {
  if (!Number.isFinite(t)) return "other";
  const n = Math.abs(t), a = g2(e);
  if (!a) return n === 1 ? "one" : "other";
  try {
    return a.select(n);
  } catch {
    return n === 1 ? "one" : "other";
  }
}
function vfe(e, t, n) {
  const a = Math.abs(t), i = cO(e), r = $y(e, a);
  if (n === i.length && n > 1) {
    const l = i.indexOf(r);
    return l >= 0 ? l : n - 1;
  }
  return n === 1 ? 0 : n === 2 ? r === "one" ? 0 : 1 : n === 3 ? a === 0 ? 0 : r === "one" ? 1 : 2 : n - 1;
}
function dO(e) {
  return e.includes(".") && e.replace(/[. ]/g, "") === "";
}
function fO(e) {
  return e !== "" && e.replace(/ /g, "") === "";
}
const pO = String.fromCodePoint(0), hO = new RegExp(
  "[" + String.fromCodePoint(1) + "-" + String.fromCodePoint(31) + String.fromCodePoint(127) + "]"
);
function Ty(e) {
  return e.replace(new RegExp("^\\p{White_Space}+|\\p{White_Space}+$", "gu"), "");
}
function b2(e) {
  return e === "" || fO(e) ? "empty" : e.includes("/") || e.includes("\\") ? "separator" : e.includes(pO) ? "nul" : hO.test(e) ? "control" : dO(e) ? "dots" : null;
}
const k2 = /* @__PURE__ */ new Set([
  1564,
  8206,
  8207,
  8234,
  8235,
  8236,
  8237,
  8238,
  8294,
  8295,
  8296,
  8297
]), pf = String.fromCodePoint(65533);
function mO(e) {
  return k2.has(e);
}
const w2 = new RegExp(
  "[" + [...k2].map((e) => String.fromCodePoint(e)).join("") + "]",
  "u"
);
function fa(e) {
  if (!e || !w2.test(e)) return e;
  let t = "";
  for (const n of e)
    t += mO(n.codePointAt(0) ?? 0) ? pf : n;
  return t;
}
const vO = 8294, yO = 8295, gO = 8296, bO = 8297;
function kO(e) {
  return e >= 8234 && e <= 8238;
}
function _2(e) {
  if (!e || !w2.test(e)) return e;
  const t = [...e], n = [];
  for (let a = 0; a < t.length; a++) {
    const i = t[a].codePointAt(0) ?? 0;
    kO(i) ? t[a] = pf : i === vO || i === yO || i === gO ? n.push(a) : i === bO && (n.length ? n.pop() : t[a] = pf);
  }
  for (const a of n) t[a] = pf;
  return t.join("");
}
const wO = Object.freeze([
  "viewer",
  "host",
  "account",
  "device"
]);
function x2(e) {
  for (const t of wO) {
    if (t === "device") break;
    const n = e[t];
    if (typeof n == "string" && n && Jr(n)) return { zone: n, tier: t };
  }
  return { zone: void 0, tier: "device" };
}
const Ku = "filex.timezone.viewer", Uf = "filex.timezone", _O = [
  "UTC",
  "Europe/Istanbul",
  "Europe/London",
  "Europe/Berlin",
  "Europe/Paris",
  "Europe/Madrid",
  "Europe/Moscow",
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "America/Sao_Paulo",
  "Africa/Cairo",
  "Africa/Lagos",
  "Asia/Dubai",
  "Asia/Karachi",
  "Asia/Kolkata",
  "Asia/Shanghai",
  "Asia/Tokyo",
  "Asia/Seoul",
  "Asia/Singapore",
  "Australia/Sydney",
  "Pacific/Auckland"
];
function S2() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}
function Jr(e) {
  if (!e) return !1;
  try {
    return new Intl.DateTimeFormat("en-US", { timeZone: e }), !0;
  } catch {
    return !1;
  }
}
function yfe() {
  try {
    const e = Intl.supportedValuesOf;
    if (typeof e == "function") {
      const t = e("timeZone");
      if (Array.isArray(t) && t.length)
        return t.includes("UTC") ? [...t] : ["UTC", ...t];
    }
  } catch {
  }
  return [..._O];
}
function jw(e, t) {
  const n = t ?? xO();
  try {
    const a = new Intl.DateTimeFormat("en-CA", {
      timeZone: n,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).formatToParts(e), i = (p) => {
      var m;
      return Number((m = a.find((v) => v.type === p)) == null ? void 0 : m.value);
    }, r = i("year"), l = i("month"), c = i("day");
    if (!Number.isFinite(r) || !Number.isFinite(l) || !Number.isFinite(c))
      throw new Error("unparsable");
    return Math.floor(Date.UTC(r, l - 1, c) / 864e5);
  } catch {
    return Math.floor(
      Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()) / 864e5
    );
  }
}
function Vu(e) {
  try {
    const t = localStorage.getItem(e);
    return t && Jr(t) ? t : "";
  } catch {
    return "";
  }
}
function $2(e, t) {
  try {
    t ? localStorage.setItem(e, t) : localStorage.removeItem(e);
  } catch {
  }
}
const Ay = typeof window < "u", Nr = S(Ay ? Vu(Ku) : "");
function T2() {
  const e = S([]);
  return {
    set(t, n) {
      const a = e.value.find((i) => i.owner === t);
      if (n === null) {
        a && (e.value = e.value.filter((i) => i !== a));
        return;
      }
      a && a.zone === n || (e.value = [...e.value.filter((i) => i.owner !== t), { owner: t, zone: n }]);
    },
    of(t) {
      var n;
      return ((n = e.value.find((a) => a.owner === t)) == null ? void 0 : n.zone) ?? null;
    },
    current() {
      const t = e.value;
      return t.length ? t[t.length - 1].zone : "";
    },
    /** The newest answer among the owners `pick` accepts. */
    currentWhere(t) {
      const n = e.value.filter((a) => t(a.owner));
      return n.length ? n[n.length - 1].zone : "";
    }
  };
}
const Tc = T2(), ko = T2(), bp = /* @__PURE__ */ new Set(), Ey = E(
  () => x2({
    viewer: Nr.value,
    host: Tc.current(),
    account: ko.current()
  })
);
function xO() {
  return Ey.value.zone;
}
function gfe() {
  return Ey.value;
}
const A2 = Symbol("filex-explorer-clock");
function SO(e) {
  return e ? {
    viewer: Nr.value,
    host: Tc.of(e) ?? "",
    account: ko.of(e) ?? ko.currentWhere((t) => bp.has(t))
  } : TO();
}
function $O(e) {
  return e ? x2(SO(e)) : Ey.value;
}
function E2(e) {
  return $O(e).zone;
}
function TO() {
  return {
    viewer: Nr.value,
    host: Tc.current(),
    account: ko.current()
  };
}
function bfe() {
  return Nr.value;
}
function AO(e) {
  const t = e && Jr(e) ? e : "";
  Nr.value = t, $2(Ku, t);
  try {
    window.dispatchEvent(new CustomEvent("filex:timezone", { detail: t }));
  } catch {
  }
}
function EO(e, t) {
  Tc.set(e, t && Jr(t) ? t : null);
}
function hf(e, t, n = {}) {
  if (t == null) {
    ko.set(e, null);
    return;
  }
  const a = t && Jr(t) ? t : "";
  ko.set(e, a), n.remember && (bp.add(e), $2(Uf, a));
}
function CO(e) {
  return ko.of(e);
}
function zO(e) {
  return {
    get: () => CO(e) ?? "",
    set: (t) => {
      hf(e, t && Jr(t) ? t : "", { remember: !0 }), AO("");
    }
  };
}
function kfe() {
  return Ay ? Vu(Uf) : "";
}
function MO(e) {
  Tc.set(e, null), ko.set(e, null), bp.delete(e);
}
if (Ay)
  try {
    window.addEventListener("storage", (e) => {
      if ((e.key === null || e.key === Ku) && (Nr.value = Vu(Ku)), e.key === null || e.key === Uf) {
        const t = Vu(Uf);
        for (const n of bp) ko.set(n, t);
      }
    }), window.addEventListener("filex:timezone", (e) => {
      const t = e.detail;
      Nr.value = typeof t == "string" ? t && Jr(t) ? t : "" : Vu(Ku);
    });
  } catch {
  }
const qw = /* @__PURE__ */ new Map();
function gi(e) {
  if (!e || e === "en") return "en-US";
  if (e === "tr") return "tr-TR";
  let t = qw.get(e);
  if (!t) {
    try {
      t = Intl.getCanonicalLocales(e)[0] || "en-US";
    } catch {
      t = "en-US";
    }
    qw.set(e, t);
  }
  return t;
}
const Ww = [
  "unit.bytes",
  "unit.kb",
  "unit.mb",
  "unit.gb",
  "unit.tb",
  "unit.pb"
], OO = {
  "unit.bytes": "B",
  "unit.kb": "KB",
  "unit.mb": "MB",
  "unit.gb": "GB",
  "unit.tb": "TB",
  "unit.pb": "PB"
};
function PO(e, t = {}) {
  const n = t.empty ?? "-";
  if (e == null || !Number.isFinite(e) || e < 0) return n;
  const a = t.base ?? 1e3, i = t.unit ?? ((m) => OO[m]);
  let r = 0, l = e;
  for (; l >= a && r < Ww.length - 1; )
    l /= a, r += 1;
  const c = r === 0 ? 0 : t.digits === "fixed1" ? 1 : l < 10 ? 2 : 1;
  let p;
  if (t.numberLocale == null)
    p = l.toFixed(c);
  else {
    const m = DO(t.numberLocale, c, t.digits === "fixed1" ? c : 0);
    p = m ? m.format(l) : l.toFixed(c);
  }
  return `${p} ${i(Ww[r])}`;
}
const Jd = /* @__PURE__ */ new Map();
function DO(e, t, n) {
  const a = `${e}|${t}|${n}`;
  if (!Jd.has(a))
    try {
      Jd.set(a, new Intl.NumberFormat(e, {
        maximumFractionDigits: t,
        minimumFractionDigits: n
      }));
    } catch {
      Jd.set(a, null);
    }
  return Jd.get(a) ?? null;
}
const Yw = /* @__PURE__ */ new Map();
function C2(e, t, n) {
  const a = E2(n), i = `${e}|${a ?? `device:${S2()}`}|${JSON.stringify(t)}`;
  let r = Yw.get(i);
  return r || (r = new Intl.DateTimeFormat(e, { ...t, timeZone: a }), Yw.set(i, r)), r;
}
function Hf(e, t, n, a) {
  try {
    return C2(gi(t), n, a).format(e);
  } catch {
    return e.toISOString();
  }
}
const LO = /^(\d{4})-(\d{2})-(\d{2})$/, Gw = /* @__PURE__ */ new Map();
function RO(e, t) {
  const n = LO.exec(e.trim());
  if (!n) return "";
  const a = new Date(Date.UTC(Number(n[1]), Number(n[2]) - 1, Number(n[3])));
  if (Number.isNaN(a.getTime())) return "";
  const i = gi(t);
  let r = Gw.get(i);
  try {
    return r || (r = new Intl.DateTimeFormat(i, { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }), Gw.set(i, r)), r.format(a);
  } catch {
    return "";
  }
}
function mf(e) {
  if (!e) return null;
  const t = new Date(e * (e < 1e12 ? 1e3 : 1));
  return Number.isNaN(t.getTime()) ? null : t;
}
function z2(e) {
  if (e == null || e === "") return null;
  if (e instanceof Date) return Number.isNaN(e.getTime()) ? null : e;
  if (typeof e == "number") return mf(e);
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? null : t;
}
const NO = { month: "short", day: "numeric", year: "numeric" }, IO = { timeStyle: "short" };
function M2(e, t, n = {}, a) {
  const i = z2(e);
  if (!i) return "";
  const r = Hf(i, t, NO, a);
  return n.time ? `${r}, ${Hf(i, t, IO, a)}` : r;
}
function BO(e, t, n) {
  const a = z2(e);
  if (!a) return "";
  const i = E2(n) ?? S2();
  return `${Hf(a, t, { dateStyle: "full", timeStyle: "long" }, n)} (${i})`;
}
const O2 = Symbol("filex-explorer-locale"), FO = ["count", "n", "days"];
function Xw(e, t, n, a = "en") {
  const i = FO.find((c) => c in t);
  if (i === void 0) return e;
  const r = $y(a, Number(t[i]));
  if (r === "other") return e;
  const l = `${e}_${r}`;
  return n(l) ? l : e;
}
function Bs(e, t) {
  const n = e[t];
  return typeof n == "string" && n ? n : void 0;
}
function UO(e, t, n = {}) {
  const a = e.strings, i = Xw(t, n, (c) => Bs(a, c) !== void 0, e.lang), r = Bs(a, i) ?? Bs(a, t);
  if (r !== void 0) return r;
  if (a === Gs) return t;
  const l = Xw(t, n, (c) => Bs(Gs, c) !== void 0, "en");
  return Bs(Gs, l) ?? Bs(Gs, t) ?? t;
}
function HO(e) {
  if (e.trashed) return !0;
  const t = e.extra_metadata;
  return t && typeof t == "object" && "deleted_at" in t ? !0 : typeof e.path == "string" && /(^|[/:])\.trash\//.test(e.path);
}
function Jw(e, t) {
  return Object.entries(t).reduce(
    (n, [a, i]) => n.replaceAll(`{${a}}`, String(i)),
    e
  );
}
function P2(e, t, n, a) {
  const i = UO(e, t, n), r = {};
  for (const [c, p] of Object.entries(n)) r[c] = typeof p == "string" ? _2(p) : p;
  if (!a) return Jw(i, r);
  const l = {};
  for (const [c, p] of Object.entries(r)) l[c] = typeof p == "string" ? JM(p) : p;
  return u2(Jw(i, l));
}
function wfe(e, t, n = {}) {
  return P2(e2(e), t, n, hl(e) === "rtl");
}
function ht(e) {
  const t = () => typeof e == "function" ? e() : e.value, n = E(() => (oi.value, e2(t()))), a = Go() ? bi(A2, void 0) : void 0, i = E(() => hl(t()));
  function r(b, C = {}) {
    return P2(n.value, b, C, i.value === "rtl");
  }
  r.foreign = (b) => Yi(t(), b);
  function l(b) {
    return PO(b, {
      unit: (C) => r(C),
      numberLocale: gi(t())
    });
  }
  function c(b) {
    return b ? b.size_partial ? typeof b.size == "number" && b.size > 0 ? r("size.at_least", { size: l(b.size) }) : "-" : l(b.size) : l(null);
  }
  function p(b) {
    if (b != null && b.size_partial)
      return typeof b.size == "number" && b.size > 0 ? r("size.partial_hint") : r("size.unknown_hint");
  }
  function m(b) {
    return b.basename === ".trash" ? r("node.trash") : fa(v(b));
  }
  function v(b) {
    if (b.basename === ".trash") return r("node.trash");
    if (typeof b.fxe_name == "string" && b.fxe_name) return b.fxe_name;
    if (HO(b)) {
      const C = b.basename.match(/^\d{8}-\d{6}-[A-Za-z0-9]+__(.+)$/);
      if (C) return C[1];
    }
    return b.basename;
  }
  function x(b, C = {}) {
    return M2(b, t(), C, a);
  }
  function k(b) {
    return BO(b, t(), a);
  }
  function _(b) {
    const C = b instanceof Date ? b : mf(b);
    return C ? Hf(C, t(), { month: "long", year: "numeric" }, a) : "";
  }
  function w(b) {
    const C = b instanceof Date ? b : mf(b);
    if (!C) return "";
    try {
      return C2("en-CA", { year: "numeric", month: "2-digit" }, a).format(C);
    } catch {
      return `${C.getFullYear()}-${String(C.getMonth() + 1).padStart(2, "0")}`;
    }
  }
  return {
    t: r,
    formatSize: l,
    formatNodeSize: c,
    nodeSizeHint: p,
    formatDate: x,
    formatDateFull: k,
    formatMonthYear: _,
    zonedYearMonth: w,
    /**
     * zaman:z1 — the wire's `last_modified` as a `Date`, or null.
     *
     * Handed out because "seconds or milliseconds" is a fact about the WIRE,
     * not about formatting, and every caller that needs the instant itself
     * (rather than a string) was otherwise re-typing `v * (v < 1e12 ? 1000 :
     * 1)`. ListView had the third copy and used it to group rows by day — so
     * the grouping and the cell four pixels away were reading the same number
     * through two different converters.
     */
    toDate: mf,
    nodeDisplayName: m,
    nodeName: v,
    /**
     * ⚠ RTL — which way this surface's language is written (`lib/direction`,
     * the server's one list). Bind it as `dir` on anything Teleported out of
     * the explorer's root: under `<body>` a menu inherits the HOST page's
     * direction, not the language its own words are in.
     */
    dir: i
  };
}
const Ir = S(0), ec = S(0), KO = E(() => Ir.value !== 0), _fe = E(() => Ir.value), xfe = E(() => ec.value), VO = 3e3;
let tc = 0;
function Zw(e = Date.now()) {
  tc = e || 1;
}
function jO() {
  tc = 0;
}
typeof window < "u" && typeof window.addEventListener == "function" && (window.addEventListener("beforeunload", () => Zw()), window.addEventListener("pagehide", () => Zw()), window.addEventListener("pageshow", () => jO()));
function qO(e) {
  const t = e;
  return !t || typeof t != "object" ? !1 : t.name === "AbortError" || t.name === "CanceledError" || t.code === "ERR_CANCELED" ? !0 : t.code === "ECONNABORTED" && typeof t.message == "string" && /aborted/i.test(t.message);
}
function WO(e, t = Date.now()) {
  return qO(e) ? !0 : tc !== 0 && t - tc < VO;
}
function bv(e, t = Date.now(), n) {
  return WO(n, t) ? "folded" : (Ir.value === 0 && (Ir.value = t || 1), e === "background" ? (ec.value += 1, "folded") : "say");
}
function kv() {
  Ir.value === 0 && ec.value === 0 || (Ir.value = 0, ec.value = 0);
}
function Sfe() {
  Ir.value = 0, ec.value = 0, tc = 0;
}
function YO(e) {
  const t = String(e ?? "get").toLowerCase();
  return t === "get" || t === "head" || t === "options" ? "background" : "action";
}
function D2(e) {
  const t = e.apiBase != null ? e.apiBase.replace(/\/+$/, "") : null;
  function n(i, r) {
    return i || (t === null ? null : `${t}${r}`);
  }
  const a = e.endpoint ?? (t !== null ? `${t}/api/files/manager` : null);
  if (!a)
    throw new Error(
      "[@brftech/filex-core] config requires either `apiBase` or `endpoint`"
    );
  return {
    manager: a,
    // Staged (chunked + resumable) uploads — what useUploadChunked speaks on
    // every driver. The {id} routes are derived from this one.
    uploadBegin: n(e.uploadBegin, "/api/files/upload/begin"),
    shareCreate: n(e.shareCreate, "/api/files/share"),
    shareList: n(e.shareList, "/api/files/share"),
    shareDelete: n(e.shareDelete, "/api/files/share/{uuid}"),
    limits: n(e.limits, "/api/files/limits"),
    capabilities: n(e.capabilities, "/api/files/capabilities"),
    me: n(e.me, "/api/auth/me"),
    archiveList: n(e.archiveList, "/api/files/archive/list"),
    archiveExtract: n(e.archiveExtract, "/api/files/archive/extract"),
    archiveCreate: n(e.archiveCreate, "/api/files/archive/create"),
    archiveAdd: n(e.archiveAdd, "/api/files/archive/add"),
    copy: n(e.copy, "/api/files/copy"),
    moveAsync: n(e.moveAsync, "/api/files/move"),
    deleteAsync: n(e.deleteAsync, "/api/files/delete"),
    opsList: n(e.opsList, "/api/files/ops"),
    opsShow: n(e.opsShow, "/api/files/ops/{id}"),
    onlyOfficeConfig: n(e.onlyOfficeConfig, "/api/files/onlyoffice/config"),
    saveText: n(e.saveText, "/api/files/save-text"),
    restore: n(e.restore, "/api/files/restore"),
    // filex trash: list soft-deleted nodes + restore one by node id.
    trashList: n(e.trashList, "/api/files/manager/trash"),
    trashRestore: n(e.trashRestore, "/api/files/manager/restore"),
    /* An operator's "Delete permanently" of one trash entry (`{id}`). */
    trashPurge: n(e.trashPurge, "/api/admin/trash/{id}"),
    /* An operator's permanent delete of a selection, in one request. */
    trashPurgeBatch: n(e.trashPurgeBatch, "/api/admin/trash/purge"),
    /* An operator's "Empty trash": POST starts it, GET follows it,
       `/preview` counts what it would delete. */
    trashEmpty: n(e.trashEmpty, "/api/admin/trash/empty"),
    /* An operator's hard delete of one version (`{id}`). */
    versionPurge: n(e.versionPurge, "/api/admin/versions/{id}"),
    /* wiring:e2 — escrow proof-of-possession, then the owner is told. */
    e2eEscrowChallenge: n(e.e2eEscrowChallenge, "/api/files/e2e/escrow/challenge"),
    e2eEscrowUsed: n(e.e2eEscrowUsed, "/api/files/e2e/escrow/used"),
    /* wiring:e2 convert — after a folder is encrypted in place. */
    e2eCleanup: n(e.e2eCleanup, "/api/files/e2e/cleanup"),
    /* wiring:e2 policy — may this account encrypt here, and asking for it. */
    e2eAllowed: n(e.e2eAllowed, "/api/files/e2e/allowed"),
    e2eRequests: n(e.e2eRequests, "/api/files/e2e/requests"),
    /* App plugins — docs/APP-PLUGINS-API.md. */
    pluginActions: n(e.pluginActions, "/api/files/plugins/actions"),
    pluginActionRun: n(e.pluginActionRun, "/api/files/plugins/actions/{plugin}/{action}/run"),
    pluginView: n(e.pluginView, "/api/files/plugins/views/{plugin}/{view}"),
    pluginViewEvent: n(e.pluginViewEvent, "/api/files/plugins/views/{plugin}/{view}/event"),
    pluginUsers: n(e.pluginUsers, "/api/files/plugins/users"),
    opsCancel: n(e.opsCancel, "/api/files/ops/{id}/cancel"),
    /* v4 — an app's own interface (AppFrame): its module, and its saves. */
    pluginUICall: n(e.pluginUICall, "/api/files/plugins/ui/{plugin}/{view}/call"),
    pluginUISave: n(e.pluginUISave, "/api/files/plugins/ui/{plugin}/{view}/save"),
    /* 0.54 - what an interface reads of its file, checked by the server (#211). */
    pluginUIRead: n(e.pluginUIRead, "/api/files/plugins/ui/{plugin}/{view}/read"),
    /* 0.56 - editing together (files:co-edit): the relay's routes (#189). */
    pluginUICoEdit: n(e.pluginUICoEdit, "/api/files/plugins/ui/{plugin}/{view}/coedit"),
    /* 0.52.0 - a paid app's license, as the app itself reads it (fx.license.get()). */
    pluginLicense: n(e.pluginLicense, "/api/files/plugins/license/{plugin}")
  };
}
const GO = ["allowed", "request", "denied"];
function XO(e) {
  return typeof e == "string" && GO.includes(e) ? e : "allowed";
}
async function JO(e) {
  if (typeof e == "function") {
    const t = e();
    return t instanceof Promise ? await t : t;
  }
  return e;
}
function ZO(e) {
  return e ? "kind" in e ? e : e.type === "bearer" ? { kind: "bearer", token: e.token } : e.type === "csrf" ? { kind: "csrf", csrf: e.csrf } : { kind: "none" } : { kind: "none" };
}
const QO = 8 << 20;
function zl(e) {
  const t = D2(e), n = ZO(e.auth);
  let a = null;
  async function i(ie = {}) {
    const ue = { Accept: "application/json", ...ie };
    if (n.kind === "bearer") {
      const Pe = await JO(n.token);
      Pe && (ue.Authorization = `Bearer ${Pe}`, a = Pe);
    } else if (n.kind === "csrf")
      ue["X-CSRF-TOKEN"] = n.csrf, ue["X-Requested-With"] = "XMLHttpRequest";
    else if (n.kind === "basic") {
      const Pe = btoa(`${n.user}:${n.pass}`);
      ue.Authorization = `Basic ${Pe}`;
    }
    return ue;
  }
  function r(ie = {}) {
    const ue = { Accept: "application/json", ...ie };
    if (n.kind === "bearer") {
      const Pe = typeof n.token == "string" ? n.token : a;
      Pe && (ue.Authorization = `Bearer ${Pe}`);
    } else if (n.kind === "csrf")
      ue["X-CSRF-TOKEN"] = n.csrf, ue["X-Requested-With"] = "XMLHttpRequest";
    else if (n.kind === "basic") {
      const Pe = btoa(`${n.user}:${n.pass}`);
      ue.Authorization = `Basic ${Pe}`;
    }
    return ue;
  }
  function l() {
    return n.kind === "csrf" ? "include" : "same-origin";
  }
  const c = () => Ca(e.locale);
  async function p(ie, ue = {}) {
    const Pe = await m(ie, ue);
    if (!Pe.ok) {
      const ot = await Pe.text().catch(() => "");
      throw pa(Pe.status, ot, c());
    }
    if (Pe.status === 204 || Pe.status === 205) return;
    const Ge = await Pe.text();
    if (Ge)
      return JSON.parse(Ge);
  }
  async function m(ie, ue = {}) {
    const Pe = {
      // ⚠⚠ The language on SCREEN, not the one the browser was installed in.
      // Everything the server writes for a person — a plugin's surface, the
      // labels inside it, the message on a queued job — is rendered with the
      // request's `Accept-Language`. Chrome sends `en-US` whatever filex is
      // set to, so a Turkish window asked a signing wizard for its screens
      // and got "Identity" and an English help line in the middle of Turkish
      // ones. The window's own language is the only right answer here.
      "Accept-Language": gi(Ca(e.locale)),
      ...await i(),
      ...ue.headers ?? {}
    };
    let Ge;
    try {
      Ge = await fetch(ie, {
        ...ue,
        headers: Pe,
        credentials: l()
      });
    } catch (ot) {
      throw (ot == null ? void 0 : ot.name) === "AbortError" ? ot : (bv(YO(ue.method), Date.now(), ot), gv(c(), ot));
    }
    return kv(), Ge;
  }
  const v = t.manager.replace(/\/manager(\?.*)?$/, "/drafts"), x = iO(v, {
    request: m,
    get locale() {
      return c();
    }
  });
  function k(ie = "") {
    return t.manager.replace(/\/manager(\?.*)?$/, "/permissions") + ie;
  }
  async function _(ie) {
    return p(k() + "?path=" + encodeURIComponent(ie));
  }
  async function w(ie) {
    return p(k("/resolve") + "?email=" + encodeURIComponent(ie));
  }
  async function b(ie) {
    return p(k("/users") + "?q=" + encodeURIComponent(ie));
  }
  async function C(ie) {
    try {
      return await p(k("/groups") + "?q=" + encodeURIComponent(ie));
    } catch {
      return { groups: [] };
    }
  }
  async function A(ie, ue) {
    return p(k("/groups/" + ie), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: ue }) });
  }
  async function T(ie) {
    return p(k("/groups/" + ie), { method: "DELETE" });
  }
  async function R(ie) {
    return p(k(), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(ie) });
  }
  async function M(ie, ue) {
    return p(k("/" + ie), { method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ level: ue }) });
  }
  async function L(ie) {
    return p(k("/" + ie), { method: "DELETE" });
  }
  async function U(ie) {
    return p(k("/invite"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(ie) });
  }
  async function P(ie) {
    return p(k("/share-mail"), { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(ie) });
  }
  async function H(ie, ue) {
    const Pe = new URLSearchParams({ share: ie });
    return ue && Pe.set("lang", ue), p(k("/share-message") + "?" + Pe.toString());
  }
  function $(ie) {
    const ue = new URLSearchParams();
    for (const [Pe, Ge] of Object.entries(ie))
      Ge != null && ue.set(Pe, String(Ge));
    return ue.toString();
  }
  function F(ie, ue = {}) {
    const Pe = t.manager.includes("?") ? "&" : "?";
    return `${t.manager}${Pe}${$({ q: ie, action: ie, ...ue })}`;
  }
  async function I(ie) {
    return p(F("index", { path: hv(ie) }));
  }
  async function Z(ie, ue, Pe) {
    return p(F("search", { ...Pe ?? {}, path: hv(ie), filter: ue }));
  }
  async function J(ie, ue = {}) {
    return (await re(ie, ue)).hits;
  }
  async function re(ie, ue = {}) {
    const Pe = t.manager.replace(/\/manager(\?.*)?$/, "/search"), Ge = Pe.includes("?") ? "&" : "?", ot = `${Pe}${Ge}${$({ ...ue.narrow ?? {}, q: ie, limit: ue.limit, scope: ue.scope })}`, St = await p(ot);
    return {
      hits: Array.isArray(St == null ? void 0 : St.results) ? St.results : [],
      truncated: typeof (St == null ? void 0 : St.truncated) == "boolean" ? St.truncated : void 0,
      total: typeof (St == null ? void 0 : St.total) == "number" ? St.total : void 0
    };
  }
  async function ve(ie, ue, Pe) {
    const Ge = t.manager.replace(/\/manager(\?.*)?$/, "/search/match"), ot = await p(Ge, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ q: ie, names: ue }),
      signal: Pe
    });
    return Array.isArray(ot == null ? void 0 : ot.matches) ? ot.matches : [];
  }
  async function W() {
    const ie = t.manager.replace(/\/manager(\?.*)?$/, "/quota/me");
    try {
      const ue = await p(ie);
      return ue && typeof ue.used_bytes == "number" ? ue : null;
    } catch {
      return null;
    }
  }
  async function z() {
    const ie = t.manager.replace(/\/manager(\?.*)?$/, "/quota/storages");
    try {
      const ue = await p(ie);
      return Array.isArray(ue == null ? void 0 : ue.storages) ? ue.storages : null;
    } catch {
      return null;
    }
  }
  async function le() {
    const ie = t.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "");
    try {
      const ue = await p(`${ie}/api/app-store`);
      return {
        visible: (ue == null ? void 0 : ue.visible) === !0,
        stores: Array.isArray(ue == null ? void 0 : ue.stores) ? ue.stores.filter((Pe) => typeof Pe == "string") : []
      };
    } catch {
      return null;
    }
  }
  async function fe(ie) {
    return p(F("subfolders", { path: ie }));
  }
  async function j(ie, ue) {
    return p(F("newfolder"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ie, name: ue })
    });
  }
  async function X(ie, ue, Pe, Ge = {}) {
    return p(F("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Ge.exactName ? { path: ie, name: ue, type: Pe, exact_name: !0 } : { path: ie, name: ue, type: Pe })
    });
  }
  async function te(ie, ue, Pe) {
    return p(F("newfile"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ie, name: ue, type: Pe, exact_name: !0, dry_run: !0 })
    });
  }
  async function V(ie, ue, Pe) {
    return p(F("rename"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ie, item: ue, name: Pe })
    });
  }
  async function G(ie, ue, Pe) {
    return p(F("rename", { queued: 1 }), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ie, item: ue, name: Pe })
    });
  }
  async function q(ie, ue, Pe) {
    return p(F("move"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ie, item: Pe, items: ue.map((Ge) => ({ path: Ge })) })
    });
  }
  async function B(ie, ue) {
    return p(F("delete"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ie, items: ue.map((Pe) => ({ path: Pe })) })
    });
  }
  async function K(ie, ue) {
    const Pe = [];
    for (let Ge = 0; Ge < ie.length; Ge += 1e3) {
      const ot = ie.slice(Ge, Ge + 1e3), St = await p(F("allowed"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: ue, items: ot.map((Et) => ({ path: Et })) })
      });
      ot.forEach((Et, ne) => {
        var Q;
        return Pe.push(((Q = St.allowed) == null ? void 0 : Q[ne]) ?? []);
      });
    }
    return Pe;
  }
  async function ke(ie, ue) {
    if (!t.copy) throw new Error("copy endpoint not configured");
    return p(t.copy, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ie, target: ue })
    });
  }
  async function Ye(ie, ue, Pe, Ge, ot) {
    const St = ie === "copy" ? t.copy : t.moveAsync;
    if (!St) throw new Error(`${ie} endpoint not configured`);
    return p(St, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: [ue], target: Pe, name: Ge, ...ot ? { sourceDir: ot } : {} })
    });
  }
  async function Oe(ie, ue, Pe) {
    if (!t.moveAsync) throw new Error("moveAsync endpoint not configured");
    return p(t.moveAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ie, target: ue, sourceDir: Pe })
    });
  }
  async function Be(ie, ue) {
    if (!t.deleteAsync) throw new Error("deleteAsync endpoint not configured");
    return p(t.deleteAsync, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ie, sourceDir: ue })
    });
  }
  async function qe(ie) {
    if (!t.restore) throw new Error("restore endpoint not configured");
    return p(t.restore, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ source: ie })
    });
  }
  async function Tt(ie) {
    if (!t.trashRestore) throw new Error("trashRestore endpoint not configured");
    const ue = t.trashRestore.includes("?") ? "&" : "?", Pe = await p(
      Ie(`${t.trashRestore}${ue}queued=1`),
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ node_ids: ie })
      }
    );
    return { ops: Pe.ops ?? [], summary: Pe.summary ?? "" };
  }
  async function $t(ie, ue = {}) {
    if (!t.trashList) throw new Error("trashList endpoint not configured");
    const Pe = [];
    ie && Pe.push(`storage=${encodeURIComponent(ie)}`), ue.limit && Pe.push(`limit=${ue.limit}`), ue.offset && Pe.push(`offset=${ue.offset}`);
    const Ge = t.trashList, ot = Pe.length ? `${Ge}${Ge.includes("?") ? "&" : "?"}${Pe.join("&")}` : Ge;
    return p(Ie(ot));
  }
  async function it(ie) {
    const ue = t.trashRestore;
    if (!ue) throw new Error("trashRestore endpoint not configured");
    return p(Ie(ue), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_ids: ie })
    });
  }
  async function yt(ie, ue = {}) {
    const Pe = t.trashPurgeBatch;
    if (!Pe) throw new Error("trashPurgeBatch endpoint not configured");
    const Ge = ue.queued ? `${Pe}${Pe.includes("?") ? "&" : "?"}queued=1` : Pe;
    return p(Ie(Ge), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_ids: ie })
    });
  }
  async function ft() {
    const ie = t.trashEmpty;
    if (!ie) throw new Error("trashEmpty endpoint not configured");
    return p(Ie(`${ie.replace(/\/+$/, "")}/preview`));
  }
  async function ze(ie, ue = {}) {
    const Pe = t.trashPurge;
    if (!Pe) throw new Error("trashPurge endpoint not configured");
    let Ge = Pe.replace("{id}", encodeURIComponent(String(ie)));
    ue.queued && (Ge += `${Ge.includes("?") ? "&" : "?"}queued=1`);
    const ot = await p(Ge, { method: "DELETE" });
    return ot != null && ot.op ? { op: ot.op } : {};
  }
  async function oe(ie) {
    const ue = t.versionPurge;
    if (!ue) throw new Error("versionPurge endpoint not configured");
    await p(ue.replace("{id}", encodeURIComponent(String(ie))), { method: "DELETE" });
  }
  async function Se(ie, ue, Pe, Ge) {
    const ot = new FormData();
    ot.append("path", ie);
    for (const [Et, ne] of Object.entries(Ge ?? {})) ot.append(Et, ne);
    for (const Et of ue)
      ot.append("file[]", Et, Et.name);
    for (const Et of ue)
      ot.append("name[]", Et.name);
    const St = await i();
    return new Promise((Et, ne) => {
      const Q = new XMLHttpRequest();
      Q.open("POST", F("upload"));
      for (const [Ae, at] of Object.entries(St))
        Ae !== "Content-Type" && Q.setRequestHeader(Ae, at);
      Q.withCredentials = l() === "include", Q.upload.onprogress = (Ae) => {
        Pe && Ae.lengthComputable && Pe(Math.round(Ae.loaded / Ae.total * 100));
      }, Q.onload = () => {
        if (kv(), Q.status >= 200 && Q.status < 300)
          try {
            Et(JSON.parse(Q.responseText));
          } catch (Ae) {
            ne(Ae);
          }
        else
          ne(pa(Q.status, Q.responseText || "", c()));
      }, Q.onerror = () => {
        bv("action"), ne(gv(c()));
      }, Q.send(ot);
    });
  }
  function he(ie) {
    return F("download", { path: ie });
  }
  function Ke(ie) {
    return F("preview", { path: ie });
  }
  async function Le(ie, ue = {}) {
    const Pe = await i(), Ge = await fetch(Ke(ie), {
      headers: Pe,
      credentials: l(),
      // ⚠ The preview endpoint answers `Cache-Control: private, max-age=60`,
      // which is right for the thing it was built for — a viewer re-opening
      // an image — and wrong for anything the client treats as CONTROL data.
      // `.filex-e2e.json` is control data: after the client rewrites it
      // (recovery upgrade, escrow slot, escrow refusal) the next read inside
      // that minute came back PRE-write, so the folder looked un-upgraded
      // and the question filex had just been answered was asked again.
      // Measured 2026-09-05 in a real browser: decline the escrow offer,
      // reopen the folder, and the offer was back.
      cache: ue.fresh ? "no-store" : "default"
    });
    if (!Ge.ok) {
      const ne = await Ge.text().catch(() => "");
      throw pa(Ge.status, ne, c());
    }
    const ot = await Ge.blob(), St = ot.type || Ge.headers.get("content-type") || "";
    return { url: URL.createObjectURL(ot), blob: ot, mime: St };
  }
  async function ut(ie) {
    const ue = await i(), Pe = await fetch(Ke(ie), {
      headers: ue,
      credentials: l()
    });
    if (!Pe.ok) {
      const Ge = await Pe.text().catch(() => "");
      throw pa(Pe.status, Ge, c());
    }
    return Pe.arrayBuffer();
  }
  async function wt() {
    return t.limits ? p(t.limits) : { max_upload_mb: 1024 };
  }
  async function _t() {
    if (!t.capabilities)
      return {
        ffmpeg: !1,
        ghostscript: !1,
        max_chunk_mb: 5,
        upload_limit_mb: 1024,
        onlyoffice_url: e.onlyOfficeBase ?? null,
        drawio_url: e.drawioBase ?? null
      };
    const ie = await p(t.capabilities);
    return jM(ie), ie;
  }
  async function At() {
    var ue;
    if (!t.me) return null;
    const ie = await p(t.me);
    return !ie || !Array.isArray(ie.permissions) ? null : {
      admin: ((ue = ie.user) == null ? void 0 : ue.role) === "admin",
      permissions: [...ie.permissions, ...ie.permissions_in_folders ?? []],
      byFolder: ie.permissions_by_folder ?? []
    };
  }
  function _e(ie, ue) {
    return Object.entries(ue).reduce(
      (Pe, [Ge, ot]) => Pe.replaceAll(`{${Ge}}`, encodeURIComponent(String(ot))),
      ie
    );
  }
  function Ie(ie) {
    return `${ie}${ie.includes("?") ? "&" : "?"}lang=${encodeURIComponent(c())}`;
  }
  function pe(ie) {
    return /^https?:\/\//i.test(ie) ? ie : t.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "") + (ie.startsWith("/") ? ie : `/${ie}`);
  }
  function we() {
    return t.manager.replace(/\/api\/files\/manager(\?.*)?$/, "").replace(/\/$/, "") + "/_print/";
  }
  async function ee(ie) {
    if (!t.pluginLicense) throw new Error("pluginLicense endpoint not configured");
    return p(_e(t.pluginLicense, { plugin: ie }));
  }
  async function ge(ie, ue, Pe) {
    if (!t.pluginUICall) throw new Error("pluginUICall endpoint not configured");
    return p(Ie(_e(t.pluginUICall, { plugin: ie, view: ue })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Pe)
    });
  }
  async function ae(ie, ue, Pe, Ge, ot) {
    if (!t.pluginUISave) throw new Error("pluginUISave endpoint not configured");
    const St = { ...(ot == null ? void 0 : ot.extra) ?? {}, ...y2(ot == null ? void 0 : ot.csv) ?? {} }, Et = Object.entries(St).map(([jt, ce]) => `&${encodeURIComponent(jt)}=${encodeURIComponent(ce)}`).join(""), ne = ("path" in Pe ? `path=${encodeURIComponent(Pe.path)}` : `dir=${encodeURIComponent(Pe.dir)}&name=${encodeURIComponent(Pe.name)}`) + Et, Q = `${ot != null && ot.e2e ? "&e2e=1" : ""}${ot != null && ot.expect ? `&expect=${encodeURIComponent(ot.expect)}` : ""}`, Ae = _e(t.pluginUISave, { plugin: ie, view: ue }), at = `${Ae}${Ae.includes("?") ? "&" : "?"}${ne}${Q}`, ct = xc("app_ui_save_chunk_bytes") ?? QO, zt = (jt, ce) => p(jt, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: ce });
    if (Ge instanceof Blob && Ge.size <= ct)
      return p(at, {
        method: "PUT",
        headers: { "Content-Type": Ge.type || "application/octet-stream" },
        body: Ge
      });
    let Ht = "", Wt = 0;
    const tn = async (jt, ce) => {
      const be = Ht ? `${at}&session=${encodeURIComponent(Ht)}&offset=${Wt}${ce ? "&final=1" : ""}` : `${at}&chunk=start${ce ? "&final=1" : ""}`, Re = await zt(be, jt);
      return ce || (Ht = Re.session ?? Ht, Wt = Re.received ?? Wt + jt.size), Re;
    };
    if (Ge instanceof Blob)
      for (let jt = 0; ; jt += ct) {
        const ce = Math.min(jt + ct, Ge.size), be = Ge.slice(jt, ce);
        if (ce >= Ge.size) return await tn(be, !0);
        await tn(be, !1);
      }
    const Ft = Ge.getReader();
    let yn = [], Nn = 0;
    for (; ; ) {
      const { done: jt, value: ce } = await Ft.read();
      for (ce && ce.byteLength && (yn.push(ce), Nn += ce.byteLength); Nn >= ct && !jt; ) {
        const be = new Blob(yn);
        await tn(be.slice(0, ct), !1);
        const Re = new Uint8Array(await be.slice(ct).arrayBuffer());
        yn = Re.byteLength ? [Re] : [], Nn = Re.byteLength;
      }
      if (jt) {
        const be = new Blob(yn);
        return !Ht && be.size <= ct ? p(at, { method: "PUT", headers: { "Content-Type": "application/octet-stream" }, body: be }) : await tn(be, !0);
      }
    }
  }
  async function xe(ie) {
    const ue = await i(), Pe = await fetch(Ke(ie), { headers: ue, credentials: l(), cache: "no-store" });
    if (!Pe.ok) {
      const Ge = await Pe.text().catch(() => "");
      throw pa(Pe.status, Ge, c());
    }
    return Pe;
  }
  async function Fe(ie, ue, Pe, Ge) {
    if (!t.pluginUIRead) {
      if (Ge != null && Ge.e2e) throw new Error("pluginUIRead endpoint not configured");
      return xe(Pe);
    }
    const ot = _e(t.pluginUIRead, { plugin: ie, view: ue }), St = await i(), Et = Ge != null && Ge.e2e ? "&e2e=1" : "", ne = await fetch(`${ot}${ot.includes("?") ? "&" : "?"}path=${encodeURIComponent(Pe)}${Et}`, {
      headers: St,
      credentials: l(),
      cache: "no-store"
    });
    if (!ne.ok) {
      const Q = await ne.text().catch(() => "");
      throw pa(ne.status, Q, c());
    }
    return ne;
  }
  function ye(ie, ue) {
    if (!t.pluginUICoEdit) throw new Error("pluginUICoEdit endpoint not configured");
    return _e(t.pluginUICoEdit, { plugin: ie, view: ue });
  }
  async function Te(ie, ue, Pe, Ge = {}) {
    return p(`${ye(ie, ue)}/join`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: Pe, ...Ge })
    });
  }
  async function Ue(ie, ue, Pe, Ge, ot, St = {}) {
    const Et = `${ye(ie, ue)}/${encodeURIComponent(Pe)}/${Ge}`;
    return St.keepalive === !0 && xt(Et, JSON.stringify(ot)) ? {} : p(Et, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ot),
      keepalive: St.keepalive === !0
    });
  }
  function xt(ie, ue) {
    if (n.kind !== "none") return !1;
    const Pe = typeof navigator > "u" ? void 0 : navigator;
    if (typeof (Pe == null ? void 0 : Pe.sendBeacon) != "function") return !1;
    try {
      return Pe.sendBeacon(ie, ue);
    } catch {
      return !1;
    }
  }
  function Qt(ie, ue, Pe, Ge, ot) {
    return `${ye(ie, ue)}/${encodeURIComponent(Pe)}/blob/${encodeURIComponent(Ge)}?client=${encodeURIComponent(ot.client)}&token=${encodeURIComponent(ot.token)}`;
  }
  async function vn(ie, ue, Pe, Ge, ot, St) {
    await p(Qt(ie, ue, Pe, Ge, ot), {
      method: "PUT",
      headers: { "Content-Type": "application/octet-stream" },
      body: new Blob([St])
    });
  }
  async function Ut(ie, ue, Pe, Ge, ot) {
    const St = await m(Qt(ie, ue, Pe, Ge, ot), { cache: "no-store" });
    if (!St.ok) {
      const Et = await St.text().catch(() => "");
      throw pa(St.status, Et, c());
    }
    return St.arrayBuffer();
  }
  async function pn() {
    if (!t.pluginActions) return { actions: [], views: [] };
    const ie = await p(t.pluginActions);
    return {
      actions: (ie == null ? void 0 : ie.actions) ?? [],
      views: (ie == null ? void 0 : ie.views) ?? [],
      ...ie != null && ie.open_rules ? { open_rules: ie.open_rules } : {}
    };
  }
  async function Rt(ie, ue, Pe) {
    if (!t.pluginActionRun) throw new Error("pluginActionRun endpoint not configured");
    return p(Ie(_e(t.pluginActionRun, { plugin: ie, action: ue })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Pe)
    });
  }
  async function rn(ie, ue, Pe, Ge) {
    if (!t.pluginView) throw new Error("pluginView endpoint not configured");
    const ot = _e(t.pluginView, { plugin: ie, view: ue }), St = [
      Pe ? `path=${encodeURIComponent(Pe)}` : "",
      Ge ? `section=${encodeURIComponent(Ge)}` : ""
    ].filter(Boolean);
    return p(Ie(ot + (St.length ? `?${St.join("&")}` : "")));
  }
  async function nn(ie, ue, Pe) {
    if (!t.pluginViewEvent) throw new Error("pluginViewEvent endpoint not configured");
    return p(Ie(_e(t.pluginViewEvent, { plugin: ie, view: ue })), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Pe)
    });
  }
  async function gt(ie, ue) {
    if (!t.pluginUsers) throw Object.assign(new Error("pluginUsers endpoint not configured"), { status: 404 });
    const Pe = `${t.pluginUsers}?plugin=${encodeURIComponent(ie)}&q=${encodeURIComponent(ue)}`, Ge = await p(Pe);
    return { users: (Ge == null ? void 0 : Ge.users) ?? [] };
  }
  async function wn(ie) {
    if (!t.opsCancel) throw new Error("opsCancel endpoint not configured");
    await p(_e(t.opsCancel, { id: ie }), { method: "POST" });
  }
  async function ra(ie) {
    if (!t.e2eEscrowChallenge) throw new Error("e2e escrow endpoint not configured");
    return p(t.e2eEscrowChallenge, {
      method: "POST",
      body: JSON.stringify({ path: ie })
    });
  }
  async function dn(ie) {
    if (!t.e2eEscrowUsed) throw new Error("e2e escrow endpoint not configured");
    return p(t.e2eEscrowUsed, {
      method: "POST",
      body: JSON.stringify(ie)
    });
  }
  async function jn(ie, ue = 16) {
    const Pe = { ...await i(), Range: `bytes=0-${ue - 1}` }, Ge = await fetch(Ke(ie), { headers: Pe, credentials: l(), cache: "no-store" });
    if (!Ge.ok) {
      const ne = await Ge.text().catch(() => "");
      throw pa(Ge.status, ne, c());
    }
    if (!Ge.body) return new Uint8Array(await Ge.arrayBuffer()).slice(0, ue);
    const ot = Ge.body.getReader(), St = new Uint8Array(ue);
    let Et = 0;
    try {
      for (; Et < ue; ) {
        const { done: ne, value: Q } = await ot.read();
        if (ne || !Q) break;
        const Ae = Math.min(Q.length, ue - Et);
        St.set(Q.subarray(0, Ae), Et), Et += Ae;
      }
    } finally {
      ot.cancel().catch(() => {
      });
    }
    return St.slice(0, Et);
  }
  async function zn(ie) {
    if (!t.e2eCleanup) throw new Error("e2e cleanup endpoint not configured");
    return p(t.e2eCleanup, { method: "POST", body: JSON.stringify(ie) });
  }
  async function Bn(ie, ue = {}) {
    var ot;
    const Pe = t.e2eAllowed;
    if (!Pe || !ie.length) return ie.map(() => "allowed");
    const Ge = [];
    try {
      for (let St = 0; St < ie.length; St += 1e3) {
        const Et = ie.slice(St, St + 1e3), ne = await p(Pe, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: Et.map((Q) => typeof Q == "string" ? { path: Q } : Q.kind ? { path: Q.path, kind: Q.kind } : { path: Q.path })
          })
        });
        Et.forEach((Q, Ae) => {
          var at;
          return Ge.push(XO((at = ne == null ? void 0 : ne.encrypt) == null ? void 0 : at[Ae]));
        });
      }
    } catch (St) {
      return console.warn("[filex] could not ask who may encrypt here; offering encryption as before", St), (ot = ue.onFailed) == null || ot.call(ue), ie.map(() => "allowed");
    }
    return Ge;
  }
  async function Sn(ie) {
    if (!t.e2eRequests) throw new Error("e2e requests endpoint not configured");
    return p(t.e2eRequests, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ie)
    });
  }
  async function mn(ie) {
    if (!t.shareCreate) throw new Error("shareCreate endpoint not configured");
    return p(t.shareCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ie)
    });
  }
  async function sn(ie) {
    if (!t.shareList) return { shares: [] };
    const ue = t.shareList.includes("?") ? "&" : "?";
    return p(`${t.shareList}${ue}path=${encodeURIComponent(ie)}`);
  }
  async function $n(ie) {
    if (!t.shareDelete) throw new Error("shareDelete endpoint not configured");
    const ue = t.shareDelete.replace("{uuid}", encodeURIComponent(ie));
    return p(ue, { method: "DELETE" });
  }
  async function Rn(ie, ue) {
    if (!t.archiveList) throw new Error("archiveList endpoint not configured");
    return {
      entries: (await p(
        t.archiveList,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ path: ie, password: ue })
        }
      )).entries.map((Ge) => ({
        name: Ge.name,
        size: Ge.size,
        isDir: Ge.is_dir,
        lastModified: Ge.mtime
      }))
    };
  }
  async function Fn(ie, ue = {}) {
    if (!t.archiveExtract) throw new Error("archiveExtract endpoint not configured");
    return p(t.archiveExtract, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ie, ...ue })
    });
  }
  async function Tn(ie) {
    if (!t.archiveCreate) throw new Error("archiveCreate endpoint not configured");
    return p(t.archiveCreate, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(ie)
    });
  }
  async function me(ie, ue) {
    if (!t.archiveAdd) throw new Error("archiveAdd endpoint not configured");
    return p(t.archiveAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ path: ie, files: ue })
    });
  }
  function De(ie = "") {
    return t.manager.replace(/\/manager(\?.*)?$/, "/versions") + ie;
  }
  async function He(ie) {
    const ue = await p(
      De() + "?node_id=" + encodeURIComponent(String(ie))
    );
    return Array.isArray(ue == null ? void 0 : ue.versions) ? ue.versions : [];
  }
  async function Ve(ie, ue, Pe = !0) {
    await p(De("/restore"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        node_id: ie,
        version_id: ue,
        snapshot_current: Pe
      })
    });
  }
  async function bt(ie) {
    await p(De("/snapshot"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: ie })
    });
  }
  function Qe(ie = "") {
    return t.manager.replace(/\/manager(\?.*)?$/, "/comments") + ie;
  }
  async function se(ie) {
    const ue = await p(
      Qe() + "?node_id=" + encodeURIComponent(String(ie))
    );
    return Array.isArray(ue == null ? void 0 : ue.comments) ? ue.comments : [];
  }
  async function je(ie, ue) {
    return (await p(Qe(), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id: ie, body: ue })
    })).comment;
  }
  async function dt(ie) {
    await p(Qe("/" + encodeURIComponent(String(ie))), {
      method: "DELETE"
    });
  }
  async function tt() {
    const ie = t.manager.replace(/\/manager(\?.*)?$/, "/ws-ticket");
    try {
      return await p(ie, { method: "POST" });
    } catch {
      return null;
    }
  }
  return {
    // Realtime
    wsTicket: tt,
    // Manager
    index: I,
    search: Z,
    globalSearch: J,
    globalSearchPage: re,
    matchNames: ve,
    quotaMe: W,
    storageUsage: z,
    appStoreStatus: le,
    subfolders: fe,
    newFolder: j,
    newFile: X,
    newFileCheck: te,
    drafts: x,
    draftsBase: v,
    rename: V,
    renameQueued: G,
    move: q,
    copy: ke,
    moveAsync: Oe,
    deleteAsync: Be,
    deleteItems: B,
    allowedAt: K,
    myPermissions: At,
    restore: qe,
    listTrash: $t,
    restoreBatch: it,
    restoreQueued: Tt,
    purgeTrash: ze,
    purgeBatch: yt,
    trashEmptyPreview: ft,
    purgeVersion: oe,
    uploadMultipart: Se,
    downloadUrl: he,
    previewUrl: Ke,
    fetchBlob: Le,
    fetchArrayBuffer: ut,
    // Peripheral
    limits: wt,
    capabilities: _t,
    /* wiring:e2 */
    e2eEscrowChallenge: ra,
    e2eEscrowUsed: dn,
    e2eCleanup: zn,
    /* wiring:e2 policy */
    e2eAllowedAt: Bn,
    e2eRequest: Sn,
    fetchHead: jn,
    transferNamed: Ye,
    /* App plugins */
    pluginActions: pn,
    pluginActionRun: Rt,
    pluginView: rn,
    pluginViewEvent: nn,
    pluginUsers: gt,
    opsCancel: wn,
    appUIUrl: pe,
    printFrameUrl: we,
    pluginUICall: ge,
    pluginUISave: ae,
    pluginUIRead: Fe,
    pluginLicense: ee,
    coeditJoin: Te,
    coeditCall: Ue,
    coeditBlobPut: vn,
    coeditBlobGet: Ut,
    fetchResponse: xe,
    createShare: mn,
    listShares: sn,
    revokeShare: $n,
    archiveList: Rn,
    archiveExtract: Fn,
    archiveCreate: Tn,
    archiveAdd: me,
    // Version history (koru:k1 inspector)
    listVersions: He,
    restoreVersion: Ve,
    snapshotVersion: bt,
    // Node comments (calisma:d3 inspector)
    listComments: se,
    addComment: je,
    deleteComment: dt,
    // Permissions (RBAC panel)
    listPermissions: _,
    resolveEmail: w,
    searchUsers: b,
    searchGroups: C,
    addPermission: R,
    updatePermission: M,
    deletePermission: L,
    updateGroupPermission: A,
    deleteGroupPermission: T,
    invitePermission: U,
    shareMail: P,
    shareMessage: H,
    // Internals (exposed for useUploadChunked + PreviewModal)
    endpoints: t,
    authHeaders: i,
    authHeadersSync: r,
    credentialsMode: l,
    jsonFetch: p,
    // One request with this client's credential and language, answered as
    // the Response (a stream's reader: the AI assistant, lib/assistant).
    rawRequest: m,
    withScreenLang: Ie
  };
}
function il() {
  const e = globalThis.crypto;
  if (typeof (e == null ? void 0 : e.randomUUID) == "function") return e.randomUUID();
  const t = new Uint8Array(16);
  if (typeof (e == null ? void 0 : e.getRandomValues) == "function") e.getRandomValues(t);
  else for (let a = 0; a < t.length; a++) t[a] = Math.floor(Math.random() * 256);
  t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128;
  const n = Array.from(t, (a) => a.toString(16).padStart(2, "0")).join("");
  return `${n.slice(0, 8)}-${n.slice(8, 12)}-${n.slice(12, 16)}-${n.slice(16, 20)}-${n.slice(20)}`;
}
const Cy = "filex:uploads:v1";
function _m(e) {
  if (!e) return;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : void 0;
}
function xm(e, t) {
  return [e, t.name, t.size, t.lastModified ?? 0].join("\0");
}
function eP() {
  try {
    return typeof localStorage > "u" ? null : (localStorage.getItem(Cy), localStorage);
  } catch {
    return null;
  }
}
function zy(e) {
  if (!e) return {};
  try {
    const t = e.getItem(Cy);
    if (!t) return {};
    const n = JSON.parse(t);
    return n && typeof n == "object" ? n : {};
  } catch {
    return {};
  }
}
function My(e, t) {
  if (e)
    try {
      e.setItem(Cy, JSON.stringify(t));
    } catch {
    }
}
function L2(e, t = Date.now()) {
  const n = zy(e);
  let a = !1;
  for (const [i, r] of Object.entries(n)) {
    const l = r == null ? void 0 : r.expiresAt;
    (!(r != null && r.uploadId) || typeof l != "number" || !Number.isFinite(l) || t >= l) && (delete n[i], a = !0);
  }
  return a && My(e, n), n;
}
function Qw(e, t, n = Date.now()) {
  return L2(e, n)[t] ?? null;
}
function e_(e, t, n, a = Date.now()) {
  const i = zy(e);
  i[t] = { ...n, updatedAt: a }, My(e, i);
}
function zu(e, t) {
  const n = zy(e);
  t in n && (delete n[t], My(e, n));
}
function tP(e, t = Date.now()) {
  return Object.values(L2(e, t)).sort((n, a) => a.updatedAt - n.updatedAt);
}
function nP(e) {
  return !e || e === "staging";
}
function t_(e) {
  return e.stagedUnsupported = !0, e;
}
function Oy(e) {
  return !!(e != null && e.stagedUnsupported);
}
function aP(e, t, n = eP()) {
  const a = e.chunkSize ?? 8388608;
  function i() {
    const _ = t.endpoints.uploadBegin;
    return _ ? _.replace(/\/begin$/, "") : t.endpoints.manager.replace(/\/manager(\?.*)?$/, "/upload");
  }
  function r() {
    return !!i();
  }
  function l() {
    return a;
  }
  function c(_) {
    return r() && _.size > l();
  }
  function p(_, w) {
    return Qw(n, xm(_, w));
  }
  function m() {
    return tP(n);
  }
  async function v(_) {
    zu(n, xm(_.path, { name: _.name, size: _.size, lastModified: _.lastModified }));
    try {
      await t.jsonFetch(`${i()}/${encodeURIComponent(_.uploadId)}`, { method: "DELETE" });
    } catch {
    }
  }
  async function x(_) {
    return t.jsonFetch(`${i()}/${encodeURIComponent(_)}`);
  }
  async function k(_) {
    var F, I, Z;
    const w = xm(_.path, _.file), b = _.source ?? null, C = b ? b.size : _.file.size, A = b ? null : n, T = {
      id: il(),
      file: _.file,
      path: _.path,
      totalBytes: C,
      uploadedBytes: 0,
      percent: 0,
      status: "initializing",
      cancel: () => {
      }
    };
    let R = !1, M = null, L;
    T.cancel = () => {
      var J;
      R = !0, M == null || M.abort(), (J = b == null ? void 0 : b.cancel) == null || J.call(b);
    };
    let U = 0;
    function P(J = 0) {
      var re;
      T.uploadedBytes = Math.min(T.totalBytes, U + J), T.percent = T.totalBytes > 0 ? Math.min(100, Math.round(T.uploadedBytes / T.totalBytes * 100)) : T.status === "done" ? 100 : 0, (re = _.onProgress) == null || re.call(_, T);
    }
    try {
      if (!r())
        throw t_(new Error("staged upload endpoint not configured"));
      const J = i();
      let re = "", ve = _.chunkSize ?? a, W;
      L = void 0;
      const z = Qw(A, w);
      if (z)
        try {
          const X = await x(z.uploadId);
          nP(X.state) && (X.total_size ?? 0) === C ? (re = z.uploadId, W = _m(X.expires_at) ?? z.expiresAt, ve = X.chunk_size ?? X.chunkSize ?? z.chunkSize, U = X.offset ?? 0, T.resumedFrom = U) : zu(A, w);
        } catch {
          zu(A, w);
        }
      if (!re) {
        let X;
        try {
          X = await t.jsonFetch(`${J}/begin`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              path: _.path,
              name: _.file.name,
              size: C,
              mime: _.file.type || "application/octet-stream",
              // Asked for, not imposed: the server clamps this to its own
              // limits and its answer is what the loop below uses.
              chunk_size: _.chunkSize ?? a
            })
          });
        } catch (te) {
          const V = te.status;
          throw (V === 404 || V === 501) && t_(te), te;
        }
        if (!(X != null && X.id)) throw new Error("begin returned no upload id");
        re = X.id, W = _m(X.expires_at), ve = X.chunk_size ?? X.chunkSize ?? ve, U = X.offset ?? 0;
      }
      T.uploadId = re, T.status = "uploading", e_(A, w, {
        uploadId: re,
        path: _.path,
        name: _.file.name,
        size: C,
        lastModified: _.file.lastModified,
        chunkSize: ve,
        offset: U,
        expiresAt: W
      }), P();
      const le = 4;
      for (; U < C; ) {
        if (R) throw new DOMException("Aborted by user", "AbortError");
        const X = Math.min(U + ve, C), te = b ? await b.read(U, X) : _.file.slice(U, X);
        let V = -1, G = null;
        for (let q = 0; q < le; q++) {
          if (q > 0) {
            if (await a_(300 * q + Math.floor(Math.random() * 150)), R) throw new DOMException("Aborted by user", "AbortError");
            try {
              const B = await x(re);
              if ((B.offset ?? 0) >= X) {
                V = B.offset ?? X;
                break;
              }
              if ((B.offset ?? 0) !== U) {
                U = B.offset ?? U, P(), V = -2;
                break;
              }
            } catch {
            }
          }
          try {
            V = await H(re, te, U, X, C);
            break;
          } catch (B) {
            const K = B instanceof Error ? B : new Error(String(B));
            if (R || K.name === "AbortError") throw K;
            const ke = K.status;
            if (ke && ke !== 400 && ke !== 409 && ke < 500) throw K;
            G = K;
          }
        }
        if (V !== -2) {
          if (V < 0) throw G ?? new Error("chunk upload failed");
          if (V <= U)
            throw console.warn("[filex] upload stalled at byte", U), new Error($c(Ca(e.locale))("err.upload_stalled"));
          U = V, L !== void 0 && (W = L), P(), e_(A, w, {
            uploadId: re,
            path: _.path,
            name: _.file.name,
            size: C,
            lastModified: _.file.lastModified,
            chunkSize: ve,
            offset: U,
            expiresAt: W
          });
        }
      }
      if (R) throw new DOMException("Aborted by user", "AbortError");
      T.status = "committing", P();
      const fe = new URLSearchParams(_.commitQuery ?? {}).toString(), j = await t.jsonFetch(
        `${J}/${encodeURIComponent(re)}/commit${fe ? `?${fe}` : ""}`,
        { method: "POST" }
      );
      return zu(A, w), T.opId = j == null ? void 0 : j.op_id, T.nodeId = j == null ? void 0 : j.node_id, _.waitForTransfer !== !1 && (j != null && j.op_id) && t.endpoints.opsShow && (T.status = "transferring", P(), await $(j.op_id)), T.status = "done", U = T.totalBytes, P(), (F = _.onDone) == null || F.call(_, T, j), j;
    } catch (J) {
      const re = J instanceof Error ? J : new Error(String(J));
      if (T.status = re.name === "AbortError" ? "aborted" : "error", T.error = re.message, P(), Oy(re) || (I = b == null ? void 0 : b.cancel) == null || I.call(b), T.uploadId && (T.status === "aborted" || b)) {
        zu(A, w);
        try {
          await t.jsonFetch(`${i()}/${encodeURIComponent(T.uploadId)}`, {
            method: "DELETE"
          });
        } catch {
        }
      }
      throw (Z = _.onError) == null || Z.call(_, T, re), re;
    }
    function H(J, re, ve, W, z) {
      return new Promise((le, fe) => {
        const j = new XMLHttpRequest();
        M = j, j.open("PUT", `${i()}/${encodeURIComponent(J)}`);
        const X = t.authHeadersSync({
          "Content-Type": "application/octet-stream",
          "Content-Range": `bytes ${ve}-${W - 1}/${z}`
        });
        for (const [te, V] of Object.entries(X)) j.setRequestHeader(te, V);
        j.withCredentials = t.credentialsMode() === "include", j.upload.onprogress = (te) => {
          te.lengthComputable && P(te.loaded);
        }, j.onload = () => {
          if (M = null, kv(), j.status >= 200 && j.status < 300) {
            try {
              const te = JSON.parse(j.responseText);
              L = _m(te.expires_at) ?? L, le(te.offset ?? W);
            } catch {
              le(W);
            }
            return;
          }
          fe(pa(j.status, j.responseText || "", Ca(e.locale)));
        }, j.onerror = () => {
          M = null, bv("action"), fe(gv(Ca(e.locale)));
        }, j.onabort = () => {
          M = null, fe(new DOMException("Aborted", "AbortError"));
        }, j.send(re);
      });
    }
    async function $(J) {
      const re = t.endpoints.opsShow;
      if (!re) return;
      const ve = re.replace("{id}", String(J));
      let W = 200, z = 0;
      for (; ; ) {
        if (R) throw new DOMException("Aborted by user", "AbortError");
        try {
          const le = await t.jsonFetch(ve);
          if ((le == null ? void 0 : le.status) === "ok") return;
          if ((le == null ? void 0 : le.status) === "failed" || (le == null ? void 0 : le.status) === "partial")
            throw new n_(le.error || "transfer failed");
          z = 0;
        } catch (le) {
          if (le instanceof n_ || le.name === "AbortError") throw le;
          if (++z >= iP) return;
        }
        await a_(W), W = Math.min(W * 2, 2e3);
      }
    }
  }
  return {
    uploadFile: k,
    /** True when this file is big enough (and the endpoints exist) to chunk. */
    shouldChunk: c,
    /** The size at which chunking kicks in. */
    threshold: l,
    resumableFor: p,
    listResumable: m,
    discardResumable: v
  };
}
const iP = 6;
class n_ extends Error {
  constructor(t) {
    super(t), this.name = "TransferFailedError";
  }
}
function a_(e) {
  return new Promise((t) => setTimeout(t, e));
}
function i_(e) {
  const t = S(/* @__PURE__ */ new Set()), n = S(null);
  function a(k, _ = {}) {
    if (_.shift && n.value) {
      const w = e(), b = w.findIndex((M) => M.path === n.value), C = w.findIndex((M) => M.path === k);
      if (b === -1 || C === -1) {
        t.value = /* @__PURE__ */ new Set([k]), n.value = k;
        return;
      }
      const [A, T] = b < C ? [b, C] : [C, b], R = /* @__PURE__ */ new Set();
      for (let M = A; M <= T; M++) R.add(w[M].path);
      t.value = R;
      return;
    }
    if (_.ctrl) {
      const w = new Set(t.value);
      w.has(k) ? w.delete(k) : w.add(k), t.value = w, n.value = k;
      return;
    }
    t.value = /* @__PURE__ */ new Set([k]), n.value = k;
  }
  function i() {
    t.value = /* @__PURE__ */ new Set(), n.value = null;
  }
  function r() {
    t.value = new Set(e().map((k) => k.path));
  }
  function l(k) {
    return t.value.has(k);
  }
  function c(k) {
    const _ = new Set(t.value);
    _.add(k), t.value = _;
  }
  function p(k) {
    const _ = new Set(t.value);
    _.delete(k), t.value = _;
  }
  const m = E(() => t.value.size), v = E(() => t.value.size === 0), x = E(() => e().filter((_) => t.value.has(_.path)));
  return { selected: t, anchor: n, click: a, clear: i, selectAll: r, has: l, add: c, remove: p, size: m, isEmpty: v, nodes: x };
}
function R2(e) {
  var n;
  const t = e;
  return !t || typeof t.tagName != "string" ? !1 : t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable || ((n = t.getAttribute) == null ? void 0 : n.call(t, "role")) === "textbox" ? !0 : typeof t.closest == "function" && !!t.closest(".monaco-editor");
}
const oP = /* @__PURE__ */ new Set([
  "Ctrl+N",
  "Ctrl+Shift+N",
  "Ctrl+T",
  "Ctrl+Shift+T",
  "Ctrl+W",
  "Ctrl+Shift+W",
  "Ctrl+Tab",
  "Ctrl+Shift+Tab",
  "Ctrl+Q",
  "Ctrl+Shift+I",
  "Ctrl+Shift+J",
  "Ctrl+Shift+C",
  "F11",
  "F12"
]);
function $fe(e) {
  return oP.has(e);
}
const Zr = [
  // Navigation
  { id: "palette", defaultCombo: "Ctrl+K", labelKey: "shortcuts.palette", groupKey: "shortcuts.group.nav" },
  { id: "search", defaultCombo: "/", labelKey: "shortcuts.search", groupKey: "shortcuts.group.nav" },
  { id: "go-up", defaultCombo: "Alt+↑", fixedCombos: ["Backspace"], labelKey: "shortcuts.go_up", groupKey: "shortcuts.group.nav" },
  { id: "open", defaultCombo: "Enter", prevent: !1, labelKey: "shortcuts.open", groupKey: "shortcuts.group.nav" },
  { id: "quicklook", defaultCombo: "Space", labelKey: "shortcuts.quicklook", groupKey: "shortcuts.group.nav" },
  { id: "close", defaultCombo: "Esc", customizable: !1, prevent: !1, inForms: !0, labelKey: "shortcuts.close", groupKey: "shortcuts.group.nav" },
  { id: "inspector", defaultCombo: "I", labelKey: "shortcuts.inspector", groupKey: "shortcuts.group.nav" },
  { id: "help", defaultCombo: "?", labelKey: "shortcuts.help", groupKey: "shortcuts.group.nav" },
  { id: "toggle-hidden", defaultCombo: "Ctrl+Shift+.", labelKey: "shortcuts.toggle_hidden", groupKey: "shortcuts.group.nav" },
  /* yildiz:s1 — starring is an action, so it belongs where the other verbs
   * are. A bare letter like the inspector's `I`; the handler ignores events
   * from form controls, so it never eats a keystroke meant for a filename. */
  { id: "star", defaultCombo: "S", labelKey: "shortcuts.star", groupKey: "shortcuts.group.file" },
  // Selection
  { id: "select-all", defaultCombo: "Ctrl+A", labelKey: "shortcuts.select_all", groupKey: "shortcuts.group.selection" },
  // File operations
  { id: "rename", defaultCombo: "F2", labelKey: "shortcuts.rename", groupKey: "shortcuts.group.file" },
  { id: "delete", defaultCombo: "Del", labelKey: "shortcuts.delete", groupKey: "shortcuts.group.file" },
  { id: "cut", defaultCombo: "Ctrl+X", labelKey: "shortcuts.cut", groupKey: "shortcuts.group.file" },
  { id: "copy", defaultCombo: "Ctrl+C", labelKey: "shortcuts.copy", groupKey: "shortcuts.group.file" },
  { id: "paste", defaultCombo: "Ctrl+V", labelKey: "shortcuts.paste", groupKey: "shortcuts.group.file" },
  /* wiring:d1 — tabs. Note: browsers reserve Ctrl+T/W/Tab in normal pages
   * (preventDefault can't stop them there); they work in webcomponent/PWA/
   * kiosk contexts and stay remappable through the settings modal. */
  { id: "tab-new", defaultCombo: "Ctrl+T", labelKey: "shortcuts.tab_new", groupKey: "shortcuts.group.tabs" },
  { id: "tab-close", defaultCombo: "Ctrl+W", labelKey: "shortcuts.tab_close", groupKey: "shortcuts.group.tabs" },
  { id: "tab-next", defaultCombo: "Ctrl+Tab", labelKey: "shortcuts.tab_next", groupKey: "shortcuts.group.tabs" },
  { id: "tab-prev", defaultCombo: "Ctrl+Shift+Tab", labelKey: "shortcuts.tab_prev", groupKey: "shortcuts.group.tabs" },
  /* /wiring:d1 */
  /* tus:t1 — the rest of the menu verbs. Until now these were reachable only
   * by right-clicking, and the right-click menu named no keys at all, so 16 of
   * the registry's actions were invisible unless somebody opened the `?` sheet
   * on their own. The ones with no default are deliberate: they are rare
   * enough that taking a key from the user by default is the wrong trade, and
   * they are in the registry so the user can take one. */
  { id: "new-folder", defaultCombo: "Shift+N", labelKey: "shortcuts.new_folder", groupKey: "shortcuts.group.file" },
  { id: "upload", defaultCombo: "U", labelKey: "shortcuts.upload", groupKey: "shortcuts.group.file" },
  { id: "refresh", defaultCombo: "R", labelKey: "shortcuts.refresh", groupKey: "shortcuts.group.nav" },
  { id: "download", defaultCombo: "D", labelKey: "shortcuts.download", groupKey: "shortcuts.group.file" },
  { id: "preview", defaultCombo: "P", labelKey: "shortcuts.preview", groupKey: "shortcuts.group.nav" },
  { id: "share", defaultCombo: "Shift+S", labelKey: "shortcuts.share", groupKey: "shortcuts.group.file" },
  { id: "tags", defaultCombo: "T", labelKey: "shortcuts.tags", groupKey: "shortcuts.group.file" },
  { id: "open-tab", defaultCombo: "", labelKey: "shortcuts.open_tab", groupKey: "shortcuts.group.tabs" },
  { id: "copy-path", defaultCombo: "", labelKey: "shortcuts.copy_path", groupKey: "shortcuts.group.file" },
  { id: "copy-id", defaultCombo: "", labelKey: "shortcuts.copy_id", groupKey: "shortcuts.group.file" },
  { id: "restore", defaultCombo: "", labelKey: "shortcuts.restore", groupKey: "shortcuts.group.file" }
  /* /tus:t1 */
], rP = {
  palette: "onPathJump",
  search: "onFocusSearch",
  "go-up": "onGoUp",
  open: "onOpen",
  quicklook: "onQuickLook",
  close: "onClose",
  inspector: "onToggleInspector",
  "toggle-hidden": "onToggleHidden",
  star: "onStar",
  help: "onShowHelp",
  "select-all": "onSelectAll",
  rename: "onRename",
  delete: "onDelete",
  cut: "onCut",
  copy: "onCopy",
  paste: "onPaste",
  /* wiring:d1 */
  "tab-new": "onTabNew",
  "tab-close": "onTabClose",
  "tab-next": "onTabNext",
  "tab-prev": "onTabPrev",
  /* tus:t1 */
  "new-folder": "onNewFolder",
  upload: "onUpload",
  refresh: "onRefresh",
  download: "onDownload",
  preview: "onPreview",
  share: "onShare",
  tags: "onTags",
  "open-tab": "onOpenTab",
  "copy-path": "onCopyPath",
  "copy-id": "onCopyId",
  restore: "onRestore"
}, wv = "filex.shortcuts";
function sP() {
  try {
    const e = localStorage.getItem(wv);
    if (!e) return {};
    const t = JSON.parse(e);
    if (!t || typeof t != "object") return {};
    const n = {};
    for (const [a, i] of Object.entries(t))
      typeof i == "string" && Zr.some((r) => r.id === a) && (n[a] = i);
    return n;
  } catch {
    return {};
  }
}
const Vi = S(sP());
function Py() {
  try {
    Object.keys(Vi.value).length === 0 ? localStorage.removeItem(wv) : localStorage.setItem(wv, JSON.stringify(Vi.value));
  } catch {
  }
}
function Dy(e) {
  return Zr.find((t) => t.id === e);
}
function Ac(e) {
  var n;
  const t = Vi.value[e];
  return t !== void 0 ? t : ((n = Dy(e)) == null ? void 0 : n.defaultCombo) ?? "";
}
function Tfe(e, t) {
  const n = Dy(e);
  if (!n || n.customizable === !1) return;
  const a = { ...Vi.value };
  t === n.defaultCombo ? delete a[e] : a[e] = t, Vi.value = a, Py();
}
function Afe(e) {
  if (!(e in Vi.value)) return;
  const t = { ...Vi.value };
  delete t[e], Vi.value = t, Py();
}
function Efe() {
  Vi.value = {}, Py();
}
function Cfe(e, t) {
  var n;
  if (!e) return null;
  for (const a of Zr)
    if (a.id !== t) {
      if ((n = a.fixedCombos) != null && n.includes(e)) return { id: a.id, fixed: !0 };
      if (Ac(a.id) === e) return { id: a.id, fixed: a.customizable === !1 };
    }
  return null;
}
const lP = {
  " ": "Space",
  Spacebar: "Space",
  Escape: "Esc",
  Delete: "Del",
  ArrowUp: "↑",
  ArrowDown: "↓",
  ArrowLeft: "←",
  ArrowRight: "→",
  PageUp: "PgUp",
  PageDown: "PgDn"
}, uP = /* @__PURE__ */ new Set(["Control", "Alt", "Shift", "Meta", "AltGraph", "CapsLock", "NumLock", "ScrollLock", "Fn", "Dead"]);
function cP(e) {
  const t = e.key;
  if (!t || uP.has(t)) return null;
  const n = lP[t];
  return n || (t.length === 1 ? t.toUpperCase() : t);
}
function N2(e) {
  const t = cP(e);
  if (!t) return null;
  const n = [];
  (e.ctrlKey || e.metaKey) && n.push("Ctrl"), e.altKey && n.push("Alt");
  const a = t.length === 1 && t.toUpperCase() === t.toLowerCase();
  return e.shiftKey && !a && n.push("Shift"), n.push(t), n.join("+");
}
function dP() {
  return E(
    () => Zr.map((e) => {
      const t = Ac(e.id), n = e.fixedCombos ?? [];
      return {
        id: e.id,
        combo: t,
        fixedCombos: n,
        keys: [t, ...n].filter((a) => !!a),
        labelKey: e.labelKey,
        groupKey: e.groupKey,
        customizable: e.customizable !== !1,
        overridden: Vi.value[e.id] !== void 0
      };
    })
  );
}
function fP() {
  return typeof navigator < "u" && /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent || "");
}
function pP(e) {
  return e ? fP() ? e.replace(/\bCtrl\b/g, "⌘") : e : "";
}
const hP = {
  open: "open",
  "open-tab": "open-tab",
  preview: "preview",
  download: "download",
  access: "share",
  details: "inspector",
  "copy-id": "copy-id",
  "copy-path": "copy-path",
  rename: "rename",
  cut: "cut",
  copy: "copy",
  paste: "paste",
  star: "star",
  tags: "tags",
  delete: "delete",
  restore: "restore",
  "new-folder": "new-folder",
  "toggle-hidden": "toggle-hidden",
  upload: "upload",
  refresh: "refresh"
};
function I2(e) {
  const t = hP[e] ?? e;
  return Zr.some((n) => n.id === t) ? Ly(t) : "";
}
function Ly(e) {
  return pP(Ac(e));
}
function B2(e, t) {
  var i, r;
  const n = Ac(t);
  if (!n) return !1;
  const a = N2(e);
  return a === n ? !0 : ((r = (i = Dy(t)) == null ? void 0 : i.fixedCombos) == null ? void 0 : r.includes(a ?? "")) ?? !1;
}
Zr.map((e) => ({
  keys: [e.defaultCombo, ...e.fixedCombos ?? []].filter((t) => !!t),
  labelKey: e.labelKey,
  groupKey: e.groupKey
}));
function mP(e, t) {
  const n = E(() => {
    const i = /* @__PURE__ */ new Map();
    for (const r of Zr) {
      const l = Ac(r.id);
      l && i.set(l, r);
    }
    return i;
  });
  function a(i) {
    var x;
    if (!e.value || i.key !== "Escape" && document.querySelector(".fe-ctx-backdrop")) return;
    const l = i.target, c = R2(l), p = N2(i);
    if (!p) return;
    if (p === "Backspace") {
      if (c) return;
      (x = t.hasSelection) != null && x.call(t) && t.onDelete ? (i.preventDefault(), t.onDelete()) : t.onGoUp && (i.preventDefault(), t.onGoUp());
      return;
    }
    const m = n.value.get(p);
    if (!m || c && !m.inForms || p === "Space" && l && typeof l.closest == "function" && l.closest('button, a, select, summary, [role="button"], [role="menuitem"]'))
      return;
    const v = t[rP[m.id]];
    v && (m.prevent !== !1 && i.preventDefault(), v());
  }
  qt(() => window.addEventListener("keydown", a)), Ct(() => window.removeEventListener("keydown", a));
}
function Ml() {
  let e;
  try {
    e = typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(prefers-color-scheme: dark)") : void 0;
  } catch {
    e = void 0;
  }
  const t = S(!!(e != null && e.matches)), n = (a) => {
    t.value = a.matches;
  };
  return qt(() => {
    var a;
    return (a = e == null ? void 0 : e.addEventListener) == null ? void 0 : a.call(e, "change", n);
  }), Ct(() => {
    var a;
    return (a = e == null ? void 0 : e.removeEventListener) == null ? void 0 : a.call(e, "change", n);
  }), t;
}
const vP = "apps";
function yP(e) {
  const t = `${vP}/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
  return e.path ? `${t}?path=${encodeURIComponent(e.path)}` : t;
}
function F2(e, t) {
  return `${String(e ?? "").replace(/\/+$/, "")}/${yP(t)}`;
}
function Kf(e) {
  return e === "page";
}
function kp(e) {
  if (!e || typeof e != "object") return !1;
  const t = e;
  return typeof t.path == "string" && t.path.trim() !== "";
}
function gP(e) {
  const t = String(e ?? "").indexOf("://");
  if (t <= 0) return "";
  const n = e.slice(0, t), a = e.slice(t + 3).replace(/^\/+/, ""), i = a.lastIndexOf("/"), r = i > 0 ? a.slice(0, i) : "";
  return r ? `${n}/${r}` : n;
}
function o_(e, t) {
  var r;
  if (!kp(e) || !t.plugin) return { href: "", newTab: !1 };
  const n = String(t.base ?? "").replace(/\/+$/, "");
  if (e.view && Kf((r = t.placementOf) == null ? void 0 : r.call(t, e.view)))
    return { href: F2(n, { plugin: t.plugin, view: e.view, path: e.path }), newTab: !0 };
  const a = [`select=${encodeURIComponent(e.path)}`, `app=${encodeURIComponent(t.plugin)}`];
  e.action ? a.push(`appAction=${encodeURIComponent(e.action)}`) : e.view && a.push(`appView=${encodeURIComponent(e.view)}`);
  const i = gP(e.path);
  return { href: `${n}/explore?${a.join("&")}${i ? `#${i}` : ""}`, newTab: !1 };
}
const bP = 2e3, kP = 8e3;
function r_(e) {
  const t = (...m) => {
    for (const v of m) if (typeof v == "number") return v;
    return 0;
  }, n = (...m) => {
    for (const v of m) if (typeof v == "string" && v !== "") return v;
    return null;
  }, a = String(e.status ?? "pending"), i = a === "ok" || a === "done" ? "done" : a === "failed" || a === "partial" || a === "error" ? "error" : a === "cancelled" ? "cancelled" : a === "cancelling" ? "cancelling" : a === "running" ? "running" : "pending", r = Array.isArray(e.sources) ? e.sources : [], l = n(e.op_type, e.kind) ?? "delete", c = Array.isArray(e.outputs) ? e.outputs.map((m) => m && typeof m == "object" ? n(m.path) : null).filter((m) => m !== null).map((m) => ({ path: m })) : void 0;
  let p;
  if (kp(e.open)) {
    const m = n(e.open.action), v = n(e.open.view);
    p = { path: e.open.path, ...m ? { action: m } : {}, ...v ? { view: v } : {} };
  }
  return {
    id: t(e.id),
    op_type: l === "plugin-action" ? "plugin" : l,
    status: i,
    progress_total: t(e.progress_total, e.total, r.length),
    progress_done: t(e.progress_done, e.done),
    bytes_total: t(e.bytes_total),
    bytes_done: t(e.bytes_done),
    objects_total: t(e.objects_total),
    objects_done: t(e.objects_done),
    target_path: n(e.target_path, e.dest),
    source_dir: n(e.source_dir),
    source_count: t(e.source_count, r.length),
    error_message: n(e.error_message, e.error),
    error_code: n(e.error_code) ?? void 0,
    error_engine: n(e.error_engine) ?? void 0,
    error_text: n(e.error_text) ?? void 0,
    cancellable: e.cancellable === !0,
    started_at: n(e.started_at),
    finished_at: n(e.finished_at),
    created_at: n(e.created_at),
    plugin: n(e.plugin) ?? void 0,
    action: n(e.action) ?? void 0,
    label: n(e.label) ?? void 0,
    message: n(e.message) ?? void 0,
    summary: n(e.summary) ?? void 0,
    outputs: c,
    ...p ? { open: p } : {}
  };
}
function U2(e, t, n = {}) {
  const a = S([]), i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Map();
  let c = !1;
  const p = E(
    () => a.value.some((b) => b.status === "pending" || b.status === "running" || b.status === "cancelling")
  );
  let m;
  function v() {
    m || t.endpoints.opsList && (m = setInterval(() => {
      k();
    }, bP), k());
  }
  function x() {
    m && (clearInterval(m), m = void 0);
  }
  async function k() {
    var b;
    if (t.endpoints.opsList)
      try {
        const A = ((await t.jsonFetch(t.withScreenLang(t.endpoints.opsList))).ops || []).map(r_);
        for (const $ of A)
          ($.status === "done" || $.status === "error" || $.status === "cancelled") && !i.has($.id) && (i.add($.id), l.set($.id, Date.now()), r.delete($.id) && ((b = n.onSettled) == null || b.call(n, $)));
        const T = new Set(a.value.map(($) => $.id)), R = A.filter(($) => $.status === "pending" || $.status === "running" || $.status === "cancelling" ? !0 : c ? T.has($.id) : !1), M = new Set(R.map(($) => $.id)), L = a.value.filter(($) => !M.has($.id)), U = [...R, ...L];
        c = !0;
        const P = Date.now(), H = U.filter(($) => {
          if ($.status === "pending" || $.status === "running" || $.status === "cancelling") return !0;
          const F = l.get($.id);
          return F !== void 0 && P - F < kP;
        });
        a.value = H, !p.value && H.length === 0 && x();
      } catch (C) {
        console.warn("[usePendingOps] poll failed:", C);
      }
  }
  function _(b) {
    const C = r_(b);
    i.has(C.id) || r.add(C.id), a.value.some((T) => T.id === C.id) || (a.value = [C, ...a.value]), v();
  }
  function w(b) {
    a.value = a.value.filter((C) => C.id !== b), l.delete(b);
  }
  return Ct(() => {
    x();
  }), {
    ops: a,
    hasActive: p,
    register: _,
    dismiss: w,
    poll: k,
    startPolling: v,
    stopPolling: x
  };
}
function ju(e) {
  return e === "folder" || e === "vault" || e === "file";
}
function Ry(e) {
  return e ? e.e2e === !0 || e.encrypted === "folder" || e.encrypted === "vault" || typeof e.e2e_root == "string" && e.e2e_root !== "" : !1;
}
function H2(e) {
  return e ? Ry(e) || e.encrypted === "file" : !1;
}
function K2(e, t) {
  if (!t || !Array.isArray(e.app_state)) return [];
  const n = `${t}:`;
  return e.app_state.filter((a) => typeof a == "string" && a.startsWith(n)).map((a) => a.slice(n.length));
}
function Ny(e, t) {
  let n = String(e.extension ?? "").toLowerCase();
  if (!n && e.basename) {
    const a = e.basename.lastIndexOf(".");
    a > 0 && (n = e.basename.slice(a + 1).toLowerCase());
  }
  return {
    kind: e.type === "dir" ? "dir" : "file",
    ext: n,
    mime: e.mime_type ?? "",
    state: K2(e, t)
  };
}
function wP(e, t) {
  return e === t ? !0 : e.endsWith("/*") ? t.startsWith(e.slice(0, -1)) : !1;
}
function Iy(e, t) {
  const n = e ?? {}, a = t.length;
  if (a === 0 || a > 1 && !n.multi) return !1;
  const i = n.min ?? 0, r = n.max ?? 0;
  if (i > 0 && a < i || r > 0 && a > r) return !1;
  const l = n.kind || "file", c = (n.ext ?? []).map((x) => x.toLowerCase()), p = (n.mime ?? []).map((x) => x.toLowerCase()), m = n.state ?? [], v = n.no_state ?? [];
  for (const x of t) {
    if (l !== "any" && l !== x.kind) return !1;
    const k = x.state ?? [];
    if (m.length > 0 && !m.some((b) => k.includes(b)) || v.some((b) => k.includes(b))) return !1;
    if (c.length === 0 && p.length === 0) continue;
    const _ = String(x.ext ?? "").toLowerCase();
    let w = c.includes(_);
    if (!w) {
      const b = String(x.mime ?? "").toLowerCase();
      w = p.some((C) => wP(C, b));
    }
    if (!w) return !1;
  }
  return !0;
}
function By(e, t, n) {
  return Iy(e, t.map((a) => Ny(a, n)));
}
function Zt(e, t) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const n = String(t || "en").toLowerCase().split("-")[0], a = e[n];
  if (typeof a == "string" && a !== "") return a;
  const i = e.en;
  if (typeof i == "string" && i !== "") return i;
  for (const r of Object.values(e))
    if (typeof r == "string" && r !== "") return r;
  return "";
}
function _P(e, t) {
  if (!e) return "";
  if (typeof e == "string") return e;
  const n = String(t || "en").toLowerCase().split("-")[0], a = e[n];
  return typeof a == "string" && a !== "" ? a : "";
}
function Fy(e, t, n) {
  const a = _P(e, t);
  if (a) return a;
  const i = n();
  return i || Zt(e, t);
}
function xP(e, t) {
  switch (e.kind) {
    case "engine":
      return t("plugin.needs_engine", { name: e.name });
    case "office":
      return t("plugin.needs_office", { name: e.name });
  }
  return t("plugin.needs_other", { name: e.name });
}
function Uy(e) {
  return e.key || `plugin:${e.plugin}/${e.id}`;
}
function SP(e) {
  return e.startsWith("plugin:");
}
function $P(e) {
  var t;
  return e.output_mode === "sibling" || e.output_mode === "version" || ((t = e.applies) == null ? void 0 : t.writable) === !0;
}
function TP(e) {
  return e.read_only_ok === !1;
}
const Sm = { none: 0, viewer: 1, editor: 2, owner: 3 };
function AP(e) {
  return e.min_role === "owner" ? "owner" : e.min_role === "editor" || $P(e) ? "editor" : "viewer";
}
function EP(e, t, n) {
  var i;
  if ((i = t.lock) != null && i.plugin && t.lock.plugin === e.plugin) return !0;
  const a = n(t);
  return a === void 0 || !(a in Sm) ? !0 : Sm[a] >= Sm[AP(e)];
}
function V2(e, t) {
  return t.length === 0 ? [] : e.filter((n) => By(n.applies, t, n.plugin));
}
function CP(e, t, n) {
  var k;
  if (n.trash || n.e2e) return [];
  if (t.some((_) => H2(_) || _.mime_type === "inode/storage")) return [];
  const a = n.permOf, i = (_) => !(n.readOnly && TP(_)) && (!a || t.every((w) => EP(_, w, a))), r = V2(e, t).filter(i), l = /* @__PURE__ */ new Map();
  if (n.needWords)
    for (const _ of e) {
      if (r.includes(_) || !((k = _.gated) != null && k.length) || !i(_)) continue;
      const w = _.gated.find(
        (b) => By({ ..._.applies, ext: b.ext ?? [], mime: [] }, t, _.plugin)
      );
      w && l.set(_, n.needWords(w.needs));
    }
  const c = e.filter((_) => r.includes(_) || l.has(_));
  if (c.length === 0) return [];
  const p = n.hasIcon ?? (() => !1), m = /* @__PURE__ */ new Map();
  for (const _ of c) {
    const w = m.get(_.plugin);
    w ? w.push(_) : m.set(_.plugin, [_]);
  }
  const v = [];
  let x = !0;
  for (const [_, w] of m) {
    v.push({ divider: !0, key: x ? "sep-plugins" : `sep-plugin:${_}`, label: "" }), x = !1;
    for (const b of w) {
      const C = l.get(b);
      v.push({
        key: Uy(b),
        label: Zt(b.label, n.locale),
        icon: b.icon && p(b.icon) ? b.icon : "plugin",
        danger: b.danger === !0,
        ...C ? { disabled: !0, title: C } : {}
      });
    }
  }
  return v;
}
const zP = 5 * 60 * 1e3, _v = /* @__PURE__ */ new Map();
function MP() {
  _v.clear();
}
function OP(e) {
  let t = _v.get(e);
  return t || (t = { at: 0, data: S({ actions: [], views: [] }), inflight: null }, _v.set(e, t)), t;
}
function PP(e, t) {
  const n = e.endpoints.pluginActions ?? "", a = OP(n || "(none)"), i = S(!1), r = S(null), l = E(() => t() && n !== ""), c = E(() => l.value ? a.data.value.actions : []), p = E(() => l.value ? a.data.value.views : []), m = E(() => l.value ? a.data.value.open_rules ?? {} : {});
  async function v(w = !1) {
    return l.value ? a.at > 0 && Date.now() - a.at < zP && !w ? (i.value = !0, a.data.value) : (a.inflight || (a.inflight = e.pluginActions().then((C) => (a.data.value = { actions: C.actions ?? [], views: C.views ?? [], open_rules: C.open_rules ?? {} }, a.at = Date.now(), r.value = null, a.data.value)).catch((C) => (r.value = String((C == null ? void 0 : C.message) ?? C), a.data.value)).finally(() => {
      a.inflight = null, i.value = !0;
    })), a.inflight) : { actions: [], views: [] };
  }
  Xe(
    l,
    (w) => {
      w && v();
    },
    { immediate: !0 }
  );
  function x(w) {
    return V2(c.value, w);
  }
  function k(w) {
    return c.value.find((b) => Uy(b) === w);
  }
  function _(w, b, C) {
    return e.pluginActionRun(w.plugin, w.id, {
      paths: b.map((A) => A.path),
      params: C
    });
  }
  return { enabled: l, actions: c, views: p, openRules: m, loaded: i, error: r, refresh: v, actionsFor: x, byKey: k, run: _ };
}
const DP = 25e3, LP = 15e3, RP = 6;
class NP {
  constructor(t) {
    Bt(this, "ws", null);
    Bt(this, "opts");
    Bt(this, "closed", !1);
    Bt(this, "connecting", !1);
    Bt(this, "retries", 0);
    Bt(this, "fallback", !1);
    Bt(this, "pingTimer", null);
    Bt(this, "reconnectTimer", null);
    // Last-known intent, replayed on (re)connect.
    Bt(this, "currentPath", null);
    Bt(this, "currentFocus", null);
    this.opts = t, this.connect();
  }
  /** Subscribe to a folder ("<adapter>://<dir>"). Swaps the active room and
   *  resets focus. Passing null unsubscribes (drive list / trash have no room). */
  subscribe(t) {
    this.currentPath = t, this.currentFocus = null, t && this.send({ type: "subscribe", path: t });
  }
  /** Report the file the user is focused on (or null to clear). */
  setFocus(t) {
    this.currentFocus = t, this.send({ type: "focus", file: t });
  }
  /** Tear down permanently — call on unmount. */
  close() {
    this.closed = !0, this.clearTimers(), this.dropSocket();
  }
  async connect() {
    if (this.closed || this.connecting || this.ws) return;
    this.connecting = !0;
    let t = null;
    try {
      t = await this.opts.getTicket();
    } catch {
      t = null;
    }
    if (this.connecting = !1, this.closed) return;
    if (!t || !t.ticket || !t.ws_url) {
      this.fail();
      return;
    }
    const n = t.ws_url.includes("?") ? "&" : "?";
    let a;
    try {
      a = new WebSocket(`${t.ws_url}${n}ticket=${encodeURIComponent(t.ticket)}`);
    } catch {
      this.fail();
      return;
    }
    this.ws = a, a.onopen = () => {
      var i, r;
      this.retries = 0, this.setFallback(!1), (r = (i = this.opts.handlers).onStatus) == null || r.call(i, !0), this.currentPath && this.send({ type: "subscribe", path: this.currentPath }), this.currentFocus !== null && this.send({ type: "focus", file: this.currentFocus }), this.startPing();
    }, a.onmessage = (i) => {
      var c, p, m, v, x, k, _, w, b, C;
      let r;
      try {
        r = JSON.parse(typeof i.data == "string" ? i.data : "");
      } catch {
        return;
      }
      const l = r;
      if ((l == null ? void 0 : l.type) === "change") (p = (c = this.opts.handlers).onChange) == null || p.call(c, r);
      else if ((l == null ? void 0 : l.type) === "presence") (v = (m = this.opts.handlers).onPresence) == null || v.call(m, r);
      else if ((l == null ? void 0 : l.type) === "app.updated") {
        const A = r;
        typeof A.app == "string" && typeof A.version == "string" && ((k = (x = this.opts.handlers).onAppUpdated) == null || k.call(x, A));
      } else if ((l == null ? void 0 : l.type) === "vault.generation" || (l == null ? void 0 : l.type) === "vault.lock") {
        const A = r;
        typeof A.path == "string" && ((w = (_ = this.opts.handlers).onVault) == null || w.call(_, A));
      } else (l == null ? void 0 : l.type) === "access.changed" && ((C = (b = this.opts.handlers).onAccessChanged) == null || C.call(b, { all: r.scope === "all" }));
    }, a.onerror = () => {
    }, a.onclose = () => {
      var i, r;
      this.stopPing(), this.ws = null, (r = (i = this.opts.handlers).onStatus) == null || r.call(i, !1), this.fail();
    };
  }
  // fail schedules a capped reconnect; after MAX_RETRIES it gives up on the live
  // socket and flips to fallback (polling) mode.
  fail() {
    if (this.closed || this.reconnectTimer) return;
    if (this.retries >= RP) {
      this.setFallback(!0);
      return;
    }
    const t = Math.min(1e3 * 2 ** this.retries, LP);
    this.retries += 1, this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null, this.connect();
    }, t);
  }
  setFallback(t) {
    var n, a;
    this.fallback !== t && (this.fallback = t, (a = (n = this.opts.handlers).onFallback) == null || a.call(n, t));
  }
  send(t) {
    const n = this.ws;
    if (!(!n || n.readyState !== WebSocket.OPEN))
      try {
        n.send(JSON.stringify(t));
      } catch {
      }
  }
  startPing() {
    this.stopPing(), this.pingTimer = setInterval(() => this.send({ type: "ping" }), DP);
  }
  stopPing() {
    this.pingTimer && (clearInterval(this.pingTimer), this.pingTimer = null);
  }
  dropSocket() {
    if (this.ws) {
      try {
        this.ws.onclose = null, this.ws.close();
      } catch {
      }
      this.ws = null;
    }
  }
  clearTimers() {
    this.stopPing(), this.reconnectTimer && (clearTimeout(this.reconnectTimer), this.reconnectTimer = null);
  }
}
function IP(e, t) {
  const n = t.now ?? (() => Date.now());
  let a = null, i = null;
  const r = () => {
    const l = n();
    i === null && (i = l);
    const c = i + t.maxWait - l, p = Math.max(0, Math.min(t.wait, c));
    a && clearTimeout(a), a = setTimeout(() => {
      a = null, i = null, e();
    }, p);
  };
  return r.cancel = () => {
    a && clearTimeout(a), a = null, i = null;
  }, r;
}
const xv = /* @__PURE__ */ new Set();
function BP(e, t) {
  for (const n of [...xv])
    try {
      n(e, t);
    } catch {
    }
}
function FP(e) {
  return xv.add(e), () => {
    xv.delete(e);
  };
}
const UP = 200, HP = 2e3, KP = 12e3;
function VP(e, t) {
  const n = S([]), a = S(!1), i = S(!1);
  let r = null, l = null, c = !1;
  const p = IP(() => t.reload(), {
    wait: UP,
    maxWait: HP
  });
  let m = null;
  function v(A) {
    l && A.path && A.path !== l || (n.value = Array.isArray(A.users) ? A.users : []);
  }
  function x(A) {
    MP(), BP(A.app, A.version);
  }
  function k(A) {
    i.value = A, A ? (n.value = [], m || (m = setInterval(() => t.reload(), KP))) : m && (clearInterval(m), m = null);
  }
  function _() {
    r || (r = new NP({
      getTicket: () => e.wsTicket(),
      handlers: {
        onChange: p,
        onPresence: v,
        onAppUpdated: x,
        onVault: (A) => {
          var T;
          return (T = t.onVault) == null ? void 0 : T.call(t, A);
        },
        onAccessChanged: (A) => {
          var T;
          return (T = t.onAccess) == null ? void 0 : T.call(t, { all: A.all, resync: !1 });
        },
        onFallback: k,
        onStatus: (A) => {
          var T;
          a.value = A, A && c && ((T = t.onAccess) == null || T.call(t, { all: !1, resync: !0 })), A && (c = !0);
        }
      }
    }));
  }
  function w(A) {
    n.value = [], l = A, r == null || r.subscribe(A);
  }
  function b(A) {
    r == null || r.setFocus(A);
  }
  function C() {
    p.cancel(), m && (clearInterval(m), m = null), r == null || r.close(), r = null, c = !1, i.value = !1;
  }
  return { presenceUsers: n, connected: a, degraded: i, start: _, subscribe: w, setFocus: b, stop: C };
}
const jP = 500;
function qP(e) {
  const t = e.thumb_url;
  if (!t) return null;
  const n = t.indexOf("?");
  if (n === -1) return `${t}||${e.last_modified ?? ""}`;
  const a = new URLSearchParams(t.slice(n + 1)).get("v") ?? "";
  return `${t.slice(0, n)}|${a}|${e.last_modified ?? ""}`;
}
function WP(e, t) {
  const n = lM(/* @__PURE__ */ new Map()), a = [], i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = (m) => gy(e, m);
  function c(m) {
    const v = m.thumb_url, x = qP(m);
    if (!v || !x) return null;
    const k = n.get(x);
    return k || (!i.has(v) && !r.has(x) && p(v, x), null);
  }
  async function p(m, v) {
    r.add(v);
    try {
      const x = await fetch(l(m), {
        headers: await t.authHeaders({ Accept: "*/*" }),
        credentials: t.credentialsMode()
      });
      if (!x.ok) throw new Error(String(x.status));
      const k = await x.blob();
      if (a.length >= jP) {
        const _ = a.shift(), w = uM(n), b = _ ? w.get(_) : void 0;
        _ && b && (URL.revokeObjectURL(b), w.delete(_));
      }
      a.push(v), n.set(v, URL.createObjectURL(k));
    } catch {
      i.add(m);
    } finally {
      r.delete(v);
    }
  }
  return { src: c };
}
let Vf = null, jf = null, vf = null, yf = null;
function wp() {
  Vf || (Vf = import(
    /* @vite-ignore */
    "monaco-editor"
  ).then((e) => (vf = e.default ?? e, vf)).catch(() => (vf = null, null))), jf || (jf = import(
    /* @vite-ignore */
    "./common-xdTjul80.js"
  ).then((e) => (yf = e.default ?? e, yf)).catch(() => (yf = null, null)));
}
async function YP() {
  return Vf || wp(), Vf;
}
async function GP() {
  return jf || wp(), jf;
}
function XP() {
  return vf;
}
function JP() {
  return yf;
}
function zfe() {
  return wp(), {
    ensureMonaco: YP,
    ensureHighlight: GP,
    getMonaco: XP,
    getHighlight: JP
  };
}
const ZP = ["title"], QP = ["src", "alt"], e3 = {
  key: 2,
  class: "fx-presence-dot",
  "aria-hidden": "true"
}, s_ = /* @__PURE__ */ rt({
  __name: "PresenceAvatar",
  props: {
    user: {},
    title: {}
  },
  setup(e) {
    const t = e, n = E(() => {
      const c = (t.user.avatar ?? "").trim();
      return /^(data:image\/|https?:\/\/|\/)/.test(c) ? c : "";
    }), a = S(!1), i = E(() => !!n.value && !a.value), r = E(() => {
      const c = t.user.name.trim().split(/\s+/).filter(Boolean);
      return c.length === 0 ? "?" : c.length === 1 ? c[0].slice(0, 2).toUpperCase() : (c[0][0] + c[c.length - 1][0]).toUpperCase();
    }), l = E(() => {
      const c = t.user.uid ?? String(t.user.id);
      let p = 0;
      for (let m = 0; m < c.length; m++) p = p * 31 + c.charCodeAt(m) >>> 0;
      return p % 360;
    });
    return (c, p) => (f(), h("span", {
      class: Ne(["fx-presence-avatar", { "fx-presence-avatar--photo": i.value }]),
      style: Xt({ backgroundColor: `hsl(${l.value} 60% 45%)` }),
      title: e.title
    }, [
      i.value ? (f(), h("img", {
        key: 0,
        class: "fx-presence-photo",
        src: n.value,
        alt: e.user.name,
        onError: p[0] || (p[0] = (m) => a.value = !0)
      }, null, 40, QP)) : (f(), h(Ce, { key: 1 }, [
        Vt(y(r.value), 1)
      ], 64)),
      e.user.file ? (f(), h("span", e3)) : D("", !0)
    ], 14, ZP));
  }
}), t3 = {
  key: 0,
  class: "fx-presence-chips"
}, n3 = ["title"], a3 = { class: "fx-presence-chip-name" }, i3 = {
  key: 0,
  class: "fx-presence-chip-file"
}, o3 = ["title"], r3 = {
  key: 0,
  class: "fx-presence-more"
}, s3 = ["title"], l3 = { class: "fx-presence-file" }, u3 = ["title", "aria-expanded"], l_ = "filex.presence.expanded", c3 = /* @__PURE__ */ rt({
  __name: "PresenceBar",
  props: {
    users: {},
    selfId: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => Ca(t.locale)), a = E(
      () => (t.users ?? []).filter((p) => t.selfId == null || p.id !== t.selfId)
    ), i = S((() => {
      try {
        return localStorage.getItem(l_) === "1";
      } catch {
        return !1;
      }
    })());
    function r() {
      i.value = !i.value;
      try {
        localStorage.setItem(l_, i.value ? "1" : "0");
      } catch {
      }
    }
    function l(p) {
      return p.uid ?? String(p.id);
    }
    function c(p) {
      return p.file ? `${p.name} · ${p.file}` : p.name;
    }
    return (p, m) => a.value.length ? (f(), h("div", {
      key: 0,
      class: Ne(["fx-presence", { "fx-presence--wide": i.value }])
    }, [
      i.value ? (f(), h("div", t3, [
        (f(!0), h(Ce, null, nt(a.value, (v) => (f(), h("span", {
          key: l(v),
          class: "fx-presence-chip",
          title: c(v)
        }, [
          Je(s_, { user: v }, null, 8, ["user"]),
          d("span", a3, [
            d("bdi", null, y(v.name), 1)
          ]),
          v.file ? (f(), h("span", i3, "· " + y(v.file), 1)) : D("", !0)
        ], 8, n3))), 128))
      ])) : (f(), h(Ce, { key: 1 }, [
        d("div", {
          class: "fx-presence-avatars",
          title: a.value.map(c).join(", ")
        }, [
          (f(!0), h(Ce, null, nt(a.value.slice(0, 5), (v) => (f(), We(s_, {
            key: l(v),
            user: v,
            title: c(v)
          }, null, 8, ["user", "title"]))), 128)),
          a.value.length > 5 ? (f(), h("span", r3, "+" + y(a.value.length - 5), 1)) : D("", !0)
        ], 8, o3),
        d("span", {
          class: "fx-presence-text",
          title: a.value.map(c).join(", ")
        }, [
          Vt(y(a.value.length === 1 ? a.value[0].name : u(n)("presence.others", { n: a.value.length })) + " ", 1),
          a.value.length === 1 && a.value[0].file ? (f(), h(Ce, { key: 0 }, [
            m[0] || (m[0] = Vt(" · ", -1)),
            d("span", l3, y(a.value[0].file), 1)
          ], 64)) : D("", !0)
        ], 8, s3)
      ], 64)),
      d("button", {
        type: "button",
        class: "fx-presence-toggle",
        title: i.value ? u(n)("presence.collapse") : u(n)("presence.expand"),
        "aria-expanded": i.value,
        onClick: r
      }, y(i.value ? "‹" : "›"), 9, u3)
    ], 2)) : D("", !0);
  }
}), d3 = '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/>', f3 = '<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z"/><circle cx="12" cy="12" r="3"/>', u_ = "M12 3.6l2.6 5.3 5.85.85-4.23 4.12 1 5.83L12 16.97l-5.22 2.73 1-5.83L3.55 9.75l5.85-.85z", c_ = '<path d="M8 3.5h8"/><path d="M9.6 3.5v6.1L7.2 12.3v1.7h9.6v-1.7L14.4 9.6V3.5"/><path d="M12 14v6.5"/>', $m = '<rect x="3.5" y="4.5" width="17" height="15" rx="2"/>', d_ = '<path d="M4 6.5h16"/><path d="M9.5 6.5V4.9a1.4 1.4 0 0 1 1.4-1.4h2.2a1.4 1.4 0 0 1 1.4 1.4v1.6"/><path d="M6.6 6.5l.85 12.1a2 2 0 0 0 2 1.9h5.1a2 2 0 0 0 2-1.9l.85-12.1"/><path d="M10.3 10.3v6.4"/><path d="M13.7 10.3v6.4"/>', f_ = '<path d="M6.8 3.5h10.4a1.6 1.6 0 0 1 1.6 1.6v15.4l-6.8-3.9-6.8 3.9V5.1A1.6 1.6 0 0 1 6.8 3.5z"/>', j2 = {
  /* ── opening ─────────────────────────────────────────────────────────── */
  open: '<path d="M14 3.5h6.5V10"/><path d="M20.5 3.5L12 12"/><path d="M18 13.5v5a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h5"/>',
  "open-tab": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/>',
  preview: f3,
  download: d3 + '<path d="M12 4v11.5"/><path d="M7.5 11L12 15.5 16.5 11"/>',
  "archive-create": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 11v5"/><path d="M9.5 13.5h5"/>',
  "archive-extract": '<path d="M5 8.5h14v11H5z"/><path d="M4 4h16v4.5H4z"/><path d="M12 10.5v6"/><path d="M9.5 14l2.5 2.5 2.5-2.5"/>',
  upload: '<path d="M4.5 15.5v3A2 2 0 0 0 6.5 20.5h11a2 2 0 0 0 2-2v-3"/><path d="M12 15.5V4"/><path d="M7.5 8.5L12 4l4.5 4.5"/>',
  convert: '<path d="M4 8.5h13"/><path d="M13.5 5L17 8.5 13.5 12"/><path d="M20 15.5H7"/><path d="M10.5 12L7 15.5 10.5 19"/>',
  /* "Paylaş / İzinler" — the three-node share, not a chain link: this row
     opens permissions as well as a link, and people are the subject. */
  access: '<circle cx="17.5" cy="6" r="2.5"/><circle cx="6.5" cy="12" r="2.5"/><circle cx="17.5" cy="18" r="2.5"/><path d="M8.75 10.8l6.5-3.6"/><path d="M8.75 13.2l6.5 3.6"/>',
  details: '<circle cx="12" cy="12" r="8.5"/><path d="M12 11.2v5.6"/><circle cx="12" cy="7.7" r="0.9" fill="currentColor" stroke="none"/>',
  /* ── identity / clipboard ────────────────────────────────────────────── */
  "copy-id": '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><circle cx="8.5" cy="10.8" r="2"/><path d="M5.3 16.2c.5-1.5 1.75-2.4 3.2-2.4s2.7.9 3.2 2.4"/><path d="M14.8 10h4.2"/><path d="M14.8 13.6h4.2"/>',
  /* A clipboard carrying a path separator — this copies the location, not the
     thing that lives at it. */
  "copy-path": '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/><path d="M10 11.2l2.4 2.4-2.4 2.4"/>',
  rename: '<path d="M4 20l.9-4.1 11-11a2.05 2.05 0 0 1 2.9 2.9l-11 11z"/><path d="M14 7l3 3"/>',
  cut: '<circle cx="6.5" cy="17.5" r="2.5"/><circle cx="6.5" cy="6.5" r="2.5"/><path d="M8.6 8.3L19 19"/><path d="M8.6 15.7L19 5"/>',
  copy: '<rect x="9" y="9" width="11.5" height="11.5" rx="2"/><path d="M15 6v-.5a2 2 0 0 0-2-2H5.5a2 2 0 0 0-2 2V13a2 2 0 0 0 2 2H6"/>',
  paste: '<path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2"/><rect x="9" y="2.8" width="6" height="3.6" rx="1.2"/>',
  /* ── metadata ────────────────────────────────────────────────────────── */
  /* star = "not starred yet, do it" (outline); unstar = the state you are in
     (filled). The renderer picks between them by name, see FileExplorer. */
  star: `<path d="${u_}"/>`,
  unstar: `<path d="${u_}" fill="currentColor"/>`,
  tags: '<path d="M3.5 11.4V5.2a1.7 1.7 0 0 1 1.7-1.7h6.2a1.7 1.7 0 0 1 1.2.5l7.2 7.2a1.7 1.7 0 0 1 0 2.4l-6.2 6.2a1.7 1.7 0 0 1-2.4 0L4 12.6a1.7 1.7 0 0 1-.5-1.2z"/><circle cx="8" cy="8" r="1.3"/>',
  /* ── destructive / recovery ──────────────────────────────────────────── */
  delete: d_,
  "open-trash": d_,
  /* The undo arrow, not a rotating one: "Geri Yükle" puts a thing back where
     it was, and that is the gesture people already read as undo. */
  restore: '<path d="M9 6L5 10l4 4"/><path d="M5 10h9a5 5 0 0 1 0 10h-3.5"/>',
  /* ── folder-level ────────────────────────────────────────────────────── */
  "new-folder": '<path d="M3 7.5a2 2 0 0 1 2-2h4.2a2 2 0 0 1 1.4.6l1.4 1.4H19a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M12 11.3v5"/><path d="M9.5 13.8h5"/>',
  /* belge:n1 — a page with a plus: "make me a new document of some type".
     Keyed by the action's own key, so the menu row carries no icon of its
     own and no emoji enters the markup. */
  "new-document": '<path d="M13.5 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"/><path d="M13.5 3l5 5"/><path d="M13.5 3v5h5"/><path d="M17.5 14.5v6"/><path d="M14.5 17.5h6"/>',
  refresh: '<path d="M20.5 12a8.5 8.5 0 1 1-2.49-6.01"/><path d="M18 1.5V6h-4.5"/>',
  /* ── desktop sync ("keep on this device") ────────────────────────────── */
  "keep-local": c_,
  "keep-online": '<path d="M7 18.5h10a3.5 3.5 0 0 0 0-7 5 5 0 0 0-9.6-1.2A4.2 4.2 0 0 0 7 18.5z"/>',
  /* Kept because a parent folder is kept — the pin, with the branch it came
     down. The row is disabled; the glyph says why. */
  "keep-inherited": c_ + '<path d="M2.5 20.5h3.6a1.6 1.6 0 0 0 1.6-1.6V17"/>',
  "keep-reveal": '<path d="M2.5 17.5V6.5a2 2 0 0 1 2-2h3.8a2 2 0 0 1 1.4.6l1.4 1.4h4.4a2 2 0 0 1 2 2v1.8"/><path d="M4 19.5h13.4a2 2 0 0 0 1.9-1.37l2-6A1.4 1.4 0 0 0 20 10.3H9.4a2 2 0 0 0-1.9 1.37L5.5 18"/>',
  /* ── view preferences ────────────────────────────────────────────────── */
  "toggle-hidden": '<path d="M3.5 3.5l17 17"/><path d="M9.9 6A9.6 9.6 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17.3 17.3 0 0 1-3.35 4.15"/><path d="M6.55 7.7A17.4 17.4 0 0 0 2.5 12S6 18.5 12 18.5a9.7 9.7 0 0 0 3.95-.85"/><path d="M10.2 10.3a2.9 2.9 0 0 0 3.9 4.1"/>',
  density: '<path d="M8.5 8L12 4.5 15.5 8"/><path d="M8.5 16L12 19.5 15.5 16"/><path d="M12 4.5v15"/>',
  "view-list": '<path d="M8.5 6.5h12"/><path d="M8.5 12h12"/><path d="M8.5 17.5h12"/><path d="M4 6.5h.01"/><path d="M4 12h.01"/><path d="M4 17.5h.01"/>',
  "view-grid": '<rect x="3.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="3.5" width="7" height="7" rx="1.5"/><rect x="3.5" y="13.5" width="7" height="7" rx="1.5"/><rect x="13.5" y="13.5" width="7" height="7" rx="1.5"/>',
  "view-gallery": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><circle cx="8.3" cy="9.6" r="1.5"/><path d="M4.3 17l4.7-4.7 3 3 3-3 5 4.7"/>',
  nav: $m + '<path d="M9.5 4.5v15"/>',
  inspector: $m + '<path d="M14.5 4.5v15"/>',
  /* ── explorer settings ───────────────────────────────────────────────── */
  "shortcut-settings": '<rect x="2.5" y="6" width="19" height="12" rx="2.5"/><path d="M6.5 9.8h.01"/><path d="M10 9.8h.01"/><path d="M13.5 9.8h.01"/><path d="M17 9.8h.01"/><path d="M6.5 12.9h.01"/><path d="M10 12.9h.01"/><path d="M13.5 12.9h.01"/><path d="M17 12.9h.01"/><path d="M8.6 15.6h6.8"/>',
  /* Light/dark as the thing it actually switches: one disc, half of it inked. */
  theme: '<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none"/>',
  /* zaman:z3 — a clock face, for the Time zone row. */
  timezone: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.2V12l3.2 2"/>',
  tour: '<path d="M2.5 9L12 4.5 21.5 9 12 13.5z"/><path d="M6.6 11.1v4.4c0 1.6 2.4 2.9 5.4 2.9s5.4-1.3 5.4-2.9v-4.4"/>',
  /* "Dosya İste" — the public drop link. A chain, because what this makes is
     a URL to hand somebody. */
  "request-files": '<path d="M10.2 13.8a4.2 4.2 0 0 0 6.1 0l2.3-2.3a4.3 4.3 0 0 0-6.1-6.1l-1.35 1.35"/><path d="M13.8 10.2a4.2 4.2 0 0 0-6.1 0l-2.3 2.3a4.3 4.3 0 0 0 6.1 6.1l1.35-1.35"/>',
  /* ── toolbar chrome that is not a ContextAction ──────────────────────── */
  "go-up": '<path d="M12 20V5"/><path d="M5.5 11.5L12 5l6.5 6.5"/>',
  /* #57 — the storage row's order menu (SideNav). One step up or down is a
     SHORT arrow, so it does not read as `go-up`'s "to the parent folder";
     "Sort by name" is the A→Z mark every file manager uses; "Use default order" is
     the refresh circle turning back. All vertical or rotational, so none of
     them is mirrored in a right-to-left interface. */
  "move-up": '<path d="M12 18V7"/><path d="M7.5 11.5L12 7l4.5 4.5"/>',
  "move-down": '<path d="M12 6v11"/><path d="M7.5 12.5L12 17l4.5-4.5"/>',
  "sort-name": '<path d="M3.5 10.5L6.5 3.5l3 7"/><path d="M4.7 8h3.6"/><path d="M4 13.5h5l-5 7h5"/><path d="M17 4v16"/><path d="M13.5 16.5L17 20l3.5-3.5"/>',
  "reset-order": '<path d="M3.5 12a8.5 8.5 0 1 0 2.49-6.01"/><path d="M6 1.5V6h4.5"/>',
  /* === gorunum:v2-topbar — the breadcrumb row's own controls ============
     The crumb trail gained the reference shell's three affordances: a home
     crumb in place of the bare "/" root, a chevron on the last crumb that
     lists what is inside it, and the path editor we already had (its glyph
     moves here from Breadcrumb.vue so every mark in the row comes from one
     file). */
  home: '<path d="M3.5 10.6L12 3.5l8.5 7.1"/><path d="M5.6 9.4V19a1.5 1.5 0 0 0 1.5 1.5h9.8a1.5 1.5 0 0 0 1.5-1.5V9.4"/><path d="M9.9 20.5v-5.2h4.2v5.2"/>',
  subfolders: '<path d="M6.8 9.8L12 15l5.2-5.2"/>',
  "edit-path": '<path d="M4 20h4l10-10a2.1 2.1 0 0 0-3-3L5 17z"/><path d="M14.5 6.5l3 3"/>',
  /* === gorunum:v2-topbar — the header's trailing cluster ================
     The page chrome around the explorer is gone, so the account-level doors
     are drawn by the header itself (the host fills them through the
     `header-actions` slot). The glyphs live here so an embedder's cluster
     comes out the same weight and colour as everything beside it. */
  admin: '<rect x="3" y="3.5" width="7.4" height="7.4" rx="1.6"/><rect x="13.6" y="3.5" width="7.4" height="4.6" rx="1.6"/><rect x="13.6" y="10.7" width="7.4" height="9.8" rx="1.6"/><rect x="3" y="13.6" width="7.4" height="6.9" rx="1.6"/>',
  /* ⚠ A PERSON, not a cog. The first draft drew the gear as a ringed disc with
     eight spokes and at 16px it came out as a SUN — sitting in the very row
     the light/dark toggle had just been removed from, which is the one thing
     the mark must not be mistaken for (measured at 1440 and 390: it read as a
     theme switch in both). The account bust is what the reference hangs this
     menu on, and the tooltip says which settings. */
  account: '<circle cx="12" cy="8.2" r="3.6"/><path d="M4.9 20.3a7.35 7.35 0 0 1 14.2 0"/>',
  "sign-out": '<path d="M9.5 20.5H6a2 2 0 0 1-2-2v-13a2 2 0 0 1 2-2h3.5"/><path d="M15.5 16.5L20 12l-4.5-4.5"/><path d="M20 12H9"/>',
  /* The AI assistant (task #269) - a spark, the mark every assistant in this
     class of product wears; it is the same glyph the "coming soon" button
     wore, so it did not change under people's fingers when it came alive. */
  ai: '<path d="M12 3.2l1.75 4.3 4.3 1.75-4.3 1.75L12 15.3l-1.75-4.3L5.95 9.25l4.3-1.75z"/><path d="M18.2 15.1l.8 1.95 1.95.8-1.95.8-.8 1.95-.8-1.95-1.95-.8 1.95-.8z"/>',
  /* The notification bell, for the host's header cluster (web/src
     NotificationBell.vue). ⚠ Drawn HERE, not taken from the app's icon
     library: it sits in the same row as refresh, the spark and the avatar,
     and a glyph at a foreign stroke weight in that row is the exact mismatch
     this set exists to prevent. A dome on a flared rim, the clapper below. */
  bell: '<path d="M6.2 16.6V11a5.8 5.8 0 0 1 11.6 0v5.6l1.7 1.9H4.5z"/><path d="M10.1 21a2.1 2.1 0 0 0 3.8 0"/>',
  /* === /gorunum:v2-topbar === */
  search: '<circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.4 15.4l5.1 5.1"/>',
  /* gorunum:v1-advsearch — sliders, not a funnel. A funnel says "throw rows
     away"; this control opens a dialog where you SET things, and two of its
     three rows are exactly a slider's job (a size range, a time window). */
  filter: '<path d="M4 7.5h4"/><path d="M13 7.5h7"/><circle cx="10.5" cy="7.5" r="2.4"/><path d="M4 16.5h7"/><path d="M16 16.5h4"/><circle cx="13.5" cy="16.5" r="2.4"/>',
  more: '<circle cx="5.5" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none"/><circle cx="18.5" cy="12" r="1.2" fill="currentColor" stroke="none"/>',
  close: '<path d="M5.5 5.5l13 13"/><path d="M18.5 5.5l-13 13"/>',
  /* A share link. Two half-chains, which is what a link IS. The details
     panel's "Not shared / Create link" row used to draw a chain EMOJI
     there, i.e. whatever glyph the OS happened to ship, full-colour,
     beside a column of stroked grey ones. */
  link: '<path d="M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5"/><path d="M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53"/>',
  /* baglan:b1 — "Connections". A PLUG, deliberately not the chain above:
     the empty screen's account menu draws both rows one under the other
     ("Paylaştıklarım", then "Bağlantılar"), and one mark on two adjacent rows
     is the misreading this set exists to stop. It is also the mark the admin
     panel's own Connections entry already wears (web lib/adminNav.ts, lucide `Cable`),
     so the two ways into the same screen agree on what it looks like. */
  connect: '<path d="M9 8.5V3"/><path d="M15 8.5V3"/><path d="M6 8.5h12v4.5a4.5 4.5 0 0 1-4.5 4.5h-3A4.5 4.5 0 0 1 6 13z"/><path d="M12 17.5V21"/>',
  /* === ikon:emoji — the command palette's own rows =======================
   * The palette printed `{{ it.icon }}` as TEXT: `➜ 📁 ⬆ ▦ 🗑 ⟳ ↑ 🎨 ⌨ 🎓 ⧉ ◫
   * 💾 🔖`. Thirteen marks from four different type families, in a list whose
   * neighbours — the context menu it duplicates and the toolbar it launches —
   * had already moved here. Most of the keys it needed were drawn already
   * (`tour` is the mortarboard, `shortcut-settings` the keyboard, the three
   * `view-*` the mode chips); these six are what was genuinely missing. */
  /* "Go to path" — the arrow goes INTO the box, the mirror of `sign-out`.
     A bare arrow would have said "next", which this row is not. */
  goto: '<path d="M13.5 4.5h4a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-4"/><path d="M10 8.2L13.8 12 10 15.8"/><path d="M4.5 12h9.3"/>',
  /* A second pane opened beside the first — `nav`/`inspector`'s panel with the
     divider down the middle, because that is literally what split view is. */
  split: $m + '<path d="M12 4.5v15"/>',
  /* A new tab: `open-tab`'s window, with the plus in the body rather than on
     the tab strip (at 16px a plus up there merges into the tab). */
  "tab-new": '<rect x="3" y="4.5" width="18" height="15" rx="2"/><path d="M3 9.5h18"/><path d="M9.5 4.5v5"/><path d="M12 12.1v5"/><path d="M9.5 14.6h5"/>',
  bookmark: f_,
  "save-search": f_ + '<path d="M12 7.2v5.2"/><path d="M9.4 9.8h5.2"/>',
  /* The padlock, for the rows and strips that talk ABOUT encryption ("create
     an encrypted folder", "this one is unlocked"). The listing marker is a
     different drawing on purpose — there the lock is cut out of the folder,
     because the row still has to read as a folder. */
  lock: '<rect x="4.5" y="10.3" width="15" height="10.2" rx="2.2"/><path d="M7.9 10.3V7.6a4.1 4.1 0 0 1 8.2 0v2.7"/><circle cx="12" cy="15.4" r="1.5"/>',
  /* === ikon:emoji — states the viewers and modals report ================
   * `✓ ✗ ⚠️ ⏳` in the viewer chrome. The first two are typographic and came
   * out at whatever weight the UI font had; the last two are colour emoji, so
   * a fallback screen's 48px mark was the only full-colour thing on a grey
   * page. `progress` is drawn as an open ring because it is SPUN by CSS
   * (`@keyframes fe-spin`) — an hourglass cannot say "still going". */
  /* An app plugin's row when its manifest names no glyph this set draws: a
     puzzle piece, the mark every extension surface already wears. Rows whose
     manifest icon IS a key here (`convert`, `lock`, …) get that glyph instead
     — lib/pluginMenu decides, this only draws. */
  plugin: '<path d="M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z"/>',
  /* A pen signing on a line — the e-signature app's own icon (manifest
     `icon: "sign"`). ⚠ Drawn here because a key the catalogue does not know
     falls back to the generic plugin piece: the sidebar and every menu showed
     the Signatures app as "some app" until it was (2026-09-21, a tester). */
  sign: '<path d="M12.5 20.5h8"/><path d="M16.2 3.9a2.05 2.05 0 0 1 2.9 2.9L8 17.9l-3.9 1 1-3.9z"/><path d="M14.6 5.5l2.9 2.9"/>',
  check: '<path d="M4.8 12.6l4.7 4.7L19.2 6.9"/>',
  alert: '<path d="M10.7 4.6L2.9 18.2a1.5 1.5 0 0 0 1.3 2.25h15.6a1.5 1.5 0 0 0 1.3-2.25L13.3 4.6a1.5 1.5 0 0 0-2.6 0z"/><path d="M12 9.9v4.3"/><circle cx="12" cy="17.4" r="0.9" fill="currentColor" stroke="none"/>',
  progress: '<path d="M20.5 12a8.5 8.5 0 1 1-8.5-8.5"/>'
}, p3 = /* @__PURE__ */ new Set(["restore", "goto", "sign-out", "copy-path", "nav", "inspector"]), p_ = /* @__PURE__ */ new Map();
function Pt(e) {
  if (!e) return "";
  const t = p_.get(e);
  if (t !== void 0) return t;
  const n = j2[e], a = n ? `<svg class="${p3.has(e) ? "fe-aicon fe-aicon--dir" : "fe-aicon"}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${n}</svg>` : "";
  return p_.set(e, a), a;
}
function Mfe() {
  return Object.keys(j2);
}
const h3 = "__fe-ctx-late";
function Sv(e) {
  const t = [];
  for (const n of e)
    n.hidden || n.divider && (t.length === 0 || t[t.length - 1].divider) || t.push(n);
  for (; t.length > 0 && t[t.length - 1].divider; ) t.pop();
  return t;
}
function m3(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const c of Sv(t))
    !c.divider && !n.has(c.key) && n.set(c.key, c);
  const a = /* @__PURE__ */ new Set(), i = e.map((c) => c.divider ? c : (a.add(c.key), n.get(c.key) ?? { ...c, disabled: !0 })), r = [...n.values()].filter((c) => !a.has(c.key));
  if (!r.length) return i;
  const l = { key: h3, label: "", divider: !0 };
  return [...i, l, ...r];
}
const Hy = 80;
function Ec(e, t = Hy) {
  var i;
  if (typeof window > "u" || typeof document > "u") return t;
  const n = Array.isArray(e) ? e : [e];
  let a = t;
  for (const r of n) {
    let l = r ?? null;
    for (let c = 0; l && c < 200 && !(l === document.body || l === document.documentElement); c++) {
      let p = Number.NaN, m = !1;
      try {
        const v = window.getComputedStyle(l);
        m = (v.position || "static") !== "static", p = Number.parseInt(v.zIndex, 10);
      } catch {
      }
      m && Number.isFinite(p) && p + 1 > a && (a = p + 1), l = l.parentElement ?? /* Out the top of a shadow tree, if the host put us in one. */
      ((i = l.getRootNode()) == null ? void 0 : i.host) ?? null;
    }
  }
  return a;
}
function v3(e, t) {
  if (typeof document > "u") return [];
  const n = [document.activeElement];
  if (typeof e == "number" && typeof t == "number" && document.elementFromPoint)
    try {
      n.push(document.elementFromPoint(e, t));
    } catch {
    }
  return n;
}
const y3 = ["dir", "data-prefers-dark"], g3 = ["aria-label"], b3 = ["aria-label", "onKeydown"], k3 = { class: "fe-sheet__items" }, w3 = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, _3 = ["disabled", "title", "data-testid", "onClick"], x3 = ["innerHTML"], S3 = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, $3 = { class: "fe-ctx__label" }, T3 = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, A3 = ["aria-label"], E3 = {
  key: 0,
  class: "fe-ctx__sep",
  role: "separator"
}, C3 = ["disabled", "title", "data-testid", "onClick"], z3 = ["innerHTML"], M3 = {
  key: 1,
  class: "fe-ctx__icon",
  "aria-hidden": "true"
}, O3 = { class: "fe-ctx__label" }, P3 = {
  key: 2,
  class: "fe-ctx__key",
  "aria-hidden": "true"
}, ml = /* @__PURE__ */ rt({
  __name: "ContextMenu",
  props: {
    locale: {},
    actions: {},
    theme: {},
    sheet: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r, dir: l } = ht(() => a.locale);
    function c(V) {
      return I2(V.shortcutId ?? V.key);
    }
    function p(V) {
      return Pt(V.icon || V.key);
    }
    const m = S(!1), v = S(0), x = S(0), k = S(Hy), _ = S([]), w = S(null);
    let b = 0, C = 0, A = null;
    async function T(V, G) {
      var q, B;
      if (A = document.activeElement ?? null, k.value = Ec(v3(V.clientX, V.clientY)), fe.value = null, ve.value = null, m.value = !0, v.value = V.clientX, x.value = V.clientY, b = V.clientX, C = V.clientY, _.value = G, await Jt(), m.value && (fe.value = Sv(a.actions)), a.sheet) {
        const K = (q = H.value) == null ? void 0 : q.getBoundingClientRect().height;
        K && (ve.value = K), (B = H.value) == null || B.focus();
        return;
      }
      R(), U(0);
    }
    function R() {
      const V = w.value;
      if (!V || typeof window > "u") return;
      V.style.maxHeight = "", V.style.overflowY = "";
      const G = V.getBoundingClientRect(), q = 8, B = window.innerWidth, K = window.innerHeight, ke = K - 2 * q;
      if (G.height > ke) {
        V.style.maxHeight = ke + "px", V.style.overflowY = "auto", x.value = q, v.value = Fw(b, G.width, B, l.value, q);
        return;
      }
      if (C + G.height > K - q) {
        const Ye = C - G.height;
        x.value = Ye >= q ? Ye : Math.max(q, K - G.height - q);
      }
      v.value = Fw(b, G.width, B, l.value, q);
    }
    function M() {
      var V;
      m.value = !1, fe.value = null, ve.value = null, $.value = !1, F.value = 0, (V = A == null ? void 0 : A.focus) == null || V.call(A), A = null;
    }
    function L() {
      const V = a.sheet ? H.value : w.value;
      return V ? Array.from(
        V.querySelectorAll(".fe-ctx__item:not(:disabled)")
      ) : [];
    }
    function U(V) {
      var B;
      const G = L();
      if (G.length === 0) return;
      const q = (V % G.length + G.length) % G.length;
      (B = G[q]) == null || B.focus();
    }
    function P(V) {
      const G = L();
      if (G.length === 0) return;
      const q = document.activeElement, B = q ? G.indexOf(q) : -1;
      if (B === -1) {
        U(V > 0 ? 0 : G.length - 1);
        return;
      }
      U(B + V);
    }
    const H = S(null), $ = S(!1), F = S(0);
    let I = 0;
    function Z(V) {
      const G = V.touches[0];
      G && ($.value = !0, I = G.clientY, F.value = 0);
    }
    function J(V) {
      if (!$.value) return;
      const G = V.touches[0];
      G && (F.value = Math.max(0, G.clientY - I));
    }
    function re() {
      if (!$.value) return;
      const V = F.value > 72;
      $.value = !1, V ? M() : F.value = 0;
    }
    const ve = S(null), W = E(() => {
      const V = {};
      return ve.value !== null && (V.height = `${ve.value}px`), F.value > 0 && (V.transform = `translateY(${F.value}px)`, V.transition = "none"), Object.keys(V).length ? V : void 0;
    });
    function z(V) {
      V.disabled || (i("select", V, _.value), M());
    }
    function le(V) {
      if (V.key === "Escape") {
        V.stopPropagation(), M();
        return;
      }
      if (V.key === "Enter" || V.key === " ") {
        V.stopPropagation();
        return;
      }
      V.key === "ArrowDown" ? (V.preventDefault(), V.stopPropagation(), P(1)) : V.key === "ArrowUp" ? (V.preventDefault(), V.stopPropagation(), P(-1)) : V.key === "Home" ? (V.preventDefault(), U(0)) : V.key === "End" ? (V.preventDefault(), U(-1)) : V.key === "Tab" && (V.preventDefault(), M());
    }
    const fe = S(null), j = E(
      () => fe.value ? m3(fe.value, a.actions) : Sv(a.actions)
    );
    Xe(
      () => j.value.length,
      async () => {
        if (!m.value || !fe.value || a.sheet) return;
        await Jt();
        const V = w.value;
        if (!V || typeof window > "u") return;
        const G = V.getBoundingClientRect(), q = window.innerHeight - 8 - G.top;
        q > 0 && G.height > q && (V.style.maxHeight = q + "px", V.style.overflowY = "auto");
      }
    );
    const X = Ml(), te = E(() => `fe-ctx-backdrop--theme-${a.theme || "auto"}`);
    return t({ show: T, hide: M }), (V, G) => (f(), We(wi, { to: "body" }, [
      Je(zr, {
        name: e.sheet ? "fe-sheet" : "fe-ctx"
      }, {
        default: mt(() => [
          m.value ? (f(), h("div", {
            key: 0,
            class: Ne(["fe-ctx-backdrop", [te.value, { "fe-ctx-backdrop--sheet": e.sheet }]]),
            dir: u(l),
            style: Xt({
              zIndex: k.value
              /* katman:z1 */
            }),
            "data-prefers-dark": u(X) ? "1" : "0",
            onClick: M,
            onContextmenu: vt(M, ["prevent"]),
            onKeydown: le
          }, [
            e.sheet ? (f(), h("div", {
              key: 0,
              ref_key: "sheetEl",
              ref: H,
              class: "fe-sheet",
              role: "menu",
              "aria-label": u(r)("sheet.menu"),
              tabindex: "-1",
              style: Xt(W.value),
              onClick: G[0] || (G[0] = vt(() => {
              }, ["stop"]))
            }, [
              d("div", {
                class: "fe-sheet__handle",
                role: "button",
                tabindex: "0",
                "aria-label": u(r)("sheet.close"),
                onClick: M,
                onKeydown: za(vt(M, ["prevent"]), ["enter"]),
                onTouchstartPassive: Z,
                onTouchmovePassive: J,
                onTouchend: re,
                onTouchcancel: re
              }, null, 40, b3),
              d("div", k3, [
                (f(!0), h(Ce, null, nt(j.value, (q, B) => (f(), h(Ce, {
                  key: q.key || B
                }, [
                  q.divider ? (f(), h("div", w3)) : (f(), h("button", {
                    key: 1,
                    type: "button",
                    class: Ne(["fe-ctx__item fe-sheet__item", { "is-danger": q.danger, "is-disabled": q.disabled }]),
                    disabled: q.disabled,
                    title: q.title,
                    "data-testid": q.testid,
                    role: "menuitem",
                    onClick: (K) => z(q)
                  }, [
                    p(q) ? (f(), h("span", {
                      key: 0,
                      class: "fe-ctx__icon",
                      "aria-hidden": "true",
                      innerHTML: p(q)
                    }, null, 8, x3)) : q.icon ? (f(), h("span", S3, y(q.icon), 1)) : D("", !0),
                    d("span", $3, y(q.label), 1),
                    c(q) ? (f(), h("span", T3, y(c(q)), 1)) : D("", !0)
                  ], 10, _3))
                ], 64))), 128))
              ])
            ], 12, g3)) : (f(), h("div", {
              key: 1,
              ref_key: "menuEl",
              ref: w,
              class: "fe-ctx",
              role: "menu",
              "aria-orientation": "vertical",
              "aria-label": u(r)("sheet.menu"),
              style: Xt({ top: x.value + "px", left: v.value + "px" }),
              onClick: G[1] || (G[1] = vt(() => {
              }, ["stop"]))
            }, [
              (f(!0), h(Ce, null, nt(j.value, (q, B) => (f(), h(Ce, {
                key: q.key || B
              }, [
                q.divider ? (f(), h("div", E3)) : (f(), h("button", {
                  key: 1,
                  type: "button",
                  class: Ne(["fe-ctx__item", { "is-danger": q.danger, "is-disabled": q.disabled }]),
                  disabled: q.disabled,
                  title: q.title,
                  "data-testid": q.testid,
                  role: "menuitem",
                  onClick: (K) => z(q)
                }, [
                  p(q) ? (f(), h("span", {
                    key: 0,
                    class: "fe-ctx__icon",
                    "aria-hidden": "true",
                    innerHTML: p(q)
                  }, null, 8, z3)) : q.icon ? (f(), h("span", M3, y(q.icon), 1)) : D("", !0),
                  d("span", O3, y(q.label), 1),
                  c(q) ? (f(), h("span", P3, y(c(q)), 1)) : D("", !0)
                ], 10, C3))
              ], 64))), 128))
            ], 12, A3))
          ], 46, y3)) : D("", !0)
        ]),
        _: 1
      }, 8, ["name"])
    ]));
  }
}), D3 = ["aria-pressed", "title", "aria-label"], L3 = {
  key: 1,
  class: "fe-toolbar__mark"
}, R3 = ["src"], N3 = { key: 1 }, I3 = { class: "fe-toolbar__primary" }, B3 = ["title"], F3 = ["innerHTML"], U3 = { class: "fe-btn__label" }, H3 = ["title", "aria-label"], K3 = ["innerHTML"], V3 = ["title"], j3 = ["innerHTML"], q3 = { class: "fe-btn__label" }, W3 = { class: "fe-toolbar__search-group fe-toolbar__search-group--drive" }, Y3 = {
  class: "fe-search fe-drivesearch",
  "data-testid": "drive-search"
}, G3 = ["placeholder", "value", "aria-label"], X3 = ["title", "aria-label"], J3 = ["innerHTML"], Z3 = ["title", "aria-label"], Q3 = { class: "fe-toolbar__tail" }, eD = ["title", "aria-label"], tD = ["innerHTML"], nD = ["title", "aria-label", "aria-pressed"], aD = ["innerHTML"], iD = ["title", "aria-label"], oD = ["innerHTML"], rD = {
  class: "fe-drivesearch",
  "data-testid": "drive-search"
}, sD = ["placeholder", "value", "aria-label"], lD = ["title", "aria-label"], uD = ["innerHTML"], cD = ["title", "aria-label"], dD = { class: "fe-toolbar__tail" }, fD = ["title", "aria-label", "aria-pressed"], pD = ["innerHTML"], hD = ["title", "aria-label"], mD = ["innerHTML"], vD = ["aria-label"], yD = {
  class: "fe-selbar__count",
  role: "status",
  "data-testid": "selection-count"
}, gD = ["disabled", "title", "aria-label", "data-key", "data-testid", "onClick"], bD = ["innerHTML"], kD = ["title", "aria-label"], wD = ["innerHTML"], _D = ["data-key"], xD = ["innerHTML"], SD = ["title", "aria-label"], $D = ["innerHTML"], Zd = "filex.density", TD = 32, h_ = "fe:header-menu", AD = /* @__PURE__ */ rt({
  __name: "Toolbar",
  props: {
    viewMode: {},
    searchQuery: {},
    trashActive: { type: Boolean },
    actions: {},
    selectionMode: {},
    selectionCount: {},
    selectionPane: {},
    pasteEnabled: { type: Boolean },
    canGoUp: { type: Boolean },
    atVirtualRoot: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    narrow: { type: Boolean },
    theme: {},
    inspectorOpen: { type: Boolean },
    assistantButton: { type: Boolean },
    assistantOpen: { type: Boolean },
    navOpen: { type: Boolean },
    navEnabled: { type: Boolean },
    viewModes: {},
    scopeLabel: {},
    brandName: {},
    brandMarkUrl: {},
    searchEscalates: { type: Boolean }
  },
  emits: ["update:viewMode", "update:searchQuery", "open-advanced-search", "new-folder", "upload", "refresh", "go-up", "action", "open-recents", "update:density", "toggle-inspector", "toggle-assistant", "toggle-nav", "open-theme", "open-shortcut-settings", "open-timezone", "open-palette"],
  setup(e, { expose: t, emit: n }) {
    function a(ae) {
      return Pt(ae.icon || ae.key);
    }
    const i = e, r = n, l = S(
      (() => {
        try {
          return localStorage.getItem(Zd) === "compact" ? "compact" : "comfortable";
        } catch {
          return "comfortable";
        }
      })()
    );
    function c() {
      try {
        const ae = localStorage.getItem(Zd) === "compact" ? "compact" : "comfortable";
        ae !== l.value && (l.value = ae, r("update:density", ae));
      } catch {
      }
    }
    function p(ae) {
      (ae.key === null || ae.key === Zd) && c();
    }
    qt(() => {
      r("update:density", l.value), window.addEventListener("storage", p), window.addEventListener("filex:density", c);
    }), Ct(() => {
      window.removeEventListener("storage", p), window.removeEventListener("filex:density", c);
    });
    function m() {
      l.value = l.value === "compact" ? "comfortable" : "compact";
      try {
        localStorage.setItem(Zd, l.value);
      } catch {
      }
      r("update:density", l.value);
    }
    const { t: v, dir: x } = ht(() => i.locale), k = S(null), _ = S(i.searchQuery);
    Xe(() => i.searchQuery, (ae) => {
      _.value = ae;
    });
    let w;
    function b(ae) {
      const xe = ae.target.value;
      _.value = xe, w && clearTimeout(w), w = setTimeout(() => r("update:searchQuery", xe), 200);
    }
    async function C() {
      var ae, xe;
      await Jt(), (ae = k.value) == null || ae.focus(), (xe = k.value) == null || xe.select();
    }
    t({ focusSearch: C });
    const A = E(() => i.selectionMode ?? "none"), T = E(() => i.actions.filter((ae) => !ae.divider && !ae.hidden)), R = /* @__PURE__ */ new Set(["download", "access", "cut", "copy", "star", "restore", "delete"]), M = E(() => A.value !== "none"), L = E(() => {
      const ae = [], xe = [];
      let Fe = 0;
      for (const ye of i.actions)
        if (!ye.hidden) {
          if (ye.divider) {
            xe.push(ye);
            continue;
          }
          R.has(ye.key) && a(ye) ? ae.push(ye) : (xe.push(ye), Fe++);
        }
      return { icons: ae, rest: Fe ? xe : [], restCount: Fe };
    }), U = S(null), P = S(null), H = S(null), $ = S(null), F = S(Number.MAX_SAFE_INTEGER), I = E(() => L.value.icons.slice(0, F.value)), Z = E(() => L.value.icons.slice(F.value)), J = E(() => {
      const ae = Z.value, xe = L.value.rest;
      return ae.length && xe.length ? [...ae, { divider: !0, key: "selbar-sep", label: "" }, ...xe] : [...ae, ...xe];
    });
    function re() {
      var pn;
      const ae = U.value, xe = P.value, Fe = L.value.icons.length;
      if (!ae || !xe) {
        F.value = Fe;
        return;
      }
      const ye = parseFloat(getComputedStyle(ae).gap) || 4, Te = Array.from(xe.children).map((Rt) => Rt.offsetWidth + ye), Ue = Te.reduce((Rt, rn) => Rt + rn, 0), xt = ae.clientWidth, Qt = (((pn = H.value) == null ? void 0 : pn.offsetWidth) || TD) + ye;
      if (Ue <= xt - (L.value.rest.length ? Qt : 0)) {
        F.value = Te.length;
        return;
      }
      let vn = Qt, Ut = 0;
      for (const Rt of Te) {
        if (vn + Rt > xt) break;
        vn += Rt, Ut += 1;
      }
      F.value = Ut;
    }
    let ve;
    Xe(U, (ae) => {
      ve == null || ve.disconnect(), ve = void 0, ae && typeof ResizeObserver < "u" && (ve = new ResizeObserver(() => re()), ve.observe(ae)), Jt(re);
    }), Ct(() => ve == null ? void 0 : ve.disconnect()), Xe(
      () => [T.value, i.narrow, i.trashActive, A.value],
      () => void Jt(re),
      { deep: !1 }
    );
    function W() {
      var xe, Fe;
      const ae = (xe = H.value) == null ? void 0 : xe.getBoundingClientRect();
      (Fe = $.value) == null || Fe.show({ clientX: ae ? Bw(ae, x.value) : 0, clientY: ae ? ae.bottom + 4 : 0 }, []);
    }
    const z = S(null), le = Ea(null), fe = S(!1), j = Ea(null), X = Ea(null);
    function te() {
      var Fe;
      const ae = (Fe = z.value) == null ? void 0 : Fe.closest(".fe");
      if (!ae) return null;
      const xe = i.selectionPane;
      if (xe && /^[A-Za-z][\w-]*$/.test(xe)) {
        const ye = ae.querySelector(`.fe__primary[data-pane="${xe}"]`);
        if (ye) return ye;
      }
      return ae.querySelector(".fe__primary");
    }
    function V() {
      const ae = le.value;
      ae && (ae.classList.remove("is-active"), fe.value && ae.remove()), le.value = null, fe.value = !1;
    }
    function G() {
      var Fe;
      const ae = te();
      if (!ae) {
        V(), X.value = null, j.value = null;
        return;
      }
      if (X.value === ae && ((Fe = le.value) != null && Fe.isConnected)) return;
      V(), X.value = ae, j.value = ae.querySelector(":scope > .fe__body");
      const xe = ae.querySelector(":scope > .fe-selbar-slot");
      if (xe)
        le.value = xe, fe.value = !1;
      else {
        const ye = document.createElement("div");
        ye.className = "fe-selbar-slot";
        const Te = ae.querySelector(":scope > .fe-tabs") ?? ae.querySelector(":scope > .fe-subhead, :scope > .fe-subhead--plain");
        Te ? Te.insertAdjacentElement("afterend", ye) : ae.prepend(ye), le.value = ye, fe.value = !0;
      }
      q(), Be();
    }
    qt(G), Ct(V);
    function q() {
      var ae;
      (ae = le.value) == null || ae.classList.toggle("is-active", M.value);
    }
    Xe(M, q, { immediate: !0 }), Xe([() => i.selectionPane, M], () => G());
    const B = S(0);
    let K, ke = !1;
    function Ye() {
      const ae = X.value;
      ae && (B.value = ae.querySelectorAll('[data-fe-path][aria-selected="true"]').length);
    }
    function Oe() {
      if (ke) return;
      ke = !0, ((xe) => typeof requestAnimationFrame == "function" ? requestAnimationFrame(xe) : setTimeout(xe, 16))(() => {
        ke = !1, Ye();
      });
    }
    function Be() {
      if (K == null || K.disconnect(), K = void 0, !M.value) {
        B.value = 0;
        return;
      }
      Ye(), !(typeof MutationObserver > "u" || !X.value) && (K = new MutationObserver(Oe), K.observe(X.value, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: ["aria-selected"]
      }));
    }
    Xe(M, Be), Ct(() => K == null ? void 0 : K.disconnect());
    const qe = E(() => typeof i.selectionCount == "number" ? i.selectionCount : A.value === "none" ? 0 : Math.max(B.value, A.value === "multi" ? 2 : 1)), Tt = E(() => v("selection.count", { n: String(qe.value) }));
    function $t() {
      var ae;
      r("action", "clear-selection"), (ae = j.value) == null || ae.dispatchEvent(new MouseEvent("click", { bubbles: !0 }));
    }
    function it(ae) {
      r("action", ae);
    }
    const yt = S(!1);
    let ft;
    function ze(ae) {
      yt.value = !!(ae && "matches" in ae && ae.matches);
    }
    qt(() => {
      var ae;
      typeof window > "u" || !window.matchMedia || (ft = window.matchMedia("(pointer: coarse)"), ze(ft), (ae = ft.addEventListener) == null || ae.call(ft, "change", ze));
    }), Ct(() => {
      var ae;
      (ae = ft == null ? void 0 : ft.removeEventListener) == null || ae.call(ft, "change", ze);
    });
    const oe = S(null), Se = S(null);
    function he(ae) {
      return !i.viewModes || i.viewModes.includes(ae);
    }
    const Ke = E(() => {
      const ae = [];
      return i.narrow && ae.push({ key: "refresh", label: v("toolbar.refresh") }), ae.push({
        key: "density",
        label: l.value === "compact" ? v("toolbar.density.comfortable") : v("toolbar.density.compact")
      }), i.viewMode !== "list" && he("list") && ae.push({ key: "view-list", label: v("toolbar.view.list") }), i.viewMode !== "grid" && he("grid") && ae.push({ key: "view-grid", label: v("toolbar.view.grid") }), i.viewMode !== "gallery" && he("gallery") && ae.push({ key: "view-gallery", label: v("toolbar.view.gallery") }), ae.push({ key: "inspector", label: v("toolbar.inspector") }), ae.push({ key: "theme", label: v("theme.menu") }), ae.push({ key: "timezone", label: v("tz.menu") }), ae.push({ key: "shortcut-settings", label: v("shortcuts.settings.menu") }), ae.push({ key: "tour", label: v("tour.restart") }), ae;
    });
    function Le(ae) {
      const xe = [], Fe = !i.trashActive && !i.atVirtualRoot && i.canWrite !== !1;
      return A.value === "none" && Fe && (xe.push({ key: "new-folder", label: v("toolbar.new_folder") }), i.pasteEnabled && xe.push({ key: "paste", label: v("ctx.paste") })), M.value || xe.push(...T.value), ae.length && (xe.length && xe.push({ divider: !0, key: "bag-sep", label: "" }), xe.push(...ae)), xe;
    }
    const ut = E(() => Ly("palette"));
    function wt(ae, xe) {
      const Fe = I2(xe);
      return Fe ? `${ae} (${Fe})` : ae;
    }
    const _t = E(() => i.narrow ? i.navOpen ? v("sidenav.close") : v("sidenav.open") : i.navOpen ? v("sidenav.collapse") : v("sidenav.expand")), At = E(
      () => i.scopeLabel ? v("drive.search.placeholder", { scope: i.scopeLabel }) : v("drive.search.placeholder_all")
    );
    function _e(ae) {
      if (B2(ae, "palette")) {
        ae.preventDefault(), ae.stopPropagation(), r("open-palette", _.value);
        return;
      }
      i.searchEscalates && ae.key === "Enter" && _.value && (ae.preventDefault(), ae.stopPropagation(), r("open-palette", _.value));
    }
    const Ie = S(!1);
    function pe() {
      const ae = z.value;
      if (!ae) return;
      const xe = {
        items: Ke.value.map((Fe) => ({ ...Fe })),
        run: (Fe) => ge({ key: Fe }),
        claimed: !1
      };
      ae.dispatchEvent(
        new CustomEvent(h_, { detail: xe, bubbles: !0, composed: !0 })
      ), Ie.value = !!xe.claimed;
    }
    qt(() => void Jt(pe)), Xe(Ke, () => void Jt(pe), { deep: !1 }), Ct(() => {
      typeof document > "u" || document.dispatchEvent(
        new CustomEvent(h_, {
          detail: { items: [], run: () => {
          }, claimed: !1 }
        })
      );
    });
    const we = E(() => {
      const ae = Ie.value ? [] : Ke.value;
      return i.narrow ? Le(ae) : ae;
    });
    function ee() {
      var xe, Fe;
      const ae = (xe = oe.value) == null ? void 0 : xe.getBoundingClientRect();
      (Fe = Se.value) == null || Fe.show({ clientX: ae ? Bw(ae, x.value) : 0, clientY: ae ? ae.bottom + 4 : 0 }, []);
    }
    function ge(ae) {
      var xe;
      switch (ae.key) {
        case "new-folder":
          r("new-folder");
          break;
        case "refresh":
          r("refresh");
          break;
        case "density":
          m();
          break;
        case "view-list":
          r("update:viewMode", "list");
          break;
        case "view-grid":
          r("update:viewMode", "grid");
          break;
        case "view-gallery":
          r("update:viewMode", "gallery");
          break;
        case "inspector":
          r("toggle-inspector");
          break;
        case "nav":
          r("toggle-nav");
          break;
        case "theme":
          r("open-theme");
          break;
        case "shortcut-settings":
          r("open-shortcut-settings");
          break;
        case "timezone":
          r("open-timezone");
          break;
        case "tour":
          (xe = z.value) == null || xe.dispatchEvent(new CustomEvent("fe:tour-restart", { bubbles: !0 }));
          break;
        default:
          it(ae.key);
      }
    }
    return (ae, xe) => (f(), h("div", {
      ref_key: "rootEl",
      ref: z,
      class: Ne(["fe-toolbar", {
        "fe-toolbar--narrow": e.narrow,
        /* surucu:d1 — ALWAYS on. It is no longer a variant: this is the only
           header filex has, and the modifier survives as the hook the one
           visual definition in styles/base.css was written against. Dropping it
           would mean moving those rules, not deleting a state. */
        "fe-toolbar--drive": !0
      }])
    }, [
      e.navEnabled !== !1 || ae.$slots.brand || e.brandName || e.brandMarkUrl ? (f(), h("div", {
        key: 0,
        class: Ne(["fe-toolbar__brand", {
          "fe-toolbar__brand--gutter": e.navEnabled !== !1,
          /* gezinti:g3 — the panel collapsed to its rail, so this gutter has to
             collapse with it. `navOpen === false`, never `!navOpen`: the prop is
             optional, and an embedder that does not pass it must keep the
             expanded layout rather than lose its wordmark to a `undefined`. */
          "fe-toolbar__brand--rail": !e.narrow && e.navEnabled !== !1 && e.navOpen === !1
        }])
      }, [
        e.navEnabled !== !1 ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--icon-only fe-toolbar__nav",
          "aria-pressed": !!e.navOpen,
          title: _t.value,
          "aria-label": _t.value,
          "data-testid": "toolbar-nav",
          onClick: xe[0] || (xe[0] = (Fe) => r("toggle-nav"))
        }, [...xe[12] || (xe[12] = [
          d("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("path", { d: "M4 7h16M4 12h16M4 17h16" })
          ], -1)
        ])], 8, D3)) : D("", !0),
        !e.narrow && e.navOpen !== !1 ? (f(), h("div", L3, [
          Ln(ae.$slots, "brand", {}, () => [
            e.brandMarkUrl ? (f(), h("img", {
              key: 0,
              class: "fe-toolbar__markimg",
              src: e.brandMarkUrl,
              alt: ""
            }, null, 8, R3)) : D("", !0),
            e.brandName ? (f(), h("span", N3, y(e.brandName), 1)) : D("", !0)
          ])
        ])) : D("", !0)
      ], 2)) : D("", !0),
      e.narrow ? (f(), h(Ce, { key: 2 }, [
        d("div", rD, [
          xe[14] || (xe[14] = d("svg", {
            class: "fe-ficon fe-drivesearch__glass",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.9",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("circle", {
              cx: "11",
              cy: "11",
              r: "6.5"
            }),
            d("path", { d: "M16 16l4.5 4.5" })
          ], -1)),
          d("input", {
            ref_key: "searchEl",
            ref: k,
            type: "search",
            class: "fe-drivesearch__input",
            placeholder: At.value,
            value: _.value,
            "aria-label": u(v)("toolbar.search"),
            onInput: b,
            onKeydown: _e
          }, null, 40, sD),
          d("button", {
            type: "button",
            class: "fe-drivesearch__tune",
            title: u(v)("advsearch.open"),
            "aria-label": u(v)("advsearch.open"),
            "data-testid": "drive-search-advanced",
            onClick: xe[8] || (xe[8] = (Fe) => r("open-advanced-search", _.value))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("filter")
            }, null, 8, uD)
          ], 8, lD),
          d("button", {
            type: "button",
            class: "fe-drivesearch__kbd",
            title: u(v)("drive.search.hint_title", { combo: ut.value }),
            "aria-label": u(v)("drive.search.hint_title", { combo: ut.value }),
            "data-testid": "drive-search-palette",
            onClick: xe[9] || (xe[9] = (Fe) => r("open-palette", _.value))
          }, y(ut.value), 9, cD)
        ]),
        d("div", dD, [
          e.assistantButton ? (f(), h("button", {
            key: 0,
            type: "button",
            class: Ne(["fe-btn fe-btn--icon-only", { "is-active": e.assistantOpen }]),
            title: u(v)("ai.assistant"),
            "aria-label": u(v)("ai.assistant"),
            "aria-pressed": e.assistantOpen ? "true" : "false",
            "data-testid": "header-ai",
            onClick: xe[10] || (xe[10] = (Fe) => r("toggle-assistant"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("ai")
            }, null, 8, pD)
          ], 10, fD)) : D("", !0),
          we.value.length > 0 ? (f(), h("button", {
            key: 1,
            ref_key: "moreBtnEl",
            ref: oe,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: u(v)("toolbar.more"),
            "aria-label": u(v)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: ee
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("more")
            }, null, 8, mD)
          ], 8, hD)) : D("", !0),
          Ln(ae.$slots, "header-actions")
        ])
      ], 64)) : (f(), h(Ce, { key: 1 }, [
        d("div", I3, [
          e.navEnabled === !1 && A.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (f(), h("button", {
            key: 0,
            type: "button",
            class: "fe-btn fe-btn--primary",
            title: wt(u(v)("toolbar.new_folder"), "new-folder"),
            onClick: xe[1] || (xe[1] = (Fe) => r("new-folder"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("new-folder")
            }, null, 8, F3),
            d("span", U3, y(u(v)("toolbar.new_folder")), 1)
          ], 8, B3)) : D("", !0),
          e.navEnabled === !1 && !e.atVirtualRoot && e.canWrite !== !1 ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: wt(u(v)("toolbar.upload"), "upload"),
            "aria-label": u(v)("toolbar.upload"),
            onClick: xe[2] || (xe[2] = (Fe) => r("upload"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("upload")
            }, null, 8, K3)
          ], 8, H3)) : D("", !0),
          e.pasteEnabled && A.value === "none" && !e.trashActive && !e.atVirtualRoot && e.canWrite !== !1 ? (f(), h("button", {
            key: 2,
            type: "button",
            class: "fe-btn",
            title: wt(u(v)("ctx.paste"), "paste"),
            onClick: xe[3] || (xe[3] = (Fe) => it("paste"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("paste")
            }, null, 8, j3),
            d("span", q3, y(u(v)("ctx.paste")), 1)
          ], 8, V3)) : D("", !0)
        ]),
        d("div", W3, [
          d("div", Y3, [
            xe[13] || (xe[13] = d("svg", {
              class: "fe-ficon fe-drivesearch__glass",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.9",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("circle", {
                cx: "11",
                cy: "11",
                r: "6.5"
              }),
              d("path", { d: "M16 16l4.5 4.5" })
            ], -1)),
            d("input", {
              ref_key: "searchEl",
              ref: k,
              type: "search",
              class: "fe-search__input fe-drivesearch__input",
              placeholder: At.value,
              value: _.value,
              "aria-label": u(v)("toolbar.search"),
              onInput: b,
              onKeydown: _e
            }, null, 40, G3),
            d("button", {
              type: "button",
              class: "fe-drivesearch__tune",
              title: u(v)("advsearch.open"),
              "aria-label": u(v)("advsearch.open"),
              "data-testid": "drive-search-advanced",
              onClick: xe[4] || (xe[4] = (Fe) => r("open-advanced-search", _.value))
            }, [
              d("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(Pt)("filter")
              }, null, 8, J3)
            ], 8, X3),
            d("button", {
              type: "button",
              class: "fe-drivesearch__kbd",
              title: u(v)("drive.search.hint_title", { combo: ut.value }),
              "aria-label": u(v)("drive.search.hint_title", { combo: ut.value }),
              "data-testid": "drive-search-palette",
              onClick: xe[5] || (xe[5] = (Fe) => r("open-palette", _.value))
            }, y(ut.value), 9, Z3)
          ])
        ]),
        d("div", Q3, [
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: wt(u(v)("toolbar.refresh"), "refresh"),
            "aria-label": u(v)("toolbar.refresh"),
            onClick: xe[6] || (xe[6] = (Fe) => r("refresh"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("refresh")
            }, null, 8, tD)
          ], 8, eD),
          e.assistantButton ? (f(), h("button", {
            key: 0,
            type: "button",
            class: Ne(["fe-btn fe-btn--icon-only", { "is-active": e.assistantOpen }]),
            title: u(v)("ai.assistant"),
            "aria-label": u(v)("ai.assistant"),
            "aria-pressed": e.assistantOpen ? "true" : "false",
            "data-testid": "header-ai",
            onClick: xe[7] || (xe[7] = (Fe) => r("toggle-assistant"))
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("ai")
            }, null, 8, aD)
          ], 10, nD)) : D("", !0),
          we.value.length > 0 ? (f(), h("button", {
            key: 1,
            ref_key: "moreBtnEl",
            ref: oe,
            type: "button",
            class: "fe-btn fe-btn--icon-only",
            title: u(v)("toolbar.more"),
            "aria-label": u(v)("toolbar.more"),
            "aria-haspopup": "menu",
            "data-testid": "drive-more",
            onClick: ee
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("more")
            }, null, 8, oD)
          ], 8, iD)) : D("", !0),
          Ln(ae.$slots, "header-actions")
        ])
      ], 64)),
      Je(ml, {
        ref_key: "moreRef",
        ref: Se,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: yt.value,
        actions: we.value,
        onSelect: ge
      }, null, 8, ["locale", "theme", "sheet", "actions"]),
      (f(), We(wi, {
        to: le.value || "body",
        disabled: !le.value
      }, [
        M.value ? (f(), h("div", {
          key: 0,
          class: Ne(["fe-selbar", { "fe-selbar--inline": !le.value }]),
          role: "toolbar",
          "aria-label": Tt.value,
          "data-testid": "selection-bar"
        }, [
          d("span", yD, y(Tt.value), 1),
          d("div", {
            ref_key: "selBarEl",
            ref: U,
            class: "fe-selbar__actions"
          }, [
            (f(!0), h(Ce, null, nt(I.value, (Fe) => (f(), h("button", {
              key: Fe.key,
              type: "button",
              class: Ne(["fe-selbar__btn", { "fe-selbar__btn--danger": Fe.danger, "is-disabled": Fe.disabled }]),
              disabled: Fe.disabled,
              title: Fe.title || wt(Fe.label, Fe.key),
              "aria-label": Fe.label,
              "data-key": Fe.key,
              "data-testid": `selbar-${Fe.key}`,
              onClick: (ye) => it(Fe.key)
            }, [
              d("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: a(Fe)
              }, null, 8, bD)
            ], 10, gD))), 128)),
            J.value.length > 0 ? (f(), h("button", {
              key: 0,
              ref_key: "selMoreBtnEl",
              ref: H,
              type: "button",
              class: "fe-selbar__btn",
              title: u(v)("toolbar.more"),
              "aria-label": u(v)("toolbar.more"),
              "aria-haspopup": "menu",
              "data-testid": "selbar-more",
              onClick: W
            }, [
              d("span", {
                class: "fe-icon",
                "aria-hidden": "true",
                innerHTML: u(Pt)("more")
              }, null, 8, wD)
            ], 8, kD)) : D("", !0),
            d("div", {
              ref_key: "measureEl",
              ref: P,
              class: "fe-selbar__measure",
              "aria-hidden": "true"
            }, [
              (f(!0), h(Ce, null, nt(L.value.icons, (Fe) => (f(), h("button", {
                key: "m-" + Fe.key,
                type: "button",
                class: "fe-selbar__btn",
                "data-key": Fe.key,
                tabindex: "-1"
              }, [
                d("span", {
                  class: "fe-icon",
                  "aria-hidden": "true",
                  innerHTML: a(Fe)
                }, null, 8, xD)
              ], 8, _D))), 128))
            ], 512)
          ], 512),
          d("button", {
            type: "button",
            class: "fe-selbar__close",
            title: u(v)("selection.clear"),
            "aria-label": u(v)("selection.clear"),
            "data-testid": "selection-clear",
            onClick: $t
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("close")
            }, null, 8, $D)
          ], 8, SD)
        ], 10, vD)) : D("", !0)
      ], 8, ["to", "disabled"])),
      Je(ml, {
        ref_key: "selMoreRef",
        ref: $,
        locale: e.locale,
        theme: e.theme || "auto",
        sheet: yt.value,
        actions: J.value,
        onSelect: xe[11] || (xe[11] = (Fe) => it(Fe.key))
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 2));
  }
}), ED = 6e4;
function CD(e) {
  return e === "personal" || e === "team";
}
function Ofe(e, t) {
  var n;
  return (n = e.find((a) => a.name === t)) == null ? void 0 : n.key;
}
function $v(e) {
  const t = e ?? {};
  return Array.isArray(t.items) ? t.items.filter(
    (n) => !!n && typeof n.name == "string" && n.name !== "" && CD(n.kind)
  ) : Array.isArray(t.tags) ? t.tags.filter((n) => typeof n == "string" && n !== "").map((n) => ({ name: n, kind: "team" })) : [];
}
const Tv = /* @__PURE__ */ new Map(), gf = /* @__PURE__ */ new Map();
function zD() {
  Tv.clear(), gf.clear();
}
const Av = /* @__PURE__ */ new Set();
function MD(e) {
  return Av.add(e), () => {
    Av.delete(e);
  };
}
function OD() {
  zD();
  for (const e of [...Av])
    try {
      e();
    } catch {
    }
}
async function m_(e = {}) {
  const t = e.apiBase ?? "", n = t || "(same-origin)";
  if (!e.force) {
    const i = Tv.get(n);
    if (i && Date.now() - i.at < ED) return i.tags;
    const r = gf.get(n);
    if (r) return r;
  }
  const a = (async () => {
    try {
      const i = await fetch(`${t}/api/files/manager/tags/all`, {
        headers: await (e.authHeaders ?? (() => ({})))(),
        credentials: e.authCredentials ?? "same-origin"
      });
      if (!i.ok) return [];
      const r = $v(await i.json());
      return Tv.set(n, { at: Date.now(), tags: r }), r;
    } catch {
      return [];
    } finally {
      gf.delete(n);
    }
  })();
  return gf.set(n, a), a;
}
async function PD(e, t = {}, n = {}) {
  const a = t.apiBase ?? "", i = new URLSearchParams({ tag: e, limit: String(n.limit ?? 100), offset: String(n.offset ?? 0) });
  n.kind && i.set("kind", n.kind), n.sort && i.set("sort", n.sort);
  const r = await fetch(`${a}/api/files/manager/tagged?${i}`, {
    headers: await (t.authHeaders ?? (() => ({})))(),
    credentials: t.authCredentials ?? "same-origin"
  });
  if (!r.ok) throw new Error(String(r.status));
  const l = await r.json(), c = Array.isArray(l == null ? void 0 : l.nodes) ? l.nodes : [];
  return {
    rows: c,
    total: typeof (l == null ? void 0 : l.total) == "number" ? l.total : (n.offset ?? 0) + c.length,
    truncated: (l == null ? void 0 : l.truncated) === !0
  };
}
const DD = ["width", "height", "data-tag-kind"], Ev = /* @__PURE__ */ rt({
  __name: "TagKindIcon",
  props: {
    kind: {},
    size: {}
  },
  setup(e) {
    return (t, n) => (f(), h("svg", {
      class: Ne(["fe-tagkind", `fe-tagkind--${e.kind}`]),
      width: e.size ?? 12,
      height: e.size ?? 12,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      focusable: "false",
      "data-tag-kind": e.kind
    }, [
      e.kind === "team" ? (f(), h(Ce, { key: 0 }, [
        n[0] || (n[0] = d("circle", {
          cx: "9",
          cy: "8",
          r: "3.2"
        }, null, -1)),
        n[1] || (n[1] = d("path", { d: "M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" }, null, -1)),
        n[2] || (n[2] = d("circle", {
          cx: "17",
          cy: "9",
          r: "2.6"
        }, null, -1)),
        n[3] || (n[3] = d("path", { d: "M16.5 14.2c2.6.3 4.5 2.6 4.5 5.3" }, null, -1))
      ], 64)) : (f(), h(Ce, { key: 1 }, [
        n[4] || (n[4] = d("circle", {
          cx: "12",
          cy: "8",
          r: "3.6"
        }, null, -1)),
        n[5] || (n[5] = d("path", { d: "M5 20c0-3.9 3.1-7 7-7s7 3.1 7 7" }, null, -1))
      ], 64))
    ], 10, DD));
  }
}), LD = ["role", "aria-labelledby", "aria-label", "data-testid"], RD = { class: "fe-choice__strip" }, ND = ["role", "aria-checked", "aria-pressed", "aria-label", "aria-describedby", "tabindex", "disabled", "data-testid", "onClick", "onKeydown"], ID = {
  key: 1,
  class: "fe-choice__label"
}, BD = {
  key: 2,
  class: "fe-choice__help"
}, FD = ["id", "data-testid"], UD = ["data-testid"], mi = /* @__PURE__ */ rt({
  __name: "ChoiceButtons",
  props: {
    options: {},
    modelValue: {},
    multi: { type: Boolean },
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    segmented: { type: Boolean },
    iconOnly: { type: Boolean },
    ariaLabelledby: {},
    ariaLabel: {},
    testidPrefix: {},
    testid: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => !!n.segmented || !!n.iconOnly), r = `fe-choice-${Math.random().toString(36).slice(2, 10)}`, l = (C) => `${r}-tip-${C}`;
    function c(C) {
      return i.value ? C.help || (n.iconOnly ? C.label : "") : "";
    }
    const p = E(() => {
      var C;
      return !i.value || n.multi ? "" : ((C = n.options.find((A) => v(A.value))) == null ? void 0 : C.help) ?? "";
    }), m = E(() => {
      const C = n.modelValue;
      return Array.isArray(C) ? C.map((A) => String(A)) : C == null || C === "" ? [] : [String(C)];
    });
    function v(C) {
      return m.value.includes(C);
    }
    function x(C) {
      var A;
      return !!n.disabled || !!((A = n.options.find((T) => T.value === C)) != null && A.disabled);
    }
    function k(C) {
      if (!x(C)) {
        if (n.multi) {
          const A = v(C) ? m.value.filter((R) => R !== C) : [...m.value, C], T = n.options.map((R) => R.value);
          a("update:modelValue", T.filter((R) => A.includes(R)));
          return;
        }
        a("update:modelValue", C);
      }
    }
    function _(C) {
      const A = n.options.length;
      for (let T = 0; T < A; T++) {
        const R = C === 1 ? T : A - 1 - T;
        if (!n.options[R].disabled) return R;
      }
      return -1;
    }
    function w(C, A) {
      var U;
      if (n.multi || n.disabled) return;
      const T = n.options.length;
      let R;
      if (C.key === "Home" || C.key === "End") {
        if (C.preventDefault(), R = _(C.key === "Home" ? 1 : -1), R < 0) return;
      } else {
        if (!["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp"].includes(C.key)) return;
        C.preventDefault();
        const H = C.key === "ArrowDown" ? 1 : C.key === "ArrowUp" ? -1 : Rf(C.key, ei(C.currentTarget));
        if (!T || (R = (A + H + T) % T, n.options[R].disabled)) return;
      }
      k(n.options[R].value);
      const M = C.currentTarget.closest(".fe-choice"), L = M == null ? void 0 : M.querySelectorAll("[data-choice]");
      (U = L == null ? void 0 : L[R]) == null || U.focus();
    }
    function b(C, A) {
      return n.multi ? 0 : m.value.length ? v(C) ? 0 : -1 : A === 0 ? 0 : -1;
    }
    return (C, A) => (f(), h("div", {
      class: Ne(["fe-choice", {
        "is-invalid": e.invalid,
        "is-disabled": e.disabled,
        "fe-choice--segmented": i.value,
        "fe-choice--icons": e.iconOnly
      }]),
      role: e.multi ? "group" : "radiogroup",
      "aria-labelledby": e.ariaLabelledby,
      "aria-label": e.ariaLabel,
      "data-testid": e.testid ?? "choice-buttons"
    }, [
      d("div", RD, [
        (f(!0), h(Ce, null, nt(e.options, (T, R) => (f(), h("span", {
          key: T.value,
          class: "fe-choice__cell"
        }, [
          d("button", {
            type: "button",
            "data-choice": "",
            class: Ne(["fe-choice__btn", { "is-on": v(T.value) }]),
            role: e.multi ? void 0 : "radio",
            "aria-checked": e.multi ? void 0 : v(T.value) ? "true" : "false",
            "aria-pressed": e.multi ? v(T.value) ? "true" : "false" : void 0,
            "aria-label": e.iconOnly ? T.label : void 0,
            "aria-describedby": i.value && T.help ? l(R) : void 0,
            tabindex: b(T.value, R),
            disabled: e.disabled || T.disabled,
            "data-testid": e.testidPrefix ? `${e.testidPrefix}-${T.value}` : void 0,
            onClick: (M) => k(T.value),
            onKeydown: (M) => w(M, R)
          }, [
            T.icon ? (f(), We(Ki(T.icon), {
              key: 0,
              class: "fe-choice__icon",
              "aria-hidden": "true"
            })) : D("", !0),
            e.iconOnly ? D("", !0) : (f(), h("span", ID, y(T.label), 1)),
            T.help && !i.value ? (f(), h("span", BD, y(T.help), 1)) : D("", !0)
          ], 42, ND),
          c(T) ? (f(), h("span", {
            key: 0,
            id: l(R),
            class: "fe-choice__tip",
            "aria-hidden": "true",
            "data-testid": e.testidPrefix ? `${e.testidPrefix}-${T.value}-tip` : void 0
          }, y(c(T)), 9, FD)) : D("", !0)
        ]))), 128))
      ]),
      p.value ? (f(), h("p", {
        key: 0,
        class: "fe-choice__note",
        "aria-hidden": "true",
        "data-testid": e.testidPrefix ? `${e.testidPrefix}-note` : void 0
      }, y(p.value), 9, UD)) : D("", !0)
    ], 10, LD));
  }
}), HD = ["data-tag-kind"], KD = ["title", "aria-label", "data-testid", "onClick"], VD = ["aria-label", "onClick"], jD = ["placeholder", "aria-label"], q2 = /* @__PURE__ */ rt({
  __name: "TagPicker",
  props: {
    nodeId: {},
    locale: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    palette: {}
  },
  emits: ["change", "error", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale ?? "en");
    function r(Z) {
      return `${i("tags.open", { tag: Z.name })} · ${i(`tags.chip.${Z.kind}`, { tag: Z.name })}`;
    }
    const l = S([]), c = S(!0), p = S(!1), m = S(!1), v = S(!1), x = S(""), k = S("personal"), _ = S(null), w = E(() => [
      ...l.value.filter((Z) => Z.kind === "personal"),
      ...l.value.filter((Z) => Z.kind === "team")
    ]), b = E(() => [
      { value: "personal", label: i("tags.kind.personal"), help: i("tags.kind.personal_help") },
      {
        value: "team",
        label: i("tags.kind.team"),
        help: c.value ? i("tags.kind.team_help") : i("tags.kind.team_locked"),
        disabled: !c.value
      }
    ]), C = E(() => n.palette ?? [
      "#ef4444",
      "#f59e0b",
      "#10b981",
      "#3b82f6",
      "#8b5cf6",
      "#ec4899",
      "#14b8a6",
      "#f97316"
    ]);
    function A(Z) {
      let J = 0;
      for (let ve = 0; ve < Z.length; ve++) J = J * 31 + Z.charCodeAt(ve) | 0;
      const re = C.value;
      return re[Math.abs(J) % re.length];
    }
    function T(Z) {
      return Z.kind === "personal" || c.value;
    }
    async function R(Z = {}) {
      return { ...await (n.authHeaders ?? (() => ({})))(), ...Z };
    }
    function M(Z) {
      const J = Z ?? {};
      p.value = !Array.isArray(J.items), l.value = $v(Z), typeof J.can_edit_team == "boolean" && (c.value = J.can_edit_team);
    }
    async function L() {
      m.value = !0;
      try {
        const Z = n.apiBase ?? "", J = await fetch(`${Z}/api/files/manager/tags?node_id=${n.nodeId}`, {
          headers: await R(),
          credentials: n.authCredentials ?? "same-origin"
        });
        J.ok && M(await J.json());
      } catch (Z) {
        a("error", Z instanceof Error ? Z.message : String(Z));
      } finally {
        m.value = !1;
      }
    }
    async function U(Z) {
      const J = [...l.value];
      l.value = Z;
      try {
        const re = n.apiBase ?? "", ve = p.value ? { node_id: n.nodeId, tags: Z.map((le) => le.name) } : { node_id: n.nodeId, items: Z }, W = await fetch(`${re}/api/files/manager/tags`, {
          method: "POST",
          headers: await R({ "Content-Type": "application/json" }),
          credentials: n.authCredentials ?? "same-origin",
          body: JSON.stringify(ve)
        });
        if (!W.ok) throw pa(W.status, await W.text().catch(() => ""), n.locale);
        const z = await W.json().catch(() => null);
        !p.value && z && Array.isArray(z.items) && (l.value = $v(z)), OD(), a("change", l.value.map((le) => le.name), l.value);
      } catch (re) {
        l.value = J, a("error", re instanceof Error ? re.message : String(re));
      }
    }
    function P() {
      x.value = "", k.value = "personal", v.value = !1;
    }
    const H = E(() => xc("tag_max_runes"));
    Xe(x, (Z) => {
      const J = by(Z, H.value);
      J !== Z && (x.value = J);
    });
    function $() {
      const Z = x.value.trim(), J = p.value ? "team" : k.value;
      if (!Z || l.value.some((re) => re.kind === J && re.name === Z)) {
        P();
        return;
      }
      U([...l.value, { name: Z, kind: J }]), P();
    }
    function F(Z) {
      var re;
      if (p.value) {
        $();
        return;
      }
      const J = Z.relatedTarget;
      J && ((re = _.value) != null && re.contains(J)) || x.value.trim() || P();
    }
    function I(Z) {
      U(l.value.filter((J) => J !== Z));
    }
    return qt(L), Xe(() => n.nodeId, L), (Z, J) => (f(), h("div", {
      class: Ne(["filex-tag-picker", { "is-loading": m.value }])
    }, [
      (f(!0), h(Ce, null, nt(w.value, (re) => (f(), h("span", {
        key: `${re.kind}:${re.name}`,
        class: Ne(["filex-tag", `filex-tag--${re.kind}`]),
        "data-tag-kind": re.kind,
        style: Xt({ "--filex-tag-color": A(re.name) })
      }, [
        Je(Ev, {
          kind: re.kind
        }, null, 8, ["kind"]),
        d("button", {
          class: "filex-tag-open",
          type: "button",
          title: r(re),
          "aria-label": r(re),
          "data-testid": `tag-open-${re.name}`,
          onClick: (ve) => a("open", re.name, re.kind)
        }, y(re.name), 9, KD),
        T(re) ? (f(), h("button", {
          key: 0,
          class: "filex-tag-x",
          type: "button",
          "aria-label": `${u(i)("tags.remove")}: ${re.name}`,
          onClick: (ve) => I(re)
        }, "×", 8, VD)) : D("", !0)
      ], 14, HD))), 128)),
      v.value ? (f(), h("form", {
        key: 0,
        ref_key: "addForm",
        ref: _,
        class: "filex-tag-add",
        onSubmit: vt($, ["prevent"])
      }, [
        cn(d("input", {
          "onUpdate:modelValue": J[0] || (J[0] = (re) => x.value = re),
          autofocus: "",
          placeholder: u(i)("tags.name"),
          "aria-label": u(i)("tags.name"),
          onBlur: F,
          onKeydown: za(P, ["escape"])
        }, null, 40, jD), [
          [xn, x.value]
        ]),
        p.value ? D("", !0) : (f(), h("div", {
          key: 0,
          class: "filex-tag-kindwrap",
          onMousedown: J[2] || (J[2] = vt(() => {
          }, ["prevent"]))
        }, [
          Je(mi, {
            "model-value": k.value,
            options: b.value,
            "aria-label": u(i)("tags.kind.label"),
            "testid-prefix": "tag-kind",
            "onUpdate:modelValue": J[1] || (J[1] = (re) => k.value = re === "team" ? "team" : "personal")
          }, null, 8, ["model-value", "options", "aria-label"])
        ], 32)),
        d("button", {
          class: "filex-tag-add-submit",
          type: "submit",
          onMousedown: J[3] || (J[3] = vt(() => {
          }, ["prevent"]))
        }, y(u(i)("tags.add_submit")), 33)
      ], 544)) : (f(), h("button", {
        key: 1,
        class: "filex-tag-add-btn",
        type: "button",
        onClick: J[4] || (J[4] = (re) => v.value = !0)
      }, y(u(i)("tags.add")), 1))
    ], 2));
  }
}), v_ = { tr: X0, en: Gs }, W2 = {};
function _i(e, t) {
  for (const n of t) W2[n] = e;
}
_i("image", ["jpg", "jpeg", "png", "webp", "gif", "bmp", "avif", "heic", "svg", "ico", "tiff", "tif"]);
_i("video", ["mp4", "webm", "mov", "mkv", "avi", "ogv", "m4v"]);
_i("audio", ["mp3", "wav", "flac", "ogg", "m4a", "aac", "opus"]);
_i("pdf", ["pdf"]);
_i("doc", ["doc", "docx", "odt", "rtf"]);
_i("sheet", ["xls", "xlsx", "ods", "csv", "tsv"]);
_i("slides", ["ppt", "pptx", "odp"]);
_i("archive", ["zip", "tar", "gz", "bz2", "7z", "rar", "xz", "zst"]);
const Y2 = /* @__PURE__ */ new Set([
  "jar",
  "war",
  "ear",
  "aar",
  "apk",
  "aab",
  "apks",
  "xapk",
  "ipa",
  "whl",
  "egg",
  "vsix",
  "nupkg",
  "snupkg",
  "xpi",
  "crx",
  "appx",
  "appxbundle",
  "msix",
  "msixbundle",
  "deb",
  "rpm",
  "snap",
  "gem",
  "crate"
]);
_i("archive", [...Y2]);
_i("code", [
  "js",
  "ts",
  "jsx",
  "tsx",
  "mjs",
  "cjs",
  "vue",
  "py",
  "go",
  "rs",
  "php",
  "rb",
  "java",
  "kt",
  "swift",
  "c",
  "cpp",
  "h",
  "hpp",
  "cs",
  "css",
  "scss",
  "less",
  "html",
  "htm",
  "json",
  "yml",
  "yaml",
  "xml",
  "sh",
  "bash",
  "ps1",
  "sql",
  "toml"
]);
_i("text", ["txt", "md", "markdown", "log", "ini", "conf", "cfg", "env"]);
function nc(e) {
  return e.mime_type === "inode/storage";
}
function xi(e) {
  if (nc(e)) return "storage";
  if (e.basename === ".trash") return "trash";
  if (e.type === "dir") return "folder";
  const t = (e.extension || "").toLowerCase();
  return t ? W2[t] ?? "unknown" : l2(e.mime_type) ? "text" : "unknown";
}
const Fo = '<path d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3z"/><path d="M13.5 3v5h5"/>', qD = {
  // Folder is the one "filled" member — a soft currentColor wash keeps it
  // visually anchored without breaking the line style.
  /**
   * gorunum:v1 — the folder is SOLID, and it is the one glyph that never
   * gets a tile. A folder is the most common thing in a listing; drawn as an
   * outline in the same weight as the file glyphs it disappears into them,
   * and the eye has to read the label to tell a folder from a document. Filled
   * and in its own colour it is recognisable before the name is read.
   */
  folder: '<path d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5z" fill="currentColor" stroke="none"/>',
  image: '<rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.6" cy="10" r="1.6"/><path d="M5.2 16.6l4.3-4.3 3 3 2.4-2.4 3.9 3.7"/>',
  video: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="M10.2 9.3v5.4l4.8-2.7z" fill="currentColor" stroke="none"/>',
  audio: '<path d="M9 17.5V7.2l9-2.2v10.4"/><circle cx="6.8" cy="17.6" r="2.2"/><circle cx="15.8" cy="15.5" r="2.2"/>',
  pdf: Fo + '<rect x="7.5" y="12" width="9" height="5" rx="1" fill="currentColor" fill-opacity="0.14"/>',
  doc: Fo + '<path d="M8.5 13h7M8.5 16h7"/>',
  sheet: Fo + '<path d="M8 12.5h8M8 15.5h8M8 18h8M12 12.5V18"/>',
  slides: Fo + '<rect x="8" y="12.5" width="8" height="5" rx="0.8"/>',
  archive: Fo + '<path d="M10 3v1.6M10 6.6v1.6M10 10.2v1.6"/><rect x="8.6" y="14" width="2.8" height="3.4" rx="0.8"/>',
  code: Fo + '<path d="M10.4 12.5L8.3 15l2.1 2.5M13.6 12.5l2.1 2.5-2.1 2.5"/>',
  text: Fo + '<path d="M8.5 12h7M8.5 15h7M8.5 18h4.5"/>',
  // The two-bay drive the sidebar already draws for the same storages, so a
  // drive is one shape across the panel rather than one per surface.
  storage: '<rect x="3" y="5" width="18" height="6" rx="1.6"/><rect x="3" y="13" width="18" height="6" rx="1.6"/><path d="M6.5 8h.01M6.5 16h.01"/>',
  trash: '<path d="M4 7h16"/><path d="M9.5 7V5.6A1.6 1.6 0 0 1 11.1 4h1.8a1.6 1.6 0 0 1 1.6 1.6V7"/><path d="M6.2 7l.85 11.6A1.6 1.6 0 0 0 8.65 20h6.7a1.6 1.6 0 0 0 1.6-1.4L17.8 7"/><path d="M10.2 10.8v5.6M13.8 10.8v5.6"/>',
  unknown: Fo + '<path d="M10.3 13.1a1.8 1.8 0 1 1 2.5 1.9c-.6.3-.8.7-.8 1.4"/><circle cx="12" cy="18.4" r="0.9" fill="currentColor" stroke="none"/>'
}, y_ = /* @__PURE__ */ new Map();
function g_(e) {
  let t = y_.get(e);
  return t || (t = `<svg class="fe-ficon fe-ficon--${e}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${qD[e]}</svg>`, y_.set(e, t)), t;
}
const b_ = /* @__PURE__ */ new Map();
function G2(e) {
  if (e === "folder")
    return `<span class="fe-ftile fe-ftile--folder">${g_(e)}</span>`;
  let t = b_.get(e);
  return t || (t = `<span class="fe-ftile fe-ftile--${e}">${g_(e)}</span>`, b_.set(e, t)), t;
}
function xa(e) {
  return WD(e) ? GD() : G2(xi(e));
}
function WD(e) {
  return e.type === "dir" ? !1 : (e.extension || "").toLowerCase() === "fxe" ? !0 : typeof e.basename == "string" && e.basename.toLowerCase().endsWith(".fxe") && e.basename.length > 4;
}
const YD = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M6.5 3h7L18.5 8v11.5a1.5 1.5 0 0 1-1.5 1.5H6.5A1.5 1.5 0 0 1 5 19.5v-15A1.5 1.5 0 0 1 6.5 3zM9.7 12.2a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12.2h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1v-3.6a1 1 0 0 1 1-1z"/>';
let Tm = "";
function GD() {
  return Tm || (Tm = `<span class="fe-ftile fe-ftile--unknown fe-ftile--file-locked"><svg class="fe-ficon fe-ficon--file-locked" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${YD}</svg></span>`), Tm;
}
function Br(e) {
  return e.type === "dir" && e.e2e === !0;
}
const XD = '<path fill="currentColor" stroke="none" fill-rule="evenodd" d="M2.5 6.5A2.5 2.5 0 0 1 5 4h4.6a2.5 2.5 0 0 1 1.77.73L13 6.4h6a2.5 2.5 0 0 1 2.5 2.5v8.6A2.5 2.5 0 0 1 19 20H5a2.5 2.5 0 0 1-2.5-2.5zM9.7 12a2.3 2.3 0 0 1 4.6 0h-1.05a1.25 1.25 0 0 0-2.5 0zM9.2 12h5.6a1 1 0 0 1 1 1v3.6a1 1 0 0 1-1 1H9.2a1 1 0 0 1-1-1V13a1 1 0 0 1 1-1z"/>';
let Am = "";
function vl() {
  return Am || (Am = `<span class="fe-ftile fe-ftile--folder fe-ftile--folder-locked"><svg class="fe-ficon fe-ficon--folder" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${XD}</svg></span>`), Am;
}
const JD = {
  // Languages the person reading the column thinks of by name.
  ts: "ftype.typescript",
  tsx: "ftype.typescript",
  mts: "ftype.typescript",
  cts: "ftype.typescript",
  js: "ftype.javascript",
  jsx: "ftype.javascript",
  mjs: "ftype.javascript",
  cjs: "ftype.javascript",
  vue: "ftype.vue",
  py: "ftype.python",
  go: "ftype.go",
  rs: "ftype.rust",
  php: "ftype.php",
  rb: "ftype.ruby",
  java: "ftype.java",
  kt: "ftype.kotlin",
  swift: "ftype.swift",
  c: "ftype.c",
  h: "ftype.c",
  cpp: "ftype.cpp",
  hpp: "ftype.cpp",
  cs: "ftype.csharp",
  // Structured text that is code by family but not a language.
  css: "ftype.stylesheet",
  scss: "ftype.stylesheet",
  less: "ftype.stylesheet",
  html: "ftype.html",
  htm: "ftype.html",
  json: "ftype.json",
  yml: "ftype.yaml",
  yaml: "ftype.yaml",
  xml: "ftype.xml",
  toml: "ftype.toml",
  sql: "ftype.sql",
  sh: "ftype.shell",
  bash: "ftype.shell",
  zsh: "ftype.shell",
  ps1: "ftype.powershell",
  // Plain-text family members that are each their own thing.
  md: "ftype.markdown",
  markdown: "ftype.markdown",
  txt: "ftype.plaintext",
  log: "ftype.log",
  ini: "ftype.config",
  conf: "ftype.config",
  cfg: "ftype.config",
  env: "ftype.config",
  // Tabular: a `.csv` IS a spreadsheet to the person looking at the column,
  // whatever the program that wrote it was.
  csv: "ftype.sheet",
  tsv: "ftype.sheet",
  // Design files. No icon family of their own (they fall to `unknown`, which
  // is a decision for the GLYPH, not for the word) — naming them still beats
  // printing "FIG".
  fig: "ftype.figma",
  // ⚠ Named, not "DRAWIO": the uppercased extension was a fourth spelling of
  // draw.io beside "Drawio", "drawio" and "diagrams.net" (QA, 2026-09-21).
  drawio: "ftype.drawio",
  dio: "ftype.drawio",
  sketch: "ftype.design",
  xd: "ftype.design",
  psd: "ftype.design",
  ai: "ftype.design"
}, ZD = {
  folder: "node.folder",
  image: "ftype.image",
  video: "ftype.video",
  audio: "ftype.audio",
  pdf: "ftype.pdf",
  doc: "ftype.document",
  sheet: "ftype.sheet",
  slides: "ftype.slides",
  archive: "ftype.archive",
  code: "ftype.code",
  text: "ftype.plaintext"
};
function X2(e) {
  if (e.type === "dir") return "node.folder";
  const t = (e.extension || "").trim().toLowerCase();
  if (t === "fxe") return "e2e.fxe.type";
  const n = JD[t];
  return n || (Y2.has(t) ? null : ZD[xi(e)] ?? null);
}
function Cv(e, t) {
  const n = X2(e);
  return n ? t(n) : J2(e) || "-";
}
function J2(e) {
  return (e.extension || "").trim().toUpperCase();
}
const Un = 16, _p = new Uint8Array(Un);
class k_ extends Error {
  constructor(t = "aes-siv: authentication failed") {
    super(t), this.name = "SivAuthError";
  }
}
function qo(e) {
  return new Uint8Array(e).buffer;
}
function qf(e) {
  const t = new Uint8Array(Un);
  let n = 0;
  for (let a = Un - 1; a >= 0; a--) {
    const i = e[a];
    t[a] = (i << 1 | n) & 255, n = i >>> 7;
  }
  return e[0] & 128 && (t[Un - 1] ^= 135), t;
}
function zv(e, t, n) {
  for (let a = 0; a < n.length; a++) e[t + a] ^= n[a];
}
function w_(e, t) {
  const n = new Uint8Array(Un);
  for (let a = 0; a < Un; a++) n[a] = e[a] ^ t[a];
  return n;
}
async function QD(e, t) {
  const n = await crypto.subtle.encrypt({ name: "AES-CBC", iv: qo(_p) }, e, qo(t));
  return new Uint8Array(n).slice(0, Un);
}
async function Em(e, t) {
  const n = Math.max(1, Math.ceil(t.length / Un)), a = t.length > 0 && t.length % Un === 0, i = new Uint8Array(n * Un);
  i.set(t);
  const r = (n - 1) * Un;
  return a ? zv(i, r, e.k1) : (i[t.length] = 128, zv(i, r, e.k2)), new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-CBC", iv: qo(_p) }, e.mac, qo(i))
  ).slice(r, r + Un);
}
async function Z2(e, t, n) {
  let a = await Em(e, _p);
  for (const r of t) a = w_(qf(a), await Em(e, r));
  let i;
  if (n.length >= Un)
    i = n.slice(), zv(i, n.length - Un, a);
  else {
    const r = new Uint8Array(Un);
    r.set(n), r[n.length] = 128, i = w_(qf(a), r);
  }
  return Em(e, i);
}
function eL(e) {
  const t = e.slice();
  return t[8] &= 127, t[12] &= 127, t;
}
async function Q2(e, t, n) {
  if (n.length === 0) return new Uint8Array(0);
  const a = await crypto.subtle.encrypt(
    { name: "AES-CTR", counter: qo(eL(t)), length: 32 },
    e.ctr,
    qo(n)
  );
  return new Uint8Array(a);
}
async function tL(e) {
  if (e.length !== 32 && e.length !== 64)
    throw new Error("aes-siv: key must be 32 or 64 bytes");
  const t = e.length / 2, n = await crypto.subtle.importKey("raw", qo(e.slice(0, t)), { name: "AES-CBC" }, !1, [
    "encrypt"
  ]), a = await crypto.subtle.importKey("raw", qo(e.slice(t)), { name: "AES-CTR" }, !1, [
    "encrypt",
    "decrypt"
  ]), i = await QD(n, _p), r = qf(i), l = qf(r);
  return { mac: n, ctr: a, k1: r, k2: l };
}
async function ex(e, t, n = []) {
  const a = await Z2(e, n, t), i = await Q2(e, a, t), r = new Uint8Array(Un + i.length);
  return r.set(a, 0), r.set(i, Un), r;
}
async function nL(e, t, n = []) {
  if (t.length < Un) throw new k_("aes-siv: ciphertext too short");
  const a = t.slice(0, Un), i = await Q2(e, a, t.slice(Un)), r = await Z2(e, n, i);
  let l = 0;
  for (let c = 0; c < Un; c++) l |= r[c] ^ a[c];
  if (l !== 0)
    throw i.fill(0), new k_();
  return i;
}
const tx = "AES-SIV-512", nx = "b64url", aL = 220, iL = 255, ax = 64, yl = 16, oL = ".fxl", ix = ".fxl.name", rL = new TextEncoder().encode("filex-e2e-dir-id"), sL = 16, ox = /^[A-Za-z0-9_-]+$/, Ky = "[A-Za-z0-9_-]{43}", rx = "[A-Za-z0-9_-]{22}", lL = new RegExp(`^(${Ky})\\.fxl\\.name$`), uL = new RegExp(`^(${Ky})\\.fxl$`), cL = new RegExp(`^(${Ky})\\.fxl\\.(${rx})$`), dL = new RegExp(`^([A-Za-z0-9_-]{23,})\\.(${rx})$`), fL = 23;
function Wo(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
  return btoa(t).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function wo(e) {
  if (!e || !ox.test(e) || e.length % 4 === 1) return null;
  const t = e.replace(/-/g, "+").replace(/_/g, "/"), n = t + "===".slice((t.length + 3) % 4);
  let a;
  try {
    a = atob(n);
  } catch {
    return null;
  }
  const i = new Uint8Array(a.length);
  for (let r = 0; r < a.length; r++) i[r] = a.charCodeAt(r);
  return Wo(i) !== e ? null : i;
}
function Vy(e) {
  return (e ?? "").normalize("NFC");
}
function Gi(e) {
  const t = Vy(e);
  return t ? t === "." || t === ".." ? "dot" : t.includes("/") || t.includes("\\") ? "slash" : /[\u0000-\u001f\u007f]/.test(t) ? "control" : new TextEncoder().encode(t).length > iL ? "too_long" : null : "empty";
}
function pL() {
  return crypto.getRandomValues(new Uint8Array(ax));
}
function sx() {
  return crypto.getRandomValues(new Uint8Array(yl));
}
const hL = sx;
async function jy(e, t, n) {
  if (e.length !== ax) throw new Error("e2e: name key must be 64 bytes");
  if (n.length !== yl) throw new Error("e2e: a folder id is 16 bytes");
  return { siv: await tL(e), long: t, rootId: n.slice() };
}
async function lx(e) {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  return Wo(new Uint8Array(t));
}
async function mL(e, t, n) {
  return (await ex(e.siv, new TextEncoder().encode(Vy(n)), [
    t,
    rL
  ])).slice(0, yl);
}
function Ol(e) {
  let t = lL.exec(e);
  if (t) return { kind: "sidecar", hash: t[1] };
  if (t = cL.exec(e), t) {
    const n = wo(t[2]);
    if (n && n.length === yl) return { kind: "longdir", hash: t[1], dirId: n };
  }
  if (t = uL.exec(e), t) return { kind: "long", hash: t[1] };
  if (t = dL.exec(e), t) {
    const n = wo(t[2]);
    if (n && n.length === yl) return { kind: "dir", encoded: t[1], dirId: n };
  }
  return e.length >= fL && ox.test(e) ? { kind: "file", encoded: e } : { kind: "plain" };
}
function vL(e) {
  return Ol(e).dirId ?? null;
}
async function Mv(e, t, n) {
  return vL(n) ?? mL(e, t, n);
}
async function Ov(e, t, n, a = {}) {
  const i = Gi(t);
  if (i) throw new Error(`e2e: invalid name (${i})`);
  const r = new TextEncoder().encode(Vy(t)), l = Wo(await ex(e.siv, r, [n])), p = a.isDir || !!a.dirId ? a.dirId ?? sx() : void 0, m = p ? `.${Wo(p)}` : "";
  if (l.length + m.length <= e.long)
    return { stored: l + m, encoded: l, ...p ? { dirId: p } : {} };
  const v = await lx(l);
  return {
    stored: `${v}${oL}${m}`,
    encoded: l,
    ...p ? { dirId: p } : {},
    sidecar: { name: `${v}${ix}`, content: l }
  };
}
async function ux(e, t, n) {
  const a = wo(t);
  if (!a || a.length <= sL) return null;
  try {
    const i = await nL(e.siv, a, [n]);
    return new TextDecoder("utf-8", { fatal: !0 }).decode(i);
  } catch {
    return null;
  }
}
async function __(e, t, n) {
  const a = await ux(e, t, n);
  return a === null ? null : Gi(a) ? "unsafe" : a;
}
async function cx(e, t, n, a) {
  const i = Ol(t);
  if (i.kind === "sidecar") return { name: null, state: "sidecar" };
  if (i.kind === "plain") return { name: t, state: "plain" };
  if (i.kind === "long" || i.kind === "longdir") {
    const c = ((a ? await a(`${i.hash}${ix}`) : null) ?? "").trim();
    if (!c || await lx(c) !== i.hash)
      return { name: null, state: "unreadable" };
    const p = await __(e, c, n);
    return p === null || p === "unsafe" ? { name: null, state: "unreadable" } : { name: p, state: "enc" };
  }
  const r = await __(e, i.encoded, n);
  return r === "unsafe" ? { name: null, state: "unreadable" } : r !== null ? { name: r, state: "enc" } : i.kind === "dir" ? { name: null, state: "unreadable" } : { name: t, state: "plain" };
}
function Wf(e) {
  const t = e.lastIndexOf(".");
  return t <= 0 || t === e.length - 1 ? "" : e.slice(t + 1).toLowerCase();
}
const xo = 20, yL = 10, gL = 24, Fr = 7, Hi = 16, Cc = 2, bL = 4294967295, ac = 12, yi = 97, Pv = 9, Dv = 21, dx = 48, Lv = 69, fx = 76, px = 32, Yf = new TextEncoder().encode("filexe2e");
function zc(e) {
  return typeof e == "number" && Number.isInteger(e) && e >= yL && e <= gL;
}
function Mc(e) {
  if (!zc(e)) throw new Error(`e2e: unsupported chunk size 2^${e}`);
  return 2 ** e;
}
function hx(e, t, n) {
  if (e.length !== Fr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  if (!Number.isInteger(t) || t < 0 || t > bL)
    throw new Error("e2e: too many chunks for one stream");
  const a = new Uint8Array(ac);
  return a.set(e, 0), new DataView(a.buffer).setUint32(Fr, t, !1), a[ac - 1] = n ? 1 : 0, a;
}
function mx(e, t = xo) {
  if (!Number.isSafeInteger(e) || e < 0) throw new Error("e2e: bad plaintext size");
  return e === 0 ? 1 : Math.ceil(e / Mc(t));
}
function qy(e, t = xo) {
  return e + Hi * mx(e, t);
}
function kL(e, t = xo) {
  if (!zc(t) || !Number.isSafeInteger(e) || e < Hi) return null;
  const n = 2 ** t + Hi, a = Math.ceil(e / n), i = e - (a - 1) * n;
  return i < Hi || a > 1 && i === Hi ? null : e - Hi * a;
}
function vx() {
  return crypto.getRandomValues(new Uint8Array(Fr));
}
class xp {
  constructor() {
    Bt(this, "parts", []);
    Bt(this, "head", 0);
    Bt(this, "length", 0);
  }
  push(t) {
    t.length !== 0 && (this.parts.push(t), this.length += t.length);
  }
  /** The next `n` bytes (n ≤ length), as a fresh buffer. */
  take(t) {
    if (t > this.length) throw new Error("ByteQueue: not enough bytes");
    const n = new Uint8Array(t);
    let a = 0;
    for (; a < t; ) {
      const i = this.parts[0], r = Math.min(i.length - this.head, t - a);
      n.set(i.subarray(this.head, this.head + r), a), a += r, this.head += r, this.head === i.length && (this.parts.shift(), this.head = 0);
    }
    return this.length -= t, n;
  }
}
function gl(e) {
  if (e instanceof Uint8Array) return e;
  if (e instanceof ArrayBuffer) return new Uint8Array(e);
  if (ArrayBuffer.isView(e)) return new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
  throw new TypeError("e2e: a stream carried something that is not bytes");
}
class Sp {
  constructor(t) {
    Bt(this, "reader");
    Bt(this, "q", new xp());
    Bt(this, "done", !1);
    this.reader = t.getReader();
  }
  /** Up to `n` bytes; fewer only when the stream ended. */
  async read(t) {
    for (; this.q.length < t && !this.done; ) {
      const { done: n, value: a } = await this.reader.read();
      n ? this.done = !0 : this.q.push(gl(a));
    }
    return this.q.take(Math.min(t, this.q.length));
  }
  /** Everything not read yet, as a stream. The reader is spent afterwards. */
  rest() {
    const t = this.q.take(this.q.length), n = this.reader;
    let a = t.length > 0 ? t : null;
    const i = this.done;
    return new ReadableStream({
      async pull(r) {
        if (a) {
          r.enqueue(a), a = null;
          return;
        }
        if (i) {
          r.close();
          return;
        }
        const { done: l, value: c } = await n.read();
        l ? r.close() : r.enqueue(gl(c));
      },
      cancel(r) {
        return n.cancel(r);
      }
    });
  }
  cancel(t) {
    return this.reader.cancel(t);
  }
}
function Oc(e, t) {
  const n = t.getReader();
  let a = !1;
  return new ReadableStream({
    async pull(i) {
      if (!a && (a = !0, e.length > 0)) {
        i.enqueue(e);
        return;
      }
      const { done: r, value: l } = await n.read();
      r ? i.close() : i.enqueue(gl(l));
    },
    cancel(i) {
      return n.cancel(i);
    }
  });
}
async function wL(e, t = Number.MAX_SAFE_INTEGER) {
  const n = new xp(), a = e.getReader();
  for (; ; ) {
    const { done: i, value: r } = await a.read();
    if (i) break;
    if (n.push(gl(r)), n.length > t)
      throw await a.cancel(), new Error("e2e: more data than expected");
  }
  return n.take(n.length);
}
async function x_(e, t, n, a, i) {
  return new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: hx(t, n, a) }, e, i)
  );
}
async function Rv(e, t, n, a, i) {
  try {
    return new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: hx(t, n, a) }, e, i)
    );
  } catch {
    throw new un(
      a ? "e2e: the last chunk failed authentication (the file is truncated, extended or damaged)" : `e2e: chunk ${n} failed authentication (the file is damaged, reordered or truncated)`
    );
  }
}
function yx(e, t, n = xo, a = {}) {
  const i = Mc(n);
  if (t.length !== Fr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const r = new xp();
  let l = 0, c = 0;
  return new TransformStream({
    async transform(p, m) {
      var x;
      const v = gl(p);
      if (c += v.length, a.expectSize !== void 0 && c > a.expectSize)
        throw new Error("e2e: the file is longer than it said it was");
      for (r.push(v); r.length > i; )
        m.enqueue(await x_(e, t, l++, !1, r.take(i))), (x = a.onProgress) == null || x.call(a, l * i);
    },
    async flush(p) {
      var m;
      if (a.expectSize !== void 0 && c !== a.expectSize)
        throw new Error("e2e: the file is shorter than it said it was");
      p.enqueue(await x_(e, t, l++, !0, r.take(r.length))), (m = a.onProgress) == null || m.call(a, c);
    }
  });
}
function gx(e, t, n = xo, a = {}) {
  const i = Mc(n) + Hi;
  if (t.length !== Fr) throw new Error("e2e: the nonce prefix must be 7 bytes");
  const r = new xp();
  let l = 0, c = 0;
  const p = (m) => {
    if (c += m.length, a.expectSize !== void 0 && c > a.expectSize)
      throw new un("e2e: the file holds more than its header says");
    return m;
  };
  return new TransformStream({
    async transform(m, v) {
      for (r.push(gl(m)); r.length > i; ) v.enqueue(p(await Rv(e, t, l++, !1, r.take(i))));
    },
    async flush(m) {
      if (r.length < Hi) throw new un("e2e: the encrypted content is truncated");
      if (l > 0 && r.length === Hi)
        throw new un("e2e: the encrypted content ends in an empty chunk no writer produces");
      if (m.enqueue(p(await Rv(e, t, l++, !0, r.take(r.length)))), a.expectSize !== void 0 && c !== a.expectSize)
        throw new un("e2e: the file holds less than its header says");
    }
  });
}
async function _L(e, t, n, a = xo) {
  const i = Mc(a), r = i + Hi, l = kL(n.length, a);
  if (l === null) throw new un("e2e: the encrypted content has an impossible length");
  const c = new Uint8Array(l), p = mx(l, a);
  for (let m = 0; m < p; m++) {
    const v = m === p - 1, x = n.slice(m * r, v ? n.length : (m + 1) * r);
    c.set(await Rv(e, t, m, v, x), m * i);
  }
  return c;
}
function bx() {
  return crypto.getRandomValues(new Uint8Array(px));
}
async function $p(e) {
  if (e.length !== px) throw new un("e2e: a file key must be 32 bytes");
  return crypto.subtle.importKey("raw", e, { name: "AES-GCM" }, !1, ["encrypt", "decrypt"]);
}
function xL(e) {
  if (e.wrapIV.length !== ac || e.wrappedDek.length !== dx)
    throw new Error("e2e: bad wrapped key");
  Mc(e.log2);
  const t = new Uint8Array(yi);
  return t.set(Yf, 0), t[8] = Cc, t.set(e.wrapIV, Pv), t.set(e.wrappedDek, Dv), t.set(e.prefix, Lv), t[fx] = e.log2, t;
}
function kx(e) {
  if (e.length < yi) throw new Error("e2e: not an encrypted file");
  for (let n = 0; n < Yf.length; n++)
    if (e[n] !== Yf[n]) throw new Error("e2e: not an encrypted file");
  if (e[8] !== Cc) throw new Error(`e2e: unsupported version ${e[8]}`);
  const t = e[fx];
  if (!zc(t)) throw new Error(`e2e: unsupported chunk size 2^${t}`);
  return {
    wrapIV: e.slice(Pv, Pv + ac),
    wrappedDek: e.slice(Dv, Dv + dx),
    prefix: e.slice(Lv, Lv + Fr),
    log2: t
  };
}
function SL(e, t = xo) {
  return yi + qy(e, t);
}
async function wx(e, t, n, a) {
  for (const i of t ? [e, t] : [e]) {
    let r;
    try {
      r = new Uint8Array(await crypto.subtle.decrypt({ name: "AES-GCM", iv: n }, i, a));
    } catch {
      continue;
    }
    try {
      return await $p(r);
    } finally {
      r.fill(0);
    }
  }
  throw new un("e2e: DEK unwrap failed (wrong key?)");
}
async function S_(e, t, n, a = {}) {
  const i = a.chunkLog2 ?? xo, r = bx(), l = crypto.getRandomValues(new Uint8Array(ac));
  let c, p;
  try {
    p = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: l }, e, r)), c = await $p(r);
  } finally {
    r.fill(0);
  }
  const m = vx(), v = xL({ wrapIV: l, wrappedDek: p, prefix: m, log2: i }), x = n.pipeThrough(
    yx(c, m, i, { expectSize: t, onProgress: a.onProgress })
  );
  return { stream: Oc(v, x), size: SL(t, i) };
}
async function $L(e, t, n) {
  const a = kx(t), i = await wx(e, n, a.wrapIV, a.wrappedDek);
  return (await _L(i, a.prefix, t.subarray(yi), a.log2)).buffer;
}
const TL = 200 * 1024 * 1024 + yi + 16;
function Nv(e, t, n, a = {}) {
  const i = new Sp(n);
  let r = null;
  return new ReadableStream({
    async start(l) {
      var k;
      const c = await i.read(yi);
      if (!(c.length >= 8 && Yf.every((_, w) => c[w] === _))) {
        if (!a.passPlain) throw new Error("e2e: not an encrypted file");
        (k = a.onPlain) == null || k.call(a), r = Oc(c, i.rest()).getReader();
        return;
      }
      if (c.length < yi) throw new un("e2e: the encrypted file is truncated");
      if (c[8] === Cc) {
        const _ = kx(c), w = await wx(e, t, _.wrapIV, _.wrappedDek);
        r = i.rest().pipeThrough(gx(w, _.prefix, _.log2)).getReader();
        return;
      }
      if (c[8] !== 1) throw new Error(`e2e: unsupported version ${c[8]}`);
      const m = await wL(i.rest(), TL - yi), v = new Uint8Array(yi + m.length);
      v.set(c, 0), v.set(m, yi);
      let x;
      try {
        x = await Jf(e, v.buffer);
      } catch (_) {
        if (!t || !(_ instanceof un)) throw _;
        x = await Jf(t, v.buffer);
      }
      l.enqueue(new Uint8Array(x)), l.close();
    },
    async pull(l) {
      if (!r) return;
      const { done: c, value: p } = await r.read();
      c ? l.close() : l.enqueue(p);
    },
    cancel(l) {
      return r ? r.cancel(l) : i.cancel(l);
    }
  });
}
const AL = yi, ic = "vault", _x = 1, EL = 16, CL = 24, xx = 22, zL = 24, ML = [xx, zL], Wy = 16, Pfe = 25e4;
function OL(e) {
  return typeof e == "number" && Number.isInteger(e) && e >= EL && e <= CL;
}
function Sx() {
  return import("./keys-DQ6CPBM-.js");
}
const ka = ".filex-e2e.json", PL = "filexe2e", Yy = 1, Tp = 2, So = 3, DL = ["names", "rekey", "conv", ic], Ap = 6e5, Ep = 6e5, $x = 1e8, qu = 200 * 1024 * 1024, Gf = 8, bf = 20, Tx = "RSA-OAEP-256", Xo = "filex-e2e-verify-v1", kf = new TextEncoder().encode(PL), oc = 97, ol = 9, rl = 21, Ax = 48, Iv = 69, ji = 12, ki = 32, LL = "filex-e2e-recovery-v1", RL = 16;
class un extends Error {
  constructor(t = "e2e: decrypt failed") {
    super(t), this.name = "E2eDecryptError";
  }
}
function Oa(e) {
  let t = "";
  for (let n = 0; n < e.length; n++) t += String.fromCharCode(e[n]);
  return btoa(t);
}
function ta(e) {
  const t = atob(e), n = new Uint8Array(t.length);
  for (let a = 0; a < t.length; a++) n[a] = t.charCodeAt(a);
  return n;
}
function kn(e) {
  return new Uint8Array(e).buffer;
}
function NL(e, t) {
  const n = new Uint8Array(e.length + t.length);
  return n.set(e, 0), n.set(t, e.length), Oa(n);
}
async function ni(e, t) {
  const n = crypto.getRandomValues(new Uint8Array(ji)), a = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: kn(n) }, e, kn(t))
  );
  return NL(n, a);
}
function $_(e, t) {
  return ni(e, t);
}
function T_(e, t) {
  return Ba(e, t);
}
async function Ba(e, t) {
  let n;
  try {
    n = ta(t);
  } catch {
    return null;
  }
  if (n.length <= ji) return null;
  try {
    const a = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: kn(n.slice(0, ji)) },
      e,
      kn(n.slice(ji))
    );
    return new Uint8Array(a);
  } catch {
    return null;
  }
}
async function Jo(e, t, n) {
  const a = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveKey"]
  );
  return crypto.subtle.deriveKey(
    { name: "PBKDF2", salt: kn(t), iterations: n, hash: "SHA-256" },
    a,
    { name: "AES-GCM", length: 256 },
    !1,
    // non-extractable
    ["encrypt", "decrypt"]
  );
}
async function Gy(e, t, n) {
  const a = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(e),
    "PBKDF2",
    !1,
    ["deriveBits"]
  ), i = await crypto.subtle.deriveBits(
    { name: "PBKDF2", salt: kn(t), iterations: n, hash: "SHA-256" },
    a,
    ki * 8
  );
  return new Uint8Array(i);
}
async function rc(e) {
  return crypto.subtle.importKey("raw", kn(e), { name: "AES-GCM" }, !1, [
    "encrypt",
    "decrypt"
  ]);
}
async function Xy(e, t) {
  return Ur(e) ? (await Sx()).importVaultFmk(t) : rc(t);
}
const Bv = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
function IL(e) {
  let t = 0, n = 0, a = "";
  for (let i = 0; i < e.length; i++)
    for (n = n << 8 | e[i], t += 8; t >= 5; )
      a += Bv[n >>> t - 5 & 31], t -= 5;
  return t > 0 && (a += Bv[n << 5 - t & 31]), (a.match(/.{1,4}/g) || []).join("-");
}
function Cp() {
  return IL(crypto.getRandomValues(new Uint8Array(bf)));
}
function Jy(e) {
  const t = (e || "").toUpperCase().replace(/[\s-]/g, "").replace(/O/g, "0").replace(/[IL]/g, "1"), n = Math.ceil(bf * 8 / 5);
  if (t.length !== n) return null;
  const a = new Uint8Array(bf);
  let i = 0, r = 0, l = 0;
  for (const c of t) {
    const p = Bv.indexOf(c);
    if (p < 0) return null;
    i = i << 5 | p, r += 5, r >= 8 && (a[l++] = i >>> r - 8 & 255, r -= 8);
  }
  return l === bf ? a : null;
}
async function Zy(e, t) {
  const n = await crypto.subtle.importKey("raw", kn(e), "HKDF", !1, ["deriveKey"]);
  return crypto.subtle.deriveKey(
    {
      name: "HKDF",
      hash: "SHA-256",
      salt: kn(t),
      info: kn(new TextEncoder().encode(LL))
    },
    n,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  );
}
async function zp(e, t) {
  const n = Jy(t);
  if (!n) throw new Error("e2e: malformed recovery key");
  const a = crypto.getRandomValues(new Uint8Array(RL)), i = await Zy(n, a), r = { salt: Oa(a), blob: await ni(i, e) };
  return n.fill(0), r;
}
async function BL(e) {
  return crypto.subtle.importKey(
    "spki",
    kn(ta(e)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !0,
    ["encrypt"]
  );
}
async function Ex(e) {
  const t = (e || "").replace(/-----[A-Z ]+-----/g, "").replace(/\s+/g, "");
  return crypto.subtle.importKey(
    "pkcs8",
    kn(ta(t)),
    { name: "RSA-OAEP", hash: "SHA-256" },
    !1,
    ["decrypt"]
  );
}
async function Cx(e) {
  const t = new Uint8Array(await crypto.subtle.digest("SHA-256", kn(ta(e))));
  return Array.from(t.slice(0, 8)).map((n) => n.toString(16).padStart(2, "0")).join("");
}
async function Pc(e, t) {
  const n = await BL(t), a = new Uint8Array(await crypto.subtle.encrypt({ name: "RSA-OAEP" }, n, kn(e)));
  return { kid: await Cx(t), alg: Tx, blob: Oa(a) };
}
async function Dfe(e, t = Ap) {
  const n = Math.max(Ep, t), a = crypto.getRandomValues(new Uint8Array(16)), i = await Jo(e, a, n), r = await ni(i, new TextEncoder().encode(Xo));
  return { marker: { v: 1, salt: Oa(a), iter: n, verify: r }, kek: i };
}
async function zx(e, t) {
  const n = pL(), a = hL(), i = {
    alg: tx,
    enc: nx,
    long: aL,
    key: await ni(e, n),
    root_id: Wo(a)
  };
  t && (i.pending = !0);
  const r = await jy(n, i.long, a);
  return n.fill(0), { slot: i, key: r };
}
async function Fv(e, t = {}) {
  const n = Math.max(Ep, t.iterations ?? Ap), a = crypto.getRandomValues(new Uint8Array(16)), i = await Jo(e, a, n), r = crypto.getRandomValues(new Uint8Array(ki)), l = Cp(), c = {
    v: Tp,
    salt: Oa(a),
    iter: n,
    verify: await ni(i, new TextEncoder().encode(Xo)),
    fmk: "wrapped",
    fmk_pw: await ni(i, r),
    rk: await zp(r, l)
  };
  t.escrowPublicKey && (c.esc = await Pc(r, t.escrowPublicKey));
  const p = await rc(r);
  if (r.fill(0), !t.encryptNames) return { marker: c, fmk: p, recoveryKey: l };
  const m = await zx(p, !1);
  return c.v = So, c.req = ["names"], c.names = m.slot, { marker: c, fmk: p, recoveryKey: l, names: m.key };
}
async function FL(e, t = {}) {
  const n = t.packLog2 ?? xx;
  if (!ML.includes(n)) throw new Error(`e2e: a vault's packs are 2^22 or 2^24 bytes, not 2^${n}`);
  const [{ importVaultFmk: a }, { cryptoRandom: i, sealIndexFile: r }, { encodeIndexBody: l }] = await Promise.all([
    Sx(),
    import("./writer-BYxV48C0.js").then((C) => C.w),
    import("./vindex-CJzGZgle.js")
  ]), c = Math.max(Ep, t.iterations ?? Ap), p = crypto.getRandomValues(new Uint8Array(16)), m = await Jo(e, p, c), v = crypto.getRandomValues(new Uint8Array(ki)), x = Cp(), k = crypto.getRandomValues(new Uint8Array(Wy)), _ = {
    v: So,
    req: [ic],
    salt: Oa(p),
    iter: c,
    verify: await ni(m, new TextEncoder().encode(Xo)),
    fmk: "wrapped",
    fmk_pw: await ni(m, v),
    rk: await zp(v, x)
  };
  t.escrowPublicKey && (_.esc = await Pc(v, t.escrowPublicKey)), _.vault = { v: _x, id: Wo(k), pack: n };
  const w = await a(v);
  v.fill(0);
  const b = await r(w, k, 1, l(/* @__PURE__ */ new Map(), []).body, i);
  return { marker: _, fmk: w, recoveryKey: x, vaultId: k, index: b };
}
async function UL(e, t, n = {}) {
  if (e.v !== 1) throw new Error("e2e: not a v1 marker");
  const a = ta(e.salt), i = await Jo(t, a, e.iter), r = await Ba(i, e.verify);
  if (!r || new TextDecoder().decode(r) !== Xo)
    throw new un("e2e: wrong password");
  const l = await Gy(t, a, e.iter), c = Cp(), p = {
    v: Tp,
    salt: e.salt,
    iter: e.iter,
    verify: e.verify,
    fmk: "kek",
    rk: await zp(l, c)
  };
  return n.escrowPublicKey && (p.esc = await Pc(l, n.escrowPublicKey)), l.fill(0), { marker: p, fmk: i, recoveryKey: c };
}
async function HL(e, t, n) {
  if (!Xi(e)) throw new Error("e2e: not a v2 marker");
  if (e.esc) throw new Error("e2e: this folder already has an escrow slot");
  if (!n) throw new Error("e2e: no escrow public key");
  const a = ta(e.salt), i = await Jo(t, a, e.iter), r = await Ba(i, e.verify);
  if (!r || new TextDecoder().decode(r) !== Xo)
    throw new un("e2e: wrong password");
  let l;
  if (e.fmk === "wrapped") {
    const m = e.fmk_pw ? await Ba(i, e.fmk_pw) : null;
    if (!m || m.length !== ki)
      throw new un("e2e: could not unwrap the folder master key");
    l = m;
  } else
    l = await Gy(t, a, e.iter);
  const c = await Pc(l, n);
  l.fill(0);
  const p = { ...e, esc: c };
  return delete p.esc_declined, p;
}
function KL(e, t) {
  return { ...e, esc_declined: t };
}
function A_(e, t) {
  return !t || !e || !Xi(e) || e.esc ? "n/a" : e.esc_declined ? "declined" : "offer";
}
function Xi(e) {
  return e.v === 2 || e.v === So;
}
function Xf(e) {
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return null;
  }
  if (!t || typeof t != "object" || t.v !== 1 && !Xi(t) || typeof t.salt != "string" || typeof t.verify != "string" || typeof t.iter != "number" || !Number.isInteger(t.iter) || t.iter < 1 || t.iter > $x || Xi(t) && (t.fmk !== "kek" && t.fmk !== "wrapped" || t.fmk === "wrapped" && typeof t.fmk_pw != "string"))
    return null;
  const n = [];
  if (t.v === So) {
    if (!Array.isArray(t.req) || t.req.some((a) => typeof a != "string")) return null;
    for (const a of t.req) DL.includes(a) || n.push(a);
    if (t.req.includes(ic)) {
      if (t.req.length !== 1 || t.fmk !== "wrapped" || typeof t.fmk_pw != "string" || t.names !== void 0 || t.rekey !== void 0 || t.conv !== void 0) return null;
      const a = VL(t.vault);
      if (a === "malformed") return null;
      a === "newer" && n.push(`${ic} v${t.vault.v}`);
    } else if (t.vault !== void 0)
      return null;
    if (t.req.includes("names") && !jL(t.names)) return null;
    if (t.req.includes("rekey")) {
      if (t.fmk !== "wrapped" || !t.rekey || typeof t.rekey.from != "string") return null;
    } else if (t.rekey !== void 0)
      return null;
    if (t.req.includes("conv")) {
      if (!t.conv || typeof t.conv != "object" || t.conv.pending !== !0) return null;
    } else if (t.conv !== void 0)
      return null;
  } else if (t.req !== void 0 || t.names !== void 0 || t.rekey !== void 0 || t.conv !== void 0 || t.vault !== void 0)
    return null;
  return { marker: t, unsupported: n };
}
function VL(e) {
  var n;
  if (!e || typeof e != "object" || Array.isArray(e)) return "malformed";
  const t = e;
  return typeof t.v != "number" || !Number.isInteger(t.v) || t.v < 1 || typeof t.id != "string" || ((n = wo(t.id)) == null ? void 0 : n.length) !== Wy || !OL(t.pack) ? "malformed" : t.v > _x ? "newer" : null;
}
function Ur(e) {
  return !!e && e.v === So && Array.isArray(e.req) && e.req.length === 1 && e.req[0] === ic && !!e.vault;
}
function Lfe(e) {
  if (!Ur(e)) return null;
  const t = wo(e.vault.id);
  return t && t.length === Wy ? t : null;
}
function jL(e) {
  var t;
  return !!e && typeof e == "object" && e.alg === tx && e.enc === nx && typeof e.key == "string" && typeof e.long == "number" && Number.isInteger(e.long) && e.long >= 64 && e.long <= 255 && typeof e.root_id == "string" && ((t = wo(e.root_id)) == null ? void 0 : t.length) === yl;
}
function Rfe(e) {
  const t = Xf(e);
  return !t || t.unsupported.length > 0 ? null : t.marker;
}
function qi(e) {
  return !!e && e.v === So && Array.isArray(e.req) && e.req.includes("names") && !!e.names;
}
async function qL(e, t) {
  if (!qi(e)) return null;
  const n = await Ba(t, e.names.key);
  if (!n || n.length !== 64) return null;
  const a = await jy(n, e.names.long, wo(e.names.root_id));
  return n.fill(0), a;
}
async function E_(e, t) {
  if (e.v !== 2) throw new Error("e2e: only a v2 folder can switch to encrypted names");
  const n = await zx(t, !0);
  return { marker: {
    ...e,
    v: So,
    req: ["names"],
    names: n.slot
  }, names: n.key };
}
function WL(e) {
  if (!qi(e)) throw new Error("e2e: this folder has no encrypted names");
  const t = { ...e.names };
  return delete t.pending, { ...e, names: t };
}
const YL = ["content", "names", "vault"], Nfe = "content";
function Ife(e = {}) {
  return YL.filter((t) => t !== "vault" || e.vault === !0);
}
function GL(e) {
  return Ur(e) ? "vault" : e && qi(e) ? e.names.pending ? "pending" : "names" : "content";
}
function XL(e) {
  return !!e && e.v === 2 && !qi(e);
}
function C_(e) {
  return !!e && Xi(e) && !!e.rk;
}
function Mx(e) {
  return !!e && Xi(e) && !!e.esc;
}
function Ox(e, t) {
  return t ? Mx(e) ? e.esc.kid === t ? "available" : "other-key" : "predates" : "off";
}
async function Px(e, t) {
  const n = await Jo(t, ta(e.salt), e.iter), a = await Ba(n, e.verify);
  return !a || new TextDecoder().decode(a) !== Xo ? null : n;
}
async function Dx(e, t) {
  if (e.v === 1 || e.fmk === "kek") return t;
  if (!e.fmk_pw) return null;
  const n = await Ba(t, e.fmk_pw);
  if (!n || n.length !== ki) return null;
  const a = await Xy(e, n);
  return n.fill(0), a;
}
async function Bfe(e, t) {
  const n = await Px(e, t);
  return n ? Dx(e, n) : null;
}
async function Lx(e, t) {
  const n = await Px(e, t);
  if (!n) return { error: "wrong" };
  const a = await Dx(e, n);
  return a ? { fmk: a } : { error: "damaged" };
}
async function Rx(e, t) {
  if (!Xi(e) || !e.rk) return null;
  const n = Jy(t);
  if (!n) return null;
  let a;
  try {
    a = ta(e.rk.salt);
  } catch {
    return null;
  }
  const i = await Zy(n, a);
  n.fill(0);
  const r = await Ba(i, e.rk.blob);
  if (!r || r.length !== ki) return null;
  const l = await Xy(e, r);
  return r.fill(0), l;
}
async function Nx(e, t) {
  if (!Xi(e) || !e.esc || e.esc.alg !== Tx) return null;
  let n;
  try {
    n = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "RSA-OAEP" },
        t,
        kn(ta(e.esc.blob))
      )
    );
  } catch {
    return null;
  }
  if (n.length !== ki) return null;
  const a = await Xy(e, n);
  return n.fill(0), a;
}
function bl(e) {
  const t = e instanceof Uint8Array ? e : new Uint8Array(e);
  if (t.length < kf.length) return !1;
  for (let n = 0; n < kf.length; n++)
    if (t[n] !== kf[n]) return !1;
  return !0;
}
async function Uv(e, t) {
  if (t.byteLength > qu)
    throw new Error("e2e: file exceeds the 200MB single-shot limit");
  const n = crypto.getRandomValues(new Uint8Array(32)), a = await crypto.subtle.importKey("raw", kn(n), { name: "AES-GCM" }, !1, [
    "encrypt"
  ]), i = crypto.getRandomValues(new Uint8Array(ji)), r = crypto.getRandomValues(new Uint8Array(ji)), l = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: kn(i) }, e, kn(n))
  ), c = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: kn(r) }, a, t)
  );
  n.fill(0);
  const p = new Uint8Array(oc + c.length);
  return p.set(kf, 0), p[8] = Yy, p.set(i, ol), p.set(l, rl), p.set(r, Iv), p.set(c, oc), p.buffer;
}
async function Jf(e, t) {
  const n = new Uint8Array(t);
  if (!bl(n) || n.length < oc)
    throw new Error("e2e: not an encrypted file");
  if (n[8] === Cc) return $L(e, n);
  if (n[8] !== Yy)
    throw new Error(`e2e: unsupported version ${n[8]}`);
  const a = n.slice(ol, ol + ji), i = n.slice(rl, rl + Ax), r = n.slice(Iv, Iv + ji);
  let l;
  try {
    l = await crypto.subtle.decrypt({ name: "AES-GCM", iv: kn(a) }, e, kn(i));
  } catch {
    throw new un("e2e: DEK unwrap failed (wrong key?)");
  }
  const c = await crypto.subtle.importKey("raw", l, { name: "AES-GCM" }, !1, ["decrypt"]);
  try {
    return await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: kn(r) },
      c,
      kn(n.slice(oc))
    );
  } catch {
    throw new un("e2e: content decrypt failed");
  }
}
async function Ix(e, t) {
  if ("recoveryKey" in t) {
    if (!Xi(e) || !e.rk) throw new un("e2e: this folder has no recovery key");
    const l = Jy(t.recoveryKey);
    if (!l) throw new un("e2e: wrong recovery key");
    let c;
    try {
      c = ta(e.rk.salt);
    } catch {
      throw new un("e2e: damaged recovery slot");
    }
    const p = await Zy(l, c);
    l.fill(0);
    const m = await Ba(p, e.rk.blob);
    if (!m || m.length !== ki) throw new un("e2e: wrong recovery key");
    return m;
  }
  const n = ta(e.salt), a = await Jo(t.password, n, e.iter), i = await Ba(a, e.verify);
  if (!i || new TextDecoder().decode(i) !== Xo)
    throw new un("e2e: wrong password");
  if (e.v === 1 || e.fmk === "kek") return Gy(t.password, n, e.iter);
  const r = e.fmk_pw ? await Ba(a, e.fmk_pw) : null;
  if (!r || r.length !== ki) throw new un("e2e: could not unwrap the folder master key");
  return r;
}
async function Bx(e, t, n) {
  if ((e ?? "").length < Gf)
    throw new Error(`e2e: the new password must be at least ${Gf} characters`);
  const a = Math.max(Ep, n ?? Ap), i = crypto.getRandomValues(new Uint8Array(16)), r = await Jo(e, i, a);
  return {
    salt: Oa(i),
    iter: a,
    verify: await ni(r, new TextEncoder().encode(Xo)),
    fmk: "wrapped",
    fmk_pw: await ni(r, t)
  };
}
function Fx(e) {
  return e.v === 1 || e.fmk === "kek";
}
function sl(e) {
  return !!e && Array.isArray(e.req) && e.req.includes("rekey") && !!e.rekey;
}
async function Ux(e, t, n, a = {}) {
  if (Fx(e))
    throw new Error("e2e: this folder needs its file keys re-wrapped to change its password (startRekey)");
  if (sl(e)) throw new Error("e2e: finish the re-key first");
  const i = await Ix(e, t);
  try {
    return { ...e, ...await Bx(n, i, a.iterations) };
  } finally {
    i.fill(0);
  }
}
class Hx extends Error {
  constructor(t = "e2e: the escrow slot cannot be carried over to the new folder key") {
    super(t), this.name = "E2eRekeyEscrowError";
  }
}
async function JL(e, t, n, a = {}) {
  if (sl(e)) throw new Error("e2e: a re-key is already in progress; resume it");
  if (Ur(e)) throw new Error("e2e: a vault is not re-keyed; make a new vault instead");
  const i = await Ix(e, t), r = crypto.getRandomValues(new Uint8Array(ki));
  try {
    const l = await rc(i), c = await rc(r);
    let p;
    if (Xi(e) && e.esc) {
      const b = a.escrowPublicKey || null;
      if (!b || await Cx(b) !== e.esc.kid) throw new Hx();
      p = await Pc(r, b);
    }
    const m = "recoveryKey" in t, v = m ? t.recoveryKey : Cp();
    let x, k;
    if (qi(e)) {
      const b = await Ba(l, e.names.key);
      if (!b || b.length !== 64) throw new un("e2e: could not open the name key");
      k = { ...e.names, key: await ni(c, b) }, x = await jy(b, e.names.long, wo(e.names.root_id)), b.fill(0);
    }
    const _ = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "rekey"])), w = {
      ...e,
      v: So,
      req: _,
      ...await Bx(n, r, a.iterations),
      rk: await zp(r, v),
      rekey: { from: await ni(c, i), pending: !0 }
    };
    return p && (w.esc = p), k && (w.names = k), {
      marker: w,
      fmk: c,
      previous: l,
      recoveryKey: v,
      recoveryKeyIsNew: !m,
      ...x ? { names: x } : {}
    };
  } finally {
    i.fill(0), r.fill(0);
  }
}
async function ZL(e, t) {
  if (!sl(e)) return null;
  const n = await Ba(t, e.rekey.from);
  if (!n || n.length !== ki) return null;
  const a = await rc(n);
  return n.fill(0), a;
}
async function Kx(e, t, n) {
  const a = new Uint8Array(e);
  if (!bl(a) || a.length < oc) throw new Error("e2e: not an encrypted file");
  if (a[8] !== Yy && a[8] !== Cc) throw new Error(`e2e: unsupported version ${a[8]}`);
  const i = a.slice(ol, ol + ji), r = a.slice(rl, rl + Ax);
  try {
    return await crypto.subtle.decrypt({ name: "AES-GCM", iv: kn(i) }, n, kn(r)), null;
  } catch {
  }
  let l;
  try {
    l = new Uint8Array(
      await crypto.subtle.decrypt({ name: "AES-GCM", iv: kn(i) }, t, kn(r))
    );
  } catch {
    throw new un("e2e: this file opens under neither the new nor the previous folder key");
  }
  const c = crypto.getRandomValues(new Uint8Array(ji)), p = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: kn(c) }, n, kn(l))
  );
  l.fill(0);
  const m = a.slice();
  return m.set(c, ol), m.set(p, rl), m.buffer;
}
function z_(e) {
  var t;
  return !!e && Array.isArray(e.req) && e.req.includes("conv") && ((t = e.conv) == null ? void 0 : t.pending) === !0;
}
function QL(e, t = (/* @__PURE__ */ new Date()).toISOString(), n) {
  if (Ur(e)) throw new Error("e2e: a vault is never converted");
  const a = Array.from(/* @__PURE__ */ new Set([...e.req ?? [], "conv"])), i = { pending: !0, started: t, ...n ? { cleanup: n } : {} };
  return { ...e, v: So, req: a, conv: i };
}
function e4(e) {
  const t = { ...e };
  delete t.conv;
  const n = (e.req ?? []).filter((a) => a !== "conv");
  return n.length > 0 ? t.req = n : (delete t.req, t.v = Tp), t;
}
function t4(e) {
  const t = { ...e };
  delete t.rekey;
  const n = (e.req ?? []).filter((a) => a !== "rekey");
  return n.length > 0 ? t.req = n : (delete t.req, t.v = Tp), t;
}
async function n4(e, t, n) {
  try {
    return await Jf(e, n);
  } catch (a) {
    if (!t || !(a instanceof un)) throw a;
    return Jf(t, n);
  }
}
function a4() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return {
    get(a) {
      return e.get(a);
    },
    set(a, i, r, l) {
      e.set(a, i), r ? t.set(a, r) : t.delete(a), l ? n.set(a, l) : n.delete(a);
    },
    /** The previous FMK of a folder mid re-key (files not re-wrapped yet). */
    previous(a) {
      return n.get(a);
    },
    /** A re-key finished: the previous FMK is no longer needed. */
    dropPrevious(a) {
      n.delete(a);
    },
    /** The folder's name key; undefined for a content-only folder or a locked one. */
    names(a) {
      return t.get(a);
    },
    setNames(a, i) {
      e.has(a) && t.set(a, i);
    },
    /** Every unlocked root, for resolving a path from any view. */
    roots() {
      return [...e.keys()];
    },
    /** Drop one folder's keys ("Lock"). */
    lock(a) {
      e.delete(a), t.delete(a), n.delete(a);
    },
    has(a) {
      return e.has(a);
    },
    clear() {
      e.clear(), t.clear(), n.clear();
    }
  };
}
function Qy(e) {
  const t = e.indexOf("://");
  return t === -1 ? e : e.slice(t + 3);
}
function i4(e) {
  const t = Qy(String(e ?? "")), n = t.lastIndexOf("/");
  return n === -1 ? "" : t.slice(0, n);
}
function Or(e) {
  return typeof e.e2e_display_dir == "string" ? e.e2e_display_dir : i4(e.path);
}
function o4(e) {
  return (e || []).filter((t) => !(gp(t.basename) || Lf(t.path) || t.basename === ".trash" || t.basename === ka));
}
const Vx = "filex.showHidden";
function r4() {
  try {
    return localStorage.getItem(Vx) === "1";
  } catch {
    return !1;
  }
}
const Wu = S(r4());
function s4(e) {
  Wu.value = e;
  try {
    localStorage.setItem(Vx, e ? "1" : "0");
  } catch {
  }
}
function l4(e, t) {
  return t ? e || [] : (e || []).filter((n) => !(n.basename || "").startsWith("."));
}
function Tr(e) {
  return l4(o4(e), Wu.value);
}
function u4(e) {
  const t = Qy(e);
  return t === "fileman" || t === "";
}
function c4(e) {
  return Qy(e).startsWith("fileman/.trash");
}
function d4(e) {
  return {
    type: "dir",
    path: `${e}://fileman/.trash`,
    basename: ".trash",
    extension: "",
    storage: e,
    visibility: "private",
    size: 0,
    file_size: 0,
    mime_type: "inode/directory",
    extra_metadata: {}
  };
}
function jx(e, t, n, a, i = {}) {
  return !a || i.navOffersTrash || i.isSearchResult || c4(n) || !u4(n) ? !1 : (e.unshift(d4(t)), !0);
}
async function qx(e, t, n) {
  try {
    const { storages: a } = await n.listTrash(t, { limit: 1 }), i = e.find((c) => c.basename === ".trash");
    if (!i) return;
    const r = (a ?? []).find((c) => c.storage_name === t);
    i.size = (r == null ? void 0 : r.bytes) ?? 0;
    const l = r != null && r.newest_deleted_at ? Date.parse(r.newest_deleted_at) : NaN;
    Number.isNaN(l) || (i.last_modified = l);
  } catch {
  }
}
const Wx = {
  /* gorunum:v3-shell — Home is a destination like the rest, so it gets a
     sentinel like the rest: a restored tab, a reload and a pasted `#.home`
     all have to reopen the overview instead of asking the backend for a
     folder called `.home` and landing on "not found". */
  ".home": "node.home",
  ".trash": "node.trash",
  ".recent": "node.recent",
  ".starred": "node.starred",
  ".shared": "node.shared",
  /* Drafts (issue #71): a view like the rest — a reload on `#.drafts` opens
     it, instead of asking the backend for a folder called `.drafts`. */
  ".drafts": "node.drafts"
}, Yx = ".tag~", Gx = [
  [".mytag~", "personal"],
  [".teamtag~", "team"],
  [Yx, ""]
];
function f4(e, t = "") {
  var a;
  return `${((a = Gx.find(([, i]) => i === t)) == null ? void 0 : a[0]) ?? Yx}${e}`;
}
function eg(e) {
  for (const [t, n] of Gx)
    if (e.startsWith(t)) {
      const a = e.slice(t.length);
      return a ? { tag: a, kind: n } : null;
    }
  return null;
}
function Xx(e) {
  var t;
  return ((t = eg(e)) == null ? void 0 : t.tag) ?? "";
}
function p4(e) {
  var n;
  const t = (e || "").replace(/^\/+|\/+$/g, "");
  return ((n = eg(t.split("/").pop() || t)) == null ? void 0 : n.kind) ?? "";
}
function h4(e) {
  const t = (e || "").replace(/^\/+|\/+$/g, "");
  return Xx(t.split("/").pop() || t);
}
function Zf(e, t) {
  const n = Wx[e];
  if (n) return t(n);
  const a = eg(e);
  return a ? a.kind ? `#${a.tag} · ${t(`tags.kind.${a.kind}`)}` : `#${a.tag}` : "";
}
function Jx(e) {
  const t = String(e ?? "").replace(/^\/+|\/+$/g, "");
  return t ? !!Wx[t] || !!Xx(t) : !1;
}
function Qf(e, t) {
  const n = e.type === "dir" ? 0 : 1, a = t.type === "dir" ? 0 : 1;
  return n - a;
}
function Mp() {
  return { w: {}, hidden: [] };
}
function Op(e, t) {
  const n = Mp();
  if (!e || typeof e != "object" || Array.isArray(e)) return n;
  const a = (p) => t.find((m) => m.id === p), i = e, r = {};
  if (i.w && typeof i.w == "object")
    for (const [p, m] of Object.entries(i.w)) {
      const v = a(p);
      !v || typeof m != "number" || !Number.isFinite(m) || (r[v.id] = Math.min(v.max, Math.max(v.min, Math.round(m))));
    }
  const l = Array.isArray(i.hidden) ? [...new Set(i.hidden.filter((p) => {
    var m;
    return (m = a(p)) == null ? void 0 : m.hideable;
  }))] : [], c = Array.isArray(i.o) ? [...new Set(i.o.filter((p) => !!a(p)))] : void 0;
  return c && c.length ? { w: r, hidden: l, o: c } : { w: r, hidden: l };
}
function Zx(e, t, n) {
  const a = [...e];
  if (t < 0 || t >= a.length) return a;
  const i = Math.max(0, Math.min(a.length - 1, n));
  if (i === t) return a;
  const [r] = a.splice(t, 1);
  return a.splice(i, 0, r), a;
}
function Qx(e, t) {
  const n = (r) => {
    var l;
    return ((l = t.find((c) => c.id === r)) == null ? void 0 : l.hideable) === !0;
  };
  let a = 0;
  for (; a < e.length && !n(e[a]); ) a++;
  let i = e.length - 1;
  for (; i >= 0 && !n(e[i]); ) i--;
  return { lo: a, hi: Math.max(a, i) };
}
const m4 = 3;
function eS(e, t, n = {}) {
  var T;
  const a = n.lead ?? ((T = e()[0]) == null ? void 0 : T.id), i = E(() => Op(t.get(), e())), r = (R) => e().find((M) => M.id === R);
  function l(R) {
    t.set(R);
  }
  function c() {
    const R = e().map((U) => U.id), M = i.value.o;
    if (!M || M.length === 0)
      return [a, ...R.filter((U) => U !== a)];
    const L = M.filter((U) => R.includes(U) && U !== a);
    L.unshift(a);
    for (const U of R) L.includes(U) || L.push(U);
    return L;
  }
  function p(R) {
    const M = r(R);
    return M ? i.value.w[R] ?? M.width : 0;
  }
  function m(R, M) {
    const L = r(R);
    if (!L || !L.resizable) return;
    const U = Math.min(L.max, Math.max(L.min, Math.round(M)));
    i.value.w[R] !== U && l({ ...i.value, w: { ...i.value.w, [R]: U } });
  }
  function v() {
    return i.value.w[a] === void 0;
  }
  function x(R) {
    const M = { ...i.value.w };
    let L = !1;
    for (const [U, P] of Object.entries(R)) {
      if (typeof P != "number" || !Number.isFinite(P) || M[U] !== void 0) continue;
      const H = r(U);
      !H || !H.resizable || (M[U] = Math.min(H.max, Math.max(H.min, Math.round(P))), L = !0);
    }
    L && l({ ...i.value, w: M });
  }
  function k(R) {
    return i.value.hidden.includes(R);
  }
  function _(R, M) {
    const L = r(R);
    if (!L || !L.hideable || R === a || k(R) === M) return;
    const U = new Set(i.value.hidden);
    M ? U.add(R) : U.delete(R), l({ ...i.value, hidden: [...U] });
  }
  function w(R, M) {
    const L = r(R);
    if (!L || !L.hideable || R === a) return;
    const U = c(), P = U.indexOf(R);
    if (P === -1) return;
    const H = Qx(U, e()), $ = Math.max(H.lo, Math.min(H.hi, M)), F = Zx(U, P, $);
    F.join() !== U.join() && l({ ...i.value, o: F });
  }
  function b() {
    l(Mp());
  }
  function C() {
    var R;
    return t.customised ? t.customised() : Object.keys(i.value.w).length > 0 || i.value.hidden.length > 0 || (((R = i.value.o) == null ? void 0 : R.length) ?? 0) > 0;
  }
  function A(R, M, L = {}) {
    var X;
    const U = L.gap ?? 8, P = L.padding ?? 24, H = L.check ?? 0, $ = L.menu ?? 28, F = r(a), I = c().filter((te) => te !== a && M.includes(te) && !k(te)), Z = {};
    for (const te of I) Z[te] = p(te);
    Z[a] = p(a);
    const J = (te) => {
      const V = (H > 0 ? 1 : 0) + 1 + te + 1;
      return H + $ + P + U * (V - 1);
    }, re = J(I.length), ve = v(), W = L.leadAuto ?? (F == null ? void 0 : F.width) ?? Z[a], z = F ? Math.min(W, F.min) : Z[a], le = I.slice(0, m4), fe = J(le.length) + z + le.reduce((te, V) => {
      var G;
      return te + (((G = r(V)) == null ? void 0 : G.min) ?? Z[V]);
    }, 0);
    if (ve && R > 0 && F) {
      const te = R - re;
      let V = I.reduce((q, B) => q + Z[B], 0);
      const G = te - W;
      if (V > G) {
        const q = I.reduce((B, K) => {
          var ke;
          return B + (Z[K] - (((ke = r(K)) == null ? void 0 : ke.min) ?? Z[K]));
        }, 0);
        if (q > 0) {
          const B = Math.min(1, (V - G) / q);
          for (const K of I) {
            const ke = ((X = r(K)) == null ? void 0 : X.min) ?? Z[K];
            Z[K] = Math.max(ke, Z[K] - Math.ceil((Z[K] - ke) * B));
          }
          V = I.reduce((K, ke) => K + Z[ke], 0);
        }
      }
      Z[a] = Math.round(Math.max(z, Math.min(F.max, te - V)));
    }
    const j = re + Z[a] + I.reduce((te, V) => te + Z[V], 0);
    return { visible: I, widths: Z, total: j, auto: ve, stackBelow: fe };
  }
  return {
    lead: a,
    specs: e,
    spec: r,
    order: c,
    width: p,
    setWidth: m,
    hidden: k,
    setHidden: _,
    move: w,
    widthsAreAuto: v,
    freeze: x,
    reset: b,
    customised: C,
    state: () => i.value,
    layout: A
  };
}
function v4(e = Mp()) {
  const t = Ea(e);
  return {
    get: () => t.value,
    set: (n) => {
      t.value = n;
    }
  };
}
let Ji = null;
const Qr = S(!1), Dc = S(!1);
function js() {
  return Qr.value;
}
function Ffe() {
  return !0;
}
function Ufe(e) {
}
function tS() {
  return Math.floor(Date.now() / 1e3);
}
function tg(e) {
  return e === "list" || e === "grid" || e === "gallery";
}
function ng(e) {
  return e === "name" || e === "type" || e === "modified" || e === "size";
}
function ag(e) {
  return e === "asc" || e === "desc";
}
function Hr(e) {
  var t;
  return !!e && (Object.keys(e.w).length > 0 || e.hidden.length > 0 || (((t = e.o) == null ? void 0 : t.length) ?? 0) > 0);
}
const Hn = S({});
function y4(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = {};
  for (const [n, a] of Object.entries(e)) {
    if (!a || typeof a != "object") continue;
    const i = a, l = { t: typeof i.t == "number" && Number.isFinite(i.t) ? i.t : 0 };
    if (tg(i.v) && (l.v = i.v), ng(i.k) && (l.k = i.k), ag(i.d) && (l.d = i.d), i.c !== void 0) {
      const c = Op(i.c, Zo);
      Hr(c) && (l.c = c);
    }
    (l.v || l.k || l.c) && (t[n] = l);
  }
  return t;
}
const M_ = 300;
function g4() {
  const e = Object.entries(Hn.value);
  if (e.length <= M_) return;
  e.sort((n, a) => a[1].t - n[1].t);
  const t = {};
  for (const [n, a] of e.slice(0, M_)) t[n] = a;
  Hn.value = t;
}
function O_(e, t) {
  const n = String(e ?? "").trim(), a = String(t ?? "").replace(/^[a-z][a-z0-9+.-]*:\/\//i, "").replace(/\/{2,}/g, "/").replace(/^\/+|\/+$/g, "");
  return n ? a ? `${n}/${a}` : n : a;
}
const b4 = ".root", Cm = {};
function nS(e) {
  if (!e) return null;
  const t = Hn.value[e];
  if (t) {
    const { t: n, ...a } = t, i = Cm[e];
    return i && !a.k ? { ...i, ...a } : a;
  }
  return Cm[e] ? { ...Cm[e] } : null;
}
function Hv(e) {
  return !!e && !!Hn.value[e];
}
function k4() {
  return Object.keys(Hn.value).length;
}
function aS(e, t) {
  if (!e) return;
  const n = Hn.value[e], a = { ...n ?? {}, ...t, t: tS() };
  if (t.c !== void 0 && !Hr(t.c) && delete a.c, !a.v && !a.k && !a.c) {
    n && iS(e);
    return;
  }
  Hn.value = { ...Hn.value, [e]: a }, g4(), _o();
}
function w4(e) {
  if (!e) return;
  const t = Hn.value[e];
  if (!t) return;
  const n = tS();
  t.t !== n && (Hn.value = { ...Hn.value, [e]: { ...t, t: n } }, _o());
}
function iS(e) {
  if (!e || !Hn.value[e]) return;
  const t = { ...Hn.value };
  delete t[e], Hn.value = t, _o();
}
function Hfe() {
  Hn.value = {}, _o();
}
const Ma = S({}), Lc = S({});
function ig(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = e, n = {};
  if (tg(t.v) && (n.v = t.v), ng(t.k) && (n.k = t.k, ag(t.d) && (n.d = t.d)), t.c !== void 0) {
    const a = Op(t.c, Zo);
    Hr(a) && (n.c = a);
  }
  return n;
}
function _4(e) {
  let t = e;
  if (typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      return {};
    }
  if (!t || typeof t != "object" || Array.isArray(t)) return {};
  const n = t, a = {};
  if (tg(n.v) && (a.v = n.v), ng(n.k) && (a.k = n.k, ag(n.d) && (a.d = n.d)), Array.isArray(n.hidden)) {
    const i = n.hidden.filter(
      (r) => typeof r == "string" && Zo.some((l) => l.id === r && l.hideable)
    );
    i.length && (a.hidden = [...new Set(i)]);
  }
  return a;
}
function Kfe() {
  return Ma.value;
}
function oS(e) {
  const t = { ...Ma.value };
  for (const [n, a] of Object.entries(e))
    a == null ? delete t[n] : t[n] = a;
  Ma.value = ig(t), sc(), _o();
}
function x4(e) {
  Ma.value = ig({ ...Ma.value, ...e }), Hn.value = {}, sc(), _o();
}
function Vfe() {
  return Lc.value;
}
function S4(e) {
  Lc.value = _4(e), sc();
}
function Pp() {
  const e = Ma.value, t = Lc.value, n = {}, a = e.v ?? t.v;
  return a && (n.v = a), e.k ? (n.k = e.k, e.d && (n.d = e.d)) : t.k && (n.k = t.k, t.d && (n.d = t.d)), n;
}
function $4(e) {
  const t = nS(e), n = Pp(), a = {}, i = (t == null ? void 0 : t.v) ?? n.v;
  return i && (a.v = i), t != null && t.k ? (a.k = t.k, t.d && (a.d = t.d)) : n.k && (a.k = n.k, n.d && (a.d = n.d)), a;
}
const Zo = [
  { id: "name", width: 260, min: 120, max: 900, hideable: !1, resizable: !0 },
  { id: "type", width: 88, min: 64, max: 220, hideable: !0, resizable: !0 },
  { id: "location", width: 160, min: 80, max: 420, hideable: !0, resizable: !0 },
  { id: "owner", width: 104, min: 72, max: 260, hideable: !0, resizable: !0 },
  { id: "modified", width: 160, min: 96, max: 300, hideable: !0, resizable: !0 },
  /* The Trash only: how long an item has left before it is purged. */
  { id: "remaining", width: 112, min: 80, max: 220, hideable: !0, resizable: !0 },
  { id: "size", width: 88, min: 64, max: 200, hideable: !0, resizable: !0 },
  { id: "star", width: 24, min: 24, max: 24, hideable: !1, resizable: !1 }
], P_ = { check: 28, menu: 28 }, jfe = 120, T4 = 220, rS = {
  gap: 8,
  padding: 24,
  check: P_.check,
  menu: P_.menu,
  leadAuto: T4
};
function D_() {
  if (Ma.value.c) return Ma.value.c;
  const e = Lc.value.hidden;
  return e && e.length ? { w: {}, hidden: [...e] } : Mp();
}
function sS(e) {
  return eS(
    () => Zo,
    {
      get: () => {
        var n;
        const t = e();
        return t ? ((n = Hn.value[t]) == null ? void 0 : n.c) ?? D_() : D_();
      },
      set: (t) => {
        const n = e();
        if (!n) {
          oS({ c: Hr(t) ? t : void 0 });
          return;
        }
        aS(n, { c: t });
      },
      customised: () => {
        var n;
        const t = e();
        return t ? !!((n = Hn.value[t]) != null && n.c) : Hr(Ma.value.c);
      }
    },
    { lead: "name" }
  );
}
const ri = sS(() => "");
function Kv() {
  return ri.order();
}
const qfe = Zx;
function Wfe(e) {
  return Qx(e, Zo);
}
function Yfe(e, t) {
  ri.move(e, t);
}
function Gfe(e, t) {
  const n = Kv().filter((l) => {
    var c;
    return (c = Zo.find((p) => p.id === l)) == null ? void 0 : c.hideable;
  }), a = n.indexOf(e);
  if (a === -1) return;
  const i = a + t;
  if (i < 0 || i >= n.length) return;
  const r = n[i];
  ri.move(e, Kv().indexOf(r));
}
function Xfe(e, t) {
  const n = Kv().filter((i) => {
    var r;
    return (r = Zo.find((l) => l.id === i)) == null ? void 0 : r.hideable;
  }), a = n.indexOf(e);
  return a === -1 ? !1 : a + t >= 0 && a + t < n.length;
}
function Jfe(e) {
  return ri.width(e);
}
function Zfe(e, t) {
  ri.setWidth(e, t);
}
function Qfe() {
  return ri.widthsAreAuto();
}
function epe(e) {
  ri.freeze(e);
}
function tpe(e) {
  return ri.hidden(e);
}
function npe(e, t) {
  ri.setHidden(e, t);
}
function ape() {
  ri.reset();
}
function ipe() {
  return ri.customised();
}
function ope(e, t, n = {}) {
  return ri.layout(e, t, { ...rS, ...n });
}
const Qd = {
  sort: "filex.list-sort",
  view: "brf-file-explorer:view-mode"
};
function sc() {
  const e = Pp();
  try {
    if (e.k) {
      const t = e.d ?? (e.k === "modified" ? "desc" : "asc");
      localStorage.setItem(Qd.sort, JSON.stringify({ key: e.k, dir: t }));
    } else localStorage.removeItem(Qd.sort);
    e.v ? localStorage.setItem(Qd.view, e.v) : localStorage.removeItem(Qd.view);
  } catch {
  }
}
const lS = ["on", "f", "p", "c", "g", "u"], lc = S(0), ho = S({});
function A4(e) {
  const t = {};
  for (const [n, a] of Object.entries(e))
    lS.includes(n) || (t[n] = a);
  return t;
}
function E4() {
  const e = {
    ...ho.value,
    on: !0,
    f: Hn.value,
    u: lc.value
  };
  return Object.keys(Ma.value).length && (e.p = Ma.value), e;
}
function C4(e) {
  if (!e || lS.includes(e))
    throw new Error(`viewPrefsSlot: "${e}" is reserved by lib/viewPrefs`);
  return {
    get: () => ho.value[e],
    set(t) {
      ho.value = { ...ho.value, [e]: t }, _o();
    },
    clear() {
      if (!(e in ho.value)) return;
      const t = { ...ho.value };
      delete t[e], ho.value = t, _o();
    },
    ready: () => Qr.value,
    persistable: () => Dc.value
  };
}
const z4 = 800;
let yo, uc = !1;
function _o() {
  !Qr.value || !Dc.value || !Ji || (uc = !0, yo && clearTimeout(yo), yo = setTimeout(kl, z4));
}
function kl() {
  yo && clearTimeout(yo), yo = void 0, !(!uc || !Ji || !Dc.value) && (uc = !1, lc.value = Date.now(), Ji.save(E4()));
}
typeof window < "u" && (window.addEventListener("pagehide", kl), window.addEventListener("visibilitychange", () => {
  typeof document < "u" && document.visibilityState === "hidden" && kl();
}));
function M4(e) {
  Ji || (Ji = e, (async () => (await cS(!0), Qr.value = !0, P4()))());
}
function rpe() {
  kl(), dS();
}
function spe() {
  return Ji !== null;
}
const ep = /* @__PURE__ */ new Set();
function uS(e) {
  return ep.add(e), () => ep.delete(e);
}
function L_() {
  for (const e of ep)
    try {
      e();
    } catch {
    }
}
async function cS(e) {
  if (!Ji) return;
  let t = null;
  try {
    t = await Ji.load();
  } catch {
    t = null;
  }
  if (!t || typeof t != "object" || Array.isArray(t)) {
    sc(), L_();
    return;
  }
  const n = t, a = typeof n.u == "number" && Number.isFinite(n.u) ? n.u : 0;
  if (!e) {
    if (uc) {
      kl();
      return;
    }
    if (a <= lc.value) return;
  }
  Hn.value = y4(n.f);
  let i = !1;
  if (n.p !== void 0)
    Ma.value = ig(n.p);
  else {
    const r = Op(n.c, Zo);
    Ma.value = Hr(r) ? { c: r } : {}, i = Hr(r) || n.g !== void 0 || n.c !== void 0;
  }
  lc.value = a, ho.value = A4(n), Dc.value = !0, sc(), i && (Qr.value = !0, _o()), L_();
}
const O4 = 3e3;
let Vv = 0, R_ = !1;
function N_(e = !1) {
  if (!Ji || !Qr.value) return;
  const t = Date.now();
  !e && t - Vv < O4 || (Vv = t, cS(!1));
}
function P4() {
  R_ || typeof window > "u" || (R_ = !0, window.addEventListener("focus", () => N_()), typeof document < "u" && document.addEventListener("visibilitychange", () => {
    document.visibilityState === "visible" && N_();
  }));
}
function dS() {
  Ji = null, Qr.value = !1, Dc.value = !1, Hn.value = {}, Ma.value = {}, Lc.value = {}, lc.value = 0, Vv = 0, ho.value = {}, uc = !1, yo && clearTimeout(yo), yo = void 0;
}
function lpe() {
  dS(), ep.clear();
}
function upe() {
  kl();
}
const og = ["name", "type", "modified", "size"], D4 = "filex.list-sort", Yu = "name";
function wl(e) {
  return e === "modified" ? "desc" : "asc";
}
function L4(e) {
  return typeof e == "string" && og.includes(e);
}
function R4() {
  const e = { key: Yu, dir: wl(Yu) };
  if (typeof localStorage > "u") return e;
  try {
    const t = localStorage.getItem(D4);
    if (!t) return e;
    const n = JSON.parse(t), a = L4(n.key) ? n.key : Yu, i = n.dir === "asc" || n.dir === "desc" ? n.dir : wl(a);
    return { key: a, dir: i };
  } catch {
    return e;
  }
}
const fS = S("en");
function rg(e) {
  fS.value = e;
}
function I_(e) {
  const t = e.last_modified;
  return t ? t * (t < 1e12 ? 1e3 : 1) : null;
}
function pS(e, t) {
  return (e || "").localeCompare(t || "", void 0, {
    numeric: !0,
    sensitivity: "base"
  });
}
function B_(e, t) {
  return pS(e.basename, t.basename);
}
function F_(e) {
  const t = X2(e);
  if (t)
    return (v_[fS.value] ?? v_.en)[t] ?? t;
  const n = (e.extension || "").trim();
  return n ? n.toUpperCase() : "";
}
function N4(e, t, n, a) {
  const i = t === "asc" ? 1 : -1;
  switch (e) {
    case "name":
      return i * B_(n, a);
    case "size":
      return i * ((n.size ?? -1) - (a.size ?? -1));
    case "type": {
      const r = F_(n).localeCompare(F_(a), void 0, { sensitivity: "base" });
      return r !== 0 ? i * r : B_(n, a);
    }
    default: {
      const r = I_(n), l = I_(a);
      return r == null && l == null ? 0 : r == null ? 1 : l == null ? -1 : i * (r - l);
    }
  }
}
const hS = /* @__PURE__ */ new Set(), jv = /* @__PURE__ */ new WeakMap();
function mS() {
  const e = sg(), t = S(e.key), n = S(e.dir);
  function a(v, x) {
    t.value = v, n.value = x ?? wl(v);
  }
  function i(v, x) {
    t.value = v, n.value = x;
  }
  function r() {
    n.value = n.value === "asc" ? "desc" : "asc";
  }
  function l(v) {
    t.value === v ? r() : a(v);
  }
  function c(v, x) {
    return Qf(v, x) || N4(t.value, n.value, v, x);
  }
  function p(v) {
    return v === "relevance" ? Qf : c;
  }
  const m = {
    key: t,
    dir: n,
    setSort: a,
    applySort: i,
    toggleSortDir: r,
    chooseSortKey: l,
    compareNodes: c,
    compareInOrder: p,
    sortListing: (v, x = "sort") => [...v || []].sort(p(x))
  };
  return hS.add(m), jv.set(m, { ...e }), m;
}
const Dp = mS(), vS = Symbol("fe-sort-store");
function Rc() {
  return bi(vS, Dp);
}
function U_() {
  return Dp.key.value;
}
function H_() {
  return Dp.dir.value;
}
function K_(e, t) {
  Dp.applySort(e, t);
}
function sg() {
  const e = Pp();
  return e.k ? { key: e.k, dir: e.d ?? wl(e.k) } : js() ? { key: Yu, dir: wl(Yu) } : R4();
}
uS(() => {
  const e = sg();
  for (const t of hS) {
    const n = jv.get(t);
    !n || t.key.value !== n.key || t.dir.value !== n.dir || (t.applySort(e.key, e.dir), jv.set(t, { ...e }));
  }
});
function I4(e) {
  const t = `${(e.apiBase ?? "").replace(/\/+$/, "")}/api/files/manager/view-prefs`, n = e.credentials ?? "same-origin";
  return {
    async load() {
      var r;
      const a = await fetch(t, {
        headers: { ...await ((r = e.headers) == null ? void 0 : r.call(e)) ?? {} },
        credentials: n
      });
      if (!a.ok) return null;
      const i = await a.json();
      return S4((i == null ? void 0 : i.instance_default) ?? null), (i == null ? void 0 : i.prefs) ?? null;
    },
    save(a) {
      (async () => {
        var i;
        try {
          const r = JSON.stringify({ prefs: a });
          await fetch(t, {
            method: "PUT",
            headers: {
              ...await ((i = e.headers) == null ? void 0 : i.call(e)) ?? {},
              "Content-Type": "application/json"
            },
            credentials: n,
            body: r,
            /* ⚠ `keepalive` is what lets the save fired on `pagehide` outlive
             * the page — but browsers reject a keepalive body over 64 KB
             * outright, so the flag goes only on documents that fit. */
            keepalive: r.length < 6e4
          });
        } catch {
        }
      })();
    }
  };
}
function B4(e) {
  M4(I4(e));
}
const yS = Symbol("fe-table-env");
function F4(e) {
  jo(yS, e);
}
function U4() {
  return bi(yS, null);
}
function zm(e, t, n) {
  return e ? {} : t ? { disabled: !0, title: n } : { hidden: !0 };
}
function cpe(e) {
  var n;
  if (!e) return !1;
  const t = (n = e.external) == null ? void 0 : n.onlyoffice;
  return t && !pv(t) ? !1 : !!e.onlyoffice_url;
}
const Mm = {
  links: "share.links",
  uploadLinks: "share.upload_links",
  users: "share.users"
}, H4 = Object.freeze({ links: !0, uploadLinks: !0, users: !0 });
function K4(e) {
  return {
    links: e(Mm.links),
    uploadLinks: e(Mm.uploadLinks),
    users: e(Mm.users)
  };
}
function V4(e, t) {
  return e.links || e.users || t && e.uploadLinks;
}
function j4(e) {
  const t = e.indexOf("://");
  return t > 0 && e.slice(t + 3).replace(/\/+/g, "") === "";
}
function dpe(e, t) {
  return j4(e) ? { ...t, links: !1, uploadLinks: !1 } : t;
}
function q4(e) {
  const t = String(e.storage || e.path).replace(/:\/\/.*$/, "").replace(/^\/+|\/+$/g, "");
  return {
    path: `${t}://`,
    basename: e.basename || t,
    type: "dir",
    mime_type: "inode/storage",
    perm: "owner"
  };
}
function W4(e, t) {
  return [
    { key: "open", label: e("ctx.open") },
    { key: "open-tab", label: e("ctx.open_new_tab") },
    {
      key: "storage-access",
      label: e("ctx.storage_access"),
      icon: "access",
      hidden: !(t.manages && t.shareUsers)
    }
  ];
}
const Y4 = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function gS(e) {
  return typeof e == "string" && Y4.has(e) ? e : void 0;
}
function G4(e) {
  const t = {};
  if (!Array.isArray(e)) return t;
  for (const n of e) {
    const a = n, i = gS(a == null ? void 0 : a.perm);
    typeof (a == null ? void 0 : a.name) == "string" && i && (t[a.name] = i);
  }
  return t;
}
function X4(e, t, n) {
  var a;
  return gS((a = t == null ? void 0 : t.find((i) => i.name === e)) == null ? void 0 : a.perm) ?? n[e];
}
function J4(e) {
  return e.admin || e.level === "owner";
}
function bS(e, t) {
  return e && !t;
}
function V_(e, t, n) {
  return bS(e, t) && (n == null ? void 0 : n.visible) === !0;
}
function kS(e, t) {
  return t ? !0 : e.some(Ry);
}
function wS(e, t = {}) {
  return t.busy || e.op_type !== "plugin" || e.status !== "done" || !e.plugin || !kp(e.open) ? null : { plugin: e.plugin, open: e.open };
}
const Z4 = ["standard", "simple"], Om = "standard", qv = /* @__PURE__ */ new Set();
function Q4(e) {
  if (e === "simple") return "simple";
  if (e === "standard" || e === void 0 || e === null || e === "")
    return Om;
  const t = typeof e == "string" ? e : String(e);
  return !qv.has(t) && typeof console < "u" && (qv.add(t), console.warn(
    `[filex] unknown uiProfile ${JSON.stringify(t)} - using "${Om}". Valid values: ${Z4.map((n) => `"${n}"`).join(", ")}. (The former "drive" profile was removed; pass "simple" for the reduced explorer.)`
  )), Om;
}
function fpe() {
  qv.clear();
}
function Xs(e, t) {
  return e ? e.endsWith("://") || e.endsWith("/") ? e + t : `${e}/${t}` : t;
}
function Ia(e) {
  const t = e.indexOf("://"), n = t === -1 ? "" : e.slice(0, t + 3), a = (t === -1 ? e : e.slice(t + 3)).replace(/\/+$/, ""), i = a.lastIndexOf("/");
  return i === -1 ? n : n + a.slice(0, i);
}
function ll(e) {
  const t = e.indexOf("://"), n = (t === -1 ? e : e.slice(t + 3)).replace(/\/+$/, ""), a = n.lastIndexOf("/");
  return a === -1 ? n : n.slice(a + 1);
}
function Dn(e) {
  const t = e.indexOf("://");
  return t === -1 ? e.replace(/^\/+|\/+$/g, "") : e.slice(0, t + 3) + e.slice(t + 3).replace(/^\/+|\/+$/g, "");
}
function Pm(e) {
  const t = e.indexOf("://");
  return t === -1 ? e : e.slice(t + 3);
}
function Js(e, t) {
  const n = Dn(e), a = Dn(t);
  if (!a) return !1;
  const i = a.endsWith("://") ? a : `${a}/`;
  return n.length > i.length && n.startsWith(i);
}
function j_(e, t) {
  const n = Dn(e), a = Dn(t), i = a.endsWith("://") ? a : `${a}/`;
  return n.slice(i.length).split("/").filter(Boolean);
}
function wf(e) {
  return typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename;
}
function e5(e) {
  const { api: t, ring: n } = e, a = S(0), i = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Set();
  function p() {
    a.value++;
  }
  async function m(W) {
    try {
      const { blob: z, url: le } = await t.fetchBlob(Xs(W, ka), { fresh: !0 });
      URL.revokeObjectURL(le);
      const fe = Xf(await z.text()), j = fe ? { marker: fe.marker, unsupported: fe.unsupported } : { marker: null, unsupported: [] };
      return r.set(W, j.marker), j;
    } catch {
      return r.set(W, null), { marker: null, unsupported: [] };
    }
  }
  async function v(W) {
    const z = Dn(W);
    let le = i.get(z);
    return le || (le = m(z), i.set(z, le)), (await le).marker;
  }
  function x(W) {
    const z = Dn(W);
    return r.has(z) ? r.get(z) : void 0;
  }
  function k(W, z) {
    const le = Dn(W);
    r.set(le, z), i.set(le, Promise.resolve({ marker: z, unsupported: [] })), p();
  }
  function _(W) {
    const z = Dn(W);
    i.delete(z), r.delete(z), l.delete(z);
    for (const le of [...A.keys()]) le.startsWith(`${z}|`) && A.delete(le);
    p();
  }
  function w(W) {
    return qi(x(W) ?? null);
  }
  function b(W, z) {
    if (z && Js(W, z)) return Dn(z);
    let le = null;
    const fe = /* @__PURE__ */ new Set([...n.roots(), ...r.keys()]);
    for (const j of fe)
      Js(W, j) && (!le || j.length > le.length) && (le = Dn(j));
    return le;
  }
  function C(W) {
    const z = Dn(W);
    let le = l.get(z);
    return le || (le = /* @__PURE__ */ new Map(), l.set(z, le)), le;
  }
  const A = /* @__PURE__ */ new Map();
  function T(W, z, le) {
    const fe = Dn(le), j = Dn(z);
    if (fe === j || !Js(fe, j)) return Promise.resolve(W.rootId);
    const X = `${j}|${fe}`;
    let te = A.get(X);
    return te || (te = T(W, z, Ia(fe)).then((V) => Mv(W, V, ll(fe))), A.set(X, te)), te;
  }
  const R = /* @__PURE__ */ new Map();
  function M(W, z, le, fe) {
    const j = C(z), X = `${Dn(le)}/${fe}`, te = j.get(X);
    if (te) return Promise.resolve(te);
    const V = `${Dn(z)}|${X}`, G = R.get(V);
    if (G) return G;
    const q = T(W, z, le).then((B) => cx(W, fe, B, async (K) => {
      try {
        const ke = await t.fetchArrayBuffer(Xs(le, K));
        return new TextDecoder().decode(ke);
      } catch {
        return null;
      }
    })).then((B) => (B.state !== "unreadable" && j.set(X, B), B)).finally(() => R.delete(V));
    return R.set(V, q), q;
  }
  function L(W, z, le, fe) {
    C(W).set(`${Dn(z)}/${le.stored}`, { name: fe, state: "enc" }), p();
  }
  async function U(W, z) {
    const le = n.names(W), fe = j_(z, W);
    if (!le) return fe.map(() => null);
    const j = [];
    let X = Dn(W);
    for (const te of fe) {
      const V = await M(le, W, X, te);
      j.push(V.name), X = Xs(X, te);
    }
    return j;
  }
  async function P(W) {
    const z = b(W);
    if (!z) return null;
    const le = n.names(z);
    return le ? M(le, z, Ia(W), ll(W)) : null;
  }
  async function H(W, z) {
    const le = Pm(Dn(W)), j = (await U(W, Ia(z))).map((X) => X === null ? e.lockedLabel() : X);
    return [le, ...j].filter(Boolean).join("/");
  }
  async function $(W, z = {}) {
    return z.root && await v(z.root), (await Promise.all(W.map((fe) => F(fe, z.root ?? null)))).filter((fe) => fe !== null);
  }
  async function F(W, z) {
    var ke;
    const le = W.type === "file" ? (ke = e.fileName) == null ? void 0 : ke.call(e, W.path) : void 0;
    le && (W = { ...W, fxe_name: le });
    const fe = typeof W.e2e_root == "string" && W.e2e_root || z, j = b(W.path, fe);
    if (!j) return W;
    const X = await v(j);
    if (!qi(X)) return W;
    const te = wf(W);
    if (te === ka || Ol(te).kind === "sidecar") return null;
    const G = n.names(j), q = await H(j, W.path), B = { ...W, e2e_stored: te, e2e_root: j, e2e_display_dir: q };
    if (!G)
      return { ...B, basename: e.lockedLabel(), extension: "", e2e_name_state: "locked" };
    const K = await M(G, j, Ia(W.path), te);
    return K.state === "enc" && K.name !== null ? {
      ...B,
      basename: K.name,
      extension: W.type === "dir" ? "" : Wf(K.name),
      e2e_name_state: "enc"
    } : K.state === "plain" ? { ...B, basename: te, e2e_name_state: "plain" } : { ...B, basename: e.unreadableLabel(), extension: "", e2e_name_state: "unreadable" };
  }
  function I(W) {
    a.value;
    const z = b(W);
    if (!z) return null;
    const le = x(z);
    if (le === void 0)
      return v(z).then(p), null;
    if (!qi(le)) return null;
    const fe = n.names(z);
    if (!fe) return e.lockedLabel();
    const j = ll(W), X = Ia(W), te = `${Dn(X)}/${j}`, V = C(z).get(te);
    if (V) return V.name ?? e.unreadableLabel();
    const G = `${z}|${te}`;
    return c.has(G) || (c.add(G), M(fe, z, X, j).finally(() => {
      c.delete(G), p();
    })), "…";
  }
  function Z(W) {
    a.value;
    const z = b(W);
    if (!z || !w(z)) return Pm(Dn(W));
    const le = Pm(Dn(z)), fe = j_(W, z), j = [];
    let X = Dn(z);
    for (const te of fe)
      X = Xs(X, te), j.push(I(X) ?? te);
    return [le, ...j].filter(Boolean).join("/");
  }
  function J(W) {
    const z = Dn(W);
    for (const le of /* @__PURE__ */ new Set([...n.roots(), ...r.keys()])) {
      const fe = Dn(le);
      if ((z === fe || Js(z, fe)) && w(fe)) return fe;
    }
    return null;
  }
  async function re(W, z, le = {}) {
    const fe = J(W);
    if (!fe) return null;
    const j = n.names(fe);
    if (!j) throw new Error("e2e: the folder is locked");
    const X = await T(j, fe, W), te = le.keepIdOf ? await T(j, fe, le.keepIdOf) : void 0, V = await Ov(j, z, X, { isDir: le.isDir, dirId: te });
    return L(fe, W, V, z.normalize("NFC")), V;
  }
  async function ve(W) {
    const z = b(W) ?? J(W);
    if (!z) return null;
    const le = n.names(z);
    return le ? T(le, z, W) : null;
  }
  return {
    version: a,
    markerFor: v,
    markerCached: x,
    setMarker: k,
    forget: _,
    namesOn: w,
    rootOf: b,
    decorate: $,
    decodePath: U,
    plainNameOf: P,
    segmentLabel: I,
    displayPath: Z,
    writesEncrypted: J,
    nameForWrite: re,
    dirIdFor: ve,
    remember: L,
    bump: p
  };
}
const Nc = Symbol("filex.e2eNameView"), t5 = { class: "filex-recent" }, n5 = ["title", "aria-label", "disabled"], a5 = ["innerHTML"], i5 = { key: 0 }, o5 = ["data-fe-path"], r5 = ["onClick", "onContextmenu"], s5 = { class: "filex-recent-name" }, l5 = { class: "filex-recent-meta" }, u5 = {
  key: 1,
  class: "filex-recent-empty"
}, c5 = {
  key: 2,
  class: "filex-recent-empty"
}, d5 = /* @__PURE__ */ rt({
  __name: "RecentlyOpened",
  props: {
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    limit: {},
    refreshKey: {},
    locale: {}
  },
  emits: ["open", "context", "error"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = ht(() => n.locale ?? "en"), i = t, r = S([]), l = S(!1), c = bi(Nc, null), p = S({});
    async function m(k) {
      if (!c) return;
      const _ = k.map((A) => ({
        id: A.id,
        type: A.type === "dir" ? "dir" : "file",
        path: typeof A.storage == "string" && A.storage ? `${A.storage}://${String(A.path).replace(/^\/+/, "")}` : String(A.path),
        basename: A.name,
        ...typeof A.e2e_root == "string" && A.e2e_root ? { e2e_root: A.e2e_root } : {}
      })), w = await c.decorate(_), b = new Set(w.map((A) => A.id)), C = {};
      for (const A of w) typeof A.id == "number" && A.e2e_stored && (C[A.id] = A.basename);
      p.value = C, b.size !== k.length && (r.value = k.filter((A) => b.has(A.id)));
    }
    c && Xe(c.version, () => void m(r.value));
    async function v() {
      l.value = !0;
      try {
        const k = await (n.authHeaders ?? (() => ({})))(), _ = n.apiBase ?? "", w = n.limit ?? 20, b = await fetch(`${_}/api/files/manager/recent?limit=${w}`, {
          headers: k,
          credentials: n.authCredentials ?? "same-origin"
        });
        if (b.ok) {
          const C = await b.json();
          r.value = Array.isArray(C.nodes) ? C.nodes : Array.isArray(C.entries) ? C.entries : Array.isArray(C) ? C : [], await m(r.value);
        }
      } catch (k) {
        i("error", k instanceof Error ? k.message : String(k));
      } finally {
        l.value = !1;
      }
    }
    function x(k) {
      if (!k) return "";
      const _ = new Date(k).getTime();
      if (Number.isNaN(_)) return "";
      const w = Date.now() - _;
      try {
        const b = new Intl.RelativeTimeFormat(gi(n.locale), { numeric: "auto", style: "short" });
        return w < 6e4 ? b.format(0, "second") : w < 36e5 ? b.format(-Math.floor(w / 6e4), "minute") : w < 864e5 ? b.format(-Math.floor(w / 36e5), "hour") : b.format(-Math.floor(w / 864e5), "day");
      } catch {
        return new Date(_).toISOString().slice(0, 16).replace("T", " ");
      }
    }
    return qt(v), Xe(() => n.refreshKey, v), (k, _) => (f(), h("div", t5, [
      d("header", null, [
        d("h3", null, y(u(a)("recents.title")), 1),
        d("button", {
          class: "filex-recent-refresh",
          type: "button",
          title: u(a)("recents.refresh"),
          "aria-label": u(a)("recents.refresh"),
          onClick: v,
          disabled: l.value
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(Pt)("refresh")
          }, null, 8, a5)
        ], 8, n5)
      ]),
      r.value.length ? (f(), h("ul", i5, [
        (f(!0), h(Ce, null, nt(r.value, (w) => (f(), h("li", {
          key: w.id,
          "data-testid": "recent-tray-item",
          "data-fe-path": w.path
        }, [
          d("button", {
            type: "button",
            class: "filex-recent-item",
            onClick: (b) => i("open", w),
            onContextmenu: vt((b) => i("context", w, b), ["prevent"])
          }, [
            d("span", s5, [
              d("bdi", null, y(p.value[w.id] ?? w.name), 1)
            ]),
            d("span", l5, y(x(w.last_opened)), 1)
          ], 40, r5)
        ], 8, o5))), 128))
      ])) : l.value ? (f(), h("p", c5, y(u(a)("recents.loading")), 1)) : (f(), h("p", u5, y(u(a)("recents.empty")), 1))
    ]));
  }
}), Ko = {
  type: "any",
  modified: "any",
  size: "any",
  name: "",
  aroundDate: "",
  aroundSpan: "d1",
  sizeMin: null,
  sizeMax: null,
  pathMode: "any",
  pathBase: "",
  people: "any"
};
function vo(e) {
  return e.normalize("NFD").replace(new RegExp("\\p{M}+", "gu"), "").toLowerCase().replace(/ı/g, "i");
}
function lg(e) {
  return (e.name ?? "").trim();
}
function _S(e) {
  return (e.pathMode ?? "any") !== "any" && !!(e.pathBase ?? "");
}
function ug(e) {
  return e.people ?? "any";
}
function Zs(e) {
  return e.type !== "any" || e.modified !== "any" || e.size !== "any" || lg(e) !== "" || _S(e) || ug(e) !== "any";
}
function f5(e) {
  return (e.type !== "any" ? 1 : 0) + (e.modified !== "any" ? 1 : 0) + (e.size !== "any" ? 1 : 0) + (lg(e) !== "" ? 1 : 0) + (_S(e) ? 1 : 0) + (ug(e) !== "any" ? 1 : 0);
}
const p5 = {
  folder: ["folder"],
  document: ["doc", "text"],
  spreadsheet: ["sheet"],
  presentation: ["slides"],
  pdf: ["pdf"],
  image: ["image"],
  video: ["video"],
  audio: ["audio"],
  archive: ["archive"],
  code: ["code"]
};
function h5(e, t) {
  if (t === "any") return !0;
  if (t === "folder") return e.type === "dir";
  if (e.type === "dir") return !1;
  const n = e.kind;
  return typeof n == "string" && n !== "" ? n === t || t === "document" && n === "text" : p5[t].includes(xi(e));
}
const m5 = {
  h1: 36e5,
  d1: 864e5,
  w1: 7 * 864e5
};
function v5(e) {
  const t = (e ?? "").trim();
  if (!t) return null;
  const n = Date.parse(t.includes("T") ? t : `${t}T00:00`);
  return Number.isNaN(n) ? null : n;
}
function xS(e, t = Date.now()) {
  const n = e.modified;
  if (n === "any") return null;
  if (n === "around") {
    const i = v5(e.aroundDate);
    if (i === null) return null;
    const r = m5[e.aroundSpan ?? "d1"];
    return { after: i - r, before: i + r };
  }
  if (n === "year") {
    const i = new Date(t).getFullYear();
    return { after: new Date(i, 0, 1).getTime(), before: new Date(i + 1, 0, 1).getTime() - 1 };
  }
  if (n === "today") {
    const i = new Date(t);
    return i.setHours(0, 0, 0, 0), { after: i.getTime() };
  }
  return { after: t - (n === "7d" ? 7 : 30) * 864e5 };
}
function y5(e, t, n) {
  const a = xS(t, n);
  if (!a) return !0;
  const i = typeof e.last_modified == "number" ? e.last_modified : 0;
  return !(!i || a.after !== void 0 && i < a.after || a.before !== void 0 && i > a.before);
}
const Fs = 1024 * 1024;
function SS(e) {
  switch (e.size) {
    case "any":
      return null;
    case "lt1":
      return { max: Fs - 1 };
    case "1to10":
      return { min: Fs, max: 10 * Fs - 1 };
    case "10to100":
      return { min: 10 * Fs, max: 100 * Fs - 1 };
    case "gt100":
      return { min: 100 * Fs };
    case "range": {
      const t = typeof e.sizeMin == "number" ? e.sizeMin : void 0, n = typeof e.sizeMax == "number" ? e.sizeMax : void 0;
      return { min: t, max: n };
    }
  }
  return null;
}
function g5(e, t) {
  const n = SS(t);
  if (!n) return !0;
  if (e.type === "dir") return !1;
  const a = typeof e.size == "number" ? e.size : 0;
  return !(n.min !== void 0 && a < n.min || n.max !== void 0 && a > n.max);
}
function $S(e, t) {
  return t ? vo(e || "").includes(vo(t)) : !0;
}
function b5(e, t) {
  const n = t.pathMode ?? "any", a = (t.pathBase ?? "").replace(/\/+$/, "");
  if (n === "any" || !a) return !0;
  const i = e.path || "", r = i === a || i.startsWith(`${a}/`);
  return n === "here" ? r : !r;
}
function cc(e) {
  const t = e.owner_id;
  return typeof t == "number" && t > 0 ? t : null;
}
function Lp(e) {
  return e.owner_self === !0;
}
function cg(e) {
  const t = e.owner_name;
  return typeof t == "string" ? t : "";
}
function q_(e) {
  const t = e.deleted_by_id;
  return typeof t == "number" && t > 0 ? t : null;
}
function W_(e) {
  return e.deleted_by_self === !0;
}
function k5(e) {
  const t = e.deleted_by_name;
  return typeof t == "string" ? t : "";
}
function w5(e) {
  return e.external_upload === !0;
}
function _5(e) {
  const t = [{ value: "any" }, { value: "me" }, { value: "system" }], n = /* @__PURE__ */ new Set();
  for (const r of e) {
    const l = cc(r);
    l === null || Lp(r) || n.has(l) || (n.add(l), t.push({ value: `u:${l}`, name: cg(r) }));
  }
  const a = t.slice(0, 3), i = t.slice(3).sort((r, l) => (r.name ?? "").localeCompare(l.name ?? "", void 0, { sensitivity: "base" }));
  return [...a, ...i];
}
function x5(e, t) {
  const n = ug(t);
  if (n === "any") return !0;
  if (n === "me") return Lp(e);
  if (n === "system") return cc(e) === null;
  const a = Number(n.slice(2));
  return Number.isFinite(a) && cc(e) === a;
}
function Wv(e, t, n = Date.now()) {
  return Zs({ ...t, name: "" }) ? e.filter(
    (a) => h5(a, t.type) && y5(a, t, n) && g5(a, t) && b5(a, t) && x5(a, t)
  ) : e;
}
const S5 = /* @__PURE__ */ rt({
  __name: "UploadProgress",
  props: {
    jobs: {},
    locale: {},
    center: {}
  },
  emits: ["cancel", "dismiss", "retry"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = ht(() => n.locale);
    function i(c) {
      return c === "committing" || c === "transferring";
    }
    const r = t;
    function l(c) {
      return c === "done" ? "done" : c === "error" ? "error" : c === "aborted" ? "aborted" : "running";
    }
    return Xe(
      () => n.jobs,
      (c) => {
        n.center.sync(
          "upload",
          c.map((p) => ({
            input: {
              id: p.id,
              kind: "upload",
              name: p.displayName ?? p.file.name,
              percent: i(p.status) ? null : p.totalBytes > 0 || p.status === "done" ? p.percent : null,
              message: i(p.status) ? a("upload.saving") : null,
              status: l(p.status),
              error: p.error ?? null,
              uploadedBytes: p.uploadedBytes,
              totalBytes: p.totalBytes,
              // Cancellable only while chunks are still moving: once the commit is
              // accepted the bytes are filex's and the ops worker owns the rest.
              cancellable: p.status === "uploading" || p.status === "initializing",
              retryable: p.status === "error"
            },
            actions: {
              cancel: () => r("cancel", p),
              dismiss: () => r("dismiss", p),
              retry: () => r("retry", p)
            }
          }))
        );
      },
      { immediate: !0 }
    ), (c, p) => D("", !0);
  }
});
function Dm(e) {
  return Math.max(0, Math.min(100, Math.round(e)));
}
function TS(e) {
  if (e.progress_total > 1) return null;
  const t = e.objects_total ?? 0;
  return t > 0 ? { done: e.objects_done ?? 0, total: t } : null;
}
function $5(e) {
  if (e.status === "done") return 100;
  const t = e.bytes_total ?? 0, n = e.bytes_done ?? 0;
  if (t > 0) return Dm(n / t * 100);
  if (n > 0) return null;
  if (e.progress_total <= 1) {
    const a = TS(e);
    return a ? Dm(a.done / a.total * 100) : null;
  }
  return Dm(e.progress_done / e.progress_total * 100);
}
const T5 = /* @__PURE__ */ rt({
  __name: "PendingOpsTray",
  props: {
    ops: {},
    locale: {},
    center: {},
    outputModeOf: { type: Function },
    callerAdmin: { type: Boolean }
  },
  emits: ["dismiss", "cancel", "open"],
  setup(e, { emit: t }) {
    const n = e, { t: a } = ht(() => n.locale);
    function i(w) {
      return Ff(w, a, { callerAdmin: n.callerAdmin === !0 });
    }
    const r = t;
    function l(w) {
      return w.status === "done" ? "done" : w.status === "cancelled" ? "aborted" : w.status === "error" ? "error" : "running";
    }
    const c = /* @__PURE__ */ new Set([
      "copy",
      "move",
      "delete",
      "rename",
      "restore",
      "purge",
      "plugin",
      "archive-create",
      "archive-extract"
    ]);
    function p(w) {
      return w.op_type === "trash-empty" ? "trash" : w.op_type === "thumb-repair" ? "thumbs" : c.has(w.op_type) ? w.op_type : "plugin";
    }
    function m(w) {
      return w.op_type === "plugin";
    }
    function v(w) {
      return w.status !== "pending" && w.status !== "running" ? !1 : w.op_type === "archive-create" || w.op_type === "archive-extract" ? w.cancellable : m(w) ? !0 : (w.op_type === "trash-empty" || w.op_type === "thumb-repair") && n.callerAdmin === !0;
    }
    const x = (w) => $5(w);
    function k(w) {
      if (w.op_type === "trash-empty" || w.op_type === "thumb-repair") return "";
      const b = w.label || w.target_path || w.source_dir || "";
      return b || (w.op_type === "restore" || w.op_type === "purge" ? a("opc.trash_items", { n: w.progress_total || w.source_count }) : "");
    }
    function _(w) {
      const b = TS(w);
      return b ? { itemsDone: b.done, itemsTotal: b.total } : {};
    }
    return Xe(
      () => n.ops,
      (w) => {
        n.center.sync(
          "ops",
          w.map((b) => {
            var C;
            return {
              input: {
                id: b.id,
                kind: p(b),
                name: k(b),
                percent: x(b),
                status: l(b),
                error: b.status === "error" ? i(b).text : null,
                errorDetail: b.status === "error" ? i(b).detail ?? null : null,
                queued: b.status === "pending",
                cancelling: b.status === "cancelling",
                doneCount: b.progress_done,
                totalCount: b.progress_total,
                ..._(b),
                cancellable: v(b),
                retryable: !1,
                message: b.message ?? null,
                outputs: (b.outputs ?? []).map((A) => A.path),
                outputMode: (m(b) ? (C = n.outputModeOf) == null ? void 0 : C.call(n, b) : void 0) ?? null
              },
              actions: {
                cancel: () => r("cancel", b.id),
                dismiss: () => r("dismiss", b.id),
                open: (A) => r("open", b.id, A)
              }
            };
          })
        );
      },
      { immediate: !0 }
    ), (w, b) => D("", !0);
  }
});
function Ic(e) {
  if (!e || e.locked !== !0) return null;
  const t = e.lock;
  return !t || typeof t != "object" || typeof t.plugin != "string" || !t.plugin ? null : t;
}
function ppe(e) {
  return e.some((t) => Ic(t) !== null);
}
function Yv(e) {
  const t = e;
  if (!t || t.status !== 423) return null;
  const n = { plugin: "" };
  typeof t.server == "string" && t.server && (n.message = t.server);
  try {
    const a = JSON.parse(String(t.detail ?? ""));
    typeof a.plugin == "string" && (n.plugin = a.plugin), a.plugin_label && typeof a.plugin_label == "object" && (n.plugin_label = a.plugin_label), typeof a.path == "string" && (n.path = a.path), typeof a.reason == "string" && a.reason && (n.reason = a.reason), a.reason_text && typeof a.reason_text == "object" && (n.reason_text = a.reason_text), typeof a.until == "string" && a.until && (n.until = a.until), !n.message && typeof a.message == "string" && a.message && (n.message = a.message);
  } catch {
  }
  return n;
}
function A5(e, t) {
  return e && (Zt(e.reason_text, t || "en") || e.reason) || "";
}
function Kr(e, t) {
  if (!e) return "";
  const n = e.message;
  if (n) return Yi(t.locale, n);
  const a = Zt(e.plugin_label, t.locale || "en") || e.plugin || t.t("applock.some_app"), i = A5(e, t.locale), r = i ? t.t("applock.held_reason", { app: a, reason: i }) : t.t("applock.held", { app: a }), l = E5(e.until, t);
  return l ? `${r} ${l}` : r;
}
function E5(e, t) {
  if (!e) return "";
  const n = Date.parse(e);
  if (!Number.isFinite(n)) return "";
  const a = t.formatDate ? t.formatDate(n, { time: !0 }) : new Date(n).toISOString();
  return t.t("applock.until", { date: a });
}
const C5 = ["outside_root", "broken", "unresolved"];
function AS(e) {
  if (!e || e.symlink !== !0) return null;
  const t = e.link_state;
  return typeof t == "string" && C5.includes(t) ? t : "unknown";
}
function z5(e, t) {
  switch (e) {
    case "outside_root":
      return { state: e, badge: t.t("symlink.badge.outside_root"), why: t.t("symlink.why.outside_root") };
    case "broken":
      return { state: e, badge: t.t("symlink.badge.broken"), why: t.t("symlink.why.broken") };
    case "unresolved":
      return { state: e, badge: t.t("symlink.badge.unresolved"), why: t.t("symlink.why.unresolved") };
    case "unknown":
      return { state: e, badge: t.t("symlink.badge.unknown"), why: t.t("symlink.why.unknown") };
    default:
      return null;
  }
}
function Bc(e, t) {
  return z5(AS(e), t);
}
function hpe(e) {
  return AS(e) !== null;
}
function ES(e) {
  return !!e && e.unavailable === !0;
}
function Fc(e, t) {
  if (!ES(e)) return null;
  const n = e.type === "dir" ? t.t("unavailable.why.dir") : t.t("unavailable.why.file"), a = typeof e.unavailable_reason == "string" ? e.unavailable_reason.trim() : "", i = a ? t.t("unavailable.withReason", { why: n, reason: a }) : n;
  return { badge: "!", why: n, reason: a, full: i };
}
function Rp(e) {
  if (!e) return "";
  for (const t of [e.name, e.display_name, e.username, e.email]) {
    const n = typeof t == "string" ? t.trim() : "";
    if (n) return n;
  }
  return "";
}
function M5(e, t) {
  const n = Rp(e);
  return n ? [...n][0].toLocaleUpperCase(t) : "";
}
function dg(e) {
  const t = Number(e);
  return Number.isFinite(t) ? (Math.round(t / 90) * 90 % 360 + 360) % 360 : 0;
}
const Y_ = { w: 0.02, h: 0.01 }, tp = (e) => Math.min(1, Math.max(0, e));
function ul(e) {
  const t = Math.min(1, Math.max(Y_.w, Number(e.w) || 0)), n = Math.min(1, Math.max(Y_.h, Number(e.h) || 0)), a = Math.min(1 - t, tp(Number(e.x) || 0)), i = Math.min(1 - n, tp(Number(e.y) || 0));
  return { x: a, y: i, w: t, h: n };
}
function ef(e, t) {
  return ul({
    x: Math.min(e.x, t.x),
    y: Math.min(e.y, t.y),
    w: Math.abs(e.x - t.x),
    h: Math.abs(e.y - t.y)
  });
}
function mpe(e, t) {
  return {
    left: e.x * t.width,
    top: e.y * t.height,
    width: e.w * t.width,
    height: e.h * t.height
  };
}
function vpe(e, t) {
  const n = t.width || 1, a = t.height || 1;
  return { x: e.left / n, y: e.top / a, w: e.width / n, h: e.height / a };
}
function G_(e, t) {
  return { x: tp(e.x / (t.width || 1)), y: tp(e.y / (t.height || 1)) };
}
function CS(e) {
  const t = dg(e.rotation);
  return t === 90 || t === 270 ? { width: e.height, height: e.width } : { width: e.width, height: e.height };
}
function X_(e, t, n) {
  const a = dg(n.rotation), i = n.width, r = n.height;
  switch (a) {
    case 90:
      return { x: t, y: i - e };
    case 180:
      return { x: i - e, y: r - t };
    case 270:
      return { x: r - t, y: e };
    default:
      return { x: e, y: t };
  }
}
function J_(e, t, n) {
  const a = dg(n.rotation), i = n.width, r = n.height;
  switch (a) {
    case 90:
      return { X: i - t, Y: e };
    case 180:
      return { X: i - e, Y: r - t };
    case 270:
      return { X: t, Y: r - e };
    default:
      return { X: e, Y: t };
  }
}
function ype(e, t) {
  const n = X_(e.x * t.width, e.y * t.height, t), a = X_((e.x + e.w) * t.width, (e.y + e.h) * t.height, t), { height: i } = CS(t), r = Math.min(n.x, a.x), l = Math.max(n.x, a.x), c = Math.min(n.y, a.y), p = Math.max(n.y, a.y);
  return zS({ x: r, y: i - p, w: l - r, h: p - c });
}
function gpe(e, t) {
  const { height: n } = CS(t), a = { x: e.x, y: n - (e.y + e.h) }, i = { x: e.x + e.w, y: n - e.y }, r = J_(a.x, a.y, t), l = J_(i.x, i.y, t), c = t.width || 1, p = t.height || 1;
  return zS({
    x: Math.min(r.X, l.X) / c,
    y: Math.min(r.Y, l.Y) / p,
    w: Math.abs(r.X - l.X) / c,
    h: Math.abs(r.Y - l.Y) / p
  });
}
function zS(e) {
  const t = {};
  for (const [n, a] of Object.entries(e)) t[n] = Math.round(a * 1e6) / 1e6;
  return t;
}
function O5(e, t, n = 16) {
  const a = Math.max(0, e.width), i = Math.max(0, e.height) - n;
  if (!t.width || !t.height || i <= 0) return a;
  const r = i * t.width / t.height;
  return Math.max(120, Math.min(a, r));
}
const _l = [
  { key: "caveat", name: "Caveat", kind: "hand", className: "fe-signfont--caveat", stack: "'Caveat', cursive" },
  {
    key: "dancing-script",
    name: "Dancing Script",
    kind: "hand",
    className: "fe-signfont--dancing-script",
    stack: "'Dancing Script', cursive"
  },
  {
    key: "homemade-apple",
    name: "Homemade Apple",
    kind: "hand",
    className: "fe-signfont--homemade-apple",
    stack: "'Homemade Apple', cursive"
  },
  {
    key: "inter",
    name: "Inter",
    kind: "formal",
    className: "fe-signfont--inter",
    stack: 'Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif'
  },
  {
    key: "source-serif",
    name: "Source Serif 4",
    kind: "formal",
    className: "fe-signfont--source-serif",
    stack: "'Source Serif 4', Georgia, 'Times New Roman', serif"
  }
], MS = "caveat";
function OS(e) {
  const t = String(e ?? "");
  return _l.find((n) => n.key === t) ?? _l.find((n) => n.key === MS);
}
function dc(e) {
  return typeof e == "string" && _l.some((t) => t.key === e);
}
const Gv = ["any", "number", "email"];
function P5(e) {
  return typeof e == "string" && Gv.includes(e);
}
function D5(e) {
  if (!e || typeof e != "object") return null;
  const t = e, a = { kind: P5(t.kind) ? t.kind : "any" }, i = Math.trunc(Number(t.min)), r = Math.trunc(Number(t.max));
  return Number.isFinite(i) && i > 0 && (a.min = i), Number.isFinite(r) && r > 0 && (a.max = r), a.kind === "any" && a.min === void 0 && a.max === void 0 ? null : a;
}
function L5(e) {
  return e ? e.kind === "number" ? "numeric" : e.kind === "email" ? "email" : "text" : "text";
}
function PS(e) {
  if (e)
    return e.max && e.max > 0 ? e.max : void 0;
}
function R5(e, t) {
  let n = String(e ?? "");
  if (!t) return n;
  if (t.kind === "number") {
    const i = n.startsWith("-");
    let r = !1;
    n = n.split("").filter((l) => l >= "0" && l <= "9" ? !0 : (l === "." || l === ",") && !r ? (r = !0, !0) : !1).join(""), i && (n = `-${n}`);
  } else t.kind === "email" && (n = n.replace(/\s+/g, ""));
  const a = PS(t);
  return a && n.length > a && (n = n.slice(0, a)), n;
}
function N5(e, t) {
  const n = typeof e == "string" ? e.trim() : "";
  return !t || n === "" ? "" : t.min && n.length < t.min ? "min" : t.max && n.length > t.max ? "max" : t.kind === "number" ? /^-?\d+([.,]\d+)?$/.test(n) ? "" : "number" : t.kind === "email" ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(n) ? "" : "email" : "";
}
const _f = ["signature", "initials", "date", "text", "checkbox"];
function DS(e) {
  return e === "signature" || e === "initials";
}
function LS(e, t) {
  if (!Array.isArray(e)) return [];
  const n = [], a = /* @__PURE__ */ new Set();
  for (const i of e) {
    if (!i || typeof i != "object") continue;
    const r = typeof i.id == "string" ? i.id.trim() : "";
    if (!r || a.has(r)) continue;
    a.add(r);
    const l = { id: r, label: i.label ?? r };
    t(l, i), n.push(l);
  }
  return n;
}
function I5(e) {
  return LS(e, (t, n) => {
    n.examples && typeof n.examples == "object" && !Array.isArray(n.examples) && (t.examples = n.examples), n.default === !0 && (t.default = !0);
  });
}
function B5(e, t) {
  if (Array.isArray(e.lines)) {
    const n = new Set(e.lines);
    return t.filter((a) => n.has(a.id)).map((a) => a.id);
  }
  return t.filter((n) => n.default).map((n) => n.id);
}
function F5(e, t) {
  const n = e.examples ?? {};
  return n[t || "*"] ?? n["*"] ?? "";
}
const np = {
  signature: { w: 0.28, h: 0.06 },
  initials: { w: 0.1, h: 0.05 },
  date: { w: 0.16, h: 0.035 },
  text: { w: 0.26, h: 0.035 },
  checkbox: { w: 0.03, h: 0.022 }
}, Lm = ["#2563eb", "#16a34a", "#d97706", "#9333ea", "#dc2626", "#0891b2"];
function RS(e) {
  return typeof e == "string" && _f.includes(e);
}
function U5(e) {
  if (!Array.isArray(e)) return [..._f];
  const t = e.filter(RS);
  return t.length ? _f.filter((n) => t.includes(n)) : [..._f];
}
function xf(e) {
  if (!Array.isArray(e)) return [];
  const t = [], n = /* @__PURE__ */ new Set();
  for (const a of e) {
    if (!a || typeof a != "object") continue;
    const i = String(a.id ?? "");
    if (!i || n.has(i) || !RS(a.type)) continue;
    n.add(i);
    const r = ul({ x: Number(a.x), y: Number(a.y), w: Number(a.w), h: Number(a.h) }), l = Math.max(1, Math.trunc(Number(a.page) || 1)), c = { id: i, type: a.type, page: l, ...r };
    typeof a.label == "string" && a.label && (c.label = a.label), typeof a.assignee == "string" && a.assignee && (c.assignee = a.assignee), a.required === !0 && (c.required = !0), a.placed === !1 && (c.placed = !1), a.value !== void 0 && a.value !== null && (c.value = a.value);
    const p = D5(a.rule);
    p && (c.rule = p), typeof a.format == "string" && a.format.trim() && (c.format = a.format.trim()), dc(a.font) && (c.font = a.font), DS(a.type) && (a.style === "typed" && (c.style = "typed"), Array.isArray(a.lines) && (c.lines = [...new Set(a.lines.filter((m) => typeof m == "string" && !!m))].slice(0, 16))), t.push(c);
  }
  return t;
}
function Xv(e) {
  return e.placed !== !1;
}
function H5(e) {
  return e.filter((t) => !Xv(t));
}
function K5(e, t, n = {}) {
  var r;
  const a = np[t], i = {
    id: fg(t, e),
    type: t,
    page: 1,
    x: 0.1,
    y: 0.1,
    w: a.w,
    h: a.h,
    placed: !1
  };
  return (r = n.label) != null && r.trim() && (i.label = n.label.trim()), n.assignee && (i.assignee = n.assignee), n.required && (i.required = !0), i;
}
function V5(e) {
  return LS(e, (t, n) => {
    typeof n.example == "string" && n.example.trim() && (t.example = n.example.trim()), typeof n.order == "string" && n.order.trim() && (t.order = n.order.trim()), n.order_label && (t.orderLabel = n.order_label), typeof n.separator == "string" && n.separator !== "" && (t.separator = n.separator), n.separator_label && (t.separatorLabel = n.separator_label);
  });
}
function j5(e) {
  if (!e || typeof e != "object" || Array.isArray(e)) return {};
  const t = e, n = {};
  for (const a of ["order", "separator", "example"]) {
    const i = t[a];
    (typeof i == "string" ? i.trim() : i && typeof i == "object") && (n[a] = i);
  }
  return n;
}
function q5(e) {
  if (!e.length) return null;
  const t = [], n = [];
  for (const a of e) {
    if (a.order === void 0 || a.separator === void 0) return null;
    t.some((i) => i.id === a.order) || t.push({ id: a.order, label: a.orderLabel ?? a.order }), n.some((i) => i.id === a.separator) || n.push({ id: a.separator, label: a.separatorLabel ?? a.separator });
  }
  return t.length && n.length ? { orders: t, separators: n } : null;
}
function Z_(e, t, n) {
  var i, r;
  const a = e.find((l) => l.order === t && l.separator === n);
  return a ? a.id : ((i = e.find((l) => l.order === t)) == null ? void 0 : i.id) ?? ((r = e[0]) == null ? void 0 : r.id) ?? "";
}
function W5(e, t) {
  const n = e.find((a) => a.id === t);
  return !n || n.order === void 0 || n.separator === void 0 ? null : { order: n.order, separator: n.separator };
}
function Y5(e) {
  const t = [];
  let n = 0;
  for (; n < e.length; )
    e.startsWith("YYYY", n) ? (t.push("YYYY"), n += 4) : e.startsWith("YY", n) ? (t.push("YY"), n += 2) : e.startsWith("DD", n) ? (t.push("DD"), n += 2) : e.startsWith("MM", n) ? (t.push("MM"), n += 2) : n += 1;
  return t;
}
function G5(e, t, n) {
  return Y5(e).map((i) => i === "YYYY" ? String(n.getFullYear()).padStart(4, "0") : i === "YY" ? String(n.getFullYear() % 100).padStart(2, "0") : i === "MM" ? String(n.getMonth() + 1).padStart(2, "0") : String(n.getDate()).padStart(2, "0")).join(t);
}
function X5(e) {
  return Array.isArray(e) ? e.filter((t) => t && typeof t == "object" && typeof t.id == "string" && t.id).map((t) => ({
    id: t.id,
    label: t.label ?? t.id,
    color: typeof t.color == "string" ? t.color : void 0
  })) : [];
}
function J5(e, t) {
  const n = e.findIndex((a) => a.id === t);
  return n < 0 ? Lm[0] : e[n].color || Lm[n % Lm.length];
}
function NS(e, t) {
  return e.assignee ? !!t && e.assignee === t : !0;
}
function Jv(e) {
  const t = e.value;
  return e.type === "checkbox" ? t === !0 : typeof t == "string" ? t !== "" : t != null;
}
function IS(e, t) {
  return {
    fields: e.filter((n) => NS(n, t) && Jv(n)).map((n) => {
      const a = { id: n.id, value: n.value };
      return n.label && (a.label = n.label), n.font && (a.font = n.font), n.rule && (a.rule = n.rule), a;
    })
  };
}
function Z5(e, t) {
  const n = t == null ? void 0 : t.fields;
  if (!Array.isArray(n)) return e;
  const a = /* @__PURE__ */ new Map();
  for (const i of n)
    i && typeof i.id == "string" && a.set(i.id, { value: i.value, font: dc(i.font) ? i.font : void 0 });
  return e.map((i) => {
    const r = a.get(i.id);
    return r ? { ...i, value: r.value, ...r.font ? { font: r.font } : {} } : i;
  });
}
function bpe(e, t, n) {
  return e.map((a) => a.id === t ? { ...a, font: n } : a);
}
function Q5(e, t, n) {
  return e.map((a) => {
    if (a.id !== t) return a;
    const i = { ...a };
    return n == null || n === "" || n === !1 ? delete i.value : i.value = n, i;
  });
}
function fg(e, t) {
  const n = { signature: "sig", initials: "ini", date: "date", text: "text", checkbox: "chk" }[e], a = new Set(t.map((i) => i.id));
  for (let i = 1; ; i++) {
    const r = `${n}-${i}`;
    if (!a.has(r)) return r;
  }
}
function Q_(e, t, n, a, i = np[t], r) {
  const l = ul({ x: a.x, y: a.y, w: i.w, h: i.h }), c = { id: fg(t, e), type: t, page: n, ...l };
  return r && (c.assignee = r), c;
}
function eR(e, t, n) {
  const a = e.find((r) => r.id === t);
  if (!a) return e;
  const i = { ...a, id: fg(a.type, e), page: Math.max(1, Math.trunc(n)) };
  return delete i.value, [...e, i];
}
function tR(e = /* @__PURE__ */ new Date()) {
  const t = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), a = String(e.getDate()).padStart(2, "0");
  return `${t}-${n}-${a}`;
}
function Uc(e, t) {
  var n;
  for (const a of e ?? [])
    t(a), (n = a.children) != null && n.length && Uc(a.children, t);
}
function nR(e) {
  const t = {};
  return Uc(e, (n) => {
    var i;
    const a = n.props ?? {};
    if (n.type === "form") {
      const r = a;
      for (const l of r.fields ?? []) {
        if (!(l != null && l.key)) continue;
        const c = (i = r.values) == null ? void 0 : i[l.key];
        c !== void 0 ? t[l.key] = e1(l, c) : l.default !== void 0 ? t[l.key] = e1(l, l.default) : l.multi === !0 && l.type === "select" && (t[l.key] = []);
      }
      return;
    }
    if (n.id) {
      if (n.type === "people-picker") {
        const r = a.value;
        t[n.id] = Array.isArray(r) ? r.filter((l) => l && typeof l.email == "string") : [];
      } else if (n.type === "file-chooser") {
        const r = a.value;
        t[n.id] = typeof r == "string" ? r : "";
      } else if (n.type === "pin-input")
        t[n.id] = "";
      else if (n.type === "signature-pad")
        t[n.id] = null;
      else if (n.type === "pdf-fields") {
        const r = a, l = xf(r.fields);
        t[n.id] = r.mode === "fill" ? IS(l, r.signer) : l;
      }
    }
  }), t;
}
function e1(e, t) {
  return e.multi !== !0 || e.type !== "select" ? t : Array.isArray(t) ? t.map((n) => String(n)) : t == null || t === "" ? [] : [String(t)];
}
const aR = /* @__PURE__ */ new Set(["string", "int", "bool", "password", "select"]);
function iR(e) {
  const t = String(e.style ?? "").toLowerCase();
  return t === "choice" ? !0 : t === "switch" ? !1 : (e.options ?? []).length > 0 ? !0 : e.required === !0;
}
function oR(e, t) {
  const n = e.secret ? "password" : aR.has(String(e.type)) ? e.type : "string";
  return {
    key: e.key,
    type: n,
    label: Zt(e.label, t) || e.key,
    help: Zt(e.help, t) || void 0,
    i18n_key: "",
    required: e.required === !0,
    secret: e.secret === !0,
    default: e.default,
    placeholder: Zt(e.placeholder, t) || void 0,
    options: (e.options ?? []).map((a) => ({ value: String(a.value), label: Zt(a.label, t) || String(a.value) })),
    min: e.min,
    max: e.max,
    monospace: e.monospace === !0,
    // ⚠⚠ `text` IS the contract's long text (wire.Field: "string | password
    // | int | bool | select | text"), and the field renderer draws a textarea
    // only on `multiline`. Nothing mapped the two, so every long field a
    // plugin asked for arrived as a one-line box — including the signing
    // app's list of signers, under a help line that says "one per line".
    multiline: e.multiline === !0 || String(e.type) === "text",
    choice: n === "select" || n === "bool" && iR(e),
    multi: e.multi === !0
  };
}
function rR(e) {
  const t = e.trim(), n = t.indexOf("@");
  return n > 0 && n < t.length - 1 && !/\s/.test(t) && t.indexOf("@", n + 1) === -1;
}
function Zv(e) {
  return e == null ? !1 : typeof e == "string" ? e.trim() !== "" : Array.isArray(e) ? e.length > 0 : !0;
}
function sR(e) {
  return e == null ? [] : Array.isArray(e) ? e.map((t) => String(t)) : typeof e == "boolean" ? [e ? "true" : "false"] : [String(e)];
}
function BS(e, t) {
  if (!e || !e.key) return !0;
  const n = t == null ? void 0 : t[e.key], a = e.equals ?? [];
  if (!a.length) return Zv(n);
  if (!Zv(n)) return !1;
  const i = sR(n);
  return a.some((r) => i.includes(String(r)));
}
function pg(e, t) {
  const n = (e ?? []).filter((i) => i && i.key);
  if (!n.length) return [];
  let a = n;
  for (let i = 0; i <= n.length; i++) {
    const r = FS(n, a, t), l = n.filter((c) => BS(c.show_when, r));
    if (l.length === a.length) return l;
    a = l;
  }
  return a;
}
function FS(e, t, n) {
  const a = new Set(t.map((r) => r.key)), i = { ...n };
  for (const r of e) a.has(r.key) || delete i[r.key];
  return i;
}
function US(e, t) {
  return e.required === !0 ? !0 : e.required_when ? BS(e.required_when, t) : !1;
}
function HS(e) {
  const t = [];
  return Uc(e, (n) => {
    var i;
    if (n.type !== "form") return;
    const a = (i = n.props) == null ? void 0 : i.fields;
    for (const r of a ?? []) r && r.key && t.push(r);
  }), t;
}
function lR(e, t) {
  const n = HS(e);
  if (!n.length) return [];
  const a = new Set(pg(n, t).map((i) => i.key));
  return n.filter((i) => !a.has(i.key)).map((i) => i.key);
}
function uR(e, t) {
  const n = lR(e, t);
  if (!n.length) return { ...t };
  const a = { ...t };
  for (const i of n) delete a[i];
  return a;
}
function t1(e, t) {
  const n = HS(e);
  if (!n.length) return [];
  const a = pg(n, t), i = FS(n, a, t);
  return a.filter((r) => US(r, i) && !Zv(i[r.key]));
}
const cR = 300;
function Np(e, t) {
  const n = S(null), a = S({}), i = S(!1), r = S(""), l = S([]), c = E(() => {
    var T;
    return ((T = n.value) == null ? void 0 : T.actions) ?? [];
  }), p = E(() => {
    var T;
    return (T = n.value) == null ? void 0 : T.errors;
  });
  function m(T, R = !1) {
    n.value = T, r.value = "", l.value = [];
    const M = nR(T == null ? void 0 : T.nodes);
    a.value = R ? { ...M, ...a.value } : M;
  }
  function v(T) {
    var R;
    if (a.value = T, l.value.length) {
      const M = t1((R = n.value) == null ? void 0 : R.nodes, T).map((L) => L.key);
      M.length !== l.value.length && (l.value = M);
    }
  }
  let x = null;
  function k() {
    x !== null && clearTimeout(x), x = null;
  }
  function _() {
    k(), x = setTimeout(() => {
      x = null, b("change");
    }, cR);
  }
  let w = 0;
  async function b(T, R, M = {}) {
    var H, $, F, I, Z, J;
    if (!n.value) return;
    const L = T !== "change";
    if (L) {
      if (k(), i.value) return;
      i.value = !0;
    }
    const U = ++w;
    r.value = "";
    const P = (H = e.paths) == null ? void 0 : H.call(e);
    try {
      const re = await e.api.pluginViewEvent(e.plugin, e.view, {
        path: ($ = e.path) == null ? void 0 : $.call(e),
        ...P != null && P.length ? { paths: [...P] } : {},
        state: ((F = n.value) == null ? void 0 : F.state) ?? {},
        event: T,
        action_id: R,
        // ⚠⚠ The values a HIDDEN field holds are dropped here, not blanked
        // (v3 §2.1: "a value belonging to a hidden field is dropped before
        // the job runs — it cannot arrive as a surprise"). The plugin is
        // re-asked the same question by the host at submit; this is the
        // client half of the same promise, and it also keeps a `change`
        // event from echoing back a field the step no longer shows.
        data: { values: uR((I = n.value) == null ? void 0 : I.nodes, a.value), ...M }
      });
      if (!L && U !== w) return;
      if (re.op) {
        t.onOp(re.op), t.onDone();
        return;
      }
      const ve = re.surface;
      if (!ve) {
        r.value = e.errorText();
        return;
      }
      const W = Zt(ve.toast, e.locale());
      W && t.onToast(W);
      const z = kp(ve.open) ? ve.open : null;
      if (ve.done) {
        t.onDone(), z && ((Z = t.onOpen) == null || Z.call(t, z));
        return;
      }
      m(ve, !L), z && ((J = t.onOpen) == null || J.call(t, z));
    } catch (re) {
      if (!L && U !== w) return;
      r.value = Yi(e.locale(), String((re == null ? void 0 : re.message) ?? re)) || e.errorText();
    } finally {
      L && (i.value = !1);
    }
  }
  function C(T) {
    var R;
    if (i.value || T.disabled) return Promise.resolve();
    if (T.primary) {
      const M = t1((R = n.value) == null ? void 0 : R.nodes, a.value);
      if (l.value = M.map((L) => L.key), M.length) return Promise.resolve();
    }
    return b(T.primary ? "submit" : "action", T.id);
  }
  function A(T) {
    return b("action", T.action_id, { row_id: T.row_id });
  }
  return Go() && Ct(k), {
    current: n,
    values: a,
    busy: i,
    failure: r,
    footer: c,
    errors: p,
    invalidKeys: l,
    setSurface: m,
    updateValues: v,
    scheduleChange: _,
    post: b,
    press: C,
    rowAction: A,
    dispose: k
  };
}
const Sf = ["draw", "type", "upload"], dR = 200 * 1024, KS = 600, VS = 200, fR = 480, pR = 160, n1 = "#111111", Qv = MS;
function jS(e) {
  return typeof e == "string" && Sf.includes(e);
}
function hR(e) {
  if (!Array.isArray(e)) return [...Sf];
  const t = e.filter(jS);
  return t.length ? Sf.filter((n) => t.includes(n)) : [...Sf];
}
function Nu(e) {
  const t = e;
  return !!t && typeof t == "object" && typeof t.png_b64 == "string" && t.png_b64 !== "" && jS(t.mode);
}
function mR(e) {
  const t = e;
  return t && dc(t.font) ? t.font : Qv;
}
function vR(e, t) {
  const n = Number(e), a = Number(t);
  return {
    width: Number.isFinite(n) && n > 0 ? Math.min(KS, Math.max(120, Math.round(n))) : fR,
    height: Number.isFinite(a) && a > 0 ? Math.min(VS, Math.max(60, Math.round(a))) : pR
  };
}
function yR(e, t, n, a) {
  if (!(e > 0) || !(t > 0)) return { width: n, height: a };
  const i = Math.min(1, n / e, a / t);
  return { width: Math.max(1, Math.round(e * i)), height: Math.max(1, Math.round(t * i)) };
}
function gR(e) {
  const t = e.indexOf("base64,");
  return t >= 0 ? e.slice(t + 7) : e;
}
function bR(e) {
  return e.type !== "image/png" && e.type !== "image/jpeg" ? "bad_type" : e.size > dR ? "too_big" : "ok";
}
function kR(e, t, n) {
  let a = Math.min(96, Math.floor(n * 0.6));
  for (; a > 12 && e(a) > t; ) a -= 2;
  return a;
}
const wR = 44;
function _R(e, t, n, a) {
  const i = t.height - e.bottom - 8, r = e.top - 8, l = Math.min(320, a * wR + 8), c = i < Math.min(l, 160) && r > i, p = Math.min(Math.max(e.width, 180), t.width - 16), m = Sc(Rr(e, n), p, t.width, n);
  return {
    top: Math.round(e.bottom + 4),
    bottom: Math.round(t.height - e.top + 4),
    start: Math.round(n === "rtl" ? t.width - m - p : m),
    width: Math.round(p),
    maxHeight: Math.round(Math.max(120, Math.min(320, c ? r : i))),
    up: c
  };
}
const xR = ["id", "disabled", "aria-expanded", "aria-activedescendant", "aria-label", "aria-labelledby", "aria-describedby", "aria-required", "aria-invalid", "data-testid", "data-value"], SR = ["name", "value", "required", "disabled"], $R = ["dir", "aria-labelledby", "data-testid"], TR = ["id", "aria-selected", "aria-disabled", "data-value", "data-testid", "onMousemove", "onClick"], AR = { class: "fe-select__label" }, ER = { class: "fe-select__text" }, CR = {
  key: 0,
  class: "fe-select__help"
}, fc = /* @__PURE__ */ rt({
  __name: "ChoiceSelect",
  props: {
    modelValue: { default: null },
    options: {},
    id: { default: void 0 },
    name: { default: void 0 },
    placeholder: { default: "" },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    size: { default: "md" },
    ariaLabel: { default: void 0 },
    ariaLabelledby: { default: void 0 },
    ariaDescribedby: { default: void 0 },
    requiredMessage: { default: "" },
    testid: { default: void 0 }
  },
  emits: ["update:modelValue", "change", "invalid"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, r = `fe-sel-${Math.random().toString(36).slice(2, 10)}`, l = E(() => a.id ?? r), c = `${r}-list`, p = (B) => `${r}-opt-${B}`, m = S(!1), v = S(-1), x = S(null), k = S(null), _ = S(null), w = S(null), b = S({
      top: 0,
      bottom: 0,
      start: 0,
      width: 0,
      maxHeight: 280,
      up: !1,
      z: Hy,
      dir: "ltr"
    }), C = S({}), A = S(!1);
    let T = "", R = 0;
    const M = (B) => B == null || B === "", L = E(() => a.options.findIndex((B) => B.value === a.modelValue)), U = E(() => a.options[L.value]), P = E(() => {
      var B;
      return ((B = U.value) == null ? void 0 : B.label) ?? a.placeholder;
    }), H = E(() => a.invalid || A.value), $ = E(() => a.required || !!a.name);
    function F() {
      var B;
      (B = _.value) == null || B.setCustomValidity(a.required && M(a.modelValue) ? a.requiredMessage || " " : "");
    }
    Xe(
      () => a.modelValue,
      (B) => {
        M(B) || (A.value = !1), Jt(F);
      },
      { immediate: !0 }
    ), Xe(() => a.required, () => void Jt(F)), Xe(
      () => a.disabled,
      (B) => {
        B && le(!1);
      }
    );
    function I(B, K) {
      const ke = a.options.length;
      for (let Ye = 0, Oe = B; Ye < ke; Ye++, Oe += K) {
        if (Oe < 0 || Oe >= ke) return -1;
        if (!a.options[Oe].disabled) return Oe;
      }
      return -1;
    }
    const Z = [
      "--fe-bg",
      "--fe-bg-hover",
      "--fe-border",
      "--fe-text",
      "--fe-text-muted",
      "--fe-primary",
      "--fe-primary-ink",
      "--fe-radius",
      "--fe-radius-sm",
      "--fe-shadow",
      "--fe-text-xs"
    ];
    function J(B) {
      const K = {};
      try {
        const ke = window.getComputedStyle(B);
        for (const Ye of Z) {
          const Oe = ke.getPropertyValue(Ye).trim();
          Oe && (K[Ye] = Oe);
        }
        ke.fontFamily && (K["font-family"] = ke.fontFamily), ke.fontSize && (K["font-size"] = ke.fontSize);
      } catch {
      }
      return K;
    }
    function re() {
      const B = x.value;
      if (!B) return;
      const K = ei(B), ke = _R(
        B.getBoundingClientRect(),
        { width: window.innerWidth, height: window.innerHeight },
        K,
        a.options.length
      );
      b.value = { ...ke, z: b.value.z, dir: K };
    }
    function ve(B) {
      var ke, Ye;
      const K = B.target;
      !K || (ke = x.value) != null && ke.contains(K) || (Ye = k.value) != null && Ye.contains(K) || le(!1);
    }
    function W(B) {
      B ? (window.addEventListener("resize", re), window.addEventListener("scroll", re, !0), document.addEventListener("pointerdown", ve, !0)) : (window.removeEventListener("resize", re), window.removeEventListener("scroll", re, !0), document.removeEventListener("pointerdown", ve, !0));
    }
    async function z(B) {
      if (a.disabled || m.value) return;
      const K = x.value;
      w.value = (K == null ? void 0 : K.closest("dialog[open]")) ?? document.body, K && (C.value = J(K), b.value = { ...b.value, z: Ec(K) }), re(), m.value = !0, v.value = B ?? (L.value >= 0 ? L.value : I(0, 1)), W(!0), await Jt(), j();
    }
    function le(B = !0) {
      var K;
      m.value && (m.value = !1, T = "", W(!1), B && ((K = x.value) == null || K.focus()));
    }
    function fe(B, K = !0) {
      const ke = a.options[B];
      !ke || ke.disabled || (ke.value !== a.modelValue && (i("update:modelValue", ke.value), i("change", ke.value)), le(K));
    }
    function j() {
      const B = document.getElementById(p(v.value));
      B && typeof B.scrollIntoView == "function" && B.scrollIntoView({ block: "nearest" });
    }
    function X(B) {
      B < 0 || (v.value = B, Jt(j));
    }
    function te(B) {
      const K = Date.now();
      T = K - R > 600 ? B : T + B, R = K;
      const ke = a.options.length, Ye = T.length > 1 ? Math.max(v.value, 0) : v.value + 1, Oe = T.toLocaleLowerCase();
      for (let Be = 0; Be < ke; Be++) {
        const qe = (Ye + Be + ke) % ke, Tt = a.options[qe];
        if (!Tt.disabled && Tt.label.toLocaleLowerCase().startsWith(Oe)) return qe;
      }
      return -1;
    }
    function V(B) {
      if (a.disabled) return;
      const K = B.key;
      if (!m.value) {
        if (K === "ArrowDown" || K === "ArrowUp" || K === "Enter" || K === " ")
          B.preventDefault(), z();
        else if (K === "Home" || K === "End")
          B.preventDefault(), z(K === "Home" ? I(0, 1) : I(a.options.length - 1, -1));
        else if (K.length === 1 && !B.ctrlKey && !B.metaKey && !B.altKey) {
          const ke = te(K);
          ke >= 0 && z(ke);
        }
        return;
      }
      switch (K) {
        case "ArrowDown":
          if (B.preventDefault(), B.altKey) return;
          X(I(v.value + 1, 1));
          return;
        case "ArrowUp":
          if (B.preventDefault(), B.altKey) return fe(v.value);
          X(I(v.value - 1, -1));
          return;
        case "Home":
          B.preventDefault(), X(I(0, 1));
          return;
        case "End":
          B.preventDefault(), X(I(a.options.length - 1, -1));
          return;
        case "PageDown":
          B.preventDefault(), X(I(Math.min(v.value + 10, a.options.length - 1), -1));
          return;
        case "PageUp":
          B.preventDefault(), X(I(Math.max(v.value - 10, 0), 1));
          return;
        case "Enter":
        case " ":
          B.preventDefault(), fe(v.value);
          return;
        case "Escape":
          B.preventDefault(), B.stopPropagation(), le();
          return;
        case "Tab":
          fe(v.value, !1);
          return;
      }
      if (K.length === 1 && !B.ctrlKey && !B.metaKey && !B.altKey) {
        const ke = te(K);
        ke >= 0 && X(ke);
      }
    }
    function G() {
      m.value ? le() : z();
    }
    function q(B) {
      var ke, Ye;
      B.preventDefault(), A.value = !0, i("invalid", B);
      const K = ((ke = _.value) == null ? void 0 : ke.form) ?? null;
      if (K) {
        if (K.dataset.fxInvalidFocus) return;
        K.dataset.fxInvalidFocus = "1", queueMicrotask(() => {
          delete K.dataset.fxInvalidFocus;
        });
      }
      (Ye = x.value) == null || Ye.focus();
    }
    return Ct(() => W(!1)), t({ focus: () => {
      var B;
      return (B = x.value) == null ? void 0 : B.focus();
    }, open: z, close: le }), (B, K) => (f(), h("span", {
      class: Ne(["fe-select", [
        e.size !== "md" ? `fe-select--${e.size}` : "",
        { "is-open": m.value, "is-disabled": e.disabled, "is-invalid": H.value }
      ]])
    }, [
      d("button", {
        id: l.value,
        ref_key: "trigger",
        ref: x,
        type: "button",
        class: "fe-select__trigger",
        role: "combobox",
        disabled: e.disabled,
        "aria-haspopup": "listbox",
        "aria-expanded": m.value ? "true" : "false",
        "aria-controls": c,
        "aria-activedescendant": m.value && v.value >= 0 ? p(v.value) : void 0,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-describedby": e.ariaDescribedby,
        "aria-required": e.required ? "true" : void 0,
        "aria-invalid": H.value ? "true" : void 0,
        "data-testid": e.testid,
        "data-value": e.modelValue ?? "",
        onClick: G,
        onKeydown: V,
        onKeyup: K[0] || (K[0] = za(vt(() => {
        }, ["prevent"]), ["space"]))
      }, [
        d("span", {
          class: Ne(["fe-select__value", { "is-placeholder": !U.value }])
        }, y(P.value), 3),
        Je(u(gM), {
          class: "fe-select__chev",
          "aria-hidden": "true"
        })
      ], 40, xR),
      $.value ? (f(), h("input", {
        key: 0,
        ref_key: "hidden",
        ref: _,
        class: "fe-select__native",
        tabindex: "-1",
        "aria-hidden": "true",
        name: e.name,
        value: e.modelValue ?? "",
        required: e.required,
        disabled: e.disabled,
        onInvalid: q
      }, null, 40, SR)) : D("", !0),
      m.value && w.value ? (f(), We(wi, {
        key: 1,
        to: w.value
      }, [
        d("ul", {
          id: c,
          ref_key: "panel",
          ref: k,
          class: Ne(["fe-select__panel", { "is-up": b.value.up }]),
          dir: b.value.dir,
          role: "listbox",
          "aria-labelledby": e.ariaLabelledby ?? l.value,
          style: Xt([
            C.value,
            {
              insetInlineStart: b.value.start + "px",
              width: b.value.width + "px",
              maxHeight: b.value.maxHeight + "px",
              top: b.value.up ? void 0 : b.value.top + "px",
              bottom: b.value.up ? b.value.bottom + "px" : void 0,
              zIndex: b.value.z
            }
          ]),
          "data-testid": e.testid ? `${e.testid}-list` : void 0,
          onMousedown: K[1] || (K[1] = vt(() => {
          }, ["prevent"]))
        }, [
          (f(!0), h(Ce, null, nt(e.options, (ke, Ye) => (f(), h("li", {
            id: p(Ye),
            key: String(ke.value),
            class: Ne(["fe-select__option", { "is-active": Ye === v.value, "is-selected": ke.value === e.modelValue }]),
            role: "option",
            "aria-selected": ke.value === e.modelValue ? "true" : "false",
            "aria-disabled": ke.disabled ? "true" : void 0,
            "data-value": ke.value,
            "data-testid": e.testid ? `${e.testid}-option-${ke.value === "" ? "none" : ke.value}` : void 0,
            onMousemove: (Oe) => !ke.disabled && (v.value = Ye),
            onClick: (Oe) => fe(Ye)
          }, [
            d("span", AR, [
              d("span", ER, y(ke.label), 1),
              ke.help ? (f(), h("span", CR, y(ke.help), 1)) : D("", !0)
            ]),
            ke.value === e.modelValue ? (f(), We(u(fv), {
              key: 0,
              class: "fe-select__check",
              "aria-hidden": "true"
            })) : D("", !0)
          ], 42, TR))), 128))
        ], 46, $R)
      ], 8, ["to"])) : D("", !0)
    ], 2));
  }
}), zR = { class: "fe-cfield" }, MR = {
  key: 0,
  class: "fe-cfield__empty"
}, OR = {
  key: 0,
  class: "fe-cfield__check"
}, PR = ["checked", "disabled", "onChange"], DR = ["for"], LR = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, RR = ["id", "value", "placeholder", "disabled", "onInput"], NR = {
  key: 5,
  class: "fe-cfield__secret"
}, IR = ["id", "type", "value", "placeholder", "disabled", "onInput"], BR = ["title", "aria-label", "onClick"], FR = ["innerHTML"], UR = ["id", "type", "value", "placeholder", "min", "max", "disabled", "onInput"], HR = {
  key: 7,
  class: "fe-cfield__help"
}, KR = {
  key: 8,
  class: "fe-cfield__error"
}, VR = {
  key: 1,
  class: "fe-cfield__adv"
}, jR = {
  key: 0,
  class: "fe-cfield__advbody"
}, qR = {
  key: 0,
  class: "fe-cfield__check"
}, WR = ["checked", "disabled", "onChange"], YR = ["for"], GR = ["id", "type", "value", "placeholder", "disabled", "onInput"], XR = {
  key: 2,
  class: "fe-cfield__help"
}, JR = {
  key: 3,
  class: "fe-cfield__error"
}, ZR = /* @__PURE__ */ rt({
  __name: "StorageFields",
  props: {
    fields: {},
    modelValue: {},
    locale: {},
    invalid: {},
    errors: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(!1), l = S({}), c = E(() => n.fields.filter(($) => !$.advanced)), p = E(() => n.fields.filter(($) => $.advanced));
    function m($) {
      const F = i($.i18n_key);
      return F === $.i18n_key ? $.label : F;
    }
    function v($) {
      if (!$.help_i18n_key) return $.help ?? "";
      const F = i($.help_i18n_key);
      return F === $.help_i18n_key ? $.help ?? "" : F;
    }
    function x($) {
      if (!$.i18n_key) return $.label;
      const F = i($.i18n_key);
      return F === $.i18n_key ? $.label : F;
    }
    function k($, F) {
      a("update:modelValue", { ...n.modelValue, [$]: F });
    }
    function _($) {
      var I, Z;
      const F = (I = n.modelValue) == null ? void 0 : I[$.key];
      if (F != null) return F;
      for (const J of $.aliases ?? []) {
        const re = (Z = n.modelValue) == null ? void 0 : Z[J];
        if (re != null) return re;
      }
      return $.default ?? void 0;
    }
    function w($) {
      const F = _($);
      return F == null ? "" : String(F);
    }
    function b($) {
      const F = _($);
      return F === "" || F === void 0 || F === null ? "" : String(F);
    }
    function C($) {
      return _($) === !0;
    }
    function A($) {
      var F;
      return (n.invalid ?? []).includes($.key) || !!((F = n.errors) != null && F[$.key]);
    }
    function T($) {
      var F;
      return ((F = n.errors) == null ? void 0 : F[$.key]) || (A($) ? i("conn.form.required") : "");
    }
    function R($) {
      if ($.type === "bool") {
        const F = ($.options ?? []).filter((J) => J.value === "true" || J.value === "false"), I = F.find((J) => J.value === "true"), Z = F.find((J) => J.value === "false");
        return [
          { value: "true", label: I ? x(I) : i("conn.form.yes") },
          { value: "false", label: Z ? x(Z) : i("conn.form.no") }
        ];
      }
      return ($.options ?? []).map((F) => ({ value: F.value, label: x(F) }));
    }
    function M($) {
      const F = _($);
      return $.type === "bool" ? F === !0 || F === "true" ? "true" : F === !1 || F === "false" ? "false" : "" : $.multi ? Array.isArray(F) ? F.map((I) => String(I)) : F == null || F === "" ? [] : [String(F)] : F == null ? "" : String(F);
    }
    function L($, F) {
      if ($.type === "bool") {
        k($.key, F === "true");
        return;
      }
      k($.key, F);
    }
    function U($) {
      return $.choice === !0 && ($.type === "select" || $.type === "bool");
    }
    function P($) {
      return $.type === "int" ? "number" : $.type === "password" && !l.value[$.key] ? "password" : "text";
    }
    function H($) {
      l.value = { ...l.value, [$]: !l.value[$] };
    }
    return ($, F) => (f(), h("div", zR, [
      e.fields.length ? D("", !0) : (f(), h("p", MR, y(u(i)("conn.form.noFields")), 1)),
      (f(!0), h(Ce, null, nt(c.value, (I) => (f(), h("div", {
        key: I.key,
        class: Ne(["fe-cfield__row", { "is-invalid": A(I) }])
      }, [
        I.type === "bool" && !U(I) ? (f(), h("label", OR, [
          d("input", {
            type: "checkbox",
            checked: C(I),
            disabled: e.disabled,
            onChange: (Z) => k(I.key, Z.target.checked)
          }, null, 40, PR),
          d("span", null, y(m(I)), 1)
        ])) : (f(), h("label", {
          key: 1,
          class: "fe-cfield__label",
          for: `fe-cf-${I.key}`
        }, [
          Vt(y(m(I)), 1),
          I.required ? (f(), h("span", LR, "*")) : D("", !0)
        ], 8, DR)),
        U(I) ? (f(), We(mi, {
          key: 2,
          options: R(I),
          "model-value": M(I),
          multi: I.multi === !0,
          disabled: e.disabled,
          invalid: A(I),
          "aria-label": m(I),
          "testid-prefix": `fe-choice-${I.key}`,
          "onUpdate:modelValue": (Z) => L(I, Z)
        }, null, 8, ["options", "model-value", "multi", "disabled", "invalid", "aria-label", "testid-prefix", "onUpdate:modelValue"])) : I.type === "select" ? (f(), We(fc, {
          key: 3,
          id: `fe-cf-${I.key}`,
          "model-value": w(I),
          options: R(I),
          disabled: e.disabled,
          invalid: A(I),
          "onUpdate:modelValue": (Z) => k(I.key, String(Z))
        }, null, 8, ["id", "model-value", "options", "disabled", "invalid", "onUpdate:modelValue"])) : I.multiline ? (f(), h("textarea", {
          key: 4,
          id: `fe-cf-${I.key}`,
          class: Ne(["fe-cfield__input fe-cfield__input--area", { "fe-cfield__input--mono": I.monospace }]),
          rows: "4",
          value: w(I),
          placeholder: I.placeholder,
          disabled: e.disabled,
          onInput: (Z) => k(I.key, Z.target.value)
        }, null, 42, RR)) : I.type === "password" ? (f(), h("div", NR, [
          d("input", {
            id: `fe-cf-${I.key}`,
            class: "fe-cfield__input fe-cfield__input--mono",
            type: P(I),
            autocomplete: "new-password",
            spellcheck: "false",
            value: w(I),
            placeholder: I.placeholder,
            disabled: e.disabled,
            onInput: (Z) => k(I.key, Z.target.value)
          }, null, 40, IR),
          d("button", {
            type: "button",
            class: "fe-cfield__eye",
            title: l.value[I.key] ? u(i)("conn.form.hide") : u(i)("conn.form.reveal"),
            "aria-label": l.value[I.key] ? u(i)("conn.form.hide") : u(i)("conn.form.reveal"),
            onClick: (Z) => H(I.key)
          }, [
            d("span", {
              "aria-hidden": "true",
              innerHTML: u(Pt)(l.value[I.key] ? "toggle-hidden" : "preview")
            }, null, 8, FR)
          ], 8, BR)
        ])) : I.type !== "bool" ? (f(), h("input", {
          key: 6,
          id: `fe-cf-${I.key}`,
          class: Ne(["fe-cfield__input", { "fe-cfield__input--mono": I.monospace }]),
          type: P(I),
          value: I.type === "int" ? b(I) : w(I),
          placeholder: I.placeholder,
          min: I.min,
          max: I.max,
          disabled: e.disabled,
          onInput: (Z) => k(
            I.key,
            I.type === "int" ? Z.target.value === "" ? null : Number(Z.target.value) : Z.target.value
          )
        }, null, 42, UR)) : D("", !0),
        v(I) ? (f(), h("p", HR, y(v(I)), 1)) : D("", !0),
        T(I) ? (f(), h("p", KR, y(T(I)), 1)) : D("", !0)
      ], 2))), 128)),
      p.value.length ? (f(), h("div", VR, [
        d("button", {
          type: "button",
          class: "fe-cfield__advtoggle",
          onClick: F[0] || (F[0] = (I) => r.value = !r.value)
        }, y(r.value ? "▾" : "▸") + " " + y(u(i)("conn.form.advanced")), 1),
        r.value ? (f(), h("div", jR, [
          (f(!0), h(Ce, null, nt(p.value, (I) => (f(), h("div", {
            key: I.key,
            class: "fe-cfield__row"
          }, [
            I.type === "bool" ? (f(), h("label", qR, [
              d("input", {
                type: "checkbox",
                checked: C(I),
                disabled: e.disabled,
                onChange: (Z) => k(I.key, Z.target.checked)
              }, null, 40, WR),
              d("span", null, y(m(I)), 1)
            ])) : (f(), h(Ce, { key: 1 }, [
              d("label", {
                class: "fe-cfield__label",
                for: `fe-cfa-${I.key}`
              }, y(m(I)), 9, YR),
              d("input", {
                id: `fe-cfa-${I.key}`,
                class: Ne(["fe-cfield__input", { "fe-cfield__input--mono": I.monospace }]),
                type: P(I),
                value: I.type === "int" ? b(I) : w(I),
                placeholder: I.placeholder,
                disabled: e.disabled,
                onInput: (Z) => k(
                  I.key,
                  I.type === "int" ? Z.target.value === "" ? null : Number(Z.target.value) : Z.target.value
                )
              }, null, 42, GR)
            ], 64)),
            v(I) ? (f(), h("p", XR, y(v(I)), 1)) : D("", !0),
            T(I) ? (f(), h("p", JR, y(T(I)), 1)) : D("", !0)
          ]))), 128))
        ])) : D("", !0)
      ])) : D("", !0)
    ]));
  }
}), QR = {
  class: "fe-surface__form",
  "data-testid": "surface-form"
}, eN = /* @__PURE__ */ rt({
  __name: "SurfaceForm",
  props: {
    fields: {},
    values: {},
    locale: {},
    errors: {},
    disabled: { type: Boolean },
    invalid: {}
  },
  emits: ["update:values"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => pg(n.fields, n.values)), r = E(
      () => i.value.map((c) => ({ ...oR(c, n.locale), required: US(c, n.values) }))
    ), l = E(() => {
      var p;
      const c = {};
      for (const m of r.value) {
        const v = Zt((p = n.errors) == null ? void 0 : p[m.key], n.locale);
        v && (c[m.key] = v);
      }
      return c;
    });
    return (c, p) => (f(), h("div", QR, [
      Je(ZR, {
        fields: r.value,
        "model-value": e.values,
        locale: e.locale,
        errors: l.value,
        invalid: e.invalid,
        disabled: e.disabled,
        "onUpdate:modelValue": p[0] || (p[0] = (m) => a("update:values", m))
      }, null, 8, ["fields", "model-value", "locale", "errors", "invalid", "disabled"])
    ]));
  }
}), tN = ["aria-label"], nN = ["aria-current", "data-step"], aN = {
  class: "fe-steps__marker",
  "aria-hidden": "true"
}, iN = {
  key: 0,
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  focusable: "false"
}, oN = { class: "fe-steps__label" }, rN = /* @__PURE__ */ rt({
  __name: "SurfaceSteps",
  props: {
    items: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale);
    function a(i) {
      return i === "done" || i === "active" ? i : "todo";
    }
    return (i, r) => (f(), h("ol", {
      class: "fe-steps",
      "aria-label": u(n)("plugin.steps.label"),
      "data-testid": "surface-steps"
    }, [
      (f(!0), h(Ce, null, nt(e.items ?? [], (l, c) => (f(), h("li", {
        key: l.id || c,
        class: Ne(["fe-steps__item", `is-${a(l.state)}`]),
        "aria-current": a(l.state) === "active" ? "step" : void 0,
        "data-step": l.id
      }, [
        d("span", aN, [
          a(l.state) === "done" ? (f(), h("svg", iN, [...r[0] || (r[0] = [
            d("path", { d: "M4.8 12.6l4.7 4.7L19.2 6.9" }, null, -1)
          ])])) : (f(), h(Ce, { key: 1 }, [
            Vt(y(c + 1), 1)
          ], 64))
        ]),
        d("span", oN, y(u(Zt)(l.label, e.locale)), 1)
      ], 10, nN))), 128))
    ], 8, tN));
  }
});
let Rm = null;
function qS() {
  return Rm || (Rm = C4("t")), Rm;
}
function hg() {
  const e = qS().get();
  return e && typeof e == "object" && !Array.isArray(e) ? e : {};
}
function WS(e, t) {
  const n = hg(), a = { ...n[e] ?? {} };
  for (const [r, l] of Object.entries(t))
    l === void 0 ? delete a[r] : a[r] = l;
  const i = { ...n };
  Object.keys(a).length ? i[e] = a : delete i[e], qS().set(i);
}
function sN(e) {
  return {
    get: () => {
      var t;
      return (t = hg()[e]) == null ? void 0 : t.c;
    },
    set: (t) => {
      var a;
      const n = Object.keys(t.w).length > 0 || t.hidden.length > 0 || (((a = t.o) == null ? void 0 : a.length) ?? 0) > 0;
      WS(e, { c: n ? t : void 0 });
    }
  };
}
function lN(e) {
  var n;
  const t = (n = hg()[e]) == null ? void 0 : n.s;
  return !t || typeof t.k != "string" || t.d !== "asc" && t.d !== "desc" ? null : { key: t.k, dir: t.d };
}
function uN(e, t) {
  WS(e, { s: t ? { k: t.key, d: t.dir } : void 0 });
}
const Nm = "data-fe-cut-title";
function a1(e) {
  const t = e;
  return t.scrollWidth > t.clientWidth;
}
function cN(e) {
  return (e.textContent ?? "").replace(/\s+/g, " ").trim();
}
function dN(e, t) {
  if (!t || typeof Element > "u" || !(e instanceof Element)) return;
  const n = e.closest(".tbl-pill");
  if (!n || !t.contains(n)) return;
  const a = n.getAttribute(Nm), i = n.getAttribute("title");
  if (i !== null && i !== a) return;
  const r = Array.from(n.querySelectorAll(".tbl-pill__text")), l = a1(n) || r.some(a1), c = cN(n);
  l && c ? (n.setAttribute("title", c), n.setAttribute(Nm, c)) : a !== null && (n.removeAttribute("title"), n.removeAttribute(Nm));
}
const fN = ["aria-checked", "aria-label", "title"], mg = /* @__PURE__ */ rt({
  __name: "ItemCheck",
  props: {
    on: { type: Boolean },
    label: {}
  },
  setup(e) {
    return (t, n) => (f(), h("button", {
      type: "button",
      class: Ne(["fe-list__check", { "is-on": e.on }]),
      role: "checkbox",
      "aria-checked": e.on ? "true" : "false",
      "aria-label": e.label,
      title: e.label,
      onMousedown: n[0] || (n[0] = vt(() => {
      }, ["prevent"]))
    }, null, 42, fN));
  }
}), pN = ["disabled", "data-testid"], hN = /* @__PURE__ */ rt({
  __name: "RowActions",
  props: {
    actions: {},
    locale: { default: "en" },
    label: {},
    disabled: { type: Boolean },
    theme: {},
    testid: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, dir: r } = ht(() => n.locale), l = S(
      null
    ), c = E(() => n.label || i("row.actions")), p = E(
      () => n.actions.filter((k) => !k.hidden).map((k) => ({
        ...k,
        shortcutId: k.shortcutId ?? "",
        testid: k.testid ?? (n.testid ? `${n.testid}-${k.key}` : void 0)
      }))
    ), m = E(() => p.value.some((k) => !k.divider && !k.disabled));
    function v(k) {
      var w, b;
      const _ = (w = k.currentTarget) == null ? void 0 : w.getBoundingClientRect();
      (b = l.value) == null || b.show(
        // ⚠ RTL: the START corner (right in RTL), as ListView `onRowMenu` does.
        { clientX: _ ? Rr(_, r.value) : k.clientX, clientY: _ ? _.bottom : k.clientY },
        []
      );
    }
    function x(k) {
      a("select", k.key, k);
    }
    return (k, _) => (f(), h("div", {
      class: "tbl-rowactions",
      onClick: _[0] || (_[0] = vt(() => {
      }, ["stop"]))
    }, [
      d("button", {
        type: "button",
        class: "tbl-rowactions__btn",
        disabled: e.disabled || !m.value,
        "data-testid": e.testid,
        "data-fe-control": "",
        "aria-haspopup": "menu",
        onClick: vt(v, ["stop"])
      }, [
        d("span", null, y(c.value), 1),
        _[1] || (_[1] = d("span", {
          class: "tbl-rowactions__caret",
          "aria-hidden": "true"
        }, "▾", -1))
      ], 8, pN),
      Je(ml, {
        ref_key: "menu",
        ref: l,
        locale: e.locale,
        theme: e.theme,
        actions: p.value,
        onSelect: x
      }, null, 8, ["locale", "theme", "actions"])
    ]));
  }
}), mN = {
  key: 0,
  class: "tbl-bar"
}, vN = {
  key: 1,
  class: "fe-list__refreshing",
  role: "status"
}, yN = { class: "fe-sr-only" }, gN = ["aria-label", "aria-busy", "data-table-id"], bN = ["data-sort-label"], kN = {
  key: 0,
  class: "fe-list__col fe-list__col--check",
  role: "columnheader"
}, wN = ["aria-sort", "data-col"], _N = ["disabled", "title"], xN = { class: "fe-list__sort-label" }, SN = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, $N = ["title"], TN = ["aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-label", "title"], AN = ["aria-sort", "aria-label", "data-col", "onPointerdown", "onKeydown"], EN = ["disabled", "title", "onClick"], CN = { class: "fe-list__sort-label" }, zN = {
  key: 0,
  class: "fe-list__sort-arrow",
  "aria-hidden": "true"
}, MN = ["title"], ON = ["aria-valuenow", "aria-valuemin", "aria-valuemax", "aria-label", "title", "onPointerdown", "onDblclick", "onKeydown"], PN = ["title", "aria-label", "aria-expanded"], DN = ["role"], LN = {
  key: 0,
  class: "fe-list__group",
  role: "presentation"
}, RN = ["aria-selected", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], NN = ["onClick"], IN = ["title"], BN = { class: "fe-list__cell-text" }, FN = ["data-col", "data-label", "title"], UN = {
  key: 0,
  class: "fe-list__cell-text"
}, HN = {
  key: 0,
  class: "fe-list__empty fe-list__empty--loading",
  role: "row"
}, KN = ["aria-colspan"], VN = {
  key: 1,
  class: "fe-list__empty",
  role: "row"
}, jN = ["aria-colspan"], qN = {
  key: 2,
  class: "tbl-foot"
}, WN = {
  key: 0,
  class: "tbl-pager"
}, YN = ["disabled", "aria-label", "title"], GN = {
  class: "tbl-pager__at",
  dir: "ltr"
}, XN = ["disabled", "aria-label", "title"], JN = ["dir", "data-prefers-dark"], ZN = ["aria-label", "onKeydown"], QN = { class: "fe-colmenu__title" }, eI = ["aria-checked", "onClick"], tI = { class: "fe-colmenu__label" }, nI = ["disabled", "title", "aria-label", "onClick"], aI = { "aria-hidden": "true" }, iI = ["disabled", "title", "aria-label", "onClick"], oI = { "aria-hidden": "true" }, rI = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, sI = { class: "fe-colmenu__label" }, Im = 8, Us = 12, i1 = 28, lI = 160, uI = 160, cI = 5, dI = 300, es = /* @__PURE__ */ rt({
  inheritAttrs: !1,
  __name: "DataTable",
  props: {
    rows: {},
    columns: {},
    rowKey: { type: [String, Function], default: void 0 },
    tableId: { default: void 0 },
    columnStore: { default: void 0 },
    candidates: { default: void 0 },
    metrics: { default: void 0 },
    locale: { default: void 0 },
    theme: { default: void 0 },
    loading: { type: Boolean },
    empty: { default: void 0 },
    ariaLabel: { default: void 0 },
    selectable: { type: Boolean },
    isSelected: { type: Function, default: void 0 },
    sort: { default: void 0 },
    sortClosed: { default: void 0 },
    groups: { default: void 0 },
    rowClass: { type: Function, default: void 0 },
    rowAttrs: { type: Function, default: void 0 },
    rowActions: { type: Function, default: void 0 },
    rowActionsTestId: { type: Function, default: void 0 },
    actionsWidth: { default: void 0 },
    framed: { type: Boolean, default: !0 },
    page: { default: void 0 },
    pageSize: { default: void 0 },
    total: { default: void 0 },
    pages: { default: void 0 },
    footNote: { default: void 0 }
  },
  emits: ["sort", "row-click", "row-dblclick", "row-contextmenu", "check-click", "row-action", "row-dragstart", "row-dragover", "row-dragleave", "row-drop", "row-touchstart", "row-touchend", "row-touchmove", "page"],
  setup(e, { expose: t, emit: n }) {
    var jt;
    const a = e, i = n, r = U4(), l = E(() => a.locale ?? (r == null ? void 0 : r.locale.value) ?? "en"), c = E(() => {
      var ce;
      return a.theme ?? ((ce = r == null ? void 0 : r.theme) == null ? void 0 : ce.value);
    }), { t: p, dir: m } = ht(() => l.value), v = E(() => {
      const ce = /* @__PURE__ */ new Map();
      for (const be of a.columns) ce.set(be.id, be);
      return ce;
    }), x = E(() => {
      var ce;
      return ((ce = a.columns.find((be) => be.lead) ?? a.columns[0]) == null ? void 0 : ce.id) ?? "";
    }), k = E(
      () => a.columns.map((ce) => {
        const be = ce.id === x.value, Re = ce.width ?? (be ? 240 : 140);
        return {
          id: ce.id,
          width: Re,
          min: Math.min(ce.min ?? (be ? 120 : 56), Re),
          max: Math.max(ce.max ?? 900, Re),
          hideable: be ? !1 : ce.hideable !== !1,
          resizable: ce.resizable !== !1
        };
      })
    ), _ = eS(
      () => k.value,
      a.tableId ? sN(a.tableId) : v4(),
      { lead: x.value }
    ), w = E(() => a.columnStore ?? _), b = E(
      () => (a.candidates ?? a.columns.map((ce) => ce.id)).filter((ce) => ce !== w.value.lead)
    ), C = i1 + Us, A = E(() => a.actionsWidth ?? (a.rowActions ? 92 : 28)), T = E(() => ({
      gap: Im,
      padding: Us * 2,
      check: a.selectable ? i1 : 0,
      menu: A.value,
      ...a.metrics ?? {}
    })), R = S(null), M = S(0);
    let L = null, U = 0, P = 0;
    const H = S(!1), $ = S(!1);
    function F(ce) {
      if (!ce) return;
      const be = yv(ce).end;
      be !== $.value && ($.value = be);
    }
    function I(ce) {
      const be = ce.currentTarget;
      if (!be) return;
      const Re = yv(be).start;
      Re !== H.value && (H.value = Re), F(be);
    }
    Xe(
      R,
      (ce) => {
        L == null || L.disconnect(), L = null, P && cancelAnimationFrame(P), P = 0, !(!ce || typeof ResizeObserver > "u") && (L = new ResizeObserver((be) => {
          var pt, fn;
          U = ((fn = (pt = be[0]) == null ? void 0 : pt.contentRect) == null ? void 0 : fn.width) ?? 0, !P && (P = requestAnimationFrame(() => {
            P = 0, Math.abs(U - M.value) >= 1 && (M.value = U);
          }));
        }), L.observe(ce));
      },
      { flush: "post" }
    );
    const Z = E(() => w.value.layout(M.value, b.value, T.value)), J = E(() => Z.value.visible), re = E(() => M.value > 0 && M.value < Z.value.stackBelow);
    Xe(
      [() => Z.value.total, M, re],
      () => F(R.value),
      { flush: "post" }
    ), Xe(re, (ce) => {
      ce && (H.value = !1);
    });
    const ve = (ce, { slots: be }) => {
      var Re, pt;
      return ce.on ? dM("div", { class: "fe-list__stack-value" }, (Re = be.default) == null ? void 0 : Re.call(be)) : (pt = be.default) == null ? void 0 : pt.call(be);
    };
    ve.props = ["on"];
    function W(ce) {
      var be;
      return ((be = v.value.get(ce)) == null ? void 0 : be.headerLabel) === !1;
    }
    function z(ce) {
      return re.value && !W(ce);
    }
    const le = E(() => {
      if (!re.value) return null;
      const ce = J.value.filter((be) => !W(be));
      return ce.length ? ce[ce.length - 1] : null;
    });
    function fe(ce) {
      dN(ce.target, R.value);
    }
    const j = E(() => re.value ? void 0 : { width: `${Z.value.total}px` }), X = E(
      () => (a.selectable ? C + Im : Us) + (Z.value.widths[w.value.lead] ?? w.value.width(w.value.lead))
    ), te = E(
      () => !re.value && M.value > 0 && M.value - X.value >= lI
    ), V = E(() => A.value + Us), G = E(
      () => !re.value && (M.value <= 0 || M.value - X.value - V.value >= uI)
    ), q = E(() => ({
      "--fe-list-lead": a.selectable ? `${C + Im}px` : "0px"
    }));
    function B(ce) {
      if (re.value) return;
      let be = Z.value.widths[ce] ?? w.value.width(ce);
      return ce === w.value.lead && te.value && !a.selectable && (be += Us), { flex: `0 0 ${be}px` };
    }
    const K = E(
      () => re.value || A.value === 28 ? void 0 : { flex: `0 0 ${A.value + Us}px` }
    );
    function ke(ce) {
      const be = v.value.get(ce), Re = ["fe-list__col", "fe-list__cell"];
      return be != null && be.class && Re.push(be.class), ce === w.value.lead && Re.push("fe-list__col--lead"), (be == null ? void 0 : be.align) === "right" ? Re.push("is-right") : (be == null ? void 0 : be.align) === "center" && Re.push("is-center"), Re;
    }
    function Ye(ce) {
      var be;
      return ((be = v.value.get(ce)) == null ? void 0 : be.label) ?? ce;
    }
    const Oe = E(() => a.sort !== void 0), Be = S(
      a.tableId ? lN(a.tableId) : null
    ), qe = E(() => Oe.value ? a.sort ?? null : Be.value), Tt = E(
      () => (a.pages ?? 1) > 1 || a.total != null && a.total > a.rows.length
    ), $t = E(() => a.sortClosed ? a.sortClosed : !Oe.value && Tt.value ? p("table.sort_paged") : null);
    function it(ce) {
      var be;
      return ((be = v.value.get(ce)) == null ? void 0 : be.sortable) === !0;
    }
    const yt = E(
      () => re.value && !$t.value && [w.value.lead, ...J.value].some(it) ? p("sort.by") : void 0
    );
    function ft(ce) {
      if ($t.value || !it(ce)) return;
      const be = qe.value, Re = v.value.get(ce), pt = be && be.key === ce ? { key: ce, dir: be.dir === "asc" ? "desc" : "asc" } : { key: ce, dir: (Re == null ? void 0 : Re.sortDir) ?? "asc" };
      Oe.value || (Be.value = pt, a.tableId && uN(a.tableId, pt)), i("sort", pt);
    }
    function ze(ce) {
      const be = qe.value;
      return $t.value || !be || be.key !== ce ? "" : be.dir === "asc" ? "↑" : "↓";
    }
    function oe(ce) {
      if (!it(ce)) return;
      const be = qe.value;
      return $t.value || !be || be.key !== ce ? "none" : be.dir === "asc" ? "ascending" : "descending";
    }
    function Se(ce) {
      return $t.value ?? p("cols.sort_by", { col: Ye(ce) });
    }
    function he(ce, be) {
      const Re = v.value.get(be);
      return Re != null && Re.sortValue ? Re.sortValue(ce) : Re != null && Re.format ? Re.format(ce) : ce == null ? void 0 : ce[be];
    }
    function Ke(ce, be) {
      const Re = ce == null || ce === "", pt = be == null || be === "";
      return Re && pt ? 0 : Re ? 1 : pt ? -1 : typeof ce == "number" && typeof be == "number" ? ce - be : typeof ce == "boolean" && typeof be == "boolean" ? Number(ce) - Number(be) : String(ce).localeCompare(String(be), l.value, { numeric: !0, sensitivity: "base" });
    }
    const Le = E(() => {
      const ce = qe.value;
      if (Oe.value || $t.value || !ce || !v.value.has(ce.key)) return a.rows;
      const be = ce.dir === "asc" ? 1 : -1;
      return a.rows.map((Re, pt) => ({ row: Re, i: pt, v: he(Re, ce.key) })).sort((Re, pt) => {
        const fn = Re.v === null || Re.v === void 0 || Re.v === "", Nt = pt.v === null || pt.v === void 0 || pt.v === "";
        return fn !== Nt ? fn ? 1 : -1 : be * Ke(Re.v, pt.v) || Re.i - pt.i;
      }).map((Re) => Re.row);
    }), ut = E(() => a.groups ?? [{ id: "all", items: Le.value }]), wt = cM(), _t = E(() => a.empty === void 0 ? p("table.empty") : a.empty ?? ""), At = E(() => !a.loading && pe.value === 0 && (!!wt.empty || _t.value !== "")), _e = E(() => pe.value > 0 || a.loading && pe.value === 0 || At.value), Ie = E(() => J.value.length + 2 + (a.selectable ? 1 : 0)), pe = E(() => ut.value.reduce((ce, be) => ce + be.items.length, 0));
    function we(ce, be) {
      return typeof a.rowKey == "function" ? a.rowKey(ce) : a.rowKey ? ce == null ? void 0 : ce[a.rowKey] : be;
    }
    function ee(ce) {
      return a.isSelected ? a.isSelected(ce) : !1;
    }
    function ge(ce, be) {
      return ce == null ? void 0 : ce[be];
    }
    function ae(ce, be) {
      const Re = v.value.get(be), pt = Re != null && Re.format ? Re.format(ce) : ce == null ? void 0 : ce[be];
      return pt == null || pt === "" ? "-" : _2(String(pt));
    }
    function xe(ce, be) {
      const Re = v.value.get(be);
      if (Re != null && Re.title) return Re.title(ce);
      const pt = ae(ce, be);
      return pt === "-" ? void 0 : pt;
    }
    function Fe(ce, be) {
      var Re;
      return [
        "fe-list__row",
        { "is-selected": ee(ce), "is-clickable": !!ye.value },
        (Re = a.rowClass) == null ? void 0 : Re.call(a, ce, be)
      ];
    }
    const ye = S(!1);
    let Te = null;
    function Ue() {
      w.value.widthsAreAuto() && w.value.freeze(Z.value.widths);
    }
    function xt(ce) {
      var be;
      return ((be = w.value.spec(ce)) == null ? void 0 : be.resizable) === !0;
    }
    function Qt(ce) {
      return Math.round(Z.value.widths[ce] ?? w.value.width(ce));
    }
    function vn(ce) {
      var be;
      return (be = w.value.spec(ce)) == null ? void 0 : be.min;
    }
    function Ut(ce) {
      var be;
      return (be = w.value.spec(ce)) == null ? void 0 : be.max;
    }
    function pn(ce, be) {
      xt(ce) && (be.preventDefault(), be.stopPropagation(), Ue(), Te = { id: ce, startX: be.clientX, startW: w.value.width(ce), sign: vv(ei(R.value)) }, window.addEventListener("pointermove", Rt), window.addEventListener("pointerup", rn));
    }
    function Rt(ce) {
      Te && w.value.setWidth(Te.id, Te.startW + Te.sign * (ce.clientX - Te.startX));
    }
    function rn() {
      Te = null, window.removeEventListener("pointermove", Rt), window.removeEventListener("pointerup", rn);
    }
    function nn(ce, be) {
      if (be.ctrlKey || be.metaKey) return;
      const Re = 16 * Rf(be.key, ei(R.value));
      Re && (be.preventDefault(), Ue(), w.value.setWidth(ce, w.value.width(ce) + Re));
    }
    function gt(ce) {
      const be = w.value.spec(ce);
      be && (Ue(), w.value.setWidth(ce, be.width));
    }
    let wn = null;
    const ra = S(null), dn = S(null);
    let jn = 0;
    function zn(ce) {
      var be;
      return ce !== w.value.lead && ((be = w.value.spec(ce)) == null ? void 0 : be.hideable) === !0;
    }
    function Bn(ce, be) {
      be.button !== 0 || !zn(ce) || re.value || (wn = { id: ce, startX: be.clientX, armed: !1 }, window.addEventListener("pointermove", sn), window.addEventListener("pointerup", $n), window.addEventListener("keydown", He, !0), window.addEventListener("pointercancel", Sn), window.addEventListener("blur", Sn));
    }
    function Sn() {
      const ce = (wn == null ? void 0 : wn.armed) === !0;
      Ve(), ce && (jn = Date.now());
    }
    function mn() {
      const ce = J.value;
      let be = 0;
      for (; be < ce.length && !zn(ce[be]); ) be++;
      let Re = ce.length;
      for (; Re > be && !zn(ce[Re - 1]); ) Re--;
      return { first: be, last: Re };
    }
    function sn(ce) {
      var la;
      if (!wn) return;
      if (!wn.armed) {
        if (Math.abs(ce.clientX - wn.startX) < cI) return;
        wn.armed = !0, ra.value = wn.id;
      }
      const be = (la = R.value) == null ? void 0 : la.querySelector(".fe-list__head");
      if (!be) return;
      const Re = Array.from(be.children).filter((_n) => _n.classList.contains("fe-list__col")), pt = a.selectable ? 2 : 1, fn = Re.slice(pt, pt + J.value.length), Nt = vv(ei(R.value));
      let sa = fn.length;
      for (let _n = 0; _n < fn.length; _n++) {
        const Dl = fn[_n].getBoundingClientRect();
        if (Nt * (ce.clientX - (Dl.left + Dl.width / 2)) < 0) {
          sa = _n;
          break;
        }
      }
      const { first: Pa, last: eo } = mn();
      sa = Math.max(Pa, Math.min(eo, sa));
      const Si = J.value.indexOf(wn.id);
      dn.value = sa === Si || sa === Si + 1 ? null : sa;
    }
    function $n() {
      const ce = wn, be = dn.value;
      Ve(), ce != null && ce.armed && (jn = Date.now(), be != null && Rn(ce.id, be));
    }
    function Rn(ce, be) {
      const Re = J.value, pt = Re.indexOf(ce);
      if (pt === -1 || be === pt || be === pt + 1) return;
      const Nt = Re.filter((eo) => eo !== ce)[be > pt ? be - 1 : be], sa = w.value.order().filter((eo) => eo !== ce), Pa = Nt ? sa.indexOf(Nt) : sa.length;
      Pa !== -1 && w.value.move(ce, Pa);
    }
    function Fn() {
      return w.value.order().filter((ce) => zn(ce) && b.value.includes(ce));
    }
    function Tn(ce, be) {
      const Re = Fn(), pt = Re.indexOf(ce), fn = pt + be;
      if (pt === -1 || fn < 0 || fn >= Re.length) return;
      const Nt = Re[fn], Pa = w.value.order().filter((eo) => eo !== ce).indexOf(Nt);
      Pa !== -1 && w.value.move(ce, be === -1 ? Pa : Pa + 1);
    }
    function me(ce, be) {
      const Re = Fn(), pt = Re.indexOf(ce);
      return pt !== -1 && pt + be >= 0 && pt + be < Re.length;
    }
    function De(ce, be) {
      if (!be.ctrlKey && !be.metaKey) return;
      const Re = Rf(be.key, ei(R.value));
      !Re || !zn(ce) || (be.preventDefault(), be.stopPropagation(), Tn(ce, Re));
    }
    function He(ce) {
      ce.key === "Escape" && (ce.stopPropagation(), Sn());
    }
    function Ve() {
      wn = null, ra.value = null, dn.value = null, window.removeEventListener("pointermove", sn), window.removeEventListener("pointerup", $n), window.removeEventListener("keydown", He, !0), window.removeEventListener("pointercancel", Sn), window.removeEventListener("blur", Sn);
    }
    function bt(ce) {
      Date.now() - jn > dI || (jn = 0, ce.preventDefault(), ce.stopPropagation());
    }
    const Qe = S(!1), se = S(0), je = S(0);
    let dt = 0;
    const tt = S(null), ie = Ml(), ue = E(() => `fe-ctx-backdrop--theme-${c.value || "auto"}`), Pe = E(
      () => m.value === "rtl" ? { earlier: { key: "cols.move_right", arrow: "→" }, later: { key: "cols.move_left", arrow: "←" } } : { earlier: { key: "cols.move_left", arrow: "←" }, later: { key: "cols.move_right", arrow: "→" } }
    ), Ge = E(
      () => (
        /* In the person's OWN order, so the list reads as the table on screen. */
        w.value.order().filter((ce) => zn(ce) && b.value.includes(ce)).map((ce) => ({
          id: ce,
          label: Ye(ce),
          on: !w.value.hidden(ce),
          canEarlier: me(ce, -1),
          canLater: me(ce, 1)
        }))
      )
    ), ot = E(() => w.value.customised());
    async function St(ce) {
      var pt;
      ce.preventDefault(), ce.stopPropagation();
      const be = ce.currentTarget, Re = be == null ? void 0 : be.getBoundingClientRect();
      dt = ce.clientX || (Re ? Rr(Re, m.value) : 0), se.value = dt, je.value = ce.clientY || (Re ? Re.bottom : 0), Qe.value = !0, await Jt(), Et(), (pt = tt.value) == null || pt.focus();
    }
    function Et() {
      const ce = tt.value;
      if (!ce) return;
      const be = ce.getBoundingClientRect(), Re = 8;
      se.value = Sc(dt, be.width, window.innerWidth, m.value, Re), be.bottom > window.innerHeight - Re && (je.value = Math.max(Re, window.innerHeight - Re - be.height));
    }
    function ne() {
      Qe.value = !1;
    }
    function Q(ce) {
      ce.key === "Escape" && (ce.stopPropagation(), ne());
    }
    Xe(Qe, (ce) => {
      typeof window > "u" || (ce ? window.addEventListener("keydown", Q, !0) : window.removeEventListener("keydown", Q, !0));
    });
    function Ae(ce) {
      w.value.setHidden(ce, !w.value.hidden(ce));
    }
    function at() {
      w.value.reset();
    }
    Ct(() => {
      L == null || L.disconnect(), L = null, P && cancelAnimationFrame(P), P = 0, rn(), Ve(), typeof window < "u" && window.removeEventListener("keydown", Q, !0);
    });
    const ct = E(() => a.pages != null ? Math.max(1, a.pages) : !a.total || !a.pageSize ? 1 : Math.max(1, Math.ceil(a.total / a.pageSize))), zt = E(() => a.page ?? 1), Ht = E(() => ct.value > 1), Wt = E(() => {
      if (a.total != null && a.pageSize != null && a.total > 0) {
        const ce = (zt.value - 1) * a.pageSize + 1, be = Math.min(zt.value * a.pageSize, a.total);
        return `${ce} - ${be} / ${a.total}`;
      }
      return "";
    });
    function tn(ce) {
      ce < 1 || ce > ct.value || i("page", ce);
    }
    const Ft = Go();
    ye.value = !!((jt = Ft == null ? void 0 : Ft.vnode.props) != null && jt.onRowClick);
    function yn(ce, be) {
      i("row-click", ce, be);
    }
    function Nn(ce, be, Re) {
      i("row-action", ce, be, Re);
    }
    return t({ store: w, layout: Z, pinLead: te, stacked: re }), (ce, be) => (f(), h(Ce, null, [
      d("div", dv(ce.$attrs, {
        class: ["fe-table", { "fe-table--framed": e.framed, "fe-table--bare": !e.framed }]
      }), [
        ce.$slots.toolbar ? (f(), h("div", mN, [
          Ln(ce.$slots, "toolbar")
        ])) : D("", !0),
        e.loading && pe.value > 0 ? (f(), h("div", vN, [
          d("span", yN, y(u(p)("loading")), 1)
        ])) : D("", !0),
        d("div", {
          ref_key: "listEl",
          ref: R,
          class: Ne(["fe-list", {
            "is-loading": e.loading,
            "is-scrolled-x": H.value,
            "is-more-end": $.value,
            "is-pin-lead": te.value,
            "is-pin-menu": G.value,
            "is-stacked": re.value,
            "fe-list--nocheck": !e.selectable
          }]),
          style: Xt(q.value),
          role: "grid",
          "aria-label": e.ariaLabel,
          "aria-busy": e.loading ? "true" : void 0,
          "data-table-id": e.tableId,
          onScrollPassive: I
        }, [
          d("div", {
            class: Ne(["fe-list__head", { "is-dragging-col": !!ra.value }]),
            role: "row",
            "data-sort-label": yt.value,
            style: Xt(j.value),
            onContextmenu: St,
            onClickCapture: bt
          }, [
            e.selectable ? (f(), h("div", kN)) : D("", !0),
            d("div", {
              class: Ne(ke(w.value.lead)),
              role: "columnheader",
              style: Xt(B(w.value.lead)),
              "aria-sort": oe(w.value.lead),
              "data-col": w.value.lead
            }, [
              it(w.value.lead) ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fe-list__sort",
                disabled: !!$t.value,
                title: Se(w.value.lead),
                onClick: be[0] || (be[0] = (Re) => ft(w.value.lead))
              }, [
                d("span", xN, y(Ye(w.value.lead)), 1),
                ze(w.value.lead) ? (f(), h("span", SN, y(ze(w.value.lead)), 1)) : D("", !0)
              ], 8, _N)) : (f(), h("span", {
                key: 1,
                class: "fe-list__head-label",
                title: Ye(w.value.lead)
              }, y(Ye(w.value.lead)), 9, $N)),
              xt(w.value.lead) && !re.value ? (f(), h("span", {
                key: 2,
                class: "fe-list__resize",
                role: "separator",
                "aria-orientation": "vertical",
                tabindex: "0",
                "aria-valuenow": Qt(w.value.lead),
                "aria-valuemin": vn(w.value.lead),
                "aria-valuemax": Ut(w.value.lead),
                "aria-label": u(p)("cols.resize", { col: Ye(w.value.lead) }),
                title: u(p)("cols.resize", { col: Ye(w.value.lead) }),
                onPointerdown: be[1] || (be[1] = (Re) => pn(w.value.lead, Re)),
                onDblclick: be[2] || (be[2] = vt((Re) => gt(w.value.lead), ["stop"])),
                onKeydown: be[3] || (be[3] = (Re) => nn(w.value.lead, Re))
              }, null, 40, TN)) : D("", !0)
            ], 14, wN),
            (f(!0), h(Ce, null, nt(J.value, (Re, pt) => (f(), h("div", {
              key: Re,
              class: Ne([
                ke(Re),
                {
                  "is-col-dragging": ra.value === Re,
                  "is-drop-before": dn.value === pt,
                  "is-drop-after": dn.value === J.value.length && pt === J.value.length - 1,
                  "is-movable": zn(Re) && !re.value
                }
              ]),
              role: "columnheader",
              style: Xt(B(Re)),
              "aria-sort": oe(Re),
              "aria-label": W(Re) ? Ye(Re) : void 0,
              "data-col": Re,
              onPointerdown: (fn) => Bn(Re, fn),
              onKeydown: (fn) => De(Re, fn)
            }, [
              it(Re) ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fe-list__sort",
                disabled: !!$t.value,
                title: Se(Re),
                onClick: (fn) => ft(Re)
              }, [
                d("span", CN, y(Ye(Re)), 1),
                ze(Re) ? (f(), h("span", zN, y(ze(Re)), 1)) : D("", !0)
              ], 8, EN)) : W(Re) ? D("", !0) : (f(), h("span", {
                key: 1,
                class: "fe-list__head-label",
                title: Ye(Re)
              }, y(Ye(Re)), 9, MN)),
              xt(Re) && !re.value ? (f(), h("span", {
                key: 2,
                class: "fe-list__resize",
                role: "separator",
                "aria-orientation": "vertical",
                tabindex: "0",
                "aria-valuenow": Qt(Re),
                "aria-valuemin": vn(Re),
                "aria-valuemax": Ut(Re),
                "aria-label": u(p)("cols.resize", { col: Ye(Re) }),
                title: u(p)("cols.resize", { col: Ye(Re) }),
                onPointerdown: (fn) => pn(Re, fn),
                onDblclick: vt((fn) => gt(Re), ["stop"]),
                onKeydown: (fn) => nn(Re, fn)
              }, null, 40, ON)) : D("", !0)
            ], 46, AN))), 128)),
            d("div", {
              class: Ne(["fe-list__col fe-list__col--menu", { "is-wide": A.value !== 28 }]),
              style: Xt(K.value),
              role: "columnheader"
            }, [
              d("button", {
                type: "button",
                class: "fe-list__menu fe-list__colmenu-btn",
                title: u(p)("cols.menu"),
                "aria-label": u(p)("cols.menu"),
                "aria-haspopup": "dialog",
                "aria-expanded": Qe.value ? "true" : "false",
                onClick: St
              }, [...be[12] || (be[12] = [
                d("span", { "aria-hidden": "true" }, "⋮", -1)
              ])], 8, PN)
            ], 6)
          ], 46, bN),
          d("div", {
            class: "fe-list__body",
            role: _e.value ? "rowgroup" : "presentation",
            onPointerover: fe
          }, [
            (f(!0), h(Ce, null, nt(ut.value, (Re) => (f(), h(Ce, {
              key: Re.id
            }, [
              Re.label ? (f(), h("div", LN, y(Re.label), 1)) : D("", !0),
              (f(!0), h(Ce, null, nt(Re.items, (pt, fn) => (f(), h("div", dv({
                key: we(pt, fn),
                class: Fe(pt, fn),
                role: "row",
                style: j.value,
                "aria-selected": e.selectable ? ee(pt) ? "true" : "false" : void 0
              }, { ref_for: !0 }, e.rowAttrs ? e.rowAttrs(pt) : {}, {
                onClick: (Nt) => yn(pt, Nt),
                onDblclick: (Nt) => i("row-dblclick", pt, Nt),
                onContextmenu: (Nt) => i("row-contextmenu", pt, Nt),
                onDragstart: (Nt) => i("row-dragstart", pt, Nt),
                onDragover: (Nt) => i("row-dragover", pt, Nt),
                onDragleave: (Nt) => i("row-dragleave", pt, Nt),
                onDrop: (Nt) => i("row-drop", pt, Nt),
                onTouchstartPassive: (Nt) => i("row-touchstart", pt, Nt),
                onTouchend: be[7] || (be[7] = (Nt) => i("row-touchend", Nt)),
                onTouchmovePassive: be[8] || (be[8] = (Nt) => i("row-touchmove", Nt))
              }), [
                e.selectable ? (f(), h("div", {
                  key: 0,
                  class: "fe-list__col fe-list__col--check",
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: vt((Nt) => i("check-click", pt, Nt), ["stop"]),
                  onDblclick: be[4] || (be[4] = vt(() => {
                  }, ["stop"]))
                }, [
                  Je(mg, {
                    on: ee(pt),
                    label: ae(pt, w.value.lead)
                  }, null, 8, ["on", "label"])
                ], 40, NN)) : D("", !0),
                d("div", {
                  class: Ne(ke(w.value.lead)),
                  role: "gridcell",
                  style: Xt(B(w.value.lead)),
                  title: ce.$slots[`cell-${w.value.lead}`] ? void 0 : xe(pt, w.value.lead)
                }, [
                  Ln(ce.$slots, `cell-${w.value.lead}`, {
                    row: pt,
                    value: ge(pt, w.value.lead)
                  }, () => [
                    d("span", BN, [
                      d("bdi", null, y(ae(pt, w.value.lead)), 1)
                    ])
                  ])
                ], 14, IN),
                (f(!0), h(Ce, null, nt(J.value, (Nt) => (f(), h("div", {
                  key: Nt,
                  class: Ne([
                    ke(Nt),
                    { "is-stack-fact": z(Nt), "is-stack-last": le.value === Nt, "is-stack-tail": re.value && !z(Nt) }
                  ]),
                  role: "gridcell",
                  style: Xt(B(Nt)),
                  "data-col": Nt,
                  "data-label": z(Nt) ? Ye(Nt) : void 0,
                  title: ce.$slots[`cell-${Nt}`] ? void 0 : xe(pt, Nt)
                }, [
                  Je(ve, {
                    on: z(Nt)
                  }, {
                    default: mt(() => [
                      Ln(ce.$slots, `cell-${Nt}`, {
                        row: pt,
                        value: ge(pt, Nt)
                      }, () => [
                        W(Nt) ? D("", !0) : (f(), h("span", UN, [
                          d("bdi", null, y(ae(pt, Nt)), 1)
                        ]))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["on"])
                ], 14, FN))), 128)),
                d("div", {
                  class: Ne(["fe-list__col fe-list__col--menu", { "is-wide": A.value !== 28 }]),
                  style: Xt(K.value),
                  role: "gridcell",
                  "data-fe-control": "",
                  onClick: be[5] || (be[5] = vt(() => {
                  }, ["stop"])),
                  onDblclick: be[6] || (be[6] = vt(() => {
                  }, ["stop"]))
                }, [
                  Ln(ce.$slots, "actions", { row: pt }, () => {
                    var Nt;
                    return [
                      e.rowActions && e.rowActions(pt).length ? (f(), We(hN, {
                        key: 0,
                        locale: l.value,
                        theme: c.value,
                        actions: e.rowActions(pt),
                        testid: (Nt = e.rowActionsTestId) == null ? void 0 : Nt.call(e, pt),
                        onSelect: (sa, Pa) => Nn(sa, pt, Pa)
                      }, null, 8, ["locale", "theme", "actions", "testid", "onSelect"])) : D("", !0)
                    ];
                  })
                ], 38)
              ], 16, RN))), 128))
            ], 64))), 128)),
            e.loading && pe.value === 0 ? (f(), h("div", HN, [
              d("div", {
                role: "gridcell",
                "aria-colspan": Ie.value,
                "aria-live": "polite"
              }, y(u(p)("loading")), 9, KN)
            ])) : At.value ? (f(), h("div", VN, [
              d("div", {
                role: "gridcell",
                "aria-colspan": Ie.value
              }, [
                Ln(ce.$slots, "empty", {}, () => [
                  Vt(y(_t.value), 1)
                ])
              ], 8, jN)
            ])) : D("", !0)
          ], 40, DN)
        ], 46, gN),
        Ht.value || e.footNote || ce.$slots.foot ? (f(), h("div", qN, [
          d("span", null, [
            Ln(ce.$slots, "foot", {}, () => [
              Vt(y(e.footNote || Wt.value), 1)
            ])
          ]),
          Ht.value ? (f(), h("div", WN, [
            d("button", {
              type: "button",
              class: "tbl-page",
              disabled: zt.value <= 1,
              "aria-label": u(p)("table.prev"),
              title: u(p)("table.prev"),
              onClick: be[9] || (be[9] = (Re) => tn(zt.value - 1))
            }, "‹", 8, YN),
            d("span", GN, y(zt.value) + " / " + y(ct.value), 1),
            d("button", {
              type: "button",
              class: "tbl-page",
              disabled: zt.value >= ct.value,
              "aria-label": u(p)("table.next"),
              title: u(p)("table.next"),
              onClick: be[10] || (be[10] = (Re) => tn(zt.value + 1))
            }, "›", 8, XN)
          ])) : D("", !0)
        ])) : D("", !0)
      ], 16),
      (f(), We(wi, { to: "body" }, [
        Qe.value ? (f(), h("div", {
          key: 0,
          class: Ne(["fe-colmenu__backdrop", ue.value]),
          dir: u(m),
          "data-prefers-dark": u(ie) ? "1" : "0",
          onClick: ne,
          onContextmenu: vt(ne, ["prevent"])
        }, [
          d("div", {
            ref_key: "colMenuEl",
            ref: tt,
            class: "fe-colmenu",
            role: "dialog",
            tabindex: "-1",
            "aria-label": u(p)("cols.menu"),
            style: Xt({ top: je.value + "px", left: se.value + "px" }),
            onClick: be[11] || (be[11] = vt(() => {
            }, ["stop"])),
            onKeydown: za(vt(ne, ["stop"]), ["esc"])
          }, [
            d("p", QN, y(u(p)("cols.title")), 1),
            (f(!0), h(Ce, null, nt(Ge.value, (Re) => (f(), h("div", {
              key: Re.id,
              class: "fe-colmenu__line"
            }, [
              d("button", {
                type: "button",
                class: "fe-colmenu__row",
                role: "checkbox",
                "aria-checked": Re.on ? "true" : "false",
                onClick: (pt) => Ae(Re.id)
              }, [
                d("span", {
                  class: Ne(["fe-list__check fe-colmenu__tick", { "is-on": Re.on }]),
                  "aria-hidden": "true"
                }, null, 2),
                d("span", tI, y(Re.label), 1)
              ], 8, eI),
              d("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !Re.canEarlier,
                title: u(p)(Pe.value.earlier.key, { col: Re.label }),
                "aria-label": u(p)(Pe.value.earlier.key, { col: Re.label }),
                onClick: (pt) => Tn(Re.id, -1)
              }, [
                d("span", aI, y(Pe.value.earlier.arrow), 1)
              ], 8, nI),
              d("button", {
                type: "button",
                class: "fe-colmenu__nudge",
                disabled: !Re.canLater,
                title: u(p)(Pe.value.later.key, { col: Re.label }),
                "aria-label": u(p)(Pe.value.later.key, { col: Re.label }),
                onClick: (pt) => Tn(Re.id, 1)
              }, [
                d("span", oI, y(Pe.value.later.arrow), 1)
              ], 8, iI)
            ]))), 128)),
            ot.value ? (f(), h("div", rI)) : D("", !0),
            ot.value ? (f(), h("button", {
              key: 1,
              type: "button",
              class: "fe-colmenu__row",
              onClick: at
            }, [
              d("span", sI, y(u(p)("cols.reset")), 1)
            ])) : D("", !0),
            Ln(ce.$slots, "colmenu-extra", { close: ne })
          ], 44, ZN)
        ], 42, JN)) : D("", !0)
      ]))
    ], 64));
  }
});
function fI(e, t, n, a) {
  if (!e || t !== "date" && t !== "datetime") return e;
  const i = RO(e, n);
  if (i) return i;
  const r = Date.parse(e.trim());
  return Number.isNaN(r) ? e : a(r, { time: t === "datetime" }) || e;
}
const pI = {
  class: "fe-slist",
  "data-testid": "surface-list"
}, hI = /* @__PURE__ */ rt({
  __name: "SurfaceList",
  props: {
    columns: {},
    rows: {},
    empty: {},
    locale: {},
    disabled: { type: Boolean },
    tableId: {}
  },
  emits: ["action"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r } = ht(() => n.locale), l = E(() => n.rows ?? []), c = E(() => l.value.some((k) => (k.actions ?? []).length > 0)), p = E(() => Fy(n.empty, n.locale, () => i("plugin.list.empty")));
    function m(k, _) {
      var w;
      return Zt((w = k.cells) == null ? void 0 : w[_], n.locale);
    }
    const v = E(
      () => (n.columns ?? []).map((k) => {
        const _ = typeof k.width == "number" && Number.isFinite(k.width) ? Math.round(k.width) : void 0;
        return {
          id: k.key,
          label: Zt(k.label, n.locale),
          width: _ === void 0 ? void 0 : Math.min(900, Math.max(60, _)),
          align: k.align,
          sortable: k.sortable !== !1,
          // A date column is printed the explorer's way, and sorted by the value.
          format: (w) => fI(m(w, k.key), k.format, n.locale, r),
          sortValue: (w) => {
            var C;
            const b = (C = w.sort) == null ? void 0 : C[k.key];
            return typeof b == "number" || typeof b == "string" ? b : m(w, k.key);
          }
        };
      })
    );
    function x(k) {
      return (k.actions ?? []).map((_) => ({
        key: _.id,
        label: Zt(_.label, n.locale),
        danger: _.danger,
        disabled: n.disabled,
        testid: `surface-list-action-${k.id}-${_.id}`
      }));
    }
    return (k, _) => (f(), h("div", pI, [
      Je(es, {
        "table-id": e.tableId,
        columns: v.value,
        rows: l.value,
        "row-key": "id",
        locale: e.locale,
        empty: p.value,
        "row-attrs": (w) => ({ "data-row": w.id }),
        "row-actions": c.value ? x : void 0,
        "row-actions-test-id": (w) => (w.actions ?? []).length ? `surface-list-actions-${w.id}` : void 0,
        onRowAction: _[0] || (_[0] = (w, b) => a("action", { action_id: w, row_id: b.id }))
      }, null, 8, ["table-id", "columns", "rows", "locale", "empty", "row-attrs", "row-actions", "row-actions-test-id"])
    ]));
  }
}), mI = {
  class: "fe-sprogress",
  "data-testid": "surface-progress"
}, vI = { class: "fe-sprogress__head" }, yI = { class: "fe-sprogress__label" }, gI = {
  key: 0,
  class: "fe-sprogress__pct"
}, bI = ["aria-label", "aria-valuenow"], kI = /* @__PURE__ */ rt({
  __name: "SurfaceProgress",
  props: {
    value: {},
    label: {},
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale), a = E(() => {
      const r = t.value;
      return r == null || !Number.isFinite(Number(r)) ? null : Math.min(100, Math.max(0, Math.round(Number(r))));
    }), i = E(() => Fy(t.label, t.locale, () => n("plugin.view.busy")));
    return (r, l) => (f(), h("div", mI, [
      d("div", vI, [
        d("span", yI, y(i.value), 1),
        a.value !== null ? (f(), h("span", gI, y(a.value) + "%", 1)) : D("", !0)
      ]),
      d("div", {
        class: Ne(["fe-sprogress__track", { "is-indeterminate": a.value === null }]),
        role: "progressbar",
        "aria-label": i.value,
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": a.value === null ? void 0 : a.value
      }, [
        d("div", {
          class: "fe-sprogress__bar",
          style: Xt(a.value === null ? void 0 : { width: `${a.value}%` })
        }, null, 4)
      ], 10, bI)
    ]));
  }
}), YS = ",،、，", wI = ";؛；", o1 = /* @__PURE__ */ new Map();
function _I(e) {
  const t = `${e.spaces ? 1 : 0}${e.semicolons ? 1 : 0}${e.newlines ? 1 : 0}`;
  let n = o1.get(t);
  if (!n) {
    const a = YS + (e.semicolons ? wI : "") + (e.newlines ? "\\n\\r" : "") + (e.spaces ? "\\s" : "");
    n = new RegExp(`[${a}]+`, "u"), o1.set(t, n);
  }
  return n;
}
function xI(e, t = {}) {
  return String(e ?? "").split(_I(t)).map((n) => n.trim()).filter((n) => n !== "");
}
function SI(e) {
  return e.length === 1 && YS.includes(e);
}
const $I = {
  key: 0,
  class: "fe-speople__chips",
  "data-testid": "surface-people-chips"
}, TI = ["title"], AI = {
  class: "fe-speople__av",
  "aria-hidden": "true"
}, EI = { class: "fe-speople__name" }, CI = ["disabled", "title", "aria-label", "data-testid", "onClick"], zI = {
  key: 1,
  class: "fe-speople__addwrap"
}, MI = ["placeholder", "disabled", "aria-invalid"], OI = ["disabled"], PI = {
  key: 1,
  class: "fe-share__suggest fe-speople__suggest",
  "data-testid": "surface-people-suggest"
}, DI = ["onMousedown"], LI = { class: "fe-share__av fe-share__av--sm" }, RI = { class: "fe-share__suggesttxt" }, NI = { class: "fe-share__suggestname" }, II = { class: "fe-share__suggestmeta" }, BI = {
  key: 2,
  class: "fe-surface__error",
  role: "alert"
}, FI = /* @__PURE__ */ rt({
  __name: "SurfacePeoplePicker",
  props: {
    id: {},
    modelValue: {},
    multi: { type: Boolean },
    allowExternal: { type: Boolean },
    api: {},
    plugin: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S([]), c = S(!1), p = S(!n.api || !n.plugin), m = S("");
    let v = null, x = 0;
    const k = E(() => n.modelValue ?? []), _ = E(() => n.allowExternal === !0 || p.value), w = E(() => n.multi !== !0 && k.value.length >= 1);
    function b(P) {
      return Rp({ name: P.name, email: P.email });
    }
    function C(P) {
      const H = String(P.email ?? "").trim().toLowerCase();
      if (!H) return;
      const $ = n.multi === !0 ? k.value.filter((F) => F.email.toLowerCase() !== H) : [];
      a("update:modelValue", [...$, { ...P, email: H }]), r.value = "", l.value = [], c.value = !1, m.value = "";
    }
    function A(P) {
      a("update:modelValue", k.value.filter((H) => H.email !== P));
    }
    function T() {
      m.value = "";
      const P = r.value.trim();
      if (v && clearTimeout(v), !P || p.value) {
        l.value = [], c.value = !1;
        return;
      }
      v = setTimeout(() => void R(P), 180);
    }
    async function R(P) {
      if (!n.api || !n.plugin || p.value) return;
      const H = ++x;
      try {
        const $ = await n.api.pluginUsers(n.plugin, P);
        if (H !== x) return;
        l.value = ($.users ?? []).filter((F) => F && typeof F.email == "string"), c.value = l.value.length > 0;
      } catch ($) {
        if (H !== x) return;
        const F = $ == null ? void 0 : $.status;
        (F === 403 || F === 404) && (p.value = !0), l.value = [], c.value = !1;
      }
    }
    function M() {
      const P = r.value.trim();
      if (P) {
        if (!_.value) {
          m.value = i("plugin.people.external_off");
          return;
        }
        if (!rR(P)) {
          m.value = i("plugin.people.invalid_email");
          return;
        }
        C({ email: P });
      }
    }
    function L(P) {
      P.key === "Enter" || SI(P.key) ? (P.preventDefault(), M()) : P.key === "Backspace" && r.value === "" && k.value.length ? A(k.value[k.value.length - 1].email) : P.key === "Escape" && (c.value = !1);
    }
    function U() {
      setTimeout(() => {
        c.value = !1;
      }, 120);
    }
    return Xe(
      () => [n.api, n.plugin],
      ([P, H]) => {
        P && H && (p.value = !1);
      }
    ), Ct(() => {
      v && clearTimeout(v);
    }), (P, H) => (f(), h("div", {
      class: Ne(["fe-speople", { "is-invalid": e.invalid }]),
      "data-testid": "surface-people"
    }, [
      k.value.length ? (f(), h("ul", $I, [
        (f(!0), h(Ce, null, nt(k.value, ($) => (f(), h("li", {
          key: $.email,
          class: "fe-speople__chip",
          title: $.email
        }, [
          d("span", AI, y(b($).charAt(0).toUpperCase()), 1),
          d("span", EI, y(b($)), 1),
          d("button", {
            type: "button",
            class: "fe-speople__remove",
            disabled: e.disabled,
            title: u(i)("plugin.people.remove", { name: b($) }),
            "aria-label": u(i)("plugin.people.remove", { name: b($) }),
            "data-testid": `surface-people-remove-${$.email}`,
            onClick: (F) => A($.email)
          }, [...H[1] || (H[1] = [
            d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, CI)
        ], 8, TI))), 128))
      ])) : D("", !0),
      w.value ? D("", !0) : (f(), h("div", zI, [
        cn(d("input", {
          "onUpdate:modelValue": H[0] || (H[0] = ($) => r.value = $),
          class: "fe-cfield__input fe-speople__input",
          type: "email",
          autocomplete: "off",
          spellcheck: "false",
          placeholder: p.value ? u(i)("plugin.people.placeholder_email") : u(i)("plugin.people.placeholder"),
          disabled: e.disabled,
          "aria-invalid": e.invalid ? "true" : void 0,
          "data-testid": "surface-people-input",
          onInput: T,
          onKeydown: L,
          onFocus: T,
          onBlur: U
        }, null, 40, MI), [
          [xn, r.value]
        ]),
        _.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !r.value.trim(),
          "data-testid": "surface-people-add",
          onClick: M
        }, y(u(i)("plugin.people.add")), 9, OI)) : D("", !0),
        c.value ? (f(), h("ul", PI, [
          (f(!0), h(Ce, null, nt(l.value, ($) => (f(), h("li", {
            key: $.user_id ?? $.email,
            onMousedown: vt((F) => C($), ["prevent"])
          }, [
            d("span", LI, y(b($).charAt(0).toUpperCase()), 1),
            d("span", RI, [
              d("span", NI, y(b($)), 1),
              d("span", II, y($.email), 1)
            ])
          ], 40, DI))), 128))
        ])) : D("", !0)
      ])),
      m.value ? (f(), h("p", BI, y(m.value), 1)) : D("", !0)
    ], 2));
  }
}), UI = {
  class: "fe-spin",
  "data-testid": "surface-pin"
}, HI = ["for"], KI = ["id", "maxlength", "size", "value", "disabled", "aria-invalid"], VI = /* @__PURE__ */ rt({
  __name: "SurfacePinInput",
  props: {
    id: {},
    length: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = E(() => {
      const c = Number(n.length);
      return Number.isInteger(c) && c > 0 ? c : void 0;
    });
    function l(c) {
      const p = c.target.value.replace(/\s+/g, "").slice(0, r.value);
      c.target.value = p, a("update:modelValue", p);
    }
    return (c, p) => (f(), h("div", UI, [
      d("label", {
        class: "fe-cfield__label",
        for: `fe-spin-${e.id}`
      }, y(u(i)("plugin.pin.label")), 9, HI),
      d("input", {
        id: `fe-spin-${e.id}`,
        class: Ne(["fe-cfield__input fe-cfield__input--mono fe-spin__input", { "is-invalid": e.invalid }]),
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        spellcheck: "false",
        maxlength: r.value,
        size: r.value,
        value: e.modelValue,
        disabled: e.disabled,
        "aria-invalid": e.invalid ? "true" : void 0,
        style: Xt({ "--spin-len": r.value }),
        onInput: l
      }, null, 46, KI)
    ]));
  }
}), Jn = "@@drives";
function xl(e) {
  const t = e.indexOf("://");
  return t < 0 ? ["", ey(e)] : [e.slice(0, t), ey(e.slice(t + 3))];
}
function Sl(e, t) {
  const n = ey(t);
  return n ? `${e}://${n}` : `${e}://`;
}
function ey(e) {
  return e.replace(/^\/+|\/+$/g, "");
}
function vg(e, t) {
  if (e === Jn) return null;
  const [n, a] = xl(e);
  if (!n) return null;
  if (!a) return t ? Jn : null;
  const i = a.split("/");
  return i.pop(), Sl(n, i.join("/"));
}
function cl(e, t) {
  if (e === Jn) return t;
  const [n, a] = xl(e);
  if (!a) return n || t;
  const i = a.split("/");
  return i[i.length - 1] || n;
}
function jI(e) {
  if (e === Jn || !e) return [];
  const [t, n] = xl(e);
  if (!t) return [];
  const a = [{ label: t, path: Sl(t, "") }];
  if (!n) return a;
  let i = "";
  for (const r of n.split("/"))
    i = i ? `${i}/${r}` : r, a.push({ label: r, path: Sl(t, i) });
  return a;
}
function GS(e) {
  return e == null || e === "" || e === "editor" || e === "owner";
}
function yg(e, t) {
  if (e === Jn || t === Jn) return !1;
  const [n, a] = xl(e), [i, r] = xl(t);
  return n !== i ? !1 : r === "" ? !0 : a === r || a.startsWith(r + "/");
}
function gg(e, t) {
  if (!t || t.length === 0 || e === Jn) return null;
  const n = (i) => {
    const [r, l] = xl(i);
    return Sl(r, l);
  }, a = n(e);
  for (const i of t)
    if (i) {
      if (a === n(i)) return "self";
      if (yg(e, i)) return "descendant";
    }
  return null;
}
function qI(e, t) {
  if (!e || e === Jn) return null;
  for (const n of t) if (n && yg(e, n)) return n;
  return null;
}
function XS(e, t, n) {
  if (!e || e === Jn) return null;
  const a = n(e);
  return t ? a === t ? null : "out" : a ? "into" : null;
}
function WI(e, t, n) {
  return XS(e, t, n) ? !(t && yg(t, e)) : !1;
}
function YI(e, t, n = {}) {
  const a = [];
  for (const i of e ?? []) {
    if (i.type !== "dir") {
      n.files && i.type === "file" && a.push({ path: i.path, label: i.basename, writable: !0, blocked: null, kind: "file" });
      continue;
    }
    a.push({
      path: i.path,
      label: i.basename,
      writable: GS(i.perm),
      blocked: gg(i.path, t),
      kind: "dir"
    });
  }
  return a;
}
function GI(e, t) {
  return (e ?? []).map((n) => {
    const a = Sl(n, "");
    return {
      path: a,
      label: n,
      // A storage root's own writability is not knowable from the drive list;
      // it is answered by the listing when the user opens it. Offering it as
      // writable here and letting the listing correct that is the honest
      // order — the alternative greys out every drive until each is opened.
      writable: !0,
      blocked: gg(a, t),
      kind: "dir"
    };
  });
}
function XI(e, t) {
  const n = ((t == null ? void 0 : t.length) ?? 0) > 1;
  if (e && e.includes("://")) return e;
  if (n) return Jn;
  const a = t == null ? void 0 : t[0];
  return a ? Sl(a, "") : Jn;
}
const pc = [];
function JI(e) {
  pc.push(e);
}
function ZI(e) {
  const t = pc.lastIndexOf(e);
  t >= 0 && pc.splice(t, 1);
}
function r1(e) {
  return pc[pc.length - 1] === e;
}
const QI = ["aria-labelledby", "aria-label", "aria-busy"], e8 = {
  key: 0,
  class: "fe-modal__head"
}, t8 = ["aria-label", "disabled"], n8 = { class: "fe-modal__body" }, a8 = {
  key: 1,
  class: "fe-modal__ask",
  role: "alert",
  "data-testid": "modal-busy-close"
}, i8 = { class: "fe-modal__ask-text" }, o8 = { class: "fe-modal__ask-actions" }, r8 = {
  key: 2,
  class: "fe-modal__actions"
}, Bm = 'input:not([disabled]),select:not([disabled]),textarea:not([disabled]),button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])', na = /* @__PURE__ */ rt({
  __name: "Modal",
  props: {
    locale: {},
    open: { type: Boolean },
    title: {},
    size: {},
    closeOnBackdrop: { type: Boolean, default: !0 },
    chromeless: { type: Boolean },
    fullbleed: { type: Boolean },
    theme: {},
    busy: { type: Boolean },
    busyClose: { default: null },
    bare: { type: Boolean },
    labelledby: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, a = Go() ? bi(O2, void 0) : void 0, { t: i } = ht(() => n.locale ?? (a == null ? void 0 : a()) ?? "en"), r = t, l = S(null);
    let c = 0;
    const p = `fe-modal-title-${++c}-${Math.random().toString(36).slice(2, 7)}`;
    let m = null, v = null;
    const x = Symbol("fe-modal");
    let k = !1, _;
    function w() {
      const $ = l.value;
      if (!$) return;
      const F = $.querySelector("[data-fe-autofocus]");
      if (F) {
        F.focus();
        return;
      }
      const I = (J) => {
        var re;
        return ((re = $.querySelector(J)) == null ? void 0 : re.querySelector(Bm)) ?? null;
      }, Z = I(".fe-modal__body") ?? I(".fe-modal__actions") ?? $.querySelector(Bm);
      Z == null || Z.focus();
    }
    function b() {
      k || (k = !0, m = document.activeElement ?? null, v = null, JI(x), document.addEventListener("keydown", L), _ = setTimeout(() => {
        var $;
        if (_ = void 0, !(typeof document > "u") && k && r1(x) && !(($ = l.value) != null && $.contains(document.activeElement))) {
          const F = document.activeElement;
          v = F && F !== document.body && F !== m ? F : null, w();
        }
      }, 30));
    }
    function C() {
      var F;
      if (!k) return;
      k = !1, _ !== void 0 && (clearTimeout(_), _ = void 0), document.removeEventListener("keydown", L), ZI(x);
      const $ = m != null && m.isConnected ? m : v != null && v.isConnected ? v : m;
      (F = $ == null ? void 0 : $.focus) == null || F.call($), m = null, v = null;
    }
    Xe(
      () => n.open,
      ($) => $ ? b() : C(),
      { immediate: !0 }
    ), Ct(C);
    const A = S(!1), T = S(null);
    Xe(
      () => [n.busy, n.open],
      ([$, F]) => {
        (!$ || !F) && (A.value = !1);
      }
    );
    function R() {
      if (!n.busy) {
        r("close");
        return;
      }
      n.busyClose && (A.value = !0, Jt(() => {
        var $;
        return ($ = T.value) == null ? void 0 : $.focus();
      }));
    }
    function M() {
      A.value = !1, r("close");
    }
    function L($) {
      if (r1(x)) {
        if ($.key === "Escape") {
          if (n.chromeless) return;
          if (A.value) {
            A.value = !1;
            return;
          }
          if (n.busy) return;
          r("close");
          return;
        }
        if ($.key === "Tab" && l.value) {
          const F = Array.from(l.value.querySelectorAll(Bm)).filter(
            (re) => re.offsetParent !== null || re === document.activeElement
          );
          if (F.length === 0) return;
          const I = F[0], Z = F[F.length - 1], J = document.activeElement;
          $.shiftKey && (J === I || !l.value.contains(J)) ? ($.preventDefault(), Z.focus()) : !$.shiftKey && (J === Z || !l.value.contains(J)) && ($.preventDefault(), I.focus());
        }
      }
    }
    let U = !1;
    function P($) {
      U = $.target === $.currentTarget;
    }
    function H($) {
      const F = U;
      U = !1, !(!n.closeOnBackdrop || n.chromeless || n.busy) && ($.target !== $.currentTarget || !F || r("close"));
    }
    return ($, F) => (f(), We(zr, { name: "fe-modal" }, {
      default: mt(() => [
        e.open ? (f(), h("div", {
          key: 0,
          class: Ne(["fe fe-modal__backdrop", [
            { "fe-modal__backdrop--chromeless": e.chromeless },
            { "fe-modal__backdrop--fullbleed": e.fullbleed && !e.chromeless },
            e.theme === "light" ? "fe--theme-light" : "",
            e.theme === "dark" ? "fe--theme-dark" : ""
          ]]),
          role: "presentation",
          onPointerdown: P,
          onClick: H
        }, [
          d("div", {
            ref_key: "cardEl",
            ref: l,
            class: Ne(["fe-modal__card", [
              e.bare ? "fe-modal__card--bare" : `fe-modal__card--${e.size || "md"}`,
              e.chromeless && "fe-modal__card--chromeless",
              e.fullbleed && !e.chromeless && "fe-modal__card--fullbleed"
            ]]),
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": e.labelledby || (e.title && !e.chromeless && !e.fullbleed && !e.bare ? p : void 0),
            "aria-label": e.labelledby ? void 0 : (!e.title || e.chromeless || e.fullbleed || e.bare) && e.title || void 0,
            "aria-busy": e.busy ? "true" : void 0,
            onClick: F[1] || (F[1] = vt(() => {
            }, ["stop"]))
          }, [
            e.title && !e.chromeless && !e.fullbleed && !e.bare ? (f(), h("header", e8, [
              d("h2", {
                id: p,
                class: "fe-modal__title"
              }, y(e.title), 1),
              d("button", {
                type: "button",
                class: "fe-modal__close",
                "aria-label": u(i)("modal.close"),
                disabled: e.busy && !e.busyClose,
                onClick: R
              }, "×", 8, t8)
            ])) : D("", !0),
            d("div", n8, [
              Ln($.$slots, "default")
            ]),
            A.value && e.busyClose ? (f(), h("div", a8, [
              d("p", i8, y(e.busyClose.question), 1),
              d("div", o8, [
                d("button", {
                  ref_key: "keepEl",
                  ref: T,
                  type: "button",
                  class: "fe-btn",
                  "data-testid": "modal-busy-close-keep",
                  onClick: F[0] || (F[0] = (I) => A.value = !1)
                }, y(u(i)("modal.busy_close.keep")), 513),
                d("button", {
                  type: "button",
                  class: "fe-btn fe-btn--danger",
                  "data-testid": "modal-busy-close-confirm",
                  onClick: M
                }, y(e.busyClose.confirm || u(i)("modal.busy_close.confirm")), 1)
              ])
            ])) : D("", !0),
            $.$slots.actions && !e.chromeless && !e.fullbleed && !e.bare ? (f(), h("footer", r8, [
              Ln($.$slots, "actions")
            ])) : D("", !0)
          ], 10, QI)
        ], 34)) : D("", !0)
      ]),
      _: 3
    }));
  }
}), s8 = {
  class: "fe-destpick",
  "data-testid": "destpicker"
}, l8 = { class: "fe-destpick__bar" }, u8 = ["disabled", "title", "aria-label"], c8 = ["aria-label"], d8 = ["onClick"], f8 = {
  key: 1,
  class: "fe-destpick__crumb is-current"
}, p8 = {
  class: "fe-destpick__rows",
  "data-testid": "destpicker-rows"
}, h8 = {
  key: 0,
  class: "fe-destpick__note"
}, m8 = {
  key: 1,
  class: "fe-destpick__note"
}, v8 = {
  key: 2,
  class: "fe-destpick__note"
}, y8 = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], g8 = ["innerHTML"], b8 = { class: "fe-destpick__rowname" }, k8 = {
  key: 0,
  class: "fe-destpick__rowtag",
  "data-testid": "destpicker-vault-tag"
}, w8 = {
  key: 1,
  class: "fe-destpick__rowtag"
}, _8 = {
  key: 2,
  class: "fe-destpick__rowtag"
}, x8 = {
  key: 3,
  class: "fe-destpick__rowinto",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, S8 = {
  key: 1,
  class: "fe-destpick__target",
  "data-testid": "destpicker-target"
}, $8 = ["disabled"], bg = /* @__PURE__ */ rt({
  __name: "DestinationPickerModal",
  props: {
    open: { type: Boolean },
    api: {},
    locale: {},
    storages: {},
    startAt: {},
    moving: {},
    mode: {},
    title: {},
    theme: {},
    pick: {},
    busy: { type: Boolean },
    vaultRoots: {},
    vaultFrom: {}
  },
  emits: ["close", "pick"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(Jn), l = S([]), c = S(!1), p = S(void 0), m = S(!1), v = E(() => {
      var j;
      return (((j = n.storages) == null ? void 0 : j.length) ?? 0) > 1;
    }), x = E(() => i("destpicker.drives")), k = E(() => n.pick === "file"), _ = S(null);
    let w = /* @__PURE__ */ new Map();
    const b = S([]);
    function C(j) {
      const X = String(j ?? "").replace(/\/+$/, "");
      X && !b.value.includes(X) && (b.value = [...b.value, X]);
    }
    function A(j) {
      return qI(j, [...n.vaultRoots ?? [], ...b.value]);
    }
    Xe(
      () => n.open,
      (j) => {
        j && (w = /* @__PURE__ */ new Map(), b.value = [], M(XI(n.startAt, n.storages)));
      },
      { immediate: !0 }
    );
    const T = bi(Nc, null);
    async function R(j) {
      const X = w.get(j);
      if (X) return X;
      try {
        let te = await n.api.index(j);
        typeof te.e2e_vault_root == "string" && te.e2e_vault_root && C(te.e2e_vault_root);
        for (const V of te.files ?? []) V.type === "dir" && V.e2e_vault && C(V.path);
        if (T) {
          const V = typeof te.e2e_root == "string" && te.e2e_root ? te.e2e_root : null;
          te = { ...te, files: await T.decorate(te.files ?? [], { root: V }) };
        }
        return w.set(j, te), te;
      } catch {
        return;
      }
    }
    async function M(j) {
      if (r.value = j, m.value = !1, _.value = null, j === Jn) {
        p.value = void 0, l.value = GI(n.storages, n.moving);
        return;
      }
      c.value = !0;
      const X = await R(j);
      if (r.value !== j) return;
      c.value = !1, p.value = X, m.value = !X;
      const te = A(j), V = te && te !== (n.vaultFrom ?? null) ? [] : X == null ? void 0 : X.files;
      l.value = YI(V, n.moving, { files: k.value }).map((G) => {
        if (G.kind !== "dir") return G;
        const q = A(G.path) === G.path.replace(/\/+$/, ""), B = !G.blocked && WI(G.path, n.vaultFrom ?? null, A);
        return { ...G, vault: q, blocked: B ? "vault" : G.blocked };
      });
    }
    const L = E(() => vg(r.value, v.value)), U = E(
      () => jI(r.value).map((j) => ({ ...j, label: (T == null ? void 0 : T.segmentLabel(j.path)) ?? j.label }))
    ), P = E(() => gg(r.value, n.moving)), H = E(() => (b.value, XS(r.value, n.vaultFrom ?? null, A))), $ = E(() => r.value === Jn || !p.value || p.value.read_only ? !1 : GS(p.value.perm)), F = E(() => n.busy || r.value === Jn || H.value ? !1 : k.value ? _.value !== null : $.value && P.value === null), I = E(() => r.value !== Jn && !(k.value && !m.value)), Z = E(() => r.value === Jn ? i("destpicker.pick_a_drive") : k.value ? m.value ? i("destpicker.unreadable") : H.value ? i("destpicker.blocked.vault_in") : _.value === null ? i("destpicker.pick_a_file") : "" : P.value === "self" ? i("destpicker.blocked.self") : P.value === "descendant" ? i("destpicker.blocked.descendant") : H.value === "into" ? i("destpicker.blocked.vault_in") : H.value === "out" ? i("destpicker.blocked.vault_out") : m.value ? i("destpicker.unreadable") : p.value && !$.value ? i("destpicker.readonly_here") : ""), J = E(() => n.title ? n.title : n.mode === "move" ? i("destpicker.title.move") : n.mode === "copy" ? i("destpicker.title.copy") : n.mode === "save" ? i("destpicker.title.save") : k.value ? i("destpicker.title.choose_file") : i("destpicker.title.choose")), re = E(() => n.mode === "move" ? i("destpicker.confirm.move") : n.mode === "copy" ? i("destpicker.confirm.copy") : n.mode === "save" ? i("destpicker.confirm.save") : k.value ? i("destpicker.confirm.choose_file") : i("destpicker.confirm.choose")), ve = E(
      () => k.value && _.value !== null ? cl(_.value, x.value) : cl(r.value, x.value)
    );
    function W(j) {
      return j.kind === "file" ? xa({ type: "file", basename: j.label }) : G2("folder");
    }
    function z(j) {
      return j.kind === "file" ? j.label : j.blocked === "self" ? i("destpicker.blocked.self") : j.blocked === "descendant" ? i("destpicker.blocked.descendant") : j.blocked === "vault" ? i(n.vaultFrom ? "destpicker.blocked.vault_out" : "destpicker.blocked.vault_in") : j.writable ? j.label : i("destpicker.readonly");
    }
    function le(j) {
      if (j.kind === "file") {
        _.value = j.path;
        return;
      }
      j.blocked || M(j.path);
    }
    function fe() {
      F.value && a("pick", k.value && _.value !== null ? _.value : r.value);
    }
    return (j, X) => (f(), We(na, {
      open: e.open,
      title: J.value,
      size: "md",
      locale: e.locale,
      theme: e.theme,
      busy: e.busy,
      onClose: X[3] || (X[3] = (te) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          onClick: X[2] || (X[2] = (te) => a("close"))
        }, y(u(i)("destpicker.cancel")), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !F.value,
          "data-testid": "destpicker-confirm",
          onClick: fe
        }, y(re.value), 9, $8)
      ]),
      default: mt(() => [
        d("div", s8, [
          d("div", l8, [
            d("button", {
              type: "button",
              class: "fe-destpick__up",
              disabled: !L.value,
              title: u(i)("destpicker.up"),
              "aria-label": u(i)("destpicker.up"),
              "data-testid": "destpicker-up",
              onClick: X[0] || (X[0] = (te) => M(L.value))
            }, [...X[4] || (X[4] = [
              d("svg", {
                class: "fe-ficon",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true",
                focusable: "false"
              }, [
                d("path", { d: "M12 19V5M5 12l7-7 7 7" })
              ], -1)
            ])], 8, u8),
            d("nav", {
              class: "fe-destpick__crumbs",
              "aria-label": u(i)("destpicker.crumbs")
            }, [
              v.value ? (f(), h("button", {
                key: 0,
                type: "button",
                class: Ne(["fe-destpick__crumb", { "is-current": r.value === u(Jn) }]),
                onClick: X[1] || (X[1] = (te) => M(u(Jn)))
              }, y(x.value), 3)) : D("", !0),
              (f(!0), h(Ce, null, nt(U.value, (te) => (f(), h(Ce, {
                key: te.path
              }, [
                X[5] || (X[5] = d("span", {
                  class: "fe-destpick__sep",
                  "aria-hidden": "true"
                }, "/", -1)),
                d("button", {
                  type: "button",
                  class: Ne(["fe-destpick__crumb", { "is-current": te.path === r.value }]),
                  onClick: (V) => M(te.path)
                }, y(te.label), 11, d8)
              ], 64))), 128)),
              !v.value && !U.value.length ? (f(), h("span", f8, y(u(cl)(r.value, x.value)), 1)) : D("", !0)
            ], 8, c8)
          ]),
          d("ul", p8, [
            c.value ? (f(), h("li", h8, y(u(i)("destpicker.loading")), 1)) : m.value ? (f(), h("li", m8, y(u(i)("destpicker.unreadable")), 1)) : l.value.length ? D("", !0) : (f(), h("li", v8, y(k.value ? u(i)("destpicker.empty_files") : u(i)("destpicker.empty")), 1)),
            (f(!0), h(Ce, null, nt(l.value, (te) => (f(), h("li", {
              key: te.path
            }, [
              d("button", {
                type: "button",
                class: Ne(["fe-destpick__row", {
                  "is-locked": !te.writable,
                  "is-blocked": !!te.blocked,
                  "is-file": te.kind === "file",
                  "is-picked": te.kind === "file" && _.value === te.path
                }]),
                disabled: !!te.blocked,
                title: z(te),
                "aria-pressed": te.kind === "file" ? _.value === te.path : void 0,
                "data-testid": "destpicker-row-" + te.label,
                onClick: (V) => le(te)
              }, [
                d("span", {
                  class: "fe-destpick__rowicon",
                  "aria-hidden": "true",
                  innerHTML: W(te)
                }, null, 8, g8),
                d("span", b8, [
                  d("bdi", null, y(te.label), 1)
                ]),
                te.vault ? (f(), h("span", k8, y(u(i)("destpicker.tag.vault")), 1)) : D("", !0),
                te.blocked ? (f(), h("span", w8, y(u(i)("destpicker.tag.blocked")), 1)) : te.writable ? D("", !0) : (f(), h("span", _8, y(u(i)("destpicker.readonly")), 1)),
                te.kind === "dir" ? (f(), h("svg", x8, [...X[6] || (X[6] = [
                  d("path", { d: "M9 5l7 7-7 7" }, null, -1)
                ])])) : D("", !0)
              ], 10, y8)
            ]))), 128))
          ]),
          Z.value ? (f(), h("p", {
            key: 0,
            class: Ne(["fe-destpick__reason", { "is-hint": !I.value }]),
            "data-testid": "destpicker-reason"
          }, y(Z.value), 3)) : (f(), h("p", S8, y(u(i)("destpicker.target", { name: ve.value })), 1))
        ])
      ]),
      _: 1
    }, 8, ["open", "title", "locale", "theme", "busy"]));
  }
}), T8 = ["title"], A8 = ["disabled"], E8 = ["disabled"], C8 = /* @__PURE__ */ rt({
  __name: "SurfaceFileChooser",
  props: {
    id: {},
    kind: {},
    modelValue: {},
    locale: {},
    theme: {},
    api: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(!1), l = E(() => n.kind === "dir" ? "dir" : "file"), c = E(() => n.modelValue ? cl(n.modelValue, "") || n.modelValue : ""), p = E(() => n.modelValue ? l.value === "dir" ? n.modelValue : vg(n.modelValue, !1) ?? n.modelValue : n.startAt);
    function m(v) {
      r.value = !1, a("update:modelValue", v);
    }
    return (v, x) => (f(), h("div", {
      class: Ne(["fe-sfile", { "is-invalid": e.invalid }]),
      "data-testid": "surface-file-chooser"
    }, [
      d("span", {
        class: Ne(["fe-sfile__value", { "fe-sfile__value--empty": !e.modelValue }]),
        title: e.modelValue || void 0,
        "data-testid": "surface-file-chooser-value"
      }, y(c.value || u(i)("plugin.file.none")), 11, T8),
      d("button", {
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled || !e.api,
        "data-testid": "surface-file-chooser-open",
        onClick: x[0] || (x[0] = (k) => r.value = !0)
      }, y(u(i)("plugin.file.choose")), 9, A8),
      e.modelValue ? (f(), h("button", {
        key: 0,
        type: "button",
        class: "fe-btn fe-btn--sm",
        disabled: e.disabled,
        "data-testid": "surface-file-chooser-clear",
        onClick: x[1] || (x[1] = (k) => a("update:modelValue", ""))
      }, y(u(i)("plugin.file.clear")), 9, E8)) : D("", !0),
      e.api ? (f(), We(bg, {
        key: 1,
        open: r.value,
        api: e.api,
        locale: e.locale,
        mode: "choose",
        pick: l.value,
        storages: e.storages,
        "start-at": p.value,
        onClose: x[2] || (x[2] = (k) => r.value = !1),
        onPick: m
      }, null, 8, ["open", "api", "locale", "pick", "storages", "start-at"])) : D("", !0)
    ], 2));
  }
}), z8 = ["data-state"], M8 = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, O8 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted"
}, P8 = ["src", "alt"], D8 = ["src"], L8 = ["src"], R8 = ["src", "type"], N8 = ["innerHTML"], I8 = ["title"], B8 = /* @__PURE__ */ rt({
  __name: "SurfacePreview",
  props: {
    path: {},
    fileRef: {},
    fileUrl: { type: Function },
    locale: {},
    api: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale), a = S(null), i = S(""), r = S("loading");
    let l = 0;
    const c = E(() => t.fileRef && t.fileUrl ? t.fileUrl(t.fileRef) : null), p = E(() => {
      var _;
      return ((_ = c.value) == null ? void 0 : _.name) || cl(t.path, "") || t.path || t.fileRef || "";
    }), m = E(() => {
      const _ = i.value;
      return _.startsWith("image/") ? "image" : _.startsWith("video/") ? "video" : _.startsWith("audio/") ? "audio" : "other";
    }), v = E(() => xa({ type: "file", basename: p.value }));
    function x() {
      a.value && a.value.startsWith("blob:") && URL.revokeObjectURL(a.value), a.value = null;
    }
    async function k() {
      const _ = ++l;
      if (x(), i.value = "", t.fileRef) {
        if (!c.value) {
          r.value = "error";
          return;
        }
        a.value = c.value.url, i.value = c.value.mime || "", r.value = "ok";
        return;
      }
      if (!t.api || !t.path) {
        r.value = "error";
        return;
      }
      r.value = "loading";
      try {
        const w = await t.api.fetchBlob(t.path);
        if (_ !== l) {
          URL.revokeObjectURL(w.url);
          return;
        }
        a.value = w.url, i.value = w.mime || "", r.value = "ok";
      } catch {
        if (_ !== l) return;
        r.value = "error";
      }
    }
    return Xe([() => t.path, () => t.fileRef], () => void k(), { immediate: !0 }), Ct(() => {
      l++, x();
    }), (_, w) => (f(), h("figure", {
      class: "fe-spreview",
      "data-testid": "surface-preview",
      "data-state": r.value
    }, [
      r.value === "loading" ? (f(), h("p", M8, y(u(n)("plugin.view.loading")), 1)) : r.value === "error" ? (f(), h("p", O8, y(u(n)("plugin.view.preview_failed")), 1)) : (f(), h(Ce, { key: 2 }, [
        m.value === "image" && a.value ? (f(), h("img", {
          key: 0,
          class: "fe-spreview__media",
          src: a.value,
          alt: p.value
        }, null, 8, P8)) : m.value === "video" && a.value ? (f(), h("video", {
          key: 1,
          class: "fe-spreview__media",
          src: a.value,
          controls: "",
          preload: "metadata"
        }, null, 8, D8)) : m.value === "audio" && a.value ? (f(), h("audio", {
          key: 2,
          class: "fe-spreview__audio",
          src: a.value,
          controls: "",
          preload: "metadata"
        }, null, 8, L8)) : e.fileRef && a.value ? (f(), h("embed", {
          key: 3,
          class: "fe-spreview__media fe-spreview__embed",
          src: a.value,
          type: i.value || void 0
        }, null, 8, R8)) : (f(), h("span", {
          key: 4,
          class: "fe-spreview__tile",
          "aria-hidden": "true",
          innerHTML: v.value
        }, null, 8, N8))
      ], 64)),
      d("figcaption", {
        class: "fe-spreview__name",
        title: e.path
      }, y(p.value), 9, I8)
    ], 8, z8));
  }
}), F8 = ["data-mode", "role", "aria-labelledby"], U8 = ["id"], H8 = {
  key: 0,
  class: "fe-cfield__req",
  "aria-hidden": "true"
}, K8 = {
  key: 1,
  class: "fe-ssig__modes",
  role: "tablist"
}, V8 = ["aria-selected", "disabled", "data-testid", "onClick"], j8 = ["aria-label"], q8 = {
  key: 0,
  class: "fe-ssig__hint"
}, W8 = {
  key: 3,
  class: "fe-ssig__typewrap"
}, Y8 = ["id", "placeholder", "disabled", "value"], G8 = ["aria-label"], X8 = ["disabled", "title", "aria-pressed", "data-testid", "onClick"], J8 = ["src"], Z8 = {
  key: 4,
  class: "fe-ssig__uploadwrap"
}, Q8 = { class: "fe-btn fe-btn--sm fe-ssig__pick" }, eB = ["disabled"], tB = { class: "fe-ssig__hint" }, nB = {
  key: 0,
  class: "fe-surface__error",
  role: "alert"
}, aB = ["src"], iB = { class: "fe-ssig__foot" }, oB = ["disabled"], rB = {
  key: 0,
  class: "fe-ssig__signed"
}, JS = /* @__PURE__ */ rt({
  __name: "SurfaceSignaturePad",
  props: {
    id: {},
    modes: {},
    width: {},
    height: {},
    modelValue: {},
    locale: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    font: {},
    fonts: {},
    label: {},
    required: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = E(() => hR(n.modes)), l = E(() => vR(n.width, n.height)), c = S(Nu(n.modelValue) && r.value.includes(n.modelValue.mode) ? n.modelValue.mode : r.value[0]), p = E(() => {
      const fe = Array.isArray(n.fonts) ? n.fonts.filter(dc) : [];
      return fe.length ? _l.filter((j) => fe.includes(j.key)) : _l;
    });
    function m() {
      const fe = p.value.map((X) => X.key), j = Nu(n.modelValue) ? mR(n.modelValue) : void 0;
      return j && fe.includes(j) ? j : dc(n.font) && fe.includes(n.font) ? n.font : fe.includes(Qv) ? Qv : fe[0];
    }
    const v = S(null), x = S(""), k = S(m()), _ = S(""), w = S(""), b = E(() => Nu(n.modelValue)), C = E(() => Nu(n.modelValue) ? `data:image/png;base64,${n.modelValue.png_b64}` : "");
    function A(fe) {
      if (!fe) return null;
      try {
        return fe.getContext("2d");
      } catch {
        return null;
      }
    }
    function T() {
      return typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1;
    }
    function R() {
      const fe = v.value;
      if (!fe) return;
      const j = T();
      fe.width = Math.round(l.value.width * j), fe.height = Math.round(l.value.height * j);
      const X = A(fe);
      X && (X.setTransform(1, 0, 0, 1, 0, 0), X.clearRect(0, 0, fe.width, fe.height), X.scale(j, j), X.lineWidth = 2.2, X.lineCap = "round", X.lineJoin = "round", X.strokeStyle = n1);
    }
    let M = !1, L = null;
    function U(fe) {
      const j = v.value, X = j == null ? void 0 : j.getBoundingClientRect();
      if (!j || !X || !X.width) return { x: fe.clientX, y: fe.clientY };
      const te = l.value.width / X.width, V = l.value.height / X.height;
      return { x: (fe.clientX - X.left) * te, y: (fe.clientY - X.top) * V };
    }
    function P(fe) {
      var X, te, V;
      if (n.disabled) return;
      const j = A(v.value);
      if (j) {
        M = !0, L = U(fe);
        try {
          (te = (X = fe.target).setPointerCapture) == null || te.call(X, fe.pointerId);
        } catch {
        }
        j.beginPath(), j.moveTo(L.x, L.y), j.lineTo(L.x + 0.1, L.y + 0.1), j.stroke(), (V = fe.preventDefault) == null || V.call(fe);
      }
    }
    function H(fe) {
      var te;
      if (!M || !L) return;
      const j = A(v.value);
      if (!j) return;
      const X = U(fe);
      j.beginPath(), j.moveTo(L.x, L.y), j.lineTo(X.x, X.y), j.stroke(), L = X, (te = fe.preventDefault) == null || te.call(fe);
    }
    function $() {
      M && (M = !1, L = null, F(v.value, "draw"));
    }
    function F(fe, j) {
      if (!fe) return;
      let X = "";
      try {
        X = fe.toDataURL("image/png");
      } catch {
        X = "";
      }
      const te = gR(X);
      te && (j !== "draw" && (w.value = X), a("update:modelValue", j === "type" ? { png_b64: te, mode: j, font: k.value } : { png_b64: te, mode: j }));
    }
    async function I(fe, j) {
      const X = document.fonts;
      if (!(!X || typeof X.load != "function"))
        try {
          await X.load(`${fe}px ${j}`, "Aa");
        } catch {
        }
    }
    async function Z() {
      const fe = x.value.trim();
      if (!fe) {
        w.value = "", a("update:modelValue", null);
        return;
      }
      const j = OS(k.value).stack;
      if (await I(Math.round(l.value.height * 0.6), j), x.value.trim() !== fe) return;
      const X = document.createElement("canvas"), te = 2, { width: V, height: G } = l.value;
      X.width = V * te, X.height = G * te;
      const q = A(X);
      if (!q) return;
      q.scale(te, te), q.fillStyle = n1, q.textBaseline = "middle";
      const B = kR(
        (K) => (q.font = `${K}px ${j}`, q.measureText(fe).width),
        V - 24,
        G
      );
      q.font = `${B}px ${j}`, q.fillText(fe, 12, G / 2), F(X, "type");
    }
    function J(fe) {
      n.disabled || fe === k.value || (k.value = fe, x.value.trim() && Z());
    }
    const re = S(null);
    function ve(fe) {
      var q;
      const j = fe.target, X = (q = j.files) == null ? void 0 : q[0];
      if (j.value = "", !X) return;
      const te = bR(X);
      if (te !== "ok") {
        _.value = te;
        return;
      }
      _.value = "";
      const V = URL.createObjectURL(X), G = new Image();
      G.onload = () => {
        URL.revokeObjectURL(V);
        const B = yR(G.naturalWidth, G.naturalHeight, KS, VS), K = document.createElement("canvas");
        K.width = B.width, K.height = B.height;
        const ke = A(K);
        ke && (ke.drawImage(G, 0, 0, B.width, B.height), F(K, "upload"));
      }, G.onerror = () => {
        URL.revokeObjectURL(V), _.value = "unreadable";
      }, G.src = V;
    }
    function W() {
      x.value = "", w.value = "", _.value = "", R(), a("update:modelValue", null);
    }
    function z(fe) {
      fe !== c.value && (c.value = fe);
    }
    Xe(c, async (fe) => {
      fe === "draw" && (await Jt(), R());
    }), Xe(l, () => {
      c.value === "draw" && R();
    }), qt(() => {
      c.value === "draw" && R();
    }), Ct(() => {
      M = !1;
    });
    const le = E(() => {
      switch (_.value) {
        case "too_big":
          return i("plugin.sig.upload_too_big", { kb: 200 });
        case "bad_type":
          return i("plugin.sig.upload_bad_type");
        case "unreadable":
          return i("plugin.sig.upload_unreadable");
        default:
          return "";
      }
    });
    return (fe, j) => (f(), h("div", {
      class: Ne(["fe-ssig", { "is-invalid": e.invalid, "is-disabled": e.disabled }]),
      "data-testid": "surface-signature",
      "data-mode": c.value,
      role: e.label ? "group" : void 0,
      "aria-labelledby": e.label ? `fe-ssig-${e.id}-lbl` : void 0
    }, [
      e.label ? (f(), h("span", {
        key: 0,
        id: `fe-ssig-${e.id}-lbl`,
        class: "fe-cfield__label",
        "data-testid": "surface-signature-label"
      }, [
        Vt(y(e.label), 1),
        e.required ? (f(), h("span", H8, "*")) : D("", !0)
      ], 8, U8)) : D("", !0),
      r.value.length > 1 ? (f(), h("div", K8, [
        (f(!0), h(Ce, null, nt(r.value, (X) => (f(), h("button", {
          key: X,
          type: "button",
          class: Ne(["fe-btn fe-btn--sm", { "fe-btn--primary": X === c.value }]),
          role: "tab",
          "aria-selected": X === c.value ? "true" : "false",
          disabled: e.disabled,
          "data-testid": `surface-signature-mode-${X}`,
          onClick: (te) => z(X)
        }, y(u(i)(`plugin.sig.mode_${X}`)), 11, V8))), 128))
      ])) : D("", !0),
      c.value === "draw" ? (f(), h("div", {
        key: 2,
        class: "fe-ssig__padwrap",
        style: Xt({ maxWidth: `${l.value.width}px` })
      }, [
        d("canvas", {
          ref_key: "canvas",
          ref: v,
          class: "fe-ssig__canvas",
          style: Xt({ aspectRatio: `${l.value.width} / ${l.value.height}` }),
          "aria-label": u(i)("plugin.sig.draw_hint"),
          "data-testid": "surface-signature-canvas",
          onPointerdown: P,
          onPointermove: H,
          onPointerup: $,
          onPointercancel: $,
          onPointerleave: $
        }, null, 44, j8),
        b.value ? D("", !0) : (f(), h("p", q8, y(u(i)("plugin.sig.draw_hint")), 1))
      ], 4)) : c.value === "type" ? (f(), h("div", W8, [
        d("input", {
          id: `fe-ssig-${e.id}`,
          class: "fe-cfield__input fe-ssig__typed",
          type: "text",
          placeholder: u(i)("plugin.sig.type_placeholder"),
          disabled: e.disabled,
          value: x.value,
          autocomplete: "name",
          "data-testid": "surface-signature-typed",
          onInput: j[0] || (j[0] = (X) => {
            x.value = X.target.value, Z();
          })
        }, null, 40, Y8),
        p.value.length > 1 ? (f(), h("div", {
          key: 0,
          class: "fe-signfonts",
          role: "group",
          "aria-label": u(i)("plugin.sign.font_label"),
          "data-testid": "surface-signature-fonts"
        }, [
          (f(!0), h(Ce, null, nt(p.value, (X) => (f(), h("button", {
            key: X.key,
            type: "button",
            class: Ne(["fe-signfonts__btn", [X.className, { "is-on": X.key === k.value }]]),
            disabled: e.disabled,
            title: X.name,
            "aria-pressed": X.key === k.value ? "true" : "false",
            "data-testid": `surface-signature-font-${X.key}`,
            onClick: (te) => J(X.key)
          }, y(x.value.trim() || X.name), 11, X8))), 128))
        ], 8, G8)) : D("", !0),
        d("div", {
          class: "fe-ssig__preview",
          style: Xt({ maxWidth: `${l.value.width}px`, aspectRatio: `${l.value.width} / ${l.value.height}` })
        }, [
          w.value || C.value ? (f(), h("img", {
            key: 0,
            class: "fe-ssig__img",
            src: w.value || C.value,
            alt: ""
          }, null, 8, J8)) : D("", !0)
        ], 4)
      ])) : (f(), h("div", Z8, [
        d("label", Q8, [
          d("input", {
            ref_key: "fileInput",
            ref: re,
            type: "file",
            accept: "image/png,image/jpeg",
            class: "fe-ssig__file",
            disabled: e.disabled,
            "data-testid": "surface-signature-file",
            onChange: ve
          }, null, 40, eB),
          Vt(" " + y(u(i)("plugin.sig.upload_pick")), 1)
        ]),
        d("p", tB, y(u(i)("plugin.sig.upload_hint", { kb: 200 })), 1),
        le.value ? (f(), h("p", nB, y(le.value), 1)) : D("", !0),
        w.value || C.value ? (f(), h("div", {
          key: 1,
          class: "fe-ssig__preview",
          style: Xt({ maxWidth: `${l.value.width}px` })
        }, [
          d("img", {
            class: "fe-ssig__img",
            src: w.value || C.value,
            alt: ""
          }, null, 8, aB)
        ], 4)) : D("", !0)
      ])),
      d("div", iB, [
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          disabled: e.disabled || !b.value,
          "data-testid": "surface-signature-clear",
          onClick: W
        }, y(u(i)("plugin.sig.clear")), 9, oB),
        b.value ? (f(), h("span", rB, y(u(i)("plugin.sig.signed")), 1)) : D("", !0)
      ])
    ], 10, F8));
  }
});
async function ZS(e) {
  const t = await fetch(e.url, {
    headers: e.headers ?? {},
    credentials: e.credentials ?? "same-origin",
    signal: e.signal
  });
  if (!t.ok) {
    const n = await t.text().catch(() => "");
    throw pa(t.status, n, void 0);
  }
  return t;
}
async function sB(e) {
  return (await ZS(e)).arrayBuffer();
}
async function kpe(e) {
  return (await ZS(e)).text();
}
const ap = "filex", lB = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
function kg(e) {
  const t = String(e ?? "").trim();
  return lB.test(t) ? t.length === 4 ? `#${t[1]}${t[1]}${t[2]}${t[2]}${t[3]}${t[3]}`.toLowerCase() : t.toLowerCase() : "";
}
function uB(e, t) {
  const n = kg(e);
  if (!n) return "";
  const a = parseInt(n.slice(1), 16), i = (l) => Math.max(0, Math.min(255, Math.round((a >> l & 255) * t))), r = (l) => l.toString(16).padStart(2, "0");
  return `#${r(i(16))}${r(i(8))}${r(i(0))}`;
}
function QS(e) {
  const t = kg(e);
  if (!t) return "";
  const n = parseInt(t.slice(1), 16), a = (r) => {
    const l = r / 255;
    return l <= 0.04045 ? l / 12.92 : ((l + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * a(n >> 16 & 255) + 0.7152 * a(n >> 8 & 255) + 0.0722 * a(n & 255) > 0.42 ? "#0b0f14" : "#ffffff";
}
function e$(e) {
  const t = kg(e);
  if (!t) return {};
  const n = parseInt(t.slice(1), 16), a = `${n >> 16 & 255}, ${n >> 8 & 255}, ${n & 255}`;
  return {
    "--fe-primary": t,
    "--fe-primary-hover": uB(t, 0.85),
    "--fe-text-on-primary": QS(t),
    // ⚠ The TINT and the ink on it, or the accent only half arrives: the
    // button turned orange while the round badge behind the padlock, the
    // focus ring on the PIN box and the row hover stayed the stock blue
    // (measured on the first after-shot of the restored gate). The old
    // Go-rendered page derived exactly these from the same colour
    // (`--px-accent-soft: rgba(r,g,b,0.14)`, `color: var(--px-accent)`), and
    // a translucent tint is right rather than a solid: it composites onto
    // the card in light and in dark without a second value.
    "--fe-primary-soft": `rgba(${a}, 0.14)`,
    "--fe-primary-ink": t
  };
}
function cB(e = {}) {
  const t = S(null), n = S(!1), a = E(() => {
    var k, _;
    return ((_ = (k = t.value) == null ? void 0 : k.name) == null ? void 0 : _.trim()) || ap;
  }), i = E(() => {
    var k, _;
    return !!((_ = (k = t.value) == null ? void 0 : k.name) != null && _.trim()) && a.value !== ap;
  }), r = E(() => {
    var k, _;
    return ((_ = (k = t.value) == null ? void 0 : k.logo_url) == null ? void 0 : _.trim()) || "";
  }), l = E(() => {
    var k, _;
    return ((_ = (k = t.value) == null ? void 0 : k.footer_text) == null ? void 0 : _.trim()) || "";
  }), c = E(() => {
    var k;
    return ((k = t.value) == null ? void 0 : k.hide_powered_by) === !0;
  }), p = E(() => {
    var _;
    const k = (_ = t.value) == null ? void 0 : _.theme;
    return k === "light" || k === "dark" ? k : "auto";
  }), m = E(() => {
    var k;
    return ((k = t.value) == null ? void 0 : k.locales) ?? [];
  }), v = E(() => {
    var k;
    return e$((k = t.value) == null ? void 0 : k.accent);
  });
  async function x() {
    const k = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
    if (!k) return null;
    const _ = El(e.base);
    for (const w of ["/api/public/branding", "/api/branding"])
      try {
        const b = await k(`${_}${w}`, {
          method: "GET",
          headers: { Accept: "application/json" },
          credentials: "same-origin"
        });
        if (!b.ok) continue;
        return t.value = await b.json(), n.value = !0, n2(t.value, { base: e.base, fetchImpl: e.fetchImpl }), t.value;
      } catch {
      }
    return null;
  }
  return { branding: t, loaded: n, name: a, whitelabel: i, logo: r, footerText: l, hidePoweredBy: c, themeDefault: p, locales: m, accentStyle: v, load: x };
}
let Fm = null;
function dB(e) {
  return `https://cdn.jsdelivr.net/npm/pdfjs-dist@${e}/legacy/build/pdf.worker.min.mjs`;
}
function fB(e) {
  return Fm || (Fm = (async () => {
    try {
      const t = await import(
        /* @vite-ignore */
        "./pdf-CaPYsOUo.js"
      ), n = t.default ?? t;
      return n.GlobalWorkerOptions && !n.GlobalWorkerOptions.workerSrc && (n.GlobalWorkerOptions.workerSrc = e || dB(n.version || "5.7.284")), n;
    } catch {
      return null;
    }
  })()), Fm;
}
const pB = ["data-testid"], hB = { class: "fe-spdf__propname" }, mB = { class: "fe-spdf__prop" }, vB = ["value", "placeholder", "disabled", "data-testid"], yB = {
  key: 0,
  class: "fe-spdf__prop"
}, gB = ["id", "data-testid"], bB = ["data-testid"], kB = ["id"], wB = { class: "fe-spdf__prop fe-spdf__prop--check" }, _B = ["checked", "disabled", "data-testid"], xB = { class: "fe-spdf__prop" }, SB = ["id"], $B = { class: "fe-spdf__prop" }, TB = ["value", "disabled", "data-testid"], AB = { class: "fe-spdf__prop" }, EB = ["value", "disabled", "data-testid"], CB = { class: "fe-spdf__prop" }, zB = ["id"], MB = { class: "fe-spdf__prop" }, OB = ["id"], PB = ["data-testid"], DB = { class: "fe-spdf__dateex-title" }, LB = { class: "fe-spdf__dateex-value" }, RB = {
  key: 4,
  class: "fe-spdf__prop"
}, NB = ["id"], IB = ["aria-label", "data-testid"], BB = ["title", "disabled", "aria-pressed", "data-testid", "onClick"], FB = ["data-testid"], UB = ["id"], HB = ["data-testid"], KB = { class: "fe-spdf__linepreview-title" }, VB = {
  key: 1,
  class: "fe-spdf__linepreview-line is-none"
}, jB = ["disabled", "data-testid"], Um = "*", s1 = /* @__PURE__ */ rt({
  __name: "PdfFieldEditor",
  props: {
    field: {},
    signers: {},
    formats: {},
    dateLabels: {},
    locale: {},
    disabled: { type: Boolean },
    testidPrefix: {},
    stampLines: {}
  },
  emits: ["patch", "remove"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = E(() => n.testidPrefix || "surface-pdf");
    function l(B) {
      return i(`plugin.pdf.type_${B}`);
    }
    function c(B) {
      const K = { ...n.field };
      B(K), a("patch", K);
    }
    function p(B) {
      c((K) => {
        B ? K.label = B : delete K.label;
      });
    }
    function m(B) {
      c((K) => {
        B ? K.assignee = B : delete K.assignee;
      });
    }
    function v(B) {
      c((K) => {
        B ? K.required = !0 : delete K.required;
      });
    }
    function x(B) {
      c((K) => {
        const ke = Gv.includes(B) ? B : "any", Ye = { ...K.rule ?? { kind: "any" }, kind: ke };
        ke === "any" && !Ye.min && !Ye.max ? delete K.rule : K.rule = Ye;
      });
    }
    function k(B, K) {
      const ke = Math.trunc(Number(String(K ?? "").trim()));
      c((Ye) => {
        const Oe = { ...Ye.rule ?? { kind: "any" } };
        Number.isFinite(ke) && ke > 0 ? Oe[B] = ke : delete Oe[B], Oe.kind === "any" && !Oe.min && !Oe.max ? delete Ye.rule : Ye.rule = Oe;
      });
    }
    function _(B) {
      c((K) => {
        B ? K.format = B : delete K.format;
      });
    }
    function w(B) {
      c((K) => {
        K.font = B;
      });
    }
    const b = E(() => DS(n.field.type)), C = E(() => n.field.style ?? "drawn");
    function A(B) {
      c((K) => {
        B === "typed" ? K.style = "typed" : delete K.style;
      });
    }
    const T = E(() => [
      { value: "drawn", label: i("plugin.pdf.style_drawn") },
      { value: "typed", label: i("plugin.pdf.style_typed") }
    ]), R = E(() => n.field.type === "checkbox" ? !1 : b.value ? C.value === "typed" : !0), M = E(() => I5(n.stampLines)), L = E(() => B5(n.field, M.value)), U = E(
      () => M.value.map((B) => ({ value: B.id, label: Zt(B.label, n.locale) || B.id }))
    );
    function P(B) {
      const K = (Array.isArray(B) ? B : [B]).filter(Boolean);
      c((ke) => {
        ke.lines = K;
      });
    }
    const H = E(
      () => L.value.map((B) => M.value.find((K) => K.id === B)).filter((B) => !!B).map((B) => Zt(F5(B, n.field.assignee), n.locale) || Zt(B.label, n.locale))
    ), $ = E(() => i(b.value ? "plugin.pdf.assignee" : "plugin.pdf.filled_by")), F = E(() => [
      { value: Um, label: i("plugin.pdf.unassigned") },
      ...n.signers.map((B) => ({ value: B.id, label: Zt(B.label, n.locale) || B.id }))
    ]), I = E(
      () => Gv.map((B) => ({ value: B, label: i(`plugin.pdf.rule_kind_${B}`) }))
    ), Z = E(() => V5(n.formats)), J = E(
      () => Z.value.map((B) => ({ value: B.id, label: Zt(B.label, n.locale) || B.id, help: B.example }))
    ), re = E(() => {
      var B;
      return n.field.format ?? ((B = Z.value[0]) == null ? void 0 : B.id) ?? "";
    }), ve = E(() => q5(Z.value)), W = E(() => j5(n.dateLabels));
    function z(B, K) {
      return Fy(W.value[B], n.locale, () => i(K));
    }
    const le = E(() => W5(Z.value, re.value)), fe = E(() => {
      var B, K, ke;
      return ((B = le.value) == null ? void 0 : B.order) ?? ((ke = (K = ve.value) == null ? void 0 : K.orders[0]) == null ? void 0 : ke.id) ?? "";
    }), j = E(() => {
      var B, K, ke;
      return ((B = le.value) == null ? void 0 : B.separator) ?? ((ke = (K = ve.value) == null ? void 0 : K.separators[0]) == null ? void 0 : ke.id) ?? "";
    }), X = E(
      () => {
        var B;
        return (((B = ve.value) == null ? void 0 : B.orders) ?? []).map((K) => ({ value: K.id, label: Zt(K.label, n.locale) || K.id }));
      }
    ), te = E(
      () => {
        var B;
        return (((B = ve.value) == null ? void 0 : B.separators) ?? []).map((K) => ({ value: K.id, label: Zt(K.label, n.locale) || K.id }));
      }
    ), V = E(() => G5(fe.value, j.value, /* @__PURE__ */ new Date()));
    function G(B) {
      _(Z_(Z.value, B, j.value));
    }
    function q(B) {
      _(Z_(Z.value, fe.value, B));
    }
    return (B, K) => {
      var ke, Ye, Oe;
      return f(), h("div", {
        class: "fe-spdf__props",
        "data-testid": `${r.value}-editor`
      }, [
        d("span", hB, y(l(e.field.type)), 1),
        d("label", mB, [
          d("span", null, y(u(i)("plugin.pdf.label")), 1),
          d("input", {
            class: "fe-cfield__input fe-spdf__name",
            type: "text",
            value: e.field.label ?? "",
            placeholder: l(e.field.type),
            disabled: e.disabled,
            "data-testid": `${r.value}-label`,
            onInput: K[0] || (K[0] = (Be) => p(Be.target.value))
          }, null, 40, vB)
        ]),
        e.signers.length ? (f(), h("div", yB, [
          d("span", {
            id: `${r.value}-${e.field.id}-assignee-lbl`,
            "data-testid": `${r.value}-assignee-label`
          }, y($.value), 9, gB),
          Je(mi, {
            options: F.value,
            "model-value": e.field.assignee || Um,
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-assignee-lbl`,
            "testid-prefix": `${r.value}-assignee`,
            "onUpdate:modelValue": K[1] || (K[1] = (Be) => m(String(Be) === Um ? "" : String(Be)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : D("", !0),
        b.value ? (f(), h("div", {
          key: 1,
          class: "fe-spdf__prop",
          "data-testid": `${r.value}-style`
        }, [
          d("span", {
            id: `${r.value}-${e.field.id}-style-lbl`
          }, y(u(i)("plugin.pdf.style")), 9, kB),
          Je(mi, {
            options: T.value,
            "model-value": C.value,
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-style-lbl`,
            "testid-prefix": `${r.value}-style`,
            "onUpdate:modelValue": K[2] || (K[2] = (Be) => A(String(Be)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ], 8, bB)) : D("", !0),
        d("label", wB, [
          d("input", {
            type: "checkbox",
            checked: e.field.required === !0,
            disabled: e.disabled,
            "data-testid": `${r.value}-required`,
            onChange: K[3] || (K[3] = (Be) => v(Be.target.checked))
          }, null, 40, _B),
          d("span", null, y(u(i)("plugin.pdf.required")), 1)
        ]),
        e.field.type === "text" ? (f(), h(Ce, { key: 2 }, [
          d("div", xB, [
            d("span", {
              id: `${r.value}-${e.field.id}-rule-lbl`
            }, y(u(i)("plugin.pdf.rule")), 9, SB),
            Je(mi, {
              options: I.value,
              "model-value": ((ke = e.field.rule) == null ? void 0 : ke.kind) ?? "any",
              disabled: e.disabled,
              "aria-labelledby": `${r.value}-${e.field.id}-rule-lbl`,
              "testid-prefix": `${r.value}-rule`,
              "onUpdate:modelValue": K[4] || (K[4] = (Be) => x(String(Be)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          d("label", $B, [
            d("span", null, y(u(i)("plugin.pdf.rule_min_label")), 1),
            d("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((Ye = e.field.rule) == null ? void 0 : Ye.min) ?? "",
              disabled: e.disabled,
              "data-testid": `${r.value}-rule-min`,
              onInput: K[5] || (K[5] = (Be) => k("min", Be.target.value))
            }, null, 40, TB)
          ]),
          d("label", AB, [
            d("span", null, y(u(i)("plugin.pdf.rule_max_label")), 1),
            d("input", {
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "0",
              value: ((Oe = e.field.rule) == null ? void 0 : Oe.max) ?? "",
              disabled: e.disabled,
              "data-testid": `${r.value}-rule-max`,
              onInput: K[6] || (K[6] = (Be) => k("max", Be.target.value))
            }, null, 40, EB)
          ])
        ], 64)) : D("", !0),
        e.field.type === "date" && ve.value ? (f(), h(Ce, { key: 3 }, [
          d("div", CB, [
            d("span", {
              id: `${r.value}-${e.field.id}-order-lbl`
            }, y(z("order", "plugin.pdf.date_order")), 9, zB),
            Je(mi, {
              options: X.value,
              "model-value": fe.value,
              disabled: e.disabled,
              "aria-labelledby": `${r.value}-${e.field.id}-order-lbl`,
              "testid-prefix": `${r.value}-order`,
              "onUpdate:modelValue": K[7] || (K[7] = (Be) => G(String(Be)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          d("div", MB, [
            d("span", {
              id: `${r.value}-${e.field.id}-sep-lbl`
            }, y(z("separator", "plugin.pdf.date_separator")), 9, OB),
            Je(mi, {
              options: te.value,
              "model-value": j.value,
              disabled: e.disabled,
              "aria-labelledby": `${r.value}-${e.field.id}-sep-lbl`,
              "testid-prefix": `${r.value}-sep`,
              "onUpdate:modelValue": K[8] || (K[8] = (Be) => q(String(Be)))
            }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
          ]),
          d("p", {
            class: "fe-spdf__dateex",
            "data-testid": `${r.value}-date-example`
          }, [
            d("span", DB, y(z("example", "plugin.pdf.date_example")), 1),
            d("bdi", LB, y(V.value), 1)
          ], 8, PB)
        ], 64)) : e.field.type === "date" && J.value.length ? (f(), h("div", RB, [
          d("span", {
            id: `${r.value}-${e.field.id}-format-lbl`
          }, y(u(i)("plugin.pdf.format")), 9, NB),
          Je(mi, {
            options: J.value,
            "model-value": re.value,
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-format-lbl`,
            "testid-prefix": `${r.value}-format`,
            "onUpdate:modelValue": K[9] || (K[9] = (Be) => _(String(Be)))
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"])
        ])) : D("", !0),
        R.value ? (f(), h("div", {
          key: 5,
          class: "fe-signfonts fe-spdf__prop",
          role: "group",
          "aria-label": u(i)("plugin.pdf.font"),
          "data-testid": `${r.value}-fonts`
        }, [
          (f(!0), h(Ce, null, nt(u(_l), (Be) => (f(), h("button", {
            key: Be.key,
            type: "button",
            class: Ne(["fe-signfonts__btn", [Be.className, { "is-on": (e.field.font ?? "caveat") === Be.key }]]),
            title: Be.name,
            disabled: e.disabled,
            "aria-pressed": (e.field.font ?? "caveat") === Be.key ? "true" : "false",
            "data-testid": `${r.value}-font-${Be.key}`,
            onClick: (qe) => w(Be.key)
          }, " Aa ", 10, BB))), 128))
        ], 8, IB)) : D("", !0),
        b.value && U.value.length ? (f(), h("div", {
          key: 6,
          class: "fe-spdf__prop fe-spdf__lines",
          "data-testid": `${r.value}-lines`
        }, [
          d("span", {
            id: `${r.value}-${e.field.id}-lines-lbl`
          }, y(u(i)("plugin.pdf.lines")), 9, UB),
          Je(mi, {
            options: U.value,
            "model-value": L.value,
            multi: "",
            disabled: e.disabled,
            "aria-labelledby": `${r.value}-${e.field.id}-lines-lbl`,
            "testid-prefix": `${r.value}-line`,
            "onUpdate:modelValue": P
          }, null, 8, ["options", "model-value", "disabled", "aria-labelledby", "testid-prefix"]),
          d("div", {
            class: "fe-spdf__linepreview",
            "data-testid": `${r.value}-lines-preview`
          }, [
            d("span", KB, y(u(i)("plugin.pdf.lines_preview")), 1),
            H.value.length ? (f(!0), h(Ce, { key: 0 }, nt(H.value, (Be, qe) => (f(), h("span", {
              key: qe,
              class: "fe-spdf__linepreview-line"
            }, y(Be), 1))), 128)) : (f(), h("span", VB, y(u(i)("plugin.pdf.lines_none")), 1))
          ], 8, HB)
        ], 8, FB)) : D("", !0),
        Ln(B.$slots, "extra"),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--sm fe-btn--danger",
          disabled: e.disabled,
          "data-testid": `${r.value}-delete`,
          onClick: K[10] || (K[10] = (Be) => a("remove"))
        }, y(u(i)("plugin.pdf.delete")), 9, jB)
      ], 8, pB);
    };
  }
}), qB = ["data-state", "data-layout"], WB = {
  key: 0,
  class: "fe-spdf__bar"
}, YB = ["aria-label"], GB = ["disabled", "aria-pressed", "data-testid", "onClick"], XB = {
  key: 0,
  class: "fe-spdf__done",
  "data-testid": "surface-pdf-all-placed"
}, JB = ["aria-label"], ZB = ["disabled", "aria-pressed", "data-testid", "onClick"], QB = { class: "fe-spdf__zoom" }, e6 = ["aria-label", "disabled"], t6 = ["aria-label", "disabled"], n6 = ["aria-label", "disabled"], a6 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint"
}, i6 = {
  key: 2,
  class: "fe-spdf__define",
  "data-testid": "surface-pdf-define"
}, o6 = {
  key: 0,
  class: "fe-spdf__empty",
  "data-testid": "surface-pdf-no-boxes"
}, r6 = ["data-testid"], s6 = {
  class: "fe-spdf__cardno",
  "aria-hidden": "true"
}, l6 = ["aria-label"], u6 = { class: "fe-spdf__addlbl" }, c6 = ["disabled", "data-testid", "onClick"], d6 = {
  key: 3,
  class: "fe-spdf__strip",
  "data-testid": "surface-pdf-strip"
}, f6 = {
  key: 0,
  class: "fe-spdf__props",
  "data-testid": "surface-pdf-selected"
}, p6 = {
  key: 0,
  class: "fe-spdf__propwho"
}, h6 = {
  key: 1,
  class: "fe-spdf__prop"
}, m6 = ["max"], v6 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info fe-spdf__hint",
  "data-testid": "surface-pdf-place-hint"
}, y6 = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted fe-spdf__hint",
  "data-testid": "surface-pdf-idle-hint"
}, g6 = {
  key: 4,
  "data-testid": "surface-pdf-selected"
}, b6 = {
  key: 0,
  class: "fe-spdf__prop"
}, k6 = ["max"], w6 = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, _6 = {
  key: 1,
  class: "fe-surface__unknown",
  role: "alert",
  "data-testid": "surface-pdf-error"
}, x6 = {
  key: 2,
  class: "fe-spdf__pages"
}, S6 = ["data-page", "onPointerdown"], $6 = ["data-testid", "data-field-type", "role", "tabindex", "title", "onPointerdown", "onClick", "onKeydown"], T6 = ["src"], A6 = ["value", "placeholder", "aria-label", "inputmode", "maxlength", "aria-invalid", "aria-describedby", "title", "disabled", "data-testid", "onInput"], E6 = ["innerHTML"], C6 = {
  key: 4,
  class: "fe-spdf__label"
}, z6 = {
  key: 0,
  class: "fe-spdf__who"
}, M6 = {
  key: 1,
  class: "fe-spdf__who"
}, O6 = ["id", "role", "data-testid"], P6 = ["onPointerdown"], D6 = {
  key: 6,
  class: "fe-spdf__pad",
  "data-testid": "surface-pdf-pad"
}, L6 = { class: "fe-surface__text fe-surface__text--muted" }, R6 = /* @__PURE__ */ rt({
  __name: "SurfacePdfFields",
  props: {
    id: {},
    src: {},
    mode: {},
    fields: {},
    signers: {},
    signer: {},
    types: {},
    formats: {},
    dateLabels: {},
    modelValue: {},
    locale: {},
    theme: {},
    disabled: { type: Boolean },
    invalid: { type: Boolean },
    api: {},
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    layout: {},
    pageHeight: {},
    stampLines: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = E(() => n.mode !== "fill"), l = E(() => n.mode === "define"), c = E(() => n.mode === "place"), p = E(() => X5(n.signers)), m = E(() => U5(n.types)), v = S([]);
    let x;
    function k() {
      r.value ? v.value = Array.isArray(n.modelValue) ? xf(n.modelValue) : xf(n.fields) : v.value = Z5(xf(n.fields), n.modelValue);
    }
    function _() {
      const me = r.value ? v.value.map((De) => ({ ...De })) : IS(v.value, n.signer);
      x = me, a("update:modelValue", me);
    }
    let w = !1;
    function b() {
      if (oe) {
        w = !0;
        return;
      }
      k();
    }
    k(), Xe([() => n.fields, () => n.mode, () => n.signer], () => b()), Xe(
      () => n.modelValue,
      (me) => {
        me !== x && b();
      }
    );
    const C = E(() => {
      const me = /* @__PURE__ */ new Map();
      for (const De of v.value) {
        if (!Xv(De)) continue;
        const He = me.get(De.page) ?? [];
        He.push(De), me.set(De.page, He);
      }
      return me;
    });
    function A(me) {
      return J5(p.value, me.assignee);
    }
    function T(me) {
      const De = A(me), He = QS(De);
      return He ? { "--spdf-color": De, "--spdf-ink": He } : { "--spdf-color": De };
    }
    function R(me) {
      const De = p.value.find((He) => He.id === me);
      return De ? Zt(De.label, n.locale) || De.id : me || "";
    }
    function M(me) {
      return !r.value && NS(me, n.signer);
    }
    function L(me) {
      return i(`plugin.pdf.type_${me}`);
    }
    function U(me) {
      const De = (me.label ?? "").trim();
      if (De) return De;
      const He = v.value.filter((Ve) => Ve.type === me.type && !(Ve.label ?? "").trim());
      return He.length < 2 ? L(me.type) : `${L(me.type)} ${He.findIndex((Ve) => Ve.id === me.id) + 1}`;
    }
    const P = S("loading"), H = S([]), $ = S(1), F = S(null), I = S(640), Z = S(0), J = E(() => n.layout === "page");
    let re = null, ve = 0, W = null, z = null;
    const le = /* @__PURE__ */ new Map(), fe = /* @__PURE__ */ new Map(), j = /* @__PURE__ */ new Map(), X = E(() => {
      if (!J.value) return I.value;
      const me = H.value[0];
      return me ? O5({ width: I.value, height: Z.value }, me) : I.value;
    }), te = E(() => Math.max(120, Math.round(X.value * $.value)));
    async function V() {
      var He, Ve;
      const me = n.src ?? {};
      if (me.path) {
        if (!n.api) throw new Error("no api");
        const bt = await n.api.fetchBlob(me.path);
        return URL.revokeObjectURL(bt.url), bt.blob.arrayBuffer();
      }
      const De = me.url || (me.ref ? (Ve = (He = n.fileUrl) == null ? void 0 : He.call(n, me.ref)) == null ? void 0 : Ve.url : "");
      if (!De) throw new Error("no source");
      return sB({ url: De, headers: {}, credentials: "same-origin" });
    }
    async function G() {
      var De, He;
      const me = ++ve;
      P.value = "loading", H.value = [], q();
      try {
        (De = re == null ? void 0 : re.destroy) == null || De.call(re);
      } catch {
      }
      re = null;
      try {
        const Ve = await fB(n.pdfWorkerUrl ?? void 0);
        if (!Ve) throw new Error("pdfjs unavailable");
        const bt = await V();
        if (me !== ve) return;
        const Qe = await Ve.getDocument({ data: bt }).promise;
        if (me !== ve) {
          (He = Qe.destroy) == null || He.call(Qe);
          return;
        }
        re = Qe;
        const se = [];
        for (let je = 1; je <= Qe.numPages; je++) {
          const tt = (await Qe.getPage(je)).getViewport({ scale: 1 });
          se.push({ num: je, width: tt.width, height: tt.height, rotation: tt.rotation ?? 0 });
        }
        if (me !== ve) return;
        H.value = se, P.value = "ok", await Jt(), K();
      } catch {
        if (me !== ve) return;
        P.value = "error";
      }
    }
    function q() {
      W == null || W.disconnect(), W = null, le.clear(), fe.clear(), j.clear();
    }
    function B(me, De) {
      if (!(De instanceof HTMLDivElement)) return;
      const He = le.get(me);
      He !== De && (He && (W == null || W.unobserve(He)), le.set(me, De), re && (W ? W.observe(De) : typeof IntersectionObserver > "u" && ke(me), He && (fe.delete(me), j.delete(me))));
    }
    function K() {
      if (typeof IntersectionObserver > "u") {
        for (const me of le.keys()) ke(me);
        return;
      }
      W = new IntersectionObserver(
        (me) => {
          for (const De of me) {
            const He = Number(De.target.dataset.page);
            De.isIntersecting && ke(He);
          }
        },
        { rootMargin: "200px 0px" }
      );
      for (const me of le.values()) W.observe(me);
    }
    async function ke(me) {
      if (!re || !le.get(me)) return;
      const He = te.value;
      if (fe.get(me) === He) return;
      fe.set(me, He);
      const Ve = H.value.find((je) => je.num === me);
      if (!Ve) return;
      const bt = typeof window < "u" && window.devicePixelRatio > 0 ? Math.min(3, window.devicePixelRatio) : 1, Qe = He / Ve.width * bt, se = re;
      try {
        const je = await se.getPage(me), dt = je.getViewport({ scale: Qe }), tt = document.createElement("canvas");
        tt.className = "fe-spdf__canvas", tt.width = Math.round(dt.width), tt.height = Math.round(dt.height);
        const ie = tt.getContext("2d");
        if (!ie || (await je.render({ canvasContext: ie, viewport: dt }).promise, se !== re || fe.get(me) !== He)) return;
        const ue = le.get(me);
        if (!ue) return;
        const Pe = j.get(me);
        Pe && Pe.parentNode === ue ? ue.replaceChild(tt, Pe) : ue.prepend(tt), j.set(me, tt);
      } catch {
        fe.get(me) === He && fe.delete(me);
      }
    }
    function Ye() {
      for (const me of le.keys())
        fe.has(me) && (fe.delete(me), ke(me));
    }
    Xe(te, () => Ye());
    function Oe() {
      $.value = Math.min(3, Math.round($.value * 1.25 * 100) / 100);
    }
    function Be() {
      $.value = Math.max(0.5, Math.round($.value / 1.25 * 100) / 100);
    }
    function qe() {
      $.value = 1;
    }
    function Tt() {
      const me = F.value;
      me && (I.value = me.clientWidth || I.value, Z.value = me.clientHeight || Z.value, !(typeof ResizeObserver > "u") && (z == null || z.disconnect(), z = new ResizeObserver(() => $t()), z.observe(me)));
    }
    function $t() {
      var He, Ve;
      if (oe) {
        it = !0;
        return;
      }
      const me = ((He = F.value) == null ? void 0 : He.clientWidth) ?? 0, De = ((Ve = F.value) == null ? void 0 : Ve.clientHeight) ?? 0;
      me > 0 && Math.abs(me - I.value) > 2 && (I.value = me), De > 0 && Math.abs(De - Z.value) > 2 && (Z.value = De);
    }
    let it = !1;
    Xe(F, () => {
      Jt(Tt);
    }), qt(() => {
      Tt(), G();
    });
    const yt = E(() => {
      const me = n.src ?? {};
      return [me.ref ?? "", me.path ?? "", me.url ?? ""].join("\0");
    });
    Xe(yt, () => void G()), Ct(() => {
      var me;
      ve++, q(), z == null || z.disconnect();
      try {
        (me = re == null ? void 0 : re.destroy) == null || me.call(re);
      } catch {
      }
      re = null;
    });
    const ft = S(""), ze = S("");
    let oe = null;
    const Se = S(null);
    function he(me, De) {
      const He = De.getBoundingClientRect();
      return G_({ x: me.clientX - He.left, y: me.clientY - He.top }, { width: He.width, height: He.height });
    }
    function Ke(me) {
      const De = le.get(me.page), He = De && De.isConnected ? De : me.el;
      if (!He || !He.isConnected) return null;
      const Ve = He.getBoundingClientRect();
      return Ve.width >= 1 && Ve.height >= 1 ? Ve : null;
    }
    function Le(me, De) {
      return G_({ x: me.clientX - De.left, y: me.clientY - De.top }, { width: De.width, height: De.height });
    }
    function ut(me) {
      ze.value = ze.value === me ? "" : me, ft.value = "";
    }
    function wt(me) {
      const De = K5(v.value, me, {
        assignee: Ue(),
        required: !0
      });
      v.value = [...v.value, De], _();
    }
    function _t(me) {
      v.value = v.value.map((De) => De.id === me.id ? me : De), _();
    }
    function At(me) {
      v.value = v.value.filter((De) => De.id !== me), ft.value === me && (ft.value = ""), _();
    }
    const _e = E(() => H5(v.value)), Ie = S("");
    function pe(me) {
      Ie.value = Ie.value === me ? "" : me, ft.value = "";
    }
    function we(me, De) {
      const He = Ie.value;
      He && (v.value = v.value.map((Ve) => {
        if (Ve.id !== He) return Ve;
        const bt = { ...Ve, page: me, ...ul(De) };
        return delete bt.placed, bt;
      }), Ie.value = "", ft.value = He, _());
    }
    function ee() {
      const me = ft.value;
      me && (v.value = v.value.map((De) => De.id === me ? { ...De, placed: !1 } : De), ft.value = "", _());
    }
    function ge(me) {
      const De = R(me.assignee), He = U(me);
      return De ? `${He} · ${De}` : He;
    }
    function ae(me, De) {
      var Ve, bt;
      if (!r.value || n.disabled) return;
      const He = me.currentTarget;
      if (c.value && Ie.value) {
        oe = { kind: "place", page: De, el: He, start: he(me, He) }, Se.value = null, Qt(), (Ve = me.preventDefault) == null || Ve.call(me);
        return;
      }
      if (ze.value) {
        oe = { kind: "place", page: De, el: He, start: he(me, He) }, Se.value = null, Qt(), (bt = me.preventDefault) == null || bt.call(me);
        return;
      }
      ft.value = "";
    }
    function xe(me, De, He) {
      var bt;
      if (!r.value || n.disabled) return;
      const Ve = me.currentTarget.closest(".fe-spdf__page");
      Ve && (ft.value = De.id, ze.value = "", oe = { kind: "move", page: He, el: Ve, start: he(me, Ve), id: De.id, orig: { ...De } }, Qt(), me.stopPropagation(), (bt = me.preventDefault) == null || bt.call(me));
    }
    function Fe(me, De, He) {
      var bt;
      if (!r.value || n.disabled) return;
      const Ve = me.currentTarget.closest(".fe-spdf__page");
      Ve && (ft.value = De.id, oe = { kind: "resize", page: He, el: Ve, start: he(me, Ve), id: De.id, orig: { ...De } }, Qt(), me.stopPropagation(), (bt = me.preventDefault) == null || bt.call(me));
    }
    function ye(me) {
      if (!oe) return;
      const De = Ke(oe);
      if (!De) return;
      const He = Le(me, De);
      if (oe.kind === "place") {
        const dt = ef(oe.start, He);
        Se.value = { page: oe.page, ...dt };
        return;
      }
      if (!oe.id || !oe.orig) return;
      const Ve = He.x - oe.start.x, bt = He.y - oe.start.y, Qe = oe.orig, se = oe.kind === "move" ? ul({ x: Qe.x + Ve, y: Qe.y + bt, w: Qe.w, h: Qe.h }) : ul({ x: Qe.x, y: Qe.y, w: Qe.w + Ve, h: Qe.h + bt }), je = oe.id;
      v.value = v.value.map((dt) => dt.id === je ? { ...dt, ...se } : dt);
    }
    function Te(me) {
      if (!oe) return;
      const De = oe;
      oe = null, vn();
      const He = Ke(De);
      it && (it = !1, $t());
      const Ve = De.kind === "place" || De.kind === "move" || De.kind === "resize";
      if (w && (w = !1, Ve || k()), !He) {
        Se.value = null, (De.kind === "move" || De.kind === "resize") && _();
        return;
      }
      if (De.kind === "place" && c.value && Ie.value) {
        const bt = Le(me, He), Qe = v.value.find((dt) => dt.id === Ie.value), je = Math.abs(bt.x - De.start.x) > 0.01 || Math.abs(bt.y - De.start.y) > 0.01 ? ef(De.start, bt) : { x: bt.x - ((Qe == null ? void 0 : Qe.w) ?? 0.2) / 2, y: bt.y - ((Qe == null ? void 0 : Qe.h) ?? 0.05) / 2, w: (Qe == null ? void 0 : Qe.w) ?? 0.2, h: (Qe == null ? void 0 : Qe.h) ?? 0.05 };
        we(De.page, je), Se.value = null;
        return;
      }
      if (De.kind === "place" && ze.value) {
        const bt = Le(me, He), Qe = Math.abs(bt.x - De.start.x) > 0.01 || Math.abs(bt.y - De.start.y) > 0.01, se = ze.value, je = Qe ? Q_(v.value, se, De.page, ef(De.start, bt), ef(De.start, bt), Ue()) : Q_(v.value, se, De.page, { x: bt.x - np[se].w / 2, y: bt.y - np[se].h / 2 }, void 0, Ue());
        v.value = [...v.value, { ...je, label: L(se) }], ft.value = je.id, Se.value = null, _();
        return;
      }
      if (Se.value = null, De.kind === "move" || De.kind === "resize") {
        const bt = v.value.find((se) => se.id === De.id), Qe = De.orig;
        (!bt || !Qe || bt.x !== Qe.x || bt.y !== Qe.y || bt.w !== Qe.w || bt.h !== Qe.h) && _();
      }
    }
    function Ue() {
      return p.value.length === 1 ? p.value[0].id : void 0;
    }
    const xt = S(!1);
    function Qt() {
      xt.value = !0, window.addEventListener("pointermove", ye), window.addEventListener("pointerup", Te), window.addEventListener("pointercancel", Te);
    }
    function vn() {
      xt.value = !1, window.removeEventListener("pointermove", ye), window.removeEventListener("pointerup", Te), window.removeEventListener("pointercancel", Te);
    }
    const Ut = E(() => v.value.find((me) => me.id === ft.value) ?? null), pn = S(1);
    function Rt() {
      if (!Ut.value) return;
      const me = v.value.length;
      v.value = eR(v.value, ft.value, pn.value), v.value.length !== me && (ft.value = v.value[v.value.length - 1].id, _());
    }
    function rn() {
      const me = F.value, De = Ut.value;
      if (!me || !De || oe || !Xv(De)) return;
      const He = le.get(De.page);
      if (!He) return;
      const Ve = He.getBoundingClientRect(), bt = me.getBoundingClientRect();
      if (!Ve.height || !bt.height) return;
      const Qe = Ve.top - bt.top + me.scrollTop + De.y * Ve.height, se = Qe + De.h * Ve.height, je = 24;
      Qe < me.scrollTop + je ? me.scrollTop = Math.max(0, Qe - je) : se > me.scrollTop + me.clientHeight - je && (me.scrollTop = se - me.clientHeight + je);
    }
    Xe(ft, () => void Jt(rn));
    const nn = S("");
    function gt(me, De) {
      v.value = Q5(v.value, me, De), _();
    }
    function wn(me) {
      if (!(r.value || n.disabled || !M(me)))
        switch (me.type) {
          case "signature":
          case "initials":
            nn.value = nn.value === me.id ? "" : me.id;
            break;
          case "checkbox":
            gt(me.id, me.value !== !0);
            break;
          case "date":
            gt(me.id, Jv(me) ? "" : tR());
            break;
        }
    }
    function ra(me, De) {
      const He = De.target, Ve = R5(He.value, sn(me));
      Ve !== He.value && (He.value = Ve), gt(me.id, Ve);
    }
    const dn = E(() => v.value.find((me) => me.id === nn.value) ?? null), jn = E(() => {
      var me;
      return ((me = dn.value) == null ? void 0 : me.style) === "typed" ? ["type"] : ["draw", "upload"];
    }), zn = E(
      () => {
        var me;
        return ((me = dn.value) == null ? void 0 : me.style) === "typed" && dn.value.font ? [dn.value.font] : void 0;
      }
    ), Bn = E(() => {
      var De;
      const me = (De = dn.value) == null ? void 0 : De.value;
      return typeof me == "string" && me ? { png_b64: me, mode: "draw" } : null;
    });
    function Sn(me) {
      dn.value && gt(dn.value.id, (me == null ? void 0 : me.png_b64) ?? "");
    }
    function mn(me) {
      return typeof me.value == "string" && me.value ? `data:image/png;base64,${me.value}` : "";
    }
    function sn(me) {
      return me.type === "text" ? me.rule ?? null : null;
    }
    function $n(me) {
      const De = sn(me);
      if (!De) return "";
      const He = [];
      return De.kind === "number" ? He.push(i("plugin.pdf.rule_number")) : De.kind === "email" && He.push(i("plugin.pdf.rule_email")), De.min && De.max ? He.push(i("plugin.pdf.rule_length", { min: De.min, max: De.max })) : De.min ? He.push(i("plugin.pdf.rule_min", { min: De.min })) : De.max && He.push(i("plugin.pdf.rule_max", { max: De.max })), He.join(" · ");
    }
    function Rn(me) {
      const De = sn(me), He = N5(me.value, De);
      return !He || !De ? "" : He === "min" ? i("plugin.pdf.err_min", { min: De.min ?? 0 }) : He === "max" ? i("plugin.pdf.err_max", { max: De.max ?? 0 }) : i(`plugin.pdf.err_${He}`);
    }
    function Fn(me) {
      return OS(me.font).className;
    }
    const Tn = Pt("check");
    return (me, De) => (f(), h("div", {
      class: Ne(["fe-spdf", {
        "is-edit": r.value,
        "is-fill": !r.value,
        "is-invalid": e.invalid,
        "is-disabled": e.disabled,
        "is-placing": !!ze.value || !!Ie.value,
        "is-define": l.value,
        "fe-spdf--page": J.value && !l.value
      }]),
      "data-testid": "surface-pdf-fields",
      style: Xt(J.value ? { "--spdf-h": e.pageHeight || "100%" } : void 0),
      "data-state": P.value,
      "data-layout": J.value ? "page" : "inline"
    }, [
      l.value ? D("", !0) : (f(), h("div", WB, [
        c.value ? (f(), h("div", {
          key: 0,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.pending")
        }, [
          (f(!0), h(Ce, null, nt(_e.value, (He) => (f(), h("button", {
            key: He.id,
            type: "button",
            class: Ne(["fe-btn fe-btn--sm", { "fe-btn--primary": Ie.value === He.id }]),
            style: Xt({ "--spdf-color": A(He) }),
            disabled: e.disabled || P.value !== "ok",
            "aria-pressed": Ie.value === He.id ? "true" : "false",
            "data-testid": `surface-pdf-pending-${He.id}`,
            onClick: (Ve) => pe(He.id)
          }, y(ge(He)), 15, GB))), 128)),
          _e.value.length ? D("", !0) : (f(), h("span", XB, y(u(i)("plugin.pdf.all_placed")), 1))
        ], 8, YB)) : r.value ? (f(), h("div", {
          key: 1,
          class: "fe-spdf__palette",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.palette")
        }, [
          (f(!0), h(Ce, null, nt(m.value, (He) => (f(), h("button", {
            key: He,
            type: "button",
            class: Ne(["fe-btn fe-btn--sm", { "fe-btn--primary": ze.value === He }]),
            disabled: e.disabled || P.value !== "ok",
            "aria-pressed": ze.value === He ? "true" : "false",
            "data-testid": `surface-pdf-type-${He}`,
            onClick: (Ve) => ut(He)
          }, y(L(He)), 11, ZB))), 128))
        ], 8, JB)) : D("", !0),
        d("div", QB, [
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": u(i)("plugin.pdf.zoom_out"),
            disabled: P.value !== "ok",
            onClick: Be
          }, "−", 8, e6),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-spdf__zoomval",
            "aria-label": u(i)(J.value ? "plugin.pdf.zoom_fit_page" : "plugin.pdf.zoom_fit"),
            disabled: P.value !== "ok",
            onClick: qe
          }, y(Math.round($.value * 100)) + "% ", 9, t6),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "aria-label": u(i)("plugin.pdf.zoom_in"),
            disabled: P.value !== "ok",
            onClick: Oe
          }, "+", 8, n6)
        ])
      ])),
      r.value && !l.value && !c.value && ze.value ? (f(), h("p", a6, y(u(i)("plugin.pdf.place_hint", { type: L(ze.value) })), 1)) : D("", !0),
      l.value ? (f(), h("div", i6, [
        v.value.length ? D("", !0) : (f(), h("div", o6, y(u(i)("plugin.pdf.no_boxes")), 1)),
        (f(!0), h(Ce, null, nt(v.value, (He, Ve) => (f(), h("div", {
          key: He.id,
          class: "fe-spdf__card",
          style: Xt(T(He)),
          "data-testid": `surface-pdf-card-${He.id}`
        }, [
          d("span", s6, y(Ve + 1), 1),
          Je(s1, {
            field: He,
            signers: p.value,
            formats: e.formats,
            "date-labels": e.dateLabels,
            "stamp-lines": e.stampLines,
            locale: e.locale,
            disabled: e.disabled,
            "testid-prefix": `surface-pdf-card-${He.id}`,
            onPatch: _t,
            onRemove: (bt) => At(He.id)
          }, null, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled", "testid-prefix", "onRemove"])
        ], 12, r6))), 128)),
        d("div", {
          class: "fe-spdf__add",
          role: "toolbar",
          "aria-label": u(i)("plugin.pdf.add_box")
        }, [
          d("span", u6, y(u(i)("plugin.pdf.add_box")), 1),
          (f(!0), h(Ce, null, nt(m.value, (He) => (f(), h("button", {
            key: He,
            type: "button",
            class: "fe-btn fe-btn--sm",
            disabled: e.disabled,
            "data-testid": `surface-pdf-add-${He}`,
            onClick: (Ve) => wt(He)
          }, " + " + y(L(He)), 9, c6))), 128))
        ], 8, l6)
      ])) : c.value ? (f(), h("div", d6, [
        Ut.value ? (f(), h("div", f6, [
          d("span", {
            class: "fe-spdf__propname",
            style: Xt({ "--spdf-color": A(Ut.value) })
          }, y(U(Ut.value)), 5),
          R(Ut.value.assignee) ? (f(), h("span", p6, y(R(Ut.value.assignee)), 1)) : D("", !0),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            "data-testid": "surface-pdf-unplace",
            onClick: ee
          }, y(u(i)("plugin.pdf.unplace")), 1),
          H.value.length > 1 ? (f(), h("label", h6, [
            d("span", null, y(u(i)("plugin.pdf.copy_to_page")), 1),
            cn(d("input", {
              "onUpdate:modelValue": De[0] || (De[0] = (He) => pn.value = He),
              class: "fe-cfield__input fe-spdf__num",
              type: "number",
              min: "1",
              max: H.value.length,
              "data-testid": "surface-pdf-copy-page"
            }, null, 8, m6), [
              [
                xn,
                pn.value,
                void 0,
                { number: !0 }
              ]
            ]),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--sm",
              "data-testid": "surface-pdf-copy",
              onClick: Rt
            }, y(u(i)("plugin.pdf.copy")), 1)
          ])) : D("", !0),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm fe-btn--danger",
            "data-testid": "surface-pdf-delete",
            onClick: De[1] || (De[1] = (He) => At(Ut.value.id))
          }, y(u(i)("plugin.pdf.delete")), 1)
        ])) : Ie.value ? (f(), h("p", v6, y(u(i)("plugin.pdf.place_box_hint", { name: ge(v.value.find((He) => He.id === Ie.value) ?? v.value[0]) })), 1)) : (f(), h("p", y6, y(u(i)(_e.value.length ? "plugin.pdf.place_idle" : "plugin.pdf.place_idle_done")), 1))
      ])) : r.value && Ut.value && !xt.value ? (f(), h("div", g6, [
        Je(s1, {
          field: Ut.value,
          signers: p.value,
          formats: e.formats,
          "date-labels": e.dateLabels,
          "stamp-lines": e.stampLines,
          locale: e.locale,
          disabled: e.disabled,
          "testid-prefix": "surface-pdf",
          onPatch: _t,
          onRemove: De[3] || (De[3] = (He) => At(Ut.value.id))
        }, {
          extra: mt(() => [
            H.value.length > 1 ? (f(), h("label", b6, [
              d("span", null, y(u(i)("plugin.pdf.copy_to_page")), 1),
              cn(d("input", {
                "onUpdate:modelValue": De[2] || (De[2] = (He) => pn.value = He),
                class: "fe-cfield__input fe-spdf__num",
                type: "number",
                min: "1",
                max: H.value.length,
                "data-testid": "surface-pdf-copy-page"
              }, null, 8, k6), [
                [
                  xn,
                  pn.value,
                  void 0,
                  { number: !0 }
                ]
              ]),
              d("button", {
                type: "button",
                class: "fe-btn fe-btn--sm",
                "data-testid": "surface-pdf-copy",
                onClick: Rt
              }, y(u(i)("plugin.pdf.copy")), 1)
            ])) : D("", !0)
          ]),
          _: 1
        }, 8, ["field", "signers", "formats", "date-labels", "stamp-lines", "locale", "disabled"])
      ])) : D("", !0),
      l.value ? D("", !0) : (f(), h("div", {
        key: 5,
        ref_key: "containerEl",
        ref: F,
        class: "fe-spdf__scroll"
      }, [
        P.value === "loading" ? (f(), h("p", w6, y(u(i)("plugin.view.loading")), 1)) : P.value === "error" ? (f(), h("p", _6, y(u(i)("plugin.pdf.load_failed")), 1)) : (f(), h("div", x6, [
          (f(!0), h(Ce, null, nt(H.value, (He) => (f(), h("div", {
            key: He.num,
            ref_for: !0,
            ref: (Ve) => B(He.num, Ve),
            class: "fe-spdf__page",
            "data-page": He.num,
            style: Xt({ width: `${te.value}px`, aspectRatio: `${He.width} / ${He.height}` }),
            onPointerdown: (Ve) => ae(Ve, He.num)
          }, [
            (f(!0), h(Ce, null, nt(C.value.get(He.num) ?? [], (Ve) => (f(), h("div", {
              key: Ve.id,
              class: Ne(["fe-spdf__field", [
                `fe-spdf__field--${Ve.type}`,
                {
                  "is-selected": r.value && ft.value === Ve.id,
                  "is-mine": M(Ve),
                  "is-foreign": !r.value && !M(Ve),
                  "is-filled": u(Jv)(Ve),
                  "is-required": Ve.required === !0
                }
              ]]),
              style: Xt({ left: `${Ve.x * 100}%`, top: `${Ve.y * 100}%`, width: `${Ve.w * 100}%`, height: `${Ve.h * 100}%`, "--spdf-color": A(Ve) }),
              "data-testid": `surface-pdf-field-${Ve.id}`,
              "data-field-type": Ve.type,
              role: M(Ve) ? "button" : void 0,
              tabindex: M(Ve) ? 0 : void 0,
              title: r.value || !M(Ve) ? R(Ve.assignee) : void 0,
              onPointerdown: (bt) => xe(bt, Ve, He.num),
              onClick: (bt) => wn(Ve),
              onKeydown: za(vt((bt) => wn(Ve), ["prevent"]), ["enter"])
            }, [
              (Ve.type === "signature" || Ve.type === "initials") && mn(Ve) ? (f(), h("img", {
                key: 0,
                class: "fe-spdf__sig",
                src: mn(Ve),
                alt: ""
              }, null, 8, T6)) : Ve.type === "text" && M(Ve) ? (f(), h("input", {
                key: 1,
                class: Ne(["fe-spdf__text", Fn(Ve)]),
                type: "text",
                value: typeof Ve.value == "string" ? Ve.value : "",
                placeholder: U(Ve),
                "aria-label": U(Ve),
                inputmode: u(L5)(sn(Ve)),
                maxlength: u(PS)(sn(Ve)),
                "aria-invalid": Rn(Ve) ? "true" : void 0,
                "aria-describedby": $n(Ve) ? `${e.id}-${Ve.id}-rule` : void 0,
                title: $n(Ve) || void 0,
                disabled: e.disabled,
                "data-testid": `surface-pdf-text-${Ve.id}`,
                onPointerdown: De[4] || (De[4] = vt(() => {
                }, ["stop"])),
                onClick: De[5] || (De[5] = vt(() => {
                }, ["stop"])),
                onInput: (bt) => ra(Ve, bt)
              }, null, 42, A6)) : Ve.type === "checkbox" && Ve.value === !0 ? (f(), h("span", {
                key: 2,
                class: "fe-spdf__check",
                "aria-hidden": "true",
                innerHTML: u(Tn)
              }, null, 8, E6)) : Ve.type === "date" && typeof Ve.value == "string" && Ve.value ? (f(), h("span", {
                key: 3,
                class: Ne(["fe-spdf__val", Fn(Ve)])
              }, y(Ve.value), 3)) : (f(), h("span", C6, [
                Vt(y(U(Ve)) + " ", 1),
                M(Ve) ? (f(), h("small", z6, y(u(i)(`plugin.pdf.tap_${Ve.type}`)), 1)) : Ve.assignee && (r.value || !M(Ve)) ? (f(), h("small", M6, y(R(Ve.assignee)), 1)) : D("", !0)
              ])),
              !r.value && M(Ve) && Ve.type === "text" && (Rn(Ve) || $n(Ve)) ? (f(), h("span", {
                key: 5,
                id: `${e.id}-${Ve.id}-rule`,
                class: Ne(["fe-spdf__rule", { "is-bad": !!Rn(Ve) }]),
                role: Rn(Ve) ? "alert" : void 0,
                "data-testid": `surface-pdf-rule-${Ve.id}`
              }, y(Rn(Ve) || $n(Ve)), 11, O6)) : D("", !0),
              r.value ? (f(), h("span", {
                key: 6,
                class: "fe-spdf__handle",
                "data-testid": "surface-pdf-handle",
                onPointerdown: (bt) => Fe(bt, Ve, He.num)
              }, null, 40, P6)) : D("", !0)
            ], 46, $6))), 128)),
            Se.value && Se.value.page === He.num ? (f(), h("div", {
              key: 0,
              class: "fe-spdf__field fe-spdf__field--ghost",
              style: Xt({ left: `${Se.value.x * 100}%`, top: `${Se.value.y * 100}%`, width: `${Se.value.w * 100}%`, height: `${Se.value.h * 100}%` })
            }, null, 4)) : D("", !0)
          ], 44, S6))), 128))
        ]))
      ], 512)),
      !r.value && dn.value ? (f(), h("div", D6, [
        d("p", L6, y(u(i)("plugin.pdf.pad_for", { type: U(dn.value) })), 1),
        Je(JS, {
          id: `${e.id}-${dn.value.id}`,
          "model-value": Bn.value,
          modes: jn.value,
          font: dn.value.font,
          fonts: zn.value,
          locale: e.locale,
          disabled: e.disabled,
          width: dn.value.type === "initials" ? 240 : void 0,
          height: dn.value.type === "initials" ? 120 : void 0,
          "onUpdate:modelValue": Sn
        }, null, 8, ["id", "model-value", "modes", "font", "fonts", "locale", "disabled", "width", "height"]),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--sm",
          "data-testid": "surface-pdf-pad-done",
          onClick: De[6] || (De[6] = (He) => nn.value = "")
        }, y(u(i)("plugin.pdf.pad_done")), 1)
      ])) : D("", !0)
    ], 14, qB));
  }
}), N6 = { class: "fe-surface" }, I6 = ["data-node"], B6 = {
  key: 1,
  class: "fe-surface__divider"
}, F6 = {
  key: 2,
  class: "fe-surface__row"
}, U6 = ["data-node-type"], H6 = {
  key: 14,
  class: "fe-surface__error"
}, K6 = /* @__PURE__ */ rt({
  __name: "SurfaceRenderer",
  props: {
    nodes: {},
    locale: {},
    theme: {},
    errors: {},
    values: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    disabled: { type: Boolean },
    fileUrl: { type: Function },
    pdfWorkerUrl: {},
    invalidKeys: {},
    layout: {},
    pageHeight: {}
  },
  emits: ["update:values", "change", "action"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = () => n.values ?? {};
    function l(b, C) {
      a("update:values", { ...r(), [b]: C });
    }
    function c(b) {
      a("update:values", b), a("change");
    }
    function p(b, C) {
      l(b.id, C), m(b).mode !== "fill" && a("change");
    }
    function m(b) {
      return b.props ?? {};
    }
    function v(b) {
      const C = m(b);
      return Zt(C.text ?? C.value ?? "", n.locale);
    }
    function x(b) {
      const C = String(m(b).tone ?? "");
      return C === "muted" || C === "danger" || C === "info" ? `fe-surface__text--${C}` : "";
    }
    function k(b) {
      return !b.id || !n.errors ? "" : Zt(n.errors[b.id], n.locale);
    }
    function _(b) {
      return typeof b == "string" ? b : "";
    }
    function w(b) {
      return Array.isArray(b) ? b : [];
    }
    return (b, C) => {
      const A = fM("SurfaceRenderer", !0);
      return f(), h("div", N6, [
        (f(!0), h(Ce, null, nt(e.nodes, (T, R) => (f(), h(Ce, {
          key: T.id || R
        }, [
          T.type === "text" ? (f(), h("p", {
            key: 0,
            class: Ne(["fe-surface__text", [x(T), m(T).heading ? "fe-surface__text--heading" : ""]]),
            "data-node": T.id || void 0
          }, y(v(T)), 11, I6)) : T.type === "divider" ? (f(), h("hr", B6)) : T.type === "row" ? (f(), h("div", F6, [
            Je(A, {
              nodes: T.children ?? [],
              locale: e.locale,
              theme: e.theme,
              errors: e.errors,
              values: e.values,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt,
              disabled: e.disabled,
              "file-url": e.fileUrl,
              "pdf-worker-url": e.pdfWorkerUrl,
              "invalid-keys": e.invalidKeys,
              layout: e.layout,
              "page-height": e.pageHeight,
              "onUpdate:values": C[0] || (C[0] = (M) => a("update:values", M)),
              onChange: C[1] || (C[1] = (M) => a("change")),
              onAction: C[2] || (C[2] = (M) => a("action", M))
            }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "disabled", "file-url", "pdf-worker-url", "invalid-keys", "layout", "page-height"])
          ])) : T.type === "form" ? (f(), We(eN, {
            key: 3,
            fields: m(T).fields ?? [],
            values: r(),
            locale: e.locale,
            errors: e.errors,
            invalid: e.invalidKeys,
            disabled: e.disabled,
            "onUpdate:values": c
          }, null, 8, ["fields", "values", "locale", "errors", "invalid", "disabled"])) : T.type === "steps" ? (f(), We(rN, {
            key: 4,
            items: m(T).items ?? [],
            locale: e.locale
          }, null, 8, ["items", "locale"])) : T.type === "list" ? (f(), We(hI, {
            key: 5,
            columns: m(T).columns ?? [],
            rows: m(T).rows ?? [],
            empty: m(T).empty,
            locale: e.locale,
            disabled: e.disabled,
            "table-id": e.plugin ? `app.${e.plugin}.${T.id || "list"}` : void 0,
            onAction: C[3] || (C[3] = (M) => a("action", M))
          }, null, 8, ["columns", "rows", "empty", "locale", "disabled", "table-id"])) : T.type === "progress" ? (f(), We(kI, {
            key: 6,
            value: m(T).value,
            label: m(T).label,
            locale: e.locale
          }, null, 8, ["value", "label", "locale"])) : T.type === "people-picker" && T.id ? (f(), We(FI, {
            key: 7,
            id: T.id,
            "model-value": w(r()[T.id]),
            multi: m(T).multi === !0,
            "allow-external": m(T).allow_external === !0,
            api: e.api,
            plugin: e.plugin,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!k(T),
            "onUpdate:modelValue": (M) => l(T.id, M)
          }, null, 8, ["id", "model-value", "multi", "allow-external", "api", "plugin", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : T.type === "pin-input" && T.id ? (f(), We(VI, {
            key: 8,
            id: T.id,
            length: m(T).length,
            "model-value": _(r()[T.id]),
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!k(T),
            "onUpdate:modelValue": (M) => l(T.id, M)
          }, null, 8, ["id", "length", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : T.type === "file-chooser" && T.id ? (f(), We(C8, {
            key: 9,
            id: T.id,
            kind: m(T).kind,
            "model-value": _(r()[T.id]),
            api: e.api,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!k(T),
            "onUpdate:modelValue": (M) => l(T.id, M)
          }, null, 8, ["id", "kind", "model-value", "api", "storages", "start-at", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : T.type === "preview" ? (f(), We(B8, {
            key: 10,
            path: _(m(T).path),
            "file-ref": _(m(T).ref),
            "file-url": e.fileUrl,
            api: e.api,
            locale: e.locale
          }, null, 8, ["path", "file-ref", "file-url", "api", "locale"])) : T.type === "signature-pad" && T.id ? (f(), We(JS, {
            key: 11,
            id: T.id,
            modes: m(T).modes,
            width: m(T).width,
            height: m(T).height,
            font: m(T).font,
            fonts: m(T).fonts,
            label: u(Zt)(m(T).label ?? "", e.locale),
            required: m(T).required === !0,
            "model-value": u(Nu)(r()[T.id]) ? r()[T.id] : null,
            locale: e.locale,
            disabled: e.disabled,
            invalid: !!k(T),
            "onUpdate:modelValue": (M) => l(T.id, M)
          }, null, 8, ["id", "modes", "width", "height", "font", "fonts", "label", "required", "model-value", "locale", "disabled", "invalid", "onUpdate:modelValue"])) : T.type === "pdf-fields" && T.id ? (f(), We(R6, {
            key: 12,
            id: T.id,
            src: m(T).src,
            mode: m(T).mode,
            fields: m(T).fields,
            layout: e.layout,
            "page-height": e.pageHeight,
            signers: m(T).signers,
            signer: m(T).signer,
            types: m(T).types,
            formats: m(T).formats,
            "date-labels": m(T).date_labels,
            "stamp-lines": m(T).stamp_lines,
            "model-value": r()[T.id],
            api: e.api,
            "file-url": e.fileUrl,
            "pdf-worker-url": e.pdfWorkerUrl,
            locale: e.locale,
            theme: e.theme,
            disabled: e.disabled,
            invalid: !!k(T),
            "onUpdate:modelValue": (M) => p(T, M)
          }, null, 8, ["id", "src", "mode", "fields", "layout", "page-height", "signers", "signer", "types", "formats", "date-labels", "stamp-lines", "model-value", "api", "file-url", "pdf-worker-url", "locale", "theme", "disabled", "invalid", "onUpdate:modelValue"])) : (f(), h("p", {
            key: 13,
            class: "fe-surface__unknown",
            "data-node-type": T.type
          }, y(u(i)("plugin.view.unsupported", { type: T.type })), 9, U6)),
          k(T) && T.type !== "form" ? (f(), h("p", H6, y(k(T)), 1)) : D("", !0)
        ], 64))), 128))
      ]);
    };
  }
}), V6 = {
  key: 1,
  class: "fe-surface__text fe-surface__text--info",
  role: "status"
}, j6 = {
  key: 2,
  class: "fe-surface__text fe-surface__text--muted"
}, q6 = {
  key: 3,
  class: "fe-surface__error",
  role: "alert"
}, Ip = /* @__PURE__ */ rt({
  __name: "SurfaceConversation",
  props: {
    conv: {},
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    storages: {},
    startAt: {},
    fileUrl: { type: Function },
    toast: {},
    layout: {},
    pageHeight: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale);
    return (a, i) => (f(), h(Ce, null, [
      e.conv.current.value ? (f(), We(K6, {
        key: 0,
        nodes: e.conv.current.value.nodes ?? [],
        locale: e.locale,
        theme: e.theme,
        errors: e.conv.errors.value,
        values: e.conv.values.value,
        api: e.api,
        plugin: e.plugin,
        storages: e.storages,
        "start-at": e.startAt,
        "file-url": e.fileUrl,
        layout: e.layout,
        "page-height": e.pageHeight,
        "invalid-keys": e.conv.invalidKeys.value,
        disabled: e.conv.busy.value,
        "onUpdate:values": e.conv.updateValues,
        onChange: e.conv.scheduleChange,
        onAction: e.conv.rowAction
      }, null, 8, ["nodes", "locale", "theme", "errors", "values", "api", "plugin", "storages", "start-at", "file-url", "layout", "page-height", "invalid-keys", "disabled", "onUpdate:values", "onChange", "onAction"])) : D("", !0),
      e.toast ? (f(), h("p", V6, y(e.toast), 1)) : D("", !0),
      e.conv.busy.value ? (f(), h("p", j6, y(u(n)("plugin.view.busy")), 1)) : D("", !0),
      e.conv.failure.value ? (f(), h("p", q6, y(e.conv.failure.value), 1)) : D("", !0)
    ], 64));
  }
});
function W6(e) {
  let t = !1;
  return Uc(e, (n) => {
    n.type === "steps" && (t = !0);
  }), t;
}
const Y6 = /* @__PURE__ */ new Set(["back", "prev", "previous", "stepback", "goback", "prevstep", "previousstep"]);
function G6(e) {
  const t = String((e == null ? void 0 : e.id) ?? "").toLowerCase().replace(/[^a-z]/g, "");
  return Y6.has(t);
}
function X6(e, t) {
  const n = (e ?? []).filter((l) => l && l.id);
  if (!t)
    return { back: null, others: n, primary: null };
  const a = n.find(G6) ?? null, i = n.filter((l) => l !== a), r = i.find((l) => l.primary === !0) ?? null;
  return { back: a, others: i.filter((l) => l !== r), primary: r };
}
const J6 = ["disabled", "data-testid", "onClick"], Bp = /* @__PURE__ */ rt({
  __name: "SurfaceFooterButtons",
  props: {
    conv: {},
    locale: {},
    testidPrefix: {},
    small: { type: Boolean }
  },
  setup(e) {
    const t = e, n = E(() => {
      var l;
      return W6((l = t.conv.current.value) == null ? void 0 : l.nodes);
    }), a = E(() => X6(t.conv.footer.value, n.value)), i = E(() => {
      const l = a.value;
      return [...l.back ? [l.back] : [], ...l.others, ...l.primary ? [l.primary] : []];
    });
    function r(l) {
      return n.value ? l === a.value.primary : l.primary === !0;
    }
    return (l, c) => (f(!0), h(Ce, null, nt(i.value, (p) => (f(), h("button", {
      key: p.id,
      type: "button",
      class: Ne(["fe-btn", {
        "fe-btn--sm": e.small,
        "fe-btn--primary": r(p) && !p.danger,
        "fe-btn--danger": p.danger,
        "fe-surface__back": n.value && p === a.value.back
      }]),
      disabled: t.conv.busy.value || p.disabled,
      "data-testid": `${e.testidPrefix}-action-${p.id}`,
      onClick: (m) => t.conv.press(p)
    }, y(u(Zt)(p.label, e.locale)), 11, J6))), 128));
  }
}), t$ = 1, Z6 = "filex:hello", Q6 = "filex:port", eF = [
  "session.get",
  "file.read",
  "file.save",
  "file.saveAs",
  "ui.dirty",
  "ui.title",
  "ui.toast",
  "ui.confirm",
  "ui.close",
  "clipboard.write",
  "ui.download",
  "engine.call",
  "job.submit",
  "state.get",
  "state.set",
  "license.get",
  "ui.print",
  "coedit.join",
  "coedit.subscribe",
  "coedit.append",
  "coedit.lease",
  "coedit.cursor",
  "coedit.blob.put",
  "coedit.blob.get",
  "coedit.leave"
], ga = {
  /** `file.read({as: 'text'})` refuses a file larger than this; read a stream. */
  maxTextBytes: 32 << 20,
  /** One `state.set` value, as JSON. */
  maxStateBytes: 8192,
  /** A `ui.toast` / `ui.title` text, in characters. */
  maxLineChars: 300,
  /** How long the SDK waits for the host's port. */
  connectTimeoutMs: 1e4,
  /** The largest file `ui.download` hands the person (streamed or not). */
  maxDownloadBytes: 256 << 20,
  /**
   * The largest PDF `ui.print` prints (filex 0.55). Lower than a download:
   * a download can stream to disk, a print is held whole in the page (one
   * Blob) until the print dialog has read it, and a document worth printing
   * is far smaller.
   */
  maxPrintBytes: 64 << 20,
  /**
   * The largest file of an encrypted folder filex hands an app in the clear
   * or takes back from it (filex 0.56, `FileInfo.plaintext`): it is
   * decrypted and encrypted whole in the page, as filex's own explorer does
   * for a file of this size.
   */
  maxEncryptedBytes: 200 << 20
};
function tF(e) {
  return !!e && typeof e == "object" && e.type === Z6 && typeof e.v == "number";
}
function nF(e) {
  return !!e && typeof e == "object" && typeof e.id == "number" && typeof e.method == "string";
}
function aF(e) {
  return eF.includes(e);
}
const Hm = { inFlight: 32, perWindow: 400, windowMs: 1e4 };
class lt extends Error {
  constructor(n, a) {
    super(a || n);
    Bt(this, "code");
    this.name = "BridgeFailure", this.code = n;
  }
}
function iF(e) {
  if (!e || typeof e != "object") return [];
  const t = [];
  for (const n of Object.values(e))
    (n instanceof ArrayBuffer || typeof ReadableStream < "u" && n instanceof ReadableStream) && t.push(n);
  return t;
}
const oF = /^[a-z][a-z0-9_]{0,39}$/;
function rF(e) {
  if (e instanceof lt) return { code: e.code, message: e.message };
  const t = e ?? {}, n = typeof t.status == "number" ? t.status : 0, a = typeof t.code == "string" && oF.test(t.code) ? t.code : "";
  let i = "failed";
  return n === 404 ? i = "not_found" : n === 413 ? i = "too_large" : n === 400 || n === 422 ? i = "invalid" : n === 409 && a === "read_only" ? i = "read_only" : n === 403 && a === "not_granted" && (i = "not_granted"), { code: i, message: a || i };
}
function sF(e) {
  const t = e.win ?? window;
  let n = null, a = !1, i = 0, r = !1, l = 0;
  const c = /* @__PURE__ */ new Map();
  function p(C) {
    var A;
    if (n) {
      n.onmessage = null;
      try {
        n.close();
      } catch {
      }
      n = null;
      for (const [, T] of c)
        clearTimeout(T.timer), T.reject(new lt("unavailable", "the interface went away"));
      c.clear(), (A = e.onDisconnect) == null || A.call(e, C);
    }
  }
  let m = 0, v = 0, x = 0;
  function k() {
    const C = Date.now();
    return C - v >= Hm.windowMs && (v = C, x = 0), x >= Hm.perWindow ? !1 : (x++, !0);
  }
  async function _(C, A, T, R) {
    let M, L = [];
    if (!k())
      M = { id: A, error: { code: "unavailable", message: "busy" } };
    else if (!aF(T))
      M = { id: A, error: { code: "unknown_method", message: T } };
    else {
      const U = e.handlers[T];
      if (!U)
        M = { id: A, error: { code: "unavailable", message: `${T} is not offered here` } };
      else if (m >= Hm.inFlight)
        M = { id: A, error: { code: "unavailable", message: "busy" } };
      else {
        m++;
        try {
          const P = await U(R);
          M = { id: A, result: P }, L = iF(P);
        } catch (P) {
          M = { id: A, error: rF(P) };
        } finally {
          m--;
        }
      }
    }
    if (C === n)
      try {
        C.postMessage(M, L);
      } catch {
        C.postMessage({ id: A, error: { code: "failed", message: "the answer cannot be sent to the interface" } });
      }
  }
  function w(C) {
    return (A) => {
      const T = A.data;
      if (!(!T || typeof T != "object")) {
        if (typeof T.hid == "number") {
          const R = c.get(T.hid);
          if (!R) return;
          if (c.delete(T.hid), clearTimeout(R.timer), T.error) {
            const M = T.error;
            R.reject(new lt(M.code ?? "failed", M.message));
          } else R.resolve(T.result);
          return;
        }
        nF(T) && _(C, T.id, T.method, T.params);
      }
    };
  }
  function b(C) {
    var M, L;
    if (r || a) return;
    const A = e.frame(), T = A == null ? void 0 : A.contentWindow;
    if (!A || !T || C.source !== T || !tF(C.data) || i > 1) return;
    a = !0;
    const R = new MessageChannel();
    n = R.port1, n.onmessage = w(n), (M = n.start) == null || M.call(n), T.postMessage({ type: Q6, v: t$ }, "*", [R.port2]), (L = e.onConnect) == null || L.call(e);
  }
  return t.addEventListener("message", b), {
    connected: () => n !== null,
    emit(C, A, T = []) {
      if (n)
        try {
          n.postMessage({ event: C, data: A }, T);
        } catch {
        }
    },
    ask(C, A, T = 6e4) {
      const R = n;
      if (!R) return Promise.reject(new lt("unavailable", "the interface is not connected"));
      const M = ++l;
      return new Promise((L, U) => {
        const P = setTimeout(() => {
          c.delete(M), U(new lt("failed", `the interface did not answer "${C}"`));
        }, T);
        c.set(M, { resolve: L, reject: U, timer: P }), R.postMessage({ hid: M, request: C, params: A });
      });
    },
    frameLoaded() {
      i++, i > 1 && p("reload");
    },
    destroy() {
      r = !0, t.removeEventListener("message", b), p("destroyed");
    }
  };
}
const lF = [
  "theme",
  "palette",
  "density",
  "locale",
  "storageOrder",
  "tour",
  "appState",
  "appStateE2e",
  "appsSeen",
  "openWith",
  "remoteImages"
], uF = ["openWith"], ip = ["theme", "palette", "density", "locale", "storageOrder"], hc = {
  theme: "filex.theme",
  palette: "filex.palette",
  density: "filex.density",
  locale: "filex.locale",
  // New in 0.45.2 (#57); no earlier reader to stay compatible with.
  storageOrder: "filex.storageOrder"
}, n$ = 400, ty = "filex.session";
let Fp = !1;
function cF() {
  try {
    return localStorage.getItem(ty) === "1";
  } catch {
    return !1;
  }
}
function Qo() {
  return Fp ? !1 : ai.sessionAware ? cF() : !0;
}
function dF(e) {
  try {
    e ? localStorage.setItem(ty, "1") : localStorage.removeItem(ty);
  } catch {
  }
  e && (Fp = !1);
}
function wpe() {
  Fp = !0;
}
const a$ = new Set(Object.values(hc));
function fF(e) {
  a$.add(e);
}
const i$ = /* @__PURE__ */ new Set();
function pF(e) {
  i$.add(e);
}
function _pe() {
  dF(!1);
  for (const e of a$)
    try {
      localStorage.removeItem(e);
    } catch {
    }
  for (const e of i$)
    try {
      e();
    } catch {
    }
  Qa = {}, Up = !1, jr = {}, oa !== null && clearTimeout(oa), oa = null, $f();
}
let ai = { surface: "web" }, Qa = {}, Up = !1, Pl = !1, Hc = !1;
const op = /* @__PURE__ */ new Set(), mc = /* @__PURE__ */ new Set();
function hF(e) {
  ai = { ...e }, Pl = !0;
}
function Kc() {
  return Pl;
}
function mF() {
  return Hc;
}
function vF(e) {
  return Hc ? (e(), () => {
  }) : (mc.add(e), () => mc.delete(e));
}
function $f() {
  Hc = !0;
  const e = [...mc];
  mc.clear();
  for (const t of e)
    try {
      t();
    } catch {
    }
}
function Qi() {
  return { ...Qa };
}
function o$() {
  return Up;
}
function Vc(e) {
  return op.add(e), () => op.delete(e);
}
function r$() {
  const e = Qi();
  for (const t of op)
    try {
      t(e);
    } catch {
    }
}
function rp(e) {
  try {
    return localStorage.getItem(hc[e]) ?? "";
  } catch {
    return "";
  }
}
function Vr(e, t) {
  try {
    t ? localStorage.setItem(hc[e], t) : localStorage.removeItem(hc[e]);
  } catch {
  }
}
function yF() {
  const e = {};
  for (const t of ip) {
    const n = rp(t);
    n && (e[t] = n);
  }
  return e;
}
function s$() {
  return `${El(ai.base)}/api/me/prefs?surface=${encodeURIComponent(ai.surface)}`;
}
async function wg(e) {
  const t = { Accept: "application/json" };
  e && (t["Content-Type"] = "application/json");
  const n = ai.headers ? await ai.headers() : {};
  return { ...t, ...n };
}
function gF(e) {
  const t = { Accept: "application/json" };
  t["Content-Type"] = "application/json";
  const n = ai.headers ? ai.headers() : {};
  return n && typeof n.then != "function" ? { ...t, ...n } : t;
}
function bF(e) {
  const t = e && typeof e == "object" ? e : {}, n = t.prefs && typeof t.prefs == "object" ? t.prefs : t, a = {};
  for (const i of lF) {
    const r = n[i];
    typeof r == "string" && r && (a[i] = r);
  }
  return a;
}
async function kF() {
  if (!Pl)
    return $f(), null;
  const e = ai.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!e)
    return $f(), null;
  Hc = !1;
  try {
    const t = await e(s$(), {
      method: "GET",
      headers: await wg(!1),
      credentials: "same-origin",
      cache: "no-store"
    });
    if (!t.ok) return null;
    if (Qa = bF(await t.json()), Up = !0, !Object.keys(Qa).length) {
      const n = yF();
      if (delete n.locale, Object.keys(n).length) {
        Qa = n;
        for (const a of ip) n[a] && (jr[a] = n[a]);
        oa !== null && clearTimeout(oa), oa = setTimeout(() => {
          $l = Hp();
        }, n$);
      }
    }
    for (const n of ip)
      n === "locale" && !Qa[n] || Vr(n, Qa[n] ?? "");
    return r$(), Qi();
  } catch {
    return null;
  } finally {
    $f();
  }
}
let jr = {}, oa = null, $l = null;
async function Hp(e = !1) {
  oa = null;
  const t = jr;
  if (jr = {}, !Object.keys(t).length || !Pl) return;
  const n = Qi();
  for (const l of uF) delete n[l];
  const a = { prefs: n }, i = ai.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!i) return;
  const r = JSON.stringify(a);
  try {
    await i(s$(), {
      method: "PUT",
      headers: e ? gF(!0) : await wg(!0),
      credentials: "same-origin",
      body: r,
      // ⚠ Sent while the page is going away: `keepalive` is what lets the
      // request outlive it. Browsers reject a keepalive body over 64 KB
      // outright, so the flag goes only on documents that fit.
      ...e && r.length < 6e4 ? { keepalive: !0 } : {}
    });
  } catch {
  }
}
function Zi(e, t) {
  Qa = { ...Qa, [e]: t }, ip.includes(e) && Vr(e, t), jr = { ...jr, [e]: t }, oa !== null && clearTimeout(oa), oa = setTimeout(() => {
    $l = Hp();
  }, n$);
}
function _g(e, t) {
  Qa = { ...Qa, [e]: t }, r$();
}
async function l$(e, t) {
  if (!Pl) return null;
  const n = ai.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
  if (!n) return null;
  try {
    return await n(`${El(ai.base)}${e}`, {
      method: t.method,
      headers: await wg(t.body !== void 0),
      credentials: "same-origin",
      body: t.body
    });
  } catch {
    return null;
  }
}
async function wF() {
  oa !== null && (clearTimeout(oa), $l = Hp()), await $l;
}
function l1() {
  oa !== null && (clearTimeout(oa), $l = Hp(!0));
}
typeof window < "u" && (window.addEventListener("pagehide", l1), document.addEventListener("visibilitychange", () => {
  document.visibilityState === "hidden" && l1();
}));
function xpe() {
  Qa = {}, Up = !1, Fp = !1, jr = {}, oa !== null && clearTimeout(oa), oa = null, $l = null, op.clear(), Hc = !1, mc.clear(), Pl = !1;
}
function u$() {
  return xc("app_state_max_bytes");
}
const _F = new TextEncoder();
function c$(e) {
  return _F.encode(e).length;
}
function Kp(e) {
  const t = Qi()[e];
  if (!t) return {};
  try {
    const n = JSON.parse(t);
    return n && typeof n == "object" && !Array.isArray(n) ? n : {};
  } catch {
    return {};
  }
}
function xF(e, t) {
  const n = Kp("appState")[e];
  return n && Object.prototype.hasOwnProperty.call(n, t) ? n[t] : void 0;
}
class vc extends Error {
}
function d$(e, t) {
  if (!e || e.length > 128 || e === "__proto__" || e === "constructor" || e === "prototype")
    throw new vc("a state key is 1-128 characters");
  const n = t === void 0 ? void 0 : JSON.stringify(t);
  if (n !== void 0 && n.length > ga.maxStateBytes)
    throw new vc(`a state value is at most ${ga.maxStateBytes} bytes as JSON`);
  return n;
}
function SF(e, t, n) {
  const a = d$(t, n), i = Kp("appState"), r = { ...i[e] ?? {} };
  a === void 0 ? delete r[t] : r[t] = JSON.parse(a);
  const l = u$();
  if (l !== void 0 && c$(JSON.stringify(r)) > l)
    throw new vc(`an app keeps at most ${l} bytes`);
  const c = { ...i, [e]: r };
  Object.keys(r).length || delete c[e], Zi("appState", JSON.stringify(c));
}
function $F(e) {
  const t = Kp("appsSeen")[e];
  return typeof t == "string" ? t : "";
}
function u1(e, t) {
  const n = Kp("appsSeen");
  n[e] !== t && Zi("appsSeen", JSON.stringify({ ...n, [e]: t }));
}
const TF = 1e4, AF = 1500, EF = 15 * 6e4, CF = 600, zF = 4 << 20, f$ = "application/pdf", qr = [37, 80, 68, 70, 45], MF = [
  "background-color",
  "color",
  "border-top-color",
  "border-right-color",
  "border-bottom-color",
  "border-left-color",
  "border-top-width",
  "border-right-width",
  "border-bottom-width",
  "border-left-width",
  "border-top-style",
  "border-right-style",
  "border-bottom-style",
  "border-left-style",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-bottom-right-radius",
  "border-bottom-left-radius",
  "font-family",
  "font-size",
  "font-weight",
  "line-height",
  "letter-spacing",
  "padding-top",
  "padding-right",
  "padding-bottom",
  "padding-left"
];
function Gu(e) {
  const t = e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : null;
  return !t || t.byteLength < qr.length ? !1 : qr.every((n, a) => t[a] === n);
}
class da extends Error {
  constructor(n, a) {
    super(a || n);
    Bt(this, "code");
    this.name = "PrintFailure", this.code = n;
  }
}
function Km() {
  return new da("invalid", "the data is not a PDF");
}
function OF(e, t) {
  const n = Math.min(qr.length - e.byteLength, t.byteLength);
  if (n <= 0) return e;
  const a = new Uint8Array(e.byteLength + n);
  return a.set(e), a.set(t.subarray(0, n), e.byteLength), a;
}
async function PF(e, t) {
  const n = () => new da("too_large", `at most ${Math.floor(t / 1048576)} MiB`);
  if (e instanceof ArrayBuffer) {
    if (e.byteLength > t) throw n();
    if (!Gu(e)) throw Km();
    return new Blob([e], { type: f$ });
  }
  let a = null, i = [], r = 0, l = 0, c = new Uint8Array(0);
  for await (const p of e) {
    if (!(p instanceof Uint8Array)) throw new da("invalid", "a PDF stream carries bytes (Uint8Array)");
    if (c.byteLength < qr.length && (c = OF(c, p), c.byteLength >= qr.length && !Gu(c)))
      throw Km();
    if (l += p.byteLength, l > t) throw n();
    i.push(p), r += p.byteLength, r >= zF && (a = c1(a, i), i = [], r = 0);
  }
  if (!Gu(c)) throw Km();
  return i.length || !a ? c1(a, i) : a;
}
function c1(e, t) {
  return new Blob(e ? [e, ...t] : t, { type: f$ });
}
function DF(e) {
  var i;
  const t = {}, n = (i = e == null ? void 0 : e.ownerDocument) == null ? void 0 : i.defaultView;
  if (!e || !n || typeof n.getComputedStyle != "function") return t;
  const a = n.getComputedStyle(e);
  for (const r of MF) {
    const l = a.getPropertyValue(r).trim();
    l && (t[r] = l);
  }
  return t;
}
async function LF(e) {
  if (typeof Blob > "u" || !(e instanceof Blob) || e.size < qr.length) return !1;
  try {
    return Gu(await e.slice(0, qr.length).arrayBuffer());
  } catch {
    return !1;
  }
}
const d1 = "position:absolute;width:1px;height:1px;border:0;opacity:0;pointer-events:none;inset-inline-start:-10000px;top:0";
function RF(e, t) {
  return `display:block;width:${e}px;height:${t}px;border:0;background:transparent;color-scheme:normal`;
}
function f1(e, t, n, a) {
  const i = typeof e == "number" && Number.isFinite(e) ? Math.round(e) : a;
  return Math.min(n, Math.max(t, i));
}
async function NF(e, t, n = {}) {
  var c, p;
  const a = n.win ?? window, i = a.document;
  if ((c = n.signal) != null && c.aborted) throw new da("cancelled", "the person said no");
  if (!await LF(t)) throw new da("invalid", "not a PDF");
  let r;
  try {
    r = new URL(e, a.location.href).origin;
  } catch {
    throw new da("unavailable", "no print page");
  }
  if (!r || r === "null") throw new da("unavailable", "no print page");
  if ((p = n.signal) != null && p.aborted) throw new da("cancelled", "the person said no");
  const l = i.createElement("iframe");
  return l.setAttribute("referrerpolicy", "no-referrer"), l.setAttribute("aria-hidden", "true"), l.setAttribute("tabindex", "-1"), l.setAttribute("title", n.label || "print"), l.dataset.testid = "appframe-print", l.style.cssText = d1, l.setAttribute("src", e), new Promise((m, v) => {
    var H;
    let x = !1, k = !1, _ = null, w = null, b = null, C = null, A = null;
    function T() {
      l.style.cssText = d1, l.setAttribute("aria-hidden", "true"), l.setAttribute("tabindex", "-1");
    }
    function R($) {
      var F;
      if (!x) {
        x = !0, a.removeEventListener("message", P), l.removeEventListener("load", L), (F = n.signal) == null || F.removeEventListener("abort", M);
        for (const I of [_, w, b, C]) I && clearTimeout(I);
        A && (A.port1.onmessage = null), $ ? (l.remove(), v($)) : (T(), m(l));
      }
    }
    function M() {
      try {
        A == null || A.port1.postMessage({ type: "cancel" });
      } catch {
      }
      R(new da("cancelled", "the person said no"));
    }
    function L() {
      x || A || w || (w = setTimeout(() => {
        A || R(new da("unavailable", "the print page may not be shown here"));
      }, n.loadGraceMs ?? AF));
    }
    function U($) {
      var I;
      const F = $.data;
      if (!(x || !F || typeof F != "object")) {
        if (F.state === "ask") {
          if (k) return;
          k = !0;
          const Z = f1(F.width, 24, 480, 96), J = f1(F.height, 16, 96, 36);
          l.style.cssText = RF(Z, J), l.removeAttribute("aria-hidden"), l.removeAttribute("tabindex"), (I = n.onAsk) == null || I.call(n, { width: Z, height: J }), C = setTimeout(() => {
            try {
              A == null || A.port1.postMessage({ type: "arm" });
            } catch {
            }
          }, n.armMs ?? CF);
          return;
        }
        F.ok === !0 ? R(null) : R(new da(F.code === "invalid" ? "invalid" : "failed", "the PDF could not be printed"));
      }
    }
    function P($) {
      const F = l.contentWindow;
      if (x || !F || $.source !== F) return;
      const I = $.data;
      if (!I || typeof I != "object" || I.type !== "filex:print-ready" || A || $.origin !== r) return;
      _ && clearTimeout(_), w && clearTimeout(w);
      const Z = new MessageChannel();
      A = Z, Z.port1.onmessage = U, b = setTimeout(() => R(new da("failed", "the print page did not answer")), n.answerMs ?? EF);
      try {
        F.postMessage({ type: "filex:print", pdf: t, label: n.label ?? "", look: n.look ?? {} }, r, [Z.port2]);
      } catch {
        R(new da("failed", "the PDF could not be handed to the print page"));
      }
    }
    a.addEventListener("message", P), l.addEventListener("load", L), (H = n.signal) == null || H.addEventListener("abort", M), _ = setTimeout(() => R(new da("unavailable", "the print page did not load")), n.readyMs ?? TF), (n.mount ?? i.body).appendChild(l);
  });
}
const jc = new TextEncoder(), IF = new TextDecoder();
function Wr(e) {
  return new Uint8Array(e);
}
const BF = Wr(jc.encode("filex-state1")), FF = Wr(jc.encode("filex-app-state")), UF = "filex-app-state-v1-key", HF = "filex-app-state-v1-id", KF = "filex-app-state-v1", p$ = 1, dl = 12, VF = 16, jF = 16, qF = "local";
async function WF() {
  var t, n;
  if (!Kc()) return qF;
  const e = await l$("/api/auth/me", { method: "GET" });
  if (!e || !e.ok) return null;
  try {
    const a = (n = (t = await e.json()) == null ? void 0 : t.user) == null ? void 0 : n.id;
    if (typeof a == "number" && Number.isSafeInteger(a) && a > 0) return `u${a}`;
    if (typeof a == "string" && /^[A-Za-z0-9_-]{1,64}$/.test(a)) return `u${a}`;
  } catch {
  }
  return null;
}
async function YF(e) {
  var n;
  if (((n = e.algorithm) == null ? void 0 : n.name) === "HKDF") return e;
  const t = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: BF }, e, new Uint8Array(32)));
  try {
    return await crypto.subtle.importKey("raw", t.subarray(0, 32), "HKDF", !1, ["deriveKey", "deriveBits"]);
  } finally {
    t.fill(0);
  }
}
function p1(e, t, n) {
  return { name: "HKDF", hash: "SHA-256", salt: FF, info: Wr(jc.encode(`${e}\0${t}\0${n}`)) };
}
const tf = /* @__PURE__ */ new WeakMap();
function h$(e) {
  let t = tf.get(e);
  if (!t) {
    const n = { account: WF().catch(() => null), byApp: /* @__PURE__ */ new Map() };
    n.account.then((a) => {
      a === null && tf.get(e) === n && tf.delete(e);
    }), tf.set(e, n), t = n;
  }
  return t;
}
function h1(e, t, n) {
  const { byApp: a } = h$(e), i = `${t}\0${n}`;
  let r = a.get(i);
  return r || (r = (async () => {
    const l = await YF(e), c = await crypto.subtle.deriveKey(p1(UF, t, n), l, { name: "AES-GCM", length: 256 }, !1, ["encrypt", "decrypt"]), p = new Uint8Array(await crypto.subtle.deriveBits(p1(HF, t, n), l, jF * 8));
    return { id: Wo(p), key: c, account: t };
  })(), a.set(i, r), r.catch(() => a.delete(i))), r;
}
async function GF(e, t, n) {
  const a = await h$(e).account;
  if (a === null) return null;
  const i = await h1(e, a, t);
  return n ? { ...i, previous: await h1(n, a, t) } : i;
}
function ny() {
  const e = Qi().appStateE2e;
  if (!e) return {};
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" && !Array.isArray(t) ? t : {};
  } catch {
    return {};
  }
}
function m$(e, t) {
  const n = e[t];
  return n && typeof n == "object" && !Array.isArray(n) ? { ...n } : {};
}
function v$(e, t) {
  return Wr(jc.encode(`${KF}\0${t.account}\0${e}\0${t.id}`));
}
async function XF(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(dl)), i = Wr(jc.encode(JSON.stringify(n)));
  try {
    const r = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: a, additionalData: v$(e, t) }, t.key, i)), l = new Uint8Array(1 + dl + r.length);
    return l[0] = p$, l.set(a, 1), l.set(r, 1 + dl), Wo(l);
  } finally {
    i.fill(0);
  }
}
async function m1(e, t, n) {
  if (typeof n != "string") return null;
  const a = wo(n);
  if (!a || a.length < 1 + dl + VF || a[0] !== p$) return null;
  let i;
  try {
    i = new Uint8Array(
      await crypto.subtle.decrypt(
        { name: "AES-GCM", iv: Wr(a.subarray(1, 1 + dl)), additionalData: v$(e, t) },
        t.key,
        Wr(a.subarray(1 + dl))
      )
    );
  } catch {
    return null;
  }
  try {
    const r = JSON.parse(IF.decode(i));
    return r && typeof r == "object" && !Array.isArray(r) ? r : null;
  } catch {
    return null;
  } finally {
    i.fill(0);
  }
}
async function y$(e, t) {
  const n = m$(ny(), e);
  if (n[t.id] !== void 0) return await m1(e, t, n[t.id]) ?? {};
  const a = t.previous;
  return a && n[a.id] !== void 0 ? await m1(e, a, n[a.id]) ?? {} : {};
}
async function JF(e, t, n) {
  const a = await y$(e, t);
  return Object.prototype.hasOwnProperty.call(a, n) ? a[n] : void 0;
}
const nf = /* @__PURE__ */ new Map();
async function ZF(e, t, n, a) {
  const i = d$(n, a), l = (nf.get(e) ?? Promise.resolve()).catch(() => {
  }).then(() => QF(e, t, n, i));
  nf.set(e, l);
  try {
    await l;
  } finally {
    nf.get(e) === l && nf.delete(e);
  }
}
async function QF(e, t, n, a) {
  const i = { ...await y$(e, t) };
  a === void 0 ? delete i[n] : i[n] = JSON.parse(a);
  const r = m$(ny(), e);
  t.previous && delete r[t.previous.id], Object.keys(i).length ? r[t.id] = await XF(e, t, i) : delete r[t.id];
  const l = u$();
  if (l !== void 0 && c$(JSON.stringify(r)) > l)
    throw new vc(`an app keeps at most ${l} bytes, sealed, in an encrypted folder`);
  const c = { ...ny(), [e]: r };
  Object.keys(r).length || delete c[e], Zi("appStateE2e", JSON.stringify(c));
}
class g$ extends Error {
  constructor() {
    super("the sealed app store needs the account this page is signed in as"), this.name = "LedgerNeedsAccount";
  }
}
async function b$(e, t, n) {
  const a = await GF(e, t, n);
  if (!a) throw new g$();
  return a;
}
class Pr extends Error {
  constructor(t) {
    super(`at most ${t >> 20} MiB in an encrypted folder`), this.limit = t, this.name = "TooLargeToHand";
  }
}
const Tl = Math.min(ga.maxEncryptedBytes, qu);
function eU(e, t) {
  return {
    vault: t ?? null,
    async open(n, a, i = Tl) {
      const r = e(n);
      if (!r)
        return await a.cancel().catch(() => {
        }), null;
      const l = Nv(r.fmk, r.previous, a, { passPlain: !0 }).getReader(), c = [];
      let p = 0;
      try {
        for (; ; ) {
          const { done: x, value: k } = await l.read();
          if (x) break;
          if (p += k.byteLength, p > i) throw new Pr(i);
          c.push(k);
        }
      } catch (x) {
        await l.cancel(x).catch(() => {
        });
        for (const k of c) k.fill(0);
        throw x;
      }
      const m = new Uint8Array(p);
      let v = 0;
      for (const x of c)
        m.set(x, v), v += x.byteLength, x.fill(0);
      return m;
    },
    async seal(n, a, i = Tl) {
      if (a.byteLength > i) throw new Pr(i);
      const r = e(n);
      return r ? Uv(r.fmk, a.buffer.byteLength === a.byteLength ? a.buffer : a.slice().buffer) : null;
    },
    async ledger(n, a) {
      const i = e(n);
      return i ? b$(i.fmk, a, i.previous) : null;
    },
    folderKeys(n) {
      return e(n);
    }
  };
}
class sp extends Error {
  constructor(t) {
    super(`vault: ${t}`), this.why = t, this.name = "VaultAppRefused";
  }
}
function tU(e) {
  if (e.buffer instanceof ArrayBuffer && e.byteOffset === 0 && e.byteLength === e.buffer.byteLength) return e;
  const t = new Uint8Array(e.byteLength);
  return t.set(e), e.fill(0), t;
}
function nU(e) {
  return {
    async read(t, n = Tl) {
      const a = await e.readForApp(t, n);
      if (a.ok) return { bytes: tU(a.bytes), sig: a.sig };
      if (a.why === "locked") return null;
      throw a.why === "too_large" ? new Pr(n) : new sp(a.why);
    },
    async save(t, n, a, i = Tl) {
      if (n.byteLength > i) throw new Pr(i);
      const r = await e.saveForApp(t, n, a);
      if (!r.ok) throw new sp(r.why);
      return { size: r.size, sig: r.sig };
    },
    async ledger(t, n) {
      const a = e.keyForApp(t);
      return a ? b$(a, n) : null;
    }
  };
}
const aU = {
  txt: "text/plain",
  md: "text/markdown",
  log: "text/plain",
  csv: "text/csv",
  json: "application/json",
  xml: "application/xml",
  html: "text/html",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
  avif: "image/avif",
  svg: "image/svg+xml",
  pdf: "application/pdf",
  mp4: "video/mp4",
  webm: "video/webm",
  mov: "video/quicktime",
  m4v: "video/mp4",
  mp3: "audio/mpeg",
  wav: "audio/wav",
  ogg: "audio/ogg",
  flac: "audio/flac",
  m4a: "audio/mp4",
  aac: "audio/aac",
  opus: "audio/opus"
};
function Qs(e) {
  return aU[(e || "").toLowerCase()] || "application/octet-stream";
}
const k$ = "files:e2e-plaintext";
function iU(e) {
  return !!e && e.includes(k$);
}
const go = "builtin", Al = "onlyoffice", oU = ["csv"];
function Vp(e) {
  return oU.includes(String(e ?? "").toLowerCase());
}
function w$(e, t) {
  return !!e && e.type === "file" && (!!(t != null && t.inEncrypted) || H2(e));
}
function _$(e) {
  return `app:${e.plugin}/${e.id}`;
}
function v1(e) {
  return e ? e === go || e === Al || e.startsWith("app:") ? e : `app:${e}` : null;
}
function Tf(e) {
  return (e == null ? void 0 : e.id) === Al;
}
function Er(e) {
  return e ? String(Ny(e).ext ?? "").toLowerCase() : "";
}
function x$(e) {
  return e.filter((t) => t.placement === "viewer" && !!t.ui);
}
function rU(e, t) {
  return !t || t.type !== "file" ? [] : x$(e).filter((n) => Iy(n.applies ?? {}, [Ny(t, n.plugin)]));
}
function sU(e) {
  const t = Qs(e);
  return t === "application/octet-stream" ? "" : t;
}
function lU(e, t, n) {
  const a = sU(n);
  return x$(e).filter(
    (i) => {
      var r;
      return iU((r = i.ui) == null ? void 0 : r.grants) && Iy(i.applies ?? {}, [{ kind: "file", ext: n, mime: a, state: K2({ app_state: t.app_state }, i.plugin) }]);
    }
  );
}
function uU(e, t, n) {
  var p;
  const a = typeof t == "string" ? { name: t } : t, i = Wf(a.name ?? ""), r = lU(e, a, i), l = r.length === 0 ? { on: [{ id: go, view: null }], off: [], custom: !1 } : $$([...r.map((m) => ({ id: _$(m), view: m })), { id: go, view: null }], (p = n == null ? void 0 : n.rules) == null ? void 0 : p[i]), c = typeof (n == null ? void 0 : n.personal) == "function" ? n.personal(i) : n == null ? void 0 : n.personal;
  return { ...l, kind: i, handler: T$(l.on, n == null ? void 0 : n.choice, c) };
}
function cU(e, t) {
  if (!(t != null && t.e2ePlaintext) || e.type !== "file" || e.encrypted === "vault" || e.encrypted === "file") return !1;
  const n = e.e2e_name_state;
  return n === void 0 || n === "enc" || n === "plain";
}
function dU(e) {
  return { name: String(e.basename ?? ""), ...Array.isArray(e.app_state) ? { app_state: e.app_state } : {} };
}
function fU(e) {
  return !!e && typeof e.e2e_stored == "string";
}
function pU(e, t) {
  return !!(t != null && t.e2ePlaintext) && e.type === "file" && e.encrypted === "vault";
}
function S$(e, t, n, a) {
  if (!t || t.type !== "file") return { on: [], off: [], custom: !1 };
  if (w$(t, a)) {
    if (!(t.encrypted === "vault" ? pU(t, a) : cU(t, a))) return { on: [{ id: go, view: null }], off: [], custom: !1 };
    const { on: l, off: c, custom: p } = uU(e, dU(t), { rules: n });
    return { on: l, off: c, custom: p };
  }
  const i = [
    ...a != null && a.onlyOffice && Vp(Er(t)) ? [{ id: Al, view: null }] : [],
    ...rU(e, t).map((r) => ({ id: _$(r), view: r })),
    { id: go, view: null }
  ];
  return $$(i, n == null ? void 0 : n[Er(t)]);
}
function $$(e, t) {
  if (!t) return { on: e, off: [], custom: !1 };
  const n = new Set(t.off ?? []), a = new Map(e.map((c) => [c.id, c])), i = /* @__PURE__ */ new Set(), r = [];
  for (const c of t.order ?? []) {
    const p = a.get(c);
    !p || n.has(c) || i.has(c) || (i.add(c), r.push(p));
  }
  const l = [];
  for (const c of e)
    n.has(c.id) ? l.push(c) : i.has(c.id) || r.push(c);
  return { on: r, off: l, custom: !0 };
}
function Iu(e, t, n, a, i, r) {
  return !t || t.type !== "file" ? null : T$(hU(S$(e, t, a, r).on, t, r), n, i);
}
function hU(e, t, n) {
  const a = Er(t);
  return n != null && n.onlyOffice || !mv(a) || Vp(a) || !e.some((i) => i.view) ? e : e.filter((i) => i.id !== go);
}
function T$(e, t, n) {
  const a = (i) => i ? e.find((r) => r.id === i) ?? null : null;
  return a(v1(t)) ?? a(v1(n)) ?? e[0] ?? null;
}
function Spe(e, t, n, a, i, r) {
  var l;
  return ((l = Iu(e, t, n, a, i, r)) == null ? void 0 : l.view) ?? null;
}
const mU = "X-Filex-Version";
function vU(e) {
  const t = /^(\d{1,15}):(\d{1,15})$/.exec((e ?? "").trim());
  if (t)
    return { size: Number(t[1]), modified: Number(t[2]) };
}
const yU = /^[a-z0-9]{2,8}$/;
function gU(e) {
  const t = {}, n = e == null ? void 0 : e.beside;
  if (n != null && n !== "") {
    if (typeof n != "string") return null;
    const i = n.trim().replace(/^\./, "").toLowerCase();
    if (!yU.test(i)) return null;
    t.beside = i;
  }
  const a = e == null ? void 0 : e.conflict;
  if (a != null) {
    if (a !== "copy") return null;
    t.conflict = "copy";
  }
  return t;
}
const xg = 32, bU = "", kU = ["changes", "lock", "release"], fl = 12, A$ = "filex-oo-sk-v1", E$ = "filex-oo-v1", C$ = "filex-oo-eph-v1", z$ = "filex-oo-blob-v1", wU = "filex-oo-log", _U = "filex-oo-eph", xU = "filex-oo-blob";
function bo(e) {
  return new Uint8Array(e).buffer;
}
const yc = new TextEncoder(), SU = new TextDecoder("utf-8", { fatal: !0 });
function er(e, ...t) {
  return bo(yc.encode(JSON.stringify([e, ...t])));
}
async function jp(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(fl)), i = new Uint8Array(
    await crypto.subtle.encrypt({ name: "AES-GCM", iv: bo(a), additionalData: n }, e, bo(t))
  ), r = new Uint8Array(fl + i.length);
  return r.set(a, 0), r.set(i, fl), r;
}
async function qp(e, t, n) {
  if (t.length <= fl) return null;
  try {
    const a = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: bo(t.slice(0, fl)), additionalData: n },
      e,
      bo(t.slice(fl))
    );
    return new Uint8Array(a);
  } catch {
    return null;
  }
}
function Wp(e) {
  try {
    return ta(e);
  } catch {
    return null;
  }
}
function M$(e) {
  try {
    return JSON.parse(SU.decode(e));
  } catch {
    return;
  }
}
function $U() {
  return crypto.getRandomValues(new Uint8Array(xg));
}
async function TU(e, t, n) {
  if (t.length !== xg) throw new Error("e2eoffice: a session key is 32 bytes");
  return Oa(await jp(e, t, er(A$, n.sid, n.file)));
}
async function AU(e, t, n) {
  const a = Wp(t);
  if (!a) return null;
  const i = await qp(e, a, er(A$, n.sid, n.file));
  if (!i || i.length !== xg) return null;
  try {
    return await ay(i, n.sid);
  } finally {
    i.fill(0);
  }
}
async function ay(e, t) {
  const n = await crypto.subtle.importKey("raw", bo(e), "HKDF", !1, ["deriveKey"]), a = (c) => crypto.subtle.deriveKey(
    { name: "HKDF", hash: "SHA-256", salt: bo(yc.encode(t)), info: bo(yc.encode(c)) },
    n,
    { name: "AES-GCM", length: 256 },
    !1,
    ["encrypt", "decrypt"]
  ), [i, r, l] = await Promise.all([a(wU), a(_U), a(xU)]);
  return { log: i, eph: r, blob: l };
}
async function EU(e, t, n, a) {
  const i = yc.encode(JSON.stringify({ p: n, b: a }));
  return Oa(await jp(e, i, er(E$, t.sid, t.seq, t.client, t.ctr, t.kind)));
}
async function CU(e, t, n) {
  const a = Wp(n);
  if (!a) return null;
  const i = await qp(e, a, er(E$, t.sid, t.seq, t.client, t.ctr, t.kind));
  if (!i) return null;
  const r = M$(i);
  if (!r || typeof r != "object" || Array.isArray(r)) return null;
  const l = r;
  return typeof l.p != "string" ? null : { prev: l.p, body: l.b };
}
async function zU(e) {
  const t = Wp(e) ?? new Uint8Array(0), n = new Uint8Array(await crypto.subtle.digest("SHA-256", bo(t)));
  return Array.from(n, (a) => a.toString(16).padStart(2, "0")).join("");
}
const MU = ["join", "leave", "saved"];
class OU {
  constructor(t, n, a = 0, i = bU) {
    Bt(this, "seq");
    Bt(this, "last");
    Bt(this, "ctrs", /* @__PURE__ */ new Map());
    Bt(this, "failed", null);
    this.key = t, this.sid = n, this.seq = a, this.last = i;
  }
  /** The last entry taken. */
  get head() {
    return this.seq;
  }
  /** What the next sealed entry has to name as `prev`. */
  get digest() {
    return this.last;
  }
  /** The counter a writer used last (0 = none yet). */
  counter(t) {
    return this.ctrs.get(t) ?? 0;
  }
  async read(t) {
    const n = (r) => (this.failed = r, { ok: !1, seq: t.seq, problem: r });
    if (this.failed) return { ok: !1, seq: t.seq, problem: this.failed };
    if (t.seq !== this.seq + 1) return n("gap");
    if (MU.includes(t.kind))
      return this.seq = t.seq, { ok: !0, seq: t.seq, kind: t.kind, client: t.client };
    if (!kU.includes(t.kind)) return n("kind");
    const a = t.ctr ?? 0;
    if (typeof t.ct != "string" || a < 1) return n("forged");
    const i = await CU(
      this.key,
      { sid: this.sid, seq: t.seq, client: t.client, ctr: a, kind: t.kind },
      t.ct
    );
    return i ? i.prev !== this.last ? n("chain") : a <= this.counter(t.client) ? n("replay") : (this.ctrs.set(t.client, a), this.last = await zU(t.ct), this.seq = t.seq, { ok: !0, seq: t.seq, kind: t.kind, client: t.client, body: i.body }) : n("forged");
  }
}
async function PU(e, t, n) {
  const a = yc.encode(JSON.stringify(n));
  return Oa(await jp(e, a, er(C$, t.sid, t.client, t.ctr)));
}
async function DU(e, t, n) {
  const a = Wp(n);
  if (!a) return;
  const i = await qp(e, a, er(C$, t.sid, t.client, t.ctr));
  return i ? M$(i) : void 0;
}
function LU(e, t, n) {
  return jp(e, n, er(z$, t.sid, t.name));
}
function RU(e, t, n) {
  return qp(e, n, er(z$, t.sid, t.name));
}
function lp() {
  const e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Map();
  let n = 0;
  return {
    async add(a) {
      const i = ++n;
      return e.set(i, { ...a, id: i }), i;
    },
    async remove(a) {
      e.delete(a);
    },
    async listPath(a) {
      return [...e.values()].filter((i) => i.path === a).sort((i, r) => (i.id ?? 0) - (r.id ?? 0));
    },
    hold(a) {
      t.set(a, (t.get(a) ?? 0) + 1);
      let i = !1;
      return () => {
        if (i) return;
        i = !0;
        const r = (t.get(a) ?? 1) - 1;
        r > 0 ? t.set(a, r) : t.delete(a);
      };
    },
    async live(a) {
      return t.has(a);
    }
  };
}
const NU = "filex-coedit", Uo = "outbox", y1 = "filex-coedit-member:";
function g1() {
  try {
    return typeof navigator < "u" && navigator.locks ? navigator.locks : void 0;
  } catch {
    return;
  }
}
function Vm(e) {
  return new Promise((t, n) => {
    e.onsuccess = () => t(e.result), e.onerror = () => n(e.error);
  });
}
function IU() {
  const e = lp(), t = lp();
  let n = null;
  const a = () => (n || (n = new Promise((i) => {
    try {
      if (typeof indexedDB > "u") return i(null);
      const r = indexedDB.open(NU, 1);
      r.onupgradeneeded = () => {
        r.result.createObjectStore(Uo, { keyPath: "id", autoIncrement: !0 }).createIndex("by_path", "path");
      }, r.onsuccess = () => {
        const l = r.result;
        if (l.objectStoreNames.contains(Uo)) return i(l);
        l.close(), i(null);
      }, r.onerror = () => i(null), r.onblocked = () => i(null);
    } catch {
      i(null);
    }
  })), n);
  return {
    async add(i) {
      const r = await a();
      if (!r) return e.add(i);
      const l = r.transaction(Uo, "readwrite"), { id: c, ...p } = i;
      return Number(await Vm(l.objectStore(Uo).add(p)));
    },
    async remove(i) {
      const r = await a();
      if (!r) return e.remove(i);
      await Vm(r.transaction(Uo, "readwrite").objectStore(Uo).delete(i));
    },
    async listPath(i) {
      const r = await a();
      return r ? (await Vm(r.transaction(Uo, "readonly").objectStore(Uo).index("by_path").getAll(i))).sort((c, p) => (c.id ?? 0) - (p.id ?? 0)) : e.listPath(i);
    },
    hold(i) {
      const r = t.hold(i), l = g1();
      if (!l || !i) return r;
      let c = () => {
      };
      const p = new Promise((m) => c = m);
      return l.request(y1 + i, () => p).catch(() => {
      }), () => {
        r(), c();
      };
    },
    async live(i) {
      if (!i) return !1;
      if (await t.live(i)) return !0;
      const r = g1();
      if (!r) return !1;
      try {
        return await r.request(y1 + i, { ifAvailable: !0 }, (l) => l === null);
      } catch {
        return !1;
      }
    }
  };
}
const pl = 12, BU = "filex-coedit-outbox-v1", O$ = new TextEncoder();
function P$(e) {
  return new Uint8Array(O$.encode(JSON.stringify([BU, e]))).buffer;
}
async function FU(e, t, n) {
  const a = crypto.getRandomValues(new Uint8Array(pl)), i = O$.encode(JSON.stringify(n)), r = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv: a, additionalData: P$(t) }, e, i));
  i.fill(0);
  const l = new Uint8Array(pl + r.length);
  return l.set(a, 0), l.set(r, pl), Oa(l);
}
async function UU(e, t, n) {
  let a;
  try {
    a = ta(n);
  } catch {
    return;
  }
  if (!(a.length <= pl))
    for (const i of e)
      try {
        const r = await crypto.subtle.decrypt(
          { name: "AES-GCM", iv: a.slice(0, pl), additionalData: P$(t) },
          i,
          a.slice(pl)
        );
        return JSON.parse(new TextDecoder().decode(r));
      } catch {
      }
}
const HU = [1e3, 2e3, 4e3, 8e3, 15e3, 3e4];
function b1(e) {
  const t = el(e);
  return t ? t.status === 0 ? !0 : t.code === "coedit_off" || t.code === "coedit_no_secret_key" ? !1 : t.status === 502 || t.status === 503 || t.status === 504 : (e == null ? void 0 : e.said) === !0;
}
const k1 = 1;
function el(e) {
  const t = e ?? {};
  if (typeof t.status != "number") return null;
  let n;
  if (typeof t.detail == "string")
    try {
      const a = JSON.parse(t.detail);
      typeof a.head == "number" && (n = a.head);
    } catch {
    }
  return { status: t.status, code: typeof t.code == "string" ? t.code : "", head: n };
}
function Sr(e) {
  if (e instanceof lt) return e;
  const t = el(e);
  if (!t) return new lt("failed", "failed");
  switch (t.code) {
    case "coedit_read_only":
      return new lt("read_only", "read_only");
    case "coedit_too_large":
      return new lt("too_large", "too_large");
    case "coedit_no_blob":
      return new lt("not_found", "not_found");
    case "coedit_blob_exists":
      return new lt("failed", "exists");
    case "coedit_no_lease":
    case "coedit_log_full":
    case "coedit_save_order":
    case "coedit_conflict":
      return new lt("failed", t.code.slice(7));
    case "coedit_gone":
    case "coedit_not_ready":
    case "coedit_nothing_to_watch":
    case "coedit_busy":
      return new lt("unavailable", t.code.slice(7));
    case "coedit_off":
    case "coedit_no_secret_key":
    case "coedit_build":
    case "coedit_file_changed":
    case "coedit_full":
    case "encrypted":
      return new lt("unavailable", t.code);
    case "not_granted":
      return new lt("not_granted", "not_granted");
    case "coedit_invalid":
    case "bad_json":
      return new lt("invalid", "invalid");
  }
  return t.status === 404 ? new lt("not_found", t.code || "not_found") : new lt("failed", /^[a-z][a-z0-9_]{0,39}$/.test(t.code) ? t.code : "failed");
}
const KU = ["changes", "lock", "release"];
function VU(e) {
  try {
    return JSON.parse(e);
  } catch {
    return;
  }
}
function w1(e) {
  if (!e || typeof e != "object") return null;
  const t = e;
  return typeof t.client != "string" ? null : {
    client: t.client,
    user: typeof t.user == "string" ? t.user : "",
    name: typeof t.name == "string" ? t.name : "",
    indexUser: typeof t.index_user == "number" ? t.index_user : 0,
    canEdit: t.can_edit === !0
  };
}
class up {
  constructor(t, n, a, i, r, l, c, p) {
    Bt(this, "reader");
    Bt(this, "t");
    /** The app subscribed from here (null: not yet - entries wait). */
    Bt(this, "from", null);
    /** Entries read before the app subscribed. */
    Bt(this, "held", []);
    /** Entries waiting to be read, in order (the reader takes one at a time). */
    Bt(this, "inbox", []);
    Bt(this, "reading", !1);
    Bt(this, "sock", null);
    Bt(this, "closed", !1);
    Bt(this, "broken", !1);
    Bt(this, "ctr", 0);
    Bt(this, "ephCtr", 0);
    Bt(this, "ephSeen", /* @__PURE__ */ new Map());
    Bt(this, "appending", Promise.resolve());
    Bt(this, "waiters", []);
    /** What the socket said of each entry besides what the reader checks. */
    Bt(this, "extras", /* @__PURE__ */ new Map());
    Bt(this, "cursorTimer", null);
    Bt(this, "cursorNext", null);
    Bt(this, "cursorLast", 0);
    Bt(this, "reconnectDelay", 1e3);
    /** The seq of the last `changes` entry the reader took. */
    Bt(this, "changesSeen", 0);
    Bt(this, "outbox");
    Bt(this, "doc", "");
    Bt(this, "owner", "");
    /** The file's path as the host named it (where its kept changes are found). */
    Bt(this, "path", "");
    /** Releases this member's lock (lib/coeditOutbox `hold`). */
    Bt(this, "release", null);
    this.transport = t, this.ev = n, this.sid = a, this.me = i, this.token = r, this.keys = l, this.info = c, this.reader = new OU(l.log, a), this.t = {
      catchUpMs: 15e3,
      cursorGapMs: 200,
      ...p
    }, this.outbox = p.outbox ?? lp();
  }
  /**
   * Join (or start) the session of the file at `path`. A session whose
   * creator has not stored the base yet is asked again for a while, then
   * `unavailable` (`not_ready`).
   */
  static async join(t, n, a, i = {}) {
    const r = Date.now() + (i.readyWaitMs ?? 2e4), l = (M) => new Promise((L) => (i.setTimeout ?? setTimeout)(L, M)), c = i.outbox ?? lp(), p = await c.listPath(n).catch(() => []), m = [];
    for (const M of p) await c.live(M.client).catch(() => !1) || m.push(M);
    const v = {};
    i.folder && (v.e2e = !0), m.length > 0 && (v.unsent = { count: m.length });
    let x;
    for (; ; )
      try {
        x = await t.join(n, v);
        break;
      } catch (M) {
        const L = el(M);
        if ((L == null ? void 0 : L.code) === "coedit_not_ready" && Date.now() < r) {
          await l(1e3);
          continue;
        }
        throw Sr(M);
      }
    const k = String(x.session ?? ""), _ = w1(x.me), w = String(x.token ?? "");
    if (!/^[0-9a-f]{32}$/.test(k) || !_ || !w) throw new lt("failed", "failed");
    const b = String(x.doc ?? ""), C = await up.keysOf(t, x, k, _.client, w, b, i), A = new up(t, a, k, _, w, C, {
      head: Number(x.head ?? 0),
      changesHead: Number(x.changes_head ?? 0),
      savedThrough: Number(x.saved_through ?? 0),
      created: x.created === !0
    }, i);
    A.doc = b, A.owner = String(x.owner ?? ""), A.path = n, A.release = c.hold(_.client);
    const T = x.socket ?? {};
    A.connect(String(T.url ?? ""), String(T.ticket ?? ""));
    const R = m.filter((M) => M.doc === A.doc && M.owner === A.owner && A.owner !== "");
    if (R.length > 0) {
      const M = x.unsent_words ?? {};
      await A.recover(R, Number(x.head ?? 0), M);
    }
    return A;
  }
  /**
   * The session's three keys. An ordinary folder: the server's key, handed
   * over. An encrypted folder (KeyFolder): the member that started the
   * session makes the key here, seals it with the folder key and gives the
   * server only that; a member that joins opens the one the starter sealed.
   */
  static async keysOf(t, n, a, i, r, l, c) {
    if (n.key_mode === "server" && typeof n.key == "string") {
      const x = ta(n.key);
      try {
        return await ay(x, a);
      } finally {
        x.fill(0);
      }
    }
    if (n.key_mode !== "folder" || !c.folder || !l) throw new lt("unavailable", "encrypted");
    const p = c.folder();
    if (!p) throw new lt("unavailable", "locked");
    const m = { sid: a, file: l };
    if (n.created === !0) {
      const x = $U();
      try {
        const k = await TU(p.fmk, x, m);
        try {
          await t.call(a, "key", { client: i, token: r, sealed: k });
        } catch (_) {
          throw Sr(_);
        }
        return await ay(x, a);
      } finally {
        x.fill(0);
      }
    }
    const v = typeof n.sealed_key == "string" ? n.sealed_key : "";
    for (const x of [p.fmk, p.previous]) {
      if (!x || !v) continue;
      const k = await AU(x, v, m);
      if (k) return k;
    }
    throw new lt("failed", "forged");
  }
  /**
   * The changes of an earlier opening, kept in this browser (lib/coeditOutbox):
   * sent at once when they are this session's and nobody changed the
   * document since; otherwise the person is asked (the server's words), and
   * they are sent on top of what is there now, or thrown away. Sent before
   * the interface reads the log, so its editor opens with them in it.
   */
  async recover(t, n, a) {
    var x, k;
    try {
      await this.until(n);
    } catch {
      return;
    }
    const i = t[0], r = i.sid === this.sid && i.changesBase === this.changesSeen;
    let l = r;
    if (!r) {
      const _ = String((i.sid === this.sid ? a.behind : a.ended) ?? "");
      if (!_ || !this.t.askUnsent) return;
      const w = await this.t.askUnsent({ text: _, apply: String(a.apply ?? ""), discard: String(a.discard ?? "") }).catch(() => null);
      if (w === null) return;
      l = w;
    }
    if (!l) {
      for (const _ of t) _.id !== void 0 && await this.outbox.remove(_.id).catch(() => {
      });
      return;
    }
    const c = ((k = (x = this.t).folder) == null ? void 0 : k.call(x)) ?? null, p = c ? [c.fmk, c.previous].filter((_) => !!_) : [];
    let m = !1, v = 0;
    try {
      for (const _ of t) {
        const w = _.sealed ? await UU(p, _.doc, _.body) : VU(_.body);
        if (_.id !== void 0 && await this.outbox.remove(_.id).catch(() => {
        }), w !== void 0) {
          if (m = m || await this.takeLease(), !m) {
            await this.keep("changes", w);
            continue;
          }
          v = (await this.append("changes", w)).seq;
        }
      }
    } finally {
      m && await this.lease("release", this.changesSeen).catch(() => !1);
    }
    v > 0 && (await this.until(v).catch(() => {
    }), this.info.head = Math.max(this.info.head, v), this.info.changesHead = Math.max(this.info.changesHead, v));
  }
  /** The lease for the changes being recovered, a few tries while another writer holds it. */
  async takeLease() {
    for (let t = 0; t < 10 && !this.closed; t++) {
      if (await this.lease("acquire", this.changesSeen).catch(() => !1)) return !0;
      await new Promise((n) => (this.t.setTimeout ?? setTimeout)(n, 1e3));
    }
    return !1;
  }
  /** What `coedit.join` answers the interface. */
  hello() {
    return { session: this.sid, me: { ...this.me }, ...this.info };
  }
  /** The query a save made in this session adds (`file.save`'s `through`). */
  saveParams(t) {
    return this.closed || !Number.isInteger(t) || t < 0 || t > this.reader.head ? null : { coedit: this.sid, client: this.me.client, token: this.token, through: String(t) };
  }
  /** The entries after `from` go to the interface, in order, then each new one. */
  subscribe(t) {
    if (!Number.isInteger(t) || t < 0) throw new lt("invalid", "from is an entry seq");
    this.from = t;
    const n = this.held;
    this.held = [];
    for (const a of n) a.seq > t && this.ev.entry(a);
  }
  /** Seal an entry at the place this page read last and have the relay place it. */
  append(t, n) {
    if (!KU.includes(t)) return Promise.reject(new lt("invalid", "kind is changes, lock or release"));
    const a = this.appending.then(() => this.place(t, n));
    return this.appending = a.catch(() => {
    }), a;
  }
  async place(t, n) {
    const a = t === "changes" ? await this.keep(t, n) : void 0, i = () => a !== void 0 ? this.outbox.remove(a).catch(() => {
    }) : void 0, r = this.t.retryMs ?? HU;
    let l = 0;
    for (let c = 0; c < 50; ) {
      if (this.closed || this.broken) throw new lt("unavailable", this.broken ? "broken" : "gone");
      const p = this.reader.head, m = ++this.ctr, v = await EU(this.keys.log, { sid: this.sid, seq: p + 1, client: this.me.client, ctr: m, kind: t }, this.reader.digest, n);
      try {
        const x = await this.transport.call(this.sid, "append", { client: this.me.client, token: this.token, kind: t, base: p, ctr: m, ct: v });
        return await i(), { seq: Number(x.seq ?? p + 1) };
      } catch (x) {
        const k = el(x);
        if ((k == null ? void 0 : k.code) === "coedit_conflict" && typeof k.head == "number") {
          c++, await this.until(k.head);
          continue;
        }
        if (b1(x)) {
          await new Promise((_) => (this.t.setTimeout ?? setTimeout)(_, r[Math.min(l, r.length - 1)])), l++;
          continue;
        }
        throw (k == null ? void 0 : k.code) === "coedit_gone" ? (this.gone(), Sr(x)) : (await i(), Sr(x));
      }
    }
    throw new lt("unavailable", "busy");
  }
  /** Keep a change in this browser (sealed in an encrypted folder); its record's id. */
  async keep(t, n) {
    var l, c;
    if (t !== "changes" || !this.doc || !this.owner || !this.me.canEdit) return;
    const a = ((c = (l = this.t).folder) == null ? void 0 : c.call(l)) ?? null;
    let i, r = !1;
    if (this.t.folder) {
      if (!a) return;
      i = await FU(a.fmk, this.doc, n), r = !0;
    } else
      i = JSON.stringify(n);
    try {
      return await this.outbox.add({
        doc: this.doc,
        owner: this.owner,
        sid: this.sid,
        client: this.me.client,
        path: this.path,
        changesBase: this.changesSeen,
        at: Date.now(),
        body: i,
        sealed: r
      });
    } catch {
      return;
    }
  }
  /** Resolves once the reader has taken entry `head` (or fails after catchUpMs). */
  until(t) {
    return this.reader.head >= t ? Promise.resolve() : new Promise((n, a) => {
      const i = this.t.setTimeout ?? setTimeout, r = this.t.clearTimeout ?? ((p) => clearTimeout(p)), l = {
        head: t,
        done: () => {
          r(c), n();
        },
        fail: (p) => {
          r(c), a(p);
        }
      }, c = i(() => {
        const p = this.waiters.indexOf(l);
        p >= 0 && this.waiters.splice(p, 1), a(new lt("unavailable", "behind"));
      }, this.t.catchUpMs);
      this.waiters.push(l);
    });
  }
  /** The changes lease: one writer at a time, and only one that has seen every change. */
  async lease(t, n) {
    var a;
    if (t !== "acquire" && t !== "release") throw new lt("invalid", "op is acquire or release");
    try {
      return (await this.transport.call(this.sid, "lease", { client: this.me.client, token: this.token, op: t, changes_seen: n })).granted === !0;
    } catch (i) {
      if (b1(i)) return !1;
      throw ((a = el(i)) == null ? void 0 : a.code) === "coedit_gone" && this.gone(), Sr(i);
    }
  }
  /** A cursor for the others: sealed, not kept, a few a second at most (the last one wins). */
  cursor(t) {
    if (this.closed || !this.me.canEdit || (this.cursorNext = { cursor: t }, this.cursorTimer !== null)) return;
    const n = Math.max(0, this.cursorLast + this.t.cursorGapMs - Date.now()), a = this.t.setTimeout ?? setTimeout;
    this.cursorTimer = a(() => {
      this.cursorTimer = null;
      const i = this.cursorNext;
      this.cursorNext = null, i && this.sendCursor(i.cursor);
    }, n);
  }
  async sendCursor(t) {
    if (!this.sock || this.sock.readyState !== k1) return;
    this.cursorLast = Date.now();
    const n = ++this.ephCtr, a = await PU(this.keys.eph, { sid: this.sid, client: this.me.client, ctr: n }, t);
    this.sock && this.sock.readyState === k1 && this.sock.send(JSON.stringify({ type: "cursor", ctr: n, ct: a }));
  }
  /** Seal and store a blob of the session (the base document, an image). */
  async putBlob(t, n) {
    if (!/^[A-Za-z0-9._-]{1,128}$/.test(t)) throw new lt("invalid", "a blob name");
    const a = await LU(this.keys.blob, { sid: this.sid, name: t }, new Uint8Array(n));
    try {
      await this.transport.putBlob(this.sid, t, { client: this.me.client, token: this.token }, a);
    } catch (i) {
      throw Sr(i);
    }
  }
  /** Read and open a blob of the session. */
  async getBlob(t) {
    if (!/^[A-Za-z0-9._-]{1,128}$/.test(t)) throw new lt("invalid", "a blob name");
    let n;
    try {
      n = await this.transport.getBlob(this.sid, t, { client: this.me.client, token: this.token });
    } catch (i) {
      throw Sr(i);
    }
    const a = await RU(this.keys.blob, { sid: this.sid, name: t }, new Uint8Array(n));
    if (!a) throw new lt("failed", "forged");
    return a.buffer.slice(a.byteOffset, a.byteOffset + a.byteLength);
  }
  /** Leave the session. `keepalive` for a page that is going away. */
  async leave(t = {}) {
    if (!this.closed) {
      this.close();
      try {
        await this.transport.call(this.sid, "leave", { client: this.me.client, token: this.token }, t);
      } catch {
      }
    }
  }
  /** Stop: no socket, no event, nothing waits. */
  close() {
    var n;
    this.closed = !0, (n = this.release) == null || n.call(this), this.release = null;
    const t = this.sock;
    if (this.sock = null, t) {
      t.onclose = null, t.onmessage = null;
      try {
        t.close(1e3);
      } catch {
      }
    }
    this.cursorTimer !== null && (this.t.clearTimeout ?? ((a) => clearTimeout(a)))(this.cursorTimer), this.cursorTimer = null;
  }
  // -------------------------------------------------------------------------
  // The socket
  // -------------------------------------------------------------------------
  connect(t, n) {
    if (this.closed || !t || !n) return;
    const a = this.t.socket ?? ((r) => new WebSocket(r));
    let i;
    try {
      i = a(`${t}${t.includes("?") ? "&" : "?"}ticket=${encodeURIComponent(n)}`);
    } catch {
      this.reconnectLater();
      return;
    }
    this.sock = i, i.onopen = () => {
      this.reconnectDelay = 1e3, i.send(JSON.stringify({ type: "subscribe", from: this.reader.head + this.inbox.length }));
    }, i.onmessage = (r) => this.onFrame(r.data), i.onclose = () => {
      this.sock === i && (this.sock = null), this.reconnectLater();
    }, i.onerror = () => {
    };
  }
  reconnectLater() {
    if (this.closed || this.broken) return;
    const t = this.reconnectDelay;
    this.reconnectDelay = Math.min(this.reconnectDelay * 2, 3e4), (this.t.setTimeout ?? setTimeout)(() => void this.reconnect(), t);
  }
  async reconnect() {
    var t;
    if (!(this.closed || this.broken || this.sock))
      try {
        const n = await this.transport.call(this.sid, "ticket", { client: this.me.client, token: this.token });
        this.connect(String(n.url ?? ""), String(n.ticket ?? ""));
      } catch (n) {
        if (((t = el(n)) == null ? void 0 : t.code) === "coedit_gone") {
          this.gone();
          return;
        }
        this.reconnectLater();
      }
  }
  onFrame(t) {
    if (this.closed || typeof t != "string") return;
    let n;
    try {
      n = JSON.parse(t);
    } catch {
      return;
    }
    switch (n.type) {
      case "entry":
        n.entry && this.take(n.entry);
        return;
      case "eph":
        this.takeCursor(n);
        return;
      case "ended":
        n.reason === "broken" ? this.stopBroken() : this.gone();
        return;
    }
  }
  take(t) {
    if (typeof t.seq != "number" || typeof t.kind != "string" || typeof t.client != "string") return;
    const n = this.reader.head + this.inbox.length;
    if (t.seq <= n) return;
    this.inbox.push({ seq: t.seq, kind: t.kind, client: t.client, ctr: t.ctr, ct: t.ct });
    const a = { at: typeof t.at == "number" ? t.at : 0, member: t.member, through: t.through };
    this.extras.set(t.seq, a), this.drain();
  }
  async drain() {
    if (!this.reading) {
      this.reading = !0;
      try {
        for (; this.inbox.length > 0 && !this.closed && !this.broken; ) {
          const t = this.inbox.shift(), n = this.extras.get(t.seq) ?? { at: 0 };
          this.extras.delete(t.seq);
          const a = await this.reader.read(t);
          if (!a.ok) {
            this.stopBroken();
            return;
          }
          a.kind === "changes" && (this.changesSeen = a.seq);
          const i = this.entryOf(a.seq, a.kind, a.client, a.body, n);
          i && (this.from === null ? this.held.push(i) : i.seq > this.from && this.ev.entry(i));
          for (const r of [...this.waiters])
            this.reader.head >= r.head && (this.waiters.splice(this.waiters.indexOf(r), 1), r.done());
        }
      } finally {
        this.reading = !1;
      }
    }
  }
  entryOf(t, n, a, i, r) {
    const l = { seq: t, at: r.at, client: a };
    switch (n) {
      case "join": {
        const c = w1(r.member);
        return c ? { ...l, kind: "join", member: c } : null;
      }
      case "leave":
        return { ...l, kind: "leave" };
      case "saved":
        return { ...l, kind: "saved", through: typeof r.through == "number" ? r.through : 0 };
      case "changes":
      case "lock":
      case "release":
        return { ...l, kind: n, body: i };
    }
    return null;
  }
  async takeCursor(t) {
    if (typeof t.client != "string" || typeof t.ctr != "number" || typeof t.ct != "string" || t.client === this.me.client || t.ctr <= (this.ephSeen.get(t.client) ?? 0)) return;
    this.ephSeen.set(t.client, t.ctr);
    const n = await DU(this.keys.eph, { sid: this.sid, client: t.client, ctr: t.ctr }, t.ct);
    n === void 0 || this.closed || this.ev.cursor({ client: t.client, cursor: n });
  }
  /** The membership ended: say so once, stop. */
  gone() {
    if (this.closed) return;
    const t = this.reader.head;
    this.close(), this.rejectWaiters("gone"), this.ev.dropped({ from: t, reason: "gone" });
  }
  /** The log stopped checking out: the editors would build different documents. */
  stopBroken() {
    if (this.broken || this.closed) return;
    this.broken = !0;
    const t = this.reader.head;
    this.close(), this.rejectWaiters("broken"), this.ev.dropped({ from: t, reason: "broken" });
  }
  rejectWaiters(t) {
    for (const n of this.waiters.splice(0)) n.fail(new lt("unavailable", t));
  }
}
const jU = { "data-testid": "plugin-confirm-message" }, D$ = /* @__PURE__ */ rt({
  __name: "PluginConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    title: {},
    message: {},
    danger: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale);
    return (r, l) => (f(), We(na, {
      open: e.open,
      title: e.title || u(i)("plugin.confirm.title"),
      size: "sm",
      theme: e.theme,
      locale: e.locale,
      onClose: l[2] || (l[2] = (c) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          onClick: l[0] || (l[0] = (c) => a("close"))
        }, y(u(i)("plugin.confirm.cancel")), 1),
        d("button", {
          type: "button",
          class: Ne(["fe-btn", e.danger ? "fe-btn--danger" : "fe-btn--primary"]),
          "data-testid": "plugin-confirm-run",
          onClick: l[1] || (l[1] = (c) => a("confirm"))
        }, y(u(i)("plugin.confirm.run")), 3)
      ]),
      default: mt(() => [
        d("p", jU, y(e.message), 1)
      ]),
      _: 1
    }, 8, ["open", "title", "theme", "locale"]));
  }
}), qU = ["data-app", "data-connected"], WU = {
  key: 0,
  class: "fe-appframe__note",
  role: "status",
  "data-testid": "appframe-updated"
}, YU = { class: "fe-appframe__note-text" }, GU = {
  key: 1,
  class: "fe-appframe__note fe-appframe__consent fe-appframe__over",
  role: "alertdialog",
  "aria-live": "assertive",
  "data-testid": "appframe-unsent"
}, XU = { class: "fe-appframe__note-text" }, JU = {
  key: 2,
  class: "fe-appframe__note fe-appframe__consent",
  role: "alertdialog",
  "aria-live": "assertive",
  "data-testid": "appframe-consent"
}, ZU = { class: "fe-appframe__note-text" }, QU = ["disabled"], eH = ["role", "aria-live", "aria-hidden", "inert", "data-shown"], tH = { class: "fe-appframe__note-text" }, nH = { "data-testid": "appframe-unsaved" }, aH = ["disabled"], iH = ["disabled"], oH = ["disabled"], _1 = 5e3, x1 = 600, Sg = /* @__PURE__ */ rt({
  __name: "AppFrame",
  props: {
    api: {},
    app: {},
    version: {},
    view: {},
    placement: {},
    ui: {},
    files: {},
    savePath: {},
    readOnly: { type: Boolean },
    locale: {},
    theme: {},
    userName: {},
    title: {},
    storages: {},
    startAt: {},
    e2e: {}
  },
  emits: ["connected", "dirty", "title", "toast", "close", "saved", "saved-as", "op"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = Ml(), c = S(null);
    let p = null, m = null;
    const v = S(!1), x = S(!1), k = S(null), _ = S(!1), w = S(0), b = S(null), C = E(() => b.value ?? a.ui), A = S(""), T = S(""), R = E(() => a.api.appUIUrl(C.value.url)), M = E(() => new Set(C.value.grants ?? [])), L = E(() => {
      var ne;
      return ((ne = b.value) == null ? void 0 : ne.version) || a.version || a.ui.version || "";
    }), U = E(
      () => a.theme === "dark" || a.theme !== "light" && l.value ? "dark" : "light"
    ), P = [
      "--fe-bg",
      "--fe-bg-elev",
      "--fe-bg-hover",
      "--fe-bg-selected",
      "--fe-border",
      "--fe-border-soft",
      "--fe-border-strong",
      "--fe-text",
      "--fe-text-muted",
      "--fe-text-on-primary",
      "--fe-primary",
      "--fe-primary-hover",
      "--fe-primary-soft",
      "--fe-primary-ink",
      "--fe-danger",
      "--fe-danger-hover",
      "--fe-warning",
      "--fe-ok",
      "--fe-radius",
      "--fe-radius-sm",
      "--fe-radius-md",
      "--fe-radius-lg",
      "--fe-font",
      "--fe-font-mono",
      "--fe-text-xs",
      "--fe-text-sm",
      "--fe-text-md",
      "--fe-shadow",
      "--fe-shadow-sm"
    ];
    function H() {
      const ne = {};
      if (c.value && typeof getComputedStyle == "function") {
        const Q = getComputedStyle(c.value);
        for (const Ae of P) {
          const at = Q.getPropertyValue(Ae).trim();
          at && (ne[Ae] = at);
        }
      }
      return { mode: U.value, tokens: ne };
    }
    function $(ne) {
      const Q = ne.lastIndexOf(".");
      return Q > 0 ? ne.slice(Q + 1).toLowerCase() : "";
    }
    function F(ne) {
      const Q = a.e2e;
      return !Q || !M.value.has(k$) ? !1 : ne.encrypted === "folder" || ne.encrypted === "vault" && !!Q.vault;
    }
    const I = E(() => (a.files ?? []).some(F));
    function Z(ne) {
      return !!a.readOnly || !!ne.readOnly || ju(ne.encrypted) && !F(ne);
    }
    function J() {
      const ne = M.value.has("files:write");
      return (a.files ?? []).map((Q, Ae) => ({
        index: Ae,
        name: Q.name,
        ext: $(Q.name),
        size: Q.size ?? 0,
        mime: Q.mime ?? "",
        readOnly: !ne || Z(Q),
        // Only when the server said so: absent means not encrypted.
        ...ju(Q.encrypted) ? { encrypted: Q.encrypted } : {},
        ...F(Q) ? { plaintext: !0 } : {}
      }));
    }
    function re() {
      return {
        v: t$,
        app: { name: a.app, version: L.value },
        view: { id: a.view, placement: a.placement },
        locale: a.locale,
        dir: hl(a.locale),
        theme: H(),
        user: { name: a.userName ?? "" },
        // The document editors' fixed language (#214), as the server's list
        // said it for this interface (filex 0.57).
        ...C.value.editor_lang ? { editor_lang: C.value.editor_lang } : {},
        files: J(),
        grants: [...M.value]
      };
    }
    function ve(ne) {
      if (!M.value.has(ne)) throw new lt("not_granted", `this app was not granted ${ne}`);
    }
    function W(ne) {
      const Q = typeof ne == "number" ? ne : 0, Ae = (a.files ?? [])[Q];
      if (!Number.isInteger(Q) || !Ae) throw new lt("not_found", `no file at ${String(ne)}`);
      return Ae;
    }
    async function z(ne, Q) {
      const Ae = typeof Q == "string" && Q.length < 200 ? Q : "";
      if (typeof ne == "string") return new Blob([ne], { type: Ae || "text/plain;charset=utf-8" });
      if (ne instanceof ArrayBuffer) return new Blob([ne], { type: Ae });
      if (typeof ReadableStream < "u" && ne instanceof ReadableStream) return ne;
      throw new lt("invalid", "save takes a string, an ArrayBuffer or a ReadableStream");
    }
    const le = /* @__PURE__ */ new Map(), fe = /* @__PURE__ */ new Map();
    function j(ne, Q) {
      const Ae = le.get(ne);
      return Ae ? `${Ae.size}:${Ae.modified}` : typeof Q.size == "number" && typeof Q.modified == "number" ? `${Q.size}:${Q.modified}` : void 0;
    }
    function X() {
      return new lt("too_large", `at most ${Tl >> 20} MiB in an encrypted folder`);
    }
    function te() {
      return new lt("unavailable", "the encrypted folder was locked");
    }
    async function V() {
      const ne = (a.files ?? []).find(F);
      return !ne || !a.e2e ? null : ne.encrypted === "vault" ? a.e2e.vault ? a.e2e.vault.ledger(ne.path, a.app) : null : a.e2e.ledger(ne.path, a.app);
    }
    function G() {
      return r("appframe.state_no_account");
    }
    async function q(ne) {
      const Q = typeof ReadableStream < "u" && ne instanceof ReadableStream;
      if (typeof ne != "string" && !(ne instanceof ArrayBuffer) && !Q)
        throw new lt("invalid", "save takes a string, an ArrayBuffer or a ReadableStream");
      const Ae = [];
      let at = 0;
      try {
        for await (const Ht of ae(ne)) {
          if (at += Ht.byteLength, at > Tl) throw X();
          Ae.push(Ht);
        }
      } catch (Ht) {
        for (const Wt of Ae) Wt.fill(0);
        throw Ht;
      }
      const ct = new Uint8Array(at);
      let zt = 0;
      for (const Ht of Ae)
        ct.set(Ht, zt), zt += Ht.byteLength, Ht.fill(0);
      return ct;
    }
    async function B(ne) {
      const Q = a.e2e, Ae = a.api.pluginUIRead;
      if (!Q || typeof Ae != "function") throw new lt("unavailable", "this host does not hand over encrypted files");
      const at = await Ae(a.app, a.view, ne.path, { e2e: !0 }), ct = at.body ?? new Blob([await at.arrayBuffer()]).stream();
      try {
        return await Q.open(ne.path, ct);
      } catch (zt) {
        throw zt instanceof Pr ? X() : new lt("failed", "the file could not be decrypted here");
      }
    }
    const K = /* @__PURE__ */ new Map();
    function ke(ne, Q) {
      if (ne instanceof lt) return ne;
      if (ne instanceof Pr) return X();
      if (!(ne instanceof sp)) return new lt("failed", Q);
      switch (ne.why) {
        case "locked":
          return new lt("unavailable", "the vault was locked");
        case "too_large":
          return X();
        case "gone":
          return new lt("not_found", "the file is not in the vault any more");
        case "read_only":
          return new lt("read_only", "the vault is read-only here");
        case "changed":
          return new lt("failed", "changed");
        case "held":
          return new lt("failed", "vault_locked");
        case "lock_lost":
          return new lt("failed", "vault_lock_lost");
        default:
          return new lt("failed", Q);
      }
    }
    async function Ye(ne) {
      var Ae;
      const Q = (Ae = a.e2e) == null ? void 0 : Ae.vault;
      if (!Q) throw new lt("unavailable", "this host does not hand over files of a vault");
      try {
        const at = await Q.read(ne.path);
        return at ? (K.set(ne.path, at.sig), at.bytes) : null;
      } catch (at) {
        throw ke(at, "the file could not be decrypted here");
      }
    }
    async function Oe(ne, Q, Ae) {
      var Wt;
      const at = (Wt = a.e2e) == null ? void 0 : Wt.vault;
      if (!at) throw new lt("unavailable", "the vault was locked");
      const ct = await q(Ae), zt = ct.byteLength;
      let Ht;
      try {
        Ht = await at.save(Q.path, ct, K.get(Q.path) ?? j(ne, Q));
      } catch (tn) {
        throw ke(tn, "the vault did not save it");
      } finally {
        ct.fill(0);
      }
      return K.set(Q.path, Ht.sig), i("saved", { path: Q.path, size: Ht.size, index: ne }), x.value = !1, i("dirty", !1), { saved: !0, size: zt };
    }
    async function Be(ne, Q) {
      const Ae = ne.encrypted === "vault" ? await Ye(ne) : await B(ne);
      if (!Ae) throw ne.encrypted === "vault" ? ke(new sp("locked"), "") : te();
      const at = { name: ne.name, size: Ae.byteLength, mime: ne.mime || "" };
      switch (Q ?? "stream") {
        case "text": {
          if (Ae.byteLength > ga.maxTextBytes)
            throw Ae.fill(0), new lt("too_large", "read a file this large as bytes");
          const ct = new TextDecoder().decode(Ae);
          return Ae.fill(0), { ...at, text: ct };
        }
        case "bytes":
          return { ...at, bytes: Ae.buffer };
        case "stream": {
          const ct = Ae;
          return {
            ...at,
            stream: new ReadableStream({
              start(zt) {
                zt.enqueue(ct), zt.close();
              }
            })
          };
        }
        default:
          throw Ae.fill(0), new lt("invalid", "as is stream, bytes or text");
      }
    }
    async function qe(ne, Q, Ae, at) {
      if (Q.encrypted === "vault") return Oe(ne, Q, Ae);
      const ct = a.e2e;
      if (!ct) throw te();
      const zt = await q(Ae), Ht = zt.byteLength;
      let Wt;
      try {
        Wt = await ct.seal(Q.path, zt);
      } catch (yn) {
        throw yn instanceof Pr ? X() : yn;
      } finally {
        zt.fill(0);
      }
      if (!Wt) throw te();
      const tn = mn && typeof at == "number" ? mn.saveParams(at) : null, Ft = await a.api.pluginUISave(a.app, a.view, { path: Q.path }, new Blob([Wt], { type: "application/octet-stream" }), {
        e2e: !0,
        expect: j(ne, Q),
        ...tn ? { extra: tn } : {}
      });
      return typeof Ft.modified == "number" && le.set(ne, { size: Ft.size, modified: Ft.modified }), i("saved", { path: Ft.path || Q.path, size: Ft.size, index: ne }), x.value = !1, i("dirty", !1), { saved: !0, size: Ht };
    }
    function Tt(ne) {
      if (I.value) throw new lt("unavailable", `${ne} is not offered while a file of an encrypted folder is open`);
    }
    const $t = S(null), it = E(() => {
      const ne = (a.title || "").trim();
      return ne ? ne.toLowerCase().includes(a.app.toLowerCase()) ? ne : `${ne} (${a.app})` : a.app;
    }), yt = S(null);
    let ft = Number.NEGATIVE_INFINITY, ze = Number.NEGATIVE_INFINITY;
    function oe() {
      const ne = typeof navigator < "u" ? navigator.userActivation : void 0;
      return !!(ne != null && ne.isActive);
    }
    function Se() {
      ze = Date.now();
    }
    function he() {
      if (!oe()) return !1;
      const ne = Date.now();
      return ne - ft < _1 || ne - ze < _1 ? !1 : (ft = ne, !0);
    }
    async function Ke(ne) {
      he() || await wt(ne);
    }
    const Le = S(!1);
    let ut = null;
    async function wt(ne) {
      if (yt.value) throw new lt("unavailable", "a question is already on screen");
      if (Le.value = !1, ut && clearTimeout(ut), ut = setTimeout(() => {
        Le.value = !0;
      }, x1), !await new Promise((Ae) => {
        yt.value = { text: ne, resolve: Ae };
      })) throw new lt("cancelled");
    }
    function _t() {
      return r("appframe.consent_clipboard", { app: it.value });
    }
    function At(ne) {
      return r("appframe.consent_job", { app: it.value, action: ne });
    }
    function _e(ne) {
      return r("appframe.consent_download", { app: it.value, name: ne });
    }
    function Ie(ne) {
      return r("appframe.consent_print", { app: it.value, name: ne });
    }
    function pe() {
      return r("appframe.consent_allow");
    }
    function we(ne) {
      if (ne && !Le.value) return;
      const Q = yt.value;
      yt.value = null, ut && clearTimeout(ut), ut = null, Q == null || Q.resolve(ne);
    }
    function ee(ne) {
      const Q = typeof ne == "string" ? ne.trim() : "";
      if (!Q || Q.length > 255 || Q === "." || Q === ".." || /[\\/\u0000-\u001f]/.test(Q))
        throw new lt("invalid", "name is a file name, without a folder");
      return Q;
    }
    function ge() {
      return new lt("too_large", `at most ${ga.maxDownloadBytes >> 20} MiB`);
    }
    async function* ae(ne) {
      if (typeof ne == "string") {
        yield new TextEncoder().encode(ne);
        return;
      }
      if (ne instanceof ArrayBuffer) {
        yield new Uint8Array(ne);
        return;
      }
      const Q = ne.getReader();
      let Ae = !1;
      try {
        for (; ; ) {
          const at = await Q.read();
          if (at.done) {
            Ae = !0;
            return;
          }
          at.value && (yield at.value);
        }
      } finally {
        Ae || await Q.cancel().catch(() => {
        });
      }
    }
    async function xe(ne, Q, Ae) {
      var tn;
      const at = window.showSaveFilePicker;
      if (typeof at == "function") {
        let Ft = null;
        try {
          Ft = await at.call(window, { suggestedName: ne });
        } catch (yn) {
          if ((yn == null ? void 0 : yn.name) === "AbortError") throw new lt("cancelled");
          Ft = null;
        }
        if (Ft) {
          const yn = await Ft.createWritable();
          let Nn = 0;
          try {
            for await (const jt of ae(Q)) {
              if (Nn += jt.byteLength, Nn > ga.maxDownloadBytes) throw ge();
              await yn.write(jt);
            }
          } catch (jt) {
            throw await ((tn = yn.abort) == null ? void 0 : tn.call(yn).catch(() => {
            })), jt;
          }
          return await yn.close(), { saved: !0, size: Nn };
        }
      }
      const ct = [];
      let zt = 0;
      for await (const Ft of ae(Q)) {
        if (zt += Ft.byteLength, zt > ga.maxDownloadBytes) throw ge();
        ct.push(Ft);
      }
      const Ht = URL.createObjectURL(new Blob(ct, { type: Ae })), Wt = document.createElement("a");
      Wt.href = Ht, Wt.download = ne, Wt.rel = "noopener", Wt.style.display = "none", document.body.appendChild(Wt);
      try {
        Wt.click();
      } finally {
        Wt.remove(), setTimeout(() => URL.revokeObjectURL(Ht), 6e4);
      }
      return { saved: !0, size: zt };
    }
    const Fe = S(null), ye = S(null);
    let Te = null, Ue = null, xt = !1;
    function Qt() {
      Ue == null || Ue.abort(), Ue = null, Te == null || Te.remove(), Te = null, Fe.value = null;
    }
    function vn() {
      Ue == null || Ue.abort();
    }
    function Ut() {
      const ne = c.value;
      if (!ne) return {};
      const Q = document.createElement("span");
      Q.className = "fe-btn fe-btn--primary", Q.setAttribute("aria-hidden", "true"), Q.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;inset-inline-start:0;top:0", Q.textContent = r("appframe.consent_allow"), ne.appendChild(Q);
      try {
        return DF(Q);
      } finally {
        Q.remove();
      }
    }
    function pn() {
      return new lt("too_large", `at most ${ga.maxPrintBytes >> 20} MiB`);
    }
    const Rt = S(null);
    let rn = !1, nn = null;
    function gt() {
      var at, ct;
      const ne = ((ct = (at = a.files) == null ? void 0 : at[0]) == null ? void 0 : ct.path) ?? "", Q = ne.includes("://") ? vg(ne, !1) ?? "" : "";
      if (Q && !Lf(Q)) return Q;
      const Ae = a.startAt ?? "";
      return Ae.includes("://") && !Lf(Ae) ? Ae : Q ? hv(Q) : void 0;
    }
    async function wn(ne) {
      var Q;
      if ((Q = a.storages) != null && Q.length) return a.storages;
      if (nn) return nn;
      try {
        const Ae = await a.api.index(ne ?? "");
        return nn = Array.isArray(Ae == null ? void 0 : Ae.storages) ? Ae.storages.filter((at) => typeof at == "string" && !!at) : [], nn;
      } catch {
        return [];
      }
    }
    async function ra(ne) {
      if (rn || Rt.value) throw new lt("unavailable", "a question is already on screen");
      rn = !0;
      try {
        const Q = gt(), Ae = await wn(Q);
        if (!Q && !Ae.length) throw new lt("unavailable", "there is no folder to save into here");
        return await new Promise((at) => {
          Rt.value = { name: ne, storages: Ae, startAt: Q, resolve: at };
        });
      } finally {
        rn = !1;
      }
    }
    function dn(ne) {
      const Q = Rt.value;
      Rt.value = null, Q == null || Q.resolve(ne);
    }
    function jn(ne) {
      return r("appframe.save_as_title", { app: it.value, name: ne });
    }
    async function zn(ne) {
      typeof ReadableStream < "u" && ne instanceof ReadableStream && await ne.cancel().catch(() => {
      });
    }
    async function Bn(ne) {
      try {
        const Ae = (await a.api.pluginActions()).actions.find((ct) => ct.plugin === a.app && ct.id === ne), at = Ae ? Zt(Ae.label, a.locale) : "";
        if (at) return at;
      } catch {
      }
      return ne;
    }
    const Sn = {
      "session.get": () => re(),
      async "file.read"(ne) {
        ve("files:read");
        const Q = ne ?? {}, Ae = W(Q.index);
        if (F(Ae)) return Be(Ae, Q.as);
        const at = a.api.pluginUIRead, ct = typeof at == "function" ? await at(a.app, a.view, Ae.path) : await a.api.fetchResponse(Ae.path), zt = Number(ct.headers.get("content-length") ?? Ae.size ?? 0) || (Ae.size ?? 0), Ht = Ae.mime || ct.headers.get("content-type") || "", Wt = vU(ct.headers.get(mU));
        Wt && le.set(typeof Q.index == "number" ? Q.index : 0, Wt);
        const tn = rO(ct.headers.get(oO)), Ft = { name: Ae.name, size: zt, mime: Ht, ...tn ? { text_dialect: tn } : {} };
        switch (Q.as ?? "stream") {
          case "text": {
            if (zt > ga.maxTextBytes) throw new lt("too_large", "read a file this large as a stream");
            return tn && tn.encoding !== "utf-8" ? { ...Ft, text: sO(await ct.arrayBuffer(), tn.encoding) } : { ...Ft, text: await ct.text() };
          }
          case "bytes":
            return { ...Ft, bytes: await ct.arrayBuffer() };
          case "stream":
            return ct.body ? { ...Ft, stream: ct.body } : { ...Ft, bytes: await ct.arrayBuffer() };
          default:
            throw new lt("invalid", "as is stream, bytes or text");
        }
      },
      async "file.save"(ne) {
        ve("files:write");
        const Q = ne ?? {}, Ae = typeof Q.index == "number" ? Q.index : 0, at = W(Ae);
        if (Z(at)) throw new lt("read_only", "this file cannot be saved over here");
        if (y2(Q.csv) === null) throw new lt("invalid", "csv is {delimiter, encoding, bom, eol}");
        const ct = gU(Q);
        if (ct === null) throw new lt("invalid", "beside is a file extension; conflict is 'copy'");
        if (F(at)) {
          if (ct.beside && ct.beside !== $(at.name))
            throw new lt("unavailable", "a file of an encrypted folder is saved only in its own format");
          return qe(Ae, at, Q.data, Q.through);
        }
        const zt = await z(Q.data, Q.mime), Ht = mn && typeof Q.through == "number" ? mn.saveParams(Q.through) : null, Wt = Ae === 0 && a.savePath ? a.savePath : at.path, tn = Ht ? Wt : fe.get(Ae) ?? Wt, Ft = ct.conflict && !Ht ? j(Ae, at) : void 0, yn = { ...Ht ?? {} };
        ct.beside && (yn.beside = ct.beside), ct.conflict && (yn.conflict = ct.conflict);
        const Nn = {
          ...Object.keys(yn).length ? { extra: yn } : {},
          ...Q.csv ? { csv: Q.csv } : {},
          ...Ft ? { expect: Ft } : {}
        }, jt = Object.keys(Nn).length ? await a.api.pluginUISave(a.app, a.view, { path: tn }, zt, Nn) : await a.api.pluginUISave(a.app, a.view, { path: tn }, zt);
        typeof jt.modified == "number" && le.set(Ae, { size: jt.size, modified: jt.modified }), !Ht && jt.path && jt.path !== tn && (jt.beside || jt.conflict) && fe.set(Ae, jt.path), i("saved", { path: jt.path || tn, size: jt.size, index: Ae }), x.value = !1, i("dirty", !1);
        const ce = jt.beside || typeof jt.conflict == "string";
        return {
          saved: !0,
          size: jt.size,
          ...ce && jt.name ? { name: jt.name } : {},
          ...jt.beside ? { beside: !0 } : {},
          ...typeof jt.conflict == "string" ? { conflict: jt.conflict } : {}
        };
      },
      async "file.saveAs"(ne) {
        ve("files:write");
        const Q = ne ?? {}, Ae = typeof Q.name == "string" ? Q.name.trim() : "";
        if (!Ae || Ae.includes("/") || Ae.includes("\\") || Ae === "." || Ae === ".." || Ae.length > 255)
          throw new lt("invalid", "name is a file name, without a folder");
        I.value && (typeof ReadableStream < "u" && Q.data instanceof ReadableStream && await Q.data.cancel().catch(() => {
        }), Tt("save as"));
        const at = await z(Q.data, Q.mime);
        let ct;
        try {
          ct = await ra(Ae);
        } catch (Ht) {
          throw await zn(at), Ht;
        }
        if (!ct)
          throw await zn(at), new lt("cancelled");
        const zt = await a.api.pluginUISave(a.app, a.view, { dir: ct, name: Ae }, at);
        return i("saved-as", { path: zt.path, name: zt.name, size: zt.size }), { saved: !0, name: zt.name, size: zt.size };
      },
      "ui.dirty"(ne) {
        return x.value = !!(ne != null && ne.dirty), i("dirty", x.value), null;
      },
      "ui.title"(ne) {
        const Q = String((ne == null ? void 0 : ne.text) ?? "").slice(0, ga.maxLineChars);
        return i("title", Q), null;
      },
      "ui.toast"(ne) {
        const Q = ne ?? {}, Ae = Q.tone === "success" || Q.tone === "warning" || Q.tone === "error" ? Q.tone : "info";
        return i("toast", { text: `${it.value}: ${String(Q.text ?? "").slice(0, ga.maxLineChars)}`, tone: Ae }), null;
      },
      "ui.confirm"(ne) {
        const Q = typeof ne == "object" && ne ? ne : {};
        if ($t.value) throw new lt("unavailable", "a question is already on screen");
        return new Promise((Ae) => {
          $t.value = {
            text: String(Q.text ?? "").slice(0, 1e3),
            title: Q.title ? String(Q.title).slice(0, ga.maxLineChars) : void 0,
            danger: !!Q.danger,
            resolve: Ae
          };
        });
      },
      "ui.close"() {
        return i("close"), null;
      },
      async "clipboard.write"(ne) {
        var Ae;
        const Q = String((ne == null ? void 0 : ne.text) ?? "");
        if (Q.length > 1 << 20) throw new lt("too_large", "at most 1 MiB of text");
        if (typeof navigator > "u" || !((Ae = navigator.clipboard) != null && Ae.writeText))
          throw new lt("unavailable", "this browser offers no clipboard here");
        if (he())
          try {
            return await navigator.clipboard.writeText(Q), null;
          } catch (at) {
            if ((at == null ? void 0 : at.name) !== "NotAllowedError") throw at;
          }
        return await wt(_t()), await navigator.clipboard.writeText(Q), null;
      },
      async "ui.download"(ne) {
        ve("ui:download");
        const Q = ne ?? {}, Ae = ee(Q.name), at = Q.data, ct = typeof ReadableStream < "u" && at instanceof ReadableStream;
        if (typeof at != "string" && !(at instanceof ArrayBuffer) && !ct)
          throw new lt("invalid", "download takes a string, an ArrayBuffer or a ReadableStream");
        if ((typeof at == "string" ? new Blob([at]).size : at instanceof ArrayBuffer ? at.byteLength : 0) > ga.maxDownloadBytes) throw ge();
        const Ht = typeof Q.mime == "string" && /^[\w.+-]+\/[\w.+-]+$/.test(Q.mime) ? Q.mime : "application/octet-stream";
        try {
          await Ke(_e(Ae));
        } catch (Wt) {
          throw ct && await at.cancel().catch(() => {
          }), Wt;
        }
        return xe(Ae, at, Ht);
      },
      /**
       * 0.55: print a PDF the interface hands over (`ui:print`) - the print
       * dialog can save the PDF, so it is the person's call every time: filex
       * asks, and the dialog opens on their click on the row's Allow, a button of
       * the server's print page (lib/printPdf; security review sec055 S9). The
       * PDF is held once, as one Blob: refused at its first bytes when they are
       * not a PDF's and past LIMITS.maxPrintBytes (S10). `unavailable` where the
       * host names no print page, or while another print is being asked about.
       */
      async "ui.print"(ne) {
        ve("ui:print");
        const Q = ne ?? {}, Ae = Q.data, at = typeof ReadableStream < "u" && Ae instanceof ReadableStream, ct = async () => {
          at && await Ae.cancel().catch(() => {
          });
        };
        let zt = "";
        try {
          if (zt = ee(Q.name), !(Ae instanceof ArrayBuffer) && !at)
            throw new lt("invalid", "print takes a PDF as an ArrayBuffer or a ReadableStream");
          if (Q.mime !== void 0 && Q.mime !== "application/pdf") throw new lt("invalid", "print takes a PDF (application/pdf)");
          if (Ae instanceof ArrayBuffer && Ae.byteLength > ga.maxPrintBytes) throw pn();
          if (Ae instanceof ArrayBuffer && !Gu(Ae)) throw new lt("invalid", "the data is not a PDF");
        } catch (Wt) {
          throw await ct(), Wt;
        }
        const Ht = typeof a.api.printFrameUrl == "function" ? a.api.printFrameUrl() : "";
        if (!Ht)
          throw await ct(), new lt("unavailable", "this host offers no printing");
        if (xt)
          throw await ct(), new lt("unavailable", "another print is waiting for the person");
        xt = !0;
        try {
          let Wt;
          try {
            Wt = await PF(Ae instanceof ArrayBuffer ? Ae : ae(Ae), ga.maxPrintBytes);
          } catch (Ft) {
            throw Ft instanceof da ? Ft.code === "too_large" ? pn() : new lt(Ft.code, Ft.message) : Ft;
          }
          Qt();
          const tn = new AbortController();
          Ue = tn, Fe.value = { text: Ie(zt), shown: !1, width: 0, height: 0 }, await Jt();
          try {
            Te = await NF(Ht, Wt, {
              mount: ye.value ?? c.value,
              label: pe(),
              look: Ut(),
              armMs: x1,
              signal: tn.signal,
              onAsk: ({ width: Ft, height: yn }) => {
                Ue === tn && Fe.value && (Fe.value = { ...Fe.value, shown: !0, width: Ft, height: yn });
              }
            });
          } catch (Ft) {
            throw Ue === tn && (Fe.value = null), Ft instanceof da ? new lt(Ft.code, Ft.message) : Ft;
          }
          return Fe.value && (Fe.value = { ...Fe.value, shown: !1 }), { printed: !0, size: Wt.size };
        } finally {
          xt = !1, Ue = null;
        }
      },
      async "engine.call"(ne) {
        if (!C.value.engine) throw new lt("unavailable", "this app has no module");
        Tt("the app's module");
        const Q = ne ?? {};
        if (typeof Q.method != "string" || !Q.method) throw new lt("invalid", "method is required");
        return (await a.api.pluginUICall(a.app, a.view, {
          method: Q.method,
          params: Q.params,
          paths: (a.files ?? []).map((at) => at.path)
        })).result;
      },
      async "job.submit"(ne) {
        if (!C.value.engine) throw new lt("unavailable", "this app has no module");
        Tt("the app's module");
        const Q = ne ?? {};
        if (typeof Q.action != "string" || !Q.action) throw new lt("invalid", "action is required");
        he() || await wt(At(await Bn(Q.action)));
        const at = (await a.api.pluginActionRun(a.app, Q.action, {
          paths: (a.files ?? []).map((ct) => ct.path),
          params: Q.params && typeof Q.params == "object" ? Q.params : {}
        })).op;
        if (!at) throw new lt("failed", "nothing was queued");
        return i("op", at), { op: at };
      },
      /* An encrypted session (the frame holds plaintext of an encrypted folder)
         reads and writes its own sealed store; a locked folder reads as an empty
         one. Any other session: the app's ordinary store, as always. */
      async "state.get"(ne) {
        const Q = String((ne == null ? void 0 : ne.key) ?? "");
        if (I.value) {
          const Ae = await V().catch(() => null);
          return Ae ? await JF(a.app, Ae, Q) ?? null : null;
        }
        return xF(a.app, Q) ?? null;
      },
      /**
       * 0.52.0: what the app's license says (`LicenseInfo`) - the status, and for a
       * valid license its dates. filex keeps the key and the licensee's name; the
       * app sees neither (only these three fields cross the bridge, whatever the
       * server answers). A free app reads `{status: "free"}`.
       */
      async "license.get"() {
        const ne = await a.api.pluginLicense(a.app), Q = { status: String(ne.status ?? "free") };
        return ne.valid_until && (Q.valid_until = ne.valid_until), ne.updates_until && (Q.updates_until = ne.updates_until), Q;
      },
      async "state.set"(ne) {
        const Q = ne ?? {};
        try {
          if (I.value) {
            const Ae = await V();
            if (!Ae) throw te();
            await ZF(a.app, Ae, String(Q.key ?? ""), Q.value);
          } else
            SF(a.app, String(Q.key ?? ""), Q.value);
        } catch (Ae) {
          throw Ae instanceof vc ? new lt("too_large", Ae.message) : Ae instanceof g$ ? new lt("unavailable", G()) : Ae;
        }
        return null;
      },
      /* ── editing together (0.56, files:co-edit) ─────────────────────────── */
      async "coedit.join"(ne) {
        ve("files:co-edit"), ve("files:read");
        const Ae = W((ne ?? {}).index), at = ju(Ae.encrypted), ct = a.e2e;
        if (at && (Ae.encrypted !== "folder" || !F(Ae) || typeof (ct == null ? void 0 : ct.folderKeys) != "function"))
          throw new lt("unavailable", "encrypted");
        const zt = at && (ct != null && ct.folderKeys) ? () => ct.folderKeys(Ae.path) : void 0, Ht = $n();
        if (!Ht) throw new lt("unavailable", "this host offers no editing together");
        const Wt = mn;
        mn = null, Wt && await Wt.leave();
        const tn = await up.join(Ht, Ae.path, {
          entry: (Ft) => m == null ? void 0 : m.emit("coedit.entry", Ft),
          cursor: (Ft) => m == null ? void 0 : m.emit("coedit.cursor", Ft),
          dropped: (Ft) => {
            mn === tn && (mn = null), m == null || m.emit("coedit.dropped", Ft);
          }
        }, { folder: zt, outbox: Fn(), askUnsent: me });
        if (!m)
          throw tn.leave({ keepalive: !0 }), new lt("unavailable", "gone");
        return mn = tn, tn.hello();
      },
      "coedit.subscribe"(ne) {
        const Q = ne ?? {};
        return sn().subscribe(Number(Q.from ?? 0)), null;
      },
      async "coedit.append"(ne) {
        const Q = ne ?? {};
        return sn().append(Q.kind, Q.body);
      },
      async "coedit.lease"(ne) {
        const Q = ne ?? {};
        return { granted: await sn().lease(Q.op, Number(Q.changesSeen ?? 0)) };
      },
      "coedit.cursor"(ne) {
        return sn().cursor(ne == null ? void 0 : ne.cursor), null;
      },
      async "coedit.blob.put"(ne) {
        const Q = sn(), Ae = ne ?? {};
        if (!(Ae.data instanceof ArrayBuffer)) throw new lt("invalid", "a blob is an ArrayBuffer");
        return await Q.putBlob(String(Ae.name ?? ""), Ae.data), null;
      },
      async "coedit.blob.get"(ne) {
        const Ae = String((ne ?? {}).name ?? "");
        return { name: Ae, bytes: await sn().getBlob(Ae) };
      },
      async "coedit.leave"() {
        const ne = mn;
        return mn = null, await (ne == null ? void 0 : ne.leave()), null;
      }
    };
    let mn = null;
    function sn() {
      if (!mn) throw new lt("unavailable", "not in a session (coedit.join first)");
      return mn;
    }
    function $n() {
      const ne = a.api;
      return typeof ne.coeditJoin != "function" || typeof ne.coeditCall != "function" ? null : {
        join: (Q, Ae) => ne.coeditJoin(a.app, a.view, Q, Ae),
        call: (Q, Ae, at, ct) => ne.coeditCall(a.app, a.view, Q, Ae, at, ct),
        putBlob: (Q, Ae, at, ct) => ne.coeditBlobPut(a.app, a.view, Q, Ae, at, ct),
        getBlob: (Q, Ae, at) => ne.coeditBlobGet(a.app, a.view, Q, Ae, at)
      };
    }
    let Rn = null;
    function Fn() {
      return Rn ?? (Rn = IU()), Rn;
    }
    const Tn = S(null);
    function me(ne) {
      return Tn.value ? Promise.resolve(null) : new Promise((Q) => {
        Tn.value = { ...ne, resolve: Q };
      });
    }
    function De(ne) {
      const Q = Tn.value;
      Tn.value = null, Q == null || Q.resolve(ne);
    }
    function He() {
      const ne = mn;
      mn = null, ne && ne.leave({ keepalive: !0 });
    }
    function Ve(ne) {
      const Q = $t.value;
      $t.value = null, Q == null || Q.resolve(ne);
    }
    function bt() {
      const ne = document.createElement("iframe");
      return ne.setAttribute("sandbox", "allow-scripts"), ne.setAttribute("referrerpolicy", "no-referrer"), ne.setAttribute("title", a.title || a.app), ne.className = "fe-appframe__frame", ne.dataset.testid = "app-frame", ne.setAttribute("src", R.value), ne;
    }
    function Qe() {
      if (se(), !c.value) return;
      const ne = bt(), Q = sF({
        frame: () => ne,
        handlers: Sn,
        onConnect: () => {
          v.value = !0, i("connected");
        },
        onDisconnect: () => {
          v.value = !1;
        }
      });
      ne.addEventListener("load", () => Q.frameLoaded()), p = ne, m = Q, c.value.appendChild(ne);
    }
    function se() {
      He(), Tn.value && De(null), m == null || m.destroy(), m = null, Qt(), p && (p.remove(), p = null), v.value = !1, x.value = !1, $t.value && Ve(!1), yt.value && we(!1), k.value && ue("keep"), Rt.value && dn(null);
    }
    let je = null;
    const dt = ["pointerdown", "keydown", "touchstart"];
    qt(() => {
      oe() && (ze = Date.now());
      for (const Q of dt) window.addEventListener(Q, Se, !0);
      window.addEventListener("pagehide", He), Qe(), je = FP((Q, Ae) => {
        Q !== a.app || !Ae || Ae === L.value || (A.value = Ae, Pe(Ae));
      });
      const ne = L.value;
      if (ne) {
        const Q = $F(a.app);
        Q && Q !== ne && (T.value = ne), Q !== ne && u1(a.app, ne);
      }
    }), Ct(() => {
      for (const ne of dt) window.removeEventListener(ne, Se, !0);
      window.removeEventListener("pagehide", He), je == null || je(), je = null, se();
    }), Xe([R, w], () => Qe()), Xe(
      () => a.ui,
      () => {
        b.value = null;
      }
    ), Xe(U, () => m == null ? void 0 : m.emit("theme", H())), Xe(
      () => a.locale,
      (ne) => m == null ? void 0 : m.emit("locale", { locale: ne, dir: hl(ne) })
    );
    async function tt() {
      if (!m || !v.value) return !1;
      try {
        return await m.ask("save"), !0;
      } catch {
        return !1;
      }
    }
    async function ie() {
      if (!x.value || !v.value)
        return Ge(), !0;
      const ne = await new Promise((Q) => {
        k.value = Q;
      });
      if (ne === "keep") return !1;
      if (ne === "save") {
        _.value = !0;
        try {
          if (!await tt()) return !1;
        } finally {
          _.value = !1;
        }
      }
      return Ge(), !0;
    }
    function ue(ne) {
      const Q = k.value;
      k.value = null, Q == null || Q(ne);
    }
    function Pe(ne) {
      m == null || m.emit("app.updated", { version: ne });
    }
    function Ge() {
      m == null || m.emit("close.request");
    }
    function ot() {
      w.value++;
    }
    async function St() {
      var Ae, at;
      if (!await ie()) return;
      const ne = A.value;
      let Q = null;
      try {
        const ct = await a.api.pluginActions();
        Q = ((Ae = ct.views.find((zt) => zt.plugin === a.app && zt.id === a.view && zt.ui)) == null ? void 0 : Ae.ui) ?? ((at = ct.actions.find((zt) => zt.plugin === a.app && zt.view === a.view && zt.ui)) == null ? void 0 : at.ui) ?? null;
      } catch {
      }
      A.value = "", T.value = "", Q && (b.value = Q, u1(a.app, Q.version || ne)), ot();
    }
    function Et() {
      A.value = "", T.value = "";
    }
    return t({ requestSave: tt, confirmClose: ie, notifyUpdated: Pe, notifyClosing: Ge, reload: ot, reloadNewer: St, connected: v, dirty: x }), (ne, Q) => (f(), h("div", {
      ref_key: "host",
      ref: c,
      class: Ne(["fe-appframe", `fe-appframe--${e.placement}`]),
      "data-app": e.app,
      "data-connected": v.value ? "true" : "false"
    }, [
      A.value || T.value ? (f(), h("div", WU, [
        d("span", YU, y(A.value ? u(r)("appframe.updated_reload", { app: e.title || e.app }) : u(r)("appframe.updated", { app: e.title || e.app, version: T.value })), 1),
        A.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-reload",
          onClick: St
        }, y(u(r)("appframe.reload")), 1)) : D("", !0),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-dismiss",
          onClick: Et
        }, y(u(r)("appframe.dismiss")), 1)
      ])) : D("", !0),
      Tn.value ? (f(), h("div", GU, [
        d("span", XU, y(Tn.value.text), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-unsent-apply",
          onClick: Q[0] || (Q[0] = (Ae) => De(!0))
        }, y(Tn.value.apply), 1),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-unsent-discard",
          onClick: Q[1] || (Q[1] = (Ae) => De(!1))
        }, y(Tn.value.discard), 1)
      ])) : D("", !0),
      yt.value ? (f(), h("div", JU, [
        d("span", ZU, y(yt.value.text), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          "data-testid": "appframe-consent-allow",
          disabled: !Le.value,
          onClick: Q[2] || (Q[2] = (Ae) => we(!0))
        }, y(u(r)("appframe.consent_allow")), 9, QU),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-consent-deny",
          onClick: Q[3] || (Q[3] = (Ae) => we(!1))
        }, y(u(r)("appframe.consent_deny")), 1)
      ])) : D("", !0),
      Fe.value ? (f(), h("div", {
        key: 3,
        class: Ne(["fe-appframe__note fe-appframe__consent fe-appframe__print", { "fe-appframe__print--parked": !Fe.value.shown }]),
        role: Fe.value.shown ? "alertdialog" : void 0,
        "aria-live": Fe.value.shown ? "assertive" : void 0,
        "aria-hidden": Fe.value.shown ? void 0 : "true",
        inert: Fe.value.shown ? void 0 : !0,
        "data-shown": Fe.value.shown ? "true" : "false",
        "data-testid": "appframe-print-ask"
      }, [
        d("span", tH, y(Fe.value.text), 1),
        d("span", {
          ref_key: "printSlot",
          ref: ye,
          class: "fe-appframe__print-slot",
          style: Xt(Fe.value.shown ? { width: `${Fe.value.width}px`, height: `${Fe.value.height}px` } : void 0)
        }, null, 4),
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "appframe-print-deny",
          onClick: vn
        }, y(u(r)("appframe.consent_deny")), 1)
      ], 10, eH)) : D("", !0),
      $t.value ? (f(), We(D$, {
        key: 4,
        open: !0,
        locale: e.locale,
        theme: e.theme,
        title: `${it.value}: ${$t.value.title || u(r)("appframe.confirm_title")}`,
        message: $t.value.text,
        danger: $t.value.danger,
        onClose: Q[4] || (Q[4] = (Ae) => Ve(!1)),
        onConfirm: Q[5] || (Q[5] = (Ae) => Ve(!0))
      }, null, 8, ["locale", "theme", "title", "message", "danger"])) : D("", !0),
      k.value ? (f(), We(na, {
        key: 5,
        open: !0,
        size: "sm",
        locale: e.locale,
        theme: e.theme,
        busy: _.value,
        title: u(r)("appframe.unsaved_title"),
        onClose: Q[9] || (Q[9] = (Ae) => ue("keep"))
      }, {
        actions: mt(() => [
          d("button", {
            type: "button",
            class: "fe-btn",
            "data-testid": "appframe-keep",
            disabled: _.value,
            onClick: Q[6] || (Q[6] = (Ae) => ue("keep"))
          }, y(u(r)("appframe.keep_open")), 9, aH),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--danger",
            "data-testid": "appframe-discard",
            disabled: _.value,
            onClick: Q[7] || (Q[7] = (Ae) => ue("discard"))
          }, y(u(r)("appframe.discard")), 9, iH),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "appframe-save-close",
            disabled: _.value,
            onClick: Q[8] || (Q[8] = (Ae) => ue("save"))
          }, y(u(r)("appframe.save_close")), 9, oH)
        ]),
        default: mt(() => [
          d("p", nH, y(u(r)("appframe.unsaved_text", { app: e.title || e.app })), 1)
        ]),
        _: 1
      }, 8, ["locale", "theme", "busy", "title"])) : D("", !0),
      Rt.value ? (f(), We(bg, {
        key: 6,
        open: !0,
        api: e.api,
        locale: e.locale,
        theme: e.theme,
        mode: "save",
        title: jn(Rt.value.name),
        storages: Rt.value.storages,
        "start-at": Rt.value.startAt,
        onClose: Q[10] || (Q[10] = (Ae) => dn(null)),
        onPick: dn
      }, null, 8, ["api", "locale", "theme", "title", "storages", "start-at"])) : D("", !0)
    ], 10, qU));
  }
}), rH = ["data-testid"], sH = { class: "fe-inspector__heading fe-pinsp__heading" }, lH = ["aria-expanded", "aria-controls", "data-testid"], uH = ["id"], cH = ["id"], dH = {
  key: 0,
  class: "fe-inspector__empty"
}, fH = {
  key: 1,
  class: "fe-surface__error",
  role: "alert"
}, pH = {
  key: 0,
  class: "fe-pinsp__actions"
}, hH = /* @__PURE__ */ rt({
  __name: "PluginInspectorSection",
  props: {
    api: {},
    view: {},
    path: {},
    locale: {},
    theme: {},
    storages: {},
    node: {},
    writable: { type: Boolean },
    userName: {}
  },
  emits: ["op", "toast", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(!1), l = S(!1), c = S(""), p = Np(
      {
        api: n.api,
        plugin: n.view.plugin,
        view: n.view.id,
        path: () => n.path,
        locale: () => n.locale,
        errorText: () => i("plugin.view.error")
      },
      {
        onOp: (w) => a("op", w),
        onOpen: (w) => a("open", w),
        // The conversation ended (a job was queued, or the plugin said `done`):
        // what the section shows next is the view's fresh state.
        onDone: () => void x(),
        onToast: (w) => a("toast", w)
      }
    ), m = E(() => Zt(n.view.label, n.locale) || n.view.id), v = E(() => `fe-plugin-insp-${n.view.plugin}-${n.view.id}`);
    async function x() {
      var w;
      l.value = !0, c.value = "";
      try {
        const b = await n.api.pluginView(n.view.plugin, n.view.id, n.path);
        p.setSurface((b == null ? void 0 : b.surface) ?? null), b != null && b.surface || (c.value = i("plugin.view.error"));
      } catch (b) {
        p.setSurface(null), c.value = ((w = i.foreign) == null ? void 0 : w.call(i, String((b == null ? void 0 : b.message) ?? b))) || i("plugin.view.error");
      } finally {
        l.value = !1;
      }
    }
    const k = E(
      () => n.node && n.node.type === "file" ? [{
        path: n.node.path,
        name: n.node.basename,
        size: n.node.size,
        mime: n.node.mime_type,
        readOnly: n.writable === !1 || !!n.node.read_only,
        ...n.node.encrypted ? { encrypted: n.node.encrypted } : {}
      }] : []
    );
    function _() {
      r.value = !r.value, !n.view.ui && r.value && !p.current.value && !l.value && x();
    }
    return Xe(
      () => n.path,
      () => {
        r.value = !1, c.value = "", p.setSurface(null);
      }
    ), (w, b) => (f(), h("section", {
      class: "fe-inspector__section fe-pinsp",
      "data-testid": `inspector-plugin-${e.view.plugin}-${e.view.id}`
    }, [
      d("h3", sH, [
        d("button", {
          type: "button",
          class: "fe-pinsp__toggle",
          "aria-expanded": r.value,
          "aria-controls": v.value,
          "data-testid": `inspector-plugin-toggle-${e.view.plugin}-${e.view.id}`,
          onClick: _
        }, [
          (f(), h("svg", {
            class: Ne(["fe-ficon fe-pinsp__chev", { "is-open": r.value }]),
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [...b[2] || (b[2] = [
            d("path", { d: "M9 5l7 7-7 7" }, null, -1)
          ])], 2)),
          d("span", null, y(m.value), 1)
        ], 8, lH)
      ]),
      r.value && e.view.ui ? (f(), h("div", {
        key: 0,
        id: v.value,
        class: "fe-pinsp__body"
      }, [
        (f(), We(Sg, {
          key: e.path,
          api: e.api,
          app: e.view.plugin,
          version: e.view.ui.version,
          view: e.view.id,
          placement: "inspector",
          ui: e.view.ui,
          files: k.value,
          storages: e.storages,
          "start-at": e.path,
          locale: e.locale,
          theme: e.theme,
          title: m.value,
          "user-name": e.userName,
          onToast: b[0] || (b[0] = (C) => a("toast", C.text)),
          onOp: b[1] || (b[1] = (C) => a("op", C))
        }, null, 8, ["api", "app", "version", "view", "ui", "files", "storages", "start-at", "locale", "theme", "title", "user-name"]))
      ], 8, uH)) : r.value ? (f(), h("div", {
        key: 1,
        id: v.value,
        class: "fe-pinsp__body"
      }, [
        l.value ? (f(), h("p", dH, y(u(i)("plugin.view.loading")), 1)) : c.value ? (f(), h("p", fH, y(c.value), 1)) : u(p).current.value ? (f(), h(Ce, { key: 2 }, [
          Je(Ip, {
            conv: u(p),
            locale: e.locale,
            theme: e.theme,
            api: e.api,
            plugin: e.view.plugin,
            storages: e.storages,
            "start-at": e.path
          }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"]),
          u(p).footer.value.length ? (f(), h("div", pH, [
            Je(Bp, {
              conv: u(p),
              locale: e.locale,
              "testid-prefix": "inspector-plugin",
              small: ""
            }, null, 8, ["conv", "locale"])
          ])) : D("", !0)
        ], 64)) : D("", !0)
      ], 8, cH)) : D("", !0)
    ], 8, rH));
  }
}), mH = ["aria-label"], vH = { class: "fe-inspector__head" }, yH = ["innerHTML"], gH = { class: "fe-inspector__head-text" }, bH = ["title"], kH = { class: "fe-inspector__caption" }, wH = {
  key: 0,
  class: "fe-inspector__held",
  role: "note",
  "data-testid": "inspector-held"
}, _H = ["title", "aria-label"], xH = ["innerHTML"], SH = ["title", "aria-label"], $H = ["innerHTML"], TH = ["aria-label"], AH = ["aria-selected"], EH = ["aria-selected"], CH = { class: "fe-inspector__scroll" }, zH = {
  key: 0,
  class: "fe-inspector__section"
}, MH = { class: "fe-inspector__heading" }, OH = {
  key: 0,
  class: "fe-inspector__lock",
  role: "note",
  "data-testid": "inspector-lock"
}, PH = ["data-link-state"], DH = {
  key: 2,
  class: "fe-inspector__unavailable",
  role: "note",
  "data-testid": "inspector-unavailable"
}, LH = {
  key: 3,
  class: "fe-inspector__meta"
}, RH = { class: "fe-inspector__row" }, NH = ["title"], IH = ["src"], BH = { class: "fe-inspector__meta" }, FH = { class: "fe-inspector__row" }, UH = { class: "fe-inspector__row" }, HH = { class: "fe-inspector__pathcell" }, KH = ["title"], VH = ["title", "aria-label"], jH = ["innerHTML"], qH = {
  key: 0,
  class: "fe-inspector__row"
}, WH = { class: "fe-inspector__row" }, YH = {
  key: 1,
  class: "fe-inspector__row"
}, GH = { class: "fe-inspector__mime" }, XH = {
  key: 2,
  class: "fe-inspector__row"
}, JH = { class: "fe-inspector__pathcell" }, ZH = { class: "fe-inspector__path" }, QH = ["title", "aria-label"], eK = ["innerHTML"], tK = {
  key: 3,
  class: "fe-inspector__row"
}, nK = { class: "fe-inspector__pathcell" }, aK = ["title"], iK = ["title", "aria-label"], oK = ["innerHTML"], rK = {
  key: 5,
  class: "fe-inspector__empty"
}, sK = {
  key: 1,
  class: "fe-inspector__section",
  "data-testid": "inspector-tags"
}, lK = { class: "fe-inspector__heading" }, uK = {
  key: 3,
  class: "fe-inspector__section"
}, cK = { class: "fe-inspector__heading" }, dK = {
  key: 0,
  class: "fe-inspector__empty"
}, fK = {
  key: 0,
  class: "fe-inspector__empty"
}, pK = {
  key: 1,
  class: "fe-inspector__versions"
}, hK = { class: "fe-inspector__version-main" }, mK = { class: "fe-inspector__version-n" }, vK = { class: "fe-inspector__version-meta" }, yK = {
  key: 0,
  class: "fe-inspector__confirm"
}, gK = { class: "fe-inspector__confirm-q" }, bK = { class: "fe-inspector__check" }, kK = { class: "fe-inspector__confirm-actions" }, wK = ["disabled", "aria-busy", "onClick"], _K = ["disabled"], xK = ["disabled", "onClick"], SK = ["disabled", "aria-busy"], $K = {
  key: 4,
  class: "fe-inspector__section"
}, TK = { class: "fe-inspector__heading" }, AK = { class: "fe-inspector__permrow" }, EK = {
  key: 5,
  class: "fe-inspector__section",
  "data-testid": "inspector-people"
}, CK = { class: "fe-inspector__heading" }, zK = {
  key: 0,
  class: "fe-inspector__empty"
}, MK = {
  key: 1,
  class: "fe-inspector__people"
}, OK = {
  class: "fe-inspector__avatar",
  "aria-hidden": "true"
}, PK = { class: "fe-inspector__person-main" }, DK = ["title"], LK = { class: "fe-inspector__person-sub" }, RK = {
  key: 6,
  class: "fe-inspector__section",
  "data-testid": "inspector-shares"
}, NK = { class: "fe-inspector__heading" }, IK = {
  key: 0,
  class: "fe-inspector__linkrow"
}, BK = ["innerHTML"], FK = { class: "fe-inspector__linknone" }, UK = ["disabled"], HK = {
  key: 1,
  class: "fe-inspector__empty"
}, KK = {
  key: 2,
  class: "fe-inspector__shares"
}, VK = ["title"], jK = {
  key: 0,
  class: "fe-inspector__badge fe-inspector__badge--pin"
}, qK = {
  key: 1,
  class: "fe-inspector__share-exp"
}, WK = ["title", "aria-label", "onClick"], YK = ["innerHTML"], GK = {
  key: 7,
  class: "fe-inspector__section"
}, XK = { class: "fe-inspector__heading" }, JK = {
  key: 0,
  class: "fe-inspector__countbadge"
}, ZK = {
  key: 0,
  class: "fe-inspector__empty"
}, QK = {
  key: 0,
  class: "fe-inspector__empty"
}, e9 = {
  key: 1,
  class: "fe-inspector__comments"
}, t9 = { class: "fe-inspector__comment-top" }, n9 = ["title"], a9 = ["title"], i9 = ["disabled", "title", "aria-label", "onClick"], o9 = { class: "fe-inspector__comment-body" }, r9 = ["placeholder", "aria-label", "disabled"], s9 = ["disabled"], l9 = {
  key: 8,
  class: "fe-inspector__section",
  "data-testid": "inspector-activity-empty"
}, u9 = { class: "fe-inspector__empty" }, c9 = {
  key: 0,
  class: "fe-inspector__hint"
}, d9 = /* @__PURE__ */ rt({
  __name: "InspectorPanel",
  props: {
    api: {},
    nodes: {},
    dirLabel: {},
    dirCount: {},
    dirPerm: { default: "" },
    heldIn: {},
    locale: {},
    narrow: { type: Boolean, default: !1 },
    callerAdmin: { type: Boolean },
    sharing: {},
    inEncrypted: { type: Boolean },
    thumbSrc: { type: Function, default: void 0 },
    tabs: { type: Boolean, default: !0 },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    pluginViews: { default: () => [] },
    theme: {},
    storages: {},
    userName: {}
  },
  emits: ["close", "share-created", "manage-permissions", "toast", "changed", "tags-changed", "open-tag", "plugin-op", "plugin-open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, formatNodeSize: l, nodeSizeHint: c, formatDate: p, nodeDisplayName: m, nodeName: v } = ht(
      () => n.locale
    );
    function x(ye) {
      if (typeof ye.e2e_display_dir != "string" || typeof ye.e2e_stored != "string") return ye.path;
      const Te = ye.path.indexOf("://");
      return `${Te === -1 ? "" : ye.path.slice(0, Te + 3)}${ye.e2e_display_dir ? `${ye.e2e_display_dir}/` : ""}${ye.basename}`;
    }
    const k = E(
      () => n.nodes.length === 1 ? n.nodes[0] : null
    ), _ = E(() => n.nodes.length > 1), w = E(() => Kr(Ic(k.value), { t: i, formatDate: p, locale: n.locale })), b = E(() => Bc(k.value, { t: i })), C = E(() => Fc(k.value, { t: i })), A = E(() => {
      var ye;
      return ((ye = k.value) == null ? void 0 : ye.type) === "file";
    }), T = E(
      () => {
        var ye;
        return typeof ((ye = k.value) == null ? void 0 : ye.id) == "number" ? k.value.id : null;
      }
    ), R = E(
      () => n.nodes.reduce((ye, Te) => ye + (typeof Te.size == "number" ? Te.size : 0), 0)
    ), M = E(() => ({
      size: R.value,
      size_partial: n.nodes.some((ye) => ye.size_partial === !0)
    })), L = E(() => {
      var Te;
      const ye = (Te = k.value) == null ? void 0 : Te.etag;
      return typeof ye == "string" && ye !== "" ? ye : null;
    }), U = E(
      () => k.value && A.value && n.thumbSrc ? n.thumbSrc(k.value) : null
    ), P = E(() => {
      const ye = k.value;
      return !ye || nc(ye) || ye.trashed === !0 ? [] : (n.pluginViews ?? []).filter(
        (Te) => Te.placement === "inspector" && By(Te.applies, [ye], Te.plugin)
      );
    }), H = E(() => _.value ? i("inspector.items", { n: n.nodes.length }) : k.value ? m(k.value) : n.dirLabel), $ = E(() => {
      if (_.value) return l(M.value);
      const ye = k.value;
      if (ye) {
        const Te = Cv(ye, i);
        if (ye.type === "dir") return Te;
        const Ue = typeof ye.size == "number" ? r(ye.size) : "";
        return Ue ? `${Te} · ${Ue}` : Te;
      }
      return i("inspector.folder_items", { n: n.dirCount });
    }), F = E(
      () => {
        var ye;
        return U.value && /^(image|video)[/]/.test(String(((ye = k.value) == null ? void 0 : ye.mime_type) ?? "")) ? U.value : null;
      }
    ), I = E(
      () => xa(k.value && !_.value ? k.value : { type: "dir" })
    ), Z = E(
      () => T.value != null && n.apiBase !== void 0 && !_.value
    );
    function J(ye) {
      return ye.length > 12 ? `${ye.slice(0, 12)}…` : ye;
    }
    function re(ye) {
      return p(ye, { time: !0 }) || "-";
    }
    function ve(ye) {
      if (!ye) return "-";
      const Te = Date.parse(ye);
      return Number.isNaN(Te) ? ye : re(Te);
    }
    async function W(ye) {
      try {
        await navigator.clipboard.writeText(ye), a("toast", i("inspector.copied"));
      } catch {
        a("toast", ye);
      }
    }
    const z = E(() => {
      if (!k.value) return "";
      const ye = k.value.perm;
      return typeof ye == "string" && ye !== "" ? ye : n.dirPerm || "";
    }), le = E(() => n.sharing ?? H4), fe = E(() => kS(n.nodes, n.inEncrypted === !0)), j = E(() => z.value === "owner" && le.value.users);
    function X(ye) {
      return i(`inspector.perm.${ye}`) === `inspector.perm.${ye}` ? ye : i(`inspector.perm.${ye}`);
    }
    const te = S("idle"), V = S([]), G = S(null), q = S(!0), B = S(null), K = E(() => B.value !== null), ke = S("idle"), Ye = S([]);
    let Oe = 0;
    async function Be() {
      const ye = ++Oe;
      if (G.value = null, V.value = [], Ye.value = [], k.value && A.value && T.value != null ? (te.value = "loading", qe(ye)) : te.value = "hidden", k.value) {
        ke.value = "loading";
        const Te = k.value.path;
        try {
          const { shares: Ue } = await n.api.listShares(Te);
          if (ye !== Oe) return;
          Ye.value = Array.isArray(Ue) ? Ue : [], ke.value = "ok";
        } catch {
          if (ye !== Oe) return;
          ke.value = "hidden";
        }
      } else
        ke.value = "hidden";
    }
    async function qe(ye) {
      const Te = T.value;
      if (Te != null)
        try {
          const Ue = await n.api.listVersions(Te);
          if (ye !== Oe) return;
          V.value = Ue, te.value = "ok";
        } catch (Ue) {
          if (ye !== Oe) return;
          const xt = Ue.status;
          xt === 401 || xt === 403 || xt === 404 ? te.value = "hidden" : te.value = "error";
        }
    }
    function Tt(ye) {
      G.value = ye.id, q.value = !0;
    }
    async function $t(ye) {
      const Te = T.value;
      if (!(Te == null || K.value)) {
        B.value = "restore";
        try {
          await n.api.restoreVersion(Te, ye.id, q.value), a("toast", i("inspector.versions.restored")), G.value = null, a("changed"), await qe(++Oe);
        } catch (Ue) {
          const xt = Yv(Ue);
          a("toast", xt ? Kr(xt, { t: i, formatDate: p, locale: n.locale }) : Ue.message);
        } finally {
          B.value = null;
        }
      }
    }
    async function it() {
      const ye = T.value;
      if (!(ye == null || K.value)) {
        B.value = "snapshot";
        try {
          await n.api.snapshotVersion(ye), a("toast", i("inspector.versions.snapshotted")), await qe(++Oe);
        } catch (Te) {
          const Ue = Te.status;
          Ue === 404 || Ue === 405 || Ue === 501 ? a("toast", i("inspector.versions.unsupported")) : a("toast", Te.message);
        } finally {
          B.value = null;
        }
      }
    }
    const yt = S("details"), ft = S("hidden"), ze = S([]);
    let oe = 0;
    async function Se() {
      const ye = ++oe, Te = k.value;
      if (!n.tabs || !Te) {
        ft.value = "hidden", ze.value = [];
        return;
      }
      ft.value = "loading";
      try {
        const Ue = await n.api.listPermissions(Te.path);
        if (ye !== oe) return;
        if (!Ue.storage_rbac) {
          ft.value = "hidden", ze.value = [];
          return;
        }
        ze.value = [...Ue.direct ?? [], ...Ue.inherited ?? []], ft.value = "ok";
      } catch {
        if (ye !== oe) return;
        ze.value = [], ft.value = "hidden";
      }
    }
    function he(ye) {
      return { name: ye.user_name, display_name: ye.user_display_name, email: ye.user_email };
    }
    function Ke(ye) {
      return Rp(he(ye)) || `#${ye.user_id}`;
    }
    function Le(ye) {
      return M5(he(ye), gi(n.locale)) || "?";
    }
    E(() => Ye.value.length ? Ye.value[0] : null);
    const ut = S(!1);
    async function wt() {
      var Te;
      const ye = k.value;
      if (!(!ye || ut.value || !le.value.links || fe.value)) {
        ut.value = !0;
        try {
          const xt = ((Te = (await n.api.createShare({ path: ye.path })).share) == null ? void 0 : Te.url) ?? "", { shares: Qt } = await n.api.listShares(ye.path);
          Ye.value = Array.isArray(Qt) ? Qt : [], ke.value = "ok", xt && (a("share-created", { path: ye.path, url: xt }), await W(xt));
        } catch (Ue) {
          a("toast", Ue.message);
        } finally {
          ut.value = !1;
        }
      }
    }
    Xe(
      () => [n.nodes.map((ye) => ye.path).join("|"), n.tabs],
      () => void Se(),
      { immediate: !0 }
    );
    const _t = E(
      () => te.value !== "hidden" || At.value !== "hidden"
    );
    Xe(
      () => n.nodes.map((ye) => ye.path).join("\0"),
      () => void Be(),
      { immediate: !0 }
    );
    const At = S("hidden"), _e = S([]), Ie = S("");
    Xe(Ie, (ye) => {
      const Te = by(ye, xc("comment_max_runes"));
      Te !== ye && (Ie.value = Te);
    });
    const pe = S(!1), we = E(
      () => {
        var ye;
        return typeof ((ye = k.value) == null ? void 0 : ye.id) == "number" ? k.value.id : null;
      }
    );
    let ee = 0;
    async function ge() {
      const ye = ++ee, Te = we.value;
      if (Te == null) {
        At.value = "hidden", _e.value = [];
        return;
      }
      At.value = _e.value.length > 0 ? "ok" : "loading";
      try {
        const Ue = await n.api.listComments(Te);
        if (ye !== ee) return;
        _e.value = Ue, At.value = "ok";
      } catch (Ue) {
        if (ye !== ee) return;
        _e.value = [];
        const xt = Ue.status;
        At.value = xt === 401 || xt === 403 || xt === 404 ? "hidden" : "error";
      }
    }
    async function ae() {
      const ye = we.value, Te = Ie.value.trim();
      if (!(ye == null || Te === "" || pe.value)) {
        pe.value = !0;
        try {
          await n.api.addComment(ye, Te), Ie.value = "", await ge();
        } catch (Ue) {
          a("toast", Ue.message);
        } finally {
          pe.value = !1;
        }
      }
    }
    async function xe(ye) {
      if (!pe.value) {
        pe.value = !0;
        try {
          await n.api.deleteComment(ye.id), await ge();
        } catch (Te) {
          a("toast", Te.message);
        } finally {
          pe.value = !1;
        }
      }
    }
    function Fe(ye) {
      const Te = Date.parse(ye);
      if (Number.isNaN(Te)) return ye;
      const Ue = Math.round((Te - Date.now()) / 1e3), xt = Math.abs(Ue), Qt = [
        ["year", 31536e3],
        ["month", 2592e3],
        ["day", 86400],
        ["hour", 3600],
        ["minute", 60]
      ];
      try {
        const vn = new Intl.RelativeTimeFormat(
          gi(n.locale),
          { numeric: "auto" }
        );
        for (const [Ut, pn] of Qt)
          if (xt >= pn) return vn.format(Math.trunc(Ue / pn), Ut);
        return vn.format(Ue, "second");
      } catch {
        return ve(ye);
      }
    }
    return Xe(
      () => we.value,
      () => {
        _e.value = [], Ie.value = "", ge();
      },
      { immediate: !0 }
    ), (ye, Te) => (f(), h("aside", {
      class: Ne(["fe-inspector", { "fe-inspector--overlay": e.narrow }]),
      role: "complementary",
      "aria-label": u(i)("inspector.title")
    }, [
      d("header", vH, [
        d("span", {
          class: "fe-inspector__head-icon",
          "aria-hidden": "true",
          innerHTML: I.value
        }, null, 8, yH),
        d("div", gH, [
          d("h2", {
            class: "fe-inspector__title",
            title: H.value
          }, [
            d("bdi", null, y(H.value), 1)
          ], 8, bH),
          d("p", kH, y($.value), 1),
          e.heldIn ? (f(), h("p", wH, y(u(i)("inspector.held", { where: e.heldIn })), 1)) : D("", !0)
        ]),
        k.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-inspector__iconbtn",
          title: u(i)("inspector.copy_name"),
          "aria-label": u(i)("inspector.copy_name"),
          "data-testid": "inspector-copy-name",
          onClick: Te[0] || (Te[0] = (Ue) => W(k.value ? u(v)(k.value) : H.value))
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(Pt)("copy")
          }, null, 8, xH)
        ], 8, _H)) : D("", !0),
        d("button", {
          type: "button",
          class: "fe-inspector__iconbtn fe-inspector__close",
          title: u(i)("inspector.close"),
          "aria-label": u(i)("inspector.close"),
          onClick: Te[1] || (Te[1] = (Ue) => a("close"))
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(Pt)("close")
          }, null, 8, $H)
        ], 8, SH)
      ]),
      e.tabs ? (f(), h("div", {
        key: 0,
        class: "fe-inspector__tabs",
        role: "tablist",
        "aria-label": u(i)("inspector.title")
      }, [
        d("button", {
          type: "button",
          class: Ne(["fe-inspector__tab", { "is-active": yt.value === "details" }]),
          role: "tab",
          "aria-selected": yt.value === "details",
          "data-testid": "inspector-tab-details",
          onClick: Te[2] || (Te[2] = (Ue) => yt.value = "details")
        }, y(u(i)("inspector.tab.details")), 11, AH),
        d("button", {
          type: "button",
          class: Ne(["fe-inspector__tab", { "is-active": yt.value === "activity" }]),
          role: "tab",
          "aria-selected": yt.value === "activity",
          "data-testid": "inspector-tab-activity",
          onClick: Te[3] || (Te[3] = (Ue) => yt.value = "activity")
        }, y(u(i)("inspector.tab.activity")), 11, EH)
      ], 8, TH)) : D("", !0),
      d("div", CH, [
        !e.tabs || yt.value === "details" ? (f(), h("section", zH, [
          d("h3", MH, y(u(i)("inspector.section.general")), 1),
          w.value ? (f(), h("p", OH, [
            Te[18] || (Te[18] = d("span", { "aria-hidden": "true" }, "🔒", -1)),
            d("span", null, [
              d("strong", null, y(u(i)("applock.inspector")), 1),
              Te[17] || (Te[17] = d("br", null, null, -1)),
              Vt(y(w.value), 1)
            ])
          ])) : D("", !0),
          b.value ? (f(), h("p", {
            key: 1,
            class: "fe-inspector__linknote",
            role: "note",
            "data-testid": "inspector-symlink",
            "data-link-state": b.value.state
          }, [
            Te[20] || (Te[20] = d("span", { "aria-hidden": "true" }, "🔗", -1)),
            d("span", null, [
              d("strong", null, y(u(i)("symlink.inspector")), 1),
              Te[19] || (Te[19] = d("br", null, null, -1)),
              Vt(y(b.value.why), 1)
            ])
          ], 8, PH)) : D("", !0),
          C.value ? (f(), h("p", DH, [
            Te[23] || (Te[23] = d("span", { "aria-hidden": "true" }, "!", -1)),
            d("span", null, [
              d("strong", null, y(u(i)("unavailable.inspector")), 1),
              Te[22] || (Te[22] = d("br", null, null, -1)),
              Vt(y(C.value.why) + " ", 1),
              C.value.reason ? (f(), h(Ce, { key: 0 }, [
                Te[21] || (Te[21] = d("br", null, null, -1)),
                d("bdi", null, y(C.value.reason), 1)
              ], 64)) : D("", !0)
            ])
          ])) : D("", !0),
          _.value ? (f(), h("dl", LH, [
            d("div", RH, [
              d("dt", null, y(u(i)("inspector.size")), 1),
              d("dd", {
                title: u(c)(M.value)
              }, y(u(l)(M.value)), 9, NH)
            ])
          ])) : k.value ? (f(), h(Ce, { key: 4 }, [
            F.value ? (f(), h("img", {
              key: 0,
              class: "fe-inspector__preview",
              src: F.value,
              alt: "",
              "aria-hidden": "true"
            }, null, 8, IH)) : D("", !0),
            d("dl", BH, [
              d("div", FH, [
                d("dt", null, y(u(i)("inspector.type")), 1),
                d("dd", null, y(u(Cv)(k.value, u(i))), 1)
              ]),
              d("div", UH, [
                d("dt", null, y(u(i)("inspector.path")), 1),
                d("dd", HH, [
                  d("span", {
                    class: "fe-inspector__path",
                    title: k.value.path
                  }, [
                    d("bdi", null, y(x(k.value)), 1)
                  ], 8, KH),
                  d("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: Te[4] || (Te[4] = (Ue) => W(k.value.path))
                  }, [
                    d("span", {
                      "aria-hidden": "true",
                      innerHTML: u(Pt)("copy")
                    }, null, 8, jH)
                  ], 8, VH)
                ])
              ]),
              A.value ? (f(), h("div", qH, [
                d("dt", null, y(u(i)("inspector.size")), 1),
                d("dd", null, y(u(r)(typeof k.value.size == "number" ? k.value.size : null)), 1)
              ])) : D("", !0),
              d("div", WH, [
                d("dt", null, y(u(i)("inspector.modified")), 1),
                d("dd", null, y(re(k.value.last_modified)), 1)
              ]),
              A.value && k.value.mime_type ? (f(), h("div", YH, [
                d("dt", null, y(u(i)("inspector.mime")), 1),
                d("dd", GH, y(k.value.mime_type), 1)
              ])) : D("", !0),
              e.callerAdmin && typeof k.value.id == "number" ? (f(), h("div", XH, [
                d("dt", null, y(u(i)("inspector.nodeId")), 1),
                d("dd", JH, [
                  d("span", ZH, y(k.value.id), 1),
                  d("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: Te[5] || (Te[5] = (Ue) => W(String(k.value.id)))
                  }, [
                    d("span", {
                      "aria-hidden": "true",
                      innerHTML: u(Pt)("copy")
                    }, null, 8, eK)
                  ], 8, QH)
                ])
              ])) : D("", !0),
              L.value ? (f(), h("div", tK, [
                d("dt", null, y(u(i)("inspector.etag")), 1),
                d("dd", nK, [
                  d("span", {
                    class: "fe-inspector__path",
                    title: L.value
                  }, y(J(L.value)), 9, aK),
                  d("button", {
                    type: "button",
                    class: "fe-inspector__copy",
                    title: u(i)("inspector.copy"),
                    "aria-label": u(i)("inspector.copy"),
                    onClick: Te[6] || (Te[6] = (Ue) => W(L.value))
                  }, [
                    d("span", {
                      "aria-hidden": "true",
                      innerHTML: u(Pt)("copy")
                    }, null, 8, oK)
                  ], 8, iK)
                ])
              ])) : D("", !0)
            ])
          ], 64)) : (f(), h("p", rK, y(u(i)("inspector.select_hint")), 1))
        ])) : D("", !0),
        Z.value && (!e.tabs || yt.value === "details") ? (f(), h("section", sK, [
          d("h3", lK, y(u(i)("inspector.section.tags")), 1),
          Je(q2, {
            "node-id": T.value,
            locale: e.locale,
            "api-base": e.apiBase,
            "auth-headers": e.authHeaders,
            "auth-credentials": e.authCredentials,
            onChange: Te[7] || (Te[7] = (Ue) => a("tags-changed", Ue)),
            onOpen: Te[8] || (Te[8] = (Ue, xt) => a("open-tag", Ue, xt)),
            onError: Te[9] || (Te[9] = () => a("toast", u(i)("inspector.error")))
          }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
        ])) : D("", !0),
        k.value && (!e.tabs || yt.value === "details") ? (f(!0), h(Ce, { key: 2 }, nt(P.value, (Ue) => (f(), We(hH, {
          key: `${Ue.plugin}/${Ue.id}`,
          api: e.api,
          view: Ue,
          path: k.value.path,
          node: k.value,
          locale: e.locale,
          theme: e.theme,
          storages: e.storages,
          "user-name": e.userName,
          onOp: Te[10] || (Te[10] = (xt) => a("plugin-op", xt)),
          onToast: Te[11] || (Te[11] = (xt) => a("toast", xt)),
          onOpen: (xt) => a("plugin-open", { plugin: Ue.plugin, req: xt })
        }, null, 8, ["api", "view", "path", "node", "locale", "theme", "storages", "user-name", "onOpen"]))), 128)) : D("", !0),
        (te.value === "ok" || te.value === "error") && (!e.tabs || yt.value === "activity") ? (f(), h("section", uK, [
          d("h3", cK, y(u(i)("inspector.section.versions")), 1),
          te.value === "error" ? (f(), h("p", dK, y(u(i)("inspector.error")), 1)) : (f(), h(Ce, { key: 1 }, [
            V.value.length === 0 ? (f(), h("p", fK, y(u(i)("inspector.versions.empty")), 1)) : (f(), h("ul", pK, [
              (f(!0), h(Ce, null, nt(V.value, (Ue) => (f(), h("li", {
                key: Ue.id,
                class: "fe-inspector__version"
              }, [
                d("div", hK, [
                  d("span", mK, y(u(i)("inspector.versions.v", { n: Ue.version_n })), 1),
                  d("span", vK, y(ve(Ue.created_at)) + " · " + y(u(r)(Ue.size)), 1)
                ]),
                G.value === Ue.id ? (f(), h("div", yK, [
                  d("p", gK, y(u(i)("inspector.versions.restore_confirm")), 1),
                  d("label", bK, [
                    cn(d("input", {
                      "onUpdate:modelValue": Te[12] || (Te[12] = (xt) => q.value = xt),
                      type: "checkbox"
                    }, null, 512), [
                      [wc, q.value]
                    ]),
                    Vt(" " + y(u(i)("inspector.versions.snapshot_current")), 1)
                  ]),
                  d("div", kK, [
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-btn--primary fe-btn--sm",
                      disabled: K.value,
                      "aria-busy": B.value === "restore",
                      onClick: (xt) => $t(Ue)
                    }, y(B.value === "restore" ? u(i)("inspector.versions.restoring") : u(i)("inspector.versions.confirm")), 9, wK),
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-btn--sm",
                      disabled: K.value,
                      onClick: Te[13] || (Te[13] = (xt) => G.value = null)
                    }, y(u(i)("inspector.versions.cancel")), 9, _K)
                  ])
                ])) : (f(), h("button", {
                  key: 1,
                  type: "button",
                  class: "fe-btn fe-btn--sm",
                  disabled: K.value,
                  onClick: (xt) => Tt(Ue)
                }, y(u(i)("inspector.versions.restore")), 9, xK))
              ]))), 128))
            ])),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--sm fe-inspector__snapshot",
              disabled: K.value,
              "aria-busy": B.value === "snapshot",
              onClick: it
            }, y(B.value === "snapshot" ? u(i)("inspector.versions.snapshotting") : u(i)("inspector.versions.take_snapshot")), 9, SK)
          ], 64))
        ])) : D("", !0),
        k.value && z.value && (!e.tabs || yt.value === "details") && !(e.tabs && ft.value === "ok") ? (f(), h("section", $K, [
          d("h3", TK, y(u(i)("inspector.section.permissions")), 1),
          d("div", AK, [
            d("span", {
              class: Ne(["fe-inspector__badge", `fe-inspector__badge--${z.value}`])
            }, y(X(z.value)), 3),
            j.value ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              onClick: Te[14] || (Te[14] = (Ue) => a("manage-permissions", k.value))
            }, y(u(i)("inspector.perm.manage")), 1)) : D("", !0)
          ])
        ])) : D("", !0),
        e.tabs && yt.value === "details" && ft.value === "ok" ? (f(), h("section", EK, [
          d("h3", CK, y(u(i)("inspector.people")), 1),
          ze.value.length === 0 ? (f(), h("p", zK, y(u(i)("inspector.people.empty")), 1)) : (f(), h("ul", MK, [
            (f(!0), h(Ce, null, nt(ze.value, (Ue) => (f(), h("li", {
              key: `${Ue.id}-${Ue.user_id}`,
              class: "fe-inspector__person"
            }, [
              d("span", OK, y(Le(Ue)), 1),
              d("span", PK, [
                d("span", {
                  class: "fe-inspector__person-name",
                  title: Ue.user_email
                }, y(Ke(Ue)), 9, DK),
                d("span", LK, [
                  Vt(y(X(Ue.level)), 1),
                  Ue.inherited ? (f(), h(Ce, { key: 0 }, [
                    Vt(" · " + y(u(i)("inspector.people.inherited")), 1)
                  ], 64)) : D("", !0)
                ])
              ])
            ]))), 128))
          ])),
          j.value && k.value ? (f(), h("button", {
            key: 2,
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: Te[15] || (Te[15] = (Ue) => a("manage-permissions", k.value))
          }, y(u(i)("inspector.people.manage")), 1)) : D("", !0)
        ])) : D("", !0),
        ke.value === "ok" && (!e.tabs || yt.value === "details") ? (f(), h("section", RK, [
          d("h3", NK, y(e.tabs ? u(i)("inspector.link") : u(i)("inspector.section.shares")), 1),
          e.tabs && Ye.value.length === 0 ? (f(), h("div", IK, [
            d("span", {
              class: "fe-inspector__linkicon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("link")
            }, null, 8, BK),
            d("span", FK, y(u(i)("inspector.link.none")), 1),
            le.value.links && !fe.value ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-btn--sm",
              disabled: ut.value || !k.value,
              "data-testid": "inspector-create-link",
              onClick: wt
            }, y(u(i)("inspector.link.create")), 9, UK)) : D("", !0)
          ])) : Ye.value.length === 0 ? (f(), h("p", HK, y(u(i)("inspector.shares.empty")), 1)) : (f(), h("ul", KK, [
            (f(!0), h(Ce, null, nt(Ye.value, (Ue) => (f(), h("li", {
              key: Ue.uuid,
              class: "fe-inspector__share"
            }, [
              d("span", {
                class: "fe-inspector__share-url",
                title: Ue.url
              }, y(Ue.url), 9, VK),
              Ue.password_pin ? (f(), h("span", jK, "PIN")) : D("", !0),
              Ue.expires_at ? (f(), h("span", qK, y(ve(Ue.expires_at)), 1)) : D("", !0),
              d("button", {
                type: "button",
                class: "fe-inspector__copy",
                title: u(i)("inspector.shares.copy"),
                "aria-label": u(i)("inspector.shares.copy"),
                onClick: (xt) => W(Ue.url)
              }, [
                d("span", {
                  "aria-hidden": "true",
                  innerHTML: u(Pt)("copy")
                }, null, 8, YK)
              ], 8, WK)
            ]))), 128))
          ]))
        ])) : D("", !0),
        (At.value === "ok" || At.value === "error") && (!e.tabs || yt.value === "activity") ? (f(), h("section", GK, [
          d("h3", XK, [
            Vt(y(u(i)("inspector.section.comments")) + " ", 1),
            _e.value.length > 0 ? (f(), h("span", JK, y(_e.value.length), 1)) : D("", !0)
          ]),
          At.value === "error" ? (f(), h("p", ZK, y(u(i)("inspector.error")), 1)) : (f(), h(Ce, { key: 1 }, [
            _e.value.length === 0 ? (f(), h("p", QK, y(u(i)("inspector.comments.empty")), 1)) : (f(), h("ul", e9, [
              (f(!0), h(Ce, null, nt(_e.value, (Ue) => (f(), h("li", {
                key: Ue.id,
                class: "fe-inspector__comment"
              }, [
                d("div", t9, [
                  d("span", {
                    class: "fe-inspector__comment-author",
                    title: Ue.author_name
                  }, y(Ue.author_name || "-"), 9, n9),
                  d("span", {
                    class: "fe-inspector__comment-time",
                    title: ve(Ue.created_at)
                  }, y(Fe(Ue.created_at)), 9, a9),
                  Ue.can_delete ? (f(), h("button", {
                    key: 0,
                    type: "button",
                    class: "fe-inspector__comment-del",
                    disabled: pe.value,
                    title: u(i)("inspector.comments.delete"),
                    "aria-label": u(i)("inspector.comments.delete"),
                    onClick: (xt) => xe(Ue)
                  }, "×", 8, i9)) : D("", !0)
                ]),
                d("p", o9, y(Ue.body), 1)
              ]))), 128))
            ])),
            d("form", {
              class: "fe-inspector__comment-form",
              onSubmit: vt(ae, ["prevent"])
            }, [
              cn(d("input", {
                "onUpdate:modelValue": Te[16] || (Te[16] = (Ue) => Ie.value = Ue),
                type: "text",
                class: "fe-inspector__comment-input",
                placeholder: u(i)("inspector.comments.placeholder"),
                "aria-label": u(i)("inspector.comments.placeholder"),
                disabled: pe.value
              }, null, 8, r9), [
                [xn, Ie.value]
              ]),
              d("button", {
                type: "submit",
                class: "fe-btn fe-btn--primary fe-btn--sm",
                disabled: pe.value || Ie.value.trim() === ""
              }, y(u(i)("inspector.comments.send")), 9, s9)
            ], 32)
          ], 64))
        ])) : D("", !0),
        e.tabs && yt.value === "activity" && !_t.value ? (f(), h("section", l9, [
          d("p", u9, y(k.value ? u(i)("inspector.activity.empty") : u(i)("inspector.activity.select")), 1),
          k.value ? (f(), h("p", c9, y(u(i)("inspector.activity.hint")), 1)) : D("", !0)
        ])) : D("", !0)
      ])
    ], 10, mH));
  }
});
/*! @license DOMPurify 3.4.2 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.2/LICENSE */
const {
  entries: L$,
  setPrototypeOf: S1,
  isFrozen: f9,
  getPrototypeOf: p9,
  getOwnPropertyDescriptor: h9
} = Object;
let {
  freeze: Sa,
  seal: ii,
  create: qs
} = Object, {
  apply: iy,
  construct: oy
} = typeof Reflect < "u" && Reflect;
Sa || (Sa = function(t) {
  return t;
});
ii || (ii = function(t) {
  return t;
});
iy || (iy = function(t, n) {
  for (var a = arguments.length, i = new Array(a > 2 ? a - 2 : 0), r = 2; r < a; r++)
    i[r - 2] = arguments[r];
  return t.apply(n, i);
});
oy || (oy = function(t) {
  for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    a[i - 1] = arguments[i];
  return new t(...a);
});
const Mu = Vn(Array.prototype.forEach), m9 = Vn(Array.prototype.lastIndexOf), $1 = Vn(Array.prototype.pop), Ou = Vn(Array.prototype.push), v9 = Vn(Array.prototype.splice), ya = Array.isArray, Bu = Vn(String.prototype.toLowerCase), jm = Vn(String.prototype.toString), T1 = Vn(String.prototype.match), Hs = Vn(String.prototype.replace), A1 = Vn(String.prototype.indexOf), y9 = Vn(String.prototype.trim), g9 = Vn(Number.prototype.toString), b9 = Vn(Boolean.prototype.toString), E1 = typeof BigInt > "u" ? null : Vn(BigInt.prototype.toString), C1 = typeof Symbol > "u" ? null : Vn(Symbol.prototype.toString), In = Vn(Object.prototype.hasOwnProperty), Pu = Vn(Object.prototype.toString), ia = Vn(RegExp.prototype.test), af = k9(TypeError);
function Vn(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      a[i - 1] = arguments[i];
    return iy(e, t, a);
  };
}
function k9(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), a = 0; a < t; a++)
      n[a] = arguments[a];
    return oy(e, n);
  };
}
function Gt(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Bu;
  if (S1 && S1(e, null), !ya(t))
    return e;
  let a = t.length;
  for (; a--; ) {
    let i = t[a];
    if (typeof i == "string") {
      const r = n(i);
      r !== i && (f9(t) || (t[a] = r), i = r);
    }
    e[i] = !0;
  }
  return e;
}
function w9(e) {
  for (let t = 0; t < e.length; t++)
    In(e, t) || (e[t] = null);
  return e;
}
function Aa(e) {
  const t = qs(null);
  for (const [n, a] of L$(e))
    In(e, n) && (ya(a) ? t[n] = w9(a) : a && typeof a == "object" && a.constructor === Object ? t[n] = Aa(a) : t[n] = a);
  return t;
}
function _9(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return g9(e);
    case "boolean":
      return b9(e);
    case "bigint":
      return E1 ? E1(e) : "0";
    case "symbol":
      return C1 ? C1(e) : "Symbol()";
    case "undefined":
      return Pu(e);
    case "function":
    case "object": {
      if (e === null)
        return Pu(e);
      const t = e, n = Ws(t, "toString");
      if (typeof n == "function") {
        const a = n(t);
        return typeof a == "string" ? a : Pu(a);
      }
      return Pu(e);
    }
    default:
      return Pu(e);
  }
}
function Ws(e, t) {
  for (; e !== null; ) {
    const a = h9(e, t);
    if (a) {
      if (a.get)
        return Vn(a.get);
      if (typeof a.value == "function")
        return Vn(a.value);
    }
    e = p9(e);
  }
  function n() {
    return null;
  }
  return n;
}
function x9(e) {
  try {
    return ia(e, ""), !0;
  } catch {
    return !1;
  }
}
const z1 = Sa(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), qm = Sa(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Wm = Sa(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), S9 = Sa(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Ym = Sa(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), $9 = Sa(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), M1 = Sa(["#text"]), O1 = Sa(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Gm = Sa(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), P1 = Sa(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), of = Sa(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), T9 = ii(/\{\{[\w\W]*|[\w\W]*\}\}/gm), A9 = ii(/<%[\w\W]*|[\w\W]*%>/gm), E9 = ii(/\$\{[\w\W]*/gm), C9 = ii(/^data-[\-\w.\u00B7-\uFFFF]+$/), z9 = ii(/^aria-[\-\w]+$/), R$ = ii(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), M9 = ii(/^(?:\w+script|data):/i), O9 = ii(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), N$ = ii(/^html$/i), P9 = ii(/^[a-z][.\w]*(-[.\w]+)+$/i);
var D1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: z9,
  ATTR_WHITESPACE: O9,
  CUSTOM_ELEMENT: P9,
  DATA_ATTR: C9,
  DOCTYPE_NAME: N$,
  ERB_EXPR: A9,
  IS_ALLOWED_URI: R$,
  IS_SCRIPT_OR_DATA: M9,
  MUSTACHE_EXPR: T9,
  TMPLIT_EXPR: E9
});
const Du = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, D9 = function() {
  return typeof window > "u" ? null : window;
}, L9 = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let a = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (a = n.getAttribute(i));
  const r = "dompurify" + (a ? "#" + a : "");
  try {
    return t.createPolicy(r, {
      createHTML(l) {
        return l;
      },
      createScriptURL(l) {
        return l;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + r + " could not be created."), null;
  }
}, L1 = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function I$() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : D9();
  const t = (Qe) => I$(Qe);
  if (t.version = "3.4.2", t.removed = [], !e || !e.document || e.document.nodeType !== Du.document || !e.Element)
    return t.isSupported = !1, t;
  let {
    document: n
  } = e;
  const a = n, i = a.currentScript, {
    DocumentFragment: r,
    HTMLTemplateElement: l,
    Node: c,
    Element: p,
    NodeFilter: m,
    NamedNodeMap: v = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: x,
    DOMParser: k,
    trustedTypes: _
  } = e, w = p.prototype, b = Ws(w, "cloneNode"), C = Ws(w, "remove"), A = Ws(w, "nextSibling"), T = Ws(w, "childNodes"), R = Ws(w, "parentNode");
  if (typeof l == "function") {
    const Qe = n.createElement("template");
    Qe.content && Qe.content.ownerDocument && (n = Qe.content.ownerDocument);
  }
  let M, L = "";
  const {
    implementation: U,
    createNodeIterator: P,
    createDocumentFragment: H,
    getElementsByTagName: $
  } = n, {
    importNode: F
  } = a;
  let I = L1();
  t.isSupported = typeof L$ == "function" && typeof R == "function" && U && U.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: Z,
    ERB_EXPR: J,
    TMPLIT_EXPR: re,
    DATA_ATTR: ve,
    ARIA_ATTR: W,
    IS_SCRIPT_OR_DATA: z,
    ATTR_WHITESPACE: le,
    CUSTOM_ELEMENT: fe
  } = D1;
  let {
    IS_ALLOWED_URI: j
  } = D1, X = null;
  const te = Gt({}, [...z1, ...qm, ...Wm, ...Ym, ...M1]);
  let V = null;
  const G = Gt({}, [...O1, ...Gm, ...P1, ...of]);
  let q = Object.seal(qs(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), B = null, K = null;
  const ke = Object.seal(qs(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Ye = !0, Oe = !0, Be = !1, qe = !0, Tt = !1, $t = !0, it = !1, yt = !1, ft = !1, ze = !1, oe = !1, Se = !1, he = !0, Ke = !1;
  const Le = "user-content-";
  let ut = !0, wt = !1, _t = {}, At = null;
  const _e = Gt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let Ie = null;
  const pe = Gt({}, ["audio", "video", "img", "source", "image", "track"]);
  let we = null;
  const ee = Gt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), ge = "http://www.w3.org/1998/Math/MathML", ae = "http://www.w3.org/2000/svg", xe = "http://www.w3.org/1999/xhtml";
  let Fe = xe, ye = !1, Te = null;
  const Ue = Gt({}, [ge, ae, xe], jm);
  let xt = Gt({}, ["mi", "mo", "mn", "ms", "mtext"]), Qt = Gt({}, ["annotation-xml"]);
  const vn = Gt({}, ["title", "style", "font", "a", "script"]);
  let Ut = null;
  const pn = ["application/xhtml+xml", "text/html"], Rt = "text/html";
  let rn = null, nn = null;
  const gt = n.createElement("form"), wn = function(se) {
    return se instanceof RegExp || se instanceof Function;
  }, ra = function() {
    let se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (nn && nn === se)
      return;
    (!se || typeof se != "object") && (se = {}), se = Aa(se), Ut = // eslint-disable-next-line unicorn/prefer-includes
    pn.indexOf(se.PARSER_MEDIA_TYPE) === -1 ? Rt : se.PARSER_MEDIA_TYPE, rn = Ut === "application/xhtml+xml" ? jm : Bu, X = In(se, "ALLOWED_TAGS") && ya(se.ALLOWED_TAGS) ? Gt({}, se.ALLOWED_TAGS, rn) : te, V = In(se, "ALLOWED_ATTR") && ya(se.ALLOWED_ATTR) ? Gt({}, se.ALLOWED_ATTR, rn) : G, Te = In(se, "ALLOWED_NAMESPACES") && ya(se.ALLOWED_NAMESPACES) ? Gt({}, se.ALLOWED_NAMESPACES, jm) : Ue, we = In(se, "ADD_URI_SAFE_ATTR") && ya(se.ADD_URI_SAFE_ATTR) ? Gt(Aa(ee), se.ADD_URI_SAFE_ATTR, rn) : ee, Ie = In(se, "ADD_DATA_URI_TAGS") && ya(se.ADD_DATA_URI_TAGS) ? Gt(Aa(pe), se.ADD_DATA_URI_TAGS, rn) : pe, At = In(se, "FORBID_CONTENTS") && ya(se.FORBID_CONTENTS) ? Gt({}, se.FORBID_CONTENTS, rn) : _e, B = In(se, "FORBID_TAGS") && ya(se.FORBID_TAGS) ? Gt({}, se.FORBID_TAGS, rn) : Aa({}), K = In(se, "FORBID_ATTR") && ya(se.FORBID_ATTR) ? Gt({}, se.FORBID_ATTR, rn) : Aa({}), _t = In(se, "USE_PROFILES") ? se.USE_PROFILES && typeof se.USE_PROFILES == "object" ? Aa(se.USE_PROFILES) : se.USE_PROFILES : !1, Ye = se.ALLOW_ARIA_ATTR !== !1, Oe = se.ALLOW_DATA_ATTR !== !1, Be = se.ALLOW_UNKNOWN_PROTOCOLS || !1, qe = se.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Tt = se.SAFE_FOR_TEMPLATES || !1, $t = se.SAFE_FOR_XML !== !1, it = se.WHOLE_DOCUMENT || !1, ze = se.RETURN_DOM || !1, oe = se.RETURN_DOM_FRAGMENT || !1, Se = se.RETURN_TRUSTED_TYPE || !1, ft = se.FORCE_BODY || !1, he = se.SANITIZE_DOM !== !1, Ke = se.SANITIZE_NAMED_PROPS || !1, ut = se.KEEP_CONTENT !== !1, wt = se.IN_PLACE || !1, j = x9(se.ALLOWED_URI_REGEXP) ? se.ALLOWED_URI_REGEXP : R$, Fe = typeof se.NAMESPACE == "string" ? se.NAMESPACE : xe, xt = In(se, "MATHML_TEXT_INTEGRATION_POINTS") && se.MATHML_TEXT_INTEGRATION_POINTS && typeof se.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Aa(se.MATHML_TEXT_INTEGRATION_POINTS) : Gt({}, ["mi", "mo", "mn", "ms", "mtext"]), Qt = In(se, "HTML_INTEGRATION_POINTS") && se.HTML_INTEGRATION_POINTS && typeof se.HTML_INTEGRATION_POINTS == "object" ? Aa(se.HTML_INTEGRATION_POINTS) : Gt({}, ["annotation-xml"]);
    const je = In(se, "CUSTOM_ELEMENT_HANDLING") && se.CUSTOM_ELEMENT_HANDLING && typeof se.CUSTOM_ELEMENT_HANDLING == "object" ? Aa(se.CUSTOM_ELEMENT_HANDLING) : qs(null);
    if (q = qs(null), In(je, "tagNameCheck") && wn(je.tagNameCheck) && (q.tagNameCheck = je.tagNameCheck), In(je, "attributeNameCheck") && wn(je.attributeNameCheck) && (q.attributeNameCheck = je.attributeNameCheck), In(je, "allowCustomizedBuiltInElements") && typeof je.allowCustomizedBuiltInElements == "boolean" && (q.allowCustomizedBuiltInElements = je.allowCustomizedBuiltInElements), Tt && (Oe = !1), oe && (ze = !0), _t && (X = Gt({}, M1), V = qs(null), _t.html === !0 && (Gt(X, z1), Gt(V, O1)), _t.svg === !0 && (Gt(X, qm), Gt(V, Gm), Gt(V, of)), _t.svgFilters === !0 && (Gt(X, Wm), Gt(V, Gm), Gt(V, of)), _t.mathMl === !0 && (Gt(X, Ym), Gt(V, P1), Gt(V, of))), ke.tagCheck = null, ke.attributeCheck = null, In(se, "ADD_TAGS") && (typeof se.ADD_TAGS == "function" ? ke.tagCheck = se.ADD_TAGS : ya(se.ADD_TAGS) && (X === te && (X = Aa(X)), Gt(X, se.ADD_TAGS, rn))), In(se, "ADD_ATTR") && (typeof se.ADD_ATTR == "function" ? ke.attributeCheck = se.ADD_ATTR : ya(se.ADD_ATTR) && (V === G && (V = Aa(V)), Gt(V, se.ADD_ATTR, rn))), In(se, "ADD_URI_SAFE_ATTR") && ya(se.ADD_URI_SAFE_ATTR) && Gt(we, se.ADD_URI_SAFE_ATTR, rn), In(se, "FORBID_CONTENTS") && ya(se.FORBID_CONTENTS) && (At === _e && (At = Aa(At)), Gt(At, se.FORBID_CONTENTS, rn)), In(se, "ADD_FORBID_CONTENTS") && ya(se.ADD_FORBID_CONTENTS) && (At === _e && (At = Aa(At)), Gt(At, se.ADD_FORBID_CONTENTS, rn)), ut && (X["#text"] = !0), it && Gt(X, ["html", "head", "body"]), X.table && (Gt(X, ["tbody"]), delete B.tbody), se.TRUSTED_TYPES_POLICY) {
      if (typeof se.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw af('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof se.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw af('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      M = se.TRUSTED_TYPES_POLICY, L = M.createHTML("");
    } else
      M === void 0 && (M = L9(_, i)), M !== null && typeof L == "string" && (L = M.createHTML(""));
    Sa && Sa(se), nn = se;
  }, dn = Gt({}, [...qm, ...Wm, ...S9]), jn = Gt({}, [...Ym, ...$9]), zn = function(se) {
    let je = R(se);
    (!je || !je.tagName) && (je = {
      namespaceURI: Fe,
      tagName: "template"
    });
    const dt = Bu(se.tagName), tt = Bu(je.tagName);
    return Te[se.namespaceURI] ? se.namespaceURI === ae ? je.namespaceURI === xe ? dt === "svg" : je.namespaceURI === ge ? dt === "svg" && (tt === "annotation-xml" || xt[tt]) : !!dn[dt] : se.namespaceURI === ge ? je.namespaceURI === xe ? dt === "math" : je.namespaceURI === ae ? dt === "math" && Qt[tt] : !!jn[dt] : se.namespaceURI === xe ? je.namespaceURI === ae && !Qt[tt] || je.namespaceURI === ge && !xt[tt] ? !1 : !jn[dt] && (vn[dt] || !dn[dt]) : !!(Ut === "application/xhtml+xml" && Te[se.namespaceURI]) : !1;
  }, Bn = function(se) {
    Ou(t.removed, {
      element: se
    });
    try {
      R(se).removeChild(se);
    } catch {
      C(se);
    }
  }, Sn = function(se, je) {
    try {
      Ou(t.removed, {
        attribute: je.getAttributeNode(se),
        from: je
      });
    } catch {
      Ou(t.removed, {
        attribute: null,
        from: je
      });
    }
    if (je.removeAttribute(se), se === "is")
      if (ze || oe)
        try {
          Bn(je);
        } catch {
        }
      else
        try {
          je.setAttribute(se, "");
        } catch {
        }
  }, mn = function(se) {
    let je = null, dt = null;
    if (ft)
      se = "<remove></remove>" + se;
    else {
      const ue = T1(se, /^[\r\n\t ]+/);
      dt = ue && ue[0];
    }
    Ut === "application/xhtml+xml" && Fe === xe && (se = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + se + "</body></html>");
    const tt = M ? M.createHTML(se) : se;
    if (Fe === xe)
      try {
        je = new k().parseFromString(tt, Ut);
      } catch {
      }
    if (!je || !je.documentElement) {
      je = U.createDocument(Fe, "template", null);
      try {
        je.documentElement.innerHTML = ye ? L : tt;
      } catch {
      }
    }
    const ie = je.body || je.documentElement;
    return se && dt && ie.insertBefore(n.createTextNode(dt), ie.childNodes[0] || null), Fe === xe ? $.call(je, it ? "html" : "body")[0] : it ? je.documentElement : ie;
  }, sn = function(se) {
    return P.call(
      se.ownerDocument || se,
      se,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, $n = function(se) {
    return se instanceof x && (typeof se.nodeName != "string" || typeof se.textContent != "string" || typeof se.removeChild != "function" || !(se.attributes instanceof v) || typeof se.removeAttribute != "function" || typeof se.setAttribute != "function" || typeof se.namespaceURI != "string" || typeof se.insertBefore != "function" || typeof se.hasChildNodes != "function");
  }, Rn = function(se) {
    return typeof c == "function" && se instanceof c;
  };
  function Fn(Qe, se, je) {
    Mu(Qe, (dt) => {
      dt.call(t, se, je, nn);
    });
  }
  const Tn = function(se) {
    let je = null;
    if (Fn(I.beforeSanitizeElements, se, null), $n(se))
      return Bn(se), !0;
    const dt = rn(se.nodeName);
    if (Fn(I.uponSanitizeElement, se, {
      tagName: dt,
      allowedTags: X
    }), $t && se.hasChildNodes() && !Rn(se.firstElementChild) && ia(/<[/\w!]/g, se.innerHTML) && ia(/<[/\w!]/g, se.textContent) || $t && se.namespaceURI === xe && dt === "style" && Rn(se.firstElementChild) || se.nodeType === Du.progressingInstruction || $t && se.nodeType === Du.comment && ia(/<[/\w]/g, se.data))
      return Bn(se), !0;
    if (B[dt] || !(ke.tagCheck instanceof Function && ke.tagCheck(dt)) && !X[dt]) {
      if (!B[dt] && He(dt) && (q.tagNameCheck instanceof RegExp && ia(q.tagNameCheck, dt) || q.tagNameCheck instanceof Function && q.tagNameCheck(dt)))
        return !1;
      if (ut && !At[dt]) {
        const tt = R(se) || se.parentNode, ie = T(se) || se.childNodes;
        if (ie && tt) {
          const ue = ie.length;
          for (let Pe = ue - 1; Pe >= 0; --Pe) {
            const Ge = b(ie[Pe], !0);
            tt.insertBefore(Ge, A(se));
          }
        }
      }
      return Bn(se), !0;
    }
    return se instanceof p && !zn(se) || (dt === "noscript" || dt === "noembed" || dt === "noframes") && ia(/<\/no(script|embed|frames)/i, se.innerHTML) ? (Bn(se), !0) : (Tt && se.nodeType === Du.text && (je = se.textContent, Mu([Z, J, re], (tt) => {
      je = Hs(je, tt, " ");
    }), se.textContent !== je && (Ou(t.removed, {
      element: se.cloneNode()
    }), se.textContent = je)), Fn(I.afterSanitizeElements, se, null), !1);
  }, me = function(se, je, dt) {
    if (K[je] || he && (je === "id" || je === "name") && (dt in n || dt in gt))
      return !1;
    const tt = V[je] || ke.attributeCheck instanceof Function && ke.attributeCheck(je, se);
    if (!(Oe && !K[je] && ia(ve, je))) {
      if (!(Ye && ia(W, je))) {
        if (!tt || K[je]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(He(se) && (q.tagNameCheck instanceof RegExp && ia(q.tagNameCheck, se) || q.tagNameCheck instanceof Function && q.tagNameCheck(se)) && (q.attributeNameCheck instanceof RegExp && ia(q.attributeNameCheck, je) || q.attributeNameCheck instanceof Function && q.attributeNameCheck(je, se)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            je === "is" && q.allowCustomizedBuiltInElements && (q.tagNameCheck instanceof RegExp && ia(q.tagNameCheck, dt) || q.tagNameCheck instanceof Function && q.tagNameCheck(dt)))
          ) return !1;
        } else if (!we[je]) {
          if (!ia(j, Hs(dt, le, ""))) {
            if (!((je === "src" || je === "xlink:href" || je === "href") && se !== "script" && A1(dt, "data:") === 0 && Ie[se])) {
              if (!(Be && !ia(z, Hs(dt, le, "")))) {
                if (dt)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, De = Gt({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), He = function(se) {
    return !De[Bu(se)] && ia(fe, se);
  }, Ve = function(se) {
    Fn(I.beforeSanitizeAttributes, se, null);
    const {
      attributes: je
    } = se;
    if (!je || $n(se))
      return;
    const dt = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: V,
      forceKeepAttr: void 0
    };
    let tt = je.length;
    for (; tt--; ) {
      const ie = je[tt], {
        name: ue,
        namespaceURI: Pe,
        value: Ge
      } = ie, ot = rn(ue), St = Ge;
      let Et = ue === "value" ? St : y9(St);
      if (dt.attrName = ot, dt.attrValue = Et, dt.keepAttr = !0, dt.forceKeepAttr = void 0, Fn(I.uponSanitizeAttribute, se, dt), Et = dt.attrValue, Ke && (ot === "id" || ot === "name") && A1(Et, Le) !== 0 && (Sn(ue, se), Et = Le + Et), $t && ia(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, Et)) {
        Sn(ue, se);
        continue;
      }
      if (ot === "attributename" && T1(Et, "href")) {
        Sn(ue, se);
        continue;
      }
      if (dt.forceKeepAttr)
        continue;
      if (!dt.keepAttr) {
        Sn(ue, se);
        continue;
      }
      if (!qe && ia(/\/>/i, Et)) {
        Sn(ue, se);
        continue;
      }
      Tt && Mu([Z, J, re], (Q) => {
        Et = Hs(Et, Q, " ");
      });
      const ne = rn(se.nodeName);
      if (!me(ne, ot, Et)) {
        Sn(ue, se);
        continue;
      }
      if (M && typeof _ == "object" && typeof _.getAttributeType == "function" && !Pe)
        switch (_.getAttributeType(ne, ot)) {
          case "TrustedHTML": {
            Et = M.createHTML(Et);
            break;
          }
          case "TrustedScriptURL": {
            Et = M.createScriptURL(Et);
            break;
          }
        }
      if (Et !== St)
        try {
          Pe ? se.setAttributeNS(Pe, ue, Et) : se.setAttribute(ue, Et), $n(se) ? Bn(se) : $1(t.removed);
        } catch {
          Sn(ue, se);
        }
    }
    Fn(I.afterSanitizeAttributes, se, null);
  }, bt = function(se) {
    let je = null;
    const dt = sn(se);
    for (Fn(I.beforeSanitizeShadowDOM, se, null); je = dt.nextNode(); )
      Fn(I.uponSanitizeShadowNode, je, null), Tn(je), Ve(je), je.content instanceof r && bt(je.content);
    Fn(I.afterSanitizeShadowDOM, se, null);
  };
  return t.sanitize = function(Qe) {
    let se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, je = null, dt = null, tt = null, ie = null;
    if (ye = !Qe, ye && (Qe = "<!-->"), typeof Qe != "string" && !Rn(Qe) && (Qe = _9(Qe), typeof Qe != "string"))
      throw af("dirty is not a string, aborting");
    if (!t.isSupported)
      return Qe;
    if (yt || ra(se), t.removed = [], typeof Qe == "string" && (wt = !1), wt) {
      const Ge = Qe.nodeName;
      if (typeof Ge == "string") {
        const ot = rn(Ge);
        if (!X[ot] || B[ot])
          throw af("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Qe instanceof c)
      je = mn("<!---->"), dt = je.ownerDocument.importNode(Qe, !0), dt.nodeType === Du.element && dt.nodeName === "BODY" || dt.nodeName === "HTML" ? je = dt : je.appendChild(dt);
    else {
      if (!ze && !Tt && !it && // eslint-disable-next-line unicorn/prefer-includes
      Qe.indexOf("<") === -1)
        return M && Se ? M.createHTML(Qe) : Qe;
      if (je = mn(Qe), !je)
        return ze ? null : Se ? L : "";
    }
    je && ft && Bn(je.firstChild);
    const ue = sn(wt ? Qe : je);
    for (; tt = ue.nextNode(); )
      Tn(tt), Ve(tt), tt.content instanceof r && bt(tt.content);
    if (wt)
      return Qe;
    if (ze) {
      if (Tt) {
        je.normalize();
        let Ge = je.innerHTML;
        Mu([Z, J, re], (ot) => {
          Ge = Hs(Ge, ot, " ");
        }), je.innerHTML = Ge;
      }
      if (oe)
        for (ie = H.call(je.ownerDocument); je.firstChild; )
          ie.appendChild(je.firstChild);
      else
        ie = je;
      return (V.shadowroot || V.shadowrootmode) && (ie = F.call(a, ie, !0)), ie;
    }
    let Pe = it ? je.outerHTML : je.innerHTML;
    return it && X["!doctype"] && je.ownerDocument && je.ownerDocument.doctype && je.ownerDocument.doctype.name && ia(N$, je.ownerDocument.doctype.name) && (Pe = "<!DOCTYPE " + je.ownerDocument.doctype.name + `>
` + Pe), Tt && Mu([Z, J, re], (Ge) => {
      Pe = Hs(Pe, Ge, " ");
    }), M && Se ? M.createHTML(Pe) : Pe;
  }, t.setConfig = function() {
    let Qe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    ra(Qe), yt = !0;
  }, t.clearConfig = function() {
    nn = null, yt = !1;
  }, t.isValidAttribute = function(Qe, se, je) {
    nn || ra({});
    const dt = rn(Qe), tt = rn(se);
    return me(dt, tt, je);
  }, t.addHook = function(Qe, se) {
    typeof se == "function" && Ou(I[Qe], se);
  }, t.removeHook = function(Qe, se) {
    if (se !== void 0) {
      const je = m9(I[Qe], se);
      return je === -1 ? void 0 : v9(I[Qe], je, 1)[0];
    }
    return $1(I[Qe]);
  }, t.removeHooks = function(Qe) {
    I[Qe] = [];
  }, t.removeAllHooks = function() {
    I = L1();
  }, t;
}
var R9 = I$();
const B$ = [
  "a",
  "abbr",
  "b",
  "bdi",
  "bdo",
  "blockquote",
  "br",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "figcaption",
  "figure",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "hr",
  "i",
  "img",
  "ins",
  "kbd",
  "li",
  "mark",
  "ol",
  "p",
  "picture",
  "pre",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "small",
  "source",
  "span",
  "strike",
  "strong",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "tt",
  "u",
  "ul",
  "var",
  "wbr"
], F$ = [
  "abbr",
  "align",
  "alt",
  "cite",
  "class",
  "colspan",
  "datetime",
  "dir",
  "height",
  "href",
  "id",
  "lang",
  "loading",
  "media",
  "open",
  "rel",
  "reversed",
  "rowspan",
  "scope",
  "span",
  "src",
  "srcset",
  "start",
  "style",
  "target",
  "title",
  "valign",
  "width"
], N9 = [
  "script",
  "iframe",
  "frame",
  "frameset",
  "object",
  "embed",
  "applet",
  "form",
  "input",
  "button",
  "select",
  "option",
  "textarea",
  "base",
  "meta",
  "link",
  "noscript",
  "template",
  "portal",
  "dialog"
], I9 = ["action", "formaction", "srcdoc", "ping", "background", "poster"], B9 = B$.filter((e) => e !== "picture" && e !== "source"), F9 = F$.filter((e) => e !== "srcset" && e !== "style" && e !== "loading" && e !== "media"), U9 = {
  document: {
    ALLOWED_TAGS: B$,
    ALLOWED_ATTR: F$,
    // Ids a document brings are prefixed (`user-content-…`) so they can never
    // shadow a global the page reads (DOM clobbering).
    SANITIZE_NAMED_PROPS: !0,
    // Parsed into an inert document and its pictures from elsewhere held
    // back there (documentMarkup, RemoteImages).
    RETURN_DOM_FRAGMENT: !0
  },
  assistant: {
    ALLOWED_TAGS: B9,
    ALLOWED_ATTR: F9,
    SANITIZE_NAMED_PROPS: !0,
    // Parsed into an inert document and reshaped there (assistantMarkup):
    // nothing is attached to the page, so nothing is fetched on the way.
    RETURN_DOM_FRAGMENT: !0
  },
  code: {
    ALLOWED_TAGS: ["span", "br"],
    ALLOWED_ATTR: ["class"]
  },
  diagram: {
    USE_PROFILES: { svg: !0, svgFilters: !0, html: !0 },
    // What Mermaid itself keeps when it sanitizes its output: HTML labels
    // live in <foreignObject> (an HTML integration point for them), and text
    // anchoring needs dominant-baseline.
    ADD_TAGS: ["foreignobject"],
    ADD_ATTR: ["dominant-baseline"],
    HTML_INTEGRATION_POINTS: { foreignobject: !0 }
  },
  math: {
    USE_PROFILES: { html: !0, mathMl: !0 }
  }
};
let Xm = null;
function H9() {
  if (Xm) return Xm;
  if (typeof window > "u") return null;
  const e = R9(window);
  return e.isSupported ? (e.addHook("uponSanitizeAttribute", (t, n) => {
    if (n.attrName === "style") {
      const a = K9(n.attrValue);
      a === "" ? n.keepAttr = !1 : n.attrValue = a;
    }
  }), e.addHook("uponSanitizeElement", (t, n) => {
    n.tagName === "style" && t.textContent && (t.textContent = V9(t.textContent));
  }), e.addHook("afterSanitizeAttributes", (t) => {
    if (t.tagName === "A") {
      const n = t.getAttribute("target");
      n && n !== "_blank" && t.removeAttribute("target"), t.getAttribute("target") === "_blank" && t.setAttribute("rel", "noopener noreferrer");
    }
  }), Xm = e, e) : null;
}
function K9(e) {
  return e.split(";").map((t) => t.trim()).filter((t) => t !== "" && !j9(t)).join("; ");
}
function V9(e) {
  return /\\/.test(e) ? "" : e.replace(/@import[^;]*;?/gi, "").replace(/url\s*\(\s*(['"]?)(?!#)[^)]*\)/gi, "none").replace(/image-set\s*\([^)]*\)/gi, "none").replace(/expression\s*\(/gi, "x(");
}
function j9(e) {
  return /\\/.test(e) || /expression\s*\(|@import|behavior\s*:|-moz-binding|image-set\s*\(|javascript:/i.test(e) ? !0 : (e.match(/url\s*\(\s*(['"]?)([^)'"]*)/gi) ?? []).some((n) => !/url\s*\(\s*['"]?#/i.test(n));
}
function q9(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function U$() {
  try {
    return typeof location < "u" ? location.origin : null;
  } catch {
    return null;
  }
}
function Yr(e) {
  const t = e.trim();
  if (/^data:image\//i.test(t)) return !0;
  const n = U$();
  if (!n) return !1;
  let a;
  try {
    a = new URL(t, n + "/");
  } catch {
    return !1;
  }
  if (a.protocol === "blob:")
    try {
      return new URL(a.pathname).origin === n;
    } catch {
      return !1;
    }
  return (a.protocol === "https:" || a.protocol === "http:") && a.origin === n;
}
function W9(e) {
  const t = e.ownerDocument;
  for (const n of Array.from(e.querySelectorAll("img"))) {
    const a = n.getAttribute("src") ?? "";
    if (a && Yr(a)) continue;
    const i = (n.getAttribute("alt") ?? "").trim(), r = t.createElement("a");
    r.setAttribute("href", a), r.setAttribute("data-remote-image", ""), r.textContent = i || a, n.replaceWith(r);
  }
  for (const n of Array.from(e.querySelectorAll("a"))) {
    const a = n.getAttribute("href");
    if (!a) {
      n.removeAttribute("target"), n.removeAttribute("rel");
      continue;
    }
    if (n.setAttribute("target", "_blank"), n.setAttribute("rel", "noopener noreferrer nofollow"), n.setAttribute("title", a), (n.textContent ?? "").trim() !== a.trim()) {
      const r = t.createElement("span");
      r.setAttribute("class", "fe-md-href"), r.textContent = ` (${a})`, n.after(r);
    }
  }
  return $g(e);
}
function $g(e) {
  const t = e.ownerDocument.createElement("div");
  return t.appendChild(e), t.innerHTML;
}
function Gr(e) {
  if (!e.trim()) return null;
  const t = U$();
  try {
    const n = new URL(e.trim(), t ? t + "/" : void 0);
    return n.protocol === "https:" || n.protocol === "http:" ? n : null;
  } catch {
    return null;
  }
}
function Tg(e) {
  const t = [];
  let n = 0;
  for (; n < e.length; ) {
    for (; n < e.length && /[\s,]/.test(e[n]); ) n++;
    if (n >= e.length) break;
    let a = n;
    for (; a < e.length && !/\s/.test(e[a]); ) a++;
    let i = e.slice(n, a), r = "";
    if (i.endsWith(","))
      i = i.replace(/,+$/, ""), n = a;
    else {
      let l = a;
      for (; l < e.length && e[l] !== ","; ) l++;
      r = e.slice(a, l).trim(), n = l + 1;
    }
    i && t.push({ url: i, descriptor: r });
  }
  return t;
}
const H$ = ["alt", "title", "width", "height", "class", "align"];
function K$(e, t) {
  var a;
  if (Yr(e)) return !0;
  const n = Gr(e);
  return !!n && !!((a = t.load) != null && a.call(t, n.href));
}
function R1(e, t) {
  const n = e.getAttribute("srcset");
  if (n === null) return;
  const a = Tg(n).filter((i) => K$(i.url, t));
  a.length ? e.setAttribute("srcset", a.map((i) => i.descriptor ? `${i.url} ${i.descriptor}` : i.url).join(", ")) : e.removeAttribute("srcset");
}
function Y9(e, t, n, a) {
  const i = e.createElement("span");
  i.setAttribute("class", "fe-remote-img");
  const r = Gr(n);
  r && (i.setAttribute("data-remote-image", r.href), i.setAttribute("data-remote-host", r.host), i.setAttribute("role", "button"), i.setAttribute("tabindex", "0"), i.setAttribute("title", r.href));
  for (const p of H$) {
    const m = t.getAttribute(p);
    m && i.setAttribute(`data-remote-${p}`, m);
  }
  const l = (p, m) => {
    const v = e.createElement("span");
    v.setAttribute("class", p), m ? v.textContent = m : v.setAttribute("aria-hidden", "true"), i.appendChild(v);
  };
  l("fe-remote-img__icon", "");
  const c = (t.getAttribute("alt") ?? "").trim();
  return c && l("fe-remote-img__alt", c), l("fe-remote-img__label", a), r && l("fe-remote-img__host", r.host), i;
}
function G9(e, t) {
  return V$(e, t), $g(e);
}
function V$(e, t) {
  var i;
  const n = e.ownerDocument, a = t.label || "Remote image";
  for (const r of Array.from(e.querySelectorAll("*")))
    for (const l of Array.from(r.attributes))
      l.name.startsWith("data-remote") && r.removeAttribute(l.name);
  for (const r of Array.from(e.querySelectorAll("source")))
    R1(r, t), r.hasAttribute("srcset") || r.remove();
  for (const r of Array.from(e.querySelectorAll("img"))) {
    const l = (r.getAttribute("src") ?? "").trim(), c = ((i = Tg(r.getAttribute("srcset") ?? "").find((m) => !Yr(m.url))) == null ? void 0 : i.url) ?? "";
    R1(r, t);
    const p = l && !Yr(l) ? l : !l && !r.hasAttribute("srcset") ? c : "";
    if (p && !K$(p, t)) {
      r.replaceWith(Y9(n, r, p, a));
      continue;
    }
    t7(r) && r.setAttribute("referrerpolicy", "no-referrer");
  }
}
const Fu = "http://www.w3.org/2000/svg", j$ = "http://www.w3.org/1999/xhtml", N1 = "#fe-remote=", X9 = ["x", "y", "width", "height", "transform", "preserveAspectRatio"];
function J9(e) {
  return (e.getAttribute("href") ?? e.getAttribute("xlink:href") ?? "").trim();
}
function Z9(e) {
  const t = e.startsWith("data:") ? e.indexOf(N1) : -1;
  if (t < 0) return e;
  try {
    return decodeURIComponent(e.slice(t + N1.length));
  } catch {
    return "";
  }
}
function q$(e, t, n) {
  const a = e.createElementNS(Fu, "foreignObject");
  for (const r of ["x", "y", "width", "height", "transform"]) {
    const l = n(r);
    l !== null && l !== "" && a.setAttribute(r, l);
  }
  const i = e.createElementNS(j$, "img");
  return i.setAttribute("referrerpolicy", "no-referrer"), i.setAttribute("style", "width: 100%; height: 100%; object-fit: contain;"), i.setAttribute("alt", ""), i.setAttribute("src", t), a.appendChild(i), a;
}
function Q9(e, t, n, a) {
  const i = e.createElementNS(Fu, "g");
  i.setAttribute("class", "fe-remote-svgimg");
  const r = Gr(n);
  if (r) {
    i.setAttribute("data-remote-image", r.href), i.setAttribute("data-remote-host", r.host), i.setAttribute("role", "button"), i.setAttribute("tabindex", "0"), i.setAttribute("aria-label", `${a} ${r.host}`);
    const b = e.createElementNS(Fu, "title");
    b.textContent = r.href, i.appendChild(b);
  }
  for (const b of X9) {
    const C = t.getAttribute(b);
    C && i.setAttribute(`data-remote-${b.toLowerCase()}`, C);
  }
  const l = t.getAttribute("transform");
  l && i.setAttribute("transform", l);
  const c = (b, C) => {
    const A = parseFloat(t.getAttribute(b) ?? "");
    return Number.isFinite(A) ? A : C;
  }, [p, m, v, x] = [c("x", 0), c("y", 0), c("width", 120), c("height", 80)], k = e.createElementNS(Fu, "rect");
  k.setAttribute("class", "fe-remote-svgimg__box");
  const _ = [["x", p], ["y", m], ["width", v], ["height", x], ["rx", 4]];
  for (const [b, C] of _) k.setAttribute(b, String(C));
  i.appendChild(k);
  const w = e.createElementNS(Fu, "text");
  return w.setAttribute("class", "fe-remote-svgimg__label"), w.setAttribute("x", String(p + v / 2)), w.setAttribute("y", String(m + x / 2)), w.setAttribute("text-anchor", "middle"), w.setAttribute("dominant-baseline", "middle"), w.textContent = a, i.appendChild(w), i;
}
function e7(e, t) {
  var i;
  const n = e.ownerDocument, a = t.label || "Remote image";
  V$(e, t);
  for (const r of Array.from(e.querySelectorAll("video, audio, track, input"))) r.remove();
  for (const r of Array.from(e.querySelectorAll("image"))) {
    const l = J9(r), c = Z9(l);
    if (c === l && Yr(l)) continue;
    const p = Gr(c);
    if (p && ((i = t.load) != null && i.call(t, p.href))) {
      r.replaceWith(q$(n, p.href, (m) => r.getAttribute(m)));
      continue;
    }
    r.replaceWith(Q9(n, r, c, a));
  }
  for (const r of Array.from(e.querySelectorAll("*")))
    if (!(r.localName === "a" || r.localName === "image" || r.namespaceURI === j$))
      for (const l of ["href", "xlink:href"]) {
        const c = (r.getAttribute(l) ?? "").trim();
        c && !c.startsWith("#") && r.removeAttribute(l);
      }
  return $g(e);
}
function t7(e) {
  var a;
  const t = (i) => {
    const r = (i.getAttribute("src") ?? "").trim();
    return i.tagName === "IMG" && r && !Yr(r) ? !0 : Tg(i.getAttribute("srcset") ?? "").some((l) => !Yr(l.url));
  };
  if (t(e)) return !0;
  const n = ((a = e.parentElement) == null ? void 0 : a.tagName) === "PICTURE" ? e.parentElement : null;
  return !!n && Array.from(n.querySelectorAll("source")).some(t);
}
function n7(e, t = "document", n = {}) {
  const a = H9();
  if (!a) return q9(e);
  const i = {
    ...U9[t],
    FORBID_TAGS: N9,
    FORBID_ATTR: I9,
    ALLOW_UNKNOWN_PROTOCOLS: !1,
    RETURN_TRUSTED_TYPE: !1
  };
  if (t === "assistant")
    return W9(a.sanitize(e, { ...i, RETURN_DOM_FRAGMENT: !0 }));
  if (t === "document" || t === "diagram") {
    const r = a.sanitize(e, { ...i, RETURN_DOM_FRAGMENT: !0 });
    return t === "document" ? G9(r, n.remoteImages ?? {}) : e7(r, n.remoteImages ?? {});
  }
  return String(a.sanitize(e, i));
}
let rf = null;
function a7() {
  return rf || (rf = import(
    /* @vite-ignore */
    "markdown-it"
  ).then((e) => {
    const t = e, n = t.default ?? t;
    return new n({ html: !0, linkify: !0, breaks: !0, typographer: !0 });
  }).catch(() => (rf = null, null))), rf;
}
async function i7(e, t = "document", n = {}) {
  const a = await a7();
  return a ? n7(a.render(e), t, n) : null;
}
const o7 = ["aria-label"], r7 = { class: "fe-assistant__head" }, s7 = { class: "fe-assistant__head-text" }, l7 = { class: "fe-assistant__title" }, u7 = {
  key: 0,
  class: "fe-assistant__provider",
  "data-testid": "assistant-provider"
}, c7 = ["title", "aria-label", "disabled"], d7 = ["title", "aria-label", "aria-pressed"], f7 = ["title", "aria-label"], p7 = {
  key: 0,
  class: "fe-assistant__history",
  "data-testid": "assistant-history-list"
}, h7 = {
  key: 0,
  class: "fe-assistant__muted"
}, m7 = {
  key: 1,
  class: "fe-assistant__convs"
}, v7 = ["onClick"], y7 = { class: "fe-assistant__conv-title" }, g7 = { class: "fe-assistant__conv-date" }, b7 = ["title", "aria-label", "onClick"], k7 = {
  key: 0,
  class: "fe-assistant__intro",
  "data-testid": "assistant-intro"
}, w7 = {
  key: 0,
  class: "fe-assistant__msg fe-assistant__msg--user"
}, _7 = { class: "fe-assistant__text" }, x7 = {
  key: 0,
  class: "fe-assistant__chips"
}, S7 = ["title"], $7 = {
  key: 1,
  class: "fe-assistant__msg fe-assistant__msg--bot"
}, T7 = ["innerHTML"], A7 = {
  key: 1,
  class: "fe-assistant__text"
}, E7 = {
  key: 2,
  class: "fe-assistant__note",
  role: "note"
}, C7 = ["data-testid"], z7 = { class: "fe-assistant__step-body" }, M7 = { class: "fe-assistant__step-label" }, O7 = ["title"], P7 = ["title"], D7 = { class: "fe-assistant__step-status" }, L7 = {
  key: 2,
  class: "fe-assistant__step-error"
}, R7 = ["disabled", "data-testid", "onClick"], N7 = {
  key: 0,
  class: "fe-assistant__msg fe-assistant__msg--user"
}, I7 = { class: "fe-assistant__text" }, B7 = {
  key: 0,
  class: "fe-assistant__chips"
}, F7 = ["title"], U7 = { class: "fe-assistant__step-body" }, H7 = { class: "fe-assistant__step-label" }, K7 = ["title"], V7 = { class: "fe-assistant__step-status" }, j7 = {
  key: 1,
  class: "fe-assistant__msg fe-assistant__msg--bot"
}, q7 = { class: "fe-assistant__text" }, W7 = {
  key: 2,
  class: "fe-assistant__muted"
}, Y7 = ["aria-label"], G7 = { class: "fe-assistant__card-question" }, X7 = {
  key: 0,
  class: "fe-assistant__card-note"
}, J7 = {
  key: 1,
  class: "fe-assistant__card-args"
}, Z7 = { class: "fe-assistant__card-actions" }, Q7 = ["disabled"], eV = ["disabled"], tV = {
  key: 3,
  class: "fe-assistant__error",
  role: "alert",
  "data-testid": "assistant-error"
}, nV = { class: "fe-assistant__foot" }, aV = {
  key: 0,
  class: "fe-assistant__with"
}, iV = { class: "fe-assistant__compose" }, oV = ["placeholder", "aria-label"], rV = ["title", "aria-label"], sV = ["title", "aria-label", "disabled"], lV = /* @__PURE__ */ rt({
  __name: "AssistantPanel",
  props: {
    client: {},
    locale: {},
    selection: {},
    narrow: { type: Boolean }
  },
  emits: ["close", "changed"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r } = ht(() => n.locale ?? "en"), l = S(null), c = S(null), p = S(!1), m = S([]), v = S(""), x = S(!0), k = S(!1), _ = S("");
    let w = null;
    const b = S(null), C = S(null), A = S(null), T = E(() => {
      var G;
      return ((G = c.value) == null ? void 0 : G.items) ?? [];
    }), R = E(() => {
      var q, B;
      return ((q = b.value) == null ? void 0 : q.steps.find((K) => K.status === "waiting")) ?? ((B = c.value) == null ? void 0 : B.waiting) ?? null;
    }), M = E(() => n.selection.length), L = E(() => {
      const G = l.value;
      return !(G != null && G.provider) || !G.model ? "" : `${U(G.provider)} · ${G.model}`;
    });
    function U(G) {
      switch (G) {
        case "anthropic":
          return "Anthropic";
        case "openai":
          return "OpenAI";
        case "ollama":
          return "Ollama";
      }
      return G;
    }
    function P(G) {
      if (!G) return "";
      const q = G.replace(/\/+$/, ""), B = q.lastIndexOf("/");
      return B >= 0 && B < q.length - 1 ? q.slice(B + 1) : q;
    }
    const H = S({});
    async function $(G) {
      if (H.value[G] !== void 0) return;
      const q = await i7(G, "assistant");
      q !== null && (H.value = { ...H.value, [G]: q });
    }
    Xe(
      T,
      (G) => {
        for (const q of G) q.kind === "assistant" && q.text && $(q.text);
      },
      { immediate: !0 }
    );
    function F() {
      Jt(() => {
        const G = C.value;
        G && (G.scrollTop = G.scrollHeight);
      });
    }
    function I(G) {
      if (!b.value) return;
      const q = b.value.steps.findIndex((B) => B.id === G.id);
      q >= 0 ? b.value.steps.splice(q, 1, G) : b.value.steps.push(G), G.class !== "read" && G.status === "done" && a("changed");
    }
    function Z(G) {
      var q;
      switch (G.name) {
        case "conversation":
          (!c.value || c.value.id !== G.data.id) && (c.value = { id: G.data.id, title: G.data.title, updated_ms: Date.now(), provider: "", model: "", items: ((q = c.value) == null ? void 0 : q.items) ?? [] });
          break;
        case "text":
          b.value && (b.value.reply += G.data.delta);
          break;
        case "step":
        case "approval":
          I(G.data);
          break;
        case "error":
          _.value = G.data.message || G.data.error;
          break;
        case "done":
          c.value = G.data.conversation, b.value = null;
          break;
      }
      F();
    }
    async function J(G) {
      var q;
      _.value = "", k.value = !0, w = new AbortController();
      try {
        await G(w.signal);
      } catch (B) {
        if ((B == null ? void 0 : B.name) !== "AbortError" && (_.value = Za(B, n.locale)), (q = c.value) != null && q.id)
          try {
            c.value = await n.client.get(c.value.id);
          } catch {
          }
        b.value = null;
      } finally {
        k.value = !1, w = null, F();
      }
    }
    async function re() {
      const G = v.value.trim();
      if (!G || k.value) return;
      const q = x.value ? [...n.selection] : [];
      v.value = "", b.value = { text: G, paths: q, reply: "", steps: [] }, F(), await J(
        (B) => {
          var K;
          return n.client.chat(
            { conversation_id: ((K = c.value) == null ? void 0 : K.id) || void 0, message: G, paths: q.length ? q : void 0 },
            Z,
            B
          );
        }
      );
    }
    async function ve(G) {
      var B;
      const q = (B = c.value) == null ? void 0 : B.id;
      !q || k.value || (b.value = { text: "", paths: [], reply: "", steps: [] }, await J((K) => n.client.decide(q, G, Z, K)));
    }
    function W() {
      w == null || w.abort();
    }
    async function z(G) {
      var B;
      const q = (B = c.value) == null ? void 0 : B.id;
      if (!(!q || k.value)) {
        _.value = "";
        try {
          const K = await n.client.undo(q, G.id);
          c.value = K.conversation, a("changed");
        } catch (K) {
          _.value = Za(K, n.locale);
        }
      }
    }
    function le() {
      k.value || (c.value = null, b.value = null, _.value = "", p.value = !1, Jt(() => {
        var G;
        return (G = A.value) == null ? void 0 : G.focus();
      }));
    }
    async function fe() {
      if (p.value = !p.value, !!p.value)
        try {
          m.value = await n.client.list();
        } catch (G) {
          _.value = Za(G, n.locale);
        }
    }
    async function j(G) {
      try {
        c.value = await n.client.get(G), p.value = !1, F();
      } catch (q) {
        _.value = Za(q, n.locale);
      }
    }
    async function X(G) {
      var q;
      try {
        await n.client.remove(G), m.value = m.value.filter((B) => B.id !== G), ((q = c.value) == null ? void 0 : q.id) === G && (c.value = null);
      } catch (B) {
        _.value = Za(B, n.locale);
      }
    }
    function te(G) {
      G.key === "Enter" && !G.shiftKey && !G.isComposing && (G.preventDefault(), re());
    }
    function V(G) {
      return Object.entries(G.args ?? {}).map(([q, B]) => [q, typeof B == "string" ? B : JSON.stringify(B)]);
    }
    return qt(async () => {
      try {
        l.value = await n.client.me();
      } catch {
      }
      Jt(() => {
        var G;
        return (G = A.value) == null ? void 0 : G.focus();
      });
    }), Ct(() => w == null ? void 0 : w.abort()), (G, q) => {
      var B;
      return f(), h("aside", {
        class: Ne(["fe-assistant", { "fe-assistant--overlay": e.narrow }]),
        role: "complementary",
        "aria-label": u(i)("ai.assistant"),
        "data-testid": "assistant-panel"
      }, [
        d("header", r7, [
          Je(u(bM), {
            class: "fe-assistant__mark",
            "aria-hidden": "true"
          }),
          d("div", s7, [
            d("h2", l7, y(((B = c.value) == null ? void 0 : B.title) || u(i)("ai.assistant")), 1),
            L.value ? (f(), h("p", u7, y(L.value), 1)) : D("", !0)
          ]),
          d("button", {
            type: "button",
            class: "fe-assistant__iconbtn",
            title: u(i)("assistant.new"),
            "aria-label": u(i)("assistant.new"),
            disabled: k.value,
            "data-testid": "assistant-new",
            onClick: le
          }, [
            Je(u(kM), { "aria-hidden": "true" })
          ], 8, c7),
          d("button", {
            type: "button",
            class: Ne(["fe-assistant__iconbtn", { "is-active": p.value }]),
            title: u(i)("assistant.history"),
            "aria-label": u(i)("assistant.history"),
            "aria-pressed": p.value,
            "data-testid": "assistant-history",
            onClick: fe
          }, [
            Je(u(wM), { "aria-hidden": "true" })
          ], 10, d7),
          d("button", {
            type: "button",
            class: "fe-assistant__iconbtn",
            title: u(i)("assistant.close"),
            "aria-label": u(i)("assistant.close"),
            "data-testid": "assistant-close",
            onClick: q[0] || (q[0] = (K) => a("close"))
          }, [
            Je(u(_M), { "aria-hidden": "true" })
          ], 8, f7)
        ]),
        p.value ? (f(), h("div", p7, [
          m.value.length === 0 ? (f(), h("p", h7, y(u(i)("assistant.history_empty")), 1)) : (f(), h("ul", m7, [
            (f(!0), h(Ce, null, nt(m.value, (K) => (f(), h("li", {
              key: K.id,
              class: "fe-assistant__conv"
            }, [
              d("button", {
                type: "button",
                class: "fe-assistant__conv-open",
                onClick: (ke) => j(K.id)
              }, [
                d("span", y7, [
                  d("bdi", null, y(K.title || u(i)("ai.assistant")), 1)
                ]),
                d("span", g7, y(u(r)(K.updated_ms, { time: !0 })), 1)
              ], 8, v7),
              d("button", {
                type: "button",
                class: "fe-assistant__iconbtn",
                title: u(i)("assistant.delete"),
                "aria-label": u(i)("assistant.delete"),
                onClick: (ke) => X(K.id)
              }, [
                Je(u(xM), { "aria-hidden": "true" })
              ], 8, b7)
            ]))), 128))
          ]))
        ])) : (f(), h("div", {
          key: 1,
          ref_key: "scroller",
          ref: C,
          class: "fe-assistant__scroll",
          "aria-live": "polite"
        }, [
          T.value.length === 0 && !b.value ? (f(), h("p", k7, y(u(i)("assistant.intro")), 1)) : D("", !0),
          (f(!0), h(Ce, null, nt(T.value, (K, ke) => (f(), h(Ce, { key: ke }, [
            K.kind === "user" ? (f(), h("div", w7, [
              d("p", _7, y(K.text), 1),
              K.paths && K.paths.length ? (f(), h("ul", x7, [
                (f(!0), h(Ce, null, nt(K.paths, (Ye) => (f(), h("li", {
                  key: Ye,
                  class: "fe-assistant__chip",
                  title: Ye
                }, [
                  d("bdi", null, y(P(Ye)), 1)
                ], 8, S7))), 128))
              ])) : D("", !0)
            ])) : K.kind === "assistant" ? (f(), h("div", $7, [
              K.text && H.value[K.text] !== void 0 ? (f(), h("div", {
                key: 0,
                class: "fe-assistant__md",
                innerHTML: H.value[K.text]
              }, null, 8, T7)) : (f(), h("p", A7, y(K.text), 1))
            ])) : K.kind === "note" ? (f(), h("div", E7, y(K.text), 1)) : K.kind === "step" && K.step && K.step.status !== "waiting" ? (f(), h("div", {
              key: 3,
              class: Ne(["fe-assistant__step", `is-${K.step.status}`]),
              "data-testid": `assistant-step-${K.step.id}`
            }, [
              K.step.status === "done" ? (f(), We(u(fv), {
                key: 0,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : K.step.status === "undone" ? (f(), We(u(SM), {
                key: 1,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : K.step.status === "denied" || K.step.status === "not_run" ? (f(), We(u($M), {
                key: 2,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : (f(), We(u(Dw), {
                key: 3,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })),
              d("span", z7, [
                d("span", M7, y(K.step.label), 1),
                K.step.target ? (f(), h("span", {
                  key: 0,
                  class: "fe-assistant__step-target",
                  title: K.step.target
                }, [
                  d("bdi", null, y(P(K.step.target)), 1)
                ], 8, O7)) : D("", !0),
                K.step.to ? (f(), h("span", {
                  key: 1,
                  class: "fe-assistant__step-to",
                  title: K.step.to
                }, [
                  d("bdi", null, y(P(K.step.to)), 1)
                ], 8, P7)) : D("", !0),
                d("span", D7, y(K.step.status_label), 1),
                K.step.error ? (f(), h("span", L7, y(K.step.error), 1)) : D("", !0)
              ]),
              K.step.can_undo ? (f(), h("button", {
                key: 4,
                type: "button",
                class: "fe-assistant__undo",
                disabled: k.value,
                "data-testid": `assistant-undo-${K.step.id}`,
                onClick: (Ye) => z(K.step)
              }, y(u(i)("assistant.undo")), 9, R7)) : D("", !0)
            ], 10, C7)) : D("", !0)
          ], 64))), 128)),
          b.value ? (f(), h(Ce, { key: 1 }, [
            b.value.text ? (f(), h("div", N7, [
              d("p", I7, y(b.value.text), 1),
              b.value.paths.length ? (f(), h("ul", B7, [
                (f(!0), h(Ce, null, nt(b.value.paths, (K) => (f(), h("li", {
                  key: K,
                  class: "fe-assistant__chip",
                  title: K
                }, [
                  d("bdi", null, y(P(K)), 1)
                ], 8, F7))), 128))
              ])) : D("", !0)
            ])) : D("", !0),
            (f(!0), h(Ce, null, nt(b.value.steps.filter((K) => K.status !== "waiting"), (K) => (f(), h("div", {
              key: `live-${K.id}`,
              class: Ne(["fe-assistant__step", `is-${K.status}`])
            }, [
              K.status === "running" ? (f(), We(u(Lw), {
                key: 0,
                class: "fe-assistant__step-icon fe-assistant__spin",
                "aria-hidden": "true"
              })) : K.status === "done" ? (f(), We(u(fv), {
                key: 1,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })) : (f(), We(u(Dw), {
                key: 2,
                class: "fe-assistant__step-icon",
                "aria-hidden": "true"
              })),
              d("span", U7, [
                d("span", H7, y(K.label), 1),
                K.target ? (f(), h("span", {
                  key: 0,
                  class: "fe-assistant__step-target",
                  title: K.target
                }, [
                  d("bdi", null, y(P(K.target)), 1)
                ], 8, K7)) : D("", !0),
                d("span", V7, y(K.status_label), 1)
              ])
            ], 2))), 128)),
            b.value.reply ? (f(), h("div", j7, [
              d("p", q7, y(b.value.reply), 1)
            ])) : k.value ? (f(), h("p", W7, [
              Je(u(Lw), {
                class: "fe-assistant__spin fe-assistant__inline-icon",
                "aria-hidden": "true"
              }),
              Vt(y(u(i)("assistant.working")), 1)
            ])) : D("", !0)
          ], 64)) : D("", !0),
          R.value ? (f(), h("section", {
            key: 2,
            class: "fe-assistant__card",
            role: "group",
            "aria-label": R.value.label,
            "data-testid": "assistant-approval"
          }, [
            d("p", G7, y(R.value.question), 1),
            R.value.note ? (f(), h("p", X7, y(R.value.note), 1)) : D("", !0),
            V(R.value).length ? (f(), h("dl", J7, [
              (f(!0), h(Ce, null, nt(V(R.value), ([K, ke]) => (f(), h(Ce, { key: K }, [
                d("dt", null, y(K), 1),
                d("dd", null, [
                  d("bdi", null, y(ke), 1)
                ])
              ], 64))), 128))
            ])) : D("", !0),
            d("div", Z7, [
              d("button", {
                type: "button",
                class: "fe-btn",
                disabled: k.value,
                "data-testid": "assistant-decline",
                onClick: q[1] || (q[1] = (K) => ve(!1))
              }, y(u(i)("assistant.decline")), 9, Q7),
              d("button", {
                type: "button",
                class: "fe-btn fe-btn--primary",
                disabled: k.value,
                "data-testid": "assistant-approve",
                onClick: q[2] || (q[2] = (K) => ve(!0))
              }, y(u(i)("assistant.approve")), 9, eV)
            ])
          ], 8, Y7)) : D("", !0),
          _.value ? (f(), h("p", tV, y(_.value), 1)) : D("", !0)
        ], 512)),
        d("footer", nV, [
          M.value > 0 ? (f(), h("label", aV, [
            cn(d("input", {
              "onUpdate:modelValue": q[3] || (q[3] = (K) => x.value = K),
              type: "checkbox",
              "data-testid": "assistant-with-selection"
            }, null, 512), [
              [wc, x.value]
            ]),
            d("span", null, y(u(i)("assistant.with_selection", { count: M.value })), 1)
          ])) : D("", !0),
          d("div", iV, [
            cn(d("textarea", {
              ref_key: "field",
              ref: A,
              "onUpdate:modelValue": q[4] || (q[4] = (K) => v.value = K),
              class: "fe-assistant__input",
              rows: "2",
              placeholder: u(i)("assistant.placeholder"),
              "aria-label": u(i)("assistant.placeholder"),
              "data-testid": "assistant-input",
              onKeydown: te
            }, null, 40, oV), [
              [xn, v.value]
            ]),
            k.value ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-btn fe-assistant__send",
              title: u(i)("assistant.stop"),
              "aria-label": u(i)("assistant.stop"),
              "data-testid": "assistant-stop",
              onClick: W
            }, [
              Je(u(TM), { "aria-hidden": "true" })
            ], 8, rV)) : (f(), h("button", {
              key: 1,
              type: "button",
              class: "fe-btn fe-btn--primary fe-assistant__send",
              title: u(i)("assistant.send"),
              "aria-label": u(i)("assistant.send"),
              disabled: !v.value.trim(),
              "data-testid": "assistant-send",
              onClick: re
            }, [
              Je(u(AM), { "aria-hidden": "true" })
            ], 8, sV))
          ])
        ])
      ], 10, o7);
    };
  }
});
function uV(e) {
  return e.replace(/\/manager(\?.*)?$/, "/assistant");
}
function cV(e) {
  let t = "";
  const n = (a) => {
    let i = "";
    const r = [];
    for (const l of a.split(`
`))
      l.startsWith("event:") ? i = l.slice(6).trim() : l.startsWith("data:") && r.push(l.slice(5).replace(/^ /, ""));
    if (!(!i || r.length === 0))
      try {
        e({ name: i, data: JSON.parse(r.join(`
`)) });
      } catch {
      }
  };
  return (a, i = !1) => {
    t += a.replace(/\r\n/g, `
`);
    let r = t.indexOf(`

`);
    for (; r >= 0; )
      n(t.slice(0, r)), t = t.slice(r + 2), r = t.indexOf(`

`);
    i && t.trim() && (n(t), t = "");
  };
}
async function I1(e, t, n, a, i) {
  var m;
  const r = await e.request(t, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
    body: JSON.stringify(n),
    signal: i
  });
  if (!r.ok)
    throw e.failure(r.status, await r.text().catch(() => ""));
  const l = cV(a), c = (m = r.body) == null ? void 0 : m.getReader();
  if (!c) {
    l(await r.text(), !0);
    return;
  }
  const p = new TextDecoder();
  for (; ; ) {
    const { done: v, value: x } = await c.read();
    if (v) break;
    l(p.decode(x, { stream: !0 }));
  }
  l(p.decode(), !0);
}
function dV(e, t) {
  const n = t.replace(/\/+$/, ""), a = (i, r) => ({
    method: i,
    headers: { "Content-Type": "application/json" },
    ...r === void 0 ? {} : { body: JSON.stringify(r) }
  });
  return {
    me: () => e.json(`${n}`),
    setPrefs: (i) => e.json(`${n}/prefs`, a("PUT", i)),
    list: async () => (await e.json(`${n}/conversations`)).conversations ?? [],
    get: (i) => e.json(`${n}/conversations/${i}`),
    remove: (i) => e.json(`${n}/conversations/${i}`, { method: "DELETE" }),
    clear: () => e.json(`${n}/conversations`, { method: "DELETE" }),
    chat: (i, r, l) => I1(e, `${n}/chat`, i, r, l),
    decide: (i, r, l, c) => I1(e, `${n}/conversations/${i}/decide`, { approve: r }, l, c),
    undo: (i, r) => e.json(
      `${n}/conversations/${i}/undo`,
      a("POST", { step_id: r })
    )
  };
}
const ry = 500, fV = 800, B1 = 10, pV = 'button, a, input, select, textarea, label, [role="checkbox"], [data-fe-control]';
function Ag(e, t) {
  return { ctrl: e.ctrlKey || e.metaKey, shift: e.shiftKey, touch: t };
}
function Eg(e) {
  return { ctrl: !0, shift: e.shiftKey, check: !0 };
}
function hV(e) {
  const t = e.target;
  if (typeof (t == null ? void 0 : t.closest) != "function") return !1;
  const n = t.closest(pV), a = e.currentTarget;
  return n !== null && (a === null || typeof a.contains != "function" || a.contains(n));
}
function Cg(e, t = {}) {
  let n, a = null, i = { clientX: 0, clientY: 0 }, r = !1, l = 0, c = !1;
  function p() {
    n && clearTimeout(n), n = void 0;
  }
  function m(_, w) {
    const b = w.touches[0];
    b && (p(), a = _, r = !1, i = { clientX: b.clientX, clientY: b.clientY }, c = !hV(w), n = setTimeout(() => {
      n = void 0, a !== null && (r = !0, e(a, i));
    }, ry));
  }
  function v(_) {
    const w = _.touches[0];
    (!w || Math.abs(w.clientX - i.clientX) > B1 || Math.abs(w.clientY - i.clientY) > B1) && (p(), a = null);
  }
  function x(_) {
    p();
    const w = a, b = r, C = w !== null && !b;
    C && (l = Date.now()), a = null, C && c && t.onTap && (_ != null && _.cancelable && _.preventDefault(), t.onTap(w)), b && (_ != null && _.cancelable) && _.preventDefault(), c = !1;
  }
  function k(_) {
    const w = _.pointerType;
    return w ? w === "touch" : Date.now() - l < fV;
  }
  return Ct(p), { onTouchStart: m, onTouchMove: v, onTouchEnd: x, isTap: k };
}
const F1 = 5, U1 = 10, mV = 300, H1 = 28;
function vV(e) {
  const t = S(null), n = S(null), a = S(!1);
  let i = null, r = 0;
  function l(C) {
    const A = e.keys();
    for (let T = 0; T < A.length; T++) {
      const R = e.rowEl(A[T]);
      if (!R) continue;
      const M = R.getBoundingClientRect();
      if (C < M.top + M.height / 2) return T;
    }
    return A.length;
  }
  function c(C, A) {
    const T = A.pointerType === "touch";
    if (!T && A.button !== 0) return;
    w();
    const R = e.touchDelayMs ?? ry, M = {
      key: C,
      pointerId: A.pointerId,
      touch: T,
      startX: A.clientX,
      startY: A.clientY,
      pressed: !T || R <= 0,
      armed: !1
    };
    T && R > 0 && (M.timer = setTimeout(() => {
      i === M && (M.pressed = !0, t.value = C);
    }, R)), i = M, window.addEventListener("pointermove", m), window.addEventListener("pointerup", x), window.addEventListener("pointercancel", _), window.addEventListener("blur", _), window.addEventListener("keydown", k, !0), T && window.addEventListener("touchmove", p, { passive: !1 });
  }
  function p(C) {
    i != null && i.pressed && C.cancelable && C.preventDefault();
  }
  function m(C) {
    var P;
    const A = i;
    if (!A || C.pointerId !== A.pointerId) return;
    const T = C.clientX - A.startX, R = C.clientY - A.startY;
    if (!A.armed) {
      if (!A.pressed) {
        (Math.abs(T) > U1 || Math.abs(R) > U1) && w();
        return;
      }
      if (Math.abs(T) < F1 && Math.abs(R) < F1) return;
      A.armed = !0, t.value = A.key, a.value = !0;
    }
    const M = l(C.clientY), L = e.keys().indexOf(A.key);
    n.value = M === L || M === L + 1 ? null : M;
    const U = (P = e.scroller) == null ? void 0 : P.call(e);
    if (U) {
      const H = U.getBoundingClientRect();
      C.clientY < H.top + H1 ? U.scrollTop -= 12 : C.clientY > H.bottom - H1 && (U.scrollTop += 12);
    }
  }
  function v() {
    const C = (R) => {
      R.cancelable && R.preventDefault(), T();
    }, A = setTimeout(() => T(), 600);
    function T() {
      clearTimeout(A), window.removeEventListener("touchend", C, !0);
    }
    window.addEventListener("touchend", C, { capture: !0, passive: !1 });
  }
  function x(C) {
    var R;
    const A = i;
    if (!A || C.pointerId !== A.pointerId) return;
    const T = n.value;
    if (w(), A.touch && A.pressed && v(), A.armed) {
      r = Date.now(), T !== null && e.onDrop(A.key, T);
      return;
    }
    A.touch && A.pressed && (e.touchDelayMs ?? ry) > 0 && (r = Date.now(), (R = e.onHold) == null || R.call(e, A.key));
  }
  function k(C) {
    C.key !== "Escape" || !i || (C.preventDefault(), C.stopPropagation(), _());
  }
  function _() {
    const C = (i == null ? void 0 : i.armed) === !0;
    w(), C && (r = Date.now());
  }
  function w() {
    i != null && i.timer && clearTimeout(i.timer), i = null, t.value = null, n.value = null, a.value = !1, window.removeEventListener("pointermove", m), window.removeEventListener("pointerup", x), window.removeEventListener("pointercancel", _), window.removeEventListener("blur", _), window.removeEventListener("keydown", k, !0), window.removeEventListener("touchmove", p);
  }
  function b(C) {
    Date.now() - r < mV && (C.preventDefault(), C.stopPropagation());
  }
  return Ct(w), {
    dragKey: t,
    dropGap: n,
    reordering: a,
    touchActive: () => (i == null ? void 0 : i.touch) === !0,
    onPointerDown: c,
    onClickCapture: b
  };
}
function Ja(e) {
  return e.uid || e.name;
}
function W$(e) {
  return e.map(Ja);
}
function Yp(e) {
  if (typeof e != "string" || !e) return [];
  let t;
  try {
    t = JSON.parse(e);
  } catch {
    return [];
  }
  if (!Array.isArray(t)) return [];
  const n = [], a = /* @__PURE__ */ new Set();
  for (const i of t)
    typeof i != "string" || !i || a.has(i) || (a.add(i), n.push(i));
  return n;
}
function yV(e) {
  return e.length ? JSON.stringify(e) : "";
}
function gV(e) {
  return typeof e == "number" && Number.isFinite(e) ? e : null;
}
function bV(e) {
  return e.map((t, n) => ({ s: t, i: n, p: gV(t.sortOrder) })).sort((t, n) => t.p === null || n.p === null ? t.p === n.p ? t.i - n.i : t.p === null ? 1 : -1 : t.p - n.p || t.i - n.i).map((t) => t.s);
}
function kV(e, t) {
  const n = bV(e);
  if (!t.length || n.length < 2) return n;
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, p) => {
    a.has(c) || a.set(c, p);
  });
  const i = (c) => (c.uid ? a.get(c.uid) : void 0) ?? a.get(c.name), r = n.filter((c) => i(c) !== void 0).sort((c, p) => (i(c) ?? 0) - (i(p) ?? 0));
  let l = 0;
  return n.map((c) => i(c) === void 0 ? c : r[l++]);
}
function K1(e, t, n) {
  const a = W$(e), i = a.indexOf(t), r = i + n;
  return i < 0 || n === 0 || r < 0 || r >= a.length ? null : (a.splice(i, 1), a.splice(r, 0, t), a);
}
function wV(e, t, n) {
  const a = W$(e), i = a.indexOf(t);
  if (i < 0) return null;
  const r = Math.max(0, Math.min(a.length, Math.trunc(n)));
  return r === i || r === i + 1 ? null : (a.splice(i, 1), a.splice(r > i ? r - 1 : r, 0, t), a);
}
function V1(e) {
  return e.map((t, n) => ({ s: t, i: n })).sort((t, n) => pS(t.s.label || t.s.name, n.s.label || n.s.name) || t.i - n.i).map((t) => Ja(t.s));
}
function _V(e, t, n) {
  const a = [...e];
  if (!n.length) return a;
  const i = /* @__PURE__ */ new Map();
  for (const l of t)
    i.set(l.name, Ja(l)), l.uid && i.set(l.uid, Ja(l));
  let r = null;
  for (const l of n) {
    const c = i.get(l);
    if (c !== void 0) {
      r = c;
      continue;
    }
    if (a.includes(l)) continue;
    const p = r === null ? 0 : a.indexOf(r) + 1;
    a.splice(p, 0, l), r = l;
  }
  return a;
}
const Vo = S([]);
let Ks = null, Jm = "";
function xV() {
  return Qo() ? Yp(rp("storageOrder")) : [];
}
function SV(e, t) {
  const n = e.length ? _V(e, t, Vo.value) : [];
  Vo.value = n;
  const a = yV(n);
  if (!Kc()) {
    Vr("storageOrder", a);
    return;
  }
  if (o$()) {
    j1(a);
    return;
  }
  Vr("storageOrder", a), Jm = a, !Ks && (Ks = Vc(() => {
    Ks == null || Ks(), Ks = null, j1(Jm), Vo.value = Yp(Jm);
  }));
}
function j1(e) {
  Zi("storageOrder", e), wF();
}
function $V() {
  Vo.value = xV();
  const e = Vc(() => {
    Vo.value = Yp(Qi().storageOrder);
  });
  return Go() && Ct(e), { saved: Vo, custom: E(() => Vo.value.length > 0) };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== hc.storageOrder || !Qo() || (Vo.value = Yp(e.newValue));
    });
  } catch {
  }
const TV = {
  class: "fe-stags",
  "data-testid": "storage-tags"
}, AV = ["title"], EV = {
  key: 1,
  class: "fe-stag fe-stag--warn tbl-pill",
  "data-testid": "storage-tag-readonly"
}, CV = {
  key: 2,
  class: "fe-stag tbl-pill",
  "data-testid": "storage-tag-disabled"
}, Y$ = /* @__PURE__ */ rt({
  __name: "StorageTags",
  props: {
    driver: {},
    readOnly: { type: Boolean },
    enabled: { type: Boolean, default: void 0 },
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale ?? "en"), a = E(() => {
      if (!t.driver) return "";
      const i = `storages.driver.${t.driver}`, r = n(i);
      return r === i ? t.driver : r;
    });
    return (i, r) => (f(), h("span", TV, [
      e.driver ? (f(), h("span", {
        key: 0,
        class: "fe-stag tbl-pill",
        title: e.driver,
        "data-testid": "storage-tag-driver"
      }, y(a.value), 9, AV)) : D("", !0),
      e.readOnly ? (f(), h("span", EV, y(u(n)("sidenav.storage.readOnly")), 1)) : D("", !0),
      e.enabled === !1 ? (f(), h("span", CV, y(u(n)("conn.list.disabled")), 1)) : D("", !0)
    ]));
  }
}), zV = ["aria-label"], MV = {
  key: 0,
  class: "fe-sidenav__head"
}, OV = ["aria-expanded", "title", "aria-label"], PV = { class: "fe-sidenav__primary" }, DV = ["title", "aria-label"], LV = { class: "fe-sidenav__new-main" }, RV = {
  key: 0,
  class: "fe-sidenav__text"
}, NV = {
  key: 0,
  class: "fe-sidenav__new-rule",
  "aria-hidden": "true"
}, IV = {
  key: 1,
  class: "fe-sidenav__new-caret",
  "aria-hidden": "true"
}, BV = { class: "fe-sidenav__scroll" }, FV = ["aria-label"], UV = ["aria-current", "title", "aria-label", "data-testid", "onClick"], HV = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, KV = {
  key: 1,
  d: "M3.5 7.5A1.5 1.5 0 0 1 5 6h4l2 2.5h8A1.5 1.5 0 0 1 20.5 10v7.5A1.5 1.5 0 0 1 19 19H5a1.5 1.5 0 0 1-1.5-1.5z"
}, VV = {
  key: 3,
  d: "M12 4l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4-3.9-3.8 5.4-.8z"
}, jV = {
  key: 0,
  class: "fe-sidenav__text"
}, qV = { key: 0 }, WV = ["title", "aria-label"], YV = {
  key: 0,
  class: "fe-sidenav__text"
}, GV = {
  key: 0,
  class: "fe-sidenav__section"
}, XV = { class: "fe-sidenav__heading" }, JV = ["data-testid"], ZV = ["aria-label"], QV = ["aria-current", "title", "aria-label", "data-testid", "data-tag-kind", "onClick"], ej = { class: "fe-sidenav__text" }, tj = ["aria-label"], nj = { key: 0 }, aj = { class: "fe-sidenav__hint" }, ij = { key: 1 }, oj = { key: 2 }, rj = ["aria-label"], sj = ["title", "aria-label"], lj = {
  key: 1,
  class: "fe-sidenav__section"
}, uj = {
  key: 0,
  class: "fe-sidenav__heading"
}, cj = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, dj = ["aria-label"], fj = ["title", "aria-label", "data-testid", "onClick", "onContextmenu", "onKeydown", "onPointerdown"], pj = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, hj = {
  key: 0,
  class: "fe-sidenav__text"
}, mj = ["aria-label"], vj = {
  key: 2,
  class: "fe-sidenav__section",
  "data-testid": "sidenav-apps"
}, yj = {
  key: 0,
  class: "fe-sidenav__heading"
}, gj = {
  key: 1,
  class: "fe-sidenav__rule",
  "aria-hidden": "true"
}, bj = ["aria-label"], kj = ["title", "aria-label", "data-testid", "onClick"], wj = ["innerHTML"], _j = {
  key: 0,
  class: "fe-sidenav__text"
}, xj = { key: 0 }, Sj = ["title", "aria-label"], $j = {
  key: 0,
  class: "fe-sidenav__text"
}, Tj = {
  key: 3,
  class: "fe-sidenav__section",
  "data-testid": "sidenav-connections"
}, Aj = ["aria-label"], Ej = ["title", "aria-label"], Cj = {
  key: 0,
  class: "fe-sidenav__text"
}, zj = { key: 0 }, Mj = ["title", "aria-label"], Oj = {
  key: 0,
  class: "fe-sidenav__text"
}, Pj = {
  key: 1,
  class: "fe-sidenav__quota",
  "data-testid": "sidenav-quota"
}, Dj = {
  key: 0,
  class: "fe-sidenav__quota-label"
}, Lj = ["aria-valuenow", "aria-label", "title"], Rj = {
  key: 1,
  class: "fe-sidenav__quota-text"
}, q1 = 8, Nj = /* @__PURE__ */ rt({
  __name: "SideNav",
  props: {
    expanded: { type: Boolean },
    narrow: { type: Boolean },
    activeView: {},
    activeStorage: {},
    storages: {},
    storageOrderCustom: { type: Boolean },
    sharedStorages: {},
    trashVisible: { type: Boolean },
    draftsVisible: { type: Boolean },
    draftCount: {},
    tags: {},
    tagsLoaded: { type: Boolean },
    activeTag: {},
    activeTagKind: {},
    showConnections: { type: Boolean },
    showMyShares: { type: Boolean },
    showAppStore: { type: Boolean },
    showIdentitySurfaces: { type: Boolean },
    canWrite: { type: Boolean },
    locale: {},
    canRequestFiles: { type: Boolean },
    requestFilesAllowed: { type: Boolean, default: !0 },
    canNewDocument: { type: Boolean },
    quota: {},
    theme: {},
    apps: {}
  },
  emits: ["toggle", "open-view", "open-tag", "open-storage", "open-root", "upload", "new-folder", "new-document", "open-connections", "open-tokens", "open-my-shares", "open-app-store", "open-app", "request-files", "reorder-storages", "close"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, dir: l } = ht(() => n.locale), c = E(() => n.expanded || !!n.narrow), p = E(() => new Set(n.sharedStorages ?? [])), m = /* @__PURE__ */ new Set(["recent", "starred", "shared", "drafts"]), v = E(() => {
      const ze = [
        { key: "home", label: i("sidenav.home") },
        ...n.storages.length <= 1 ? [{ key: "myfiles", label: i("sidenav.myfiles") }] : [],
        { key: "shared", label: i("sidenav.shared") },
        { key: "recent", label: i("sidenav.recent") },
        { key: "starred", label: i("sidenav.starred") }
      ];
      return n.draftsVisible && ze.push({ key: "drafts", label: i("sidenav.drafts") }), n.trashVisible !== !1 && ze.push({ key: "trash", label: i("sidenav.trash") }), n.showIdentitySurfaces === !1 ? ze.filter((oe) => !m.has(oe.key)) : ze;
    }), x = E(() => n.canWrite !== !1), k = E(
      () => (n.apps ?? []).map((ze) => ({
        ...ze,
        svg: Pt(ze.icon && Pt(ze.icon) !== "" ? ze.icon : "plugin")
      }))
    ), _ = E(
      () => !!n.activeStorage && n.storages.some((ze) => ze.name === n.activeStorage && ze.readOnly === !0)
    ), w = E(() => !_.value && n.activeView !== "trash");
    function b(ze) {
      const oe = n.draftCount ?? 0;
      return ze.key !== "drafts" || oe <= 0 ? ze.label : `${ze.label}, ${i("sidenav.drafts.count", { n: oe })}`;
    }
    function C(ze) {
      return ze === "myfiles" ? !n.activeView && !n.activeStorage : n.activeView === ze;
    }
    const A = S(!1), T = E(() => n.tags ?? []), R = E(
      () => ["personal", "team"].map((ze) => {
        const oe = T.value.filter((Se) => Se.kind === ze);
        return { kind: ze, list: oe, visible: A.value ? oe : oe.slice(0, q1) };
      }).filter((ze) => ze.list.length > 0)
    ), M = E(
      () => R.value.reduce((ze, oe) => ze + oe.list.length - oe.visible.length, 0)
    ), L = E(() => R.value.some((ze) => ze.list.length > q1));
    function U(ze) {
      return n.activeView !== "tag" || n.activeTag !== ze.name ? !1 : !n.activeTagKind || n.activeTagKind === ze.kind;
    }
    const P = E(() => !!n.tagsLoaded || T.value.length > 0), H = S(null), $ = S(null), F = E(() => {
      const ze = [
        /* ⚠ NO `icon:` on any of these three, and that is the fix rather than an
           omission. `ContextMenu.iconFor` resolves `actionIconSvg(a.icon || a.key)`,
           so an `icon` string is an OVERRIDE — and `'⬆'` / `'📁'` / `'🔗'` are not
           keys, so the lookup missed, the component fell through to its literal
           branch and printed the emoji. Meanwhile `new-document`, which carries no
           override, resolved by key and drew a proper glyph: one menu, two icon
           systems, three rows apart. All three keys have had stroked glyphs in
           `lib/actionIcons.ts` the whole time (`upload`, `new-folder`,
           `request-files`); dropping the override is what reaches them.
           ⚠ Emoji in markup is forbidden here for a reason that is visible in this
           very menu: they are rendered by whatever font the OS ships, so the row
           came out flat-grey on one machine and full-colour on another, at a weight
           that matched nothing beside it. */
        { key: "upload", label: i("drive.new.upload"), disabled: !x.value },
        { key: "new-folder", label: i("drive.new.folder"), disabled: !x.value }
      ];
      return n.canNewDocument && ze.push({ key: "new-document", label: i("drive.new.document"), disabled: !x.value }), n.requestFilesAllowed !== !1 && (ze.push({ divider: !0, key: "new-sep", label: "" }), ze.push({
        key: "request-files",
        label: i("drive.new.request"),
        disabled: !n.canRequestFiles
      })), ze;
    });
    function I() {
      var oe, Se;
      const ze = (oe = H.value) == null ? void 0 : oe.getBoundingClientRect();
      (Se = $.value) == null || Se.show(
        // ⚠ RTL: hangs from the pill's START edge (its right side in RTL).
        { clientX: ze ? Rr(ze, l.value) : 0, clientY: ze ? ze.bottom + 6 : 0 },
        []
      );
    }
    function Z(ze) {
      ze.key === "upload" ? a("upload") : ze.key === "new-document" ? a("new-document") : ze.key === "new-folder" ? a("new-folder") : ze.key === "request-files" && a("request-files");
    }
    const J = E(() => {
      const ze = n.quota;
      return !ze || ze.unlimited || ze.total <= 0 ? 0 : Math.max(0, Math.min(100, Math.round(ze.used / ze.total * 100)));
    }), re = E(() => {
      const ze = n.quota;
      return ze ? ze.unlimited || ze.total <= 0 ? ze.partial ? i("drive.storage.used_partial", { used: r(ze.used) }) : i("drive.storage.used_unlimited", { used: r(ze.used) }) : i("drive.storage.used", { used: r(ze.used), total: r(ze.total) }) : "";
    }), ve = E(() => i("sidenav.close")), W = E(() => n.storages.length > 1), z = /* @__PURE__ */ new Map();
    function le(ze, oe) {
      oe instanceof HTMLElement ? z.set(ze, oe) : z.delete(ze);
    }
    const fe = S(null), j = S(null), X = S(""), te = S(!1);
    function V(ze) {
      return n.storages.findIndex((oe) => Ja(oe) === ze);
    }
    const G = E(() => {
      const ze = V(X.value), oe = n.storages.length, Se = n.storages.map(Ja), Ke = V1(n.storages).every((Le, ut) => Le === Se[ut]);
      return [
        {
          key: "storage-move-up",
          icon: "move-up",
          label: i("sidenav.storage.moveUp"),
          disabled: ze <= 0,
          testid: "sidenav-storage-move-up"
        },
        {
          key: "storage-move-down",
          icon: "move-down",
          label: i("sidenav.storage.moveDown"),
          disabled: ze < 0 || ze >= oe - 1,
          testid: "sidenav-storage-move-down"
        },
        { divider: !0, key: "storage-order-sep", label: "" },
        {
          key: "storage-sort-name",
          icon: "sort-name",
          label: i("sidenav.storage.sortName"),
          disabled: Ke,
          // ⚠ A greyed row says why, or it reads as broken (ContextAction.title).
          title: Ke ? i("sidenav.storage.sortName.done") : void 0,
          testid: "sidenav-storage-sort-name"
        },
        {
          // "Use default order": drop the person's own order and fall back to the
          // administrator's (or, with none, the host's). Not "Reset": nothing of
          // the default is being reset, the person's order is being let go.
          key: "storage-default-order",
          icon: "reset-order",
          label: i("sidenav.storage.defaultOrder"),
          disabled: !n.storageOrderCustom,
          title: n.storageOrderCustom ? void 0 : i("sidenav.storage.defaultOrder.none"),
          testid: "sidenav-storage-default-order"
        }
      ];
    });
    function q(ze, oe, Se = !1) {
      var Le, ut;
      if (!W.value) return;
      const he = Ja(ze);
      X.value = he, te.value = Se;
      let Ke = oe;
      if (!Ke) {
        const wt = (Le = z.get(he)) == null ? void 0 : Le.getBoundingClientRect();
        Ke = wt ? { clientX: Rr(wt, l.value), clientY: wt.bottom + 4 } : { clientX: 0, clientY: 0 };
      }
      (ut = j.value) == null || ut.show(Ke, []);
    }
    function B(ze, oe) {
      W.value && (oe.preventDefault(), oe.stopPropagation(), !qe.touchActive() && q(ze, { clientX: oe.clientX, clientY: oe.clientY }));
    }
    let K = null;
    function ke(ze = !1) {
      K == null || K();
      const oe = (Ke) => {
        const Le = Ke.target, ut = typeof (Le == null ? void 0 : Le.closest) == "function" && !!Le.closest(".fe-ctx-backdrop");
        !ze && !ut || (Ke.preventDefault(), Ke.stopPropagation(), he());
      }, Se = setTimeout(() => he(), 1e3);
      function he() {
        clearTimeout(Se), window.removeEventListener("contextmenu", oe, !0), K = null;
      }
      window.addEventListener("contextmenu", oe, !0), K = he;
    }
    Ct(() => K == null ? void 0 : K());
    function Ye(ze, oe) {
      oe.key !== "ContextMenu" && !(oe.key === "F10" && oe.shiftKey) || W.value && (oe.preventDefault(), oe.stopPropagation(), ke(), q(ze, null));
    }
    async function Oe(ze, oe) {
      var Se;
      ze !== null && (a("reorder-storages", ze), await Jt(), (Se = z.get(oe)) == null || Se.focus());
    }
    function Be(ze) {
      const oe = X.value;
      ze.key === "storage-move-up" ? Oe(K1(n.storages, oe, -1), oe) : ze.key === "storage-move-down" ? Oe(K1(n.storages, oe, 1), oe) : ze.key === "storage-sort-name" ? Oe(V1(n.storages), oe) : ze.key === "storage-default-order" && Oe([], oe);
    }
    const qe = vV({
      keys: () => n.storages.map(Ja),
      rowEl: (ze) => z.get(ze),
      scroller: () => {
        var ze;
        return (ze = fe.value) == null ? void 0 : ze.querySelector(".fe-sidenav__scroll");
      },
      onDrop: (ze, oe) => void Oe(wV(n.storages, ze, oe), ze),
      onHold: (ze) => {
        const oe = n.storages.find((Se) => Ja(Se) === ze);
        oe && (ke(!0), q(oe, null, !0));
      }
    }), { dragKey: Tt, dropGap: $t, reordering: it, onClickCapture: yt } = qe;
    function ft(ze, oe) {
      W.value && qe.onPointerDown(Ja(ze), oe);
    }
    return (ze, oe) => (f(), h("nav", {
      ref_key: "navEl",
      ref: fe,
      class: Ne(["fe-sidenav", {
        "fe-sidenav--rail": !e.expanded && !e.narrow,
        "fe-sidenav--drawer": e.narrow,
        "fe-sidenav--reordering": u(it)
      }]),
      role: "navigation",
      "aria-label": u(i)("sidenav.title"),
      "data-testid": "sidenav"
    }, [
      e.narrow ? (f(), h("div", MV, [
        d("button", {
          type: "button",
          class: "fe-sidenav__toggle",
          "aria-expanded": c.value,
          title: ve.value,
          "aria-label": ve.value,
          "data-testid": "sidenav-toggle",
          onClick: oe[0] || (oe[0] = (Se) => a("close"))
        }, [...oe[9] || (oe[9] = [
          d("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.8",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("path", { d: "M6 6l12 12M18 6L6 18" })
          ], -1)
        ])], 8, OV)
      ])) : D("", !0),
      d("div", PV, [
        w.value ? (f(), h("button", {
          key: 0,
          ref_key: "newBtnEl",
          ref: H,
          type: "button",
          class: "fe-sidenav__new",
          "aria-haspopup": "menu",
          title: u(i)("drive.new"),
          "aria-label": u(i)("drive.new"),
          "data-testid": "sidenav-new",
          onClick: I
        }, [
          d("span", LV, [
            oe[10] || (oe[10] = d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M12 5v14M5 12h14" })
            ], -1)),
            c.value ? (f(), h("span", RV, y(u(i)("drive.new")), 1)) : D("", !0)
          ]),
          c.value ? (f(), h("span", NV)) : D("", !0),
          c.value ? (f(), h("span", IV, [...oe[11] || (oe[11] = [
            d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1)
          ])])) : D("", !0)
        ], 8, DV)) : D("", !0)
      ]),
      d("div", BV, [
        d("ul", {
          class: "fe-sidenav__group",
          "aria-label": u(i)("sidenav.views")
        }, [
          (f(!0), h(Ce, null, nt(v.value, (Se) => (f(), h(Ce, {
            key: Se.key
          }, [
            d("li", null, [
              d("button", {
                type: "button",
                class: Ne(["fe-sidenav__item", { "is-active": C(Se.key) }]),
                "aria-current": C(Se.key) ? "page" : void 0,
                title: b(Se),
                "aria-label": b(Se),
                "data-testid": `sidenav-view-${Se.key}`,
                onClick: (he) => a("open-view", Se.key)
              }, [
                (f(), h("svg", HV, [
                  Se.key === "home" ? (f(), h(Ce, { key: 0 }, [
                    oe[12] || (oe[12] = d("path", { d: "M4 10.5L12 4l8 6.5" }, null, -1)),
                    oe[13] || (oe[13] = d("path", { d: "M6 9.8V19a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.8" }, null, -1)),
                    oe[14] || (oe[14] = d("path", { d: "M10 20v-5.5h4V20" }, null, -1))
                  ], 64)) : Se.key === "myfiles" ? (f(), h("path", KV)) : Se.key === "recent" ? (f(), h(Ce, { key: 2 }, [
                    oe[15] || (oe[15] = d("circle", {
                      cx: "12",
                      cy: "12",
                      r: "8.5"
                    }, null, -1)),
                    oe[16] || (oe[16] = d("path", { d: "M12 7.5V12l3 2" }, null, -1))
                  ], 64)) : Se.key === "starred" ? (f(), h("path", VV)) : Se.key === "shared" ? (f(), h(Ce, { key: 4 }, [
                    oe[17] || (oe[17] = d("circle", {
                      cx: "17.5",
                      cy: "6.5",
                      r: "2.5"
                    }, null, -1)),
                    oe[18] || (oe[18] = d("circle", {
                      cx: "6.5",
                      cy: "12",
                      r: "2.5"
                    }, null, -1)),
                    oe[19] || (oe[19] = d("circle", {
                      cx: "17.5",
                      cy: "17.5",
                      r: "2.5"
                    }, null, -1)),
                    oe[20] || (oe[20] = d("path", { d: "M8.8 10.8l6.4-3.2M8.8 13.2l6.4 3.2" }, null, -1))
                  ], 64)) : Se.key === "drafts" ? (f(), h(Ce, { key: 5 }, [
                    oe[21] || (oe[21] = d("path", { d: "M13.5 4H7a1.5 1.5 0 0 0-1.5 1.5v13A1.5 1.5 0 0 0 7 20h10a1.5 1.5 0 0 0 1.5-1.5V9z" }, null, -1)),
                    oe[22] || (oe[22] = d("path", { d: "M13.5 4v5h5" }, null, -1)),
                    oe[23] || (oe[23] = d("path", { d: "M9 15.5l4.8-4.8 1.7 1.7-4.8 4.8H9z" }, null, -1))
                  ], 64)) : (f(), h(Ce, { key: 6 }, [
                    oe[24] || (oe[24] = d("path", { d: "M4.5 7h15" }, null, -1)),
                    oe[25] || (oe[25] = d("path", { d: "M9.5 7V5.2A1.2 1.2 0 0 1 10.7 4h2.6a1.2 1.2 0 0 1 1.2 1.2V7" }, null, -1)),
                    oe[26] || (oe[26] = d("path", { d: "M6.5 7l.9 11.1A1.4 1.4 0 0 0 8.8 19.4h6.4a1.4 1.4 0 0 0 1.4-1.3L17.5 7" }, null, -1))
                  ], 64))
                ])),
                c.value ? (f(), h("span", jV, y(Se.label), 1)) : D("", !0),
                Se.key === "drafts" && (e.draftCount ?? 0) > 0 ? (f(), h("span", {
                  key: 1,
                  class: Ne(["fe-sidenav__count", { "fe-sidenav__count--rail": !c.value }]),
                  "aria-hidden": "true",
                  "data-testid": "sidenav-drafts-count"
                }, y(e.draftCount), 3)) : D("", !0)
              ], 10, UV)
            ]),
            Se.key === "shared" && e.showMyShares ? (f(), h("li", qV, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.myshares"),
                "aria-label": u(i)("sidenav.myshares"),
                "data-testid": "sidenav-my-shares",
                onClick: oe[1] || (oe[1] = (he) => a("open-my-shares"))
              }, [
                oe[27] || (oe[27] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("path", { d: "M10 13.5a4.5 4.5 0 0 0 6.8.5l2.7-2.7a4.5 4.5 0 0 0-6.36-6.36L11.6 6.5" }),
                  d("path", { d: "M14 10.5a4.5 4.5 0 0 0-6.8-.5l-2.7 2.7a4.5 4.5 0 0 0 6.36 6.36l1.53-1.53" })
                ], -1)),
                c.value ? (f(), h("span", YV, y(u(i)("sidenav.myshares")), 1)) : D("", !0)
              ], 8, WV)
            ])) : D("", !0)
          ], 64))), 128))
        ], 8, FV),
        P.value ? (f(), h("div", GV, [
          c.value ? (f(), h(Ce, { key: 0 }, [
            d("p", XV, y(u(i)("sidenav.tags")), 1),
            (f(!0), h(Ce, null, nt(R.value, (Se) => (f(), h(Ce, {
              key: Se.kind
            }, [
              d("p", {
                class: "fe-sidenav__subheading",
                "data-testid": `sidenav-tags-${Se.kind}`
              }, [
                Je(Ev, {
                  kind: Se.kind,
                  size: 12
                }, null, 8, ["kind"]),
                d("span", null, y(u(i)(`sidenav.tags.${Se.kind}`)), 1)
              ], 8, JV),
              d("ul", {
                class: "fe-sidenav__group",
                "aria-label": `${u(i)("sidenav.tags")} - ${u(i)(`sidenav.tags.${Se.kind}`)}`
              }, [
                (f(!0), h(Ce, null, nt(Se.visible, (he) => (f(), h("li", {
                  key: `${he.kind}:${he.name}`
                }, [
                  d("button", {
                    type: "button",
                    class: Ne(["fe-sidenav__item fe-sidenav__item--tag", { "is-active": U(he) }]),
                    "aria-current": U(he) ? "page" : void 0,
                    title: u(i)(`tags.chip.${he.kind}`, { tag: he.name }),
                    "aria-label": u(i)(`tags.chip.${he.kind}`, { tag: he.name }),
                    "data-testid": `sidenav-tag-${he.name}`,
                    "data-tag-kind": he.kind,
                    onClick: (Ke) => a("open-tag", he.name, he.kind)
                  }, [
                    Je(Ev, {
                      class: "fe-ficon",
                      kind: he.kind,
                      size: 16
                    }, null, 8, ["kind"]),
                    d("span", ej, y(he.name), 1)
                  ], 10, QV)
                ]))), 128))
              ], 8, ZV)
            ], 64))), 128)),
            d("ul", {
              class: "fe-sidenav__group",
              "aria-label": u(i)("sidenav.tags")
            }, [
              T.value.length === 0 ? (f(), h("li", nj, [
                d("p", aj, y(u(i)("sidenav.tags.empty")), 1)
              ])) : D("", !0),
              M.value > 0 ? (f(), h("li", ij, [
                d("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-more",
                  onClick: oe[2] || (oe[2] = (Se) => A.value = !0)
                }, y(u(i)("sidenav.tags.more", { count: M.value })), 1)
              ])) : A.value && L.value ? (f(), h("li", oj, [
                d("button", {
                  type: "button",
                  class: "fe-sidenav__more",
                  "data-testid": "sidenav-tags-less",
                  onClick: oe[3] || (oe[3] = (Se) => A.value = !1)
                }, y(u(i)("sidenav.tags.less")), 1)
              ])) : D("", !0)
            ], 8, tj)
          ], 64)) : (f(), h(Ce, { key: 1 }, [
            oe[29] || (oe[29] = d("hr", {
              class: "fe-sidenav__rule",
              "aria-hidden": "true"
            }, null, -1)),
            d("ul", {
              class: "fe-sidenav__group",
              "aria-label": u(i)("sidenav.tags")
            }, [
              d("li", null, [
                d("button", {
                  type: "button",
                  class: Ne(["fe-sidenav__item", { "is-active": e.activeView === "tag" }]),
                  title: u(i)("sidenav.tags"),
                  "aria-label": u(i)("sidenav.tags"),
                  "data-testid": "sidenav-tags-rail",
                  onClick: oe[4] || (oe[4] = (Se) => a("toggle"))
                }, [...oe[28] || (oe[28] = [
                  d("svg", {
                    class: "fe-ficon",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.8",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "aria-hidden": "true",
                    focusable: "false"
                  }, [
                    d("path", { d: "M4 4.5h7l9 9-6.5 6.5-9-9z" }),
                    d("circle", {
                      cx: "8",
                      cy: "8.5",
                      r: "1.4"
                    })
                  ], -1)
                ])], 10, sj)
              ])
            ], 8, rj)
          ], 64))
        ])) : D("", !0),
        e.storages.length ? (f(), h("div", lj, [
          c.value ? (f(), h("p", uj, y(u(i)("sidenav.storages")), 1)) : (f(), h("hr", cj)),
          d("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.storages"),
            "data-testid": "sidenav-storages",
            onClickCapture: oe[5] || (oe[5] = //@ts-ignore
            (...Se) => u(yt) && u(yt)(...Se))
          }, [
            (f(!0), h(Ce, null, nt(e.storages, (Se, he) => (f(), h("li", {
              key: Se.name,
              class: Ne({
                "is-drop-before": u($t) === he,
                "is-drop-after": u($t) === e.storages.length && he === e.storages.length - 1
              })
            }, [
              d("button", {
                ref_for: !0,
                ref: (Ke) => le(u(Ja)(Se), Ke),
                type: "button",
                class: Ne(["fe-sidenav__item fe-sidenav__item--storage", {
                  "is-active": !e.activeView && e.activeStorage === Se.name,
                  "is-dragging": u(Tt) === u(Ja)(Se)
                }]),
                title: p.value.has(Se.name) ? `${Se.label || Se.name} - ${u(i)("sidenav.storage.shared")}` : Se.label || Se.name,
                "aria-label": p.value.has(Se.name) ? `${Se.label || Se.name} - ${u(i)("sidenav.storage.shared")}` : Se.label || Se.name,
                "data-testid": `sidenav-storage-${Se.name}`,
                onClick: (Ke) => a("open-storage", Se.name),
                onContextmenu: (Ke) => B(Se, Ke),
                onKeydown: (Ke) => Ye(Se, Ke),
                onPointerdown: (Ke) => ft(Se, Ke)
              }, [
                (f(), h("svg", pj, [
                  p.value.has(Se.name) ? (f(), h(Ce, { key: 0 }, [
                    oe[30] || (oe[30] = d("path", { d: "M3 8.5A1.5 1.5 0 0 1 4.5 7h5L11 9h8.5A1.5 1.5 0 0 1 21 10.5v7A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z" }, null, -1)),
                    oe[31] || (oe[31] = d("circle", {
                      cx: "15.6",
                      cy: "13.6",
                      r: "1.6"
                    }, null, -1)),
                    oe[32] || (oe[32] = d("circle", {
                      cx: "9.4",
                      cy: "15.4",
                      r: "1.6"
                    }, null, -1)),
                    oe[33] || (oe[33] = d("path", { d: "M10.9 14.7l3.3-.9" }, null, -1))
                  ], 64)) : (f(), h(Ce, { key: 1 }, [
                    oe[34] || (oe[34] = d("rect", {
                      x: "3",
                      y: "5",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    oe[35] || (oe[35] = d("rect", {
                      x: "3",
                      y: "13",
                      width: "18",
                      height: "6",
                      rx: "1.6"
                    }, null, -1)),
                    oe[36] || (oe[36] = d("path", { d: "M6.5 8h.01M6.5 16h.01" }, null, -1))
                  ], 64))
                ])),
                c.value ? (f(), h("span", hj, y(Se.label || Se.name), 1)) : D("", !0),
                c.value && p.value.has(Se.name) ? (f(), h("span", {
                  key: 1,
                  class: "fe-sidenav__tag",
                  role: "img",
                  "aria-label": u(i)("sidenav.storage.shared")
                }, y(u(i)("sidenav.storage.shared")), 9, mj)) : D("", !0),
                c.value && Se.readOnly ? (f(), We(Y$, {
                  key: 2,
                  "read-only": "",
                  locale: e.locale,
                  class: "fe-sidenav__stags",
                  "data-testid": "sidenav-storage-readonly"
                }, null, 8, ["locale"])) : D("", !0)
              ], 42, fj)
            ], 2))), 128))
          ], 40, dj)
        ])) : D("", !0),
        k.value.length || e.showAppStore ? (f(), h("div", vj, [
          c.value ? (f(), h("p", yj, y(u(i)("sidenav.apps")), 1)) : (f(), h("hr", gj)),
          d("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.apps")
          }, [
            (f(!0), h(Ce, null, nt(k.value, (Se) => (f(), h("li", {
              key: Se.key
            }, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: Se.label,
                "aria-label": Se.label,
                "data-testid": `sidenav-app-${Se.key}`,
                onClick: (he) => a("open-app", Se.key)
              }, [
                d("span", {
                  class: "fe-sidenav__appicon",
                  "aria-hidden": "true",
                  innerHTML: Se.svg
                }, null, 8, wj),
                c.value ? (f(), h("span", _j, y(Se.label), 1)) : D("", !0)
              ], 8, kj)
            ]))), 128)),
            e.showAppStore ? (f(), h("li", xj, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.appstore"),
                "aria-label": u(i)("sidenav.appstore"),
                "data-testid": "sidenav-app-store",
                onClick: oe[6] || (oe[6] = (Se) => a("open-app-store"))
              }, [
                oe[37] || (oe[37] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("path", { d: "M3 9l1.5-5h15L21 9" }),
                  d("path", { d: "M3 9a3 3 0 0 0 6 0a3 3 0 0 0 6 0a3 3 0 0 0 6 0" }),
                  d("path", { d: "M5 11.5V20h14v-8.5" }),
                  d("path", { d: "M10 20v-5h4v5" })
                ], -1)),
                c.value ? (f(), h("span", $j, y(u(i)("sidenav.appstore")), 1)) : D("", !0)
              ], 8, Sj)
            ])) : D("", !0)
          ], 8, bj)
        ])) : D("", !0),
        e.showConnections ? (f(), h("div", Tj, [
          oe[40] || (oe[40] = d("hr", {
            class: "fe-sidenav__rule",
            "aria-hidden": "true"
          }, null, -1)),
          d("ul", {
            class: "fe-sidenav__group",
            "aria-label": u(i)("sidenav.connections")
          }, [
            d("li", null, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.connect"),
                "aria-label": u(i)("sidenav.connect"),
                "data-testid": "sidenav-connect",
                onClick: oe[7] || (oe[7] = (Se) => a("open-connections"))
              }, [
                oe[38] || (oe[38] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("path", { d: "M9.5 14.5l-2.6 2.6a3.7 3.7 0 0 1-5.2-5.2l2.6-2.6" }),
                  d("path", { d: "M14.5 9.5l2.6-2.6a3.7 3.7 0 0 1 5.2 5.2l-2.6 2.6" }),
                  d("path", { d: "M9 15l6-6" })
                ], -1)),
                c.value ? (f(), h("span", Cj, y(u(i)("sidenav.connect")), 1)) : D("", !0)
              ], 8, Ej)
            ]),
            e.showIdentitySurfaces !== !1 ? (f(), h("li", zj, [
              d("button", {
                type: "button",
                class: "fe-sidenav__item",
                title: u(i)("sidenav.apikeys"),
                "aria-label": u(i)("sidenav.apikeys"),
                "data-testid": "sidenav-apikeys",
                onClick: oe[8] || (oe[8] = (Se) => a("open-tokens"))
              }, [
                oe[39] || (oe[39] = d("svg", {
                  class: "fe-ficon",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "aria-hidden": "true",
                  focusable: "false"
                }, [
                  d("circle", {
                    cx: "8",
                    cy: "12",
                    r: "3.5"
                  }),
                  d("path", { d: "M11.5 12H21" }),
                  d("path", { d: "M17.5 12v3.2M20 12v2.2" })
                ], -1)),
                c.value ? (f(), h("span", Oj, y(u(i)("sidenav.apikeys")), 1)) : D("", !0)
              ], 8, Mj)
            ])) : D("", !0)
          ], 8, Aj)
        ])) : D("", !0)
      ]),
      e.quota ? (f(), h("div", Pj, [
        c.value ? (f(), h("p", Dj, y(u(i)("drive.storage.label")), 1)) : D("", !0),
        d("div", {
          class: "fe-sidenav__quota-bar",
          role: "progressbar",
          "aria-valuenow": J.value,
          "aria-valuemin": "0",
          "aria-valuemax": "100",
          "aria-label": re.value,
          title: re.value
        }, [
          d("span", {
            class: "fe-sidenav__quota-fill",
            style: Xt({ width: J.value + "%" })
          }, null, 4)
        ], 8, Lj),
        c.value ? (f(), h("p", Rj, y(re.value), 1)) : D("", !0)
      ])) : D("", !0),
      Je(ml, {
        ref_key: "newMenuRef",
        ref: $,
        locale: e.locale,
        theme: e.theme,
        actions: F.value,
        onSelect: Z
      }, null, 8, ["locale", "theme", "actions"]),
      Je(ml, {
        ref_key: "storageMenuRef",
        ref: j,
        locale: e.locale,
        theme: e.theme,
        sheet: te.value,
        actions: G.value,
        onSelect: Be
      }, null, 8, ["locale", "theme", "sheet", "actions"])
    ], 10, zV));
  }
}), Ij = 200;
function W1(e) {
  if (!e || typeof e != "object") return !1;
  const t = e, n = t.e2e_name_state;
  return n === "enc" || n === "locked" || n === "unreadable" ? !0 : typeof t.vault_root == "string" && t.vault_root !== "";
}
function Xu(e, t, n, a) {
  const i = S(null), r = S(!1), l = S(!1);
  let c = null, p = null;
  function m() {
    c && clearTimeout(c), c = null, p == null || p.abort(), p = null;
  }
  async function v(x, k) {
    const _ = a();
    if (!_) {
      r.value = !0;
      return;
    }
    const w = new AbortController();
    p = w, l.value = !0;
    try {
      const b = await _(x, k, w.signal);
      if (w.signal.aborted) return;
      i.value = { q: x, names: new Set(b.map((C) => k[C]).filter((C) => typeof C == "string")) }, r.value = !1;
    } catch (b) {
      if ((b == null ? void 0 : b.name) === "AbortError" || w.signal.aborted) return;
      r.value = !0;
    } finally {
      p === w && (p = null, l.value = !1);
    }
  }
  return Xe(
    () => {
      const x = e().trim();
      if (!x) return "";
      const k = /* @__PURE__ */ new Set();
      for (const _ of t())
        W1(_) || k.add(n(_) || "");
      return JSON.stringify([x, [...k].sort()]);
    },
    (x) => {
      if (m(), !x) {
        i.value = null, l.value = !1;
        return;
      }
      const [k, _] = JSON.parse(x);
      if (_.length === 0) {
        i.value = { q: k, names: /* @__PURE__ */ new Set() };
        return;
      }
      l.value = !0, c = setTimeout(() => {
        c = null, v(k, _);
      }, Ij);
    },
    { immediate: !0 }
  ), q0() && yy(m), {
    pending: l,
    apply(x) {
      const k = e().trim();
      if (!k) return x;
      const _ = i.value;
      return x.filter((w) => {
        const b = n(w) || "";
        return W1(w) || r.value || !a() ? $S(b, k) : !_ || _.q !== k ? !0 : _.names.has(b);
      });
    }
  };
}
const G$ = "application/x-brf-files", Bj = "application/x-brf-files-src";
let tl = null;
const Fj = 5 * 6e4;
function Uj(e, t) {
  tl = { items: e.slice(), origin: t, startedAt: Date.now() };
}
function $r() {
  tl = null;
}
function gc() {
  return tl ? Date.now() - tl.startedAt > Fj ? (tl = null, null) : tl : null;
}
function ti(e) {
  var t;
  return (t = e.dataTransfer) != null && t.types.includes(G$) ? !0 : gc() !== null;
}
function Af(e) {
  var a;
  const t = (a = e.dataTransfer) == null ? void 0 : a.getData(G$);
  if (t)
    try {
      const i = JSON.parse(t);
      return Array.isArray(i) && i.length > 0 ? i : null;
    } catch {
      return null;
    }
  const n = gc();
  return n && n.items.length > 0 ? n.items : null;
}
function sy(e) {
  var n, a;
  const t = (n = e.dataTransfer) == null ? void 0 : n.getData(Bj);
  return t || ((a = gc()) == null ? void 0 : a.origin) || void 0;
}
function Zm(e) {
  const t = Hj(e);
  return t === void 0 || t === "none" || t === "csrf";
}
function Hj(e) {
  if (!e || typeof e != "object") return;
  const t = e;
  return typeof t.kind == "string" ? t.kind : typeof t.type == "string" ? t.type : void 0;
}
function Kj(e, t, n) {
  if (e.type !== "file") return null;
  let a = t;
  try {
    a = new URL(t, typeof location < "u" ? location.href : void 0).toString();
  } catch {
    return null;
  }
  if (!/^https?:/i.test(a)) return null;
  const i = e.basename.replace(/[:\r\n]/g, "_");
  return `${n && n.trim() ? n : "application/octet-stream"}:${i}:${a}`;
}
function Vj(e) {
  return e.map((t) => t.path).sort().join("\0");
}
function jj(e, t = {}) {
  const n = t.now ?? (() => Date.now()), a = t.refreshBelowMs ?? 3e4, i = t.usableAboveMs ?? 5e3, r = t.failPauseMs ?? 3e4, l = t.max ?? 32, c = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new Map();
  let m = null, v = null, x = !0;
  function k(C) {
    const A = c.get(C);
    return A ? A.expiresAt - n() : -1 / 0;
  }
  function _(C) {
    m = C;
    let A;
    try {
      A = e(C);
    } catch (T) {
      A = Promise.reject(T);
    }
    A.then((T) => {
      var R;
      if (T === null) {
        x && (x = !1, c.clear(), (R = t.onUnsupported) == null || R.call(t));
        return;
      }
      for (c.delete(C), c.set(C, { url: T.url, expiresAt: n() + T.ttlMs }); c.size > l; ) {
        const M = c.keys().next().value;
        if (M === void 0) break;
        c.delete(M);
      }
    }).catch(() => {
      p.set(C, n() + r);
    }).finally(() => {
      m = null;
      const T = v;
      v = null, T && w(T);
    });
  }
  function w(C) {
    if (!x || !C || k(C) > a) return;
    const A = p.get(C);
    if (A !== void 0) {
      if (A > n()) return;
      p.delete(C);
    }
    if (m !== C) {
      if (m !== null) {
        v = C;
        return;
      }
      _(C);
    }
  }
  function b(C) {
    const A = c.get(C);
    return A ? (c.delete(C), A.expiresAt - n() > i ? A.url : null) : null;
  }
  return {
    warm: w,
    take: b,
    get supported() {
      return x;
    }
  };
}
function cp(e) {
  return !!e && e.basename !== ".trash" && !Ry(e) && !(typeof e.vault_root == "string" && e.vault_root !== "");
}
function Ef(e) {
  return { path: e.path, basename: e.basename, type: e.type };
}
function Y1(e, t = {}) {
  return t.inEncryptedFolder || e.length === 0 || !e.every((n) => cp(n)) ? null : e.map(Ef);
}
function G1(e) {
  return !!e && e.type === "file" && cp(e);
}
function qj(e, t) {
  const { t: n } = t, a = !!e.dropped;
  return e.error === "drop_not_found" ? { kind: "flash", message: n("dragout.not_found") } : e.error === "cancelled" ? { kind: "flash", message: n("dragout.stopped") } : e.error ? a || !t.quiet ? { kind: "flash", message: e.error } : null : a ? e.finished ? { kind: "flash", message: n("dragout.done") } : {
    kind: "hold",
    message: e.files ? n("dragout.downloading_n", { n: e.files }) : n("dragout.downloading"),
    stoppable: t.stoppable
  } : t.quiet ? null : !e.finished && e.done === 0 ? { kind: "flash", message: n("dragout.preparing") } : null;
}
const Wj = ["corrupt", "encrypted", "too_large"], Yj = {
  corrupt: [
    "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z",
    "M14 2v4a2 2 0 0 0 2 2h4",
    "m14.5 12.5-5 5",
    "m9.5 12.5 5 5"
  ],
  encrypted: ["M5 11h14a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z", "M7 11V7a5 5 0 0 1 10 0v4"],
  too_large: ["M15 3h6v6", "M9 21H3v-6", "M21 3l-7 7", "M3 21l7-7"]
}, X1 = /* @__PURE__ */ new Map();
function Gj(e) {
  if (!e || e.type !== "file" || e.thumb_url) return null;
  const t = e.thumb_note;
  return t && Wj.includes(t) ? t : null;
}
function zg(e, t) {
  const n = Gj(e);
  if (!n) return null;
  let a, i;
  switch (n) {
    case "corrupt":
      a = t.t("thumbNote.corrupt"), i = t.t("thumbNote.corrupt_why");
      break;
    case "encrypted":
      a = t.t("thumbNote.encrypted"), i = t.t("thumbNote.encrypted_why");
      break;
    default:
      a = t.t("thumbNote.too_large"), i = t.t("thumbNote.too_large_why");
  }
  const r = t.t("thumbNote.full", { label: a, why: i }), l = `${n}|${r}`;
  let c = X1.get(l);
  return c || (c = { note: n, label: a, why: i, full: r, paths: Yj[n] }, X1.set(l, c)), c;
}
const Vs = 8 * 1024, Xj = 4 * 1024 * 1024, Jj = 3, Zj = 24, J1 = 120, Qj = 16, eq = 8, tq = 400, nq = /* @__PURE__ */ new Set(["csv", "tsv"]);
function aq(e) {
  if (e.trashed) return !0;
  const t = e.extra_metadata;
  return !!t && typeof t == "object" && "deleted_at" in t;
}
function dp(e) {
  if (e.type !== "file" || e.basename === ".trash" || e.mime_type === "inode/storage" || aq(e)) return null;
  const t = e.size ?? 0;
  if (t <= 0 || t > Xj) return null;
  const n = (e.extension || "").trim().toLowerCase();
  if (nq.has(n)) return "table";
  const a = xi(e);
  return a === "code" ? "code" : a === "text" ? "text" : null;
}
function Mg(e) {
  if (e.type !== "file") return !1;
  switch (xi(e)) {
    case "pdf":
    case "doc":
    case "sheet":
    case "slides":
      return !0;
    default:
      return !1;
  }
}
function X$(e) {
  return e.type === "file" && xi(e) === "video";
}
const iq = /* @__PURE__ */ new Set([
  "pdf",
  "doc",
  "sheet",
  "slides",
  "text",
  "archive"
]);
function oq(e) {
  return e.type === "file" && iq.has(xi(e));
}
const rq = /* @__PURE__ */ new Set(["image", "video"]), Z1 = /* @__PURE__ */ new Map();
function J$(e) {
  if (e.type !== "file") return null;
  const t = xi(e);
  if (rq.has(t)) return null;
  const n = J2(e);
  if (!n) return null;
  const a = `${t}:${n}`;
  let i = Z1.get(a);
  return i || (i = { family: t, label: n }, Z1.set(a, i)), i;
}
const sq = /* @__PURE__ */ new Set([
  "import",
  "export",
  "from",
  "require",
  "include",
  "use",
  "using",
  "package",
  "module",
  "namespace",
  "const",
  "let",
  "var",
  "function",
  "func",
  "fn",
  "def",
  "class",
  "struct",
  "enum",
  "interface",
  "type",
  "impl",
  "trait",
  "public",
  "private",
  "protected",
  "static",
  "async",
  "await",
  "return",
  "if",
  "else",
  "for",
  "while",
  "switch",
  "case",
  "try",
  "catch",
  "select",
  "insert",
  "update",
  "delete",
  "create",
  "alter",
  "drop"
]), lq = /^(#{1,6}|[-*+]|>|\d+\.)$/;
function uq(e) {
  return e.replace(/[(){}[\];:,.]+$/, "").toLowerCase();
}
function cq(e, t) {
  const n = e.length > J1 ? e.slice(0, J1) : e, a = /^(\s*)(\S+)([\s\S]*)$/.exec(n);
  if (!a) return { indent: "", tint: "", text: n };
  const [, i, r, l] = a;
  return (t === "code" ? sq.has(uq(r)) : lq.test(r)) ? { indent: i, tint: r, text: l } : { indent: "", tint: "", text: n };
}
function dq(e, t) {
  const n = [];
  let a = "", i = !1;
  for (let r = 0; r < e.length; r++) {
    const l = e[r];
    i ? l === '"' ? e[r + 1] === '"' ? (a += '"', r++) : i = !1 : a += l : l === '"' ? i = !0 : l === t ? (n.push(a), a = "") : a += l;
  }
  return n.push(a), n;
}
function fq(e, t) {
  return e === "tsv" ? "	" : !t.includes(",") && t.includes(";") ? ";" : ",";
}
function pq(e, t, n, a) {
  for (let c = 0; c < e.length; c++)
    if (e[c] === 0) return null;
  const i = new TextDecoder("utf-8", { fatal: !1 }).decode(e);
  let r = 0;
  for (const c of i) c === "�" && r++;
  if (i.length > 0 && r / i.length > 0.1) return null;
  const l = i.split(/\r\n|\r|\n/);
  for (a && l.length > 1 && l.pop(); l.length && l[0].trim() === ""; ) l.shift();
  for (; l.length && l[l.length - 1].trim() === ""; ) l.pop();
  if (l.length === 0) return null;
  if (t === "table") {
    const c = fq(n, l[0]), p = l.filter((v) => v.trim() !== "").slice(0, Qj).map((v) => dq(v, c).slice(0, eq).map((x) => x.trim().slice(0, 24)));
    if (p.length === 0) return null;
    const m = p.reduce((v, x) => Math.max(v, x.length), 0);
    for (const v of p) for (; v.length < m; ) v.push("");
    return { kind: t, lines: [], rows: p, cols: m };
  }
  return {
    kind: t,
    lines: l.slice(0, Zj).map((c) => cq(c, t)),
    rows: [],
    cols: 0
  };
}
const hq = "\0";
function Lu(e) {
  const n = (typeof e.etag == "string" ? e.etag : "") || String(e.last_modified ?? "") || String(e.size ?? "");
  return `${e.path}${hq}${n}`;
}
function Z$(e) {
  const t = e.apiBase !== void 0 && typeof e.authHeaders == "function" && typeof IntersectionObserver < "u" && typeof fetch == "function", n = S({}), a = [], i = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), l = [], c = /* @__PURE__ */ new Set(), p = /* @__PURE__ */ new WeakMap();
  let m = 0, v = null;
  const x = /* @__PURE__ */ new Map();
  function k(M) {
    const L = D2({ apiBase: e.apiBase }).manager, U = L.includes("?") ? "&" : "?", P = new URLSearchParams({ q: "preview", action: "preview", path: M });
    return `${L}${U}${P.toString()}`;
  }
  function _(M, L) {
    if (a.length >= tq) {
      const U = a.shift();
      if (U) {
        const P = { ...n.value };
        delete P[U], n.value = P;
      }
    }
    a.push(M), n.value = { ...n.value, [M]: L };
  }
  async function w(M) {
    const L = M.body;
    if (!L) {
      const I = new Uint8Array(await M.arrayBuffer());
      return { bytes: I.slice(0, Vs), truncated: I.length > Vs };
    }
    const U = L.getReader(), P = [];
    let H = 0;
    try {
      for (; H < Vs; ) {
        const { done: I, value: Z } = await U.read();
        if (I) break;
        Z && Z.length && (P.push(Z), H += Z.length);
      }
    } finally {
      try {
        await U.cancel();
      } catch {
      }
    }
    const $ = new Uint8Array(Math.min(H, Vs));
    let F = 0;
    for (const I of P) {
      if (F >= $.length) break;
      $.set(I.subarray(0, $.length - F), F), F += I.length;
    }
    return { bytes: $, truncated: H >= Vs };
  }
  async function b(M, L) {
    const U = Lu(M), P = new AbortController();
    c.add(P);
    try {
      const H = e.authHeaders ? await e.authHeaders() : {}, $ = await fetch(k(M.path), {
        headers: { ...H, Accept: "*/*", Range: `bytes=0-${Vs - 1}` },
        credentials: e.credentials,
        signal: P.signal
      });
      if (!$.ok && $.status !== 206) throw new Error(String($.status));
      const { bytes: F, truncated: I } = await w($);
      P.abort();
      const Z = (M.extension || "").trim().toLowerCase(), J = pq(F, L, Z, I);
      if (!J) {
        i.add(U);
        return;
      }
      _(U, J);
    } catch {
      i.add(U);
    } finally {
      c.delete(P);
    }
  }
  function C() {
    for (; m < Jj && l.length > 0; ) {
      const M = l.shift(), L = dp(M);
      r.delete(Lu(M)), L && (m++, b(M, L).finally(() => {
        m--, C();
      }));
    }
  }
  function A(M) {
    const L = Lu(M);
    n.value[L] || i.has(L) || r.has(L) || (r.add(L), l.push(M), C());
  }
  function T() {
    return t ? (v || (v = new IntersectionObserver(
      (M) => {
        for (const L of M) {
          if (!L.isIntersecting) continue;
          const U = x.get(L.target);
          v == null || v.unobserve(L.target), x.delete(L.target), U && A(U);
        }
      },
      { rootMargin: "150px" }
    )), v) : null;
  }
  function R(M) {
    var L;
    return !t || (L = e.disabled) != null && L.call(e) ? null : dp(M);
  }
  return {
    enabled: t,
    kindFor: R,
    get(M) {
      return t ? n.value[Lu(M)] ?? null : null;
    },
    bind(M, L) {
      if (!M || !R(L)) return;
      const U = Lu(L);
      if (p.get(M) === U || (p.set(M, U), n.value[U] || i.has(U))) return;
      const P = T();
      P && (x.set(M, L), P.observe(M));
    },
    stats: () => ({
      loaded: a.length,
      inflight: m,
      queued: l.length,
      failed: i.size
    }),
    dispose() {
      v == null || v.disconnect(), v = null, x.clear();
      for (const M of c) M.abort();
      c.clear(), l.length = 0, r.clear();
    }
  };
}
function mq(e, t) {
  if (!e) return { id: "none", label: t.t("group.no_date") };
  const n = /* @__PURE__ */ new Date(), a = jw(n), i = jw(e);
  if (i >= a) return { id: "today", label: t.t("group.today") };
  if (i === a - 1) return { id: "yesterday", label: t.t("group.yesterday") };
  if (i > a - 7) return { id: "week", label: t.t("group.this_week") };
  const r = t.zonedYearMonth(e);
  return r === t.zonedYearMonth(n) ? { id: "month", label: t.t("group.this_month") } : { id: `m-${r}`, label: t.formatMonthYear(e) };
}
function Og(e, t) {
  return t !== "relevance" && e === "modified";
}
function Pg(e, t) {
  var i;
  const n = [];
  if (!t.active)
    n.push({ id: "all", label: null, items: [...e] });
  else {
    let r = null;
    for (const l of e) {
      const c = ((i = t.aside) == null ? void 0 : i.call(t, l)) ?? null, p = c ? { id: c.id, label: c.label ?? null } : mq(t.dateOf(l), t.labels);
      (!r || r.id !== p.id) && (r = { id: p.id, label: p.label, items: [] }, n.push(r)), r.items.push(l);
    }
  }
  const a = /* @__PURE__ */ new Map();
  for (const r of n)
    r.label && r.items.length && a.set(r.items[0], r.label);
  return {
    active: t.active,
    runs: n,
    headingBefore: (r) => a.get(r) ?? null
  };
}
async function Q$(e, t, n = {}) {
  const a = {
    "Content-Type": "application/json",
    ...await (n.authHeaders ?? (() => ({})))()
  }, i = n.apiBase ?? "", r = await fetch(`${i}/api/files/manager/star`, {
    method: "POST",
    headers: a,
    credentials: n.authCredentials ?? "same-origin",
    body: JSON.stringify({ node_id: e, starred: t })
  });
  if (!r.ok) throw pa(r.status, await r.text().catch(() => ""), n.locale);
}
const vq = ["aria-pressed", "title", "aria-label"], yq = {
  viewBox: "0 0 24 24",
  width: "16",
  height: "16",
  "aria-hidden": "true"
}, gq = ["fill"], bq = {
  key: 0,
  class: "filex-star-label"
}, Dg = /* @__PURE__ */ rt({
  __name: "StarButton",
  props: {
    starred: { type: Boolean },
    nodeId: {},
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    compact: { type: Boolean },
    card: { type: Boolean },
    locale: {}
  },
  emits: ["change", "error"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = S(n.starred);
    Xe(() => n.starred, (p) => {
      i.value = p;
    });
    const { t: r } = ht(() => Ca(n.locale)), l = E(() => r(i.value ? "ctx.unstar" : "ctx.star"));
    async function c() {
      const p = !i.value;
      i.value = p;
      try {
        await Q$(n.nodeId, p, {
          apiBase: n.apiBase,
          authHeaders: n.authHeaders,
          authCredentials: n.authCredentials,
          locale: Ca(n.locale)
        }), a("change", p);
      } catch (m) {
        i.value = !p, a("error", m instanceof Error ? m.message : String(m));
      }
    }
    return (p, m) => (f(), h("button", {
      type: "button",
      class: Ne(["filex-star-btn", { "is-starred": i.value, "is-compact": e.compact, "is-card": e.card }]),
      "aria-pressed": i.value,
      title: l.value,
      "aria-label": l.value,
      "data-testid": "star-toggle",
      onClick: vt(c, ["stop"])
    }, [
      (f(), h("svg", yq, [
        d("path", {
          fill: i.value ? "currentColor" : "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linejoin": "round",
          d: "M12 2.5l3.09 6.26 6.91 1-5 4.87 1.18 6.87L12 18.27l-6.18 3.23L7 14.63 2 9.76l6.91-1z"
        }, null, 8, gq)
      ])),
      e.compact ? D("", !0) : (f(), h("span", bq, y(l.value), 1))
    ], 10, vq));
  }
}), Q1 = "300px";
let mo = null;
const nl = /* @__PURE__ */ new Map();
function kq() {
  return mo || (mo = new IntersectionObserver(
    (e) => {
      for (const t of e) {
        if (!t.isIntersecting) continue;
        const n = nl.get(t.target);
        n && (nl.delete(t.target), mo == null || mo.unobserve(t.target), n.forEach((a) => a()));
      }
    },
    // `rootMargin` widens the viewport only: a tile in the pane's own scroll
    // box is still cut off at that box's edge. `scrollMargin` widens the
    // scroll boxes too (Chromium 120+; an engine that does not know it
    // ignores it, and the picture is asked for as the tile scrolls in).
    { rootMargin: Q1, scrollMargin: Q1 }
  )), mo;
}
function wq(e, t) {
  if (!e || typeof IntersectionObserver > "u")
    return t(), () => {
    };
  let n = nl.get(e);
  return n || (n = /* @__PURE__ */ new Set(), nl.set(e, n), kq().observe(e)), n.add(t), () => {
    const a = nl.get(e);
    a && (a.delete(t), a.size === 0 && (nl.delete(e), mo == null || mo.unobserve(e)));
  };
}
const _q = ["src"], xq = {
  key: 2,
  class: "fe-thumb__play",
  "aria-hidden": "true"
}, Sq = ["aria-label", "data-note"], $q = {
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  focusable: "false"
}, Tq = ["d"], Aq = ["dir"], qc = /* @__PURE__ */ rt({
  inheritAttrs: !1,
  __name: "ThumbTile",
  props: {
    node: {},
    srcOf: { type: Function },
    videoBadge: { type: Boolean },
    typeBadge: {},
    note: {}
  },
  setup(e) {
    const t = e, n = S(!1);
    let a = null;
    qt(() => {
      var R;
      const T = (R = Go()) == null ? void 0 : R.subTree.el;
      a = wq(T == null ? void 0 : T.parentElement, () => {
        n.value = !0;
      });
    }), Ct(() => {
      a == null || a(), k();
    });
    const i = E(() => n.value ? t.srcOf(t.node) : null), r = S(null), l = S(null), c = S(!1), p = S("ltr");
    function m() {
      const T = l.value, R = r.value;
      if (!T || !R) return;
      const M = R.getBoundingClientRect(), L = window.innerWidth, U = window.innerHeight, P = T.offsetWidth, H = T.offsetHeight, $ = p.value, F = Sc($ === "rtl" ? M.right : M.left, P, L, $);
      let I = M.bottom + 6;
      I + H > U - 8 && (I = Math.max(8, M.top - H - 6)), T.style.insetInlineStart = `${Math.round($ === "rtl" ? L - F - P : F)}px`, T.style.top = `${Math.round(I)}px`, T.style.zIndex = String(Ec(R));
    }
    function v(T) {
      r.value && T.target instanceof Node && r.value.contains(T.target) || k();
    }
    function x() {
      c.value || !r.value || (p.value = ei(r.value), c.value = !0, document.addEventListener("pointerdown", v, !0), window.addEventListener("scroll", k, !0), Jt(m));
    }
    function k() {
      c.value && (c.value = !1, document.removeEventListener("pointerdown", v, !0), window.removeEventListener("scroll", k, !0));
    }
    function _(T) {
      T.pointerType === "mouse" && x();
    }
    function w(T) {
      T.pointerType === "mouse" && k();
    }
    let b = "";
    function C(T) {
      b = T.pointerType;
    }
    function A() {
      if (b === "mouse") {
        x();
        return;
      }
      c.value ? k() : x();
    }
    return (T, R) => (f(), h(Ce, null, [
      i.value ? (f(), h("img", dv({ key: 0 }, T.$attrs, {
        src: i.value,
        draggable: "false"
      }), null, 16, _q)) : Ln(T.$slots, "default", { key: 1 }),
      i.value && e.videoBadge ? (f(), h("span", xq)) : D("", !0),
      i.value && e.typeBadge ? (f(), h("span", {
        key: 3,
        class: Ne(["fe-thumb__type", `fe-ftile--${e.typeBadge.family}`, { "fe-thumb__type--long": e.typeBadge.label.length > 4 }]),
        "aria-hidden": "true"
      }, y(e.typeBadge.label), 3)) : D("", !0),
      !i.value && e.note ? (f(), h("span", {
        key: 4,
        ref_key: "mark",
        ref: r,
        class: Ne(["fe-thumb__note", `fe-thumb__note--${e.note.note}`]),
        role: "img",
        "aria-label": e.note.full,
        "data-note": e.note.note,
        "data-testid": "thumb-note",
        onPointerenter: _,
        onPointerleave: w,
        onPointerdown: C,
        onClick: vt(A, ["stop"]),
        onDblclick: R[0] || (R[0] = vt(() => {
        }, ["stop"]))
      }, [
        (f(), h("svg", $q, [
          (f(!0), h(Ce, null, nt(e.note.paths, (M, L) => (f(), h("path", {
            key: L,
            d: M
          }, null, 8, Tq))), 128))
        ]))
      ], 42, Sq)) : D("", !0),
      (f(), We(wi, { to: "body" }, [
        c.value && e.note ? (f(), h("span", {
          key: 0,
          ref_key: "tip",
          ref: l,
          class: "fe-thumb__note-tip",
          dir: p.value,
          role: "tooltip",
          "data-testid": "thumb-note-tip"
        }, y(e.note.full), 9, Aq)) : D("", !0)
      ]))
    ], 64));
  }
}), Eq = ["innerHTML"], Cq = {
  key: 1,
  class: "fe-fmosaic__stage"
}, zq = ["innerHTML"], Lg = /* @__PURE__ */ rt({
  __name: "FolderMosaic",
  props: {
    node: {},
    srcOf: {},
    shape: { default: "peek" }
  },
  setup(e) {
    const t = e, n = E(() => t.shape === "mini" ? 1 : 3), a = E(
      () => (t.node.preview ?? []).slice(0, n.value).map((r) => {
        const l = r.name.lastIndexOf(".");
        return {
          path: `${t.node.path.replace(/\/+$/, "")}/${r.name}`,
          basename: r.name,
          type: "file",
          extension: l > 0 ? r.name.slice(l + 1).toLowerCase() : void 0,
          thumb_url: r.thumb_url
        };
      })
    ), i = E(() => {
      const [r, l, c] = a.value;
      return c ? [{ it: c, at: 1 }, { it: l, at: 3 }, { it: r, at: 2 }] : l ? [{ it: l, at: 1 }, { it: r, at: 2 }] : r ? [{ it: r, at: 1 }] : [];
    });
    return (r, l) => (f(), h("div", {
      class: Ne(["fe-fmosaic", [`fe-fmosaic--${e.shape}`, `fe-fmosaic--${a.value.length}`]]),
      "aria-hidden": "true",
      "data-fe-mosaic": ""
    }, [
      u(Br)(e.node) ? (f(), h("span", {
        key: 0,
        class: "fe-fmosaic__glyph fe-grid__icon fe-grid__icon--svg",
        innerHTML: u(vl)()
      }, null, 8, Eq)) : (f(), h("div", Cq, [
        l[0] || (l[0] = d("svg", {
          class: "fe-fmosaic__back",
          viewBox: "0 0 120 88",
          preserveAspectRatio: "none",
          focusable: "false"
        }, [
          d("path", { d: "M0 10a6 6 0 0 1 6-6h27.5a6 6 0 0 1 4.4 1.9L43.6 12H114a6 6 0 0 1 6 6v64a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z" })
        ], -1)),
        (f(!0), h(Ce, null, nt(i.value, (c) => (f(), h("div", {
          key: c.it.path,
          class: Ne(["fe-fmosaic__print", [`fe-fmosaic__print--${c.at}`, { "is-icon": !c.it.thumb_url }]])
        }, [
          Je(qc, {
            node: c.it,
            "src-of": e.srcOf,
            alt: "",
            class: "fe-fmosaic__img"
          }, {
            default: mt(() => [
              d("span", {
                class: "fe-fmosaic__icon fe-grid__icon--svg",
                innerHTML: u(xa)(c.it)
              }, null, 8, zq)
            ]),
            _: 2
          }, 1032, ["node", "src-of"])
        ], 2))), 128)),
        l[1] || (l[1] = d("svg", {
          class: "fe-fmosaic__front",
          viewBox: "0 0 120 56",
          preserveAspectRatio: "none",
          focusable: "false"
        }, [
          d("path", { d: "M5 0h110a5 5 0 0 1 5 5.4l-3.3 44.6a6 6 0 0 1-6 5.6H9.3a6 6 0 0 1-6-5.6L0 5.4A5 5 0 0 1 5 0z" })
        ], -1))
      ]))
    ], 2));
  }
});
function ly(e) {
  const t = [];
  if (!e) return t;
  const n = /«([^«»]*)»/g;
  let a = 0, i;
  for (; (i = n.exec(e)) !== null; )
    i.index > a && t.push({ text: e.slice(a, i.index), match: !1 }), i[1] && t.push({ text: i[1], match: !0 }), a = i.index + i[0].length;
  return a < e.length && t.push({ text: e.slice(a), match: !1 }), t;
}
function Mq(e) {
  return e === "content" || e === "both";
}
function Rg(e, t, n) {
  const a = e.dataTransfer;
  if (!(!a || typeof document > "u" || typeof a.setDragImage != "function"))
    try {
      const i = document.createElement("div");
      i.className = "fe-dragghost";
      const r = document.createElement("span");
      if (r.className = "fe-dragghost__name", r.dir = "auto", r.textContent = t, i.appendChild(r), n > 1) {
        const l = document.createElement("span");
        l.className = "fe-dragghost__badge", l.textContent = String(n), i.appendChild(l);
      }
      i.style.position = "fixed", i.style.top = "-1000px", i.style.left = "-1000px", document.body.appendChild(i), a.setDragImage(i, 14, 14), setTimeout(() => i.remove(), 0);
    } catch {
    }
}
const Oq = { class: "fe-gridbox" }, Pq = {
  key: 0,
  class: "fe-grid__refreshing",
  role: "status"
}, Dq = { class: "fe-sr-only" }, Lq = ["aria-label", "aria-busy"], Rq = {
  key: 0,
  class: "fe-grid__heading",
  "aria-hidden": "true"
}, Nq = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive", "onPointerenter", "onPointerleave"], Iq = ["dir"], Bq = {
  key: 0,
  class: "fe-fprev__tint"
}, Fq = ["innerHTML"], Uq = ["aria-label", "innerHTML"], Hq = ["innerHTML"], Kq = {
  key: 1,
  class: "fe-grid__thumb fe-grid__thumb--folder"
}, Vq = { class: "fe-grid__foot" }, jq = ["aria-label", "innerHTML"], qq = ["innerHTML"], Wq = ["onClick"], Yq = { class: "fe-grid__main" }, Gq = ["title"], Xq = ["title", "aria-label"], Jq = ["title"], Zq = ["title", "aria-label"], Qq = ["title", "aria-label", "data-link-state"], eW = ["title", "aria-label"], tW = ["title"], nW = ["title"], aW = {
  key: 0,
  class: "fe-grid__mark"
}, iW = ["aria-label", "title", "onClick"], oW = {
  key: 0,
  class: "fe-grid__empty"
}, uy = /* @__PURE__ */ rt({
  __name: "GridView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    keepBadgeFor: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    sections: { type: Boolean },
    order: {},
    e2eActive: { type: Boolean },
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change", "display-order", "peek", "peek-end"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => n.files.some((Oe) => {
      var Be;
      return Oe.type === "dir" && (((Be = Oe.preview) == null ? void 0 : Be.length) ?? 0) > 0;
    }));
    function r(Oe, Be) {
      Oe.type === "dir" && a("peek", Oe, Be.currentTarget, Be.pointerType);
    }
    const { t: l, formatSize: c, nodeDisplayName: p, formatDate: m, formatMonthYear: v, zonedYearMonth: x, toDate: k } = ht(() => n.locale);
    function _(Oe) {
      return Kr(Ic(Oe), { t: l, formatDate: m, locale: n.locale });
    }
    function w(Oe) {
      return Bc(Oe, { t: l });
    }
    function b(Oe) {
      return Fc(Oe, { t: l });
    }
    function C(Oe) {
      return zg(Oe, { t: l });
    }
    const A = E(() => [...n.files].sort(Qf));
    Xe(
      A,
      (Oe) => a("display-order", Oe),
      { immediate: !0 }
    );
    const T = E(() => {
      var Oe;
      return ((Oe = A.value.find((Be) => Be.type === "dir")) == null ? void 0 : Oe.path) ?? null;
    }), R = E(() => {
      var Oe;
      return ((Oe = A.value.find((Be) => Be.type !== "dir")) == null ? void 0 : Oe.path) ?? null;
    }), M = Rc(), L = E(
      () => Pg(A.value, {
        active: Og(M.key.value, n.order),
        dateOf: (Oe) => k(Oe.last_modified),
        /* Folders keep their own run at the top — the same rule the list follows,
         * and the reason "folders before files" survives a date sort. Here the run
         * is the one that already had a name. */
        aside: (Oe) => Oe.type === "dir" ? { id: "dirs", label: n.sections ? l("drive.section.folders") : null } : null,
        labels: { t: l, formatMonthYear: v, zonedYearMonth: x }
      })
    );
    function U(Oe) {
      return L.value.active ? L.value.headingBefore(Oe) : n.sections ? Oe.path === T.value ? l("drive.section.folders") : Oe.path === R.value ? l("drive.section.files") : null : null;
    }
    function P(Oe) {
      return n.thumbSrc ? n.thumbSrc(Oe) : Oe.thumb_url ?? null;
    }
    const H = Z$({
      // Read once: the explorer's `config.apiBase` is fixed for the life of a
      // mounted panel, and `enabled` has to be answerable at construction.
      apiBase: n.apiBase,
      // Wrapped rather than passed, so a parent that re-creates its arrow on each
      // render is still called through the CURRENT prop. ⚠ The builder is async;
      // `createFilePreviews` awaits it (see the note there — a Promise spread into
      // a headers object sends no Authorization and 401s in silence).
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    Ct(() => H.dispose());
    function $(Oe) {
      return H.kindFor(Oe);
    }
    function F(Oe) {
      const Be = H.get(Oe);
      return Be ? [Be] : [];
    }
    function I(Oe, Be) {
      H.bind(Oe instanceof Element ? Oe : null, Be);
    }
    function Z(Oe) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof Oe.id == "number" && Oe.type === "file";
    }
    function J(Oe) {
      return n.selected.has(Oe.path);
    }
    function re(Oe, Be) {
      a("click-card", Oe, Eg(Be));
    }
    function ve(Oe, Be) {
      a("click-card", Oe, Ag(Be, G.isTap(Be)));
    }
    function W(Oe) {
      a("dbl-card", Oe);
    }
    function z(Oe, Be) {
      Be.preventDefault(), Be.stopPropagation(), a("context-card", Oe, Be);
    }
    function le(Oe, Be) {
      z(Oe, Be);
    }
    function fe(Oe, Be) {
      Rg(
        Be,
        p(Oe),
        n.selected.has(Oe.path) ? n.selected.size : 1
      ), a("item-drag-start", Oe, Be);
    }
    const j = S(null);
    function X(Oe, Be) {
      Oe.type === "dir" && ti(Be) && (Be.preventDefault(), Be.stopPropagation(), Be.dataTransfer && (Be.dataTransfer.dropEffect = "move"), j.value = Oe.path);
    }
    function te(Oe) {
      j.value === Oe.path && (j.value = null);
    }
    function V(Oe, Be) {
      j.value = null, Oe.type === "dir" && ti(Be) && (Be.preventDefault(), Be.stopPropagation(), a("item-drop-into", Oe, Be));
    }
    const G = Cg(
      (Oe, Be) => a("context-card", Oe, { ...Be, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (Oe) => a("click-card", Oe, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function q(Oe) {
      return m(Oe);
    }
    function B(Oe) {
      if (Oe.type === "dir") return l("node.folder");
      const Be = q(Oe.last_modified), qe = c(Oe.size);
      return Be ? `${qe} • ${Be}` : qe;
    }
    function K(Oe) {
      return Oe === "kept" ? "✓" : Oe === "syncing" ? "⟳" : Oe === "partial" ? "◐" : "☁";
    }
    function ke(Oe) {
      const Be = Oe.snippet;
      return typeof Be == "string" ? Be : "";
    }
    function Ye(Oe) {
      return ly(Oe).map((Be) => Be.text).join("");
    }
    return (Oe, Be) => (f(), h("div", Oq, [
      e.loading && A.value.length > 0 ? (f(), h("div", Pq, [
        d("span", Dq, y(u(l)("loading")), 1)
      ])) : D("", !0),
      d("div", {
        class: Ne(["fe-grid", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0, "has-folder-previews": i.value }]),
        role: "listbox",
        "aria-multiselectable": "true",
        "aria-label": u(l)("grid.aria"),
        "aria-busy": e.loading ? "true" : void 0
      }, [
        (f(!0), h(Ce, null, nt(A.value, (qe) => {
          var Tt, $t;
          return f(), h(Ce, {
            key: qe.path
          }, [
            U(qe) ? (f(), h("p", Rq, y(U(qe)), 1)) : D("", !0),
            d("div", {
              class: Ne(["fe-grid__card", {
                "fe-grid__card--folder": qe.type === "dir",
                "fe-grid__card--file": qe.type !== "dir",
                "is-selected": J(qe),
                "is-dir": qe.type === "dir",
                "is-trash": qe.trashed,
                "is-clipped": (Tt = e.clipped) == null ? void 0 : Tt.has(qe.path),
                "is-droptarget": j.value === qe.path
              }]),
              tabindex: "0",
              role: "option",
              "aria-selected": J(qe) ? "true" : "false",
              "aria-label": u(p)(qe),
              "data-fe-path": qe.path,
              draggable: "true",
              onClick: (it) => ve(qe, it),
              onDblclick: (it) => W(qe),
              onContextmenu: (it) => z(qe, it),
              onDragstart: (it) => fe(qe, it),
              onDragover: (it) => X(qe, it),
              onDragleave: (it) => te(qe),
              onDrop: (it) => V(qe, it),
              onTouchstartPassive: (it) => u(G).onTouchStart(qe, it),
              onTouchend: Be[4] || (Be[4] = //@ts-ignore
              (...it) => u(G).onTouchEnd && u(G).onTouchEnd(...it)),
              onTouchmovePassive: Be[5] || (Be[5] = //@ts-ignore
              (...it) => u(G).onTouchMove && u(G).onTouchMove(...it)),
              onPointerenter: (it) => r(qe, it),
              onPointerleave: (it) => qe.type === "dir" && a("peek-end"),
              onPointerdown: Be[6] || (Be[6] = (it) => a("peek-end"))
            }, [
              qe.type !== "dir" ? (f(), h("div", {
                key: 0,
                class: "fe-grid__thumb",
                ref_for: !0,
                ref: (it) => I(it, qe)
              }, [
                $(qe) ? (f(), h(Ce, { key: 0 }, [
                  (f(!0), h(Ce, null, nt(F(qe), (it) => (f(), h("div", {
                    key: "fprev",
                    class: Ne(["fe-fprev", "fe-fprev--" + it.kind]),
                    dir: u(c2)(it.kind),
                    style: Xt(it.kind === "table" ? { "--fprev-cols": String(it.cols) } : void 0),
                    "aria-hidden": "true"
                  }, [
                    it.kind === "table" ? (f(!0), h(Ce, { key: 0 }, nt(it.rows, (yt, ft) => (f(), h(Ce, { key: ft }, [
                      (f(!0), h(Ce, null, nt(yt, (ze, oe) => (f(), h("span", {
                        key: oe,
                        class: Ne(["fe-fprev__cell", { "is-head": ft === 0 }])
                      }, y(ze), 3))), 128))
                    ], 64))), 128)) : (f(!0), h(Ce, { key: 1 }, nt(it.lines, (yt, ft) => (f(), h("div", {
                      key: ft,
                      class: "fe-fprev__line"
                    }, [
                      yt.tint ? (f(), h("span", Bq, y(yt.indent) + y(yt.tint), 1)) : D("", !0),
                      Vt(y(yt.text), 1)
                    ]))), 128))
                  ], 14, Iq))), 128)),
                  F(qe).length === 0 ? (f(), h("span", {
                    key: 0,
                    class: "fe-grid__icon fe-grid__icon--svg",
                    innerHTML: u(xa)(qe)
                  }, null, 8, Fq)) : D("", !0)
                ], 64)) : (f(), We(qc, {
                  key: 1,
                  node: qe,
                  "src-of": P,
                  "video-badge": u(X$)(qe),
                  note: C(qe),
                  alt: qe.basename,
                  class: Ne({
                    "fe-thumb--page": u(Mg)(qe)
                    /* gorunum:v1-preview — crop a page from its TOP */
                  })
                }, {
                  default: mt(() => [
                    u(Br)(qe) ? (f(), h("span", {
                      key: 0,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      role: "img",
                      "aria-label": u(l)("e2e.badge"),
                      innerHTML: u(vl)()
                    }, null, 8, Uq)) : (f(), h("span", {
                      key: 1,
                      class: "fe-grid__icon fe-grid__icon--svg",
                      innerHTML: u(xa)(qe)
                    }, null, 8, Hq))
                  ]),
                  _: 2
                }, 1032, ["node", "video-badge", "note", "alt", "class"])),
                Z(qe) ? (f(), h("div", {
                  key: 2,
                  class: "fe-grid__star",
                  onClick: Be[0] || (Be[0] = vt(() => {
                  }, ["stop"])),
                  onDblclick: Be[1] || (Be[1] = vt(() => {
                  }, ["stop"]))
                }, [
                  Je(Dg, {
                    starred: !!(($t = e.starredIds) != null && $t.has(qe.id)),
                    "node-id": qe.id,
                    "api-base": e.apiBase,
                    "auth-headers": e.authHeaders,
                    "auth-credentials": e.authCredentials,
                    locale: e.locale,
                    compact: "",
                    card: "",
                    onChange: (it) => a("star-change", qe, it)
                  }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
                ], 32)) : D("", !0)
              ], 512)) : i.value ? (f(), h("div", Kq, [
                Je(Lg, {
                  node: qe,
                  "src-of": P
                }, null, 8, ["node"])
              ])) : D("", !0),
              d("div", Vq, [
                d("span", {
                  class: Ne(["fe-grid__lead", { "fe-grid__lead--pick": e.selectable }])
                }, [
                  u(Br)(qe) ? (f(), h("span", {
                    key: 0,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    role: "img",
                    "aria-label": u(l)("e2e.badge"),
                    innerHTML: u(vl)()
                  }, null, 8, jq)) : (f(), h("span", {
                    key: 1,
                    class: "fe-grid__tile fe-grid__tile--svg",
                    innerHTML: u(xa)(qe)
                  }, null, 8, qq)),
                  e.selectable ? (f(), h("span", {
                    key: 2,
                    class: "fe-item-check",
                    "data-fe-control": "",
                    onClick: vt((it) => re(qe, it), ["stop"]),
                    onDblclick: Be[2] || (Be[2] = vt(() => {
                    }, ["stop"]))
                  }, [
                    Je(mg, {
                      on: J(qe),
                      label: u(p)(qe)
                    }, null, 8, ["on", "label"])
                  ], 40, Wq)) : D("", !0)
                ], 2),
                d("div", Yq, [
                  d("div", {
                    class: "fe-grid__label",
                    title: u(p)(qe)
                  }, [
                    d("bdi", null, y(u(p)(qe)), 1),
                    e.keepBadgeFor && e.keepBadgeFor(qe) ? (f(), h("span", {
                      key: 0,
                      class: Ne(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(qe)]),
                      title: u(l)("keep.badge_" + e.keepBadgeFor(qe)),
                      role: "img",
                      "aria-label": u(l)("keep.badge_" + e.keepBadgeFor(qe))
                    }, y(K(e.keepBadgeFor(qe))), 11, Xq)) : D("", !0)
                  ], 8, Gq),
                  d("div", {
                    class: "fe-grid__meta",
                    title: B(qe)
                  }, [
                    _(qe) ? (f(), h("span", {
                      key: 0,
                      class: "fe-applock",
                      role: "img",
                      title: _(qe),
                      "aria-label": _(qe),
                      "data-testid": "lock-badge"
                    }, [
                      Be[7] || (Be[7] = d("span", {
                        class: "fe-applock__glyph",
                        "aria-hidden": "true"
                      }, "🔒", -1)),
                      Vt(y(u(l)("applock.badge")), 1)
                    ], 8, Zq)) : D("", !0),
                    w(qe) ? (f(), h("span", {
                      key: 1,
                      class: Ne(["fe-symlink", "fe-symlink--" + w(qe).state]),
                      role: "img",
                      title: w(qe).why,
                      "aria-label": w(qe).why,
                      "data-testid": "symlink-badge",
                      "data-link-state": w(qe).state
                    }, [
                      Be[8] || (Be[8] = d("span", {
                        class: "fe-symlink__glyph",
                        "aria-hidden": "true"
                      }, "🔗", -1)),
                      Vt(y(w(qe).badge), 1)
                    ], 10, Qq)) : D("", !0),
                    b(qe) ? (f(), h("span", {
                      key: 2,
                      class: "fe-unavailable",
                      role: "img",
                      title: b(qe).full,
                      "aria-label": b(qe).full,
                      "data-testid": "unavailable-badge"
                    }, y(b(qe).badge), 9, eW)) : D("", !0),
                    Vt(" " + y(B(qe)), 1)
                  ], 8, Jq),
                  e.showParentPath && u(Or)(qe) ? (f(), h("div", {
                    key: 0,
                    class: "fe-grid__parent",
                    title: u(Or)(qe)
                  }, [
                    d("bdi", null, y(u(Or)(qe)), 1)
                  ], 8, tW)) : D("", !0),
                  ke(qe) ? (f(), h("div", {
                    key: 1,
                    class: "fe-grid__snippet",
                    title: Ye(ke(qe))
                  }, [
                    (f(!0), h(Ce, null, nt(u(ly)(ke(qe)), (it, yt) => (f(), h(Ce, { key: yt }, [
                      it.match ? (f(), h("mark", aW, y(it.text), 1)) : (f(), h(Ce, { key: 1 }, [
                        Vt(y(it.text), 1)
                      ], 64))
                    ], 64))), 128))
                  ], 8, nW)) : D("", !0)
                ]),
                d("button", {
                  type: "button",
                  class: "fe-grid__menu",
                  "aria-label": u(l)("toolbar.more"),
                  title: u(l)("toolbar.more"),
                  onClick: vt((it) => le(qe, it), ["stop"]),
                  onDblclick: Be[3] || (Be[3] = vt(() => {
                  }, ["stop"]))
                }, "⋮", 40, iW)
              ])
            ], 42, Nq)
          ], 64);
        }), 128)),
        !e.loading && e.files.length === 0 ? (f(), h("div", oW, y(u(l)("empty.folder")), 1)) : D("", !0)
      ], 10, Lq)
    ]));
  }
}), rW = {
  class: "fe-home",
  "data-testid": "home-view"
}, sW = {
  class: "fe-home__section",
  "data-testid": "home-storages"
}, lW = { class: "fe-home__heading" }, uW = {
  key: 0,
  class: "fe-home__storages"
}, cW = ["data-storage", "title", "onClick"], dW = ["innerHTML"], fW = { class: "fe-home__storage-main" }, pW = { class: "fe-home__storage-label" }, hW = ["data-partial"], mW = {
  key: 1,
  class: "fe-home__nomatch",
  "data-testid": "home-storages-nomatch"
}, vW = {
  key: 2,
  class: "fe-state fe-home__state",
  "data-testid": "home-storages-empty"
}, yW = { class: "fe-state__title" }, gW = { class: "fe-state__hint" }, bW = {
  class: "fe-home__section",
  "data-testid": "home-recent"
}, kW = { class: "fe-home__heading" }, wW = {
  key: 1,
  class: "fe-home__loading"
}, _W = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-recent-nomatch"
}, xW = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-recent-empty"
}, SW = { class: "fe-state__title" }, $W = { class: "fe-state__hint" }, TW = {
  class: "fe-home__section",
  "data-testid": "home-starred"
}, AW = { class: "fe-home__heading" }, EW = {
  key: 1,
  class: "fe-home__loading"
}, CW = {
  key: 2,
  class: "fe-home__nomatch",
  "data-testid": "home-starred-nomatch"
}, zW = {
  key: 3,
  class: "fe-state fe-home__state",
  "data-testid": "home-starred-empty"
}, MW = { class: "fe-state__title" }, OW = { class: "fe-state__hint" }, PW = /* @__PURE__ */ rt({
  __name: "HomeView",
  props: {
    storages: {},
    recent: {},
    starred: {},
    loading: { type: Boolean },
    locale: {},
    nameFilter: {},
    matchNames: { type: Function },
    thumbSrc: { type: Function }
  },
  emits: ["open-storage", "open-node", "context-node"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r } = ht(() => n.locale), l = E(() => (n.nameFilter ?? "").trim()), c = E(() => l.value !== ""), p = Xu(
      () => l.value,
      () => n.storages,
      (M) => M.label || M.name,
      () => n.matchNames
    ), m = Xu(
      () => l.value,
      () => n.recent,
      (M) => M.basename || "",
      () => n.matchNames
    ), v = Xu(
      () => l.value,
      () => n.starred,
      (M) => M.basename || "",
      () => n.matchNames
    ), x = E(() => p.apply(n.storages)), k = E(() => m.apply(n.recent)), _ = E(() => v.apply(n.starred));
    function w(M, L) {
      return c.value && M > 0 && L === 0;
    }
    const b = /* @__PURE__ */ new Set(), C = xa({ type: "dir", mime_type: "inode/storage" });
    function A(M) {
      return typeof M.usedBytes != "number" || M.usedBytes < 0 ? i("conn.guide.storage") : M.usedPartial ? i("drive.storage.used_partial", { used: r(M.usedBytes) }) : i("drive.storage.used_unlimited", { used: r(M.usedBytes) });
    }
    const T = S({ path: "", at: 0 });
    function R(M) {
      const L = Date.now();
      M.path === T.value.path && L - T.value.at < 700 || (T.value = { path: M.path, at: L }, a("open-node", M));
    }
    return (M, L) => (f(), h("div", rW, [
      d("section", sW, [
        d("h2", lW, y(u(i)("sidenav.storages")), 1),
        x.value.length ? (f(), h("div", uW, [
          (f(!0), h(Ce, null, nt(x.value, (U) => (f(), h("button", {
            key: U.name,
            type: "button",
            class: "fe-home__storage",
            "data-testid": "home-storage-card",
            "data-storage": U.name,
            title: U.label || U.name,
            onClick: (P) => a("open-storage", U.name)
          }, [
            d("span", {
              class: "fe-home__storage-tile",
              "aria-hidden": "true",
              innerHTML: u(C)
            }, null, 8, dW),
            d("span", fW, [
              d("span", pW, y(U.label || U.name), 1),
              d("span", {
                class: "fe-home__storage-meta",
                "data-testid": "home-storage-used",
                "data-partial": U.usedPartial ? "true" : void 0
              }, y(A(U)), 9, hW),
              U.readOnly ? (f(), We(Y$, {
                key: 0,
                "read-only": "",
                locale: e.locale,
                class: "fe-home__storage-ro",
                "data-testid": "home-storage-readonly"
              }, null, 8, ["locale"])) : D("", !0)
            ])
          ], 8, cW))), 128))
        ])) : w(e.storages.length, x.value.length) ? (f(), h("p", mW, y(u(i)("filter.empty.title")), 1)) : (f(), h("div", vW, [
          L[2] || (L[2] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("rect", {
              x: "26",
              y: "30",
              width: "68",
              height: "18",
              rx: "5"
            }),
            d("rect", {
              x: "26",
              y: "54",
              width: "68",
              height: "18",
              rx: "5"
            }),
            d("path", { d: "M38 39h.01M38 63h.01" })
          ], -1)),
          d("p", yW, y(u(i)("home.storages.empty")), 1),
          d("p", gW, y(u(i)("home.storages.hint")), 1)
        ]))
      ]),
      d("section", bW, [
        d("h2", kW, y(u(i)("sidenav.recent")), 1),
        k.value.length ? (f(), We(uy, {
          key: 0,
          files: k.value,
          selected: u(b),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: R,
          onDblCard: R,
          onContextCard: L[0] || (L[0] = (U, P) => a("context-node", U, P))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (f(), h("p", wW, y(u(i)("loading")), 1)) : w(e.recent.length, k.value.length) ? (f(), h("p", _W, y(u(i)("filter.empty.title")), 1)) : (f(), h("div", xW, [
          L[3] || (L[3] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("circle", {
              cx: "60",
              cy: "50",
              r: "28"
            }),
            d("path", { d: "M60 32v18l12 8" })
          ], -1)),
          d("p", SW, y(u(i)("empty.recent.title")), 1),
          d("p", $W, y(u(i)("empty.recent.hint")), 1)
        ]))
      ]),
      d("section", TW, [
        d("h2", AW, y(u(i)("sidenav.starred")), 1),
        _.value.length ? (f(), We(uy, {
          key: 0,
          files: _.value,
          selected: u(b),
          selectable: !1,
          locale: e.locale,
          "thumb-src": e.thumbSrc,
          onClickCard: R,
          onDblCard: R,
          onContextCard: L[1] || (L[1] = (U, P) => a("context-node", U, P))
        }, null, 8, ["files", "selected", "locale", "thumb-src"])) : e.loading ? (f(), h("p", EW, y(u(i)("loading")), 1)) : w(e.starred.length, _.value.length) ? (f(), h("p", CW, y(u(i)("filter.empty.title")), 1)) : (f(), h("div", zW, [
          L[4] || (L[4] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "96",
            height: "80",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("path", { d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z" })
          ], -1)),
          d("p", MW, y(u(i)("empty.starred.title")), 1),
          d("p", OW, y(u(i)("empty.starred.hint")), 1)
        ]))
      ])
    ]));
  }
}), DW = {
  class: "fe-drafts",
  "data-testid": "drafts-view"
}, LW = { class: "fe-drafts__head" }, RW = { class: "fe-drafts__lead" }, NW = {
  key: 0,
  class: "fe-drafts__count",
  "data-testid": "drafts-count-line"
}, IW = {
  key: 0,
  class: "fe-state",
  "data-testid": "empty-drafts"
}, BW = { class: "fe-state__title" }, FW = { class: "fe-state__hint" }, UW = { class: "fe-drafts__name" }, HW = ["innerHTML"], KW = ["title", "data-testid", "onClick"], VW = { class: "fe-drafts__target" }, jW = /* @__PURE__ */ rt({
  __name: "DraftsView",
  props: {
    drafts: {},
    loading: { type: Boolean },
    limit: {},
    locale: {},
    nameFilter: {},
    matchNames: { type: Function },
    busyKey: {}
  },
  emits: ["open", "save", "delete"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r } = ht(() => n.locale), l = Xu(
      () => n.nameFilter ?? "",
      () => n.drafts,
      (C) => C.name,
      () => n.matchNames
    ), c = E(() => l.apply(n.drafts));
    function p(C) {
      const A = C.lastIndexOf(".");
      return A > 0 ? C.slice(A + 1).toLowerCase() : "";
    }
    function m(C) {
      return xa({ type: "file", basename: C.name, extension: p(C.name) || C.type });
    }
    function v(C) {
      const A = C.target_dir.indexOf("://"), T = (A >= 0 ? C.target_dir.slice(A + 3) : C.target_dir).replace(/^\/+|\/+$/g, "");
      return T ? T.split("/").filter(Boolean).join(" / ") : "/";
    }
    function x(C) {
      return Date.parse(C.modified_at || C.created_at) || 0;
    }
    const k = E(() => [
      {
        id: "name",
        label: i("col.name"),
        lead: !0,
        sortable: !0,
        width: 280,
        min: 160,
        format: (C) => C.name
      },
      {
        id: "target",
        label: i("drafts.col.target"),
        sortable: !0,
        width: 240,
        format: v,
        title: (C) => C.target
      },
      {
        id: "storage",
        label: i("drafts.col.storage"),
        sortable: !0,
        width: 140,
        format: (C) => C.storage
      },
      {
        id: "modified",
        label: i("col.modified"),
        sortable: !0,
        sortDir: "desc",
        width: 170,
        format: (C) => r(x(C)),
        sortValue: (C) => x(C)
      }
    ]);
    function _(C) {
      const A = n.busyKey === C.key;
      return [
        { key: "open", label: i("ctx.open"), icon: "open", disabled: A },
        { key: "save", label: i("drafts.action.save"), icon: "check", disabled: A },
        { key: "delete", label: i("ctx.delete"), icon: "delete", danger: !0, disabled: A }
      ];
    }
    function w(C, A) {
      C === "open" ? a("open", A) : C === "save" ? a("save", A) : C === "delete" && a("delete", A);
    }
    const b = E(
      () => n.limit && n.limit > 0 ? i("drafts.count_of", { n: n.drafts.length, limit: n.limit }) : ""
    );
    return (C, A) => (f(), h("section", DW, [
      d("header", LW, [
        d("p", RW, y(u(i)("drafts.lead")), 1),
        b.value && e.drafts.length ? (f(), h("p", NW, y(b.value), 1)) : D("", !0)
      ]),
      !e.loading && e.drafts.length === 0 ? (f(), h("div", IW, [
        A[2] || (A[2] = d("svg", {
          class: "fe-state__art",
          viewBox: "0 0 120 100",
          width: "110",
          height: "92",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true"
        }, [
          d("path", { d: "M66 18H38a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h44a6 6 0 0 0 6-6V40z" }),
          d("path", { d: "M66 18v22h22" }),
          d("path", { d: "M50 66l18-18 6 6-18 18H50z" })
        ], -1)),
        d("p", BW, y(u(i)("empty.drafts.title")), 1),
        d("p", FW, y(u(i)("empty.drafts.hint")), 1)
      ])) : (f(), We(es, {
        key: 1,
        "table-id": "explorer.drafts",
        columns: k.value,
        rows: c.value,
        "row-key": "key",
        locale: e.locale,
        loading: e.loading,
        framed: !1,
        empty: u(i)("drafts.no_match"),
        "aria-label": u(i)("node.drafts"),
        "row-attrs": (T) => ({ "data-testid": `draft-row-${T.key}`, "data-draft-name": T.name }),
        "row-actions": _,
        "row-actions-test-id": (T) => `draft-actions-${T.key}`,
        onRowAction: A[0] || (A[0] = (T, R) => w(T, R)),
        onRowDblclick: A[1] || (A[1] = (T) => a("open", T))
      }, {
        "cell-name": mt(({ row: T }) => [
          d("span", UW, [
            d("span", {
              class: "fe-drafts__tile",
              "aria-hidden": "true",
              innerHTML: m(T)
            }, null, 8, HW),
            d("button", {
              type: "button",
              class: "fe-drafts__open",
              title: u(i)("drafts.open_hint", { name: T.name }),
              "data-testid": `draft-open-${T.key}`,
              onClick: vt((R) => a("open", T), ["stop"])
            }, [
              d("bdi", null, y(u(fa)(T.name)), 1)
            ], 8, KW)
          ])
        ]),
        "cell-target": mt(({ row: T }) => [
          d("bdi", VW, y(v(T)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "loading", "empty", "aria-label", "row-attrs", "row-actions-test-id"]))
    ]));
  }
});
function ba(e) {
  if (e.apiBase != null) return e.apiBase.replace(/\/+$/, "");
  const t = e.endpoint ?? "", n = t.indexOf("/api/");
  return n >= 0 ? t.slice(0, n) : "";
}
function qW(e, t) {
  const n = String(t ?? "").trim();
  if (/^https?:\/\/[^/]/i.test(n)) return n.replace(/\/+$/, "");
  const a = ba(e);
  if (/^https?:\/\//i.test(a))
    try {
      const i = new URL(a);
      return i.origin + i.pathname.replace(/\/+$/, "");
    } catch {
      return a;
    }
  return typeof window < "u" && window.location ? window.location.origin + (a.startsWith("/") ? a : "") : a;
}
function WW(e) {
  const t = zl(e), n = ba(e), a = (I) => `${n}${I}`, i = Ea([]), r = Ea([]), l = Ea([]), c = S(null), p = S(null), m = S(null), v = S(!1), x = S(!1), k = S(null), _ = S(null), w = S(null);
  function b(I) {
    return I == null ? void 0 : I.status;
  }
  function C(I) {
    return Za(I, e.locale);
  }
  async function A() {
    v.value = !0, k.value = null;
    try {
      const I = t.capabilities().then((Z) => {
        const J = Z == null ? void 0 : Z.public_url;
        m.value = typeof J == "string" && J ? J : null;
      }).catch(() => {
        m.value = null;
      });
      try {
        const Z = await t.jsonFetch(a("/api/auth/me"));
        c.value = (Z == null ? void 0 : Z.user) ?? null, p.value = typeof (Z == null ? void 0 : Z.realm) == "string" && Z.realm ? Z.realm : null;
      } catch (Z) {
        b(Z) === 401 && (_.value = !1, w.value = "anonymous"), c.value = null;
      }
      try {
        i.value = await t.jsonFetch(
          a("/api/admin/storage-drivers")
        ), _.value = !0, w.value = null;
      } catch (Z) {
        i.value = [], _.value = !1;
        const J = b(Z);
        J === 403 ? w.value = "none" : J === 401 ? w.value = "anonymous" : (w.value = "unreachable", k.value = C(Z));
      }
      if (_.value)
        try {
          const Z = await t.jsonFetch(a("/api/admin/storages"));
          r.value = Array.isArray(Z) ? Z : [], l.value = r.value.map((J) => J.name);
        } catch (Z) {
          k.value = C(Z);
        }
      else
        try {
          const Z = await t.index("");
          l.value = Array.isArray(Z == null ? void 0 : Z.storages) ? Z.storages : [];
        } catch {
          l.value = [];
        }
      await I, x.value = !0;
    } finally {
      v.value = !1;
    }
  }
  async function T(I) {
    const Z = await t.jsonFetch(a("/api/admin/storages"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(I)
    });
    return await A(), Z;
  }
  async function R(I, Z) {
    const J = await t.jsonFetch(a(`/api/admin/storages/${I}`), {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(Z)
    });
    return await A(), J;
  }
  async function M(I) {
    await t.jsonFetch(a(`/api/admin/storages/${I}`), { method: "DELETE" }), await A();
  }
  async function L(I) {
    try {
      return await t.jsonFetch(a("/api/admin/storages/test"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(I)
      });
    } catch (Z) {
      return { ok: !1, error: C(Z) };
    }
  }
  function U(I) {
    return i.value.find((Z) => Z.driver === I);
  }
  function P(I) {
    var Z;
    return ((Z = U(I)) == null ? void 0 : Z.fields) ?? [];
  }
  function H(I) {
    const Z = {};
    for (const J of P(I))
      J.default !== void 0 && J.default !== null && (Z[J.key] = J.default);
    return Z;
  }
  function $(I, Z) {
    return P(I).filter((J) => {
      if (!J.required || J.default !== void 0) return !1;
      for (const re of [J.key, ...J.aliases ?? []]) {
        const ve = Z[re];
        if (ve != null && !(typeof ve == "string" && ve.trim() === ""))
          return !1;
      }
      return !0;
    });
  }
  const F = E(() => i.value.map((I) => I.driver));
  return {
    // state
    drivers: i,
    driverNames: F,
    storages: r,
    visible: l,
    me: c,
    realm: p,
    publicUrl: m,
    loading: v,
    loaded: x,
    error: k,
    canManage: _,
    denial: w,
    // actions
    load: A,
    createStorage: T,
    updateStorage: R,
    deleteStorage: M,
    testStorage: L,
    // descriptor helpers
    descriptor: U,
    fields: P,
    defaults: H,
    missingRequired: $
  };
}
function eT(e) {
  return /^http:\/\//i.test(e);
}
function YW(e, t) {
  const n = e.replace(/\/+$/, "");
  return t ? `${n}/dav/${t}/` : `${n}/dav/`;
}
function GW(e, t) {
  let n;
  try {
    n = new URL(e);
  } catch {
    return e.replace(/^https:/i, "davs:").replace(/^http:/i, "dav:");
  }
  return `${n.protocol === "http:" ? "dav" : "davs"}://${n.host}${n.pathname}`;
}
function XW(e) {
  return ["use", e.letter, e.url, `/user:${e.user}`, e.password, "/persistent:yes"];
}
function JW(e) {
  const [t, n, a, ...i] = XW(e);
  return ["net", t, n, `"${a}"`, ...i].join(" ");
}
const e0 = "HKLM\\SYSTEM\\CurrentControlSet\\Services\\WebClient\\Parameters", ZW = 4294967295, QW = 2e7, eY = [
  `reg add "${e0}" /v FileSizeLimitInBytes /t REG_DWORD /d ${ZW} /f`,
  `reg add "${e0}" /v FileAttributesLimitInBytes /t REG_DWORD /d ${QW} /f`,
  "net stop webclient && net start webclient"
];
function Xr(e) {
  try {
    return new URL(e).host;
  } catch {
    return e.replace(/^https?:\/\//i, "").replace(/\/+$/, "");
  }
}
function tY(e) {
  try {
    return new URL(e).pathname.replace(/\/+$/, "");
  } catch {
    return "";
  }
}
function nY(e, t) {
  const n = String(e ?? "").trim(), a = String(t ?? "").trim();
  return n && a ? `${a}/${n}` : n;
}
function Ng(e, t) {
  return e.user || t("conn.guide.userPlaceholder");
}
const aY = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), a = YW(n, e.storage), i = Ng(e, t), r = t("conn.guide.secretPlaceholder"), l = [
    { label: t("conn.guide.fact.url"), value: a, hint: e.storage ? t("conn.guide.fact.urlStorageHint", { storage: e.storage }) : t("conn.guide.fact.urlRootHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.webdav.userHint") },
    { label: t("conn.guide.fact.password"), value: r, hint: t("conn.guide.webdav.passwordHint"), placeholderOnly: !0 }
  ], c = [
    {
      id: "windows",
      name: "Windows Explorer",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.win.s1"),
            t("conn.guide.webdav.win.s2", { url: a }),
            t("conn.guide.webdav.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.cmdCaption"),
          code: JW({ letter: "Z:", url: a, user: i, password: r })
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.win.limits")
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.win.regCaption"),
          code: eY.join(`
`)
        },
        { kind: "note", text: t("conn.guide.webdav.win.https") },
        { kind: "note", text: t("conn.guide.webdav.win.persist") },
        { kind: "note", text: t("conn.guide.webdav.win.service") }
      ]
    },
    {
      id: "macos",
      name: "macOS Finder",
      platform: "macos",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.mac.s1"),
            t("conn.guide.webdav.mac.s2", { url: a }),
            t("conn.guide.webdav.mac.s3")
          ]
        },
        { kind: "note", text: t("conn.guide.webdav.mac.note") }
      ]
    },
    {
      id: "linux",
      name: "Linux (davfs2 / GNOME / KDE)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.linux.mountCaption"),
          code: [
            `sudo mount -t davfs ${a} /mnt/filex`,
            "",
            `# ${t("conn.guide.webdav.linux.gvfsComment")}`,
            `gio mount ${GW(a)}`
          ].join(`
`)
        },
        {
          kind: "warn",
          text: t("conn.guide.webdav.linux.locks")
        },
        {
          kind: "code",
          caption: "/etc/davfs2/davfs2.conf",
          code: "use_locks 0"
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.obscureCaption"),
          code: `rclone obscure "${r}"`
        },
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = webdav",
            `url = ${n}/dav`,
            "vendor = other",
            `user = ${i}`,
            `pass = ${t("conn.guide.webdav.rclone.passPlaceholder")}`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.webdav.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            e.storage ? `rclone lsl filex:${e.storage}` : "rclone lsl filex:<storage>",
            e.storage ? `rclone copy ./local filex:${e.storage}/backup` : "rclone copy ./local filex:<storage>/backup",
            "rclone mount filex: /mnt/filex"
          ].join(`
`)
        }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.webdav.duck.s1"),
            t("conn.guide.webdav.duck.s2", { host: Xr(n) }),
            t("conn.guide.webdav.duck.s3", { path: tY(n) + (e.storage ? `/dav/${e.storage}/` : "/dav/") }),
            t("conn.guide.webdav.duck.s4", { user: i })
          ]
        }
      ]
    }
  ], p = [
    { kind: "note", text: t("conn.guide.webdav.note.delete") },
    { kind: "note", text: t("conn.guide.webdav.note.locks") },
    { kind: "note", text: t("conn.guide.webdav.note.permissions") }
  ];
  return eT(n) && p.unshift({ kind: "warn", text: t("conn.guide.webdav.note.http") }), {
    id: "webdav",
    name: "WebDAV",
    summary: t("conn.guide.webdav.summary"),
    facts: l,
    clients: c,
    notes: p
  };
}, iY = (e, t) => {
  const n = (e.s3Endpoint || `${e.origin.replace(/\/+$/, "")}/s3`).replace(/\/+$/, ""), a = e.storage || e.storages[0] || "<bucket>", i = e.s3AccessKeyID || t("conn.guide.s3.keyPlaceholder"), r = e.s3Secret || t("conn.guide.s3.secretPlaceholder"), l = e.s3PathStyle !== !1, c = Xr(n), p = [
    { label: t("conn.guide.s3.fact.endpoint"), value: n, hint: t("conn.guide.s3.fact.endpointHint") },
    { label: t("conn.guide.s3.fact.bucket"), value: a, hint: t("conn.guide.s3.fact.bucketHint") },
    { label: t("conn.guide.s3.fact.key"), value: i, hint: t("conn.guide.s3.fact.keyHint") },
    {
      label: t("conn.guide.s3.fact.secret"),
      value: r,
      hint: t("conn.guide.s3.fact.secretHint"),
      // ⚠ Only real right after minting. filex stores the secret sealed and
      // cannot show it again, and a guide that printed something secret-shaped
      // would be teaching a value that authenticates as nothing.
      placeholderOnly: !e.s3Secret
    },
    { label: t("conn.guide.s3.fact.region"), value: "us-east-1", hint: t("conn.guide.s3.fact.regionHint") },
    {
      label: t("conn.guide.s3.fact.addressing"),
      value: t(l ? "conn.guide.s3.fact.pathStyle" : "conn.guide.s3.fact.virtualHosted"),
      hint: t(l ? "conn.guide.s3.fact.pathStyleHint" : "conn.guide.s3.fact.virtualHostedHint")
    }
  ], m = [
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex]",
            "type = s3",
            "provider = Other",
            `endpoint = ${n}`,
            `access_key_id = ${i}`,
            `secret_access_key = ${r}`,
            "region = us-east-1",
            ...l ? ["force_path_style = true"] : []
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.rclone.useCaption"),
          code: [
            "rclone lsd filex:",
            `rclone copy ./local filex:${a}/backup -P`,
            `rclone sync ./local filex:${a}/backup`,
            `rclone mount filex:${a} /mnt/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.rclone.mtime") }
      ]
    },
    {
      id: "awscli",
      name: "AWS CLI",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.configureCaption"),
          code: [
            "aws configure set aws_access_key_id " + i,
            "aws configure set aws_secret_access_key " + r,
            "aws configure set region us-east-1"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.aws.useCaption"),
          code: [
            `aws --endpoint-url ${n} s3 ls`,
            `aws --endpoint-url ${n} s3 cp ./file.pdf s3://${a}/file.pdf`,
            `aws --endpoint-url ${n} s3 sync ./local s3://${a}/backup`,
            `aws --endpoint-url ${n} s3 presign s3://${a}/file.pdf --expires-in 300`
          ].join(`
`)
        },
        ...l ? [
          {
            kind: "note",
            text: t("conn.guide.s3.aws.pathStyle")
          },
          {
            kind: "code",
            caption: "~/.aws/config",
            code: ["[default]", "s3 =", "    addressing_style = path"].join(`
`)
          }
        ] : []
      ]
    },
    {
      id: "restic",
      name: "restic",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.envCaption"),
          code: [
            `export AWS_ACCESS_KEY_ID=${i}`,
            `export AWS_SECRET_ACCESS_KEY=${r}`,
            `export RESTIC_REPOSITORY="s3:${n}/${a}/restic"`,
            "export RESTIC_PASSWORD=…"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.restic.useCaption"),
          code: [
            `restic init${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic backup ~/Documents${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic check --read-data${l ? " -o s3.bucket-lookup=path" : ""}`,
            `restic forget --keep-daily 7 --prune${l ? " -o s3.bucket-lookup=path" : ""}`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.restic.verified") }
      ]
    },
    {
      id: "mc",
      name: "MinIO Client (mc)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.aliasCaption"),
          code: `mc alias set filex ${n} ${i} ${r} --api S3v4${l ? " --path on" : ""}`
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.mc.useCaption"),
          code: [
            "mc ls filex",
            `mc cp ./file.pdf filex/${a}/file.pdf`,
            `mc mirror ./local filex/${a}/backup`,
            `mc du filex/${a}`
          ].join(`
`)
        }
      ]
    },
    {
      id: "s3fs",
      name: "s3fs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.credsCaption"),
          code: [
            `echo "${i}:${r}" > ~/.passwd-s3fs`,
            "chmod 600 ~/.passwd-s3fs"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.s3.s3fs.mountCaption"),
          code: [
            `s3fs ${a} /mnt/filex \\`,
            "  -o passwd_file=~/.passwd-s3fs \\",
            `  -o url=${n} \\`,
            ...l ? ["  -o use_path_request_style"] : []
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.s3fs.note") }
      ]
    },
    {
      id: "cyberduck",
      name: "Cyberduck / Mountain Duck",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.s3.duck.s1"),
            t("conn.guide.s3.duck.s2", { host: c }),
            t("conn.guide.s3.duck.s3", { key: i }),
            t("conn.guide.s3.duck.s4")
          ]
        },
        ...l ? [{ kind: "warn", text: t("conn.guide.s3.duck.pathStyle") }] : []
      ]
    },
    {
      id: "sdk",
      name: "SDK (Go / Python / JS)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "boto3",
          code: [
            "import boto3",
            "s3 = boto3.client(",
            '    "s3",',
            `    endpoint_url="${n}",`,
            `    aws_access_key_id="${i}",`,
            `    aws_secret_access_key="${r}",`,
            '    region_name="us-east-1",',
            ...l ? [
              '    config=boto3.session.Config(s3={"addressing_style": "path"}),'
            ] : [],
            ")",
            `print([o["Key"] for o in s3.list_objects_v2(Bucket="${a}").get("Contents", [])])`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.s3.sdk.note") }
      ]
    }
  ], v = [
    { kind: "note", text: t("conn.guide.s3.note.buckets") },
    { kind: "note", text: t("conn.guide.s3.note.permissions") },
    { kind: "note", text: t("conn.guide.s3.note.trash") },
    { kind: "note", text: t("conn.guide.s3.note.mtime") }
  ];
  return l && v.unshift({ kind: "warn", text: t("conn.guide.s3.note.pathStyle") }), eT(n) && v.unshift({ kind: "warn", text: t("conn.guide.s3.note.http") }), {
    id: "s3",
    name: "S3",
    summary: t("conn.guide.s3.summary"),
    facts: p,
    clients: m,
    notes: v
  };
}, oY = (e, t) => {
  const n = e.sftpHost || Xr(e.origin), a = e.sftpPort || 2022, i = e.sftpLogin || Ng(e, t), r = e.storage ? `/${e.storage}` : "/<storage>", l = a === 22 ? "" : ` -P ${a}`, c = [
    { label: t("conn.guide.sftp.fact.host"), value: n, hint: t("conn.guide.sftp.fact.hostHint") },
    { label: t("conn.guide.sftp.fact.port"), value: String(a), hint: t("conn.guide.sftp.fact.portHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.sftp.fact.userHint") },
    {
      label: t("conn.guide.sftp.fact.auth"),
      value: e.sftpHasKey ? t("conn.guide.sftp.fact.authKey") : t("conn.guide.sftp.fact.authPassword"),
      hint: t("conn.guide.sftp.fact.authHint"),
      placeholderOnly: !0
    },
    { label: t("conn.guide.sftp.fact.path"), value: r, hint: t("conn.guide.sftp.fact.pathHint") }
  ], p = [
    {
      id: "openssh",
      name: "OpenSSH (sftp / scp)",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.openssh.connectCaption"),
          code: [
            `sftp${l} ${i}@${n}`,
            `scp${l} ./report.pdf ${i}@${n}:${r}/report.pdf`,
            `scp${l} ${i}@${n}:${r}/report.pdf ./`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "~/.ssh/config",
          code: [
            "Host filex",
            `  HostName ${n}`,
            `  Port ${a}`,
            `  User ${i}`,
            "  # IdentityFile ~/.ssh/id_ed25519"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.openssh.noShell") }
      ]
    },
    {
      id: "key",
      name: t("conn.guide.sftp.key.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.key.s1"),
            t("conn.guide.sftp.key.s2"),
            t("conn.guide.sftp.key.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.key.genCaption"),
          code: ['ssh-keygen -t ed25519 -C "filex"', "cat ~/.ssh/id_ed25519.pub"].join(`
`)
        },
        // ⚠ The one command people reach for, and the one that cannot work.
        { kind: "warn", text: t("conn.guide.sftp.key.noCopyId") }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.winscp.s1"),
            t("conn.guide.sftp.winscp.s2", { host: n, port: String(a) }),
            t("conn.guide.sftp.winscp.s3", { user: i }),
            t("conn.guide.sftp.winscp.s4")
          ]
        }
      ]
    },
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.sftp.filezilla.s1"),
            t("conn.guide.sftp.filezilla.s2", { host: `sftp://${n}`, port: String(a) }),
            t("conn.guide.sftp.filezilla.s3", { user: i })
          ]
        }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-sftp]",
            "type = sftp",
            `host = ${n}`,
            `port = ${a}`,
            `user = ${i}`,
            "key_file = ~/.ssh/id_ed25519",
            "# filex has no shell, so tell rclone not to look for one:",
            "shell_type = none",
            "md5sum_command = none",
            "sha1sum_command = none"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.sftp.rclone.useCaption"),
          code: [
            "rclone lsd filex-sftp:",
            `rclone copy ./local filex-sftp:${r}/backup -P`,
            `rclone sync ./local filex-sftp:${r}/backup`
          ].join(`
`)
        }
      ]
    },
    {
      id: "sshfs",
      name: "sshfs (Linux / macOS)",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.sftp.sshfs.mountCaption"),
          code: [
            `sshfs -p ${a} ${i}@${n}:${r} /mnt/filex`,
            "fusermount -u /mnt/filex"
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.sftp.sshfs.note") }
      ]
    }
  ], m = [
    { kind: "note", text: t("conn.guide.sftp.note.storages") },
    { kind: "note", text: t("conn.guide.sftp.note.permissions") },
    { kind: "note", text: t("conn.guide.sftp.note.trash") },
    { kind: "note", text: t("conn.guide.sftp.note.totp") }
  ];
  return e.sftpEnabled === !1 && m.unshift({ kind: "warn", text: t("conn.guide.sftp.note.disabled") }), {
    id: "sftp",
    name: "SFTP",
    summary: t("conn.guide.sftp.summary"),
    facts: c,
    clients: p,
    notes: m
  };
}, rY = (e, t) => {
  const n = e.ftpsHost || Xr(e.origin), a = e.ftpsPort || 2121, i = e.sftpLogin || Ng(e, t), r = t("conn.guide.secretPlaceholder"), l = e.storage ? `/${e.storage}` : "/<storage>", c = e.ftpsPasvMin && e.ftpsPasvMax ? `${e.ftpsPasvMin}-${e.ftpsPasvMax}` : "30000-30100", p = [
    { label: t("conn.guide.ftps.fact.host"), value: n, hint: t("conn.guide.ftps.fact.hostHint") },
    { label: t("conn.guide.ftps.fact.port"), value: String(a), hint: t("conn.guide.ftps.fact.portHint") },
    { label: t("conn.guide.ftps.fact.mode"), value: t("conn.guide.ftps.fact.modeValue"), hint: t("conn.guide.ftps.fact.modeHint") },
    { label: t("conn.guide.fact.user"), value: i, hint: t("conn.guide.ftps.fact.userHint") },
    { label: t("conn.guide.fact.password"), value: r, hint: t("conn.guide.ftps.fact.passwordHint"), placeholderOnly: !0 },
    { label: t("conn.guide.ftps.fact.pasv"), value: c, hint: t("conn.guide.ftps.fact.pasvHint") }
  ], m = [
    {
      id: "filezilla",
      name: "FileZilla",
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.filezilla.s1"),
            t("conn.guide.ftps.filezilla.s2", { host: n, port: String(a) }),
            t("conn.guide.ftps.filezilla.s3", { user: i }),
            t("conn.guide.ftps.filezilla.s4")
          ]
        }
      ]
    },
    {
      id: "winscp",
      name: "WinSCP",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.winscp.s1"),
            t("conn.guide.ftps.winscp.s2", { host: n, port: String(a) }),
            t("conn.guide.ftps.winscp.s3", { user: i })
          ]
        }
      ]
    },
    {
      id: "curl",
      name: "curl",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.ftps.curl.caption"),
          code: [
            `curl --ssl-reqd --ftp-pasv --user ${i} \\`,
            `  -T ./report.pdf "ftp://${n}:${a}${l}/report.pdf"`,
            "",
            `curl --ssl-reqd --ftp-pasv --user ${i} \\`,
            `  -o ./report.pdf "ftp://${n}:${a}${l}/report.pdf"`
          ].join(`
`)
        },
        // ⚠ The flag that matters. Without it curl will happily fall back to
        // plaintext against a server that allows it — this one does not, but
        // the habit is what protects you against the ones that do.
        { kind: "note", text: t("conn.guide.ftps.curl.sslReqd") }
      ]
    },
    {
      id: "lftp",
      name: "lftp",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.lftprc",
          code: [
            "set ftp:ssl-force true",
            "set ftp:ssl-protect-data true",
            "set ftp:passive-mode true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.lftp.caption"),
          code: [
            `lftp -u ${i} ftp://${n}:${a}`,
            `# then: cd ${l}; put ./report.pdf; ls`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.ftps.lftp.protectData") }
      ]
    },
    {
      id: "rclone",
      name: "rclone",
      platform: "any",
      blocks: [
        {
          kind: "code",
          caption: "~/.config/rclone/rclone.conf",
          code: [
            "[filex-ftp]",
            "type = ftp",
            `host = ${n}`,
            `port = ${a}`,
            `user = ${i}`,
            '# rclone obscure "<your password>"',
            "pass = …",
            "explicit_tls = true"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.ftps.rclone.useCaption"),
          code: [
            "rclone lsd filex-ftp:",
            `rclone copy ./local filex-ftp:${l}/backup -P`
          ].join(`
`)
        }
      ]
    },
    {
      id: "printer",
      name: t("conn.guide.ftps.printer.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.ftps.printer.s1", { host: n, port: String(a) }),
            t("conn.guide.ftps.printer.s2", { user: i }),
            t("conn.guide.ftps.printer.s3", { path: l }),
            t("conn.guide.ftps.printer.s4")
          ]
        },
        // ⚠ The honest warning: plenty of scan-to-FTP firmware cannot do TLS
        // at all, and this endpoint will not talk to it. Saying so beats an
        // afternoon spent debugging a device that was never going to connect.
        { kind: "warn", text: t("conn.guide.ftps.printer.noTLS") }
      ]
    }
  ], v = [
    { kind: "warn", text: t("conn.guide.ftps.note.tls") },
    { kind: "note", text: t("conn.guide.ftps.note.passive") },
    { kind: "note", text: t("conn.guide.ftps.note.storages") },
    { kind: "note", text: t("conn.guide.ftps.note.trash") },
    { kind: "note", text: t("conn.guide.ftps.note.prefer") }
  ];
  return e.ftpsSelfSigned && v.push({ kind: "warn", text: t("conn.guide.ftps.note.selfSigned") }), e.ftpsEnabled === !1 && v.unshift({ kind: "warn", text: t("conn.guide.ftps.note.disabled") }), {
    id: "ftps",
    name: "FTPS",
    summary: t("conn.guide.ftps.summary"),
    facts: p,
    clients: m,
    notes: v
  };
}, sY = (e, t) => {
  const n = e.nfsHost || Xr(e.origin), a = e.nfsPort || 2049, i = e.nfsPath || t("conn.guide.nfs.pathPlaceholder"), r = e.nfsReadOnly ? ",ro" : "", l = `nfsvers=3,tcp,port=${a},mountport=${a},nolock${r}`, c = [
    { label: t("conn.guide.nfs.fact.host"), value: n, hint: t("conn.guide.nfs.fact.hostHint") },
    { label: t("conn.guide.nfs.fact.port"), value: String(a), hint: t("conn.guide.nfs.fact.portHint") },
    {
      label: t("conn.guide.nfs.fact.export"),
      value: i,
      hint: t("conn.guide.nfs.fact.exportHint"),
      // ⚠ Only real right after minting: the path is stored hashed and cannot
      // be shown again, and printing something path-shaped would produce a
      // mount line that fails with no clue why.
      placeholderOnly: !e.nfsPath
    },
    { label: t("conn.guide.nfs.fact.options"), value: l, hint: t("conn.guide.nfs.fact.optionsHint") }
  ], p = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.linux.mountCaption"),
          code: [
            "sudo mkdir -p /mnt/filex",
            `sudo mount -t nfs -o ${l} ${n}:${i} /mnt/filex`,
            "",
            "# and to unmount:",
            "sudo umount /mnt/filex"
          ].join(`
`)
        },
        {
          kind: "code",
          caption: "/etc/fstab",
          code: `${n}:${i}  /mnt/filex  nfs  ${l},_netdev,noauto,x-systemd.automount  0  0`
        },
        // ⚠ The warning that belongs next to the fstab line rather than in a
        // document: that file is world-readable on most systems.
        { kind: "warn", text: t("conn.guide.nfs.linux.fstabSecret") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.nfs.mac.mountCaption"),
          code: [
            "sudo mkdir -p /Volumes/filex",
            `sudo mount -t nfs -o vers=3,tcp,port=${a},mountport=${a},nolock${r},resvport ${n}:${i} /Volumes/filex`
          ].join(`
`)
        },
        { kind: "note", text: t("conn.guide.nfs.mac.resvport") }
      ]
    },
    {
      id: "windows",
      name: "Windows (Client for NFS)",
      platform: "windows",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.win.s1"),
            t("conn.guide.nfs.win.s2"),
            t("conn.guide.nfs.win.s3")
          ]
        },
        {
          kind: "code",
          caption: t("conn.guide.nfs.win.cmdCaption"),
          code: `mount -o anon nolock ${n}:${i} Z:`
        },
        // ⚠ Windows' client has no way to say "the mount service is on this
        // port", so it only works when filex is on 2049.
        { kind: "warn", text: t("conn.guide.nfs.win.port") }
      ]
    },
    {
      id: "synology",
      name: t("conn.guide.nfs.nas.tab"),
      platform: "any",
      blocks: [
        {
          kind: "steps",
          steps: [
            t("conn.guide.nfs.nas.s1", { host: n, port: String(a) }),
            t("conn.guide.nfs.nas.s2"),
            t("conn.guide.nfs.nas.s3")
          ]
        }
      ]
    }
  ], m = [
    { kind: "warn", text: t("conn.guide.nfs.note.unencrypted") },
    { kind: "warn", text: t("conn.guide.nfs.note.pathIsSecret") },
    { kind: "note", text: t("conn.guide.nfs.note.noPortmapper") },
    { kind: "note", text: t("conn.guide.nfs.note.uid") },
    { kind: "note", text: t("conn.guide.nfs.note.trash") },
    { kind: "note", text: t("conn.guide.nfs.note.revoke") }
  ];
  return e.nfsEnabled === !1 && m.unshift({ kind: "warn", text: t("conn.guide.nfs.note.disabled") }), {
    id: "nfs",
    name: "NFS",
    summary: t("conn.guide.nfs.summary"),
    facts: c,
    clients: p,
    notes: m
  };
}, lY = (e, t) => {
  const n = e.origin.replace(/\/+$/, ""), a = e.storage || e.storages[0] || "main", i = [
    { label: t("conn.guide.mount.fact.url"), value: n, hint: t("conn.guide.mount.fact.urlHint") },
    {
      label: t("conn.guide.mount.fact.token"),
      value: t("conn.guide.mount.fact.tokenPlaceholder"),
      hint: t("conn.guide.mount.fact.tokenHint"),
      // filex never has the plaintext of a token after it is minted, and a
      // fact row that looked like one would be a lie the user pastes.
      placeholderOnly: !0
    },
    { label: t("conn.guide.mount.fact.remote"), value: `${a}://`, hint: t("conn.guide.mount.fact.remoteHint") }
  ], r = [
    {
      id: "linux",
      name: "Linux",
      platform: "linux",
      blocks: [
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.mountCaption"),
          code: [
            `export FILEX_URL=${n}`,
            "export FILEX_TOKEN=<token>",
            "",
            "mkdir -p ~/filex",
            "filex mount ~/filex",
            "",
            "# one storage only, or a subfolder of it:",
            `filex mount --remote '${a}://' ~/filex`,
            `filex mount --remote '${a}://projects/acme' --read-only ~/acme`
          ].join(`
`)
        },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.umountCaption"),
          code: "fusermount -u ~/filex"
        },
        // ⚠ The one that costs an afternoon if it is not said: killing the
        // process leaves a directory where every `ls` hangs.
        { kind: "warn", text: t("conn.guide.mount.linux.umountWarn") },
        {
          kind: "code",
          caption: t("conn.guide.mount.linux.systemdCaption"),
          code: [
            "# ~/.config/systemd/user/filex-mount.service",
            "[Unit]",
            "Description=filex mount",
            "After=network-online.target",
            "",
            "[Service]",
            `Environment=FILEX_URL=${n}`,
            "Environment=FILEX_TOKEN=<token>",
            "ExecStart=%h/.local/bin/filex mount %h/filex",
            "ExecStop=/bin/fusermount -u %h/filex",
            "Restart=on-failure",
            "",
            "[Install]",
            "WantedBy=default.target"
          ].join(`
`)
        }
      ]
    },
    {
      id: "windows",
      name: "Windows",
      platform: "windows",
      blocks: [
        { kind: "note", text: t("conn.guide.mount.win.winfsp") },
        {
          kind: "code",
          caption: t("conn.guide.mount.win.mountCaption"),
          code: [
            `$env:FILEX_URL   = "${n}"`,
            '$env:FILEX_TOKEN = "<token>"',
            "",
            "filex mount Z:"
          ].join(`
`)
        },
        // ⚠ The drive letter is CREATED, not reused — pointing it at one that
        // already exists is the commonest way this fails, and the message the
        // driver gives for it says nothing useful.
        { kind: "warn", text: t("conn.guide.mount.win.freeLetter") },
        { kind: "note", text: t("conn.guide.mount.win.stop") }
      ]
    },
    {
      id: "macos",
      name: "macOS",
      platform: "macos",
      blocks: [
        // ⚠⚠ A refusal stated up front rather than discovered. macFUSE's Go
        // binding needs a C toolchain filex deliberately does not use, and its
        // licence forbids a commercial program from installing it. Pretending
        // otherwise would mean a command that appears to work and does nothing.
        { kind: "warn", text: t("conn.guide.mount.mac.unsupported") },
        { kind: "note", text: t("conn.guide.mount.mac.alternatives") }
      ]
    }
  ], l = [
    { kind: "note", text: t("conn.guide.mount.note.notASync") },
    { kind: "note", text: t("conn.guide.mount.note.reachable") },
    { kind: "note", text: t("conn.guide.mount.note.wholeFileWrites") },
    { kind: "note", text: t("conn.guide.mount.note.trash") },
    { kind: "note", text: t("conn.guide.mount.note.revoke") }
  ];
  return {
    id: "mount",
    name: "filex mount",
    summary: t("conn.guide.mount.summary"),
    facts: i,
    clients: r,
    notes: l
  };
}, tT = {
  webdav: aY,
  s3: iY,
  sftp: oY,
  ftps: rY,
  nfs: sY,
  mount: lY
}, uY = {
  webdav: "WebDAV",
  s3: "S3",
  sftp: "SFTP",
  ftps: "FTPS",
  nfs: "NFS",
  mount: "filex mount"
};
function cY(e) {
  return uY[e] || e.toUpperCase();
}
function dY() {
  return Object.keys(tT);
}
function fY(e, t, n) {
  const a = tT[e];
  return a ? a(t, n) : null;
}
const pY = { class: "fe-guide" }, hY = { class: "fe-guide__summary" }, mY = {
  class: "fe-guide__facts",
  "data-testid": "guide-facts"
}, vY = { class: "fe-guide__factlabel" }, yY = { class: "fe-guide__factvalue" }, gY = ["data-testid", "onClick"], bY = {
  key: 0,
  class: "fe-guide__facthint"
}, kY = {
  class: "fe-guide__tabs",
  role: "tablist"
}, wY = ["aria-selected", "data-testid", "onClick"], _Y = {
  key: 0,
  class: "fe-guide__body",
  role: "tabpanel"
}, xY = {
  key: 0,
  class: "fe-guide__steps"
}, SY = {
  key: 1,
  class: "fe-guide__codewrap"
}, $Y = { class: "fe-guide__codehead" }, TY = { class: "fe-guide__caption" }, AY = ["data-testid", "onClick"], EY = { class: "fe-guide__code" }, CY = {
  key: 2,
  class: "fe-guide__warn"
}, zY = {
  key: 3,
  class: "fe-guide__note"
}, MY = {
  key: 4,
  class: "fe-guide__text"
}, OY = {
  key: 1,
  class: "fe-guide__notes"
}, PY = { class: "fe-guide__notestitle" }, DY = /* @__PURE__ */ rt({
  __name: "ConnectionGuideView",
  props: {
    guide: {},
    locale: {}
  },
  setup(e) {
    var v;
    const t = e, { t: n } = ht(() => t.locale), a = S(((v = t.guide.clients[0]) == null ? void 0 : v.id) ?? ""), i = S(null);
    let r = null;
    const l = E(
      () => t.guide.clients.find((x) => x.id === a.value) ?? t.guide.clients[0]
    );
    async function c(x, k) {
      let _ = !1;
      try {
        await navigator.clipboard.writeText(x), _ = !0;
      } catch {
        try {
          const w = document.createElement("textarea");
          w.value = x, w.setAttribute("readonly", ""), w.style.position = "fixed", w.style.opacity = "0", document.body.appendChild(w), w.select(), _ = document.execCommand("copy"), document.body.removeChild(w);
        } catch {
          _ = !1;
        }
      }
      i.value = _ ? k : null, r && clearTimeout(r), r = setTimeout(() => {
        i.value = null;
      }, 1600);
    }
    function p(x, k) {
      return `${x}-${k}`;
    }
    function m(x) {
      return x.kind === "code";
    }
    return (x, k) => (f(), h("div", pY, [
      d("p", hY, y(e.guide.summary), 1),
      d("section", mY, [
        (f(!0), h(Ce, null, nt(e.guide.facts, (_, w) => (f(), h("div", {
          key: _.label,
          class: "fe-guide__fact"
        }, [
          d("span", vY, y(_.label), 1),
          d("span", yY, [
            d("code", {
              class: Ne({ "fe-guide__ph": _.placeholderOnly })
            }, y(_.value), 3),
            _.placeholderOnly ? D("", !0) : (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-guide__copy",
              "data-testid": `copy-fact-${w}`,
              onClick: (b) => c(_.value, p("fact", w))
            }, y(i.value === p("fact", w) ? u(n)("conn.guide.copied") : u(n)("conn.guide.copy")), 9, gY))
          ]),
          _.hint ? (f(), h("span", bY, y(_.hint), 1)) : D("", !0)
        ]))), 128))
      ]),
      d("nav", kY, [
        (f(!0), h(Ce, null, nt(e.guide.clients, (_) => (f(), h("button", {
          key: _.id,
          type: "button",
          role: "tab",
          class: Ne(["fe-guide__tab", { "is-active": l.value && _.id === l.value.id }]),
          "aria-selected": l.value && _.id === l.value.id,
          "data-testid": `guide-tab-${_.id}`,
          onClick: (w) => a.value = _.id
        }, y(_.name), 11, wY))), 128))
      ]),
      l.value ? (f(), h("div", _Y, [
        (f(!0), h(Ce, null, nt(l.value.blocks, (_, w) => (f(), h(Ce, { key: w }, [
          _.kind === "steps" ? (f(), h("ol", xY, [
            (f(!0), h(Ce, null, nt(_.steps ?? [], (b, C) => (f(), h("li", { key: C }, y(b), 1))), 128))
          ])) : m(_) ? (f(), h("div", SY, [
            d("div", $Y, [
              d("span", TY, y(_.caption), 1),
              d("button", {
                type: "button",
                class: "fe-guide__copy",
                "data-testid": `copy-code-${w}`,
                onClick: (b) => c(_.code ?? "", p(l.value.id, w))
              }, y(i.value === p(l.value.id, w) ? u(n)("conn.guide.copied") : u(n)("conn.guide.copy")), 9, AY)
            ]),
            d("pre", EY, [
              d("code", null, y(_.code), 1)
            ])
          ])) : _.kind === "warn" ? (f(), h("p", CY, y(_.text), 1)) : _.kind === "note" ? (f(), h("p", zY, y(_.text), 1)) : (f(), h("p", MY, y(_.text), 1))
        ], 64))), 128))
      ])) : D("", !0),
      e.guide.notes.length ? (f(), h("section", OY, [
        d("h4", PY, y(u(n)("conn.guide.goodToKnow")), 1),
        (f(!0), h(Ce, null, nt(e.guide.notes, (_, w) => (f(), h("p", {
          key: w,
          class: Ne(_.kind === "warn" ? "fe-guide__warn" : "fe-guide__note")
        }, y(_.text), 3))), 128))
      ])) : D("", !0)
    ]));
  }
});
function LY(e) {
  const t = zl(e), n = ba(e), a = (M) => `${n}${M}`, i = Ea([]), r = S(null), l = S(!1), c = S(!1), p = S(null), m = S(null), v = S(null), x = S(null);
  function k(M) {
    return m.value = (M == null ? void 0 : M.hint) ?? null, Za(M, e.locale);
  }
  function _(M) {
    return M == null ? void 0 : M.status;
  }
  async function w() {
    l.value = !0, p.value = null, m.value = null;
    try {
      const M = await t.jsonFetch(
        a("/api/auth/s3-keys")
      );
      i.value = Array.isArray(M == null ? void 0 : M.keys) ? M.keys : [], r.value = {
        endpoint: (M == null ? void 0 : M.endpoint) ?? "",
        enabled: (M == null ? void 0 : M.enabled) !== !1,
        path_style: (M == null ? void 0 : M.path_style) !== !1
      }, v.value = !0;
    } catch (M) {
      i.value = [];
      const L = _(M);
      L === 401 || L === 403 ? v.value = !1 : (v.value = !1, p.value = k(M));
    } finally {
      l.value = !1, c.value = !0;
    }
  }
  async function b(M) {
    p.value = null, m.value = null;
    try {
      const L = await t.jsonFetch(a("/api/auth/s3-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(M)
      });
      return x.value = L, L != null && L.endpoint && (r.value = {
        endpoint: L.endpoint,
        enabled: L.enabled !== !1,
        path_style: L.path_style !== !1
      }), await w(), L;
    } catch (L) {
      return p.value = k(L), null;
    }
  }
  async function C(M, L) {
    p.value = null, m.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/s3-keys/${M}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: L })
      }), await w();
    } catch (U) {
      p.value = k(U);
    }
  }
  async function A(M) {
    var L, U;
    p.value = null, m.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/s3-keys/${M}`), { method: "DELETE" }), ((U = (L = x.value) == null ? void 0 : L.key) == null ? void 0 : U.id) === M && (x.value = null), await w();
    } catch (P) {
      p.value = k(P);
    }
  }
  function T() {
    x.value = null;
  }
  const R = E(() => {
    var L;
    if ((L = x.value) != null && L.key) return x.value.key;
    const M = i.value.filter((U) => !U.disabled_at);
    return M.length ? M.reduce((U, P) => U.created_at >= P.created_at ? U : P) : null;
  });
  return {
    keys: i,
    connection: r,
    loading: l,
    loaded: c,
    error: p,
    errorHint: m,
    canMint: v,
    revealed: x,
    guideKey: R,
    load: w,
    create: b,
    setDisabled: C,
    remove: A,
    dismissSecret: T
  };
}
const RY = {
  class: "fe-s3keys",
  "data-testid": "s3-keys"
}, NY = { class: "fe-s3keys__head" }, IY = { class: "fe-s3keys__title" }, BY = { class: "fe-s3keys__lead" }, FY = {
  key: 0,
  class: "fe-s3keys__warn"
}, UY = {
  key: 1,
  class: "fe-s3keys__muted"
}, HY = {
  key: 2,
  class: "fe-s3keys__warn"
}, KY = {
  key: 3,
  class: "fe-s3keys__hint",
  "data-testid": "s3keys-admin-hint"
}, VY = {
  key: 4,
  class: "fe-s3keys__form"
}, jY = ["placeholder"], qY = ["placeholder", "disabled"], WY = ["disabled"], YY = {
  key: 5,
  class: "fe-s3keys__hint"
}, GY = {
  key: 6,
  class: "fe-s3keys__secret",
  "data-testid": "s3-key-secret"
}, XY = { class: "fe-s3keys__once" }, JY = { class: "fe-s3keys__pair" }, ZY = { class: "fe-s3keys__k" }, QY = { class: "fe-s3keys__pair" }, eG = { class: "fe-s3keys__k" }, tG = {
  key: 7,
  class: "fe-s3keys__muted"
}, nG = { class: "tbl-mono" }, aG = /* @__PURE__ */ rt({
  __name: "S3KeysPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Ca(n.config.locale)), { t: r, formatDate: l } = ht(i), {
      keys: c,
      connection: p,
      loading: m,
      error: v,
      errorHint: x,
      canMint: k,
      revealed: _,
      guideKey: w,
      load: b,
      create: C,
      setDisabled: A,
      remove: T,
      dismissSecret: R
    } = LY(n.config), M = S(""), L = S(""), U = E(() => [
      { value: "", label: r("conn.s3keys.everyBucket") },
      ...n.storages.map((te) => ({ value: te, label: te }))
    ]), P = S(""), H = S(!1), $ = S(null), F = S(null);
    let I = null;
    function Z() {
      var V, G, q, B, K;
      const te = p.value;
      te && a("active", {
        accessKeyID: ((V = w.value) == null ? void 0 : V.access_key_id) ?? "",
        // Only the freshly minted one. Re-emitting a stale secret would put a
        // dead credential into the commands.
        secret: ((q = (G = _.value) == null ? void 0 : G.key) == null ? void 0 : q.id) === ((B = w.value) == null ? void 0 : B.id) ? (K = _.value) == null ? void 0 : K.secret : void 0,
        endpoint: te.endpoint,
        pathStyle: te.path_style
      });
    }
    qt(async () => {
      await b(), Z();
    });
    async function J() {
      H.value = !0;
      try {
        await C({
          label: M.value.trim() || r("conn.s3keys.defaultLabel"),
          bucket: L.value.trim() || void 0,
          prefix: P.value.trim() || void 0
        }), M.value = "", Z();
      } finally {
        H.value = !1;
      }
    }
    function re(te) {
      return [
        {
          key: "toggle",
          label: te.disabled_at ? r("conn.s3keys.enable") : r("conn.s3keys.disable"),
          icon: te.disabled_at ? "check" : "lock",
          disabled: H.value
        },
        {
          key: "revoke",
          label: $.value === te.id ? r("conn.s3keys.confirm") : r("conn.s3keys.revoke"),
          icon: "delete",
          danger: !0,
          disabled: H.value
        }
      ];
    }
    const ve = E(() => [
      {
        id: "label",
        label: r("conn.s3keys.col.label"),
        sortable: !0,
        width: 180,
        format: (te) => te.label || r("conn.s3keys.noLabel")
      },
      {
        id: "key",
        label: r("conn.s3keys.col.key"),
        sortable: !0,
        width: 200,
        sortValue: (te) => te.access_key_id,
        title: (te) => te.access_key_id
      },
      { id: "scope", label: r("conn.s3keys.col.scope"), sortable: !0, width: 160, format: X },
      {
        id: "lastUsed",
        label: r("conn.s3keys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (te) => te.last_used_at ? j(te.last_used_at) : r("conn.s3keys.neverUsed"),
        sortValue: (te) => te.last_used_at ? new Date(te.last_used_at).getTime() : null
      }
    ]);
    function W(te, V) {
      te === "toggle" ? z(V) : te === "revoke" && le(V);
    }
    async function z(te) {
      H.value = !0;
      try {
        await A(te.id, !te.disabled_at), Z();
      } finally {
        H.value = !1;
      }
    }
    async function le(te) {
      if ($.value !== te.id) {
        $.value = te.id;
        return;
      }
      $.value = null, H.value = !0;
      try {
        await T(te.id), Z();
      } finally {
        H.value = !1;
      }
    }
    async function fe(te, V) {
      let G = !1;
      try {
        await navigator.clipboard.writeText(te), G = !0;
      } catch {
        try {
          const q = document.createElement("textarea");
          q.value = te, q.setAttribute("readonly", ""), q.style.position = "fixed", q.style.opacity = "0", document.body.appendChild(q), q.select(), G = document.execCommand("copy"), document.body.removeChild(q);
        } catch {
          G = !1;
        }
      }
      G && (F.value = V, I && clearTimeout(I), I = setTimeout(() => F.value = null, 1600));
    }
    function j(te) {
      const V = new Date(te ?? "").getTime();
      return Number.isNaN(V) ? "" : l(V);
    }
    function X(te) {
      return te.bucket ? te.prefix ? `${te.bucket}/${te.prefix}` : te.bucket : r("conn.s3keys.scopeAll");
    }
    return (te, V) => (f(), h("section", RY, [
      d("header", NY, [
        d("h4", IY, y(u(r)("conn.s3keys.title")), 1),
        d("p", BY, y(u(r)("conn.s3keys.lead")), 1)
      ]),
      u(p) && !u(p).enabled ? (f(), h("p", FY, y(u(r)("conn.s3keys.disabled")), 1)) : D("", !0),
      u(k) === !1 ? (f(), h("p", UY, y(u(r)("conn.s3keys.cannotMint")), 1)) : D("", !0),
      u(v) ? (f(), h("p", HY, y(u(v)), 1)) : D("", !0),
      u(v) && u(x) ? (f(), h("p", KY, y(u(x)), 1)) : D("", !0),
      u(k) ? (f(), h("div", VY, [
        cn(d("input", {
          "onUpdate:modelValue": V[0] || (V[0] = (G) => M.value = G),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.s3keys.label"),
          "data-testid": "s3-key-label"
        }, null, 8, jY), [
          [xn, M.value]
        ]),
        Je(fc, {
          "model-value": L.value,
          options: U.value,
          "aria-label": u(r)("conn.s3keys.col.scope"),
          testid: "s3-key-bucket",
          "onUpdate:modelValue": V[1] || (V[1] = (G) => L.value = String(G))
        }, null, 8, ["model-value", "options", "aria-label"]),
        cn(d("input", {
          "onUpdate:modelValue": V[2] || (V[2] = (G) => P.value = G),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.s3keys.prefix"),
          disabled: !L.value,
          "data-testid": "s3-key-prefix"
        }, null, 8, qY), [
          [xn, P.value]
        ]),
        d("button", {
          class: "fe-s3keys__btn",
          disabled: H.value,
          "data-testid": "s3-key-mint",
          onClick: J
        }, y(u(r)("conn.s3keys.mint")), 9, WY)
      ])) : D("", !0),
      u(k) ? (f(), h("p", YY, y(u(r)("conn.s3keys.inheritNote")), 1)) : D("", !0),
      u(_) ? (f(), h("div", GY, [
        d("p", XY, y(u(r)("conn.s3keys.once")), 1),
        d("div", JY, [
          d("span", ZY, y(u(r)("conn.s3keys.accessKeyID")), 1),
          d("code", null, y(u(_).key.access_key_id), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: V[3] || (V[3] = (G) => fe(u(_).key.access_key_id, "akid"))
          }, y(F.value === "akid" ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        d("div", QY, [
          d("span", eG, y(u(r)("conn.s3keys.secret")), 1),
          d("code", null, y(u(_).secret), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: V[4] || (V[4] = (G) => fe(u(_).secret, "secret"))
          }, y(F.value === "secret" ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__dismiss",
          onClick: V[5] || (V[5] = //@ts-ignore
          (...G) => u(R) && u(R)(...G))
        }, y(u(r)("conn.s3keys.dismiss")), 1)
      ])) : D("", !0),
      u(m) ? (f(), h("p", tG, "…")) : (f(), We(es, {
        key: 8,
        "table-id": "conn.s3keys",
        columns: ve.value,
        rows: u(c),
        "row-key": "id",
        locale: i.value,
        empty: u(r)("conn.s3keys.empty"),
        "row-class": (G) => G.disabled_at ? "is-muted" : void 0,
        "row-actions": re,
        "row-actions-test-id": (G) => `s3-key-actions-${G.id}`,
        onRowAction: V[6] || (V[6] = (G, q) => W(G, q))
      }, {
        "cell-key": mt(({ row: G }) => [
          d("code", nG, y(G.access_key_id), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function iG(e) {
  const t = zl(e), n = ba(e), a = (A) => `${n}${A}`, i = Ea([]), r = S(null), l = S(!1), c = S(!1), p = S(null), m = S(null);
  function v(A) {
    return Za(A, e.locale);
  }
  function x(A) {
    return A == null ? void 0 : A.status;
  }
  async function k() {
    l.value = !0, p.value = null;
    try {
      const A = await t.jsonFetch(
        a("/api/auth/ssh-keys")
      );
      i.value = Array.isArray(A == null ? void 0 : A.keys) ? A.keys : [], r.value = {
        enabled: (A == null ? void 0 : A.enabled) !== !1,
        host: (A == null ? void 0 : A.host) ?? "",
        port: (A == null ? void 0 : A.port) ?? 2022,
        login: (A == null ? void 0 : A.login) ?? "",
        ftps: A == null ? void 0 : A.ftps
      }, m.value = !0;
    } catch (A) {
      i.value = [], m.value = !1, x(A) !== 401 && x(A) !== 403 && (p.value = v(A));
    } finally {
      l.value = !1, c.value = !0;
    }
  }
  async function _(A, T) {
    p.value = null;
    try {
      return await t.jsonFetch(a("/api/auth/ssh-keys"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ key: A, name: T })
      }), await k(), !0;
    } catch (R) {
      return p.value = v(R), !1;
    }
  }
  async function w(A, T) {
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/ssh-keys/${A}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: T })
      }), await k();
    } catch (R) {
      p.value = v(R);
    }
  }
  async function b(A) {
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/ssh-keys/${A}`), { method: "DELETE" }), await k();
    } catch (T) {
      p.value = v(T);
    }
  }
  const C = E(() => i.value.some((A) => !A.disabled_at));
  return { keys: i, connection: r, loading: l, loaded: c, error: p, canAdd: m, hasUsableKey: C, load: k, add: _, setDisabled: w, remove: b };
}
const oG = {
  key: 0,
  class: "fe-s3keys",
  "data-testid": "ssh-keys"
}, rG = { class: "fe-s3keys__head" }, sG = { class: "fe-s3keys__title" }, lG = { class: "fe-s3keys__lead" }, uG = {
  key: 0,
  class: "fe-s3keys__warn"
}, cG = {
  key: 1,
  class: "fe-s3keys__muted"
}, dG = {
  key: 2,
  class: "fe-s3keys__warn"
}, fG = {
  key: 3,
  class: "fe-sshkeys__form"
}, pG = ["placeholder"], hG = { class: "fe-sshkeys__row" }, mG = ["placeholder"], vG = ["disabled"], yG = { class: "fe-s3keys__hint" }, gG = {
  key: 4,
  class: "fe-s3keys__muted"
}, bG = { class: "tbl-mono" }, kG = /* @__PURE__ */ rt({
  __name: "SSHKeysPanel",
  props: {
    config: {},
    keysVisible: { type: Boolean }
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = E(() => n.keysVisible !== !1), i = t, r = E(() => Ca(n.config.locale)), { t: l, formatDate: c } = ht(r), { keys: p, connection: m, loading: v, error: x, canAdd: k, hasUsableKey: _, load: w, add: b, setDisabled: C, remove: A } = iG(n.config), T = S(""), R = S(""), M = S(!1), L = S(null);
    function U() {
      const ve = m.value;
      ve && i("active", {
        host: ve.host,
        port: ve.port,
        login: ve.login,
        enabled: ve.enabled,
        hasKey: _.value,
        // The FTPS endpoint travels with the SSH facts: for the user this is one
        // question ("how do I reach this from a program?"), and two calls to
        // answer it would be two chances to disagree.
        ftps: ve.ftps
      });
    }
    qt(async () => {
      await w(), U();
    });
    async function P() {
      if (T.value.trim()) {
        M.value = !0;
        try {
          await b(T.value.trim(), R.value.trim() || void 0) && (T.value = "", R.value = ""), U();
        } finally {
          M.value = !1;
        }
      }
    }
    function H(ve) {
      return [
        {
          key: "toggle",
          label: ve.disabled_at ? l("conn.sshkeys.enable") : l("conn.sshkeys.disable"),
          icon: ve.disabled_at ? "check" : "lock",
          disabled: M.value
        },
        {
          key: "remove",
          label: L.value === ve.id ? l("conn.sshkeys.confirm") : l("conn.sshkeys.remove"),
          icon: "delete",
          danger: !0,
          disabled: M.value
        }
      ];
    }
    const $ = E(() => [
      {
        id: "name",
        label: l("conn.sshkeys.col.name"),
        sortable: !0,
        width: 180,
        format: (ve) => ve.name || l("conn.sshkeys.noName")
      },
      {
        id: "fingerprint",
        label: l("conn.sshkeys.col.fingerprint"),
        sortable: !0,
        width: 240,
        sortValue: (ve) => re(ve),
        title: (ve) => re(ve)
      },
      {
        id: "lastUsed",
        label: l("conn.sshkeys.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (ve) => ve.last_used_at ? J(ve.last_used_at) : l("conn.sshkeys.neverUsed"),
        sortValue: (ve) => ve.last_used_at ? new Date(ve.last_used_at).getTime() : null
      }
    ]);
    function F(ve, W) {
      ve === "toggle" ? I(W) : ve === "remove" && Z(W);
    }
    async function I(ve) {
      M.value = !0;
      try {
        await C(ve.id, !ve.disabled_at), U();
      } finally {
        M.value = !1;
      }
    }
    async function Z(ve) {
      if (L.value !== ve.id) {
        L.value = ve.id;
        return;
      }
      L.value = null, M.value = !0;
      try {
        await A(ve.id), U();
      } finally {
        M.value = !1;
      }
    }
    function J(ve) {
      const W = new Date(ve ?? "").getTime();
      return Number.isNaN(W) ? "" : c(W);
    }
    function re(ve) {
      return "SHA256:" + ve.fingerprint;
    }
    return (ve, W) => a.value ? (f(), h("section", oG, [
      d("header", rG, [
        d("h4", sG, y(u(l)("conn.sshkeys.title")), 1),
        d("p", lG, y(u(l)("conn.sshkeys.lead")), 1)
      ]),
      u(m) && !u(m).enabled ? (f(), h("p", uG, y(u(l)("conn.sshkeys.disabled")), 1)) : D("", !0),
      u(k) === !1 ? (f(), h("p", cG, y(u(l)("conn.sshkeys.cannotAdd")), 1)) : D("", !0),
      u(x) ? (f(), h("p", dG, y(u(x)), 1)) : D("", !0),
      u(k) ? (f(), h("div", fG, [
        cn(d("textarea", {
          "onUpdate:modelValue": W[0] || (W[0] = (z) => T.value = z),
          class: "fe-cfield__input fe-sshkeys__paste",
          rows: "2",
          spellcheck: "false",
          placeholder: u(l)("conn.sshkeys.paste"),
          "data-testid": "ssh-key-input"
        }, null, 8, pG), [
          [xn, T.value]
        ]),
        d("div", hG, [
          cn(d("input", {
            "onUpdate:modelValue": W[1] || (W[1] = (z) => R.value = z),
            class: "fe-cfield__input",
            placeholder: u(l)("conn.sshkeys.name"),
            "data-testid": "ssh-key-name"
          }, null, 8, mG), [
            [xn, R.value]
          ]),
          d("button", {
            class: "fe-s3keys__btn",
            disabled: M.value,
            "data-testid": "ssh-key-add",
            onClick: P
          }, y(u(l)("conn.sshkeys.add")), 9, vG)
        ]),
        d("p", yG, y(u(l)("conn.sshkeys.noCopyId")), 1)
      ])) : D("", !0),
      u(v) ? (f(), h("p", gG, "…")) : (f(), We(es, {
        key: 5,
        "table-id": "conn.sshkeys",
        columns: $.value,
        rows: u(p),
        "row-key": "id",
        locale: r.value,
        empty: u(l)("conn.sshkeys.empty"),
        "row-class": (z) => z.disabled_at ? "is-muted" : void 0,
        "row-actions": H,
        "row-actions-test-id": (z) => `ssh-key-actions-${z.id}`,
        onRowAction: W[2] || (W[2] = (z, le) => F(z, le))
      }, {
        "cell-fingerprint": mt(({ row: z }) => [
          d("code", bG, y(re(z)), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ])) : D("", !0);
  }
});
function wG(e) {
  const t = zl(e), n = ba(e), a = (R) => `${n}${R}`, i = Ea([]), r = S(null), l = S(!1), c = S(!1), p = S(null), m = S(null), v = S(null);
  function x(R) {
    return Za(R, e.locale);
  }
  function k(R) {
    return R == null ? void 0 : R.status;
  }
  async function _() {
    l.value = !0, p.value = null;
    try {
      const R = await t.jsonFetch(
        a("/api/auth/nfs-exports")
      );
      i.value = Array.isArray(R == null ? void 0 : R.exports) ? R.exports : [], r.value = {
        enabled: (R == null ? void 0 : R.enabled) !== !1,
        host: (R == null ? void 0 : R.host) ?? "",
        port: (R == null ? void 0 : R.port) ?? 2049
      }, m.value = !0;
    } catch (R) {
      i.value = [], m.value = !1, k(R) !== 401 && k(R) !== 403 && (p.value = x(R));
    } finally {
      l.value = !1, c.value = !0;
    }
  }
  async function w(R) {
    p.value = null;
    try {
      const M = await t.jsonFetch(a("/api/auth/nfs-exports"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(R)
      });
      return v.value = M, M != null && M.host && (r.value = { enabled: M.enabled !== !1, host: M.host, port: M.port }), await _(), M;
    } catch (M) {
      return p.value = x(M), null;
    }
  }
  async function b(R, M) {
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/nfs-exports/${R}/state`), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ disabled: M })
      }), await _();
    } catch (L) {
      p.value = x(L);
    }
  }
  async function C(R) {
    var M, L;
    p.value = null;
    try {
      await t.jsonFetch(a(`/api/auth/nfs-exports/${R}`), { method: "DELETE" }), ((L = (M = v.value) == null ? void 0 : M.export) == null ? void 0 : L.id) === R && (v.value = null), await _();
    } catch (U) {
      p.value = x(U);
    }
  }
  function A() {
    v.value = null;
  }
  const T = E(() => {
    var M;
    if ((M = v.value) != null && M.export) return v.value.export;
    const R = i.value.filter((L) => !L.disabled_at);
    return R.length ? R.reduce((L, U) => L.created_at >= U.created_at ? L : U) : null;
  });
  return {
    exports: i,
    connection: r,
    loading: l,
    loaded: c,
    error: p,
    canMint: m,
    revealed: v,
    guideExport: T,
    load: _,
    create: w,
    setDisabled: b,
    remove: C,
    dismissPath: A
  };
}
const _G = {
  class: "fe-s3keys",
  "data-testid": "nfs-exports"
}, xG = { class: "fe-s3keys__head" }, SG = { class: "fe-s3keys__title" }, $G = { class: "fe-s3keys__lead" }, TG = { class: "fe-s3keys__warn" }, AG = {
  key: 0,
  class: "fe-s3keys__warn"
}, EG = {
  key: 1,
  class: "fe-s3keys__muted"
}, CG = {
  key: 2,
  class: "fe-s3keys__warn"
}, zG = {
  key: 3,
  class: "fe-s3keys__form fe-nfs__form"
}, MG = ["placeholder"], OG = ["placeholder", "disabled"], PG = ["placeholder"], DG = { class: "fe-nfs__ro" }, LG = ["disabled"], RG = {
  key: 4,
  class: "fe-s3keys__hint"
}, NG = {
  key: 5,
  class: "fe-s3keys__secret",
  "data-testid": "nfs-path"
}, IG = { class: "fe-s3keys__once" }, BG = { class: "fe-s3keys__pair" }, FG = {
  key: 6,
  class: "fe-s3keys__muted"
}, UG = /* @__PURE__ */ rt({
  __name: "NFSExportsPanel",
  props: {
    config: {},
    storages: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Ca(n.config.locale)), { t: r, formatDate: l } = ht(i), {
      exports: c,
      connection: p,
      loading: m,
      error: v,
      canMint: x,
      revealed: k,
      guideExport: _,
      load: w,
      create: b,
      setDisabled: C,
      remove: A,
      dismissPath: T
    } = wG(n.config), R = S(""), M = S(""), L = E(() => [
      { value: "", label: r("conn.nfs.everyStorage") },
      ...n.storages.map((G) => ({ value: G, label: G }))
    ]), U = S(""), P = S(!0), H = S(""), $ = S(!1), F = S(null), I = S(!1);
    let Z = null;
    function J() {
      var q, B;
      const G = p.value;
      G && a("active", {
        host: G.host,
        port: G.port,
        enabled: G.enabled,
        // Only the freshly minted path — the stored ones cannot be recovered, and
        // printing a placeholder in a mount line somebody copies would produce a
        // command that fails with no clue why.
        path: (q = k.value) == null ? void 0 : q.path,
        readOnly: ((B = _.value) == null ? void 0 : B.read_only) ?? P.value
      });
    }
    qt(async () => {
      await w(), J();
    });
    async function re() {
      $.value = !0;
      try {
        await b({
          label: R.value.trim() || r("conn.nfs.defaultLabel"),
          storage: M.value.trim() || void 0,
          prefix: U.value.trim() || void 0,
          read_only: P.value,
          allow_cidrs: H.value.trim() || void 0
        }), R.value = "", J();
      } finally {
        $.value = !1;
      }
    }
    function ve(G) {
      return [
        {
          key: "toggle",
          label: G.disabled_at ? r("conn.nfs.enable") : r("conn.nfs.disable"),
          icon: G.disabled_at ? "check" : "lock",
          disabled: $.value
        },
        {
          key: "revoke",
          label: F.value === G.id ? r("conn.nfs.confirm") : r("conn.nfs.revoke"),
          icon: "delete",
          danger: !0,
          disabled: $.value
        }
      ];
    }
    const W = E(() => [
      {
        id: "label",
        label: r("conn.nfs.col.label"),
        sortable: !0,
        width: 180,
        format: (G) => G.label || r("conn.nfs.noLabel")
      },
      { id: "scope", label: r("conn.nfs.col.scope"), sortable: !0, width: 180, format: V },
      {
        id: "mode",
        label: r("conn.nfs.col.mode"),
        sortable: !0,
        width: 120,
        format: (G) => G.read_only ? r("conn.nfs.modeRead") : r("conn.nfs.modeWrite")
      },
      {
        id: "lastUsed",
        label: r("conn.nfs.col.lastUsed"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: (G) => G.last_used_at ? te(G.last_used_at) : r("conn.nfs.neverUsed"),
        sortValue: (G) => G.last_used_at ? new Date(G.last_used_at).getTime() : null
      }
    ]);
    function z(G, q) {
      G === "toggle" ? le(q) : G === "revoke" && fe(q);
    }
    async function le(G) {
      $.value = !0;
      try {
        await C(G.id, !G.disabled_at), J();
      } finally {
        $.value = !1;
      }
    }
    async function fe(G) {
      if (F.value !== G.id) {
        F.value = G.id;
        return;
      }
      F.value = null, $.value = !0;
      try {
        await A(G.id), J();
      } finally {
        $.value = !1;
      }
    }
    const j = E(() => {
      var K, ke, Ye;
      const G = p.value, q = (K = k.value) == null ? void 0 : K.path;
      if (!G || !q) return "";
      const B = (Ye = (ke = k.value) == null ? void 0 : ke.export) != null && Ye.read_only ? ",ro" : "";
      return `sudo mount -t nfs -o nfsvers=3,tcp,port=${G.port},mountport=${G.port},nolock${B} ${G.host}:${q} /mnt/filex`;
    });
    async function X() {
      const G = j.value;
      if (!G) return;
      let q = !1;
      try {
        await navigator.clipboard.writeText(G), q = !0;
      } catch {
        try {
          const B = document.createElement("textarea");
          B.value = G, B.setAttribute("readonly", ""), B.style.position = "fixed", B.style.opacity = "0", document.body.appendChild(B), B.select(), q = document.execCommand("copy"), document.body.removeChild(B);
        } catch {
          q = !1;
        }
      }
      q && (I.value = !0, Z && clearTimeout(Z), Z = setTimeout(() => I.value = !1, 1600));
    }
    function te(G) {
      const q = new Date(G ?? "").getTime();
      return Number.isNaN(q) ? "" : l(q);
    }
    function V(G) {
      return G.storage_name ? G.prefix ? `${G.storage_name}/${G.prefix}` : G.storage_name : r("conn.nfs.scopeAll");
    }
    return (G, q) => (f(), h("section", _G, [
      d("header", xG, [
        d("h4", SG, y(u(r)("conn.nfs.title")), 1),
        d("p", $G, y(u(r)("conn.nfs.lead")), 1)
      ]),
      d("p", TG, y(u(r)("conn.nfs.pathIsSecret")), 1),
      u(p) && !u(p).enabled ? (f(), h("p", AG, y(u(r)("conn.nfs.disabled")), 1)) : D("", !0),
      u(x) === !1 ? (f(), h("p", EG, y(u(r)("conn.nfs.cannotMint")), 1)) : D("", !0),
      u(v) ? (f(), h("p", CG, y(u(v)), 1)) : D("", !0),
      u(x) ? (f(), h("div", zG, [
        cn(d("input", {
          "onUpdate:modelValue": q[0] || (q[0] = (B) => R.value = B),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.nfs.label"),
          "data-testid": "nfs-label"
        }, null, 8, MG), [
          [xn, R.value]
        ]),
        Je(fc, {
          "model-value": M.value,
          options: L.value,
          "aria-label": u(r)("conn.nfs.col.scope"),
          testid: "nfs-storage",
          "onUpdate:modelValue": q[1] || (q[1] = (B) => M.value = String(B))
        }, null, 8, ["model-value", "options", "aria-label"]),
        cn(d("input", {
          "onUpdate:modelValue": q[2] || (q[2] = (B) => U.value = B),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.nfs.prefix"),
          disabled: !M.value,
          "data-testid": "nfs-prefix"
        }, null, 8, OG), [
          [xn, U.value]
        ]),
        cn(d("input", {
          "onUpdate:modelValue": q[3] || (q[3] = (B) => H.value = B),
          class: "fe-cfield__input",
          placeholder: u(r)("conn.nfs.allowCidrs"),
          "data-testid": "nfs-cidrs"
        }, null, 8, PG), [
          [xn, H.value]
        ]),
        d("label", DG, [
          cn(d("input", {
            type: "checkbox",
            "onUpdate:modelValue": q[4] || (q[4] = (B) => P.value = B),
            "data-testid": "nfs-readonly"
          }, null, 512), [
            [wc, P.value]
          ]),
          Vt(" " + y(u(r)("conn.nfs.readOnly")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__btn",
          disabled: $.value,
          "data-testid": "nfs-mint",
          onClick: re
        }, y(u(r)("conn.nfs.mint")), 9, LG)
      ])) : D("", !0),
      u(x) ? (f(), h("p", RG, y(u(r)("conn.nfs.readOnlyHint")), 1)) : D("", !0),
      u(k) ? (f(), h("div", NG, [
        d("p", IG, y(u(r)("conn.nfs.once")), 1),
        d("div", BG, [
          d("code", null, y(j.value), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: X
          }, y(I.value ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__dismiss",
          onClick: q[5] || (q[5] = //@ts-ignore
          (...B) => u(T) && u(T)(...B))
        }, y(u(r)("conn.nfs.dismiss")), 1)
      ])) : D("", !0),
      u(m) ? (f(), h("p", FG, "…")) : (f(), We(es, {
        key: 7,
        "table-id": "conn.nfs",
        columns: W.value,
        rows: u(c),
        "row-key": "id",
        locale: i.value,
        empty: u(r)("conn.nfs.empty"),
        "row-class": (B) => B.disabled_at ? "is-muted" : void 0,
        "row-actions": ve,
        "row-actions-test-id": (B) => `nfs-export-actions-${B.id}`,
        onRowAction: q[6] || (q[6] = (B, K) => z(B, K))
      }, null, 8, ["columns", "rows", "locale", "empty", "row-class", "row-actions-test-id"]))
    ]));
  }
});
function HG(e) {
  const t = zl(e), n = ba(e), a = (A) => `${n}${A}`, i = Ea([]), r = S(!1), l = S(!1), c = S(null), p = S(null), m = S(null);
  function v(A) {
    return Za(A, e.locale);
  }
  function x(A) {
    return A == null ? void 0 : A.status;
  }
  async function k() {
    r.value = !0, c.value = null;
    try {
      const A = await t.jsonFetch(a("/api/tokens"));
      i.value = Array.isArray(A == null ? void 0 : A.tokens) ? A.tokens : [], p.value = !0;
    } catch (A) {
      i.value = [];
      const T = x(A);
      p.value = !1, T !== 401 && T !== 403 && (c.value = v(A));
    } finally {
      r.value = !1, l.value = !0;
    }
  }
  async function _(A) {
    c.value = null;
    try {
      const T = await t.jsonFetch(a("/api/tokens"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(A)
      });
      return m.value = T, await k(), T;
    } catch (T) {
      return c.value = v(T), null;
    }
  }
  async function w(A) {
    var T, R;
    c.value = null;
    try {
      await t.jsonFetch(a(`/api/tokens/${A}`), { method: "DELETE" }), ((R = (T = m.value) == null ? void 0 : T.row) == null ? void 0 : R.id) === A && (m.value = null), await k();
    } catch (M) {
      c.value = v(M);
    }
  }
  async function b(A, T) {
    c.value = null;
    try {
      return await t.jsonFetch(a(`/api/tokens/${A}`), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ permissions: T })
      }), await k(), !0;
    } catch (R) {
      return c.value = v(R), !1;
    }
  }
  function C() {
    m.value = null;
  }
  return { tokens: i, loading: r, loaded: l, error: c, canMint: p, revealed: m, load: k, create: _, remove: w, setPermissions: b, dismiss: C };
}
const KG = {
  class: "fe-s3keys",
  "data-testid": "api-tokens"
}, VG = { class: "fe-s3keys__head" }, jG = { class: "fe-s3keys__title" }, qG = { class: "fe-s3keys__lead" }, WG = {
  key: 0,
  class: "fe-s3keys__muted"
}, YG = {
  key: 1,
  class: "fe-s3keys__warn"
}, GG = {
  key: 2,
  class: "fe-s3keys__form"
}, XG = ["placeholder"], JG = ["disabled"], ZG = {
  key: 3,
  class: "fe-tokform",
  "data-testid": "token-form-full"
}, QG = ["placeholder"], eX = { class: "fe-tokform__scopes" }, tX = { class: "fe-tokform__legend" }, nX = ["onUpdate:modelValue", "data-testid"], aX = {
  key: 0,
  class: "fe-s3keys__hint fe-tokform__required",
  role: "alert",
  "data-testid": "token-scopes-required"
}, iX = { class: "fe-tokform__field" }, oX = {
  id: "token-comments-label",
  class: "fe-tokform__label"
}, rX = { class: "fe-s3keys__hint" }, sX = { class: "fe-tokform__field" }, lX = { class: "fe-tokform__label" }, uX = ["placeholder"], cX = { class: "fe-tokform__row" }, dX = { class: "fe-tokform__field fe-tokform__field--narrow" }, fX = { class: "fe-tokform__label" }, pX = ["placeholder"], hX = ["disabled"], mX = { class: "fe-s3keys__hint" }, vX = {
  key: 4,
  class: "fe-s3keys__secret",
  "data-testid": "token-secret"
}, yX = { class: "fe-s3keys__once" }, gX = { class: "fe-s3keys__pair" }, bX = {
  key: 5,
  class: "fe-s3keys__muted"
}, kX = { class: "tbl-mono" }, wX = {
  key: 7,
  class: "fe-s3keys__hint"
}, nT = /* @__PURE__ */ rt({
  __name: "TokensPanel",
  props: {
    config: {},
    full: { type: Boolean },
    protocol: {},
    host: {}
  },
  emits: ["active"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Ca(n.config.locale)), { t: r, formatDate: l } = ht(i), { tokens: c, loading: p, error: m, canMint: v, revealed: x, load: k, create: _, remove: w, setPermissions: b, dismiss: C } = HG(
      n.config
    ), A = S(""), T = S(!1), R = S(!1), M = S(null), L = ["read", "write", "delete", "mcp"], U = S({
      read: !0,
      write: !1,
      delete: !1,
      mcp: !1
    }), P = S(""), H = S(null), $ = S("read"), F = E(() => [
      { value: "read", label: r("conn.tokens.commentsRead") },
      { value: "rw", label: r("conn.tokens.commentsRw") }
    ]);
    function I(q) {
      var B;
      return ((B = q.permissions) == null ? void 0 : B.comments) === "rw" ? r("conn.tokens.commentsRw") : r("conn.tokens.commentsRead");
    }
    const Z = E(() => !L.some((q) => U.value[q]));
    function J() {
      const q = L.filter((K) => U.value[K]), B = P.value.trim();
      return B && q.push("root:" + B), $.value === "rw" && q.push("comments:rw"), q.join(",");
    }
    qt(async () => {
      await k(), a("active", { hasToken: c.value.length > 0 });
    });
    function re() {
      const q = (n.protocol || "").toUpperCase();
      return q ? n.host ? `${q} - ${n.host}` : q : r("conn.tokens.defaultName", { date: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10) });
    }
    function ve() {
      return n.protocol ? re() : r("conn.tokens.namePlaceholder");
    }
    async function W() {
      if (!T.value) {
        T.value = !0, R.value = !1;
        try {
          if (n.full) {
            if (Z.value) return;
            const q = J();
            await _({
              label: A.value.trim() || re(),
              scopes: q,
              expires_in_days: H.value && H.value > 0 ? H.value : void 0
            }), await k(), a("active", { hasToken: c.value.length > 0 }), A.value = "", P.value = "", $.value = "read";
            return;
          }
          await _({ label: A.value.trim() || re(), scopes: "read,write,delete" }), await k(), a("active", { hasToken: c.value.length > 0 }), A.value = "";
        } finally {
          T.value = !1;
        }
      }
    }
    const z = E(() => [
      {
        id: "label",
        label: r("conn.tokens.col.label"),
        sortable: !0,
        width: 200,
        format: (q) => q.label || "-"
      },
      { id: "scopes", label: r("conn.tokens.col.scopes"), sortable: !0, width: 200 },
      {
        id: "comments",
        label: r("conn.tokens.col.comments"),
        sortable: !0,
        width: 140,
        format: I
      },
      {
        id: "used",
        label: r("conn.tokens.col.used"),
        sortable: !0,
        sortDir: "desc",
        width: 140,
        format: G,
        sortValue: (q) => q.last_used_at ? new Date(q.last_used_at).getTime() : null
      }
    ]);
    function le(q) {
      var K;
      const B = ((K = q.permissions) == null ? void 0 : K.comments) === "rw";
      return [
        {
          key: "comments",
          label: r(B ? "conn.tokens.commentsToRead" : "conn.tokens.commentsToRw"),
          icon: "rename",
          disabled: T.value
        },
        {
          key: "revoke",
          label: M.value === q.id ? r("conn.tokens.confirm") : r("conn.tokens.revoke"),
          icon: "delete",
          danger: !0,
          /* The whole control used to be `:disabled="busy"`; the table draws the
             control, so the verb carries it — RowActions greys a button with
             nothing usable behind it. */
          disabled: T.value
        }
      ];
    }
    function fe(q, B) {
      q === "revoke" ? X(B) : q === "comments" && j(B);
    }
    async function j(q) {
      var B;
      T.value = !0;
      try {
        await b(q.id, { comments: ((B = q.permissions) == null ? void 0 : B.comments) === "rw" ? "read" : "rw" });
      } finally {
        T.value = !1;
      }
    }
    async function X(q) {
      if (M.value !== q.id) {
        M.value = q.id;
        return;
      }
      M.value = null, T.value = !0;
      try {
        await w(q.id), a("active", { hasToken: c.value.length > 0 });
      } finally {
        T.value = !1;
      }
    }
    async function te() {
      var q;
      if ((q = x.value) != null && q.token)
        try {
          await navigator.clipboard.writeText(x.value.token), R.value = !0, window.setTimeout(() => R.value = !1, 1600);
        } catch {
        }
    }
    function V(q) {
      const B = new Date(q ?? "").getTime();
      return Number.isNaN(B) ? "" : l(B);
    }
    function G(q) {
      return q.last_used_at ? V(q.last_used_at) : r("conn.tokens.neverUsed");
    }
    return (q, B) => (f(), h("section", KG, [
      d("header", VG, [
        d("h4", jG, y(u(r)("conn.tokens.title")), 1),
        d("p", qG, y(u(r)("conn.tokens.lead")), 1)
      ]),
      u(v) === !1 ? (f(), h("p", WG, y(u(r)("conn.tokens.cannotMint")), 1)) : D("", !0),
      u(m) ? (f(), h("p", YG, y(u(m)), 1)) : D("", !0),
      u(v) && !e.full ? (f(), h("div", GG, [
        cn(d("input", {
          "onUpdate:modelValue": B[0] || (B[0] = (K) => A.value = K),
          class: "fe-cfield__input",
          placeholder: ve(),
          "data-testid": "token-label"
        }, null, 8, XG), [
          [xn, A.value]
        ]),
        d("button", {
          class: "fe-s3keys__btn",
          disabled: T.value,
          "data-testid": "token-mint",
          onClick: W
        }, y(u(r)("conn.tokens.mint")), 9, JG)
      ])) : u(v) ? (f(), h("div", ZG, [
        cn(d("input", {
          "onUpdate:modelValue": B[1] || (B[1] = (K) => A.value = K),
          class: "fe-cfield__input",
          placeholder: ve(),
          "data-testid": "token-label"
        }, null, 8, QG), [
          [xn, A.value]
        ]),
        d("fieldset", eX, [
          d("legend", tX, y(u(r)("conn.tokens.scopes")), 1),
          (f(), h(Ce, null, nt(L, (K) => d("label", {
            key: K,
            class: "fe-tokform__scope"
          }, [
            cn(d("input", {
              "onUpdate:modelValue": (ke) => U.value[K] = ke,
              type: "checkbox",
              "data-testid": `token-scope-${K}`
            }, null, 8, nX), [
              [wc, U.value[K]]
            ]),
            d("span", null, y(K), 1)
          ])), 64)),
          Z.value ? (f(), h("p", aX, y(u(r)("conn.tokens.scopesRequired")), 1)) : D("", !0)
        ]),
        d("div", iX, [
          d("span", oX, y(u(r)("conn.tokens.comments")), 1),
          Je(mi, {
            "model-value": $.value,
            options: F.value,
            "aria-labelledby": "token-comments-label",
            "testid-prefix": "token-comments",
            "onUpdate:modelValue": B[2] || (B[2] = (K) => $.value = K)
          }, null, 8, ["model-value", "options"]),
          d("p", rX, y(u(r)("conn.tokens.commentsHint")), 1)
        ]),
        d("label", sX, [
          d("span", lX, y(u(r)("conn.tokens.root")), 1),
          cn(d("input", {
            "onUpdate:modelValue": B[3] || (B[3] = (K) => P.value = K),
            class: "fe-cfield__input",
            placeholder: u(r)("conn.tokens.rootPlaceholder"),
            "data-testid": "token-root"
          }, null, 8, uX), [
            [xn, P.value]
          ])
        ]),
        d("div", cX, [
          d("label", dX, [
            d("span", fX, y(u(r)("conn.tokens.expiry")), 1),
            cn(d("input", {
              "onUpdate:modelValue": B[4] || (B[4] = (K) => H.value = K),
              type: "number",
              min: "0",
              class: "fe-cfield__input",
              placeholder: u(r)("conn.tokens.expiryNever"),
              "data-testid": "token-expiry"
            }, null, 8, pX), [
              [
                xn,
                H.value,
                void 0,
                { number: !0 }
              ]
            ])
          ]),
          d("button", {
            class: "fe-s3keys__btn",
            disabled: T.value || Z.value,
            "data-testid": "token-mint",
            onClick: W
          }, y(u(r)("conn.tokens.mint")), 9, hX)
        ]),
        d("p", mX, y(u(r)("conn.tokens.capNote")), 1)
      ])) : D("", !0),
      u(x) ? (f(), h("div", vX, [
        d("p", yX, y(u(r)("conn.tokens.once")), 1),
        d("div", gX, [
          d("code", null, y(u(x).token), 1),
          d("button", {
            class: "fe-s3keys__copy",
            onClick: te
          }, y(R.value ? u(r)("conn.guide.copied") : u(r)("conn.guide.copy")), 1)
        ]),
        d("button", {
          class: "fe-s3keys__dismiss",
          onClick: B[5] || (B[5] = //@ts-ignore
          (...K) => u(C) && u(C)(...K))
        }, y(u(r)("conn.tokens.dismiss")), 1)
      ])) : D("", !0),
      u(p) ? (f(), h("p", bX, "…")) : (f(), We(es, {
        key: 6,
        "table-id": "conn.tokens",
        columns: z.value,
        rows: u(c),
        "row-key": "id",
        locale: i.value,
        empty: u(r)("conn.tokens.empty"),
        "row-actions": le,
        "row-actions-test-id": (K) => `api-token-actions-${K.id}`,
        onRowAction: B[6] || (B[6] = (K, ke) => fe(K, ke))
      }, {
        "cell-scopes": mt(({ row: K }) => [
          d("code", kX, y(K.scopes), 1)
        ]),
        _: 1
      }, 8, ["columns", "rows", "locale", "empty", "row-actions-test-id"])),
      u(v) ? (f(), h("p", wX, y(u(r)("conn.tokens.revokeHint")), 1)) : D("", !0)
    ]));
  }
}), _X = { class: "fe-conn__head" }, xX = { class: "fe-conn__title" }, SX = { class: "fe-conn__sub" }, $X = ["aria-label"], TX = ["innerHTML"], AX = {
  key: 0,
  class: "fe-conn__error",
  "data-testid": "conn-error"
}, EX = { class: "fe-conn__body" }, CX = { class: "fe-conn__guidebar" }, zX = {
  key: 0,
  class: "fe-conn__pick"
}, MX = { class: "fe-cfield__label" }, OX = { class: "fe-conn__pick" }, PX = { class: "fe-cfield__label" }, DX = /* @__PURE__ */ rt({
  __name: "ConnectionsPanel",
  props: {
    config: {},
    closable: { type: Boolean }
  },
  emits: ["close", "error"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Ca(n.config.locale)), { t: r } = ht(i), { visible: l, me: c, realm: p, publicUrl: m, error: v, load: x } = WW(n.config), k = E(() => {
      var $;
      return nY((($ = c.value) == null ? void 0 : $.email) ?? "", p.value);
    }), _ = Ml(), w = E(() => {
      const $ = n.config.theme ?? "auto";
      return $ === "light" || $ === "dark" ? $ : _.value ? "dark" : "light";
    }), b = dY(), C = S(b[0] ?? "webdav"), A = S(""), T = E(() => b.map(($) => ({ value: $, label: cY($) }))), R = E(() => [
      { value: "", label: r("conn.guide.allStorages") },
      ...l.value.map(($) => ({ value: $, label: $ }))
    ]), M = S(
      null
    ), L = E(() => qW(n.config, m.value)), U = S(
      null
    ), P = S(null), H = E(
      () => {
        var $, F, I, Z, J, re, ve, W, z, le, fe, j, X, te, V, G, q, B, K, ke, Ye, Oe, Be, qe, Tt, $t;
        return fY(
          C.value,
          {
            origin: L.value,
            user: k.value,
            storages: l.value,
            storage: A.value || void 0,
            s3Endpoint: ($ = U.value) == null ? void 0 : $.endpoint,
            s3PathStyle: (F = U.value) == null ? void 0 : F.pathStyle,
            s3AccessKeyID: ((I = U.value) == null ? void 0 : I.accessKeyID) || void 0,
            s3Secret: (Z = U.value) == null ? void 0 : Z.secret,
            sftpHost: ((J = P.value) == null ? void 0 : J.host) || void 0,
            sftpPort: (re = P.value) == null ? void 0 : re.port,
            sftpEnabled: (ve = P.value) == null ? void 0 : ve.enabled,
            sftpLogin: ((W = P.value) == null ? void 0 : W.login) || void 0,
            sftpHasKey: (z = P.value) == null ? void 0 : z.hasKey,
            ftpsHost: ((fe = (le = P.value) == null ? void 0 : le.ftps) == null ? void 0 : fe.host) || void 0,
            ftpsPort: (X = (j = P.value) == null ? void 0 : j.ftps) == null ? void 0 : X.port,
            ftpsEnabled: (V = (te = P.value) == null ? void 0 : te.ftps) == null ? void 0 : V.enabled,
            ftpsPasvMin: (q = (G = P.value) == null ? void 0 : G.ftps) == null ? void 0 : q.pasv_min,
            ftpsPasvMax: (K = (B = P.value) == null ? void 0 : B.ftps) == null ? void 0 : K.pasv_max,
            ftpsSelfSigned: (Ye = (ke = P.value) == null ? void 0 : ke.ftps) == null ? void 0 : Ye.self_signed,
            nfsHost: ((Oe = M.value) == null ? void 0 : Oe.host) || void 0,
            nfsPort: (Be = M.value) == null ? void 0 : Be.port,
            nfsEnabled: (qe = M.value) == null ? void 0 : qe.enabled,
            nfsPath: (Tt = M.value) == null ? void 0 : Tt.path,
            nfsReadOnly: ($t = M.value) == null ? void 0 : $t.readOnly
          },
          r
        );
      }
    );
    return Xe(
      () => l.value,
      ($) => {
        !A.value && $.length === 1 && (A.value = $[0]);
      }
    ), qt(() => {
      x();
    }), Xe(
      () => [n.config.apiBase, n.config.endpoint],
      () => {
        x();
      }
    ), ($, F) => (f(), h("div", {
      class: Ne(["fe-conn", {
        "fe--theme-dark": w.value === "dark",
        "fe--theme-light": w.value === "light"
      }]),
      "data-testid": "connections-panel"
    }, [
      d("header", _X, [
        d("div", null, [
          d("h2", xX, y(u(r)("conn.title")), 1),
          d("p", SX, y(u(r)("conn.subtitle", { host: u(Xr)(L.value) })), 1)
        ]),
        e.closable ? (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-conn__btn",
          "data-testid": "connections-close",
          "aria-label": u(r)("conn.close"),
          onClick: F[0] || (F[0] = (I) => a("close"))
        }, [
          d("span", {
            "aria-hidden": "true",
            innerHTML: u(Pt)("close")
          }, null, 8, TX)
        ], 8, $X)) : D("", !0)
      ]),
      u(v) ? (f(), h("p", AX, y(u(v)), 1)) : D("", !0),
      d("section", EX, [
        d("div", CX, [
          u(b).length > 1 ? (f(), h("label", zX, [
            d("span", MX, y(u(r)("conn.guide.protocol")), 1),
            Je(fc, {
              "model-value": C.value,
              options: T.value,
              testid: "guide-protocol",
              "onUpdate:modelValue": F[1] || (F[1] = (I) => C.value = String(I))
            }, null, 8, ["model-value", "options"])
          ])) : D("", !0),
          d("label", OX, [
            d("span", PX, y(u(r)("conn.guide.storage")), 1),
            Je(fc, {
              "model-value": A.value,
              options: R.value,
              testid: "guide-storage",
              "onUpdate:modelValue": F[2] || (F[2] = (I) => A.value = String(I))
            }, null, 8, ["model-value", "options"])
          ])
        ]),
        C.value === "s3" ? (f(), We(aG, {
          key: 0,
          config: e.config,
          storages: u(l),
          onActive: F[3] || (F[3] = (I) => U.value = I)
        }, null, 8, ["config", "storages"])) : D("", !0),
        C.value === "sftp" || C.value === "ftps" ? (f(), We(kG, {
          key: 1,
          config: e.config,
          "keys-visible": C.value === "sftp",
          onActive: F[4] || (F[4] = (I) => P.value = I)
        }, null, 8, ["config", "keys-visible"])) : D("", !0),
        C.value === "nfs" ? (f(), We(UG, {
          key: 2,
          config: e.config,
          storages: u(l),
          onActive: F[5] || (F[5] = (I) => M.value = I)
        }, null, 8, ["config", "storages"])) : D("", !0),
        C.value === "ftps" || C.value === "webdav" || C.value === "mount" ? (f(), We(nT, {
          key: 3,
          config: e.config,
          protocol: C.value,
          host: u(Xr)(L.value)
        }, null, 8, ["config", "protocol", "host"])) : D("", !0),
        H.value ? (f(), We(DY, {
          key: 4,
          guide: H.value,
          locale: i.value
        }, null, 8, ["guide", "locale"])) : D("", !0)
      ])
    ], 2));
  }
});
function $pe(e = "") {
  return {
    text: "",
    tags: [],
    excludeTags: [],
    scope: "name",
    filters: { ...Ko, pathBase: e }
  };
}
function t0(e, t) {
  const n = e.trim();
  if (!n) return "";
  const a = /\s/.test(n) ? `"${n}"` : n;
  return `${t ? "-" : ""}tag:${a}`;
}
function cy(e) {
  const t = [], n = e.text.trim();
  n && t.push(n);
  for (const a of e.tags) {
    const i = t0(a, !1);
    i && t.push(i);
  }
  for (const a of e.excludeTags) {
    const i = t0(a, !0);
    i && t.push(i);
  }
  return t.join(" ");
}
function LX(e, t = Date.now(), n = {}) {
  const a = {};
  e.type && e.type !== "any" && (a.type = e.type === "folder" ? "dir" : e.type);
  const i = xS(e, t);
  (i == null ? void 0 : i.after) !== void 0 && (a.modified_after = String(Math.floor(i.after))), (i == null ? void 0 : i.before) !== void 0 && (a.modified_before = String(Math.floor(i.before)));
  const r = SS(e);
  (r == null ? void 0 : r.min) !== void 0 && (a.min_size = String(Math.max(0, Math.floor(r.min)))), (r == null ? void 0 : r.max) !== void 0 && (a.max_size = String(Math.max(0, Math.floor(r.max))));
  const l = (e.pathBase ?? "").replace(/\/+$/, "");
  l && e.pathMode === "here" && (a.under = l), l && e.pathMode === "skip" && (a.not_under = l);
  const c = e.people ?? "any";
  return c === "me" || c === "system" ? a.owner = c : c.startsWith("u:") && (a.owner = c.slice(2)), n.showHidden === !1 && (a.hidden = "false"), a;
}
function Tpe(e) {
  return cy(e) === "";
}
function Ape(e) {
  return xI(e, { newlines: !0 });
}
function Qm(e, t, n) {
  return typeof n == "boolean" ? n : e >= t;
}
const RX = { class: "fe-shortcuts" }, NX = { class: "fe-shortcuts__heading" }, IX = { class: "fe-shortcuts__table" }, BX = { class: "fe-shortcuts__keys" }, FX = {
  key: 0,
  class: "fe-shortcuts__unbound"
}, UX = { class: "fe-kbd" }, HX = {
  key: 0,
  class: "fe-shortcuts__or",
  "aria-hidden": "true"
}, KX = { class: "fe-shortcuts__desc" }, VX = ["title"], jX = ["innerHTML"], qX = /* @__PURE__ */ rt({
  __name: "ShortcutsHelp",
  props: {
    open: { type: Boolean },
    locale: {}
  },
  emits: ["close", "customize"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = dP(), l = E(() => {
      const c = [], p = /* @__PURE__ */ new Map();
      for (const m of r.value)
        p.has(m.groupKey) || (p.set(m.groupKey, []), c.push(m.groupKey)), p.get(m.groupKey).push(m);
      return c.map((m) => ({ key: m, items: p.get(m) }));
    });
    return (c, p) => (f(), We(na, {
      open: e.open,
      title: u(i)("shortcuts.title"),
      size: "md",
      onClose: p[2] || (p[2] = (m) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: p[0] || (p[0] = (m) => a("customize"))
        }, [
          d("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(Pt)("shortcut-settings")
          }, null, 8, jX),
          Vt(" " + y(u(i)("shortcuts.customize")), 1)
        ]),
        d("button", {
          type: "button",
          class: "fe-btn",
          onClick: p[1] || (p[1] = (m) => a("close"))
        }, y(u(i)("viewer.close")), 1)
      ]),
      default: mt(() => [
        d("div", RX, [
          (f(!0), h(Ce, null, nt(l.value, (m) => (f(), h("section", {
            key: m.key,
            class: "fe-shortcuts__group"
          }, [
            d("h3", NX, y(u(i)(m.key)), 1),
            d("div", IX, [
              (f(!0), h(Ce, null, nt(m.items, (v) => (f(), h("div", {
                key: v.id,
                class: "fe-shortcuts__row"
              }, [
                d("span", BX, [
                  v.keys.length === 0 ? (f(), h("span", FX, y(u(i)("shortcuts.settings.unbound")), 1)) : (f(!0), h(Ce, { key: 1 }, nt(v.keys, (x, k) => (f(), h(Ce, { key: x }, [
                    d("kbd", UX, y(x), 1),
                    k < v.keys.length - 1 ? (f(), h("span", HX, "/")) : D("", !0)
                  ], 64))), 128))
                ]),
                d("span", KX, [
                  Vt(y(u(i)(v.labelKey)) + " ", 1),
                  v.overridden ? (f(), h("span", {
                    key: 0,
                    class: "fe-shortcuts__custom",
                    title: u(i)("shortcuts.settings.customized")
                  }, "●", 8, VX)) : D("", !0)
                ])
              ]))), 128))
            ])
          ]))), 128))
        ])
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
});
function aT(e) {
  return !e || typeof e != "object" || e.complete === !0 ? null : e;
}
function WX(e) {
  const t = Math.max(0, e.catalogued_folders ?? 0), n = Math.max(0, e.pending_folders ?? 0);
  if (t + n === 0) return 0;
  const a = Math.floor(t * 100 / (t + n));
  return n > 0 ? Math.min(a, 99) : a;
}
function YX(e) {
  switch (e.reason) {
    case "lazy_on_open":
      return { key: "coverage.lazy_on_open", vars: {} };
    case "lazy_filling":
      return { key: "coverage.lazy_filling", vars: { pct: WX(e) } };
    default:
      return { key: "coverage.first_scan", vars: {} };
  }
}
function GX(e) {
  const t = {};
  if (!Array.isArray(e)) return t;
  for (const n of e)
    !n || typeof n.name != "string" || n.name === "" || (t[n.name] = aT(n.coverage ?? null));
  return t;
}
function XX(e) {
  const { map: t, adapter: n, searching: a, crossStorage: i, admin: r } = e;
  if (a && i) {
    const c = Object.keys(t).filter((p) => t[p] !== null).sort((p, m) => p.localeCompare(m));
    return c.length === 0 ? null : c.length === 1 ? n0(c[0], t[c[0]], r) : { key: "coverage.search_some", vars: { names: c.join(", ") }, offerCatalogAll: !1 };
  }
  const l = t[n];
  return l ? n0(n, l, r) : null;
}
function n0(e, t, n) {
  const a = YX(t);
  return { key: a.key, vars: a.vars, storage: e, offerCatalogAll: n && t.reason === "lazy_on_open" };
}
function JX() {
  let e = 0, t = null, n = Promise.resolve();
  return {
    begin(a, i) {
      return e += 1, { ticket: e, want: a ?? t ?? i };
    },
    going(a) {
      t = a;
    },
    view() {
      return t = null, e += 1, e;
    },
    isNewest(a) {
      return a === e;
    },
    end(a) {
      a === e && (t = null);
    },
    async follow(a) {
      let i;
      const r = new Promise((c) => i = c);
      n = r;
      try {
        await a();
      } finally {
        i();
      }
      let l = r;
      for (; n !== l; )
        l = n, await l;
    }
  };
}
function ZX() {
  let e = 0, t = [];
  function n() {
    if (e > 0 || t.length === 0) return;
    const a = t;
    t = [];
    for (const i of a) i();
  }
  return {
    start() {
      e++;
      let a = !1;
      return () => {
        a || (a = !0, e--, n());
      };
    },
    settled(a) {
      return e === 0 ? Promise.resolve(!0) : new Promise((i) => {
        let r;
        const l = () => {
          r !== void 0 && clearTimeout(r), i(!0);
        };
        t.push(l), r = setTimeout(() => {
          t = t.filter((c) => c !== l), i(!1);
        }, Math.max(0, a));
      });
    },
    get count() {
      return e;
    }
  };
}
const Ju = "filex.menuAnswers.v1|", sf = 1, QX = 1500, eJ = 6, tJ = 196608, a0 = 7 * 24 * 60 * 60 * 1e3, nJ = 3e4, aJ = 400, iJ = ["allowed", "request", "denied"], oJ = ["p", "e:file", "e:folder", "e:new_folder"], fp = /* @__PURE__ */ new Set();
function lf(e) {
  const t = e.indexOf("://");
  return t > 0 ? e.slice(0, t) : "";
}
function i0(e) {
  const t = e.indexOf("://");
  return t < 0 ? e : e.slice(0, t + 3) + e.slice(t + 3).replace(/^\/+|\/+$/g, "");
}
function ev(e) {
  const t = e.indexOf("://");
  if (t < 0) return null;
  const n = e.slice(t + 3);
  if (!n) return null;
  const a = n.lastIndexOf("/");
  return e.slice(0, t + 3) + (a < 0 ? "" : n.slice(0, a));
}
function tv(e) {
  return e === "p" ? "p" : "e";
}
function rJ(e, t) {
  return e === "p" ? Array.isArray(t) && t.every((n) => typeof n == "string") : typeof t == "string" && iJ.includes(t);
}
function sJ(e) {
  let t = 2166136261, n = 1523705862;
  for (let a = 0; a < e.length; a++) {
    const i = e.charCodeAt(a);
    t = Math.imul(t ^ i, 16777619), n = Math.imul(n ^ i, 1540483477);
  }
  return (t >>> 0).toString(16).padStart(8, "0") + (n >>> 0).toString(16).padStart(8, "0");
}
function lJ() {
  try {
    const e = globalThis.localStorage;
    if (!e) return null;
    const t = `${Ju}probe`;
    return e.setItem(t, "1"), e.removeItem(t), e;
  } catch {
    return null;
  }
}
function uJ(e = {}) {
  const t = e.now ?? (() => Date.now()), n = S(0), a = /* @__PURE__ */ new Map(), i = Math.random().toString(36).slice(2, 8);
  let r = 0, l = `${i}.0`, c = null, p = null, m = {}, v = null, x = !1;
  const k = () => `${Ju}${c}`, _ = (U) => `${Ju}${c}|${encodeURIComponent(U)}`;
  function w(U, P) {
    var I;
    if (!p || !c || !U) return;
    let H = null;
    try {
      H = JSON.parse(p.getItem(_(U)) ?? "null");
    } catch {
      H = null;
    }
    if (!H || H.v !== sf || !Array.isArray(H.r)) return;
    const $ = t(), F = /* @__PURE__ */ new Map();
    for (const Z of H.r) {
      if (!Array.isArray(Z)) continue;
      const [J, re, ve] = Z;
      if (typeof J != "string" || typeof ve != "number" || $ - ve > a0) continue;
      const W = J.slice(0, J.indexOf("|"));
      !oJ.includes(W) || ((I = H.sig) == null ? void 0 : I[tv(W)]) !== m[tv(W)] || !rJ(W, re) || P.rows.has(J) || F.set(J, [re, ve, "", 1]);
    }
    for (const [Z, J] of P.rows) F.set(Z, J);
    P.rows = F;
  }
  function b(U) {
    let P = a.get(U);
    return P || (P = { sig: { ...m }, rows: /* @__PURE__ */ new Map(), dirty: !1 }, a.set(U, P), w(U, P)), P;
  }
  function C() {
    !p || !c || v || x || (v = setTimeout(R, aJ));
  }
  function A(U, P, H) {
    if (!p) return;
    let $ = [...P.rows].filter(([, F]) => F[3] === 1).map(([F, I]) => [F, I[0], I[1]]);
    for (; $.length > 0; ) {
      const F = JSON.stringify({ v: sf, at: H, sig: P.sig, r: $ });
      if (F.length <= tJ)
        try {
          p.setItem(_(U), F);
          return;
        } catch {
        }
      $ = $.slice(Math.ceil($.length / 2));
    }
    try {
      p.removeItem(_(U));
    } catch {
    }
  }
  function T() {
    try {
      const U = JSON.parse((p == null ? void 0 : p.getItem(k())) ?? "null");
      if (U && U.v === sf && U.s && typeof U.s == "object") {
        const P = {};
        for (const [H, $] of Object.entries(U.s)) typeof $ == "number" && (P[H] = $);
        return P;
      }
    } catch {
    }
    return {};
  }
  function R() {
    if (v && clearTimeout(v), v = null, !p || !c) return;
    const U = t(), P = T();
    for (const [$, F] of a)
      F.dirty && (F.dirty = !1, $ && (P[$] = U, A($, F, U)));
    const H = Object.entries(P).sort(($, F) => F[1] - $[1]);
    for (const [$] of H.slice(eJ)) {
      delete P[$];
      try {
        p.removeItem(_($));
      } catch {
      }
    }
    try {
      p.setItem(k(), JSON.stringify({ v: sf, at: U, s: P }));
    } catch {
    }
  }
  function M() {
    var H;
    if (!p) return;
    const U = t(), P = [];
    try {
      for (let $ = 0; $ < p.length; $++) {
        const F = p.key($);
        if (!F || !F.startsWith(Ju)) continue;
        let I = 0;
        try {
          I = Number((H = JSON.parse(p.getItem(F) ?? "null")) == null ? void 0 : H.at) || 0;
        } catch {
          I = 0;
        }
        U - I > a0 && P.push(F);
      }
      for (const $ of P) p.removeItem($);
    } catch {
    }
  }
  const L = {
    rev: n,
    attach(U, P) {
      if (x) return;
      R();
      const H = U ? sJ(U) : null;
      c !== null && H !== c && a.clear(), c = H, p = H ? e.storage ? e.storage() : lJ() : null;
      for (const $ of ["p", "e"]) m[$] !== void 0 && m[$] !== P[$] && L.sign($, P[$]);
      if (m = { ...P }, p) {
        M();
        for (const [$, F] of a)
          F.sig = { ...m }, w($, F), F.dirty = !0;
        C();
      }
      n.value++;
    },
    sign(U, P) {
      if (m[U] !== P) {
        m = { ...m, [U]: P };
        for (const H of a.values()) {
          for (const $ of [...H.rows.keys()]) tv($.slice(0, $.indexOf("|"))) === U && H.rows.delete($);
          H.sig = { ...m }, H.dirty = !0;
        }
        C(), n.value++;
      }
    },
    peek(U, P) {
      var H;
      return n.value, (H = b(lf(P)).rows.get(`${U}|${P}`)) == null ? void 0 : H[0];
    },
    fresh(U, P) {
      const H = b(lf(P)).rows.get(`${U}|${P}`);
      return !!H && H[2] === l && t() - H[1] < nJ;
    },
    put(U, P, H, $ = !0) {
      if (x) return;
      const F = b(lf(P)), I = `${U}|${P}`;
      for (F.rows.delete(I), F.rows.set(I, [H, t(), l, $ ? 1 : 0]); F.rows.size > QX; ) {
        const Z = F.rows.keys().next().value;
        if (Z === void 0) break;
        F.rows.delete(Z);
      }
      $ && (F.dirty = !0, C());
    },
    stale() {
      r++, l = `${i}.${r}`, n.value++;
    },
    around(U) {
      const P = lf(U);
      if (!P) return [];
      const H = i0(U), $ = `${P}://`, F = ev(H), I = /* @__PURE__ */ new Set([$, H]);
      F !== null && I.add(F);
      const Z = [];
      for (const J of b(P).rows.keys()) {
        const re = J.indexOf("|"), ve = J.slice(re + 1), W = i0(ve), z = ev(W);
        (I.has(W) || z !== null && (I.has(z) || ev(z) === H)) && Z.push({ q: J.slice(0, re), path: ve });
      }
      return Z;
    },
    flush() {
      R();
    },
    forget() {
      v && clearTimeout(v), v = null, a.clear(), c = null, p = null, n.value++;
    },
    dispose() {
      R(), x = !0, fp.delete(L);
    }
  };
  return fp.add(L), L;
}
function cJ() {
  for (const e of fp) e.forget();
  try {
    const e = globalThis.localStorage;
    if (!e) return;
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const a = e.key(n);
      a && a.startsWith(Ju) && t.push(a);
    }
    for (const n of t) e.removeItem(n);
  } catch {
  }
}
pF(cJ);
typeof window < "u" && typeof window.addEventListener == "function" && window.addEventListener("pagehide", () => {
  for (const e of fp) e.flush();
});
function Cf(e) {
  return typeof e == "number" && Number.isFinite(e) && e >= 0 ? e : null;
}
function iT(e) {
  return !!e && !e.unlimited && e.quota_bytes > 0;
}
function dJ(e, t) {
  return !e || iT(e) ? !1 : t.length === 0 || t.some((n) => Cf(n.usedBytes) === null);
}
function fJ(e, t, n) {
  if (!e) return null;
  if (iT(e))
    return { used: Cf(e.used_bytes) ?? 0, total: e.quota_bytes, unlimited: !1, partial: !1 };
  const a = /* @__PURE__ */ new Map();
  for (const m of n ?? []) m && typeof m.name == "string" && a.set(m.name, m);
  const i = t.length ? t : [...a.keys()].map((m) => ({ name: m }));
  let r = 0, l = 0, c = !1;
  const p = /* @__PURE__ */ new Set();
  for (const m of i) {
    if (p.has(m.name)) continue;
    p.add(m.name);
    const v = Cf(m.usedBytes), x = v === null ? a.get(m.name) : void 0, k = v ?? Cf(x == null ? void 0 : x.used_bytes);
    if (k === null) {
      c = !0;
      continue;
    }
    r += k, l++, (v !== null ? m.usedPartial === !0 : aT(x == null ? void 0 : x.coverage) !== null) && (c = !0);
  }
  return !l || r <= 0 ? null : { used: r, total: 0, unlimited: !0, partial: c };
}
const pJ = "custom:", pp = "filex.palette", o0 = "filex.theme", Fa = "default", oT = [
  {
    // Stock palette — the maps duplicate variables.css ONLY for the
    // gallery preview; applying this theme clears all overrides.
    id: Fa,
    nameKey: "theme.name.default",
    light: {
      /* ⚠ Mirrors styles/variables.css exactly — web/tests/api/themeContrast.test.ts
       * fails on any drift. It has drifted before: the stock primary was
       * darkened for contrast and this preview map kept the old blue, so the
       * gallery card advertised a colour the product no longer used. */
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f7f8fb",
      "--fe-bg-hover": "#f3f4f6",
      "--fe-bg-selected": "#eef3ff",
      "--fe-border": "#e5e7eb",
      "--fe-border-soft": "#eef0f4",
      "--fe-border-strong": "#d1d5db",
      "--fe-text": "#1f2937",
      "--fe-text-muted": "#6b7280",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2f6ceb",
      "--fe-primary-hover": "#2559c9",
      "--fe-primary-soft": "#e6ecfa",
      "--fe-primary-ink": "#2559c9",
      "--fe-danger": "#dc2626",
      "--fe-danger-hover": "#b91c1c",
      /* The outward-facing pages, as the stock palette defines them (#74):
       * the share page's ground and card (variables.css `.fe.fe-ppage`) and
       * the sign-in page's (`--fe-login-*`, which are the palette's own
       * sunken ground and surface). Optional for every theme - PAGE_TOKENS
       * below. */
      "--fe-ppage-ground-1": "#f5f7fb",
      "--fe-ppage-ground-2": "#e9edf4",
      "--fe-ppage-card": "#ffffff",
      "--fe-login-ground": "#f7f8fb",
      "--fe-login-card": "#ffffff"
    },
    dark: {
      "--fe-bg": "#15171c",
      "--fe-bg-elev": "#1a1d23",
      "--fe-bg-hover": "#1f232a",
      "--fe-bg-selected": "#1c2740",
      "--fe-border": "#2e333c",
      "--fe-border-soft": "#262a32",
      "--fe-border-strong": "#3d444f",
      "--fe-text": "#e6e8ec",
      "--fe-text-muted": "#888f9b",
      /* Dark ink, not white: white on the button measures 3.16 against the 4.5
       * this file claims. Mirrors styles/variables.css. */
      "--fe-text-on-primary": "#15171c",
      "--fe-primary": "#5b8cff",
      "--fe-primary-hover": "#7ba3ff",
      "--fe-primary-soft": "#1c2740",
      "--fe-primary-ink": "#7ba3ff",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444",
      "--fe-ppage-ground-1": "#12151a",
      "--fe-ppage-ground-2": "#191e25",
      "--fe-ppage-card": "#1f242c",
      "--fe-login-ground": "#1a1d23",
      "--fe-login-card": "#15171c"
    }
  },
  {
    // Night Blue — deep indigo/navy.
    id: "night",
    nameKey: "theme.name.night",
    light: {
      "--fe-bg": "#f6f8fd",
      "--fe-bg-elev": "#edf1fa",
      "--fe-bg-hover": "#e2e9f7",
      "--fe-bg-selected": "#d2ddf4",
      "--fe-border": "#d6deee",
      "--fe-border-soft": "#e3e8f4",
      "--fe-border-strong": "#aebfda",
      "--fe-text": "#151f38",
      "--fe-text-muted": "#49587a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2c4a9e",
      "--fe-primary-hover": "#213a80",
      "--fe-primary-soft": "#e0e6f4",
      "--fe-primary-ink": "#213a80",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0a1024",
      "--fe-bg-elev": "#111a35",
      "--fe-bg-hover": "#1a2547",
      "--fe-bg-selected": "#243665",
      "--fe-border": "#26335a",
      "--fe-border-soft": "#1d2748",
      "--fe-border-strong": "#3c4e84",
      "--fe-text": "#dfe6f7",
      "--fe-text-muted": "#96a5cc",
      "--fe-text-on-primary": "#050b26",
      "--fe-primary": "#6d8dfc",
      "--fe-primary-hover": "#5273f2",
      "--fe-primary-soft": "#182243",
      "--fe-primary-ink": "#6d8dfc",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Forest — calm greens.
    id: "forest",
    nameKey: "theme.name.forest",
    light: {
      "--fe-bg": "#f5faf5",
      "--fe-bg-elev": "#eaf3eb",
      "--fe-bg-hover": "#dcecdf",
      "--fe-bg-selected": "#c8e2ce",
      "--fe-border": "#d2e2d4",
      "--fe-border-soft": "#e0ece1",
      "--fe-border-strong": "#a2c3a8",
      "--fe-text": "#182b1d",
      "--fe-text-muted": "#42604a",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#2b7a41",
      "--fe-primary-hover": "#226334",
      "--fe-primary-soft": "#dbe9dc",
      "--fe-primary-ink": "#226334",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#0d1611",
      "--fe-bg-elev": "#132019",
      "--fe-bg-hover": "#1b2d23",
      "--fe-bg-selected": "#264532",
      "--fe-border": "#28402f",
      "--fe-border-soft": "#1f3225",
      "--fe-border-strong": "#3e5f49",
      "--fe-text": "#dcebe0",
      "--fe-text-muted": "#93b09b",
      "--fe-text-on-primary": "#04180b",
      "--fe-primary": "#54c17a",
      "--fe-primary-hover": "#3fae66",
      "--fe-primary-soft": "#16291d",
      "--fe-primary-ink": "#54c17a",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Amber — warm amber/bronze.
    id: "amber",
    nameKey: "theme.name.amber",
    light: {
      "--fe-bg": "#fdf9f0",
      "--fe-bg-elev": "#f7efdd",
      "--fe-bg-hover": "#f0e3c8",
      "--fe-bg-selected": "#ead6ab",
      "--fe-border": "#e6dabf",
      "--fe-border-soft": "#efe6d3",
      "--fe-border-strong": "#c6b184",
      "--fe-text": "#33270f",
      "--fe-text-muted": "#655631",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#9a4b00",
      "--fe-primary-hover": "#7c3c00",
      "--fe-primary-soft": "#f3e5d7",
      "--fe-primary-ink": "#7c3c00",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#191307",
      "--fe-bg-elev": "#231a0c",
      "--fe-bg-hover": "#2f2312",
      "--fe-bg-selected": "#44331b",
      "--fe-border": "#3b2e17",
      "--fe-border-soft": "#302512",
      "--fe-border-strong": "#5b4a29",
      "--fe-text": "#f2e7d4",
      "--fe-text-muted": "#bda887",
      "--fe-text-on-primary": "#2a1c02",
      "--fe-primary": "#f5a524",
      "--fe-primary-hover": "#ffb84d",
      "--fe-primary-soft": "#31230c",
      "--fe-primary-ink": "#ffb84d",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Lilac — soft purple.
    id: "lilac",
    nameKey: "theme.name.lilac",
    light: {
      "--fe-bg": "#faf7fd",
      "--fe-bg-elev": "#f2ecfa",
      "--fe-bg-hover": "#e8ddf5",
      "--fe-bg-selected": "#dccaf0",
      "--fe-border": "#e1d6ee",
      "--fe-border-soft": "#ebe3f4",
      "--fe-border-strong": "#bda6d9",
      "--fe-text": "#241a33",
      "--fe-text-muted": "#584871",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#7231e0",
      "--fe-primary-hover": "#5f21c4",
      "--fe-primary-soft": "#e9e3fc",
      "--fe-primary-ink": "#5f21c4",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#130f1c",
      "--fe-bg-elev": "#1b1527",
      "--fe-bg-hover": "#261d37",
      "--fe-bg-selected": "#37294f",
      "--fe-border": "#302546",
      "--fe-border-soft": "#261e38",
      "--fe-border-strong": "#4b3a6d",
      "--fe-text": "#e9e2f5",
      "--fe-text-muted": "#a999c5",
      "--fe-text-on-primary": "#180d33",
      "--fe-primary": "#b197fa",
      "--fe-primary-hover": "#9c7cf4",
      "--fe-primary-soft": "#272038",
      "--fe-primary-ink": "#b197fa",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // High Contrast — black/white with strong borders, saturated accents.
    id: "contrast",
    nameKey: "theme.name.contrast",
    light: {
      "--fe-bg": "#ffffff",
      "--fe-bg-elev": "#f2f2f2",
      "--fe-bg-hover": "#e0e0e0",
      "--fe-bg-selected": "#c9dcff",
      "--fe-border": "#5c5c5c",
      "--fe-border-soft": "#5c5c5c",
      "--fe-border-strong": "#000000",
      "--fe-text": "#000000",
      "--fe-text-muted": "#3d3d3d",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#003d99",
      "--fe-primary-hover": "#002a6b",
      "--fe-primary-soft": "#e7edf7",
      "--fe-primary-ink": "#002a6b",
      "--fe-danger": "#a80000",
      "--fe-danger-hover": "#7d0000",
      "--fe-shadow": "0 0 0 1px #000000, 0 10px 32px rgba(0, 0, 0, 0.25)",
      "--fe-shadow-sm": "0 0 0 1px #000000"
    },
    dark: {
      "--fe-bg": "#000000",
      "--fe-bg-elev": "#0d0d0d",
      "--fe-bg-hover": "#212121",
      "--fe-bg-selected": "#003d80",
      "--fe-border": "#8f8f8f",
      "--fe-border-soft": "#8f8f8f",
      "--fe-border-strong": "#ffffff",
      "--fe-text": "#ffffff",
      "--fe-text-muted": "#d6d6d6",
      "--fe-text-on-primary": "#001430",
      "--fe-primary": "#7ab8ff",
      "--fe-primary-hover": "#9ccaff",
      "--fe-primary-soft": "#0e1a29",
      "--fe-primary-ink": "#9ccaff",
      "--fe-danger": "#ff7575",
      "--fe-danger-hover": "#ff9999",
      "--fe-shadow": "0 0 0 1px #ffffff, 0 12px 32px rgba(0, 0, 0, 0.65)",
      "--fe-shadow-sm": "0 0 0 1px #ffffff"
    }
  },
  {
    // Soft Gray — desaturated, quiet neutral.
    id: "gray",
    nameKey: "theme.name.gray",
    light: {
      "--fe-bg": "#f7f7f8",
      "--fe-bg-elev": "#efeff1",
      "--fe-bg-hover": "#e4e4e7",
      "--fe-bg-selected": "#d6d7db",
      "--fe-border": "#dfdfe2",
      "--fe-border-soft": "#e9e9eb",
      "--fe-border-strong": "#b9b9c0",
      "--fe-text": "#26272b",
      "--fe-text-muted": "#585a63",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#4b4b54",
      "--fe-primary-hover": "#38383f",
      "--fe-primary-soft": "#e4e4e6",
      "--fe-primary-ink": "#38383f",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f"
    },
    dark: {
      "--fe-bg": "#131316",
      "--fe-bg-elev": "#1b1b1f",
      "--fe-bg-hover": "#26262b",
      "--fe-bg-selected": "#35353c",
      "--fe-border": "#2d2d33",
      "--fe-border-soft": "#242429",
      "--fe-border-strong": "#4a4a52",
      "--fe-text": "#e6e6e9",
      "--fe-text-muted": "#a4a4ad",
      "--fe-text-on-primary": "#17171b",
      "--fe-primary": "#b0b0ba",
      "--fe-primary-hover": "#c4c4cd",
      "--fe-primary-soft": "#242428",
      "--fe-primary-ink": "#c4c4cd",
      "--fe-danger": "#f87171",
      "--fe-danger-hover": "#ef4444"
    }
  },
  {
    // Terminal Green — phosphor green, monospace face for the full CRT vibe.
    id: "terminal",
    nameKey: "theme.name.terminal",
    light: {
      "--fe-bg": "#f3f9f4",
      "--fe-bg-elev": "#e5f2e8",
      "--fe-bg-hover": "#d5ead9",
      "--fe-bg-selected": "#bce3c6",
      "--fe-border": "#cbe2d1",
      "--fe-border-soft": "#dbebdf",
      "--fe-border-strong": "#94c2a0",
      "--fe-text": "#0c2913",
      "--fe-text-muted": "#31573c",
      "--fe-text-on-primary": "#ffffff",
      "--fe-primary": "#116b33",
      "--fe-primary-hover": "#0c5427",
      "--fe-primary-soft": "#dbe9dd",
      "--fe-primary-ink": "#0c5427",
      "--fe-danger": "#c62828",
      "--fe-danger-hover": "#a51f1f",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    },
    dark: {
      "--fe-bg": "#050d07",
      "--fe-bg-elev": "#0a1710",
      "--fe-bg-hover": "#112418",
      "--fe-bg-selected": "#1a3a26",
      "--fe-border": "#1c3a2a",
      "--fe-border-soft": "#142b1e",
      "--fe-border-strong": "#316144",
      "--fe-text": "#4fdd8b",
      "--fe-text-muted": "#38a668",
      "--fe-text-on-primary": "#03180a",
      "--fe-primary": "#25c95e",
      "--fe-primary-hover": "#4fdd8b",
      "--fe-primary-soft": "#0c2412",
      "--fe-primary-ink": "#4fdd8b",
      "--fe-danger": "#ff6b62",
      "--fe-danger-hover": "#ff8d86",
      "--fe-font": 'ui-monospace, "SF Mono", Consolas, Menlo, monospace'
    }
  }
], Gp = S([]);
function Epe(e) {
  Gp.value = Array.isArray(e) ? e : [], Yo.value !== Fa && !Wc(Yo.value) && lT(Fa);
}
function Cpe() {
  return { customThemes: Gp };
}
function rT() {
  return [...oT, ...Gp.value];
}
function Wc(e) {
  if (e)
    return oT.find((t) => t.id === e) ?? Gp.value.find((t) => t.id === e);
}
function hJ(e, t) {
  return e.name ?? (e.nameKey ? t(e.nameKey) : e.id);
}
function mJ() {
  return Array.from(
    new Set(rT().flatMap((e) => [...Object.keys(e.light), ...Object.keys(e.dark)]))
  );
}
function Yc(e) {
  return !!e && (!!Wc(e) || e.startsWith(pJ));
}
function sT() {
  if (!Qo()) return Fa;
  try {
    const e = localStorage.getItem(pp);
    if (Yc(e)) return e;
    const t = localStorage.getItem(o0);
    return t && Wc(t) ? (localStorage.setItem(pp, t), localStorage.removeItem(o0), t) : Fa;
  } catch {
    return Fa;
  }
}
const Yo = S(
  typeof window > "u" ? Fa : sT()
);
function vJ(e) {
  const t = Yc(e) ? e : Fa;
  Yo.value = t;
  try {
    localStorage.setItem(pp, t);
  } catch {
  }
  Zi("palette", t);
}
function lT(e) {
  if (!e) return;
  const t = Yc(e) ? e : Fa;
  Yo.value = t, Vr("palette", t);
}
function zpe(e) {
  e && Yc(e) && (Yo.value = e);
}
function yJ() {
  return { themeId: Yo, setTheme: vJ };
}
const bc = "filex.thememode";
fF(bc);
const Ig = ["host", "auto", "light", "dark"];
function uT() {
  if (!Qo()) return "host";
  try {
    const e = localStorage.getItem(bc);
    return e && Ig.includes(e) ? e : "host";
  } catch {
    return "host";
  }
}
const Xp = S(
  typeof window > "u" ? "host" : uT()
);
function gJ(e) {
  const t = Ig.includes(e) ? e : "host";
  Xp.value = t;
  try {
    t === "host" ? localStorage.removeItem(bc) : localStorage.setItem(bc, t);
  } catch {
  }
}
function Mpe() {
  Yo.value = sT(), Xp.value = uT();
}
function bJ() {
  return { themeMode: Xp, setThemeMode: gJ };
}
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      if (e.key !== bc || !Qo()) return;
      const t = e.newValue;
      Xp.value = t && Ig.includes(t) ? t : "host";
    });
  } catch {
  }
if (typeof window < "u")
  try {
    window.addEventListener("storage", (e) => {
      e.key !== pp || !Qo() || (Yo.value = Yc(e.newValue) ? e.newValue : Fa);
    });
  } catch {
  }
function kJ(e, t, n) {
  for (const r of mJ()) e.style.removeProperty(r);
  if (t === Fa) return;
  const a = Wc(t);
  if (!a) return;
  const i = n ? a.dark : a.light;
  for (const [r, l] of Object.entries(i)) e.style.setProperty(r, l);
}
const r0 = "data-filex-theme";
function uf(e) {
  return Object.entries(e).map(([t, n]) => `${t}:${n};`).join("");
}
const Bg = ["--fe-ppage-ground-1", "--fe-ppage-ground-2", "--fe-ppage-card"], wJ = ["--fe-login-ground", "--fe-login-card"], Ope = [...Bg, ...wJ], _J = {
  light: {
    "--fe-ppage-ground-1": "color-mix(in srgb, var(--fe-bg) 96%, var(--fe-text))",
    "--fe-ppage-ground-2": "color-mix(in srgb, var(--fe-bg) 90%, var(--fe-text))",
    "--fe-ppage-card": "var(--fe-bg)"
  },
  dark: {
    "--fe-ppage-ground-1": "color-mix(in srgb, var(--fe-bg) 88%, #000000)",
    "--fe-ppage-ground-2": "color-mix(in srgb, var(--fe-bg) 96%, var(--fe-text))",
    "--fe-ppage-card": "color-mix(in srgb, var(--fe-bg) 92%, var(--fe-text))"
  }
};
function s0(e, t) {
  const n = e[t] ?? {}, a = {};
  for (const i of Bg) {
    const r = typeof n[i] == "string" ? n[i].trim() : "";
    a[i] = r || _J[t][i];
  }
  return a;
}
const xJ = new Set(Bg);
function l0(e) {
  const t = {};
  for (const [n, a] of Object.entries(e)) xJ.has(n) || (t[n] = a);
  return t;
}
function SJ(e) {
  const t = uf(l0(e.light)), n = uf(l0(e.dark)), a = uf(s0(e, "light")), i = uf(s0(e, "dark")), r = [
    ".fe.fe-ppage.fe--theme-dark",
    ":root[data-theme='dark'] .fe.fe-ppage",
    ":root.dark .fe.fe-ppage",
    ".dark .fe.fe-ppage"
  ].join(","), l = [
    ".fe--theme-dark",
    ":root[data-theme='dark'] .fe",
    ".fe.fe--theme-dark",
    ":root.dark",
    ".dark",
    ":root.dark .fe",
    ".dark .fe",
    ".fe-ctx-backdrop--theme-dark",
    ".fe-ctx-backdrop--theme-auto[data-prefers-dark='1']"
  ].join(","), c = [
    ".fe:not(.fe--theme-light)",
    ".fe-ctx-backdrop--theme-auto:not(.fe-ctx-backdrop--theme-light)"
  ].join(",");
  return `/* filex theme: ${e.id} */:root,.fe{${t}}${l}{${n}}@media (prefers-color-scheme: dark){${c}{${n}}}.fe.fe-ppage{${a}}${r}{${i}}@media (prefers-color-scheme: dark){.fe.fe-ppage:not(.fe--theme-light){${i}}}`;
}
function $J(e) {
  if (typeof document > "u") return;
  let t = document.head.querySelector(`style[${r0}]`);
  const n = e === Fa ? void 0 : Wc(e);
  if (!n) {
    t && (t.textContent = "");
    return;
  }
  t ? t !== document.head.lastElementChild && document.head.appendChild(t) : (t = document.createElement("style"), t.setAttribute(r0, ""), document.head.appendChild(t));
  const a = SJ(n);
  t.textContent !== a && (t.textContent = a);
}
const TJ = {
  key: 0,
  class: "fe-themes__hint"
}, AJ = ["aria-label"], EJ = ["aria-selected", "data-theme-id", "onClick"], CJ = { class: "fe-themecard__name" }, zJ = ["title"], MJ = /* @__PURE__ */ rt({
  __name: "ThemePalette",
  props: {
    locale: {},
    dark: { type: Boolean },
    current: {},
    hint: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale);
    function r(l) {
      return n.dark ? l.dark : l.light;
    }
    return (l, c) => (f(), h(Ce, null, [
      e.hint !== !1 ? (f(), h("p", TJ, y(u(i)("theme.hint")), 1)) : D("", !0),
      d("div", {
        class: "fe-themes",
        role: "listbox",
        "aria-label": u(i)("theme.title")
      }, [
        (f(!0), h(Ce, null, nt(u(rT)(), (p) => (f(), h("button", {
          key: p.id,
          type: "button",
          class: Ne(["fe-themecard", { "is-selected": p.id === e.current }]),
          role: "option",
          "aria-selected": p.id === e.current,
          "data-theme-id": p.id,
          style: Xt(r(p)),
          onClick: (m) => a("select", p.id)
        }, [
          c[0] || (c[0] = W0('<span class="fe-themecard__preview" aria-hidden="true"><span class="fe-themecard__topbar"><span class="fe-themecard__chip fe-themecard__chip--primary"></span><span class="fe-themecard__chip"></span><span class="fe-themecard__chip fe-themecard__chip--ghost"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot"></span><span class="fe-themecard__line" style="width:62%;"></span></span><span class="fe-themecard__row fe-themecard__row--selected"><span class="fe-themecard__dot fe-themecard__dot--primary"></span><span class="fe-themecard__line" style="width:44%;"></span></span><span class="fe-themecard__row"><span class="fe-themecard__dot fe-themecard__dot--muted"></span><span class="fe-themecard__line fe-themecard__line--muted" style="width:74%;"></span></span></span>', 1)),
          d("span", CJ, [
            Vt(y(u(hJ)(p, u(i))) + " ", 1),
            p.id === e.current ? (f(), h("span", {
              key: 0,
              class: "fe-themecard__check",
              title: u(i)("theme.selected")
            }, "✓", 8, zJ)) : D("", !0)
          ])
        ], 14, EJ))), 128))
      ], 8, AJ)
    ], 64));
  }
}), OJ = ["aria-label"], PJ = { class: "fe-thememode__label" }, DJ = { class: "fe-thememode__seg" }, LJ = ["aria-pressed", "onClick"], RJ = {
  class: "fe-ficon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, NJ = {
  key: 1,
  d: "M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"
}, IJ = ["disabled"], BJ = /* @__PURE__ */ rt({
  __name: "ThemeGallery",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    dark: { type: Boolean },
    current: {},
    mode: {},
    hostMode: {}
  },
  emits: ["close", "select", "mode"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = [
      { id: "light", labelKey: "theme.mode.light" },
      { id: "dark", labelKey: "theme.mode.dark" },
      { id: "auto", labelKey: "theme.mode.auto" }
    ], l = E(() => n.mode === "host" ? n.hostMode : n.mode), c = Fa;
    return (p, m) => (f(), We(na, {
      open: e.open,
      title: u(i)("theme.title"),
      size: "lg",
      theme: e.theme,
      onClose: m[3] || (m[3] = (v) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.current === u(c),
          onClick: m[1] || (m[1] = (v) => a("select", u(c)))
        }, y(u(i)("theme.reset")), 9, IJ),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          onClick: m[2] || (m[2] = (v) => a("close"))
        }, y(u(i)("theme.close")), 1)
      ]),
      default: mt(() => [
        d("div", {
          class: "fe-thememode",
          role: "group",
          "aria-label": u(i)("theme.mode.label")
        }, [
          d("span", PJ, y(u(i)("theme.mode.label")), 1),
          d("div", DJ, [
            (f(), h(Ce, null, nt(r, (v) => d("button", {
              key: v.id,
              type: "button",
              class: Ne(["fe-thememode__opt", { "is-active": l.value === v.id }]),
              "aria-pressed": l.value === v.id,
              onClick: (x) => a("mode", v.id)
            }, [
              (f(), h("svg", RJ, [
                v.id === "light" ? (f(), h(Ce, { key: 0 }, [
                  m[4] || (m[4] = d("circle", {
                    cx: "12",
                    cy: "12",
                    r: "4"
                  }, null, -1)),
                  m[5] || (m[5] = d("path", { d: "M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" }, null, -1))
                ], 64)) : v.id === "dark" ? (f(), h("path", NJ)) : (f(), h(Ce, { key: 2 }, [
                  m[6] || (m[6] = d("circle", {
                    cx: "12",
                    cy: "12",
                    r: "9"
                  }, null, -1)),
                  m[7] || (m[7] = d("path", {
                    d: "M12 3a9 9 0 0 1 0 18z",
                    fill: "currentColor",
                    stroke: "none"
                  }, null, -1))
                ], 64))
              ])),
              d("span", null, y(u(i)(v.labelKey)), 1)
            ], 10, LJ)), 64))
          ])
        ], 8, OJ),
        Je(MJ, {
          locale: e.locale,
          dark: e.dark,
          current: e.current,
          onSelect: m[0] || (m[0] = (v) => a("select", v))
        }, null, 8, ["locale", "dark", "current"])
      ]),
      _: 1
    }, 8, ["open", "title", "theme"]));
  }
}), cT = "filex.density";
function FJ(e) {
  if (!(e !== "comfortable" && e !== "compact")) {
    Vr("density", e);
    try {
      window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
    } catch {
    }
  }
}
function Ppe() {
  try {
    return localStorage.getItem(cT) === "compact" ? "compact" : "comfortable";
  } catch {
    return "comfortable";
  }
}
function Dpe(e) {
  try {
    localStorage.setItem(cT, e);
  } catch {
  }
  Zi("density", e);
  try {
    window.dispatchEvent(new CustomEvent("filex:density", { detail: e }));
  } catch {
  }
}
function UJ(e) {
  const t = Symbol("filex-explorer");
  jo(A2, t), Xe(
    () => e.config().timeZone,
    (i) => EO(t, i),
    { immediate: !0 }
  );
  const n = () => {
    var i;
    return e.config().callerKind ?? ((i = e.capabilities.value) == null ? void 0 : i.caller_kind);
  };
  let a = !1;
  return Xe(
    n,
    (i) => {
      if (i !== "user") {
        hf(t, null);
        return;
      }
      a || (a = !0, e.fetchMe().then((r) => {
        var c;
        if (n() !== "user") return;
        const l = (c = r == null ? void 0 : r.user) == null ? void 0 : c.timezone;
        hf(t, typeof l == "string" ? l : null);
      }).catch(() => hf(t, null)));
    },
    { immediate: !0 }
  ), Ct(() => MO(t)), t;
}
const HJ = ["aria-label"], KJ = { class: "fe-opc__head" }, VJ = ["aria-label"], jJ = { class: "fe-opc__body" }, qJ = {
  key: 0,
  class: "fe-opc__section",
  "aria-live": "polite"
}, WJ = { class: "fe-opc__section-title" }, YJ = { class: "fe-opc__list" }, GJ = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, XJ = ["d"], JJ = { class: "fe-opc__mid" }, ZJ = ["title"], QJ = { class: "fe-opc__sub" }, eZ = { class: "fe-opc__kind" }, tZ = ["title"], nZ = { class: "fe-opc__state" }, aZ = {
  key: 0,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, iZ = ["aria-valuenow"], oZ = {
  key: 0,
  class: "fe-opc__spin",
  "aria-hidden": "true"
}, rZ = { class: "fe-opc__acts" }, sZ = ["onClick"], lZ = ["onClick"], uZ = ["onClick"], cZ = ["aria-label", "onClick"], dZ = {
  key: 1,
  class: "fe-opc__section"
}, fZ = { class: "fe-opc__section-title" }, pZ = { class: "fe-opc__list fe-opc__list--history" }, hZ = {
  class: "fe-opc__kicon",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, mZ = ["d"], vZ = { class: "fe-opc__mid" }, yZ = ["title"], gZ = {
  key: 0,
  class: "fe-opc__sub"
}, bZ = ["title"], kZ = {
  key: 1,
  class: "fe-opc__sub fe-opc__sub--err"
}, wZ = {
  key: 2,
  class: "fe-opc__sub fe-opc__sub--detail",
  "data-testid": "opc-error-detail"
}, _Z = ["onClick"], xZ = {
  key: 2,
  class: "fe-opc__empty"
}, SZ = ["aria-expanded", "aria-label"], $Z = ["stroke-dashoffset"], TZ = { class: "fe-opc__count" }, AZ = {
  key: 0,
  class: "fe-opc__pct"
}, nv = 8.5, EZ = /* @__PURE__ */ rt({
  __name: "OperationsCenter",
  props: {
    center: {},
    locale: {},
    narrow: { type: Boolean }
  },
  setup(e) {
    const t = e, { t: n, formatSize: a } = ht(() => t.locale), i = S(!1), r = S(null), l = E(() => t.center.active.value), c = E(() => t.center.history.value), p = E(() => t.center.hasError.value), m = E(() => t.center.overallPercent.value), v = E(() => t.center.runningCount.value), x = E(() => l.value.length > 0 || i.value && c.value.length > 0);
    Xe(x, (I) => {
      I || (i.value = !1);
    }), Xe(
      () => {
        var I;
        return ((I = t.center.revealRequests) == null ? void 0 : I.value) ?? 0;
      },
      (I, Z) => {
        I > Z && (i.value = !0);
      }
    );
    const k = 2 * Math.PI * nv, _ = E(() => {
      const I = m.value;
      return I === null ? k * 0.72 : k * (1 - Math.min(100, Math.max(0, I)) / 100);
    }), w = E(() => m.value === null && v.value > 0), b = E(() => v.value === 0 || m.value === null ? "" : n("opc.percent", { n: m.value })), C = E(() => n("opc.aria_badge", { n: l.value.length })), A = {
      upload: "M12 16V5M7 9.5 12 5l5 4.5M5 19h14",
      copy: "M9 9h11v11H9zM5 15V4h11",
      move: "M4 12h13M12 6l6 6-6 6",
      delete: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13",
      /* A folder given a new name, and one brought back from the trash. */
      rename: "M4 20h4L18.5 9.5l-4-4L4 16zM13 7l4 4",
      restore: "M9 14 4 9l5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11",
      /* A trash entry taken out for good: the bin, crossed. */
      purge: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10 11l4 5M14 11l-4 5",
      convert: "M20 8A8 8 0 0 0 6 6L4 8M4 16a8 8 0 0 0 14 2l2-2M20 3v5h-5M4 21v-5h5",
      archive: "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      /* "Empty the trash" — the bin, with the lines of what is going. */
      trash: "M5 7h14M9 7V5h6v2M8 7l1 13h6l1-13M10.5 11v5M13.5 11v5",
      /* "Repair thumbnails" (Admin → Tools): a picture, its frame and its hill. */
      thumbs: "M4 5h16v14H4zM4 16l5-5 4 4 3-3 4 4M15 9.5h.01",
      /* An app-plugin job — the puzzle piece its menu row wears (lib/actionIcons). */
      plugin: "M9.5 4.5a2 2 0 1 1 4 0h3a1.5 1.5 0 0 1 1.5 1.5v3a2 2 0 1 1 0 4v3a1.5 1.5 0 0 1-1.5 1.5h-3a2 2 0 1 1-4 0h-3A1.5 1.5 0 0 1 5 16v-3a2 2 0 1 1 0-4V6a1.5 1.5 0 0 1 1.5-1.5z",
      "archive-create": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4",
      "archive-extract": "M4 8V5h16v3zM5 8h14v12H5zM10 12h4"
    };
    function T(I) {
      return n(`opc.kind.${I.kind}`);
    }
    function R(I) {
      return I.name || T(I);
    }
    function M(I) {
      return I.outputMode === "sibling" ? n("plugin.output.sibling") : I.outputMode === "version" ? n("plugin.output.version") : "";
    }
    function L(I) {
      return I.outputMode === "sibling" ? n("plugin.output.sibling_title") : I.outputMode === "version" ? n("plugin.output.version_title") : "";
    }
    function U(I) {
      return I.status === "running" ? I.cancelling ? n("opc.cancelling") : I.queued ? n("opc.queued") : I.message ? I.message : I.totalBytes && I.totalBytes > 0 ? `${a(I.uploadedBytes ?? 0)} / ${a(I.totalBytes)}` : (I.kind === "archive-create" || I.kind === "archive-extract") && I.percent !== null ? n("opc.percent", { n: I.percent }) : I.itemsTotal && I.itemsTotal > 0 ? n("opc.items", { done: I.itemsDone ?? 0, total: I.itemsTotal }) : I.percent !== null && I.totalCount && I.totalCount > 1 ? `${I.doneCount ?? 0}/${I.totalCount}` : n("opc.status.running") : I.status === "done" ? I.message || n("opc.status.done") : I.status === "aborted" ? n("opc.status.aborted") : I.error || n("opc.status.error");
    }
    function P(I) {
      return I.status === "done" && I.outputs.length > 0;
    }
    function H(I) {
      return n(`opc.status.${I.status === "running" ? "running" : I.status}`);
    }
    function $(I) {
      if (!i.value) return;
      const Z = r.value;
      Z && I.target instanceof Node && !Z.contains(I.target) && (i.value = !1);
    }
    function F(I) {
      i.value && I.key === "Escape" && (i.value = !1);
    }
    return qt(() => {
      document.addEventListener("mousedown", $), document.addEventListener("keydown", F);
    }), Ct(() => {
      document.removeEventListener("mousedown", $), document.removeEventListener("keydown", F);
    }), (I, Z) => x.value ? (f(), h("div", {
      key: 0,
      ref_key: "rootEl",
      ref: r,
      class: Ne(["fe-opc", { "fe-opc--narrow": e.narrow, "fe-opc--open": i.value }])
    }, [
      Je(zr, { name: "fe-opc-pop" }, {
        default: mt(() => [
          i.value ? (f(), h("section", {
            key: 0,
            class: "fe-opc__panel",
            role: "dialog",
            "aria-label": u(n)("opc.title")
          }, [
            d("header", KJ, [
              d("strong", null, y(u(n)("opc.title")), 1),
              d("button", {
                type: "button",
                class: "fe-opc__x",
                "aria-label": u(n)("opc.close"),
                onClick: Z[0] || (Z[0] = (J) => i.value = !1)
              }, "×", 8, VJ)
            ]),
            d("div", jJ, [
              l.value.length > 0 ? (f(), h("div", qJ, [
                d("h3", WJ, y(u(n)("opc.active")), 1),
                d("ul", YJ, [
                  (f(!0), h(Ce, null, nt(l.value, (J) => (f(), h("li", {
                    key: J.key,
                    class: Ne(["fe-opc__item", `is-${J.status}`])
                  }, [
                    (f(), h("svg", GJ, [
                      d("path", {
                        d: A[J.kind]
                      }, null, 8, XJ)
                    ])),
                    d("div", JJ, [
                      d("div", {
                        class: "fe-opc__name",
                        title: R(J)
                      }, y(R(J)), 9, ZJ),
                      d("div", QJ, [
                        d("span", eZ, y(T(J)), 1),
                        M(J) ? (f(), h(Ce, { key: 0 }, [
                          Z[3] || (Z[3] = d("span", {
                            class: "fe-opc__dot",
                            "aria-hidden": "true"
                          }, "·", -1)),
                          d("span", {
                            class: "fe-opc__outmode",
                            title: L(J),
                            "data-testid": "opc-output-mode"
                          }, y(M(J)), 9, tZ)
                        ], 64)) : D("", !0),
                        Z[4] || (Z[4] = d("span", {
                          class: "fe-opc__dot",
                          "aria-hidden": "true"
                        }, "·", -1)),
                        d("span", nZ, y(U(J)), 1)
                      ]),
                      J.status === "error" && J.errorDetail ? (f(), h("div", aZ, y(J.errorDetail), 1)) : D("", !0),
                      J.status === "running" && J.percent !== null ? (f(), h("div", {
                        key: 1,
                        class: "fe-opc__bar",
                        role: "progressbar",
                        "aria-valuenow": J.percent,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, [
                        d("div", {
                          class: "fe-opc__bar-fill",
                          style: Xt({ width: J.percent + "%" })
                        }, null, 4)
                      ], 8, iZ)) : D("", !0)
                    ]),
                    J.status === "running" && J.percent === null && !J.queued ? (f(), h("span", oZ)) : D("", !0),
                    d("div", rZ, [
                      J.status === "running" && J.cancellable ? (f(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-opc__act",
                        onClick: (re) => e.center.cancel(J.key)
                      }, y(u(n)("opc.cancel")), 9, sZ)) : D("", !0),
                      P(J) ? (f(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-opc__act",
                        "data-testid": "opc-open",
                        onClick: (re) => e.center.open(J.key)
                      }, y(u(n)("opc.open")), 9, lZ)) : D("", !0),
                      J.status === "error" && J.retryable ? (f(), h("button", {
                        key: 2,
                        type: "button",
                        class: "fe-opc__act fe-opc__act--retry",
                        onClick: (re) => e.center.retry(J.key)
                      }, y(u(n)("opc.retry")), 9, uZ)) : D("", !0),
                      J.status !== "running" ? (f(), h("button", {
                        key: 3,
                        type: "button",
                        class: "fe-opc__x",
                        "aria-label": u(n)("opc.dismiss"),
                        onClick: (re) => e.center.dismiss(J.key)
                      }, "×", 8, cZ)) : D("", !0)
                    ])
                  ], 2))), 128))
                ])
              ])) : D("", !0),
              c.value.length > 0 ? (f(), h("div", dZ, [
                d("h3", fZ, [
                  Vt(y(u(n)("opc.history")) + " ", 1),
                  d("button", {
                    type: "button",
                    class: "fe-opc__act",
                    onClick: Z[1] || (Z[1] = (J) => e.center.clearHistory())
                  }, y(u(n)("opc.clear")), 1)
                ]),
                d("ul", pZ, [
                  (f(!0), h(Ce, null, nt(c.value, (J) => (f(), h("li", {
                    key: "h-" + J.key,
                    class: Ne(["fe-opc__item fe-opc__item--history", `is-${J.status}`])
                  }, [
                    (f(), h("svg", hZ, [
                      d("path", {
                        d: A[J.kind]
                      }, null, 8, mZ)
                    ])),
                    d("div", vZ, [
                      d("div", {
                        class: "fe-opc__name",
                        title: R(J)
                      }, y(R(J)), 9, yZ),
                      M(J) ? (f(), h("div", gZ, [
                        d("span", {
                          class: "fe-opc__outmode",
                          title: L(J),
                          "data-testid": "opc-output-mode"
                        }, y(M(J)), 9, bZ)
                      ])) : D("", !0),
                      J.status === "error" && J.error ? (f(), h("div", kZ, y(J.error), 1)) : D("", !0),
                      J.status === "error" && J.errorDetail ? (f(), h("div", wZ, y(J.errorDetail), 1)) : D("", !0)
                    ]),
                    P(J) ? (f(), h("button", {
                      key: 0,
                      type: "button",
                      class: "fe-opc__act",
                      onClick: (re) => e.center.open(J.key)
                    }, y(u(n)("opc.open")), 9, _Z)) : D("", !0),
                    d("span", {
                      class: Ne(["fe-opc__chip", `is-${J.status}`])
                    }, y(H(J)), 3)
                  ], 2))), 128))
                ])
              ])) : D("", !0),
              l.value.length === 0 && c.value.length === 0 ? (f(), h("p", xZ, y(u(n)("opc.empty")), 1)) : D("", !0)
            ])
          ], 8, HJ)) : D("", !0)
        ]),
        _: 1
      }),
      d("button", {
        type: "button",
        class: Ne(["fe-opc__badge", { "is-error": p.value }]),
        "aria-expanded": i.value,
        "aria-label": C.value,
        onClick: Z[2] || (Z[2] = (J) => i.value = !i.value)
      }, [
        (f(), h("svg", {
          class: Ne(["fe-opc__ring", { "fe-opc__ring--spin": w.value }]),
          viewBox: "0 0 22 22",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("circle", {
            class: "fe-opc__ring-track",
            cx: "11",
            cy: "11",
            r: nv,
            fill: "none",
            "stroke-width": "2.5"
          }),
          d("circle", {
            class: "fe-opc__ring-fill",
            cx: "11",
            cy: "11",
            r: nv,
            fill: "none",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-dasharray": k,
            "stroke-dashoffset": _.value,
            transform: "rotate(-90 11 11)"
          }, null, 8, $Z)
        ], 2)),
        d("span", TZ, y(l.value.length), 1),
        b.value ? (f(), h("span", AZ, y(b.value), 1)) : D("", !0)
      ], 10, SZ)
    ], 2)) : D("", !0);
  }
}), CZ = 4e3, u0 = 50;
function zZ(e, t, n) {
  const a = t.status !== "running";
  return {
    key: e,
    kind: t.kind,
    name: t.name,
    percent: t.percent,
    status: t.status,
    error: t.error ?? null,
    errorDetail: t.errorDetail ?? null,
    queued: t.queued ?? !1,
    cancelling: t.cancelling ?? !1,
    doneCount: t.doneCount ?? null,
    totalCount: t.totalCount ?? null,
    itemsDone: t.itemsDone ?? null,
    itemsTotal: t.itemsTotal ?? null,
    uploadedBytes: t.uploadedBytes ?? null,
    totalBytes: t.totalBytes ?? null,
    cancellable: t.cancellable ?? !1,
    retryable: t.retryable ?? !1,
    message: t.message ?? null,
    outputs: t.outputs ?? [],
    outputMode: t.outputMode ?? null,
    startedAt: (n == null ? void 0 : n.startedAt) ?? Date.now(),
    settledAt: (n == null ? void 0 : n.settledAt) ?? (a ? Date.now() : null)
  };
}
function MZ() {
  const e = S([]), t = S([]), n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Map();
  function r(M) {
    const L = i.get(M);
    L !== void 0 && (clearTimeout(L), i.delete(M));
  }
  function l(M, L = {}) {
    r(M);
    const U = e.value.findIndex((H) => H.key === M);
    if (U === -1) return;
    const [P] = e.value.splice(U, 1);
    e.value = [...e.value], a.add(M), L.toHistory !== !1 && (t.value = [{ ...P, settledAt: P.settledAt ?? Date.now() }, ...t.value].slice(
      0,
      u0
    ));
  }
  function c(M) {
    i.has(M) || i.set(
      M,
      setTimeout(() => {
        var U;
        i.delete(M);
        const L = n.get(M);
        l(M), (U = L == null ? void 0 : L.dismiss) == null || U.call(L);
      }, CZ)
    );
  }
  function p(M, L) {
    const U = `${M}:`, P = /* @__PURE__ */ new Set();
    let H = [...e.value], $ = !1;
    for (const F of L) {
      const I = `${M}:${F.input.id}`;
      if (P.add(I), F.actions && n.set(I, F.actions), a.has(I)) continue;
      const Z = H.findIndex((re) => re.key === I), J = zZ(I, F.input, Z === -1 ? void 0 : H[Z]);
      Z === -1 ? (H = [J, ...H], $ = !0) : JSON.stringify(H[Z]) !== JSON.stringify(J) && (H[Z] = J, $ = !0), (J.status === "done" || J.status === "aborted") && c(I);
    }
    for (const F of [...H])
      !F.key.startsWith(U) || P.has(F.key) || F.status !== "error" && (r(F.key), H = H.filter((I) => I.key !== F.key), $ = !0, F.status !== "running" && (a.add(F.key), t.value = [{ ...F, settledAt: F.settledAt ?? Date.now() }, ...t.value].slice(
        0,
        u0
      )));
    for (const F of [...a])
      F.startsWith(U) && !P.has(F) && a.delete(F);
    for (const F of [...n.keys()])
      if (F.startsWith(U) && !P.has(F) && !e.value.some((I) => I.key === F)) {
        if (H.some((I) => I.key === F) || t.value.some((I) => I.key === F && I.outputs.length > 0)) continue;
        n.delete(F);
      }
    $ && (e.value = H);
  }
  function m(M) {
    var L, U;
    (U = (L = n.get(M)) == null ? void 0 : L.cancel) == null || U.call(L);
  }
  function v(M) {
    var U, P;
    const L = n.get(M);
    l(M), (U = L == null ? void 0 : L.dismiss) == null || U.call(L), (P = L == null ? void 0 : L.retry) == null || P.call(L);
  }
  function x(M) {
    var U;
    const L = n.get(M);
    l(M), (U = L == null ? void 0 : L.dismiss) == null || U.call(L);
  }
  function k(M, L) {
    var H, $;
    const U = e.value.find((F) => F.key === M) ?? t.value.find((F) => F.key === M), P = L ?? (U == null ? void 0 : U.outputs[0]);
    P && (($ = (H = n.get(M)) == null ? void 0 : H.open) == null || $.call(H, P));
  }
  function _() {
    t.value = [];
  }
  const w = S(0);
  function b() {
    w.value += 1;
  }
  const C = E(
    () => e.value.filter((M) => M.status === "running").length
  ), A = E(() => e.value.filter((M) => M.status === "error").length), T = E(() => A.value > 0), R = E(() => {
    const M = e.value.filter((P) => P.status === "running");
    let L = 0, U = 0;
    for (const P of M)
      P.percent !== null && (L += Math.min(1, Math.max(0, P.percent / 100)), U += 1);
    return U === 0 ? null : Math.round(L / U * 100);
  });
  return q0() && yy(() => {
    for (const M of i.values()) clearTimeout(M);
    i.clear();
  }), {
    active: e,
    history: t,
    runningCount: C,
    errorCount: A,
    hasError: T,
    overallPercent: R,
    sync: p,
    cancel: m,
    retry: v,
    dismiss: x,
    open: k,
    clearHistory: _,
    revealRequests: w,
    reveal: b
  };
}
const dT = "filex.tourDone", c0 = "done", OZ = 900, PZ = 5e3;
function DZ() {
  try {
    return !!localStorage.getItem(dT);
  } catch {
    return !0;
  }
}
function av() {
  return DZ() || !!Qi().tour;
}
let Cr = null;
function fT() {
  try {
    localStorage.setItem(dT, "1");
  } catch {
  }
  if (!Kc()) return;
  if (o$()) {
    Qi().tour || Zi("tour", c0);
    return;
  }
  if (Cr) return;
  const e = Vc((t) => {
    e(), Cr = null, t.tour || Zi("tour", c0);
  });
  Cr = e;
}
function LZ(e, t = {}) {
  const n = t.delayMs ?? OZ, a = t.accountWaitMs ?? PZ;
  let i = !1, r, l, c;
  const p = () => {
    i = !0, r && clearTimeout(r), l && clearTimeout(l), c == null || c();
  };
  if (av()) return p;
  const m = () => {
    l && clearTimeout(l), c == null || c(), !(i || av()) && (fT(), e());
  };
  return r = setTimeout(() => {
    if (!(i || av())) {
      if (!Kc() || mF()) {
        m();
        return;
      }
      l = setTimeout(m, a), c = vF(m);
    }
  }, n), p;
}
function Lpe() {
  Cr == null || Cr(), Cr = null;
}
const RZ = ["aria-label"], NZ = {
  key: 0,
  class: "fe-tabs__scroll"
}, IZ = ["aria-selected", "title", "onClick", "onKeydown", "onAuxclick", "onDragstart", "onDragover", "onDragleave", "onDrop"], BZ = {
  key: 0,
  class: "fe-tabs__splitdot",
  "aria-hidden": "true"
}, FZ = { class: "fe-tabs__label" }, UZ = ["aria-label", "title", "onClick"], HZ = ["aria-label", "title"], KZ = ["aria-label", "title", "aria-pressed"], VZ = ["aria-pressed", "title", "aria-label"], jZ = /* @__PURE__ */ rt({
  __name: "TabBar",
  props: {
    tabs: {},
    activeId: {},
    locale: {},
    splitEnabled: { type: Boolean },
    splitActive: { type: Boolean },
    inspectorEnabled: { type: Boolean },
    inspectorOpen: { type: Boolean },
    hideTabs: { type: Boolean }
  },
  emits: ["select", "close", "new", "reorder", "toggle-split", "toggle-inspector"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(null), l = S(null);
    function c(w, b) {
      var C;
      r.value = w, b.dataTransfer && (b.dataTransfer.effectAllowed = "move", b.dataTransfer.setData("text/plain", ((C = n.tabs[w]) == null ? void 0 : C.id) ?? ""));
    }
    function p(w, b) {
      r.value !== null && (b.preventDefault(), b.stopPropagation(), b.dataTransfer && (b.dataTransfer.dropEffect = "move"), l.value = w);
    }
    function m(w) {
      l.value === w && (l.value = null);
    }
    function v(w, b) {
      r.value !== null && (b.preventDefault(), b.stopPropagation(), r.value !== w && a("reorder", r.value, w), r.value = null, l.value = null);
    }
    function x() {
      r.value = null, l.value = null;
    }
    function k(w) {
      w.button === 1 && w.preventDefault();
    }
    function _(w, b) {
      b.button === 1 && (b.preventDefault(), b.stopPropagation(), !(n.tabs.length <= 1) && a("close", w));
    }
    return (w, b) => (f(), h("div", {
      class: "fe-tabs",
      role: "tablist",
      "aria-label": u(i)("tabs.strip")
    }, [
      e.hideTabs ? D("", !0) : (f(), h("div", NZ, [
        (f(!0), h(Ce, null, nt(e.tabs, (C, A) => (f(), h("div", {
          key: C.id,
          class: Ne(["fe-tabs__tab", {
            "is-active": C.id === e.activeId,
            "is-dragover": l.value === A && r.value !== null && r.value !== A
          }]),
          role: "tab",
          "aria-selected": C.id === e.activeId ? "true" : "false",
          tabindex: "0",
          draggable: "true",
          title: C.label,
          onClick: (T) => a("select", C.id),
          onKeydown: za(vt((T) => a("select", C.id), ["prevent"]), ["enter"]),
          onMousedown: b[0] || (b[0] = (T) => k(T)),
          onAuxclick: (T) => _(C.id, T),
          onDragstart: (T) => c(A, T),
          onDragover: (T) => p(A, T),
          onDragleave: (T) => m(A),
          onDrop: (T) => v(A, T),
          onDragend: x
        }, [
          C.split ? (f(), h("span", BZ)) : D("", !0),
          d("span", FZ, [
            d("bdi", null, y(C.label), 1)
          ]),
          e.tabs.length > 1 ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-tabs__close",
            "aria-label": u(i)("tabs.close"),
            title: u(i)("tabs.close"),
            onClick: vt((T) => a("close", C.id), ["stop"])
          }, "×", 8, UZ)) : D("", !0)
        ], 42, IZ))), 128))
      ])),
      e.hideTabs ? D("", !0) : (f(), h("button", {
        key: 1,
        type: "button",
        class: "fe-tabs__new",
        "aria-label": u(i)("tabs.new"),
        title: u(i)("tabs.new"),
        onClick: b[1] || (b[1] = (C) => a("new"))
      }, "+", 8, HZ)),
      e.splitEnabled !== !1 ? (f(), h("button", {
        key: 2,
        type: "button",
        class: Ne(["fe-tabs__split", { "is-active": e.splitActive }]),
        "aria-label": e.splitActive ? u(i)("tabs.split_off") : u(i)("tabs.split"),
        title: e.splitActive ? u(i)("tabs.split_off") : u(i)("tabs.split"),
        "aria-pressed": e.splitActive ? "true" : "false",
        "data-testid": "tabs-split",
        onClick: b[2] || (b[2] = (C) => a("toggle-split"))
      }, [...b[4] || (b[4] = [
        d("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("rect", {
            x: "3",
            y: "4",
            width: "18",
            height: "16",
            rx: "2"
          }),
          d("path", { d: "M12 4v16" })
        ], -1)
      ])], 10, KZ)) : D("", !0),
      e.inspectorEnabled ? (f(), h("button", {
        key: 3,
        type: "button",
        class: Ne(["fe-tabs__inspector", { "is-active": e.inspectorOpen }]),
        "aria-pressed": e.inspectorOpen ? "true" : "false",
        title: u(i)("toolbar.inspector"),
        "aria-label": u(i)("toolbar.inspector"),
        "data-testid": "tabs-inspector",
        onClick: b[3] || (b[3] = (C) => a("toggle-inspector"))
      }, [...b[5] || (b[5] = [
        d("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "1.8",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("circle", {
            cx: "12",
            cy: "12",
            r: "9"
          }),
          d("path", { d: "M12 11v5" }),
          d("circle", {
            cx: "12",
            cy: "7.6",
            r: "1",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 10, VZ)) : D("", !0)
    ], 8, RZ));
  }
}), pT = Symbol("filex.e2eLock"), qZ = ["width", "height"], WZ = { class: "fe-state__title" }, YZ = { class: "fe-state__hint" }, GZ = ["placeholder", "aria-label", "disabled"], XZ = ["disabled"], JZ = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, hT = /* @__PURE__ */ rt({
  __name: "E2eLockScreen",
  props: {
    locale: {},
    busy: { type: Boolean, default: !1 },
    error: { default: "" },
    showRecovery: { type: Boolean, default: !0 },
    compact: { type: Boolean, default: !1 }
  },
  emits: ["unlock", "recovery"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = S("");
    function c() {
      !l.value || a.busy || i("unlock", l.value);
    }
    return t({ clear: () => l.value = "" }), (p, m) => (f(), h("div", {
      class: Ne(["fe-state fe-e2e-lock", { "fe-e2e-lock--compact": e.compact }]),
      "data-testid": "e2e-lock"
    }, [
      (f(), h("svg", {
        class: "fe-state__art",
        viewBox: "0 0 120 100",
        width: e.compact ? 80 : 110,
        height: e.compact ? 67 : 92,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true"
      }, [...m[2] || (m[2] = [
        d("rect", {
          x: "38",
          y: "44",
          width: "44",
          height: "34",
          rx: "6"
        }, null, -1),
        d("path", { d: "M46 44v-8a14 14 0 0 1 28 0v8" }, null, -1),
        d("circle", {
          cx: "60",
          cy: "59",
          r: "3",
          fill: "currentColor",
          stroke: "none"
        }, null, -1),
        d("path", { d: "M60 62v7" }, null, -1)
      ])], 8, qZ)),
      d("p", WZ, y(u(r)("e2e.locked.title")), 1),
      d("p", YZ, y(u(r)("e2e.locked.hint")), 1),
      d("form", {
        class: "fe-e2e-lock__form",
        onSubmit: vt(c, ["prevent"])
      }, [
        cn(d("input", {
          "onUpdate:modelValue": m[0] || (m[0] = (v) => l.value = v),
          type: "password",
          class: "fe-input fe-e2e-lock__input",
          placeholder: u(r)("e2e.locked.pw_placeholder"),
          "aria-label": u(r)("e2e.locked.pw_placeholder"),
          autocomplete: "current-password",
          disabled: e.busy
        }, null, 8, GZ), [
          [xn, l.value]
        ]),
        d("button", {
          type: "submit",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !l.value
        }, y(e.busy ? u(r)("e2e.locked.busy") : u(r)("e2e.locked.unlock")), 9, XZ)
      ], 32),
      e.error ? (f(), h("p", JZ, y(e.error), 1)) : D("", !0),
      e.showRecovery ? (f(), h("button", {
        key: 1,
        type: "button",
        class: "fe-e2e-optlink",
        onClick: m[1] || (m[1] = (v) => i("recovery"))
      }, y(u(r)("e2e.locked.use_recovery")), 1)) : D("", !0)
    ], 2));
  }
}), ZZ = ["aria-label"], QZ = ["aria-current", "title", "aria-label"], eQ = ["innerHTML"], tQ = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, nQ = ["aria-current", "onClick", "onContextmenu", "onDrop"], aQ = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, iQ = ["aria-expanded", "aria-label", "title"], oQ = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, rQ = ["onClick"], sQ = ["aria-current", "onClick", "onContextmenu", "onDrop"], lQ = {
  key: 0,
  class: "fe-breadcrumb__sep",
  "aria-hidden": "true"
}, uQ = ["aria-expanded", "title", "aria-label"], cQ = ["innerHTML"], dQ = {
  key: 0,
  class: "fe-breadcrumb__menu",
  role: "menu"
}, fQ = ["onClick"], pQ = {
  key: 0,
  class: "fe-breadcrumb__menu-empty"
}, hQ = ["title", "aria-label"], mQ = ["innerHTML"], vQ = ["placeholder", "onKeydown"], yQ = 4, gQ = /* @__PURE__ */ rt({
  __name: "Breadcrumb",
  props: {
    dirname: {},
    adapter: {},
    rootLabel: {},
    locale: {},
    multiStorageRoot: { type: Boolean },
    rootPath: {},
    subfolders: {}
  },
  emits: ["navigate", "copy-path", "crumb-context", "crumb-drop"],
  setup(e, { emit: t }) {
    const n = e, a = E(() => {
      if (!n.rootPath) return "";
      const V = n.rootPath, G = V.indexOf("://");
      return (G >= 0 ? V.slice(G + 3) : V).replace(/^\/+|\/+$/g, "");
    }), i = E(() => {
      const V = a.value;
      if (!V) return n.rootLabel || n.adapter;
      const G = V.split("/");
      return G[G.length - 1] || n.rootLabel || n.adapter;
    }), { t: r } = ht(() => n.locale), l = bi(Nc, null), c = t, p = E(() => {
      const V = n.adapter ? `${n.adapter}://` : "", G = V && n.dirname.startsWith(V) ? n.dirname.slice(V.length) : n.dirname, q = G.split("/").filter(Boolean), B = (Ye) => (l == null ? void 0 : l.segmentLabel(Ye)) ?? null, K = [];
      if (n.rootPath) {
        const Ye = a.value, Oe = G.replace(/^\/+|\/+$/g, ""), Be = Ye && (Oe === Ye || Oe.startsWith(Ye + "/")) ? Oe.slice(Ye.length).replace(/^\/+/, "") : "";
        K.push({ label: i.value, adapterPath: n.rootPath });
        let qe = Ye;
        for (const Tt of Be.split("/").filter(Boolean))
          qe = qe ? `${qe}/${Tt}` : Tt, K.push({
            label: Zf(Tt, r) || fa(B(`${V}${qe}`) || Tt),
            adapterPath: `${V}${qe}`
          });
        return K;
      }
      n.multiStorageRoot ? (K.push({ label: "/", adapterPath: "" }), n.adapter && K.push({ label: n.rootLabel || n.adapter, adapterPath: V })) : (n.adapter || n.rootLabel) && K.push({
        label: n.rootLabel || n.adapter,
        adapterPath: V
      });
      let ke = "";
      for (const Ye of q) {
        ke = ke ? `${ke}/${Ye}` : Ye;
        const Oe = Zf(Ye, r) || fa(B(`${V}${ke}`) || Ye);
        K.push({ label: Oe, adapterPath: `${V}${ke}` });
      }
      return K;
    }), m = E(() => {
      const V = p.value[0];
      return V && n.multiStorageRoot && V.adapterPath === "" ? V : null;
    }), v = E(
      () => m.value ? p.value.slice(1) : p.value
    ), x = E(() => !!m.value && v.value.length === 0), k = E(() => v.value.length > yQ), _ = E(
      () => k.value ? v.value.slice(0, 1) : v.value
    ), w = E(
      () => k.value ? v.value.slice(1, -2) : []
    ), b = E(
      () => k.value ? v.value.slice(-2) : []
    ), C = S(!1), A = S(null), T = S(!1), R = S(null), M = E(() => C.value || T.value);
    function L() {
      C.value = !1, T.value = !1;
    }
    function U(V) {
      L(), c("navigate", V.adapterPath);
    }
    function P() {
      C.value = !1, T.value = !T.value;
    }
    function H(V) {
      var q, B;
      const G = V.target;
      if (!(G instanceof Node)) {
        L();
        return;
      }
      (q = A.value) != null && q.contains(G) || (B = R.value) != null && B.contains(G) || L();
    }
    function $(V) {
      V.key === "Escape" && (V.stopPropagation(), L());
    }
    Xe(M, (V) => {
      V ? (document.addEventListener("click", H, !0), document.addEventListener("keydown", $, !0)) : (document.removeEventListener("click", H, !0), document.removeEventListener("keydown", $, !0));
    }), Xe(p, L), Ct(() => {
      document.removeEventListener("click", H, !0), document.removeEventListener("keydown", $, !0);
    });
    function F(V) {
      c("navigate", V.adapterPath);
    }
    function I() {
      m.value && F(m.value);
    }
    function Z(V) {
      m.value && re(V, m.value);
    }
    function J(V) {
      m.value && W(V, m.value);
    }
    function re(V, G) {
      V.preventDefault(), V.stopPropagation(), c("crumb-context", {
        x: V.clientX,
        y: V.clientY,
        adapterPath: G.adapterPath,
        label: G.label
      });
    }
    function ve(V) {
      ti(V) && (V.preventDefault(), V.stopPropagation(), V.dataTransfer && (V.dataTransfer.dropEffect = "move"));
    }
    function W(V, G) {
      ti(V) && (V.preventDefault(), V.stopPropagation(), c("crumb-drop", G.adapterPath, V));
    }
    const z = S(!1), le = S(""), fe = S(null);
    function j() {
      const V = `${n.adapter}://`, G = n.dirname.startsWith(V) ? n.dirname.slice(V.length) : n.dirname;
      if (n.rootPath) {
        const q = a.value, B = G.replace(/^\/+|\/+$/g, ""), K = q && (B === q || B.startsWith(q + "/")) ? B.slice(q.length).replace(/^\/+/, "") : "";
        le.value = K ? `/${K}` : "/", z.value = !0, Jt(() => {
          var ke, Ye;
          (ke = fe.value) == null || ke.focus(), (Ye = fe.value) == null || Ye.select();
        });
        return;
      }
      if (n.multiStorageRoot)
        if (!n.adapter)
          le.value = "/";
        else {
          const q = G.replace(/^\/+|\/+$/g, "");
          le.value = q ? `/${n.adapter}/${q}` : `/${n.adapter}`;
        }
      else
        le.value = G;
      z.value = !0, Jt(() => {
        var q, B;
        (q = fe.value) == null || q.focus(), (B = fe.value) == null || B.select();
      });
    }
    function X() {
      const V = le.value.trim();
      if (z.value = !1, n.rootPath) {
        const q = V.replace(/^\/+|\/+$/g, ""), B = a.value, K = q ? B ? `${B}/${q}` : q : B;
        c("navigate", K ? `${n.adapter}://${K}` : `${n.adapter}://`);
        return;
      }
      if (n.multiStorageRoot) {
        const q = V.replace(/^\/+|\/+$/g, "");
        if (!q) {
          c("navigate", "");
          return;
        }
        const B = q.indexOf("/"), K = B === -1 ? q : q.slice(0, B), ke = B === -1 ? "" : q.slice(B + 1);
        c("navigate", ke ? `${K}://${ke}` : `${K}://`);
        return;
      }
      const G = V.replace(/^\/+|\/+$/g, "");
      G && c("navigate", `${n.adapter}://${G}`);
    }
    function te() {
      z.value = !1;
    }
    return (V, G) => (f(), h("nav", {
      class: "fe-breadcrumb",
      "aria-label": u(r)("breadcrumb.aria")
    }, [
      z.value ? cn((f(), h("input", {
        key: 1,
        ref_key: "pathInput",
        ref: fe,
        "onUpdate:modelValue": G[1] || (G[1] = (q) => le.value = q),
        type: "text",
        class: "fe-breadcrumb__input",
        placeholder: u(r)("breadcrumb.path_placeholder"),
        spellcheck: "false",
        autocomplete: "off",
        onKeydown: [
          za(vt(X, ["prevent"]), ["enter"]),
          za(vt(te, ["prevent"]), ["escape"])
        ],
        onBlur: te
      }, null, 40, vQ)), [
        [xn, le.value]
      ]) : (f(), h(Ce, { key: 0 }, [
        m.value ? (f(), h("button", {
          key: 0,
          type: "button",
          class: Ne(["fe-breadcrumb__crumb fe-breadcrumb__home", { "is-last": x.value }]),
          "aria-current": x.value ? "page" : void 0,
          title: u(r)("breadcrumb.root"),
          "aria-label": u(r)("breadcrumb.root"),
          "data-testid": "breadcrumb-home",
          onClick: I,
          onContextmenu: Z,
          onDragover: ve,
          onDrop: J
        }, [
          d("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(Pt)("home")
          }, null, 8, eQ),
          x.value ? D("", !0) : (f(), h("span", tQ, "›"))
        ], 42, QZ)) : D("", !0),
        (f(!0), h(Ce, null, nt(_.value, (q, B) => (f(), h("button", {
          key: q.adapterPath,
          class: Ne(["fe-breadcrumb__crumb", { "is-last": !k.value && B === _.value.length - 1 }]),
          type: "button",
          "aria-current": !k.value && B === _.value.length - 1 ? "page" : void 0,
          onClick: (K) => F(q),
          onContextmenu: (K) => re(K, q),
          onDragover: ve,
          onDrop: (K) => W(K, q)
        }, [
          d("span", null, [
            d("bdi", null, y(q.label), 1)
          ]),
          k.value || B < _.value.length - 1 ? (f(), h("span", aQ, "›")) : D("", !0)
        ], 42, nQ))), 128)),
        w.value.length ? (f(), h("span", {
          key: 1,
          ref_key: "moreWrapEl",
          ref: A,
          class: "fe-breadcrumb__more-wrap"
        }, [
          d("button", {
            type: "button",
            class: "fe-breadcrumb__more",
            "aria-haspopup": "menu",
            "aria-expanded": C.value,
            "aria-label": u(r)("breadcrumb.more"),
            title: u(r)("breadcrumb.more"),
            onClick: G[0] || (G[0] = (q) => C.value = !C.value)
          }, "…", 8, iQ),
          G[2] || (G[2] = d("span", {
            class: "fe-breadcrumb__sep",
            "aria-hidden": "true"
          }, "›", -1)),
          C.value ? (f(), h("div", oQ, [
            (f(!0), h(Ce, null, nt(w.value, (q) => (f(), h("button", {
              key: q.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (B) => U(q)
            }, [
              d("bdi", null, y(q.label), 1)
            ], 8, rQ))), 128))
          ])) : D("", !0)
        ], 512)) : D("", !0),
        (f(!0), h(Ce, null, nt(b.value, (q, B) => (f(), h("button", {
          key: q.adapterPath,
          class: Ne(["fe-breadcrumb__crumb", { "is-last": B === b.value.length - 1 }]),
          type: "button",
          "aria-current": B === b.value.length - 1 ? "page" : void 0,
          onClick: (K) => F(q),
          onContextmenu: (K) => re(K, q),
          onDragover: ve,
          onDrop: (K) => W(K, q)
        }, [
          d("span", null, [
            d("bdi", null, y(q.label), 1)
          ]),
          B < b.value.length - 1 ? (f(), h("span", lQ, "›")) : D("", !0)
        ], 42, sQ))), 128)),
        e.subfolders ? (f(), h("span", {
          key: 2,
          ref_key: "subWrapEl",
          ref: R,
          class: "fe-breadcrumb__sub-wrap"
        }, [
          d("button", {
            type: "button",
            class: "fe-breadcrumb__sub",
            "aria-haspopup": "menu",
            "aria-expanded": T.value,
            title: u(r)("breadcrumb.subfolders"),
            "aria-label": u(r)("breadcrumb.subfolders"),
            "data-testid": "breadcrumb-subfolders",
            onClick: P
          }, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("subfolders")
            }, null, 8, cQ)
          ], 8, uQ),
          T.value ? (f(), h("div", dQ, [
            (f(!0), h(Ce, null, nt(e.subfolders, (q) => (f(), h("button", {
              key: q.adapterPath,
              type: "button",
              class: "fe-breadcrumb__menu-item",
              role: "menuitem",
              onClick: (B) => U(q)
            }, [
              d("bdi", null, y(q.label), 1)
            ], 8, fQ))), 128)),
            e.subfolders.length ? D("", !0) : (f(), h("p", pQ, y(u(r)("breadcrumb.subfolders.empty")), 1))
          ])) : D("", !0)
        ], 512)) : D("", !0),
        d("button", {
          type: "button",
          class: "fe-breadcrumb__edit",
          title: u(r)("breadcrumb.go_to_path"),
          "aria-label": u(r)("breadcrumb.go_to_path"),
          "data-testid": "breadcrumb-edit-path",
          onClick: j
        }, [
          d("span", {
            class: "fe-icon",
            "aria-hidden": "true",
            innerHTML: u(Pt)("edit-path")
          }, null, 8, mQ)
        ], 8, hQ)
      ], 64))
    ], 8, ZZ));
  }
}), bQ = ["data-mode"], kQ = ["aria-label"], wQ = ["aria-expanded", "data-testid", "onClick"], _Q = { class: "fe-filterbar__label" }, xQ = { class: "fe-filterbar__find" }, SQ = ["placeholder", "aria-label", "value", "onKeydown"], $Q = {
  key: 2,
  class: "fe-filterbar__count",
  role: "status",
  "data-testid": "filter-count"
}, TQ = {
  key: 3,
  class: "fe-filterbar__sort"
}, AQ = ["disabled", "title"], EQ = { class: "fe-sr-only" }, CQ = {
  key: 0,
  class: "fe-ficon fe-filterbar__sortarrow",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false"
}, zQ = ["aria-label", "title", "disabled", "aria-expanded"], MQ = ["aria-label", "title", "aria-expanded"], OQ = ["dir", "role", "aria-label"], PQ = {
  key: 0,
  class: "fe-filterpop__rule",
  "aria-hidden": "true"
}, DQ = ["disabled", "aria-disabled", "data-testid", "onClick"], LQ = ["data-active", "data-testid", "onClick"], RQ = ["aria-selected", "data-checked", "data-active", "data-testid", "onClick"], NQ = {
  class: "fe-filterpop__tick",
  "aria-hidden": "true"
}, IQ = /* @__PURE__ */ rt({
  __name: "FilterBar",
  props: {
    value: {},
    locale: {},
    theme: {},
    shown: {},
    total: {},
    files: {},
    canPaste: { type: Boolean },
    canWrite: { type: Boolean },
    order: {},
    mode: {},
    findLabel: {}
  },
  emits: ["update:value", "new-folder", "upload", "paste", "select-all"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, dir: r } = ht(() => n.locale), l = E(() => (n.mode ?? "full") === "full"), c = E(() => n.findLabel || i("filter.find")), p = ["type", "people", "modified", "size"], m = [
      "any",
      "folder",
      "document",
      "spreadsheet",
      "presentation",
      "pdf",
      "image",
      "video",
      "audio",
      "archive",
      "code"
    ], v = ["any", "today", "7d", "30d", "year"], x = ["any", "lt1", "1to10", "10to100", "gt100"], k = E(() => _5(n.files ?? []));
    function _(oe) {
      return oe === "people" ? k.value.map((Se) => Se.value) : oe === "type" ? m : oe === "modified" ? v : x;
    }
    function w(oe, Se) {
      var he;
      return oe === "people" && Se.startsWith("u:") ? ((he = k.value.find((Ke) => Ke.value === Se)) == null ? void 0 : he.name) || Se.slice(2) : i(`filter.${oe}.${Se}`);
    }
    function b(oe) {
      const Se = oe === "people" ? n.value.people ?? "any" : n.value[oe];
      return Se === "any" ? i(`filter.${oe}`) : w(oe, Se);
    }
    function C(oe) {
      return oe === "people" ? n.value.people ?? "any" : n.value[oe];
    }
    const A = E(() => f5(n.value)), T = Rc(), R = E(() => T.key.value), M = E(() => T.dir.value === "asc"), L = E(() => n.order === "relevance"), U = E(() => L.value ? i("sort.relevance") : i(`col.${R.value}`)), P = E(
      () => L.value ? i("sort.relevance_why") : i(M.value ? "sort.asc" : "sort.desc")
    );
    Xe(() => n.locale, (oe) => rg(oe), { immediate: !0 });
    function H(oe) {
      T.setSort(oe), q(!0);
    }
    function $() {
      L.value || T.toggleSortDir();
    }
    function F() {
      L.value || G("sort");
    }
    const I = E(() => [
      { key: "new-folder", label: i("toolbar.new_folder"), disabled: n.canWrite === !1 },
      { key: "upload", label: i("toolbar.upload"), disabled: n.canWrite === !1 },
      { key: "paste", label: i("ctx.paste"), disabled: !n.canPaste || n.canWrite === !1 },
      { key: "sep", label: "", divider: !0, disabled: !0 },
      { key: "select-all", label: i("shortcuts.select_all"), disabled: !1 }
    ]);
    function Z(oe) {
      q(!0), oe === "new-folder" ? a("new-folder") : oe === "upload" ? a("upload") : oe === "paste" ? a("paste") : oe === "select-all" && a("select-all");
    }
    const J = S(null), re = S({ x: 0, y: 0 }), ve = S(null), W = S({});
    function z(oe, Se) {
      W.value[oe] = Se ?? null;
    }
    const le = E(
      () => J.value && J.value !== "sort" && J.value !== "actions" ? J.value : null
    ), fe = E(() => le.value ? _(le.value) : []), j = E(
      () => le.value ? i(`filter.${le.value}`) : J.value === "actions" ? i("filter.actions") : i("sort.by")
    );
    function X(oe) {
      return !!le.value && C(le.value) === oe;
    }
    function te(oe) {
      return le.value ? w(le.value, oe) : oe;
    }
    function V(oe) {
      le.value && B(le.value, oe);
    }
    async function G(oe) {
      var Le, ut, wt;
      if (J.value === oe) {
        q();
        return;
      }
      const Se = (Le = W.value[oe]) == null ? void 0 : Le.getBoundingClientRect(), he = Se ? Rr(Se, r.value) : 8;
      re.value = { x: he, y: Se ? Se.bottom + 6 : 8 }, J.value = oe, await Jt();
      const Ke = ve.value;
      if (Ke) {
        const _t = Ke.getBoundingClientRect();
        if (re.value = { ...re.value, x: Sc(he, _t.width, window.innerWidth, r.value) }, _t.bottom > window.innerHeight - 8) {
          const At = (ut = W.value[oe]) == null ? void 0 : ut.getBoundingClientRect();
          re.value = { ...re.value, y: Math.max(8, (At ? At.top : 0) - _t.height - 6) };
        }
        (wt = Ke.querySelector('[data-active="true"]')) == null || wt.focus();
      }
    }
    function q(oe = !1) {
      var he;
      const Se = J.value;
      J.value = null, oe && Se && ((he = W.value[Se]) == null || he.focus());
    }
    Xe(
      () => n.order,
      (oe) => {
        oe === "relevance" && J.value === "sort" && q();
      }
    );
    function B(oe, Se) {
      a("update:value", { ...n.value, [oe]: Se }), q(!0);
    }
    function K() {
      ke.value = "", a("update:value", {
        ...n.value,
        type: "any",
        modified: "any",
        size: "any",
        name: "",
        people: "any"
      });
    }
    const ke = S(n.value.name ?? "");
    Xe(
      () => n.value.name ?? "",
      (oe) => {
        oe !== ke.value.trim() && (ke.value = oe);
      }
    );
    let Ye;
    function Oe(oe) {
      ke.value = oe.target.value, Ye && clearTimeout(Ye), Ye = setTimeout(() => {
        a("update:value", { ...n.value, name: ke.value.trim() });
      }, 140);
    }
    function Be() {
      Ye && clearTimeout(Ye), ke.value = "", a("update:value", { ...n.value, name: "" });
    }
    Ct(() => {
      Ye && clearTimeout(Ye);
    });
    function qe(oe) {
      var he;
      if (!J.value) return;
      const Se = oe.target;
      (he = ve.value) != null && he.contains(Se) || Object.values(W.value).some((Ke) => Ke == null ? void 0 : Ke.contains(Se)) || q();
    }
    function Tt(oe) {
      oe.key === "Escape" && J.value && (oe.stopPropagation(), q(!0));
    }
    qt(() => {
      document.addEventListener("pointerdown", qe, !0), document.addEventListener("keydown", Tt, !0);
    }), Ct(() => {
      document.removeEventListener("pointerdown", qe, !0), document.removeEventListener("keydown", Tt, !0);
    });
    const $t = S(null), it = S({ start: !1, end: !1 });
    function yt() {
      const oe = $t.value;
      if (!oe) return;
      const Se = yv(oe);
      (Se.start !== it.value.start || Se.end !== it.value.end) && (it.value = Se);
    }
    let ft = null;
    function ze() {
      const oe = $t.value;
      if (!(!oe || !ft)) {
        ft.observe(oe);
        for (const Se of Array.from(oe.querySelectorAll(":scope > *, .fe-filterbar__chip"))) ft.observe(Se);
      }
    }
    return Xe(
      $t,
      (oe) => {
        ft == null || ft.disconnect(), ft = null, oe && (typeof ResizeObserver < "u" && (ft = new ResizeObserver(() => yt()), ze()), yt());
      },
      { flush: "post" }
    ), pM(() => {
      ze(), yt();
    }), Ct(() => {
      ft == null || ft.disconnect(), ft = null;
    }), (oe, Se) => (f(), h("div", {
      class: "fe-filterbar",
      "data-mode": l.value ? "full" : "find",
      "data-testid": "filterbar"
    }, [
      d("div", {
        ref_key: "trackEl",
        ref: $t,
        class: Ne(["fe-filterbar__track", { "is-more-start": it.value.start, "is-more-end": it.value.end }]),
        "data-testid": "filterbar-track",
        onScrollPassive: yt
      }, [
        l.value ? (f(), h("div", {
          key: 0,
          class: "fe-filterbar__chips",
          role: "group",
          "aria-label": u(i)("filter.aria")
        }, [
          (f(), h(Ce, null, nt(p, (he) => d("button", {
            key: he,
            ref_for: !0,
            ref: (Ke) => z(he, Ke),
            type: "button",
            class: Ne(["fe-filterbar__chip", { "is-set": C(he) !== "any", "is-open": J.value === he }]),
            "aria-expanded": J.value === he,
            "aria-haspopup": "listbox",
            "data-testid": `filter-${he}`,
            onClick: (Ke) => G(he)
          }, [
            d("span", _Q, y(b(he)), 1),
            Se[3] || (Se[3] = d("svg", {
              class: "fe-ficon fe-filterbar__caret",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1))
          ], 10, wQ)), 64))
        ], 8, kQ)) : D("", !0),
        d("div", xQ, [
          Se[4] || (Se[4] = d("svg", {
            class: "fe-ficon fe-filterbar__find-glass",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.9",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("circle", {
              cx: "11",
              cy: "11",
              r: "6.5"
            }),
            d("path", { d: "M16 16l4.5 4.5" })
          ], -1)),
          d("input", {
            type: "search",
            class: "fe-filterbar__find-input",
            placeholder: c.value,
            "aria-label": c.value,
            value: ke.value,
            "data-testid": "filter-find",
            onInput: Oe,
            onKeydown: za(vt(Be, ["stop", "prevent"]), ["esc"])
          }, null, 40, SQ)
        ]),
        l.value && A.value > 0 ? (f(), h("button", {
          key: 1,
          type: "button",
          class: "fe-filterbar__clear",
          "data-testid": "filter-clear",
          onClick: K
        }, y(u(i)("filter.clear")), 1)) : D("", !0),
        l.value && A.value > 0 && typeof e.shown == "number" && typeof e.total == "number" ? (f(), h("span", $Q, y(u(i)("filter.count", { shown: String(e.shown), total: String(e.total) })), 1)) : D("", !0),
        l.value ? (f(), h("div", TQ, [
          d("button", {
            ref: (he) => z("sort", he),
            type: "button",
            class: Ne(["fe-filterbar__sortdir", { "is-ranked": L.value }]),
            disabled: L.value,
            title: L.value ? P.value : void 0,
            "data-testid": "sort-dir",
            onClick: Se[0] || (Se[0] = (he) => $())
          }, [
            d("span", null, y(U.value), 1),
            d("span", EQ, ", " + y(P.value), 1),
            L.value ? D("", !0) : (f(), h("svg", CQ, [
              M.value ? (f(), h(Ce, { key: 0 }, [
                Se[5] || (Se[5] = d("path", { d: "M12 19V5" }, null, -1)),
                Se[6] || (Se[6] = d("path", { d: "M5 12l7-7 7 7" }, null, -1))
              ], 64)) : (f(), h(Ce, { key: 1 }, [
                Se[7] || (Se[7] = d("path", { d: "M12 5v14" }, null, -1)),
                Se[8] || (Se[8] = d("path", { d: "M19 12l-7 7-7-7" }, null, -1))
              ], 64))
            ]))
          ], 10, AQ),
          d("button", {
            type: "button",
            class: "fe-filterbar__sortpick",
            "aria-label": L.value ? P.value : u(i)("sort.by"),
            title: L.value ? P.value : u(i)("sort.by"),
            disabled: L.value,
            "aria-haspopup": "menu",
            "aria-expanded": J.value === "sort",
            "data-testid": "sort-menu",
            onClick: Se[1] || (Se[1] = (he) => F())
          }, [...Se[9] || (Se[9] = [
            d("svg", {
              class: "fe-ficon fe-filterbar__caret",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1)
          ])], 8, zQ)
        ])) : D("", !0)
      ], 34),
      l.value ? (f(), h("button", {
        key: 0,
        ref: (he) => z("actions", he),
        type: "button",
        class: "fe-filterbar__actions",
        "aria-label": u(i)("filter.actions"),
        title: u(i)("filter.actions"),
        "aria-haspopup": "menu",
        "aria-expanded": J.value === "actions",
        "data-testid": "listing-actions",
        onClick: Se[2] || (Se[2] = (he) => G("actions"))
      }, [...Se[10] || (Se[10] = [
        d("svg", {
          class: "fe-ficon",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "aria-hidden": "true",
          focusable: "false"
        }, [
          d("circle", {
            cx: "12",
            cy: "5.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          d("circle", {
            cx: "12",
            cy: "12",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          }),
          d("circle", {
            cx: "12",
            cy: "18.5",
            r: "1.2",
            fill: "currentColor",
            stroke: "none"
          })
        ], -1)
      ])], 8, MQ)) : D("", !0),
      (f(), We(wi, { to: "body" }, [
        J.value ? (f(), h("div", {
          key: 0,
          ref_key: "panelEl",
          ref: ve,
          class: Ne(["fe-filterpop", {
            "fe--theme-light": e.theme === "light",
            "fe--theme-dark": e.theme === "dark",
            "fe-filterpop--sort": J.value === "sort",
            "fe-filterpop--actions": J.value === "actions"
          }]),
          dir: u(r),
          role: J.value === "sort" || J.value === "actions" ? "menu" : "listbox",
          "aria-label": j.value,
          style: Xt({ left: re.value.x + "px", top: re.value.y + "px" })
        }, [
          J.value === "actions" ? (f(!0), h(Ce, { key: 0 }, nt(I.value, (he) => (f(), h(Ce, {
            key: he.key
          }, [
            he.divider ? (f(), h("hr", PQ)) : (f(), h("button", {
              key: 1,
              type: "button",
              class: "fe-filterpop__item",
              role: "menuitem",
              disabled: he.disabled,
              "aria-disabled": he.disabled,
              "data-active": "false",
              "data-testid": `listing-action-${he.key}`,
              onClick: (Ke) => Z(he.key)
            }, [
              d("span", null, y(he.label), 1)
            ], 8, DQ))
          ], 64))), 128)) : J.value === "sort" ? (f(!0), h(Ce, { key: 1 }, nt(u(og), (he) => (f(), h("button", {
            key: he,
            type: "button",
            class: "fe-filterpop__item",
            role: "menuitem",
            "data-active": R.value === he ? "true" : "false",
            "data-testid": `sort-opt-${he}`,
            onClick: (Ke) => H(he)
          }, [
            d("span", null, y(u(i)(`col.${he}`)), 1)
          ], 8, LQ))), 128)) : (f(!0), h(Ce, { key: 2 }, nt(fe.value, (he) => (f(), h("button", {
            key: he,
            type: "button",
            class: "fe-filterpop__item",
            role: "option",
            "aria-selected": X(he),
            "data-checked": X(he) ? "true" : "false",
            "data-active": X(he) ? "true" : "false",
            "data-testid": `filter-opt-${he}`,
            onClick: (Ke) => V(he)
          }, [
            d("span", NQ, y(X(he) ? "✓" : ""), 1),
            d("span", null, y(te(he)), 1)
          ], 8, RQ))), 128))
        ], 14, OQ)) : D("", !0)
      ]))
    ], 8, bQ));
  }
}), BQ = ["aria-label"], FQ = ["aria-selected", "title", "aria-label"], UQ = ["innerHTML"], HQ = ["aria-selected", "title", "aria-label"], KQ = ["innerHTML"], VQ = ["aria-selected", "title", "aria-label"], jQ = ["innerHTML"], qQ = /* @__PURE__ */ rt({
  __name: "ViewSwitcher",
  props: {
    viewMode: {},
    locale: {},
    modes: {}
  },
  emits: ["update:viewMode"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale);
    function r(l) {
      return !n.modes || n.modes.includes(l);
    }
    return (l, c) => (f(), h("div", {
      class: "fe-toolbar__view",
      role: "tablist",
      "aria-label": u(i)("toolbar.view_label")
    }, [
      r("list") ? (f(), h("button", {
        key: 0,
        type: "button",
        class: Ne(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "list" }]),
        role: "tab",
        "aria-selected": e.viewMode === "list",
        title: u(i)("toolbar.view.list"),
        "aria-label": u(i)("toolbar.view.list"),
        "data-testid": "view-list",
        onClick: c[0] || (c[0] = (p) => a("update:viewMode", "list"))
      }, [
        d("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(Pt)("view-list")
        }, null, 8, UQ)
      ], 10, FQ)) : D("", !0),
      r("grid") ? (f(), h("button", {
        key: 1,
        type: "button",
        class: Ne(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "grid" }]),
        role: "tab",
        "aria-selected": e.viewMode === "grid",
        title: u(i)("toolbar.view.grid"),
        "aria-label": u(i)("toolbar.view.grid"),
        "data-testid": "view-grid",
        onClick: c[1] || (c[1] = (p) => a("update:viewMode", "grid"))
      }, [
        d("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(Pt)("view-grid")
        }, null, 8, KQ)
      ], 10, HQ)) : D("", !0),
      r("gallery") ? (f(), h("button", {
        key: 2,
        type: "button",
        class: Ne(["fe-btn fe-btn--icon-only", { "is-active": e.viewMode === "gallery" }]),
        role: "tab",
        "aria-selected": e.viewMode === "gallery",
        title: u(i)("toolbar.view.gallery"),
        "aria-label": u(i)("toolbar.view.gallery"),
        "data-testid": "view-gallery",
        onClick: c[2] || (c[2] = (p) => a("update:viewMode", "gallery"))
      }, [
        d("span", {
          class: "fe-icon",
          "aria-hidden": "true",
          innerHTML: u(Pt)("view-gallery")
        }, null, 8, jQ)
      ], 10, VQ)) : D("", !0)
    ], 8, BQ));
  }
});
function WQ(e, t) {
  return typeof e != "number" || !Number.isFinite(e) ? "-" : e <= 0 ? t("trash.days_remaining_due") : t("trash.days_remaining", { n: e });
}
const YQ = ["aria-label", "innerHTML"], GQ = {
  key: 2,
  class: "fe-list__thumb"
}, XQ = ["innerHTML"], JQ = { class: "fe-list__name-wrap" }, ZQ = ["title"], QQ = {
  key: 0,
  class: "fe-list__badge"
}, eee = ["title", "aria-label"], tee = {
  key: 0,
  class: "fe-list__snippet"
}, nee = {
  key: 0,
  class: "fe-list__mark"
}, aee = ["title", "aria-label"], iee = { class: "tbl-pill__text" }, oee = ["title", "aria-label", "data-link-state"], ree = { class: "tbl-pill__text" }, see = ["title", "aria-label"], lee = {
  key: 6,
  class: "fe-list__kind"
}, uee = ["title", "aria-label", "onClick"], cee = {
  key: 0,
  class: "fe-colmenu__sep",
  role: "separator"
}, dee = {
  key: 1,
  class: "fe-colmenu__title"
}, fee = {
  key: 2,
  class: "fe-colmenu__hint"
}, pee = ["onClick"], hee = { class: "fe-colmenu__label" }, mee = ["onClick"], vee = { class: "fe-colmenu__label" }, yee = /* @__PURE__ */ rt({
  __name: "ListView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: { type: Function },
    authCredentials: {},
    keepBadgeFor: { type: Function },
    order: {},
    folderKey: {},
    theme: {},
    thumbSrc: { type: Function },
    trash: { type: Boolean }
  },
  emits: ["click-row", "dbl-row", "context-row", "item-drag-start", "item-drop-into", "star-change", "display-order", "peek", "peek-end"],
  setup(e, { emit: t }) {
    const n = e, a = t, {
      t: i,
      formatNodeSize: r,
      nodeSizeHint: l,
      formatDate: c,
      formatDateFull: p,
      formatMonthYear: m,
      zonedYearMonth: v,
      toDate: x,
      nodeDisplayName: k,
      dir: _
    } = ht(() => n.locale);
    function w(ee) {
      return Kr(Ic(ee), { t: i, formatDate: c, locale: n.locale });
    }
    function b(ee) {
      return Bc(ee, { t: i });
    }
    function C(ee) {
      return Fc(ee, { t: i });
    }
    function A(ee) {
      return zg(ee, { t: i });
    }
    function T(ee) {
      return n.selected.has(ee.path);
    }
    function R(ee, ge) {
      a("click-row", ee, Ag(ge, J.isTap(ge)));
    }
    function M(ee) {
      a("dbl-row", ee);
    }
    function L(ee, ge) {
      ge.preventDefault(), ge.stopPropagation(), a("context-row", ee, ge);
    }
    function U(ee, ge) {
      const ae = ge.currentTarget, xe = ae == null ? void 0 : ae.getBoundingClientRect();
      a("context-row", ee, {
        // ⚠ RTL: the button's START corner — its right one in RTL — so the menu
        // hangs from the control and opens the way the line reads.
        clientX: xe ? Rr(xe, _.value) : ge.clientX,
        clientY: xe ? xe.bottom : ge.clientY,
        preventDefault: () => {
        },
        stopPropagation: () => {
        }
      });
    }
    function P(ee, ge) {
      a("click-row", ee, Eg(ge));
    }
    function H(ee, ge) {
      Rg(
        ge,
        k(ee),
        n.selected.has(ee.path) ? n.selected.size : 1
      ), a("item-drag-start", ee, ge);
    }
    const $ = S(null);
    function F(ee, ge) {
      ee.type === "dir" && ti(ge) && (ge.preventDefault(), ge.stopPropagation(), ge.dataTransfer && (ge.dataTransfer.dropEffect = "move"), $.value = ee.path);
    }
    function I(ee) {
      $.value === ee.path && ($.value = null);
    }
    function Z(ee, ge) {
      $.value = null, ee.type === "dir" && ti(ge) && (ge.preventDefault(), ge.stopPropagation(), a("item-drop-into", ee, ge));
    }
    const J = Cg(
      (ee, ge) => a("context-row", ee, { ...ge, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (ee) => a("click-row", ee, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function re(ee) {
      return ee === "kept" ? "✓" : ee === "syncing" ? "⟳" : ee === "partial" ? "◐" : "☁";
    }
    function ve(ee) {
      return ee.basename === ".trash" || nc(ee);
    }
    function W(ee) {
      return c(ee, { time: !0 }) || "-";
    }
    function z(ee) {
      return p(ee);
    }
    function le(ee) {
      return ve(ee) ? "-" : Cv(ee, i);
    }
    function fe(ee) {
      return ee.type === "dir" || dp(ee) ? null : n.thumbSrc ? n.thumbSrc(ee) : ee.thumb_url ?? null;
    }
    const j = E(() => n.files.some((ee) => {
      var ge;
      return ee.type === "dir" && (((ge = ee.preview) == null ? void 0 : ge.length) ?? 0) > 0;
    }));
    function X(ee) {
      return n.thumbSrc ? n.thumbSrc(ee) : ee.thumb_url ?? null;
    }
    const te = E(() => it.value.includes("type"));
    function V(ee) {
      return ee.type === "dir" && !ve(ee);
    }
    function G(ee) {
      var xe;
      if ((xe = ee.extra_metadata) != null && xe.draft)
        return i("node.drafts");
      const ge = Or(ee);
      return [String(ee.storage ?? "").trim(), ge].filter(Boolean).join("/");
    }
    function q(ee) {
      const ge = ee.extra_metadata;
      if (ge != null && ge.purging) return i("trash.purging");
      const ae = ge == null ? void 0 : ge.ttl_days;
      return WQ(ae, i);
    }
    function B(ee) {
      const ge = ee.snippet;
      return typeof ge == "string" ? ge : "";
    }
    function K(ee) {
      return Mq(ee.matched);
    }
    const ke = Rc(), Ye = E(() => ke.key.value), Oe = E(() => n.order === "relevance");
    Xe(() => n.locale, (ee) => rg(ee), { immediate: !0 });
    const Be = E(
      () => Oe.value ? null : { key: Ye.value, dir: ke.dir.value }
    );
    function qe(ee) {
      Oe.value || og.includes(ee.key) && ke.chooseSortKey(ee.key);
    }
    const Tt = E(() => {
      if (n.trash) return ["type", "location", "owner", "modified", "remaining", "size"];
      const ee = ["type"];
      return n.showParentPath && ee.push("location"), ee.push("owner", "modified", "size"), n.starEnabled !== !1 && (n.apiBase || n.apiBase === "") && ee.push("star"), ee;
    }), $t = sS(() => n.folderKey ?? ""), it = E(
      () => $t.order().filter((ee) => ee !== "name" && Tt.value.includes(ee) && !$t.hidden(ee))
    ), yt = E(() => [
      { id: "name", label: i("col.name"), lead: !0, sortable: !0, class: "fe-list__col--name" },
      { id: "type", label: i("col.type"), sortable: !0, class: "fe-list__col--type", format: le },
      {
        id: "location",
        label: n.trash ? i("col.deleted_from") : i("col.location"),
        class: "fe-list__col--location",
        format: G,
        title: (ee) => G(ee) || void 0
      },
      {
        id: "owner",
        label: n.trash ? i("col.deleted_by") : i("col.owner"),
        class: "fe-list__col--owner",
        format: n.trash ? _e : _t,
        title: n.trash ? Ie : At
      },
      {
        id: "modified",
        label: n.trash ? i("col.deleted") : i("col.modified"),
        sortable: !0,
        sortDir: "desc",
        class: "fe-list__col--mod",
        format: (ee) => W(ee.last_modified),
        title: (ee) => z(ee.last_modified)
      },
      {
        id: "remaining",
        label: i("col.remaining"),
        class: "fe-list__col--remaining",
        format: q
      },
      {
        id: "size",
        label: i("col.size"),
        sortable: !0,
        class: "fe-list__col--size",
        // A folder the catalog does not cover in full says so: "≥ 1.2 GB", or
        // "—" when nothing below it is known (useLocale formatNodeSize).
        format: (ee) => r(ee),
        title: (ee) => l(ee)
      },
      { id: "star", label: i("col.star"), class: "fe-list__col--star", headerLabel: !1 }
    ]);
    function ft(ee) {
      const ge = k(ee);
      if (!n.showParentPath || it.value.includes("location")) return ge;
      const ae = G(ee);
      return ae ? `${ge} · ${ae}` : ge;
    }
    function ze(ee) {
      const ge = {
        tabindex: 0,
        "aria-label": k(ee),
        "data-fe-path": ee.path,
        draggable: "true"
      };
      return ee.type === "dir" && (ge.onPointerenter = (ae) => a("peek", ee, ae.currentTarget, ae.pointerType), ge.onPointerleave = () => a("peek-end"), ge.onPointerdown = () => a("peek-end")), ge;
    }
    function oe(ee) {
      var ge;
      return {
        "is-dir": ee.type === "dir",
        "is-trash": !!ee.trashed,
        "is-clipped": !!((ge = n.clipped) != null && ge.has(ee.path)),
        "is-droptarget": $.value === ee.path
      };
    }
    const Se = E(() => k4()), he = E(() => !!n.folderKey && Hv(n.folderKey));
    function Ke(ee) {
      x4({
        v: "list",
        ...Oe.value ? {} : { k: ke.key.value, d: ke.dir.value },
        c: $t.state()
      }), ee();
    }
    function Le(ee) {
      n.folderKey && iS(n.folderKey), ee();
    }
    const ut = E(() => {
      const ee = [], ge = [];
      for (const ae of n.files) (ve(ae) ? ee : ge).push(ae);
      return [...ee, ...ge.sort(ke.compareInOrder(n.order ?? "sort"))];
    }), wt = E(() => ({ t: i, formatMonthYear: m, zonedYearMonth: v }));
    Xe(
      ut,
      (ee) => a("display-order", ee),
      { immediate: !0 }
    );
    function _t(ee) {
      return Lp(ee) ? i("owner.you") : cc(ee) === null ? i("owner.system") : cg(ee) || i("owner.unknown");
    }
    function At(ee) {
      const ge = [_t(ee)];
      w5(ee) && ge.push(i("owner.external"));
      const ae = ee.last_actor_name, xe = ee.last_actor_self === !0, Fe = ee.last_actor_id;
      if (xe || typeof ae == "string" && ae) {
        const ye = xe ? i("owner.you") : String(ae);
        ye !== ge[0] && ge.push(i("owner.last_actor", { who: ye }));
      } else Fe === void 0 && cc(ee) !== null && ge.push(i("owner.last_actor", { who: i("owner.system") }));
      return ge.join(" · ");
    }
    function _e(ee) {
      return W_(ee) ? i("owner.you") : q_(ee) === null ? "-" : k5(ee) || i("owner.unknown");
    }
    function Ie(ee) {
      return q_(ee) === null && !W_(ee) ? i("trash.deleted_by_nobody") : _e(ee);
    }
    const pe = E(
      () => Pg(ut.value, {
        /* ⚠ `ranked` is half of this and not a detail: over a search's ranked
         * answer the key is still `modified` (nothing cleared it), the listing
         * just is not obeying it — see `lib/dateGroups.groupingActive`. */
        active: Og(Ye.value, n.order),
        dateOf: (ee) => x(ee.last_modified),
        /* ⚠ Folders are their OWN run, above the first date heading, and that is
         * what lets "folders before files" hold while sorted by date. The rule
         * used to be softened instead — rows sorted by date, folders floating to
         * the top of each bucket — because hoisting them all would have split a
         * bucket in two and drawn "Today" twice, once over the folders and once
         * over the files. A run of their own removes that reason, and a folder has
         * no meaningful modification date to file under anyway. */
        aside: (ee) => ve(ee) ? { id: "pinned" } : ee.type === "dir" ? { id: "dirs" } : null,
        labels: wt.value
      }).runs
    ), we = E(
      () => pe.value.map((ee) => ({ id: ee.id, label: ee.label ?? void 0, items: ee.items }))
    );
    return (ee, ge) => (f(), We(es, {
      rows: ut.value,
      groups: we.value,
      columns: yt.value,
      "column-store": u($t),
      candidates: Tt.value,
      metrics: u(rS),
      "row-key": (ae) => ae.path,
      locale: e.locale,
      theme: e.theme,
      loading: e.loading,
      empty: u(i)("empty.folder"),
      "aria-label": u(i)("list.aria"),
      framed: !1,
      selectable: "",
      "is-selected": T,
      sort: Be.value,
      "sort-closed": Oe.value ? u(i)("sort.relevance_why") : null,
      "row-class": oe,
      "row-attrs": ze,
      onSort: qe,
      onRowClick: R,
      onRowDblclick: M,
      onRowContextmenu: L,
      onCheckClick: P,
      onRowDragstart: H,
      onRowDragover: F,
      onRowDragleave: I,
      onRowDrop: Z,
      onRowTouchstart: ge[2] || (ge[2] = (ae, xe) => u(J).onTouchStart(ae, xe)),
      onRowTouchend: ge[3] || (ge[3] = (ae) => u(J).onTouchEnd(ae)),
      onRowTouchmove: ge[4] || (ge[4] = (ae) => u(J).onTouchMove(ae))
    }, {
      "cell-name": mt(({ row: ae }) => [
        u(Br)(ae) ? (f(), h("span", {
          key: 0,
          class: "fe-list__icon fe-list__icon--svg",
          role: "img",
          "aria-label": u(i)("e2e.badge"),
          innerHTML: u(vl)()
        }, null, 8, YQ)) : ae.type === "dir" && j.value ? (f(), We(Lg, {
          key: 1,
          shape: "mini",
          node: ae,
          "src-of": X,
          class: "fe-list__icon"
        }, null, 8, ["node"])) : (f(), h("span", GQ, [
          Je(qc, {
            node: ae,
            "src-of": fe,
            "type-badge": u(J$)(ae),
            note: A(ae),
            class: Ne(["fe-list__icon fe-list__icon--img", { "fe-thumb--page": u(Mg)(ae) }]),
            alt: "",
            "aria-hidden": "true"
          }, {
            default: mt(() => [
              d("span", {
                class: "fe-list__icon fe-list__icon--svg",
                "aria-hidden": "true",
                innerHTML: u(xa)(ae)
              }, null, 8, XQ)
            ]),
            _: 2
          }, 1032, ["node", "type-badge", "note", "class"])
        ])),
        d("div", JQ, [
          d("span", {
            class: "fe-list__name",
            title: ft(ae)
          }, [
            d("bdi", null, y(u(k)(ae)), 1),
            K(ae) ? (f(), h("span", QQ, y(u(i)("search.in_content")), 1)) : D("", !0),
            e.keepBadgeFor && e.keepBadgeFor(ae) ? (f(), h("span", {
              key: 1,
              class: Ne(["fe-keepbadge", "fe-keepbadge--" + e.keepBadgeFor(ae)]),
              title: u(i)("keep.badge_" + e.keepBadgeFor(ae)),
              role: "img",
              "aria-label": u(i)("keep.badge_" + e.keepBadgeFor(ae))
            }, y(re(e.keepBadgeFor(ae))), 11, eee)) : D("", !0)
          ], 8, ZQ),
          B(ae) ? (f(), h("span", tee, [
            (f(!0), h(Ce, null, nt(u(ly)(B(ae)), (xe, Fe) => (f(), h(Ce, { key: Fe }, [
              xe.match ? (f(), h("mark", nee, y(xe.text), 1)) : (f(), h(Ce, { key: 1 }, [
                Vt(y(xe.text), 1)
              ], 64))
            ], 64))), 128))
          ])) : D("", !0)
        ]),
        w(ae) ? (f(), h("span", {
          key: 3,
          class: "fe-applock tbl-pill",
          role: "img",
          title: w(ae),
          "aria-label": w(ae),
          "data-testid": "lock-badge"
        }, [
          ge[5] || (ge[5] = d("span", {
            class: "fe-applock__glyph",
            "aria-hidden": "true"
          }, "🔒", -1)),
          d("span", iee, y(u(i)("applock.badge")), 1)
        ], 8, aee)) : D("", !0),
        b(ae) ? (f(), h("span", {
          key: 4,
          class: Ne(["fe-symlink tbl-pill", "fe-symlink--" + b(ae).state]),
          role: "img",
          title: b(ae).why,
          "aria-label": b(ae).why,
          "data-testid": "symlink-badge",
          "data-link-state": b(ae).state
        }, [
          ge[6] || (ge[6] = d("span", {
            class: "fe-symlink__glyph",
            "aria-hidden": "true"
          }, "🔗", -1)),
          d("span", ree, y(b(ae).badge), 1)
        ], 10, oee)) : D("", !0),
        C(ae) ? (f(), h("span", {
          key: 5,
          class: "fe-unavailable",
          role: "img",
          title: C(ae).full,
          "aria-label": C(ae).full,
          "data-testid": "unavailable-badge"
        }, y(C(ae).badge), 9, see)) : D("", !0),
        V(ae) && !te.value ? (f(), h("span", lee, y(u(i)("node.folder")), 1)) : D("", !0)
      ]),
      "cell-star": mt(({ row: ae }) => {
        var xe;
        return [
          e.starEnabled !== !1 && typeof ae.id == "number" && ae.type === "file" ? (f(), h("span", {
            key: 0,
            class: "fe-list__star-hit",
            "data-fe-control": "",
            onClick: ge[0] || (ge[0] = vt(() => {
            }, ["stop"])),
            onDblclick: ge[1] || (ge[1] = vt(() => {
            }, ["stop"]))
          }, [
            Je(Dg, {
              starred: !!((xe = e.starredIds) != null && xe.has(ae.id)),
              "node-id": ae.id,
              "api-base": e.apiBase,
              "auth-headers": e.authHeaders,
              "auth-credentials": e.authCredentials,
              locale: e.locale,
              compact: "",
              onChange: (Fe) => a("star-change", ae, Fe)
            }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
          ], 32)) : D("", !0)
        ];
      }),
      actions: mt(({ row: ae }) => [
        d("button", {
          type: "button",
          class: "fe-list__menu",
          title: u(i)("toolbar.more"),
          "aria-label": u(i)("toolbar.more"),
          onClick: (xe) => U(ae, xe)
        }, [...ge[7] || (ge[7] = [
          d("span", { "aria-hidden": "true" }, "⋮", -1)
        ])], 8, uee)
      ]),
      "colmenu-extra": mt(({ close: ae }) => [
        he.value || Se.value > 0 ? (f(), h("div", cee)) : D("", !0),
        he.value || Se.value > 0 ? (f(), h("p", dee, y(u(i)("cols.folder_title")), 1)) : D("", !0),
        he.value || Se.value > 0 ? (f(), h("p", fee, y(u(i)("cols.folder_hint")), 1)) : D("", !0),
        he.value ? (f(), h("button", {
          key: 3,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (xe) => Le(ae)
        }, [
          d("span", hee, y(u(i)("cols.forget_folder")), 1)
        ], 8, pee)) : D("", !0),
        Se.value > 0 || he.value ? (f(), h("button", {
          key: 4,
          type: "button",
          class: "fe-colmenu__row",
          onClick: (xe) => Ke(ae)
        }, [
          d("span", vee, y(u(i)("cols.apply_all", { count: Se.value })), 1)
        ], 8, mee)) : D("", !0)
      ]),
      _: 1
    }, 8, ["rows", "groups", "columns", "column-store", "candidates", "metrics", "row-key", "locale", "theme", "loading", "empty", "aria-label", "sort", "sort-closed"]));
  }
}), gee = ["aria-label", "aria-busy"], bee = {
  key: 0,
  class: "fe-gal__heading",
  "aria-hidden": "true"
}, kee = ["aria-selected", "aria-label", "data-fe-path", "onClick", "onDblclick", "onContextmenu", "onDragstart", "onDragover", "onDragleave", "onDrop", "onTouchstartPassive"], wee = ["dir"], _ee = {
  key: 0,
  class: "fe-fprev__tint"
}, xee = ["innerHTML"], See = ["aria-label", "innerHTML"], $ee = ["innerHTML"], Tee = ["onClick"], Aee = {
  class: "fe-gal__meta",
  "aria-hidden": "true"
}, Eee = {
  key: 0,
  class: "fe-gal__meta-line"
}, Cee = ["title"], zee = ["title"], Mee = {
  key: 0,
  class: "fe-gal__meta-line"
}, Oee = ["title", "aria-label", "data-link-state"], Pee = {
  key: 1,
  class: "fe-gal__meta-line"
}, Dee = ["title", "aria-label"], Lee = {
  key: 2,
  class: "fe-gal__meta-line"
}, Ree = ["title", "aria-label"], Nee = {
  key: 0,
  class: "fe-gal__empty"
}, Iee = /* @__PURE__ */ rt({
  __name: "GalleryView",
  props: {
    files: {},
    selected: {},
    clipped: {},
    showParentPath: { type: Boolean },
    locale: {},
    loading: { type: Boolean },
    thumbSrc: {},
    starredIds: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    order: {},
    selectable: { type: Boolean, default: !0 }
  },
  emits: ["click-card", "dbl-card", "context-card", "item-drag-start", "item-drop-into", "star-change"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, nodeDisplayName: l, formatDate: c, formatMonthYear: p, zonedYearMonth: m, toDate: v } = ht(() => n.locale);
    function x(X) {
      return Kr(Ic(X), { t: i, formatDate: c, locale: n.locale });
    }
    function k(X) {
      return Bc(X, { t: i });
    }
    function _(X) {
      return Fc(X, { t: i });
    }
    function w(X) {
      return zg(X, { t: i });
    }
    const b = Rc(), C = E(
      () => Pg(n.files, {
        active: Og(b.key.value, n.order),
        dateOf: (X) => v(X.last_modified),
        aside: (X) => X.type === "dir" ? { id: "dirs" } : null,
        labels: { t: i, formatMonthYear: p, zonedYearMonth: m }
      })
    ), A = E(() => n.files.some((X) => {
      var te;
      return X.type === "dir" && (((te = X.preview) == null ? void 0 : te.length) ?? 0) > 0;
    }));
    function T(X) {
      return n.thumbSrc ? n.thumbSrc(X) : X.thumb_url ?? null;
    }
    const R = Z$({
      apiBase: n.apiBase,
      authHeaders: n.authHeaders ? () => n.authHeaders() : void 0,
      credentials: n.authCredentials,
      disabled: () => n.e2eActive === !0
    });
    Ct(() => R.dispose());
    function M(X) {
      return R.kindFor(X);
    }
    function L(X) {
      const te = R.get(X);
      return te ? [te] : [];
    }
    function U(X, te) {
      R.bind(X instanceof Element ? X : null, te);
    }
    function P(X) {
      return n.starEnabled === !1 ? !1 : n.apiBase !== void 0 && typeof X.id == "number" && X.type === "file";
    }
    function H(X) {
      return n.selected.has(X.path);
    }
    function $(X, te) {
      a("click-card", X, Eg(te));
    }
    function F(X, te) {
      a("click-card", X, Ag(te, le.isTap(te)));
    }
    function I(X) {
      a("dbl-card", X);
    }
    function Z(X, te) {
      te.preventDefault(), te.stopPropagation(), a("context-card", X, te);
    }
    function J(X, te) {
      Rg(
        te,
        l(X),
        n.selected.has(X.path) ? n.selected.size : 1
      ), a("item-drag-start", X, te);
    }
    const re = S(null);
    function ve(X, te) {
      X.type === "dir" && ti(te) && (te.preventDefault(), te.stopPropagation(), te.dataTransfer && (te.dataTransfer.dropEffect = "move"), re.value = X.path);
    }
    function W(X) {
      re.value === X.path && (re.value = null);
    }
    function z(X, te) {
      re.value = null, X.type === "dir" && ti(te) && (te.preventDefault(), te.stopPropagation(), a("item-drop-into", X, te));
    }
    const le = Cg(
      (X, te) => a("context-card", X, { ...te, preventDefault: () => {
      }, stopPropagation: () => {
      } }),
      {
        // A finger lifted on the item, off its controls, opens at touchend — see useRowTouch.
        onTap: (X) => a("click-card", X, { ctrl: !1, shift: !1, touch: !0 })
      }
    );
    function fe(X) {
      return c(X, { time: !0 });
    }
    function j(X) {
      const te = fe(X.last_modified);
      return [X.type === "dir" ? "" : r(X.size), te].filter((G) => !!G).join(" · ");
    }
    return (X, te) => (f(), h("div", {
      class: Ne(["fe-gal", { "is-loading": e.loading, "has-selection": e.selectable && e.selected.size > 0 }]),
      role: "listbox",
      "aria-multiselectable": "true",
      "aria-label": u(i)("gallery.aria"),
      "aria-busy": e.loading ? "true" : void 0
    }, [
      (f(!0), h(Ce, null, nt(e.files, (V) => {
        var G, q;
        return f(), h(Ce, {
          key: V.path
        }, [
          C.value.headingBefore(V) ? (f(), h("p", bee, y(C.value.headingBefore(V)), 1)) : D("", !0),
          d("div", {
            class: Ne(["fe-gal__card", {
              "is-selected": H(V),
              "is-dir": V.type === "dir",
              "is-trash": V.trashed,
              "is-clipped": (G = e.clipped) == null ? void 0 : G.has(V.path),
              "is-droptarget": re.value === V.path
            }]),
            tabindex: "0",
            role: "option",
            "aria-selected": H(V) ? "true" : "false",
            "aria-label": u(l)(V),
            "data-fe-path": V.path,
            draggable: "true",
            onClick: (B) => F(V, B),
            onDblclick: (B) => I(V),
            onContextmenu: (B) => Z(V, B),
            onDragstart: (B) => J(V, B),
            onDragover: (B) => ve(V, B),
            onDragleave: (B) => W(V),
            onDrop: (B) => z(V, B),
            onTouchstartPassive: (B) => u(le).onTouchStart(V, B),
            onTouchend: te[3] || (te[3] = //@ts-ignore
            (...B) => u(le).onTouchEnd && u(le).onTouchEnd(...B)),
            onTouchmovePassive: te[4] || (te[4] = //@ts-ignore
            (...B) => u(le).onTouchMove && u(le).onTouchMove(...B))
          }, [
            d("div", {
              class: "fe-gal__thumb",
              ref_for: !0,
              ref: (B) => U(B, V)
            }, [
              M(V) ? (f(), h(Ce, { key: 0 }, [
                (f(!0), h(Ce, null, nt(L(V), (B) => (f(), h("div", {
                  key: "fprev",
                  class: Ne(["fe-fprev", "fe-fprev--" + B.kind]),
                  dir: u(c2)(B.kind),
                  style: Xt(B.kind === "table" ? { "--fprev-cols": String(B.cols) } : void 0),
                  "aria-hidden": "true"
                }, [
                  B.kind === "table" ? (f(!0), h(Ce, { key: 0 }, nt(B.rows, (K, ke) => (f(), h(Ce, { key: ke }, [
                    (f(!0), h(Ce, null, nt(K, (Ye, Oe) => (f(), h("span", {
                      key: Oe,
                      class: Ne(["fe-fprev__cell", { "is-head": ke === 0 }])
                    }, y(Ye), 3))), 128))
                  ], 64))), 128)) : (f(!0), h(Ce, { key: 1 }, nt(B.lines, (K, ke) => (f(), h("div", {
                    key: ke,
                    class: "fe-fprev__line"
                  }, [
                    K.tint ? (f(), h("span", _ee, y(K.indent) + y(K.tint), 1)) : D("", !0),
                    Vt(y(K.text), 1)
                  ]))), 128))
                ], 14, wee))), 128)),
                L(V).length === 0 ? (f(), h("span", {
                  key: 0,
                  class: "fe-gal__icon fe-gal__icon--svg",
                  innerHTML: u(xa)(V)
                }, null, 8, xee)) : D("", !0)
              ], 64)) : V.type === "dir" && A.value && !u(Br)(V) ? (f(), We(Lg, {
                key: 1,
                shape: "fan",
                node: V,
                "src-of": T
              }, null, 8, ["node"])) : (f(), We(qc, {
                key: 2,
                node: V,
                "src-of": T,
                "video-badge": u(X$)(V),
                note: w(V),
                alt: V.basename,
                class: Ne({
                  "fe-thumb--page": u(Mg)(V)
                  /* gorunum:v1-preview — crop a page from its TOP */
                })
              }, {
                default: mt(() => [
                  u(Br)(V) ? (f(), h("span", {
                    key: 0,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    role: "img",
                    "aria-label": u(i)("e2e.badge"),
                    innerHTML: u(vl)()
                  }, null, 8, See)) : (f(), h("span", {
                    key: 1,
                    class: "fe-gal__icon fe-gal__icon--svg",
                    innerHTML: u(xa)(V)
                  }, null, 8, $ee))
                ]),
                _: 2
              }, 1032, ["node", "video-badge", "note", "alt", "class"])),
              e.selectable ? (f(), h("span", {
                key: 3,
                class: "fe-item-check fe-gal__check",
                "data-fe-control": "",
                onClick: vt((B) => $(V, B), ["stop"]),
                onDblclick: te[0] || (te[0] = vt(() => {
                }, ["stop"]))
              }, [
                Je(mg, {
                  on: H(V),
                  label: u(l)(V)
                }, null, 8, ["on", "label"])
              ], 40, Tee)) : D("", !0),
              P(V) ? (f(), h("div", {
                key: 4,
                class: "fe-gal__star",
                onClick: te[1] || (te[1] = vt(() => {
                }, ["stop"])),
                onDblclick: te[2] || (te[2] = vt(() => {
                }, ["stop"]))
              }, [
                Je(Dg, {
                  starred: !!((q = e.starredIds) != null && q.has(V.id)),
                  "node-id": V.id,
                  "api-base": e.apiBase,
                  "auth-headers": e.authHeaders,
                  "auth-credentials": e.authCredentials,
                  locale: e.locale,
                  compact: "",
                  card: "",
                  onChange: (B) => a("star-change", V, B)
                }, null, 8, ["starred", "node-id", "api-base", "auth-headers", "auth-credentials", "locale", "onChange"])
              ], 32)) : D("", !0),
              d("div", Aee, [
                j(V) ? (f(), h("span", Eee, y(j(V)), 1)) : D("", !0),
                e.showParentPath && u(Or)(V) ? (f(), h("span", {
                  key: 1,
                  class: "fe-gal__meta-line fe-gal__meta-line--path",
                  title: u(Or)(V)
                }, [
                  d("bdi", null, y(u(Or)(V)), 1)
                ], 8, Cee)) : D("", !0)
              ])
            ], 512),
            d("div", {
              class: "fe-gal__label",
              title: u(l)(V)
            }, [
              d("bdi", null, y(u(l)(V)), 1)
            ], 8, zee),
            k(V) ? (f(), h("div", Mee, [
              d("span", {
                class: Ne(["fe-symlink", "fe-symlink--" + k(V).state]),
                role: "img",
                title: k(V).why,
                "aria-label": k(V).why,
                "data-testid": "symlink-badge",
                "data-link-state": k(V).state
              }, [
                te[5] || (te[5] = d("span", {
                  class: "fe-symlink__glyph",
                  "aria-hidden": "true"
                }, "🔗", -1)),
                Vt(y(k(V).badge), 1)
              ], 10, Oee)
            ])) : D("", !0),
            _(V) ? (f(), h("div", Pee, [
              d("span", {
                class: "fe-unavailable",
                role: "img",
                title: _(V).full,
                "aria-label": _(V).full,
                "data-testid": "unavailable-badge"
              }, y(_(V).badge), 9, Dee)
            ])) : D("", !0),
            x(V) ? (f(), h("div", Lee, [
              x(V) ? (f(), h("span", {
                key: 0,
                class: "fe-applock",
                role: "img",
                title: x(V),
                "aria-label": x(V),
                "data-testid": "lock-badge"
              }, [
                te[6] || (te[6] = d("span", {
                  class: "fe-applock__glyph",
                  "aria-hidden": "true"
                }, "🔒", -1)),
                Vt(y(u(i)("applock.badge")), 1)
              ], 8, Ree)) : D("", !0)
            ])) : D("", !0)
          ], 42, kee)
        ], 64);
      }), 128)),
      !e.loading && e.files.length === 0 ? (f(), h("div", Nee, y(u(i)("empty.folder")), 1)) : D("", !0)
    ], 10, gee));
  }
}), Bee = ["dir", "aria-label"], Fee = { class: "fe-fpeek__head" }, Uee = { class: "fe-fpeek__name" }, Hee = {
  key: 0,
  class: "fe-fpeek__count"
}, Kee = {
  key: 0,
  class: "fe-fpeek__loading"
}, Vee = {
  key: 1,
  class: "fe-fpeek__list"
}, jee = { class: "fe-fpeek__tile" }, qee = ["innerHTML"], Wee = ["innerHTML"], Yee = ["innerHTML"], Gee = { class: "fe-fpeek__label" }, Xee = {
  key: 2,
  class: "fe-fpeek__more"
}, Jee = /* @__PURE__ */ rt({
  __name: "FolderPeek",
  props: {
    state: {},
    srcOf: { type: Function },
    locale: {}
  },
  setup(e) {
    const t = e, { t: n, dir: a, nodeDisplayName: i } = ht(() => t.locale), r = S(null), l = (m) => {
      if (m.type === "dir" || dp(m)) return !1;
      const v = xi(m);
      return v === "image" || v === "video" || oq(m);
    }, c = E(() => t.state ? Math.max(0, t.state.total - t.state.items.length) : 0);
    function p() {
      const m = r.value, v = t.state;
      if (!m || !v) return;
      const x = window.innerWidth, k = window.innerHeight, _ = m.offsetWidth, w = m.offsetHeight, b = ei(m), C = b === "rtl" ? v.anchor.right : v.anchor.left, A = Sc(C, _, x, b);
      let T = v.anchor.bottom + 6;
      T + w > k - 8 && (T = Math.max(8, v.anchor.top - w - 6)), m.style.insetInlineStart = `${Math.round(b === "rtl" ? x - A - _ : A)}px`, m.style.top = `${Math.round(T)}px`, m.style.zIndex = String(Ec(document.elementFromPoint(v.anchor.left + 1, v.anchor.top + 1)));
    }
    return Xe(
      () => t.state,
      async () => {
        await Jt(), p();
      }
    ), (m, v) => (f(), We(wi, { to: "body" }, [
      e.state ? (f(), h("div", {
        key: 0,
        ref_key: "box",
        ref: r,
        class: "fe-fpeek",
        dir: u(a),
        role: "tooltip",
        "data-fe-peek": "",
        "aria-label": u(i)(e.state.node)
      }, [
        d("p", Fee, [
          d("bdi", Uee, y(u(i)(e.state.node)), 1),
          e.state.loading ? D("", !0) : (f(), h("span", Hee, y(e.state.total === 0 ? u(n)("peek.empty") : u(n)("peek.items", { n: e.state.total })), 1))
        ]),
        e.state.loading ? (f(), h("p", Kee, y(u(n)("peek.loading")), 1)) : e.state.items.length ? (f(), h("ul", Vee, [
          (f(!0), h(Ce, null, nt(e.state.items, (x) => (f(), h("li", {
            key: x.path,
            class: "fe-fpeek__row"
          }, [
            d("span", jee, [
              l(x) ? (f(), We(qc, {
                key: 0,
                node: x,
                "src-of": e.srcOf,
                "type-badge": u(J$)(x),
                alt: "",
                class: "fe-fpeek__img"
              }, {
                default: mt(() => [
                  d("span", {
                    class: "fe-grid__tile--svg",
                    innerHTML: u(xa)(x)
                  }, null, 8, qee)
                ]),
                _: 2
              }, 1032, ["node", "src-of", "type-badge"])) : u(Br)(x) ? (f(), h("span", {
                key: 1,
                class: "fe-grid__tile--svg",
                innerHTML: u(vl)()
              }, null, 8, Wee)) : (f(), h("span", {
                key: 2,
                class: "fe-grid__tile--svg",
                innerHTML: u(xa)(x)
              }, null, 8, Yee))
            ]),
            d("bdi", Gee, y(u(i)(x)), 1)
          ]))), 128))
        ])) : D("", !0),
        !e.state.loading && c.value > 0 ? (f(), h("p", Xee, y(u(n)("peek.more", { n: c.value })), 1)) : D("", !0)
      ], 8, Bee)) : D("", !0)
    ]));
  }
}), Zee = 500, Qee = 3e4, ete = 8;
function tte(e, t = () => !0) {
  const n = Ea(null), a = /* @__PURE__ */ new Map();
  let i, r = 0;
  async function l(v) {
    const x = a.get(v);
    if (x && Date.now() - x.at < Qee) return x;
    const _ = [...(await e(v)).files ?? []].sort(Qf), w = { at: Date.now(), items: _.slice(0, ete), total: _.length };
    return a.set(v, w), w;
  }
  function c(v, x, k = "mouse") {
    if (v.type !== "dir" || k !== "mouse" || !x || !t()) return;
    const _ = ++r;
    clearTimeout(i), i = setTimeout(async () => {
      if (_ !== r) return;
      const w = x.getBoundingClientRect();
      n.value = { node: v, anchor: w, loading: !0, items: [], total: 0 };
      try {
        const b = await l(v.path);
        if (_ !== r) return;
        n.value = { node: v, anchor: w, loading: !1, items: b.items, total: b.total };
      } catch {
        _ === r && (n.value = null);
      }
    }, Zee);
  }
  function p() {
    r++, clearTimeout(i), i = void 0, n.value = null;
  }
  function m(v) {
    v ? a.delete(v) : a.clear();
  }
  return { state: n, enter: c, leave: p, forget: m };
}
const nte = ["data-pane", "data-testid", "aria-label"], ate = {
  key: 0,
  class: "fe-subhead"
}, ite = { class: "fe-subhead__actions" }, ote = ["title", "aria-label"], rte = {
  key: 2,
  class: "fe__skeleton",
  role: "status"
}, ste = { class: "fe-sr-only" }, lte = {
  key: 0,
  class: "fe-skel-grid",
  "aria-hidden": "true"
}, ute = {
  key: 1,
  class: "fe-skel-list",
  "aria-hidden": "true"
}, cte = {
  key: 3,
  class: "fe-state"
}, dte = { class: "fe-state__title" }, fte = { class: "fe-state__hint" }, pte = { class: "fe-state__actions" }, hte = { class: "fe-state__details" }, mte = { class: "fe-state__details-summary" }, vte = { class: "fe-state__details-pre" }, yte = {
  key: 4,
  class: "fe-state",
  "data-testid": "empty-filtered"
}, gte = { class: "fe-state__title" }, bte = { class: "fe-state__hint" }, kte = { class: "fe-state__actions" }, wte = { class: "fe-state" }, _te = { class: "fe-state__title" }, xte = "application/x-brf-files", Ste = "application/x-brf-files-src", $te = 500, d0 = /* @__PURE__ */ rt({
  __name: "FilePane",
  props: {
    paneId: {},
    api: {},
    locale: {},
    theme: {},
    focused: { type: Boolean },
    closable: { type: Boolean },
    path: {},
    selfDriven: { type: Boolean },
    qualify: {},
    toUser: {},
    clamp: {},
    rootLabel: {},
    rootPath: {},
    floor: {},
    multiRoot: { type: Boolean },
    virtualRows: {},
    trashVisible: { type: Boolean, default: !0 },
    navOffersTrash: { type: Boolean },
    rows: {},
    loading: { type: Boolean },
    error: {},
    order: {},
    viewMode: {},
    viewModes: {},
    showCrumbs: { type: Boolean, default: !0 },
    showFilterBar: { type: Boolean, default: !0 },
    filterMode: {},
    findLabel: {},
    showViewSwitcher: { type: Boolean, default: !0 },
    crumbSubfolders: {},
    folderKey: {},
    showParentPath: { type: Boolean },
    trash: { type: Boolean },
    clipped: {},
    extraFilters: {},
    extraFiltersOnServer: { type: Boolean },
    canWrite: { type: Boolean },
    canPaste: { type: Boolean },
    selected: {},
    filters: {},
    thumbSrc: {},
    folderPreviews: { type: Boolean },
    keepBadgeFor: {},
    starredIds: {},
    starOverrides: {},
    starEnabled: { type: Boolean },
    apiBase: {},
    authHeaders: {},
    authCredentials: {},
    e2eActive: { type: Boolean },
    bodyOverride: { type: Boolean },
    openTrigger: { default: "double" }
  },
  emits: ["activate", "close", "navigate", "open", "open-trash", "click-row", "context", "clear-selection", "display-order", "item-drag-start", "item-drop-into", "transfer", "update:viewMode", "update:filters", "crumb-context", "copy-path", "crumb-drop", "new-folder", "upload", "paste", "select-all", "clear-filters", "star-change", "retry"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = a.paneId === "main" ? Rc() : mS();
    jo(vS, l);
    const c = S(""), p = S([]), m = S(!1), v = S(""), x = S("");
    function k(_e) {
      return xi(_e) === "storage";
    }
    const _ = bi(Nc, null), w = bi(pT, null), b = S(""), C = S(!1), A = S(""), T = E(
      () => a.selfDriven && !!w && !!b.value && w.locked(b.value)
    );
    async function R(_e) {
      if (!(!w || !b.value || C.value)) {
        C.value = !0, A.value = "";
        try {
          const Ie = await w.unlock(b.value, _e);
          Ie ? A.value = Ie : await $(c.value);
        } finally {
          C.value = !1;
        }
      }
    }
    const M = E(() => a.selfDriven ? c.value : a.path ?? ""), L = E(
      () => a.selfDriven ? p.value : a.rows ?? []
    ), U = E(() => a.selfDriven ? m.value : !!a.loading), P = E(() => a.selfDriven ? v.value : a.error ?? ""), H = E(
      () => !!a.multiRoot && !(M.value ?? "").replace(/^\/+|\/+$/g, "")
    );
    async function $(_e) {
      const Ie = a.clamp(_e ?? c.value ?? "");
      m.value = !0, v.value = "";
      try {
        if (a.multiRoot && !Ie) {
          p.value = a.virtualRows ? a.virtualRows() : [], x.value = "", b.value = "", c.value = "", i("navigate", "");
          return;
        }
        const pe = await a.api.index(a.qualify(Ie));
        x.value = pe.perm || "";
        const we = typeof pe.e2e_root == "string" ? pe.e2e_root : "";
        we !== b.value && (A.value = ""), b.value = we;
        const ee = _ ? await _.decorate(pe.files, { root: we || null }) : pe.files;
        p.value = Tr(ee), jx(p.value, pe.adapter, pe.dirname, a.trashVisible !== !1, {
          navOffersTrash: a.navOffersTrash
        }) && qx(p.value, pe.adapter, a.api), c.value = a.toUser(pe.dirname), i("navigate", c.value);
      } catch (pe) {
        v.value = pe instanceof Error ? pe.message : String(pe);
      } finally {
        m.value = !1;
      }
    }
    a.selfDriven && $(a.path ?? "");
    function F(_e) {
      i("activate"), a.selfDriven ? $(_e) : i("navigate", _e);
    }
    const I = E(
      () => Jx(M.value) ? M.value : a.qualify(M.value)
    ), Z = E(() => {
      const _e = I.value, Ie = _e.indexOf("://");
      return Ie === -1 ? "" : _e.slice(0, Ie);
    });
    function J(_e) {
      if (i("activate"), !a.selfDriven) {
        i("navigate", _e);
        return;
      }
      if (a.multiRoot && !_e) {
        $("");
        return;
      }
      $(a.toUser(_e));
    }
    const re = tte(
      (_e) => a.api.index(_e),
      () => a.folderPreviews !== !1
    );
    function ve(_e) {
      return a.thumbSrc ? a.thumbSrc(_e) : _e.thumb_url ?? null;
    }
    function W() {
      re.leave();
    }
    Xe(L, () => re.forget()), qt(() => {
      window.addEventListener("scroll", W, !0), window.addEventListener("dragstart", W, !0), window.addEventListener("keydown", W, !0);
    }), Ct(() => {
      window.removeEventListener("scroll", W, !0), window.removeEventListener("dragstart", W, !0), window.removeEventListener("keydown", W, !0), re.leave();
    });
    const z = Xu(
      () => lg(a.filters),
      () => L.value,
      (_e) => _e.basename || "",
      () => a.api.matchNames
    ), le = E(() => {
      const _e = z.apply(Wv(L.value, a.filters));
      return l.sortListing(
        a.extraFilters && !a.extraFiltersOnServer ? Wv(_e, a.extraFilters) : _e,
        a.order ?? "sort"
      );
    }), fe = E(() => {
      const _e = new Set(a.starredIds ?? []);
      for (const Ie of L.value)
        typeof Ie.id == "number" && Ie.starred === !0 && _e.add(Ie.id);
      for (const [Ie, pe] of a.starOverrides ?? /* @__PURE__ */ new Map())
        pe ? _e.add(Ie) : _e.delete(Ie);
      return _e;
    }), j = E(() => Zs(a.filters) || !!a.extraFilters), X = E(
      () => H.value ? "find" : a.filterMode ?? "full"
    ), te = E(
      () => H.value ? r("filter.find.storages") : a.findLabel ?? ""
    ), V = E(
      () => L.value.filter((_e) => _e.type === "dir").map((_e) => ({ label: _e.basename, adapterPath: _e.path }))
    );
    let G = 0;
    function q() {
      return Date.now() - G < $te;
    }
    function B(_e, Ie) {
      if (!q()) {
        if (Ie.check) {
          i("activate"), i("click-row", _e, { ctrl: !0, shift: Ie.shift });
          return;
        }
        if (Ie.touch || a.openTrigger === "single") {
          G = Date.now(), Be(_e);
          return;
        }
        i("activate"), i("click-row", _e, { ctrl: Ie.ctrl, shift: Ie.shift });
      }
    }
    function K(_e) {
      q() || (G = Date.now(), Be(_e));
    }
    function ke(_e, Ie) {
      Ie.preventDefault(), Ie.stopPropagation(), i("activate"), i("context", _e, Ie);
    }
    function Ye(_e) {
      _e.preventDefault(), _e.stopPropagation(), i("activate"), i("clear-selection"), i("context", null, _e);
    }
    function Oe() {
      i("clear-selection");
    }
    function Be(_e) {
      if (i("activate"), _e.basename === ".trash") {
        i("open-trash");
        return;
      }
      if (_e.type === "dir" && a.selfDriven) {
        $(k(_e) ? _e.path : a.toUser(_e.path));
        return;
      }
      i("open", _e);
    }
    function qe(_e, Ie) {
      if (!Ie.dataTransfer) return;
      if (k(_e) || H.value || _e.basename === ".trash") {
        Ie.preventDefault();
        return;
      }
      const pe = L.value.filter((ee) => a.selected.has(ee.path) && !k(ee)).filter((ee) => {
        var ge;
        return !((ge = a.clipped) != null && ge.has(ee.path));
      }).map((ee) => ({ path: ee.path, basename: ee.basename, type: ee.type })), we = pe.length > 0 ? pe : [{ path: _e.path, basename: _e.basename, type: _e.type }];
      Ie.dataTransfer.setData(xte, JSON.stringify(we)), Ie.dataTransfer.setData(Ste, I.value), Ie.dataTransfer.setData("text/plain", we.map((ee) => ee.path).join(`
`)), Ie.dataTransfer.effectAllowed = "move", i("item-drag-start", _e, Ie);
    }
    const Tt = S(!1);
    function $t(_e) {
      return ti(_e);
    }
    function it(_e, Ie) {
      const pe = Af(_e);
      if (!pe || !Ie) return;
      const we = sy(_e), ee = pe.map((ge) => ge.path).filter((ge) => ge && ge !== Ie && !Ie.startsWith(ge + "/"));
      ee.length !== 0 && (_e.preventDefault(), _e.stopPropagation(), i("transfer", { sources: ee, targetWire: Ie, originWire: we }));
    }
    function yt(_e, Ie) {
      Tt.value = !1, !(_e.type !== "dir" || k(_e)) && $t(Ie) && i("item-drop-into", _e, Ie);
    }
    function ft(_e) {
      !$t(_e) || H.value || (_e.preventDefault(), _e.stopPropagation(), _e.dataTransfer && (_e.dataTransfer.dropEffect = "move"), Tt.value = !0);
    }
    function ze() {
      Tt.value = !1;
    }
    function oe(_e) {
      Tt.value = !1, !(!$t(_e) || H.value) && it(_e, I.value);
    }
    function Se() {
      return a.selfDriven ? $() : Promise.resolve();
    }
    function he() {
      const _e = (M.value ?? "").replace(/^\/+|\/+$/g, ""), Ie = (a.floor || "").replace(/^\/+|\/+$/g, "");
      if (!_e || _e === Ie) return;
      const pe = _e.lastIndexOf("/");
      F(pe === -1 ? "" : _e.slice(0, pe));
    }
    function Ke() {
      return M.value;
    }
    function Le() {
      return le.value.filter((_e) => !k(_e));
    }
    function ut() {
      return L.value.length;
    }
    function wt() {
      return L.value.map((_e) => _e.path);
    }
    function _t() {
      return a.selfDriven ? x.value : "";
    }
    function At() {
      return a.selfDriven ? b.value : "";
    }
    return t({ reload: Se, goUp: he, getPath: Ke, visibleNodes: Le, loadFolder: $, rowCount: ut, rowPaths: wt, dirPerm: _t, e2eRoot: At }), Xe(M, () => {
      Tt.value = !1;
    }), (_e, Ie) => (f(), h("section", {
      class: Ne(["fe__primary fe-pane", {
        "fe-pane--focus": e.focused,
        "fe-pane--split": e.paneId === "split",
        "fe-pane--dropover": Tt.value
      }]),
      "data-pane": e.paneId,
      "data-testid": `pane-${e.paneId}`,
      role: "region",
      "aria-label": e.paneId === "split" ? u(r)("split.pane") : u(r)("toolbar.view_label"),
      onPointerdownCapture: Ie[18] || (Ie[18] = (pe) => i("activate"))
    }, [
      e.showCrumbs || _e.$slots.heading || e.showViewSwitcher || e.closable ? (f(), h("div", ate, [
        Ln(_e.$slots, "heading", {}, () => [
          e.showCrumbs ? (f(), We(gQ, {
            key: 0,
            dirname: I.value,
            adapter: Z.value,
            "root-label": e.rootLabel || Z.value,
            locale: e.locale,
            "multi-storage-root": e.multiRoot,
            "root-path": e.rootPath,
            subfolders: e.crumbSubfolders ?? V.value,
            onNavigate: J,
            onCopyPath: Ie[0] || (Ie[0] = (pe) => i("copy-path", pe)),
            onCrumbContext: Ie[1] || (Ie[1] = (pe) => i("crumb-context", pe)),
            onCrumbDrop: Ie[2] || (Ie[2] = (pe, we) => i("crumb-drop", pe, we))
          }, null, 8, ["dirname", "adapter", "root-label", "locale", "multi-storage-root", "root-path", "subfolders"])) : D("", !0)
        ]),
        d("div", ite, [
          e.showViewSwitcher ? (f(), We(qQ, {
            key: 0,
            "view-mode": e.viewMode,
            locale: e.locale,
            modes: e.viewModes,
            "onUpdate:viewMode": Ie[3] || (Ie[3] = (pe) => {
              i("activate"), i("update:viewMode", pe);
            })
          }, null, 8, ["view-mode", "locale", "modes"])) : D("", !0),
          e.closable ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--icon-only fe-pane__close",
            title: u(r)("split.close"),
            "aria-label": u(r)("split.close"),
            "data-testid": "pane-close",
            onClick: Ie[4] || (Ie[4] = (pe) => i("close"))
          }, [...Ie[19] || (Ie[19] = [
            d("svg", {
              class: "fe-ficon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M6 6l12 12M18 6L6 18" })
            ], -1)
          ])], 8, ote)) : D("", !0)
        ])
      ])) : D("", !0),
      Ie[25] || (Ie[25] = d("div", { class: "fe-selbar-slot" }, null, -1)),
      e.showFilterBar ? (f(), We(IQ, {
        key: 1,
        value: e.filters,
        locale: e.locale,
        theme: e.theme,
        mode: X.value,
        "find-label": te.value,
        order: e.order,
        shown: le.value.length,
        total: L.value.length,
        files: L.value,
        "can-paste": e.canPaste,
        "can-write": e.canWrite,
        "onUpdate:value": Ie[5] || (Ie[5] = (pe) => {
          i("activate"), i("update:filters", pe);
        }),
        onNewFolder: Ie[6] || (Ie[6] = (pe) => {
          i("activate"), i("new-folder");
        }),
        onUpload: Ie[7] || (Ie[7] = (pe) => {
          i("activate"), i("upload");
        }),
        onPaste: Ie[8] || (Ie[8] = (pe) => {
          i("activate"), i("paste");
        }),
        onSelectAll: Ie[9] || (Ie[9] = (pe) => {
          i("activate"), i("select-all");
        })
      }, null, 8, ["value", "locale", "theme", "mode", "find-label", "order", "shown", "total", "files", "can-paste", "can-write"])) : D("", !0),
      Ln(_e.$slots, "banners"),
      d("div", {
        class: Ne(["fe__body", { "is-dropover": Tt.value }]),
        onClick: vt(Oe, ["self"]),
        onContextmenu: Ye,
        onDragover: ft,
        onDragleave: ze,
        onDrop: oe
      }, [
        e.bodyOverride ? Ln(_e.$slots, "body", { key: 0 }) : T.value ? (f(), We(hT, {
          key: 1,
          compact: "",
          locale: e.locale,
          busy: C.value,
          error: A.value,
          onUnlock: R,
          onRecovery: Ie[10] || (Ie[10] = (pe) => {
            var we;
            return (we = u(w)) == null ? void 0 : we.recovery(b.value);
          })
        }, null, 8, ["locale", "busy", "error"])) : U.value && L.value.length === 0 ? (f(), h("div", rte, [
          d("span", ste, y(u(r)("loading")), 1),
          e.viewMode !== "list" ? (f(), h("div", lte, [
            (f(), h(Ce, null, nt(8, (pe) => d("div", {
              key: pe,
              class: "fe-skel-card"
            }, [...Ie[20] || (Ie[20] = [
              d("div", { class: "fe-skel fe-skel--thumb" }, null, -1),
              d("div", { class: "fe-skel fe-skel--label" }, null, -1)
            ])])), 64))
          ])) : (f(), h("div", ute, [
            (f(), h(Ce, null, nt(8, (pe) => d("div", {
              key: pe,
              class: "fe-skel-row"
            }, [...Ie[21] || (Ie[21] = [
              d("div", { class: "fe-skel fe-skel--icon" }, null, -1),
              d("div", { class: "fe-skel fe-skel--name" }, null, -1),
              d("div", { class: "fe-skel fe-skel--size" }, null, -1),
              d("div", { class: "fe-skel fe-skel--date" }, null, -1)
            ])])), 64))
          ]))
        ])) : P.value && L.value.length === 0 ? (f(), h("div", cte, [
          Ie[22] || (Ie[22] = W0('<svg class="fe-state__art" viewBox="0 0 120 100" width="110" height="92" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="60" cy="50" r="28"></circle><path d="M60 36v18"></path><circle cx="60" cy="63" r="1.8" fill="currentColor" stroke="none"></circle><path d="M24 88h72" stroke-dasharray="3 5"></path></svg>', 1)),
          d("p", dte, y(u(r)("error.title")), 1),
          d("p", fte, y(u(r)("error.hint")), 1),
          d("div", pte, [
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: Ie[11] || (Ie[11] = (pe) => e.selfDriven ? $() : i("retry"))
            }, y(u(r)("error.retry")), 1)
          ]),
          d("details", hte, [
            d("summary", mte, y(u(r)("error.details")), 1),
            d("pre", vte, y(P.value), 1)
          ])
        ])) : !U.value && j.value && le.value.length === 0 && L.value.length > 0 ? (f(), h("div", yte, [
          Ie[23] || (Ie[23] = d("svg", {
            class: "fe-state__art",
            viewBox: "0 0 120 100",
            width: "110",
            height: "92",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("path", { d: "M26 28h68L68 58v24l-16 8V58z" })
          ], -1)),
          d("p", gte, y(u(r)("filter.empty.title")), 1),
          d("p", bte, y(u(r)("filter.empty.hint")), 1),
          d("div", kte, [
            d("button", {
              type: "button",
              class: "fe-btn",
              onClick: Ie[12] || (Ie[12] = (pe) => i("clear-filters"))
            }, y(u(r)("filter.clear")), 1)
          ])
        ])) : !U.value && L.value.length === 0 ? Ln(_e.$slots, "empty", { key: 5 }, () => [
          d("div", wte, [
            Ie[24] || (Ie[24] = d("svg", {
              class: "fe-state__art",
              viewBox: "0 0 120 100",
              width: "110",
              height: "92",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true"
            }, [
              d("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" })
            ], -1)),
            d("p", _te, y(u(r)("empty.folder")), 1)
          ])
        ]) : e.viewMode === "list" ? (f(), We(yee, {
          key: 6,
          files: le.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          trash: e.trash,
          locale: e.locale,
          loading: U.value,
          "folder-key": e.folderKey,
          theme: e.theme,
          "thumb-src": e.thumbSrc,
          "keep-badge-for": e.keepBadgeFor,
          "starred-ids": fe.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickRow: B,
          onDisplayOrder: Ie[13] || (Ie[13] = (pe) => i("display-order", pe)),
          onDblRow: K,
          onContextRow: ke,
          onItemDragStart: qe,
          onItemDropInto: yt,
          onStarChange: Ie[14] || (Ie[14] = (pe, we) => i("star-change", pe, we)),
          onPeek: u(re).enter,
          onPeekEnd: W
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "trash", "locale", "loading", "folder-key", "theme", "thumb-src", "keep-badge-for", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "onPeek"])) : e.viewMode === "grid" ? (f(), We(uy, {
          key: 7,
          files: le.value,
          order: e.order,
          sections: !0,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: U.value,
          "keep-badge-for": e.keepBadgeFor,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": fe.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: B,
          onDisplayOrder: Ie[15] || (Ie[15] = (pe) => i("display-order", pe)),
          onDblCard: K,
          onContextCard: ke,
          onItemDragStart: qe,
          onItemDropInto: yt,
          onStarChange: Ie[16] || (Ie[16] = (pe, we) => i("star-change", pe, we)),
          onPeek: u(re).enter,
          onPeekEnd: W
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "keep-badge-for", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials", "onPeek"])) : (f(), We(Iee, {
          key: 8,
          files: le.value,
          order: e.order,
          selected: e.selected,
          clipped: e.clipped,
          "show-parent-path": e.showParentPath,
          locale: e.locale,
          loading: U.value,
          "thumb-src": e.thumbSrc,
          "e2e-active": e.e2eActive,
          "starred-ids": fe.value,
          "star-enabled": e.starEnabled,
          "api-base": e.apiBase,
          "auth-headers": e.authHeaders,
          "auth-credentials": e.authCredentials,
          onClickCard: B,
          onDblCard: K,
          onContextCard: ke,
          onItemDragStart: qe,
          onItemDropInto: yt,
          onStarChange: Ie[17] || (Ie[17] = (pe, we) => i("star-change", pe, we))
        }, null, 8, ["files", "order", "selected", "clipped", "show-parent-path", "locale", "loading", "thumb-src", "e2e-active", "starred-ids", "star-enabled", "api-base", "auth-headers", "auth-credentials"]))
      ], 34),
      Je(Jee, {
        state: u(re).state.value,
        "src-of": ve,
        locale: e.locale
      }, null, 8, ["state", "locale"])
    ], 42, nte));
  }
});
function Tte(e) {
  const t = S([]), n = S(""), a = E(
    () => t.value.find((C) => C.id === n.value) ?? null
  ), i = E(() => t.value.findIndex((C) => C.id === n.value)), r = E(() => t.value.length > 1);
  function l() {
    if (!e.storageKey) return !1;
    try {
      const C = localStorage.getItem(e.storageKey);
      if (!C) return !1;
      const A = JSON.parse(C);
      if (!A || !Array.isArray(A.tabs) || A.tabs.length === 0) return !1;
      const T = [];
      for (const R of A.tabs) {
        if (!R || typeof R.path != "string") continue;
        const M = typeof R.viewMode == "string" && R.viewMode ? R.viewMode : "list", L = R.split, U = L && typeof L == "object" && typeof L.path == "string" ? {
          path: L.path,
          viewMode: typeof L.viewMode == "string" && L.viewMode ? L.viewMode : void 0
        } : null;
        T.push({
          id: typeof R.id == "string" && R.id ? R.id : il(),
          path: R.path,
          viewMode: M,
          split: U
        });
      }
      return T.length === 0 ? !1 : (t.value = T, n.value = T.some((R) => R.id === A.active) ? String(A.active) : T[0].id, !0);
    } catch {
      return !1;
    }
  }
  function c() {
    if (e.storageKey)
      try {
        localStorage.setItem(
          e.storageKey,
          JSON.stringify({ v: 1, active: n.value, tabs: t.value })
        );
      } catch {
      }
  }
  Xe([t, n], c, { deep: !0 });
  function p(C, A) {
    if (t.value.length > 0) return;
    const T = { id: il(), path: C, viewMode: A, split: null };
    t.value = [T], n.value = T.id;
  }
  function m(C) {
    const A = a.value;
    A && (C.path !== void 0 && (A.path = C.path), C.viewMode !== void 0 && (A.viewMode = C.viewMode));
  }
  function v(C, A) {
    const T = { id: il(), path: C, viewMode: A.viewMode, split: A.split ?? null }, R = i.value;
    return t.value.splice(R === -1 ? t.value.length : R + 1, 0, T), A.background || (n.value = T.id), T;
  }
  function x(C) {
    if (t.value.length <= 1) return null;
    const A = t.value.findIndex((M) => M.id === C);
    if (A === -1) return null;
    const T = t.value[A].id === n.value;
    if (t.value.splice(A, 1), !T) return null;
    const R = t.value[Math.min(A, t.value.length - 1)];
    return n.value = R.id, R;
  }
  function k(C) {
    const A = t.value.find((T) => T.id === C);
    return !A || A.id === n.value ? null : (n.value = A.id, A);
  }
  function _(C) {
    if (t.value.length < 2) return null;
    const A = i.value === -1 ? 0 : i.value, T = t.value[(A + C + t.value.length) % t.value.length];
    return k(T.id);
  }
  function w(C, A) {
    if (C === A || C < 0 || A < 0 || C >= t.value.length || A >= t.value.length) return;
    const T = [...t.value], [R] = T.splice(C, 1);
    T.splice(A, 0, R), t.value = T;
  }
  function b(C) {
    const A = a.value;
    A && (A.split = C);
  }
  return {
    tabs: t,
    activeId: n,
    activeTab: a,
    activeIndex: i,
    hasMultiple: r,
    restore: l,
    seed: p,
    syncActive: m,
    openTab: v,
    closeTab: x,
    activate: k,
    step: _,
    move: w,
    setSplit: b
  };
}
function mT(e, t) {
  const n = e.lastIndexOf(".");
  return n <= 0 ? `${e} (${t})` : `${e.slice(0, n)} (${t})${e.slice(n)}`;
}
function Ate(e, t) {
  if (e.length !== t.length) return !1;
  for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
  return !0;
}
async function Ete(e, t, n, a) {
  if (!t) return null;
  for (const i of a) {
    if (Ate(i, n)) continue;
    const r = await ux(e, t, i);
    if (r !== null) return Gi(r) ? null : r;
  }
  return null;
}
async function Cte(e, t, n) {
  var r;
  const a = Ol(e);
  return a.kind === "file" || a.kind === "dir" ? a.encoded ?? null : a.kind !== "long" && a.kind !== "longdir" ? null : (((r = await n.readSidecar(t, `${a.hash}.fxl.name`)) == null ? void 0 : r.trim()) ?? "") || null;
}
async function zte(e, t, n, a) {
  const i = [], r = [{ wire: t, id: e.rootId }];
  for (; r.length; ) {
    if (n.stopped()) return;
    const c = r.shift();
    let p;
    try {
      p = await n.list(c.wire);
    } catch {
      a.failed++;
      continue;
    }
    i.push({ ...c, rows: p });
    for (const m of p)
      m.type === "dir" && r.push({ wire: m.path, id: await Mv(e, c.id, m.basename) });
  }
  const l = i.map((c) => c.id);
  for (const c of i.reverse()) {
    const p = new Set(c.rows.map((m) => m.basename));
    for (const m of c.rows) {
      if (n.stopped()) return;
      const v = m.basename;
      if (v === ka) continue;
      const x = await cx(e, v, c.id, (C) => n.readSidecar(c.wire, C));
      if (x.state === "enc" || x.state === "sidecar") continue;
      a.seen++;
      const k = await Ete(e, await Cte(v, c.wire, n), c.id, l), _ = k ?? (x.state === "plain" ? v : null);
      if (_ === null || Gi(_)) {
        a.failed++;
        continue;
      }
      const w = m.type === "dir" ? { dirId: await Mv(e, c.id, v) } : {};
      let b = await Ov(e, _, c.id, w);
      for (let C = 2; p.has(b.stored) && C < 100; C++)
        b = await Ov(e, mT(_, C), c.id, w);
      if (p.has(b.stored)) {
        a.failed++;
        continue;
      }
      try {
        b.sidecar && await n.writeSidecar(c.wire, b.sidecar.name, b.sidecar.content), await n.rename(c.wire, m, b.stored), p.delete(v), p.add(b.stored), a.renamed++, k !== null && (a.repaired = (a.repaired ?? 0) + 1);
      } catch {
        a.failed++;
      }
    }
  }
}
function f0(e) {
  return typeof e.size != "number" || typeof e.last_modified != "number" ? null : `${e.size}:${e.last_modified}`;
}
async function Mte(e, t, n, a) {
  const i = [], r = [e], l = (c) => c.replace(/\/+$/, "") === e.replace(/\/+$/, "");
  for (; r.length; ) {
    if (t.stopped()) return;
    const c = r.shift();
    let p;
    try {
      p = await t.list(c);
    } catch {
      n.failed++;
      continue;
    }
    for (const m of p) {
      if (m.type === "dir") {
        r.push(m.path);
        continue;
      }
      l(c) && m.basename === ka || Ol(m.basename).kind !== "sidecar" && i.push({ dir: c, row: m });
    }
  }
  n.total = i.length;
  for (const { dir: c, row: p } of i) {
    if (t.stopped()) return;
    try {
      if (bl(await t.head(p.path))) {
        n.skipped++;
        continue;
      }
      if (typeof p.size == "number" && p.size > a.maxBytes) {
        t.writeLarge && await t.writeLarge(c, p, f0(p)) ? (n.done++, n.large = (n.large ?? 0) + 1) : n.tooBig++;
        continue;
      }
      const m = await t.read(p.path);
      if (m.byteLength > a.maxBytes) {
        n.tooBig++;
        continue;
      }
      const v = await t.encrypt(m);
      await t.write(c, p, new Blob([v], { type: "application/octet-stream" }), f0(p)), n.done++;
    } catch {
      n.failed++;
    }
  }
}
const dy = /* @__PURE__ */ new Set(), fy = S(0);
function Ote(e) {
  return dy.add(e), fy.value++, () => {
    dy.delete(e) && fy.value++;
  };
}
function Pte(e, t) {
  fy.value;
  for (const n of dy) {
    const a = n(e, t);
    if (a) return a;
  }
  return null;
}
const Dte = {
  key: 0,
  class: "fe-e2e-form",
  "data-testid": "e2e-too-big"
}, Lte = { class: "fe-e2e-rk__lead" }, Rte = { class: "fe-e2e-big__steps" }, Nte = { class: "fe-e2e-big__cmd" }, Ite = { "data-testid": "e2e-too-big-command" }, Bte = { class: "fe-e2e-names__hint" }, Fte = /* @__PURE__ */ rt({
  __name: "E2eTooBigModal",
  props: {
    open: { type: Boolean },
    locale: {},
    info: {}
  },
  emits: ["close", "download"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r } = ht(() => n.locale), l = S(!1);
    Xe(
      () => n.open,
      (m) => {
        m && (l.value = !1);
      }
    );
    const c = E(() => {
      const m = n.info;
      if (!m) return "";
      const v = r(m.limit);
      return m.size !== null ? i("e2e.big.lead", { name: m.name, size: r(m.size), limit: v }) : i("e2e.big.lead_grew", { name: m.name, limit: v });
    });
    async function p() {
      var v;
      const m = (v = n.info) == null ? void 0 : v.command;
      if (m)
        try {
          await navigator.clipboard.writeText(m), l.value = !0;
        } catch {
        }
    }
    return (m, v) => (f(), We(na, {
      open: e.open,
      title: u(i)("e2e.big.title"),
      size: "sm",
      onClose: v[2] || (v[2] = (x) => a("close"))
    }, {
      actions: mt(() => {
        var x;
        return [
          d("button", {
            type: "button",
            class: "fe-btn",
            onClick: v[0] || (v[0] = (k) => a("close"))
          }, y(u(i)("e2e.big.close")), 1),
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "e2e-too-big-download",
            onClick: v[1] || (v[1] = (k) => a("download"))
          }, y(((x = e.info) == null ? void 0 : x.encrypted.kind) === "folder" ? u(i)("e2e.big.download_folder") : u(i)("e2e.big.download_file")), 1)
        ];
      }),
      default: mt(() => [
        e.info ? (f(), h("div", Dte, [
          d("p", Lte, y(c.value), 1),
          d("p", null, y(u(i)("e2e.big.instead")), 1),
          d("ol", Rte, [
            d("li", null, y(e.info.encrypted.kind === "file" ? u(i)("e2e.big.step_file") : u(i)("e2e.big.step_folder")), 1),
            d("li", null, [
              Vt(y(u(i)("e2e.big.step_run")) + " ", 1),
              d("span", Nte, [
                d("code", Ite, y(e.info.command), 1),
                d("button", {
                  type: "button",
                  class: "fe-e2e-optlink",
                  "data-testid": "e2e-too-big-copy",
                  onClick: p
                }, y(l.value ? u(i)("e2e.big.copied") : u(i)("e2e.big.copy")), 1)
              ])
            ])
          ]),
          d("p", Bte, y(u(i)("e2e.big.other_ways")), 1)
        ])) : D("", !0)
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}), Ute = "filexfxe", vT = 1, hp = ".fxe", yT = 64 * 1024, Hte = [], zf = new TextEncoder().encode(Ute), kc = 13, Kte = 32;
function gT(e) {
  return typeof e == "string" && e.length > hp.length && e.toLowerCase().endsWith(hp);
}
function Vte() {
  const e = crypto.getRandomValues(new Uint8Array(4));
  return `encrypted-${Array.from(e, (t) => t.toString(16).padStart(2, "0")).join("")}${hp}`;
}
function jte(e) {
  return /^encrypted-[0-9a-f]{8}\.fxe$/i.test(e);
}
function p0(e, t) {
  return t ? Vte() : `${e}${hp}`;
}
function Fg(e) {
  const t = { v: 2, salt: e.salt, iter: e.iter, verify: e.verify, fmk: "wrapped", fmk_pw: e.fmk_pw };
  return e.rk && (t.rk = e.rk), e.esc && (t.esc = e.esc), t;
}
function h0(e) {
  return !!e.rk && typeof e.rk.salt == "string" && typeof e.rk.blob == "string";
}
function bT(e) {
  const t = new TextEncoder().encode(JSON.stringify(e));
  if (t.length === 0 || t.length > yT) throw new Error("e2e: the .fxe header is too large");
  const n = new Uint8Array(kc + t.length);
  return n.set(zf, 0), n[8] = vT, new DataView(n.buffer).setUint32(9, t.length, !1), n.set(t, kc), n;
}
function qte(e) {
  if (e.length < zf.length) return !1;
  for (let t = 0; t < zf.length; t++) if (e[t] !== zf[t]) return !1;
  return !0;
}
class Dr extends Error {
  constructor(t) {
    super(t), this.name = "FxeFormatError";
  }
}
function Wte(e) {
  if (e.length < kc || !qte(e)) throw new Dr("e2e: not a filex encrypted file (.fxe)");
  if (e[8] !== vT) throw new Dr(`e2e: unsupported .fxe version ${e[8]} - a newer filex wrote it`);
  const t = new DataView(e.buffer, e.byteOffset, e.byteLength).getUint32(9, !1);
  if (t === 0 || t > yT) throw new Dr("e2e: the .fxe header length is out of range");
  return t;
}
function m0(e, t) {
  if (typeof e != "string" || e.length === 0) return !1;
  try {
    const n = ta(e);
    return t === void 0 || n.length === t;
  } catch {
    return !1;
  }
}
function Yte(e, t) {
  var r, l, c, p, m;
  let n;
  try {
    n = JSON.parse(new TextDecoder("utf-8", { fatal: !0 }).decode(e));
  } catch {
    throw new Dr("e2e: the .fxe header is not readable");
  }
  const a = (v) => new Dr(`e2e: the .fxe header is damaged (${v})`);
  if (!n || typeof n != "object" || Array.isArray(n)) throw a("not an object");
  if (!m0(n.salt)) throw a("salt");
  if (typeof n.iter != "number" || !Number.isInteger(n.iter) || n.iter < 1 || n.iter > $x) throw a("iter");
  if (typeof n.verify != "string") throw a("verify");
  if (n.fmk !== "wrapped" || typeof n.fmk_pw != "string") throw a("fmk");
  if (n.rk !== void 0 && (typeof n.rk != "object" || typeof ((r = n.rk) == null ? void 0 : r.salt) != "string" || typeof ((l = n.rk) == null ? void 0 : l.blob) != "string"))
    throw a("rk");
  if (n.esc !== void 0 && (typeof n.esc != "object" || typeof ((c = n.esc) == null ? void 0 : c.kid) != "string" || typeof ((p = n.esc) == null ? void 0 : p.alg) != "string" || typeof ((m = n.esc) == null ? void 0 : m.blob) != "string"))
    throw a("esc");
  if (typeof n.dek != "string" || typeof n.name != "string") throw a("dek/name");
  if (!zc(n.chunk)) throw a("chunk");
  if (!m0(n.nonce, Fr)) throw a("nonce");
  if (typeof n.size != "number" || !Number.isSafeInteger(n.size) || n.size < 0) throw a("size");
  const i = [];
  if (n.req !== void 0) {
    if (!Array.isArray(n.req) || n.req.some((v) => typeof v != "string")) throw a("req");
    for (const v of n.req) Hte.includes(v) || i.push(v);
  }
  return { header: n, unsupported: i, prefixLength: t };
}
async function Gte(e) {
  const t = new Sp(e);
  try {
    const n = await t.read(kc), a = Wte(n), i = await t.read(a);
    if (i.length < a) throw new Dr("e2e: the .fxe file is truncated");
    return { parsed: Yte(i, kc + a), body: t.rest() };
  } catch (n) {
    throw await t.cancel().catch(() => {
    }), n;
  }
}
async function Xte(e, t) {
  const n = await T_(t, e.dek);
  if (!n || n.length !== Kte) return null;
  let a;
  try {
    a = await $p(new Uint8Array(n));
  } finally {
    n.fill(0);
  }
  const i = await T_(t, e.name);
  if (!i) return null;
  let r;
  try {
    r = new TextDecoder("utf-8", { fatal: !0 }).decode(i);
  } catch {
    return null;
  }
  return Gi(r) ? null : { header: e, fmk: t, dek: a, name: r.normalize("NFC") };
}
async function Jte(e, t) {
  const n = Fg(e);
  let a;
  if ("password" in t) {
    const r = await Lx(n, t.password);
    if ("error" in r) return { error: r.error };
    a = r.fmk;
  } else if ("recoveryKey" in t) {
    if (a = await Rx(n, t.recoveryKey), !a) return { error: "wrong" };
  } else if (a = await Nx(n, t.escrowKey), !a) return { error: "wrong" };
  const i = await Xte(e, a);
  return i ? { key: i } : { error: "damaged" };
}
function Zte(e, t) {
  return { ...e, header: t };
}
async function Qte(e, t, n, a, i = {}) {
  const r = (e ?? "").normalize("NFC"), l = Gi(r);
  if (l) throw new Error(`e2e: invalid name (${l})`);
  if ((a ?? "").length < Gf)
    throw new Error(`e2e: the password must be at least ${Gf} characters`);
  if (!Number.isSafeInteger(t) || t < 0) throw new Error("e2e: bad file size");
  const c = i.chunkLog2 ?? xo;
  if (!zc(c)) throw new Error("e2e: bad chunk size");
  const p = await Fv(a, {
    escrowPublicKey: i.escrowPublicKey ?? null,
    iterations: i.iterations
  }), m = bx();
  let v, x;
  try {
    v = await $_(p.fmk, m), x = await $p(m);
  } finally {
    m.fill(0);
  }
  const k = vx(), _ = p.marker, w = {
    salt: _.salt,
    iter: _.iter,
    verify: _.verify,
    fmk: "wrapped",
    fmk_pw: _.fmk_pw,
    ..._.rk ? { rk: _.rk } : {},
    ..._.esc ? { esc: _.esc } : {},
    dek: v,
    name: await $_(p.fmk, new TextEncoder().encode(r)),
    chunk: c,
    nonce: Oa(k),
    size: t
  }, b = bT(w), C = n.pipeThrough(
    yx(x, k, c, { expectSize: t, onProgress: i.onProgress })
  );
  return {
    header: w,
    stream: Oc(b, C),
    size: b.length + qy(t, c),
    recoveryKey: p.recoveryKey,
    key: { header: w, fmk: p.fmk, dek: x, name: r }
  };
}
function iv(e, t) {
  const n = e.header;
  return t.pipeThrough(gx(e.dek, ta(n.nonce), n.chunk, { expectSize: n.size }));
}
async function ene(e, t, n) {
  const a = await Ux(Fg(e), t, n);
  if (a.fmk !== "wrapped" || !a.fmk_pw) throw new un("e2e: the password slot did not re-seal");
  return { ...e, salt: a.salt, iter: a.iter, verify: a.verify, fmk: "wrapped", fmk_pw: a.fmk_pw };
}
function tne(e, t) {
  const n = bT(e);
  return { stream: Oc(n, t), size: n.length + qy(e.size, e.chunk) };
}
const vi = 1024 * 1024 * 1024;
function kT() {
  if (typeof window > "u") return null;
  const e = window;
  return typeof e.showSaveFilePicker == "function" && e.isSecureContext !== !1 ? e.showSaveFilePicker.bind(window) : null;
}
function nne() {
  return kT() !== null;
}
class Ys extends Error {
  constructor() {
    super("save cancelled"), this.name = "SaveCancelled";
  }
}
class Mf extends Error {
  constructor() {
    super("the save dialog needs a click"), this.name = "SaveNeedsGesture";
  }
}
class Xa extends Error {
  constructor(t, n) {
    super(`e2e: ${t} bytes is more than this browser can save from memory (${n})`), this.size = t, this.limit = n, this.name = "SaveTooLarge";
  }
}
async function ov(e, t) {
  const n = kT();
  if (n) {
    let a;
    try {
      a = await n({ suggestedName: e });
    } catch (i) {
      const r = i == null ? void 0 : i.name;
      throw r === "AbortError" ? new Ys() : r === "SecurityError" || r === "NotAllowedError" ? new Mf() : i;
    }
    return ane(e, a);
  }
  if (t !== void 0 && t > vi) throw new Xa(t, vi);
  return ine(e);
}
function ane(e, t) {
  let n = null;
  return {
    kind: "fsa",
    name: e,
    async write(a) {
      var l;
      n = await t.createWritable();
      const i = n, r = a.getReader();
      try {
        for (; ; ) {
          const { done: c, value: p } = await r.read();
          if (c) break;
          await i.write(p);
        }
        await i.close();
      } catch (c) {
        throw await i.abort(c).catch(() => {
        }), await r.cancel(c).catch(() => {
        }), await ((l = t.remove) == null ? void 0 : l.call(t).catch(() => {
        })), c;
      }
    },
    async discard() {
      var a;
      n && await n.abort().catch(() => {
      }), await ((a = t.remove) == null ? void 0 : a.call(t).catch(() => {
      }));
    }
  };
}
function ine(e) {
  return {
    kind: "blob",
    name: e,
    async write(t, n) {
      const a = [];
      let i = 0;
      const r = t.getReader();
      try {
        for (; ; ) {
          const { done: m, value: v } = await r.read();
          if (m) break;
          if (i += v.length, i > vi) throw new Xa(i, vi);
          a.push(new Blob([v]));
        }
      } catch (m) {
        throw await r.cancel(m).catch(() => {
        }), m;
      }
      const l = new Blob(a, { type: (n == null ? void 0 : n.mime) || "application/octet-stream" }), c = URL.createObjectURL(l), p = document.createElement("a");
      p.href = c, p.download = e, p.rel = "noopener", document.body.appendChild(p), p.click(), p.remove(), setTimeout(() => URL.revokeObjectURL(c), 6e4);
    },
    async discard() {
    }
  };
}
const wa = 4294967295, Of = 65535, one = new TextEncoder();
let rv = null;
function rne() {
  if (rv) return rv;
  const e = new Uint32Array(256);
  for (let t = 0; t < 256; t++) {
    let n = t;
    for (let a = 0; a < 8; a++) n = n & 1 ? 3988292384 ^ n >>> 1 : n >>> 1;
    e[t] = n >>> 0;
  }
  return rv = e, e;
}
function sne(e, t = 0) {
  const n = rne();
  let a = (t ^ wa) >>> 0;
  for (let i = 0; i < e.length; i++) a = n[(a ^ e[i]) & 255] ^ a >>> 8;
  return (a ^ wa) >>> 0;
}
class Lr {
  constructor(t) {
    Bt(this, "buf");
    Bt(this, "dv");
    Bt(this, "o", 0);
    this.buf = new Uint8Array(t), this.dv = new DataView(this.buf.buffer);
  }
  u16(t) {
    return this.dv.setUint16(this.o, t, !0), this.o += 2, this;
  }
  u32(t) {
    return this.dv.setUint32(this.o, t >>> 0, !0), this.o += 4, this;
  }
  u64(t) {
    return this.dv.setUint32(this.o, t % 2 ** 32, !0), this.dv.setUint32(this.o + 4, Math.floor(t / 2 ** 32), !0), this.o += 8, this;
  }
  bytes(t) {
    return this.buf.set(t, this.o), this.o += t.length, this;
  }
  done() {
    if (this.o !== this.buf.length) throw new Error(`zip: record size ${this.o} != ${this.buf.length}`);
    return this.buf;
  }
}
function lne(e) {
  const t = e.getFullYear();
  return t < 1980 ? { time: 0, date: 33 } : {
    time: e.getHours() << 11 | e.getMinutes() << 5 | Math.floor(e.getSeconds() / 2),
    date: Math.min(t, 2107) - 1980 << 9 | e.getMonth() + 1 << 5 | e.getDate()
  };
}
const wT = 2048, _T = 8, xT = 813, une = 33188, cne = 16877;
function dne(e) {
  const t = e.zip64Local ? 20 : 0, n = new Lr(30 + e.name.length + t).u32(67324752).u16(e.zip64Local ? 45 : 20).u16(wT | (e.dir ? 0 : _T)).u16(0).u16(e.time).u16(e.date).u32(0).u32(e.zip64Local ? wa : 0).u32(e.zip64Local ? wa : 0).u16(e.name.length).u16(t).bytes(e.name);
  return e.zip64Local && n.u16(1).u16(16).u64(0).u64(0), n.done();
}
function fne(e) {
  return e.zip64Local ? new Lr(24).u32(134695760).u32(e.crc).u64(e.size).u64(e.size).done() : new Lr(16).u32(134695760).u32(e.crc).u32(e.size).u32(e.size).done();
}
function pne(e, t) {
  const n = t || e.size >= wa, a = t || e.offset >= wa, i = n || a ? 4 + (n ? 16 : 0) + (a ? 8 : 0) : 0, r = new Lr(46 + e.name.length + i).u32(33639248).u16(xT).u16(n || a || e.zip64Local ? 45 : 20).u16(wT | (e.dir ? 0 : _T)).u16(0).u16(e.time).u16(e.date).u32(e.crc).u32(n ? wa : e.size).u32(n ? wa : e.size).u16(e.name.length).u16(i).u16(0).u16(0).u16(0).u32((e.dir ? cne : une) * 65536 + (e.dir ? 16 : 0) >>> 0).u32(a ? wa : e.offset).bytes(e.name);
  return i && (r.u16(1).u16(i - 4), n && r.u64(e.size).u64(e.size), a && r.u64(e.offset)), r.done();
}
function hne(e, t, n, a) {
  const i = [], r = a || e >= Of || t >= wa || n >= wa;
  if (r) {
    const l = t + n;
    i.push(
      new Lr(56).u32(101075792).u64(44).u16(xT).u16(45).u32(0).u32(0).u64(e).u64(e).u64(n).u64(t).done()
    ), i.push(new Lr(20).u32(117853008).u32(0).u64(l).u32(1).done());
  }
  return i.push(
    new Lr(22).u32(101010256).u16(0).u16(0).u16(r ? Of : e).u16(r ? Of : e).u32(r ? wa : n).u32(r ? wa : t).u16(0).done()
  ), i;
}
function mne(e, t) {
  const n = e.replace(/\\/g, "/").split("/").filter((a) => a !== "" && a !== ".");
  if (n.length === 0 || n.some((a) => a === "..")) throw new Error(`zip: unsafe entry name ${JSON.stringify(e)}`);
  return n.join("/") + (t ? "/" : "");
}
async function* vne(e, t) {
  const n = !!t.forceZip64, a = [];
  let i = 0;
  const r = (p) => {
    var m;
    return i += p.length, (m = t.onProgress) == null || m.call(t, i), p;
  };
  for await (const p of e) {
    const m = p.name.endsWith("/") && !p.data, v = one.encode(mne(p.name, m));
    if (v.length > Of) throw new Error("zip: entry name too long");
    const { time: x, date: k } = lne(p.mtime ?? /* @__PURE__ */ new Date()), _ = {
      name: v,
      dir: m,
      zip64Local: !m && (n || p.sizeHint === void 0 || p.sizeHint >= wa),
      crc: 0,
      size: 0,
      offset: i,
      time: x,
      date: k
    };
    if (yield r(dne(_)), !m && p.data) {
      const b = (typeof p.data == "function" ? await p.data() : p.data).getReader();
      try {
        for (; ; ) {
          const { done: C, value: A } = await b.read();
          if (C) break;
          !A || A.length === 0 || (_.crc = sne(A, _.crc), _.size += A.length, yield r(A));
        }
      } catch (C) {
        throw await b.cancel(C).catch(() => {
        }), C;
      } finally {
        b.releaseLock();
      }
      if (!_.zip64Local && _.size >= wa) throw new Error(`zip: ${p.name} grew past its size hint and 4 GiB`);
      yield r(fne(_));
    }
    a.push(_);
  }
  const l = i;
  for (const p of a) yield r(pne(p, n));
  const c = i - l;
  for (const p of hne(a.length, l, c, n)) yield r(p);
}
function yne(e, t = {}) {
  const n = vne(e, t);
  return new ReadableStream({
    async pull(a) {
      const { value: i, done: r } = await n.next();
      r ? a.close() : a.enqueue(i);
    },
    async cancel() {
      await n.return(void 0);
    }
  });
}
function v0(e, t) {
  let n = null;
  const a = () => n ?? (n = new Sp(e));
  let i = 0, r = new Uint8Array(0), l = 0, c = !1;
  return {
    size: t,
    async read(p, m) {
      if (c) throw new Error("upload source cancelled");
      if (p < i || p > l || m < p || m > t)
        throw new Error(`upload source: cannot read [${p}, ${m}) after [${i}, ${l})`);
      const v = r.subarray(p - i);
      if (m > l) {
        const x = await a().read(m - l);
        if (x.length < m - l) throw new Error("upload source: the stream ended early");
        const k = new Uint8Array(v.length + x.length);
        k.set(v, 0), k.set(x, v.length), r = k, l = m;
      } else
        r = v.slice();
      return i = p, new Blob([r.subarray(0, m - p)]);
    },
    cancel() {
      c || (c = !0, (n ? n.cancel() : e.cancel()).catch(() => {
      }));
    }
  };
}
async function y0(e, t, n = "application/octet-stream") {
  const a = [], i = e.getReader();
  for (; ; ) {
    const { done: r, value: l } = await i.read();
    if (r) break;
    a.push(new Blob([l]));
  }
  return new File(a, t, { type: n });
}
const gne = [
  "fxe-encrypt",
  "fxe-request",
  "fxe-download-raw",
  "fxe-remove",
  "fxe-password",
  "e2e-download-encrypted"
];
function bne(e) {
  return gne.includes(e);
}
function Ui(e) {
  return !!e && e.type === "file" && gT(typeof e.e2e_stored == "string" ? e.e2e_stored : e.basename);
}
function ST(e, t) {
  const n = e.length === 1 ? e[0] : null;
  return !n || n.type !== "file" || Ui(n) || t.inEncrypted || n.e2e_root || !t.canWrite ? null : n;
}
function kne(e, t) {
  const n = e.lastIndexOf(".");
  return n <= 0 ? `${e} (${t})` : `${e.slice(0, n)} (${t})${e.slice(n)}`;
}
function wne(e) {
  const { api: t, t: n } = e, a = /* @__PURE__ */ new Map(), i = S(0), r = /* @__PURE__ */ new Map();
  function l() {
    for (const pe of r.values()) URL.revokeObjectURL(pe);
    r.clear();
  }
  Ct(() => {
    l(), a.clear();
  });
  const c = S(null), p = S(!1), m = S(null), v = S(null), x = S(null), k = S("open"), _ = S(!1), w = S(null), b = S(null), C = S(!1), A = S(!0), T = S("off"), R = S(null), M = S(null), L = S(!1), U = S(null), P = S(null);
  async function H(pe) {
    const we = await t.authHeaders(), ee = await fetch(t.previewUrl(pe), {
      headers: we,
      credentials: t.credentialsMode(),
      cache: "no-store"
    });
    if (!ee.ok) {
      const ge = await ee.text().catch(() => "");
      throw pa(ee.status, ge, e.locale());
    }
    if (!ee.body) throw new Error("e2e: this browser cannot read a download as a stream");
    return ee.body;
  }
  async function $(pe) {
    const we = await t.index(pe);
    return new Set((we.files ?? []).map((ee) => ee.basename));
  }
  function F(pe, we) {
    if (!we.has(pe)) return pe;
    for (let ee = 2; ee < 1e3; ee++) {
      const ge = kne(pe, ee);
      if (!we.has(ge)) return ge;
    }
    throw new Error("e2e: no free name");
  }
  async function I(pe, we, ee, ge, ae, xe = {}) {
    const Fe = new File([], we, { type: "application/octet-stream" }), { fields: ye, signal: Te } = xe;
    if (Te != null && Te.aborted)
      throw await ee.cancel().catch(() => {
      }), new DOMException("Aborted by user", "AbortError");
    if (ge > e.chunked.threshold()) {
      const xt = v0(ee, ge);
      let Qt = null;
      const vn = () => Qt == null ? void 0 : Qt.cancel();
      Te == null || Te.addEventListener("abort", vn);
      try {
        await e.chunked.uploadFile({
          path: pe,
          file: Fe,
          source: xt,
          commitQuery: ye,
          onProgress: (Ut) => {
            Qt = Ut, Te != null && Te.aborted && Ut.cancel(), ae == null || ae(Ut.uploadedBytes);
          }
        });
        return;
      } catch (Ut) {
        if (!Oy(Ut)) throw Ut;
        if (ge > vi)
          throw await ee.cancel().catch(() => {
          }), new Xa(ge, vi);
      } finally {
        Te == null || Te.removeEventListener("abort", vn);
      }
    }
    const Ue = await y0(ee, we);
    if (Ue.size !== ge) throw new Error("e2e: the upload came out a different size than it should");
    if (Te != null && Te.aborted) throw new DOMException("Aborted by user", "AbortError");
    await t.uploadMultipart(pe, [Ue], (xt) => ae == null ? void 0 : ae(Math.round(xt / 100 * ge)), ye);
  }
  async function Z(pe) {
    const we = Ia(pe);
    if (t.endpoints.deleteAsync) {
      const { op: ee } = await t.deleteAsync([pe], we);
      e.registerOp(ee);
      return;
    }
    await t.deleteItems(we, [pe]);
  }
  function J(pe) {
    return pe instanceof Error && pe.message ? pe.message : String(pe);
  }
  function re(pe) {
    return pe instanceof Dr ? n("e2e.fxe.not_readable") : pe instanceof un ? n("e2e.fxe.damaged") : J(pe);
  }
  async function ve(pe) {
    const { parsed: we, body: ee } = await Gte(await H(pe));
    return { header: we.header, unsupported: we.unsupported, body: ee };
  }
  function W(pe, we) {
    return pe.header.dek === we.dek && pe.header.nonce === we.nonce && pe.header.size === we.size;
  }
  function z(pe) {
    var we;
    return i.value, (we = a.get(pe)) == null ? void 0 : we.name;
  }
  function le(pe, we) {
    const ee = pe.length === 1 ? pe[0] : null, ge = !!ee && Ui(ee), ae = ST(pe, we) !== null, xe = we.encryptAnswer ?? "allowed";
    return [
      {
        key: "fxe-encrypt",
        label: n("e2e.fxe.ctx_encrypt"),
        icon: "lock",
        hidden: !ae || xe !== "allowed"
      },
      /* wiring:e2 policy — the same place, where encrypting needs an approval. */
      {
        key: "fxe-request",
        label: n("e2e.request.ctx"),
        icon: "lock",
        hidden: !ae || xe !== "request"
      },
      { key: "fxe-download-raw", label: n("e2e.fxe.ctx_download_raw"), icon: "download", hidden: !ge },
      {
        key: "e2e-download-encrypted",
        label: n("e2e.dl.ctx_encrypted_copy"),
        icon: "download",
        hidden: ge || pe.length === 0 || !we.unlockedEncryptedCopy
      },
      { key: "fxe-password", label: n("e2e.fxe.ctx_password"), icon: "lock", hidden: !ge || !we.canWrite },
      { key: "fxe-remove", label: n("e2e.fxe.ctx_remove"), icon: "restore", hidden: !ge || !we.canWrite }
    ];
  }
  function fe(pe) {
    c.value = pe, m.value = null, v.value = null;
  }
  function j() {
    p.value || (c.value = null);
  }
  async function X(pe, we) {
    for (const ee of await t.listVersions(we)) await t.purgeVersion(ee.id);
    await t.deleteItems(Ia(pe.path), [pe.path]);
    try {
      await t.purgeTrash(we);
    } catch (ee) {
      if (ee.status !== 404) throw ee;
    }
  }
  async function te(pe) {
    const we = c.value;
    if (!(!we || p.value)) {
      p.value = !0, m.value = null, v.value = 0;
      try {
        const ee = Ia(we.path), ge = typeof we.size == "number" ? we.size : NaN;
        if (!Number.isSafeInteger(ge) || ge < 0) throw new Error(n("e2e.fxe.size_unknown"));
        const ae = pe.purge === !0;
        if (ae && typeof we.id != "number") throw new Error(n("e2e.fxe.purge_no_id"));
        if (Gi(we.basename)) throw new Error(n("e2e.fxe.bad_name"));
        const xe = await $(ee);
        let Fe = p0(we.basename, pe.hideName);
        if (pe.hideName)
          for (let Ue = 0; xe.has(Fe) && Ue < 20; Ue++) Fe = p0(we.basename, !0);
        else
          Fe = `${F(we.basename, new Set([...xe].filter(gT).map((Ue) => Ue.slice(0, -4))))}.fxe`;
        if (Gi(Fe)) throw new Error(n("e2e.fxe.name_too_long"));
        const ye = await Qte(we.basename, ge, await H(we.path), pe.password, {
          escrowPublicKey: e.escrowPublicKey()
        });
        await I(ee, Fe, ye.stream, ye.size, (Ue) => {
          v.value = ye.size > 0 ? Math.min(100, Math.round(Ue / ye.size * 100)) : 100;
        });
        const Te = Xs(ee, Fe);
        if (a.set(Te, ye.key), i.value++, ae) {
          try {
            await X(we, we.id);
          } catch (Ue) {
            c.value = null, e.emitError(J(Ue), "fxe-purge-original"), e.toast(n("e2e.fxe.purge_failed", { name: we.basename, reason: J(Ue) }), !0), e.showRecoveryKey(ye.recoveryKey, we.basename), await e.reload();
            return;
          }
          c.value = null, e.showRecoveryKey(ye.recoveryKey, we.basename), e.toast(n("e2e.fxe.purged", { name: we.basename })), await e.reload();
          return;
        }
        try {
          await Z(we.path);
        } catch (Ue) {
          c.value = null, e.emitError(J(Ue), "fxe-trash-original"), e.toast(n("e2e.fxe.original_kept", { name: we.basename }), !0), e.showRecoveryKey(ye.recoveryKey, we.basename), await e.reload();
          return;
        }
        c.value = null, e.showRecoveryKey(ye.recoveryKey, we.basename), e.toast(n("e2e.fxe.encrypted", { name: we.basename })), await e.reload();
      } catch (ee) {
        m.value = ee instanceof Xa ? n("e2e.fxe.upload_too_big") : J(ee), e.emitError(J(ee), "fxe-encrypt");
      } finally {
        p.value = !1, v.value = null;
      }
    }
  }
  function V(pe, we) {
    x.value = pe, k.value = we, w.value = null, C.value = !1, b.value = null, A.value = !0, T.value = "off", R.value = null, a.has(pe.path) || G(pe);
  }
  async function G(pe) {
    var we, ee, ge;
    try {
      const { header: ae, body: xe } = await ve(pe.path);
      if (await xe.cancel().catch(() => {
      }), ((we = x.value) == null ? void 0 : we.path) !== pe.path) return;
      A.value = h0(ae), T.value = Ox(Fg(ae), ((ee = e.escrowKid) == null ? void 0 : ee.call(e)) ?? null), R.value = ((ge = ae.esc) == null ? void 0 : ge.kid) ?? null;
    } catch {
    }
  }
  async function q(pe, we) {
    const ee = await t.e2eEscrowChallenge(pe), ge = new Uint8Array(
      await crypto.subtle.decrypt({ name: "RSA-OAEP" }, we, ta(ee.challenge).buffer)
    );
    await t.e2eEscrowUsed({ path: pe, id: ee.id, nonce: Oa(ge) });
  }
  function B() {
    _.value || (x.value = null, C.value = !1);
  }
  async function K(pe) {
    const we = a.get(pe.path);
    if (!we) {
      V(pe, "open");
      return;
    }
    try {
      await yt(pe, we);
    } catch (ee) {
      it(pe, ee, "fxe-open");
    }
  }
  async function ke(pe) {
    if (await $t(pe)) return;
    const we = a.get(pe.path);
    if (!we) {
      V(pe, "download");
      return;
    }
    try {
      await ft(pe, we);
    } catch (ee) {
      if (ee instanceof Mf) {
        V(pe, "download"), C.value = !0;
        return;
      }
      it(pe, ee, "fxe-download");
    }
  }
  function Ye(pe) {
    V(pe, "remove");
  }
  function Oe(pe) {
    return `"${pe.replace(/(["\\$`])/g, "\\$1")}"`;
  }
  function Be(pe, we, ee) {
    var ae;
    const ge = ll(pe.path);
    P.value = {
      name: ((ae = a.get(pe.path)) == null ? void 0 : ae.name) ?? pe.basename,
      size: we,
      limit: ee,
      encrypted: { kind: "file", path: pe.path },
      command: `filex decrypt ${Oe(ge)}`
    };
  }
  function qe(pe, we, ee, ge) {
    const ae = ll(we) || "filex";
    P.value = {
      name: pe,
      size: ee,
      limit: ge,
      encrypted: { kind: "folder", path: we },
      command: `filex decrypt ${Oe(`${ae}.zip`)}`
    };
  }
  function Tt() {
    P.value = null;
  }
  async function $t(pe) {
    var ge;
    if (nne()) return !1;
    const we = (ge = a.get(pe.path)) == null ? void 0 : ge.header.size;
    let ee = typeof we == "number" ? we : null;
    if (ee === null) {
      if (typeof pe.size != "number" || pe.size <= vi) return !1;
      try {
        const { header: ae, body: xe } = await ve(pe.path);
        await xe.cancel().catch(() => {
        }), ee = ae.size;
      } catch {
        return !1;
      }
    }
    return ee <= vi ? !1 : (Be(pe, ee, vi), !0);
  }
  function it(pe, we, ee) {
    if (!(we instanceof Ys)) {
      if (we instanceof Xa) {
        Be(pe, we.size, we.limit);
        return;
      }
      we instanceof un && (a.delete(pe.path), i.value++), e.emitError(J(we), ee), e.toast(re(we), !0);
    }
  }
  async function yt(pe, we) {
    const { header: ee, body: ge } = await ve(pe.path);
    if (!W(we, ee))
      throw await ge.cancel().catch(() => {
      }), new un("e2e: the file changed since it was opened");
    if (ee.size > vi)
      throw await ge.cancel().catch(() => {
      }), new Xa(ee.size, vi);
    const ae = Wf(we.name), xe = await y0(iv(we, ge), we.name, Qs(ae)), Fe = r.get(pe.path);
    Fe && URL.revokeObjectURL(Fe);
    const ye = URL.createObjectURL(xe);
    r.set(pe.path, ye), e.openPreview(
      { ...pe, basename: we.name, extension: ae, mime_type: Qs(ae), size: ee.size, fxe_name: we.name },
      ye
    );
  }
  async function ft(pe, we, ee) {
    const ge = await ov(we.name, we.header.size);
    let ae = !1;
    try {
      const { header: xe, body: Fe } = await ve(pe.path);
      if (!W(we, xe))
        throw await Fe.cancel().catch(() => {
        }), new un("e2e: the file changed since it was opened");
      ae = !0, await ge.write(iv(we, Fe), { mime: Qs(Wf(we.name)) }), e.toast(n("e2e.fxe.downloaded", { name: we.name }));
    } catch (xe) {
      throw ae || await ge.discard(), xe;
    }
  }
  async function ze(pe, we) {
    const ee = Ia(pe.path), { header: ge, body: ae } = await ve(pe.path);
    if (!W(we, ge))
      throw await ae.cancel().catch(() => {
      }), new un("e2e: the file changed since it was opened");
    const xe = F(we.name, await $(ee));
    b.value = 0, await I(ee, xe, iv(we, ae), ge.size, (Fe) => {
      b.value = ge.size > 0 ? Math.min(100, Math.round(Fe / ge.size * 100)) : 100;
    }), await Z(pe.path), a.delete(pe.path), i.value++, e.toast(n("e2e.fxe.removed", { name: xe })), await e.reload();
  }
  async function oe(pe = {}) {
    const we = x.value;
    if (!(!we || _.value)) {
      _.value = !0, w.value = null;
      try {
        let ee = a.get(we.path);
        if (!ee || pe.password || pe.recoveryKey || pe.escrowKey) {
          let ge;
          if (pe.escrowKey)
            try {
              ge = { escrowKey: await Ex(pe.escrowKey) };
            } catch {
              w.value = n("e2e.recover.bad_escrow_key");
              return;
            }
          else pe.recoveryKey ? ge = { recoveryKey: pe.recoveryKey } : ge = { password: pe.password ?? "" };
          const { header: ae, unsupported: xe, body: Fe } = await ve(we.path);
          if (await Fe.cancel().catch(() => {
          }), A.value = h0(ae), xe.length > 0) {
            w.value = n("e2e.fxe.unsupported", { features: xe.join(", ") });
            return;
          }
          const ye = await Jte(ae, ge);
          if ("error" in ye) {
            w.value = ye.error === "damaged" ? n("e2e.fxe.damaged") : "escrowKey" in ge ? n("e2e.fxe.wrong_escrow") : "recoveryKey" in ge ? n("e2e.fxe.wrong_recovery") : n("e2e.fxe.wrong_password");
            return;
          }
          if ("escrowKey" in ge) {
            try {
              await q(we.path, ge.escrowKey);
            } catch (Te) {
              w.value = n("e2e.fxe.escrow_notify_failed"), e.emitError(J(Te), "fxe-escrow-notify");
              return;
            }
            e.toast(n("e2e.fxe.escrow_done"));
          }
          ee = ye.key, a.set(we.path, ee), i.value++;
        }
        if (k.value === "open")
          await yt(we, ee), x.value = null;
        else if (k.value === "download") {
          try {
            await ft(we, ee);
          } catch (ge) {
            if (ge instanceof Mf) {
              C.value = !0;
              return;
            }
            throw ge;
          }
          x.value = null, C.value = !1;
        } else
          await ze(we, ee), x.value = null;
      } catch (ee) {
        if (ee instanceof Ys) return;
        if (ee instanceof Xa && k.value === "download") {
          x.value = null, Be(we, ee.size, ee.limit);
          return;
        }
        w.value = ee instanceof Xa ? n("e2e.dl.too_big", { size: _e(ee.size), limit: _e(ee.limit) }) : re(ee), ee instanceof un && (a.delete(we.path), i.value++), e.emitError(J(ee), `fxe-${k.value}`);
      } finally {
        _.value = !1, b.value = null;
      }
    }
  }
  function Se(pe) {
    M.value = pe, U.value = null;
  }
  function he() {
    L.value || (M.value = null);
  }
  async function Ke(pe) {
    const we = M.value;
    if (!we || L.value) return;
    if (!pe.proof) {
      U.value = n("e2e.password.current_required");
      return;
    }
    L.value = !0, U.value = null;
    const ee = "recoveryKey" in pe.proof ? "recovery_key" : "password";
    try {
      const { header: ge, unsupported: ae, body: xe } = await ve(we.path);
      if (ae.length > 0) {
        await xe.cancel().catch(() => {
        }), U.value = n("e2e.fxe.unsupported", { features: ae.join(", ") });
        return;
      }
      let Fe;
      try {
        Fe = await ene(ge, pe.proof, pe.newPassword);
      } catch (Ue) {
        if (await xe.cancel().catch(() => {
        }), Ue instanceof un) {
          U.value = n(ee === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current");
          return;
        }
        throw Ue;
      }
      const ye = tne(Fe, xe);
      await I(Ia(we.path), ll(we.path), ye.stream, ye.size);
      const Te = a.get(we.path);
      Te && a.set(we.path, Zte(Te, Fe)), i.value++, M.value = null, e.toast(n("e2e.fxe.password_done")), await e.reload();
    } catch (ge) {
      U.value = n("e2e.password.failed"), e.emitError(J(ge), "fxe-password");
    } finally {
      L.value = !1;
    }
  }
  async function Le(pe, we, ee, ge) {
    const ae = (Fe) => {
      ge ? qe(pe.basename, ge, Fe.size, Fe.limit) : e.toast(n("e2e.dl.too_big", { size: _e(Fe.size), limit: _e(Fe.limit) }), !0);
    };
    let xe;
    try {
      xe = await ov(pe.basename, pe.size);
    } catch (Fe) {
      Fe instanceof Xa ? ae(Fe) : it(pe, Fe, "e2e-download");
      return;
    }
    try {
      const Fe = Nv(we, ee, await H(pe.path), { passPlain: !0 });
      await xe.write(Fe, { mime: Qs(pe.extension) });
    } catch (Fe) {
      if (await xe.discard(), Fe instanceof Ys) return;
      if (Fe instanceof Xa) {
        ae(Fe);
        return;
      }
      e.emitError(J(Fe), "e2e-download"), e.toast(n("e2e.download.failed"), !0);
    }
  }
  async function ut(pe, we) {
    let ee;
    try {
      ee = await ov(we.zipName);
    } catch (Te) {
      if (Te instanceof Ys) return;
      if (Te instanceof Mf) {
        e.toast(n("e2e.dl.click_again"), !0);
        return;
      }
      throw Te;
    }
    let ge = 0;
    const ae = (Te, Ue) => ({
      name: Ue,
      sizeHint: typeof Te.size == "number" ? Te.size : void 0,
      mtime: typeof Te.last_modified == "number" ? new Date(Te.last_modified) : void 0,
      data: async () => Nv(we.fmk, we.previous, await H(Te.path), {
        passPlain: !0,
        onPlain: () => ge++
      })
    }), xe = (Te) => (Te.e2e_name_state === "locked" || Te.e2e_name_state === "unreadable") && typeof Te.e2e_stored == "string" ? Te.e2e_stored : Te.basename;
    async function* Fe(Te, Ue) {
      yield { name: `${Ue}/` };
      const xt = await t.index(Te.path), Qt = await we.decorate(xt.files ?? [], { root: we.root }), vn = /* @__PURE__ */ new Set();
      for (const Ut of Qt) {
        if (Ut.basename === ka || typeof Ut.e2e_stored != "string" && Ut.basename === ka) continue;
        const pn = F(xe(Ut), vn);
        vn.add(pn), Ut.type === "dir" ? yield* Fe(Ut, `${Ue}/${pn}`) : yield ae(Ut, `${Ue}/${pn}`);
      }
    }
    async function* ye() {
      const Te = /* @__PURE__ */ new Set();
      for (const Ue of pe) {
        const xt = F(xe(Ue), Te);
        Te.add(xt), Ue.type === "dir" ? yield* Fe(Ue, xt) : yield ae(Ue, xt);
      }
    }
    e.toast(n("e2e.dl.zip_started", { name: we.zipName }));
    try {
      await ee.write(yne(ye()), { mime: "application/zip" }), e.toast(
        ge > 0 ? n("e2e.dl.zip_done_plain", { name: we.zipName, n: ge }) : n("e2e.dl.zip_done", { name: we.zipName })
      );
    } catch (Te) {
      if (await ee.discard(), Te instanceof Ys) return;
      if (Te instanceof Xa) {
        qe(we.zipName, we.root, null, Te.limit);
        return;
      }
      e.emitError(J(Te), "e2e-download-zip"), e.toast(Te instanceof un ? n("e2e.dl.zip_damaged") : n("e2e.download.failed"), !0);
    }
  }
  async function wt(pe, we) {
    const ee = await S_(we, pe.size, pe.stream());
    return v0(ee.stream, ee.size);
  }
  async function _t(pe, we, ee, ge = {}) {
    const ae = pe.size;
    if (typeof ae != "number" || !Number.isSafeInteger(ae) || ae < 0)
      throw new Error("e2e: unknown file size");
    const xe = await S_(we, ae, await H(pe.path)), Fe = ge.onProgress ? (ye) => ge.onProgress(xe.size > 0 ? Math.min(1, ye / xe.size) : 1) : void 0;
    try {
      await I(Ia(pe.path), pe.basename, xe.stream, xe.size, Fe, {
        fields: { e2e_convert: "1", ...ee ? { expect: ee } : {} },
        signal: ge.signal
      });
    } catch (ye) {
      if (ye instanceof Xa) return !1;
      throw ye;
    }
    return !0;
  }
  async function At(pe, we, ee) {
    const ge = new Sp(await H(pe.path)), ae = await ge.read(AL);
    if (!bl(ae))
      return await ge.cancel().catch(() => {
      }), !1;
    const xe = await Kx(ae.buffer, we, ee);
    if (!xe)
      return await ge.cancel().catch(() => {
      }), !0;
    const Fe = typeof pe.size == "number" ? pe.size : NaN;
    if (!Number.isSafeInteger(Fe))
      throw await ge.cancel().catch(() => {
      }), new Error("e2e: unknown file size");
    const ye = typeof pe.e2e_stored == "string" ? pe.e2e_stored : pe.basename;
    return await I(Ia(pe.path), ye, Oc(new Uint8Array(xe), ge.rest()), Fe), !0;
  }
  const { formatSize: _e } = ht(() => e.locale() ?? "en");
  async function Ie(pe, we, ee) {
    var ae;
    const ge = we[0];
    switch (pe) {
      case "fxe-encrypt":
        return ge && fe(ge), !0;
      case "fxe-request":
        return ge && ((ae = e.requestEncrypt) == null || ae.call(e, ge)), !0;
      case "fxe-download-raw":
        return ge && window.open(t.downloadUrl(ge.path), "_blank"), !0;
      case "fxe-password":
        return ge && Se(ge), !0;
      case "fxe-remove":
        return ge && Ye(ge), !0;
      case "e2e-download-encrypted":
        return await ee(we), !0;
    }
    return !1;
  }
  return {
    ringVer: i,
    realName: z,
    isHiddenFxeName: jte,
    menuRows: le,
    dispatch: Ie,
    // encrypt
    encryptTarget: c,
    encryptBusy: p,
    encryptError: m,
    encryptProgress: v,
    startEncrypt: fe,
    closeEncrypt: j,
    submitEncrypt: te,
    // open / download / remove
    unlockTarget: x,
    unlockIntent: k,
    unlockBusy: _,
    unlockError: w,
    unlockProgress: b,
    unlockNeedsSave: C,
    unlockHasRecovery: A,
    unlockEscrow: T,
    unlockEscrowKid: R,
    open: K,
    download: ke,
    startRemove: Ye,
    closeUnlock: B,
    submitUnlock: oe,
    // password
    pwTarget: M,
    pwBusy: L,
    pwError: U,
    // too big for this browser
    tooBig: P,
    closeTooBig: Tt,
    startPassword: Se,
    closePassword: he,
    submitPassword: Ke,
    // encrypted folders
    downloadFolderFile: Le,
    downloadDecryptedZip: ut,
    folderUploadSource: wt,
    convertLarge: _t,
    rewrapLarge: At,
    revokeAll: l
  };
}
function _ne(e, t) {
  const n = String(t ?? "").replace(/\/+$/, "");
  return n === e ? "" : n.slice(e.length + 1);
}
function xne(e) {
  const t = new Set(Sne()), n = Y0({}), a = S(0);
  let i = null, r = null;
  function l(b) {
    t.has(b) || (t.add(b), g0([...t]));
  }
  function c(b) {
    t.delete(b) && g0([...t]);
  }
  function p(b) {
    const C = String(b ?? "").replace(/\/+$/, "");
    let A = null;
    for (const T of [...(i == null ? void 0 : i.openRoots()) ?? [], ...t])
      (C === T || C.startsWith(T + "/")) && (!A || T.length > A.length) && (A = T);
    return A;
  }
  function m() {
    return [.../* @__PURE__ */ new Set([...(i == null ? void 0 : i.openRoots()) ?? [], ...t])];
  }
  const v = { strips: n, version: a, rootOf: p, remember: l };
  function x() {
    return i ? Promise.resolve(i) : (r || (r = import("./e2eVaultEngine-QzlKCQ98.js").then(
      (b) => i = b.createVaultEngine(e, v),
      (b) => {
        throw r = null, b;
      }
    )), r);
  }
  function k(b) {
    return !!b && typeof b.vault_root == "string" && !!b.vault_root;
  }
  function _(b) {
    if (i) {
      i.lock(b);
      return;
    }
    e.dropKeys(b), e.onLocked(b, "manual");
  }
  function w() {
    i == null || i.onPageHide();
  }
  return {
    version: a,
    strips: n,
    rootOf: p,
    roots: m,
    isVaultRow: k,
    forget: c,
    relOf: _ne,
    isOpen: (b) => !!(i != null && i.isOpen(b)),
    permOf: (b) => i == null ? void 0 : i.permOf(b),
    node: (...b) => (i == null ? void 0 : i.node(...b)) ?? null,
    rows: (...b) => (i == null ? void 0 : i.rows(...b)) ?? null,
    search: (...b) => (i == null ? void 0 : i.search(...b)) ?? null,
    close: (...b) => i == null ? void 0 : i.close(...b),
    closeAll: (...b) => i == null ? void 0 : i.closeAll(...b),
    touch: (...b) => i == null ? void 0 : i.touch(...b),
    onVisible: () => i == null ? void 0 : i.onVisible(),
    onEvent: (...b) => i == null ? void 0 : i.onEvent(...b),
    dismiss: (...b) => i == null ? void 0 : i.dismiss(...b),
    lock: _,
    onPageHide: w,
    open: async (...b) => (await x()).open(...b),
    create: async (...b) => (await x()).create(...b),
    readBytes: async (...b) => (await x()).readBytes(...b),
    readUrl: async (...b) => (await x()).readUrl(...b),
    /** filex 0.56 (#189): an app's interface reads / saves a file of an open
     *  vault (lib/appPlaintext createAppVaultDoor). No engine: no vault is
     *  open, so nothing is loaded for it. */
    readForApp: async (...b) => i ? i.readForApp(...b) : { ok: !1, why: "locked" },
    saveForApp: async (...b) => i ? i.saveForApp(...b) : { ok: !1, why: "locked" },
    keyForApp: (...b) => (i == null ? void 0 : i.keyForApp(...b)) ?? null,
    download: async (...b) => (await x()).download(...b),
    upload: async (...b) => (await x()).upload(...b),
    mkdir: async (...b) => (await x()).mkdir(...b),
    rename: async (...b) => (await x()).rename(...b),
    move: async (...b) => (await x()).move(...b),
    copy: async (...b) => (await x()).copy(...b),
    remove: async (...b) => (await x()).remove(...b),
    takeOver: async (...b) => (await x()).takeOver(...b),
    continueFromShown: async (...b) => (await x()).continueFromShown(...b),
    /** The person's idle time (minutes, 1-10), kept on the server. */
    idlePrefs: {
      get: async () => (await x()).idlePrefs.get(),
      set: async (b) => (await x()).idlePrefs.set(b)
    }
  };
}
const $T = "filex.e2e.vaults", TT = 200;
function Sne() {
  try {
    const e = typeof localStorage > "u" ? null : localStorage.getItem($T), t = e ? JSON.parse(e) : [];
    return Array.isArray(t) ? t.filter((n) => typeof n == "string" && n.includes("://")).slice(-TT) : [];
  } catch {
    return [];
  }
}
function g0(e) {
  try {
    typeof localStorage < "u" && localStorage.setItem($T, JSON.stringify(e.slice(-TT)));
  } catch {
  }
}
const $ne = {
  class: "fe-e2e-names__hint",
  "data-testid": "e2e-request-lead"
}, Tne = { class: "fe-field" }, Ane = { class: "fe-field__label" }, Ene = ["placeholder", "disabled"], Cne = {
  key: 0,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "e2e-request-error"
}, zne = ["disabled"], Mne = ["disabled", "aria-busy"], One = /* @__PURE__ */ rt({
  __name: "E2eRequestModal",
  props: {
    open: { type: Boolean },
    locale: {},
    api: {},
    path: {},
    kind: {},
    name: {}
  },
  emits: ["close", "sent"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = E(
      () => n.kind === "file" ? i("e2e.request.lead_file") : n.kind === "folder" ? i("e2e.request.lead_folder") : i("e2e.request.lead")
    ), l = E(() => xc("e2e_request_reason_max_runes")), c = S("");
    Xe(c, (x) => {
      const k = by(x, l.value);
      k !== x && (c.value = k);
    });
    const p = S(!1), m = S(null);
    Xe(
      () => n.open,
      (x) => {
        x && (c.value = "", m.value = null);
      }
    );
    async function v() {
      if (p.value) return;
      const x = c.value.trim();
      if (!x) {
        m.value = i("e2e.request.reason_required");
        return;
      }
      p.value = !0, m.value = null;
      try {
        const k = await n.api.e2eRequest({ path: n.path, kind: n.kind, reason: x });
        a("sent", k);
      } catch (k) {
        m.value = p2(k, i("e2e.request.failed"), { t: i }).text;
      } finally {
        p.value = !1;
      }
    }
    return (x, k) => (f(), We(na, {
      open: e.open,
      locale: e.locale,
      title: u(i)("e2e.request.title", { name: e.name }),
      size: "sm",
      busy: p.value,
      onClose: k[2] || (k[2] = (_) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: p.value,
          onClick: k[1] || (k[1] = (_) => a("close"))
        }, y(u(i)("modal.newfolder.cancel")), 9, zne),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: p.value,
          "aria-busy": p.value ? "true" : void 0,
          "data-testid": "e2e-request-send",
          onClick: v
        }, y(p.value ? u(i)("e2e.request.sending") : u(i)("e2e.request.send")), 9, Mne)
      ]),
      default: mt(() => [
        d("form", {
          class: "fe-e2e-form",
          "data-testid": "e2e-request",
          onSubmit: vt(v, ["prevent"])
        }, [
          d("p", $ne, y(r.value), 1),
          d("label", Tne, [
            d("span", Ane, y(u(i)("e2e.request.reason")), 1),
            cn(d("textarea", {
              "onUpdate:modelValue": k[0] || (k[0] = (_) => c.value = _),
              class: "fe-input",
              rows: "4",
              placeholder: u(i)("e2e.request.reason_placeholder"),
              disabled: p.value,
              "data-testid": "e2e-request-reason"
            }, null, 8, Ene), [
              [xn, c.value]
            ])
          ]),
          m.value ? (f(), h("p", Cne, y(m.value), 1)) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "locale", "title", "busy"]));
  }
}), Pne = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function b0(e) {
  if (typeof e != "string" || !e) return;
  const t = Date.parse(e);
  return Number.isFinite(t) ? t : void 0;
}
function Dne(e, t) {
  var _;
  const n = String((e == null ? void 0 : e.path) ?? "").replace(/^\/+/, "");
  if (!n) return null;
  const a = t.storages ?? [], i = typeof e.storage == "string" && e.storage ? e.storage : a.length === 1 ? a[0].name : "";
  if (t.multiStorageRoot && !i) return null;
  const r = String(e.name ?? n.split("/").pop() ?? ""), l = e.type === "dir", c = e.type === "symlink", p = typeof e.size == "number" ? e.size : 0, m = typeof e.id == "number" ? e.id : void 0, v = typeof e.perm == "string" && Pne.has(e.perm) ? e.perm : void 0, x = ((_ = a.find((w) => w.name === i)) == null ? void 0 : _.readOnly) === !0, k = typeof e.read_only == "boolean" ? e.read_only : x;
  return {
    type: l ? "dir" : "file",
    id: m,
    /* tablo:t1 — ⚠⚠ THE DATE. A node row carries `backend_mtime` (what the
       storage says) and `db_mtime` (what our last scan recorded) as RFC3339
       strings; `FileNode.last_modified` is unix MILLISECONDS. Nothing mapped
       between the two, so every row from Recent, Starred and a tag view
       arrived with no date at all — measured on Recent: eleven rows, eleven em
       dashes in the Modified column, and a Modified column header you could
       click that then sorted nothing. It also made the date grouping this view
       is supposed to show impossible, because every row fell in the "No date"
       bucket. Storage first: `backend_mtime` is the file's own truth and
       `db_mtime` only says when we last looked at it. */
    last_modified: b0(e.backend_mtime) ?? b0(e.db_mtime),
    path: i ? `${i}://${n}` : n,
    basename: r,
    extension: l ? "" : r.includes(".") ? (r.split(".").pop() || "").toLowerCase() : "",
    storage: i,
    visibility: "private",
    size: p,
    file_size: p,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    ...v ? { perm: v } : {},
    read_only: k,
    /* #207 (0.54) — whether the row is starred is the row's own fact: the
       server puts `starred: true` on every listing and view row it answers
       (handlers/meta.go), and the explorer no longer fetches a star list of
       its own to match ids against. Dropped here, every Starred / Recent /
       tag / Home row read as unstarred, so the menu offered "Star" on a file
       in Starred and the inline star was hollow. */
    ...e.starred === !0 ? { starred: !0 } : {},
    /* ...and WHY it will not open, under the folder listing's own name: the
       node row carries the reason the sync recorded (`link_state`, migration
       00098), so the badge here says "Outside storage" exactly where the
       folder says it. A row without one reads as the general "Link". */
    ...c ? {
      symlink: !0,
      ...typeof e.link_state == "string" && e.link_state ? { link_state: e.link_state } : {}
    } : {},
    /* issue #104 - an entry the storage could not answer for. The raw node
       row carries the flag and the storage's answer under the same names the
       folder listing uses, so Recent, Starred, a tag view and Home badge it
       and refuse it exactly as the folder does (lib/unavailable). */
    ...e.unavailable === !0 ? {
      unavailable: !0,
      ...typeof e.unavailable_reason == "string" ? { unavailable_reason: e.unavailable_reason } : {}
    } : {},
    // ⚠⚠ The SERVER's `thumb_url`, never one built here. It used to be
    // `/api/files/thumb/<id>` for every file, and the endpoint answers
    // `404 "not ready"` for everything it has not rendered — a docx, a
    // markdown note, a diagram: opening Recent with ten such files fired ten
    // requests and all ten 404'd (2026-09-21). The rows now carry the URL
    // exactly when there is an image behind it (handlers/meta.go, the folder
    // listing's rule), so a file with none is never asked about.
    thumb_url: !l && typeof e.thumb_url == "string" && e.thumb_url ? e.thumb_url : void 0,
    /* wiring:e2 names — the encrypted folder the row sits in (the server
       answers it for rows outside a folder listing). The explorer's name view
       reads it to name the row, and openNode to open it in its folder. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {},
    /* #189 - how the file is end-to-end encrypted, as the SERVER stamps the
       row (`folder` / `vault` / `file`, handlers/meta.go, the folder
       listing's rule). An app's interface opened from Recent, Starred, a tag
       view or Home is handed it as is (FileInfo.encrypted); dropped here, it
       was told an encrypted file is not. */
    ...ju(e.encrypted) ? { encrypted: e.encrypted } : {},
    extra_metadata: {}
  };
}
const Lne = /* @__PURE__ */ new Set(["none", "viewer", "editor", "owner"]);
function Rne(e) {
  return typeof e == "string" && Lne.has(e);
}
function Nne(e, t) {
  return Rne(t) ? e.map((n) => typeof n.perm == "string" ? n : { ...n, perm: t }) : e;
}
function Ine(e, t) {
  if (!e)
    return t || void 0;
}
function sv(e, t) {
  return e.openInHost && t.type === "file" ? "host" : "page";
}
class AT extends Error {
}
const Bne = 1500;
function ET(e) {
  try {
    const t = JSON.parse(e);
    return t && typeof t == "object" ? t : {};
  } catch {
    return {};
  }
}
async function Fne(e) {
  return ET(await e.text().catch(() => ""));
}
async function Une(e, t = Bne) {
  var c, p, m, v;
  const n = e.sleep ?? ((x) => new Promise((k) => setTimeout(k, x))), a = await e.start(), i = await a.text().catch(() => ""), r = ET(i);
  let l;
  if (a.status === 409 && r.code === "BUSY") {
    const x = r.job;
    if (!(x != null && x.running))
      throw new AT(typeof r.message == "string" && r.message ? r.message : String(r.error ?? "busy"));
    (c = e.onBusy) == null || c.call(e, typeof r.message == "string" ? r.message : ""), l = x;
  } else if (a.ok)
    l = r;
  else
    throw pa(a.status, i, e.locale);
  for ((p = e.onStart) == null || p.call(e, l); l.running; ) {
    if ((m = e.onProgress) == null || m.call(e, l), await n(t), (v = e.stopped) != null && v.call(e)) return null;
    try {
      const x = await e.status(), k = x.ok ? await Fne(x) : {};
      typeof k.running == "boolean" && (l = k);
    } catch {
    }
  }
  return l;
}
function k0(e) {
  const t = String(e ?? "").indexOf("://");
  return t === -1 ? "" : e.slice(0, t);
}
function w0(e, t, n = "auto") {
  const a = k0(t), i = e.some((r) => {
    const l = k0(r);
    return l !== "" && a !== "" && l !== a;
  });
  return n === "copy" ? { kind: "copy", cross: i } : n === "move" ? { kind: "move", cross: i } : { kind: i ? "copy" : "move", cross: i };
}
function CT(e) {
  return e.split("?")[0].replace(/\/manager$/, "/archive/download");
}
const _0 = "/api/files/manager";
function zT(e, t) {
  if (/^https?:\/\//i.test(t)) return t;
  const n = e.split("?")[0];
  if (n.endsWith(_0)) return gy(n.slice(0, -_0.length), t);
  const a = /^(https?:\/\/[^/]+)/i.exec(n);
  return a ? a[1] + t : t;
}
async function Hne(e, t, n) {
  const a = CT(e.endpoints.manager);
  return e.jsonFetch(a, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(n ? { paths: t, name: n } : { paths: t })
  });
}
async function Kne(e, t) {
  const n = await e.jsonFetch(
    CT(e.endpoints.manager),
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ paths: [t], mode: "file" })
    }
  );
  if (!n || n.mode !== "file" || typeof n.url != "string") return null;
  const a = Number(n.ttl_seconds);
  return {
    url: zT(e.endpoints.manager, n.url),
    ttlMs: Number.isFinite(a) && a > 0 ? a * 1e3 : 6e4
  };
}
const Vne = 6e4;
function jne(e, t = document) {
  const n = t.createElement("iframe");
  n.hidden = !0, n.setAttribute("aria-hidden", "true"), n.style.display = "none", n.src = e, t.body.appendChild(n), setTimeout(() => n.remove(), Vne);
}
async function qne(e, t, n = {}) {
  const a = await Hne(e, t, n.name);
  return jne(
    zT(e.endpoints.manager, a.url),
    n.doc ?? document
  ), a;
}
function MT(e) {
  return String(e.path ?? "").replace(/^\/+|\/+$/g, "");
}
function py(e, t) {
  return typeof e.storage == "string" && e.storage ? e.storage : typeof e.storage_name == "string" && e.storage_name ? e.storage_name : t.configured.length === 1 && t.configured[0] ? t.configured[0] : t.current || "";
}
function Pf(e, t) {
  const n = String(e.path ?? "").replace(/^\/+/, ""), a = typeof e.storage == "string" && e.storage ? e.storage : t, i = String(e.name ?? n.split("/").pop() ?? ""), r = i.lastIndexOf("."), l = typeof e.backend_mtime == "string" ? e.backend_mtime : e.updated_at, c = typeof l == "string" ? Date.parse(l) : NaN;
  return {
    id: typeof e.id == "number" ? e.id : void 0,
    path: a ? `${a}://${n}` : n,
    basename: i,
    relativePath: n,
    type: e.type === "dir" ? "dir" : "file",
    extension: r > 0 ? i.slice(r + 1).toLowerCase() : "",
    size: typeof e.size == "number" ? e.size : 0,
    // ⚠ Left UNSET when the row carries no parseable timestamp rather than
    // defaulted to 0 or to now: `matchesModified` treats a missing timestamp
    // as "unknown" and drops the row from a date filter, which is the honest
    // answer. Stamping it with `Date.now()` would file every such file under
    // "Today".
    last_modified: Number.isNaN(c) ? void 0 : c,
    mime_type: typeof e.mime == "string" ? e.mime : "",
    /* The content snippet the hit came with, so a content match can show why
       it matched. Undefined on name-only hits, exactly as the backend sends. */
    snippet: typeof e.snippet == "string" && e.snippet ? e.snippet : void 0,
    /* Owner, so the People filter and the Owner column mean the same thing in a
       content result as they do in a folder listing. Undefined rather than
       guessed when the backend does not send it. */
    owner_id: typeof e.owner_id == "number" ? e.owner_id : void 0,
    owner_name: typeof e.owner_name == "string" ? e.owner_name : void 0,
    owner_self: e.owner_self === !0 ? !0 : void 0,
    /* wiring:e2 names — the encrypted folder the hit sits in (the server
       answers it); the explorer's name view reads it. */
    ...typeof e.e2e_root == "string" && e.e2e_root ? { e2e_root: e.e2e_root } : {},
    /* #189 - how the hit is end-to-end encrypted, as the server stamps it
       (`folder` / `vault` / `file`); an app's interface opened from a
       search result is handed it as is (FileInfo.encrypted). */
    ...ju(e.encrypted) ? { encrypted: e.encrypted } : {}
  };
}
function Wne(e, t) {
  const n = py(e, t);
  if (!MT(e) || !n) return null;
  const a = Pf(e, n);
  return {
    path: a.path,
    basename: a.basename,
    type: a.type,
    ...a.e2e_root ? { e2e_root: a.e2e_root } : {},
    ...a.encrypted ? { encrypted: a.encrypted } : {}
  };
}
function Rpe(e, t) {
  var i;
  const n = [], a = /* @__PURE__ */ new Map();
  for (const r of e) {
    const l = ((i = r.account) == null ? void 0 : i.id) ?? "";
    let c = a.get(l);
    c || (c = { account: r.account, hits: [] }, a.set(l, c), n.push(c)), c.hits.length < t && c.hits.push(r);
  }
  return n;
}
function Yne(e) {
  if (!e) return [];
  const t = e.items;
  if (t && t.length > 0) {
    const n = [];
    let a = !1;
    for (let i = 0; i < t.length; i++) {
      const r = t[i];
      if (!r || r.kind !== "file") continue;
      a = !0;
      const l = r.webkitGetAsEntry ?? r.getAsEntry, c = typeof l == "function" ? l.call(r) : null;
      if (c && c.isDirectory) {
        n.push({ kind: "entry", entry: c });
        continue;
      }
      const p = r.getAsFile();
      p ? n.push({ kind: "file", file: p }) : c && c.isFile && n.push({ kind: "entry", entry: c });
    }
    if (a) return n;
  }
  return Array.from(e.files ?? []).map((n) => ({ kind: "file", file: n }));
}
function Gne(e) {
  return new Promise((t, n) => {
    if (typeof e.file != "function") {
      n(new Error("not a file entry"));
      return;
    }
    e.file(t, n);
  });
}
async function Xne(e) {
  if (typeof e.createReader != "function") throw new Error("not a folder entry");
  const t = e.createReader(), n = [];
  for (; ; ) {
    const a = await new Promise((i, r) => t.readEntries(i, r));
    if (a.length === 0) return n;
    n.push(...a);
  }
}
function Jne(e, t) {
  return e ? `${e}/${t}` : t;
}
async function Zne(e) {
  const t = { dirs: [], files: [], unreadable: [] }, n = async (a, i) => {
    const r = Jne(i, a.name);
    if (a.isDirectory) {
      let l;
      try {
        l = await Xne(a);
      } catch {
        t.unreadable.push(r);
        return;
      }
      t.dirs.push(r);
      for (const c of l) await n(c, r);
      return;
    }
    if (a.isFile)
      try {
        t.files.push({ file: await Gne(a), dir: i });
      } catch {
        t.unreadable.push(r);
      }
  };
  for (const a of e)
    a.kind === "file" ? t.files.push({ file: a.file, dir: "" }) : await n(a.entry, "");
  return t;
}
function Qne(e) {
  const t = /* @__PURE__ */ new Set();
  for (const { dir: n } of e.files)
    for (let a = n; a; a = a.includes("/") ? a.slice(0, a.lastIndexOf("/")) : "") t.add(a);
  return e.dirs.filter((n) => !t.has(n));
}
async function eae(e, t, n) {
  const a = /* @__PURE__ */ new Map([["", t]]);
  for (const r of e.dirs) {
    const l = r.lastIndexOf("/"), c = a.get(l === -1 ? "" : r.slice(0, l));
    if (c !== void 0)
      try {
        a.set(r, await n.mkdir(c, r.slice(l + 1)));
      } catch (p) {
        n.failed(r, p);
      }
  }
  const i = /* @__PURE__ */ new Map();
  for (const { file: r, dir: l } of e.files) {
    const c = i.get(l);
    c ? c.push(r) : i.set(l, [r]);
  }
  for (const [r, l] of i) {
    const c = a.get(r);
    if (c !== void 0)
      try {
        await n.upload(l, c);
      } catch (p) {
        n.failed(r || l[0].name, p);
      }
  }
}
function tae(e, t) {
  return Object.defineProperty(e, "webkitRelativePath", { value: t, configurable: !0 }), e;
}
const nae = { class: "fe-field" }, aae = { class: "fe-field__label" }, iae = ["onKeydown"], oae = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, rae = ["innerHTML"], sae = ["innerHTML"], lae = ["disabled"], uae = ["disabled", "aria-busy"], cae = /* @__PURE__ */ rt({
  __name: "NewFolderModal",
  props: {
    open: { type: Boolean },
    locale: {},
    encryptedOption: { type: Boolean },
    encryptedRequest: { type: Boolean },
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit", "encrypted", "request-encrypted"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S(null);
    Xe(() => n.open, (p) => {
      p && (r.value = "", l.value = null);
    }), Xe(
      () => n.error,
      (p) => {
        p && (l.value = p);
      }
    );
    function c() {
      if (n.busy) return;
      const p = Ty(r.value), m = b2(p);
      if (m === "empty") {
        l.value = i("modal.newfolder.placeholder");
        return;
      }
      if (m) {
        l.value = i("modal.newfolder.invalid");
        return;
      }
      if (gp(p)) {
        l.value = i("names.reserved", { name: p });
        return;
      }
      a("submit", p);
    }
    return (p, m) => (f(), We(na, {
      open: e.open,
      title: u(i)("modal.newfolder.title"),
      size: "sm",
      busy: e.busy,
      onClose: m[4] || (m[4] = (v) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: m[3] || (m[3] = (v) => a("close"))
        }, y(u(i)("modal.newfolder.cancel")), 9, lae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: c
        }, y(e.busy ? u(i)("modal.newfolder.creating") : u(i)("modal.newfolder.create")), 9, uae)
      ]),
      default: mt(() => [
        d("form", {
          onSubmit: vt(c, ["prevent"])
        }, [
          d("label", nae, [
            d("span", aae, y(u(i)("modal.newfolder.placeholder")), 1),
            cn(d("input", {
              "onUpdate:modelValue": m[0] || (m[0] = (v) => r.value = v),
              type: "text",
              class: "fe-input",
              autocomplete: "off",
              onKeydown: za(vt(c, ["prevent"]), ["enter"])
            }, null, 40, iae), [
              [xn, r.value]
            ])
          ]),
          l.value ? (f(), h("p", oae, y(l.value), 1)) : D("", !0),
          e.encryptedOption !== !1 ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-e2e-optlink",
            onClick: m[1] || (m[1] = (v) => a("encrypted"))
          }, [
            d("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("lock")
            }, null, 8, rae),
            Vt(" " + y(u(i)("e2e.create.option")), 1)
          ])) : e.encryptedRequest ? (f(), h("button", {
            key: 2,
            type: "button",
            class: "fe-e2e-optlink",
            "data-testid": "e2e-request-option",
            onClick: m[2] || (m[2] = (v) => a("request-encrypted"))
          }, [
            d("span", {
              class: "fe-e2e-optlink__icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("lock")
            }, null, 8, sae),
            Vt(" " + y(u(i)("e2e.request.option")), 1)
          ])) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), dae = { class: "fe-field__hint" }, fae = { class: "fe-field" }, pae = { class: "fe-field__label" }, hae = ["disabled"], mae = {
  key: 0,
  class: "fe-form__error"
}, vae = ["disabled"], yae = ["disabled", "aria-busy"], gae = /* @__PURE__ */ rt({
  __name: "ArchiveExtractModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    suggestedFolder: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S("");
    Xe(() => n.open, (p) => {
      p && (r.value = n.suggestedFolder, l.value = "");
    });
    function c() {
      if (!n.busy) {
        if (!r.value.trim() || /[\\/]/.test(r.value)) {
          l.value = i("archive.invalid_folder");
          return;
        }
        a("submit", { folder: r.value.trim() });
      }
    }
    return (p, m) => (f(), We(na, {
      open: e.open,
      title: u(i)("archive.extract_title"),
      size: "sm",
      busy: e.busy,
      onClose: m[2] || (m[2] = (v) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: m[1] || (m[1] = (v) => a("close"))
        }, y(u(i)("archive.cancel")), 9, vae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: c
        }, y(e.busy ? u(i)("archive.extracting") : u(i)("archive.extract_to_folder")), 9, yae)
      ]),
      default: mt(() => [
        d("form", {
          class: "fe-form",
          onSubmit: vt(c, ["prevent"])
        }, [
          d("p", dae, y(e.archiveName), 1),
          d("label", fae, [
            d("span", pae, y(u(i)("archive.destination_folder")), 1),
            cn(d("input", {
              "onUpdate:modelValue": m[0] || (m[0] = (v) => r.value = v),
              class: "fe-input",
              autocomplete: "off",
              disabled: e.busy
            }, null, 8, hae), [
              [xn, r.value]
            ])
          ]),
          l.value || e.error ? (f(), h("p", mae, y(l.value || e.error), 1)) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), bae = { class: "fe-field__hint" }, kae = { class: "fe-field" }, wae = { class: "fe-field__label" }, _ae = ["disabled"], xae = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, Sae = ["disabled"], $ae = ["disabled", "aria-busy"], Tae = /* @__PURE__ */ rt({
  __name: "ArchivePasswordModal",
  props: {
    open: { type: Boolean },
    locale: {},
    archiveName: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S("");
    Xe(() => n.open, (c) => {
      c && (r.value = "");
    });
    function l() {
      !r.value || n.busy || a("submit", r.value);
    }
    return (c, p) => (f(), We(na, {
      open: e.open,
      title: u(i)("archive.password_title"),
      size: "sm",
      busy: e.busy,
      onClose: p[2] || (p[2] = (m) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: p[1] || (p[1] = (m) => a("close"))
        }, y(u(i)("archive.cancel")), 9, Sae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy || !r.value,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: l
        }, y(e.busy ? u(i)("archive.opening") : u(i)("archive.continue")), 9, $ae)
      ]),
      default: mt(() => [
        d("form", {
          class: "fe-form",
          onSubmit: vt(l, ["prevent"])
        }, [
          d("p", bae, y(e.archiveName), 1),
          d("label", kae, [
            d("span", wae, y(u(i)("archive.password_required")), 1),
            cn(d("input", {
              "onUpdate:modelValue": p[0] || (p[0] = (m) => r.value = m),
              class: "fe-input",
              type: "password",
              autocomplete: "off",
              "data-1p-ignore": "",
              "data-bwignore": "true",
              "data-lpignore": "true",
              autofocus: "",
              disabled: e.busy
            }, null, 8, _ae), [
              [xn, r.value]
            ])
          ]),
          e.error ? (f(), h("p", xae, y(e.error), 1)) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), Aae = {
  class: "fe-draftq",
  "data-testid": "draft-taken-dialog"
}, Eae = { class: "fe-draftq__body" }, Cae = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, zae = ["disabled"], Mae = ["disabled", "aria-busy"], x0 = /* @__PURE__ */ rt({
  __name: "DraftConflictModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    suggested: {},
    folder: {},
    busy: { type: Boolean },
    error: {},
    kind: {}
  },
  emits: ["cancel", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = () => n.kind === "upload";
    return (l, c) => (f(), We(na, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: u(i)("draft.taken.title"),
      size: "sm",
      busy: e.busy,
      onClose: c[2] || (c[2] = (p) => a("cancel"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          "data-testid": "draft-taken-cancel",
          onClick: c[0] || (c[0] = (p) => a("cancel"))
        }, y(u(i)("modal.rename.cancel")), 9, zae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          "data-testid": "draft-taken-confirm",
          onClick: c[1] || (c[1] = (p) => a("confirm"))
        }, y(u(i)(r() ? "upload.taken.confirm" : "draft.taken.confirm", { name: e.suggested })), 9, Mae)
      ]),
      default: mt(() => [
        d("div", Aae, [
          d("p", Eae, y(u(i)(r() ? "upload.taken.body" : "draft.taken.body", { name: e.name, folder: e.folder, suggested: e.suggested })), 1),
          e.error ? (f(), h("p", Cae, y(e.error), 1)) : D("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title", "busy"]));
  }
});
function Oae(e, t) {
  const n = S(!1), a = S(null), i = S(null);
  let r = null;
  function l(v) {
    i.value = null, a.value = null;
    const x = r;
    r = null, x == null || x(v);
  }
  async function c(v) {
    const x = e();
    if (!x) return null;
    n.value = !0;
    try {
      const k = await x.save(v.key);
      if (k.saved) return { path: k.path, name: k.name, targetDir: k.targetDir };
      i.value = {
        key: v.key,
        name: k.name,
        suggested: k.suggested,
        folder: h2(k.targetDir)
      }, a.value = null;
    } finally {
      n.value = !1;
    }
    return new Promise((k) => {
      r = k;
    });
  }
  async function p() {
    const v = i.value, x = e();
    if (!(!v || !x || n.value)) {
      n.value = !0, a.value = null;
      try {
        const k = await x.save(v.key, v.suggested);
        if (k.saved) {
          l({ path: k.path, name: k.name, targetDir: k.targetDir });
          return;
        }
        i.value = { ...v, name: k.name || v.name, suggested: k.suggested };
      } catch (k) {
        a.value = t(k);
      } finally {
        n.value = !1;
      }
    }
  }
  function m() {
    n.value || l(null);
  }
  return { busy: n, error: a, question: i, save: c, confirm: p, cancel: m };
}
const Pae = ["onKeydown"], Dae = {
  key: 0,
  class: "fe-form__error",
  role: "alert",
  "data-testid": "rename-error"
}, Lae = ["disabled"], Rae = ["disabled", "aria-busy"], Nae = /* @__PURE__ */ rt({
  __name: "RenameModal",
  props: {
    open: { type: Boolean },
    locale: {},
    currentName: {},
    error: {},
    busy: { type: Boolean }
  },
  emits: ["close", "submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S(null);
    Xe(
      () => [n.open, n.currentName],
      ([m, v]) => {
        m && (r.value = v, l.value = n.error ?? null);
      }
    ), Xe(
      () => n.error,
      (m) => {
        l.value = m ?? null;
      },
      { immediate: !0 }
    );
    function c() {
      l.value = null;
    }
    function p() {
      if (n.busy) return;
      if (r.value === n.currentName) {
        a("close");
        return;
      }
      const m = Ty(r.value), v = b2(m);
      if (v === "empty") {
        l.value = i("modal.rename.empty");
        return;
      }
      if (v) {
        l.value = i("modal.newfolder.invalid");
        return;
      }
      if (gp(m)) {
        l.value = i("names.reserved", { name: m });
        return;
      }
      a("submit", m);
    }
    return (m, v) => (f(), We(na, {
      open: e.open,
      title: u(i)("modal.rename.title"),
      size: "sm",
      busy: e.busy,
      onClose: v[2] || (v[2] = (x) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: v[1] || (v[1] = (x) => a("close"))
        }, y(u(i)("modal.rename.cancel")), 9, Lae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: p
        }, y(e.busy ? u(i)("modal.rename.saving") : u(i)("modal.rename.save")), 9, Rae)
      ]),
      default: mt(() => [
        d("form", {
          onSubmit: vt(p, ["prevent"])
        }, [
          cn(d("input", {
            "onUpdate:modelValue": v[0] || (v[0] = (x) => r.value = x),
            type: "text",
            class: "fe-input",
            autocomplete: "off",
            onInput: c,
            onKeydown: za(vt(p, ["prevent"]), ["enter"])
          }, null, 40, Pae), [
            [xn, r.value]
          ]),
          l.value ? (f(), h("p", Dae, y(l.value), 1)) : D("", !0)
        ], 32)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
}), Iae = {
  key: 0,
  class: "fe-form__error",
  role: "alert"
}, Bae = ["disabled"], Fae = ["disabled", "aria-busy"], Uae = /* @__PURE__ */ rt({
  __name: "DeleteConfirmModal",
  props: {
    open: { type: Boolean },
    locale: {},
    count: {},
    error: {},
    busy: { type: Boolean },
    permanent: { type: Boolean }
  },
  emits: ["close", "confirm"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale);
    function r() {
      n.busy || a("confirm");
    }
    return (l, c) => (f(), We(na, {
      open: e.open,
      title: e.permanent ? u(i)("modal.delete.permanent_title") : u(i)("modal.delete.title"),
      size: "sm",
      busy: e.busy,
      onClose: c[1] || (c[1] = (p) => a("close"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          disabled: e.busy,
          onClick: c[0] || (c[0] = (p) => a("close"))
        }, y(u(i)("modal.delete.cancel")), 9, Bae),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--danger",
          disabled: e.busy,
          "aria-busy": e.busy ? "true" : void 0,
          onClick: r
        }, y(e.busy ? u(i)(e.permanent ? "modal.delete.permanent_working" : "modal.delete.working") : u(i)(e.permanent ? "modal.delete.permanent_confirm" : "modal.delete.confirm")), 9, Fae)
      ]),
      default: mt(() => [
        d("p", null, y(e.permanent ? u(i)("modal.delete.permanent_message", { count: e.count }) : u(i)("modal.delete.message", { count: e.count })), 1),
        e.error ? (f(), h("p", Iae, y(e.error), 1)) : D("", !0)
      ]),
      _: 1
    }, 8, ["open", "title", "busy"]));
  }
});
function Hae(e, t) {
  return e && e.queued ? t("toast.undo_queued") : e && e.summary ? e.summary : t("toast.undone");
}
function S0(e, t, n) {
  return !e || e.source === t ? !0 : e.source === "drag-out-stopping" ? n === "end" : !1;
}
function $0(e, t, n, a) {
  return (e == null ? void 0 : e.kind) === "plain" ? t === "running" ? e.running : e.done : t === "running" ? a("toast.undoing") : Hae(n, a);
}
function lv(e, t = {}) {
  const n = S(!1), a = S(null);
  let i = 0;
  Xe(e, (l, c) => {
    !l || c || (i++, n.value = !1, a.value = null);
  });
  function r(l) {
    return l === i && e.value;
  }
  return {
    busy: n,
    error: a,
    begin() {
      return n.value ? null : (n.value = !0, a.value = null, i);
    },
    end(l) {
      l === i && (n.value = !1);
    },
    refuse(l, c) {
      var p;
      return r(l) ? (a.value = c, !0) : ((p = t.say) == null || p.call(t, c), !1);
    },
    inDialog: r
  };
}
const Kae = 3e3, Vae = 20;
function jae(e) {
  const t = e.last_sync_error || void 0;
  switch (e.last_sync_state) {
    case "ok":
      return { status: "ok" };
    case "failed":
    case "error":
      return t ? { status: "failed", error: t } : { status: "failed" };
    case "aborted":
      return { status: "aborted" };
    default:
      return { status: "unknown" };
  }
}
function qae(e) {
  const t = e.pollMs ?? Kae, n = e.giveUpAfter ?? Vae, a = /* @__PURE__ */ new Map(), i = S(0);
  let r, l = !1, c = !1, p = 0;
  const m = /* @__PURE__ */ new Set();
  function v() {
    c || r !== void 0 || l || a.size === 0 || (r = setTimeout(() => {
      r = void 0, x();
    }, t));
  }
  async function x() {
    if (c || a.size === 0) return;
    l = !0;
    let _ = null;
    try {
      _ = await e.list(), p = 0;
    } catch {
      p++;
    } finally {
      l = !1;
    }
    if (c) return;
    const w = _ === null && p >= n;
    if (_ !== null || w) {
      for (const [b, C] of a) {
        const A = _ == null ? void 0 : _.find((R) => R.id === C.id), T = C.settle.filter((R) => !R(A, w));
        T.length === 0 ? a.delete(b) : C.settle = T;
      }
      i.value++;
    }
    v();
  }
  function k(_, w, b) {
    return c ? Promise.resolve(null) : new Promise((C) => {
      const A = (L) => {
        m.delete(A), C(L);
      };
      m.add(A);
      const T = `${w}:${_}`, R = (L, U) => {
        const P = b(L, U);
        return P === void 0 ? !1 : (A(P), !0);
      }, M = a.get(T);
      M ? M.settle.push(R) : a.set(T, { id: _, kind: w, settle: [R] }), i.value++, v();
    });
  }
  return {
    scan: (_) => k(_, "scan", (w, b) => b ? { status: "unknown" } : w ? w.running ? void 0 : jae(w) : { status: "gone" }),
    deletion: (_) => k(_, "deletion", (w, b) => b ? !1 : w ? void 0 : !0),
    watching(_) {
      return i.value, a.has(`deletion:${_}`) ? "deletion" : a.has(`scan:${_}`) ? "scan" : null;
    },
    stop() {
      c = !0, r !== void 0 && clearTimeout(r), r = void 0, a.clear(), i.value++;
      for (const _ of [...m]) _(null);
    }
  };
}
const Wae = ["aria-label"], Yae = ["aria-selected", "tabindex", "disabled", "data-testid", "data-section", "onClick", "onKeydown"], Gae = { class: "fe-sections__label" }, Xae = ["data-testid"], OT = /* @__PURE__ */ rt({
  __name: "SurfaceSections",
  props: {
    sections: {},
    active: {},
    locale: {},
    label: {},
    disabled: { type: Boolean }
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(
      () => n.sections.filter((c) => c && typeof c.id == "string" && c.id).map((c) => ({
        id: c.id,
        label: Zt(c.label, n.locale) || c.id,
        count: typeof c.count == "number" && Number.isFinite(c.count) ? c.count : null
      }))
    );
    function r(c) {
      n.disabled || c === n.active || a("select", c);
    }
    function l(c, p) {
      var _, w;
      if (!["ArrowRight", "ArrowLeft", "Home", "End"].includes(c.key)) return;
      c.preventDefault();
      const v = i.value.length;
      if (!v) return;
      let x = p;
      c.key === "ArrowRight" ? x = (p + 1) % v : c.key === "ArrowLeft" ? x = (p - 1 + v) % v : c.key === "Home" ? x = 0 : c.key === "End" && (x = v - 1);
      const k = (_ = c.currentTarget.parentElement) == null ? void 0 : _.querySelectorAll('[role="tab"]');
      (w = k == null ? void 0 : k[x]) == null || w.focus(), r(i.value[x].id);
    }
    return (c, p) => (f(), h("nav", {
      class: "fe-sections",
      role: "tablist",
      "aria-label": e.label,
      "data-testid": "surface-sections"
    }, [
      (f(!0), h(Ce, null, nt(i.value, (m, v) => (f(), h("button", {
        key: m.id,
        type: "button",
        role: "tab",
        class: Ne(["fe-sections__tab", { "is-active": m.id === e.active }]),
        "aria-selected": m.id === e.active ? "true" : "false",
        tabindex: m.id === e.active || !e.active && v === 0 ? 0 : -1,
        disabled: e.disabled,
        "data-testid": `surface-section-${m.id}`,
        "data-section": m.id,
        onClick: (x) => r(m.id),
        onKeydown: (x) => l(x, v)
      }, [
        d("span", Gae, y(m.label), 1),
        m.count !== null ? (f(), h("span", {
          key: 0,
          class: "fe-sections__count",
          "data-testid": `surface-section-count-${m.id}`
        }, y(m.count), 9, Xae)) : D("", !0)
      ], 42, Yae))), 128))
    ], 8, Wae));
  }
}), Jae = {
  class: "fe-plugin-view",
  "data-testid": "plugin-view"
}, Zae = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted",
  role: "status",
  "data-testid": "plugin-view-opening"
}, Qae = ["disabled"], eie = /* @__PURE__ */ rt({
  __name: "PluginViewModal",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    api: {},
    plugin: {},
    view: {},
    surface: {},
    path: {},
    paths: {},
    storages: {},
    startAt: {},
    size: {},
    label: {}
  },
  emits: ["close", "op", "toast", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = Np(
      {
        api: n.api,
        plugin: n.plugin,
        view: n.view,
        path: () => n.path,
        paths: () => n.paths,
        locale: () => n.locale,
        errorText: () => i("plugin.view.error")
      },
      {
        onOp: (x) => a("op", x),
        onDone: () => a("close"),
        onToast: (x) => a("toast", x),
        onOpen: (x) => a("open", x)
      }
    );
    Xe(
      () => n.surface,
      (x) => r.setSurface(x),
      { immediate: !0 }
    );
    const l = r.current, c = E(() => {
      var x;
      return Zt((x = l.value) == null ? void 0 : x.title, n.locale) || n.label || n.view;
    }), p = E(() => {
      var x;
      return ((x = l.value) == null ? void 0 : x.sections) ?? [];
    });
    async function m(x) {
      var k, _;
      if (!(!x || x === ((k = l.value) == null ? void 0 : k.section)))
        try {
          const w = await n.api.pluginView(n.plugin, n.view, n.path, x);
          w != null && w.surface && r.setSurface(w.surface);
        } catch (w) {
          a("toast", ((_ = i.foreign) == null ? void 0 : _.call(i, String((w == null ? void 0 : w.message) ?? ""))) || i("plugin.view.error"));
        }
    }
    const v = E(() => {
      var k;
      if (n.size) return n.size;
      const x = (k = l.value) == null ? void 0 : k.size;
      return x === "sm" || x === "lg" || x === "xl" ? x : "md";
    });
    return (x, k) => (f(), We(na, {
      open: e.open,
      title: c.value,
      size: v.value,
      theme: e.theme,
      locale: e.locale,
      busy: u(r).busy.value,
      onClose: k[1] || (k[1] = (_) => a("close"))
    }, {
      actions: mt(() => [
        u(r).footer.value.length ? D("", !0) : (f(), h("button", {
          key: 0,
          type: "button",
          class: "fe-btn",
          disabled: u(r).busy.value,
          "data-testid": "plugin-view-close",
          onClick: k[0] || (k[0] = (_) => a("close"))
        }, y(u(i)("plugin.view.close")), 9, Qae)),
        Je(Bp, {
          conv: u(r),
          locale: e.locale,
          "testid-prefix": "plugin-view"
        }, null, 8, ["conv", "locale"])
      ]),
      default: mt(() => {
        var _;
        return [
          d("div", Jae, [
            u(l) ? D("", !0) : (f(), h("p", Zae, y(u(i)("plugin.view.loading")), 1)),
            p.value.length ? (f(), We(OT, {
              key: 1,
              sections: p.value,
              active: (_ = u(l)) == null ? void 0 : _.section,
              locale: e.locale,
              label: c.value,
              disabled: u(r).busy.value,
              onSelect: m
            }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : D("", !0),
            Je(Ip, {
              conv: u(r),
              locale: e.locale,
              theme: e.theme,
              api: e.api,
              plugin: e.plugin,
              storages: e.storages,
              "start-at": e.startAt
            }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at"])
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "size", "theme", "locale", "busy"]));
  }
}), tie = { class: "fe-appframe-modal__body" }, nie = /* @__PURE__ */ rt({
  __name: "AppFrameModal",
  props: {
    api: {},
    locale: {},
    theme: {},
    plugin: {},
    view: {},
    placement: {},
    ui: {},
    label: {},
    files: {},
    userName: {},
    storages: {},
    startAt: {}
  },
  emits: ["close", "toast", "op"],
  setup(e, { emit: t }) {
    const n = t, a = S(null), i = S("");
    async function r() {
      a.value && !await a.value.confirmClose() || n("close");
    }
    return (l, c) => (f(), We(na, {
      open: !0,
      size: e.placement === "home" ? "xl" : "lg",
      title: i.value ? `${e.label} - ${i.value}` : e.label,
      locale: e.locale,
      theme: e.theme,
      "close-on-backdrop": !1,
      "data-testid": "app-frame-modal",
      onClose: r
    }, {
      default: mt(() => [
        d("div", tie, [
          Je(Sg, {
            ref_key: "frame",
            ref: a,
            api: e.api,
            app: e.plugin,
            version: e.ui.version,
            view: e.view,
            placement: e.placement,
            ui: e.ui,
            files: e.files,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            "user-name": e.userName,
            title: e.label,
            onTitle: c[0] || (c[0] = (p) => i.value = p),
            onToast: c[1] || (c[1] = (p) => n("toast", p.text)),
            onOp: c[2] || (c[2] = (p) => n("op", p)),
            onClose: r
          }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "storages", "start-at", "locale", "theme", "user-name", "title"])
        ])
      ]),
      _: 1
    }, 8, ["size", "title", "locale", "theme"]));
  }
}), Gc = S(0);
function PT() {
  const e = Qi().openWith;
  if (!e) return {};
  try {
    const t = JSON.parse(e);
    if (!t || typeof t != "object" || Array.isArray(t)) return {};
    const n = {};
    for (const [a, i] of Object.entries(t))
      typeof i == "string" && Ug(a) && Hg(i, a) && (n[a] = i);
    return n;
  } catch {
    return {};
  }
}
function Ug(e) {
  return /^[a-z0-9][a-z0-9_+-]{0,31}$/.test(e);
}
function Hg(e, t) {
  return e === Al ? t === void 0 || Vp(t) : e === "builtin" || /^app:[a-z0-9][a-z0-9_-]{0,31}\/[a-z0-9][a-z0-9_.-]{0,63}$/.test(e);
}
function aie() {
  return Gc.value, PT();
}
function iie(e) {
  return e ? aie()[e.toLowerCase()] ?? null : null;
}
async function DT(e, t) {
  const n = await l$(e, t);
  if (!(!n || !n.ok))
    try {
      const a = await n.json();
      if (!a || !a.choices || typeof a.choices != "object" || Array.isArray(a.choices)) return;
      const i = {};
      for (const [r, l] of Object.entries(a.choices))
        typeof l == "string" && Ug(r) && Hg(l, r) && (i[r] = l);
      _g("openWith", JSON.stringify(i)), Gc.value++;
    } catch {
    }
}
function oie(e, t) {
  const n = e.toLowerCase();
  if (!Ug(n) || t !== null && !Hg(t, n)) return;
  const a = PT();
  t === null ? delete a[n] : a[n] = t, _g("openWith", JSON.stringify(a)), Gc.value++;
  const i = `/api/me/open-with/${encodeURIComponent(n)}`;
  DT(i, t === null ? { method: "DELETE" } : { method: "PUT", body: JSON.stringify({ handler: t }) });
}
function Npe() {
  _g("openWith", "{}"), Gc.value++, DT("/api/me/open-with", { method: "DELETE" });
}
function rie() {
  return Vc(() => {
    Gc.value++;
  });
}
const sie = {
  class: "fe-openwith",
  "data-testid": "open-with-dialog"
}, lie = { class: "fe-openwith__lead" }, uie = {
  key: 0,
  class: "fe-openwith__always"
}, cie = {
  key: 1,
  class: "fe-openwith__hint"
}, die = ["disabled"], fie = /* @__PURE__ */ rt({
  __name: "OpenWithDialog",
  props: {
    open: { type: Boolean },
    locale: {},
    theme: {},
    name: {},
    kind: {},
    handlers: {},
    current: {},
    remembered: {}
  },
  emits: ["cancel", "open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(null), l = S(!1);
    Xe(
      () => n.open,
      (v) => {
        var x;
        v && (r.value = n.current ?? ((x = n.handlers[0]) == null ? void 0 : x.id) ?? null, l.value = !!n.remembered && n.remembered === r.value);
      },
      { immediate: !0 }
    );
    function c(v) {
      return Tf(v) ? i("openWith.onlyoffice") : v.view ? Zt(v.view.label, n.locale) || v.view.plugin : i("openWith.builtin");
    }
    const p = E(
      () => n.handlers.map((v) => ({
        value: v.id,
        label: c(v),
        help: v.id === n.current ? i("openWith.now") : void 0
      }))
    );
    function m() {
      r.value && a("open", r.value, l.value && !!n.kind);
    }
    return (v, x) => (f(), We(na, {
      open: e.open,
      locale: e.locale,
      theme: e.theme,
      title: u(i)("openWith.title"),
      size: "sm",
      onClose: x[3] || (x[3] = (k) => a("cancel"))
    }, {
      actions: mt(() => [
        d("button", {
          type: "button",
          class: "fe-btn",
          "data-testid": "open-with-cancel",
          onClick: x[2] || (x[2] = (k) => a("cancel"))
        }, y(u(i)("modal.rename.cancel")), 1),
        d("button", {
          type: "button",
          class: "fe-btn fe-btn--primary",
          disabled: !r.value,
          "data-testid": "open-with-open",
          onClick: m
        }, y(u(i)("openWith.open")), 9, die)
      ]),
      default: mt(() => [
        d("div", sie, [
          d("p", lie, y(u(i)("openWith.lead", { name: e.name })), 1),
          Je(mi, {
            "model-value": r.value,
            "onUpdate:modelValue": x[0] || (x[0] = (k) => r.value = typeof k == "string" ? k : null),
            options: p.value,
            "aria-label": u(i)("openWith.title"),
            "testid-prefix": "open-with-choice"
          }, null, 8, ["model-value", "options", "aria-label"]),
          e.kind ? (f(), h("label", uie, [
            cn(d("input", {
              "onUpdate:modelValue": x[1] || (x[1] = (k) => l.value = k),
              type: "checkbox",
              "data-testid": "open-with-always"
            }, null, 512), [
              [wc, l.value]
            ]),
            d("span", null, y(u(i)("openWith.always", { ext: "." + e.kind })), 1)
          ])) : D("", !0),
          e.kind ? (f(), h("p", cie, y(u(i)("openWith.hint")), 1)) : D("", !0)
        ])
      ]),
      _: 1
    }, 8, ["open", "locale", "theme", "title"]));
  }
});
function LT(e) {
  if (!e) return null;
  if (typeof HTMLElement < "u" && e instanceof HTMLElement) return e;
  const t = e.$el;
  return typeof HTMLElement < "u" && t instanceof HTMLElement ? t : null;
}
function Kg() {
  if (typeof window > "u") return { width: 0, height: 0 };
  const e = typeof document < "u" ? document.documentElement : null, t = e && e.clientWidth > 0 ? e.clientWidth : window.innerWidth, n = e && e.clientHeight > 0 ? e.clientHeight : window.innerHeight;
  return { width: t, height: n };
}
function Vg(e, t, n = {}) {
  const a = n.dir === "rtl", i = a ? "left" : "right", r = n.gutter ?? 8, l = Math.round(e.bottom + (n.gap ?? 6)), c = Math.round(a ? e.left ?? 0 : t.width - e.right), p = Math.max(200, t.height - l - r), m = `${n.maxHeight ? Math.min(n.maxHeight, p) : p}px`;
  if (!n.width) return { top: `${l}px`, [i]: `${c}px`, maxHeight: m };
  const v = Math.max(0, Math.min(n.width, t.width - r * 2)), x = Math.min(Math.max(c, r), t.width - v - r);
  return { top: `${l}px`, [i]: `${Math.round(x)}px`, width: `${Math.round(v)}px`, maxHeight: m };
}
function Ho(e) {
  return typeof e == "string" ? e : "";
}
function pie(e, t) {
  const n = { title: Ho(e.title), body: Ho(e.body) }, a = e.e2e;
  if (!a || typeof t != "function" || !Array.isArray(a.names)) return n;
  const i = a.names.map((l) => {
    let c = null;
    try {
      c = t(Ho(l == null ? void 0 : l.wire), Ho(l == null ? void 0 : l.root));
    } catch {
      c = null;
    }
    return c ? l.part === "path" ? Ho(c.path) : Ho(c.name) : Ho(l == null ? void 0 : l.locked);
  }), r = (l, c) => Array.isArray(l) ? l.map((p) => typeof (p == null ? void 0 : p.name) == "number" ? i[p.name] ?? "" : Ho(p == null ? void 0 : p.text)).join("") : c;
  return { title: r(a.title, n.title), body: r(a.body, n.body) };
}
function hie() {
  function e(t) {
    return pie(t, Pte);
  }
  return { notificationText: e };
}
const mp = ".trash";
function T0(e, t) {
  const n = (a) => {
    const i = String(a ?? ""), r = i.indexOf("://");
    return r < 0 ? i : `${i.slice(0, r + 3)}${i.slice(r + 3).replace(/^\/+/, "")}`;
  };
  return n(e) === n(t);
}
function mie(e) {
  let t = String(e ?? "").trim().replace(/\\/g, "/");
  const n = t.indexOf("://");
  return n >= 0 && (t = t.slice(n + 3)), t.replace(/^\/+/, "").replace(/\/+$/, "");
}
function vie(e) {
  const t = e.lastIndexOf("/");
  return t < 0 ? "" : e.slice(0, t);
}
function RT(e) {
  var i, r, l;
  if (!e || !e.kind || e.kind === "none") return { kind: "none" };
  if (e.kind === "share") {
    const c = String(e.id ?? "").trim();
    return c ? { kind: "share", token: c } : { kind: "none" };
  }
  if (e.kind === "app") {
    const c = String(((i = e.open) == null ? void 0 : i.plugin) ?? "").trim(), p = String(((r = e.open) == null ? void 0 : r.view) ?? "").trim(), m = String(((l = e.open) == null ? void 0 : l.section) ?? "").trim();
    return !c || !p ? { kind: "none" } : { kind: "app", plugin: c, view: p, ...m ? { section: m } : {} };
  }
  const t = String(e.storage ?? "").trim(), n = mie(e.path);
  if (e.kind === "trash")
    return t && n ? { kind: "trash", select: `${t}://${n}` } : { kind: "trash" };
  if (!t) return { kind: "none" };
  const a = yie(e);
  return e.kind === "dir" ? { kind: "folder", storage: t, folder: n, ...a ? { open: a } : {} } : e.kind === "file" ? n ? {
    kind: "folder",
    storage: t,
    folder: vie(n),
    select: `${t}://${n}`,
    ...a ? { open: a } : {}
  } : { kind: "folder", storage: t, folder: "", ...a ? { open: a } : {} } : { kind: "none" };
}
function yie(e) {
  const t = e.open;
  if (!t || typeof t != "object") return;
  const n = String(t.plugin ?? "").trim(), a = String(t.action ?? "").trim(), i = String(t.view ?? "").trim();
  if (!(!n || !a && !i))
    return { plugin: n, ...a ? { action: a } : {}, ...i ? { view: i } : {} };
}
function gie(e) {
  return RT(e).kind !== "none";
}
function bie(e) {
  return typeof e.opens == "boolean" ? e.opens : gie(e.target);
}
function hy(e) {
  return e.kind === "trash" ? mp : e.kind !== "folder" ? "" : e.folder ? `${e.storage}/${e.folder}` : e.storage;
}
function NT(e) {
  return e ? e.split("/").map(encodeURIComponent).join("/") : "";
}
function kie(e) {
  return e.kind === "trash" ? mp : e.kind !== "folder" ? "" : `${e.storage}://${e.folder}`;
}
function Ipe(e, t = {}) {
  const n = String(e ?? "").replace(/^#/, "").replace(/^\/+/, "");
  if (!n) return "";
  let a = n;
  if (!t.decoded)
    try {
      a = decodeURIComponent(n);
    } catch {
    }
  const i = a.indexOf("/");
  return i < 0 ? `${a}://` : `${a.slice(0, i)}://${a.slice(i + 1)}`;
}
function Bpe(e) {
  if (e.kind === "app")
    return {
      name: "app-home",
      params: { plugin: e.plugin, view: e.view },
      query: e.section ? { section: e.section } : {},
      hash: ""
    };
  if (e.kind === "folder") {
    const t = e.select ? { select: e.select } : {};
    return e.open && (t.app = e.open.plugin, e.open.action ? t.appAction = e.open.action : e.open.view && (t.appView = e.open.view)), {
      name: "explore",
      query: t,
      // vue-router wants the '#'; the explorer encodes segment-by-segment, so
      // we hand over the readable form and let the browser escape it.
      hash: `#${hy(e)}`
    };
  }
  return e.kind === "trash" ? {
    name: "explore",
    query: e.select ? { select: e.select } : {},
    hash: `#${hy(e)}`
  } : null;
}
function IT(e, t = "") {
  return `${t.replace(/\/+$/, "")}/s/${encodeURIComponent(e)}`;
}
function Fpe(e, t = "/", n = "") {
  if (e.kind === "share") return IT(e.token, n);
  const a = `${String(t || "/").replace(/\/+$/, "")}/`;
  if (e.kind === "app") {
    const l = `${a}app/${encodeURIComponent(e.plugin)}/${encodeURIComponent(e.view)}`;
    return e.section ? `${l}?section=${encodeURIComponent(e.section)}` : l;
  }
  if (e.kind !== "folder" && e.kind !== "trash") return "";
  const i = [];
  e.select && i.push(`select=${encodeURIComponent(e.select)}`), e.kind === "folder" && e.open && (i.push(`app=${encodeURIComponent(e.open.plugin)}`), e.open.action ? i.push(`appAction=${encodeURIComponent(e.open.action)}`) : e.open.view && i.push(`appView=${encodeURIComponent(e.open.view)}`));
  const r = NT(hy(e));
  return `${a}explore${i.length ? `?${i.join("&")}` : ""}${r ? `#${r}` : ""}`;
}
const wie = { class: "fx-nrow__body" }, _ie = { class: "fx-nrow__meta" }, xie = { class: "fx-nrow__when" }, Sie = { class: "fx-nrow__title" }, $ie = {
  key: 0,
  class: "fx-nrow__body-text"
}, BT = /* @__PURE__ */ rt({
  __name: "NotificationRow",
  props: {
    item: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), { notificationText: r } = hie(), l = E(() => r(n.item)), c = E(() => bie(n.item)), p = E(() => !n.item.read_at), m = E(() => M2(n.item.created_at, n.locale, { time: !0 }) || "-");
    function v(k) {
      const _ = `notifications.severity.${k}`, w = i(_);
      return w === _ ? k : w;
    }
    function x(k) {
      return k === "critical" || k === "error" ? "danger" : k === "warning" ? "warning" : "info";
    }
    return (k, _) => (f(), We(Ki(c.value ? "button" : "div"), {
      type: c.value ? "button" : void 0,
      class: Ne(["fx-nrow", { "is-unread": p.value, "has-target": c.value, "is-static": !c.value }]),
      title: c.value ? u(i)("notifications.openTarget") : void 0,
      "data-testid": "notification-row",
      "data-clickable": c.value ? "yes" : "no",
      "data-notification-id": e.item.id,
      onClick: _[0] || (_[0] = (w) => c.value ? a("open", e.item) : void 0)
    }, {
      default: mt(() => [
        _[1] || (_[1] = d("span", {
          class: "fx-nrow__dot",
          "aria-hidden": "true"
        }, null, -1)),
        d("span", wie, [
          d("span", _ie, [
            d("span", {
              class: Ne(["fx-nrow__sev", `is-${x(e.item.severity)}`])
            }, y(v(e.item.severity)), 3),
            d("span", xie, y(m.value), 1)
          ]),
          d("span", Sie, y(l.value.title), 1),
          l.value.body ? (f(), h("span", $ie, y(l.value.body), 1)) : D("", !0)
        ])
      ]),
      _: 1
    }, 8, ["type", "class", "title", "data-clickable", "data-notification-id"]));
  }
}), A0 = 99;
function Tie(e) {
  const t = Math.floor(Number(e ?? 0));
  return !Number.isFinite(t) || t <= 0 ? "" : t > A0 ? `${A0}+` : String(t);
}
function Upe(e) {
  const t = Math.floor(Number(e ?? 0));
  return Number.isFinite(t) && t > 0 ? t : 0;
}
const Aie = {
  key: 0,
  class: "fx-badge",
  "aria-hidden": "true",
  "data-testid": "unread-badge"
}, FT = /* @__PURE__ */ rt({
  __name: "UnreadBadge",
  props: {
    count: {}
  },
  setup(e) {
    const t = e, n = E(() => Tie(t.count));
    return (a, i) => n.value ? (f(), h("span", Aie, y(n.value), 1)) : D("", !0);
  }
}), Eie = ["innerHTML"], Cie = { class: "fx-bell__heading" }, zie = ["innerHTML"], Mie = {
  key: 0,
  class: "fx-bell__empty"
}, Oie = { class: "fx-bell__foot" }, Pie = ["onClick"], Die = ["href", "onClick"], uv = 360, Lie = /* @__PURE__ */ rt({
  __name: "NotificationBell",
  props: {
    feed: {},
    locale: {},
    manageHref: {}
  },
  emits: ["open", "manage"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = E(() => Math.max(0, n.feed.unreadCount || 0)), l = E(
      () => r.value > 0 ? `${i("notifications.bell")} - ${i("notifications.unreadCount", { n: r.value })}` : i("notifications.bell")
    ), c = S(null), p = S({
      top: "0px",
      right: "0px",
      width: `${uv}px`,
      maxHeight: "420px"
    });
    function m() {
      const b = LT(c.value), C = b == null ? void 0 : b.getBoundingClientRect();
      if (!C) return;
      const A = Vg(
        C,
        Kg(),
        // The list scrolls inside the panel; 520 keeps ~6 rows on a laptop and
        // the head + foot visible on a phone. ⚠ RTL: flush with the bell's END
        // edge — its left one in a right-to-left header.
        { width: uv, maxHeight: 520, dir: ei(b) }
      );
      p.value = { top: A.top, right: A.right, left: A.left, width: A.width ?? `${uv}px`, maxHeight: A.maxHeight };
    }
    function v() {
      m(), n.feed.refreshFeed();
    }
    async function x(b, C) {
      C(), b.read_at || await n.feed.markRead(b.id).catch(() => {
      }), a("open", b);
    }
    function k(b) {
      b(), n.feed.openPanel();
    }
    function _(b) {
      b(), a("manage");
    }
    const w = E(() => n.feed.feed.slice(0, 15));
    return (b, C) => (f(), We(u(EM), { class: "fx-bell" }, {
      default: mt(({ open: A, close: T }) => [
        Je(u(CM), {
          ref_key: "btnEl",
          ref: c,
          class: Ne(["fx-bell__btn", { "is-open": A }]),
          title: l.value,
          "aria-label": l.value,
          "data-testid": "notification-bell",
          onClick: m,
          onKeydown: m
        }, {
          default: mt(() => [
            d("span", {
              class: "fx-bell__icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("bell")
            }, null, 8, Eie),
            Je(FT, { count: r.value }, null, 8, ["count"])
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (f(), We(wi, { to: "body" }, [
          Je(u(zM), {
            class: "fx-bell__panel",
            style: Xt({ top: p.value.top, right: p.value.right, left: p.value.left, width: p.value.width }),
            "data-testid": "notification-panel"
          }, {
            default: mt(() => [
              d("div", {
                class: "fx-bell__head",
                onVnodeMounted: v
              }, [
                d("span", Cie, y(u(i)("notifications.title")), 1),
                e.feed.hasUnread ? (f(), h("button", {
                  key: 0,
                  type: "button",
                  class: "fx-bell__markall",
                  "data-testid": "notification-mark-all",
                  onClick: C[0] || (C[0] = (R) => e.feed.markAllRead())
                }, [
                  d("span", {
                    class: "fx-bell__markall-icon",
                    "aria-hidden": "true",
                    innerHTML: u(Pt)("check")
                  }, null, 8, zie),
                  Vt(" " + y(u(i)("notifications.markAllRead")), 1)
                ])) : D("", !0)
              ], 512),
              d("ul", {
                class: "fx-bell__list",
                style: Xt({ maxHeight: p.value.maxHeight }),
                "data-testid": "notification-list"
              }, [
                !w.value.length && !e.feed.feedLoading ? (f(), h("li", Mie, y(u(i)("notifications.empty")), 1)) : D("", !0),
                (f(!0), h(Ce, null, nt(w.value, (R) => (f(), h("li", {
                  key: R.id
                }, [
                  Je(BT, {
                    item: R,
                    locale: e.locale,
                    onOpen: (M) => x(M, T)
                  }, null, 8, ["item", "locale", "onOpen"])
                ]))), 128))
              ], 4),
              d("div", Oie, [
                d("button", {
                  type: "button",
                  class: "fx-bell__all",
                  "data-testid": "notification-view-all",
                  onClick: (R) => k(T)
                }, y(u(i)("notifications.viewAll")), 9, Pie),
                e.manageHref ? (f(), h("a", {
                  key: 0,
                  href: e.manageHref,
                  class: "fx-bell__manage",
                  "data-testid": "notification-manage",
                  onClick: vt((R) => _(T), ["prevent"])
                }, y(u(i)("notifications.manageAdmin")), 9, Die)) : D("", !0)
              ])
            ]),
            _: 2
          }, 1032, ["style"])
        ]))
      ]),
      _: 1
    }));
  }
}), Rie = ["aria-label"], Nie = { class: "fx-nall__sheet" }, Iie = { class: "fx-nall__head" }, Bie = { class: "fx-nall__title" }, Fie = {
  class: "fx-nall__title-icon",
  "aria-hidden": "true"
}, Uie = ["innerHTML"], Hie = { class: "fx-nall__tools" }, Kie = ["aria-pressed"], Vie = ["aria-label"], jie = ["innerHTML"], qie = {
  key: 0,
  class: "fx-nall__error",
  "data-testid": "notifications-screen-error"
}, Wie = {
  class: "fx-nall__list",
  "data-testid": "notifications-screen-list"
}, Yie = {
  key: 0,
  class: "fx-nall__empty"
}, Gie = ["title", "aria-label", "onClick"], Xie = ["innerHTML"], Jie = {
  key: 1,
  class: "fx-nall__foot",
  "data-testid": "notifications-screen-pager"
}, Zie = ["disabled"], Qie = { class: "fx-nall__count" }, eoe = ["disabled"], toe = /* @__PURE__ */ rt({
  __name: "NotificationsPanel",
  props: {
    feed: {},
    locale: {}
  },
  emits: ["open"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = E(() => Math.floor(n.feed.mineOffset / n.feed.mineLimit) + 1), l = E(() => Math.max(1, Math.ceil(n.feed.mineTotal / n.feed.mineLimit)));
    function c(k) {
      k < 1 || k > l.value || (n.feed.setMinePage(k), n.feed.fetchMine());
    }
    function p() {
      n.feed.setMineUnreadFilter(!n.feed.mineUnreadOnly), n.feed.fetchMine();
    }
    async function m(k) {
      n.feed.closePanel(), k.read_at || await n.feed.markRead(k.id).catch(() => {
      }), a("open", k);
    }
    async function v(k) {
      k.read_at || await n.feed.markRead(k.id).catch(() => {
      });
    }
    function x(k) {
      k.key === "Escape" && n.feed.closePanel();
    }
    return Xe(
      () => n.feed.panelOpen,
      (k) => {
        k ? window.addEventListener("keydown", x) : window.removeEventListener("keydown", x);
      },
      { immediate: !0 }
    ), Ct(() => window.removeEventListener("keydown", x)), (k, _) => (f(), We(wi, { to: "body" }, [
      e.feed.panelOpen ? (f(), h("div", {
        key: 0,
        class: "fx-nall",
        role: "dialog",
        "aria-modal": "true",
        "aria-label": u(i)("notifications.title"),
        "data-testid": "notifications-screen"
      }, [
        d("div", {
          class: "fx-nall__scrim",
          onClick: _[0] || (_[0] = vt((w) => e.feed.closePanel(), ["self"]))
        }),
        d("section", Nie, [
          d("header", Iie, [
            d("span", Bie, [
              d("span", Fie, [
                d("span", {
                  innerHTML: u(Pt)("bell")
                }, null, 8, Uie),
                Je(FT, {
                  count: e.feed.unreadCount
                }, null, 8, ["count"])
              ]),
              Vt(" " + y(u(i)("notifications.title")), 1)
            ]),
            d("div", Hie, [
              d("button", {
                type: "button",
                class: Ne(["fx-nall__tool", { "is-on": e.feed.mineUnreadOnly }]),
                "aria-pressed": e.feed.mineUnreadOnly,
                "data-testid": "notifications-screen-unread",
                onClick: p
              }, y(u(i)("notifications.unreadOnly")), 11, Kie),
              e.feed.hasUnread ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fx-nall__tool",
                "data-testid": "notifications-screen-mark-all",
                onClick: _[1] || (_[1] = (w) => e.feed.markAllRead())
              }, y(u(i)("notifications.markAllRead")), 1)) : D("", !0),
              d("button", {
                type: "button",
                class: "fx-nall__close",
                "aria-label": u(i)("modal.close"),
                "data-testid": "notifications-screen-close",
                onClick: _[2] || (_[2] = (w) => e.feed.closePanel())
              }, [
                d("span", {
                  "aria-hidden": "true",
                  innerHTML: u(Pt)("close")
                }, null, 8, jie)
              ], 8, Vie)
            ])
          ]),
          e.feed.mineError ? (f(), h("p", qie, y(e.feed.mineError), 1)) : D("", !0),
          d("ul", Wie, [
            !e.feed.mine.length && !e.feed.mineLoading ? (f(), h("li", Yie, y(u(i)("notifications.empty")), 1)) : D("", !0),
            (f(!0), h(Ce, null, nt(e.feed.mine, (w) => (f(), h("li", {
              key: w.id,
              class: "fx-nall__item"
            }, [
              Je(BT, {
                item: w,
                locale: e.locale,
                onOpen: m
              }, null, 8, ["item", "locale"]),
              w.read_at ? D("", !0) : (f(), h("button", {
                key: 0,
                type: "button",
                class: "fx-nall__read",
                title: u(i)("notifications.markRead"),
                "aria-label": u(i)("notifications.markRead"),
                "data-testid": "notifications-screen-mark-one",
                onClick: (b) => v(w)
              }, [
                d("span", {
                  "aria-hidden": "true",
                  innerHTML: u(Pt)("check")
                }, null, 8, Xie)
              ], 8, Gie))
            ]))), 128))
          ]),
          l.value > 1 ? (f(), h("footer", Jie, [
            d("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: r.value <= 1,
              onClick: _[3] || (_[3] = (w) => c(r.value - 1))
            }, y(u(i)("common.prev")), 9, Zie),
            d("span", Qie, y(u(i)("notifications.pageOf", { page: r.value, pages: l.value, total: e.feed.mineTotal })), 1),
            d("button", {
              type: "button",
              class: "fx-nall__page",
              disabled: r.value >= l.value,
              onClick: _[4] || (_[4] = (w) => c(r.value + 1))
            }, y(u(i)("common.next")), 9, eoe)
          ])) : D("", !0)
        ])
      ], 8, Rie)) : D("", !0)
    ]));
  }
}), noe = "filex", aoe = "0.0.0";
function Hpe(e) {
  return /^[0-9a-f]{8,}$/i.test(e) ? e.slice(0, 7) : e;
}
function UT(e) {
  const t = String(e ?? "").trim();
  return !t || t === aoe ? "" : `${noe} ${t}`;
}
const ioe = {
  key: 0,
  class: "fe-version",
  "data-testid": "product-version"
}, ooe = /* @__PURE__ */ rt({
  __name: "ProductVersion",
  props: {
    version: {}
  },
  setup(e) {
    const t = e, n = E(() => UT(t.version));
    return (a, i) => n.value ? (f(), h("p", ioe, [
      d("bdi", null, y(n.value), 1)
    ])) : D("", !0);
  }
}), roe = {
  class: "fx-account__face",
  "aria-hidden": "true"
}, soe = ["src"], loe = {
  key: 1,
  class: "fx-account__initial"
}, uoe = {
  key: 2,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  focusable: "false"
}, coe = { class: "fx-acctmenu__who" }, doe = ["data-testid", "onClick"], foe = ["innerHTML"], poe = { class: "fx-acctmenu__label" }, hoe = /* @__PURE__ */ rt({
  __name: "AccountMenu",
  props: {
    actions: {},
    user: {},
    version: {},
    locale: {},
    fallbackLabel: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => Rp(n.user ?? null)), r = E(() => {
      var x;
      return (((x = n.user) == null ? void 0 : x.avatar_url) || "").trim();
    }), l = E(() => {
      const x = i.value;
      return x ? [...x][0].toLocaleUpperCase(gi(n.locale)) : "";
    }), c = E(() => i.value || n.fallbackLabel), p = S(null), m = S({ top: "0px", right: "0px" });
    function v() {
      const x = LT(p.value), k = x == null ? void 0 : x.getBoundingClientRect();
      if (!k) return;
      const { top: _, right: w, left: b } = Vg(
        k,
        Kg(),
        { dir: ei(x) }
      );
      m.value = { top: _, right: w, left: b };
    }
    return (x, k) => (f(), We(u(MM), {
      as: "div",
      class: "fx-account"
    }, {
      default: mt(({ open: _ }) => [
        Je(u(OM), {
          ref_key: "btnEl",
          ref: p,
          class: Ne(["fx-account__btn", { "is-open": _ }]),
          title: c.value,
          "aria-label": c.value,
          "data-testid": "explore-account",
          onClick: v,
          onKeydown: v
        }, {
          default: mt(() => [
            d("span", roe, [
              r.value ? (f(), h("img", {
                key: 0,
                class: "fx-account__img",
                src: r.value,
                alt: ""
              }, null, 8, soe)) : l.value ? (f(), h("span", loe, y(l.value), 1)) : (f(), h("svg", uoe, [...k[0] || (k[0] = [
                d("circle", {
                  cx: "12",
                  cy: "8.5",
                  r: "3.5"
                }, null, -1),
                d("path", { d: "M5.5 19.5a6.5 6.5 0 0 1 13 0" }, null, -1)
              ])]))
            ]),
            k[1] || (k[1] = d("svg", {
              class: "fx-account__chev",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
              focusable: "false"
            }, [
              d("path", { d: "M7 10l5 5 5-5" })
            ], -1))
          ]),
          _: 1
        }, 8, ["class", "title", "aria-label"]),
        (f(), We(wi, { to: "body" }, [
          Je(zr, {
            "enter-active-class": "fx-acct-in",
            "leave-active-class": "fx-acct-out"
          }, {
            default: mt(() => [
              Je(u(PM), {
                class: "fx-acctmenu",
                style: Xt({ top: m.value.top, right: m.value.right, left: m.value.left }),
                "data-testid": "explore-account-menu"
              }, {
                default: mt(() => [
                  d("p", coe, y(c.value), 1),
                  (f(!0), h(Ce, null, nt(e.actions, (w) => (f(), We(u(DM), {
                    key: w.key
                  }, {
                    default: mt(({ active: b }) => [
                      d("button", {
                        type: "button",
                        class: Ne(["fx-acctmenu__item", { "is-active": b, "is-separated": w.separated }]),
                        "data-testid": `explore-${w.key}`,
                        onClick: (C) => a("select", w.key)
                      }, [
                        d("span", {
                          class: "fx-acctmenu__icon",
                          "aria-hidden": "true",
                          innerHTML: u(Pt)(w.icon || w.key)
                        }, null, 8, foe),
                        d("span", poe, y(w.label), 1)
                      ], 10, doe)
                    ]),
                    _: 2
                  }, 1024))), 128)),
                  u(UT)(e.version) ? (f(), We(ooe, {
                    key: 0,
                    version: e.version,
                    class: "fx-acctmenu__version"
                  }, null, 8, ["version"])) : D("", !0)
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]))
      ]),
      _: 1
    }));
  }
});
function E0(e, t) {
  const n = t.replace(/\/+$/, ""), a = (i, r) => ({
    method: i,
    headers: { "Content-Type": "application/json" },
    ...r === void 0 ? {} : { body: JSON.stringify(r) }
  });
  return {
    updateProfile: (i) => e(`${n}/api/auth/profile`, a("PATCH", i)),
    checkAccount: (i) => e(`${n}/api/auth/account/check`, a("POST", i)),
    changePassword: async (i, r) => {
      await e(`${n}/api/auth/password`, a("POST", { current_password: i, new_password: r }));
    },
    enrollTotp: () => e(`${n}/api/auth/totp/enroll`, a("POST")),
    verifyTotp: async (i) => {
      await e(`${n}/api/auth/totp/verify`, a("POST", { code: i }));
    },
    disableTotp: async (i) => {
      await e(`${n}/api/auth/totp/disable`, a("POST", { code: i }));
    },
    quota: () => e(`${n}/api/files/quota/me`),
    notificationSettings: () => e(`${n}/api/notifications/settings`),
    updateNotificationSettings: (i) => e(`${n}/api/notifications/settings`, a("PATCH", i)),
    pluginActions: () => e(`${n}/api/files/plugins/actions`),
    vaultIdle: async () => (await e(`${n}/api/files/e2e/vault/prefs`)).idle_minutes,
    setVaultIdle: async (i) => (await e(`${n}/api/files/e2e/vault/prefs`, a("PUT", { idle_minutes: i }))).idle_minutes,
    assistant: () => e(`${n}/api/files/assistant`),
    setAssistantPrefs: (i) => e(`${n}/api/files/assistant/prefs`, a("PUT", i)),
    clearAssistantHistory: async () => {
      await e(`${n}/api/files/assistant/conversations`, a("DELETE"));
    }
  };
}
const moe = 50, voe = 15e3;
function yoe(e) {
  const t = e.transport, n = e.errorText ?? ((re) => re instanceof Error ? re.message : String(re)), a = () => {
    var re;
    return ((re = e.alsoStamp) == null ? void 0 : re.call(e)) ?? [];
  }, i = S([]), r = S(!1), l = S([]), c = S(0), p = S(25), m = S(0), v = S(!1), x = S(!1), k = S(null);
  let _ = 0;
  const w = S(!1);
  let b = null, C = 0;
  const A = S(0), T = E(() => A.value > 0);
  async function R() {
    const re = ++C;
    r.value = !0;
    try {
      const [ve, W] = await Promise.all([
        t.list({ unread: !1, limit: moe, offset: 0 }),
        t.unreadCount()
      ]);
      return re !== C || (i.value = ve.items ?? [], A.value = W, b = W), !0;
    } catch {
      return !1;
    } finally {
      re === C && (r.value = !1);
    }
  }
  async function M() {
    try {
      A.value = await t.unreadCount();
    } catch {
    }
  }
  async function L() {
    await M(), b !== A.value && await R();
  }
  async function U(re) {
    const ve = Math.max(0, Math.floor(Number(re) || 0));
    A.value = ve, b !== ve && await R();
  }
  async function P() {
    const re = ++_;
    x.value = !0, k.value = null;
    try {
      const ve = await t.list({
        unread: v.value,
        limit: p.value,
        offset: m.value
      });
      if (re !== _) return;
      l.value = ve.items ?? [], c.value = ve.total ?? 0;
    } catch (ve) {
      if (re !== _) return;
      k.value = n(ve);
    } finally {
      re === _ && (x.value = !1);
    }
  }
  function H(re) {
    m.value = Math.max(0, (re - 1) * p.value);
  }
  function $(re) {
    v.value = re, m.value = 0;
  }
  function F() {
    w.value = !0, m.value = 0, P();
  }
  function I() {
    w.value = !1;
  }
  async function Z(re) {
    var fe;
    await t.markRead(re);
    const ve = (/* @__PURE__ */ new Date()).toISOString(), W = (j) => j.id === re && !j.read_at ? { ...j, read_at: ve } : j, z = [i, l, ...a()], le = z.some((j) => j.value.some((X) => X.id === re && !X.read_at));
    for (const j of z) j.value = j.value.map(W);
    le && A.value > 0 && (A.value -= 1, b !== null && b > 0 && (b -= 1)), (fe = e.onRead) == null || fe.call(e);
  }
  async function J() {
    var W;
    await t.markAllRead();
    const re = (/* @__PURE__ */ new Date()).toISOString(), ve = (z) => ({ ...z, read_at: z.read_at ?? re });
    for (const z of [i, l, ...a()]) z.value = z.value.map(ve);
    A.value = 0, b !== null && (b = 0), (W = e.onRead) == null || W.call(e), w.value && v.value && (m.value = 0, P());
  }
  return {
    feed: i,
    feedLoading: r,
    unreadCount: A,
    hasUnread: T,
    mine: l,
    mineTotal: c,
    mineLimit: p,
    mineOffset: m,
    mineUnreadOnly: v,
    mineLoading: x,
    mineError: k,
    panelOpen: w,
    refreshFeed: R,
    fetchUnread: M,
    syncUnread: L,
    acceptCount: U,
    fetchMine: P,
    setMinePage: H,
    setMineUnreadFilter: $,
    openPanel: F,
    closePanel: I,
    markRead: Z,
    markAllRead: J
  };
}
function goe(e, t) {
  const n = `${t.replace(/\/+$/, "")}/api/notifications`;
  return {
    async list(a) {
      const i = [];
      return a.unread && i.push("unread=true"), a.limit != null && i.push(`limit=${encodeURIComponent(String(a.limit))}`), a.offset != null && i.push(`offset=${encodeURIComponent(String(a.offset))}`), await e(
        i.length ? `${n}?${i.join("&")}` : n
      ) ?? { items: [], total: 0 };
    },
    async unreadCount() {
      const a = await e(`${n}/unread-count`);
      return Math.max(0, Number((a == null ? void 0 : a.count) ?? 0) || 0);
    },
    async markRead(a) {
      await e(`${n}/${encodeURIComponent(String(a))}/read`, { method: "POST" });
    },
    async markAllRead() {
      await e(`${n}/read-all`, { method: "POST" });
    }
  };
}
const boe = ["view-list", "view-grid", "view-gallery", "inspector", "nav"], koe = ["theme", "density", "timezone", "shortcut-settings"], my = "fe:";
function woe(e, t, n = {}) {
  const a = new Set(n.omit ?? []), i = [...e];
  t.filter((r) => !r.divider && !a.has(r.key)).forEach(
    (r, l) => i.push({
      key: `${my}${r.key}`,
      label: r.label,
      icon: r.icon || r.key,
      separated: l === 0
    })
  );
  for (const r of n.tail ?? []) i.push({ ...r, separated: r.separated ?? !0 });
  return i;
}
function _oe(e) {
  return e.startsWith(my) ? e.slice(my.length) : null;
}
function ea(e) {
  return G0({ loader: e, suspensible: !1 });
}
const xoe = ["dir"], Soe = ["title", "aria-label"], $oe = { class: "fe__stack" }, Toe = { class: "fe__panes" }, Aoe = {
  key: 0,
  class: "fe-search-cut",
  role: "status"
}, Eoe = {
  key: 1,
  class: "fe-search-cut fe-nav-more",
  role: "status",
  "data-testid": "nav-more"
}, Coe = ["disabled", "aria-busy"], zoe = {
  key: 2,
  class: "fe-coverage",
  role: "status",
  "data-testid": "catalog-coverage"
}, Moe = { class: "fe-coverage__text" }, Ooe = ["disabled", "aria-busy"], Poe = {
  key: 3,
  class: "fe__presence"
}, Doe = ["title"], Loe = {
  key: 4,
  class: "fe-e2e-upgrade",
  role: "alert"
}, Roe = { class: "fe-e2e-upgrade__text" }, Noe = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, Ioe = { class: "fe-e2e-upgrade__actions" }, Boe = ["disabled"], Foe = ["disabled"], Uoe = {
  key: 5,
  class: "fe-e2e-upgrade fe-e2e-upgrade--escrow",
  role: "alert"
}, Hoe = { class: "fe-e2e-upgrade__text" }, Koe = { class: "fe-e2e-upgrade__escrow" }, Voe = {
  key: 0,
  class: "fe-e2e-upgrade__escrow"
}, joe = {
  key: 1,
  class: "fe-e2e-upgrade__pw"
}, qoe = ["disabled"], Woe = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, Yoe = { class: "fe-e2e-upgrade__actions" }, Goe = ["disabled"], Xoe = ["disabled"], Joe = {
  key: 6,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-convert-strip"
}, Zoe = { class: "fe-e2e-upgrade__text" }, Qoe = { key: 0 }, ere = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-convert-progress"
}, tre = {
  key: 2,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-convert-large"
}, nre = {
  key: 3,
  class: "fe-form__error",
  role: "alert"
}, are = { class: "fe-e2e-upgrade__actions" }, ire = {
  key: 7,
  class: "fe-e2e-upgrade fe-e2e-upgrade--names",
  role: "status",
  "data-testid": "e2e-names-progress-strip"
}, ore = { class: "fe-e2e-upgrade__text" }, rre = { key: 0 }, sre = {
  key: 1,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-names-progress"
}, lre = {
  key: 2,
  class: "fe-form__error",
  role: "alert"
}, ure = { class: "fe-e2e-upgrade__actions" }, cre = {
  key: 8,
  class: "fe-e2e-upgrade fe-e2e-upgrade--rekey",
  role: "status",
  "data-testid": "e2e-rekey-offer"
}, dre = { class: "fe-e2e-upgrade__text" }, fre = {
  key: 0,
  class: "fe-e2e-upgrade__progress",
  "data-testid": "e2e-rekey-progress"
}, pre = {
  key: 1,
  class: "fe-form__error",
  role: "alert"
}, hre = { class: "fe-e2e-upgrade__actions" }, mre = ["disabled"], vre = {
  key: 10,
  class: "fe-e2e-strip",
  role: "status"
}, yre = ["innerHTML"], gre = { class: "fe-e2e-strip__label" }, bre = {
  class: "fe-e2e-strip__names",
  "data-testid": "e2e-names-status"
}, kre = ["disabled"], wre = {
  key: 11,
  class: "fe-trashbar"
}, _re = { class: "fe-trashbar__text" }, xre = {
  key: 0,
  class: "fe-trashbar__count",
  "data-testid": "trash-summary"
}, Sre = {
  key: 0,
  class: "fe-trashbar__shown"
}, $re = ["disabled"], Tre = {
  key: 2,
  class: "fe-trashbar__progress",
  role: "status",
  "aria-live": "polite"
}, Are = ["disabled"], Ere = {
  key: 2,
  class: "fe-state"
}, Cre = { class: "fe-state__title" }, zre = { class: "fe-state__path" }, Mre = { class: "fe-state__hint" }, Ore = { class: "fe-state__actions" }, Pre = {
  key: 0,
  class: "fe-state"
}, Dre = { class: "fe-state__title" }, Lre = { class: "fe-state__hint" }, Rre = ["data-testid"], Nre = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, Ire = {
  key: 1,
  d: "M60 26l9 18.6 20.4 3-14.8 14.4 3.5 20.4L60 72.8 41.9 82.4l3.5-20.4L30.6 47.6l20.4-3z"
}, Bre = { class: "fe-state__title" }, Fre = { class: "fe-state__hint" }, Ure = {
  key: 2,
  class: "fe-state"
}, Hre = { class: "fe-state__title" }, Kre = { class: "fe-state__hint" }, Vre = {
  key: 3,
  class: "fe-state"
}, jre = {
  class: "fe-state__art",
  viewBox: "0 0 120 100",
  width: "110",
  height: "92",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, qre = { key: 0 }, Wre = { class: "fe-state__title" }, Yre = {
  key: 0,
  class: "fe-state__hint"
}, Gre = {
  key: 1,
  class: "fe-state__actions"
}, Xre = { class: "fe-overlay__head" }, Jre = { class: "fe-overlay__title" }, Zre = ["title", "aria-label"], Qre = {
  key: 1,
  class: "fe__dragover"
}, ese = { class: "fe__dragover-card" }, tse = ["innerHTML"], nse = ["title", "aria-label"], ase = {
  key: 3,
  class: "fe-keep-strip",
  role: "status",
  "aria-live": "polite"
}, ise = { class: "fe-keep-strip__label" }, ose = {
  key: 0,
  class: "fe-keep-strip__bar",
  "aria-hidden": "true"
}, rse = {
  key: 0,
  "data-testid": "trash-empty-count"
}, sse = {
  key: 1,
  class: "fe-form__error",
  role: "alert"
}, lse = {
  key: 2,
  role: "status"
}, use = ["disabled"], cse = { class: "fe-recents__header" }, dse = ["aria-label"], fse = { class: "fe-modal__head" }, pse = { class: "fe-modal__title" }, hse = ["aria-label"], mse = { class: "fe-modal__body" }, vse = { class: "fe-toast__msg" }, C0 = "brf-file-explorer:view-mode", cf = 250, z0 = 3, M0 = "user-settings", yse = 800, O0 = "filex.inspector", P0 = "filex.sidenav", D0 = 250, Ru = 100, gse = 500, bse = 2e3, hi = 2500, bn = 6e3, df = 10 * 60 * 1e3, L0 = 200, cv = "brf-file-explorer:path", kse = 40, wse = "application/x-brf-files", _se = 8 * 1024 * 1024, xse = 10, Sse = "/files/edit", R0 = "filex.tabs", $se = "https://docs.filex.sh/E2E-ENCRYPTION#what-escrow-can-and-cannot-do", Tse = 6e4, Ase = 2e3, Kpe = /* @__PURE__ */ rt({
  __name: "FileExplorer",
  props: {
    config: {}
  },
  emits: ["share-created", "file-opened", "error", "upload-progress", "selection-change", "navigate", "refresh", "open-my-shares", "open-app-store", "open-app-home"],
  setup(e, { expose: t, emit: n }) {
    var _w;
    const a = () => import("./E2eVaultStrip-bpbXc9VW.js"), i = G0(a), r = ea(() => import("./PreviewModal-Dsw9p6If.js").then((o) => o.P)), l = ea(() => import("./QuickLook-ZIhDsUcB.js")), c = ea(() => import("./UserSettingsDialog-CQnxM1IM.js")), p = ea(() => import("./TimeZoneDialog-CR5Rpi0Y.js")), m = ea(() => import("./PermissionsModal-BEDKSeLs.js")), v = ea(() => import("./AdvancedSearch-mdfaD0Dx.js")), x = ea(() => import("./CommandPalette-Dl_YPwpv.js")), k = ea(() => import("./NewDocumentModal-CcRjhcOb.js")), _ = ea(() => import("./ArchiveCreateModal-CHoNFSOd.js")), w = ea(() => import("./OnboardingTour-DTf6ztZD.js")), b = ea(() => import("./ShortcutSettings-gioxUeZe.js")), C = ea(() => import("./EncryptedFolderModal-CqqO2hZv.js")), A = ea(() => import("./E2eSettingsModal-BYqHMRZW.js")), T = ea(() => import("./E2eChangePasswordModal-D8m7DUHA.js")), R = ea(() => import("./RecoveryKeyModal-Dw1bfJuF.js")), M = ea(() => import("./E2eRecoveryUnlockModal-X1B9xajl.js")), L = ea(() => import("./E2eFileEncryptModal-pothre07.js")), U = ea(() => import("./E2eFileUnlockModal-CSpVDifC.js")), P = e, H = n, $ = zl(P.config), F = S(null), I = E(
      () => {
        var o;
        return P.config.permissions ?? ((o = F.value) == null ? void 0 : o.permissions);
      }
    ), Z = E(
      () => {
        var o;
        return P.config.permissions ? P.config.permissionsByFolder : (o = F.value) == null ? void 0 : o.byFolder;
      }
    );
    let J = Promise.resolve();
    function re() {
      P.config.permissions || (J = $.myPermissions().then(
        (o) => {
          F.value = o && !o.admin ? { permissions: o.permissions, byFolder: o.byFolder } : null;
        },
        () => {
          F.value = null;
        }
      ));
    }
    qt(re);
    const ve = S(""), W = E(() => Ca(ve.value || P.config.locale));
    jo(O2, () => W.value), Xe(W, (o) => rg(o), { immediate: !0 });
    const { t: z, formatDate: le, dir: fe } = ht(W), j = xne({
      http: {
        endpoints: $.endpoints,
        authHeaders: (o) => $.authHeaders(o),
        credentialsMode: () => $.credentialsMode(),
        downloadUrl: (o) => $.downloadUrl(o),
        acceptLanguage: () => gi(W.value)
      },
      headersNow: () => $.authHeadersSync(),
      t: (o, s) => z(o, s),
      toast: (o, s) => Yt({ message: o }, s ? bn : hi),
      emitError: (o, s) => H("error", { message: o, context: { op: s } }),
      // The lock's holder says which client: the desktop app is the explorer that
      // was handed the shell's hooks.
      clientKind: () => P.config.desktopSync || P.config.dragOut ? "desktop" : "web",
      dropKeys: (o) => Pz(o),
      formatCount: (o) => new Intl.NumberFormat(gi(W.value)).format(o),
      onLocked: (o, s) => Dz(o, s),
      onChanged: (o) => Lz(o),
      onLockSoon: (o, s) => Tz(o, s),
      askName: (o) => te(o)
    }), X = S(null);
    function te(o) {
      return new Promise((s) => {
        X.value = { ...o, resolve: s };
      });
    }
    function V(o) {
      const s = X.value;
      X.value = null, s == null || s.resolve(o);
    }
    function G(o) {
      return j.rootOf(o) ?? o;
    }
    function q(o) {
      const s = String(o ?? "").replace(/\/+$/, ""), g = j.rootOf(s);
      if (!g || !j.isOpen(g)) return null;
      const O = j.rows(s) ? s : g, N = j.permOf(g);
      return {
        adapter: O.slice(0, O.indexOf("://")),
        storages: [],
        dirname: O,
        read_only: !1,
        ...N ? { perm: N } : {},
        e2e_root: g,
        e2e_vault_root: g,
        files: Tr(j.rows(O) ?? [])
      };
    }
    function B(o) {
      const s = String(o.dirname ?? "").replace(/\/+$/, ""), g = typeof o.e2e_vault_root == "string" && o.e2e_vault_root ? o.e2e_vault_root : j.rootOf(s);
      return g ? { ...o, e2e_vault_root: g, files: [] } : o;
    }
    const K = {
      ...$,
      index: async (o) => {
        const s = q(o);
        if (s) return s;
        const g = j.rootOf(String(o ?? ""));
        return B(await $.index(g ?? o));
      }
    }, ke = () => Promise.reject(new Error("vault: not asked")), Ye = {
      ...$,
      listShares: (o) => j.rootOf(o) ? ke() : $.listShares(o),
      listPermissions: (o) => j.rootOf(o) ? ke() : $.listPermissions(o),
      createShare: (o) => j.rootOf(o.path) ? ke() : $.createShare(o)
    };
    function Oe() {
      typeof document < "u" && document.visibilityState === "visible" && j.onVisible();
    }
    qt(() => {
      typeof document < "u" && document.addEventListener("visibilitychange", Oe), typeof window < "u" && window.addEventListener("pagehide", j.onPageHide);
    }), Ct(() => {
      typeof document < "u" && document.removeEventListener("visibilitychange", Oe), typeof window < "u" && window.removeEventListener("pagehide", j.onPageHide), j.closeAll("manual");
    });
    const Be = VP($, {
      reload: () => kt(),
      onVault: (o) => j.onEvent(o),
      onAccess: (o) => CE(o)
    }), qe = Be.presenceUsers, Tt = Be.degraded;
    function $t(o) {
      const s = (o || "").replace(/^\/+|\/+$/g, "");
      if (s === ".trash" || s.startsWith(".trash/")) return null;
      const g = It(s);
      return !g || !g.includes("://") || g.startsWith("://") ? null : j.rootOf(g) ?? g;
    }
    qt(() => {
      Be.start(), Be.subscribe($t(Le.value));
    }), Ct(() => Be.stop());
    const it = WP(P.config.apiBase, $), yt = aP(P.config, $), ft = /* @__PURE__ */ new Map(), ze = U2(P.config, $, {
      onSettled: (o) => {
        var O, N;
        const s = ft.get(o.id);
        if (ft.delete(o.id), o.op_type === "trash-empty") {
          kt();
          return;
        }
        const g = Jh.get(o.id);
        if (g) {
          Jh.delete(o.id), fu(g, !1);
          const Y = o.summary || (o.status === "error" ? Ff(o, z).text : "");
          Y && o.status !== "cancelled" && Yt({ message: Y }, o.status === "done" ? hi : bn), Rt.value && zi();
          return;
        }
        if (o.status === "cancelled") {
          const Y = o.op_type === "archive-extract" ? z("archive.extraction_cancelled", { count: o.progress_done }) : z("opc.status.aborted");
          et(Y);
        } else if (o.op_type === "restore" && o.summary)
          Yt({ message: o.summary }, o.status === "done" ? hi : bn);
        else if (o.status === "error")
          et(Ff(o, z).text);
        else if (s)
          md(o.op_type === "rename" ? s.message : `${s.message} (${o.progress_total})`, s.fn);
        else if (o.op_type === "plugin") {
          et(o.message || z("plugin.done", { label: vA(o) }));
          const Y = wS(o, { busy: !!_n.value || !!Da.value });
          if (Y) {
            th(Y.plugin, Y.open), (O = en.value) == null || O.reload();
            return;
          }
        } else if (o.op_type === "rename")
          et(z("toast.renamed"));
        else if (o.op_type === "restore")
          et(z("toast.restored", { n: o.progress_done }));
        else {
          const Y = o.op_type === "archive-create" ? z("archive.created") : o.op_type === "archive-extract" ? z("archive.extraction_completed") : o.op_type === "copy" ? z("toast.copied") : o.op_type === "move" ? z("toast.moved") : z("toast.deleted");
          et(o.op_type.startsWith("archive-") ? Y : `${Y} (${o.progress_total})`);
        }
        kt(), (N = en.value) == null || N.reload();
      }
    }), oe = S(!1), Se = (P.config.rootPath || "").trim(), he = Se.replace("://", "/").replace(/^\/+|\/+$/g, ""), Ke = he || P.config.initialPath || "", Le = S(Ke), ut = JX(), wt = (o) => ut.isNewest(o), _t = S(P.config.defaultAdapter || "brf"), At = S(Ke), _e = S([]), Ie = S(""), pe = S(!1), we = S(""), ee = S("");
    let ge;
    function ae() {
      kt(ge);
    }
    const xe = S(
      (() => {
        try {
          const o = localStorage.getItem(C0);
          if (o === "list" || o === "grid" || o === "gallery") return o;
        } catch {
        }
        return P.config.viewMode ?? "list";
      })()
    ), Fe = S("comfortable"), ye = S(""), Te = S(!1), Ue = S({}), xt = S({}), Qt = S({});
    let vn = null;
    function Ut() {
      if (!vn) {
        const o = ba(P.config);
        vn = qae({
          list: async () => {
            const s = await $.jsonFetch(`${o}/api/admin/storages`);
            return Array.isArray(s) ? s : [];
          }
        });
      }
      return vn;
    }
    function pn(o) {
      return !!o && o in Qt.value;
    }
    const Rt = S(!1), rn = S(""), nn = E(() => Rt.value), gt = S(""), wn = S(""), ra = E(
      () => gt.value !== "" && gt.value !== "trash" && gt.value !== "home"
    ), dn = E(
      () => gt.value === "recent" || gt.value === "starred" || gt.value === "shared" || gt.value === "tag"
    ), jn = E(() => P.config.rememberFolderView !== !1), zn = E(() => {
      if (!jn.value) return "";
      const o = String(Le.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!o) return b4;
      const [s, ...g] = o.split("/"), O = (P.config.storages ?? []).find((N) => N.name === s);
      return O_((O == null ? void 0 : O.uid) || s, g.join("/"));
    });
    function Bn() {
      const o = Pp().v;
      if (o) return o;
      if (!js())
        try {
          const s = localStorage.getItem(C0);
          if (s === "list" || s === "grid" || s === "gallery") return s;
        } catch {
        }
      return P.config.viewMode ?? "list";
    }
    yy(
      uS(() => {
        js() && mn(zn.value);
      })
    );
    let Sn = null;
    function mn(o) {
      if (!o && jn.value) return;
      w4(o);
      const s = o ? $4(o) : {}, g = s.v ?? Bn();
      if (g !== xe.value && (xe.value = g), s.k) K_(s.k, s.d ?? wl(s.k));
      else {
        const O = sg();
        K_(O.key, O.dir);
      }
      Sn = { key: o, v: xe.value, k: U_(), d: H_() };
    }
    qt(() => {
      B4({
        apiBase: P.config.apiBase ?? "",
        headers: Qn,
        credentials: $.credentialsMode()
      });
    }), Xe(
      [zn, () => js()],
      ([o, s]) => {
        s && mn(o);
      },
      { immediate: !0, flush: "post" }
    ), Xe(
      () => [zn.value, xe.value, U_(), H_()],
      ([o, s, g, O]) => {
        if (!js() || !Sn || Sn.key !== o) return;
        const N = {};
        s !== Sn.v && (N.v = s), (g !== Sn.k || O !== Sn.d) && (N.k = g, N.d = O), Sn = { key: o, v: s, k: g, d: O }, Object.keys(N).length && (o ? aS(o, N) : jn.value || oS(N));
      },
      /* ⚠⚠ `post`, and registered AFTER the applier: a navigation changes
       * `currentFolderKey`, which both watchers depend on. Pre-flush this would
       * run first, while the view state is still the folder you LEFT, and record
       * that folder's setup against the one you arrived in. */
      { flush: "post" }
    ), Xe(
      () => Hv(zn.value),
      (o, s) => {
        s && !o && js() && mn(zn.value);
      }
    );
    const sn = S(""), $n = S(""), Rn = {
      home: ".home",
      recent: ".recent",
      starred: ".starred",
      shared: ".shared",
      drafts: ".drafts"
    };
    function Fn(o) {
      if (!Jx(o)) return null;
      const s = String(o ?? "").replace(/^\/+|\/+$/g, ""), g = h4(s);
      return g ? { kind: "tag", tag: g, tagKind: p4(s) } : { kind: s.slice(1), tag: "", tagKind: "" };
    }
    const Tn = E(() => {
      if (!En.value) return "";
      const o = P.config.storages ?? [];
      return o.length === 1 ? o[0].name : "";
    }), me = E(() => {
      const o = (Le.value ?? "").replace(/^\/+|\/+$/g, "");
      return he && o === he || Tn.value && o === Tn.value ? !1 : o.length > 0;
    }), De = E(() => gt.value && gt.value !== "trash" ? !0 : En.value ? !(Le.value ?? "").replace(/^\/+|\/+$/g, "") : !1), He = E(
      () => gt.value === "home" ? "find" : "full"
    );
    function Ve() {
      if (Rt.value) {
        kt(rn.value);
        return;
      }
      if (gt.value) {
        kt(wn.value);
        return;
      }
      const o = (Le.value ?? "").replace(/^\/+|\/+$/g, "");
      if (!o || o === he || Tn.value && o === Tn.value) return;
      const s = o.lastIndexOf("/");
      let g = s === -1 ? "" : o.slice(0, s);
      he && !(g === he || g.startsWith(he + "/")) && (g = he), kt(g);
    }
    const bt = S([]), Qe = E(
      () => (bt.value.length ? bt.value : _e.value).filter((o) => o.type !== "dir")
    ), se = E(() => {
      var O;
      const o = Qe.value, s = (O = hn.value) == null ? void 0 : O.path, g = s ? o.findIndex((N) => N.path === s) : -1;
      return { index: g === -1 ? 0 : g + 1, total: g === -1 ? 0 : o.length };
    });
    async function je(o) {
      const s = Qe.value, g = s.findIndex((N) => {
        var Y;
        return N.path === ((Y = hn.value) == null ? void 0 : Y.path);
      });
      if (g === -1) return;
      const O = s[g + o];
      if (O) {
        if (Ui(O) && !an.value && !O.e2e_root) {
          ca.value = !1, Dt.open(O);
          return;
        }
        if (Gn.value && O.type === "file")
          try {
            await Vd(O);
          } catch {
            et(z("e2e.decrypt_failed"));
            return;
          }
        hn.value = O;
      }
    }
    function dt(o) {
      const s = Date.now(), g = /* @__PURE__ */ new Set([..._e.value, ...bt.value]);
      hn.value && g.add(hn.value);
      for (const O of g)
        O.path === o.path && (typeof o.size == "number" && (O.size = o.size), O.last_modified = s);
    }
    const tt = i_(() => bt.value.length ? bt.value : _e.value);
    Xe(
      () => [...tt.selected.value],
      () => {
        H(
          "selection-change",
          /* wiring:e2 names — `basename` stays what the server calls the item
             (hosts pass it back to the API); an encrypted-names row adds its
             plaintext as `display_name` for a host that draws it. */
          tt.nodes.value.map((s) => ({
            path: s.path,
            basename: wf(s),
            type: s.type,
            ...s.e2e_stored ? { display_name: s.basename } : {}
          }))
        );
        const o = tt.nodes.value.filter((s) => s.type === "file");
        Be.setFocus(o.length === 1 && !j.isVaultRow(o[0]) ? wf(o[0]) : null);
      }
    );
    const ie = S({ mode: null, items: [], sourcePath: null }), ue = S(null);
    let Pe = null;
    function Ge() {
      return Pe || ($.endpoints.capabilities ? (Pe = (async () => {
        for (let o = 1; o <= z0; o++)
          try {
            ue.value = await $.capabilities();
            return;
          } catch (s) {
            if (o === z0) {
              H("error", {
                message: `capabilities: ${(s == null ? void 0 : s.message) ?? String(s)}`,
                context: { what: "capabilities", attempts: o }
              });
              return;
            }
            await new Promise((g) => setTimeout(g, 200 * o));
          }
      })(), Pe) : (Pe = Promise.resolve(), Pe));
    }
    const ot = S(!1);
    let St = null;
    function Et() {
      return St || (St = $.jsonFetch(`${ba(P.config)}/api/auth/me`), St.catch(() => {
        St = null;
      })), St;
    }
    const ne = UJ({
      config: () => P.config,
      capabilities: ue,
      fetchMe: () => Et()
    }), Q = P.config.notifications ? Y0(
      yoe({
        // The server says each row in the language on screen (`lang=`).
        transport: goe($.jsonFetch, ba(P.config)),
        errorText: (o) => (o == null ? void 0 : o.message) || z("inspector.error"),
        onRead: () => {
          var o, s;
          return (s = (o = P.config.notifications) == null ? void 0 : o.onRead) == null ? void 0 : s.call(o);
        }
      })
    ) : null;
    let Ae = null;
    qt(() => {
      var s;
      const o = P.config.notifications;
      !Q || !o || (Q.refreshFeed(), o.poll !== !1 && (Ae = setInterval(() => void Q.syncUnread(), voe)), (s = o.onUnread) == null || s.call(o, (g) => void Q.acceptCount(g)));
    }), Ct(() => {
      Ae && clearInterval(Ae), Ae = null;
    }), Xe(W, () => {
      Q && (Q.refreshFeed(), Q.panelOpen && Q.fetchMine());
    });
    const at = E(() => {
      var g, O, N;
      const o = (O = (g = P.config.notifications) == null ? void 0 : g.manage) == null ? void 0 : O.href;
      return o && (ha.value || ((N = Nn.value) == null ? void 0 : N.role) === "admin") ? o : void 0;
    });
    function ct() {
      var o, s;
      (s = (o = P.config.notifications) == null ? void 0 : o.manage) == null || s.open();
    }
    let zt = () => {
    };
    const Ht = new Promise((o) => {
      zt = o;
    });
    async function Wt(o) {
      var O;
      if (await Ht, o.kind === "none") return !1;
      if (o.kind === "share")
        return window.open(IT(o.token, ba(P.config)), "_blank", "noopener"), !0;
      if (o.kind === "app")
        return await Ge(), await la.refresh(), await Qg(`${o.plugin}/${o.view}`), !0;
      const s = kie(o);
      if (!s) return !1;
      s === mp ? await kt(mp) : await kt(En.value ? Ao(s) : Va(s));
      const g = o.select;
      if (g) {
        const N = _e.value.find((Y) => T0(Y.path, g));
        if (N) {
          tt.click(N.path), await Jt();
          const Y = Array.from(((O = Mn.value) == null ? void 0 : O.querySelectorAll("[data-fe-path]")) ?? []).find(
            (de) => T0(de.getAttribute("data-fe-path"), g)
          );
          Y == null || Y.scrollIntoView({ block: "center" });
        }
      }
      if (o.kind === "folder" && o.open) {
        const N = o.select || s;
        await eh({ plugin: o.open.plugin, action: o.open.action, view: o.open.view, path: N });
      }
      return !0;
    }
    function tn(o) {
      Wt(RT(o.target));
    }
    function Ft() {
      Et().then((o) => {
        const s = o == null ? void 0 : o.user;
        if (!s) return;
        const g = typeof s.locale == "string" ? s.locale.trim() : "";
        if (g) {
          ve.value = g;
          return;
        }
        const O = String(P.config.locale ?? "").trim();
        O && E0($.jsonFetch, ba(P.config)).updateProfile({ locale: O }).catch(() => {
        });
      }).catch(() => {
      });
    }
    let yn = !1;
    Xe(
      () => {
        var o;
        return (P.config.callerKind ?? ((o = ue.value) == null ? void 0 : o.caller_kind)) === "user";
      },
      (o) => {
        if (!o) {
          ve.value = "";
          return;
        }
        yn || (yn = !0, Ft());
      },
      { immediate: !0 }
    ), Xe(
      () => P.config.locale,
      () => {
        ve.value = "";
      }
    );
    const Nn = S(((_w = P.config.account) == null ? void 0 : _w.person) ?? null);
    qt(() => {
      !P.config.account || P.config.account.person || Et().then((o) => {
        Nn.value = (o == null ? void 0 : o.user) ?? null;
      }).catch(() => {
      });
    });
    const jt = S([]);
    let ce = null;
    function be(o) {
      if (!P.config.account) return;
      const s = o.detail;
      !s || !Array.isArray(s.items) || (s.claimed = !0, o.stopPropagation(), jt.value = s.items, ce = typeof s.run == "function" ? s.run : null);
    }
    qt(() => {
      var o;
      return (o = Mn.value) == null ? void 0 : o.addEventListener("fe:header-menu", be);
    }), Ct(() => {
      var o;
      return (o = Mn.value) == null ? void 0 : o.removeEventListener("fe:header-menu", be);
    });
    const Re = E(() => {
      const o = P.config.account;
      if (!o) return [];
      const s = Nn.value, g = typeof o.actions == "function" ? o.actions(s) : o.actions ?? [], O = o.settings ? [{ key: M0, label: z("userSettings.open"), icon: "account" }, ...g] : g, N = typeof o.tail == "function" ? o.tail(s) : o.tail ?? [], Y = boe.filter(($e) => $e !== "inspector" || P.config.showInfoPanel !== !1), de = o.settings ? koe : [];
      return woe(O, jt.value, {
        omit: [...Y, ...de, ...o.omit ?? []],
        tail: N
      });
    });
    function pt(o) {
      var g, O;
      const s = _oe(o);
      if (s !== null) {
        ce == null || ce(s);
        return;
      }
      if (o === M0 && ((g = P.config.account) != null && g.settings)) {
        fn.value = !0;
        return;
      }
      (O = P.config.account) == null || O.select(o, Nn.value);
    }
    const fn = S(!1), Nt = {
      get locale() {
        return String(W.value);
      },
      get user() {
        return Nn.value;
      },
      get isAdmin() {
        var o;
        return ((o = Nn.value) == null ? void 0 : o.role) === "admin";
      },
      get demoReadOnly() {
        var o;
        return ((o = ue.value) == null ? void 0 : o.demo_mode) === !0;
      },
      get capabilities() {
        return ue.value;
      },
      api: E0($.jsonFetch, ba(P.config)),
      setUser(o) {
        Nn.value = { ...Nn.value ?? {}, ...o };
      },
      toast(o, s) {
        Yt({ message: s }, o === "success" ? hi : bn);
      },
      errorText: (o, s) => (o == null ? void 0 : o.message) || s,
      zone: zO(ne),
      mode: {
        get: () => {
          const o = pu.value === "host" ? P.config.theme || "auto" : pu.value;
          return o === "light" || o === "dark" ? o : "auto";
        },
        set: (o) => Pa(o)
      },
      // The rows only the host can carry out (ExplorerConfig.account.settings as
      // an object, task #258): the desktop app's language, its click setting and
      // its own notifications. Read per access, so a host that swaps its config
      // is followed.
      get language() {
        var o;
        return (o = sa()) == null ? void 0 : o.language;
      },
      get openTrigger() {
        var o;
        return (o = sa()) == null ? void 0 : o.openTrigger;
      },
      get deviceNotifications() {
        var o;
        return (o = sa()) == null ? void 0 : o.deviceNotifications;
      }
    };
    function sa() {
      var s;
      const o = (s = P.config.account) == null ? void 0 : s.settings;
      return o && typeof o == "object" ? o : void 0;
    }
    function Pa(o) {
      var s;
      Ok(o), (s = P.config.accountPrefs) != null && s.surface && (o === "light" || o === "dark" || o === "auto") && Zi("theme", o);
    }
    qt(() => {
      var s;
      const o = (s = P.config.accountPrefs) == null ? void 0 : s.surface;
      o && (hF({ surface: o, base: ba(P.config), headers: () => $.authHeaders() }), kF().then((g) => {
        g && ((g.theme === "light" || g.theme === "dark" || g.theme === "auto") && Ok(g.theme), lT(g.palette), FJ(g.density));
      }));
    });
    const eo = E(
      () => {
        var o, s;
        return ((o = ue.value) == null ? void 0 : o.share_link_max_days) ?? ((s = ue.value) == null ? void 0 : s.share_max_ttl_days) ?? 0;
      }
    ), Si = E(() => {
      var o, s;
      return typeof P.config.plugins == "boolean" ? P.config.plugins : ((s = (o = ue.value) == null ? void 0 : o.app_plugins) == null ? void 0 : s.enabled) === !0;
    }), la = PP($, () => Si.value), _n = S(null);
    let Dl = 0;
    const Jp = S(!1);
    let Zp;
    Ct(() => clearTimeout(Zp));
    function tA(o) {
      const s = ++Dl;
      return _n.value = { ...o, surface: null, ticket: s }, Jp.value = !1, clearTimeout(Zp), Zp = setTimeout(() => {
        Xc(s) && (Jp.value = !0);
      }, yse), s;
    }
    const nA = E(
      () => !!_n.value && (_n.value.surface !== null || Jp.value)
    );
    function Xc(o) {
      var s;
      return o > 0 && ((s = _n.value) == null ? void 0 : s.ticket) === o;
    }
    const Da = S(null);
    function aA(o) {
      return o.filter((s) => s.type === "file").map((s) => ({
        path: s.path,
        name: s.basename,
        size: s.size,
        mime: s.mime_type,
        readOnly: !!s.read_only || !oo(s),
        ...s.encrypted ? { encrypted: s.encrypted } : {}
      }));
    }
    const Ll = E(() => Si.value ? la.views.value : []), Rl = E(() => Si.value ? la.openRules.value : {}), Gg = E(() => ({ onlyOffice: !!tr.value }));
    function ts(o) {
      return { ...Gg.value, inEncrypted: an.value || j.isVaultRow(o), e2ePlaintext: !!Qp(o) };
    }
    function Qp(o) {
      var O;
      if (Yn.value, !o || o.type !== "file" || Ui(o) || ((O = ue.value) == null ? void 0 : O.apps_e2e_plaintext) !== !0) return null;
      if (j.isVaultRow(o)) return iA(o);
      if (o.encrypted && o.encrypted !== "folder") return null;
      const s = typeof o.e2e_root == "string" && o.e2e_root || (an.value ? Ot.value : null), g = Kt.rootOf(o.path, s);
      return !g || !ln.has(g) ? null : g;
    }
    function iA(o) {
      j.version.value;
      const s = typeof o.vault_root == "string" ? o.vault_root : "";
      return s && j.isOpen(s) ? s : null;
    }
    function Nl(o, s, g) {
      const O = Iu(Ll.value, o, s, Rl.value, Il(o), ts(o));
      return O != null && O.view ? ($i.value = s, Ha.value = g === "edit" && oo(o) ? "edit" : "view", hn.value = o, ca.value = !0, H("file-opened", { path: o.path, basename: o.basename }), Ua(o), !0) : !1;
    }
    function Xg(o) {
      return S$(Ll.value, o, Rl.value, ts(o));
    }
    function Il(o) {
      return o ? iie(Er(o)) : null;
    }
    const $i = S(null), Jg = E(
      () => Iu(
        Ll.value,
        hn.value,
        $i.value,
        Rl.value,
        Il(hn.value),
        ts(hn.value)
      )
    ), Zg = E(() => {
      var o;
      return ((o = Jg.value) == null ? void 0 : o.view) ?? null;
    }), oA = E(() => Tf(Jg.value));
    function rA(o) {
      return Tf(o) ? z("ctx.open_with", { app: "ONLYOFFICE" }) : o.view ? z("ctx.open_with", { app: Zt(o.view.label, W.value) || o.view.plugin }) : z("ctx.open_with_builtin");
    }
    function sA(o) {
      var O;
      if (o.length !== 1) return [];
      const { on: s } = Xg(o[0]), g = !w$(o[0], ts(o[0])) && ((O = o[0]) == null ? void 0 : O.type) === "file" && Vp(Er(o[0])) && !Gg.value.onlyOffice ? [
        {
          key: `open-with:${Al}`,
          label: z("ctx.open_with", { app: "ONLYOFFICE" }),
          icon: "open",
          testid: `ctx-open-with-${Al}`,
          ...zm(!1, ha.value, z("ctx.needs_onlyoffice"))
        }
      ].filter((N) => !N.hidden) : [];
      return s.length < 2 && g.length === 0 ? [] : [
        ...s.map((N) => ({ key: `open-with:${N.id}`, label: rA(N), icon: "open", testid: `ctx-open-with-${N.id}` })),
        ...g,
        ...s.length < 2 ? [] : [{ key: "open-with-choose", label: z("ctx.open_with_choose"), icon: "open", testid: "ctx-open-with-choose" }]
      ];
    }
    const La = S(null), lA = E(() => Xg(La.value).on), uA = E(
      () => La.value && !fU(La.value) ? Er(La.value) : ""
    ), cA = E(() => {
      var s;
      const o = La.value;
      return o ? ((s = Iu(Ll.value, o, null, Rl.value, Il(o), ts(o))) == null ? void 0 : s.id) ?? null : null;
    });
    function dA(o, s) {
      const g = La.value;
      if (!g) return;
      const O = Er(g);
      if (La.value = null, s && O && oie(O, o), (Gn.value || j.isVaultRow(g)) && Qp(g)) {
        (o === go || !Nl(g, o, "edit")) && ($i.value = go, Ps(g));
        return;
      }
      $d(g), $i.value = o, o !== "builtin" && oo(g) && (Ha.value = "edit");
    }
    const fA = rie();
    Ct(fA);
    const pA = E(
      () => Si.value ? la.views.value.filter((o) => o.placement === "inspector") : []
    ), hA = E(
      () => Si.value ? la.views.value.filter((o) => o.placement === "home").map((o) => ({ key: `${o.plugin}/${o.id}`, label: Zt(o.label, W.value) || o.id, icon: o.icon })) : []
    );
    async function Qg(o) {
      const s = la.views.value.find((g) => `${g.plugin}/${g.id}` === o);
      if (s) {
        if (To(), P.config.appHomePage === !0) {
          H("open-app-home", { plugin: s.plugin, view: s.id });
          return;
        }
        if (s.ui) {
          Da.value = {
            plugin: s.plugin,
            view: s.id,
            placement: "home",
            ui: s.ui,
            label: Zt(s.label, W.value) || s.plugin,
            files: []
          };
          return;
        }
        try {
          const g = await $.pluginView(s.plugin, s.id);
          if (!(g != null && g.surface)) {
            et(z("plugin.view.error"));
            return;
          }
          _n.value = { plugin: s.plugin, view: s.id, surface: g.surface, size: "xl" };
        } catch (g) {
          et((g == null ? void 0 : g.message) || z("plugin.view.error"));
        }
      }
    }
    const Ti = S(null);
    function mA(o) {
      return Si.value ? CP(la.actions.value, o, {
        locale: W.value,
        trash: nn.value,
        e2e: an.value,
        readOnly: pe.value || Nb(o),
        // The level each row answers with — the same one the built-in verbs
        // read — so an app's row a viewer could only be refused is not offered.
        permOf: (s) => Sh(s),
        hasIcon: (s) => Pt(s) !== "",
        // Greyed rows with the reason are an ADMINISTRATOR's (the server sends
        // `gated` to them only; asked here too, so no other caller draws one).
        needWords: ha.value ? (s) => xP(s, z) : void 0
      }) : [];
    }
    function vA(o) {
      return o.label || o.action || z("opc.kind.plugin");
    }
    function yA(o) {
      var s;
      if (!(!o.plugin || !o.action))
        return (s = la.actions.value.find((g) => g.plugin === o.plugin && g.id === o.action)) == null ? void 0 : s.output_mode;
    }
    async function eb(o, s) {
      const g = la.byKey(o);
      if (!g || s.length === 0) return;
      if (Zt(g.confirm, W.value)) {
        Ti.value = { action: g, targets: s };
        return;
      }
      await nb(g, s);
    }
    async function gA() {
      const o = Ti.value;
      Ti.value = null, o && await nb(o.action, o.targets);
    }
    function tb(o, s) {
      var $e, Ee, st;
      const g = o.view, O = P.config.pluginPageBase;
      if (!g || O === void 0) return !1;
      const N = { plugin: o.plugin, view: g, path: ($e = s[0]) == null ? void 0 : $e.path }, Y = F2(O, N);
      if (((st = (Ee = P.config).openPluginPage) == null ? void 0 : st.call(Ee, { ...N, url: Y })) === !0) return !0;
      const de = window.open(Y, "_blank");
      if (!de)
        return et(z("plugin.page_view.blocked")), !1;
      try {
        de.opener = null;
      } catch {
      }
      return !0;
    }
    function Bl(o, s, g = {}) {
      const O = P.config.refusalToasts !== !1, N = Yv(o);
      N ? O && et(Kr(N, { t: z, formatDate: le, locale: W.value })) : !g.inDialog && O && Yt({ message: g.words ?? Zn(o) }, bn), H("error", { message: (o == null ? void 0 : o.message) ?? String(o), context: s });
    }
    function Fl(o, s, g, O, N = Zn(g)) {
      Bl(g, O, { inDialog: o.refuse(s, N), words: N });
    }
    function Zn(o, s = z("toast.failed")) {
      return p2(o, s, { t: z, callerAdmin: ha.value }).text;
    }
    async function nb(o, s) {
      var Y;
      const g = Zt(o.label, W.value);
      if (Kf(o.view_placement) && tb(o, s)) return;
      if (o.ui) {
        Da.value = {
          plugin: o.plugin,
          view: o.view || o.id,
          placement: "modal",
          ui: o.ui,
          label: g || o.plugin,
          files: aA(s)
        };
        return;
      }
      const O = {
        plugin: o.plugin,
        view: o.view || o.id,
        path: (Y = s[0]) == null ? void 0 : Y.path,
        paths: s.map((de) => de.path),
        label: g
      }, N = o.view ? tA(O) : 0;
      try {
        const de = await la.run(o, s);
        if (de.surface) {
          if (o.view && !Xc(N)) return;
          _n.value = { ...O, surface: de.surface, ticket: N || ++Dl };
          return;
        }
        Xc(N) && (_n.value = null), de.op && Ul(de.op, g);
      } catch (de) {
        Xc(N) && (_n.value = null);
        const $e = de, Ee = Yv($e);
        Ee ? et(Kr(Ee, { t: z, formatDate: le, locale: W.value })) : Yt({ message: Zn($e, z("plugin.failed", { label: g })) }, bn);
      }
    }
    function Ul(o, s) {
      ze.register(o);
      const g = s || (typeof o.label == "string" ? o.label : "") || z("opc.kind.plugin");
      et(z("plugin.queued", { label: g }));
    }
    async function eh(o) {
      if (!o.plugin || !o.path) return !1;
      if (await Ge(), !Si.value)
        return H("error", {
          message: "app plugins are off on this instance - deep link ignored",
          context: { what: "openAppTarget", plugin: o.plugin, path: o.path }
        }), !1;
      await la.refresh();
      const s = _e.value.find((O) => O.path === o.path) ?? { path: o.path, basename: o.path.split("/").pop() ?? o.path, type: "file" };
      if (o.action) {
        const O = la.byKey(`plugin:${o.plugin}/${o.action}`);
        return O ? (await eb(Uy(O), [s]), !0) : (et(z("plugin.not_applicable")), H("error", {
          message: `no such plugin action: ${o.plugin}/${o.action}`,
          context: { what: "openAppTarget", path: o.path }
        }), !1);
      }
      if (!o.view) return !1;
      const g = la.actions.value.find((O) => O.plugin === o.plugin && O.view === o.view);
      if (g && Kf(g.view_placement) && tb(g, [s]))
        return !0;
      try {
        const O = await $.pluginView(o.plugin, o.view, o.path);
        return O != null && O.surface ? (_n.value = { plugin: o.plugin, view: o.view, surface: O.surface, path: o.path }, !0) : (et(z("plugin.view.error")), !1);
      } catch (O) {
        return et((O == null ? void 0 : O.message) || z("plugin.view.error")), !1;
      }
    }
    async function th(o, s) {
      if (!o || !(s != null && s.path)) return;
      _n.value = null;
      const g = s.path.indexOf("://"), O = g === -1 ? "" : s.path.slice(0, g), N = Va(s.path).replace(/^\/+|\/+$/g, ""), Y = N.lastIndexOf("/"), de = Y === -1 ? "" : N.slice(0, Y), $e = En.value && O ? de ? `${O}/${de}` : O : de;
      try {
        await kt($e);
      } catch {
      }
      await eh({ plugin: o, action: s.action, view: s.view, path: s.path });
    }
    async function bA(o, s) {
      const g = s.indexOf("://"), O = g === -1 ? "" : s.slice(0, g), N = Va(s).replace(/^\/+|\/+$/g, ""), Y = N.lastIndexOf("/"), de = Y === -1 ? "" : N.slice(0, Y), $e = En.value && O ? de ? `${O}/${de}` : O : de;
      await kt($e);
      const Ee = _e.value.find((st) => st.path === s);
      if (Ee) {
        tt.click(Ee.path);
        return;
      }
      et(z("plugin.output_missing"));
    }
    const ns = S(/* @__PURE__ */ new Map()), as = S(!1), Hl = S(!1), Kl = S(null), ab = S(0);
    function ib(o) {
      return typeof o.id != "number" ? !1 : ns.value.get(o.id) ?? o.starred === !0;
    }
    function nh(o, s) {
      const g = new Map(ns.value);
      g.set(o, s), ns.value = g;
    }
    const ob = E(() => {
      const o = /* @__PURE__ */ new Set();
      for (const s of _e.value) ib(s) && o.add(s.id);
      for (const [s, g] of ns.value) g && o.add(s);
      return o;
    });
    function rb(o, s) {
      typeof o.id == "number" && nh(o.id, s);
    }
    function ah(o) {
      return ps.value ? o.filter((s) => typeof s.id == "number" && s.type === "file") : [];
    }
    function sb(o) {
      const s = ah(o);
      return s.length > 0 && s.every((g) => ib(g));
    }
    async function lb(o) {
      const s = ah(o);
      if (s.length === 0) return;
      const g = !sb(s), O = {
        apiBase: P.config.apiBase ?? "",
        authHeaders: () => Qn(),
        authCredentials: $.credentialsMode()
      };
      for (const Y of s) nh(Y.id, g);
      let N = 0;
      await Promise.all(
        s.map(async (Y) => {
          try {
            await Q$(Y.id, g, O);
          } catch {
            N += 1, nh(Y.id, !g);
          }
        })
      ), N > 0 && et(z("star.failed")), gt.value === "starred" && await nu("starred");
    }
    async function Ua(o) {
      if (typeof o.id == "number")
        try {
          const s = P.config.apiBase ?? "";
          await fetch(`${s}/api/files/manager/recent`, {
            method: "POST",
            headers: await Qn({ "Content-Type": "application/json" }),
            credentials: $.credentialsMode(),
            body: JSON.stringify({ node_id: o.id })
          }), ab.value += 1;
        } catch {
        }
    }
    function kA(o) {
      typeof o.id == "number" && (Kl.value = o, Hl.value = !0);
    }
    function wA(o, s = "") {
      Hl.value = !1, ys(o, s);
    }
    function _A() {
      _h(), gt.value === "tag" && sn.value && ys(sn.value, $n.value);
    }
    const xA = MD(_A);
    Ct(xA);
    function SA(o) {
      const s = rd(o) ?? {
        type: "file",
        path: o.path,
        basename: o.name,
        extension: (o.name.split(".").pop() || "").toLowerCase(),
        id: o.id
      };
      as.value = !1, qa(s);
    }
    function $A(o, s) {
      const g = rd(o);
      g && (as.value = !1, jh(g, s));
    }
    const tr = E(() => {
      var s, g, O;
      if (P.config.onlyOfficeBase) return P.config.onlyOfficeBase;
      const o = (g = (s = ue.value) == null ? void 0 : s.external) == null ? void 0 : g.onlyoffice;
      return o && !pv(o) ? null : ((O = ue.value) == null ? void 0 : O.onlyoffice_url) || null;
    }), ha = E(() => {
      var o;
      return ((o = ue.value) == null ? void 0 : o.caller_admin) === !0;
    });
    function Jc(o) {
      var s, g;
      return ((g = (s = ue.value) == null ? void 0 : s.queued) == null ? void 0 : g.includes(o)) === !0;
    }
    const ub = E(() => tr.value && $.endpoints.onlyOfficeConfig || null), Vl = E(() => {
      var g, O, N;
      const o = P.config.drawioUrl || P.config.drawioBase;
      if (o) return o;
      const s = (O = (g = ue.value) == null ? void 0 : g.external) == null ? void 0 : O.drawio;
      return s && !pv(s) ? null : ((N = ue.value) == null ? void 0 : N.drawio_url) || null;
    }), cb = E(() => {
      var o;
      return ((o = ue.value) == null ? void 0 : o.newdoc_types) ?? null;
    }), TA = E(() => {
      const o = cb.value;
      return !o || o.length === 0 ? !1 : o.some(
        (s) => s.requires === "onlyoffice" ? !!tr.value : s.requires === "drawio" ? !!Vl.value : !0
      );
    }), nr = E(() => {
      var o;
      return !!((o = ue.value) != null && o.drafts);
    }), is = S(0), ih = S([]), oh = S(0), rh = S(!1), ar = S(null);
    async function sh() {
      if (!nr.value) {
        is.value = 0;
        return;
      }
      try {
        const { count: o, limit: s } = await $.drafts.count();
        is.value = o, oh.value = s;
      } catch {
      }
    }
    async function db() {
      rh.value = !0;
      try {
        const o = await $.drafts.list();
        ih.value = o.drafts, oh.value = o.limit, is.value = o.count;
      } catch (o) {
        ih.value = [];
        const s = Zn(o);
        H("error", { message: s, context: { op: "nav-view:drafts" } }), et(s);
      } finally {
        rh.value = !1;
      }
    }
    async function jl() {
      gt.value === "drafts" ? await db() : await sh();
    }
    Xe(nr, (o) => void (o ? sh() : is.value = 0), { immediate: !0 });
    function AA(o) {
      const s = o.lastIndexOf(".");
      return s > 0 ? o.slice(s + 1).toLowerCase() : "";
    }
    function fb(o, s = null) {
      const g = {
        type: "file",
        path: o.path,
        basename: o.name,
        extension: AA(o.name),
        storage: o.storage,
        size: o.size,
        file_size: o.size,
        mime_type: o.mime ?? "",
        visibility: "private",
        extra_metadata: {}
      };
      if (sv(P.config, g) === "host") {
        H("file-opened", { path: g.path, basename: g.basename });
        return;
      }
      ds.value = o.type ? { path: g.path, ext: o.type } : null, $i.value = s, hn.value = g, Ha.value = "edit", ca.value = !0;
    }
    function pb(o) {
      et(z("draft.saved_to", { name: o.name, folder: h2(o.targetDir) }));
    }
    const to = Oae(() => nr.value ? $.drafts : null, (o) => Zn(o));
    async function EA(o) {
      if (!ar.value) {
        ar.value = o.key;
        try {
          const s = await to.save(o);
          s && (pb(s), await jl());
        } catch (s) {
          Yt({ message: Zn(s) }, bn);
        } finally {
          ar.value = null;
        }
      }
    }
    async function CA(o) {
      if (!ar.value) {
        ar.value = o.key;
        try {
          await $.drafts.discard(o.key), et(z("draft.discarded", { name: o.name })), await jl();
        } catch (s) {
          Yt({ message: Zn(s) }, bn);
        } finally {
          ar.value = null;
        }
      }
    }
    function zA(o) {
      pb(o), jl(), !gt.value && !Rt.value && kt();
    }
    function MA() {
      var s;
      const o = ((s = hn.value) == null ? void 0 : s.basename) ?? "";
      et(z("draft.discarded", { name: o })), jl();
    }
    function OA() {
      ql.value = !1, nu("drafts");
    }
    const qn = S([]), hb = S(null), ua = S(!1), ql = S(!1), no = S(!1), ma = S(!1), ca = S(!1), Zc = S(!1), ir = S(!1), os = S(!1), Wl = S([]), $o = S(null), rs = S(""), lh = S(!1), or = S(/* @__PURE__ */ new Set()), Ai = S(""), ss = S(!1), ls = S(""), rr = S(null), PA = E(() => {
      var o;
      return Wl.value.length !== 1 ? "archive" : ((o = Wl.value[0]) == null ? void 0 : o.basename.replace(/\.[^.]+$/, "")) || "archive";
    }), DA = ["zip", "7z", "tar", "tar.gz", "tar.bz2", "tar.xz"], Yl = E(() => {
      var s, g;
      return (((g = (s = ue.value) == null ? void 0 : s.archive) == null ? void 0 : g.allowed_formats) ?? []).filter((O) => DA.includes(O));
    }), LA = E(() => {
      var s, g;
      const o = (g = (s = ue.value) == null ? void 0 : s.archive) == null ? void 0 : g.default_format;
      return o && Yl.value.includes(o) ? o : Yl.value.includes("7z") ? "7z" : Yl.value[0] ?? "zip";
    }), RA = E(() => {
      var o, s;
      return ((s = (o = ue.value) == null ? void 0 : o.archive) == null ? void 0 : s.encryption) !== !1;
    }), NA = E(
      () => {
        var o;
        return (((o = $o.value) == null ? void 0 : o.basename) || "archive").replace(/\.(tar\.(gz|bz2|xz)|zip|7z|rar|tgz|gz|bz2|xz)$/i, "") || "archive";
      }
    ), sr = S(null), us = lv(no), cs = lv(ua), $a = lv(ma), { busy: IA, error: BA } = us, { busy: FA, error: UA } = cs, { busy: HA, error: KA } = $a, Ei = S(!1), hn = S(null), Ha = S("edit"), ds = S(null), VA = E(
      () => {
        var o;
        return ds.value && ((o = hn.value) == null ? void 0 : o.path) === ds.value.path ? ds.value.ext : null;
      }
    );
    Xe(ca, (o) => {
      o || (ds.value = null), !o && nr.value && hn.value && Iw(hn.value.path) && jl();
    });
    const lr = S(!1), si = S(null), fs = S(!1), Qc = S("move"), ed = S([]), jA = E(() => (j.version.value, fs.value, j.roots())), qA = E(() => {
      const o = ed.value[0];
      return o ? j.rootOf(o.path) : null;
    }), td = S(!1), Ra = S(
      (() => {
        try {
          return localStorage.getItem(O0) === "1";
        } catch {
          return !1;
        }
      })()
    );
    function nd(o) {
      try {
        localStorage.setItem(O0, o ? "1" : "0");
      } catch {
      }
    }
    function uh() {
      Ra.value = !Ra.value, nd(Ra.value), Ra.value && (ao.value = !1);
    }
    function WA() {
      Ra.value || (Ra.value = !0, nd(!0)), ao.value = !1;
    }
    const ao = S(!1), ch = E(() => {
      var o, s;
      return ((s = (o = ue.value) == null ? void 0 : o.assistant) == null ? void 0 : s.button) === !0;
    }), YA = dV(
      {
        request: $.rawRequest,
        json: $.jsonFetch,
        failure: (o, s) => pa(o, s, W.value)
      },
      uV($.endpoints.manager)
    );
    function GA() {
      ao.value = !ao.value, ao.value && Ra.value && (Ra.value = !1, nd(!1));
    }
    const XA = E(() => aa().map((o) => o.path));
    Xe(ch, (o) => {
      o || (ao.value = !1);
    });
    function mb() {
      Ra.value && (Ra.value = !1, nd(!1));
    }
    const JA = E(() => Q4(P.config.uiProfile)), Gl = E(() => JA.value === "simple"), vb = E(() => P.config.showInfoPanel !== !1), Xl = S(
      (() => {
        try {
          const o = localStorage.getItem(P0);
          if (o === "1") return !0;
          if (o === "0") return !1;
        } catch {
        }
        return !0;
      })()
    );
    function ZA(o) {
      try {
        localStorage.setItem(P0, o ? "1" : "0");
      } catch {
      }
    }
    const ur = S(!1), Jl = E(() => P.config.sideNav ?? !Se), dh = E(
      () => Jl.value && (Ta.value ? ur.value : !0)
    ), yb = E(
      () => Jl.value && P.config.trashVisible !== !1
    ), QA = E(
      () => Ta.value ? ur.value : Xl.value
    );
    function gb() {
      if (Jl.value) {
        if (Ta.value) {
          ur.value = !ur.value;
          return;
        }
        Xl.value = !Xl.value, ZA(Xl.value);
      }
    }
    function To() {
      ur.value = !1;
    }
    const fh = S([]), eE = E(() => P.config.connections ?? !Gl.value), tE = E(() => P.config.mySharesVisible === !0), ad = E(
      () => {
        var o;
        return (P.config.callerKind ?? ((o = ue.value) == null ? void 0 : o.caller_kind)) === "app";
      }
    ), ps = E(() => !ad.value), ph = S(!1);
    let bb = 0;
    Xe(
      () => [P.config.appStorePage === !0, ad.value],
      async ([o, s]) => {
        const g = ++bb;
        if (!bS(o, s)) {
          ph.value = !1;
          return;
        }
        const O = await $.appStoreStatus();
        g === bb && (ph.value = V_(o, s, O));
      },
      { immediate: !0 }
    );
    const nE = E(() => V_(P.config.appStorePage === !0, ad.value, { visible: ph.value })), hs = S(!1), Zl = S(!1);
    function aE() {
      Zl.value = !1, hs.value = !0;
    }
    function iE() {
      ad.value || (hs.value = !1, Zl.value = !0);
    }
    function id() {
      hs.value = !1, Zl.value = !1;
    }
    const oE = E(() => hs.value || Zl.value);
    function rE(o) {
      const s = o instanceof Error ? o.message : String(o);
      H("error", { message: s, context: { op: "connections" } }), et(s);
    }
    const hh = E(
      () => Gl.value ? ["list", "grid"] : void 0
    );
    hM(() => {
      Gl.value && xe.value === "gallery" && (xe.value = "grid");
    });
    const ms = S({ ...Ko }), vs = S(null), od = S("name"), sE = E(
      () => ye.value || dn.value ? "relevance" : "sort"
    );
    function lE() {
      vs.value = null, kb({ ...Ko });
    }
    function kb(o) {
      ms.value = o, tt.clear();
    }
    Xe(
      () => `${Le.value}|${gt.value}`,
      () => {
        Zs(ms.value) && (ms.value = { ...Ko }), ye.value || (vs.value = null);
      }
    );
    const Ql = S(!1), wb = S([]);
    Xe(Ql, async (o) => {
      o && (wb.value = await m_({
        apiBase: P.config.apiBase ?? "",
        authHeaders: () => Qn(),
        authCredentials: $.credentialsMode()
      }));
    });
    const _b = S(""), uE = E(() => !0);
    function mh(o = vs.value) {
      return LX(o ?? Ko, Date.now(), { showHidden: Wu.value });
    }
    const xb = S(!1);
    async function Sb(o, s, g, O = mh()) {
      var de;
      if (o === "name") {
        const $e = await pw(g, s), Ee = $e ?? await $.search(g, s, O);
        return {
          rows: Tr(await Kt.decorate(Ee.files, { root: Ee.e2e_root || null })),
          truncated: Qm(Ee.files.length, cf, Ee.truncated),
          local: !!$e
        };
      }
      const N = await $.globalSearchPage(s, { limit: D0, scope: o, narrow: O }), Y = _t.value || ((de = (P.config.storages ?? [])[0]) == null ? void 0 : de.name) || "";
      return {
        rows: Tr(await Kt.decorate(N.hits.map(($e) => Pf($e, Y)))),
        truncated: Qm(N.hits.length, D0, N.truncated),
        local: !1
      };
    }
    function cE() {
      const o = Le.value ?? "";
      return En.value ? vd(o) : It(o);
    }
    async function dE(o) {
      const s = cy(o), { rows: g, truncated: O, local: N } = await Sb(o.scope, s, cE(), mh(o.filters));
      return {
        count: (N && Zs(o.filters) ? Wv(g, o.filters) : g).length,
        capped: O
      };
    }
    function fE(o) {
      _b.value = It(Le.value ?? "") || "", $b.value = o, Ql.value = !0;
    }
    const $b = S("");
    function pE(o) {
      Ql.value = !1, od.value = o.scope, vs.value = Zs(o.filters) ? { ...o.filters } : null;
      const s = cy(o);
      s === ye.value ? kt() : ye.value = s;
    }
    function hE(o) {
      vs.value = null, od.value = "name", gt.value !== "home" && (ye.value = o);
    }
    const Tb = E(() => {
      if (gt.value || De.value) return "";
      const o = _t.value;
      if (!o) return "";
      const s = (P.config.storages ?? []).find((g) => g.name === o);
      return (s == null ? void 0 : s.label) || o;
    }), vh = S("");
    function mE(o) {
      vh.value = o, xd.value = !0;
    }
    const eu = S(void 0);
    function vE() {
      const o = It(Le.value);
      if (!o || !Hb.value) return;
      const s = Le.value.split("/").filter(Boolean);
      si.value = {
        path: o,
        basename: s.length ? s[s.length - 1] : _t.value,
        type: "dir"
      }, eu.value = "drop", lr.value = !0;
    }
    function yE(o) {
      H("share-created", { path: o.path, url: o.url, pin: null }), et(z("inspector.copied"));
    }
    const yh = S(null), Ab = S(null), gE = E(() => fJ(yh.value, kh.value, Ab.value));
    async function Eb() {
      if (!ps.value) {
        yh.value = null;
        return;
      }
      const o = await $.quotaMe();
      yh.value = o, Ab.value = dJ(o, kh.value) ? await $.storageUsage() : null;
    }
    function rd(o) {
      return Dne(o, {
        storages: P.config.storages ?? [],
        multiStorageRoot: En.value
      });
    }
    const io = S(null), tu = S(!1), sd = E(() => {
      if (!dn.value) return "";
      const o = zn.value;
      if (!o || !Hv(o)) return "";
      const s = nS(o);
      return s != null && s.k ? `${s.d === "desc" ? "-" : ""}${s.k}` : "";
    });
    Xe(sd, (o, s) => {
      o === s || !dn.value || (gt.value === "tag" && sn.value ? ys(sn.value, $n.value) : (gt.value === "recent" || gt.value === "starred" || gt.value === "shared") && nu(gt.value));
    });
    async function ld(o, s = 0) {
      const g = P.config.apiBase ?? "", O = new URLSearchParams({ limit: String(Ru), offset: String(s) });
      sd.value && O.set("sort", sd.value);
      const N = o === "shared" ? `${g}/api/files/manager/shared-with-me?${O}` : o === "starred" ? `${g}/api/files/manager/star/list?${O}` : `${g}/api/files/manager/recent?${O}`, Y = await fetch(N, {
        headers: await Qn(),
        // ⚠ NOT 'include' — with a bearer token this is cross-origin for every
        // embedder serving the UI from another origin (the desktop app): a credentialed
        // cross-origin request cannot be answered with `ACAO: *`.
        credentials: $.credentialsMode()
      });
      if (!Y.ok) throw new Error(String(Y.status));
      const de = await Y.json(), $e = (st) => ({
        rows: st,
        total: typeof (de == null ? void 0 : de.total) == "number" ? de.total : s + st.length,
        truncated: (de == null ? void 0 : de.truncated) === !0
      });
      if (o === "shared")
        return fh.value = Array.isArray(de == null ? void 0 : de.storages) ? de.storages : [], $e(await Kt.decorate(Array.isArray(de == null ? void 0 : de.files) ? de.files : []));
      const Ee = Array.isArray(de == null ? void 0 : de.nodes) ? de.nodes : [];
      return $e(await Kt.decorate(Ee.map(rd).filter((st) => st !== null)));
    }
    async function bE() {
      const o = io.value;
      if (!o || !o.truncated || tu.value) return;
      tu.value = !0;
      const s = Le.value;
      try {
        const g = o.kind === "tag" ? await Ob(sn.value, $n.value, o.next) : await ld(o.kind, o.next);
        if (Le.value !== s) return;
        _e.value = [..._e.value, ...g.rows], io.value = { kind: o.kind, total: g.total, truncated: g.truncated, next: o.next + Ru };
      } catch (g) {
        et(g instanceof Error ? g.message : String(g));
      } finally {
        tu.value = !1;
      }
    }
    const Cb = S([]), zb = S([]), gh = S(!1), Mb = $V(), bh = E(() => kV(P.config.storages ?? [], Mb.saved.value));
    function kE(o) {
      SV(o, bh.value);
    }
    const kh = E(
      () => bh.value.map(
        (o) => o.usedPartial !== void 0 || !(o.name in Ue.value) ? o : { ...o, usedPartial: Ue.value[o.name] !== null }
      )
    );
    async function wE() {
      gh.value = !0;
      try {
        const [o, s] = await Promise.all([
          ld("recent").then((g) => g.rows).catch(() => []),
          ld("starred").then((g) => g.rows).catch(() => [])
        ]);
        Cb.value = o, zb.value = s;
      } finally {
        gh.value = !1;
      }
    }
    async function nu(o) {
      To();
      const s = ut.view();
      if (o === "home") {
        gt.value || (wn.value = Le.value ?? ""), gt.value = "home", sn.value = "", $n.value = "", Rt.value = !1, Ot.value = "", ud(), tt.clear(), _e.value = [], At.value = Rn.home, Le.value = Rn.home, _t.value = "", await wE();
        return;
      }
      if (o === "tag") {
        sn.value && await ys(sn.value, $n.value);
        return;
      }
      if (o === "drafts") {
        gt.value || (wn.value = Le.value ?? ""), gt.value = "drafts", sn.value = "", $n.value = "", Rt.value = !1, Ot.value = "", ud(), tt.clear(), _e.value = [], At.value = Rn.drafts, Le.value = Rn.drafts, _t.value = "", await db();
        return;
      }
      if (o === "trash") {
        RE(), await zi(), gt.value = "trash", sn.value = "", $n.value = "";
        return;
      }
      oe.value = !0, gt.value || (wn.value = Le.value ?? ""), gt.value = o, sn.value = "", $n.value = "", Rt.value = !1, Ot.value = "", ud(), tt.clear(), At.value = Rn[o], Le.value = Rn[o], io.value = null;
      try {
        const g = await ld(o);
        if (!wt(s)) return;
        _e.value = g.rows, io.value = { kind: o, total: g.total, truncated: g.truncated, next: Ru }, _t.value = "";
      } catch (g) {
        if (!wt(s)) return;
        const O = g instanceof Error ? g.message : String(g);
        _e.value = [], H("error", { message: O, context: { op: `nav-view:${o}` } }), et(O);
      } finally {
        wt(s) && (oe.value = !1);
      }
    }
    async function Ob(o, s, g) {
      const O = await PD(
        o,
        {
          apiBase: P.config.apiBase ?? "",
          authHeaders: () => Qn(),
          authCredentials: $.credentialsMode()
        },
        { limit: Ru, offset: g, kind: s, sort: sd.value }
      );
      return { rows: await Kt.decorate(O.rows.map(rd).filter((Y) => Y !== null)), total: O.total, truncated: O.truncated };
    }
    async function ys(o, s = "") {
      To();
      const g = String(o ?? "").trim();
      if (!g) return;
      const O = ut.view();
      oe.value = !0, gt.value || (wn.value = Le.value ?? ""), gt.value = "tag", sn.value = g, $n.value = s, Rt.value = !1, Ot.value = "", ud(), tt.clear();
      const N = f4(g, s);
      At.value = N, Le.value = N, io.value = null;
      try {
        const Y = await Ob(g, s, 0);
        if (!wt(O)) return;
        _e.value = Y.rows, io.value = { kind: "tag", total: Y.total, truncated: Y.truncated, next: Ru }, _t.value = "";
      } catch (Y) {
        if (!wt(O)) return;
        const de = Y instanceof Error ? Y.message : String(Y);
        _e.value = [], H("error", { message: de, context: { op: `nav-view:tag:${s ? `${s}:` : ""}${g}` } }), et(de);
      } finally {
        wt(O) && (oe.value = !1);
      }
    }
    const Pb = S([]), wh = S(!1);
    async function _h(o = !1) {
      dh.value && (Pb.value = await m_({
        apiBase: P.config.apiBase ?? "",
        authHeaders: () => Qn(),
        authCredentials: $.credentialsMode(),
        force: o
      }), wh.value = !0);
    }
    function _E(o) {
      if (o === "myfiles") {
        To(), kt("");
        return;
      }
      nu(o);
    }
    function Db(o) {
      To(), kt(En.value ? o : "");
    }
    async function xE() {
      try {
        const o = P.config.apiBase ?? "", s = await fetch(`${o}/api/files/manager/shared-with-me?limit=1`, {
          headers: await Qn(),
          credentials: $.credentialsMode()
        });
        if (!s.ok) return;
        const g = await s.json();
        fh.value = Array.isArray(g == null ? void 0 : g.storages) ? g.storages : [];
      } catch {
      }
    }
    function xh(o) {
      const s = (o ?? "").replace(/^\/+|\/+$/g, "");
      if (!s) return En.value ? z("breadcrumb.root") : _t.value || z("breadcrumb.root");
      const g = s.split("/").pop() || s, O = Zf(g, z);
      return O || (Kt.segmentLabel(It(s)) ?? g);
    }
    function SE(o) {
      si.value = o, lr.value = !0;
    }
    function au(o) {
      return pe.value ? !1 : o === void 0 || o === "editor" || o === "owner";
    }
    function ud() {
      Ie.value = "", pe.value = !1;
    }
    const $E = E(() => !!gt.value && gt.value !== "trash");
    function Sh(o) {
      return typeof o.perm == "string" ? o.perm : Ine($E.value, Ie.value);
    }
    function Lb(o) {
      if (o.read_only === !0) return !0;
      const s = typeof o.storage == "string" ? o.storage : "";
      return s ? (P.config.storages ?? []).some((g) => g.name === s && g.readOnly === !0) : !1;
    }
    function oo(o) {
      return au(Sh(o)) && !Lb(o);
    }
    const Rb = { none: 0, viewer: 1, editor: 2, owner: 3 };
    function TE(o) {
      if (o.length === 0) return Ie.value;
      let s, g = !1;
      for (const O of o) {
        const N = Sh(O);
        if (N === void 0) {
          g = !0;
          continue;
        }
        (s === void 0 || (Rb[N] ?? 0) < (Rb[s] ?? 0)) && (s = N);
      }
      return s ?? (g ? void 0 : Ie.value);
    }
    function Nb(o) {
      return o.some(Lb);
    }
    const iu = ZX(), Na = uJ();
    Ct(() => Na.dispose());
    function $h() {
      var s;
      const o = (s = ue.value) == null ? void 0 : s.e2e_policy;
      return {
        p: [...Z.value ?? []].sort().join(","),
        e: o ? `${o.available}|${o.policy}` : ""
      };
    }
    async function AE() {
      var O, N, Y;
      if (await Promise.all([Ge(), J]), !((O = ue.value) != null && O.e2e_policy) && !((N = Z.value) != null && N.length)) return;
      let o;
      try {
        o = (Y = await Et()) == null ? void 0 : Y.user;
      } catch {
        o = null;
      }
      const s = ba(P.config) || (typeof location < "u" ? location.origin : ""), g = o && typeof o.id == "number" ? [s, o.id, o.provider_id ?? "", he].join("|") : null;
      Na.attach(g, $h()), Eh();
    }
    qt(() => void AE());
    const cd = S({}), dd = /* @__PURE__ */ new Set();
    let Th = 0;
    Xe(
      () => [I.value, Z.value],
      () => {
        Th++, dd.clear(), cd.value = {}, Na.sign("p", $h().p);
      }
    );
    function Ib(o) {
      const s = Z.value;
      if (!(s != null && s.length)) return;
      const g = o.filter(($e) => !Na.fresh("p", $e) && !dd.has($e));
      if (!g.length) return;
      g.forEach(($e) => dd.add($e));
      const O = [...s], N = Th, Y = ($e, Ee) => {
        if (N !== Th) return;
        const st = { ...cd.value };
        g.forEach((Ze, Lt) => {
          st[Ze] = $e[Lt] ?? [], Na.put("p", Ze, st[Ze], Ee), dd.delete(Ze);
        }), cd.value = st;
      }, de = g.some(($e) => Bb($e) === void 0) ? iu.start() : () => {
      };
      $.allowedAt(g, O).then(
        ($e) => Y($e, !0),
        () => Y(g.map(() => O), !1)
      ).finally(de);
    }
    function Bb(o) {
      return cd.value[o] ?? Na.peek("p", o);
    }
    function ou(o, s) {
      var O;
      const g = [...new Set(s.map(G))];
      return !I.value || !g.length || !((O = Z.value) != null && O.includes(o)) ? Ts(o) : (Ib(g), g.every((N) => {
        var Y;
        return ((Y = Bb(N)) == null ? void 0 : Y.includes(o)) ?? !1;
      }));
    }
    const fd = S({}), pd = /* @__PURE__ */ new Set();
    let Ah = 0;
    function EE() {
      Ah++, pd.clear(), fd.value = {}, Na.sign("e", $h().e);
    }
    Xe(
      () => {
        var o, s, g, O;
        return [
          I.value,
          Z.value,
          (s = (o = ue.value) == null ? void 0 : o.e2e_policy) == null ? void 0 : s.available,
          (O = (g = ue.value) == null ? void 0 : g.e2e_policy) == null ? void 0 : O.policy
        ];
      },
      EE
    );
    function ru(o, s) {
      return `${s}:${o}`;
    }
    async function Fb(o) {
      const s = o.filter((de) => {
        const $e = ru(de.path, de.kind);
        return !Na.fresh(`e:${de.kind}`, de.path) && !pd.has($e);
      });
      if (!s.length) return;
      for (const de of s) pd.add(ru(de.path, de.kind));
      const g = Ah, N = s.some((de) => Ub(de.path, de.kind) === void 0) ? iu.start() : () => {
      };
      let Y = !1;
      try {
        const de = await $.e2eAllowedAt(s, {
          onFailed: () => {
            Y = !0;
          }
        });
        if (g !== Ah) return;
        const $e = { ...fd.value };
        s.forEach((Ee, st) => {
          const Ze = ru(Ee.path, Ee.kind);
          $e[Ze] = de[st] ?? "allowed", Na.put(`e:${Ee.kind}`, Ee.path, $e[Ze], !Y), pd.delete(Ze);
        }), fd.value = $e;
      } finally {
        N();
      }
    }
    function Ub(o, s) {
      return fd.value[ru(o, s)] ?? Na.peek(`e:${s}`, o);
    }
    function Eh() {
      var de, $e;
      if (Rt.value || gt.value || we.value || ee.value) return;
      const o = It(Le.value ?? "");
      if (!o.includes("://") || j.rootOf(o)) return;
      const s = !!((de = ue.value) != null && de.e2e_policy) && !an.value, g = !!I.value && !!(($e = Z.value) != null && $e.length);
      if (!s && !g) return;
      const O = /* @__PURE__ */ new Set(), N = /* @__PURE__ */ new Map(), Y = (Ee, st) => {
        if (Ee === "p")
          g && O.add(st);
        else if (s) {
          const Ze = Ee.slice(2);
          N.set(ru(st, Ze), { path: st, kind: Ze });
        }
      };
      Y("p", o), Y("e:new_folder", o);
      for (const Ee of _e.value.slice(0, gse))
        !Ee || typeof Ee.path != "string" || !Ee.path.includes("://") || nc(Ee) || j.isVaultRow(Ee) || (Y("p", Ee.path), !(!oo(Ee) || Ee.e2e || Ee.e2e_root) && (Ee.type === "dir" ? Y("e:folder", Ee.path) : Ui(Ee) || Y("e:file", Ee.path)));
      for (const Ee of Na.around(o)) Y(Ee.q, Ee.path);
      O.size && Ib([...O].slice(0, 1e3)), N.size && Fb([...N.values()].slice(0, 1e3));
    }
    let gs = null;
    function CE(o) {
      if (Na.stale(), o.resync) {
        Eh();
        return;
      }
      gs || (gs = setTimeout(
        () => {
          gs = null, re(), kt();
        },
        o.all ? Math.random() * bse : 0
      ));
    }
    Ct(() => {
      gs && clearTimeout(gs), gs = null;
    });
    function Ch(o, s) {
      var N;
      const g = G(o);
      return ((N = ue.value) == null ? void 0 : N.e2e_policy) ? (Fb([{ path: g, kind: s }]), Ub(g, s) ?? "denied") : "allowed";
    }
    const li = E(
      () => au(Ie.value) && ou("files.create", Le.value ? [It(Le.value)] : [])
    ), hd = E(
      () => li.value && !De.value && !Rt.value
    ), Hb = E(
      () => Cd(Le.value ? [It(Le.value)] : []).uploadLinks
    ), zE = E(
      () => si.value && I.value ? Cd([si.value.path]) : void 0
    ), zh = S(null), Mn = S(null), Kb = S(null), Ta = S(!1), Vb = S(!1);
    let bs, ui;
    function Mh(o) {
      Vb.value = !!(o && "matches" in o && o.matches);
    }
    qt(() => {
      var o;
      typeof ResizeObserver < "u" && Mn.value && (bs = new ResizeObserver((s) => {
        var O, N, Y;
        const g = ((N = (O = s[0]) == null ? void 0 : O.contentRect) == null ? void 0 : N.width) ?? ((Y = Mn.value) == null ? void 0 : Y.clientWidth) ?? 0;
        Ta.value = g > 0 && g < 560;
      }), bs.observe(Mn.value)), typeof window < "u" && window.matchMedia && (ui = window.matchMedia("(pointer: coarse)"), Mh(ui), (o = ui.addEventListener) == null || o.call(ui, "change", Mh));
    }), Ct(() => {
      var o;
      bs == null || bs.disconnect(), bs = void 0, (o = ui == null ? void 0 : ui.removeEventListener) == null || o.call(ui, "change", Mh), ui = void 0;
    });
    const va = S(null);
    let Ka, ks = null;
    function Yt(o, s) {
      va.value = o, Ka && clearTimeout(Ka), Ka = setTimeout(jb, s);
    }
    function et(o) {
      Yt({ message: o }, hi);
    }
    function jb() {
      Ka = void 0, va.value = null;
      const o = ks;
      ks = null, o && Yt({ message: o.message, source: "drag-out" }, o.ms);
    }
    Ct(() => {
      Ka && clearTimeout(Ka), Ka = void 0, ks = null;
    });
    const Ci = E(() => {
      if (gt.value || nn.value || we.value) return null;
      const o = !!ye.value, s = Va(At.value).replace(/^\/+|\/+$/g, "") === "";
      return XX({
        map: Ue.value,
        adapter: _t.value,
        searching: o,
        crossStorage: o && s && Object.keys(Ue.value).length > 1,
        admin: ha.value
      });
    });
    async function ME(o) {
      if (!o || pn(o)) return;
      Qt.value = { ...Qt.value, [o]: 0 };
      const s = () => {
        const { [o]: N, ...Y } = Qt.value;
        Qt.value = Y;
      };
      let g;
      try {
        const N = ba(P.config), Y = await $.jsonFetch(`${N}/api/admin/storages`), de = Array.isArray(Y) ? Y.find((Ee) => Ee.name === o) : void 0;
        if (!de) throw new Error("no such storage");
        const $e = await $.jsonFetch(`${N}/api/admin/storages/${de.id}/sync`, { method: "POST" });
        g = de.id, Qt.value = { ...Qt.value, [o]: g }, et(($e == null ? void 0 : $e.status) === "running" ? z("coverage.catalog_joined", { storage: o }) : z("coverage.catalog_started"));
      } catch (N) {
        s(), Yt({ message: Zn(N) }, bn);
        return;
      }
      const O = await Ut().scan(g);
      s(), O !== null && (O.status === "ok" ? (et(z("coverage.catalog_done", { storage: o })), await kt()) : O.status === "failed" ? Yt({ message: z("coverage.catalog_failed", { storage: o }) }, bn) : O.status === "aborted" ? Yt({ message: z("coverage.catalog_stopped", { storage: o }) }, bn) : O.status === "gone" ? Yt({ message: z("coverage.catalog_gone", { storage: o }) }, bn) : Yt({ message: z("coverage.catalog_unfollowed", { storage: o }) }, bn));
    }
    function md(o, s) {
      Yt({ message: o, actionLabel: z("toast.undo"), action: s, after: { kind: "undo" } }, 8e3);
    }
    function Oh() {
      Ka && clearTimeout(Ka), jb();
    }
    async function OE() {
      const o = va.value, s = o == null ? void 0 : o.action;
      if (Ka && clearTimeout(Ka), Ka = void 0, va.value = null, !o || !s) return;
      const g = o.after ?? { kind: "undo" }, O = g.kind === "plain", N = O && o.source ? "drag-out-stopping" : void 0;
      Yt({ message: $0(g, "running", void 0, z), source: N }, df);
      try {
        const Y = await s();
        Yt({ message: $0(g, "done", Y, z), source: N }, hi), O || await kt();
      } catch (Y) {
        O ? Yt({ message: Zn(Y) }, bn) : et(z("toast.undo_failed"));
      }
    }
    const En = E(() => P.config.multiStorageRoot === !0);
    function PE(o) {
      const s = o.replace(/^\/+|\/+$/g, "");
      if (!s) return { adapter: "", rel: "" };
      const g = s.indexOf("/");
      return g === -1 ? { adapter: s, rel: "" } : { adapter: s.slice(0, g), rel: s.slice(g + 1) };
    }
    function vd(o) {
      if (o.includes("://")) return o;
      const { adapter: s, rel: g } = PE(o);
      return s ? g ? `${s}://${g}` : `${s}://` : "";
    }
    function Ao(o) {
      const s = o.indexOf("://");
      if (s === -1) return o.replace(/^\/+|\/+$/g, "");
      const g = o.slice(0, s), O = o.slice(s + 3).replace(/^\/+|\/+$/g, "");
      return O ? `${g}/${O}` : g;
    }
    function qb() {
      return (P.config.storages ?? []).map((s) => ({
        type: "dir",
        path: s.name,
        // virtual path (no adapter prefix)
        basename: s.label || s.name,
        extension: "",
        storage: s.name,
        visibility: "private",
        file_size: 0,
        mime_type: "inode/storage",
        extra_metadata: { driver: s.driver, readOnly: s.readOnly }
      }));
    }
    function Wb() {
      var o;
      s4(!Wu.value), kt(), (o = en.value) == null || o.reload();
    }
    function Yb() {
      kt(), Eb(), H("refresh");
    }
    function kt(o) {
      return ut.follow(() => DE(o));
    }
    async function DE(o) {
      var $e;
      Te.value = !1;
      const { ticket: s, want: g } = ut.begin(o, Le.value ?? "");
      Be.connected.value || Na.stale();
      const O = Fn(g);
      if (O) {
        if (!(O.kind === "trash" ? P.config.trashVisible !== !1 : Jl.value))
          return Rh(""), await kt("");
        O.kind === "tag" ? await ys(O.tag, O.tagKind) : await nu(O.kind);
        return;
      }
      const N = String(Le.value ?? "").replace(/^\/+|\/+$/g, ""), Y = (Ee) => {
        String(Ee ?? "").replace(/^\/+|\/+$/g, "") !== N && (tt.clear(), bt.value = []);
      };
      oe.value = !0, Rt.value = !1, gt.value = "", sn.value = "", $n.value = "";
      let de = g;
      ut.going(g);
      try {
        if (we.value = "", ee.value = "", he) {
          const gn = String(de).replace(/^\/+|\/+$/g, "");
          (!gn || !(gn === he || gn.startsWith(he + "/"))) && (de = he);
        }
        if (En.value && !vd(de)) {
          if (Tn.value) return await kt(Tn.value);
          Y(""), Le.value = "", _t.value = "", At.value = "", Ot.value = "", _e.value = qb();
          return;
        }
        const Ee = En.value ? vd(de) : It(de), st = j.rootOf(Ee);
        if (st) {
          const gn = String(Ee).replace(/\/+$/, "");
          if (j.isOpen(st)) {
            const Cn = j.rows(gn) ? gn : st, Fi = ye.value ? j.search(Cn, ye.value) : j.rows(Cn);
            if (!wt(s)) return;
            j.touch(Cn), Te.value = !1, _t.value = Cn.slice(0, Cn.indexOf("://")), At.value = Cn, Ie.value = j.permOf(st) || "", pe.value = !!(($e = j.strips[st]) != null && $e.readOnly), Ot.value = st;
            const Ga = Li(Cn);
            Y(Ga), _e.value = Tr(Fi ?? []), Le.value = Ga;
            return;
          }
          if (gn !== st) return await kt(Li(st));
        }
        const Lt = !!ye.value && od.value !== "name" ? await Sb(od.value, ye.value, Ee) : null;
        let Pn = !1;
        const Mt = Lt ? {
          adapter: _t.value,
          storages: (P.config.storages ?? []).map((gn) => gn.name),
          dirname: At.value,
          read_only: !1,
          files: Lt.rows,
          truncated: Lt.truncated
        } : ye.value ? await (async () => {
          const gn = await pw(Ee, ye.value);
          return Pn = !!gn, gn ?? await $.search(Ee, ye.value, mh());
        })() : await $.index(Ee);
        if (!Lt && !ye.value && typeof Mt.e2e_vault_root == "string" && Mt.e2e_vault_root) {
          const gn = Mt.e2e_vault_root.replace(/\/+$/, "");
          if (String(Mt.dirname ?? "").replace(/\/+$/, "") !== gn)
            return wt(s) ? await kt(Li(gn)) : void 0;
          Mt.files = [];
        }
        if (Mt.files = await Kt.decorate(Mt.files, {
          root: typeof Mt.e2e_root == "string" && Mt.e2e_root ? Mt.e2e_root : null
        }), !wt(s)) return;
        Mt.files = Nne(Mt.files, Mt.perm), Te.value = !!ye.value && Qm(Mt.files.length, cf, Mt.truncated), xb.value = !!ye.value && (Lt ? Lt.local : Pn), Array.isArray(Mt.storage_info) && (Ue.value = GX(Mt.storage_info), xt.value = G4(Mt.storage_info)), _t.value = Mt.adapter, At.value = Mt.dirname, Ie.value = Mt.perm || "", pe.value = Mt.read_only === !0, Ot.value = typeof Mt.e2e_root == "string" ? Mt.e2e_root : "";
        {
          const gn = String(Mt.dirname ?? "").replace(/\/+$/, ""), Cn = typeof Mt.e2e_root == "string" ? Mt.e2e_root.replace(/\/+$/, "") : "";
          j.rootOf(gn) === gn && Cn !== gn && j.forget(gn);
        }
        const Ya = En.value ? Ao(Mt.dirname) : Va(Mt.dirname);
        Y(Ya), _e.value = Tr(Mt.files), jx(_e.value, Mt.adapter, Mt.dirname, P.config.trashVisible !== !1, {
          isSearchResult: !!ye.value,
          navOffersTrash: yb.value
        }) && qx(_e.value, Mt.adapter, $), Le.value = Ya, Eh();
      } catch (Ee) {
        if (!wt(s)) return;
        const st = Ee instanceof Error ? Ee.message : String(Ee), Ze = Ee.status;
        if (Ze === 404 || Ze === 403) {
          we.value = String(de), Y(String(de)), Ot.value = "", _e.value = [], H("error", { message: st, context: { path: o } });
          return;
        }
        ee.value = st, ge = typeof de == "string" ? de : void 0, H("error", { message: st, context: { path: o } }), _e.value.length > 0 && et(st);
      } finally {
        wt(s) && (oe.value = !1), ut.end(s);
      }
    }
    function Va(o) {
      const s = o.indexOf("://");
      return s === -1 ? o : o.slice(s + 3);
    }
    function LE() {
      we.value = "", Rh(""), kt("");
    }
    const yd = S(null), Eo = S(!1), gd = S(!1), su = S(!1), Ph = S(null);
    let Gb = !1;
    Ct(() => {
      Gb = !0, vn == null || vn.stop();
    });
    async function RE() {
      try {
        const o = await fetch(`${P.config.apiBase ?? ""}/api/admin/protection`, {
          headers: await Qn(),
          credentials: $.credentialsMode()
        });
        if (!o.ok) {
          yd.value = null, Eo.value = !1;
          return;
        }
        const s = await o.json(), g = s == null ? void 0 : s.trash_retention_days;
        yd.value = typeof g == "number" && g > 0 ? g : null, Eo.value = !0;
      } catch {
      }
    }
    const NE = E(
      () => yd.value !== null ? z("trash.retention", { days: yd.value }) : z("trash.retention_unknown")
    ), ws = S(null), bd = S("");
    let Dh = 0;
    async function IE() {
      ws.value = null, bd.value = "", su.value = !0;
      const o = ++Dh;
      try {
        const s = await $.trashEmptyPreview();
        o === Dh && (ws.value = s);
      } catch (s) {
        o === Dh && (bd.value = Za(s, W.value));
      }
    }
    const Xb = E(() => {
      const o = Ph.value;
      return o != null && o.running ? o.summary ?? "" : "";
    });
    async function BE() {
      if (su.value = !1, !Eo.value || gd.value) return;
      const o = $.endpoints.trashEmpty;
      if (o) {
        gd.value = !0;
        try {
          const s = await Une({
            start: async () => fetch($.withScreenLang(o), {
              method: "POST",
              headers: await Qn(),
              credentials: $.credentialsMode()
            }),
            status: async () => fetch($.withScreenLang(o), { headers: await Qn(), credentials: $.credentialsMode() }),
            locale: W.value,
            /* The run is an ops row: it goes into the operations centre (progress,
             * Cancel) the moment the server names it — a run done within the wait
             * as well, like any other operation the person started. */
            onStart: (g) => {
              g.op_id && ze.register({
                id: g.op_id,
                kind: "trash-empty",
                status: g.running ? g.queued ? "pending" : "running" : g.cancelled ? "cancelled" : "ok",
                total: g.total ?? 0,
                done: g.scanned ?? 0
              });
            },
            onProgress: (g) => {
              Ph.value = g;
            },
            onBusy: (g) => {
              g && et(g);
            },
            stopped: () => Gb
          });
          if (s === null || (Rt.value && await zi(), !s.started_at || !s.summary)) return;
          Yt({ message: s.summary }, s.error || s.failed ? bn : hi);
        } catch (s) {
          if (s instanceof AT) {
            et(s.message);
            return;
          }
          const g = Za(s, W.value);
          H("error", { message: (s == null ? void 0 : s.message) ?? String(s), context: { op: "trash:empty" } }), et(g);
        } finally {
          Ph.value = null, gd.value = !1;
        }
      }
    }
    const _s = S(0), Co = S(0), kd = S(""), wd = S(!1), FE = E(() => {
      const o = new Intl.NumberFormat(gi(W.value));
      return z("trash.shown_of", { shown: o.format(Co.value), total: o.format(_s.value) });
    });
    function Jb(o) {
      return o.map(
        (s) => ({
          type: "file",
          id: s.id,
          /* Which storage's trash it is in: a permanent delete is one job per
             storage, and each job's rows are the ones it deletes. */
          storage_id: s.storage_id,
          /* ⚠ The ORIGINAL path, which the server sends with its leading
             slash: `depo:///x.txt` put an empty segment in the Location
             column ("depo/"), so it is dropped here. */
          path: s.storage_name ? `${s.storage_name}://${s.path.replace(/^\/+/, "")}` : s.path,
          basename: s.name,
          extension: s.name.includes(".") && s.name.split(".").pop() || "",
          storage: s.storage_name || "",
          visibility: "private",
          /* tablo:t1 — ⚠ BOTH. Every view reads `size` (the Size column, the
             info panel); only the upload code reads `file_size`. Setting one of
             the two left every trashed row with a blank Size cell. */
          size: s.size,
          file_size: s.size,
          mime_type: s.mime || "",
          /* The date the Trash's date column prints and sorts by — WHEN it was
             deleted. A trashed row has no modification date to show, and the
             column read "—" for every row. */
          last_modified: Date.parse(s.deleted_at) || void 0,
          extra_metadata: {
            deleted_at: s.deleted_at,
            ttl_days: s.ttl_days ?? null,
            /* A permanent delete is on its way for it (purgeSelection). */
            purging: As.value.has(s.id),
            /* #71 — a discarded draft of the asker's: its Location reads
               "Drafts" (ListView), which is where Restore puts it back. */
            ...s.draft ? { draft: !0 } : {}
          },
          /* Who put it here — the Trash draws it where a folder draws the
             owner. Keys absent when nobody is named, as the listing sends. */
          ...s.deleted_by_id !== void 0 ? { deleted_by_id: s.deleted_by_id } : {},
          ...s.deleted_by_name ? { deleted_by_name: s.deleted_by_name } : {},
          ...s.deleted_by_self ? { deleted_by_self: !0 } : {},
          /* wiring:e2 names — the encrypted folder it was deleted from. */
          ...s.e2e_root ? { e2e_root: s.e2e_root } : {}
        })
      );
    }
    async function zi() {
      const o = ut.view(), s = Rt.value;
      oe.value = !0, rn.value = _t.value || "", Rt.value = !0, Ot.value = "", s || tt.clear();
      try {
        const g = await $.listTrash(void 0, { limit: L0 }), O = await Kt.decorate(Jb(g.entries));
        if (!wt(o)) return;
        _e.value = O, Co.value = g.entries.length, _s.value = g.total, kd.value = g.summary ?? "", At.value = ".trash", Le.value = ".trash";
      } catch (g) {
        if (!wt(o)) return;
        const O = g instanceof Error ? g.message : String(g);
        H("error", { message: O, context: { op: "trash-list" } }), et(O);
      } finally {
        wt(o) && (oe.value = !1);
      }
    }
    async function UE() {
      if (wd.value || Co.value >= _s.value) return;
      const o = Co.value;
      wd.value = !0;
      try {
        const s = await $.listTrash(void 0, { limit: L0, offset: o }), g = await Kt.decorate(Jb(s.entries));
        if (!Rt.value || Co.value !== o) return;
        _e.value = [..._e.value, ...g], Co.value = o + s.entries.length, _s.value = s.total, kd.value = s.summary ?? "";
      } catch (s) {
        Yt({ message: Zn(s) }, bn);
      } finally {
        wd.value = !1;
      }
    }
    function It(o) {
      if (o && o.includes("://")) return o;
      if (En.value) {
        const s = vd(o ?? "");
        return s || (_t.value ? `${_t.value}://` : "");
      }
      return o ? `${_t.value}://${o.replace(/^\/+/, "")}` : `${_t.value}://`;
    }
    function Mi(o) {
      const s = o.indexOf("://"), g = (s === -1 ? o : o.slice(s + 3)).replace(/\/+$/, ""), O = g.lastIndexOf("/");
      return O === -1 ? g : g.slice(O + 1);
    }
    function ro(o) {
      const s = o.indexOf("://"), g = s === -1 ? "" : o.slice(0, s + 3), O = (s === -1 ? o : o.slice(s + 3)).replace(/\/+$/, ""), N = O.lastIndexOf("/");
      return N === -1 ? g : g + O.slice(0, N);
    }
    function Lh(o, s) {
      const g = (O) => {
        const N = O.indexOf("://"), Y = N === -1 ? "" : O.slice(0, N + 3), de = (N === -1 ? O : O.slice(N + 3)).replace(/\/+$/, "");
        return Y + de;
      };
      return g(o) === g(s);
    }
    function ja(o, s) {
      return o ? o.endsWith("://") || o.endsWith("/") ? o + s : `${o}/${s}` : s;
    }
    async function Zb(o, s) {
      try {
        const g = await $.index(s), O = new Set((g.files ?? []).map((N) => String(N.basename ?? "").toLowerCase()));
        return o.some((N) => O.has(Mi(N).toLowerCase()));
      } catch {
        return !0;
      }
    }
    function Qb(o, s, g, O, N) {
      if (!O || !g || N) return;
      const Y = s.map((de) => ja(g, Mi(de)));
      Y.length !== 0 && ft.set(o, {
        message: z("toast.moved"),
        fn: async () => {
          const { op: de } = await $.moveAsync(Y, O, g);
          return ze.register(de), { queued: !0 };
        }
      });
    }
    Xe(
      () => ye.value,
      () => void kt()
    );
    function _d() {
      return P.config.pathPersist ?? "hash";
    }
    function ek() {
      const o = _d();
      return o === "hash" || o === "hash+localStorage";
    }
    function HE(o) {
      try {
        return decodeURIComponent(o);
      } catch {
        return o;
      }
    }
    function tk() {
      try {
        return localStorage.getItem(cv) || "";
      } catch {
        return "";
      }
    }
    function nk() {
      const o = window.location.hash || "";
      return o.startsWith("#") ? HE(o.slice(1)).replace(/^\/+|\/+$/g, "") : "";
    }
    function KE() {
      if (typeof window > "u") return "";
      const o = _d();
      if (o === "none") return "";
      if (o === "localStorage") return tk();
      const s = nk();
      return s || o === "hash" ? s : Ke ? "" : tk();
    }
    function Rh(o) {
      if (typeof window > "u") return;
      const s = _d();
      if (s === "none") return;
      if (s === "localStorage" || s === "hash+localStorage") {
        try {
          o ? localStorage.setItem(cv, o) : localStorage.removeItem(cv);
        } catch {
        }
        if (s === "localStorage") return;
      }
      const g = NT(o), O = g ? `#${g}` : "";
      (window.location.hash || "") !== O && history.replaceState(
        history.state,
        "",
        O || window.location.pathname + window.location.search
      );
    }
    function ak() {
      if (!ek()) return;
      const o = nk();
      o && o !== Le.value && kt(o);
    }
    Xe(Le, (o) => {
      const s = j.rootOf(It(o)) ? Li(j.rootOf(It(o))) : o;
      Rh(s), H("navigate", { path: s }), Be.subscribe($t(o));
    }), t({
      reload: () => kt(),
      /* App plugins — a notification's `target.open` lands here (see the
         function's own note for why this is a method and not a prop). */
      openAppTarget: eh,
      /* A notification's destination, carried out in this explorer — the desktop
         app hands a clicked OS notification here (see the function's note). */
      revealNotification: Wt
    }), qt(async () => {
      var s;
      wp();
      const o = KE();
      try {
        await kt(o || void 0);
      } finally {
        zt();
      }
      await Jt(), (s = Mn.value) == null || s.focus(), xE(), _h(), Eb(), Xe(dh, (g) => {
        g && !wh.value && _h();
      }), ek() && window.addEventListener("hashchange", ak), $.endpoints.opsList && ze.startPolling(), Ge();
    });
    const xd = S(!1), Sd = S(!1);
    function Nh() {
      return { configured: (P.config.storages ?? []).map((o) => o.name), current: _t.value };
    }
    function xs(o) {
      const s = P.config.accountSearch, g = o.account;
      return !s || !g || g.id === s.self.id ? null : g;
    }
    function lu(o) {
      return Wne(o, xs(o) ? { configured: [], current: "" } : Nh());
    }
    async function VE(o) {
      var N;
      if (!o.some((Y) => typeof Y.e2e_root == "string" && Y.e2e_root)) return o;
      const s = _t.value || ((N = (P.config.storages ?? [])[0]) == null ? void 0 : N.name) || "", g = await Promise.all(
        o.map((Y) => Kt.decorate([Pf(Y, s)]).then((de) => de[0] ?? null))
      ), O = [];
      return o.forEach((Y, de) => {
        const $e = g[de];
        $e && O.push($e.e2e_stored ? { ...Y, name: $e.basename, e2e_display_dir: $e.e2e_display_dir } : Y);
      }), O;
    }
    async function jE(o) {
      const s = $.globalSearch(o, { limit: 8, scope: "all" }).then(VE), g = P.config.accountSearch;
      if (!g) return s;
      let O = [];
      try {
        O = await g.others() ?? [];
      } catch {
        O = [];
      }
      if (O.length === 0) return s;
      const N = [g.self, ...O], Y = await Promise.allSettled([
        s,
        ...O.map(($e) => g.search($e.id, o, { limit: 8, scope: "all" }))
      ]), de = [];
      return Y.forEach(($e, Ee) => {
        if (!($e.status !== "fulfilled" || !Array.isArray($e.value)))
          for (const st of $e.value) de.push({ ...st, account: N[Ee] });
      }), de;
    }
    async function qE(o) {
      const s = MT(o);
      if (!s) return;
      const g = o.type === "dir", O = s.lastIndexOf("/"), N = g ? s : O === -1 ? "" : s.slice(0, O);
      let Y = N;
      if (En.value) {
        const Ee = py(o, Nh());
        if (!Ee) return;
        Y = N ? `${Ee}/${N}` : Ee;
      }
      if (await kt(Y), g) return;
      const de = String(o.name ?? s.slice(O + 1)), $e = _e.value.find((Ee) => Ee.type === "file" && Ee.basename === de);
      $e && (tt.click($e.path), qa($e));
    }
    function Ih(o) {
      return (s) => H("error", { message: (s == null ? void 0 : s.message) ?? String(s), context: { op: o } });
    }
    function WE(o) {
      const s = xs(o), g = P.config.accountSearch;
      if (s && g) {
        const O = lu(o);
        O && Promise.resolve(g.open(s.id, Ef(O))).catch(Ih("search-open"));
        return;
      }
      qE(o);
    }
    function YE(o, s) {
      const g = lu(o);
      if (!g || s === "drag" && !cp(g)) return !1;
      if (xs(o)) {
        const O = P.config.accountSearch;
        return s === "download" ? !!(O != null && O.download) : !!(O != null && O.dragStart);
      }
      return s === "download" ? !0 : !!fi.value || g.type === "file" && (Zm(P.config.auth) || wk.value);
    }
    function GE(o) {
      if (xs(o)) return;
      const s = lu(o);
      s && G1(s) && Sk(s.path);
    }
    function XE(o) {
      const s = lu(o);
      if (!s) return;
      const g = xs(o);
      if (g) {
        const O = P.config.accountSearch;
        O != null && O.download && Promise.resolve(O.download(g.id, Ef(s))).catch(Ih("search-download"));
        return;
      }
      zd([Pf(o, py(o, Nh()))]);
    }
    function JE(o, s) {
      const g = lu(o);
      if (!g || !s.dataTransfer || !cp(g)) {
        s.preventDefault();
        return;
      }
      s.dataTransfer.effectAllowed = "copy";
      const O = xs(o);
      if (O) {
        const N = P.config.accountSearch;
        s.preventDefault(), N != null && N.dragStart && Promise.resolve(N.dragStart(O.id, [Ef(g)])).catch(Ih("drag-out"));
        return;
      }
      kk(s, [g], null, typeof o.mime == "string" ? o.mime : void 0, !1);
    }
    function ZE() {
      $r(), Es();
    }
    mP(Mn, {
      onDelete: () => {
        if (Rt.value && !On.value && !Eo.value) {
          tt.isEmpty.value || et(z("toast.trash_retention"));
          return;
        }
        if (On.value) {
          const o = Wn.nodes.value;
          o.length && (zo.value = o, Ei.value = !0, ma.value = !0);
        } else tt.isEmpty.value || (Ei.value = !1, ma.value = !0);
      },
      onRename: () => {
        if (On.value) {
          const o = Wn.nodes.value;
          o.length === 1 && (sr.value = o[0], Ei.value = !0, no.value = !0);
        } else tt.nodes.value.length === 1 && (sr.value = tt.nodes.value[0], Ei.value = !1, no.value = !0);
      },
      onSelectAll: () => On.value ? Wn.selectAll() : tt.selectAll(),
      onOpen: () => {
        if (On.value) {
          const s = Wn.nodes.value[0];
          s && sz("split", s);
          return;
        }
        const o = tt.nodes.value[0];
        o && qa(o);
      },
      onClose: () => {
        var o;
        if (ua.value = !1, no.value = !1, ma.value = !1, hn.value && Iw(hn.value.path) || (ca.value = !1), (o = zh.value) == null || o.hide(), Oh(), oE.value) {
          id();
          return;
        }
        if (ur.value) {
          To();
          return;
        }
        Ta.value && mb();
      },
      onFocusSearch: () => {
        var o;
        return (o = Kb.value) == null ? void 0 : o.focusSearch();
      },
      onCut: () => On.value ? Wk() : yC(),
      onCopy: () => On.value ? Yk() : gC(),
      onPaste: () => On.value ? void Gk() : void fk(),
      onGoUp: () => {
        var o;
        return On.value ? (o = en.value) == null ? void 0 : o.goUp() : Ve();
      },
      /* cila:c wiring */
      onPathJump: () => {
        vh.value = "", xd.value = !0;
      },
      onShowHelp: () => {
        Sd.value = !0;
      },
      /* /cila:c wiring */
      onQuickLook: () => jC(),
      onToggleHidden: () => Wb(),
      onStar: () => void lb(tt.nodes.value),
      onToggleInspector: () => uh(),
      /* wiring:d1 — tab actions (registry: tab-new/close/next/prev) */
      onTabNew: () => sm(),
      onTabClose: () => Rk(rm.value),
      onTabNext: () => ez(),
      onTabPrev: () => tz(),
      /* /wiring:d1 */
      /* tus:t1 — the menu verbs, routed through the SAME dispatcher the right-click
       * menu and the toolbar use (dispatchItemAction), so a key and a click cannot
       * drift apart. The ones that act on a selection do nothing without one, which
       * is what the menu does too. */
      onNewFolder: () => {
        ua.value = !0;
      },
      onUpload: () => Mo(),
      onRefresh: () => void kt(),
      onDownload: () => void Pi("download", aa()),
      onPreview: () => void Pi("preview", aa()),
      /* The share dialog is a door that makes links: the key opens it only where
         the menu offers Share (a role without any sharing permission gets
         nothing from the key either). */
      onShare: () => {
        const o = aa();
        dC("access", o) && Pi("access", o);
      },
      onTags: () => void Pi("tags", aa()),
      onOpenTab: () => void Pi("open-tab", aa()),
      onCopyPath: () => {
        const o = aa()[0];
        o && Pd(o.path);
      },
      onCopyId: () => void Pi("copy-id", aa()),
      onRestore: () => void Pi("restore", aa()),
      /* /tus:t1 */
      hasSelection: () => !tt.isEmpty.value
    });
    function aa() {
      return On.value ? Wn.nodes.value : tt.nodes.value;
    }
    function qa(o) {
      if (o.basename === ".trash") {
        zi();
        return;
      }
      const s = Bc(o, { t: z });
      if (s) {
        Yt({ message: s.why }, 8e3);
        return;
      }
      const g = Fc(o, { t: z });
      if (g) {
        Yt({ message: g.full }, 8e3);
        return;
      }
      if (o.type === "dir") {
        const Y = En.value ? Ao(o.path) : Va(o.path);
        kt(Y);
        return;
      }
      if (j.isVaultRow(o) && o.type === "file") {
        if (Nl(o, null, "edit")) return;
        Ps(o);
        return;
      }
      if (Ui(o) && !an.value && !o.e2e_root) {
        Dt.open(o);
        return;
      }
      if (o.type === "file" && !an.value && typeof o.e2e_root == "string" && o.e2e_root) {
        const Y = Ia(o.path);
        kt(En.value ? Ao(Y) : Va(Y));
        return;
      }
      if (Gn.value && o.type === "file") {
        if (Nl(o, null, "edit")) return;
        Ps(o);
        return;
      }
      if (ku.value && o.type === "file") return;
      if (sv(P.config, o) === "host") {
        H("file-opened", { path: o.path, basename: o.basename }), Ua(o);
        return;
      }
      const O = (o.extension || "").toLowerCase();
      Ha.value = oo(o) ? eC(O) : "view", $i.value = null;
      const N = Iu(Ll.value, o, null, Rl.value, Il(o), ts(o));
      N != null && N.view && oo(o) ? Ha.value = "edit" : Tf(N) && (Ha.value = "view"), hn.value = o, ca.value = !0, H("file-opened", { path: o.path, basename: o.basename }), Ua(o);
    }
    const QE = /* @__PURE__ */ new Set([
      "drawio",
      "dio",
      "pdf",
      "epub",
      "ipynb",
      "tiff",
      "tif",
      "psd",
      "mmd",
      "mermaid",
      "glb",
      "gltf",
      "obj",
      "stl",
      "fbx",
      "3ds",
      "zip",
      "rar",
      "7z",
      "tar",
      "gz",
      "tgz",
      "jpg",
      "jpeg",
      "png",
      "webp",
      "gif",
      "bmp",
      "avif",
      "svg",
      "heic",
      "mp4",
      "webm",
      "mov",
      "mkv",
      "m4v",
      "ogv",
      "mp3",
      "wav",
      "ogg",
      "flac",
      "m4a",
      "aac",
      "opus"
    ]);
    function eC(o) {
      return mv(o) || QE.has(o) ? "view" : "edit";
    }
    const Bh = S(!1);
    async function tC(o) {
      if (Bh.value) return;
      const s = o ?? tt.nodes.value;
      if (s.length !== 0) {
        Bh.value = !0;
        try {
          if (Rt.value) {
            const N = s.map((de) => de.id).filter((de) => typeof de == "number");
            if (Jc("restore")) {
              const { ops: de, summary: $e } = await $.restoreQueued(N);
              for (const Ee of de) ze.register(Ee);
              $e && et($e), tt.clear();
              return;
            }
            const Y = await $.restoreBatch(N);
            Yt({ message: Y.summary }, Y.failed ? bn : hi), tt.clear(), await zi();
            return;
          }
          if (!$.endpoints.restore) return;
          const g = s.map((N) => N.path), { restored: O } = await $.restore(g);
          et(z("toast.restored", { n: O })), tt.clear(), await kt();
        } catch (g) {
          Yt({ message: Zn(g) }, bn), H("error", { message: g.message, context: { op: "restore" } });
        } finally {
          Bh.value = !1;
        }
      }
    }
    function $d(o) {
      if (j.isVaultRow(o) && o.type === "file") {
        if (Nl(o, null, "view")) return;
        Ps(o);
        return;
      }
      if (Ui(o) && !an.value && !o.e2e_root) {
        Dt.open(o);
        return;
      }
      if (Gn.value && o.type === "file") {
        if (Nl(o, null, "view")) return;
        Ps(o);
        return;
      }
      Ha.value = "view", $i.value = null, hn.value = o, ca.value = !0, Ua(o);
    }
    function nC(o) {
      if (o.type === "dir") {
        const de = En.value ? Ao(o.path) : Va(o.path);
        kt(de);
        return;
      }
      if (Ui(o) && !an.value && !o.e2e_root) {
        Dt.open(o);
        return;
      }
      if (an.value) {
        Gn.value && Ps(o);
        return;
      }
      if (P.config.openInHost) {
        qa(o);
        return;
      }
      if (!oo(o)) {
        $d(o);
        return;
      }
      const s = (o.extension || "").toLowerCase(), g = P.config.openPageBase;
      if (!g) {
        qa(o);
        return;
      }
      const O = zk(g), N = O.includes("?") ? "&" : "?", Y = `${O}${N}path=${encodeURIComponent(o.path)}&type=${encodeURIComponent(s)}&mode=edit`;
      window.open(Y, "_blank", "noopener"), H("file-opened", { path: o.path, basename: o.basename }), Ua(o);
    }
    const Oi = S("selection"), Fh = S(""), zo = S([]), aC = S(""), iC = E(() => {
      const o = aa();
      return o.length === 0 ? "none" : o.length === 1 ? o[0].type === "dir" ? "single-dir" : "single-file" : "multi";
    });
    async function Uh(o) {
      const s = aa();
      if (o === "open") {
        s[0] && qa(s[0]);
        return;
      }
      await Pi(o, s);
    }
    const ci = E(() => P.config.desktopSync ?? null), Td = S([]);
    let ik = !1;
    async function cr() {
      if (!ci.value) return;
      const o = ik ? () => {
      } : iu.start();
      try {
        Td.value = await ci.value.kept(), ik = !0;
      } catch {
      } finally {
        o();
      }
    }
    const Ss = S(null);
    async function ok() {
      const o = ci.value;
      if (o != null && o.status)
        try {
          Ss.value = (await o.status()).active ?? null;
        } catch {
          Ss.value = null;
        }
    }
    let $s = null, Hh = !0;
    function oC() {
      $s || !Hh || ($s = setTimeout(() => {
        $s = null, Hh && (ok(), cr());
      }, 300));
    }
    qt(() => {
      var o, s;
      cr(), ok(), (s = (o = ci.value) == null ? void 0 : o.onChange) == null || s.call(o, oC);
    }), Ct(() => {
      Hh = !1, $s && (clearTimeout($s), $s = null);
    });
    function uu(o) {
      const s = String(o.path ?? "");
      return s.includes("://") ? s.replace(/\/+$/, "") : `${s}://`;
    }
    function Ad(o, s) {
      return s.endsWith("://") ? o.startsWith(s) && o !== s : o === s ? !1 : o.startsWith(s + "/");
    }
    function Kh(o) {
      return Td.value.some((s) => s.remote === o) ? "kept" : Td.value.some((s) => Ad(o, s.remote)) ? "inherited" : Td.value.some((s) => Ad(s.remote, o)) ? "partial" : "none";
    }
    function rk(o) {
      if (!ci.value || nn.value || o.basename === ".trash") return null;
      const s = uu(o), g = Ss.value;
      if (g && (s === g.remote || Ad(s, g.remote) || Ad(g.remote, s)))
        return "syncing";
      const O = Kh(s);
      return O === "kept" || O === "inherited" ? "kept" : O === "partial" ? "partial" : "cloud";
    }
    const rC = E(() => {
      const o = Ss.value;
      if (!o) return "";
      const s = o.remote.endsWith("://") ? o.remote.slice(0, -3) : o.remote.slice(o.remote.lastIndexOf("/") + 1);
      return o.phase === "transfer" && o.total > 0 ? z("keep.strip_transfer", {
        name: s,
        done: String(o.done),
        total: String(o.total),
        pct: String(Math.min(100, Math.round(o.done * 100 / o.total)))
      }) : o.phase === "settling" ? z("keep.strip_settling", { name: s }) : z("keep.strip_inventory", { name: s });
    }), sk = E(() => {
      const o = Ss.value;
      return !o || o.phase !== "transfer" || o.total <= 0 ? null : Math.min(100, Math.round(o.done * 100 / o.total));
    });
    function lk(o) {
      const s = o[0], g = String((s == null ? void 0 : s.storage) || (s == null ? void 0 : s.path) || ""), O = X4(g, P.config.storages, xt.value);
      return [
        ...W4(z, {
          manages: J4({ admin: ha.value, level: O }),
          shareUsers: Ts("share.users")
        }),
        ...uk(o)
      ];
    }
    function uk(o) {
      var N, Y, de;
      const s = ci.value, g = o.length === 1 && (((N = o[0]) == null ? void 0 : N.type) === "dir" || ((Y = o[0]) == null ? void 0 : Y.type) === "file");
      if (!s || !g || nn.value || an.value || ((de = o[0]) == null ? void 0 : de.e2e) === !0) return [];
      const O = Kh(uu(o[0]));
      return [
        { divider: !0, key: "sep-keep", label: "" },
        { key: "keep-local", label: z("ctx.keep_local"), hidden: O === "kept" || O === "inherited" },
        { key: "keep-online", label: z("ctx.keep_online"), hidden: O !== "kept" },
        { key: "keep-inherited", label: z("ctx.keep_inherited"), disabled: !0, hidden: O !== "inherited" },
        { key: "keep-reveal", label: z("ctx.keep_reveal"), hidden: O !== "kept" && O !== "inherited" }
      ];
    }
    const Vh = S([]);
    let Ed = 0;
    async function cu(o, s) {
      var O;
      const g = ++Ed;
      if (s.length > 0 && (dk.value, iu.count > 0 && typeof window < "u")) {
        const N = (Y) => {
          Y.type === "keydown" && Y.key !== "Escape" || g === Ed && Ed++;
        };
        window.addEventListener("pointerdown", N, !0), window.addEventListener("keydown", N, !0);
        try {
          await iu.settled(kse);
        } finally {
          window.removeEventListener("pointerdown", N, !0), window.removeEventListener("keydown", N, !0);
        }
      }
      g === Ed && ((O = zh.value) == null || O.show(o, s));
    }
    async function jh(o, s) {
      Oi.value = "selection", cr(), tt.has(o.path) || (tt.click(o.path), await Jt()), Vh.value = tt.nodes.value.length ? [] : [o];
      const g = tt.nodes.value.length ? tt.nodes.value : [o];
      await cu({ clientX: s.clientX, clientY: s.clientY }, g);
    }
    function sC(o) {
      o.preventDefault(), Oi.value = "selection", tt.clear(), Vh.value = [], cu({ clientX: o.clientX, clientY: o.clientY }, []);
    }
    function lC(o) {
      Oi.value = "breadcrumb", Fh.value = o.adapterPath, aC.value = o.label, cu({ clientX: o.x, clientY: o.y }, []);
    }
    async function ck(o, s, g) {
      if (cr(), o === "split") {
        pi.value = "split";
        const O = Wn.nodes.value;
        s && !Wn.has(s.path) && (Wn.click(s.path), await Jt());
        const N = Wn.nodes.value;
        zo.value = s ? N.length > 0 ? N : O.length > 0 ? O : [s] : [], Oi.value = "pane", await cu({ clientX: g.clientX, clientY: g.clientY }, zo.value);
        return;
      }
      if (pi.value = "main", Oi.value = "selection", !s) {
        tt.clear(), cu({ clientX: g.clientX, clientY: g.clientY }, []);
        return;
      }
      await jh(s, g);
    }
    const dk = E(() => {
      if (Oi.value === "breadcrumb")
        return [
          { key: "open", label: z("ctx.open") },
          { key: "copy-path", label: z("breadcrumb.copy_path") }
        ];
      if (Oi.value === "pane") {
        const Y = zo.value;
        return Y.length === 0 ? [
          { key: "new-folder", label: z("toolbar.new_folder") },
          { key: "paste", label: z("ctx.paste"), disabled: !ie.value.mode }
        ] : du(Y);
      }
      const o = tt.nodes.value.length ? tt.nodes.value : Vh.value, s = o.length > 0, g = o.length === 1;
      if (nn.value)
        return s ? [
          { key: "restore", label: z("ctx.restore"), hidden: !Ts("files.create") },
          ...Eo.value ? [
            { divider: !0, key: "sep1", label: "" },
            { key: "delete", label: z("ctx.delete_perm"), danger: !0, hidden: !Ts("files.purge") }
          ] : []
        ] : [];
      const O = (Le.value ?? "").replace(/^\/+|\/+$/g, "");
      if (En.value && O === "")
        return s ? g ? lk(o) : [] : [];
      if (!s) {
        const Y = [
          {
            key: "toggle-hidden",
            label: Wu.value ? z("ctx.hide_hidden") : z("ctx.show_hidden")
          }
        ];
        return au(Ie.value) ? [
          { key: "new-folder", label: z("toolbar.new_folder") },
          { key: "paste", label: z("ctx.paste"), disabled: !ie.value.mode },
          ...Y
        ] : Y;
      }
      return du(o);
    });
    function Ts(o) {
      const s = I.value;
      return !s || s.includes(o);
    }
    const uC = {
      rename: ["files.rename"],
      cut: ["files.move"],
      "move-to": ["files.move"],
      delete: ["files.delete"],
      download: ["files.download"],
      convert: ["files.create"],
      "copy-to": ["files.create"],
      paste: ["files.create", "files.move"],
      tags: ["files.tag"],
      /* wiring:e2 policy — the four rows that START an encryption make something,
         a key file or a `.fxe`, and the server asks files.create for that beside
         files.encrypt (backend perm.FilesEncrypt: "carved out of files.create,
         which the same write needs as well"). A place can allow the one and deny
         the other; the row is then hidden, not offered to be refused. */
      "fxe-encrypt": ["files.create"],
      "fxe-request": ["files.create"],
      "e2e-convert": ["files.create"],
      "e2e-request": ["files.create"]
    };
    function Cd(o) {
      return K4((s) => ou(s, o));
    }
    function cC(o, s) {
      if (!I.value || s.length > 0 && s.every((O) => j.isVaultRow(O))) return o;
      const g = s.map((O) => O.path);
      return o.map((O) => {
        if (O.key === "access") {
          const Y = s.length > 0 && s.every((de) => de.type === "dir");
          return V4(Cd(g), Y) ? O : { ...O, hidden: !0 };
        }
        const N = uC[O.key];
        return N && !N.some((Y) => ou(Y, g)) ? { ...O, hidden: !0 } : O;
      });
    }
    function dC(o, s) {
      return du(s).some((g) => g.key === o && !g.hidden && !g.disabled);
    }
    function du(o) {
      const s = cC(pC(o), o);
      return o.some(ES) ? s.map((g) => g.divider || g.key === "details" ? g : { ...g, disabled: !0 }) : s;
    }
    function fC(o) {
      var Y;
      const s = String(o[0].vault_root ?? ""), g = o.length === 1, O = g && o[0].type === "file", N = au(j.permOf(s)) && !((Y = j.strips[s]) != null && Y.readOnly) && ou("files.create", [s]) && ou("files.delete", [s]);
      return [
        { key: "preview", label: z("ctx.preview"), hidden: !g, disabled: !O },
        { key: "download", label: z("ctx.download"), disabled: o.length === 0 },
        { key: "details", label: z("ctx.details") },
        { divider: !0, key: "sep1", label: "", hidden: !N },
        { key: "rename", label: z("ctx.rename"), hidden: !g || !N },
        { key: "cut", label: z("ctx.cut"), hidden: !N },
        { key: "copy", label: z("ctx.copy") },
        { key: "paste", label: z("ctx.paste"), hidden: !N, disabled: !ie.value.mode },
        { divider: !0, key: "sep2", label: "", hidden: !N },
        { key: "delete", label: z("ctx.delete"), danger: !0, hidden: !N }
      ];
    }
    function pC(o) {
      var gn, Cn, Fi, Ga;
      if (o.length > 0 && o.every((Xd) => j.isVaultRow(Xd))) return fC(o);
      const s = o.length > 0, g = o.length === 1;
      if (o.some(nc))
        return g ? lk(o) : [];
      const O = g && ((gn = o[0]) == null ? void 0 : gn.type) === "file", N = z("ctx.tags_menu"), Y = g && qh(o[0]), de = g && typeof ((Cn = o[0]) == null ? void 0 : Cn.id) == "number", $e = ah(o).length > 0, Ee = sb(o), st = TE(o), Ze = au(st) && !Nb(o), Lt = z("shortcuts.share"), Pn = String(((Fi = o[0]) == null ? void 0 : Fi.extension) ?? "").toLowerCase(), Mt = O ? mv(Pn) ? zm(!!tr.value, ha.value, z("ctx.needs_onlyoffice")) : Pn === "drawio" || Pn === "dio" ? zm(!!Vl.value, ha.value, z("ctx.needs_drawio")) : {} : {}, Ya = ST(o, { canWrite: Ze, inEncrypted: an.value });
      return [
        { key: "open", label: z("ctx.open"), ...Mt, hidden: !g || Mt.hidden === !0 },
        { key: "open-tab", label: z("ctx.open_new_tab"), hidden: !g || ((Ga = o[0]) == null ? void 0 : Ga.type) !== "dir" },
        { key: "preview", label: z("ctx.preview"), hidden: !g, disabled: !O },
        /* tasi:m1 — Download works on ANY selection now. It used to disappear the
           moment a second row was ticked, because the only implementation was one
           `window.open` per node and the browser blocks the second popup; there is
           one streaming archive behind it now (lib/downloadSelection), and the
           server expands a selected folder itself, so a lone folder is a zip too.
           Inside an encrypted folder the server has no plaintext to zip: the zip
           is made in this tab (below), and a LOCKED folder downloads one row at
           a time. */
        /* wiring:e2 fxe — inside an unlocked encrypted folder a selection of any
           size downloads DECRYPTED now (a zip made in this tab); the ciphertext is
           "Download encrypted copy" below. */
        { key: "download", label: z("ctx.download"), hidden: !s || ku.value && !g, disabled: !s },
        /* wiring:e2 fxe — single encrypted files, and the ciphertext copy.
           wiring:e2 policy — "Encrypt with E2EE…" asks the answer for the file it
           would encrypt, and becomes "Request encryption…" under the approval
           policy (useE2eFiles menuRows). */
        ...Dt.menuRows(o, {
          canWrite: Ze,
          inEncrypted: an.value,
          unlockedEncryptedCopy: Gn.value || g && ww(o[0]) !== null,
          encryptAnswer: Ya ? Ch(Ya.path, "file") : void 0
        }),
        { key: "archive-create", label: z("ctx.archive_create"), hidden: !s || g && Y || !Ze || an.value || Yl.value.length === 0, disabled: !s },
        { key: "archive-extract", label: z("ctx.archive_extract"), hidden: !Y || !Ze || an.value, disabled: !Y },
        { key: "archive-extract-here", icon: "archive-extract", label: z("archive.extract_here"), hidden: !Y || !Ze || an.value, disabled: !Y },
        /* tasi:m1 — VISIBLE and grey above a multi-selection, not gone. Sharing
           really is one item at a time (a share link addresses one node), and the
           row now says so in its tooltip; vanishing taught the reader that filex
           cannot share the thing they are looking at. */
        {
          key: "access",
          label: Lt,
          hidden: !s || !Ze || kS(o, an.value),
          disabled: !g,
          title: g ? void 0 : z("ctx.access.one_only")
        },
        { key: "details", label: z("ctx.details"), hidden: !s },
        /* wiring:e2 convert — encrypt a folder that already exists, in place.
           wiring:e2 policy — offered where the policy lets this account encrypt
           that folder; where it wants an approval, the menu asks for one. */
        { key: "e2e-convert", label: z("e2e.convert.ctx"), icon: "lock", hidden: !vw(o, Ze, "allowed") },
        { key: "e2e-request", label: z("e2e.request.ctx"), icon: "lock", hidden: !vw(o, Ze, "request") },
        /* ⚠ "Copy node id" is NOT here any more (owner's call, 2026-09-13): it is a
           developer's handle on a support ticket, not an everyday verb, and this
           list is rendered by BOTH the right-click menu and the selection bar — so
           one row put it in front of everyone, twice. It lives in the details
           panel now, beside Path and ETag, which is where the other technical
           facts about a file already are. The `copy-id` case below stays: the
           panel dispatches it. */
        { divider: !0, key: "sep1", label: "", hidden: !Ze },
        { key: "rename", label: z("ctx.rename"), hidden: !g || !Ze, disabled: !g },
        { key: "cut", label: z("ctx.cut"), hidden: !s || !Ze, disabled: !s },
        { key: "copy", label: z("ctx.copy"), hidden: !s, disabled: !s },
        /* tasi:m1 — "somewhere else", without the clipboard. Cut+paste has always
           been able to do this, but only by navigating away from the rows you had
           just picked; these two ask WHERE in a dialog and leave the listing where
           it is.
           ⚠ `icon:` is not decoration here — `actionIconSvg` answers '' for a key
           it does not know, and a bar button with no glyph is an empty 28px box.
           They borrow the clipboard verbs' marks, which is what they are. */
        { key: "move-to", label: z("ctx.move_to"), icon: "cut", hidden: !s || !Ze, disabled: !s },
        { key: "copy-to", label: z("ctx.copy_to"), icon: "copy", hidden: !s, disabled: !s },
        /* Paste needs a destination folder; a virtual view (Recent / Starred /
           Shared / a tag / Home) has none, so it is the one write verb the row
           menu does not carry there — every per-row verb above and below does. */
        { key: "paste", label: z("ctx.paste"), hidden: !Ze || De.value, disabled: !ie.value.mode },
        { divider: !0, key: "sep-meta", label: "", hidden: !de && !$e },
        /* yildiz:s1 — "star must be an action, like a tag" (owner, v0.30.0).
           Beside Tags on purpose: they are the same kind of verb, and this is the
           ONLY star a grid/gallery user reaches with the keyboard. Works on a
           multi-selection; the label follows the selection's state. */
        {
          key: "star",
          label: z(Ee ? "ctx.unstar" : "ctx.star"),
          icon: Ee ? "unstar" : "star",
          hidden: !$e
        },
        { key: "tags", label: N, hidden: !de, disabled: !de },
        /* App plugins — one row per action whose `applies` rule accepts the
           selection, under its own `sep-plugins` divider; `[]` when the feature
           is off, in the trash, or inside an encrypted folder (lib/pluginMenu). */
        ...sA(o),
        ...mA(o),
        ...uk(o),
        { divider: !0, key: "sep2", label: "", hidden: !Ze },
        { key: "delete", label: z("ctx.delete"), danger: !0, hidden: !s || !Ze, disabled: !s }
      ];
    }
    const hC = /* @__PURE__ */ new Set(["zip", "7z", "rar", "tar", "gz", "tgz", "bz2", "tbz2", "xz", "txz"]);
    function qh(o) {
      return !!o && o.type === "file" && hC.has((o.extension || "").toLowerCase());
    }
    const mC = E(() => {
      const o = aa();
      if (On.value) return o.length ? du(o).filter((g) => g.key !== "archive-extract-here") : [];
      if (nn.value)
        return o.length === 0 ? [] : [
          { key: "restore", label: z("ctx.restore"), hidden: !Ts("files.create") },
          ...Eo.value ? [{ key: "delete", label: z("ctx.delete_perm"), danger: !0, hidden: !Ts("files.purge") }] : []
        ];
      const s = (Le.value ?? "").replace(/^\/+|\/+$/g, "");
      return En.value && s === "" ? o.length === 1 ? [{ key: "open", label: z("ctx.open") }] : [] : o.length === 0 ? [] : du(o).filter((g) => g.key !== "archive-extract-here");
    });
    async function vC(o, s) {
      if (Oi.value === "breadcrumb") {
        o.key === "open" ? kt(Va(Fh.value)) : o.key === "copy-path" && await Pd(Fh.value);
        return;
      }
      if (Oi.value === "pane") {
        await Pi(o.key, zo.value);
        return;
      }
      await Pi(o.key, s);
    }
    function di() {
      return Oi.value === "pane" || On.value;
    }
    async function Pi(o, s) {
      var g, O;
      if (SP(o)) {
        await eb(o, s);
        return;
      }
      if (o === "open-with-choose") {
        s[0] && (La.value = s[0]);
        return;
      }
      if (o.startsWith("open-with:")) {
        const N = s[0];
        if (N) {
          const Y = o.slice(10);
          $d(N), $i.value = Y, Y !== "builtin" && oo(N) && (Ha.value = "edit");
        }
        return;
      }
      if (bne(o)) {
        await Dt.dispatch(o, s, (N) => zd(N, { encrypted: !0 }));
        return;
      }
      switch (o) {
        case "clear-selection":
          On.value ? Wn.clear() : tt.clear();
          return;
        case "open":
          s[0] && nC(s[0]);
          break;
        case "preview":
          s[0] && $d(s[0]);
          break;
        case "e2e-convert":
          s[0] && qz(s[0]);
          break;
        case "e2e-request":
          s[0] && dm(s[0].path, "folder", s[0].basename);
          break;
        case "download":
          await zd(s);
          break;
        case "archive-create":
          if (s.length === 0) break;
          Wl.value = s, ss.value = di(), rs.value = ss.value ? It(((g = en.value) == null ? void 0 : g.getPath()) ?? "") : It(Le.value), Ai.value = "", Zc.value = !0;
          break;
        case "archive-extract":
          if (!s[0] || !qh(s[0])) break;
          $o.value = s[0], ss.value = di(), rs.value = ro(s[0].path), Ai.value = "", ir.value = !0;
          break;
        case "archive-extract-here":
          if (!s[0] || !qh(s[0])) break;
          $o.value = s[0], ss.value = di(), rs.value = ro(s[0].path), Ai.value = "", await Xh(s[0], rs.value, ss.value);
          break;
        case "move-to":
        case "copy-to":
          if (s.length === 0) break;
          Qc.value = o === "move-to" ? "move" : "copy", ed.value = s, td.value = !1, fs.value = !0;
          break;
        case "keep-local": {
          const N = ci.value;
          if (!N || !s[0]) break;
          const Y = uu(s[0]);
          try {
            await N.keep(Y, s[0].type === "file" ? "file" : "dir"), await cr(), Kh(Y) !== "none" && et(z("keep.started"));
          } catch (de) {
            await cr(), et(`${z("keep.failed")}: ${String((de == null ? void 0 : de.message) ?? de)}`);
          }
          break;
        }
        case "keep-online": {
          const N = ci.value;
          if (!N || !s[0]) break;
          try {
            await N.unkeep(uu(s[0]));
          } catch {
          }
          await cr();
          break;
        }
        case "keep-reveal": {
          const N = ci.value;
          N && s[0] && N.reveal(uu(s[0]));
          break;
        }
        case "access":
          s[0] && (si.value = s[0], lr.value = !0);
          break;
        case "storage-access":
          s[0] && (si.value = q4(s[0]), eu.value = "perms", lr.value = !0);
          break;
        case "details":
          WA();
          break;
        case "copy-id":
          if (s[0] && typeof s[0].id == "number") {
            const N = s[0].id;
            (O = navigator.clipboard) == null || O.writeText(String(N)).then(
              () => et(z("toast.node_id_copied", { id: N })),
              () => et(`#${N}`)
            );
          }
          break;
        case "star":
          await lb(s);
          break;
        case "tags":
          s[0] && kA(s[0]);
          break;
        case "rename":
          s[0] && (sr.value = s[0], Ei.value = di(), no.value = !0);
          break;
        case "cut":
          di() ? Wk() : (ie.value = { mode: "cut", items: s, sourcePath: Le.value }, et(z("toast.cut_ready")));
          break;
        case "copy":
          di() ? Yk() : (ie.value = { mode: "copy", items: s, sourcePath: Le.value }, et(z("toast.copy_ready")));
          break;
        case "paste":
          di() ? await Gk() : await fk();
          break;
        case "delete": {
          const N = di();
          N && (zo.value = s), Ei.value = N, ma.value = !0;
          break;
        }
        case "restore":
          s.length > 0 && await tC(s);
          break;
        case "toggle-hidden":
          Wb();
          break;
        case "new-folder":
          Ei.value = di(), ua.value = !0;
          break;
        case "duplicate":
          s[0] && await bC(s[0]);
          break;
        case "open-tab":
          s[0] && Nk(s[0]);
          break;
      }
    }
    function yC() {
      tt.isEmpty.value || (ie.value = { mode: "cut", items: tt.nodes.value, sourcePath: Le.value }, et(z("toast.cut")));
    }
    function gC() {
      tt.isEmpty.value || (ie.value = { mode: "copy", items: tt.nodes.value, sourcePath: Le.value }, et(z("toast.copied")));
    }
    let Wh = !1;
    async function fk() {
      const o = ie.value;
      if (!(!o.mode || o.items.length === 0 || Wh)) {
        Wh = !0;
        try {
          const s = o.items.map((Ee) => Ee.path), g = o.sourcePath || "";
          if (o.mode === "cut" && g === Le.value) {
            et(z("toast.same_folder_cut"));
            return;
          }
          const N = It(Le.value), Y = ow(s, N);
          if (Y === "cross") {
            et(z("e2e.vault.cross"));
            return;
          }
          if (Y === "inside") {
            (o.mode === "cut" ? await j.move(s, N) : await j.copy(s, N)) && o.mode === "cut" && (ie.value = { mode: null, items: [], sourcePath: null });
            return;
          }
          const de = w0(s, N, o.mode === "cut" ? "move" : "copy"), $e = await km(o.mode === "cut" ? "move" : "copy", s, N, It(g) || void 0);
          if ($e) {
            $e.undo && $e.ops.length && ft.set($e.ops[$e.ops.length - 1].id, { message: z("toast.moved"), fn: $e.undo }), $e.ops.length && et(o.mode === "cut" ? z("split.move_queued") : z("split.copy_queued")), ie.value = { mode: null, items: [], sourcePath: null };
            return;
          }
          if (o.mode === "cut") {
            const Ee = It(g) || void 0, st = await Zb(s, N), { op: Ze } = await $.moveAsync(s, N, Ee);
            Qb(Ze.id, s, N, Ee, st), ze.register(Ze), et(
              st ? z("toast.move_kept_both") : de.cross ? z("split.cross_move") : z("split.move_queued")
            );
          } else {
            const { op: Ee } = await $.copy(s, N);
            ze.register(Ee), et(de.cross ? z("split.cross_copy") : z("split.copy_queued"));
          }
          ie.value = { mode: null, items: [], sourcePath: null };
        } catch (s) {
          Bl(s, { op: "paste" });
        } finally {
          Wh = !1;
        }
      }
    }
    async function bC(o) {
      try {
        const { op: s } = await $.copy([o.path], It(Le.value));
        ze.register(s);
      } catch (s) {
        Bl(s, { op: "duplicate" });
      }
    }
    function kC(o) {
      if (j.isVaultRow(o)) {
        j.download([o]);
        return;
      }
      if (Gn.value) {
        Ez(o);
        return;
      }
      const s = $.downloadUrl(o.path);
      window.open(s, "_blank");
    }
    const Yh = S(!1);
    async function zd(o, s = {}) {
      if (o.length !== 0) {
        if (o.every((g) => j.isVaultRow(g))) {
          await j.download(o);
          return;
        }
        if (!(!s.encrypted && await aM(o))) {
          if (o.length === 1 && o[0].type === "file") {
            if (s.encrypted) {
              window.open($.downloadUrl(o[0].path), "_blank");
              return;
            }
            kC(o[0]);
            return;
          }
          if (!Yh.value) {
            Yh.value = !0, Yt({ message: z("toast.archive.preparing") }, df);
            try {
              const g = await qne($, o.map((N) => N.path)), O = o.length === 1 && o[0].e2e_stored ? `${o[0].basename}.zip` : g.name;
              et(z("toast.archive.started", { name: O, count: String(g.files) }));
            } catch (g) {
              const O = g;
              Yt({ message: O.status === 409 ? z("toast.archive.empty") : Zn(g) }, bn), H("error", { message: O.message, context: { op: "archive-download" } });
            } finally {
              Yh.value = !1;
            }
          }
        }
      }
    }
    async function wC(o) {
      var N;
      const s = ed.value;
      if (!o || s.length === 0) {
        fs.value = !1;
        return;
      }
      const g = Qc.value === "move", O = di() ? It(((N = en.value) == null ? void 0 : N.getPath()) ?? "") : It(Le.value);
      td.value = !0;
      try {
        const Y = await Ms(s.map(($e) => $e.path), o, O || void 0, g ? "move" : "copy"), de = Kt.segmentLabel(o) ?? cl(o, o);
        Y === "queued" ? et(g ? z("toast.moved_to", { name: de }) : z("toast.copied_to", { name: de })) : Y === "nothing" && et(z("toast.already_there", { name: de })), g && (Y === "queued" || Y === "done") && (di() ? Wn.clear() : tt.clear());
      } finally {
        td.value = !1, fs.value = !1;
      }
    }
    async function _C(o) {
      ql.value = !1;
      const s = o.app ? `${o.app.plugin}/${o.app.view}` : null;
      if (o.draft) {
        is.value += 1, fb(o.draft, s), sh();
        return;
      }
      const g = o.path.slice(0, o.path.lastIndexOf("/"));
      g && g !== It(Le.value) ? await kt(g) : await kt();
      const O = o.name.lastIndexOf("."), N = _e.value.find((Y) => Y.path === o.path) ?? {
        type: "file",
        path: o.path,
        basename: o.name,
        extension: O > 0 ? o.name.slice(O + 1).toLowerCase() : ""
      };
      if (sv(P.config, N) === "host") {
        H("file-opened", { path: N.path, basename: N.basename }), Ua(N);
        return;
      }
      ds.value = o.ext ? { path: N.path, ext: o.ext } : null, $i.value = s, hn.value = N, Ha.value = oo(N) ? "edit" : "view", ca.value = !0, H("file-opened", { path: N.path, basename: N.basename }), Ua(N);
    }
    function xC(o) {
      const s = o == null ? void 0 : o.detail;
      if (s)
        try {
          return JSON.parse(s).code;
        } catch {
          return;
        }
    }
    function Gh(o) {
      const s = o == null ? void 0 : o.detail;
      if (s)
        try {
          const g = JSON.parse(s), O = {
            PASSWORD_REQUIRED: "archive.password_required",
            BAD_PASSWORD: "archive.bad_password",
            TARGET_EXISTS: "archive.target_exists",
            PASSWORD_CHARSET: "archive.password_charset",
            UNSUPPORTED_FORMAT: "archive.error_unsupported",
            ARCHIVE_LIMIT_EXCEEDED: "archive.error_limit",
            PROVIDER_UNAVAILABLE: "archive.error_unavailable"
          };
          if (g.code && O[g.code]) return z(O[g.code]);
          if (g.error) return g.error;
        } catch {
        }
      return (o == null ? void 0 : o.message) || z("toast.failed");
    }
    async function SC(o) {
      lh.value = !0, Ai.value = "";
      try {
        const { op: s } = await $.archiveCreate({
          dest: ja(rs.value, o.name),
          sources: Wl.value.map((g) => g.path),
          format: o.format,
          password: o.password,
          encrypt_filenames: o.encrypt_filenames,
          compression: o.compression,
          solid: o.solid,
          dictionary_size_mb: o.dictionary_size_mb
        });
        ze.register(s), Zc.value = !1, mu.reveal(), et(z("archive.queued"));
      } catch (s) {
        Ai.value = Gh(s), H("error", { message: Ai.value, context: { op: "archive-create" } });
      } finally {
        lh.value = !1;
      }
    }
    async function Xh(o, s, g, O) {
      var de, $e;
      if (or.value.has(o.path)) {
        et(z("archive.already_preparing", { name: o.basename }));
        return;
      }
      or.value = new Set(or.value).add(o.path), Ai.value = "";
      const N = z("archive.preparing_extract", { name: o.basename }), Y = setTimeout(() => {
        !ir.value && !os.value && Yt({ message: N }, df);
      }, 600);
      try {
        const Ee = await $.archiveExtract(o.path, {
          dest: s,
          password: O
        });
        if (ir.value = !1, os.value = !1, rr.value = null, ls.value = "", Ee.op) {
          ze.register(Ee.op), mu.reveal(), et(z("archive.extraction_queued"));
          return;
        }
        g ? await ((de = en.value) == null ? void 0 : de.reload()) : await kt(), et(z("archive.extracted", { count: Ee.count ?? 0 }));
      } catch (Ee) {
        const st = xC(Ee);
        if (st === "PASSWORD_REQUIRED" || st === "BAD_PASSWORD") {
          rr.value = { target: o, dest: s, inPane: g }, ls.value = st === "BAD_PASSWORD" ? z("archive.bad_password") : "", ir.value = !1, os.value = !0;
          return;
        }
        const Ze = Gh(Ee);
        os.value ? ls.value = Ze : ir.value ? Ai.value = Ze : Yt({ message: Ze }, 6e3);
      } finally {
        clearTimeout(Y), (($e = va.value) == null ? void 0 : $e.message) === N && (va.value = null);
        const Ee = new Set(or.value);
        Ee.delete(o.path), or.value = Ee;
      }
    }
    async function $C(o) {
      const s = $o.value;
      s && await Xh(
        s,
        ja(rs.value, o.folder),
        ss.value
      );
    }
    async function TC(o) {
      const s = rr.value;
      s && (ls.value = "", await Xh(s.target, s.dest, s.inPane, o));
    }
    function AC() {
      os.value = !1, rr.value = null, ls.value = "";
    }
    async function EC(o) {
      try {
        await $.opsCancel(o), await ze.poll();
      } catch (s) {
        const g = ze.ops.value.find((N) => N.id === o), O = (g == null ? void 0 : g.op_type) === "archive-create" || (g == null ? void 0 : g.op_type) === "archive-extract";
        Yt({ message: O ? Gh(s) : Zn(s, z("plugin.cancel_failed")) }, bn);
      }
    }
    async function CC(o) {
      var O, N;
      const s = cs.begin();
      if (s === null) return;
      const g = Ei.value;
      try {
        const Y = It(g ? ((O = en.value) == null ? void 0 : O.getPath()) ?? "" : Le.value);
        if (j.rootOf(Y)) {
          await j.mkdir(Y, o) && (ua.value = !1, cs.end(s));
          return;
        }
        await pk(Y, o), ua.value = !1, cs.end(s), g ? await ((N = en.value) == null ? void 0 : N.reload()) : await kt();
      } catch (Y) {
        Fl(cs, s, Y, { op: "newfolder" });
      } finally {
        cs.end(s);
      }
    }
    async function pk(o, s) {
      const g = Ty(await fw(o, s, { isDir: !0 }));
      return await $.newFolder(o, g), ja(o, g);
    }
    async function zC(o) {
      var N, Y;
      const s = sr.value;
      if (!s) return;
      const g = us.begin();
      if (g === null) return;
      const O = Ei.value;
      try {
        const de = It(O ? ((N = en.value) == null ? void 0 : N.getPath()) ?? "" : Le.value), $e = s.path;
        if (j.rootOf($e)) {
          await j.rename($e, o) && (no.value = !1, sr.value = null, us.end(g));
          return;
        }
        const Ee = wf(s), st = await fw(
          ro($e),
          o,
          s.type === "dir" ? { keepIdOf: $e } : {}
        ), Ze = s.type === "dir" && Jc("rename");
        let Lt;
        Ze ? Lt = (await $.renameQueued(de, $e, st)).op : await $.rename(de, $e, st), no.value = !1, sr.value = null, us.end(g);
        const Pn = ja(ro($e), st), Mt = st && st !== Ee ? async () => {
          if (!Ze) {
            await $.rename(de, Pn, Ee);
            return;
          }
          const Ya = (await $.renameQueued(de, Pn, Ee)).op;
          return Ya && ze.register(Ya), { queued: !0 };
        } : null;
        if (Lt) {
          Mt && ft.set(Lt.id, { message: z("toast.renamed"), fn: Mt }), ze.register(Lt), et(z("toast.rename_queued", { name: o }));
          return;
        }
        O ? await ((Y = en.value) == null ? void 0 : Y.reload()) : await kt(), Mt && md(z("toast.renamed"), Mt);
      } catch (de) {
        const $e = de, Ee = de instanceof dw ? z("e2e.names.bad_name", { name: o }) : $e.status === 409 ? z("newdoc.err.exists", { name: o }) : Zn(de);
        Fl(us, g, de, { op: "rename" }, Ee);
      } finally {
        us.end(g);
      }
    }
    const As = S(/* @__PURE__ */ new Set()), Jh = /* @__PURE__ */ new Map();
    function fu(o, s) {
      const g = new Set(As.value);
      for (const O of o)
        s ? g.add(O) : g.delete(O);
      As.value = g;
      for (const O of _e.value) {
        const N = O.id, Y = O.extra_metadata;
        typeof N == "number" && o.includes(N) && Y && (Y.purging = s);
      }
    }
    async function MC() {
      const o = tt.nodes.value.map((Ee) => Ee.id).filter((Ee) => typeof Ee == "number");
      if (o.length === 0) {
        ma.value = !1;
        return;
      }
      const s = o.filter((Ee) => !As.value.has(Ee));
      if (s.length === 0) {
        ma.value = !1, et(z("trash.row_busy"));
        return;
      }
      const g = $a.begin();
      if (g === null) return;
      const O = Jc("purge");
      fu(s, !0);
      let N;
      try {
        N = await $.purgeBatch(s, { queued: O });
      } catch (Ee) {
        fu(s, !1), $a.end(g), Fl($a, g, Ee, { op: "purge" });
        return;
      }
      $a.end(g);
      const Y = N.ops ?? [];
      Y.length === 0 && fu(s, !1);
      const de = (Ee) => {
        var st;
        return (st = _e.value.find((Ze) => Ze.id === Ee)) == null ? void 0 : st.storage_id;
      }, $e = /* @__PURE__ */ new Set();
      for (const Ee of Y) {
        ze.register(Ee);
        const st = Ee.storage_id, Ze = Y.length === 1 ? s : s.filter((Lt) => de(Lt) === st);
        for (const Lt of Ze) $e.add(Lt);
        Jh.set(Ee.id, Ze);
      }
      if (Y.length > 1 && fu(s.filter((Ee) => !$e.has(Ee)), !1), N.done === 0) {
        Fl($a, g, new Error(N.summary), { op: "purge" }, N.summary);
        return;
      }
      ma.value = !1, tt.clear(), Yt({ message: N.summary }, N.failed ? bn : hi), Y.length === 0 && Rt.value && await zi();
    }
    async function OC() {
      var $e, Ee, st;
      if ($a.busy.value) return;
      if (Rt.value) {
        if (!Eo.value) {
          ma.value = !1, et(z("toast.trash_retention"));
          return;
        }
        await MC();
        return;
      }
      const o = Ei.value, s = o ? zo.value : tt.nodes.value, g = It(o ? (($e = en.value) == null ? void 0 : $e.getPath()) ?? "" : Le.value), O = s.map((Ze) => Ze.path);
      if (O.length === 0) {
        ma.value = !1;
        return;
      }
      if (j.rootOf(O[0])) {
        const Ze = $a.begin();
        if (Ze === null) return;
        try {
          await j.remove(O) && (ma.value = !1, o || tt.clear());
        } finally {
          $a.end(Ze);
        }
        return;
      }
      const N = s.map((Ze) => Ze.id).filter((Ze) => typeof Ze == "number"), Y = $.endpoints.trashRestore && N.length === s.length ? async () => {
        const Ze = await $.restoreBatch(N);
        if (Ze.done === 0) throw new Error(Ze.summary);
        return { summary: Ze.summary };
      } : null, de = $a.begin();
      if (de !== null)
        try {
          if ($.endpoints.deleteAsync) {
            const { op: Ze } = await $.deleteAsync(O, g);
            Y && ft.set(Ze.id, { message: z("toast.trashed"), fn: Y }), ze.register(Ze), et(z("toast.delete_queued")), ma.value = !1, $a.end(de);
          } else
            await $.deleteItems(g, O), ma.value = !1, $a.end(de), o ? await ((Ee = en.value) == null ? void 0 : Ee.reload()) : await kt(), Y && md(z("toast.trashed"), Y);
          o ? (st = en.value) == null || st.reload() : tt.clear();
        } catch (Ze) {
          Fl($a, de, Ze, { op: "delete" });
        } finally {
          $a.end(de);
        }
    }
    function Mo() {
      var o;
      if (!li.value) {
        et(z("toast.read_only_here"));
        return;
      }
      (o = hb.value) == null || o.click();
    }
    function PC(o) {
      const s = o.target, g = s.files ? Array.from(s.files) : [];
      s.value = "", Zh(g);
    }
    async function Zh(o, s, g = {}) {
      if (o.length === 0) return;
      const O = s ?? It(Le.value);
      if (j.rootOf(O)) {
        if (!j.isOpen(j.rootOf(O))) {
          et(z("e2e.upload.locked"));
          return;
        }
        await j.upload(O, o);
        return;
      }
      if (ku.value) {
        et(z("e2e.upload.locked"));
        return;
      }
      if (Gn.value) {
        const N = await Cz(o, O);
        if (o = N.files, o.length === 0) return;
        if (N.sidecars.length > 0)
          try {
            await $.uploadMultipart(O, N.sidecars);
          } catch (Y) {
            H("error", { message: Y.message, context: { op: "e2e-name-sidecar" } }), et(z("e2e.names.write_failed"));
            return;
          }
      }
      for (const N of o) {
        const Y = Zk.get(N);
        if (Y) {
          await Qh(N, O, Y) || et(z("e2e.upload.streaming_unsupported"));
          continue;
        }
        if (yt.shouldChunk(N)) {
          const de = yt.resumableFor(O, N);
          if (de && et(
            z("upload.resuming", {
              name: dr.get(N) ?? N.name,
              percent: N.size > 0 ? Math.round(de.offset / N.size * 100) : 0
            })
          ), await Qh(N, O)) continue;
        }
        await mk(N, O);
      }
      g.reload !== !1 && await kt();
    }
    function hk() {
      return an.value ? `${Ot.value}|${Gn.value ? "open" : "locked"}` : "";
    }
    async function DC(o, s) {
      const g = hk(), O = await Zne(o);
      for (const de of O.unreadable) et(z("upload.failed", { name: de }));
      if (O.dirs.length === 0) {
        await Zh(O.files.map((de) => de.file), s);
        return;
      }
      const N = j.rootOf(s);
      if (N) {
        if (!j.isOpen(N)) {
          et(z("e2e.upload.locked"));
          return;
        }
        const de = O.files.map(({ file: $e, dir: Ee }) => Ee ? tae($e, `${Ee}/${$e.name}`) : $e);
        de.length > 0 && await j.upload(s, de);
        for (const $e of Qne(O)) {
          const Ee = $e.lastIndexOf("/");
          await j.mkdir(Ee === -1 ? s : ja(s, $e.slice(0, Ee)), $e.slice(Ee + 1));
        }
        return;
      }
      if (ku.value) {
        et(z("e2e.upload.locked"));
        return;
      }
      const Y = (de) => hk() === g ? de() : Promise.reject(new Error("the encrypted folder was left during the upload"));
      await eae(O, s, {
        mkdir: (de, $e) => Y(() => pk(de, $e)),
        upload: (de, $e) => Y(() => Zh(de, $e, { reload: !1 })),
        failed: (de, $e) => {
          et(z("upload.failed", { name: de })), H("error", { message: $e.message, context: { op: "upload", file: de } });
        }
      }), await kt();
    }
    async function mk(o, s) {
      const g = il(), O = s ?? It(Le.value);
      qn.value = [
        ...qn.value,
        { id: g, file: o, displayName: dr.get(o), path: O, totalBytes: o.size, uploadedBytes: 0, percent: 0, status: "uploading", cancel() {
        } }
      ];
      const N = (Y) => {
        const de = qn.value.findIndex((Ee) => Ee.id === g);
        if (de === -1) return;
        const $e = [...qn.value];
        $e[de] = { ...$e[de], ...Y }, qn.value = $e;
      };
      try {
        await $.uploadMultipart(O, [o], (Y) => {
          N({ percent: Y, uploadedBytes: Math.round(Y / 100 * o.size) }), H("upload-progress", { uploadId: g, percent: Y, done: Y >= 100 });
        }), N({ percent: 100, uploadedBytes: o.size, status: "done" }), H("upload-progress", { uploadId: g, percent: 100, done: !0 });
      } catch (Y) {
        const de = Y.message;
        N({ status: "error", error: de }), et(z("upload.failed", { name: o.name })), H("error", {
          message: de,
          context: { op: "upload", file: o.name }
        });
      }
    }
    async function Qh(o, s, g) {
      const O = il();
      let N = !1;
      const Y = ($e) => {
        if (!N) {
          qn.value = [...qn.value, { ...$e, id: O, displayName: dr.get(o) }], N = !0;
          return;
        }
        const Ee = qn.value.findIndex((st) => st.id === O);
        if (Ee !== -1) {
          const st = [...qn.value];
          st[Ee] = { ...$e, id: O, displayName: dr.get(o) }, qn.value = st;
        }
      }, de = s ?? It(Le.value);
      try {
        return await yt.uploadFile({
          path: de,
          file: o,
          source: g,
          onProgress: ($e) => {
            !N && $e.status !== "uploading" && $e.uploadedBytes <= 0 || (Y($e), H("upload-progress", {
              uploadId: $e.uploadId ?? O,
              percent: $e.percent,
              done: $e.status === "done"
            }));
          }
        }), !0;
      } catch ($e) {
        if (Oy($e))
          return N && (qn.value = qn.value.filter((st) => st.id !== O)), !1;
        const Ee = $e.message;
        return N || (qn.value = [
          ...qn.value,
          {
            id: O,
            file: o,
            displayName: dr.get(o),
            path: de,
            totalBytes: o.size,
            uploadedBytes: 0,
            percent: 0,
            status: "error",
            error: Ee,
            cancel() {
            }
          }
        ], N = !0), et(z("upload.failed", { name: dr.get(o) ?? o.name })), H("error", { message: Ee, context: { op: "upload", file: o.name } }), !0;
      }
    }
    const Oo = S(0), Po = S(!1);
    function em(o) {
      const s = o.dataTransfer;
      if (!s || s.types && s.types.includes(wse) || gc()) return !1;
      if (s.items && s.items.length > 0) {
        let g = !1;
        for (const O of Array.from(s.items))
          if (O.kind === "file") {
            g = !0;
            break;
          }
        return g;
      }
      return s.types ? s.types.includes("Files") : !1;
    }
    function LC(o) {
      em(o) && (o.preventDefault(), Oo.value++, Po.value = !0);
    }
    function RC() {
      Oo.value = Math.max(0, Oo.value - 1), Oo.value === 0 && (Po.value = !1);
    }
    function NC(o) {
      if (ti(o)) {
        o.preventDefault();
        return;
      }
      em(o) && o.preventDefault();
    }
    function IC(o) {
      if (ti(o)) {
        const g = sy(o) || "", O = It(Le.value), N = Af(o);
        if (N && g && O && g !== O && !Rt.value && li.value) {
          o.preventDefault(), Oo.value = 0, Po.value = !1, $r(), Es(), Ms(N.map((Y) => Y.path), O, g);
          return;
        }
      }
      if (ti(o)) {
        Oo.value = 0, Po.value = !1, $r(), Es();
        return;
      }
      if (!em(o)) {
        Oo.value = 0, Po.value = !1;
        return;
      }
      if (o.preventDefault(), Oo.value = 0, Po.value = !1, !li.value) {
        et(z("toast.read_only_here"));
        return;
      }
      const s = Yne(o.dataTransfer);
      s.length !== 0 && DC(s, It(Le.value));
    }
    function vk(o) {
      var s;
      (s = o.dataTransfer) != null && s.types.includes("Files") && o.preventDefault();
    }
    function yk(o) {
      const s = Mn.value, g = o.target;
      s && g && !s.contains(g) && o.preventDefault();
    }
    qt(() => {
      var o, s;
      window.addEventListener("dragover", vk), window.addEventListener("drop", yk), window.addEventListener("pointerup", Md), window.addEventListener("blur", Md), (s = (o = fi.value) == null ? void 0 : o.onProgress) == null || s.call(o, (g) => {
        var N;
        if (!g) return;
        const O = qj(g, { quiet: am, stoppable: !!((N = fi.value) != null && N.stop), t: z });
        if (O) {
          if (O.kind === "flash") {
            const Y = g.error && g.error !== "cancelled" ? bn : hi;
            S0(va.value, "drag-out", "end") ? (ks = null, Yt({ message: O.message, source: "drag-out" }, Y)) : ks = { message: O.message, ms: Y };
            return;
          }
          S0(va.value, "drag-out", "hold") && (ks = null, Yt(
            O.stoppable ? {
              message: O.message,
              actionLabel: z("dragout.stop"),
              action: () => {
                var Y, de;
                return (de = (Y = fi.value) == null ? void 0 : Y.stop) == null ? void 0 : de.call(Y);
              },
              after: { kind: "plain", running: z("dragout.stopping"), done: z("dragout.stopped") },
              source: "drag-out"
            } : { message: O.message, source: "drag-out" },
            df
          ));
        }
      });
    });
    function Md() {
      gc() && $r();
    }
    function Es() {
      var o;
      (o = fi.value) != null && o.cancel && Promise.resolve(fi.value.cancel()).catch(() => {
      });
    }
    Ct(() => {
      window.removeEventListener("dragover", vk), window.removeEventListener("drop", yk), window.removeEventListener("hashchange", ak), window.removeEventListener("pointerup", Md), window.removeEventListener("blur", Md);
    });
    const tm = E(() => {
      const o = new Set(ie.value.mode === "cut" ? ie.value.items.map((s) => s.path) : []);
      if (Rt.value && As.value.size)
        for (const s of _e.value) {
          const g = s.id;
          typeof g == "number" && As.value.has(g) && o.add(s.path);
        }
      return o;
    });
    function gk(o, s, g) {
      (o === "split" ? Wn : tt).click(s.path, g);
    }
    function bk(o, s, g) {
      var $e;
      if (!g.dataTransfer) return;
      if (s.basename === ".trash") {
        g.preventDefault();
        return;
      }
      const O = o === "split" ? Wn.nodes.value : tt.nodes.value, N = It(o === "split" ? (($e = en.value) == null ? void 0 : $e.getPath()) ?? "" : Le.value), de = (O.some((Ee) => Ee.path === s.path) ? O : [s]).filter((Ee) => !tm.value.has(Ee.path)).filter((Ee) => Ee.basename !== ".trash");
      de.length !== 0 && kk(g, de, N, s.mime_type, um(o));
    }
    function kk(o, s, g, O, N) {
      const Y = Y1(s, { inEncryptedFolder: N });
      if (Y) {
        if (fi.value) {
          o.preventDefault(), g !== null && Uj(Y, g), Promise.resolve(fi.value.start(Y)).catch((de) => {
            $r(), Es(), H("error", { message: de.message, context: { op: "drag-out" } });
          }), Ak(Y);
          return;
        }
        if (Y.length === 1 && Y[0] && o.dataTransfer) {
          const de = Y[0], $e = Zm(P.config.auth) ? $.downloadUrl(de.path) : _k.take(de.path), Ee = $e ? Kj(de, $e, O) : null;
          Ee && o.dataTransfer.setData("DownloadURL", Ee);
        }
      }
    }
    const wk = S(!0), _k = jj((o) => Kne($, o), {
      onUnsupported: () => {
        wk.value = !1;
      }
    }), xk = E(() => !fi.value && !Zm(P.config.auth));
    function Sk(o) {
      !o || !xk.value || nn.value || _k.warm(o);
    }
    function Od(o) {
      if (o.pointerType === "touch" || !xk.value) return;
      const s = o.target, g = s && typeof s.closest == "function" ? s.closest("[data-fe-path]") : null, O = g == null ? void 0 : g.getAttribute("data-fe-path");
      if (!O) return;
      const N = _e.value.find((Y) => Y.path === O) ?? vu.value.find((Y) => Y.path === O);
      N && G1(N) && Sk(N.path);
    }
    qt(() => {
      var o, s;
      (o = Mn.value) == null || o.addEventListener("pointerover", Od, { passive: !0 }), (s = Mn.value) == null || s.addEventListener("pointerdown", Od, { capture: !0, passive: !0 });
    }), Ct(() => {
      var o, s;
      (o = Mn.value) == null || o.removeEventListener("pointerover", Od), (s = Mn.value) == null || s.removeEventListener("pointerdown", Od, { capture: !0 });
    });
    const fi = E(() => P.config.dragOut ?? null), $k = S(""), nm = S(!1);
    let am = !1, Tk;
    Xe(
      () => tt.selected.value,
      () => {
        if (!fi.value) return;
        clearTimeout(Tk);
        const o = tt.nodes.value;
        if (o.length === 0 || o.length > xse || o.some((O) => O.type !== "file")) return;
        const s = Y1(o, { inEncryptedFolder: an.value });
        !s || o.reduce((O, N) => O + (N.size ?? 0), 0) > _se || (Tk = setTimeout(() => void Ak(s, !0), 400));
      },
      { deep: !0 }
    );
    async function Ak(o, s = !1) {
      const g = fi.value;
      if (!g || nm.value) return;
      const O = Vj(o);
      if (O !== $k.value) {
        nm.value = !0, am = s;
        try {
          const N = await g.prepare(o);
          N != null && N.ready ? ($k.value = O, s || et(z("dragout.ready"))) : N != null && N.error && !s && et(N.error);
        } catch (N) {
          H("error", { message: N.message, context: { op: "drag-out-prepare" } });
        } finally {
          nm.value = !1, am = !1;
        }
      }
    }
    async function BC(o, s, g, O) {
      try {
        const N = O ?? It(Le.value), Y = await km("move", o, s, N);
        if (Y)
          return Y.undo && Y.ops.length && ft.set(Y.ops[Y.ops.length - 1].id, { message: z("toast.moved"), fn: Y.undo }), Y.ops.length && et(z("split.move_queued")), tt.clear(), "queued";
        const de = await Zb(o, s);
        if ($.endpoints.moveAsync) {
          const { op: $e } = await $.moveAsync(o, s, N);
          Qb($e.id, o, s, N, de), ze.register($e), et(z(de ? "toast.move_kept_both" : "split.move_queued"));
        } else if (await $.move(N, o, s), await kt(), de)
          et(z("toast.move_kept_both"));
        else {
          const $e = o.map((Ee) => ja(s, Mi(Ee)));
          md(z("toast.moved"), async () => {
            await $.move(s, $e, N);
          });
        }
        return tt.clear(), $.endpoints.moveAsync ? "queued" : "done";
      } catch (N) {
        return Bl(N, { op: g, targetDir: s }), "refused";
      }
    }
    async function Ek(o, s) {
      if (o.type !== "dir") return;
      const g = Af(s);
      if (!g || g.length === 0) return;
      $r(), Es();
      const O = o.path, N = g.map((Y) => Y.path).filter((Y) => Y && Y !== O && !O.startsWith(Y + "/") && !Lh(ro(Y), O));
      N.length !== 0 && await Ms(N, O, Xk(s));
    }
    async function Ck(o, s) {
      const g = Af(s);
      if (!g || g.length === 0) return;
      $r(), Es();
      const O = o, N = g.map((Y) => Y.path).filter((Y) => Y && Y !== O && !O.startsWith(Y + "/") && !Lh(ro(Y), O));
      N.length !== 0 && await Ms(N, O, Xk(s));
    }
    function FC(o) {
      o.cancel();
    }
    function UC(o) {
      qn.value = qn.value.filter((s) => s.id !== o.id);
    }
    function HC(o) {
      if (En.value && !o) {
        kt("");
        return;
      }
      if (En.value) {
        kt(Ao(o));
        return;
      }
      kt(Va(o));
    }
    async function Pd(o) {
      try {
        await navigator.clipboard.writeText(o), et(z("breadcrumb.copy_path"));
      } catch {
      }
    }
    function Qn(o = {}) {
      return $.authHeaders({ ...o });
    }
    function zk(o) {
      if (/^[a-z][a-z0-9+.-]*:\/\//i.test(o)) return o;
      const s = P.config.apiBase;
      if (!s) return o;
      try {
        return new URL(o, s.endsWith("/") ? s : `${s}/`).toString();
      } catch {
        return o;
      }
    }
    const Mk = E(
      () => P.config.viewerBaseUrl ? zk(P.config.viewerBaseUrl) : gy(P.config.apiBase, Sse)
    ), Dd = S(!1), { themeId: Ld, setTheme: KC } = yJ(), { themeMode: pu, setThemeMode: Ok } = bJ(), An = E(
      () => pu.value === "host" ? P.config.theme || "auto" : pu.value
    );
    F4({ locale: W, theme: An });
    const VC = Ml(), im = E(
      () => An.value === "dark" || An.value !== "light" && VC.value
    );
    Xe(
      [Ld, im, Mn],
      () => {
        $J(Ld.value), Mn.value && kJ(Mn.value, Ld.value, im.value);
      },
      { immediate: !0 }
    );
    const hu = S(!1), so = S(!1), Di = S(null);
    function jC() {
      if (so.value) {
        so.value = !1;
        return;
      }
      const o = tt.nodes.value, s = o.length === 1 ? o[0] : null;
      if (!(!s || s.type !== "file" || s.basename === ".trash")) {
        if (Ui(s) && !an.value && !s.e2e_root) {
          Dt.open(s);
          return;
        }
        if (an.value) {
          if (!Gn.value) return;
          (async () => {
            try {
              await Vd(s);
            } catch {
              et(z("e2e.decrypt_failed"));
              return;
            }
            Di.value = s, so.value = !0, Ua(s);
          })();
          return;
        }
        Di.value = s, so.value = !0, Ua(s);
      }
    }
    function qC(o) {
      const s = _e.value.filter((Y) => Y.type === "file");
      if (s.length === 0) return;
      const g = Di.value;
      let O = g ? s.findIndex((Y) => Y.path === g.path) : -1;
      O = O === -1 ? o > 0 ? 0 : s.length - 1 : (O + o + s.length) % s.length;
      const N = s[O];
      !N || N.path === (g == null ? void 0 : g.path) || tt.click(N.path);
    }
    function WC() {
      const o = Di.value;
      so.value = !1, o && qa(o);
    }
    Xe(
      () => tt.nodes.value,
      (o) => {
        var g, O;
        if (!so.value) return;
        const s = o.length === 1 && o[0].type === "file" ? o[0] : null;
        if (s && s.path !== ((g = Di.value) == null ? void 0 : g.path) && Gn.value) {
          (async () => {
            try {
              await Vd(s);
            } catch {
            }
            Di.value = s, Ua(s);
          })();
          return;
        }
        s && s.path !== ((O = Di.value) == null ? void 0 : O.path) && (Di.value = s, Ua(s));
      }
    );
    const mu = MZ();
    function YC(o) {
      qn.value = qn.value.filter((O) => O.id !== o.id);
      const s = o.file, g = o.path || It(Le.value);
      (async () => {
        if (yt.shouldChunk(s) && await Qh(s, g)) {
          await kt();
          return;
        }
        await mk(s, g), await kt();
      })();
    }
    const Rd = S(!1);
    let Nd;
    function om() {
      Rd.value = !0;
    }
    function GC() {
      var o;
      Rd.value = !1, fT(), (o = Mn.value) == null || o.focus();
    }
    function Pk() {
      om();
    }
    qt(() => {
      var o;
      (o = Mn.value) == null || o.addEventListener("fe:tour-restart", Pk), Nd = LZ(() => {
        Rd.value || om();
      });
    }), Ct(() => {
      var o;
      Nd == null || Nd(), (o = Mn.value) == null || o.removeEventListener("fe:tour-restart", Pk);
    });
    function XC() {
      return _d() === "none" ? null : Se ? `${R0}:${Se}` : R0;
    }
    const Kn = Tte({ storageKey: XC() }), JC = Kn.restore(), rm = Kn.activeId, lo = E(() => {
      var o;
      return ((o = Kn.activeTab.value) == null ? void 0 : o.split) ?? null;
    });
    function ZC(o) {
      const s = (o || "").replace(/^\/+|\/+$/g, ""), g = Zf(s.split("/").pop() || s, z);
      if (g) return g;
      if (!s) return En.value ? z("breadcrumb.root") : _t.value || z("breadcrumb.root");
      const O = Kt.segmentLabel(It(s));
      return O !== null ? O : s.split("/").pop() || s;
    }
    const Dk = E(
      () => Kn.tabs.value.map((o) => ({ id: o.id, label: ZC(o.path), split: !!o.split }))
    ), Lk = E(
      () => (
        /* gezinti:g1 — the simple profile has no tab strip at all, not even once a
           second tab exists: tabs were the first thing #14 named as power-user
           chrome. The tab STATE is untouched, so switching the profile back brings
           the strip and its tabs straight back. */
        !Gl.value && (Kn.hasMultiple.value || P.config.tabStrip !== "auto" && Dk.value.length > 0)
      )
    );
    Xe(Le, (o) => Kn.syncActive({ path: o })), Xe(xe, (o) => Kn.syncActive({ viewMode: o })), qt(() => {
      JC || Kn.seed(Le.value ?? "", xe.value);
    });
    function Id(o) {
      !jn.value && o.viewMode && o.viewMode !== xe.value && (xe.value = o.viewMode);
      const s = () => mn(zn.value);
      if (o.path === ".trash") {
        zi().then(s, s);
        return;
      }
      kt(o.path).then(s, s);
    }
    function QC(o) {
      const s = Kn.activate(o);
      s && Id(s);
    }
    function sm() {
      Kn.openTab(Le.value ?? "", { viewMode: xe.value, background: !1 });
    }
    function Rk(o) {
      const s = Kn.closeTab(o);
      s && Id(s);
    }
    function ez() {
      const o = Kn.step(1);
      o && Id(o);
    }
    function tz() {
      const o = Kn.step(-1);
      o && Id(o);
    }
    function Nk(o) {
      if (o.type !== "dir" || o.basename === ".trash") return;
      const s = En.value ? Ao(o.path) : Va(o.path);
      Kn.openTab(s, { viewMode: xe.value, background: !0 });
    }
    function Ik(o) {
      if (o.button !== 1) return;
      const s = o.target, g = s && typeof s.closest == "function" ? s.closest("[data-fe-path]") : null, O = g == null ? void 0 : g.getAttribute("data-fe-path");
      if (!O) return;
      const N = _e.value.find((Y) => Y.path === O);
      !N || N.type !== "dir" || N.basename === ".trash" || (o.preventDefault(), Nk(N));
    }
    function Bk(o) {
      if (o.button !== 1) return;
      const s = o.target;
      s && typeof s.closest == "function" && s.closest("[data-fe-path]") && o.preventDefault();
    }
    qt(() => {
      var o, s;
      (o = Mn.value) == null || o.addEventListener("auxclick", Ik), (s = Mn.value) == null || s.addEventListener("mousedown", Bk);
    }), Ct(() => {
      var o, s;
      (o = Mn.value) == null || o.removeEventListener("auxclick", Ik), (s = Mn.value) == null || s.removeEventListener("mousedown", Bk);
    });
    const nz = S(null), en = S(null), vu = S([]), Wn = i_(
      () => {
        var o;
        return vu.value.length ? vu.value : ((o = en.value) == null ? void 0 : o.visibleNodes()) ?? [];
      }
    ), yu = S({ ...Ko }), az = E(() => {
      var N;
      if (!jn.value) return "";
      const o = String(((N = en.value) == null ? void 0 : N.getPath()) ?? "").replace(/^\/+|\/+$/g, "");
      if (!o) return "";
      const [s, ...g] = o.split("/"), O = (P.config.storages ?? []).find((Y) => Y.name === s);
      return O_((O == null ? void 0 : O.uid) || s, g.join("/"));
    }), iz = E(
      () => Lk.value || vb.value || gu.value
    ), Bd = E(() => gt.value === "home" ? "home" : gt.value === "drafts" ? "drafts" : oe.value && _e.value.length === 0 ? "" : we.value ? "notfound" : ee.value && _e.value.length === 0 ? "" : ku.value ? "locked" : ""), gu = E(() => !Ta.value && !Gl.value), Cs = E(
      () => !!lo.value && gu.value
      /* gezinti:g1 */
    );
    function Fk() {
      if (lo.value) {
        Kn.setSplit(null), pi.value = "main";
        return;
      }
      gu.value && Kn.setSplit({ path: Le.value ?? "", viewMode: xe.value });
    }
    function oz() {
      Kn.setSplit(null), pi.value = "main";
    }
    function rz(o) {
      Kn.setSplit({ ...lo.value ?? {}, path: o }), Zs(yu.value) && (yu.value = { ...Ko }), Wn.clear(), vu.value = [];
    }
    function sz(o, s) {
      var g;
      if (s.type === "dir" && s.basename !== ".trash") {
        (g = en.value) == null || g.loadFolder(
          /* A multi-storage drive row's path is already the wire form for that
             storage's root; a real row needs converting. The predicate comes from
             `lib/fileIcons`, which is that concept's one home. */
          xi(s) === "storage" ? s.path : Li(s.path)
        );
        return;
      }
      qa(s);
    }
    function lz() {
      pi.value = "main", zi();
    }
    const Uk = E(() => {
      var o;
      return ((o = lo.value) == null ? void 0 : o.viewMode) ?? xe.value;
    });
    function Hk(o) {
      lo.value && Kn.setSplit({ ...lo.value, viewMode: o });
    }
    const lm = E(
      () => On.value ? Uk.value : xe.value
    );
    function Kk(o) {
      On.value ? Hk(o) : xe.value = o;
    }
    const pi = S("main");
    function uz() {
      pi.value = "main";
    }
    Xe(Cs, (o) => {
      o || (pi.value = "main");
    });
    const On = E(() => pi.value === "split" && Cs.value), cz = E(() => Cs.value && pi.value === "main"), Fd = E(() => On.value ? "split" : "main"), zs = S(null);
    function um(o) {
      var s;
      return o === "split" ? !!((s = en.value) != null && s.e2eRoot()) : an.value;
    }
    const Vk = E(
      () => {
        var o;
        return On.value ? ((o = en.value) == null ? void 0 : o.getPath()) ?? "" : Le.value ?? "";
      }
    );
    function dz(o) {
      var s;
      return o === "split" ? ((s = en.value) == null ? void 0 : s.getPath()) ?? "" : Le.value ?? "";
    }
    function fz(o) {
      var s;
      return o === "split" ? ((s = en.value) == null ? void 0 : s.rowPaths()) ?? [] : _e.value.map((g) => g.path);
    }
    Xe(
      () => aa(),
      (o) => {
        o.length && (zs.value = {
          nodes: o,
          pane: Fd.value,
          path: Vk.value,
          // Where the item was when it was selected: a held item keeps the
          // folder it came from, whatever folder the pane shows now.
          inEncrypted: um(Fd.value)
        });
      },
      { deep: !1 }
    );
    const Ud = E(() => {
      const o = zs.value;
      if (!o || !o.nodes.length || o.pane === "split" && !Cs.value) return !1;
      if (dz(o.pane) !== o.path) return !0;
      const s = new Set(fz(o.pane));
      return o.nodes.some((g) => s.has(g.path));
    });
    Xe(Ud, (o) => {
      o || (zs.value = null);
    });
    const pz = E(() => aa().length === 0 && Ud.value), jk = E(() => {
      var s;
      const o = aa();
      return o.length ? o : Ud.value ? ((s = zs.value) == null ? void 0 : s.nodes) ?? [] : [];
    }), hz = E(() => {
      const o = jk.value;
      return o.length === 1 && I.value ? Cd([o[0].path]) : void 0;
    }), mz = E(
      () => {
        var o;
        return aa().length ? um(Fd.value) : Ud.value && ((o = zs.value) == null ? void 0 : o.inEncrypted) === !0;
      }
    ), vz = E(
      () => {
        var o;
        return pz.value ? xh(((o = zs.value) == null ? void 0 : o.path) ?? "") : "";
      }
    ), yz = E(() => xh(Vk.value)), gz = E(
      () => {
        var o;
        return On.value ? ((o = en.value) == null ? void 0 : o.rowCount()) ?? 0 : _e.value.length;
      }
    ), bz = E(
      () => {
        var o;
        return On.value ? ((o = en.value) == null ? void 0 : o.dirPerm()) ?? "" : Ie.value;
      }
    );
    function Li(o) {
      return En.value ? Ao(o) : Va(o);
    }
    function qk(o) {
      const s = String(o ?? "").replace(/^\/+|\/+$/g, "");
      return he && (!s || !(s === he || s.startsWith(he + "/"))) ? he : s;
    }
    function Wk() {
      var s;
      const o = Wn.nodes.value;
      o.length !== 0 && (ie.value = { mode: "cut", items: o, sourcePath: ((s = en.value) == null ? void 0 : s.getPath()) ?? "" }, et(z("toast.cut")));
    }
    function Yk() {
      var s;
      const o = Wn.nodes.value;
      o.length !== 0 && (ie.value = { mode: "copy", items: o, sourcePath: ((s = en.value) == null ? void 0 : s.getPath()) ?? "" }, et(z("toast.copied")));
    }
    async function Gk() {
      const o = ie.value, s = en.value;
      if (!o.mode || o.items.length === 0 || !s) return;
      const g = It(s.getPath() ?? ""), O = It(o.sourcePath || "") || void 0;
      if (o.mode === "cut" && O === g) {
        et(z("toast.same_folder_cut"));
        return;
      }
      await Ms(o.items.map((N) => N.path), g, O, o.mode === "copy" ? "copy" : "move"), ie.value = { mode: null, items: [], sourcePath: null };
    }
    function Xk(o) {
      return sy(o);
    }
    async function Ms(o, s, g, O = "auto") {
      var Ee, st, Ze;
      const N = o.filter(
        (Lt) => Lt && Lt !== s && !s.startsWith(Lt + "/") && !Lh(ro(Lt), s)
      );
      if (N.length === 0 || !s) return "nothing";
      const Y = ow(N, s);
      if (Y === "cross")
        return et(z("e2e.vault.cross")), "refused";
      if (Y === "inside") {
        const Lt = O === "copy" ? await j.copy(N, s) : await j.move(N, s);
        return (Ee = en.value) == null || Ee.reload(), Lt ? "done" : "refused";
      }
      const de = w0(N, s, O);
      let $e;
      if (de.kind === "copy")
        try {
          if (await km("copy", N, s))
            return et(z("split.copy_queued")), (st = en.value) == null || st.reload(), "queued";
          const { op: Pn } = await $.copy(N, s);
          ze.register(Pn), et(de.cross ? z("split.cross_copy") : z("split.copy_queued")), $e = "queued";
        } catch (Lt) {
          return Bl(Lt, { op: "transfer", targetWire: s }), "refused";
        }
      else
        de.cross && et(z("split.cross_move")), $e = await BC(N, s, "move-transfer", g);
      return (Ze = en.value) == null || Ze.reload(), $e;
    }
    function Jk(o) {
      Ms(o.sources, o.targetWire, o.originWire);
    }
    const ln = a4(), Yn = S(0), Zk = /* @__PURE__ */ new WeakMap(), Dt = wne({
      api: $,
      chunked: yt,
      locale: () => W.value,
      t: (o, s) => z(o, s),
      toast: (o, s) => Yt({ message: o }, s ? bn : hi),
      emitError: (o, s) => H("error", { message: o, context: { op: s } }),
      escrowPublicKey: () => yr.value,
      escrowKid: () => Wa.value,
      registerOp: (o) => ze.register(o),
      reload: () => kt(),
      openPreview: (o, s) => {
        uo.set(o.path, s), Ha.value = "view", hn.value = o, ca.value = !0, H("file-opened", { path: o.path, basename: o.basename }), o.fxe_name && (_e.value = _e.value.map((g) => g.path === o.path ? { ...g, fxe_name: o.fxe_name } : g));
      },
      showRecoveryKey: (o, s) => {
        Lo.value = o, Ro.value = s, mr.value = "file", Do.value = !0;
      },
      /* wiring:e2 policy — "Request encryption…" on a plain file. */
      requestEncrypt: (o) => dm(o.path, "file", o.basename)
    }), bu = E(() => {
      var o;
      return !!((o = hn.value) != null && o.fxe_name);
    }), Kt = e5({
      api: $,
      ring: ln,
      lockedLabel: () => z("e2e.names.locked_item"),
      unreadableLabel: () => z("e2e.names.unreadable_item"),
      fileName: (o) => Dt.realName(o)
    });
    jo(Nc, Kt);
    const kz = Ote((o, s) => {
      Kt.version.value;
      const g = Kt.rootOf(o, s);
      if (!g || !ln.names(g)) return null;
      const O = Kt.segmentLabel(o);
      return !O || O === "…" ? null : { name: O, path: Kt.displayPath(o) };
    });
    Ct(kz);
    const dr = /* @__PURE__ */ new WeakMap(), Qk = S([]), Ot = S(""), uo = /* @__PURE__ */ new Map(), an = E(() => !!Ot.value && !Rt.value), Gn = E(() => (Yn.value, an.value && ln.has(Ot.value))), ku = E(() => (Yn.value, an.value && !ln.has(Ot.value))), Hd = S(!1), cm = S(""), fr = S(!1), pr = S(!1), ew = E(
      () => ua.value && !an.value && li.value ? Ch(It(Le.value), "new_folder") : "denied"
    ), hr = S(null);
    function dm(o, s, g) {
      hr.value = { path: o, kind: s, name: g };
    }
    function wz() {
      ua.value = !1, dm(It(Le.value), "new_folder", xh(Le.value));
    }
    function _z(o) {
      hr.value = null, et(o.created ? z("e2e.request.sent") : z("e2e.request.already"));
    }
    const on = S(null), Kd = S(!1), fm = S(!1), co = S(null), Do = S(!1), Lo = S(""), mr = S("created"), Ro = S(""), Os = S(!1), vr = S(""), wu = S(!1), No = S(!1), _u = S("unlock"), Ri = S(""), Ni = S(!1), Ii = S(""), yr = E(
      () => {
        var o, s;
        return ((s = (o = ue.value) == null ? void 0 : o.e2e_escrow) == null ? void 0 : s.public_key) || null;
      }
    ), Wa = E(
      () => {
        var o, s;
        return ((s = (o = ue.value) == null ? void 0 : o.e2e_escrow) == null ? void 0 : s.kid) || null;
      }
    );
    function pm() {
      return ln.get(Ot.value) ?? null;
    }
    function hm() {
      for (const o of uo.values()) URL.revokeObjectURL(o);
      uo.clear();
    }
    Ct(hm);
    async function tw(o, s) {
      var $e;
      let g = "";
      try {
        const { blob: Ee, url: st } = await $.fetchBlob(ja(o, ka), { fresh: !0 });
        URL.revokeObjectURL(st), g = await Ee.text();
      } catch {
        return z("e2e.unlock.marker_missing");
      }
      const O = Xf(g);
      if (!O) return z("e2e.unlock.marker_missing");
      const N = o === Ot.value;
      if (O.unsupported.length > 0)
        return N && (Qk.value = O.unsupported), z("e2e.unlock.unsupported", { features: O.unsupported.join(", ") });
      const Y = O.marker;
      N && (on.value = Y);
      const de = await Lx(Y, s);
      return "error" in de ? de.error === "damaged" ? z("e2e.unlock.damaged") : z("e2e.unlock.wrong") : await nw(o, Y, de.fmk) ? (N && (Y.v === 1 ? (vr.value = s, Os.value = !0) : A_(Y, Wa.value) === "offer" && (Ri.value = s, _u.value = "unlock", Ii.value = "", No.value = !0)), N && await kt(), ($e = en.value) == null || $e.reload(), null) : Ur(Y) ? z("e2e.vault.open_failed") : z("e2e.names.key_failed");
    }
    async function xz(o) {
      if (!(!o || Hd.value || !Ot.value)) {
        Hd.value = !0, cm.value = "";
        try {
          const s = await tw(Ot.value, o);
          s && (cm.value = s);
        } finally {
          Hd.value = !1;
        }
      }
    }
    jo(pT, {
      locked: (o) => (Yn.value, !ln.has(o)),
      unlock: tw,
      recovery: (o) => {
        pi.value = "main", kt(Li(o)).then(() => {
          Ot.value === o && lw();
        });
      }
    });
    async function nw(o, s, g) {
      if (Ur(s)) {
        ln.set(o, g, null, null), Kt.setMarker(o, s), Yn.value++, a().catch(() => {
        });
        try {
          await j.open(o, s, g, { perm: o === Ot.value && Ie.value || void 0 });
        } catch (Y) {
          return ln.lock(o), Yn.value++, H("error", { message: (Y == null ? void 0 : Y.message) ?? String(Y), context: { op: "e2e-vault-open" } }), !1;
        }
        return !0;
      }
      let O = null;
      if (qi(s) && (O = await qL(s, g), !O))
        return !1;
      let N = null;
      return sl(s) && (N = await ZL(s, g), !N) ? !1 : (ln.set(o, g, O, N), Kt.setMarker(o, s), Yn.value++, !0);
    }
    function mm() {
      if (!Ot.value) return;
      const o = Ot.value;
      j.isOpen(o) && j.close(o, "manual"), ln.lock(o), Kt.forget(o), Yn.value++, hm();
      const s = sw(o);
      Bi.value = !1, Ns = null, Rs.value = !1, s ? Yt({ message: s }, bn) : et(z("e2e.locked_toast")), kt();
    }
    function aw(o) {
      return Qs(o.extension);
    }
    async function Vd(o) {
      const s = uo.get(o.path);
      if (s) return s;
      if (j.isVaultRow(o)) {
        const de = await j.readUrl(o.path, aw(o));
        return uo.set(o.path, de), de;
      }
      const g = pm();
      if (!g) return null;
      const O = await $.fetchArrayBuffer(o.path);
      if (!bl(O)) return null;
      const N = await n4(g, ln.previous(Ot.value), O), Y = URL.createObjectURL(new Blob([N], { type: aw(o) }));
      return uo.set(o.path, Y), Y;
    }
    function jd(o) {
      return uo.get(o) ?? $.previewUrl(o);
    }
    async function Ps(o) {
      try {
        await Vd(o);
      } catch {
        et(z("e2e.decrypt_failed"));
        return;
      }
      Ha.value = "view", $i.value = go, hn.value = o, ca.value = !0, H("file-opened", { path: o.path, basename: o.basename }), Ua(o);
    }
    const Sz = eU(
      (o) => {
        const s = Kt.rootOf(o, an.value ? Ot.value : null), g = s ? ln.get(s) : void 0;
        return s && g ? { fmk: g, previous: ln.previous(s) ?? null } : null;
      },
      /* a vault's file: the vault engine reads and writes it (useE2eVault). */
      nU(j)
    ), xu = S(!1);
    function $z(o) {
      xu.value = o;
      const s = hn.value;
      o && s && j.isVaultRow(s) && j.touch(s.path), o || iw();
    }
    Xe(ca, (o) => {
      o || (xu.value = !1, iw());
    });
    let Su = null;
    function Tz(o, s) {
      const g = hn.value;
      if (!ca.value || !g || !Js(g.path, o) || !xu.value || !s.app_lock_soon || !s.app_lock_soon_keep) return;
      const O = s.app_lock_kept || s.app_lock_soon_keep;
      Su = {
        message: s.app_lock_soon,
        actionLabel: s.app_lock_soon_keep,
        action: () => j.touch(o),
        after: { kind: "plain", running: O, done: O }
      }, Yt(Su, Tse);
    }
    function iw() {
      var o;
      Su && ((o = va.value) == null ? void 0 : o.message) === Su.message && Oh(), Su = null;
    }
    const Az = E(() => Zg.value && Qp(hn.value) ? Sz : null);
    async function Ez(o) {
      if (j.isVaultRow(o)) {
        await j.download([o]);
        return;
      }
      const s = pm();
      if (!s) {
        et(z("e2e.download.failed"));
        return;
      }
      await Dt.downloadFolderFile(o, s, ln.previous(Ot.value), Ot.value);
    }
    async function Cz(o, s) {
      const g = pm();
      if (!g) return { files: [], sidecars: [] };
      const O = [], N = [];
      await bm(s);
      const Y = !!Kt.writesEncrypted(s);
      for (const de of o)
        if (de.name !== ka) {
          if (Y && Gi(de.name)) {
            et(z("e2e.names.bad_name", { name: de.name }));
            continue;
          }
          try {
            const $e = de.size > qu ? await Dt.folderUploadSource(de, g) : null, Ee = $e ? null : await Uv(g, await de.arrayBuffer());
            let st = de.name;
            if (Y) {
              const Lt = await Kt.nameForWrite(s, de.name);
              if (!Lt) throw new Error("e2e: the folder name key is missing");
              st = Lt.stored, Lt.sidecar && N.push(new File([Lt.sidecar.content], Lt.sidecar.name, { type: "text/plain" }));
            }
            const Ze = new File(Ee ? [Ee] : [], st, { type: "application/octet-stream" });
            $e && Zk.set(Ze, $e), Y && dr.set(Ze, de.name), O.push(Ze);
          } catch ($e) {
            H("error", { message: $e.message, context: { op: "e2e-encrypt" } });
          }
        }
      return { files: O, sidecars: N };
    }
    async function zz(o) {
      if (an.value) {
        et(z("e2e.create.nested"));
        return;
      }
      if (o.level === "vault") {
        await Mz(o);
        return;
      }
      pr.value = !0;
      let s = !1;
      try {
        const g = It(Le.value);
        await $.newFolder(g, o.name), s = !0;
        const { marker: O, fmk: N, recoveryKey: Y, names: de } = await Fv(o.password, {
          escrowPublicKey: yr.value,
          encryptNames: o.level === "names"
        }), $e = new File([JSON.stringify(O)], ka, {
          type: "application/json"
        }), Ee = ja(g, o.name);
        await $.uploadMultipart(Ee, [$e]), ln.set(Ee, N, de ?? null), Kt.setMarker(Ee, O), Yn.value++, fr.value = !1, Lo.value = Y, Ro.value = o.name, mr.value = "created", Do.value = !0, await kt();
      } catch (g) {
        H("error", { message: g.message, context: { op: "e2e-create" } }), Yt({ message: Zn(g, z("e2e.create.failed")) }, bn), s && await kt();
      } finally {
        pr.value = !1;
      }
    }
    async function Mz(o) {
      var s;
      if (((s = ue.value) == null ? void 0 : s.e2e_vault) !== !0) {
        Yt({ message: z("e2e.create.failed") }, bn);
        return;
      }
      pr.value = !0;
      try {
        const g = It(Le.value), O = ja(g, o.name), N = await FL(o.password, {
          escrowPublicKey: yr.value,
          packLog2: o.packLog2
        });
        await j.create(O, N.marker, N.index), ln.set(O, N.fmk, null, null), Kt.setMarker(O, N.marker), Yn.value++, a().catch(() => {
        }), await j.open(O, N.marker, N.fmk, { justMade: !0, perm: Ie.value || void 0 }), fr.value = !1, Lo.value = N.recoveryKey, Ro.value = o.name, mr.value = "created", Do.value = !0, await kt();
      } catch (g) {
        H("error", { message: g.message, context: { op: "e2e-vault-create" } }), Yt({ message: Zn(g, z("e2e.create.failed")) }, bn);
      } finally {
        pr.value = !1;
      }
    }
    function ow(o, s) {
      const g = j.rootOf(s), O = o.map((N) => j.rootOf(N));
      return !g && O.every((N) => !N) ? "none" : g && j.isOpen(g) && O.every((N) => N === g) ? "inside" : "cross";
    }
    const vm = E(() => {
      j.version.value;
      const o = Ot.value;
      return o ? j.strips[o] ?? null : null;
    }), $u = E(() => !!hn.value && j.isVaultRow(hn.value)), Oz = E(() => [...tt.nodes.value, ...zo.value].some((o) => j.isVaultRow(o)));
    function ym(o, s) {
      return !!o && (o === s || o.startsWith(s + "/"));
    }
    function rw(o, s) {
      var g;
      for (const [O, N] of [...uo])
        ym(O, o) && ((s || O !== ((g = hn.value) == null ? void 0 : g.path)) && URL.revokeObjectURL(N), uo.delete(O));
    }
    let gm = "";
    function sw(o) {
      const s = hn.value;
      if (!ca.value || !s || !Js(s.path, o)) return "";
      const g = xu.value;
      return ca.value = !1, xu.value = !1, g ? z("e2e.app_closed_unsaved", { name: s.basename }) : "";
    }
    function Pz(o) {
      var s;
      ln.lock(o), Kt.forget(o), Yn.value++, gm = sw(o), ym((s = Di.value) == null ? void 0 : s.path, o) && (so.value = !1), rw(o, !0);
    }
    function Dz(o, s) {
      var O;
      const g = gm;
      if (gm = "", s === "idle") {
        const N = z("e2e.vault.locked_idle_toast", { name: Mi(o) });
        Yt({ message: g ? `${N} ${g}` : N }, g ? 12e3 : 8e3);
      } else g && Yt({ message: g }, bn);
      (Ot.value === o || ym(It(Le.value), o)) && (Bi.value = !1, kt(Li(o))), (O = en.value) == null || O.reload();
    }
    function Lz(o) {
      var s;
      rw(o, !1), Ot.value === o && kt(), (s = en.value) == null || s.reload();
    }
    async function Rz(o) {
      if (!(!on.value || !Ot.value)) {
        fm.value = !0, co.value = null;
        try {
          let s = null;
          if (o.mode === "recovery") {
            if (s = await Rx(on.value, o.value), !s) {
              co.value = z("e2e.recover.wrong_recovery");
              return;
            }
          } else {
            let g;
            try {
              g = await Ex(o.value);
            } catch {
              co.value = z("e2e.recover.bad_escrow_key");
              return;
            }
            if (s = await Nx(on.value, g), !s) {
              co.value = z("e2e.recover.wrong_escrow");
              return;
            }
            try {
              const O = await $.e2eEscrowChallenge(Ot.value), N = new Uint8Array(
                await crypto.subtle.decrypt(
                  { name: "RSA-OAEP" },
                  g,
                  ta(O.challenge).buffer
                )
              );
              await $.e2eEscrowUsed({
                path: Ot.value,
                id: O.id,
                nonce: Oa(N)
              });
            } catch (O) {
              co.value = z("e2e.recover.notify_failed"), H("error", {
                message: O.message,
                context: { op: "e2e-escrow-notify" }
              });
              return;
            }
          }
          if (!await nw(Ot.value, on.value, s)) {
            co.value = z("e2e.names.key_failed");
            return;
          }
          Kd.value = !1, et(
            o.mode === "escrow" ? z("e2e.recover.escrow_done") : z("e2e.recover.recovery_done")
          ), await kt(), o.mode === "recovery" && (Ns = o.value, gw("reset"));
        } catch (s) {
          co.value = s.message;
        } finally {
          fm.value = !1;
        }
      }
    }
    async function lw() {
      if (!on.value && Ot.value)
        try {
          const { blob: o, url: s } = await $.fetchBlob(ja(Ot.value, ka), { fresh: !0 });
          URL.revokeObjectURL(s);
          const g = Xf(await o.text());
          on.value = g && g.unsupported.length === 0 ? g.marker : null;
        } catch {
          on.value = null;
        }
      co.value = null, Kd.value = !0;
    }
    async function Nz() {
      if (!(!on.value || !Ot.value || !vr.value)) {
        wu.value = !0;
        try {
          const o = await UL(on.value, vr.value, {
            escrowPublicKey: yr.value
          }), s = new File([JSON.stringify(o.marker)], ka, {
            type: "application/json"
          });
          await $.uploadMultipart(Ot.value, [s]), on.value = o.marker, Kt.setMarker(Ot.value, o.marker), Os.value = !1, vr.value = "", Lo.value = o.recoveryKey, Ro.value = Mi(Ot.value), mr.value = "upgraded", Do.value = !0;
        } catch (o) {
          H("error", { message: o.message, context: { op: "e2e-upgrade" } }), et(z("e2e.upgrade.failed"));
        } finally {
          wu.value = !1;
        }
      }
    }
    const uw = E(() => A_(on.value, Wa.value));
    function Iz() {
      _u.value = "manual", Ri.value = "", Ii.value = "", No.value = !0;
    }
    async function Io(o) {
      const s = new File([JSON.stringify(o)], ka, { type: "application/json" });
      await $.uploadMultipart(Ot.value, [s]), on.value = o, Kt.setMarker(Ot.value, o);
    }
    async function cw() {
      const o = on.value, s = yr.value;
      if (!(!o || !s || !Ot.value || Ni.value)) {
        if (!Ri.value) {
          Ii.value = z("e2e.escrowoffer.password_required");
          return;
        }
        Ni.value = !0, Ii.value = "";
        try {
          const g = await HL(o, Ri.value, s);
          await Io(g), No.value = !1, Ri.value = "", et(z("e2e.escrowoffer.done"));
        } catch (g) {
          (g == null ? void 0 : g.name) === "E2eDecryptError" ? Ii.value = z("e2e.escrowoffer.wrong_password") : (Ii.value = z("e2e.escrowoffer.failed"), H("error", { message: g.message, context: { op: "e2e-escrow-offer" } }));
        } finally {
          Ni.value = !1;
        }
      }
    }
    async function Bz() {
      const o = on.value;
      if (!(!o || !Ot.value || Ni.value)) {
        Ni.value = !0;
        try {
          await Io(KL(o, (/* @__PURE__ */ new Date()).toISOString())), No.value = !1, Ri.value = "", et(z("e2e.escrowoffer.declined_toast"));
        } catch (s) {
          Ii.value = z("e2e.escrowoffer.decline_failed"), H("error", { message: s.message, context: { op: "e2e-escrow-decline" } });
        } finally {
          Ni.value = !1;
        }
      }
    }
    function Fz() {
      No.value = !1, Ri.value = "", Ii.value = "";
    }
    function Uz() {
      Os.value = !1, vr.value = "";
    }
    class dw extends Error {
      constructor(s) {
        super(`e2e: invalid name (${s})`), this.problem = s, this.name = "E2eNameRefused";
      }
    }
    async function fw(o, s, g = {}) {
      if (await bm(o), !Kt.writesEncrypted(o)) return s;
      const O = Gi(s);
      if (O) throw new dw(O);
      const N = await Kt.nameForWrite(o, s, g);
      return N ? (N.sidecar && await $.uploadMultipart(o, [
        new File([N.sidecar.content], N.sidecar.name, { type: "text/plain" })
      ]), N.stored) : s;
    }
    async function bm(o) {
      const s = Ot.value;
      if (!s) return;
      const g = o.replace(/\/+$/, ""), O = s.replace(/\/+$/, "");
      (g === O || g.startsWith(O.endsWith("://") ? O : `${O}/`)) && await Kt.markerFor(s);
    }
    async function km(o, s, g, O) {
      await bm(g);
      const N = Kt.writesEncrypted(g);
      if (!N || !ln.names(N) || !s.every((Ze) => Kt.rootOf(Ze) === N)) return null;
      const Y = [], de = [], $e = (Ze, Lt) => Ze.replace(/\/+$/, "") === Lt.replace(/\/+$/, "");
      let Ee = /* @__PURE__ */ new Set();
      try {
        Ee = new Set(((await $.index(g)).files ?? []).map((Ze) => Ze.basename));
      } catch {
      }
      for (const Ze of s) {
        const Lt = ro(Ze);
        if (o === "move" && $e(Lt, g)) continue;
        const Pn = Mi(Ze), Mt = await Kt.plainNameOf(Ze);
        if (!Mt || Mt.state === "unreadable" || Mt.name === null)
          throw new Error(z("e2e.names.move_unreadable"));
        const gn = await Hz(Ze) ? { keepIdOf: Ze } : {};
        let Cn = await Kt.nameForWrite(g, Mt.name, gn);
        if (!Cn) return null;
        for (let Ga = 2; o === "copy" && Ee.has(Cn.stored) && Ga < 100; Ga++)
          Cn = await Kt.nameForWrite(g, mT(Mt.name, Ga), gn);
        if (Ee.has(Cn.stored)) throw new Error(z("e2e.names.move_taken", { name: Mt.name }));
        Ee.add(Cn.stored), Cn.sidecar && await $.uploadMultipart(g, [
          new File([Cn.sidecar.content], Cn.sidecar.name, { type: "text/plain" })
        ]);
        const { op: Fi } = await $.transferNamed(o, Ze, g, Cn.stored, O);
        ze.register(Fi), Y.push(Fi), de.push({ moved: ja(g, Cn.stored), origin: Lt, name: Pn });
      }
      return { ops: Y, undo: o === "move" ? async () => {
        for (const Ze of de) {
          const { op: Lt } = await $.transferNamed("move", Ze.moved, Ze.origin, Ze.name);
          ze.register(Lt);
        }
        return { queued: !0 };
      } : null };
    }
    async function Hz(o) {
      var O;
      const s = _e.value.find((N) => N.path === o) ?? (((O = en.value) == null ? void 0 : O.visibleNodes()) ?? []).find((N) => N.path === o);
      if (s) return s.type === "dir";
      const g = Ol(Mi(o)).kind;
      if (g === "dir" || g === "longdir") return !0;
      if (g === "file" || g === "long") return !1;
      try {
        return ((await $.index(ro(o))).files ?? []).some((Y) => Y.path === o && Y.type === "dir");
      } catch {
        return !1;
      }
    }
    async function pw(o, s) {
      const g = Kt.writesEncrypted(o);
      if (!g) return null;
      const O = o.indexOf("://"), Y = {
        adapter: O === -1 ? _t.value : o.slice(0, O),
        storages: (P.config.storages ?? []).map((st) => st.name),
        dirname: o,
        read_only: !1,
        files: [],
        e2e_root: g
      };
      if (!ln.names(g)) return Y;
      const de = [], $e = [o];
      let Ee = 0;
      for (; $e.length > 0 && de.length < cf && Ee < Ase; ) {
        const st = $e.shift();
        Ee++;
        let Ze;
        try {
          Ze = await $.index(st);
        } catch {
          continue;
        }
        const Lt = Tr(await Kt.decorate(Ze.files ?? [], { root: g }));
        for (const Pn of Lt)
          if (Pn.type === "dir" && $e.push(Pn.path), $S(Pn.basename, s) && de.push(Pn), de.length >= cf) break;
      }
      return { ...Y, files: de, truncated: $e.length > 0 };
    }
    const Bi = S(!1);
    Xe(Ot, async (o, s) => {
      if (o === s) return;
      if (Os.value = !1, vr.value = "", No.value = !1, Ri.value = "", Bi.value = !1, gr.value = "", br.value = null, Qk.value = [], !o) {
        on.value = null;
        return;
      }
      const g = Kt.markerCached(o);
      if (on.value = g === void 0 ? null : g, g === void 0) {
        const O = await Kt.markerFor(o);
        Ot.value === o && (on.value = O);
      }
    });
    const fo = S(!1), gr = S(""), br = S(null);
    let Ds = !1;
    const qd = E(() => (Yn.value, GL(on.value))), hw = E(() => qd.value !== "content"), Kz = E(() => (Yn.value, XL(on.value))), Vz = E(
      () => hw.value ? _e.value.filter((o) => o.e2e_name_state === "plain" || o.e2e_name_state === "unreadable").length : 0
    );
    async function Wd() {
      var O;
      const o = Ot.value, s = o ? ln.get(o) : void 0;
      let g = on.value;
      if (!o || !s || !g || fo.value) return !1;
      Bi.value = !1, fo.value = !0, gr.value = "", Ds = !1;
      try {
        if (!qi(g)) {
          const $e = await E_(g, s);
          await Io($e.marker), ln.setNames(o, $e.names), Yn.value++, g = $e.marker;
        }
        const N = ln.names(o);
        if (!N) throw new Error("e2e: the folder name key is missing");
        br.value = { renamed: 0, failed: 0, seen: 0 };
        const Y = br.value;
        if (await zte(N, o, {
          list: async ($e) => (await $.index($e)).files ?? [],
          readSidecar: async ($e, Ee) => {
            try {
              return new TextDecoder().decode(await $.fetchArrayBuffer(Xs($e, Ee)));
            } catch {
              return null;
            }
          },
          writeSidecar: async ($e, Ee, st) => {
            await $.uploadMultipart($e, [new File([st], Ee, { type: "text/plain" })]);
          },
          // A folder rename is a job of the queue where the server has one: the
          // queue keeps order, so a folder is renamed after its contents.
          rename: async ($e, Ee, st) => {
            if (Ee.type === "dir" && Jc("rename")) {
              const Ze = (await $.renameQueued($e, Ee.path, st)).op;
              Ze && ze.register(Ze);
            } else
              await $.rename($e, Ee.path, st);
          },
          stopped: () => Ds
        }, Y), Ds)
          return et(z("e2e.names.stopped", { n: Y.renamed })), !1;
        if (Y.failed > 0)
          return gr.value = z("e2e.names.partial", { n: Y.failed }), !1;
        const de = on.value ?? g;
        return (O = de.names) != null && O.pending && await Io(WL(de)), br.value = null, et(z("e2e.names.done", { n: Y.renamed })), !0;
      } catch (N) {
        return gr.value = z("e2e.names.failed"), H("error", { message: N.message, context: { op: "e2e-names" } }), !1;
      } finally {
        fo.value = !1, await kt();
      }
    }
    const kr = S(null), Bo = S(!1), wr = S(""), po = S(null);
    let Yd = !1, Tu = null;
    const Ls = S(null), mw = E(() => (Yn.value, z_(on.value)));
    function jz(o, s) {
      const g = o.length === 1 ? o[0] : null;
      return !!g && g.type === "dir" && s && !an.value && !g.e2e && !g.e2e_root && !nn.value && typeof crypto < "u" && !!crypto.subtle;
    }
    function vw(o, s, g) {
      return jz(o, s) && Ch(o[0].path, "folder") === g;
    }
    function qz(o) {
      kr.value = o, fr.value = !0;
    }
    async function Wz(o) {
      const s = [o];
      for (; s.length; ) {
        const g = s.shift(), O = await $.index(g);
        if (g !== o && typeof O.e2e_root == "string" && O.e2e_root) return !0;
        for (const N of O.files ?? [])
          if (N.type === "dir") {
            if (N.e2e) return !0;
            s.push(N.path);
          }
      }
      return !1;
    }
    async function Yz(o) {
      const s = kr.value;
      if (!s) return;
      const g = s.path;
      pr.value = !0;
      try {
        if (await Wz(g)) {
          et(z("e2e.convert.nested"));
          return;
        }
        const O = await Fv(o.password, { escrowPublicKey: yr.value });
        let N = O.marker, Y = null;
        if (o.level === "names") {
          const de = await E_(N, O.fmk);
          N = de.marker, Y = de.names;
        }
        N = QL(N, void 0, o.cleanup ?? { versions: !1, trash: !1 }), await $.uploadMultipart(g, [
          new File([JSON.stringify(N)], ka, { type: "application/json" })
        ]), ln.set(g, O.fmk, Y), Kt.setMarker(g, N), Yn.value++, fr.value = !1, kr.value = null, Lo.value = O.recoveryKey, Ro.value = o.name, mr.value = "created", Do.value = !0, await kt(Li(g)), await Jt(), Ot.value === g && (on.value = N, yw());
      } catch (O) {
        H("error", { message: O.message, context: { op: "e2e-convert" } }), Yt({ message: Zn(O, z("e2e.convert.failed")) }, bn);
      } finally {
        pr.value = !1;
      }
    }
    async function yw() {
      var Y, de, $e;
      const o = Ot.value, s = o ? ln.get(o) : void 0, g = on.value;
      if (!o || !s || !g || !z_(g) || Bo.value) return;
      Bo.value = !0, wr.value = "", Yd = !1;
      const O = new AbortController();
      Tu = O, po.value = { total: 0, done: 0, skipped: 0, tooBig: 0, failed: 0 };
      const N = po.value;
      try {
        if (await Mte(
          o,
          {
            list: async (Ze) => (await $.index(Ze)).files ?? [],
            head: (Ze) => $.fetchHead(Ze, 16),
            read: (Ze) => $.fetchArrayBuffer(Ze),
            write: async (Ze, Lt, Pn, Mt) => {
              await $.uploadMultipart(
                Ze,
                [new File([Pn], Lt.basename, { type: "application/octet-stream" })],
                void 0,
                { e2e_convert: "1", ...Mt ? { expect: Mt } : {} }
              );
            },
            encrypt: (Ze) => Uv(s, Ze),
            /* wiring:e2 convert - over 200 MB: STREAM (0x02), streamed both ways. */
            writeLarge: async (Ze, Lt, Pn) => {
              Ls.value = { name: Lt.basename, percent: 0 };
              try {
                return await Dt.convertLarge(Lt, s, Pn, {
                  signal: O.signal,
                  onProgress: (Mt) => {
                    Ls.value = { name: Lt.basename, percent: Math.floor(Mt * 100) };
                  }
                });
              } finally {
                Ls.value = null;
              }
            },
            stopped: () => Yd
          },
          N,
          { maxBytes: qu }
        ), Yd) {
          et(z("e2e.convert.stopped", { n: N.done }));
          return;
        }
        if (N.tooBig > 0 && N.failed === 0) {
          wr.value = z("e2e.convert.too_large_here", { n: N.tooBig });
          return;
        }
        if (N.failed + N.tooBig > 0) {
          wr.value = z("e2e.convert.partial", { n: N.failed + N.tooBig });
          return;
        }
        if ((de = (Y = on.value) == null ? void 0 : Y.names) != null && de.pending && !await Wd()) return;
        const Ee = on.value ?? g, st = ($e = Ee.conv) == null ? void 0 : $e.cleanup;
        await Io(e4(Ee)), po.value = null;
        try {
          const Ze = await $.e2eCleanup({ path: o, versions: !!(st != null && st.versions), trash: !!(st != null && st.trash) });
          et(
            z("e2e.convert.done", {
              n: N.done + N.skipped,
              versions: Ze.versions_deleted,
              trash: Ze.trash_purged
            })
          );
        } catch (Ze) {
          et(z("e2e.convert.cleanup_failed")), H("error", { message: Ze.message, context: { op: "e2e-convert-cleanup" } });
        }
      } catch (Ee) {
        wr.value = Zn(Ee, z("e2e.convert.failed")), H("error", { message: Ee.message, context: { op: "e2e-convert" } });
      } finally {
        Bo.value = !1, Tu = null, await kt();
      }
    }
    function Gz() {
      Yd = !0, Tu == null || Tu.abort();
    }
    function Xz() {
      Bi.value = !1, gw("change");
    }
    function Jz() {
      Bi.value = !1, Iz();
    }
    const Rs = S(!1), wm = S("change"), Au = S(!1), _r = S(null);
    let Ns = null;
    const xr = S(!1), Eu = S(""), Is = S(null), Zz = E(() => (Yn.value, sl(on.value))), Qz = E(() => !!on.value && Fx(on.value));
    function gw(o) {
      wm.value = o, _r.value = null, Rs.value = !0;
    }
    function eM() {
      if (!Au.value) {
        if (wm.value === "reset") {
          mm();
          return;
        }
        Rs.value = !1;
      }
    }
    async function tM(o) {
      const s = Ot.value, g = on.value;
      if (!s || !g || Au.value) return;
      const O = o.proof ?? (Ns ? { recoveryKey: Ns } : null);
      if (!O) {
        _r.value = z("e2e.password.current_required");
        return;
      }
      const N = "recoveryKey" in O ? "recovery_key" : "password";
      Au.value = !0, _r.value = null;
      try {
        if (!o.rotate) {
          const de = await Ux(g, O, o.newPassword);
          await Io(de), Ns = null, Rs.value = !1, et(z("e2e.password.done"));
          return;
        }
        const Y = await JL(g, O, o.newPassword, {
          escrowPublicKey: yr.value
        });
        await Io(Y.marker), Os.value = !1, vr.value = "", ln.set(s, Y.fmk, Y.names ?? ln.names(s) ?? null, Y.previous), Yn.value++, hm(), Ns = null, Rs.value = !1, Y.recoveryKeyIsNew && (Lo.value = Y.recoveryKey, Ro.value = Mi(s), mr.value = "replaced", Do.value = !0), await kw();
      } catch (Y) {
        Y instanceof un ? _r.value = z(N === "recovery_key" ? "e2e.password.wrong_recovery" : "e2e.password.wrong_current") : Y instanceof Hx ? _r.value = z("e2e.password.escrow_blocked") : (_r.value = z("e2e.password.failed"), H("error", { message: Y.message, context: { op: "e2e-password" } }));
      } finally {
        Au.value = !1;
      }
    }
    async function nM(o, s, g) {
      const O = new File([g], s, { type: "application/octet-stream" });
      if (yt.shouldChunk(O)) {
        await yt.uploadFile({ path: o, file: O });
        return;
      }
      await $.uploadMultipart(o, [O]);
    }
    async function bw(o, s, g) {
      const O = Is.value;
      let N;
      try {
        N = await $.index(o);
      } catch {
        O.failed++;
        return;
      }
      for (const Y of N.files ?? [])
        if (Y.basename !== ka) {
          if (Y.type === "dir") {
            await bw(Y.path, s, g);
            continue;
          }
          try {
            if ((Y.size ?? 0) > qu) {
              await Dt.rewrapLarge(Y, s, g) && O.done++;
              continue;
            }
            const de = await $.fetchArrayBuffer(Y.path);
            if (!bl(de)) continue;
            const $e = await Kx(de, s, g);
            $e && await nM(o, Y.basename, $e), O.done++;
          } catch {
            O.failed++;
          }
        }
    }
    async function kw() {
      const o = Ot.value, s = o ? ln.get(o) : void 0, g = o ? ln.previous(o) : void 0;
      if (!(!o || !s || !g || xr.value)) {
        xr.value = !0, Eu.value = "", Is.value = { done: 0, failed: 0 };
        try {
          await bw(o, g, s);
          const O = Is.value;
          if (O.failed > 0) {
            Eu.value = z("e2e.password.rekey_partial", { n: O.failed });
            return;
          }
          const N = on.value;
          N && sl(N) && await Io(t4(N)), ln.dropPrevious(o), Yn.value++, et(z("e2e.password.rekey_done", { n: O.done }));
        } catch (O) {
          Eu.value = z("e2e.password.failed"), H("error", { message: O.message, context: { op: "e2e-rekey" } });
        } finally {
          xr.value = !1, await kt();
        }
      }
    }
    function Gd(o) {
      return o.replace(/\/+$/, "");
    }
    function ww(o) {
      if (!o || o.type !== "dir" || o.e2e !== !0) return null;
      const s = Gd(o.path);
      return ln.roots().find((g) => Gd(g) === s) ?? null;
    }
    async function aM(o) {
      const s = o.length === 1 ? o[0] : null;
      if (s && Ui(s) && !an.value && !s.e2e_root)
        return await Dt.download(s), !0;
      let g = null;
      if (Gn.value ? g = Ot.value : s && (g = ww(s)), !g && o.length > 0) {
        const de = o.map((Ee) => Kt.rootOf(Ee.path, Ee.e2e_root ?? null)), $e = de[0];
        $e && de.every((Ee) => Ee === $e) && (g = ln.roots().find((Ee) => Gd(Ee) === Gd($e)) ?? null);
      }
      if (!g) return !1;
      const O = ln.get(g);
      if (!O) return !1;
      if (s && s.type === "file")
        return await Dt.downloadFolderFile(s, O, ln.previous(g), g), !0;
      const N = Kt.segmentLabel(It(Le.value)) ?? Mi(It(Le.value)), Y = `${s ? s.basename : N || "filex"}.zip`;
      return await Dt.downloadDecryptedZip(o, {
        root: g,
        fmk: O,
        previous: ln.previous(g),
        decorate: (de, $e) => Kt.decorate(de, $e),
        zipName: Y
      }), !0;
    }
    function iM() {
      const o = Dt.tooBig.value;
      if (Dt.closeTooBig(), !o) return;
      if (o.encrypted.kind === "file") {
        window.open($.downloadUrl(o.encrypted.path), "_blank");
        return;
      }
      const s = { path: o.encrypted.path, basename: Mi(o.encrypted.path), type: "dir" };
      zd([s], { encrypted: !0 });
    }
    function oM() {
      Do.value = !1, Lo.value = "", Ro.value = "";
    }
    return (o, s) => {
      var g, O, N, Y, de, $e, Ee, st, Ze, Lt, Pn, Mt, Ya, gn, Cn, Fi, Ga, Xd, xw, Sw, $w, Tw, Aw, Ew, Cw, zw, Mw, Ow, Pw;
      return f(), h("div", {
        ref_key: "rootEl",
        ref: Mn,
        class: Ne(["fe", {
          "fe--theme-light": An.value === "light",
          "fe--theme-dark": An.value === "dark",
          "fe--is-dragover": Po.value,
          "fe--density-compact": Fe.value === "compact",
          "fe--narrow": Ta.value
        }]),
        dir: u(fe),
        tabindex: "-1",
        onDragenter: LC,
        onDragover: NC,
        onDragleave: RC,
        onDrop: IC,
        onContextmenu: sC
      }, [
        Je(AD, {
          ref_key: "toolbarRef",
          ref: Kb,
          "view-mode": lm.value,
          "search-query": ye.value,
          "trash-active": nn.value,
          actions: mC.value,
          "selection-mode": iC.value,
          "selection-count": aa().length,
          "selection-pane": Fd.value,
          "paste-enabled": !!ie.value.mode,
          "can-go-up": me.value,
          "at-virtual-root": De.value,
          "can-write": li.value,
          locale: W.value,
          narrow: Ta.value,
          theme: An.value,
          "inspector-open": Ra.value,
          "assistant-button": ch.value,
          "assistant-open": ao.value,
          "nav-open": QA.value,
          "nav-enabled": Jl.value,
          "view-modes": hh.value,
          "scope-label": Tb.value,
          "brand-name": (g = e.config.brand) == null ? void 0 : g.name,
          "brand-mark-url": (O = e.config.brand) == null ? void 0 : O.markUrl,
          "search-escalates": gt.value === "home",
          onOpenPalette: mE,
          onToggleInspector: uh,
          onToggleAssistant: GA,
          onToggleNav: gb,
          onOpenTheme: s[0] || (s[0] = (Me) => Dd.value = !0),
          "onUpdate:viewMode": s[1] || (s[1] = (Me) => Kk(Me)),
          "onUpdate:searchQuery": hE,
          onOpenAdvancedSearch: fE,
          "onUpdate:density": s[2] || (s[2] = (Me) => Fe.value = Me),
          onOpenShortcutSettings: s[3] || (s[3] = (Me) => hu.value = !0),
          onOpenTimezone: s[4] || (s[4] = (Me) => ot.value = !0),
          onNewFolder: s[5] || (s[5] = (Me) => ua.value = !0),
          onUpload: Mo,
          onRefresh: Yb,
          onGoUp: Ve,
          onAction: Uh,
          onOpenRecents: s[6] || (s[6] = (Me) => as.value = !0)
        }, mM({
          "header-actions": mt(() => {
            var Me;
            return [
              u(Q) ? (f(), We(Lie, {
                key: 0,
                feed: u(Q),
                locale: W.value,
                "manage-href": at.value,
                onOpen: tn,
                onManage: ct
              }, null, 8, ["feed", "locale", "manage-href"])) : D("", !0),
              e.config.account ? (f(), We(hoe, {
                key: 1,
                actions: Re.value,
                user: Nn.value,
                version: (Me = ue.value) == null ? void 0 : Me.release,
                locale: W.value,
                "fallback-label": u(z)("explore.account"),
                onSelect: pt
              }, null, 8, ["actions", "user", "version", "locale", "fallback-label"])) : D("", !0),
              Ln(o.$slots, "header-actions")
            ];
          }),
          _: 2
        }, [
          o.$slots.brand ? {
            name: "brand",
            fn: mt(() => [
              Ln(o.$slots, "brand")
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["view-mode", "search-query", "trash-active", "actions", "selection-mode", "selection-count", "selection-pane", "paste-enabled", "can-go-up", "at-virtual-root", "can-write", "locale", "narrow", "theme", "inspector-open", "assistant-button", "assistant-open", "nav-open", "nav-enabled", "view-modes", "scope-label", "brand-name", "brand-mark-url", "search-escalates", "onOpenPalette", "onToggleInspector", "onToggleNav", "onUpdate:searchQuery", "onOpenAdvancedSearch", "onRefresh"]),
        d("div", {
          class: Ne([
            "fe__main",
            { "fe__main--split": Cs.value }
            /* wiring:d1 */
          ])
        }, [
          dh.value ? (f(), We(Nj, {
            key: 0,
            expanded: Xl.value,
            narrow: Ta.value,
            "active-view": gt.value,
            "active-tag": sn.value,
            "active-tag-kind": $n.value,
            tags: Pb.value,
            "tags-loaded": wh.value,
            "active-storage": _t.value,
            storages: bh.value,
            "storage-order-custom": u(Mb).custom.value,
            onReorderStorages: kE,
            "shared-storages": fh.value,
            "trash-visible": e.config.trashVisible !== !1,
            "drafts-visible": nr.value && ps.value,
            "draft-count": is.value,
            "show-connections": eE.value,
            "show-my-shares": tE.value,
            "show-identity-surfaces": ps.value,
            "can-write": li.value && !De.value && !nn.value,
            locale: W.value,
            "can-request-files": li.value && !De.value && !nn.value && !gt.value && !an.value,
            "request-files-allowed": Hb.value,
            "can-new-document": TA.value && !nn.value && !gt.value && !an.value,
            onNewDocument: s[7] || (s[7] = (Me) => ql.value = !0),
            quota: gE.value,
            theme: An.value,
            onRequestFiles: vE,
            onToggle: gb,
            onClose: To,
            onOpenView: _E,
            onOpenTag: ys,
            onOpenStorage: Db,
            onUpload: Mo,
            onNewFolder: s[8] || (s[8] = (Me) => ua.value = !0),
            onOpenConnections: aE,
            onOpenTokens: iE,
            onOpenMyShares: s[9] || (s[9] = (Me) => H("open-my-shares")),
            "show-app-store": nE.value,
            onOpenAppStore: s[10] || (s[10] = (Me) => H("open-app-store")),
            apps: hA.value,
            onOpenApp: Qg
          }, null, 8, ["expanded", "narrow", "active-view", "active-tag", "active-tag-kind", "tags", "tags-loaded", "active-storage", "storages", "storage-order-custom", "shared-storages", "trash-visible", "drafts-visible", "draft-count", "show-connections", "show-my-shares", "show-identity-surfaces", "can-write", "locale", "can-request-files", "request-files-allowed", "can-new-document", "quota", "theme", "onRequestFiles", "onOpenView", "show-app-store", "apps"])) : D("", !0),
          Ta.value && ur.value ? (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-sidenav__scrim",
            title: u(z)("sidenav.close"),
            "aria-label": u(z)("sidenav.close"),
            onClick: To
          }, null, 8, Soe)) : D("", !0),
          d("div", $oe, [
            iz.value ? (f(), We(jZ, {
              key: 0,
              tabs: Dk.value,
              "active-id": u(rm),
              locale: W.value,
              "hide-tabs": !Lk.value,
              "split-enabled": gu.value,
              "split-active": !!lo.value,
              "inspector-enabled": vb.value,
              "inspector-open": Ra.value,
              onSelect: QC,
              onClose: Rk,
              onNew: sm,
              onReorder: s[11] || (s[11] = (Me, Xn) => u(Kn).move(Me, Xn)),
              onToggleSplit: Fk,
              onToggleInspector: uh
            }, null, 8, ["tabs", "active-id", "locale", "hide-tabs", "split-enabled", "split-active", "inspector-enabled", "inspector-open"])) : D("", !0),
            d("div", Toe, [
              Je(d0, {
                "pane-id": "main",
                ref_key: "mainPaneRef",
                ref: nz,
                api: K,
                locale: W.value,
                theme: An.value,
                focused: cz.value,
                path: Le.value,
                qualify: It,
                "to-user": Li,
                clamp: qk,
                "root-path": u(Se),
                floor: u(he),
                "multi-root": En.value,
                rows: _e.value,
                loading: oe.value,
                error: ee.value,
                order: sE.value,
                "view-mode": xe.value,
                "view-modes": hh.value,
                "open-trigger": P.config.openTrigger,
                "show-crumbs": gt.value !== "home",
                "filter-mode": He.value,
                "find-label": gt.value === "home" ? u(z)("filter.find.home") : "",
                "show-view-switcher": gt.value !== "home",
                "folder-key": zn.value,
                "show-parent-path": !!ye.value || ra.value,
                trash: nn.value,
                clipped: tm.value,
                "extra-filters": vs.value,
                "extra-filters-on-server": !xb.value,
                "can-write": li.value && !nn.value,
                "can-paste": !!ie.value.mode,
                selected: u(tt).selected.value,
                filters: ms.value,
                "thumb-src": u(it).src,
                "folder-previews": ((N = ue.value) == null ? void 0 : N.folder_previews) !== !1,
                "keep-badge-for": ci.value ? rk : void 0,
                "starred-ids": ob.value,
                "star-overrides": ns.value,
                "star-enabled": ps.value,
                "api-base": P.config.apiBase ?? "",
                "auth-headers": () => Qn(),
                "auth-credentials": u($).credentialsMode(),
                "e2e-active": an.value,
                "body-override": Bd.value !== "",
                onActivate: uz,
                onNavigate: HC,
                onOpen: qa,
                onOpenTrash: s[22] || (s[22] = () => zi()),
                onClickRow: s[23] || (s[23] = (Me, Xn) => gk("main", Me, Xn)),
                onContext: s[24] || (s[24] = (Me, Xn) => ck("main", Me, Xn)),
                onClearSelection: s[25] || (s[25] = (Me) => u(tt).clear()),
                onDisplayOrder: s[26] || (s[26] = (Me) => bt.value = Me),
                onItemDragStart: s[27] || (s[27] = (Me, Xn) => bk("main", Me, Xn)),
                onItemDropInto: Ek,
                onTransfer: Jk,
                "onUpdate:viewMode": s[28] || (s[28] = (Me) => xe.value = Me),
                "onUpdate:filters": kb,
                onCrumbContext: lC,
                onCopyPath: Pd,
                onCrumbDrop: Ck,
                onNewFolder: s[29] || (s[29] = (Me) => ua.value = !0),
                onUpload: Mo,
                onPaste: s[30] || (s[30] = (Me) => Uh("paste")),
                onSelectAll: s[31] || (s[31] = (Me) => u(tt).selectAll()),
                onClearFilters: lE,
                onStarChange: rb,
                onRetry: ae
              }, {
                banners: mt(() => [
                  ye.value && Te.value && !gt.value && !nn.value ? (f(), h("div", Aoe, y(u(z)("search.truncated")), 1)) : D("", !0),
                  io.value && io.value.truncated && dn.value && !ye.value ? (f(), h("div", Eoe, [
                    d("span", null, y(u(z)("nav.more_shown", { shown: _e.value.length, total: io.value.total })), 1),
                    d("button", {
                      type: "button",
                      class: "fe-coverage__action",
                      "data-testid": "nav-more-load",
                      disabled: tu.value,
                      "aria-busy": tu.value ? "true" : void 0,
                      onClick: bE
                    }, y(u(z)("nav.load_more")), 9, Coe)
                  ])) : D("", !0),
                  Ci.value ? (f(), h("div", zoe, [
                    d("span", Moe, y(pn(Ci.value.storage) ? u(z)("coverage.cataloging", { storage: Ci.value.storage ?? "" }) : u(z)(Ci.value.key, Ci.value.vars)), 1),
                    Ci.value.offerCatalogAll ? (f(), h("button", {
                      key: 0,
                      type: "button",
                      class: "fe-coverage__action",
                      "data-testid": "catalog-coverage-all",
                      disabled: pn(Ci.value.storage),
                      "aria-busy": pn(Ci.value.storage) ? "true" : void 0,
                      onClick: s[12] || (s[12] = (Me) => ME(Ci.value.storage))
                    }, y(pn(Ci.value.storage) ? u(z)("coverage.catalog_running") : u(z)("coverage.catalog_all")), 9, Ooe)) : D("", !0)
                  ])) : D("", !0),
                  u(qe).length || u(Tt) ? (f(), h("div", Poe, [
                    u(qe).length ? (f(), We(c3, {
                      key: 0,
                      users: u(qe),
                      locale: W.value
                    }, null, 8, ["users", "locale"])) : D("", !0),
                    u(Tt) ? (f(), h("span", {
                      key: 1,
                      class: "fe-connbadge",
                      role: "status",
                      title: u(z)("conn.tooltip")
                    }, [
                      s[113] || (s[113] = d("span", {
                        class: "fe-connbadge__dot",
                        "aria-hidden": "true"
                      }, null, -1)),
                      Vt(" " + y(u(z)("conn.offline")), 1)
                    ], 8, Doe)) : D("", !0)
                  ])) : D("", !0),
                  Os.value ? (f(), h("div", Loe, [
                    d("div", Roe, [
                      d("strong", null, y(u(z)("e2e.upgrade.title")), 1),
                      d("p", null, y(u(z)("e2e.upgrade.body")), 1),
                      Wa.value ? (f(), h("p", Noe, y(u(z)("e2e.upgrade.escrow_note")), 1)) : D("", !0)
                    ]),
                    d("div", Ioe, [
                      d("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: wu.value,
                        onClick: Uz
                      }, y(u(z)("e2e.upgrade.decline")), 9, Boe),
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: wu.value,
                        onClick: Nz
                      }, y(wu.value ? u(z)("e2e.upgrade.busy") : u(z)("e2e.upgrade.accept")), 9, Foe)
                    ])
                  ])) : D("", !0),
                  No.value ? (f(), h("div", Uoe, [
                    d("div", Hoe, [
                      d("strong", null, y(u(z)("e2e.escrowoffer.title")), 1),
                      d("p", null, y(u(z)("e2e.escrowoffer.body")), 1),
                      d("p", Koe, [
                        Vt(y(u(z)("e2e.escrowoffer.consequence")) + " ", 1),
                        d("a", {
                          href: $se,
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, y(u(z)("e2e.escrowoffer.learn_more")), 1)
                      ]),
                      Wa.value ? (f(), h("p", Voe, [
                        Vt(y(u(z)("e2e.recover.escrow_kid")) + ": ", 1),
                        d("code", null, y(Wa.value), 1)
                      ])) : D("", !0),
                      _u.value === "manual" ? (f(), h("label", joe, [
                        d("span", null, y(u(z)("e2e.escrowoffer.password_label")), 1),
                        cn(d("input", {
                          "onUpdate:modelValue": s[13] || (s[13] = (Me) => Ri.value = Me),
                          type: "password",
                          class: "fe-input",
                          autocomplete: "current-password",
                          disabled: Ni.value,
                          onKeyup: za(cw, ["enter"])
                        }, null, 40, qoe), [
                          [xn, Ri.value]
                        ])
                      ])) : D("", !0),
                      Ii.value ? (f(), h("p", Woe, y(Ii.value), 1)) : D("", !0)
                    ]),
                    d("div", Yoe, [
                      d("button", {
                        type: "button",
                        class: "fe-btn",
                        disabled: Ni.value,
                        onClick: s[14] || (s[14] = (Me) => _u.value === "manual" ? Fz() : Bz())
                      }, y(_u.value === "manual" ? u(z)("e2e.escrowoffer.cancel") : u(z)("e2e.escrowoffer.decline")), 9, Goe),
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        disabled: Ni.value,
                        onClick: cw
                      }, y(Ni.value ? u(z)("e2e.escrowoffer.busy") : u(z)("e2e.escrowoffer.accept")), 9, Xoe)
                    ])
                  ])) : D("", !0),
                  Gn.value && (mw.value || Bo.value || wr.value) ? (f(), h("div", Joe, [
                    d("div", Zoe, [
                      d("strong", null, y(Bo.value ? u(z)("e2e.convert.busy") : u(z)("e2e.convert.resume_title")), 1),
                      Bo.value ? D("", !0) : (f(), h("p", Qoe, y(u(z)("e2e.convert.resume_body")), 1)),
                      po.value ? (f(), h("p", ere, y(u(z)("e2e.convert.progress", {
                        n: po.value.done + po.value.skipped,
                        total: po.value.total,
                        failed: po.value.failed + po.value.tooBig
                      })), 1)) : D("", !0),
                      Ls.value ? (f(), h("p", tre, y(u(z)("e2e.convert.large_progress", { name: Ls.value.name, percent: Ls.value.percent })), 1)) : D("", !0),
                      wr.value ? (f(), h("p", nre, y(wr.value), 1)) : D("", !0)
                    ]),
                    d("div", are, [
                      Bo.value ? (f(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-convert-stop",
                        onClick: Gz
                      }, y(u(z)("e2e.names.stop")), 1)) : (f(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-convert-resume",
                        onClick: yw
                      }, y(u(z)("e2e.names.resume")), 1))
                    ])
                  ])) : D("", !0),
                  Gn.value && !mw.value && !Bo.value && (qd.value === "pending" || fo.value || gr.value) ? (f(), h("div", ire, [
                    d("div", ore, [
                      d("strong", null, y(fo.value ? u(z)("e2e.names.busy") : u(z)("e2e.names.resume_title")), 1),
                      fo.value ? D("", !0) : (f(), h("p", rre, y(u(z)("e2e.names.resume_body")), 1)),
                      br.value ? (f(), h("p", sre, y(u(z)("e2e.names.progress", { n: br.value.renamed, failed: br.value.failed })), 1)) : D("", !0),
                      gr.value ? (f(), h("p", lre, y(gr.value), 1)) : D("", !0)
                    ]),
                    d("div", ure, [
                      fo.value ? (f(), h("button", {
                        key: 0,
                        type: "button",
                        class: "fe-btn",
                        "data-testid": "e2e-names-stop",
                        onClick: s[15] || (s[15] = (Me) => vM(Ds) ? Ds.value = !0 : Ds = !0)
                      }, y(u(z)("e2e.names.stop")), 1)) : (f(), h("button", {
                        key: 1,
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-names-resume",
                        onClick: Wd
                      }, y(u(z)("e2e.names.resume")), 1))
                    ])
                  ])) : D("", !0),
                  Gn.value && (Zz.value || xr.value) ? (f(), h("div", cre, [
                    d("div", dre, [
                      d("strong", null, y(u(z)("e2e.password.resume_title")), 1),
                      d("p", null, y(u(z)("e2e.password.resume_body")), 1),
                      Is.value ? (f(), h("p", fre, y(u(z)("e2e.password.progress", { n: Is.value.done, failed: Is.value.failed })), 1)) : D("", !0),
                      Eu.value ? (f(), h("p", pre, y(Eu.value), 1)) : D("", !0)
                    ]),
                    d("div", hre, [
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        "data-testid": "e2e-rekey-resume",
                        disabled: xr.value,
                        onClick: kw
                      }, y(xr.value ? u(z)("e2e.password.busy") : u(z)("e2e.names.resume")), 9, mre)
                    ])
                  ])) : D("", !0),
                  Gn.value && vm.value ? (f(), We(u(i), {
                    key: 9,
                    locale: W.value,
                    state: vm.value,
                    onSettings: s[16] || (s[16] = (Me) => Bi.value = !0),
                    onLock: mm,
                    onTakeOver: s[17] || (s[17] = (Me) => u(j).takeOver(Ot.value)),
                    onContinue: s[18] || (s[18] = (Me) => u(j).continueFromShown(Ot.value)),
                    onDismiss: s[19] || (s[19] = (Me) => u(j).dismiss(Ot.value))
                  }, null, 8, ["locale", "state"])) : D("", !0),
                  Gn.value && !vm.value ? (f(), h("div", vre, [
                    d("span", {
                      class: "fe-e2e-strip__icon",
                      "aria-hidden": "true",
                      innerHTML: u(Pt)("lock")
                    }, null, 8, yre),
                    d("span", gre, y(u(z)("e2e.strip.label")), 1),
                    d("span", bre, y(hw.value ? u(z)("e2e.level.names") : u(z)("e2e.level.content")), 1),
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      "data-testid": "e2e-settings-open",
                      disabled: xr.value || fo.value,
                      onClick: s[20] || (s[20] = (Me) => Bi.value = !0)
                    }, y(u(z)("e2e.settings.open")), 9, kre),
                    d("button", {
                      type: "button",
                      class: "fe-btn fe-e2e-strip__btn",
                      onClick: mm
                    }, y(u(z)("e2e.strip.lock")), 1)
                  ])) : D("", !0),
                  Rt.value && !oe.value ? (f(), h("div", wre, [
                    d("p", _re, y(NE.value), 1),
                    kd.value ? (f(), h("p", xre, [
                      Vt(y(kd.value), 1),
                      Co.value < _s.value ? (f(), h("span", Sre, " · " + y(FE.value), 1)) : D("", !0)
                    ])) : D("", !0),
                    Co.value < _s.value ? (f(), h("button", {
                      key: 1,
                      type: "button",
                      class: "fe-btn fe-trashbar__more",
                      "data-testid": "trash-more",
                      disabled: wd.value,
                      onClick: UE
                    }, y(u(z)("trash.show_more")), 9, $re)) : D("", !0),
                    Xb.value ? (f(), h("p", Tre, y(Xb.value), 1)) : D("", !0),
                    Eo.value ? (f(), h("button", {
                      key: 3,
                      type: "button",
                      class: "fe-btn fe-btn--danger fe-trashbar__action",
                      disabled: _e.value.length === 0 || gd.value,
                      "data-testid": "trash-empty",
                      onClick: IE
                    }, y(u(z)("trash.empty_action")), 9, Are)) : D("", !0)
                  ])) : D("", !0)
                ]),
                body: mt(() => [
                  Bd.value === "home" ? (f(), We(PW, {
                    key: 0,
                    storages: kh.value,
                    recent: Cb.value,
                    starred: zb.value,
                    loading: gh.value,
                    locale: W.value,
                    "match-names": u($).matchNames,
                    "name-filter": ms.value.name ?? "",
                    "thumb-src": u(it).src,
                    onOpenStorage: Db,
                    onOpenNode: qa,
                    onContextNode: jh
                  }, null, 8, ["storages", "recent", "starred", "loading", "locale", "match-names", "name-filter", "thumb-src"])) : Bd.value === "drafts" ? (f(), We(jW, {
                    key: 1,
                    drafts: ih.value,
                    loading: rh.value,
                    limit: oh.value,
                    locale: W.value,
                    "name-filter": ms.value.name ?? "",
                    "match-names": u($).matchNames,
                    "busy-key": ar.value,
                    onOpen: s[21] || (s[21] = (Me) => fb(Me)),
                    onSave: EA,
                    onDelete: CA
                  }, null, 8, ["drafts", "loading", "limit", "locale", "name-filter", "match-names", "busy-key"])) : Bd.value === "notfound" ? (f(), h("div", Ere, [
                    s[114] || (s[114] = d("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      d("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }),
                      d("path", { d: "M52 55c0-4.6 3.6-8 8-8s8 3.4 8 8c0 5.5-8 4.8-8 11" }),
                      d("circle", {
                        cx: "60",
                        cy: "73",
                        r: "1.6",
                        fill: "currentColor",
                        stroke: "none"
                      })
                    ], -1)),
                    d("p", Cre, y(u(z)("notFound.title")), 1),
                    d("p", zre, y(we.value), 1),
                    d("p", Mre, y(u(z)("notFound.desc")), 1),
                    d("div", Ore, [
                      d("button", {
                        type: "button",
                        class: "fe-btn",
                        onClick: LE
                      }, y(u(z)("notFound.goRoot")), 1)
                    ])
                  ])) : (f(), We(hT, {
                    key: 3,
                    locale: W.value,
                    busy: Hd.value,
                    error: cm.value,
                    onUnlock: xz,
                    onRecovery: lw
                  }, null, 8, ["locale", "busy", "error"]))
                ]),
                empty: mt(() => [
                  ye.value ? (f(), h("div", Pre, [
                    s[115] || (s[115] = d("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      d("circle", {
                        cx: "52",
                        cy: "44",
                        r: "22"
                      }),
                      d("path", { d: "M68 61l20 20" }),
                      d("path", { d: "M46 38l12 12M58 38l-12 12" })
                    ], -1)),
                    d("p", Dre, y(u(z)("empty.search.title")), 1),
                    d("p", Lre, y(u(z)("empty.search.hint")), 1)
                  ])) : gt.value && gt.value !== "trash" ? (f(), h("div", {
                    key: 1,
                    class: "fe-state",
                    "data-testid": `empty-${gt.value}`
                  }, [
                    (f(), h("svg", Nre, [
                      gt.value === "recent" ? (f(), h(Ce, { key: 0 }, [
                        s[116] || (s[116] = d("circle", {
                          cx: "60",
                          cy: "50",
                          r: "28"
                        }, null, -1)),
                        s[117] || (s[117] = d("path", { d: "M60 32v18l12 8" }, null, -1))
                      ], 64)) : gt.value === "starred" ? (f(), h("path", Ire)) : gt.value === "tag" ? (f(), h(Ce, { key: 2 }, [
                        s[118] || (s[118] = d("path", { d: "M30 30h24l32 32-24 24-32-32z" }, null, -1)),
                        s[119] || (s[119] = d("circle", {
                          cx: "43",
                          cy: "43",
                          r: "4.5"
                        }, null, -1))
                      ], 64)) : (f(), h(Ce, { key: 3 }, [
                        s[120] || (s[120] = d("circle", {
                          cx: "84",
                          cy: "34",
                          r: "9"
                        }, null, -1)),
                        s[121] || (s[121] = d("circle", {
                          cx: "36",
                          cy: "52",
                          r: "9"
                        }, null, -1)),
                        s[122] || (s[122] = d("circle", {
                          cx: "84",
                          cy: "70",
                          r: "9"
                        }, null, -1)),
                        s[123] || (s[123] = d("path", { d: "M44.5 47.5l31-9M44.5 56.5l31 9" }, null, -1))
                      ], 64))
                    ])),
                    d("p", Bre, y(gt.value === "tag" ? u(z)("empty.tag.title", { tag: sn.value }) : u(z)(`empty.${gt.value}.title`)), 1),
                    d("p", Fre, y(gt.value === "tag" ? u(z)("empty.tag.hint") : u(z)(`empty.${gt.value}.hint`)), 1)
                  ], 8, Rre)) : Rt.value ? (f(), h("div", Ure, [
                    s[124] || (s[124] = d("svg", {
                      class: "fe-state__art",
                      viewBox: "0 0 120 100",
                      width: "110",
                      height: "92",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "aria-hidden": "true"
                    }, [
                      d("path", { d: "M38 34l4 48a6 6 0 0 0 6 5.6h24a6 6 0 0 0 6-5.6l4-48" }),
                      d("path", { d: "M32 34h56" }),
                      d("path", { d: "M50 34v-6a6 6 0 0 1 6-6h8a6 6 0 0 1 6 6v6" }),
                      d("path", {
                        d: "M52 44v32M60 44v32M68 44v32",
                        opacity: "0.5"
                      })
                    ], -1)),
                    d("p", Hre, y(u(z)("empty.trash.title")), 1),
                    d("p", Kre, y(u(z)("empty.trash.hint")), 1)
                  ])) : (f(), h("div", Vre, [
                    (f(), h("svg", jre, [
                      s[126] || (s[126] = d("path", { d: "M18 36v42a6 6 0 0 0 6 6h72a6 6 0 0 0 6-6V44a6 6 0 0 0-6-6H62l-9-10H24a6 6 0 0 0-6 6z" }, null, -1)),
                      hd.value ? (f(), h("g", qre, [...s[125] || (s[125] = [
                        d("path", {
                          d: "M60 50v14",
                          "stroke-dasharray": "3 4"
                        }, null, -1),
                        d("path", { d: "M53 59l7 8 7-8" }, null, -1)
                      ])])) : D("", !0)
                    ])),
                    d("p", Wre, y(u(z)("empty.folder")), 1),
                    hd.value ? (f(), h("p", Yre, y(u(z)("empty.hint")), 1)) : D("", !0),
                    hd.value ? (f(), h("div", Gre, [
                      d("button", {
                        type: "button",
                        class: "fe-btn fe-btn--primary",
                        onClick: Mo
                      }, y(u(z)("empty.upload")), 1)
                    ])) : D("", !0)
                  ]))
                ]),
                _: 1
              }, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "rows", "loading", "error", "order", "view-mode", "view-modes", "open-trigger", "show-crumbs", "filter-mode", "find-label", "show-view-switcher", "folder-key", "show-parent-path", "trash", "clipped", "extra-filters", "extra-filters-on-server", "can-write", "can-paste", "selected", "filters", "thumb-src", "folder-previews", "keep-badge-for", "starred-ids", "star-overrides", "star-enabled", "api-base", "auth-headers", "auth-credentials", "e2e-active", "body-override"]),
              Cs.value && lo.value ? (f(), We(d0, {
                ref_key: "splitPaneRef",
                ref: en,
                key: "split-" + u(rm),
                "pane-id": "split",
                "self-driven": "",
                closable: "",
                api: K,
                locale: W.value,
                theme: An.value,
                focused: On.value,
                path: lo.value.path,
                qualify: It,
                "to-user": Li,
                clamp: qk,
                "root-path": u(Se),
                floor: u(he),
                "multi-root": En.value,
                "virtual-rows": qb,
                "trash-visible": e.config.trashVisible !== !1,
                "nav-offers-trash": yb.value,
                "view-mode": Uk.value,
                "view-modes": hh.value,
                "open-trigger": P.config.openTrigger,
                clipped: tm.value,
                "can-write": li.value,
                "can-paste": !!ie.value.mode,
                selected: u(Wn).selected.value,
                filters: yu.value,
                "folder-key": az.value,
                "thumb-src": u(it).src,
                "folder-previews": ((Y = ue.value) == null ? void 0 : Y.folder_previews) !== !1,
                "keep-badge-for": ci.value ? rk : void 0,
                "starred-ids": ob.value,
                "star-overrides": ns.value,
                "star-enabled": ps.value,
                "api-base": P.config.apiBase ?? "",
                "auth-headers": () => Qn(),
                "auth-credentials": u($).credentialsMode(),
                onActivate: s[32] || (s[32] = (Me) => pi.value = "split"),
                onClose: oz,
                onNavigate: rz,
                onOpen: qa,
                onOpenTrash: lz,
                onClickRow: s[33] || (s[33] = (Me, Xn) => gk("split", Me, Xn)),
                onContext: s[34] || (s[34] = (Me, Xn) => ck("split", Me, Xn)),
                onClearSelection: s[35] || (s[35] = (Me) => u(Wn).clear()),
                onDisplayOrder: s[36] || (s[36] = (Me) => vu.value = Me),
                onItemDragStart: s[37] || (s[37] = (Me, Xn) => bk("split", Me, Xn)),
                onItemDropInto: Ek,
                onTransfer: Jk,
                "onUpdate:viewMode": Hk,
                "onUpdate:filters": s[38] || (s[38] = (Me) => yu.value = Me),
                onCopyPath: Pd,
                onCrumbDrop: Ck,
                onNewFolder: s[39] || (s[39] = (Me) => ua.value = !0),
                onUpload: Mo,
                onPaste: s[40] || (s[40] = (Me) => Uh("paste")),
                onSelectAll: s[41] || (s[41] = (Me) => u(Wn).selectAll()),
                onClearFilters: s[42] || (s[42] = (Me) => yu.value = { ...u(Ko) }),
                onStarChange: rb
              }, null, 8, ["api", "locale", "theme", "focused", "path", "root-path", "floor", "multi-root", "trash-visible", "nav-offers-trash", "view-mode", "view-modes", "open-trigger", "clipped", "can-write", "can-paste", "selected", "filters", "folder-key", "thumb-src", "folder-previews", "keep-badge-for", "starred-ids", "star-overrides", "star-enabled", "api-base", "auth-headers", "auth-credentials"])) : D("", !0)
            ])
          ]),
          Ra.value ? (f(), We(d9, {
            key: 2,
            api: Ye,
            nodes: jk.value,
            "dir-label": yz.value,
            "dir-count": gz.value,
            "dir-perm": bz.value,
            "held-in": vz.value,
            locale: W.value,
            narrow: Ta.value,
            "caller-admin": ha.value,
            sharing: hz.value,
            "in-encrypted": mz.value,
            "thumb-src": u(it).src,
            "api-base": P.config.apiBase ?? "",
            "auth-headers": () => Qn(),
            "auth-credentials": u($).credentialsMode(),
            "plugin-views": pA.value,
            theme: An.value,
            storages: (P.config.storages ?? []).map((Me) => Me.name),
            "user-name": P.config.userName || "",
            onPluginOp: s[43] || (s[43] = (Me) => Ul(Me)),
            onPluginOpen: s[44] || (s[44] = (Me) => th(Me.plugin, Me.req)),
            onOpenTag: wA,
            onClose: mb,
            onShareCreated: yE,
            onManagePermissions: SE,
            onToast: et,
            onChanged: s[45] || (s[45] = () => {
              var Me;
              return On.value ? void ((Me = en.value) == null ? void 0 : Me.reload()) : void kt();
            })
          }, null, 8, ["api", "nodes", "dir-label", "dir-count", "dir-perm", "held-in", "locale", "narrow", "caller-admin", "sharing", "in-encrypted", "thumb-src", "api-base", "auth-headers", "auth-credentials", "plugin-views", "theme", "storages", "user-name", "onOpenTag", "onShareCreated"])) : D("", !0),
          ao.value && ch.value ? (f(), We(lV, {
            key: 3,
            client: u(YA),
            locale: W.value,
            selection: XA.value,
            narrow: Ta.value,
            onClose: s[46] || (s[46] = (Me) => ao.value = !1),
            onChanged: s[47] || (s[47] = () => {
              var Me;
              return On.value ? void ((Me = en.value) == null ? void 0 : Me.reload()) : void kt();
            })
          }, null, 8, ["client", "locale", "selection", "narrow"])) : D("", !0)
        ], 2),
        hs.value || Zl.value ? (f(), h("div", {
          key: 0,
          class: "fe-overlay",
          "data-testid": "explorer-overlay",
          onClick: vt(id, ["self"])
        }, [
          d("div", {
            class: "fe-overlay__card",
            onClick: s[48] || (s[48] = vt(() => {
            }, ["stop"]))
          }, [
            hs.value ? (f(), We(DX, {
              key: 0,
              config: e.config,
              closable: "",
              onClose: id,
              onError: rE
            }, null, 8, ["config"])) : (f(), h(Ce, { key: 1 }, [
              d("header", Xre, [
                d("h2", Jre, y(u(z)("sidenav.apikeys")), 1),
                d("button", {
                  type: "button",
                  class: "fe-overlay__close",
                  title: u(z)("overlay.close"),
                  "aria-label": u(z)("overlay.close"),
                  onClick: id
                }, " × ", 8, Zre)
              ]),
              Je(nT, {
                config: e.config,
                full: ""
              }, null, 8, ["config"])
            ], 64))
          ])
        ])) : D("", !0),
        Po.value ? (f(), h("div", Qre, [
          d("div", ese, [
            d("span", {
              class: "fe-icon",
              "aria-hidden": "true",
              innerHTML: u(Pt)("upload")
            }, null, 8, tse),
            d("p", null, y(u(z)("dropzone.hint")), 1)
          ])
        ])) : D("", !0),
        Je(S5, {
          jobs: qn.value,
          locale: W.value,
          center: u(mu),
          onCancel: FC,
          onDismiss: UC,
          onRetry: YC
        }, null, 8, ["jobs", "locale", "center"]),
        Je(T5, {
          ops: u(ze).ops.value,
          locale: W.value,
          center: u(mu),
          "output-mode-of": yA,
          "caller-admin": ha.value,
          onCancel: EC,
          onDismiss: s[49] || (s[49] = (Me) => u(ze).dismiss(Me)),
          onOpen: bA
        }, null, 8, ["ops", "locale", "center", "caller-admin"]),
        Je(EZ, {
          center: u(mu),
          locale: W.value,
          narrow: Ta.value
        }, null, 8, ["center", "locale", "narrow"]),
        Ta.value && hd.value ? (f(), h("button", {
          key: 2,
          type: "button",
          class: "fe-fab",
          title: u(z)("toolbar.upload"),
          "aria-label": u(z)("toolbar.upload"),
          onClick: Mo
        }, [...s[127] || (s[127] = [
          d("svg", {
            class: "fe-ficon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2",
            "stroke-linecap": "round",
            "aria-hidden": "true",
            focusable: "false"
          }, [
            d("path", { d: "M12 5v14M5 12h14" })
          ], -1)
        ])], 8, nse)) : D("", !0),
        Ss.value ? (f(), h("div", ase, [
          s[128] || (s[128] = d("span", {
            class: "fe-keep-strip__icon",
            "aria-hidden": "true"
          }, "⟳", -1)),
          d("span", ise, y(rC.value), 1),
          sk.value !== null ? (f(), h("div", ose, [
            d("div", {
              class: "fe-keep-strip__fill",
              style: Xt({ width: sk.value + "%" })
            }, null, 4)
          ])) : D("", !0)
        ])) : D("", !0),
        Je(ml, {
          ref_key: "ctxRef",
          ref: zh,
          locale: W.value,
          theme: An.value,
          sheet: Vb.value,
          actions: dk.value,
          onSelect: vC
        }, null, 8, ["locale", "theme", "sheet", "actions"]),
        Je(u(k), {
          open: ql.value,
          locale: W.value,
          theme: An.value,
          api: u($),
          types: cb.value,
          "current-path": It(Le.value),
          storages: (P.config.storages ?? []).map((Me) => Me.name),
          "only-office-ready": !!tr.value,
          "drawio-ready": !!Vl.value,
          "can-configure": ha.value,
          "withheld-words": ((de = ue.value) == null ? void 0 : de.newdoc_withheld) ?? null,
          drafts: nr.value,
          onClose: s[50] || (s[50] = (Me) => ql.value = !1),
          onOpenDrafts: OA,
          onCreated: _C,
          onError: s[51] || (s[51] = (Me) => H("error", { message: Me.message, context: { op: "newdoc" } }))
        }, null, 8, ["open", "locale", "theme", "api", "types", "current-path", "storages", "only-office-ready", "drawio-ready", "can-configure", "withheld-words", "drafts"]),
        Je(cae, {
          open: ua.value,
          locale: W.value,
          "encrypted-option": ew.value === "allowed",
          "encrypted-request": ew.value === "request",
          busy: u(FA),
          error: u(UA),
          onClose: s[52] || (s[52] = (Me) => ua.value = !1),
          onSubmit: CC,
          onEncrypted: s[53] || (s[53] = (Me) => {
            ua.value = !1, fr.value = !0;
          }),
          onRequestEncrypted: wz
        }, null, 8, ["open", "locale", "encrypted-option", "encrypted-request", "busy", "error"]),
        Je(u(_), {
          open: Zc.value,
          locale: W.value,
          count: Wl.value.length,
          "suggested-name": PA.value,
          "default-format": LA.value,
          "allowed-formats": Yl.value,
          encryption: RA.value,
          busy: lh.value,
          "request-error": Ai.value,
          onClose: s[54] || (s[54] = (Me) => Zc.value = !1),
          onSubmit: SC
        }, null, 8, ["open", "locale", "count", "suggested-name", "default-format", "allowed-formats", "encryption", "busy", "request-error"]),
        Je(gae, {
          open: ir.value,
          locale: W.value,
          "archive-name": (($e = $o.value) == null ? void 0 : $e.basename) || "",
          "suggested-folder": NA.value,
          busy: !!$o.value && or.value.has($o.value.path),
          error: Ai.value,
          onClose: s[55] || (s[55] = (Me) => ir.value = !1),
          onSubmit: $C
        }, null, 8, ["open", "locale", "archive-name", "suggested-folder", "busy", "error"]),
        Je(Tae, {
          open: os.value,
          locale: W.value,
          "archive-name": ((Ee = rr.value) == null ? void 0 : Ee.target.basename) || ((st = $o.value) == null ? void 0 : st.basename) || "",
          busy: !!rr.value && or.value.has(rr.value.target.path),
          error: ls.value,
          onClose: AC,
          onSubmit: TC
        }, null, 8, ["open", "locale", "archive-name", "busy", "error"]),
        Je(bg, {
          open: fs.value,
          api: K,
          "vault-roots": jA.value,
          "vault-from": qA.value,
          locale: W.value,
          mode: Qc.value,
          busy: td.value,
          storages: (P.config.storages ?? []).map((Me) => Me.name),
          "start-at": It(On.value ? ((Ze = en.value) == null ? void 0 : Ze.getPath()) ?? "" : Le.value),
          moving: Qc.value === "move" ? ed.value.filter((Me) => Me.type === "dir").map((Me) => Me.path) : [],
          onClose: s[56] || (s[56] = (Me) => fs.value = !1),
          onPick: wC
        }, null, 8, ["open", "api", "vault-roots", "vault-from", "locale", "mode", "busy", "storages", "start-at", "moving"]),
        Je(u(C), {
          open: fr.value,
          locale: W.value,
          busy: pr.value,
          "escrow-kid": Wa.value,
          existing: kr.value ? kr.value.basename : null,
          "vault-available": ((Lt = ue.value) == null ? void 0 : Lt.e2e_vault) === !0,
          onClose: s[57] || (s[57] = (Me) => {
            fr.value = !1, kr.value = null;
          }),
          onSubmit: s[58] || (s[58] = (Me) => kr.value ? Yz(Me) : zz(Me))
        }, null, 8, ["open", "locale", "busy", "escrow-kid", "existing", "vault-available"]),
        Je(One, {
          open: !!hr.value,
          locale: W.value,
          api: u($),
          path: ((Pn = hr.value) == null ? void 0 : Pn.path) ?? "",
          kind: ((Mt = hr.value) == null ? void 0 : Mt.kind) ?? "folder",
          name: ((Ya = hr.value) == null ? void 0 : Ya.name) ?? "",
          onClose: s[59] || (s[59] = (Me) => hr.value = null),
          onSent: _z
        }, null, 8, ["open", "locale", "api", "path", "kind", "name"]),
        Je(u(R), {
          open: Do.value,
          locale: W.value,
          "recovery-key": Lo.value,
          "folder-name": Ro.value,
          "escrow-kid": Wa.value,
          variant: mr.value,
          onClose: oM
        }, null, 8, ["open", "locale", "recovery-key", "folder-name", "escrow-kid", "variant"]),
        Je(u(A), {
          open: Bi.value,
          locale: W.value,
          level: qd.value,
          "can-raise": Kz.value,
          "plain-named": Vz.value,
          "escrow-state": uw.value === "n/a" || No.value ? "n/a" : uw.value,
          busy: fo.value,
          onClose: s[60] || (s[60] = (Me) => Bi.value = !1),
          onRaiseLevel: Wd,
          onFixNames: Wd,
          onChangePassword: Xz,
          onEscrow: Jz
        }, null, 8, ["open", "locale", "level", "can-raise", "plain-named", "escrow-state", "busy"]),
        Je(u(T), {
          open: Rs.value,
          locale: W.value,
          mode: wm.value,
          "needs-rekey": Qz.value,
          vault: qd.value === "vault",
          "has-recovery": u(C_)(on.value),
          "has-escrow": u(Mx)(on.value),
          busy: Au.value,
          error: _r.value,
          onClose: eM,
          onSubmit: tM
        }, null, 8, ["open", "locale", "mode", "needs-rekey", "vault", "has-recovery", "has-escrow", "busy", "error"]),
        Je(u(M), {
          open: Kd.value,
          locale: W.value,
          "has-recovery": u(C_)(on.value),
          "escrow-state": u(Ox)(on.value, Wa.value),
          "escrow-kid": ((Cn = (gn = on.value) == null ? void 0 : gn.esc) == null ? void 0 : Cn.kid) || Wa.value,
          busy: fm.value,
          error: co.value,
          onClose: s[61] || (s[61] = (Me) => Kd.value = !1),
          onSubmit: Rz
        }, null, 8, ["open", "locale", "has-recovery", "escrow-state", "escrow-kid", "busy", "error"]),
        Je(u(L), {
          open: !!u(Dt).encryptTarget.value,
          locale: W.value,
          "file-name": ((Fi = u(Dt).encryptTarget.value) == null ? void 0 : Fi.basename) ?? "",
          busy: u(Dt).encryptBusy.value,
          error: u(Dt).encryptError.value,
          progress: u(Dt).encryptProgress.value,
          "escrow-kid": Wa.value,
          "can-purge": ha.value,
          "not-owner": !!u(Dt).encryptTarget.value && !u(Lp)(u(Dt).encryptTarget.value),
          "owner-name": u(Dt).encryptTarget.value ? u(cg)(u(Dt).encryptTarget.value) : "",
          onClose: s[62] || (s[62] = (Me) => u(Dt).closeEncrypt()),
          onSubmit: s[63] || (s[63] = (Me) => u(Dt).submitEncrypt(Me))
        }, null, 8, ["open", "locale", "file-name", "busy", "error", "progress", "escrow-kid", "can-purge", "not-owner", "owner-name"]),
        Je(u(U), {
          open: !!u(Dt).unlockTarget.value,
          locale: W.value,
          intent: u(Dt).unlockIntent.value,
          "file-name": u(Dt).unlockTarget.value ? u(Dt).realName(u(Dt).unlockTarget.value.path) ?? u(Dt).unlockTarget.value.basename : "",
          known: !!u(Dt).unlockTarget.value && !!u(Dt).realName(u(Dt).unlockTarget.value.path),
          "has-recovery": u(Dt).unlockHasRecovery.value,
          busy: u(Dt).unlockBusy.value,
          error: u(Dt).unlockError.value,
          progress: u(Dt).unlockProgress.value,
          "needs-save": u(Dt).unlockNeedsSave.value,
          "escrow-state": u(Dt).unlockEscrow.value,
          "escrow-kid": u(Dt).unlockEscrowKid.value || Wa.value,
          onClose: s[64] || (s[64] = (Me) => u(Dt).closeUnlock()),
          onSubmit: s[65] || (s[65] = (Me) => u(Dt).submitUnlock(Me))
        }, null, 8, ["open", "locale", "intent", "file-name", "known", "has-recovery", "busy", "error", "progress", "needs-save", "escrow-state", "escrow-kid"]),
        Je(Fte, {
          open: !!u(Dt).tooBig.value,
          locale: W.value,
          info: u(Dt).tooBig.value,
          onClose: s[66] || (s[66] = (Me) => u(Dt).closeTooBig()),
          onDownload: iM
        }, null, 8, ["open", "locale", "info"]),
        Je(u(T), {
          open: !!u(Dt).pwTarget.value,
          locale: W.value,
          mode: "change",
          subject: "file",
          "needs-rekey": !1,
          "has-recovery": !0,
          "has-escrow": !1,
          busy: u(Dt).pwBusy.value,
          error: u(Dt).pwError.value,
          onClose: s[67] || (s[67] = (Me) => u(Dt).closePassword()),
          onSubmit: s[68] || (s[68] = (Me) => u(Dt).submitPassword(Me))
        }, null, 8, ["open", "locale", "busy", "error"]),
        Je(Nae, {
          open: no.value,
          locale: W.value,
          "current-name": ((Ga = sr.value) == null ? void 0 : Ga.basename) || "",
          error: u(BA),
          busy: u(IA),
          onClose: s[69] || (s[69] = (Me) => no.value = !1),
          onSubmit: zC
        }, null, 8, ["open", "locale", "current-name", "error", "busy"]),
        Je(na, {
          open: su.value,
          title: u(z)("trash.empty_confirm_title"),
          size: "sm",
          onClose: s[71] || (s[71] = (Me) => su.value = !1)
        }, {
          actions: mt(() => [
            d("button", {
              type: "button",
              class: "fe-btn",
              onClick: s[70] || (s[70] = (Me) => su.value = !1)
            }, y(u(z)("modal.delete.cancel")), 1),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--danger",
              "data-testid": "trash-empty-confirm",
              disabled: !ws.value || ws.value.count === 0,
              onClick: BE
            }, y(u(z)("trash.empty_action")), 9, use)
          ]),
          default: mt(() => [
            ws.value ? (f(), h("p", rse, y(ws.value.summary), 1)) : bd.value ? (f(), h("p", sse, y(bd.value), 1)) : (f(), h("p", lse, y(u(z)("trash.empty_counting")), 1))
          ]),
          _: 1
        }, 8, ["open", "title"]),
        Je(Uae, {
          open: ma.value,
          locale: W.value,
          count: u(tt).size.value,
          permanent: Rt.value || Oz.value,
          busy: u(HA),
          error: u(KA),
          onClose: s[72] || (s[72] = (Me) => ma.value = !1),
          onConfirm: OC
        }, null, 8, ["open", "locale", "count", "permanent", "busy", "error"]),
        Je(u(r), {
          open: ca.value,
          locale: W.value,
          file: hn.value,
          theme: An.value,
          "preview-url": (Me) => jd(Me),
          "download-url": (Me) => Gn.value || bu.value || u(j).rootOf(Me) ? jd(Me) : u($).downloadUrl(Me),
          "only-office-base": an.value || bu.value || $u.value ? null : tr.value,
          "only-office-config-endpoint": ub.value,
          "can-configure": ha.value,
          "new-tab-enabled": !an.value && !bu.value && !$u.value,
          "save-text-endpoint": an.value || bu.value || $u.value ? null : u($).endpoints.saveText || null,
          "archive-list-endpoint": $u.value ? null : u($).endpoints.archiveList || null,
          "open-mode": Ha.value,
          "open-as": VA.value,
          "auth-headers": () => Qn({ "Content-Type": "application/json" }),
          "auth-credentials": u($).credentialsMode(),
          "drawio-url": Vl.value,
          "pdf-worker-url": P.config.pdfWorkerUrl || null,
          "pdf-save-url": P.config.pdfSaveUrl || null,
          "viewer-base-url": Mk.value,
          index: se.value.index,
          total: se.value.total,
          "nav-enabled": se.value.total > 1,
          "share-enabled": !an.value && !bu.value && !$u.value,
          onShare: s[73] || (s[73] = (Me) => {
            const Xn = Me ?? hn.value;
            Xn && (si.value = Xn, eu.value = void 0, lr.value = !0);
          }),
          "api-base": P.config.apiBase ?? "",
          "drafts-endpoint": nr.value ? u($).draftsBase : null,
          "app-viewer": Zg.value,
          "app-e2e": Az.value,
          "in-office": oA.value,
          api: u($),
          "user-name": P.config.userName || "",
          storages: (P.config.storages ?? []).map((Me) => Me.name),
          onToast: et,
          onOp: s[74] || (s[74] = (Me) => Ul(Me)),
          onNav: je,
          onDraftSaved: zA,
          onDraftDiscarded: MA,
          onSaved: dt,
          onAppDirty: $z,
          onClose: s[75] || (s[75] = (Me) => ca.value = !1)
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "new-tab-enabled", "save-text-endpoint", "archive-list-endpoint", "open-mode", "open-as", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "pdf-save-url", "viewer-base-url", "index", "total", "nav-enabled", "share-enabled", "api-base", "drafts-endpoint", "app-viewer", "app-e2e", "in-office", "api", "user-name", "storages", "onAppDirty"]),
        Je(fie, {
          open: !!La.value,
          locale: W.value,
          theme: An.value,
          name: ((Xd = La.value) == null ? void 0 : Xd.basename) ?? "",
          kind: uA.value,
          handlers: lA.value,
          current: cA.value,
          remembered: La.value ? Il(La.value) : null,
          onCancel: s[76] || (s[76] = (Me) => La.value = null),
          onOpen: dA
        }, null, 8, ["open", "locale", "theme", "name", "kind", "handlers", "current", "remembered"]),
        Je(x0, {
          open: !!X.value,
          kind: "upload",
          locale: W.value,
          theme: An.value,
          name: ((xw = X.value) == null ? void 0 : xw.name) ?? "",
          suggested: ((Sw = X.value) == null ? void 0 : Sw.suggested) ?? "",
          folder: (($w = X.value) == null ? void 0 : $w.folder) ?? "",
          onCancel: s[77] || (s[77] = (Me) => V(!1)),
          onConfirm: s[78] || (s[78] = (Me) => V(!0))
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder"]),
        Je(x0, {
          open: !!u(to).question.value,
          locale: W.value,
          theme: An.value,
          name: ((Tw = u(to).question.value) == null ? void 0 : Tw.name) ?? "",
          suggested: ((Aw = u(to).question.value) == null ? void 0 : Aw.suggested) ?? "",
          folder: ((Ew = u(to).question.value) == null ? void 0 : Ew.folder) ?? "",
          busy: u(to).busy.value,
          error: u(to).error.value,
          onCancel: u(to).cancel,
          onConfirm: u(to).confirm
        }, null, 8, ["open", "locale", "theme", "name", "suggested", "folder", "busy", "error", "onCancel", "onConfirm"]),
        Da.value ? (f(), We(nie, {
          key: `${Da.value.plugin}/${Da.value.view}`,
          api: u($),
          locale: W.value,
          theme: An.value,
          plugin: Da.value.plugin,
          view: Da.value.view,
          placement: Da.value.placement,
          ui: Da.value.ui,
          label: Da.value.label,
          files: Da.value.files,
          "user-name": P.config.userName || "",
          storages: (P.config.storages ?? []).map((Me) => Me.name),
          "start-at": It(On.value ? ((Cw = en.value) == null ? void 0 : Cw.getPath()) ?? "" : Le.value),
          onClose: s[79] || (s[79] = (Me) => Da.value = null),
          onToast: et,
          onOp: s[80] || (s[80] = (Me) => Ul(Me))
        }, null, 8, ["api", "locale", "theme", "plugin", "view", "placement", "ui", "label", "files", "user-name", "storages", "start-at"])) : D("", !0),
        _n.value ? (f(), We(eie, {
          key: 5,
          open: nA.value,
          api: u($),
          locale: W.value,
          theme: An.value,
          plugin: _n.value.plugin,
          view: _n.value.view,
          surface: _n.value.surface,
          path: _n.value.path,
          paths: _n.value.paths,
          size: _n.value.size,
          label: _n.value.label,
          storages: (P.config.storages ?? []).map((Me) => Me.name),
          "start-at": It(On.value ? ((zw = en.value) == null ? void 0 : zw.getPath()) ?? "" : Le.value),
          onClose: s[81] || (s[81] = (Me) => _n.value = null),
          onOp: s[82] || (s[82] = (Me) => Ul(Me)),
          onToast: et,
          onOpen: s[83] || (s[83] = (Me) => {
            var Xn;
            return th(((Xn = _n.value) == null ? void 0 : Xn.plugin) ?? "", Me);
          })
        }, null, 8, ["open", "api", "locale", "theme", "plugin", "view", "surface", "path", "paths", "size", "label", "storages", "start-at"])) : D("", !0),
        Je(D$, {
          open: !!Ti.value,
          locale: W.value,
          theme: An.value,
          title: Ti.value ? u(Zt)(Ti.value.action.label, W.value) : "",
          message: Ti.value ? u(Zt)(Ti.value.action.confirm, W.value) : "",
          danger: ((Mw = Ti.value) == null ? void 0 : Mw.action.danger) === !0,
          onClose: s[84] || (s[84] = (Me) => Ti.value = null),
          onConfirm: gA
        }, null, 8, ["open", "locale", "theme", "title", "message", "danger"]),
        lr.value && si.value ? (f(), We(u(m), {
          key: 6,
          api: u($),
          path: si.value.path,
          "is-dir": si.value.type === "dir",
          locale: W.value,
          "share-max-ttl-days": eo.value,
          "initial-tab": eu.value,
          "mail-ready": (Pw = (Ow = ue.value) == null ? void 0 : Ow.mail) == null ? void 0 : Pw.ready,
          "can-configure": ha.value,
          perm: si.value.perm || Ie.value,
          sharing: zE.value,
          onClose: s[85] || (s[85] = (Me) => {
            lr.value = !1, eu.value = void 0;
          })
        }, null, 8, ["api", "path", "is-dir", "locale", "share-max-ttl-days", "initial-tab", "mail-ready", "can-configure", "perm", "sharing"])) : D("", !0),
        Je(zr, { name: "fe-modal" }, {
          default: mt(() => [
            as.value ? (f(), h("div", {
              key: 0,
              class: Ne(["fe fe-modal__backdrop fe-recents__backdrop", {
                "fe--theme-light": An.value === "light",
                "fe--theme-dark": An.value === "dark"
              }]),
              onClick: s[89] || (s[89] = (Me) => as.value = !1)
            }, [
              d("div", {
                class: "fe-recents__panel",
                onClick: s[88] || (s[88] = vt(() => {
                }, ["stop"]))
              }, [
                d("div", cse, [
                  d("strong", null, y(u(z)("recents.title")), 1),
                  d("button", {
                    class: "fe-recents__close",
                    "aria-label": u(z)("recents.close"),
                    onClick: s[86] || (s[86] = (Me) => as.value = !1)
                  }, "×", 8, dse)
                ]),
                Je(d5, {
                  locale: W.value,
                  "api-base": P.config.apiBase ?? "",
                  "auth-headers": () => Qn(),
                  "auth-credentials": u($).credentialsMode(),
                  limit: 20,
                  "refresh-key": ab.value,
                  onOpen: SA,
                  onContext: $A,
                  onError: s[87] || (s[87] = (Me) => H("error", { message: Me, context: { op: "recents" } }))
                }, null, 8, ["locale", "api-base", "auth-headers", "auth-credentials", "refresh-key"])
              ])
            ], 2)) : D("", !0)
          ]),
          _: 1
        }),
        Je(zr, { name: "fe-modal" }, {
          default: mt(() => [
            Hl.value && Kl.value && typeof Kl.value.id == "number" ? (f(), h("div", {
              key: 0,
              class: "fe-modal__backdrop",
              onClick: s[94] || (s[94] = (Me) => Hl.value = !1)
            }, [
              d("div", {
                class: "fe-modal__card fe-modal__card--md",
                onClick: s[93] || (s[93] = vt(() => {
                }, ["stop"]))
              }, [
                d("header", fse, [
                  d("h2", pse, y(u(z)("tags.title")) + " - " + y(Kl.value.basename), 1),
                  d("button", {
                    class: "fe-modal__close",
                    "aria-label": u(z)("tags.close"),
                    onClick: s[90] || (s[90] = (Me) => Hl.value = !1)
                  }, "×", 8, hse)
                ]),
                d("div", mse, [
                  Je(q2, {
                    "node-id": Kl.value.id,
                    locale: W.value,
                    "api-base": P.config.apiBase ?? "",
                    "auth-headers": () => Qn(),
                    "auth-credentials": u($).credentialsMode(),
                    onOpen: s[91] || (s[91] = (Me) => {
                    }),
                    onError: s[92] || (s[92] = (Me) => H("error", { message: Me, context: { op: "tags" } }))
                  }, null, 8, ["node-id", "locale", "api-base", "auth-headers", "auth-credentials"])
                ])
              ])
            ])) : D("", !0)
          ]),
          _: 1
        }),
        Je(u(v), {
          open: Ql.value,
          locale: W.value,
          theme: An.value,
          "initial-query": $b.value,
          "folder-label": Tb.value,
          "path-base": _b.value,
          "content-search": uE.value,
          count: dE,
          "known-tags": wb.value,
          onClose: s[95] || (s[95] = (Me) => Ql.value = !1),
          onSubmit: pE
        }, null, 8, ["open", "locale", "theme", "initial-query", "folder-label", "path-base", "content-search", "known-tags"]),
        Je(u(x), {
          "initial-query": vh.value,
          open: xd.value,
          locale: W.value,
          files: _e.value,
          "view-mode": xe.value,
          "can-write": li.value && !De.value && !nn.value,
          "can-go-up": me.value,
          "global-search": jE,
          "hit-can": YE,
          onClose: s[96] || (s[96] = (Me) => xd.value = !1),
          onOpenHit: WE,
          onDownloadHit: XE,
          onDragHit: JE,
          onWarmHit: GE,
          onDropInside: ZE,
          onOpenNode: qa,
          onNavigate: s[97] || (s[97] = (Me) => kt(Me)),
          onNewFolder: s[98] || (s[98] = (Me) => ua.value = !0),
          onUpload: Mo,
          onToggleView: s[99] || (s[99] = (Me) => Kk(lm.value === "list" ? "grid" : lm.value === "grid" ? "gallery" : "list")),
          onOpenTrash: zi,
          onRefresh: Yb,
          onGoUp: Ve,
          onOpenTheme: s[100] || (s[100] = (Me) => Dd.value = !0),
          onOpenShortcutSettings: s[101] || (s[101] = (Me) => hu.value = !0),
          onStartTour: s[102] || (s[102] = (Me) => om()),
          "split-enabled": gu.value,
          onTabNew: s[103] || (s[103] = (Me) => sm()),
          onSplitToggle: s[104] || (s[104] = (Me) => Fk())
        }, null, 8, ["initial-query", "open", "locale", "files", "view-mode", "can-write", "can-go-up", "hit-can", "onOpenHit", "onDownloadHit", "onDragHit", "onWarmHit", "onDropInside", "onRefresh", "split-enabled"]),
        Je(qX, {
          open: Sd.value,
          locale: W.value,
          onClose: s[105] || (s[105] = (Me) => Sd.value = !1),
          onCustomize: s[106] || (s[106] = (Me) => {
            Sd.value = !1, hu.value = !0;
          })
        }, null, 8, ["open", "locale"]),
        fn.value ? (f(), We(u(c), {
          key: 7,
          modelValue: fn.value,
          "onUpdate:modelValue": s[107] || (s[107] = (Me) => fn.value = Me),
          host: Nt
        }, null, 8, ["modelValue"])) : D("", !0),
        u(Q) ? (f(), We(toe, {
          key: 8,
          feed: u(Q),
          locale: W.value,
          onOpen: tn
        }, null, 8, ["feed", "locale"])) : D("", !0),
        Je(BJ, {
          open: Dd.value,
          locale: W.value,
          theme: An.value,
          dark: im.value,
          current: u(Ld),
          mode: u(pu),
          "host-mode": e.config.theme || "auto",
          onClose: s[108] || (s[108] = (Me) => Dd.value = !1),
          onSelect: u(KC),
          onMode: s[109] || (s[109] = (Me) => Pa(Me))
        }, null, 8, ["open", "locale", "theme", "dark", "current", "mode", "host-mode", "onSelect"]),
        d("input", {
          ref_key: "fileInputEl",
          ref: hb,
          type: "file",
          multiple: "",
          class: "fe__file-input",
          onChange: PC
        }, null, 544),
        Je(zr, { name: "fe-toast" }, {
          default: mt(() => [
            va.value ? (f(), h("div", {
              key: 0,
              class: Ne(["fe-toast", { "fe-toast--action": !!va.value.actionLabel }]),
              role: "status",
              onClick: Oh
            }, [
              d("span", vse, y(va.value.message), 1),
              va.value.actionLabel && va.value.action ? (f(), h("button", {
                key: 0,
                type: "button",
                class: "fe-toast__action",
                onClick: vt(OE, ["stop"])
              }, y(va.value.actionLabel), 1)) : D("", !0)
            ], 2)) : D("", !0)
          ]),
          _: 1
        }),
        Je(u(p), {
          open: ot.value,
          locale: W.value,
          theme: An.value,
          onClose: s[110] || (s[110] = (Me) => ot.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        Je(u(b), {
          open: hu.value,
          locale: W.value,
          theme: An.value,
          onClose: s[111] || (s[111] = (Me) => hu.value = !1)
        }, null, 8, ["open", "locale", "theme"]),
        Je(u(l), {
          open: so.value,
          locale: W.value,
          file: Di.value,
          theme: An.value,
          "preview-url": (Me) => jd(Me),
          "download-url": (Me) => Gn.value || u(j).rootOf(Me) ? jd(Me) : u($).downloadUrl(Me),
          "only-office-base": an.value ? null : tr.value,
          "only-office-config-endpoint": ub.value,
          "can-configure": ha.value,
          "auth-headers": () => Qn({ "Content-Type": "application/json" }),
          "auth-credentials": u($).credentialsMode(),
          "drawio-url": Vl.value,
          "pdf-worker-url": P.config.pdfWorkerUrl || null,
          "viewer-base-url": Mk.value,
          onClose: s[112] || (s[112] = (Me) => so.value = !1),
          onNav: qC,
          onOpenFull: WC
        }, null, 8, ["open", "locale", "file", "theme", "preview-url", "download-url", "only-office-base", "only-office-config-endpoint", "can-configure", "auth-headers", "auth-credentials", "drawio-url", "pdf-worker-url", "viewer-base-url"]),
        Je(u(w), {
          open: Rd.value,
          locale: W.value,
          root: Mn.value,
          theme: An.value,
          onClose: GC
        }, null, 8, ["open", "locale", "root", "theme"])
      ], 42, xoe);
    };
  }
}), Ese = "/web-apps/apps/api/documents/api.js", Cse = "/?embed=1&proto=json", zse = 1e4;
function Mse(e) {
  return e.trim().replace(/\/+$/, "");
}
function Ose(e, t) {
  return new Promise((n) => {
    const a = document.createElement("script");
    let i = !1;
    const r = (c) => {
      i || (i = !0, clearTimeout(l), a.remove(), n(c));
    }, l = setTimeout(() => r("timeout"), t);
    a.async = !0, a.src = e, a.onload = () => r("load"), a.onerror = () => r("error"), document.head.appendChild(a);
  });
}
function Pse(e, t) {
  return new Promise((n) => {
    let a = null;
    try {
      a = new URL(e, window.location.href).origin;
    } catch {
      a = null;
    }
    const i = document.createElement("iframe");
    i.setAttribute("aria-hidden", "true"), i.style.cssText = "position:absolute;inset-inline-start:-9999px;width:1px;height:1px;border:0";
    let r = !1;
    const l = (m) => {
      r || (r = !0, clearTimeout(p), window.removeEventListener("message", c), i.remove(), n(m));
    }, c = (m) => {
      if (a && m.origin !== a) return;
      let v = m.data;
      if (typeof v == "string")
        try {
          v = JSON.parse(v);
        } catch {
          return;
        }
      v && typeof v == "object" && v.event === "init" && l("ready");
    };
    window.addEventListener("message", c);
    const p = setTimeout(() => l("timeout"), t);
    i.src = e, document.body.appendChild(i);
  });
}
async function Dse(e) {
  try {
    return await fetch(e, { mode: "no-cors", cache: "no-store" }), !0;
  } catch {
    return !1;
  }
}
const Lse = {
  loadScript: Ose,
  loadFramed: Pse,
  reachable: Dse,
  hasDocsAPI: () => {
    var e;
    return !!((e = window.DocsAPI) != null && e.DocEditor);
  },
  pageProtocol: () => window.location.protocol,
  now: () => typeof performance < "u" ? performance.now() : Date.now()
};
function Rse(e, t) {
  const n = Mse(t);
  return n ? e === "onlyoffice" ? n + Ese : e === "drawio" ? n + Cse : "" : "";
}
async function Vpe(e, t, n = {}) {
  const a = { ...Lse, ...n.deps ?? {} }, i = n.timeoutMs ?? zse, r = Rse(e, t ?? ""), l = e === "onlyoffice" ? "script" : e === "drawio" ? "iframe" : "none";
  if (!r)
    return { service: e, state: "skipped", url: "", ms: 0, mechanism: l };
  if (a.pageProtocol() === "https:" && r.startsWith("http://"))
    return { service: e, state: "blocked-mixed-content", url: r, ms: 0, mechanism: l };
  const c = a.now(), p = () => Math.round(a.now() - c);
  if (l === "script") {
    const m = await a.loadScript(r, i);
    if (m === "timeout") return { service: e, state: "timeout", url: r, ms: p(), mechanism: l };
    if (m === "load")
      return {
        service: e,
        state: a.hasDocsAPI() ? "ok" : "wrong-content",
        url: r,
        ms: p(),
        mechanism: l
      };
    const v = await a.reachable(r);
    return {
      service: e,
      state: v ? "wrong-content" : "unreachable",
      url: r,
      ms: p(),
      mechanism: l
    };
  }
  if (l === "iframe") {
    if (await a.loadFramed(r, i) === "ready") return { service: e, state: "ok", url: r, ms: p(), mechanism: l };
    const v = await a.reachable(r);
    return {
      service: e,
      state: v ? "wrong-content" : "unreachable",
      url: r,
      ms: p(),
      mechanism: l
    };
  }
  return { service: e, state: "skipped", url: "", ms: 0, mechanism: l };
}
const vy = "filex:remote-images";
function N0() {
  return Qo() && Qi().remoteImages === "on";
}
function Nse() {
  return Kc() && Qo();
}
function jpe(e) {
  Zi("remoteImages", e ? "on" : "");
  try {
    window.dispatchEvent(new CustomEvent(vy, { detail: e }));
  } catch {
  }
}
const Ise = {
  class: "fe-remote-ask",
  "data-testid": "remote-image-dialog"
}, Bse = { class: "fe-remote-ask__text" }, Fse = {
  class: "fe-remote-ask__host",
  dir: "ltr",
  "data-testid": "remote-image-host"
}, Use = {
  key: 0,
  class: "fe-remote-ask__hint",
  "data-testid": "remote-image-hint"
}, qpe = /* @__PURE__ */ rt({
  __name: "RemoteImageDialog",
  props: {
    gate: {},
    locale: {},
    theme: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale ?? "en"), a = E(() => t.gate.asking.value), i = E(() => !!a.value && Nse());
    return (r, l) => (f(), We(na, {
      open: !!a.value,
      title: u(n)("viewer.remote_image.title"),
      size: "sm",
      theme: e.theme,
      locale: String(e.locale ?? "en"),
      onClose: l[3] || (l[3] = (c) => e.gate.dismiss())
    }, {
      actions: mt(() => {
        var c, p, m, v;
        return [
          d("button", {
            type: "button",
            class: "fe-btn",
            "data-testid": "remote-image-cancel",
            onClick: l[0] || (l[0] = (x) => e.gate.dismiss())
          }, y(u(n)("common.cancel")), 1),
          (c = a.value) != null && c.whole || (((p = a.value) == null ? void 0 : p.others) ?? 0) > 0 ? (f(), h("button", {
            key: 0,
            type: "button",
            class: Ne(["fe-btn", { "fe-btn--primary": (m = a.value) == null ? void 0 : m.whole }]),
            "data-testid": "remote-image-load-all",
            onClick: l[1] || (l[1] = (x) => e.gate.acceptAll())
          }, y(u(n)("viewer.remote_image.load_all")), 3)) : D("", !0),
          (v = a.value) != null && v.whole ? D("", !0) : (f(), h("button", {
            key: 1,
            type: "button",
            class: "fe-btn fe-btn--primary",
            "data-testid": "remote-image-load",
            onClick: l[2] || (l[2] = (x) => e.gate.accept())
          }, y(u(n)("viewer.remote_image.load")), 1))
        ];
      }),
      default: mt(() => {
        var c;
        return [
          d("div", Ise, [
            d("p", Bse, y(u(n)("viewer.remote_image.body")), 1),
            d("p", Fse, y((c = a.value) == null ? void 0 : c.host), 1),
            i.value ? (f(), h("p", Use, y(u(n)("viewer.remote_image.setting_hint")), 1)) : D("", !0)
          ])
        ];
      }),
      _: 1
    }, 8, ["open", "title", "theme", "locale"]));
  }
}), HT = Symbol("fe-remote-images"), I0 = "[data-remote-image]";
function B0(e) {
  const t = Gr(e.getAttribute("data-remote-image") ?? "");
  if (!t) return null;
  if (e.namespaceURI === "http://www.w3.org/2000/svg") {
    const a = q$(e.ownerDocument, t.href, (r) => e.getAttribute(`data-remote-${r.toLowerCase()}`)), i = e.getAttribute("transform");
    return i && a.setAttribute("transform", i), e.replaceWith(a), a.querySelector("img");
  }
  const n = e.ownerDocument.createElement("img");
  n.setAttribute("referrerpolicy", "no-referrer");
  for (const a of H$) {
    const i = e.getAttribute(`data-remote-${a}`);
    i !== null && n.setAttribute(a, i);
  }
  return n.setAttribute("src", t.href), e.replaceWith(n), n;
}
function Wpe(e = () => "en") {
  const { t } = ht(() => e() ?? "en"), n = S(null), a = S(N0()), i = S(!1), r = /* @__PURE__ */ new Set(), l = [];
  function c() {
    const w = [];
    for (const b of l)
      b.value && w.push(...Array.from(b.value.querySelectorAll(I0)));
    return w;
  }
  function p(w) {
    for (const b of c())
      w(b.getAttribute("data-remote-image") ?? "") && B0(b);
  }
  function m(w) {
    return a.value || i.value || r.has(w);
  }
  function v(w) {
    const b = Gr(w.getAttribute("data-remote-image") ?? "");
    if (!b) return;
    if (m(b.href)) {
      B0(w);
      return;
    }
    const C = c().filter((A) => A.getAttribute("data-remote-image") !== b.href).length;
    n.value = { src: b.href, host: b.host, others: C };
  }
  function x(w) {
    const b = w.target, C = b && typeof b.closest == "function" ? b.closest(I0) : null, A = w.currentTarget;
    return C && (!A || typeof A.contains != "function" || A.contains(C)) ? C : null;
  }
  const k = () => {
    a.value = N0();
  }, _ = Vc(k);
  return typeof window < "u" && window.addEventListener(vy, k), Go() && Ct(() => {
    _(), typeof window < "u" && window.removeEventListener(vy, k);
  }), Xe(a, (w) => {
    w && (n.value = null, p(() => !0));
  }), {
    asking: n,
    settingOn: a,
    allLoaded: E(() => a.value || i.value),
    askWhole(w) {
      const b = w.map((C) => Gr(C)).find((C) => !!C);
      !b || a.value || i.value || (n.value = { src: b.href, host: b.host, others: Math.max(0, w.length - 1), whole: !0 });
    },
    policy: () => ({ label: t("viewer.remote_image.label"), load: m }),
    watchRoot(w) {
      l.push(w);
    },
    onClick(w) {
      const b = x(w);
      b && (w.preventDefault(), w.stopPropagation(), v(b));
    },
    onKeydown(w) {
      if (w.key !== "Enter" && w.key !== " ") return;
      const b = x(w);
      b && (w.preventDefault(), w.stopPropagation(), v(b));
    },
    accept() {
      const w = n.value;
      n.value = null, w && (r.add(w.src), p((b) => b === w.src));
    },
    acceptAll() {
      n.value = null, i.value = !0, p(() => !0);
    },
    dismiss() {
      n.value = null;
    },
    reset() {
      n.value = null, i.value = !1, r.clear();
    }
  };
}
function Ype(e) {
  jo(HT, e);
}
function Gpe() {
  return Go() ? bi(HT, null) : null;
}
function Xpe(e) {
  return e ? e.replace(/diagnose$/, "session") : null;
}
async function Jpe(e, t, n) {
  try {
    const a = await e(t, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "state", ...n })
    });
    if (!a.ok) return null;
    const i = await a.json();
    return { stale: i.stale === !0, known: i.known === !0 };
  } catch {
    return null;
  }
}
function Zpe(e, t) {
  return e || t.pending ? "ask" : "reload";
}
function Qpe(e, t) {
  return /(^|\/|:\/\/)\.filex-open\//.test(e) ? t.replace(/^[0-9a-f]{12}-/, "") : t;
}
const Hse = {
  viewBox: "0 0 32 32",
  "aria-hidden": "true"
}, F0 = /* @__PURE__ */ rt({
  __name: "LogoMark",
  setup(e) {
    return (t, n) => (f(), h("svg", Hse, [...n[0] || (n[0] = [
      d("rect", {
        width: "32",
        height: "32",
        rx: "7",
        fill: "var(--fe-primary, #2f6ceb)"
      }, null, -1),
      d("path", {
        d: "M7 11a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V11z",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linejoin": "round"
      }, null, -1),
      d("path", {
        d: "M11.5 17.5l3 2.5 5.5-6",
        fill: "none",
        stroke: "#fff",
        "stroke-width": "1.8",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])]));
  }
});
function ehe(e) {
  return e.trim().toLowerCase();
}
const Kse = 250;
function the(e, t = Kse) {
  let n = 0, a = null;
  return (i) => {
    const r = ++n;
    return a && (clearTimeout(a.timer), a.resolve(null), a = null), new Promise((l) => {
      a = { timer: setTimeout(() => {
        a = null, e(i).then(
          (p) => l(r === n ? p ?? {} : null),
          () => l(null)
        );
      }, t), resolve: l };
    });
  };
}
function nhe(e) {
  var n;
  let t = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data;
  if (!t) {
    const a = e == null ? void 0 : e.detail;
    if (typeof a == "string" && a.trim().startsWith("{"))
      try {
        t = JSON.parse(a);
      } catch {
        t = void 0;
      }
  }
  return !t || typeof t.field != "string" || typeof t.message != "string" ? null : { field: t.field, message: t.message };
}
async function Vse(e, { maxPx: t, maxBytes: n }) {
  const a = await jse(e), i = Math.min(a.width, a.height), r = Math.min(t, i), l = document.createElement("canvas");
  l.width = r, l.height = r;
  const c = l.getContext("2d");
  if (!c) throw new Error("canvas unavailable");
  c.fillStyle = "#ffffff", c.fillRect(0, 0, r, r), c.drawImage(
    a,
    (a.width - i) / 2,
    (a.height - i) / 2,
    i,
    i,
    0,
    0,
    r,
    r
  );
  for (const p of [0.85, 0.7, 0.55, 0.4]) {
    const m = l.toDataURL("image/jpeg", p);
    if (m.length <= n) return m;
  }
  if (r > 64)
    return Vse(e, { maxPx: Math.floor(r / 2), maxBytes: n });
  throw new Error("image too large");
}
async function jse(e) {
  if (typeof createImageBitmap == "function")
    return createImageBitmap(e);
  const t = URL.createObjectURL(e);
  try {
    return await new Promise((n, a) => {
      const i = new Image();
      i.onload = () => n(i), i.onerror = () => a(new Error("decode failed")), i.src = t;
    });
  } finally {
    URL.revokeObjectURL(t);
  }
}
const ahe = [
  "file.uploaded",
  "file.updated",
  "file.upload_failed",
  "file.infected",
  "file.deleted",
  "file.trashed",
  "file.moved",
  "archive.created",
  "archive.extracted",
  "share.created",
  "drop.received",
  "comment.added",
  "e2e.escrow_used",
  "e2e.password_changed",
  "e2e.request_created",
  "e2e.request_decided",
  "plugin.notice",
  // One person's held notifications, told together (backend notify/digest.go).
  // A target receives it only when it ticks it; the person's own switch mutes
  // their digests, and it has no "urgent" switch of its own (DIGEST_EVENT).
  "notification.digest"
], ihe = "notification.digest";
function KT(e) {
  return e.replace(/\./g, "_");
}
function ohe(e) {
  return `webhooks.events.${KT(e)}`;
}
function rhe(e) {
  return `userSettings.notifications.events.${KT(e)}`;
}
const qse = "filex.notify.push";
function U0(e) {
  const t = e.replace(/-/g, "+").replace(/_/g, "/").replace(/=+$/, ""), n = t + "=".repeat((4 - t.length % 4) % 4), a = atob(n), i = new Uint8Array(a.length);
  for (let r = 0; r < a.length; r++) i[r] = a.charCodeAt(r);
  return i;
}
const Wse = [
  [/Edg(e|A|iOS)?\//, "Edge"],
  [/OPR\/|Opera/, "Opera"],
  [/SamsungBrowser\//, "Samsung Internet"],
  [/Firefox\/|FxiOS\//, "Firefox"],
  [/Chrome\/|CriOS\//, "Chrome"],
  [/Safari\//, "Safari"]
], Yse = [
  [/iPhone/, "iPhone"],
  [/iPad/, "iPad"],
  [/Android/, "Android"],
  [/CrOS/, "ChromeOS"],
  [/Windows/, "Windows"],
  [/Mac OS X|Macintosh/, "macOS"],
  [/Linux/, "Linux"]
];
function Gse(e) {
  const t = (n) => {
    var a;
    return ((a = n.find(([i]) => i.test(e))) == null ? void 0 : a[1]) ?? "";
  };
  return [t(Wse), t(Yse)].filter(Boolean).join(" · ");
}
async function Xse(e) {
  const t = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(e));
  return Array.from(new Uint8Array(t), (n) => n.toString(16).padStart(2, "0")).join("");
}
function Jse() {
  try {
    return typeof localStorage > "u" ? null : localStorage;
  } catch {
    return null;
  }
}
function H0(e, t) {
  var i;
  const n = (i = e.options) == null ? void 0 : i.applicationServerKey;
  if (!n) return !1;
  const a = new Uint8Array(n);
  if (a.length !== t.length) return !1;
  for (let r = 0; r < t.length; r++) if (a[r] !== t[r]) return !1;
  return !0;
}
function Zse(e, t) {
  var a, i;
  const n = e.toJSON();
  return {
    endpoint: n.endpoint ?? e.endpoint,
    keys: { p256dh: ((a = n.keys) == null ? void 0 : a.p256dh) ?? "", auth: ((i = n.keys) == null ? void 0 : i.auth) ?? "" },
    label: t
  };
}
async function Qse(e) {
  if (!e || !e.pushManager) return null;
  if (e.active) return e;
  const t = e.installing ?? e.waiting;
  return t ? (await new Promise((n) => {
    const a = setTimeout(n, 1e4);
    t.addEventListener("statechange", () => {
      t.state === "activated" && (clearTimeout(a), n());
    });
  }), e.active ? e : null) : null;
}
function she(e, t) {
  const n = t.storage === void 0 ? Jse() : t.storage, a = t.userId ? `${qse}.${t.userId}` : "", i = t.sha256 ?? Xse, r = t.userAgent ?? (typeof navigator > "u" ? "" : navigator.userAgent ?? "");
  let l = null;
  const c = () => t.notification !== void 0 ? t.notification : typeof window < "u" && "Notification" in window ? window.Notification : null, p = () => t.supported ? t.supported() : typeof window < "u" && "PushManager" in window && typeof navigator < "u" && "serviceWorker" in navigator && c() !== null, m = () => {
    const L = c();
    return !L || !p() ? "unsupported" : L.permission ?? "default";
  }, v = () => {
    if (!a || !n) return !1;
    try {
      return n.getItem(a) === "1";
    } catch {
      return !1;
    }
  }, x = (L) => {
    if (!(!a || !n))
      try {
        L ? n.setItem(a, "1") : n.removeItem(a);
      } catch {
      }
  }, k = async () => {
    try {
      l = await e.status();
    } catch {
      l = null;
    }
    return l;
  }, _ = async () => {
    if (!p()) return null;
    try {
      const L = await t.registration();
      return L != null && L.pushManager ? await L.pushManager.getSubscription() : null;
    } catch {
      return null;
    }
  }, w = async (L) => {
    const U = await Qse(await t.registration());
    if (!U) throw new Error("no service worker");
    const P = U0(L);
    let H = await U.pushManager.getSubscription();
    H && !H0(H, P) && (await H.unsubscribe().catch(() => !1), H = null), H || (H = await U.pushManager.subscribe({ userVisibleOnly: !0, applicationServerKey: P })), await e.subscribe(Zse(H, Gse(r)));
  };
  async function b() {
    var $;
    const L = await k();
    let U = null;
    const P = L ? await _() : null;
    if (P && L)
      try {
        const F = await i(P.endpoint);
        U = (($ = L.devices.find((I) => I.endpoint_hash === F)) == null ? void 0 : $.id) ?? null;
      } catch {
        U = null;
      }
    const H = m();
    return { supported: p(), permission: H, status: L, on: U !== null && H === "granted", thisDevice: U };
  }
  async function C() {
    const L = c();
    if (!L || !p()) return b();
    let U = L.permission;
    if (U === "default") {
      const H = await Promise.resolve(L.requestPermission());
      U = typeof H == "string" ? H : L.permission;
    }
    if (U !== "granted") return b();
    const P = l ?? await k();
    return !(P != null && P.available) || !P.public_key || (await w(P.public_key), x(!0)), b();
  }
  async function A() {
    x(!1);
    const L = await _();
    return L && (await e.forget(L.endpoint).catch(() => {
    }), await L.unsubscribe().catch(() => !1)), b();
  }
  async function T(L) {
    const U = await b();
    if (await e.remove(L), U.thisDevice === L) {
      x(!1);
      const P = await _();
      await (P == null ? void 0 : P.unsubscribe().catch(() => !1));
    }
    return b();
  }
  async function R() {
    if (!v() || m() !== "granted") return;
    const L = await k();
    if (!(!(L != null && L.available) || !L.public_key))
      try {
        const U = await _();
        if (U && H0(U, U0(L.public_key))) {
          const P = await i(U.endpoint);
          if (L.devices.some((H) => H.endpoint_hash === P)) return;
        }
        await w(L.public_key);
      } catch {
      }
  }
  async function M() {
    const L = await _();
    L && (await e.forget(L.endpoint).catch(() => {
    }), await L.unsubscribe().catch(() => !1));
  }
  return {
    state: b,
    enable: C,
    disable: A,
    remove: T,
    test: () => e.test(),
    reconcile: R,
    forgetDevice: M
  };
}
function al(e) {
  return !e.sections && typeof e.href == "string";
}
function ele(e) {
  const t = [];
  for (const n of e) {
    if (al(n)) {
      t.push(n);
      continue;
    }
    const a = (n.sections ?? []).filter((i) => i.items.length > 0);
    a.length > 0 && t.push({ ...n, sections: a });
  }
  return t;
}
function tle(e) {
  return al(e) ? e.active === !0 : (e.sections ?? []).some((t) => t.items.some((n) => n.active === !0));
}
function nle(e, t, n) {
  if (n <= 0) return null;
  switch (e) {
    case "ArrowDown":
      return Math.min(t + 1, n - 1);
    case "ArrowUp":
      return Math.max(t - 1, 0);
    case "Home":
      return 0;
    case "End":
      return n - 1;
    default:
      return null;
  }
}
function ale(e, t, n, a = "ltr") {
  if (n <= 0) return null;
  const i = Rf(e, a);
  return i !== 0 ? (t + i + n) % n : e === "Home" ? 0 : e === "End" ? n - 1 : null;
}
function ile(e) {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && !e.defaultPrevented;
}
const ole = ["aria-label"], rle = {
  key: 0,
  class: "fx-mega__bar"
}, sle = ["href", "aria-current", "data-mega-top", "data-testid", "onClick", "onKeydown"], lle = ["aria-expanded", "aria-controls", "data-mega-top", "data-testid", "onClick", "onKeydown"], ule = ["id", "data-mega-panel", "data-testid", "onKeydown"], cle = ["data-testid"], dle = ["id"], fle = ["aria-labelledby"], ple = ["href", "aria-current", "data-testid", "onClick"], hle = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, mle = ["innerHTML"], vle = { class: "fx-mega__text" }, yle = { class: "fx-mega__label" }, gle = {
  key: 0,
  class: "fx-mega__hint"
}, ble = {
  key: 1,
  class: "fx-mega__list"
}, kle = ["href", "aria-current", "data-testid", "onClick"], wle = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, _le = { class: "fx-mega__text" }, xle = { class: "fx-mega__label" }, Sle = ["aria-labelledby", "data-testid"], $le = ["id"], Tle = ["data-testid"], Ale = ["id"], Ele = ["aria-labelledby"], Cle = ["href", "aria-current", "data-testid", "onClick"], zle = {
  class: "fx-mega__icon",
  "aria-hidden": "true"
}, Mle = ["innerHTML"], Ole = { class: "fx-mega__text" }, Ple = { class: "fx-mega__label" }, lhe = /* @__PURE__ */ rt({
  __name: "MegaMenu",
  props: {
    entries: {},
    label: {},
    mode: { default: "bar" }
  },
  emits: ["navigate"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = `fx-mega-${Math.random().toString(36).slice(2, 10)}`, r = E(() => ele(n.entries)), l = S(null), c = S(null), p = (U) => `${i}-${U.id}`, m = (U, P) => `${i}-${U.id}-${P}`;
    function v() {
      c.value = null;
    }
    function x(U) {
      c.value = c.value === U ? null : U;
    }
    function k() {
      var U;
      return Array.from(((U = l.value) == null ? void 0 : U.querySelectorAll("[data-mega-top]")) ?? []);
    }
    function _(U) {
      var H;
      const P = (H = l.value) == null ? void 0 : H.querySelector(`[data-mega-panel="${U}"]`);
      return Array.from((P == null ? void 0 : P.querySelectorAll("a.fx-mega__item")) ?? []);
    }
    function w(U) {
      var P;
      return ((P = l.value) == null ? void 0 : P.querySelector(`[data-mega-top="${U}"]`)) ?? null;
    }
    async function b(U, P) {
      var $;
      c.value = U, await Jt();
      const H = _(U);
      ($ = P === "first" ? H[0] : H[H.length - 1]) == null || $.focus();
    }
    function C(U, P, H) {
      var I;
      const $ = k(), F = ale(U.key, P, $.length, ei(l.value));
      if (F !== null) {
        U.preventDefault(), v(), (I = $[F]) == null || I.focus();
        return;
      }
      al(H) || (U.key === "ArrowDown" ? (U.preventDefault(), b(H.id, "first")) : U.key === "ArrowUp" ? (U.preventDefault(), b(H.id, "last")) : U.key === "Escape" && c.value === H.id && (U.preventDefault(), v()));
    }
    function A(U, P) {
      var I, Z, J;
      if (U.key === "Escape") {
        U.preventDefault(), U.stopPropagation(), v(), (I = w(P.id)) == null || I.focus();
        return;
      }
      const H = _(P.id), $ = H.indexOf(document.activeElement);
      if ($ < 0) return;
      if (U.key === "ArrowUp" && $ === 0) {
        U.preventDefault(), (Z = w(P.id)) == null || Z.focus();
        return;
      }
      const F = nle(U.key, $, H.length);
      F !== null && (U.preventDefault(), (J = H[F]) == null || J.focus());
    }
    function T(U, P) {
      !P.href || !ile(U) || (U.preventDefault(), v(), a("navigate", { id: P.id, href: P.href }));
    }
    function R(U) {
      const P = U.relatedTarget;
      P && l.value && !l.value.contains(P) && v();
    }
    function M(U) {
      if (c.value === null) return;
      const P = U.target;
      P && l.value && !l.value.contains(P) && v();
    }
    qt(() => document.addEventListener("pointerdown", M, !0)), Ct(() => document.removeEventListener("pointerdown", M, !0));
    const L = E(
      () => r.value.flatMap(
        (U) => al(U) ? U.active ? [U.id] : [] : (U.sections ?? []).flatMap((P) => P.items.filter((H) => H.active).map((H) => H.id))
      ).join("|")
    );
    return Xe(L, v), (U, P) => (f(), h("nav", {
      ref_key: "root",
      ref: l,
      class: Ne(["fx-mega", `fx-mega--${e.mode}`]),
      "aria-label": e.label,
      "data-testid": "mega-menu",
      onFocusout: R
    }, [
      e.mode === "bar" ? (f(), h("ul", rle, [
        (f(!0), h(Ce, null, nt(r.value, (H, $) => (f(), h("li", {
          key: H.id,
          class: "fx-mega__top"
        }, [
          u(al)(H) ? (f(), h("a", {
            key: 0,
            href: H.href,
            class: Ne(["fx-mega__toplink", H.active && "is-current"]),
            "aria-current": H.active ? "page" : void 0,
            "data-mega-top": H.id,
            "data-testid": `nav-${H.id}`,
            onClick: (F) => T(F, H),
            onKeydown: (F) => C(F, $, H)
          }, y(H.label), 43, sle)) : (f(), h(Ce, { key: 1 }, [
            d("button", {
              type: "button",
              class: Ne(["fx-mega__topbtn", c.value === H.id && "is-open", u(tle)(H) && "is-current"]),
              "aria-expanded": c.value === H.id ? "true" : "false",
              "aria-controls": p(H),
              "data-mega-top": H.id,
              "data-testid": `nav-top-${H.id}`,
              onClick: (F) => x(H.id),
              onKeydown: (F) => C(F, $, H)
            }, [
              d("span", null, y(H.label), 1),
              P[0] || (P[0] = d("svg", {
                class: "fx-mega__chev",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "aria-hidden": "true"
              }, [
                d("path", { d: "m6 9 6 6 6-6" })
              ], -1))
            ], 42, lle),
            cn(d("div", {
              id: p(H),
              class: "fx-mega__panel",
              "data-mega-panel": H.id,
              "data-testid": `nav-panel-${H.id}`,
              onKeydown: (F) => A(F, H)
            }, [
              (f(!0), h(Ce, null, nt(H.sections, (F) => (f(), h("div", {
                key: F.id,
                class: "fx-mega__section",
                "data-testid": `nav-group-${F.id}`
              }, [
                d("p", {
                  id: m(H, F.id),
                  class: "fx-mega__heading"
                }, y(F.label), 9, dle),
                d("ul", {
                  class: "fx-mega__items",
                  "aria-labelledby": m(H, F.id)
                }, [
                  (f(!0), h(Ce, null, nt(F.items, (I) => (f(), h("li", {
                    key: I.id
                  }, [
                    d("a", {
                      href: I.href,
                      class: Ne(["fx-mega__item", I.active && "is-current"]),
                      "aria-current": I.active ? "page" : void 0,
                      "data-testid": `nav-${I.id}`,
                      onClick: (Z) => T(Z, I)
                    }, [
                      d("span", hle, [
                        I.iconName ? (f(), h("span", {
                          key: 0,
                          class: "fx-mega__glyph",
                          innerHTML: u(Pt)(I.iconName)
                        }, null, 8, mle)) : I.icon ? (f(), We(Ki(I.icon), {
                          key: 1,
                          class: "fx-mega__glyph"
                        })) : D("", !0)
                      ]),
                      d("span", vle, [
                        d("span", yle, y(I.label), 1),
                        I.hint ? (f(), h("span", gle, y(I.hint), 1)) : D("", !0)
                      ])
                    ], 10, ple)
                  ]))), 128))
                ], 8, fle)
              ], 8, cle))), 128))
            ], 40, ule), [
              [yM, c.value === H.id]
            ])
          ], 64))
        ]))), 128))
      ])) : (f(), h("div", ble, [
        (f(!0), h(Ce, null, nt(r.value, (H) => (f(), h(Ce, {
          key: H.id
        }, [
          u(al)(H) ? (f(), h("a", {
            key: 0,
            href: H.href,
            class: Ne(["fx-mega__item", "fx-mega__item--top", H.active && "is-current"]),
            "aria-current": H.active ? "page" : void 0,
            "data-testid": `nav-${H.id}`,
            onClick: ($) => T($, H)
          }, [
            d("span", wle, [
              H.icon ? (f(), We(Ki(H.icon), {
                key: 0,
                class: "fx-mega__glyph"
              })) : D("", !0)
            ]),
            d("span", _le, [
              d("span", xle, y(H.label), 1)
            ])
          ], 10, kle)) : (f(), h("section", {
            key: 1,
            class: "fx-mega__group",
            "aria-labelledby": p(H),
            "data-testid": `nav-top-${H.id}`
          }, [
            d("p", {
              id: p(H),
              class: "fx-mega__grouphead"
            }, y(H.label), 9, $le),
            (f(!0), h(Ce, null, nt(H.sections, ($) => (f(), h("div", {
              key: $.id,
              class: "fx-mega__section",
              "data-testid": `nav-group-${$.id}`
            }, [
              d("p", {
                id: m(H, $.id),
                class: "fx-mega__heading"
              }, y($.label), 9, Ale),
              d("ul", {
                class: "fx-mega__items",
                "aria-labelledby": m(H, $.id)
              }, [
                (f(!0), h(Ce, null, nt($.items, (F) => (f(), h("li", {
                  key: F.id
                }, [
                  d("a", {
                    href: F.href,
                    class: Ne(["fx-mega__item", F.active && "is-current"]),
                    "aria-current": F.active ? "page" : void 0,
                    "data-testid": `nav-${F.id}`,
                    onClick: (I) => T(I, F)
                  }, [
                    d("span", zle, [
                      F.iconName ? (f(), h("span", {
                        key: 0,
                        class: "fx-mega__glyph",
                        innerHTML: u(Pt)(F.iconName)
                      }, null, 8, Mle)) : F.icon ? (f(), We(Ki(F.icon), {
                        key: 1,
                        class: "fx-mega__glyph"
                      })) : D("", !0)
                    ]),
                    d("span", Ole, [
                      d("span", Ple, y(F.label), 1)
                    ])
                  ], 10, Cle)
                ]))), 128))
              ], 8, Ele)
            ], 8, Tle))), 128))
          ], 8, Sle))
        ], 64))), 128))
      ]))
    ], 42, ole));
  }
}), Dle = [
  "page",
  "setting",
  "app",
  "user",
  "group",
  "key",
  "storage",
  "share",
  "file"
], Lle = {
  file: "file",
  user: "user",
  app: "app",
  key: "key",
  group: "group",
  storage: "storage",
  setting: "setting"
}, Rle = ["file", "user", "app", "key", "group", "storage", "setting"], Nle = 6, VT = 3, jT = 25;
function K0(e) {
  return vo(e ?? "").split(/\s+/).filter((t) => t.length > 0);
}
function qT(e) {
  const t = (e ?? "").replace(/^\s+/, ""), n = /^([A-Za-z]+)\s*:/.exec(t);
  if (n) {
    const i = n[1].toLowerCase(), r = Lle[i];
    if (r) {
      const l = t.slice(n[0].length).trim();
      return { kind: r, prefix: i, text: l, words: K0(l) };
    }
  }
  const a = t.trim();
  return { kind: null, prefix: "", text: a, words: K0(a) };
}
function V0(e, t) {
  const n = qT(e);
  return t ? `${t}:${n.text}` : n.text;
}
function Ile(e, t) {
  return t === 0 ? !0 : !/[\p{L}\p{N}]/u.test(e[t - 1]);
}
function ff(e, t, n) {
  if (!e) return 0;
  const a = e.indexOf(t);
  return a < 0 ? 0 : a === 0 ? n : Ile(e, a) ? Math.round(n * 0.8) : Math.round(n * 0.5);
}
function Ble(e, t) {
  if (t.length === 0) return 0;
  const n = vo(e.label ?? ""), a = (e.terms ?? []).map((p) => vo(p)), i = (e.aliases ?? []).map((p) => vo(p)), r = vo(e.detail ?? "");
  let l = 0;
  for (const p of t) {
    let m = ff(n, p, 100);
    for (const v of a) m = Math.max(m, ff(v, p, 70));
    for (const v of i) m = Math.max(m, ff(v, p, 50));
    if (m = Math.max(m, ff(r, p, 25)), m <= 0) return e.found ? 1 : -1;
    l += m;
  }
  const c = t.join(" ");
  return n === c ? l += 300 : a.includes(c) ? l += 200 : i.includes(c) ? l += 150 : n.startsWith(c) && (l += 80), l -= Math.min(n.length, 60) / 10, l;
}
function Fle(e, t) {
  if (t.length === 0) return !1;
  const n = t.join(" ");
  return vo(e.label ?? "") === n ? !0 : (e.terms ?? []).some((a) => vo(a) === n);
}
function Ule(e, t, n = {}) {
  if (t.words.length === 0) return [];
  const a = /* @__PURE__ */ new Map();
  for (const l of e) {
    if (t.kind && l.kind !== t.kind) continue;
    const c = Ble(l, t.words);
    if (c < 0) continue;
    const p = a.get(l.kind) ?? [];
    p.push({ item: l, score: c }), a.set(l.kind, p);
  }
  const i = [], r = [];
  for (const l of Dle) {
    const c = a.get(l);
    if (!c || c.length === 0) continue;
    c.sort((v, x) => x.score - v.score);
    const p = n[l] ?? (t.kind ? jT : l === "file" ? VT : Nle), m = { kind: l, items: c.slice(0, p).map((v) => v.item), total: c.length };
    (Fle(c[0].item, t.words) ? i : r).push(m);
  }
  return [...i, ...r];
}
function uhe(e) {
  return e.flatMap((t) => t.items);
}
const Hle = ["aria-label", "aria-expanded"], Kle = ["innerHTML"], Vle = {
  key: 0,
  class: "fx-psearch__trigger-text"
}, jle = {
  key: 1,
  class: "fx-psearch__kbd"
}, qle = ["aria-modal", "aria-label"], Wle = { class: "fx-psearch__field" }, Yle = ["aria-label"], Gle = ["innerHTML"], Xle = ["innerHTML"], Jle = ["aria-label", "aria-expanded", "aria-activedescendant", "placeholder"], Zle = ["aria-label"], Qle = ["innerHTML"], eue = ["aria-label"], tue = ["aria-labelledby", "data-testid"], nue = ["id"], aue = ["id", "aria-selected", "data-testid", "data-id", "onMouseenter", "onClick"], iue = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, oue = ["innerHTML"], rue = { class: "fx-psearch__text" }, sue = { class: "fx-psearch__label" }, lue = {
  key: 0,
  class: "fx-psearch__detail"
}, uue = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, cue = ["innerHTML"], due = { class: "fx-psearch__text" }, fue = { class: "fx-psearch__label" }, pue = {
  class: "fx-psearch__icon",
  "aria-hidden": "true"
}, hue = ["innerHTML"], mue = { class: "fx-psearch__text" }, vue = { class: "fx-psearch__label" }, yue = ["aria-label", "title", "onClick"], gue = ["innerHTML"], bue = {
  key: 0,
  class: "fx-psearch__note"
}, kue = {
  key: 1,
  class: "fx-psearch__note",
  "data-testid": "panel-search-empty"
}, wue = {
  key: 2,
  class: "fx-psearch__note fx-psearch__note--warn",
  role: "alert",
  "data-testid": "panel-search-failed"
}, _ue = { class: "fx-psearch__foot" }, xue = { class: "fx-psearch__foot-label" }, Sue = ["aria-pressed", "data-testid", "onClick"], $ue = {
  class: "fe-sr-only",
  role: "status",
  "aria-live": "polite"
}, j0 = 2, Tue = 200, che = /* @__PURE__ */ rt({
  __name: "PanelSearch",
  props: {
    locale: {},
    compact: { type: Boolean, default: !1 },
    items: {},
    remote: { type: Function, default: void 0 },
    files: { type: Function, default: void 0 },
    recent: { default: void 0 },
    shortcut: { type: Boolean, default: !0 }
  },
  emits: ["choose"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = `fx-psearch-${Math.random().toString(36).slice(2, 10)}`, c = `${l}-list`, p = S(null), m = S(null), v = S(null), x = S(null), k = S(!1), _ = S(""), w = S(0), b = S(null), C = S(80), A = E(() => qT(_.value)), T = S([]), R = S([]), M = S(!1), L = S(!1);
    let U, P = 0;
    function H(he) {
      U && clearTimeout(U);
      const Ke = ++P;
      if (he.text.length < j0 || !a.remote && !a.files) {
        T.value = [], R.value = [], M.value = !1, L.value = !1;
        return;
      }
      M.value = !0, U = setTimeout(() => void $(he, Ke), Tue);
    }
    async function $(he, Ke) {
      const Le = !!a.remote && he.kind !== "file" && he.kind !== "page" && he.kind !== "setting", ut = !!a.files && (he.kind === null || he.kind === "file"), wt = he.kind === "file" ? jT : VT, [_t, At] = await Promise.allSettled([
        Le && a.remote ? a.remote(he) : Promise.resolve([]),
        ut && a.files ? a.files(he.text, wt) : Promise.resolve([])
      ]);
      Ke === P && (T.value = _t.status === "fulfilled" ? _t.value.map((_e) => ({ ..._e, found: !0 })) : [], R.value = At.status === "fulfilled" ? At.value.map((_e) => ({ ..._e, kind: "file", found: !0 })) : [], L.value = _t.status === "rejected" || At.status === "rejected", M.value = !1);
    }
    Xe(_, () => {
      w.value = 0, H(A.value);
    });
    const F = S([]);
    async function I() {
      if (a.recent)
        try {
          F.value = await a.recent.list();
        } catch {
        }
    }
    function Z(he) {
      const Ke = he.trim();
      !Ke || !a.recent || (F.value = [{ id: `local-${Ke}`, query: Ke }, ...F.value.filter((Le) => Le.query !== Ke)], a.recent.add(Ke).then(I, () => {
      }));
    }
    async function J(he) {
      var Ke;
      F.value = F.value.filter((Le) => Le.id !== he.id), w.value >= le.value.length && (w.value = Math.max(0, le.value.length - 1));
      try {
        await ((Ke = a.recent) == null ? void 0 : Ke.remove(he.id));
      } catch {
        await I();
      }
    }
    async function re() {
      var he, Ke;
      F.value = [], w.value = 0;
      try {
        await ((he = a.recent) == null ? void 0 : he.clear());
      } catch {
        await I();
      }
      (Ke = v.value) == null || Ke.focus();
    }
    const ve = {
      page: "panelsearch.group.page",
      setting: "panelsearch.group.setting",
      app: "panelsearch.group.app",
      user: "panelsearch.group.user",
      group: "panelsearch.group.group",
      key: "panelsearch.group.key",
      storage: "panelsearch.group.storage",
      share: "panelsearch.group.share",
      file: "panelsearch.group.file"
    }, W = E(() => !!a.files && A.value.kind === null && A.value.text.length >= j0), z = E(() => {
      let he = 0;
      const Ke = [], Le = A.value;
      if (Le.words.length === 0)
        return Le.kind === null && F.value.length && Ke.push({
          key: "recent",
          heading: r("panelsearch.group.recent"),
          rows: F.value.map((wt) => ({ type: "recent", id: `recent:${wt.id}`, index: he++, entry: wt }))
        }), Ke;
      const ut = Ule([...a.items, ...T.value, ...R.value], Le);
      for (const wt of ut)
        Ke.push({
          key: wt.kind,
          heading: r(ve[wt.kind]),
          rows: wt.items.map((_t) => ({ type: "item", id: `item:${_t.id}`, index: he++, item: _t }))
        });
      if (W.value) {
        const wt = Ke.find((At) => At.key === "file"), _t = { type: "files-all", id: "files-all", index: he++ };
        wt ? wt.rows.push(_t) : Ke.push({ key: "file", heading: r(ve.file), rows: [_t] });
      }
      return Ke;
    }), le = E(() => z.value.flatMap((he) => he.rows)), fe = (he) => `${l}-opt-${he}`, j = E(() => le.value.length && w.value < le.value.length ? fe(w.value) : void 0), X = E(() => {
      if (!k.value || A.value.words.length === 0) return "";
      if (M.value) return r("panelsearch.searching");
      const he = le.value.filter((Ke) => Ke.type === "item").length;
      return he === 0 ? r("panelsearch.empty", { q: A.value.text }) : r("panelsearch.count", { n: he });
    }), te = E(
      () => A.value.words.length > 0 && !M.value && le.value.every((he) => he.type !== "item")
    );
    function V(he) {
      if (he.kind === "file") {
        const Ke = he.label ?? "", Le = Ke.lastIndexOf(".");
        return xa({
          type: he.isDir ? "dir" : "file",
          basename: Ke,
          extension: !he.isDir && Le > 0 ? Ke.slice(Le + 1) : ""
        });
      }
      return Pt(he.iconName ?? G[he.kind]);
    }
    const G = {
      page: "goto",
      setting: "admin",
      app: "plugin",
      user: "account",
      group: "account",
      key: "lock",
      storage: "connect",
      share: "link",
      file: "open"
    };
    function q() {
      const he = p.value;
      if (!(!he || typeof window > "u")) {
        if (C.value = Ec([he]), a.compact) {
          b.value = null;
          return;
        }
        b.value = Vg(
          he.getBoundingClientRect(),
          Kg(),
          { width: 560, gutter: 16, gap: 6, maxHeight: 620, dir: ei(he) }
        );
      }
    }
    const B = E(() => {
      const he = { zIndex: String(C.value) };
      return b.value && (he.top = b.value.top, he.right = b.value.right, he.left = b.value.left, he.width = b.value.width, he.maxHeight = b.value.maxHeight), he;
    });
    async function K(he) {
      var Ke, Le;
      k.value || (q(), k.value = !0, I()), typeof he == "string" && (_.value = he), await Jt(), (Ke = v.value) == null || Ke.focus(), typeof he != "string" && ((Le = v.value) == null || Le.select());
    }
    function ke(he) {
      k.value && (k.value = !1, U && clearTimeout(U), M.value = !1, he && Jt(() => {
        var Ke;
        return (Ke = p.value) == null ? void 0 : Ke.focus();
      }));
    }
    function Ye(he) {
      he.key.length === 1 && !he.ctrlKey && !he.metaKey && !he.altKey && he.key !== " " ? (he.preventDefault(), K(he.key)) : he.key === "ArrowDown" && (he.preventDefault(), K());
    }
    function Oe(he) {
      if (he) {
        if (he.type === "recent") {
          _.value = he.entry.query, Jt(() => {
            var Ke;
            return (Ke = v.value) == null ? void 0 : Ke.focus();
          });
          return;
        }
        if (he.type === "files-all") {
          _.value = V0(_.value, "file"), Jt(() => {
            var Ke;
            return (Ke = v.value) == null ? void 0 : Ke.focus();
          });
          return;
        }
        Z(_.value), ke(!1), i("choose", he.item);
      }
    }
    function Be(he) {
      _.value = V0(_.value, he), Jt(() => {
        var Ke;
        return (Ke = v.value) == null ? void 0 : Ke.focus();
      });
    }
    function qe() {
      _.value = "", Jt(() => {
        var he;
        return (he = v.value) == null ? void 0 : he.focus();
      });
    }
    function Tt(he) {
      const Ke = le.value.length;
      Ke && (w.value = (w.value + he + Ke) % Ke, Jt(() => {
        var ut;
        const Le = (ut = x.value) == null ? void 0 : ut.querySelector(`#${fe(w.value)}`);
        Le && typeof Le.scrollIntoView == "function" && Le.scrollIntoView({ block: "nearest" });
      }));
    }
    function $t(he) {
      switch (he.key) {
        case "ArrowDown":
          he.preventDefault(), Tt(1);
          break;
        case "ArrowUp":
          he.preventDefault(), Tt(-1);
          break;
        case "Enter":
          if (he.isComposing) return;
          he.preventDefault(), Oe(le.value[w.value] ?? le.value[0]);
          break;
        case "Escape":
          he.preventDefault(), he.stopPropagation(), ke(!0);
          break;
        case "Delete": {
          const Ke = le.value[w.value];
          _.value === "" && (Ke == null ? void 0 : Ke.type) === "recent" && (he.preventDefault(), J(Ke.entry));
          break;
        }
      }
    }
    function it(he) {
      var Ke, Le;
      return he ? !!((Ke = m.value) != null && Ke.contains(he) || (Le = p.value) != null && Le.contains(he)) : !1;
    }
    function yt(he) {
      if (a.compact) return;
      const Ke = he.relatedTarget;
      Ke && !it(Ke) && ke(!1);
    }
    function ft(he) {
      !k.value || a.compact || it(he.target) || ke(!1);
    }
    function ze(he) {
      var Ke, Le;
      !a.shortcut || he.defaultPrevented || B2(he, "palette") && (R2(he.target) && !it(he.target) || (he.preventDefault(), k.value ? ((Ke = v.value) == null || Ke.focus(), (Le = v.value) == null || Le.select()) : K()));
    }
    function oe() {
      k.value && q();
    }
    qt(() => {
      document.addEventListener("keydown", ze), document.addEventListener("pointerdown", ft, !0), window.addEventListener("resize", oe);
    }), Ct(() => {
      U && clearTimeout(U), document.removeEventListener("keydown", ze), document.removeEventListener("pointerdown", ft, !0), window.removeEventListener("resize", oe);
    });
    const Se = E(() => a.shortcut ? Ly("palette") : "");
    return t({ openPanel: K, close: ke }), (he, Ke) => (f(), h("div", {
      class: Ne(["fx-psearch", e.compact ? "fx-psearch--compact" : "fx-psearch--box"])
    }, [
      d("button", {
        ref_key: "trigger",
        ref: p,
        type: "button",
        class: "fx-psearch__trigger",
        "aria-label": u(r)("panelsearch.label"),
        "aria-haspopup": "dialog",
        "aria-expanded": k.value ? "true" : "false",
        "data-testid": "panel-search-open",
        onClick: Ke[0] || (Ke[0] = (Le) => k.value ? ke(!0) : K()),
        onKeydown: Ye
      }, [
        d("span", {
          class: "fx-psearch__glyph",
          "aria-hidden": "true",
          innerHTML: u(Pt)("search")
        }, null, 8, Kle),
        e.compact ? D("", !0) : (f(), h("span", Vle, y(u(r)("panelsearch.trigger")), 1)),
        !e.compact && Se.value ? (f(), h("kbd", jle, y(Se.value), 1)) : D("", !0)
      ], 40, Hle),
      (f(), We(wi, { to: "body" }, [
        k.value ? (f(), h("div", {
          key: 0,
          ref_key: "layer",
          ref: m,
          class: Ne(["fx-psearch__layer", e.compact ? "fx-psearch__layer--full" : "fx-psearch__layer--drop"]),
          style: Xt(B.value),
          role: "dialog",
          "aria-modal": e.compact ? "true" : void 0,
          "aria-label": u(r)("panelsearch.label"),
          "data-testid": "panel-search",
          onFocusout: yt
        }, [
          d("div", Wle, [
            e.compact ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fx-psearch__iconbtn",
              "aria-label": u(r)("panelsearch.close"),
              "data-testid": "panel-search-close",
              onClick: Ke[1] || (Ke[1] = (Le) => ke(!0))
            }, [
              d("span", {
                class: "fx-psearch__glyph",
                "aria-hidden": "true",
                innerHTML: u(Pt)("close")
              }, null, 8, Gle)
            ], 8, Yle)) : (f(), h("span", {
              key: 1,
              class: "fx-psearch__glyph fx-psearch__glyph--field",
              "aria-hidden": "true",
              innerHTML: u(Pt)("search")
            }, null, 8, Xle)),
            cn(d("input", {
              ref_key: "inputEl",
              ref: v,
              "onUpdate:modelValue": Ke[2] || (Ke[2] = (Le) => _.value = Le),
              type: "text",
              class: "fx-psearch__input",
              role: "combobox",
              "aria-label": u(r)("panelsearch.label"),
              "aria-autocomplete": "list",
              "aria-expanded": le.value.length > 0 ? "true" : "false",
              "aria-controls": c,
              "aria-activedescendant": j.value,
              placeholder: u(r)("panelsearch.placeholder"),
              autocomplete: "off",
              autocapitalize: "off",
              spellcheck: "false",
              enterkeyhint: "search",
              "data-testid": "panel-search-input",
              onKeydown: $t
            }, null, 40, Jle), [
              [xn, _.value]
            ]),
            _.value ? (f(), h("button", {
              key: 2,
              type: "button",
              class: "fx-psearch__iconbtn",
              "aria-label": u(r)("panelsearch.clear"),
              "data-testid": "panel-search-clear",
              onClick: qe
            }, [
              d("span", {
                class: "fx-psearch__glyph",
                "aria-hidden": "true",
                innerHTML: u(Pt)("close")
              }, null, 8, Qle)
            ], 8, Zle)) : D("", !0)
          ]),
          d("div", {
            id: c,
            ref_key: "listEl",
            ref: x,
            class: "fx-psearch__list",
            role: "listbox",
            "aria-label": u(r)("panelsearch.results")
          }, [
            (f(!0), h(Ce, null, nt(z.value, (Le) => (f(), h("div", {
              key: Le.key,
              class: "fx-psearch__group",
              role: "group",
              "aria-labelledby": `${l}-h-${Le.key}`,
              "data-testid": `panel-search-group-${Le.key}`
            }, [
              d("div", {
                id: `${l}-h-${Le.key}`,
                class: "fx-psearch__heading",
                role: "presentation"
              }, y(Le.heading), 9, nue),
              (f(!0), h(Ce, null, nt(Le.rows, (ut) => (f(), h("div", {
                id: fe(ut.index),
                key: ut.id,
                class: Ne(["fx-psearch__row", ut.index === w.value && "is-active"]),
                role: "option",
                "aria-selected": ut.index === w.value ? "true" : "false",
                "data-testid": ut.type === "item" ? `panel-search-row-${ut.item.kind}` : `panel-search-${ut.type}`,
                "data-id": ut.type === "item" ? ut.item.id : void 0,
                onMousedown: Ke[3] || (Ke[3] = vt(() => {
                }, ["prevent"])),
                onMouseenter: (wt) => w.value = ut.index,
                onClick: (wt) => Oe(ut)
              }, [
                ut.type === "item" ? (f(), h(Ce, { key: 0 }, [
                  d("span", iue, [
                    ut.item.icon && ut.item.kind !== "file" ? (f(), We(Ki(ut.item.icon), {
                      key: 0,
                      class: "fx-psearch__svg"
                    })) : (f(), h("span", {
                      key: 1,
                      class: "fx-psearch__svg",
                      innerHTML: V(ut.item)
                    }, null, 8, oue))
                  ]),
                  d("span", rue, [
                    d("span", sue, [
                      d("bdi", null, y(ut.item.label), 1)
                    ]),
                    ut.item.detail ? (f(), h("span", lue, [
                      d("bdi", null, y(ut.item.detail), 1)
                    ])) : D("", !0)
                  ])
                ], 64)) : ut.type === "files-all" ? (f(), h(Ce, { key: 1 }, [
                  d("span", uue, [
                    d("span", {
                      class: "fx-psearch__svg",
                      innerHTML: u(Pt)("search")
                    }, null, 8, cue)
                  ]),
                  d("span", due, [
                    d("span", fue, y(u(r)("panelsearch.files_all", { q: A.value.text })), 1)
                  ])
                ], 64)) : (f(), h(Ce, { key: 2 }, [
                  d("span", pue, [
                    d("span", {
                      class: "fx-psearch__svg",
                      innerHTML: u(Pt)("search")
                    }, null, 8, hue)
                  ]),
                  d("span", mue, [
                    d("span", vue, [
                      d("bdi", null, y(ut.entry.query), 1)
                    ])
                  ]),
                  d("button", {
                    type: "button",
                    class: "fx-psearch__iconbtn fx-psearch__remove",
                    tabindex: "-1",
                    "aria-label": u(r)("panelsearch.recent_remove"),
                    title: u(r)("panelsearch.recent_remove"),
                    "data-testid": "panel-search-recent-remove",
                    onClick: vt((wt) => J(ut.entry), ["stop"])
                  }, [
                    d("span", {
                      class: "fx-psearch__glyph",
                      "aria-hidden": "true",
                      innerHTML: u(Pt)("close")
                    }, null, 8, gue)
                  ], 8, yue)
                ], 64))
              ], 42, aue))), 128))
            ], 8, tue))), 128)),
            M.value && le.value.length === 0 ? (f(), h("p", bue, y(u(r)("panelsearch.searching")), 1)) : te.value ? (f(), h("p", kue, y(u(r)("panelsearch.empty", { q: A.value.text })), 1)) : D("", !0),
            L.value ? (f(), h("p", wue, y(u(r)("panelsearch.failed")), 1)) : D("", !0)
          ], 8, eue),
          d("div", _ue, [
            d("span", xue, y(u(r)("panelsearch.prefixes")), 1),
            (f(!0), h(Ce, null, nt(u(Rle), (Le) => (f(), h("button", {
              key: Le,
              type: "button",
              class: Ne(["fx-psearch__chip", A.value.prefix === Le && "is-on"]),
              "aria-pressed": A.value.prefix === Le ? "true" : "false",
              "data-testid": `panel-search-prefix-${Le}`,
              onMousedown: Ke[4] || (Ke[4] = vt(() => {
              }, ["prevent"])),
              onClick: (ut) => Be(A.value.prefix === Le ? "" : Le)
            }, y(Le) + ":", 43, Sue))), 128)),
            A.value.words.length === 0 && A.value.kind === null && F.value.length ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fx-psearch__clearall",
              "data-testid": "panel-search-recent-clear",
              onMousedown: Ke[5] || (Ke[5] = vt(() => {
              }, ["prevent"])),
              onClick: re
            }, y(u(r)("panelsearch.recent_clear")), 33)) : D("", !0)
          ]),
          d("p", $ue, y(X.value), 1)
        ], 46, qle)) : D("", !0)
      ]))
    ], 2));
  }
});
function WT(e, t = {}) {
  return e === "app" ? "wide" : e === "folder" ? t.list ? "wide" : "form" : e === "drop" ? "form" : "gate";
}
function Aue(e, t) {
  const n = (t ?? []).map((r) => r.trim().replace(/^\./, "").toLowerCase()).filter(Boolean);
  if (!n.length) return !0;
  const a = e.lastIndexOf("."), i = a > 0 || a === 0 && e.length > 1 ? e.slice(a + 1).toLowerCase() : "";
  return n.includes(i);
}
function Eue(e, t, n) {
  const a = { accepted: [], refused: [] }, i = (t == null ? void 0 : t.max_file_size_mb) ?? 0;
  let r = t != null && t.max_files && t.max_files > 0 ? t.max_files : 1 / 0;
  typeof n == "number" && Number.isFinite(n) && (r = Math.min(r, Math.max(0, n)));
  for (const l of e)
    Aue(l.name, t == null ? void 0 : t.allowed_ext) ? i > 0 && l.size > i * 1024 * 1024 ? a.refused.push({ file: l, reason: { code: "too_large", name: l.name, mb: i } }) : a.accepted.length >= r ? a.refused.push({ file: l, reason: { code: "too_many", count: r } }) : a.accepted.push(l) : a.refused.push({ file: l, reason: { code: "ext", name: l.name } });
  return a;
}
class Cue extends Error {
  constructor(t, n, a) {
    super(a || n || String(t)), this.status = t, this.code = n, this.name = "PublicLinkError";
  }
}
function jg(e, t, n) {
  const a = (e ?? "").replace(/\/+$/, "");
  return (i = "") => `${a}${t}${encodeURIComponent(n)}${i}`;
}
function zue(e, t) {
  return jg(e, "/api/public/s/", t);
}
function Mue(e, t) {
  return jg(e, "/api/public/d/", t);
}
function qg(e, t) {
  return jg(e, "/api/p/", t);
}
function YT(e, t) {
  const n = (...i) => (t.fetchImpl ?? fetch)(...i);
  async function a(i, r = {}) {
    const l = { Accept: "application/json", "Accept-Language": t.locale() };
    r.body !== void 0 && (l["Content-Type"] = "application/json");
    const c = await n(e(i), {
      method: r.method ?? "GET",
      headers: l,
      credentials: "same-origin",
      cache: "no-store",
      body: r.body !== void 0 ? JSON.stringify(r.body) : void 0
    });
    let p = null;
    try {
      p = await c.json();
    } catch {
      p = null;
    }
    if (!c.ok) {
      const m = p ?? {};
      throw new Cue(c.status, m.error ?? "", m.message);
    }
    return { status: c.status, body: p };
  }
  return {
    /** What the link is and what the visitor may see of it. */
    info: (i = "") => a(i).then((r) => r.body),
    pin: (i) => a("/pin", { method: "POST", body: { pin: i } }).then((r) => r.body),
    /**
     * The app's opening screen.
     *
     * ⚠ There is no `/view` route: an open is `POST /event
     * {"event":"open"}`, because the opening surface and every later one are
     * the same call to the app. One endpoint, one code path in the plugin.
     */
    open: () => a("/event", { method: "POST", body: { event: "open", state: {}, data: {} } }).then(
      (i) => i.body
    ),
    /** `{surface}`, or `{op}` when the server queued a job (202). */
    event: async (i) => {
      var l, c, p;
      const r = await a("/event", {
        method: "POST",
        body: i
      });
      return r.status === 202 || (l = r.body) != null && l.accepted ? { op: { accepted: !0, job_id: (c = r.body) == null ? void 0 : c.job_id }, job_id: (p = r.body) == null ? void 0 : p.job_id } : { surface: r.body.surface };
    },
    /** Where the browser loads an exposed copy from (`pub:N`). */
    fileUrl: (i) => e(`/file/${encodeURIComponent(i)}`),
    /**
     * The same copy, asked for as a DOWNLOAD — the Download button's link.
     * ⚠ Kept apart from `fileUrl` because only this one counts as a download
     * (handlers/public_api.go serveExposed): the page's own viewer loads the
     * document to SHOW it, and the owner ruled on 2026-09-21 that looking at
     * a signing link is not downloading it.
     */
    fileDownloadUrl: (i) => e(`/file/${encodeURIComponent(i)}?download=1`),
    url: e
  };
}
function Wg(e, t) {
  const n = YT(e, t), a = S("loading"), i = S(null), r = S(""), l = S(""), c = S(""), p = S(""), m = S(""), v = S(""), x = Np(
    {
      api: { pluginViewEvent: (T, R, M) => n.event(M) },
      plugin: "",
      view: "",
      locale: t.locale,
      errorText: t.errorText
    },
    {
      onOp: (T) => {
        c.value = String(T.job_id ?? ""), a.value = "accepted";
      },
      onDone: () => {
        a.value !== "accepted" && (a.value = "done");
      },
      onToast: (T) => {
        p.value = T;
      }
    }
  );
  function k(T) {
    const R = T;
    (R == null ? void 0 : R.status) === 404 ? (a.value = "not_found", v.value = "not_found") : (R == null ? void 0 : R.status) === 410 ? (a.value = "gone", v.value = "gone") : (a.value = "error", v.value = "error", m.value = Yi(t.locale(), String((T == null ? void 0 : T.message) ?? T)) || t.errorText());
  }
  async function _() {
    try {
      const T = await n.open(), R = T == null ? void 0 : T.surface;
      if (!R) {
        a.value = "error", m.value = t.errorText();
        return;
      }
      x.setSurface(R), a.value = R.done ? "done" : "ready";
    } catch (T) {
      if ((T == null ? void 0 : T.status) === 401) {
        a.value = "pin";
        return;
      }
      k(T);
    }
  }
  function w(T) {
    return (T == null ? void 0 : T.expired) === !0 || (T == null ? void 0 : T.revoked) === !0;
  }
  async function b(T = "") {
    var R, M, L, U;
    a.value = "loading", m.value = "", v.value = "";
    try {
      i.value = await n.info(T);
    } catch (P) {
      k(P);
      return;
    }
    if (w(i.value)) {
      a.value = "gone", v.value = "gone";
      return;
    }
    if ((R = i.value) != null && R.needs_pin && !((M = i.value) != null && M.unlocked)) {
      a.value = "pin", r.value = ((L = i.value) == null ? void 0 : L.locked) === !0 ? "locked" : "";
      return;
    }
    if ((U = t.hasSurface) != null && U.call(t, i.value)) {
      await _();
      return;
    }
    a.value = "ready";
  }
  const C = S(!1);
  async function A(T) {
    var R;
    if (!C.value) {
      r.value = "", l.value = "", C.value = !0;
      try {
        i.value = await n.pin(T.trim()), w(i.value) ? (a.value = "gone", v.value = "gone") : (R = t.hasSurface) != null && R.call(t, i.value) ? await _() : a.value = "ready";
      } catch (M) {
        const L = M;
        (L == null ? void 0 : L.status) === 429 ? (r.value = "locked", l.value = Yi(t.locale(), L.message ?? "")) : (L == null ? void 0 : L.status) === 401 || (L == null ? void 0 : L.status) === 403 ? r.value = "wrong" : k(M);
      } finally {
        C.value = !1;
      }
    }
  }
  return {
    status: a,
    info: i,
    reason: v,
    pinFailure: r,
    lockMessage: l,
    pinBusy: C,
    failure: m,
    toast: p,
    jobId: c,
    conv: x,
    load: b,
    submitPin: A,
    fileUrl: n.fileUrl,
    fileDownloadUrl: n.fileDownloadUrl,
    /**
     * A `FileRefResolver` for the surface renderer: the URL, plus the name
     * and type the link's own `files[]` already told us.
     *
     * ⚠ The renderer needs the mime to decide how to draw the thing (a
     * picture, an embedded PDF, a link). Handing it a bare URL makes every
     * exposed copy render as "something to download", which is what a
     * `preview` node is specifically not for.
     */
    resolveFile: (T) => {
      var L, U;
      const R = (U = (L = i.value) == null ? void 0 : L.app) == null ? void 0 : U.files, M = R == null ? void 0 : R.find((P) => P.ref === T);
      return { url: n.fileUrl(T), name: M == null ? void 0 : M.name, mime: M == null ? void 0 : M.mime };
    },
    url: n.url
  };
}
function Oue(e, t, n = {}) {
  const a = (e ?? "").replace(/\/+$/, ""), i = encodeURIComponent(t);
  return n.path ? `${a}/s/${i}/f/${n.path.split("/").map(encodeURIComponent).join("/")}?download=1` : `${a}/s/${i}?${n.zip ? "zip=1" : "download=1"}`;
}
function Pue(e, t) {
  return `${(e ?? "").replace(/\/+$/, "")}/s/${encodeURIComponent(t)}?nojs=1`;
}
function Due(e, t) {
  return {
    ...Wg(zue(t.base, e), {
      ...t,
      hasSurface: (a) => (a == null ? void 0 : a.kind) === "app"
    }),
    downloadUrl: (a = {}) => Oue(t.base, e, a),
    noJsUrl: () => Pue(t.base, e)
  };
}
const Lue = /* @__PURE__ */ new Set([504, 524]);
function Rue(e, t) {
  const n = Wg(Mue(t.base, e), t), a = S([]);
  function i(c, p, m) {
    a.value = a.value.map((v, x) => x >= c && x < p ? { ...v, ...m } : v);
  }
  function r(c, p, m) {
    const v = p + c.length;
    return new Promise((x) => {
      let k;
      try {
        k = new XMLHttpRequest();
      } catch {
        i(p, v, { state: "failed", error: t.errorText() }), x();
        return;
      }
      k.open("POST", n.url("/upload")), k.withCredentials = !0, k.setRequestHeader("Accept", "application/json"), k.setRequestHeader("Accept-Language", t.locale()), k.upload.onprogress = (C) => {
        C.lengthComputable && C.total > 0 && i(p, v, { percent: Math.round(C.loaded / C.total * 100) });
      };
      let _ = !1;
      k.upload.onload = () => {
        _ = !0, i(p, v, { state: "saving", percent: 100 });
      };
      const w = () => i(p, v, { state: "unconfirmed", error: (t.unansweredText ?? t.errorText)() });
      k.onload = () => {
        var C;
        if (k.status >= 200 && k.status < 300)
          i(p, v, { state: "done", percent: 100 });
        else {
          let A = "";
          try {
            A = String(((C = JSON.parse(k.responseText)) == null ? void 0 : C.message) ?? "");
          } catch {
            A = "";
          }
          !A && _ && Lue.has(k.status) ? w() : i(p, v, { state: "failed", error: A || t.errorText() });
        }
        x();
      }, k.onerror = () => {
        _ ? w() : i(p, v, { state: "failed", error: t.errorText() }), x();
      };
      const b = new FormData();
      for (const C of c) b.append("file", C, C.name);
      for (const C of c) b.append("name[]", C.name);
      m && b.append("uploader_name", m), k.send(b);
    });
  }
  async function l(c, p = {}) {
    const m = n.info.value, { accepted: v, refused: x } = Eue(Array.from(c), m == null ? void 0 : m.limits, (m == null ? void 0 : m.uploads_left) ?? null), k = p.refusedText ?? (() => t.errorText());
    if (a.value = [
      ...a.value,
      ...x.map(({ file: w, reason: b }) => ({
        name: w.name,
        size: w.size,
        percent: -1,
        state: "refused",
        error: k(b)
      }))
    ], !v.length) return;
    const _ = a.value.length;
    a.value = [
      ...a.value,
      ...v.map((w) => ({ name: w.name, size: w.size, percent: -1, state: "sending" }))
    ], await r(v, _, (p.name ?? "").trim()), await n.load();
  }
  return { ...n, uploads: a, upload: l };
}
function dhe(e, t, n = "") {
  return qg(e, t)(n);
}
function fhe(e, t) {
  return YT(qg(t.base, e), t);
}
function phe(e, t) {
  return Wg(qg(t.base, e), { ...t, hasSurface: () => !0 });
}
const GT = Symbol("filex-public-text");
function XT(e) {
  const t = S({}), n = S(""), a = S(!1);
  let i = 0;
  async function r(l) {
    const c = ++i;
    a.value = !1;
    const p = e.fetchImpl ?? (typeof fetch == "function" ? fetch : null);
    try {
      if (!p) return;
      const m = await p(`${El(e.base)}/api/public/strings?lang=${encodeURIComponent(l)}`, {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "same-origin"
      });
      if (!m.ok) return;
      const v = await m.json();
      if (c !== i) return;
      t.value = v != null && v.strings && typeof v.strings == "object" ? v.strings : {}, n.value = (v == null ? void 0 : v.lang) || l;
    } catch {
    } finally {
      c === i && (a.value = !0);
    }
  }
  return Xe(e.locale, (l) => void r(l), { immediate: !0 }), { table: t, lang: n, ready: a };
}
function JT(e) {
  jo(GT, e);
}
const Nue = ["count", "n"];
function ZT(e, t, n, a = {}) {
  let i;
  const r = Nue.find((l) => l in a);
  if (r !== void 0) {
    const l = $y(t || "en", Number(a[r]));
    l !== "other" && (i = e[`${n}_${l}`]);
  }
  return i = i || e[n] || "", Object.entries(a).reduce((l, [c, p]) => l.replaceAll(`{${c}}`, String(p)), i);
}
function Yg(e) {
  const t = bi(GT, null), n = E(() => (t == null ? void 0 : t.table.value) ?? {}), a = E(() => (t == null ? void 0 : t.lang.value) || (e ? e() : "") || "en"), i = E(() => (t == null ? void 0 : t.ready.value) ?? !0);
  function r(l, c = {}) {
    const p = ZT(n.value, a.value, l, c);
    return p ? Yi(a.value, p) : "";
  }
  return { pt: r, ready: i };
}
const Iue = { class: "fe-ppage__state" }, Bue = { class: "fe-ppage__state-title" }, Fue = { class: "fe-surface__text fe-surface__text--muted" }, Uue = {
  class: "fe-ppage__srlabel",
  for: "fe-ppage-pin"
}, Hue = ["maxlength", "disabled", "aria-invalid"], Kue = {
  key: 0,
  class: "fe-ppage__error",
  role: "alert",
  "data-testid": "public-page-pin-error"
}, Vue = ["disabled"], jue = /* @__PURE__ */ rt({
  __name: "PublicPinGate",
  props: {
    locale: {},
    busy: { type: Boolean },
    failure: {},
    lockMessage: {},
    maxLength: {}
  },
  emits: ["submit"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i } = ht(() => n.locale), r = S(""), l = S(null), c = () => n.failure === "wrong" ? i("plugin.page.pin_wrong") : n.failure === "locked" ? i("plugin.page.pin_locked") : "";
    Xe(
      () => n.failure,
      async (m) => {
        var v;
        m === "wrong" && (r.value = "", await Jt(), (v = l.value) == null || v.focus());
      }
    ), qt(() => {
      var m;
      return (m = l.value) == null ? void 0 : m.focus();
    });
    function p() {
      var m;
      if (!(n.busy || n.failure === "locked")) {
        if (!r.value.trim()) {
          (m = l.value) == null || m.focus();
          return;
        }
        a("submit", r.value);
      }
    }
    return (m, v) => (f(), h("form", {
      class: "fe-ppage__pin",
      "data-testid": "public-page-pin",
      onSubmit: vt(p, ["prevent"])
    }, [
      d("div", Iue, [
        d("h2", Bue, y(u(i)("plugin.page.pin_title")), 1),
        d("p", Fue, y(u(i)("plugin.page.pin_hint")), 1)
      ]),
      d("label", Uue, y(u(i)("plugin.pin.label")), 1),
      cn(d("input", {
        id: "fe-ppage-pin",
        ref_key: "input",
        ref: l,
        "onUpdate:modelValue": v[0] || (v[0] = (x) => r.value = x),
        class: Ne(["fe-cfield__input fe-ppage__pinput", { "is-invalid": !!c() }]),
        type: "text",
        inputmode: "numeric",
        autocomplete: "one-time-code",
        spellcheck: "false",
        maxlength: e.maxLength && e.maxLength > 0 ? e.maxLength : void 0,
        disabled: e.busy || e.failure === "locked",
        "aria-invalid": c() ? "true" : void 0,
        "data-testid": "public-page-pin-input"
      }, null, 10, Hue), [
        [xn, r.value]
      ]),
      c() ? (f(), h("p", Kue, [
        Vt(y(c()), 1),
        e.lockMessage ? (f(), h(Ce, { key: 0 }, [
          Vt(" (" + y(e.lockMessage) + ")", 1)
        ], 64)) : D("", !0)
      ])) : D("", !0),
      d("button", {
        type: "submit",
        class: "fe-btn fe-btn--primary",
        disabled: e.busy || e.failure === "locked",
        "data-testid": "public-page-pin-submit"
      }, y(u(i)("plugin.page.pin_submit")), 9, Vue)
    ], 32));
  }
}), que = {
  key: 0,
  class: "fe-plang",
  role: "group",
  "data-testid": "public-language"
}, Wue = ["lang", "aria-pressed", "title", "data-testid", "onClick"], Yue = {
  key: 0,
  class: "fe-plang__src"
}, Gue = /* @__PURE__ */ rt({
  __name: "PublicLanguagePicker",
  props: {
    modelValue: {},
    pluginNote: { type: Function }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = E(() => (oi.value, Mr())), r = E(() => i.value.length > 1);
    return (l, c) => r.value ? (f(), h("div", que, [
      (f(!0), h(Ce, null, nt(i.value, (p) => (f(), h("button", {
        key: p.code,
        type: "button",
        class: Ne(["fe-plang__btn", { "is-on": p.code === n.modelValue }]),
        lang: p.code,
        "aria-pressed": p.code === n.modelValue ? "true" : "false",
        title: p.source === "plugin" && p.plugin && e.pluginNote ? e.pluginNote(p.plugin) : void 0,
        "data-testid": `public-language-${p.code}`,
        onClick: (m) => a("update:modelValue", p.code)
      }, [
        Vt(y(p.label) + " ", 1),
        p.source === "plugin" && p.plugin ? (f(), h("small", Yue, y(p.plugin), 1)) : D("", !0)
      ], 10, Wue))), 128))
    ])) : D("", !0);
  }
}), Xue = ["dir", "data-state", "data-layout"], Jue = {
  class: "fe-ppage__brand",
  "data-testid": "public-brand"
}, Zue = ["src", "alt"], Que = { class: "fe-ppage__brandname" }, ece = ["data-badge"], tce = {
  key: 0,
  class: "fe-ppage__spinner"
}, nce = ["stroke-width"], ace = {
  key: 1,
  d: "M4.5 12.5l5 5 10-11"
}, ice = {
  key: 1,
  class: "fe-ppage__head"
}, oce = {
  key: 0,
  class: "fe-ppage__title",
  "data-testid": "public-page-title"
}, rce = {
  key: 1,
  class: "fe-ppage__subject",
  "data-testid": "public-page-subject"
}, sce = {
  key: 2,
  class: "fe-ppage__meta",
  "data-testid": "public-page-meta"
}, lce = { key: 0 }, uce = {
  key: 1,
  "aria-hidden": "true"
}, cce = { key: 2 }, dce = {
  key: 3,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-page-loading"
}, fce = {
  key: 6,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-accepted"
}, pce = { class: "fe-ppage__state-title" }, hce = { class: "fe-surface__text" }, mce = {
  key: 7,
  class: "fe-ppage__state fe-ppage__state--ok",
  "data-testid": "public-page-done"
}, vce = { class: "fe-ppage__state-title" }, yce = { class: "fe-surface__text" }, gce = {
  key: 8,
  class: "fe-ppage__state",
  "data-testid": "public-page-error"
}, bce = { class: "fe-ppage__state-title" }, kce = {
  key: 0,
  class: "fe-ppage__error"
}, wce = {
  key: 9,
  class: "fe-ppage__state",
  "data-testid": "public-page-unavailable"
}, _ce = { class: "fe-ppage__state-title" }, xce = { class: "fe-surface__text fe-surface__text--muted" }, Sce = { class: "fe-ppage__foot" }, $ce = {
  key: 0,
  class: "fe-ppage__footline",
  "data-testid": "public-footer-text"
}, Tce = {
  key: 1,
  class: "fe-ppage__footmark",
  "data-testid": "public-footer-powered"
}, Ace = ["src"], QT = /* @__PURE__ */ rt({
  __name: "PublicShell",
  props: {
    status: {},
    locale: {},
    theme: {},
    brandName: {},
    logoUrl: {},
    accentStyle: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    layout: {},
    badge: {},
    title: {},
    subject: {},
    expiresAt: {},
    visitsLeft: {},
    pinMax: {},
    pinBusy: { type: Boolean },
    pinFailure: {},
    lockMessage: {},
    failure: {},
    embedded: { type: Boolean }
  },
  emits: ["pin", "retry", "update:locale"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatDate: r, dir: l } = ht(() => n.locale), { pt: c } = Yg(() => String(n.locale)), p = E(() => n.status === "ready"), m = E(() => p.value ? n.layout ?? "form" : "gate"), v = E(
      () => n.theme === "dark" ? "fe--theme-dark" : n.theme === "light" ? "fe--theme-light" : ""
    ), x = E(() => {
      if (!n.expiresAt) return "";
      const A = Date.parse(n.expiresAt);
      return Number.isFinite(A) ? c("expires", { when: r(A, { time: !0 }) }) : "";
    }), k = E(() => {
      const A = n.visitsLeft;
      return A == null || !Number.isFinite(A) ? "" : c("visits_left", { count: A });
    }), _ = E(() => n.status === "pin" ? "lock" : n.status === "accepted" || n.status === "done" ? "check" : n.status === "loading" ? "loading" : p.value ? n.badge ?? "" : "alert"), w = E(
      () => _.value === "check" ? "fe-ppage__badge--ok" : _.value === "alert" ? "fe-ppage__badge--err" : ""
    ), b = E(() => !n.logoUrl && n.brandName === ap);
    function C(A) {
      return c("language_from", { app: A });
    }
    return (A, T) => (f(), h("div", {
      class: Ne(["fe fe-ppage", [v.value, `fe-ppage--${m.value}`]]),
      dir: u(l),
      style: Xt(e.accentStyle),
      "data-testid": "public-page",
      "data-state": e.status,
      "data-layout": m.value
    }, [
      d("header", Jue, [
        e.logoUrl ? (f(), h("img", {
          key: 0,
          class: "fe-ppage__logo",
          src: e.logoUrl,
          alt: e.brandName
        }, null, 8, Zue)) : b.value ? (f(), We(F0, {
          key: 1,
          class: "fe-ppage__logo"
        })) : D("", !0),
        d("span", Que, y(e.brandName), 1)
      ]),
      (f(), We(Ki(e.embedded ? "div" : "main"), { class: "fe-ppage__card" }, {
        default: mt(() => [
          _.value ? (f(), h("div", {
            key: 0,
            class: Ne(["fe-ppage__badge", w.value]),
            "data-testid": "public-page-badge",
            "data-badge": _.value,
            "aria-hidden": "true"
          }, [
            _.value === "loading" ? (f(), h("span", tce)) : (f(), h("svg", {
              key: 1,
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": _.value === "check" ? 2 : 1.8,
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _.value === "lock" ? (f(), h(Ce, { key: 0 }, [
                T[3] || (T[3] = d("rect", {
                  x: "4.5",
                  y: "10.5",
                  width: "15",
                  height: "9.5",
                  rx: "2"
                }, null, -1)),
                T[4] || (T[4] = d("path", { d: "M8 10.5V7a4 4 0 0 1 8 0v3.5" }, null, -1)),
                T[5] || (T[5] = d("path", { d: "M12 14.5v2" }, null, -1))
              ], 64)) : _.value === "check" ? (f(), h("path", ace)) : _.value === "alert" ? (f(), h(Ce, { key: 2 }, [
                T[6] || (T[6] = d("path", { d: "M10.3 4.2 2.6 17.9a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 4.2a2 2 0 0 0-3.4 0z" }, null, -1)),
                T[7] || (T[7] = d("path", { d: "M12 9.5v4.5" }, null, -1)),
                T[8] || (T[8] = d("path", { d: "M12 17.4h.01" }, null, -1))
              ], 64)) : _.value === "folder" ? (f(), h(Ce, { key: 3 }, [
                T[9] || (T[9] = d("path", { d: "M3.5 7a2 2 0 0 1 2-2h4l2 2h7a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V7z" }, null, -1)),
                T[10] || (T[10] = d("path", { d: "M12 10.5V16" }, null, -1)),
                T[11] || (T[11] = d("path", { d: "M9.5 13.5 12 16l2.5-2.5" }, null, -1))
              ], 64)) : (f(), h(Ce, { key: 4 }, [
                T[12] || (T[12] = d("path", { d: "M7 3.5h7l4 4V20a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 20V5A1.5 1.5 0 0 1 7.5 3.5z" }, null, -1)),
                T[13] || (T[13] = d("path", { d: "M13.5 3.5V8H18" }, null, -1)),
                T[14] || (T[14] = d("path", { d: "M12 11.5V17" }, null, -1)),
                T[15] || (T[15] = d("path", { d: "M9.5 14.5 12 17l2.5-2.5" }, null, -1))
              ], 64))
            ], 8, nce))
          ], 10, ece)) : D("", !0),
          (e.title || e.subject) && p.value ? (f(), h("header", ice, [
            e.title ? (f(), h("h1", oce, [
              d("bdi", null, y(e.title), 1)
            ])) : D("", !0),
            e.subject ? (f(), h("p", rce, y(e.subject), 1)) : D("", !0)
          ])) : D("", !0),
          (x.value || k.value) && p.value ? (f(), h("p", sce, [
            x.value ? (f(), h("span", lce, y(x.value), 1)) : D("", !0),
            x.value && k.value ? (f(), h("span", uce, "·")) : D("", !0),
            k.value ? (f(), h("span", cce, y(k.value), 1)) : D("", !0)
          ])) : D("", !0),
          e.status === "loading" ? (f(), h("p", dce, y(u(i)("plugin.page.loading")), 1)) : e.status === "pin" ? (f(), We(jue, {
            key: 4,
            locale: e.locale,
            busy: e.pinBusy,
            failure: e.pinFailure,
            "lock-message": e.lockMessage,
            "max-length": e.pinMax ?? void 0,
            onSubmit: T[0] || (T[0] = (R) => a("pin", R))
          }, null, 8, ["locale", "busy", "failure", "lock-message", "max-length"])) : p.value ? Ln(A.$slots, "default", { key: 5 }) : e.status === "accepted" ? (f(), h("div", fce, [
            Ln(A.$slots, "accepted", {}, () => [
              d("h2", pce, y(u(i)("plugin.page.accepted_title")), 1),
              d("p", hce, y(u(i)("plugin.page.accepted_text")), 1)
            ])
          ])) : e.status === "done" ? (f(), h("div", mce, [
            Ln(A.$slots, "done", {}, () => [
              d("h2", vce, y(u(i)("plugin.page.done_title")), 1),
              d("p", yce, y(u(i)("plugin.page.done_text")), 1)
            ])
          ])) : e.status === "error" ? (f(), h("div", gce, [
            d("h2", bce, y(u(i)("plugin.page.error_title")), 1),
            e.failure ? (f(), h("p", kce, y(e.failure), 1)) : D("", !0),
            d("button", {
              type: "button",
              class: "fe-btn fe-btn--primary",
              onClick: T[1] || (T[1] = (R) => a("retry"))
            }, y(u(i)("plugin.page.retry")), 1)
          ])) : (f(), h("div", wce, [
            d("h2", _ce, y(u(i)("plugin.page.unavailable_title")), 1),
            d("p", xce, y(u(i)("plugin.page.unavailable_text")), 1)
          ])),
          Ln(A.$slots, "extra")
        ]),
        _: 3
      })),
      d("footer", Sce, [
        Je(Gue, {
          "model-value": String(e.locale),
          "plugin-note": C,
          "onUpdate:modelValue": T[2] || (T[2] = (R) => a("update:locale", R))
        }, null, 8, ["model-value"]),
        e.footerText ? (f(), h("p", $ce, y(e.footerText), 1)) : D("", !0),
        e.hidePoweredBy ? D("", !0) : (f(), h("span", Tce, [
          e.logoUrl ? (f(), h("img", {
            key: 0,
            src: e.logoUrl,
            alt: ""
          }, null, 8, Ace)) : b.value ? (f(), We(F0, { key: 1 })) : D("", !0),
          Vt(" " + y(u(c)("served_by", { name: e.brandName })), 1)
        ]))
      ])
    ], 14, Xue));
  }
}), Ece = {
  key: 0,
  class: "fe-ppage__actions"
}, Cce = {
  key: 1,
  class: "fe-ppage__appfiles",
  "data-testid": "public-page-files"
}, zce = { class: "fe-surface__text" }, Mce = {
  key: 0,
  class: "fe-ppage__filesize"
}, Oce = ["href", "title", "data-testid"], Pce = {
  key: 1,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-unavailable"
}, Dce = {
  key: 0,
  class: "fe-surface__text"
}, Lce = {
  class: "fe-surface__text fe-surface__text--muted",
  role: "status"
}, Rce = {
  key: 2,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-folder"
}, Nce = {
  key: 0,
  class: "fe-surface__text"
}, Ice = {
  key: 1,
  class: "fe-ppage__crumbs",
  "data-testid": "public-share-crumbs"
}, Bce = { class: "fe-ppage__crumb" }, Fce = {
  key: 2,
  class: "fe-ppage__files",
  "data-testid": "public-share-entries"
}, Uce = ["data-dir"], Hce = ["data-testid", "onClick"], Kce = ["href", "data-testid"], Vce = {
  key: 2,
  class: "fe-ppage__filesize"
}, jce = {
  key: 3,
  class: "fe-ppage__filesize"
}, qce = { class: "fe-ppage__actions" }, Wce = ["href"], Yce = ["href"], Gce = {
  key: 3,
  class: "fe-ppage__file-one",
  "data-testid": "public-share-file"
}, Xce = ["src", "alt"], Jce = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-share-fileline"
}, Zce = { key: 0 }, Qce = {
  key: 1,
  class: "fe-ppage__filesize"
}, ede = ["href"], eA = /* @__PURE__ */ rt({
  __name: "PublicShareBody",
  props: {
    link: {},
    locale: {},
    theme: {}
  },
  emits: ["navigate"],
  setup(e, { emit: t }) {
    const n = e, a = t, { t: i, formatSize: r, formatDate: l } = ht(() => n.locale), { pt: c } = Yg(() => String(n.locale)), p = E(() => n.link.info.value), m = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.kind) ?? "file";
    }), v = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.node) ?? null;
    }), x = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.app) ?? null;
    }), k = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.entries) ?? [];
    }), _ = E(() => {
      var C;
      return ((C = p.value) == null ? void 0 : C.unavailable) === !0;
    }), w = E(() => {
      var C;
      return (((C = v.value) == null ? void 0 : C.mime) ?? "").startsWith("image/");
    }), b = E(() => {
      var T;
      const C = (((T = p.value) == null ? void 0 : T.path) ?? "").replace(/\/+$/, "");
      if (!C) return null;
      const A = C.lastIndexOf("/");
      return A <= 0 ? "" : C.slice(0, A);
    });
    return (C, A) => {
      var T, R, M, L, U, P, H, $, F, I, Z, J, re, ve;
      return m.value === "app" ? (f(), h(Ce, { key: 0 }, [
        Je(Ip, {
          conv: e.link.conv,
          locale: e.locale,
          theme: e.theme,
          "file-url": e.link.resolveFile,
          toast: e.link.toast.value,
          layout: "page",
          "page-height": "min(80vh, 1000px)"
        }, null, 8, ["conv", "locale", "theme", "file-url", "toast"]),
        e.link.conv.footer.value.length ? (f(), h("div", Ece, [
          Je(Bp, {
            conv: e.link.conv,
            locale: e.locale,
            "testid-prefix": "public-page"
          }, null, 8, ["conv", "locale"])
        ])) : D("", !0),
        (R = (T = x.value) == null ? void 0 : T.files) != null && R.length ? (f(), h("section", Cce, [
          (f(!0), h(Ce, null, nt(((M = x.value) == null ? void 0 : M.files) ?? [], (W) => (f(), h("div", {
            key: W.ref,
            class: "fe-ppage__file-one fe-ppage__appfile"
          }, [
            d("p", zce, [
              d("strong", null, y(u(fa)(W.name)), 1),
              W.size ? (f(), h("span", Mce, " · " + y(u(r)(W.size)), 1)) : D("", !0)
            ]),
            d("a", {
              class: "fe-btn",
              href: e.link.fileDownloadUrl(W.ref),
              download: "",
              title: u(i)("plugin.page.open_file", { name: u(fa)(W.name) }),
              "data-testid": `public-page-file-${W.ref}`
            }, y(u(i)("ctx.download")), 9, Oce)
          ]))), 128))
        ])) : D("", !0)
      ], 64)) : _.value ? (f(), h("div", Pce, [
        (L = v.value) != null && L.name ? D("", !0) : (f(), h("p", Dce, [
          d("strong", null, y(u(fa)(((U = p.value) == null ? void 0 : U.subject) ?? "")), 1)
        ])),
        d("p", Lce, y(u(c)("err_unavailable_body")), 1)
      ])) : m.value === "folder" ? (f(), h("div", Rce, [
        (P = v.value) != null && P.name ? D("", !0) : (f(), h("p", Nce, [
          d("strong", null, y(u(fa)(((H = p.value) == null ? void 0 : H.subject) ?? "")), 1)
        ])),
        ($ = p.value) != null && $.path ? (f(), h("nav", Ice, [
          d("button", {
            type: "button",
            class: "fe-btn fe-btn--sm",
            onClick: A[0] || (A[0] = (W) => a("navigate", b.value ?? ""))
          }, y(u(c)("folder_up")), 1),
          d("span", Bce, y(u(fa)(((F = p.value) == null ? void 0 : F.path) ?? "")), 1)
        ])) : D("", !0),
        k.value.length ? (f(), h("ul", Fce, [
          (f(!0), h(Ce, null, nt(k.value, (W) => (f(), h("li", {
            key: W.path,
            class: "fe-ppage__file",
            "data-dir": W.is_dir ? "1" : void 0
          }, [
            W.is_dir ? (f(), h("button", {
              key: 0,
              type: "button",
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${W.name}`,
              onClick: (z) => a("navigate", W.path)
            }, [
              d("bdi", null, y(u(fa)(W.name)), 1)
            ], 8, Hce)) : (f(), h("a", {
              key: 1,
              href: W.url || e.link.downloadUrl({ path: W.path }),
              class: "fe-ppage__entry",
              "data-testid": `public-entry-${W.name}`,
              download: ""
            }, [
              d("bdi", null, y(u(fa)(W.name)), 1)
            ], 8, Kce)),
            !W.is_dir && W.size !== void 0 ? (f(), h("span", Vce, y(u(r)(W.size)), 1)) : D("", !0),
            W.modified ? (f(), h("span", jce, y(u(l)(W.modified)), 1)) : D("", !0)
          ], 8, Uce))), 128))
        ])) : D("", !0),
        d("div", qce, [
          d("a", {
            class: "fe-btn fe-btn--primary",
            href: e.link.downloadUrl({ zip: !0 }),
            "data-testid": "public-share-zip"
          }, y(u(c)("folder_zip")), 9, Wce),
          k.value.length ? D("", !0) : (f(), h("a", {
            key: 0,
            class: "fe-btn",
            href: e.link.noJsUrl(),
            "data-testid": "public-share-browse"
          }, y(u(c)("browse")), 9, Yce))
        ])
      ])) : (f(), h("div", Gce, [
        w.value ? (f(), h("img", {
          key: 0,
          class: "fe-ppage__shot",
          src: e.link.downloadUrl(),
          alt: u(fa)(((I = v.value) == null ? void 0 : I.name) ?? "")
        }, null, 8, Xce)) : D("", !0),
        d("p", Jce, [
          (Z = v.value) != null && Z.name ? D("", !0) : (f(), h("strong", Zce, y(u(fa)(((J = p.value) == null ? void 0 : J.subject) ?? "")), 1)),
          ((re = v.value) == null ? void 0 : re.size) !== void 0 ? (f(), h("span", Qce, y(u(r)((ve = v.value) == null ? void 0 : ve.size)), 1)) : D("", !0)
        ]),
        d("a", {
          class: "fe-btn fe-btn--primary",
          href: e.link.downloadUrl(),
          "data-testid": "public-share-download"
        }, y(u(i)("ctx.download")), 9, ede)
      ]));
    };
  }
}), tde = {
  class: "fe-pdrop",
  "data-testid": "public-request"
}, nde = {
  key: 0,
  class: "fe-surface__text",
  "data-testid": "public-request-folder"
}, ade = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "public-request-lead"
}, ide = {
  key: 1,
  class: "fe-pdrop__who",
  "data-testid": "public-request-name"
}, ode = { class: "fe-pdrop__wholabel" }, rde = ["maxlength", "placeholder", "disabled"], sde = ["onKeydown"], lde = { class: "fe-pdrop__lead" }, ude = {
  key: 0,
  class: "fe-surface__text fe-surface__text--muted"
}, cde = ["accept", "disabled"], dde = {
  key: 2,
  class: "fe-ppage__meta",
  "data-testid": "public-request-limits"
}, fde = {
  key: 0,
  "aria-hidden": "true"
}, pde = {
  key: 3,
  class: "fe-pdrop__list",
  "data-testid": "public-request-uploads"
}, hde = ["data-state"], mde = { class: "fe-pdrop__name" }, vde = { class: "fe-ppage__filesize" }, yde = ["value"], gde = {
  class: "fe-pdrop__saving",
  role: "status"
}, bde = {
  key: 2,
  class: "fe-pdrop__ok"
}, kde = {
  key: 3,
  class: "fe-pdrop__unconfirmed",
  role: "status"
}, wde = {
  key: 4,
  class: "fe-surface__error"
}, _de = /* @__PURE__ */ rt({
  __name: "PublicRequestBody",
  props: {
    info: {},
    uploads: {},
    locale: {},
    disabled: { type: Boolean },
    hideFolder: { type: Boolean }
  },
  emits: ["files"],
  setup(e, { emit: t }) {
    const n = e, a = t, i = S(""), r = E(() => {
      var R, M;
      return ((M = (R = n.info) == null ? void 0 : R.limits) == null ? void 0 : M.ask_name) === !0;
    });
    function l(R) {
      a("files", R, r.value ? i.value.trim() : "");
    }
    const { formatSize: c } = ht(() => n.locale), { pt: p } = Yg(() => String(n.locale)), m = E(() => {
      var M, L;
      const R = (L = (M = n.info) == null ? void 0 : M.limits) == null ? void 0 : L.name_max;
      return typeof R == "number" && R > 0 ? R : void 0;
    }), v = S(null), x = S(!1), k = E(() => {
      var R;
      return ((R = n.info) == null ? void 0 : R.limits) ?? {};
    }), _ = E(() => {
      const R = k.value.allowed_ext ?? [];
      return R.length ? R.map((M) => `.${M.replace(/^\./, "")}`).join(",") : void 0;
    }), w = E(() => {
      var P;
      const R = [], M = k.value.max_file_size_mb;
      M && M > 0 && R.push(p("drop_limit_size", { mb: M }));
      const L = k.value.allowed_ext ?? [];
      L.length && R.push(p("drop_limit_ext", { types: L.map((H) => H.toUpperCase()).join(", ") }));
      const U = (P = n.info) == null ? void 0 : P.uploads_left;
      return U != null && Number.isFinite(U) && R.push(p("files_left", { count: U })), R;
    }), b = E(() => {
      var M;
      const R = (M = n.info) == null ? void 0 : M.uploads_left;
      return R != null && Number.isFinite(R) && R <= 0;
    });
    function C() {
      var R;
      n.disabled || b.value || (R = v.value) == null || R.click();
    }
    function A(R) {
      const M = R.target, L = Array.from(M.files ?? []);
      L.length && l(L), M.value = "";
    }
    function T(R) {
      var L;
      if (x.value = !1, n.disabled || b.value) return;
      const M = Array.from(((L = R.dataTransfer) == null ? void 0 : L.files) ?? []);
      M.length && l(M);
    }
    return (R, M) => {
      var L, U;
      return f(), h("div", tde, [
        (L = e.info) != null && L.folder && !e.hideFolder ? (f(), h("p", nde, [
          d("strong", null, y((U = e.info) == null ? void 0 : U.folder), 1)
        ])) : D("", !0),
        d("p", ade, y(u(p)("drop_sub")), 1),
        r.value && !b.value ? (f(), h("label", ide, [
          d("span", ode, y(u(p)("drop_name_label")), 1),
          cn(d("input", {
            "onUpdate:modelValue": M[0] || (M[0] = (P) => i.value = P),
            class: "fe-pdrop__whoinput",
            type: "text",
            maxlength: m.value,
            autocomplete: "name",
            placeholder: u(p)("drop_name_ph"),
            disabled: e.disabled,
            "data-testid": "public-request-name-input"
          }, null, 8, rde), [
            [xn, i.value]
          ])
        ])) : D("", !0),
        d("div", {
          class: Ne(["fe-pdrop__zone", { "is-over": x.value, "is-disabled": e.disabled || b.value }]),
          role: "button",
          tabindex: "0",
          "data-testid": "public-request-drop",
          onClick: C,
          onKeydown: [
            za(vt(C, ["prevent"]), ["enter"]),
            za(vt(C, ["prevent"]), ["space"])
          ],
          onDragover: M[1] || (M[1] = vt((P) => x.value = !0, ["prevent"])),
          onDragleave: M[2] || (M[2] = (P) => x.value = !1),
          onDrop: vt(T, ["prevent"])
        }, [
          M[3] || (M[3] = d("svg", {
            class: "fe-pdrop__icon",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.7",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true"
          }, [
            d("path", { d: "M4 14.9A7 7 0 1 1 15.7 8h1.8a4.5 4.5 0 0 1 2.5 8.2" }),
            d("path", { d: "M12 12v9" }),
            d("path", { d: "m16 16-4-4-4 4" })
          ], -1)),
          d("p", lde, y(b.value ? u(p)("request_full") : u(p)("drop_zone_big")), 1),
          b.value ? D("", !0) : (f(), h("p", ude, y(u(p)("drop_zone_hint")), 1)),
          d("input", {
            ref_key: "input",
            ref: v,
            class: "fe-pdrop__input",
            type: "file",
            multiple: "",
            accept: _.value,
            disabled: e.disabled || b.value,
            "data-testid": "public-request-input",
            onChange: A
          }, null, 40, cde)
        ], 42, sde),
        w.value.length ? (f(), h("p", dde, [
          (f(!0), h(Ce, null, nt(w.value, (P, H) => (f(), h(Ce, { key: H }, [
            H ? (f(), h("span", fde, "·")) : D("", !0),
            d("span", null, y(P), 1)
          ], 64))), 128))
        ])) : D("", !0),
        e.uploads.length ? (f(), h("ul", pde, [
          (f(!0), h(Ce, null, nt(e.uploads, (P, H) => (f(), h("li", {
            key: `${P.name}-${H}`,
            class: "fe-pdrop__item",
            "data-state": P.state
          }, [
            d("span", mde, [
              d("bdi", null, y(u(fa)(P.name)), 1)
            ]),
            d("span", vde, y(u(c)(P.size)), 1),
            P.state === "sending" ? (f(), h("progress", {
              key: 0,
              class: "fe-pdrop__bar",
              max: 100,
              value: P.percent >= 0 ? P.percent : void 0
            }, null, 8, yde)) : P.state === "saving" ? (f(), h(Ce, { key: 1 }, [
              M[4] || (M[4] = d("progress", {
                class: "fe-pdrop__bar",
                max: 100
              }, null, -1)),
              d("span", gde, y(u(p)("upload_saving")), 1)
            ], 64)) : P.state === "done" ? (f(), h("span", bde, y(u(p)("upload_done")), 1)) : P.state === "unconfirmed" ? (f(), h("span", kde, y(P.error || u(p)("upload_unanswered")), 1)) : (f(), h("span", wde, y(P.error || u(p)("drop_err_generic")), 1))
          ], 8, hde))), 128))
        ])) : D("", !0)
      ]);
    };
  }
}), hhe = /* @__PURE__ */ rt({
  __name: "PublicLinkPage",
  props: {
    kind: {},
    token: {},
    base: {},
    locale: {},
    theme: {}
  },
  setup(e) {
    const t = e, n = S(""), a = E(() => {
      if (t.locale) return String(t.locale);
      if (n.value) return n.value;
      const $ = Wi(rp("locale"));
      return $ && Df($) ? $ : a2();
    });
    function i($) {
      const F = Wi($);
      !F || !Df(F) || (n.value = F, Vr("locale", F));
    }
    const { t: r } = ht(() => a.value), l = XT({ base: t.base ?? Zu(), locale: () => a.value });
    JT(l);
    const c = S(!1);
    Xe(
      () => l.ready.value,
      ($) => {
        $ && (c.value = !0);
      },
      { immediate: !0 }
    );
    function p($, F = {}) {
      return ZT(l.table.value, l.lang.value || a.value, $, F);
    }
    const m = t.base ?? Zu(), v = cB({ base: m }), x = Ml(), k = E(() => {
      const $ = t.theme && t.theme !== "auto" ? t.theme : rp("theme") || v.themeDefault.value;
      return $ === "light" || $ === "dark" ? $ : x.value ? "dark" : "light";
    }), _ = {
      base: m,
      locale: () => a.value,
      errorText: () => r("plugin.view.error")
    }, w = t.kind === "share" ? Due(t.token ?? "", _) : null, b = t.kind === "request" ? Rue(t.token ?? "", {
      ..._,
      errorText: () => p("drop_err_generic"),
      unansweredText: () => p("upload_unanswered")
    }) : null;
    function C($) {
      return $.code === "ext" ? p("drop_err_ext", { name: $.name }) : $.code === "too_large" ? p("drop_err_too_large", { name: $.name, mb: $.mb }) : $.count <= 0 ? p("request_full") : p("drop_err_too_many", { count: $.count });
    }
    const A = w ?? b, T = E(() => (w == null ? void 0 : w.info.value) ?? null), R = E(() => (b == null ? void 0 : b.info.value) ?? null), M = E(() => {
      var I, Z, J, re, ve;
      const $ = (I = T.value) == null ? void 0 : I.app, F = Zt((Z = w == null ? void 0 : w.conv.current.value) == null ? void 0 : Z.title, a.value);
      return $ ? F || Zt($.title, a.value) || "" : fa(((re = (J = T.value) == null ? void 0 : J.node) == null ? void 0 : re.name) || ((ve = R.value) == null ? void 0 : ve.folder) || "");
    }), L = E(() => {
      var F;
      const $ = fa(((F = A.info.value) == null ? void 0 : F.subject) ?? "");
      return $ && $ !== M.value ? $ : "";
    }), U = E(
      () => {
        var $, F, I;
        return WT((($ = T.value) == null ? void 0 : $.kind) ?? (b ? "drop" : ""), {
          list: (((I = (F = T.value) == null ? void 0 : F.entries) == null ? void 0 : I.length) ?? 0) > 0
        });
      }
    ), P = E(() => {
      var F;
      if (b) return "";
      const $ = (F = T.value) == null ? void 0 : F.kind;
      return $ === "folder" ? "folder" : $ === "app" ? "" : "file";
    });
    function H($) {
      A.load($ ? `?path=${encodeURIComponent($)}` : "");
    }
    return Xe(M, ($) => {
      $ && typeof document < "u" && (document.title = $);
    }), Xe(
      a,
      ($) => {
        typeof document < "u" && (document.documentElement.lang = $);
      },
      { immediate: !0 }
    ), Xe(a, () => {
      var $;
      A.status.value === "ready" && (($ = T.value) == null ? void 0 : $.kind) === "app" && (A.conv.current.value ? A.conv.post("change") : A.load());
    }), qt(() => {
      if (v.load(), !t.token) {
        A.status.value = "not_found";
        return;
      }
      A.load();
    }), ($, F) => {
      var I, Z, J, re;
      return f(), We(QT, {
        status: c.value ? u(A).status.value : "loading",
        locale: a.value,
        theme: k.value,
        "brand-name": u(v).name.value,
        "logo-url": u(v).logo.value,
        "accent-style": u(v).accentStyle.value,
        "footer-text": u(v).footerText.value,
        "hide-powered-by": u(v).hidePoweredBy.value,
        layout: U.value,
        badge: P.value,
        title: M.value,
        subject: L.value,
        "expires-at": ((I = u(A).info.value) == null ? void 0 : I.expires_at) ?? null,
        "visits-left": ((Z = T.value) == null ? void 0 : Z.visits_left) ?? ((J = R.value) == null ? void 0 : J.uploads_left) ?? null,
        "pin-max": ((re = u(A).info.value) == null ? void 0 : re.pin_max) ?? null,
        "pin-busy": u(A).pinBusy.value,
        "pin-failure": u(A).pinFailure.value,
        "lock-message": u(A).lockMessage.value,
        failure: u(A).failure.value,
        onPin: F[1] || (F[1] = (ve) => u(A).submitPin(ve)),
        onRetry: F[2] || (F[2] = () => u(A).load()),
        "onUpdate:locale": i
      }, {
        default: mt(() => [
          u(w) ? (f(), We(eA, {
            key: 0,
            link: u(w),
            locale: a.value,
            theme: k.value,
            onNavigate: H
          }, null, 8, ["link", "locale", "theme"])) : u(b) ? (f(), We(_de, {
            key: 1,
            info: R.value,
            uploads: u(b).uploads.value,
            locale: a.value,
            "hide-folder": "",
            onFiles: F[0] || (F[0] = (ve, W) => u(b).upload(ve, { name: W, refusedText: C }))
          }, null, 8, ["info", "uploads", "locale"])) : D("", !0)
        ]),
        _: 1
      }, 8, ["status", "locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "badge", "title", "subject", "expires-at", "visits-left", "pin-max", "pin-busy", "pin-failure", "lock-message", "failure"]);
    };
  }
}), xde = {
  class: "fe-ppreview",
  inert: "",
  "data-testid": "public-link-preview"
}, mhe = /* @__PURE__ */ rt({
  __name: "PublicLinkPreview",
  props: {
    brandName: {},
    logoUrl: {},
    accent: {},
    footerText: {},
    hidePoweredBy: { type: Boolean },
    locale: {},
    theme: {},
    sample: {}
  },
  setup(e) {
    const t = e, n = E(() => t.sample ?? { name: "report-2026.pdf", size: 124e4, mime: "application/pdf" }), a = E(() => ({
      kind: "file",
      node: { name: n.value.name, size: n.value.size, mime: n.value.mime ?? "application/pdf" }
    })), i = E(
      () => ({
        info: S(a.value),
        downloadUrl: () => "#",
        noJsUrl: () => "#"
      })
    ), r = E(() => {
      var l;
      return ((l = t.brandName) == null ? void 0 : l.trim()) || ap;
    });
    return JT(XT({ base: Zu(), locale: () => String(t.locale) })), (l, c) => {
      var p, m;
      return f(), h("div", xde, [
        Je(QT, {
          status: "ready",
          locale: e.locale,
          theme: e.theme ?? "light",
          "brand-name": r.value,
          "logo-url": ((p = e.logoUrl) == null ? void 0 : p.trim()) || "",
          "accent-style": u(e$)(e.accent),
          "footer-text": ((m = e.footerText) == null ? void 0 : m.trim()) || "",
          "hide-powered-by": e.hidePoweredBy === !0,
          layout: u(WT)("file"),
          badge: "file",
          title: n.value.name,
          embedded: ""
        }, {
          default: mt(() => [
            Je(eA, {
              link: i.value,
              locale: e.locale,
              theme: e.theme ?? "light"
            }, null, 8, ["link", "locale", "theme"])
          ]),
          _: 1
        }, 8, ["locale", "theme", "brand-name", "logo-url", "accent-style", "footer-text", "hide-powered-by", "layout", "title"])
      ]);
    };
  }
}), Sde = {
  key: 0,
  class: "fe-apppage__bar"
}, $de = {
  class: "fe-apppage__title",
  "data-testid": "plugin-page-title"
}, Tde = ["title"], Ade = ["href"], Ede = {
  key: 0,
  class: "fe-surface__text",
  role: "status"
}, Cde = {
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, zde = {
  key: 1,
  class: "fe-surface__text fe-surface__text--muted",
  "data-testid": "plugin-page-loading"
}, Mde = ["data-job"], Ode = {
  class: "fe-apppage__state-title",
  "data-testid": "plugin-page-job-title"
}, Pde = ["role"], Dde = { class: "fe-apppage__state-actions" }, Lde = ["href"], Rde = ["href"], Nde = {
  key: 4,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-done"
}, Ide = { class: "fe-apppage__state-title" }, Bde = { class: "fe-surface__text" }, Fde = { class: "fe-apppage__state-actions" }, Ude = ["href"], Hde = {
  key: 5,
  class: "fe-apppage__state",
  "data-testid": "plugin-page-error"
}, Kde = { class: "fe-apppage__state-title" }, Vde = {
  key: 0,
  class: "fe-surface__error"
}, jde = { class: "fe-apppage__state-actions" }, qde = ["href"], Wde = {
  key: 4,
  class: "fe-apppage__foot"
}, vhe = /* @__PURE__ */ rt({
  __name: "PluginPageView",
  props: {
    locale: {},
    theme: {},
    api: {},
    userName: {},
    plugin: {},
    view: {},
    path: {},
    storages: {},
    startAt: {},
    backHref: {},
    opsHref: {},
    mountBase: {},
    frame: {},
    section: {}
  },
  emits: ["op", "section"],
  setup(e, { expose: t, emit: n }) {
    const a = e, i = n, { t: r } = ht(() => a.locale), l = E(() => a.frame === "embedded"), c = E(() => l.value ? "div" : "main"), p = S("loading"), m = S(""), v = S(""), x = S("running"), k = S(""), _ = S(/* @__PURE__ */ new Set());
    function w(le) {
      const fe = o_(le, {
        plugin: a.plugin,
        base: a.mountBase,
        placementOf: (j) => _.value.has(j) ? "page" : void 0
      });
      if (!fe.href) return !1;
      try {
        return window.location.assign(fe.href), !0;
      } catch {
        return !1;
      }
    }
    function b(le) {
      if (le.status === "done") {
        k.value = le.message ?? "";
        const fe = wS(le);
        if (fe && w(fe.open)) {
          x.value = "opening";
          return;
        }
        x.value = "done";
        return;
      }
      k.value = Ff(le, r).text, x.value = "failed";
    }
    const C = U2({}, a.api, { onSettled: b });
    function A(le) {
      var fe;
      x.value = "running", k.value = "", (fe = a.api.endpoints) != null && fe.opsList && C.register(le);
    }
    const T = E(() => {
      switch (x.value) {
        case "done":
          return r("plugin.page_view.finished_title");
        case "failed":
          return r("plugin.page_view.failed_title");
        case "opening":
          return r("plugin.page_view.opening_title");
        default:
          return r("plugin.page_view.queued_title");
      }
    }), R = E(() => x.value === "running" ? r("plugin.page_view.queued_text") : x.value === "done" ? k.value || r("plugin.page_view.finished_text") : k.value), M = Np(
      {
        api: a.api,
        plugin: a.plugin,
        view: a.view,
        path: () => a.path,
        locale: () => a.locale,
        errorText: () => r("plugin.view.error")
      },
      {
        // ⚠ `onOp` fires BEFORE `onDone` (usePluginSurface posts them in that
        // order), so the queued state has to be set after both — otherwise
        // `onDone` would overwrite it with "finished" and the person would never
        // see that a job is running.
        /**
         * v3 §3.0 — "go to this file, and start that screen on it".
         *
         * ⚠ A real navigation, not a tab: this IS a whole page, and the person
         * asked to be taken to a document. The address is the explorer deep link
         * a notification already uses, so the placement question is answered
         * where it is answerable — the explorer knows which of the plugin's
         * views is a `page` and opens that one in its own tab.
         */
        onOpen: (le) => {
          const fe = o_(le, { plugin: a.plugin, base: a.mountBase });
          if (fe.href)
            try {
              if (fe.newTab) {
                const j = window.open(fe.href, "_blank");
                j ? j.opener = null : window.location.assign(fe.href);
              } else
                window.location.assign(fe.href);
            } catch {
            }
        },
        onOp: (le) => {
          i("op", le), p.value = "queued", A(le);
        },
        onDone: () => {
          p.value !== "queued" && (p.value = "done");
        },
        onToast: (le) => v.value = le
      }
    ), L = M.current, U = E(() => {
      var le;
      return Zt((le = L.value) == null ? void 0 : le.title, a.locale) || a.view;
    }), P = S(a.section ?? ""), H = E(() => {
      var le;
      return ((le = L.value) == null ? void 0 : le.sections) ?? [];
    }), $ = E(() => {
      var le;
      return ((le = L.value) == null ? void 0 : le.section) || P.value;
    });
    function F(le) {
      !le || le === $.value || (P.value = le, i("section", le), I());
    }
    Xe(
      () => a.section,
      (le) => {
        const fe = le ?? "";
        fe !== P.value && (P.value = fe, I());
      }
    );
    async function I() {
      var le;
      L.value || (p.value = "loading"), m.value = "";
      try {
        const fe = P.value ? await a.api.pluginView(a.plugin, a.view, a.path, P.value) : await a.api.pluginView(a.plugin, a.view, a.path);
        if (!(fe != null && fe.surface)) {
          m.value = r("plugin.view.error"), p.value = "error";
          return;
        }
        M.setSurface(fe.surface), p.value = "surface";
        const j = fe.surface.section ?? "";
        !P.value && j && (P.value = j, i("section", j, { replace: !0 }));
      } catch (fe) {
        m.value = ((le = r.foreign) == null ? void 0 : le.call(r, String((fe == null ? void 0 : fe.message) ?? ""))) || r("plugin.view.error"), p.value = "error";
      }
    }
    const Z = S(null), J = S("page"), re = S(!1), ve = E(
      () => a.path ? [{ path: a.path, name: a.path.split("/").pop() || a.path }] : []
    );
    async function W() {
      try {
        const le = await a.api.pluginActions();
        _.value = new Set(
          (le.actions ?? []).filter((X) => X.plugin === a.plugin && X.view && Kf(X.view_placement)).map((X) => X.view)
        );
        const fe = le.views.find((X) => X.plugin === a.plugin && X.id === a.view && X.ui);
        if (fe != null && fe.ui) {
          Z.value = fe.ui, J.value = fe.placement === "home" ? "home" : "page";
          return;
        }
        const j = le.actions.find((X) => X.plugin === a.plugin && X.view === a.view && X.ui);
        j != null && j.ui && (Z.value = j.ui);
      } catch {
      } finally {
        re.value = !0;
      }
    }
    qt(async () => {
      await W(), Z.value || I();
    }), t({ reload: I });
    const z = E(() => {
      var fe;
      let le = !1;
      return Uc((fe = M.current.value) == null ? void 0 : fe.nodes, (j) => {
        var X;
        j.type === "pdf-fields" && ((X = j.props) == null ? void 0 : X.mode) !== "define" && (le = !0);
      }), le;
    });
    return (le, fe) => (f(), h("div", {
      class: Ne(["fe fe-apppage", [
        e.theme === "dark" ? "fe--theme-dark" : e.theme === "light" ? "fe--theme-light" : "",
        { "is-doc": z.value && !l.value, "fe-apppage--embedded": l.value }
      ]]),
      "data-testid": "plugin-page"
    }, [
      l.value ? D("", !0) : (f(), h("header", Sde, [
        d("h1", $de, y(U.value), 1),
        e.path ? (f(), h("p", {
          key: 0,
          class: "fe-apppage__path",
          title: e.path
        }, y(e.path), 9, Tde)) : D("", !0),
        e.backHref ? (f(), h("a", {
          key: 1,
          class: "fe-btn fe-apppage__back",
          href: e.backHref,
          "data-testid": "plugin-page-back"
        }, y(u(r)("plugin.page_view.back")), 9, Ade)) : D("", !0)
      ])),
      Z.value ? (f(), We(Ki(c.value), {
        key: 1,
        class: "fe-apppage__body fe-apppage__body--ui"
      }, {
        default: mt(() => [
          Je(Sg, {
            api: e.api,
            app: e.plugin,
            version: Z.value.version,
            view: e.view,
            placement: J.value,
            ui: Z.value,
            files: ve.value,
            storages: e.storages,
            "start-at": e.startAt,
            locale: e.locale,
            theme: e.theme,
            title: U.value,
            "user-name": e.userName,
            onToast: fe[0] || (fe[0] = (j) => v.value = j.text),
            onOp: fe[1] || (fe[1] = (j) => i("op", j))
          }, null, 8, ["api", "app", "version", "view", "placement", "ui", "files", "storages", "start-at", "locale", "theme", "title", "user-name"]),
          v.value ? (f(), h("p", Ede, y(v.value), 1)) : D("", !0)
        ]),
        _: 1
      })) : re.value ? (f(), We(Ki(c.value), {
        key: 3,
        class: "fe-apppage__body"
      }, {
        default: mt(() => [
          p.value === "surface" && H.value.length ? (f(), We(OT, {
            key: 0,
            sections: H.value,
            active: $.value,
            locale: e.locale,
            label: U.value,
            disabled: u(M).busy.value,
            onSelect: F
          }, null, 8, ["sections", "active", "locale", "label", "disabled"])) : D("", !0),
          p.value === "loading" ? (f(), h("p", zde, y(u(r)("plugin.view.loading")), 1)) : p.value === "surface" ? (f(), We(Ip, {
            key: 2,
            conv: u(M),
            locale: e.locale,
            theme: e.theme,
            api: e.api,
            plugin: e.plugin,
            storages: e.storages,
            "start-at": e.startAt,
            toast: v.value,
            layout: l.value ? "inline" : "page"
          }, null, 8, ["conv", "locale", "theme", "api", "plugin", "storages", "start-at", "toast", "layout"])) : p.value === "queued" ? (f(), h("div", {
            key: 3,
            class: "fe-apppage__state",
            "data-testid": "plugin-page-queued",
            "data-job": x.value
          }, [
            d("h2", Ode, y(T.value), 1),
            d("p", {
              class: Ne(x.value === "failed" ? "fe-surface__error" : "fe-surface__text"),
              role: x.value === "failed" ? "alert" : "status",
              "data-testid": "plugin-page-job-text"
            }, y(R.value), 11, Pde),
            d("div", Dde, [
              e.opsHref ? (f(), h("a", {
                key: 0,
                class: "fe-btn fe-btn--primary",
                href: e.opsHref,
                "data-testid": "plugin-page-ops"
              }, y(u(r)("plugin.page_view.open_ops")), 9, Lde)) : D("", !0),
              e.backHref ? (f(), h("a", {
                key: 1,
                class: "fe-btn",
                href: e.backHref
              }, y(u(r)("plugin.page_view.back")), 9, Rde)) : D("", !0)
            ])
          ], 8, Mde)) : p.value === "done" ? (f(), h("div", Nde, [
            d("h2", Ide, y(u(r)("plugin.page_view.done_title")), 1),
            d("p", Bde, y(u(r)("plugin.page_view.done_text")), 1),
            d("div", Fde, [
              e.backHref ? (f(), h("a", {
                key: 0,
                class: "fe-btn fe-btn--primary",
                href: e.backHref
              }, y(u(r)("plugin.page_view.back")), 9, Ude)) : D("", !0)
            ])
          ])) : (f(), h("div", Hde, [
            d("h2", Kde, y(u(r)("plugin.page_view.error_title")), 1),
            m.value ? (f(), h("p", Vde, y(m.value), 1)) : D("", !0),
            d("div", jde, [
              d("button", {
                type: "button",
                class: "fe-btn",
                onClick: fe[2] || (fe[2] = (j) => I())
              }, y(u(r)("plugin.page_view.retry")), 1),
              e.backHref ? (f(), h("a", {
                key: 0,
                class: "fe-btn",
                href: e.backHref
              }, y(u(r)("plugin.page_view.back")), 9, qde)) : D("", !0)
            ])
          ]))
        ]),
        _: 1
      })) : (f(), We(Ki(c.value), {
        key: 2,
        class: "fe-apppage__body"
      }, {
        default: mt(() => [
          d("p", Cde, y(u(r)("plugin.view.loading")), 1)
        ]),
        _: 1
      })),
      p.value === "surface" && u(M).footer.value.length ? (f(), h("footer", Wde, [
        Je(Bp, {
          conv: u(M),
          locale: e.locale,
          "testid-prefix": "plugin-page"
        }, null, 8, ["conv", "locale"])
      ])) : D("", !0)
    ], 2));
  }
});
function yhe(e) {
  const t = e.trim().toLowerCase();
  return t === "7z" ? "7z" : t.toUpperCase();
}
const Yde = {
  key: 0,
  class: "fe-connlost",
  role: "status",
  "aria-live": "polite",
  "data-testid": "connection-notice"
}, Gde = { class: "fe-connlost__text" }, ghe = /* @__PURE__ */ rt({
  __name: "ConnectionNotice",
  props: {
    locale: {}
  },
  setup(e) {
    const t = e, { t: n } = ht(() => t.locale ?? "en");
    return (a, i) => u(KO) ? (f(), h("div", Yde, [
      i[0] || (i[0] = d("span", {
        class: "fe-connlost__dot",
        "aria-hidden": "true"
      }, null, -1)),
      d("span", Gde, y(u(n)("err.network")), 1)
    ])) : D("", !0);
  }
});
export {
  aie as $,
  i7 as A,
  n7 as B,
  YP as C,
  gi as D,
  Ca as E,
  Zpe as F,
  Rse as G,
  N1 as H,
  XP as I,
  p2 as J,
  GP as K,
  Jpe as L,
  S2 as M,
  yfe as N,
  dP as O,
  $fe as P,
  Tfe as Q,
  NP as R,
  Zr as S,
  Afe as T,
  Efe as U,
  N2 as V,
  Ac as W,
  Cfe as X,
  ap as Y,
  rie as Z,
  na as _,
  Zt as a,
  j4 as a$,
  S$ as a0,
  cpe as a1,
  M5 as a2,
  Mr as a3,
  Ml as a4,
  gfe as a5,
  Kfe as a6,
  Vfe as a7,
  k4 as a8,
  ahe as a9,
  jI as aA,
  bg as aB,
  Cv as aC,
  G2 as aD,
  xi as aE,
  xl as aF,
  Rf as aG,
  pfe as aH,
  mfe as aI,
  GS as aJ,
  Ly as aK,
  R2 as aL,
  B2 as aM,
  Ife as aN,
  Nfe as aO,
  xx as aP,
  zL as aQ,
  Gf as aR,
  Jy as aS,
  A2 as aT,
  x2 as aU,
  SO as aV,
  $O as aW,
  AO as aX,
  bfe as aY,
  M2 as aZ,
  wfe as a_,
  zm as aa,
  ooe as ab,
  Rp as ac,
  MJ as ad,
  Hfe as ae,
  fc as af,
  oie as ag,
  mi as ah,
  Npe as ai,
  rhe as aj,
  Al as ak,
  the as al,
  Yi as am,
  Vse as an,
  nhe as ao,
  yJ as ap,
  vJ as aq,
  Hf as ar,
  oS as as,
  Dpe as at,
  jpe as au,
  ihe as av,
  Ppe as aw,
  N0 as ax,
  b2 as ay,
  gp as az,
  Wo as b,
  T4 as b$,
  dpe as b0,
  H4 as b1,
  xI as b2,
  Za as b3,
  Ko as b4,
  Ape as b5,
  $pe as b6,
  Tpe as b7,
  cy as b8,
  Ev as b9,
  Jn as bA,
  es as bB,
  Ap as bC,
  Tx as bD,
  Cc as bE,
  PL as bF,
  ka as bG,
  Tp as bH,
  qu as bI,
  bf as bJ,
  xo as bK,
  Yy as bL,
  un as bM,
  boe as bN,
  rS as bO,
  my as bP,
  moe as bQ,
  M_ as bR,
  Kpe as bS,
  d0 as bT,
  tT as bU,
  wJ as bV,
  ip as bW,
  F0 as bX,
  hP as bY,
  Ju as bZ,
  lhe as b_,
  Ofe as ba,
  Rpe as bb,
  Mq as bc,
  ly as bd,
  vo as be,
  yhe as bf,
  Kse as bg,
  LM as bh,
  hoe as bi,
  J0 as bj,
  go as bk,
  lO as bl,
  Zo as bm,
  pJ as bn,
  DY as bo,
  ghe as bp,
  DX as bq,
  zse as br,
  MS as bs,
  Fa as bt,
  Om as bu,
  cT as bv,
  Vne as bw,
  aO as bx,
  tO as by,
  nO as bz,
  rfe as c,
  q2 as c$,
  jfe as c0,
  UG as c1,
  voe as c2,
  Lie as c3,
  BT as c4,
  toe as c5,
  oU as c6,
  EZ as c7,
  Ope as c8,
  VT as c9,
  d5 as cA,
  hN as cB,
  aG as cC,
  ty as cD,
  koe as cE,
  dR as cF,
  _l as cG,
  kG as cH,
  Kae as cI,
  cR as cJ,
  ZR as cK,
  Y$ as cL,
  Ip as cM,
  Bp as cN,
  R6 as cO,
  K6 as cP,
  JS as cQ,
  yS as cR,
  oT as cS,
  pp as cT,
  bc as cU,
  Uf as cV,
  Ku as cW,
  wO as cX,
  dT as cY,
  mp as cZ,
  jZ as c_,
  Nle as ca,
  Dle as cb,
  jT as cc,
  Lle as cd,
  Rle as ce,
  _f as cf,
  Gv as cg,
  zP as ch,
  vP as ci,
  n$ as cj,
  lF as ck,
  hc as cl,
  noe as cm,
  Bg as cn,
  GT as co,
  che as cp,
  vhe as cq,
  Gue as cr,
  Cue as cs,
  hhe as ct,
  mhe as cu,
  jue as cv,
  _de as cw,
  eA as cx,
  QT as cy,
  b4 as cz,
  mv as d,
  _fe as d$,
  BJ as d0,
  nT as d1,
  Z4 as d2,
  A0 as d3,
  FT as d4,
  qse as d5,
  upe as d6,
  fpe as d7,
  lpe as d8,
  zT as d9,
  B4 as dA,
  M4 as dB,
  U0 as dC,
  gg as dD,
  rY as dE,
  fY as dF,
  sY as dG,
  iY as dH,
  oY as dI,
  aY as dJ,
  Xfe as dK,
  ene as dL,
  Sc as dM,
  ul as dN,
  Ol as dO,
  cJ as dP,
  zu as dQ,
  by as dR,
  Wfe as dS,
  tpe as dT,
  Kv as dU,
  Jfe as dV,
  ipe as dW,
  pP as dX,
  BS as dY,
  hF as dZ,
  KO as d_,
  e$ as da,
  UM as db,
  woe as dc,
  CO as dd,
  zO as de,
  Mfe as df,
  xO as dg,
  HL as dh,
  rT as di,
  Vg as dj,
  ppe as dk,
  Zu as dl,
  rU as dm,
  Ny as dn,
  Iy as dp,
  By as dq,
  FJ as dr,
  zpe as ds,
  R5 as dt,
  lT as du,
  kJ as dv,
  x4 as dw,
  CT as dx,
  uV as dy,
  dV as dz,
  Wpe as e,
  Hv as e$,
  xfe as e0,
  ba as e1,
  qW as e2,
  _2 as e3,
  GX as e4,
  aT as e5,
  YX as e6,
  XX as e7,
  WX as e8,
  eS as e9,
  vL as eA,
  ei as eB,
  qne as eC,
  GI as eD,
  wV as eE,
  ofe as eF,
  Mv as eG,
  Mp as eH,
  Gs as eI,
  NT as eJ,
  Uv as eK,
  S_ as eL,
  Ov as eM,
  t2 as eN,
  tle as eO,
  Ox as eP,
  Cx as eQ,
  A_ as eR,
  KT as eS,
  hy as eT,
  kie as eU,
  _oe as eV,
  US as eW,
  IS as eX,
  O5 as eY,
  wF as eZ,
  sS as e_,
  Fv as ea,
  Qte as eb,
  a4 as ec,
  Dfe as ed,
  yoe as ee,
  qae as ef,
  gx as eg,
  yx as eh,
  she as ei,
  Qi as ej,
  mq as ek,
  KL as el,
  Jf as em,
  Nv as en,
  iv as eo,
  cx as ep,
  Pp as eq,
  dB as er,
  eP as es,
  bV as et,
  K5 as eu,
  Jo as ev,
  YI as ew,
  rpe as ex,
  a2 as ey,
  Gse as ez,
  xa as f,
  u2 as f$,
  O_ as f0,
  Ffe as f1,
  nS as f2,
  iS as f3,
  _pe as f4,
  HS as f5,
  PO as f6,
  IL as f7,
  BO as f8,
  ype as f9,
  vv as fA,
  Rr as fB,
  MP as fC,
  yg as fD,
  G6 as fE,
  Cl as fF,
  hfe as fG,
  pv as fH,
  NS as fI,
  al as fJ,
  SI as fK,
  fP as fL,
  gie as fM,
  Tf as fN,
  kp as fO,
  Kf as fP,
  Xv as fQ,
  ile as fR,
  eT as fS,
  SP as fT,
  dc as fU,
  Nu as fV,
  Oy as fW,
  CD as fX,
  ES as fY,
  hpe as fZ,
  Jr as f_,
  mpe as fa,
  epe as fb,
  Cp as fc,
  SJ as fd,
  JP as fe,
  Pg as ff,
  Og as fg,
  dY as fh,
  nY as fi,
  Zv as fj,
  iT as fk,
  Df as fl,
  bl as fm,
  Qo as fn,
  W6 as fo,
  lR as fp,
  Wne as fq,
  py as fr,
  Pf as fs,
  Xr as ft,
  kF as fu,
  Ex as fv,
  BL as fw,
  XI as fx,
  QS as fy,
  Bw as fz,
  Qpe as g,
  TS as g$,
  eO as g0,
  wS as g1,
  Sl as g2,
  YO as g3,
  cl as g4,
  AS as g5,
  z5 as g6,
  Bc as g7,
  tP as g8,
  ife as g9,
  Yfe as gA,
  Gfe as gB,
  K1 as gC,
  fU as gD,
  Gi as gE,
  dJ as gF,
  gv as gG,
  dg as gH,
  kg as gI,
  xf as gJ,
  Wi as gK,
  r_ as gL,
  v1 as gM,
  D5 as gN,
  ehe as gO,
  bv as gP,
  kv as gQ,
  Fpe as gR,
  Bpe as gS,
  pie as gT,
  goe as gU,
  LZ as gV,
  Vp as gW,
  Vc as gX,
  vF as gY,
  uS as gZ,
  dO as g_,
  fB as ga,
  XT as gb,
  Qw as gc,
  rp as gd,
  yF as ge,
  hl as gf,
  Z0 as gg,
  e2 as gh,
  afe as gi,
  HM as gj,
  vp as gk,
  oi as gl,
  Ic as gm,
  A5 as gn,
  E5 as go,
  Kr as gp,
  Yv as gq,
  rR as gr,
  xy as gs,
  fT as gt,
  Mx as gu,
  qi as gv,
  C_ as gw,
  v4 as gx,
  I2 as gy,
  v_ as gz,
  iO as h,
  Zte as h$,
  $5 as h0,
  Fw as h1,
  _$ as h2,
  gP as h3,
  Er as h4,
  o_ as h5,
  iie as h6,
  kV as h7,
  qg as h8,
  Fle as h9,
  mF as hA,
  wp as hB,
  Vpe as hC,
  UT as hD,
  JT as hE,
  F4 as hF,
  ele as hG,
  L2 as hH,
  WT as hI,
  YT as hJ,
  fhe as hK,
  s0 as hL,
  dhe as hM,
  ZT as hN,
  Ipe as hO,
  NM as hP,
  Op as hQ,
  Gte as hR,
  _4 as hS,
  LT as hT,
  N_ as hU,
  ZM as hV,
  ffe as hW,
  Ote as hX,
  BM as hY,
  pF as hZ,
  fF as h_,
  Ble as ha,
  Ule as hb,
  uhe as hc,
  K0 as hd,
  vg as he,
  Rfe as hf,
  qT as hg,
  Yp as hh,
  gpe as hi,
  Spe as hj,
  Iu as hk,
  vpe as hl,
  uU as hm,
  IM as hn,
  Uy as ho,
  V2 as hp,
  _P as hq,
  CP as hr,
  yP as hs,
  F2 as ht,
  Fy as hu,
  cO as hv,
  $y as hw,
  vfe as hx,
  Kc as hy,
  o$ as hz,
  Lf as i,
  fJ as i$,
  MO as i0,
  aS as i1,
  dF as i2,
  kfe as i3,
  qfe as i4,
  tne as i5,
  Hne as i6,
  Mue as i7,
  ape as i8,
  Sfe as i9,
  dfe as iA,
  hf as iB,
  npe as iC,
  Zfe as iD,
  Epe as iE,
  Ufe as iF,
  EO as iG,
  S4 as iH,
  Vr as iI,
  FM as iJ,
  n2 as iK,
  uN as iL,
  gJ as iM,
  uB as iN,
  Oue as iO,
  IT as iP,
  Pue as iQ,
  zue as iR,
  Hpe as iS,
  OS as iT,
  hR as iU,
  cfe as iV,
  ufe as iW,
  ale as iX,
  nle as iY,
  X6 as iZ,
  oR as i_,
  nfe as ia,
  xpe as ib,
  Lpe as ic,
  Pte as id,
  D2 as ie,
  $4 as ig,
  RT as ih,
  Mpe as ii,
  Q4 as ij,
  _m as ik,
  B0 as il,
  gS as im,
  bie as io,
  N5 as ip,
  L5 as iq,
  PS as ir,
  Mte as is,
  zte as it,
  sfe as iu,
  T0 as iv,
  Zi as iw,
  SV as ix,
  wpe as iy,
  xc as iz,
  Iw as j,
  Px as j$,
  Ja as j0,
  SL as j1,
  uR as j2,
  nR as j3,
  t1 as j4,
  lfe as j5,
  $J as j6,
  sN as j7,
  Qx as j8,
  ope as j9,
  Cpe as jA,
  zl as jB,
  mP as jC,
  zfe as jD,
  wG as jE,
  hie as jF,
  MZ as jG,
  U2 as jH,
  PP as jI,
  Np as jJ,
  cB as jK,
  Wg as jL,
  phe as jM,
  Rue as jN,
  Due as jO,
  Yg as jP,
  vV as jQ,
  LY as jR,
  iG as jS,
  i_ as jT,
  $V as jU,
  U4 as jV,
  Tte as jW,
  bJ as jX,
  HG as jY,
  aP as jZ,
  E0 as j_,
  lN as ja,
  $v as jb,
  jM as jc,
  Wc as jd,
  hJ as je,
  TO as jf,
  tR as jg,
  w4 as jh,
  av as ji,
  X0 as jj,
  WQ as jk,
  jne as jl,
  Fc as jm,
  gy as jn,
  Jte as jo,
  qL as jp,
  Nx as jq,
  Bfe as jr,
  Rx as js,
  H5 as jt,
  Upe as ju,
  Tie as jv,
  tfe as jw,
  UL as jx,
  xm as jy,
  WW as jz,
  h2 as k,
  spe as k0,
  I4 as k1,
  js as k2,
  C4 as k3,
  x$ as k4,
  pg as k5,
  ohe as k6,
  Qfe as k7,
  bpe as k8,
  V0 as k9,
  jw as ka,
  Wy as kb,
  _x as kc,
  Pfe as kd,
  Gpe as ke,
  kpe as kf,
  sB as kg,
  Tae as kh,
  Tg as ki,
  Oa as kj,
  mT as kk,
  ov as kl,
  Ys as km,
  Mf as kn,
  Xa as ko,
  Qs as kp,
  yne as kq,
  Ur as kr,
  Lfe as ks,
  _ne as kt,
  Yr as l,
  Oae as m,
  Pt as n,
  Xpe as o,
  Ype as p,
  Dg as q,
  Gr as r,
  Sg as s,
  x0 as t,
  ht as u,
  fa as v,
  qpe as w,
  l2 as x,
  efe as y,
  pa as z
};
//# sourceMappingURL=index-CditYVY2.js.map
